(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.m.n5 === region.k.n5)
	{
		return 'on line ' + region.m.n5;
	}
	return 'on lines ' + region.m.n5 + ' through ' + region.k.n5;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nE,
		impl.qd,
		impl.pT,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		of: func(record.of),
		lw: record.lw,
		k3: record.k3
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.of;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.lw;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.k3) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nE,
		impl.qd,
		impl.pT,
		function(sendToApp, initialModel) {
			var view = impl.qi;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nE,
		impl.qd,
		impl.pT,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.iM && impl.iM(sendToApp)
			var view = impl.qi;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.f6);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.fN) && (_VirtualDom_doc.title = title = doc.fN);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.oX;
	var onUrlRequest = impl.oY;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		iM: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.pn === next.pn
							&& curr.e3 === next.e3
							&& curr.pb.a === next.pb.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		nE: function(flags)
		{
			return A3(impl.nE, flags, _Browser_getUrl(), key);
		},
		qi: impl.qi,
		qd: impl.qd,
		pT: impl.pT
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { ns: 'hidden', mq: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { ns: 'mozHidden', mq: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { ns: 'msHidden', mq: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { ns: 'webkitHidden', mq: 'webkitvisibilitychange' }
		: { ns: 'hidden', mq: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		lm: _Browser_getScene(),
		qj: {
			l2: _Browser_window.pageXOffset,
			l3: _Browser_window.pageYOffset,
			l1: _Browser_doc.documentElement.clientWidth,
			gD: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		l1: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		gD: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			lm: {
				l1: node.scrollWidth,
				gD: node.scrollHeight
			},
			qj: {
				l2: node.scrollLeft,
				l3: node.scrollTop,
				l1: node.clientWidth,
				gD: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			lm: _Browser_getScene(),
			qj: {
				l2: x,
				l3: y,
				l1: _Browser_doc.documentElement.clientWidth,
				gD: _Browser_doc.documentElement.clientHeight
			},
			jJ: {
				l2: x + rect.left,
				l3: y + rect.top,
				l1: rect.width,
				gD: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.gt.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.gt.b, xhr)); });
		$elm$core$Maybe$isJust(request.lK) && _Http_track(router, xhr, request.lK.a);

		try {
			xhr.open(request.cd, request.hn, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.hn));
		}

		_Http_configureRequest(xhr, request);

		request.f6.a && xhr.setRequestHeader('Content-Type', request.f6.a);
		xhr.send(request.f6.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.nr; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.au.a || 0;
	xhr.responseType = request.gt.d;
	xhr.withCredentials = request.mf;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		hn: xhr.responseURL,
		pO: xhr.status,
		iS: xhr.statusText,
		nr: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			pE: event.loaded,
			he: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			pq: event.loaded,
			he: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.om) { flags += 'm'; }
	if (options.mp) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $author$project$Main$ChangedUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$ClickedLink = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.D) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.I),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.I);
		} else {
			var treeLen = builder.D * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.R) : builder.R;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.D);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.I) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.I);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{R: nodeList, D: (len / $elm$core$Array$branchFactor) | 0, I: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {nl: fragment, e3: host, g_: path, pb: port_, pn: protocol, ed: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $author$project$Log$DebugBreadcrumb = 1;
var $author$project$Log$DebugLevel = 4;
var $author$project$Main$GotPageMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$Ignored = {$: 0};
var $author$project$Main$Redirect = {$: 0};
var $author$project$UpdateResult$addBreadcrumb = F2(
	function (breadcrumb, uResult) {
		return _Utils_update(
			uResult,
			{
				af: A2($elm$core$List$cons, breadcrumb, uResult.af)
			});
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Main$Analysis = function (a) {
	return {$: 45, a: a};
};
var $author$project$Route$Analysis = {$: 48};
var $author$project$Main$Claim = F3(
	function (a, b, c) {
		return {$: 25, a: a, b: b, c: c};
	});
var $author$project$Route$Claim = F3(
	function (a, b, c) {
		return {$: 38, a: a, b: b, c: c};
	});
var $author$project$Main$ComingSoon = {$: 2};
var $author$project$Main$CommunityAbout = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$CommunityAbout = {$: 14};
var $author$project$Main$CommunityEditor = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$CommunityObjectives = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$CommunityObjectives = function (a) {
	return {$: 15, a: a};
};
var $author$project$Main$CommunitySelector = function (a) {
	return {$: 17, a: a};
};
var $author$project$Route$CommunitySelector = function (a) {
	return {$: 34, a: a};
};
var $author$project$Main$CommunitySettings = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$CommunitySettings = {$: 18};
var $author$project$Main$CommunitySettingsActionEditor = function (a) {
	return {$: 23, a: a};
};
var $author$project$Main$CommunitySettingsContacts = function (a) {
	return {$: 24, a: a};
};
var $author$project$Route$CommunitySettingsContacts = {$: 32};
var $author$project$Main$CommunitySettingsCurrency = function (a) {
	return {$: 13, a: a};
};
var $author$project$Route$CommunitySettingsCurrency = {$: 23};
var $author$project$Route$CommunitySettingsEditAction = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$Route$CommunitySettingsEditObjective = function (a) {
	return {$: 29, a: a};
};
var $author$project$Main$CommunitySettingsFeatures = function (a) {
	return {$: 9, a: a};
};
var $author$project$Route$CommunitySettingsFeatures = {$: 19};
var $author$project$Main$CommunitySettingsInfo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Route$CommunitySettingsInfo = {$: 20};
var $author$project$Route$CommunitySettingsNewAction = function (a) {
	return {$: 30, a: a};
};
var $author$project$Route$CommunitySettingsNewObjective = {$: 28};
var $author$project$Main$CommunitySettingsNews = function (a) {
	return {$: 11, a: a};
};
var $author$project$Route$CommunitySettingsNews = {$: 21};
var $author$project$Main$CommunitySettingsNewsEditor = function (a) {
	return {$: 12, a: a};
};
var $author$project$Route$CommunitySettingsNewsEditor = function (a) {
	return {$: 22, a: a};
};
var $author$project$Main$CommunitySettingsObjectiveEditor = function (a) {
	return {$: 22, a: a};
};
var $author$project$Main$CommunitySettingsObjectives = function (a) {
	return {$: 21, a: a};
};
var $author$project$Route$CommunitySettingsObjectives = {$: 27};
var $author$project$Main$CommunitySettingsShopCategories = function (a) {
	return {$: 8, a: a};
};
var $author$project$Route$CommunitySettingsShopCategories = {$: 33};
var $author$project$Main$CommunitySettingsSponsorship = function (a) {
	return {$: 14, a: a};
};
var $author$project$Route$CommunitySettingsSponsorship = {$: 24};
var $author$project$Main$CommunitySettingsSponsorshipFiat = function (a) {
	return {$: 15, a: a};
};
var $author$project$Route$CommunitySettingsSponsorshipFiat = {$: 25};
var $author$project$Main$CommunitySettingsSponsorshipThankYouMessage = function (a) {
	return {$: 16, a: a};
};
var $author$project$Route$CommunitySettingsSponsorshipThankYouMessage = {$: 26};
var $author$project$Main$CommunitySponsor = function (a) {
	return {$: 19, a: a};
};
var $author$project$Route$CommunitySponsor = {$: 36};
var $author$project$Main$CommunitySupporters = function (a) {
	return {$: 20, a: a};
};
var $author$project$Route$CommunitySupporters = {$: 37};
var $author$project$Main$CommunityThankYou = {$: 18};
var $author$project$Main$Dashboard = function (a) {
	return {$: 27, a: a};
};
var $author$project$Route$Dashboard = {$: 13};
var $author$project$Route$EditSale = F2(
	function (a, b) {
		return {$: 42, a: a, b: b};
	});
var $author$project$Main$GotAnalysisMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Main$GotCommunityAboutMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$GotCommunityEditorMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$GotCommunityObjectivesMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$GotCommunitySettingsActionEditorMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Main$GotCommunitySettingsContactsMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Main$GotCommunitySettingsCurrencyMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Main$GotCommunitySettingsFeaturesMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$GotCommunitySettingsInfoMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$GotCommunitySettingsMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$GotCommunitySettingsNewsEditorMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Main$GotCommunitySettingsNewsMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Main$GotCommunitySettingsObjectiveEditorMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Main$GotCommunitySettingsObjectivesMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Main$GotCommunitySettingsShopCategoriesMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$GotCommunitySettingsSponsorshipFiatMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Main$GotCommunitySettingsSponsorshipMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Main$GotCommunitySettingsSponsorshipThankYouMessageMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Main$GotCommunitySponsorMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Main$GotCommunitySupportersMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Main$GotDashboardMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Main$GotInviteMsg = function (a) {
	return {$: 42, a: a};
};
var $author$project$Main$GotJoinMsg = function (a) {
	return {$: 43, a: a};
};
var $author$project$Page$GotLoggedInMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$GotLoginMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Main$GotNewsMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Main$GotNotificationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$GotPaymentHistoryMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Main$GotProfileAddContactMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Main$GotProfileAddKycMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Main$GotProfileClaimsMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Main$GotProfileContributionsMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Main$GotProfileEditorMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Main$GotProfileMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Main$GotRegisterMsg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Main$GotSettingsMsg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Main$GotShopEditorMsg = function (a) {
	return {$: 39, a: a};
};
var $author$project$Main$GotShopMsg = function (a) {
	return {$: 38, a: a};
};
var $author$project$Main$GotShopViewerMsg = function (a) {
	return {$: 40, a: a};
};
var $author$project$Session$LoggedIn$GotTimeInternal = function (a) {
	return {$: 25, a: a};
};
var $author$project$Main$GotTransferMsg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Main$GotVerifyClaimMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Main$GotViewTransferScreenMsg = function (a) {
	return {$: 41, a: a};
};
var $author$project$Page$Guest = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$Invite = function (a) {
	return {$: 42, a: a};
};
var $author$project$Route$Invite = function (a) {
	return {$: 45, a: a};
};
var $author$project$Main$Join = function (a) {
	return {$: 43, a: a};
};
var $author$project$Route$Join = function (a) {
	return {$: 46, a: a};
};
var $author$project$Page$LoggedIn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$Login = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Route$NewCommunity = {$: 16};
var $author$project$Route$NewSale = function (a) {
	return {$: 41, a: a};
};
var $author$project$Main$News = function (a) {
	return {$: 29, a: a};
};
var $author$project$Route$News = function (a) {
	return {$: 17, a: a};
};
var $author$project$Main$NotFound = {$: 1};
var $author$project$Main$Notification = function (a) {
	return {$: 26, a: a};
};
var $author$project$Route$Notification = {$: 5};
var $author$project$Main$PaymentHistory = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$PaymentHistory = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$Profile = function (a) {
	return {$: 30, a: a};
};
var $author$project$Route$Profile = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$ProfileAddContact = function (a) {
	return {$: 35, a: a};
};
var $author$project$Route$ProfileAddContact = {$: 9};
var $author$project$Main$ProfileAddKyc = function (a) {
	return {$: 33, a: a};
};
var $author$project$Route$ProfileAddKyc = {$: 7};
var $author$project$Main$ProfileClaims = function (a) {
	return {$: 34, a: a};
};
var $author$project$Route$ProfileClaims = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$ProfileContributions = function (a) {
	return {$: 31, a: a};
};
var $author$project$Route$ProfileContributions = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$ProfileEditor = function (a) {
	return {$: 32, a: a};
};
var $author$project$Route$ProfileEditor = {$: 6};
var $author$project$Main$Register = F3(
	function (a, b, c) {
		return {$: 36, a: a, b: b, c: c};
	});
var $author$project$Main$Settings = function (a) {
	return {$: 37, a: a};
};
var $author$project$Route$Settings = {$: 39};
var $author$project$Main$Shop = F2(
	function (a, b) {
		return {$: 38, a: a, b: b};
	});
var $author$project$Route$Shop = function (a) {
	return {$: 40, a: a};
};
var $author$project$Main$ShopEditor = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $author$project$Main$ShopViewer = F2(
	function (a, b) {
		return {$: 40, a: a, b: b};
	});
var $author$project$Main$Transfer = function (a) {
	return {$: 44, a: a};
};
var $author$project$Route$Transfer = function (a) {
	return {$: 47, a: a};
};
var $author$project$Route$ViewSale = function (a) {
	return {$: 43, a: a};
};
var $author$project$Main$ViewTransfer = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $author$project$Route$ViewTransfer = function (a) {
	return {$: 44, a: a};
};
var $author$project$Session$Guest$addAfterLoginRedirect = F2(
	function (route, model) {
		return _Utils_update(
			model,
			{
				me: $elm$core$Maybe$Just(route)
			});
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Action$Id = $elm$core$Basics$identity;
var $author$project$Action$idFromInt = function (id) {
	return id;
};
var $author$project$Page$Community$About$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Community$ContributionsField = 0;
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$Community$NewsField = 4;
var $author$project$Page$Community$About$NoOp = {$: 0};
var $author$project$Session$LoggedIn$RequestedCommunityField = function (a) {
	return {$: 7, a: a};
};
var $author$project$Community$UploadsField = 2;
var $author$project$UpdateResult$addCmd = F2(
	function (cmd, uResult) {
		return _Utils_update(
			uResult,
			{
				ju: _Utils_ap(
					uResult.ju,
					_List_fromArray(
						[cmd]))
			});
	});
var $author$project$UpdateResult$addExt = F2(
	function (eMsg, uResult) {
		return _Utils_update(
			uResult,
			{
				jS: _Utils_ap(
					uResult.jS,
					_List_fromArray(
						[eMsg]))
			});
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$UpdateResult$init = function (model) {
	return {af: _List_Nil, ju: _List_Nil, jQ: _List_Nil, jS: _List_Nil, ok: model, k0: _List_Nil};
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Session$LoggedIn$maybeInitWith = F3(
	function (toMsg, attribute, model) {
		var _v0 = attribute(model);
		if (_v0.$ === 3) {
			var value = _v0.a;
			return A2(
				$elm$core$Task$perform,
				toMsg,
				$elm$core$Task$succeed(value));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Page$Community$About$init = function (loggedIn) {
	return A2(
		$author$project$UpdateResult$addCmd,
		A2(
			$elm$core$Task$attempt,
			function (_v0) {
				return $author$project$Page$Community$About$NoOp;
			},
			A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
		A2(
			$author$project$UpdateResult$addExt,
			$author$project$Session$LoggedIn$RequestedCommunityField(4),
			A2(
				$author$project$UpdateResult$addExt,
				$author$project$Session$LoggedIn$RequestedCommunityField(0),
				A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$RequestedCommunityField(2),
					A2(
						$author$project$UpdateResult$addCmd,
						A3(
							$author$project$Session$LoggedIn$maybeInitWith,
							$author$project$Page$Community$About$CompletedLoadCommunity,
							function ($) {
								return $.pC;
							},
							loggedIn),
						$author$project$UpdateResult$init(
							{fR: $krisajenkins$remotedata$RemoteData$Loading}))))));
};
var $author$project$Page$Community$Invite$CompletedLoadInvite = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Community$Invite$CompletedLoadProfile = {$: 1};
var $author$project$Page$Community$Invite$Closed = 0;
var $author$project$Page$Community$Invite$Loading = {$: 0};
var $author$project$Page$Community$Invite$initModel = function (invitationId) {
	return {eL: 0, kk: invitationId, fc: $elm$core$Maybe$Nothing, bI: $author$project$Page$Community$Invite$Loading};
};
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required = F3(
	function (fieldName, raw, encode) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument,
			fieldName,
			encode(raw));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$RawField$Composite = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite = F3(
	function (fieldName, args, fields) {
		return A3($dillonkearns$elm_graphql$Graphql$RawField$Composite, fieldName, args, fields);
	});
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $dillonkearns$elm_graphql$Graphql$Document$Hash$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {dp: charsProcessed, dJ: hash, c5: seed, ek: shift};
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c1 = 3432918353;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c2 = 461845907;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Bitwise$or = _Bitwise_or;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize = function (data) {
	var acc = (!(!data.dJ)) ? (data.c5 ^ A2(
		$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
		A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
			15,
			A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, data.dJ)))) : data.c5;
	var h0 = acc ^ data.dp;
	var h1 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$mix = F2(
	function (h1, k1) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
			5,
			A2(
				$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
				13,
				h1 ^ A2(
					$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
					$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
					A2(
						$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
						15,
						A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, k1))))) + 3864292196;
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold = F2(
	function (c, data) {
		var res = data.dJ | ((255 & $elm$core$Char$toCode(c)) << data.ek);
		var _v0 = data.ek;
		if (_v0 === 24) {
			return {
				dp: data.dp + 1,
				dJ: 0,
				c5: A2($dillonkearns$elm_graphql$Graphql$Document$Hash$mix, data.c5, res),
				ek: 0
			};
		} else {
			return {dp: data.dp + 1, dJ: res, c5: data.c5, ek: data.ek + 8};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashString = F2(
	function (seed, str) {
		return $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize(
			A3(
				$elm$core$String$foldl,
				$dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold,
				A4($dillonkearns$elm_graphql$Graphql$Document$Hash$HashData, 0, seed, 0, 0),
				str));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$List = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object = function (a) {
	return {$: 3, a: a};
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize = function (value) {
	var serializeJson = function (json) {
		var decoder = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$List,
						$elm$core$List$map($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json)),
					$elm$json$Json$Decode$list($elm$json$Json$Decode$value)),
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$Object,
						$elm$core$List$map(
							$elm$core$Tuple$mapSecond($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json))),
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value))
				]));
		var _v2 = A2($elm$json$Json$Decode$decodeValue, decoder, json);
		if (!_v2.$) {
			var v = _v2.a;
			return $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(v);
		} else {
			return A2($elm$json$Json$Encode$encode, 0, json);
		}
	};
	switch (value.$) {
		case 0:
			var enumValue = value.a;
			return enumValue;
		case 1:
			var json = value.a;
			return serializeJson(json);
		case 2:
			var values = value.a;
			return '[' + (A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize, values)) + ']');
		default:
			var keyValuePairs = value.a;
			return '{' + (A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var objectValue = _v1.b;
						return key + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(objectValue));
					},
					keyValuePairs)) + '}');
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return name + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(value));
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$serialize = function (args) {
	if (!args.b) {
		return '';
	} else {
		var nonemptyArgs = args;
		return '(' + (A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString, nonemptyArgs)) + ')');
	}
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash = function (field) {
	return A2(
		$elm$core$Maybe$map,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$hashString(0),
		function () {
			if (!field.$) {
				var name = field.a;
				var _arguments = field.b;
				var children = field.c;
				return $elm$core$List$isEmpty(_arguments) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments));
			} else {
				var typeString = field.a.qa;
				var fieldName = field.a.jT;
				var _arguments = field.b;
				return (fieldName === '__typename') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$elm$core$String$concat(
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[typeString]),
							$elm$core$List$singleton(
								$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments)))));
			}
		}());
};
var $dillonkearns$elm_graphql$Graphql$RawField$name = function (field) {
	if (!field.$) {
		var fieldName = field.a;
		var argumentList = field.b;
		var fieldList = field.c;
		return fieldName;
	} else {
		var typeString = field.a.qa;
		var fieldName = field.a.jT;
		var argumentList = field.b;
		return fieldName;
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$alias = function (field) {
	return A2(
		$elm$core$Maybe$map,
		function (aliasHash) {
			return _Utils_ap(
				$dillonkearns$elm_graphql$Graphql$RawField$name(field),
				$elm$core$String$fromInt(aliasHash));
		},
		$dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash(field));
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName = function (field) {
	return A2(
		$elm$core$Maybe$withDefault,
		$dillonkearns$elm_graphql$Graphql$RawField$name(field),
		$dillonkearns$elm_graphql$Graphql$Document$Field$alias(field));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField = F4(
	function (fieldName, args, _v0, decoderTransform) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)
				]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$field,
						fieldName,
						decoderTransform(decoder)),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(
							A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)),
						decoderTransform(decoder))
					])));
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$string = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$string(value));
};
var $author$project$Cambiatus$Query$invite = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'invite',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Community$Invite = F2(
	function (community, creator) {
		return {V: community, jz: creator};
	});
var $author$project$Cambiatus$Object$Invite$communityPreview = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'communityPreview', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Community$CommunityPreview = function (name) {
	return function (description) {
		return function (logo) {
			return function (symbol) {
				return function (subdomain) {
					return function (hasShop) {
						return function (hasObjectives) {
							return function (hasKyc) {
								return function (hasAutoInvite) {
									return function (uploads) {
										return function (memberCount) {
											return function (website) {
												return {aR: description, bx: hasAutoInvite, by: hasKyc, bz: hasObjectives, bB: hasShop, fe: logo, gT: memberCount, fj: name, pP: subdomain, as: symbol, bQ: uploads, bT: website};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $dillonkearns$elm_graphql$Graphql$RawField$Leaf = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf = F2(
	function (details, args) {
		return A2($dillonkearns$elm_graphql$Graphql$RawField$Leaf, details, args);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField = F4(
	function (typeString, fieldName, args, decoder) {
		var newLeaf = A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf,
			{jT: fieldName, qa: typeString},
			args);
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[newLeaf]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, fieldName, decoder),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(newLeaf),
						decoder)
					])));
	});
var $author$project$Cambiatus$Object$CommunityPreview$autoInvite = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'autoInvite', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Constants$defaultCommunityLogo = 'https://cambiatus-uploads.s3.amazonaws.com/cambiatus-uploads/community_2.png';
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Cambiatus$Object$CommunityPreview$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$CommunityPreview$hasKyc = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasKyc', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$CommunityPreview$hasObjectives = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasObjectives', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$CommunityPreview$hasShop = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasShop', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$CommunityPreview$logo = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'logo',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map = F2(
	function (mapFunction, _v0) {
		var selectionFields = _v0.a;
		var selectionDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			selectionFields,
			A2($elm$json$Json$Decode$map, mapFunction, selectionDecoder));
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Cambiatus$Object$CommunityPreview$memberCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'memberCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$CommunityPreview$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Subdomain$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Markdown$Markdown = $elm$core$Basics$identity;
var $author$project$Markdown$selectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$map($elm$core$Basics$identity);
var $author$project$Cambiatus$Object$CommunityPreview$subdomain = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'subdomain',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed = function (constructor) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
		_List_Nil,
		$elm$json$Json$Decode$succeed(constructor));
};
var $author$project$Cambiatus$Object$CommunityPreview$symbol = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'symbol', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Eos$Symbol = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$fail = _Json_fail;
var $dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail = F2(
	function (mapFunction, _v0) {
		var field = _v0.a;
		var decoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			field,
			A2(
				$elm$json$Json$Decode$andThen,
				function (result) {
					if (!result.$) {
						var value = result.a;
						return $elm$json$Json$Decode$succeed(value);
					} else {
						var errorMessage = result.a;
						return $elm$json$Json$Decode$fail('Check your code for calls to mapOrFail, your map function returned an `Err` with the message: ' + errorMessage);
					}
				},
				A2($elm$json$Json$Decode$map, mapFunction, decoder)));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$with = F2(
	function (_v0, _v1) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_Utils_ap(selectionFields1, selectionFields2),
			A3($elm$json$Json$Decode$map2, $elm$core$Basics$apR, selectionDecoder1, selectionDecoder2));
	});
var $author$project$Eos$symbolSelectionSet = function (field) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
			function (s) {
				var _v1 = A2(
					$elm$core$Maybe$andThen,
					$elm$core$String$toInt,
					$elm$core$List$head(
						A2($elm$core$String$split, ',', s)));
				if (!_v1.$) {
					var e = _v1.a;
					return $elm$core$Result$Ok(e);
				} else {
					return $elm$core$Result$Err('Can\'t parse symbol');
				}
			},
			field),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
				function (s) {
					var _v0 = $elm$core$List$head(
						$elm$core$List$reverse(
							A2($elm$core$String$split, ',', s)));
					if (!_v0.$) {
						var e = _v0.a;
						return $elm$core$Result$Ok(e);
					} else {
						return $elm$core$Result$Err('Can\'t parse symbol');
					}
				},
				field),
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Eos$Symbol)));
};
var $author$project$Cambiatus$Object$CommunityPreview$uploads = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'uploads',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Upload$url = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'url', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$CommunityPreview$website = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'website',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault = function (_default) {
	return $dillonkearns$elm_graphql$Graphql$SelectionSet$map(
		$elm$core$Maybe$withDefault(_default));
};
var $author$project$Community$communityPreviewSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$CommunityPreview$website,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$CommunityPreview$memberCount,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$CommunityPreview$uploads($author$project$Cambiatus$Object$Upload$url),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$CommunityPreview$autoInvite,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$CommunityPreview$hasKyc,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$CommunityPreview$hasObjectives,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$CommunityPreview$hasShop,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
									$elm$core$Maybe$withDefault(''),
									$author$project$Cambiatus$Object$CommunityPreview$subdomain($author$project$Cambiatus$Object$Subdomain$name)),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$CommunityPreview$symbol),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Constants$defaultCommunityLogo, $author$project$Cambiatus$Object$CommunityPreview$logo),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$CommunityPreview$description),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Cambiatus$Object$CommunityPreview$name,
												$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$CommunityPreview)))))))))))));
var $author$project$Cambiatus$Object$Invite$creator = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'creator', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Profile$Minimal = F6(
	function (name, account, avatar, email, bio, contacts) {
		return {l8: account, dl: avatar, dm: bio, az: contacts, jK: email, fj: name};
	});
var $author$project$Cambiatus$Object$User$account = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'account', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$User$avatar = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'avatar',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$User$bio = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'bio',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$User$email = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'email',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Markdown$maybeSelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$map(
	$elm$core$Maybe$map($elm$core$Basics$identity));
var $author$project$Cambiatus$Object$User$name = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'name',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Eos$Account$Name = $elm$core$Basics$identity;
var $author$project$Eos$Account$nameSelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$map($elm$core$Basics$identity);
var $author$project$Avatar$Avatar = $elm$core$Basics$identity;
var $author$project$Avatar$selectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$map($elm$core$Basics$identity);
var $author$project$Cambiatus$Object$User$contacts = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'contacts',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $author$project$Profile$Contact$Normalized = $elm$core$Basics$identity;
var $author$project$Cambiatus$Object$Contact$externalId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'externalId',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Contact$label = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'label',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Enum$ContactType$Email = 0;
var $author$project$Cambiatus$Enum$ContactType$Instagram = 1;
var $author$project$Cambiatus$Enum$ContactType$Link = 2;
var $author$project$Cambiatus$Enum$ContactType$Phone = 3;
var $author$project$Cambiatus$Enum$ContactType$Telegram = 4;
var $author$project$Cambiatus$Enum$ContactType$Whatsapp = 5;
var $author$project$Cambiatus$Enum$ContactType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'EMAIL':
				return $elm$json$Json$Decode$succeed(0);
			case 'INSTAGRAM':
				return $elm$json$Json$Decode$succeed(1);
			case 'LINK':
				return $elm$json$Json$Decode$succeed(2);
			case 'PHONE':
				return $elm$json$Json$Decode$succeed(3);
			case 'TELEGRAM':
				return $elm$json$Json$Decode$succeed(4);
			case 'WHATSAPP':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('Invalid ContactType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Contact$type_ = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.ContactType.ContactType)',
	'type',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$Cambiatus$Enum$ContactType$decoder));
var $author$project$Profile$Contact$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Contact$label,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Contact$externalId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Contact$type_,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
				F3(
					function (maybeType, maybeExternalId, label) {
						var _v0 = _Utils_Tuple2(maybeType, maybeExternalId);
						if ((!_v0.a.$) && (!_v0.b.$)) {
							var type_ = _v0.a.a;
							var externalId = _v0.b.a;
							return $elm$core$Maybe$Just(
								{mD: externalId, mE: type_, n$: label});
						} else {
							return $elm$core$Maybe$Nothing;
						}
					})))));
var $author$project$Profile$userContactSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$author$project$Cambiatus$Object$User$contacts($author$project$Profile$Contact$selectionSet));
var $author$project$Profile$minimalSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Profile$userContactSelectionSet,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$User$bio),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$User$email,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Avatar$selectionSet($author$project$Cambiatus$Object$User$avatar),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$User$account),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$User$name,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Minimal)))))));
var $author$project$Community$inviteSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Invite$creator($author$project$Profile$minimalSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Invite$communityPreview($author$project$Community$communityPreviewSelectionSet),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$Invite)));
var $author$project$Community$inviteQuery = function (invitationId) {
	return A2(
		$author$project$Cambiatus$Query$invite,
		{w: invitationId},
		$author$project$Community$inviteSelectionSet);
};
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$Query = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$Request = $elm$core$Basics$identity;
var $dillonkearns$elm_graphql$Graphql$Document$decoder = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($elm$json$Json$Decode$field, 'data', decoder_);
};
var $dillonkearns$elm_graphql$Graphql$Http$queryRequest = F2(
	function (baseUrl, query) {
		return {
			eE: baseUrl,
			m_: A2($dillonkearns$elm_graphql$Graphql$Http$Query, $elm$core$Maybe$Nothing, query),
			gt: $dillonkearns$elm_graphql$Graphql$Document$decoder(query),
			nr: _List_Nil,
			cW: $elm$core$Maybe$Nothing,
			c3: _List_Nil,
			au: $elm$core$Maybe$Nothing,
			dg: false
		};
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {lf: reqs, lz: subs};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.lK;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.lf));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.lz)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					mf: r.mf,
					f6: r.f6,
					gt: A2(_Http_mapExpect, func, r.gt),
					nr: r.nr,
					cd: r.cd,
					au: r.au,
					lK: r.lK,
					hn: r.hn
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{mf: false, f6: r.f6, gt: r.gt, nr: r.nr, cd: r.cd, au: r.au, lK: r.lK, hn: r.hn}));
};
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{mf: true, f6: r.f6, gt: r.gt, nr: r.nr, cd: r.cd, au: r.au, lK: r.lK, hn: r.hn}));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$HttpError = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$convertResult = function (httpResult) {
	if (!httpResult.$) {
		var successOrError = httpResult.a;
		if (!successOrError.$) {
			var value = successOrError.a;
			return $elm$core$Result$Ok(value);
		} else {
			var _v2 = successOrError.a;
			var possiblyParsedData = _v2.a;
			var error = _v2.b;
			return $elm$core$Result$Err(
				A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, possiblyParsedData, error));
		}
	} else {
		var httpError = httpResult.a;
		return $elm$core$Result$Err(
			$dillonkearns$elm_graphql$Graphql$Http$HttpError(httpError));
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$BadPayload = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$NetworkError = {$: 2};
var $dillonkearns$elm_graphql$Graphql$Http$Timeout = {$: 1};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $dillonkearns$elm_graphql$Graphql$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 0:
						var url = response.a;
						return $elm$core$Result$Err(
							$dillonkearns$elm_graphql$Graphql$Http$BadUrl(url));
					case 1:
						return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$Timeout);
					case 2:
						return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$NetworkError);
					case 3:
						var metadata = response.a;
						var body = response.b;
						return $elm$core$Result$Err(
							A2($dillonkearns$elm_graphql$Graphql$Http$BadStatus, metadata, body));
					default:
						var metadata = response.a;
						var body = response.b;
						var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
						if (!_v1.$) {
							var value = _v1.a;
							return $elm$core$Result$Ok(value);
						} else {
							var err = _v1.a;
							return $elm$core$Result$Err(
								$dillonkearns$elm_graphql$Graphql$Http$BadPayload(err));
						}
				}
			});
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Get = 0;
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Post = 1;
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$core$Basics$ge = _Utils_ge;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength = 2000;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation = F2(
	function (replacements, _v0) {
		var match = _v0.fg;
		var ordinalString = A2(
			$elm$core$Basics$composeL,
			$elm$core$String$dropLeft(1),
			$elm$core$String$dropRight(1))(match);
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (value) {
					return A2($elm$core$Array$get, value, replacements);
				},
				$elm$core$String$toInt(ordinalString)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{R: nodeList, D: nodeListSize, I: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {e5: index, fg: match, d2: number, iW: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{mp: false, om: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\{\\d+\\}'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolate = F2(
	function (string, args) {
		var asArray = $elm$core$Array$fromList(args);
		return A3(
			$elm$regex$Regex$replace,
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex,
			$lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation(asArray),
			string);
	});
var $j_maas$elm_ordered_containers$OrderedDict$OrderedDict = $elm$core$Basics$identity;
var $j_maas$elm_ordered_containers$OrderedDict$empty = {u: $elm$core$Dict$empty, oZ: _List_Nil};
var $j_maas$elm_ordered_containers$OrderedDict$get = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return A2($elm$core$Dict$get, key, orderedDict.u);
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $j_maas$elm_ordered_containers$OrderedDict$insert = F3(
	function (key, value, _v0) {
		var orderedDict = _v0;
		var filteredOrder = A2($elm$core$Dict$member, key, orderedDict.u) ? A2(
			$elm$core$List$filter,
			function (k) {
				return !_Utils_eq(k, key);
			},
			orderedDict.oZ) : orderedDict.oZ;
		var newOrder = _Utils_ap(
			filteredOrder,
			_List_fromArray(
				[key]));
		return {
			u: A3($elm$core$Dict$insert, key, value, orderedDict.u),
			oZ: newOrder
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$remove = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return {
			u: A2($elm$core$Dict$remove, key, orderedDict.u),
			oZ: A2($elm$core$Dict$member, key, orderedDict.u) ? A2(
				$elm$core$List$filter,
				function (k) {
					return !_Utils_eq(k, key);
				},
				orderedDict.oZ) : orderedDict.oZ
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$update = F3(
	function (key, alter, original) {
		var orderedDict = original;
		var _v0 = A2($elm$core$Dict$get, key, orderedDict.u);
		if (!_v0.$) {
			var oldItem = _v0.a;
			var _v1 = alter(
				$elm$core$Maybe$Just(oldItem));
			if (!_v1.$) {
				var newItem = _v1.a;
				return {
					u: A3(
						$elm$core$Dict$update,
						key,
						$elm$core$Basics$always(
							$elm$core$Maybe$Just(newItem)),
						orderedDict.u),
					oZ: orderedDict.oZ
				};
			} else {
				return A2($j_maas$elm_ordered_containers$OrderedDict$remove, key, original);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (!_v2.$) {
				var newItem = _v2.a;
				return A3($j_maas$elm_ordered_containers$OrderedDict$insert, key, newItem, original);
			} else {
				return original;
			}
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing = function (rawFields) {
	var fieldCounts = A3(
		$elm$core$List$foldl,
		F2(
			function (fld, acc) {
				return A3(
					$j_maas$elm_ordered_containers$OrderedDict$update,
					fld,
					function (val) {
						return $elm$core$Maybe$Just(
							function () {
								if (val.$ === 1) {
									return 0;
								} else {
									var count = val.a;
									return count + 1;
								}
							}());
					},
					acc);
			}),
		$j_maas$elm_ordered_containers$OrderedDict$empty,
		A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$RawField$name, rawFields));
	return A2(
		$elm$core$List$map,
		function (field) {
			return _Utils_Tuple2(
				field,
				(!A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$j_maas$elm_ordered_containers$OrderedDict$get,
						$dillonkearns$elm_graphql$Graphql$RawField$name(field),
						fieldCounts))) ? $elm$core$Maybe$Nothing : $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field));
		},
		rawFields);
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $dillonkearns$elm_graphql$Graphql$Document$Indent$generate = function (indentationLevel) {
	return A2($elm$core$String$repeat, indentationLevel, '  ');
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields = function (rawFields) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (field, mergedSoFar) {
				if (!field.$) {
					var newChildren = field.c;
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							if (maybeChildrenSoFar.$ === 1) {
								return $elm$core$Maybe$Just(field);
							} else {
								if (!maybeChildrenSoFar.a.$) {
									var _v2 = maybeChildrenSoFar.a;
									var existingFieldName = _v2.a;
									var existingArgs = _v2.b;
									var existingChildren = _v2.c;
									return $elm$core$Maybe$Just(
										A3(
											$dillonkearns$elm_graphql$Graphql$RawField$Composite,
											existingFieldName,
											existingArgs,
											_Utils_ap(existingChildren, newChildren)));
								} else {
									return $elm$core$Maybe$Just(field);
								}
							}
						},
						mergedSoFar);
				} else {
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							return $elm$core$Maybe$Just(
								A2($elm$core$Maybe$withDefault, field, maybeChildrenSoFar));
						},
						mergedSoFar);
				}
			}),
		$j_maas$elm_ordered_containers$OrderedDict$empty,
		rawFields);
};
var $j_maas$elm_ordered_containers$OrderedDict$values = function (_v0) {
	var orderedDict = _v0;
	return A2(
		$elm$core$List$filterMap,
		function (key) {
			return A2($elm$core$Dict$get, key, orderedDict.u);
		},
		orderedDict.oZ);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields = function (children) {
	return $j_maas$elm_ordered_containers$OrderedDict$values(
		$dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields(children));
};
var $dillonkearns$elm_graphql$Graphql$RawField$typename = A2(
	$dillonkearns$elm_graphql$Graphql$RawField$Leaf,
	{jT: '__typename', qa: ''},
	_List_Nil);
var $dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren = function (children) {
	return $elm$core$List$isEmpty(children) ? A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, children) : children;
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$serialize = F3(
	function (aliasName, mIndentationLevel, field) {
		var prefix = function () {
			if (!aliasName.$) {
				var aliasName_ = aliasName.a;
				return _Utils_ap(
					aliasName_,
					function () {
						if (!mIndentationLevel.$) {
							return ': ';
						} else {
							return ':';
						}
					}());
			} else {
				return '';
			}
		}();
		return A2(
			$elm$core$Maybe$map,
			function (string) {
				return _Utils_ap(
					$dillonkearns$elm_graphql$Graphql$Document$Indent$generate(
						A2($elm$core$Maybe$withDefault, 0, mIndentationLevel)),
					_Utils_ap(prefix, string));
			},
			function () {
				if (!field.$) {
					var fieldName = field.a;
					var args = field.b;
					var children = field.c;
					if (mIndentationLevel.$ === 1) {
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + ('{' + A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, children)))) + '}');
					} else {
						var indentationLevel = mIndentationLevel.a;
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + (' {\n' + A2(
								$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
								$elm$core$Maybe$Just(indentationLevel),
								children)))) + ('\n' + ($dillonkearns$elm_graphql$Graphql$Document$Indent$generate(indentationLevel) + '}')));
					}
				} else {
					var fieldName = field.a.jT;
					var args = field.b;
					return $elm$core$Maybe$Just(
						_Utils_ap(
							fieldName,
							$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args)));
				}
			}());
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren = F2(
	function (indentationLevel, children) {
		return A2(
			$elm$core$String$join,
			function () {
				if (!indentationLevel.$) {
					return '\n';
				} else {
					return ' ';
				}
			}(),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var field = _v0.a;
						var maybeAlias = _v0.b;
						return A3(
							$dillonkearns$elm_graphql$Graphql$Document$Field$serialize,
							maybeAlias,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$add(1),
								indentationLevel),
							field);
					},
					$dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing(
						$dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren(
							$dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields(children))))));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serialize = F2(
	function (operationType, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {\n{1}\n}',
			_List_fromArray(
				[
					operationType,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQuery = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'query', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return '{' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}');
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return 'query ' + (operationName + (' {' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}')));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName = F3(
	function (operationType, operationName, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {1} {\n{2}\n}',
			_List_fromArray(
				[
					operationType,
					operationName,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'query', operationName, fields);
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace = F2(
	function (old, _new) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split(old),
			$elm$core$String$join(_new));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace, '%20', '+'));
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(key) + ('=' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded = function (args) {
	return A2(
		$elm$core$String$join,
		'&',
		A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair, args));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams = F2(
	function (queryParams, url) {
		return $elm$core$List$isEmpty(queryParams) ? url : (url + ('?' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded(queryParams)));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build = F5(
	function (forceMethod, url, queryParams, maybeOperationName, queryDocument) {
		var _v0 = function () {
			if (!maybeOperationName.$) {
				var operationName = maybeOperationName.a;
				return _Utils_Tuple2(
					A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName, operationName, queryDocument),
					_List_fromArray(
						[
							_Utils_Tuple2('operationName', operationName)
						]));
			} else {
				return _Utils_Tuple2(
					$dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl(queryDocument),
					_List_Nil);
			}
		}();
		var serializedQueryForGetRequest = _v0.a;
		var operationNameParamForGetRequest = _v0.b;
		var urlForGetRequest = A2(
			$dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams,
			_Utils_ap(
				queryParams,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('query', serializedQueryForGetRequest),
					operationNameParamForGetRequest)),
			url);
		if (_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(1)) || ((_Utils_cmp(
			$elm$core$String$length(urlForGetRequest),
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength) > -1) && (!_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(0))))) {
			var _v2 = function () {
				if (!maybeOperationName.$) {
					var operationName = maybeOperationName.a;
					return _Utils_Tuple2(
						A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName, operationName, queryDocument),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'operationName',
								$elm$json$Json$Encode$string(operationName))
							]));
				} else {
					return _Utils_Tuple2(
						$dillonkearns$elm_graphql$Graphql$Document$serializeQuery(queryDocument),
						_List_Nil);
				}
			}();
			var serializedQuery = _v2.a;
			var operationNameParamForPostRequest = _v2.b;
			return {
				f6: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedQuery)),
							operationNameParamForPostRequest))),
				cd: 1,
				hn: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, queryParams, url)
			};
		} else {
			return {f6: $elm$http$Http$emptyBody, cd: 0, hn: urlForGetRequest};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError = F3(
	function (message, locations, details) {
		return {m_: details, ob: locations, of: message};
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location = F2(
	function (line, column) {
		return {mB: column, n5: line};
	});
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder = A3(
	$elm$json$Json$Decode$map2,
	$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location,
	A2($elm$json$Json$Decode$field, 'line', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'column', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder = A2(
	$elm$json$Json$Decode$field,
	'errors',
	$elm$json$Json$Decode$list(
		A4(
			$elm$json$Json$Decode$map3,
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError,
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'locations',
					$elm$json$Json$Decode$list($dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder))),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Dict$remove('locations'),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Dict$remove('message'),
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$value))))));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData = function (data) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Result$Err,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Tuple$pair(data),
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$nullJsonValue = function (a) {
	nullJsonValue:
	while (true) {
		var _v0 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, 'null');
		if (!_v0.$) {
			var value = _v0.a;
			return value;
		} else {
			var $temp$a = 0;
			a = $temp$a;
			continue nullJsonValue;
		}
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$errorDecoder = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2($elm$json$Json$Decode$map, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData, decoder)),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2(
					$elm$json$Json$Decode$map,
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value))),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				$elm$json$Json$Decode$succeed(
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData(
						$dillonkearns$elm_graphql$Graphql$Http$nullJsonValue(0))))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Http$decoderOrError = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_graphql$Graphql$Http$errorDecoder(decoder),
				A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, decoder)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutation = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'mutation', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'mutation', operationName, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Http$toReadyRequest = function (_v0) {
	var request = _v0;
	var _v1 = request.m_;
	if (!_v1.$) {
		var forcedRequestMethod = _v1.a;
		var querySelectionSet = _v1.b;
		var queryRequestDetails = A5(
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build,
			function () {
				if (!forcedRequestMethod.$) {
					if (!forcedRequestMethod.a) {
						var _v4 = forcedRequestMethod.a;
						return $elm$core$Maybe$Just(0);
					} else {
						var _v5 = forcedRequestMethod.a;
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Just(1);
				}
			}(),
			request.eE,
			request.c3,
			request.cW,
			querySelectionSet);
		return {
			f6: queryRequestDetails.f6,
			jE: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.gt),
			nr: request.nr,
			cd: function () {
				var _v2 = queryRequestDetails.cd;
				if (!_v2) {
					return 'GET';
				} else {
					return 'Post';
				}
			}(),
			au: request.au,
			hn: queryRequestDetails.hn
		};
	} else {
		var mutationSelectionSet = _v1.a;
		var serializedMutation = function () {
			var _v7 = request.cW;
			if (!_v7.$) {
				var operationName = _v7.a;
				return A2($dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName, operationName, mutationSelectionSet);
			} else {
				return $dillonkearns$elm_graphql$Graphql$Document$serializeMutation(mutationSelectionSet);
			}
		}();
		return {
			f6: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedMutation))
							]),
						function () {
							var _v6 = request.cW;
							if (!_v6.$) {
								var operationName = _v6.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'operationName',
										$elm$json$Json$Encode$string(operationName))
									]);
							} else {
								return _List_Nil;
							}
						}()))),
			jE: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.gt),
			nr: request.nr,
			cd: 'POST',
			au: request.au,
			hn: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, request.c3, request.eE)
		};
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$toHttpRequestRecord = F2(
	function (resultToMessage, fullRequest) {
		var request = fullRequest;
		return function (readyRequest) {
			return {
				f6: readyRequest.f6,
				gt: A2(
					$dillonkearns$elm_graphql$Graphql$Http$expectJson,
					A2($elm$core$Basics$composeR, $dillonkearns$elm_graphql$Graphql$Http$convertResult, resultToMessage),
					readyRequest.jE),
				nr: readyRequest.nr,
				cd: readyRequest.cd,
				au: readyRequest.au,
				lK: $elm$core$Maybe$Nothing,
				hn: readyRequest.hn
			};
		}(
			$dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(fullRequest));
	});
var $dillonkearns$elm_graphql$Graphql$Http$send = F2(
	function (resultToMessage, fullRequest) {
		var request = fullRequest;
		return (request.dg ? $elm$http$Http$riskyRequest : $elm$http$Http$request)(
			A2($dillonkearns$elm_graphql$Graphql$Http$toHttpRequestRecord, resultToMessage, fullRequest));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $dillonkearns$elm_graphql$Graphql$Http$withHeader = F3(
	function (key, value, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				nr: A2(
					$elm$core$List$cons,
					A2($elm$http$Http$header, key, value),
					request.nr)
			});
	});
var $author$project$Api$Graphql$withAuthToken = function (maybeToken) {
	if (!maybeToken.$) {
		var token = maybeToken.a;
		return A2($dillonkearns$elm_graphql$Graphql$Http$withHeader, 'authorization', 'Bearer ' + token);
	} else {
		return $elm$core$Basics$identity;
	}
};
var $author$project$Environment$Demo = 2;
var $author$project$Environment$Development = 0;
var $author$project$Environment$Production = 3;
var $author$project$Environment$Staging = 1;
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Environment$fromUrl = function (url) {
	return A2($elm$core$String$endsWith, 'localhost', url.e3) ? 0 : (A2($elm$core$String$endsWith, '.staging.cambiatus.io', url.e3) ? 1 : (A2($elm$core$String$endsWith, '.demo.cambiatus.io', url.e3) ? 2 : (A2($elm$core$String$endsWith, '.cambiatus.io', url.e3) ? 3 : 1)));
};
var $author$project$Environment$communitySubdomainParts = function (url) {
	var isStaging = function () {
		var _v4 = $author$project$Environment$fromUrl(url);
		switch (_v4) {
			case 0:
				return true;
			case 1:
				return true;
			default:
				return false;
		}
	}();
	var allParts = A2($elm$core$String$split, '.', url.e3);
	var addStaging = function (parts) {
		return isStaging ? _Utils_ap(
			parts,
			_List_fromArray(
				['staging'])) : parts;
	};
	if (!allParts.b) {
		return addStaging(
			_List_fromArray(
				['cambiatus']));
	} else {
		if (!allParts.b.b) {
			var subdomain = allParts.a;
			return addStaging(
				_List_fromArray(
					[subdomain]));
		} else {
			switch (allParts.b.a) {
				case 'localhost':
					var subdomain = allParts.a;
					var _v1 = allParts.b;
					return _List_fromArray(
						[subdomain, 'staging']);
				case 'cambiatus':
					var subdomain = allParts.a;
					var _v2 = allParts.b;
					return _List_fromArray(
						[subdomain]);
				default:
					var subdomain = allParts.a;
					var _v3 = allParts.b;
					var env = _v3.a;
					return _List_fromArray(
						[subdomain, env]);
			}
		}
	}
};
var $author$project$Environment$communityDomain = function (url) {
	return A2(
		$elm$core$String$join,
		'.',
		_Utils_ap(
			$author$project$Environment$communitySubdomainParts(url),
			_List_fromArray(
				['cambiatus', 'io'])));
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, list),
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $author$project$Api$Graphql$withCommunityDomain = function (shared) {
	var communityDomain = function () {
		if (shared.qf) {
			return $author$project$Environment$communityDomain(shared.hn);
		} else {
			if (A2($elm$core$String$endsWith, '.cambiatus.io', shared.hn.g_)) {
				var sharedUrl = shared.hn;
				return _Utils_update(
					sharedUrl,
					{
						g_: A2(
							$elm$core$String$join,
							'.',
							A3(
								$elm_community$list_extra$List$Extra$updateAt,
								0,
								function (_v0) {
									return 'cambiatus';
								},
								A2($elm$core$String$split, '.', sharedUrl.g_)))
					}).g_;
			} else {
				return 'cambiatus.staging.cambiatus.io';
			}
		}
	}();
	return A2($dillonkearns$elm_graphql$Graphql$Http$withHeader, 'Community-Domain', 'https://' + communityDomain);
};
var $author$project$Api$Graphql$query = F4(
	function (shared, maybeAuthToken, query_, toMsg) {
		var endpoints = shared.jN;
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, toMsg),
			A2(
				$author$project$Api$Graphql$withAuthToken,
				maybeAuthToken,
				A2(
					$author$project$Api$Graphql$withCommunityDomain,
					shared,
					A2($dillonkearns$elm_graphql$Graphql$Http$queryRequest, endpoints.gx, query_))));
	});
var $author$project$Page$toShared = function (session) {
	if (session.$ === 1) {
		var loggedIn = session.a;
		return loggedIn.A;
	} else {
		var guest = session.a;
		return guest.A;
	}
};
var $author$project$Page$Community$Invite$init = F2(
	function (session, invitationId) {
		return _Utils_Tuple2(
			$author$project$Page$Community$Invite$initModel(invitationId),
			function () {
				if (!session.$) {
					return A4(
						$author$project$Api$Graphql$query,
						$author$project$Page$toShared(session),
						$elm$core$Maybe$Nothing,
						$author$project$Community$inviteQuery(invitationId),
						$author$project$Page$Community$Invite$CompletedLoadInvite);
				} else {
					var loggedIn = session.a;
					return A3(
						$author$project$Session$LoggedIn$maybeInitWith,
						function (_v1) {
							return $author$project$Page$Community$Invite$CompletedLoadProfile;
						},
						function ($) {
							return $.pl;
						},
						loggedIn);
				}
			}());
	});
var $author$project$Page$Community$New$defaultLogos = _List_fromArray(
	['https://cambiatus-uploads.s3.amazonaws.com/cambiatus-uploads/community_1.png', 'https://cambiatus-uploads.s3.amazonaws.com/cambiatus-uploads/community_2.png', 'https://cambiatus-uploads.s3.amazonaws.com/cambiatus-uploads/community_3.png', 'https://cambiatus-uploads.s3.amazonaws.com/cambiatus-uploads/community_4.png', 'https://cambiatus-uploads.s3.amazonaws.com/cambiatus-uploads/community_5.png']);
var $author$project$Form$ErrorTracking = $elm$core$Basics$identity;
var $author$project$Form$Model = $elm$core$Basics$identity;
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Form$init = function (values) {
	return {
		b_: false,
		aT: {fD: false, cn: $elm$core$Set$empty},
		gP: $elm$core$Set$empty,
		o: values
	};
};
var $author$project$Form$RichText$Model = $elm$core$Basics$identity;
var $author$project$Form$RichText$NotShowing = {$: 0};
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine = {$: 10};
var $dillonkearns$elm_markdown$Markdown$Block$BlockQuote = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote = function (a) {
	return {$: 11, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Cdata = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeBlock = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeSpan = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CompletedTask = 2;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Emphasis = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Emphasis = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock = {$: 0};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$Block$Heading = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Heading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Html = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlComment = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlElement = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlInline = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Image = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$IncompleteTask = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Link = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$ListItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$NoTask = 0;
var $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$OrderedList = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock = F6(
	function (a, b, c, d, e, f) {
		return {$: 4, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Paragraph = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strikethrough = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strong = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Table = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Table = function (a) {
	return {$: 8, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Table$Table = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Text = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ThematicBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak = {$: 7};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$UnorderedList = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Parser$addReference = F2(
	function (state, linkRef) {
		return {
			a: A2($elm$core$List$cons, linkRef, state.a),
			b: state.b
		};
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.iQ);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.d, offset) < 0,
					0,
					{jw: col, j: s0.j, l: s0.l, d: offset, pA: row, iQ: s0.iQ});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.d, s.pA, s.jw, s);
	};
};
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Parser$Token$carriageReturn = A2(
	$elm$parser$Parser$Advanced$Token,
	'\r',
	$elm$parser$Parser$Expecting('a carriage return'));
var $dillonkearns$elm_markdown$Parser$Token$newline = A2(
	$elm$parser$Parser$Advanced$Token,
	'\n',
	$elm$parser$Parser$Expecting('a newline'));
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {jw: col, mK: contextStack, ph: problem, pA: row};
	});
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.pA, s.jw, x, s.j));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.d, s.pA, s.jw, s.iQ);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{jw: newCol, j: s.j, l: s.l, d: newOffset, pA: newRow, iQ: s.iQ});
	};
};
var $dillonkearns$elm_markdown$Whitespace$lineEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$carriageReturn),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
						$elm$parser$Parser$Advanced$succeed(0)
					])))
		]));
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$blankLine = A2(
	$elm$parser$Parser$Advanced$map,
	function (_v0) {
		return $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine;
	},
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$dillonkearns$elm_markdown$Whitespace$lineEnd));
var $dillonkearns$elm_markdown$Parser$Token$space = A2(
	$elm$parser$Parser$Advanced$Token,
	' ',
	$elm$parser$Parser$Expecting('a space'));
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts = _List_fromArray(
	[
		$elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			'>',
			$elm$parser$Parser$Expecting('>'))),
		A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'>',
						$elm$parser$Parser$Expecting(' >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						' >',
						$elm$parser$Parser$Expecting('  >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'  >',
						$elm$parser$Parser$Expecting('   >')))
				])))
	]);
var $dillonkearns$elm_markdown$Whitespace$isLineEnd = function (_char) {
	switch (_char) {
		case '\n':
			return true;
		case '\r':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd = $elm$parser$Parser$Advanced$chompWhile(
	A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd));
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.d, s1.d, s0.iQ),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.iQ),
			s.d) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $dillonkearns$elm_markdown$Helpers$endOfFile = $elm$parser$Parser$Advanced$end(
	$elm$parser$Parser$Expecting('the end of the input'));
var $dillonkearns$elm_markdown$Helpers$lineEndOrEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[$dillonkearns$elm_markdown$Whitespace$lineEnd, $dillonkearns$elm_markdown$Helpers$endOfFile]));
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuote = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote),
			$elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$Parser$problemToString = function (problem) {
	switch (problem.$) {
		case 0:
			var string = problem.a;
			return 'Expecting ' + string;
		case 1:
			return 'Expecting int';
		case 2:
			return 'Expecting hex';
		case 3:
			return 'Expecting octal';
		case 4:
			return 'Expecting binary';
		case 5:
			return 'Expecting float';
		case 6:
			return 'Expecting number';
		case 7:
			return 'Expecting variable';
		case 8:
			var string = problem.a;
			return 'Expecting symbol ' + string;
		case 9:
			var string = problem.a;
			return 'Expecting keyword ' + string;
		case 10:
			return 'Expecting keyword end';
		case 11:
			return 'Unexpected char';
		case 12:
			var problemDescription = problem.a;
			return problemDescription;
		default:
			return 'Bad repeat';
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString = function (deadEnd) {
	return 'Problem at row ' + ($elm$core$String$fromInt(deadEnd.pA) + ('\n' + $dillonkearns$elm_markdown$Markdown$Parser$problemToString(deadEnd.ph)));
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString = function (deadEnds) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
};
var $dillonkearns$elm_markdown$HtmlParser$Cdata = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$Element = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$HtmlParser$Text = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.d, s.iQ);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{jw: 1, j: s.j, l: s.l, d: s.d + 1, pA: s.pA + 1, iQ: s.iQ}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{jw: s.jw + 1, j: s.j, l: s.l, d: newOffset, pA: s.pA, iQ: s.iQ}));
		};
	});
var $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter = $elm$parser$Parser$Expecting('at least 1 tag name character');
var $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter = function (c) {
	switch (c) {
		case ' ':
			return false;
		case '\r':
			return false;
		case '\n':
			return false;
		case '\t':
			return false;
		case '/':
			return false;
		case '<':
			return false;
		case '>':
			return false;
		case '\"':
			return false;
		case '\'':
			return false;
		case '=':
			return false;
		default:
			return true;
	}
};
var $elm$core$String$toLower = _String_toLower;
var $dillonkearns$elm_markdown$HtmlParser$tagName = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (name, _v0) {
			return $elm$core$String$toLower(name);
		}),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter, $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter),
		$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$tagNameCharacter)));
var $dillonkearns$elm_markdown$HtmlParser$attributeName = $dillonkearns$elm_markdown$HtmlParser$tagName;
var $dillonkearns$elm_markdown$HtmlParser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $dillonkearns$elm_markdown$HtmlParser$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('quot', '\"')
		]));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $dillonkearns$elm_markdown$HtmlParser$decodeEscape = function (s) {
	return A2($elm$core$String$startsWith, '#x', s) ? A2(
		$elm$core$Result$mapError,
		$elm$parser$Parser$Problem,
		A2(
			$elm$core$Result$map,
			$elm$core$Char$fromCode,
			$rtfeldman$elm_hex$Hex$fromString(
				A2($elm$core$String$dropLeft, 2, s)))) : (A2($elm$core$String$startsWith, '#', s) ? A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('Invalid escaped character: ' + s),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Char$fromCode,
			$elm$core$String$toInt(
				A2($elm$core$String$dropLeft, 1, s)))) : A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('No entity named \"&' + (s + ';\" found.')),
		A2($elm$core$Dict$get, s, $dillonkearns$elm_markdown$HtmlParser$entities)));
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $dillonkearns$elm_markdown$HtmlParser$escapedChar = function (end_) {
	var process = function (entityStr) {
		var _v0 = $dillonkearns$elm_markdown$HtmlParser$decodeEscape(entityStr);
		if (!_v0.$) {
			var c = _v0.a;
			return $elm$parser$Parser$Advanced$succeed(c);
		} else {
			var e = _v0.a;
			return $elm$parser$Parser$Advanced$problem(e);
		}
	};
	var isEntityChar = function (c) {
		return (!_Utils_eq(c, end_)) && (c !== ';');
	};
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('&')),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$andThen,
				process,
				$elm$parser$Parser$Advanced$getChompedString(
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$chompIf,
							isEntityChar,
							$elm$parser$Parser$Expecting('an entity character')),
						$elm$parser$Parser$Advanced$chompWhile(isEntityChar)))),
			$dillonkearns$elm_markdown$HtmlParser$symbol(';')));
};
var $dillonkearns$elm_markdown$HtmlParser$textStringStep = F3(
	function (closingChar, predicate, accum) {
		return A2(
			$elm$parser$Parser$Advanced$andThen,
			function (soFar) {
				return $elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$map,
							function (escaped) {
								return $elm$parser$Parser$Advanced$Loop(
									_Utils_ap(
										accum,
										_Utils_ap(
											soFar,
											$elm$core$String$fromChar(escaped))));
							},
							$dillonkearns$elm_markdown$HtmlParser$escapedChar(closingChar)),
							$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(
								_Utils_ap(accum, soFar)))
						]));
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile(predicate)));
	});
var $dillonkearns$elm_markdown$HtmlParser$textString = function (closingChar) {
	var predicate = function (c) {
		return (!_Utils_eq(c, closingChar)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$Advanced$loop,
		'',
		A2($dillonkearns$elm_markdown$HtmlParser$textStringStep, closingChar, predicate));
};
var $dillonkearns$elm_markdown$HtmlParser$attributeValue = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\"')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString('\"'),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\"'))),
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\'')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString('\''),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\'')))
		]));
var $dillonkearns$elm_markdown$HtmlParser$keepOldest = F2(
	function (_new, mValue) {
		if (!mValue.$) {
			var v = mValue.a;
			return $elm$core$Maybe$Just(v);
		} else {
			return $elm$core$Maybe$Just(_new);
		}
	});
var $dillonkearns$elm_markdown$HtmlParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\r':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$whiteSpace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace);
var $dillonkearns$elm_markdown$HtmlParser$attributesStep = function (attrs) {
	var process = F2(
		function (name, value) {
			return $elm$parser$Parser$Advanced$Loop(
				A3(
					$elm$core$Dict$update,
					$elm$core$String$toLower(name),
					$dillonkearns$elm_markdown$HtmlParser$keepOldest(value),
					attrs));
		});
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(process),
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeName, $dillonkearns$elm_markdown$HtmlParser$whiteSpace),
							$dillonkearns$elm_markdown$HtmlParser$symbol('=')),
						$dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeValue, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				$elm$parser$Parser$Advanced$succeed(
				$elm$parser$Parser$Advanced$Done(attrs))
			]));
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $dillonkearns$elm_markdown$HtmlParser$attributes = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$Dict$foldl,
		F3(
			function (key, value, accum) {
				return A2(
					$elm$core$List$cons,
					{fj: key, lW: value},
					accum);
			}),
		_List_Nil),
	A2($elm$parser$Parser$Advanced$loop, $elm$core$Dict$empty, $dillonkearns$elm_markdown$HtmlParser$attributesStep));
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _v0 = A5(_Parser_findSubString, str, s.d, s.pA, s.jw, s.iQ);
		var newOffset = _v0.a;
		var newRow = _v0.b;
		var newCol = _v0.c;
		var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.iQ) : newOffset;
		return A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.d, adjustedOffset) < 0,
			0,
			{jw: newCol, j: s.j, l: s.l, d: adjustedOffset, pA: newRow, iQ: s.iQ});
	};
};
var $dillonkearns$elm_markdown$HtmlParser$cdata = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<![CDATA[')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr(']]>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol(']]>')));
var $dillonkearns$elm_markdown$HtmlParser$childrenStep = F2(
	function (options, accum) {
		return A2(
			$elm$parser$Parser$Advanced$map,
			function (f) {
				return f(accum);
			},
			$elm$parser$Parser$Advanced$oneOf(options));
	});
var $dillonkearns$elm_markdown$HtmlParser$fail = function (str) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(str));
};
var $dillonkearns$elm_markdown$HtmlParser$closingTag = function (startTagName) {
	var closingTagName = A2(
		$elm$parser$Parser$Advanced$andThen,
		function (endTagName) {
			return _Utils_eq(startTagName, endTagName) ? $elm$parser$Parser$Advanced$succeed(0) : $dillonkearns$elm_markdown$HtmlParser$fail('tag name mismatch: ' + (startTagName + (' and ' + endTagName)));
		},
		$dillonkearns$elm_markdown$HtmlParser$tagName);
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$HtmlParser$symbol('</'),
					$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
				closingTagName),
			$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>'));
};
var $dillonkearns$elm_markdown$HtmlParser$Comment = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $dillonkearns$elm_markdown$HtmlParser$comment = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Comment),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('<!--'))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('-->')),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('-->'))));
var $dillonkearns$elm_markdown$HtmlParser$Declaration = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter = $elm$parser$Parser$Expecting('at least 1 uppercase character');
var $dillonkearns$elm_markdown$HtmlParser$allUppercase = $elm$parser$Parser$Advanced$getChompedString(
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $elm$core$Char$isUpper, $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter),
		$elm$parser$Parser$Advanced$chompWhile($elm$core$Char$isUpper)));
var $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$HtmlParser$isWhitespace,
		$elm$parser$Parser$Expecting('at least one whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace));
var $dillonkearns$elm_markdown$HtmlParser$docType = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Declaration),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<!')),
		A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$allUppercase, $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>')));
var $dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$processingInstruction = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<?')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('?>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('?>')));
var $dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar = function (c) {
	switch (c) {
		case '<':
			return false;
		case '&':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions = _List_fromArray(
	[
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			return $elm$parser$Parser$Advanced$Loop(0);
		},
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$chompIf,
				$dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar,
				$elm$parser$Parser$Expecting('is not & or <')),
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar))),
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v1) {
			return $elm$parser$Parser$Advanced$Loop(0);
		},
		$dillonkearns$elm_markdown$HtmlParser$escapedChar('<')),
		$elm$parser$Parser$Advanced$succeed(
		$elm$parser$Parser$Advanced$Done(0))
	]);
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep = function (_v0) {
	return $elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions);
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeString = $elm$parser$Parser$Advanced$getChompedString(
	A2($elm$parser$Parser$Advanced$loop, 0, $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep));
var $dillonkearns$elm_markdown$HtmlParser$children = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_List_Nil,
		$dillonkearns$elm_markdown$HtmlParser$childrenStep(
			$dillonkearns$elm_markdown$HtmlParser$childrenStepOptions(startTagName)));
};
var $dillonkearns$elm_markdown$HtmlParser$childrenStepOptions = function (startTagName) {
	return _List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_v1, accum) {
					return $elm$parser$Parser$Advanced$Done(
						$elm$core$List$reverse(accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)),
			A2(
			$elm$parser$Parser$Advanced$andThen,
			function (text) {
				return $elm$core$String$isEmpty(text) ? A2(
					$elm$parser$Parser$Advanced$map,
					F2(
						function (_v2, accum) {
							return $elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(accum));
						}),
					$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)) : $elm$parser$Parser$Advanced$succeed(
					function (accum) {
						return $elm$parser$Parser$Advanced$Loop(
							A2(
								$elm$core$List$cons,
								$dillonkearns$elm_markdown$HtmlParser$Text(text),
								accum));
					});
			},
			$dillonkearns$elm_markdown$HtmlParser$textNodeString),
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_new, accum) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($elm$core$List$cons, _new, accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$cyclic$html())
		]);
};
var $dillonkearns$elm_markdown$HtmlParser$elementContinuation = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$HtmlParser$Element(startTagName)),
				$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
			A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributes, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return _List_Nil;
					},
					$dillonkearns$elm_markdown$HtmlParser$symbol('/>')),
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$HtmlParser$symbol('>')),
					$dillonkearns$elm_markdown$HtmlParser$children(startTagName))
				])));
};
function $dillonkearns$elm_markdown$HtmlParser$cyclic$html() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$HtmlParser$Cdata, $dillonkearns$elm_markdown$HtmlParser$cdata),
				$dillonkearns$elm_markdown$HtmlParser$processingInstruction,
				$dillonkearns$elm_markdown$HtmlParser$comment,
				$dillonkearns$elm_markdown$HtmlParser$docType,
				$dillonkearns$elm_markdown$HtmlParser$cyclic$element()
			]));
}
function $dillonkearns$elm_markdown$HtmlParser$cyclic$element() {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<')),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$HtmlParser$elementContinuation, $dillonkearns$elm_markdown$HtmlParser$tagName));
}
var $dillonkearns$elm_markdown$HtmlParser$html = $dillonkearns$elm_markdown$HtmlParser$cyclic$html();
$dillonkearns$elm_markdown$HtmlParser$cyclic$html = function () {
	return $dillonkearns$elm_markdown$HtmlParser$html;
};
var $dillonkearns$elm_markdown$HtmlParser$element = $dillonkearns$elm_markdown$HtmlParser$cyclic$element();
$dillonkearns$elm_markdown$HtmlParser$cyclic$element = function () {
	return $dillonkearns$elm_markdown$HtmlParser$element;
};
var $dillonkearns$elm_markdown$Parser$Token$tab = A2(
	$elm$parser$Parser$Advanced$Token,
	'\t',
	$elm$parser$Parser$Expecting('a tab'));
var $dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$backtrackable(
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'   ',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							' \t',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'  \t',
							$elm$parser$Parser$ExpectingSymbol('Indentation')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock),
		$dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $elm$core$Basics$modBy = _Basics_modBy;
var $dillonkearns$elm_markdown$Markdown$Helpers$isEven = function (_int) {
	return !A2($elm$core$Basics$modBy, 2, _int);
};
var $dillonkearns$elm_markdown$Markdown$Block$Loose = 0;
var $dillonkearns$elm_markdown$Markdown$Block$Tight = 1;
var $dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay = function (isTight) {
	return isTight ? 1 : 0;
};
var $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith = F3(
	function (joinWith, string1, string2) {
		var _v0 = _Utils_Tuple2(string1, string2);
		if (_v0.a === '') {
			return string2;
		} else {
			if (_v0.b === '') {
				return string1;
			} else {
				return _Utils_ap(
					string1,
					_Utils_ap(joinWith, string2));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll = F2(
	function (string1, string2) {
		return string1 + ('\n' + string2);
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (rawLine, _v0) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
		}),
	$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser = A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$OrderedList$ListItem = F4(
	function (order, intended, marker, body) {
		return {f6: body, nM: intended, oc: marker, oZ: order};
	});
var $elm$parser$Parser$Advanced$getCol = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.jw, s);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, '');
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore = function (condition) {
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$chompIf,
			condition,
			$elm$parser$Parser$Problem('Expected one or more character')),
		$elm$parser$Parser$Advanced$chompWhile(condition));
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$OrderedList$Dot = 0;
var $dillonkearns$elm_markdown$Markdown$OrderedList$Paren = 1;
var $dillonkearns$elm_markdown$Parser$Token$closingParen = A2(
	$elm$parser$Parser$Advanced$Token,
	')',
	$elm$parser$Parser$Expecting('a `)`'));
var $dillonkearns$elm_markdown$Parser$Token$dot = A2(
	$elm$parser$Parser$Advanced$Token,
	'.',
	$elm$parser$Parser$Expecting('a `.`'));
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$dot)),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$closingParen))
		]));
var $dillonkearns$elm_markdown$Parser$Extra$positiveInteger = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($elm$core$Char$isDigit));
var $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (parsed) {
		return (parsed <= 999999999) ? $elm$parser$Parser$Advanced$succeed(parsed) : $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Starting numbers must be nine digits or less.'));
	},
	$dillonkearns$elm_markdown$Parser$Extra$positiveInteger);
var $dillonkearns$elm_markdown$Whitespace$space = $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$space);
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $dillonkearns$elm_markdown$Parser$Extra$upTo = F2(
	function (n, parser) {
		var _v0 = A2($elm$core$List$repeat, n, parser);
		if (!_v0.b) {
			return $elm$parser$Parser$Advanced$succeed(0);
		} else {
			var firstParser = _v0.a;
			var remainingParsers = _v0.b;
			return A3(
				$elm$core$List$foldl,
				F2(
					function (p, parsers) {
						return $elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									A2($elm$parser$Parser$Advanced$ignorer, p, parsers),
									$elm$parser$Parser$Advanced$succeed(0)
								]));
					}),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							firstParser,
							$elm$parser$Parser$Advanced$succeed(0)
						])),
				remainingParsers);
		}
	});
var $dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1 = function (parsed) {
	if (parsed === 1) {
		return $elm$parser$Parser$Advanced$succeed(parsed);
	} else {
		return $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Lists inside a paragraph or after a paragraph without a blank line must start with 1'));
	}
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser = function (previousWasBody) {
	return previousWasBody ? A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits)) : A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
		$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$parser = function (previousWasBody) {
	var parseSubsequentItem = F5(
		function (start, order, marker, mid, _v0) {
			var end = _v0.a;
			var body = _v0.b;
			return ((end - mid) <= 4) ? A4($dillonkearns$elm_markdown$Markdown$OrderedList$ListItem, order, end - start, marker, body) : A4(
				$dillonkearns$elm_markdown$Markdown$OrderedList$ListItem,
				order,
				(mid - start) + 1,
				marker,
				_Utils_ap(
					A2($elm$core$String$repeat, (end - mid) - 1, ' '),
					body));
		});
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(parseSubsequentItem),
						$elm$parser$Parser$Advanced$getCol),
					$elm$parser$Parser$Advanced$backtrackable(
						$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser(previousWasBody))),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (item) {
			return A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, true, item.nM, item.oc, item.oZ, _List_Nil, item.f6);
		},
		$dillonkearns$elm_markdown$Markdown$OrderedList$parser(previousWasBody));
};
var $dillonkearns$elm_markdown$Markdown$Inline$CodeInline = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak = {$: 1};
var $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Image = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Link = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Text = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline = function (_v0) {
	var match = _v0;
	var _v1 = match.eq;
	switch (_v1.$) {
		case 0:
			return $dillonkearns$elm_markdown$Markdown$Inline$Text(match.n);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak;
		case 2:
			return $dillonkearns$elm_markdown$Markdown$Inline$CodeInline(match.n);
		case 3:
			var _v2 = _v1.a;
			var text = _v2.a;
			var url = _v2.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Markdown$Inline$Text(text)
					]));
		case 4:
			var _v3 = _v1.a;
			var url = _v3.a;
			var maybeTitle = _v3.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.Q));
		case 5:
			var _v4 = _v1.a;
			var url = _v4.a;
			var maybeTitle = _v4.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Image,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.Q));
		case 6:
			var model = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline(model);
		case 7:
			var length = _v1.a;
			return A2(
				$dillonkearns$elm_markdown$Markdown$Inline$Emphasis,
				length,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.Q));
		default:
			return $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough(
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.Q));
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines = function (matches) {
	return A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline, matches);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Match = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch = F2(
	function (parentMatch, childMatch) {
		return {k: childMatch.k - parentMatch.S, Q: childMatch.Q, m: childMatch.m - parentMatch.S, n: childMatch.n, at: childMatch.at - parentMatch.S, S: childMatch.S - parentMatch.S, eq: childMatch.eq};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$addChild = F2(
	function (parentMatch, childMatch) {
		return {
			k: parentMatch.k,
			Q: A2(
				$elm$core$List$cons,
				A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, parentMatch, childMatch),
				parentMatch.Q),
			m: parentMatch.m,
			n: parentMatch.n,
			at: parentMatch.at,
			S: parentMatch.S,
			eq: parentMatch.eq
		};
	});
var $elm$core$List$sortBy = _List_sortBy;
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren = function (_v4) {
	var match = _v4;
	return {
		k: match.k,
		Q: $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(match.Q),
		m: match.m,
		n: match.n,
		at: match.at,
		S: match.S,
		eq: match.eq
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches = function (matches) {
	var _v2 = A2(
		$elm$core$List$sortBy,
		function (_v3) {
			var match = _v3;
			return match.m;
		},
		matches);
	if (!_v2.b) {
		return _List_Nil;
	} else {
		var first = _v2.a;
		var rest = _v2.b;
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp, rest, first, _List_Nil);
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp = F3(
	function (remaining, _v0, matchesTail) {
		organizeMatchesHelp:
		while (true) {
			var prevMatch = _v0;
			if (!remaining.b) {
				return A2(
					$elm$core$List$cons,
					$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch),
					matchesTail);
			} else {
				var match = remaining.a;
				var rest = remaining.b;
				if (_Utils_cmp(prevMatch.k, match.m) < 1) {
					var $temp$remaining = rest,
						$temp$_v0 = match,
						$temp$matchesTail = A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch),
						matchesTail);
					remaining = $temp$remaining;
					_v0 = $temp$_v0;
					matchesTail = $temp$matchesTail;
					continue organizeMatchesHelp;
				} else {
					if ((_Utils_cmp(prevMatch.m, match.m) < 0) && (_Utils_cmp(prevMatch.k, match.k) > 0)) {
						var $temp$remaining = rest,
							$temp$_v0 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$addChild, prevMatch, match),
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					} else {
						var $temp$remaining = rest,
							$temp$_v0 = prevMatch,
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					}
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType = {$: 0};
var $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand = function (string) {
	return A2($elm$core$String$contains, '&', string);
};
var $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#([0-9]{1,8});'));
var $dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode = function (_int) {
	var remain_ = A2($elm$core$Basics$modBy, 16, _int);
	var remain = A2($elm$core$Basics$modBy, 131070, _int);
	return (_int >= 131070) && ((((0 <= remain) && (remain <= 15)) || ((65536 <= remain) && (remain <= 65551))) && ((remain_ === 14) || (remain_ === 15)));
};
var $dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode = function (_int) {
	return (_int === 9) || ((_int === 10) || ((_int === 13) || ((_int === 133) || (((32 <= _int) && (_int <= 126)) || (((160 <= _int) && (_int <= 55295)) || (((57344 <= _int) && (_int <= 64975)) || (((65008 <= _int) && (_int <= 65533)) || ((65536 <= _int) && (_int <= 1114109)))))))));
};
var $dillonkearns$elm_markdown$Markdown$Entity$validUnicode = function (_int) {
	return ($dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode(_int) && (!$dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode(_int))) ? $elm$core$String$fromChar(
		$elm$core$Char$fromCode(_int)) : $elm$core$String$fromChar(
		$elm$core$Char$fromCode(65533));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal = function (match) {
	var _v0 = match.iW;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		var _v1 = $elm$core$String$toInt(first);
		if (!_v1.$) {
			var v = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(v);
		} else {
			return match.fg;
		}
	} else {
		return match.fg;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal);
var $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&([0-9a-zA-Z]+);'));
var $dillonkearns$elm_markdown$Markdown$Entity$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('quot', 34),
			_Utils_Tuple2('amp', 38),
			_Utils_Tuple2('apos', 39),
			_Utils_Tuple2('lt', 60),
			_Utils_Tuple2('gt', 62),
			_Utils_Tuple2('nbsp', 160),
			_Utils_Tuple2('iexcl', 161),
			_Utils_Tuple2('cent', 162),
			_Utils_Tuple2('pound', 163),
			_Utils_Tuple2('curren', 164),
			_Utils_Tuple2('yen', 165),
			_Utils_Tuple2('brvbar', 166),
			_Utils_Tuple2('sect', 167),
			_Utils_Tuple2('uml', 168),
			_Utils_Tuple2('copy', 169),
			_Utils_Tuple2('ordf', 170),
			_Utils_Tuple2('laquo', 171),
			_Utils_Tuple2('not', 172),
			_Utils_Tuple2('shy', 173),
			_Utils_Tuple2('reg', 174),
			_Utils_Tuple2('macr', 175),
			_Utils_Tuple2('deg', 176),
			_Utils_Tuple2('plusmn', 177),
			_Utils_Tuple2('sup2', 178),
			_Utils_Tuple2('sup3', 179),
			_Utils_Tuple2('acute', 180),
			_Utils_Tuple2('micro', 181),
			_Utils_Tuple2('para', 182),
			_Utils_Tuple2('middot', 183),
			_Utils_Tuple2('cedil', 184),
			_Utils_Tuple2('sup1', 185),
			_Utils_Tuple2('ordm', 186),
			_Utils_Tuple2('raquo', 187),
			_Utils_Tuple2('frac14', 188),
			_Utils_Tuple2('frac12', 189),
			_Utils_Tuple2('frac34', 190),
			_Utils_Tuple2('iquest', 191),
			_Utils_Tuple2('Agrave', 192),
			_Utils_Tuple2('Aacute', 193),
			_Utils_Tuple2('Acirc', 194),
			_Utils_Tuple2('Atilde', 195),
			_Utils_Tuple2('Auml', 196),
			_Utils_Tuple2('Aring', 197),
			_Utils_Tuple2('AElig', 198),
			_Utils_Tuple2('Ccedil', 199),
			_Utils_Tuple2('Egrave', 200),
			_Utils_Tuple2('Eacute', 201),
			_Utils_Tuple2('Ecirc', 202),
			_Utils_Tuple2('Euml', 203),
			_Utils_Tuple2('Igrave', 204),
			_Utils_Tuple2('Iacute', 205),
			_Utils_Tuple2('Icirc', 206),
			_Utils_Tuple2('Iuml', 207),
			_Utils_Tuple2('ETH', 208),
			_Utils_Tuple2('Ntilde', 209),
			_Utils_Tuple2('Ograve', 210),
			_Utils_Tuple2('Oacute', 211),
			_Utils_Tuple2('Ocirc', 212),
			_Utils_Tuple2('Otilde', 213),
			_Utils_Tuple2('Ouml', 214),
			_Utils_Tuple2('times', 215),
			_Utils_Tuple2('Oslash', 216),
			_Utils_Tuple2('Ugrave', 217),
			_Utils_Tuple2('Uacute', 218),
			_Utils_Tuple2('Ucirc', 219),
			_Utils_Tuple2('Uuml', 220),
			_Utils_Tuple2('Yacute', 221),
			_Utils_Tuple2('THORN', 222),
			_Utils_Tuple2('szlig', 223),
			_Utils_Tuple2('agrave', 224),
			_Utils_Tuple2('aacute', 225),
			_Utils_Tuple2('acirc', 226),
			_Utils_Tuple2('atilde', 227),
			_Utils_Tuple2('auml', 228),
			_Utils_Tuple2('aring', 229),
			_Utils_Tuple2('aelig', 230),
			_Utils_Tuple2('ccedil', 231),
			_Utils_Tuple2('egrave', 232),
			_Utils_Tuple2('eacute', 233),
			_Utils_Tuple2('ecirc', 234),
			_Utils_Tuple2('euml', 235),
			_Utils_Tuple2('igrave', 236),
			_Utils_Tuple2('iacute', 237),
			_Utils_Tuple2('icirc', 238),
			_Utils_Tuple2('iuml', 239),
			_Utils_Tuple2('eth', 240),
			_Utils_Tuple2('ntilde', 241),
			_Utils_Tuple2('ograve', 242),
			_Utils_Tuple2('oacute', 243),
			_Utils_Tuple2('ocirc', 244),
			_Utils_Tuple2('otilde', 245),
			_Utils_Tuple2('ouml', 246),
			_Utils_Tuple2('divide', 247),
			_Utils_Tuple2('oslash', 248),
			_Utils_Tuple2('ugrave', 249),
			_Utils_Tuple2('uacute', 250),
			_Utils_Tuple2('ucirc', 251),
			_Utils_Tuple2('uuml', 252),
			_Utils_Tuple2('yacute', 253),
			_Utils_Tuple2('thorn', 254),
			_Utils_Tuple2('yuml', 255),
			_Utils_Tuple2('OElig', 338),
			_Utils_Tuple2('oelig', 339),
			_Utils_Tuple2('Scaron', 352),
			_Utils_Tuple2('scaron', 353),
			_Utils_Tuple2('Yuml', 376),
			_Utils_Tuple2('fnof', 402),
			_Utils_Tuple2('circ', 710),
			_Utils_Tuple2('tilde', 732),
			_Utils_Tuple2('Alpha', 913),
			_Utils_Tuple2('Beta', 914),
			_Utils_Tuple2('Gamma', 915),
			_Utils_Tuple2('Delta', 916),
			_Utils_Tuple2('Epsilon', 917),
			_Utils_Tuple2('Zeta', 918),
			_Utils_Tuple2('Eta', 919),
			_Utils_Tuple2('Theta', 920),
			_Utils_Tuple2('Iota', 921),
			_Utils_Tuple2('Kappa', 922),
			_Utils_Tuple2('Lambda', 923),
			_Utils_Tuple2('Mu', 924),
			_Utils_Tuple2('Nu', 925),
			_Utils_Tuple2('Xi', 926),
			_Utils_Tuple2('Omicron', 927),
			_Utils_Tuple2('Pi', 928),
			_Utils_Tuple2('Rho', 929),
			_Utils_Tuple2('Sigma', 931),
			_Utils_Tuple2('Tau', 932),
			_Utils_Tuple2('Upsilon', 933),
			_Utils_Tuple2('Phi', 934),
			_Utils_Tuple2('Chi', 935),
			_Utils_Tuple2('Psi', 936),
			_Utils_Tuple2('Omega', 937),
			_Utils_Tuple2('alpha', 945),
			_Utils_Tuple2('beta', 946),
			_Utils_Tuple2('gamma', 947),
			_Utils_Tuple2('delta', 948),
			_Utils_Tuple2('epsilon', 949),
			_Utils_Tuple2('zeta', 950),
			_Utils_Tuple2('eta', 951),
			_Utils_Tuple2('theta', 952),
			_Utils_Tuple2('iota', 953),
			_Utils_Tuple2('kappa', 954),
			_Utils_Tuple2('lambda', 955),
			_Utils_Tuple2('mu', 956),
			_Utils_Tuple2('nu', 957),
			_Utils_Tuple2('xi', 958),
			_Utils_Tuple2('omicron', 959),
			_Utils_Tuple2('pi', 960),
			_Utils_Tuple2('rho', 961),
			_Utils_Tuple2('sigmaf', 962),
			_Utils_Tuple2('sigma', 963),
			_Utils_Tuple2('tau', 964),
			_Utils_Tuple2('upsilon', 965),
			_Utils_Tuple2('phi', 966),
			_Utils_Tuple2('chi', 967),
			_Utils_Tuple2('psi', 968),
			_Utils_Tuple2('omega', 969),
			_Utils_Tuple2('thetasym', 977),
			_Utils_Tuple2('upsih', 978),
			_Utils_Tuple2('piv', 982),
			_Utils_Tuple2('ensp', 8194),
			_Utils_Tuple2('emsp', 8195),
			_Utils_Tuple2('thinsp', 8201),
			_Utils_Tuple2('zwnj', 8204),
			_Utils_Tuple2('zwj', 8205),
			_Utils_Tuple2('lrm', 8206),
			_Utils_Tuple2('rlm', 8207),
			_Utils_Tuple2('ndash', 8211),
			_Utils_Tuple2('mdash', 8212),
			_Utils_Tuple2('lsquo', 8216),
			_Utils_Tuple2('rsquo', 8217),
			_Utils_Tuple2('sbquo', 8218),
			_Utils_Tuple2('ldquo', 8220),
			_Utils_Tuple2('rdquo', 8221),
			_Utils_Tuple2('bdquo', 8222),
			_Utils_Tuple2('dagger', 8224),
			_Utils_Tuple2('Dagger', 8225),
			_Utils_Tuple2('bull', 8226),
			_Utils_Tuple2('hellip', 8230),
			_Utils_Tuple2('permil', 8240),
			_Utils_Tuple2('prime', 8242),
			_Utils_Tuple2('Prime', 8243),
			_Utils_Tuple2('lsaquo', 8249),
			_Utils_Tuple2('rsaquo', 8250),
			_Utils_Tuple2('oline', 8254),
			_Utils_Tuple2('frasl', 8260),
			_Utils_Tuple2('euro', 8364),
			_Utils_Tuple2('image', 8465),
			_Utils_Tuple2('weierp', 8472),
			_Utils_Tuple2('real', 8476),
			_Utils_Tuple2('trade', 8482),
			_Utils_Tuple2('alefsym', 8501),
			_Utils_Tuple2('larr', 8592),
			_Utils_Tuple2('uarr', 8593),
			_Utils_Tuple2('rarr', 8594),
			_Utils_Tuple2('darr', 8595),
			_Utils_Tuple2('harr', 8596),
			_Utils_Tuple2('crarr', 8629),
			_Utils_Tuple2('lArr', 8656),
			_Utils_Tuple2('uArr', 8657),
			_Utils_Tuple2('rArr', 8658),
			_Utils_Tuple2('dArr', 8659),
			_Utils_Tuple2('hArr', 8660),
			_Utils_Tuple2('forall', 8704),
			_Utils_Tuple2('part', 8706),
			_Utils_Tuple2('exist', 8707),
			_Utils_Tuple2('empty', 8709),
			_Utils_Tuple2('nabla', 8711),
			_Utils_Tuple2('isin', 8712),
			_Utils_Tuple2('notin', 8713),
			_Utils_Tuple2('ni', 8715),
			_Utils_Tuple2('prod', 8719),
			_Utils_Tuple2('sum', 8721),
			_Utils_Tuple2('minus', 8722),
			_Utils_Tuple2('lowast', 8727),
			_Utils_Tuple2('radic', 8730),
			_Utils_Tuple2('prop', 8733),
			_Utils_Tuple2('infin', 8734),
			_Utils_Tuple2('ang', 8736),
			_Utils_Tuple2('and', 8743),
			_Utils_Tuple2('or', 8744),
			_Utils_Tuple2('cap', 8745),
			_Utils_Tuple2('cup', 8746),
			_Utils_Tuple2('int', 8747),
			_Utils_Tuple2('there4', 8756),
			_Utils_Tuple2('sim', 8764),
			_Utils_Tuple2('cong', 8773),
			_Utils_Tuple2('asymp', 8776),
			_Utils_Tuple2('ne', 8800),
			_Utils_Tuple2('equiv', 8801),
			_Utils_Tuple2('le', 8804),
			_Utils_Tuple2('ge', 8805),
			_Utils_Tuple2('sub', 8834),
			_Utils_Tuple2('sup', 8835),
			_Utils_Tuple2('nsub', 8836),
			_Utils_Tuple2('sube', 8838),
			_Utils_Tuple2('supe', 8839),
			_Utils_Tuple2('oplus', 8853),
			_Utils_Tuple2('otimes', 8855),
			_Utils_Tuple2('perp', 8869),
			_Utils_Tuple2('sdot', 8901),
			_Utils_Tuple2('lceil', 8968),
			_Utils_Tuple2('rceil', 8969),
			_Utils_Tuple2('lfloor', 8970),
			_Utils_Tuple2('rfloor', 8971),
			_Utils_Tuple2('lang', 9001),
			_Utils_Tuple2('rang', 9002),
			_Utils_Tuple2('loz', 9674),
			_Utils_Tuple2('spades', 9824),
			_Utils_Tuple2('clubs', 9827),
			_Utils_Tuple2('hearts', 9829),
			_Utils_Tuple2('diams', 9830)
		]));
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity = function (match) {
	var _v0 = match.iW;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		var _v1 = A2($elm$core$Dict$get, first, $dillonkearns$elm_markdown$Markdown$Entity$entities);
		if (!_v1.$) {
			var code = _v1.a;
			return $elm$core$String$fromChar(
				$elm$core$Char$fromCode(code));
		} else {
			return match.fg;
		}
	} else {
		return match.fg;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntities = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity);
var $dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\+)([!\"#$%&\\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])'));
var $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable = A2(
	$elm$regex$Regex$replace,
	$dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex,
	function (regexMatch) {
		var _v0 = regexMatch.iW;
		if (((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) {
			var backslashes = _v0.a.a;
			var _v1 = _v0.b;
			var escapedStr = _v1.a.a;
			return _Utils_ap(
				A2(
					$elm$core$String$repeat,
					($elm$core$String$length(backslashes) / 2) | 0,
					'\\'),
				escapedStr);
		} else {
			return regexMatch.fg;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#[Xx]([0-9a-fA-F]{1,8});'));
var $dillonkearns$elm_markdown$Markdown$Entity$hexToInt = function (string) {
	var folder = F2(
		function (hexDigit, _int) {
			return ((_int * 16) + A2(
				$elm$core$Basics$modBy,
				39,
				$elm$core$Char$toCode(hexDigit))) - 9;
		});
	return A3(
		$elm$core$String$foldl,
		folder,
		0,
		$elm$core$String$toLower(string));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal = function (match) {
	var _v0 = match.iW;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(
			$dillonkearns$elm_markdown$Markdown$Entity$hexToInt(first));
	} else {
		return match.fg;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal);
var $dillonkearns$elm_markdown$Markdown$Helpers$formatStr = function (str) {
	var withEscapes = $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable(str);
	return $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand(withEscapes) ? $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals(
		$dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals(
			$dillonkearns$elm_markdown$Markdown$Entity$replaceEntities(withEscapes))) : withEscapes;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch = function (text) {
	return {
		k: 0,
		Q: _List_Nil,
		m: 0,
		n: $dillonkearns$elm_markdown$Markdown$Helpers$formatStr(text),
		at: 0,
		S: 0,
		eq: $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch = F3(
	function (rawText, _v2, parsedMatches) {
		var matchModel = _v2;
		var updtMatch = {
			k: matchModel.k,
			Q: A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches, matchModel.n, _List_Nil, matchModel.Q),
			m: matchModel.m,
			n: matchModel.n,
			at: matchModel.at,
			S: matchModel.S,
			eq: matchModel.eq
		};
		if (!parsedMatches.b) {
			var finalStr = A2($elm$core$String$dropLeft, matchModel.k, rawText);
			return $elm$core$String$isEmpty(finalStr) ? _List_fromArray(
				[updtMatch]) : _List_fromArray(
				[
					updtMatch,
					$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(finalStr)
				]);
		} else {
			var matchHead = parsedMatches.a;
			var matchesTail = parsedMatches.b;
			var _v4 = matchHead.eq;
			if (!_v4.$) {
				return A2($elm$core$List$cons, updtMatch, parsedMatches);
			} else {
				return _Utils_eq(matchModel.k, matchHead.m) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : ((_Utils_cmp(matchModel.k, matchHead.m) < 0) ? A2(
					$elm$core$List$cons,
					updtMatch,
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A3($elm$core$String$slice, matchModel.k, matchHead.m, rawText)),
						parsedMatches)) : parsedMatches);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches = F3(
	function (rawText, parsedMatches, matches) {
		parseTextMatches:
		while (true) {
			if (!matches.b) {
				if (!parsedMatches.b) {
					return $elm$core$String$isEmpty(rawText) ? _List_Nil : _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(rawText)
						]);
				} else {
					var matchModel = parsedMatches.a;
					return (matchModel.m > 0) ? A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A2($elm$core$String$left, matchModel.m, rawText)),
						parsedMatches) : parsedMatches;
				}
			} else {
				var match = matches.a;
				var matchesTail = matches.b;
				var $temp$rawText = rawText,
					$temp$parsedMatches = A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch, rawText, match, parsedMatches),
					$temp$matches = matchesTail;
				rawText = $temp$rawText;
				parsedMatches = $temp$parsedMatches;
				matches = $temp$matches;
				continue parseTextMatches;
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\<)'));
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen = {$: 4};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken = function (regMatch) {
	var _v0 = regMatch.iW;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var delimiter = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{e5: regMatch.e5 + backslashesLength, ie: 1, f: $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\>)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Escaped = 0;
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotEscaped = 1;
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken = function (regMatch) {
	var _v0 = regMatch.iW;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				e5: regMatch.e5 + backslashesLength,
				ie: 1,
				f: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(0)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^*])?(\\*+)([^*])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation = function (c) {
	switch (c) {
		case '!':
			return true;
		case '\"':
			return true;
		case '#':
			return true;
		case '%':
			return true;
		case '&':
			return true;
		case '\'':
			return true;
		case '(':
			return true;
		case ')':
			return true;
		case '*':
			return true;
		case ',':
			return true;
		case '-':
			return true;
		case '.':
			return true;
		case '/':
			return true;
		case ':':
			return true;
		case ';':
			return true;
		case '?':
			return true;
		case '@':
			return true;
		case '[':
			return true;
		case ']':
			return true;
		case '_':
			return true;
		case '{':
			return true;
		case '}':
			return true;
		case '~':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\u000C':
			return true;
		case '\n':
			return true;
		case '\r':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u00A0':
			return true;
		case '\u2028':
			return true;
		case '\u2029':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank = function (mstring) {
	if (!mstring.$) {
		var string = mstring.a;
		return ($elm$core$String$isEmpty(string) || $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace(string)) ? 0 : ($dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation(string) ? 1 : 2);
	} else {
		return 0;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken = F3(
	function (_char, rawText, regMatch) {
		var _v0 = regMatch.iW;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) && _v0.b.b.b.b) {
			var maybeBackslashes = _v0.a;
			var _v1 = _v0.b;
			var maybeLeftFringe = _v1.a;
			var _v2 = _v1.b;
			var delimiter = _v2.a.a;
			var _v3 = _v2.b;
			var maybeRightFringe = _v3.a;
			var rFringeRank = $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(maybeRightFringe);
			var leftFringeLength = function () {
				if (!maybeLeftFringe.$) {
					var left = maybeLeftFringe.a;
					return $elm$core$String$length(left);
				} else {
					return 0;
				}
			}();
			var mLeftFringe = ((!(!regMatch.e5)) && (!leftFringeLength)) ? $elm$core$Maybe$Just(
				A3($elm$core$String$slice, regMatch.e5 - 1, regMatch.e5, rawText)) : maybeLeftFringe;
			var backslashesLength = function () {
				if (!maybeBackslashes.$) {
					var backslashes = maybeBackslashes.a;
					return $elm$core$String$length(backslashes);
				} else {
					return 0;
				}
			}();
			var isEscaped = ((!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) && (!leftFringeLength)) || function () {
				if ((!mLeftFringe.$) && (mLeftFringe.a === '\\')) {
					return true;
				} else {
					return false;
				}
			}();
			var delimiterLength = isEscaped ? ($elm$core$String$length(delimiter) - 1) : $elm$core$String$length(delimiter);
			var lFringeRank = isEscaped ? 1 : $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(mLeftFringe);
			if ((delimiterLength <= 0) || ((_char === '_') && ((lFringeRank === 2) && (rFringeRank === 2)))) {
				return $elm$core$Maybe$Nothing;
			} else {
				var index = ((regMatch.e5 + backslashesLength) + leftFringeLength) + (isEscaped ? 1 : 0);
				return $elm$core$Maybe$Just(
					{
						e5: index,
						ie: delimiterLength,
						f: A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken,
							_char,
							{gO: lFringeRank, g5: rFringeRank})
					});
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '*', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\`+)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken = function (regMatch) {
	var _v0 = regMatch.iW;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backtick = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				e5: regMatch.e5 + backslashesLength,
				ie: $elm$core$String$length(backtick),
				f: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(0)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( {2,}))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken = {$: 9};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken = function (regMatch) {
	var _v0 = regMatch.iW;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return (!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) ? $elm$core$Maybe$Just(
					{e5: (regMatch.e5 + backslashesLength) - 1, ie: 2, f: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Nothing;
			} else {
				if (_v0.b.b && (!_v0.b.a.$)) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							e5: regMatch.e5,
							ie: $elm$core$String$length(regMatch.fg),
							f: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken = function (regMatch) {
	var _v0 = regMatch.iW;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
					{e5: regMatch.e5 + backslashesLength, ie: 1, f: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Just(
					{e5: (regMatch.e5 + backslashesLength) - 1, ie: 2, f: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken});
			} else {
				if (_v0.b.b) {
					var _v1 = _v0.b;
					var maybeSpaces = _v1.a;
					return $elm$core$Maybe$Just(
						{
							e5: regMatch.e5,
							ie: $elm$core$String$length(regMatch.fg),
							f: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak = false;
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( *))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens = function (str) {
	return $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak ? A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex, str)) : A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\])'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose = {$: 3};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken = function (regMatch) {
	var _v0 = regMatch.iW;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{e5: regMatch.e5 + backslashesLength, ie: 1, f: $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\!)?(\\[)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$Active = 0;
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken = function (regMatch) {
	var _v0 = regMatch.iW;
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var maybeImageOpen = _v1.a;
		var _v2 = _v1.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var isEscaped = !$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength);
		var index = isEscaped ? ((regMatch.e5 + backslashesLength) + 1) : (regMatch.e5 + backslashesLength);
		if (isEscaped) {
			if (!maybeImageOpen.$) {
				return $elm$core$Maybe$Just(
					{
						e5: index,
						ie: 1,
						f: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			if (!maybeImageOpen.$) {
				return $elm$core$Maybe$Just(
					{e5: index, ie: 2, f: $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken});
			} else {
				return $elm$core$Maybe$Just(
					{
						e5: index,
						ie: 1,
						f: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
					});
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken = function (a) {
	return {$: 10, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken = function (regMatch) {
	var _v0 = regMatch.iW;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var tilde = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var _v2 = $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(1)) : _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(0));
		var length = _v2.a;
		var meaning = _v2.b;
		return $elm$core$Maybe$Just(
			{e5: regMatch.e5 + backslashesLength, ie: length, f: meaning});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(~{2,})([^~])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^_])?(\\_+)([^_])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '_', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex = F2(
	function (left, right) {
		if (left.b) {
			var lfirst = left.a;
			var lrest = left.b;
			if (right.b) {
				var rfirst = right.a;
				var rrest = right.b;
				return (_Utils_cmp(lfirst.e5, rfirst.e5) < 0) ? A2(
					$elm$core$List$cons,
					lfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, lrest, right)) : A2(
					$elm$core$List$cons,
					rfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, left, rrest));
			} else {
				return left;
			}
		} else {
			return right;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize = function (rawText) {
	return A2(
		$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
		$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens(rawText),
		A2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
			$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens(rawText),
			A2(
				$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
				$dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens(rawText),
				A2(
					$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
					$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens(rawText),
					A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
						$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens(rawText),
						A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
							$dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens(rawText),
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
								$dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens(rawText),
								A2(
									$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
									$dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens(rawText),
									$dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens(rawText)))))))));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Inactive = 1;
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType = {$: 8};
var $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType = function (a) {
	return {$: 3, a: a};
};
var $elm$regex$Regex$contains = _Regex_contains;
var $dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)'));
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2(
		$elm$regex$Regex$replace,
		$dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex,
		function (match) {
			return A2(
				$elm$core$Maybe$withDefault,
				match.fg,
				$elm$url$Url$percentDecode(match.fg));
		}));
var $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex, match.n) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				eq: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.n,
						$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.n)))
			})) : $elm$core$Result$Err(match);
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex = '[^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*';
var $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\[\\s*(' + ($dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + ')\\s*\\]')));
var $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces = function (original) {
	return original;
};
var $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel = A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $elm$core$String$toLower);
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle = F2(
	function (rawUrl, maybeTitle) {
		return _Utils_Tuple2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(
				$dillonkearns$elm_markdown$Markdown$Helpers$formatStr(rawUrl)),
			A2($elm$core$Maybe$map, $dillonkearns$elm_markdown$Markdown$Helpers$formatStr, maybeTitle));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch = F3(
	function (matchModel, references, maybeRegexMatch) {
		var refLabel = function (str) {
			return $elm$core$String$isEmpty(str) ? matchModel.n : str;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				matchModel.n,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.iW;
							},
							$elm$core$List$head),
						maybeRegexMatch))));
		var _v0 = A2(
			$elm$core$Dict$get,
			$dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel(refLabel),
			references);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v1 = _v0.a;
			var rawUrl = _v1.a;
			var maybeTitle = _v1.b;
			var type_ = function () {
				var _v3 = matchModel.eq;
				if (_v3.$ === 5) {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				} else {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				}
			}();
			var regexMatchLength = function () {
				if (!maybeRegexMatch.$) {
					var match = maybeRegexMatch.a.fg;
					return $elm$core$String$length(match);
				} else {
					return 0;
				}
			}();
			return $elm$core$Maybe$Just(
				_Utils_update(
					matchModel,
					{k: matchModel.k + regexMatchLength, eq: type_}));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences = F3(
	function (remainText, _v0, references) {
		var tempMatch = _v0;
		var matches = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex, remainText);
		return A3(
			$dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch,
			tempMatch,
			references,
			$elm$core$List$head(matches));
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars = '\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars = ' \\t\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex = '(?:<([^<>' + ($dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars + (']*)>|([^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + ('\\(\\)\\\\]*(?:\\\\.[^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + '\\(\\)\\\\]*)*))')))));
var $dillonkearns$elm_markdown$Markdown$Helpers$titleRegex = '(?:[' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + (']+' + ('(?:\'([^\'\\\\]*(?:\\\\.[^\'\\\\]*)*)\'|' + ('\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|' + '\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?'))));
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\(\\s*' + ($dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex + ($dillonkearns$elm_markdown$Markdown$Helpers$titleRegex + '\\s*\\)'))));
var $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust = function (maybes) {
	var process = F2(
		function (a, maybeFound) {
			if (!maybeFound.$) {
				var found = maybeFound.a;
				return $elm$core$Maybe$Just(found);
			} else {
				return a;
			}
		});
	return A3($elm$core$List$foldl, process, $elm$core$Maybe$Nothing, maybes);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch = F2(
	function (matchModel, regexMatch) {
		var _v0 = regexMatch.iW;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
			var maybeRawUrlAngleBrackets = _v0.a;
			var _v1 = _v0.b;
			var maybeRawUrlWithoutBrackets = _v1.a;
			var _v2 = _v1.b;
			var maybeTitleSingleQuotes = _v2.a;
			var _v3 = _v2.b;
			var maybeTitleDoubleQuotes = _v3.a;
			var _v4 = _v3.b;
			var maybeTitleParenthesis = _v4.a;
			var maybeTitle = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis]));
			var toMatch = function (rawUrl) {
				return _Utils_update(
					matchModel,
					{
						k: matchModel.k + $elm$core$String$length(regexMatch.fg),
						eq: function () {
							var _v5 = matchModel.eq;
							if (_v5.$ === 5) {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType;
							} else {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType;
							}
						}()(
							A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle))
					});
			};
			var maybeRawUrl = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
			return $elm$core$Maybe$Just(
				toMatch(
					A2($elm$core$Maybe$withDefault, '', maybeRawUrl)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType = F3(
	function (remainText, _v0, refs) {
		var tempMatch = _v0;
		var _v1 = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex, remainText);
		if (_v1.b) {
			var first = _v1.a;
			var _v2 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch, tempMatch, first);
			if (!_v2.$) {
				var match = _v2.a;
				return $elm$core$Maybe$Just(match);
			} else {
				return A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences, remainText, tempMatch, refs);
			}
		} else {
			return A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences, remainText, tempMatch, refs);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping = F2(
	function (_v0, remainMatches) {
		var match = _v0;
		var overlappingMatches = $elm$core$List$filter(
			function (_v1) {
				var testMatch = _v1;
				return (_Utils_cmp(match.k, testMatch.m) > 0) && (_Utils_cmp(match.k, testMatch.k) < 0);
			});
		return ($elm$core$List$isEmpty(remainMatches) || $elm$core$List$isEmpty(
			overlappingMatches(remainMatches))) ? $elm$core$Maybe$Just(
			A2($elm$core$List$cons, match, remainMatches)) : $elm$core$Maybe$Nothing;
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex, match.n) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				eq: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.n,
						'mailto:' + $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.n)))
			})) : $elm$core$Result$Err(match);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp = F3(
	function (innerTokens, isToken, tokens) {
		findTokenHelp:
		while (true) {
			if (!tokens.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var nextToken = tokens.a;
				var remainingTokens = tokens.b;
				if (isToken(nextToken)) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							nextToken,
							$elm$core$List$reverse(innerTokens),
							remainingTokens));
				} else {
					var $temp$innerTokens = A2($elm$core$List$cons, nextToken, innerTokens),
						$temp$isToken = isToken,
						$temp$tokens = remainingTokens;
					innerTokens = $temp$innerTokens;
					isToken = $temp$isToken;
					tokens = $temp$tokens;
					continue findTokenHelp;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findToken = F2(
	function (isToken, tokens) {
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp, _List_Nil, isToken, tokens);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotOpening = 1;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.d, s);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{jw: 1, j: _List_Nil, l: 1, d: 0, pA: 1, iQ: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken = F2(
	function (rawText, _v0) {
		var match = _v0;
		var consumedCharacters = A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (startOffset, htmlTag, endOffset) {
								return {j8: htmlTag, ie: endOffset - startOffset};
							})),
					$elm$parser$Parser$Advanced$getOffset),
				$dillonkearns$elm_markdown$HtmlParser$html),
			$elm$parser$Parser$Advanced$getOffset);
		var parsed = A2(
			$elm$parser$Parser$Advanced$run,
			consumedCharacters,
			A2($elm$core$String$dropLeft, match.m, rawText));
		if (!parsed.$) {
			var htmlTag = parsed.a.j8;
			var length = parsed.a.ie;
			var htmlToken = A2($dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken, 1, htmlTag);
			return $elm$core$Maybe$Just(
				{e5: match.m, ie: length, f: htmlToken});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$ifError = F2(
	function (_function, result) {
		if (!result.$) {
			return result;
		} else {
			var err = result.a;
			return _function(err);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken = F2(
	function (htmlModel, token) {
		return false;
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.f;
		if (!_v0.$) {
			if (!_v0.a) {
				var _v1 = _v0.a;
				return _Utils_eq(openToken.ie - 1, closeToken.ie);
			} else {
				var _v2 = _v0.a;
				return _Utils_eq(openToken.ie, closeToken.ie);
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken = function (token) {
	var _v0 = token.f;
	switch (_v0.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.f;
		if (_v0.$ === 7) {
			var openChar = _v0.a;
			var open = _v0.b;
			var _v1 = closeToken.f;
			if (_v1.$ === 7) {
				var closeChar = _v1.a;
				var close = _v1.b;
				return _Utils_eq(openChar, closeChar) ? ((_Utils_eq(open.gO, open.g5) || _Utils_eq(close.gO, close.g5)) ? ((!(!A2($elm$core$Basics$modBy, 3, closeToken.ie + openToken.ie))) || ((!A2($elm$core$Basics$modBy, 3, closeToken.ie)) && (!A2($elm$core$Basics$modBy, 3, openToken.ie)))) : true) : false;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = function () {
			var _v1 = openToken.f;
			if (_v1.$ === 10) {
				if (!_v1.a) {
					var _v2 = _v1.a;
					return _Utils_Tuple2(true, openToken.ie - 1);
				} else {
					var _v3 = _v1.a;
					return _Utils_Tuple2(true, openToken.ie);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var openTokenIsStrikethrough = _v0.a;
		var openTokenLength = _v0.b;
		var _v4 = function () {
			var _v5 = closeToken.f;
			if (_v5.$ === 10) {
				if (!_v5.a) {
					var _v6 = _v5.a;
					return _Utils_Tuple2(true, closeToken.ie - 1);
				} else {
					var _v7 = _v5.a;
					return _Utils_Tuple2(true, closeToken.ie);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var closeTokenIsStrikethrough = _v4.a;
		var closeTokenLength = _v4.b;
		return closeTokenIsStrikethrough && (openTokenIsStrikethrough && _Utils_eq(closeTokenLength, openTokenLength));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType = {$: 1};
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch = F2(
	function (token, type_) {
		return {k: token.e5 + token.ie, Q: _List_Nil, m: token.e5, n: '', at: 0, S: 0, eq: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM = F5(
	function (remaining, tokens, matches, refs, rawText) {
		lineBreakTTM:
		while (true) {
			if (!remaining.b) {
				return matches;
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v1 = token.f;
				if (_v1.$ === 9) {
					var $temp$remaining = tokensTail,
						$temp$tokens = tokens,
						$temp$matches = A2(
						$elm$core$List$cons,
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch, token, $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType),
						matches),
						$temp$refs = refs,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					refs = $temp$refs;
					rawText = $temp$rawText;
					continue lineBreakTTM;
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$refs = refs,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					refs = $temp$refs;
					rawText = $temp$rawText;
					continue lineBreakTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens = F2(
	function (_v0, tokensTail) {
		var match = _v0;
		return A2(
			$elm$core$List$filter,
			function (token) {
				return _Utils_cmp(token.e5, match.k) > -1;
			},
			tokensTail);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch = F6(
	function (closeToken, escaped, matches, references, rawText, _v46) {
		var openToken = _v46.a;
		var remainTokens = _v46.c;
		var result = A2(
			$dillonkearns$elm_markdown$Markdown$Helpers$ifError,
			$dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch,
			$dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch(
				A7(
					$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
					references,
					rawText,
					function (s) {
						return s;
					},
					$dillonkearns$elm_markdown$Markdown$InlineParser$CodeType,
					openToken,
					closeToken,
					_List_Nil)));
		if (result.$ === 1) {
			var tempMatch = result.a;
			if (escaped === 1) {
				var _v49 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken, rawText, tempMatch);
				if (!_v49.$) {
					var newToken = _v49.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A2($elm$core$List$cons, newToken, remainTokens),
							matches));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			var newMatch = result.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					remainTokens,
					A2($elm$core$List$cons, newMatch, matches)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		codeAutolinkTypeHtmlTagTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v38 = token.f;
				switch (_v38.$) {
					case 0:
						var isEscaped = _v38.a;
						var _v39 = A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
							$dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair(token),
							tokens);
						if (!_v39.$) {
							var code = _v39.a;
							var _v40 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch, token, matches, references, rawText, code);
							var newTokens = _v40.a;
							var newMatches = _v40.b;
							var $temp$remaining = tokensTail,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					case 5:
						var isEscaped = _v38.a;
						var isAngleBracketOpen = function (_v45) {
							var meaning = _v45.f;
							if (meaning.$ === 4) {
								return true;
							} else {
								return false;
							}
						};
						var _v41 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, isAngleBracketOpen, tokens);
						if (!_v41.$) {
							var found = _v41.a;
							var _v42 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch, token, isEscaped, matches, references, rawText, found);
							if (!_v42.$) {
								var _v43 = _v42.a;
								var newTokens = _v43.a;
								var newMatches = _v43.b;
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									newTokens),
									$temp$matches = newMatches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
								tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					default:
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue codeAutolinkTypeHtmlTagTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch = F5(
	function (closeToken, matches, references, rawText, _v34) {
		var openToken = _v34.a;
		var remainTokens = _v34.c;
		var updatedOpenToken = function () {
			var _v35 = openToken.f;
			if ((!_v35.$) && (!_v35.a)) {
				var _v36 = _v35.a;
				return _Utils_update(
					openToken,
					{e5: openToken.e5 + 1, ie: openToken.ie - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		emphasisTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v29 = token.f;
				if (_v29.$ === 7) {
					var _char = _v29.a;
					var leftFringeRank = _v29.b.gO;
					var rightFringeRank = _v29.b.g5;
					if (_Utils_eq(leftFringeRank, rightFringeRank)) {
						if ((!(!rightFringeRank)) && ((_char !== '_') || (rightFringeRank === 1))) {
							var _v30 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (!_v30.$) {
								var found = _v30.a;
								var _v31 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v31.a;
								var match = _v31.b;
								var newTokens = _v31.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2($elm$core$List$cons, token, tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						}
					} else {
						if (_Utils_cmp(leftFringeRank, rightFringeRank) < 0) {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						} else {
							var _v32 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (!_v32.$) {
								var found = _v32.a;
								var _v33 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v33.a;
								var match = _v33.b;
								var newTokens = _v33.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = tokens,
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						}
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue emphasisTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch = F5(
	function (references, rawText, closeToken, tokensTail, _v27) {
		var openToken = _v27.a;
		var innerTokens = _v27.b;
		var remainTokens = _v27.c;
		var remainLength = openToken.ie - closeToken.ie;
		var updt = (!remainLength) ? {gc: closeToken, fm: openToken, g4: remainTokens, hj: tokensTail} : ((remainLength > 0) ? {
			gc: closeToken,
			fm: _Utils_update(
				openToken,
				{e5: openToken.e5 + remainLength, ie: closeToken.ie}),
			g4: A2(
				$elm$core$List$cons,
				_Utils_update(
					openToken,
					{ie: remainLength}),
				remainTokens),
			hj: tokensTail
		} : {
			gc: _Utils_update(
				closeToken,
				{ie: openToken.ie}),
			fm: openToken,
			g4: remainTokens,
			hj: A2(
				$elm$core$List$cons,
				_Utils_update(
					closeToken,
					{e5: closeToken.e5 + openToken.ie, ie: -remainLength}),
				tokensTail)
		});
		var match = A7(
			$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
			references,
			rawText,
			function (s) {
				return s;
			},
			$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType(updt.fm.ie),
			updt.fm,
			updt.gc,
			$elm$core$List$reverse(innerTokens));
		return _Utils_Tuple3(updt.hj, match, updt.g4);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		htmlElementTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v23 = token.f;
				if (_v23.$ === 6) {
					var isOpen = _v23.a;
					var htmlModel = _v23.b;
					if (isOpen === 1) {
						var $temp$remaining = tokensTail,
							$temp$tokens = tokens,
							$temp$matches = A2(
							$elm$core$List$cons,
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
								token,
								$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)),
							matches),
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue htmlElementTTM;
					} else {
						var _v25 = A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
							$dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken(htmlModel),
							tokensTail);
						if (_v25.$ === 1) {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = A2(
								$elm$core$List$cons,
								A2(
									$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
									token,
									$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)),
								matches),
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue htmlElementTTM;
						} else {
							var _v26 = _v25.a;
							var closeToken = _v26.a;
							var innerTokens = _v26.b;
							var newTail = _v26.c;
							var newMatch = A7(
								$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
								references,
								rawText,
								function (s) {
									return s;
								},
								$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel),
								token,
								closeToken,
								innerTokens);
							var $temp$remaining = newTail,
								$temp$tokens = tokens,
								$temp$matches = A2($elm$core$List$cons, newMatch, matches),
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue htmlElementTTM;
						}
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue htmlElementTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		linkImageTypeTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v18 = token.f;
				if (_v18.$ === 3) {
					var _v19 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken, tokens);
					if (!_v19.$) {
						var found = _v19.a;
						var _v20 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch, token, tokensTail, matches, references, rawText, found);
						if (!_v20.$) {
							var _v21 = _v20.a;
							var x = _v21.a;
							var newMatches = _v21.b;
							var newTokens = _v21.c;
							var $temp$remaining = x,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						}
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = tokens,
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue linkImageTypeTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue linkImageTypeTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch = F6(
	function (closeToken, tokensTail, oldMatches, references, rawText, _v8) {
		var openToken = _v8.a;
		var innerTokens = _v8.b;
		var remainTokens = _v8.c;
		var removeOpenToken = _Utils_Tuple3(
			tokensTail,
			oldMatches,
			_Utils_ap(innerTokens, remainTokens));
		var remainText = A2($elm$core$String$dropLeft, closeToken.e5 + 1, rawText);
		var inactivateLinkOpenToken = function (token) {
			var _v16 = token.f;
			if (_v16.$ === 1) {
				return _Utils_update(
					token,
					{
						f: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(1)
					});
			} else {
				return token;
			}
		};
		var findTempMatch = function (isLinkType) {
			return A7(
				$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
				references,
				rawText,
				function (s) {
					return s;
				},
				isLinkType ? $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)) : $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)),
				openToken,
				closeToken,
				$elm$core$List$reverse(innerTokens));
		};
		var _v9 = openToken.f;
		switch (_v9.$) {
			case 2:
				var tempMatch = findTempMatch(false);
				var _v10 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
				if (_v10.$ === 1) {
					return $elm$core$Maybe$Just(removeOpenToken);
				} else {
					var match = _v10.a;
					var _v11 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
					if (!_v11.$) {
						var matches = _v11.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple3(
								A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
								matches,
								remainTokens));
					} else {
						return $elm$core$Maybe$Just(removeOpenToken);
					}
				}
			case 1:
				if (!_v9.a) {
					var _v12 = _v9.a;
					var tempMatch = findTempMatch(true);
					var _v13 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
					if (_v13.$ === 1) {
						return $elm$core$Maybe$Just(removeOpenToken);
					} else {
						var match = _v13.a;
						var _v14 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
						if (!_v14.$) {
							var matches = _v14.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
									matches,
									A2($elm$core$List$map, inactivateLinkOpenToken, remainTokens)));
						} else {
							return $elm$core$Maybe$Just(removeOpenToken);
						}
					}
				} else {
					var _v15 = _v9.a;
					return $elm$core$Maybe$Just(removeOpenToken);
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		strikethroughTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v5 = token.f;
				if (_v5.$ === 10) {
					var isEscaped = _v5.a;
					var _v6 = A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
						$dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair(token),
						tokens);
					if (!_v6.$) {
						var content = _v6.a;
						var _v7 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch, token, matches, references, rawText, content);
						var newTokens = _v7.a;
						var newMatches = _v7.b;
						var $temp$remaining = tokensTail,
							$temp$tokens = newTokens,
							$temp$matches = newMatches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue strikethroughTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch = F5(
	function (closeToken, matches, references, rawText, _v1) {
		var openToken = _v1.a;
		var remainTokens = _v1.c;
		var updatedOpenToken = function () {
			var _v2 = openToken.f;
			if ((_v2.$ === 10) && (!_v2.a)) {
				var _v3 = _v2.a;
				return _Utils_update(
					openToken,
					{e5: openToken.e5 + 1, ie: openToken.ie - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch = F7(
	function (references, rawText, processText, type_, openToken, closeToken, innerTokens) {
		var textStart = openToken.e5 + openToken.ie;
		var textEnd = closeToken.e5;
		var text = processText(
			A3($elm$core$String$slice, textStart, textEnd, rawText));
		var start = openToken.e5;
		var end = closeToken.e5 + closeToken.ie;
		var match = {k: end, Q: _List_Nil, m: start, n: text, at: textEnd, S: textStart, eq: type_};
		var matches = A2(
			$elm$core$List$map,
			function (_v0) {
				var matchModel = _v0;
				return A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, match, matchModel);
			},
			A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, innerTokens, _List_Nil, references, rawText));
		return {k: end, Q: matches, m: start, n: text, at: textEnd, S: textStart, eq: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches = F4(
	function (tokens, matches, references, rawText) {
		return A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM, tokens, _List_Nil, matches, references, rawText);
	});
var $elm$core$String$trim = _String_trim;
var $dillonkearns$elm_markdown$Markdown$InlineParser$parse = F2(
	function (refs, rawText_) {
		var rawText = $elm$core$String$trim(rawText_);
		var tokens = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize(rawText);
		return $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(
			A3(
				$dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches,
				rawText,
				_List_Nil,
				$dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(
					A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, tokens, _List_Nil, refs, rawText))));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				' ',
				$elm$parser$Parser$Expecting(' '))),
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				'>',
				$elm$parser$Parser$Expecting('>'))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Char$isAlpha,
					$elm$parser$Parser$Expecting('Alpha')),
				$elm$parser$Parser$Advanced$chompWhile(
					function (c) {
						return $elm$core$Char$isAlphaNum(c) || (c === '-');
					})),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							':',
							$elm$parser$Parser$Expecting(':'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'@',
							$elm$parser$Parser$Expecting('@'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'\\',
							$elm$parser$Parser$Expecting('\\'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'+',
							$elm$parser$Parser$Expecting('+'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'.',
							$elm$parser$Parser$Expecting('.')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock = $elm$parser$Parser$Advanced$backtrackable(
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (rawLine, _v0) {
				return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
			}),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'<',
							$elm$parser$Parser$Expecting('<'))),
					$dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag),
				$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
var $dillonkearns$elm_markdown$Markdown$Table$TableHeader = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Parser$Token$parseString = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$Expecting(str)));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper = function (_v0) {
	var curr = _v0.a;
	var acc = _v0.b;
	var _return = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Done(acc),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Done(
					A2($elm$core$List$cons, cell, acc));
			},
			curr));
	var finishCell = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2($elm$core$Maybe$Nothing, acc)),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Loop(
					_Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2($elm$core$List$cons, cell, acc)));
			},
			curr));
	var addToCurrent = function (c) {
		return _Utils_ap(
			A2($elm$core$Maybe$withDefault, '', curr),
			c);
	};
	var continueCell = function (c) {
		return $elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2(
				$elm$core$Maybe$Just(
					addToCurrent(c)),
				acc));
	};
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('|\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v3) {
					return _return;
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\\\|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('\\'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\\\')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(finishCell)),
				$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (_char, _v4) {
						return continueCell(_char);
					}),
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Basics$always(true),
					$elm$parser$Parser$Problem('No character found')))
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCells = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$List$foldl,
		F2(
			function (cell, acc) {
				return A2(
					$elm$core$List$cons,
					$elm$core$String$trim(cell),
					acc);
			}),
		_List_Nil),
	A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
		$dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper));
var $dillonkearns$elm_markdown$Markdown$TableParser$rowParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	$dillonkearns$elm_markdown$Markdown$TableParser$parseCells);
var $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader = F2(
	function (_v0, headersRow) {
		var columnAlignments = _v0.b;
		var headersWithAlignment = function (headers) {
			return A3(
				$elm$core$List$map2,
				F2(
					function (headerCell, alignment) {
						return {f0: alignment, n$: headerCell};
					}),
				headers,
				columnAlignments);
		};
		var combineHeaderAndDelimiter = function (headers) {
			return _Utils_eq(
				$elm$core$List$length(headers),
				$elm$core$List$length(columnAlignments)) ? $elm$core$Result$Ok(
				headersWithAlignment(headers)) : $elm$core$Result$Err(
				'Tables must have the same number of header columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(headers)) + (') as delimiter columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(columnAlignments)) + ')'))));
		};
		var _v1 = A2($elm$parser$Parser$Advanced$run, $dillonkearns$elm_markdown$Markdown$TableParser$rowParser, headersRow);
		if (!_v1.$) {
			var headers = _v1.a;
			return combineHeaderAndDelimiter(headers);
		} else {
			return $elm$core$Result$Err('Unable to parse previous line as a table header');
		}
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock = F2(
	function (language, body) {
		return {f6: body, ic: language};
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$infoString = function (fenceCharacter) {
	var toInfoString = F2(
		function (str, _v2) {
			var _v1 = $elm$core$String$trim(str);
			if (_v1 === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				var trimmed = _v1;
				return $elm$core$Maybe$Just(trimmed);
			}
		});
	var _v0 = fenceCharacter.z;
	if (!_v0) {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return (c !== '`') && (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c));
				}));
	} else {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd)));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Backtick = 0;
var $dillonkearns$elm_markdown$Parser$Token$backtick = A2(
	$elm$parser$Parser$Advanced$Token,
	'`',
	$elm$parser$Parser$Expecting('a \'`\''));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick = {f8: '`', z: 0, p5: $dillonkearns$elm_markdown$Parser$Token$backtick};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation = function (_int) {
	switch (_int) {
		case 1:
			return $elm$parser$Parser$Advanced$succeed(0);
		case 2:
			return $elm$parser$Parser$Advanced$succeed(1);
		case 3:
			return $elm$parser$Parser$Advanced$succeed(2);
		case 4:
			return $elm$parser$Parser$Advanced$succeed(3);
		default:
			return $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Expecting('Fenced code blocks should be indented no more than 3 spaces'));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast = F2(
	function (minLength, fenceCharacter) {
		var builtTokens = A3(
			$elm$core$List$foldl,
			F2(
				function (t, p) {
					return A2($elm$parser$Parser$Advanced$ignorer, p, t);
				}),
			$elm$parser$Parser$Advanced$succeed(0),
			A2(
				$elm$core$List$repeat,
				minLength,
				$elm$parser$Parser$Advanced$token(fenceCharacter.p5)));
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			F2(
				function (str, _v0) {
					return _Utils_Tuple2(
						fenceCharacter,
						$elm$core$String$length(str));
				}),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				builtTokens,
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(fenceCharacter.f8))));
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Tilde = 1;
var $dillonkearns$elm_markdown$Parser$Token$tilde = A2(
	$elm$parser$Parser$Advanced$Token,
	'~',
	$elm$parser$Parser$Expecting('a `~`'));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde = {f8: '~', z: 1, p5: $dillonkearns$elm_markdown$Parser$Token$tilde};
var $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$Whitespace$space,
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Whitespace$space,
						$elm$parser$Parser$Advanced$succeed(0)
					]))),
			$elm$parser$Parser$Advanced$succeed(0)
		]));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (indent, _v0) {
						var character = _v0.a;
						var length = _v0.b;
						return {f9: character, h6: indent, ie: length};
					})),
			$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation, $elm$parser$Parser$Advanced$getCol)),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick),
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde)
			])));
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $dillonkearns$elm_markdown$Whitespace$isSpace = $elm$core$Basics$eq(' ');
var $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence = F2(
	function (minLength, fenceCharacter) {
		return A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(0),
						$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, minLength, fenceCharacter)),
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpace)),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine = function (indented) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, indented, $dillonkearns$elm_markdown$Whitespace$space)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getOffset, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
};
var $elm$parser$Parser$Advanced$getSource = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.iQ, s);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp = function (_v0) {
	var fence = _v0.a;
	var body = _v0.b;
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$elm$parser$Parser$Advanced$Done(body)),
				$elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd)),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (lineEnd, _v1) {
						return $elm$parser$Parser$Advanced$Loop(
							_Utils_Tuple2(
								fence,
								_Utils_ap(body, lineEnd)));
					}),
				$dillonkearns$elm_markdown$Whitespace$lineEnd),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						$elm$parser$Parser$Advanced$Done(body)),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence, fence.ie, fence.f9))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(
							F3(
								function (start, end, source) {
									return $elm$parser$Parser$Advanced$Loop(
										_Utils_Tuple2(
											fence,
											_Utils_ap(
												body,
												A3($elm$core$String$slice, start, end, source))));
								})),
						$dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine(fence.h6)),
					$elm$parser$Parser$Advanced$getOffset),
				$elm$parser$Parser$Advanced$getSource)
			]));
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock = function (fence) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2(fence, ''),
		$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$parser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (fence) {
		return A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$CodeBlock$infoString(fence.f9),
					$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)),
			$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock(fence));
	},
	$dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence);
var $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes = function (headingString) {
	return A2($elm$core$String$endsWith, '#', headingString) ? $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes(
		A2($elm$core$String$dropRight, 1, headingString)) : headingString;
};
var $elm$core$String$trimRight = _String_trimRight;
var $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence = function (headingString) {
	var droppedTrailingHashesString = $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes(headingString);
	return (A2($elm$core$String$endsWith, ' ', droppedTrailingHashesString) || $elm$core$String$isEmpty(droppedTrailingHashesString)) ? $elm$core$String$trimRight(droppedTrailingHashesString) : headingString;
};
var $dillonkearns$elm_markdown$Parser$Token$hash = A2(
	$elm$parser$Parser$Advanced$Token,
	'#',
	$elm$parser$Parser$Expecting('a `#`'));
var $dillonkearns$elm_markdown$Markdown$Heading$isHash = function (c) {
	if ('#' === c) {
		return true;
	} else {
		return false;
	}
};
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var $dillonkearns$elm_markdown$Markdown$Heading$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Heading),
				A2(
					$elm$parser$Parser$Advanced$andThen,
					function (startingSpaces) {
						var startSpace = $elm$core$String$length(startingSpaces);
						return (startSpace >= 4) ? $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Expecting('heading with < 4 spaces in front')) : $elm$parser$Parser$Advanced$succeed(startSpace);
					},
					$elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$spaces))),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$hash)),
		A2(
			$elm$parser$Parser$Advanced$andThen,
			function (additionalHashes) {
				var level = $elm$core$String$length(additionalHashes) + 1;
				return (level >= 7) ? $elm$parser$Parser$Advanced$problem(
					$elm$parser$Parser$Expecting('heading with < 7 #\'s')) : $elm$parser$Parser$Advanced$succeed(level);
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Markdown$Heading$isHash)))),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(''),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$newline)),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab)
							]))),
				A2(
					$elm$parser$Parser$Advanced$mapChompedString,
					F2(
						function (headingText, _v0) {
							return $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence(
								$elm$core$String$trim(headingText));
						}),
					$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd))
			])));
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.d, s.pA, s.jw, s.iQ);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.j)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.d, newOffset) < 0,
			0,
			{jw: newCol, j: s.j, l: s.l, d: newOffset, pA: newRow, iQ: s.iQ});
	};
};
var $dillonkearns$elm_markdown$Parser$Token$greaterThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'>',
	$elm$parser$Parser$Expecting('a `>`'));
var $elm$parser$Parser$Advanced$Located = F3(
	function (row, col, context) {
		return {jw: col, j: context, pA: row};
	});
var $elm$parser$Parser$Advanced$changeContext = F2(
	function (newContext, s) {
		return {jw: s.jw, j: newContext, l: s.l, d: s.d, pA: s.pA, iQ: s.iQ};
	});
var $elm$parser$Parser$Advanced$inContext = F2(
	function (context, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(
				A2(
					$elm$parser$Parser$Advanced$changeContext,
					A2(
						$elm$core$List$cons,
						A3($elm$parser$Parser$Advanced$Located, s0.pA, s0.jw, context),
						s0.j),
					s0));
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					a,
					A2($elm$parser$Parser$Advanced$changeContext, s0.j, s1));
			} else {
				var step = _v1;
				return step;
			}
		};
	});
var $dillonkearns$elm_markdown$Whitespace$isWhitespace = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u000C':
			return true;
		case '\r':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Parser$Token$lessThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'<',
	$elm$parser$Parser$Expecting('a `<`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link destination',
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$url$Url$percentEncode),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$lessThan)),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$greaterThan)),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$greaterThan))),
				$elm$parser$Parser$Advanced$getChompedString(
				$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isWhitespace)))
			])));
var $dillonkearns$elm_markdown$Parser$Token$closingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	']',
	$elm$parser$Parser$Expecting('a `]`'));
var $dillonkearns$elm_markdown$Parser$Token$openingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	'[',
	$elm$parser$Parser$Expecting('a `[`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel),
		$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$openingSquareBracket)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$closingSquareBracket)),
		$elm$parser$Parser$Advanced$symbol(
			A2(
				$elm$parser$Parser$Advanced$Token,
				']:',
				$elm$parser$Parser$Expecting(']:')))));
var $dillonkearns$elm_markdown$Parser$Token$doubleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\"',
	$elm$parser$Parser$Expecting('a double quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine = function (str) {
	return A2($elm$core$String$contains, '\n\n', str) ? $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Expecting('no blank line')) : $elm$parser$Parser$Advanced$succeed(str);
};
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline = A2(
	$elm$parser$Parser$Advanced$ignorer,
	$elm$parser$Parser$Advanced$chompWhile(
		function (c) {
			return (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c)) && $dillonkearns$elm_markdown$Whitespace$isWhitespace(c);
		}),
	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Whitespace$requiredWhitespace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$Whitespace$isWhitespace,
		$elm$parser$Parser$Expecting('Required whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isWhitespace));
var $dillonkearns$elm_markdown$Parser$Token$singleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\'',
	$elm$parser$Parser$Expecting('a single quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser = function () {
	var inSingleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$singleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	var inDoubleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$doubleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'title',
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$backtrackable(
					A2(
						$elm$parser$Parser$Advanced$keeper,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
							$dillonkearns$elm_markdown$Whitespace$requiredWhitespace),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									inDoubleQuotes,
									inSingleQuotes,
									$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
								])))),
					A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing),
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline)
				])));
}();
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link reference definition',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (label, destination, title) {
								return _Utils_Tuple2(
									label,
									{jG: destination, fN: title});
							})),
					$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser,
							$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									$dillonkearns$elm_markdown$Whitespace$lineEnd,
									$elm$parser$Parser$Advanced$succeed(0)
								]))),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser),
		$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser));
var $dillonkearns$elm_markdown$ThematicBreak$ThematicBreak = 0;
var $dillonkearns$elm_markdown$ThematicBreak$whitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$ThematicBreak$withChar = function (tchar) {
	var token = $dillonkearns$elm_markdown$Parser$Token$parseString(
		$elm$core$String$fromChar(tchar));
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed(0),
								token),
							$dillonkearns$elm_markdown$ThematicBreak$whitespace),
						token),
					$dillonkearns$elm_markdown$ThematicBreak$whitespace),
				token),
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return _Utils_eq(c, tchar) || $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab(c);
				})),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
};
var $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$dillonkearns$elm_markdown$ThematicBreak$withChar('-'),
			$dillonkearns$elm_markdown$ThematicBreak$withChar('*'),
			$dillonkearns$elm_markdown$ThematicBreak$withChar('_')
		]));
var $dillonkearns$elm_markdown$ThematicBreak$parser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$Whitespace$space),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Whitespace$space,
								$elm$parser$Parser$Advanced$succeed(0)
							]))),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak
		]));
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelOne = 0;
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelTwo = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Parser$Token$equals = A2(
	$elm$parser$Parser$Advanced$Token,
	'=',
	$elm$parser$Parser$Expecting('a `=`'));
var $dillonkearns$elm_markdown$Parser$Token$minus = A2(
	$elm$parser$Parser$Advanced$Token,
	'-',
	$elm$parser$Parser$Expecting('a `-`'));
var $dillonkearns$elm_markdown$Markdown$Parser$setextLineParser = function () {
	var setextLevel = F3(
		function (level, levelToken, levelChar) {
			return A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(level),
					$elm$parser$Parser$Advanced$token(levelToken)),
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(levelChar)));
		});
	return A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (raw, level) {
				return A2($dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine, level, raw);
			}),
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								A3(setextLevel, 0, $dillonkearns$elm_markdown$Parser$Token$equals, '='),
								A3(setextLevel, 1, $dillonkearns$elm_markdown$Parser$Token$minus, '-')
							])),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
				$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
}();
var $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter = function (a) {
	return {$: 9, a: a};
};
var $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$Parser$Extra$maybeChomp = function (condition) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$chompIf,
				condition,
				$elm$parser$Parser$Problem('Character not found')),
				$elm$parser$Parser$Advanced$succeed(0)
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst = function (columns) {
	return $elm$core$List$isEmpty(columns) ? $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
				$elm$parser$Parser$Advanced$succeed(0)
			])) : $dillonkearns$elm_markdown$Parser$Token$parseString('|');
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp = function (revDelimiterColumns) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
					},
					$dillonkearns$elm_markdown$Parser$Token$parseString('|\n'))),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(revDelimiterColumns)),
						$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
					$elm$parser$Parser$Advanced$end(
						$elm$parser$Parser$Expecting('end')))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							function (column) {
								return $elm$parser$Parser$Advanced$Loop(
									A2($elm$core$List$cons, column, revDelimiterColumns));
							}),
						$dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst(revDelimiterColumns)),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								A2(
									$elm$parser$Parser$Advanced$ignorer,
									$elm$parser$Parser$Advanced$succeed(0),
									$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
										function (c) {
											return c === ':';
										})),
								$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
									function (c) {
										return c === '-';
									})),
							$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
								function (c) {
									return c === ':';
								}))),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Block$AlignCenter = 2;
var $dillonkearns$elm_markdown$Markdown$Block$AlignLeft = 0;
var $dillonkearns$elm_markdown$Markdown$Block$AlignRight = 1;
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment = function (cell) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$String$startsWith, ':', cell),
		A2($elm$core$String$endsWith, ':', cell));
	if (_v0.a) {
		if (_v0.b) {
			return $elm$core$Maybe$Just(2);
		} else {
			return $elm$core$Maybe$Just(0);
		}
	} else {
		if (_v0.b) {
			return $elm$core$Maybe$Just(1);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (delimiterRow) {
		var trimmed = delimiterRow.a.lP;
		var headers = delimiterRow.b;
		return $elm$core$List$isEmpty(headers) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Expecting('Must have at least one column in delimiter row.')) : ((($elm$core$List$length(headers) === 1) && (!(A2($elm$core$String$startsWith, '|', trimmed) && A2($elm$core$String$endsWith, '|', trimmed)))) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity.')) : $elm$parser$Parser$Advanced$succeed(delimiterRow));
	},
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (delimiterText, revDelimiterColumns) {
				return A2(
					$dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow,
					{
						k9: delimiterText,
						lP: $elm$core$String$trim(delimiterText)
					},
					A2(
						$elm$core$List$map,
						$dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment,
						$elm$core$List$reverse(revDelimiterColumns)));
			}),
		A2($elm$parser$Parser$Advanced$loop, _List_Nil, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp)));
var $dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph = A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser);
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength = F2(
	function (expectedLength, row) {
		var rowLength = $elm$core$List$length(row);
		var _v0 = A2($elm$core$Basics$compare, expectedLength, rowLength);
		switch (_v0) {
			case 0:
				return A2($elm$core$List$take, expectedLength, row);
			case 1:
				return row;
			default:
				return _Utils_ap(
					row,
					A2($elm$core$List$repeat, expectedLength - rowLength, ''));
		}
	});
var $dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser = function (expectedRowLength) {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		function (row) {
			return ($elm$core$List$isEmpty(row) || A2($elm$core$List$all, $elm$core$String$isEmpty, row)) ? $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Problem('A line must have at least one column')) : $elm$parser$Parser$Advanced$succeed(
				A2($dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength, expectedRowLength, row));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$rowParser);
};
var $dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted = function (_v0) {
	var headers = _v0.a;
	var body = _v0.b;
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (row) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$Table(
				A2(
					$dillonkearns$elm_markdown$Markdown$Table$Table,
					headers,
					_Utils_ap(
						body,
						_List_fromArray(
							[row]))));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser(
			$elm$core$List$length(headers)));
};
var $dillonkearns$elm_markdown$Markdown$Block$H1 = 0;
var $dillonkearns$elm_markdown$Markdown$Block$H2 = 1;
var $dillonkearns$elm_markdown$Markdown$Block$H3 = 2;
var $dillonkearns$elm_markdown$Markdown$Block$H4 = 3;
var $dillonkearns$elm_markdown$Markdown$Block$H5 = 4;
var $dillonkearns$elm_markdown$Markdown$Block$H6 = 5;
var $dillonkearns$elm_markdown$Markdown$Parser$toHeading = function (level) {
	switch (level) {
		case 1:
			return $elm$core$Result$Ok(0);
		case 2:
			return $elm$core$Result$Ok(1);
		case 3:
			return $elm$core$Result$Ok(2);
		case 4:
			return $elm$core$Result$Ok(3);
		case 5:
			return $elm$core$Result$Ok(4);
		case 6:
			return $elm$core$Result$Ok(5);
		default:
			return $elm$core$Result$Err(
				$elm$parser$Parser$Expecting(
					'A heading with 1 to 6 #\'s, but found ' + $elm$core$String$fromInt(level)));
	}
};
var $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem = {$: 2};
var $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem = F4(
	function (markerStartPos, listMarker, markerEndPos, _v0) {
		var bodyStartPos = _v0.a;
		var item = _v0.b;
		var spaceNum = bodyStartPos - markerEndPos;
		if (spaceNum <= 4) {
			return _Utils_Tuple3(listMarker, bodyStartPos - markerStartPos, item);
		} else {
			var intendedCodeItem = function () {
				switch (item.$) {
					case 0:
						var completion = item.a;
						var string = item.b;
						return A2(
							$dillonkearns$elm_markdown$Markdown$ListItem$TaskItem,
							completion,
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					case 1:
						var string = item.a;
						return $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem(
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					default:
						return $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem;
				}
			}();
			return _Utils_Tuple3(listMarker, (markerEndPos - markerStartPos) + 1, intendedCodeItem);
		}
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem);
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$ListItem$Complete = 1;
var $dillonkearns$elm_markdown$Markdown$ListItem$Incomplete = 0;
var $dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[x] ',
					$elm$parser$Parser$ExpectingSymbol('[x] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[X] ',
					$elm$parser$Parser$ExpectingSymbol('[X] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[ ] ',
					$elm$parser$Parser$ExpectingSymbol('[ ] '))))
		]));
var $dillonkearns$elm_markdown$Markdown$ListItem$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$TaskItem),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser,
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$PlainItem)
			])),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	$dillonkearns$elm_markdown$Markdown$ListItem$parser);
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Asterisk = 2;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Minus = 0;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Plus = 1;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(0),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'-',
					$elm$parser$Parser$ExpectingSymbol('-')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'+',
					$elm$parser$Parser$ExpectingSymbol('+')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(2),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'*',
					$elm$parser$Parser$ExpectingSymbol('*'))))
		]));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$parser = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem),
					$elm$parser$Parser$Advanced$getCol),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock = function (previousWasBody) {
	var parseListItem = F3(
		function (listmarker, intended, unparsedListItem) {
			switch (unparsedListItem.$) {
				case 0:
					var completion = unparsedListItem.a;
					var body = unparsedListItem.b;
					return {
						f6: body,
						oc: listmarker,
						B: $elm$core$Maybe$Just(
							function () {
								if (completion === 1) {
									return true;
								} else {
									return false;
								}
							}())
					};
				case 1:
					var body = unparsedListItem.a;
					return {f6: body, oc: listmarker, B: $elm$core$Maybe$Nothing};
				default:
					return {f6: '', oc: listmarker, B: $elm$core$Maybe$Nothing};
			}
		});
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			var listmarker = _v0.a;
			var intended = _v0.b;
			var unparsedListItem = _v0.c;
			return A4(
				$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
				true,
				intended,
				_List_Nil,
				A3(parseListItem, listmarker, intended, unparsedListItem));
		},
		$dillonkearns$elm_markdown$Markdown$UnorderedList$parser(previousWasBody));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks = F2(
	function (node, blocks) {
		switch (node.$) {
			case 0:
				var tag = node.a;
				var attributes = node.b;
				var children = node.c;
				var _v99 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
				if (!_v99.$) {
					var childrenAsBlocks = _v99.a;
					var block = $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, childrenAsBlocks));
					return $elm$core$Result$Ok(
						A2($elm$core$List$cons, block, blocks));
				} else {
					var err = _v99.a;
					return $elm$core$Result$Err(err);
				}
			case 1:
				var innerText = node.a;
				var _v100 = $dillonkearns$elm_markdown$Markdown$Parser$parse(innerText);
				if (!_v100.$) {
					var value = _v100.a;
					return $elm$core$Result$Ok(
						_Utils_ap(
							$elm$core$List$reverse(value),
							blocks));
				} else {
					var error = _v100.a;
					return $elm$core$Result$Err(
						$elm$parser$Parser$Expecting(
							A2(
								$elm$core$String$join,
								'\n',
								A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, error))));
				}
			case 2:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)),
						blocks));
			case 3:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)),
						blocks));
			case 4:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)),
						blocks));
			default:
				var declarationType = node.a;
				var content = node.b;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)),
						blocks));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$completeBlocks = function (state) {
	var _v84 = state.b;
	_v84$5:
	while (true) {
		if (_v84.b) {
			switch (_v84.a.$) {
				case 11:
					var body2 = _v84.a.a;
					var rest = _v84.b;
					var _v85 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						body2);
					if (!_v85.$) {
						var value = _v85.a;
						return $elm$parser$Parser$Advanced$succeed(
							{
								a: _Utils_ap(state.a, value.a),
								b: A2(
									$elm$core$List$cons,
									$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.b),
									rest)
							});
					} else {
						var error = _v85.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(error)));
					}
				case 3:
					var _v86 = _v84.a;
					var tight = _v86.a;
					var intended = _v86.b;
					var closeListItems = _v86.c;
					var openListItem = _v86.d;
					var rest = _v84.b;
					var _v87 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem.f6);
					if (!_v87.$) {
						var value = _v87.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								a: _Utils_ap(state.a, value.a),
								b: A2(
									$elm$core$List$cons,
									A4(
										$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
										tight2,
										intended,
										A2(
											$elm$core$List$cons,
											{f6: value.b, B: openListItem.B},
											closeListItems),
										openListItem),
									rest)
							});
					} else {
						var e = _v87.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 4:
					var _v92 = _v84.a;
					var tight = _v92.a;
					var intended = _v92.b;
					var marker = _v92.c;
					var order = _v92.d;
					var closeListItems = _v92.e;
					var openListItem = _v92.f;
					var rest = _v84.b;
					var _v93 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem);
					if (!_v93.$) {
						var value = _v93.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								a: _Utils_ap(state.a, value.a),
								b: A2(
									$elm$core$List$cons,
									A6(
										$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
										tight2,
										intended,
										marker,
										order,
										A2($elm$core$List$cons, value.b, closeListItems),
										openListItem),
									rest)
							});
					} else {
						var e = _v93.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 10:
					if (_v84.b.b) {
						switch (_v84.b.a.$) {
							case 3:
								var _v88 = _v84.a;
								var _v89 = _v84.b;
								var _v90 = _v89.a;
								var tight = _v90.a;
								var intended = _v90.b;
								var closeListItems = _v90.c;
								var openListItem = _v90.d;
								var rest = _v89.b;
								var _v91 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem.f6);
								if (!_v91.$) {
									var value = _v91.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												A4(
													$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
													tight2,
													intended,
													A2(
														$elm$core$List$cons,
														{f6: value.b, B: openListItem.B},
														closeListItems),
													openListItem),
												rest)
										});
								} else {
									var e = _v91.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							case 4:
								var _v94 = _v84.a;
								var _v95 = _v84.b;
								var _v96 = _v95.a;
								var tight = _v96.a;
								var intended = _v96.b;
								var marker = _v96.c;
								var order = _v96.d;
								var closeListItems = _v96.e;
								var openListItem = _v96.f;
								var rest = _v95.b;
								var _v97 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem);
								if (!_v97.$) {
									var value = _v97.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												A6(
													$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
													tight2,
													intended,
													marker,
													order,
													A2($elm$core$List$cons, value.b, closeListItems),
													openListItem),
												rest)
										});
								} else {
									var e = _v97.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							default:
								break _v84$5;
						}
					} else {
						break _v84$5;
					}
				default:
					break _v84$5;
			}
		} else {
			break _v84$5;
		}
	}
	return $elm$parser$Parser$Advanced$succeed(state);
};
var $dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks = F2(
	function (state, newRawBlock) {
		var _v41 = _Utils_Tuple2(newRawBlock, state.b);
		_v41$13:
		while (true) {
			if (_v41.b.b) {
				switch (_v41.b.a.$) {
					case 5:
						if (_v41.a.$ === 5) {
							var block1 = _v41.a.a;
							var _v42 = _v41.b;
							var block2 = _v42.a.a;
							var rest = _v42.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									a: state.a,
									b: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock(
											{
												f6: A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2.f6, block1.f6),
												ic: $elm$core$Maybe$Nothing
											}),
										rest)
								});
						} else {
							break _v41$13;
						}
					case 6:
						switch (_v41.a.$) {
							case 6:
								var block1 = _v41.a.a;
								var _v43 = _v41.b;
								var block2 = _v43.a.a;
								var rest = _v43.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2, block1)),
											rest)
									});
							case 10:
								var _v44 = _v41.a;
								var _v45 = _v41.b;
								var block = _v45.a.a;
								var rest = _v45.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block, '\n')),
											rest)
									});
							default:
								break _v41$13;
						}
					case 11:
						var _v46 = _v41.b;
						var body2 = _v46.a.a;
						var rest = _v46.b;
						switch (newRawBlock.$) {
							case 11:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, body2, body1)),
											rest)
									});
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
												A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', body2, body1)),
											rest)
									});
							default:
								var _v48 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (!_v48.$) {
									var value = _v48.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.b),
													rest))
										});
								} else {
									var e = _v48.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 3:
						var _v49 = _v41.b;
						var _v50 = _v49.a;
						var tight = _v50.a;
						var intended1 = _v50.b;
						var closeListItems2 = _v50.c;
						var openListItem2 = _v50.d;
						var rest = _v49.b;
						switch (newRawBlock.$) {
							case 3:
								var intended2 = newRawBlock.b;
								var closeListItems1 = newRawBlock.c;
								var openListItem1 = newRawBlock.d;
								if (_Utils_eq(openListItem2.oc, openListItem1.oc)) {
									var _v52 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.f6);
									if (!_v52.$) {
										var value = _v52.a;
										return A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														false,
														intended2,
														A2(
															$elm$core$List$cons,
															{f6: value.b, B: openListItem2.B},
															closeListItems2),
														openListItem1),
													rest)
											}) : $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended2,
														A2(
															$elm$core$List$cons,
															{f6: value.b, B: openListItem2.B},
															closeListItems2),
														openListItem1),
													rest)
											});
									} else {
										var e = _v52.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v53 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.f6);
									if (!_v53.$) {
										var value = _v53.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight2,
															intended1,
															A2(
																$elm$core$List$cons,
																{f6: value.b, B: openListItem2.B},
																closeListItems2),
															openListItem1),
														rest))
											});
									} else {
										var e = _v53.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											A4(
												$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
												tight,
												intended1,
												closeListItems2,
												_Utils_update(
													openListItem2,
													{
														f6: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem2.f6, body1)
													})),
											rest)
									});
							default:
								var _v54 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2.f6);
								if (!_v54.$) {
									var value = _v54.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight2,
														intended1,
														A2(
															$elm$core$List$cons,
															{f6: value.b, B: openListItem2.B},
															closeListItems2),
														openListItem2),
													rest))
										});
								} else {
									var e = _v54.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 4:
						var _v55 = _v41.b;
						var _v56 = _v55.a;
						var tight = _v56.a;
						var intended1 = _v56.b;
						var marker = _v56.c;
						var order = _v56.d;
						var closeListItems2 = _v56.e;
						var openListItem2 = _v56.f;
						var rest = _v55.b;
						switch (newRawBlock.$) {
							case 4:
								var intended2 = newRawBlock.b;
								var marker2 = newRawBlock.c;
								var closeListItems1 = newRawBlock.e;
								var openListItem1 = newRawBlock.f;
								if (_Utils_eq(marker, marker2)) {
									var _v58 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v58.$) {
										var value = _v58.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended2,
														marker,
														order,
														A2($elm$core$List$cons, value.b, closeListItems2),
														openListItem1),
													rest)
											});
									} else {
										var e = _v58.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v59 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v59.$) {
										var value = _v59.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															tight2,
															intended1,
															marker,
															order,
															A2($elm$core$List$cons, value.b, closeListItems2),
															openListItem2),
														rest))
											});
									} else {
										var e = _v59.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended1, marker, order, closeListItems2, openListItem2 + ('\n' + body1)),
											rest)
									});
							default:
								var _v60 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2);
								if (!_v60.$) {
									var value = _v60.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended1,
														marker,
														order,
														A2($elm$core$List$cons, value.b, closeListItems2),
														openListItem2),
													rest))
										});
								} else {
									var e = _v60.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 1:
						switch (_v41.a.$) {
							case 1:
								var body1 = _v41.a.a;
								var _v61 = _v41.b;
								var body2 = _v61.a.a;
								var rest = _v61.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
												A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', body2, body1)),
											rest)
									});
							case 13:
								if (!_v41.a.a) {
									var _v62 = _v41.a;
									var _v63 = _v62.a;
									var _v64 = _v41.b;
									var unparsedInlines = _v64.a.a;
									var rest = _v64.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 1, unparsedInlines),
												rest)
										});
								} else {
									var _v65 = _v41.a;
									var _v66 = _v65.a;
									var _v67 = _v41.b;
									var unparsedInlines = _v67.a.a;
									var rest = _v67.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 2, unparsedInlines),
												rest)
										});
								}
							case 9:
								var _v68 = _v41.a.a;
								var text = _v68.a;
								var alignments = _v68.b;
								var _v69 = _v41.b;
								var rawHeaders = _v69.a.a;
								var rest = _v69.b;
								var _v70 = A2(
									$dillonkearns$elm_markdown$Markdown$TableParser$parseHeader,
									A2($dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow, text, alignments),
									rawHeaders);
								if (!_v70.$) {
									var headers = _v70.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$Table(
													A2($dillonkearns$elm_markdown$Markdown$Table$Table, headers, _List_Nil)),
												rest)
										});
								} else {
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
													A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', rawHeaders, text.k9)),
												rest)
										});
								}
							default:
								break _v41$13;
						}
					case 8:
						if (_v41.a.$ === 8) {
							var updatedTable = _v41.a.a;
							var _v71 = _v41.b;
							var rest = _v71.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									a: state.a,
									b: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$Table(updatedTable),
										rest)
								});
						} else {
							break _v41$13;
						}
					case 10:
						if (_v41.b.b.b) {
							switch (_v41.b.b.a.$) {
								case 4:
									var _v72 = _v41.b;
									var _v73 = _v72.a;
									var _v74 = _v72.b;
									var _v75 = _v74.a;
									var tight = _v75.a;
									var intended1 = _v75.b;
									var marker = _v75.c;
									var order = _v75.d;
									var closeListItems2 = _v75.e;
									var openListItem2 = _v75.f;
									var rest = _v74.b;
									var _v76 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v76.$) {
										var value = _v76.a;
										if (newRawBlock.$ === 4) {
											var intended2 = newRawBlock.b;
											var openListItem = newRawBlock.f;
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															false,
															intended2,
															marker,
															order,
															A2($elm$core$List$cons, value.b, closeListItems2),
															openListItem),
														rest)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A6(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
																	tight,
																	intended1,
																	marker,
																	order,
																	A2($elm$core$List$cons, value.b, closeListItems2),
																	openListItem2),
																rest)))
												});
										}
									} else {
										var e = _v76.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								case 3:
									var _v78 = _v41.b;
									var _v79 = _v78.a;
									var _v80 = _v78.b;
									var _v81 = _v80.a;
									var tight = _v81.a;
									var intended1 = _v81.b;
									var closeListItems2 = _v81.c;
									var openListItem2 = _v81.d;
									var rest = _v80.b;
									var _v82 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.f6);
									if (!_v82.$) {
										var value = _v82.a;
										if (newRawBlock.$ === 3) {
											var openListItem = newRawBlock.d;
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															false,
															intended1,
															A2(
																$elm$core$List$cons,
																{f6: value.b, B: openListItem2.B},
																closeListItems2),
															openListItem),
														rest)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended1,
																	A2(
																		$elm$core$List$cons,
																		{f6: value.b, B: openListItem2.B},
																		closeListItems2),
																	openListItem2),
																rest)))
												});
										}
									} else {
										var e = _v82.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								default:
									break _v41$13;
							}
						} else {
							break _v41$13;
						}
					default:
						break _v41$13;
				}
			} else {
				break _v41$13;
			}
		}
		return $elm$parser$Parser$Advanced$succeed(
			{
				a: state.a,
				b: A2($elm$core$List$cons, newRawBlock, state.b)
			});
	});
var $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper = F2(
	function (referencesDict, _v36) {
		var unparsedInlines = _v36;
		var mappedReferencesDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					function (_v37) {
						var destination = _v37.jG;
						var title = _v37.fN;
						return _Utils_Tuple2(destination, title);
					}),
				referencesDict));
		return A2(
			$elm$core$List$map,
			$dillonkearns$elm_markdown$Markdown$Parser$mapInline,
			A2($dillonkearns$elm_markdown$Markdown$InlineParser$parse, mappedReferencesDict, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$mapInline = function (inline) {
	switch (inline.$) {
		case 0:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Text(string);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak;
		case 2:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$CodeSpan(string);
		case 3:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Link,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 4:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Image,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 5:
			var node = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlInline(
				$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(node));
		case 6:
			var level = inline.a;
			var inlines = inline.b;
			switch (level) {
				case 1:
					return $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				case 2:
					return $dillonkearns$elm_markdown$Markdown$Block$Strong(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				default:
					return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(level) ? $dillonkearns$elm_markdown$Markdown$Block$Strong(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 2, inlines))
							])) : $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 1, inlines))
							]));
			}
		default:
			var inlines = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Strikethrough(
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock = function (node) {
	switch (node.$) {
		case 1:
			var innerText = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment('TODO this never happens, but use types to drop this case.');
		case 0:
			var tag = node.a;
			var attributes = node.b;
			var children = node.c;
			var parseChild = function (child) {
				if (child.$ === 1) {
					var text = child.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks(text);
				} else {
					return _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(child))
						]);
				}
			};
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$HtmlElement,
				tag,
				attributes,
				A2($elm$core$List$concatMap, parseChild, children));
		case 2:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string);
		case 3:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Cdata(string);
		case 4:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string);
		default:
			var declarationType = node.a;
			var content = node.b;
			return A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content);
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks = function (children) {
	return A2($dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp, children, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp = F2(
	function (remaining, soFar) {
		nodesToBlocksHelp:
		while (true) {
			if (remaining.b) {
				var node = remaining.a;
				var rest = remaining.b;
				var _v31 = A2($dillonkearns$elm_markdown$Markdown$Parser$childToBlocks, node, soFar);
				if (!_v31.$) {
					var newSoFar = _v31.a;
					var $temp$remaining = rest,
						$temp$soFar = newSoFar;
					remaining = $temp$remaining;
					soFar = $temp$soFar;
					continue nodesToBlocksHelp;
				} else {
					var e = _v31.a;
					return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(
					$elm$core$List$reverse(soFar));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parse = function (input) {
	var _v27 = A2(
		$elm$parser$Parser$Advanced$run,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
			$dillonkearns$elm_markdown$Helpers$endOfFile),
		input);
	if (_v27.$ === 1) {
		var e = _v27.a;
		return $elm$core$Result$Err(e);
	} else {
		var v = _v27.a;
		var _v28 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(v);
		if (_v28.$ === 1) {
			var e = _v28.a;
			return A2(
				$elm$parser$Parser$Advanced$run,
				$elm$parser$Parser$Advanced$problem(e),
				'');
		} else {
			var blocks = _v28.a;
			var isNotEmptyParagraph = function (block) {
				if ((block.$ === 5) && (!block.a.b)) {
					return false;
				} else {
					return true;
				}
			};
			return $elm$core$Result$Ok(
				A2($elm$core$List$filter, isNotEmptyParagraph, blocks));
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines = function (state) {
	return A3($dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp, state, state.b, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp = F3(
	function (state, rawBlocks, parsedBlocks) {
		parseAllInlinesHelp:
		while (true) {
			if (rawBlocks.b) {
				var rawBlock = rawBlocks.a;
				var rest = rawBlocks.b;
				var _v26 = A2($dillonkearns$elm_markdown$Markdown$Parser$parseInlines, state.a, rawBlock);
				switch (_v26.$) {
					case 1:
						var newParsedBlock = _v26.a;
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = A2($elm$core$List$cons, newParsedBlock, parsedBlocks);
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					case 0:
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = parsedBlocks;
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					default:
						var e = _v26.a;
						return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(parsedBlocks);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines = F2(
	function (linkReferences, header) {
		return A2(
			$elm$core$List$map,
			function (_v24) {
				var label = _v24.n$;
				var alignment = _v24.f0;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Parser$parseRawInline,
					linkReferences,
					function (parsedHeaderLabel) {
						return {f0: alignment, n$: parsedHeaderLabel};
					},
					label);
			},
			header);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseInlines = F2(
	function (linkReferences, rawBlock) {
		switch (rawBlock.$) {
			case 0:
				var level = rawBlock.a;
				var unparsedInlines = rawBlock.b;
				var _v17 = $dillonkearns$elm_markdown$Markdown$Parser$toHeading(level);
				if (!_v17.$) {
					var parsedLevel = _v17.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						A2(
							$dillonkearns$elm_markdown$Markdown$Block$Heading,
							parsedLevel,
							A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
				} else {
					var e = _v17.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 1:
				var unparsedInlines = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
			case 2:
				var html = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(html));
			case 3:
				var tight = rawBlock.a;
				var intended = rawBlock.b;
				var unparsedItems = rawBlock.c;
				var parseItem = F2(
					function (rawBlockTask, rawBlocks) {
						var blocksTask = function () {
							if (!rawBlockTask.$) {
								if (!rawBlockTask.a) {
									return 1;
								} else {
									return 2;
								}
							} else {
								return 0;
							}
						}();
						var blocks = function () {
							var _v18 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
								{a: linkReferences, b: rawBlocks});
							if (!_v18.$) {
								var parsedBlocks = _v18.a;
								return parsedBlocks;
							} else {
								var e = _v18.a;
								return _List_Nil;
							}
						}();
						return A2($dillonkearns$elm_markdown$Markdown$Block$ListItem, blocksTask, blocks);
					});
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$UnorderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						$elm$core$List$reverse(
							A2(
								$elm$core$List$map,
								function (item) {
									return A2(parseItem, item.B, item.f6);
								},
								unparsedItems))));
			case 4:
				var tight = rawBlock.a;
				var startingIndex = rawBlock.d;
				var unparsedItems = rawBlock.e;
				var parseItem = function (rawBlocks) {
					var _v20 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
						{a: linkReferences, b: rawBlocks});
					if (!_v20.$) {
						var parsedBlocks = _v20.a;
						return parsedBlocks;
					} else {
						var e = _v20.a;
						return _List_Nil;
					}
				};
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A3(
						$dillonkearns$elm_markdown$Markdown$Block$OrderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						startingIndex,
						$elm$core$List$reverse(
							A2($elm$core$List$map, parseItem, unparsedItems))));
			case 5:
				var codeBlock = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(codeBlock));
			case 7:
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$ThematicBreak);
			case 10:
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 11:
				var rawBlocks = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 12:
				var rawBlocks = rawBlock.a;
				var _v21 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
					{a: linkReferences, b: rawBlocks});
				if (!_v21.$) {
					var parsedBlocks = _v21.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						$dillonkearns$elm_markdown$Markdown$Block$BlockQuote(parsedBlocks));
				} else {
					var e = _v21.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 6:
				var codeBlockBody = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(
						{f6: codeBlockBody, ic: $elm$core$Maybe$Nothing}));
			case 8:
				var _v22 = rawBlock.a;
				var header = _v22.a;
				var rows = _v22.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$Table,
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines, linkReferences, header),
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines, linkReferences, rows)));
			case 9:
				var _v23 = rawBlock.a;
				var text = _v23.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, text.k9)));
			default:
				var raw = rawBlock.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, raw)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline = F3(
	function (linkReferences, wrap, unparsedInlines) {
		return wrap(
			A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines = F2(
	function (linkReferences, rows) {
		return A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$elm$core$List$map,
					function (column) {
						return A3($dillonkearns$elm_markdown$Markdown$Parser$parseRawInline, linkReferences, $elm$core$Basics$identity, column);
					},
					row);
			},
			rows);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock = function (revStmts) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revStmts);
				},
				$dillonkearns$elm_markdown$Helpers$endOfFile),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (reference) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($dillonkearns$elm_markdown$Markdown$Parser$addReference, revStmts, reference));
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser)),
				function () {
				var _v3 = revStmts.b;
				_v3$6:
				while (true) {
					if (_v3.b) {
						switch (_v3.a.$) {
							case 1:
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser()));
							case 8:
								var table = _v3.a.a;
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$elm$parser$Parser$Advanced$oneOf(
											_List_fromArray(
												[
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser(),
													$dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted(table)
												]))));
							case 3:
								var _v4 = _v3.a;
								var tight = _v4.a;
								var intended = _v4.b;
								var closeListItems = _v4.c;
								var openListItem = _v4.d;
								var rest = _v3.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight,
															intended,
															closeListItems,
															_Utils_update(
																openListItem,
																{
																	f6: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.f6, newString)
																})),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended,
														closeListItems,
														_Utils_update(
															openListItem,
															{
																f6: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem.f6, newString)
															})),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v5) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 4:
								var _v10 = _v3.a;
								var tight = _v10.a;
								var intended = _v10.b;
								var marker = _v10.c;
								var order = _v10.d;
								var closeListItems = _v10.e;
								var openListItem = _v10.f;
								var rest = _v3.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v11) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 10:
								if (_v3.b.b) {
									switch (_v3.b.a.$) {
										case 3:
											var _v6 = _v3.a;
											var _v7 = _v3.b;
											var _v8 = _v7.a;
											var tight = _v8.a;
											var intended = _v8.b;
											var closeListItems = _v8.c;
											var openListItem = _v8.d;
											var rest = _v7.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A4(
																		$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																		tight,
																		intended,
																		closeListItems,
																		_Utils_update(
																			openListItem,
																			{
																				f6: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.f6, newString)
																			})),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended,
																	closeListItems,
																	_Utils_update(
																		openListItem,
																		{
																			f6: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem.f6, newString)
																		})),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem.f6) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v9) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										case 4:
											var _v12 = _v3.a;
											var _v13 = _v3.b;
											var _v14 = _v13.a;
											var tight = _v14.a;
											var intended = _v14.b;
											var marker = _v14.c;
											var order = _v14.d;
											var closeListItems = _v14.e;
											var openListItem = _v14.f;
											var rest = _v13.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v15) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										default:
											break _v3$6;
									}
								} else {
									break _v3$6;
								}
							default:
								break _v3$6;
						}
					} else {
						break _v3$6;
					}
				}
				return A2(
					$elm$parser$Parser$Advanced$map,
					function (block) {
						return $elm$parser$Parser$Advanced$Loop(block);
					},
					A2(
						$elm$parser$Parser$Advanced$andThen,
						$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()));
			}(),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (block) {
					return $elm$parser$Parser$Advanced$Loop(block);
				},
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
					$dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks = function (textNodeValue) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		$dillonkearns$elm_markdown$Markdown$Parser$parse(textNodeValue));
};
var $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode = function (xmlNode) {
	switch (xmlNode.$) {
		case 1:
			var innerText = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(innerText));
		case 0:
			var tag = xmlNode.a;
			var attributes = xmlNode.b;
			var children = xmlNode.c;
			var _v1 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
			if (!_v1.$) {
				var parsedChildren = _v1.a;
				return $elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, parsedChildren)));
			} else {
				var err = _v1.a;
				return $elm$parser$Parser$Advanced$problem(err);
			}
		case 2:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)));
		case 3:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)));
		case 4:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)));
		default:
			var declarationType = xmlNode.a;
			var content = xmlNode.b;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)));
	}
};
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser() {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$Parser$completeBlocks,
		A2(
			$elm$parser$Parser$Advanced$loop,
			{a: _List_Nil, b: _List_Nil},
			$dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock,
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v40) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$setextLineParser),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v39) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(true),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(true),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser(),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph)
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v38) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser() {
	return A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode, $dillonkearns$elm_markdown$HtmlParser$html);
}
var $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList;
};
var $dillonkearns$elm_markdown$Markdown$Parser$htmlParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$htmlParser;
};
var $author$project$Markdown$Bold = {$: 0};
var $author$project$Markdown$Header = function (a) {
	return {$: 5, a: a};
};
var $author$project$Markdown$Italic = {$: 1};
var $author$project$Markdown$LinkFormatting = function (a) {
	return {$: 4, a: a};
};
var $author$project$Markdown$OrderedList = {$: 6};
var $author$project$Markdown$QuillOp = $elm$core$Basics$identity;
var $author$project$Markdown$Strike = {$: 2};
var $author$project$Markdown$Underline = {$: 3};
var $author$project$Markdown$UnorderedList = {$: 7};
var $dillonkearns$elm_markdown$Markdown$Block$headingLevelToInt = function (headingLevel) {
	switch (headingLevel) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		default:
			return 6;
	}
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $elm_community$list_extra$List$Extra$intercalate = function (xs) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$List$concat,
		$elm$core$List$intersperse(xs));
};
var $author$project$Markdown$quillOpFromMarkdownBlock = function (block) {
	var parseList = F2(
		function (listType, children) {
			return function (list) {
				return A2(
					$elm$core$List$cons,
					{y: _List_Nil, aI: '\n'},
					list);
			}(
				A2(
					$elm$core$List$concatMap,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map($author$project$Markdown$quillOpFromMarkdownBlock),
						A2(
							$elm$core$Basics$composeR,
							$elm_community$list_extra$List$Extra$intercalate(
								_List_fromArray(
									[
										{y: _List_Nil, aI: ' '}
									])),
							function (line) {
								return _Utils_ap(
									line,
									_List_fromArray(
										[
											{
											y: _List_fromArray(
												[listType]),
											aI: '\n'
										}
										]));
							})),
					children));
		});
	_v4$5:
	while (true) {
		switch (block.$) {
			case 1:
				var children = block.b;
				var listItemToList = function (_v5) {
					var children_ = _v5.b;
					return children_;
				};
				return A2(
					parseList,
					$author$project$Markdown$UnorderedList,
					A2($elm$core$List$map, listItemToList, children));
			case 2:
				var children = block.c;
				return A2(parseList, $author$project$Markdown$OrderedList, children);
			case 4:
				var headingLevel = block.a;
				var children = block.b;
				return function (l) {
					return _Utils_ap(
						l,
						_List_fromArray(
							[
								{
								y: _List_fromArray(
									[
										$author$project$Markdown$Header(
										$dillonkearns$elm_markdown$Markdown$Block$headingLevelToInt(headingLevel))
									]),
								aI: '\n'
							}
							]));
				}(
					A2($elm$core$List$concatMap, $author$project$Markdown$quillOpFromMarkdownInline, children));
			case 5:
				var children = block.a;
				return A2($elm$core$List$concatMap, $author$project$Markdown$quillOpFromMarkdownInline, children);
			case 0:
				if ((!block.a.$) && (block.a.a === 'u')) {
					var _v6 = block.a;
					var children = _v6.c;
					return A2(
						$elm$core$List$map,
						function (_v7) {
							var quillOp = _v7;
							return _Utils_update(
								quillOp,
								{
									y: A2($elm$core$List$cons, $author$project$Markdown$Underline, quillOp.y)
								});
						},
						A2($elm$core$List$concatMap, $author$project$Markdown$quillOpFromMarkdownBlock, children));
				} else {
					break _v4$5;
				}
			default:
				break _v4$5;
		}
	}
	return _List_Nil;
};
var $author$project$Markdown$quillOpFromMarkdownInline = function (inline) {
	var addFormatting = F2(
		function (children, formatting) {
			return A2(
				$elm$core$List$map,
				function (_v3) {
					var quillOp = _v3;
					return _Utils_update(
						quillOp,
						{
							y: A2($elm$core$List$cons, formatting, quillOp.y)
						});
				},
				A2($elm$core$List$concatMap, $author$project$Markdown$quillOpFromMarkdownInline, children));
		});
	_v0$6:
	while (true) {
		switch (inline.$) {
			case 1:
				var link = inline.a;
				var children = inline.c;
				return A2(
					addFormatting,
					children,
					$author$project$Markdown$LinkFormatting(link));
			case 3:
				var children = inline.a;
				return A2(addFormatting, children, $author$project$Markdown$Italic);
			case 4:
				var children = inline.a;
				return A2(addFormatting, children, $author$project$Markdown$Bold);
			case 5:
				var children = inline.a;
				return A2(addFormatting, children, $author$project$Markdown$Strike);
			case 7:
				var content = inline.a;
				return _List_fromArray(
					[
						{y: _List_Nil, aI: content}
					]);
			case 0:
				if ((!inline.a.$) && (inline.a.a === 'u')) {
					var _v1 = inline.a;
					var children = _v1.c;
					return A2(
						$elm$core$List$map,
						function (_v2) {
							var quillOp = _v2;
							return _Utils_update(
								quillOp,
								{
									y: A2($elm$core$List$cons, $author$project$Markdown$Underline, quillOp.y)
								});
						},
						A2($elm$core$List$concatMap, $author$project$Markdown$quillOpFromMarkdownBlock, children));
				} else {
					break _v0$6;
				}
			default:
				break _v0$6;
		}
	}
	return _List_Nil;
};
var $author$project$Markdown$toQuillOps = function (_v0) {
	var markdown = _v0;
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$core$Result$map,
			$elm$core$List$concatMap($author$project$Markdown$quillOpFromMarkdownBlock),
			$dillonkearns$elm_markdown$Markdown$Parser$parse(markdown)));
};
var $author$project$Form$RichText$initModel = F2(
	function (id, maybeMarkdown) {
		return {
			ge: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$Markdown$toQuillOps, maybeMarkdown)),
			w: id,
			nQ: false,
			bj: $author$project$Form$RichText$NotShowing
		};
	});
var $author$project$Form$File$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$File$LoadingFileType = {$: 0};
var $author$project$Form$File$MultipleModel = $elm$core$Basics$identity;
var $author$project$Form$File$WithImageCropper = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$File$WithoutImageCropper = {$: 0};
var $author$project$View$ImageCropper$Loading = {$: 0};
var $author$project$View$ImageCropper$init = function (_v0) {
	var aspectRatio = _v0.mj;
	return {mj: aspectRatio, ah: $author$project$View$ImageCropper$Loading, dP: false, b8: false, e8: false, nU: false};
};
var $author$project$Form$File$initMultiple = function (_v0) {
	var fileUrls = _v0.nj;
	var aspectRatio = _v0.mj;
	return {
		mj: aspectRatio,
		i: A2(
			$elm$core$List$map,
			function (file) {
				return {
					aG: $author$project$Form$File$LoadingFileType,
					X: function () {
						if (aspectRatio.$ === 1) {
							return $author$project$Form$File$WithoutImageCropper;
						} else {
							var validAspectRatio = aspectRatio.a;
							return $author$project$Form$File$WithImageCropper(
								$author$project$View$ImageCropper$init(
									{mj: validAspectRatio}));
						}
					}(),
					hn: $author$project$Form$File$Loaded(file)
				};
			},
			fileUrls),
		aj: false,
		Y: 0,
		r: $elm$core$Maybe$Nothing
	};
};
var $author$project$Page$Community$New$initModel = {
	hY: $author$project$Form$init(
		{
			aR: A2($author$project$Form$RichText$initModel, 'description-editor', $elm$core$Maybe$Nothing),
			b5: '10',
			b6: '0',
			fe: $author$project$Form$File$initMultiple(
				{
					mj: $elm$core$Maybe$Just(1),
					nj: $author$project$Page$Community$New$defaultLogos
				}),
			d0: '-100',
			fj: '',
			eg: true,
			ha: 0,
			as: '',
			hn: '',
			bT: ''
		}),
	nP: false
};
var $author$project$Page$Community$New$init = function (_v0) {
	return _Utils_Tuple2($author$project$Page$Community$New$initModel, $elm$core$Platform$Cmd$none);
};
var $author$project$Page$Community$Objectives$NoOp = {$: 0};
var $author$project$Community$ObjectivesField = 1;
var $author$project$Session$LoggedIn$RequestedReloadCommunityField = function (a) {
	return {$: 6, a: a};
};
var $pzp1997$assoc_list$AssocList$D = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$empty = _List_Nil;
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				return !_Utils_eq(key, targetKey);
			},
			alist);
	});
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(key, value),
			alteredAlist);
	});
var $pzp1997$assoc_list$AssocList$fromList = function (alist) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, result) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($pzp1997$assoc_list$AssocList$insert, key, value, result);
			}),
		_List_Nil,
		alist);
};
var $author$project$Action$ObjectiveId = $elm$core$Basics$identity;
var $author$project$Action$objectiveIdFromInt = function (id) {
	return id;
};
var $author$project$Page$Community$Objectives$init = F2(
	function (selectedObjective, _v0) {
		return A2(
			$author$project$UpdateResult$addCmd,
			A2(
				$elm$core$Task$attempt,
				function (_v3) {
					return $author$project$Page$Community$Objectives$NoOp;
				},
				A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
			A2(
				$author$project$UpdateResult$addExt,
				$author$project$Session$LoggedIn$RequestedReloadCommunityField(1),
				$author$project$UpdateResult$init(
					{
						b2: function () {
							if (selectedObjective.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var id = selectedObjective.a.w;
								var action = selectedObjective.a.dh;
								return $elm$core$Maybe$Just(
									{
										f_: A2($elm$core$Maybe$map, $author$project$Action$idFromInt, action),
										kP: $author$project$Action$objectiveIdFromInt(id)
									});
							}
						}(),
						E: function () {
							if (selectedObjective.$ === 1) {
								return $pzp1997$assoc_list$AssocList$empty;
							} else {
								var id = selectedObjective.a.w;
								return $pzp1997$assoc_list$AssocList$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											$author$project$Action$objectiveIdFromInt(id),
											{a3: $elm$core$Maybe$Nothing, bh: false, bn: $elm$core$Maybe$Nothing, bJ: $elm$core$Maybe$Nothing, bK: $elm$core$Maybe$Nothing, bR: $elm$core$Maybe$Nothing, bS: $elm$core$Maybe$Nothing})
										]));
							}
						}()
					})));
	});
var $author$project$Page$Community$Selector$init = F2(
	function (maybeRedirect, _v0) {
		return _Utils_Tuple2(
			{kD: maybeRedirect},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Community$Settings$ActionEditor$Loading = {$: 1};
var $author$project$Page$Community$Settings$ActionEditor$NoOp = {$: 0};
var $author$project$Page$Community$Settings$ActionEditor$init = F3(
	function (_v0, objectiveId, actionId) {
		return A2(
			$author$project$UpdateResult$addCmd,
			A2(
				$elm$core$Task$perform,
				function (_v1) {
					return $author$project$Page$Community$Settings$ActionEditor$NoOp;
				},
				A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
			A2(
				$author$project$UpdateResult$addExt,
				$author$project$Session$LoggedIn$RequestedCommunityField(1),
				$author$project$UpdateResult$init(
					{f_: actionId, kP: objectiveId, pN: $author$project$Page$Community$Settings$ActionEditor$Loading})));
	});
var $author$project$Page$Community$Settings$Contacts$CompletedLoadCommunity = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Community$Settings$Contacts$Loading = {$: 1};
var $author$project$Page$Community$Settings$Contacts$init = function (loggedIn) {
	return _Utils_Tuple2(
		$author$project$Page$Community$Settings$Contacts$Loading,
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Community$Settings$Contacts$CompletedLoadCommunity,
			function ($) {
				return $.pC;
			},
			loggedIn));
};
var $author$project$Page$Community$Settings$Currency$CompletedLoadCommunity = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Settings$Currency$Loading = {$: 0};
var $author$project$Page$Community$Settings$Currency$init = function (loggedIn) {
	return _Utils_Tuple2(
		{hY: $author$project$Page$Community$Settings$Currency$Loading, ap: true},
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Community$Settings$Currency$CompletedLoadCommunity,
			function ($) {
				return $.pC;
			},
			loggedIn));
};
var $author$project$Page$Community$Settings$Features$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$Features$NoOp = {$: 0};
var $author$project$Page$Community$Settings$Features$Loading = 0;
var $author$project$Page$Community$Settings$Features$initModel = {by: false, dH: false, bz: false, bB: false, pN: 0};
var $author$project$Page$Community$Settings$Features$init = function (loggedIn) {
	return _Utils_Tuple2(
		$author$project$Page$Community$Settings$Features$initModel,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3(
					$author$project$Session$LoggedIn$maybeInitWith,
					$author$project$Page$Community$Settings$Features$CompletedLoadCommunity,
					function ($) {
						return $.pC;
					},
					loggedIn),
					A2(
					$elm$core$Task$perform,
					function (_v0) {
						return $author$project$Page$Community$Settings$Features$NoOp;
					},
					A2($elm$browser$Browser$Dom$setViewport, 0, 0))
				])));
};
var $author$project$Page$Community$Settings$Info$CompletedLoadCommunity = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Community$Settings$Info$Loading = {$: 0};
var $author$project$Page$Community$Settings$Info$init = function (loggedIn) {
	return _Utils_Tuple2(
		{hY: $author$project$Page$Community$Settings$Info$Loading, e1: false, ap: true},
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Community$Settings$Info$CompletedLoadCommunity,
			function ($) {
				return $.pC;
			},
			loggedIn));
};
var $author$project$Page$Community$Settings$News$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$News$NotVisible = {$: 0};
var $author$project$Page$Community$Settings$News$init = function (loggedIn) {
	return A2(
		$author$project$UpdateResult$addExt,
		$author$project$Session$LoggedIn$RequestedReloadCommunityField(4),
		A2(
			$author$project$UpdateResult$addCmd,
			A3(
				$author$project$Session$LoggedIn$maybeInitWith,
				$author$project$Page$Community$Settings$News$CompletedLoadCommunity,
				function ($) {
					return $.pC;
				},
				loggedIn),
			$author$project$UpdateResult$init(
				{cL: $author$project$Page$Community$Settings$News$NotVisible})));
};
var $author$project$Page$Community$Settings$News$Editor$CompletedLoadCommunity = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Community$Settings$News$Editor$CompletedLoadNews = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$News$Editor$CreateNew = {$: 0};
var $author$project$Page$Community$Settings$News$Editor$Editing = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Community$Settings$News$Editor$WaitingNewsToCopy = {$: 0};
var $author$project$Page$Community$Settings$News$Editor$WaitingNewsToEdit = {$: 1};
var $author$project$Page$Community$Settings$News$Editor$PublishImmediately = 0;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.m, posixMinutes) < 0) {
					return posixMinutes + era.d;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		mX: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		ol: month,
		qn: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).mX;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ol;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).qn;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $author$project$Form$DatePicker$Model = $elm$core$Basics$identity;
var $CurrySoftware$elm_datepicker$DatePicker$DatePicker = $elm$core$Basics$identity;
var $CurrySoftware$elm_datepicker$DatePicker$initFromDate = function (date) {
	return {
		aH: $elm$core$Maybe$Just(date),
		b0: false,
		bf: $elm$core$Maybe$Nothing,
		bH: false,
		p4: date
	};
};
var $author$project$Form$DatePicker$initModel = function (date) {
	return {
		cZ: $CurrySoftware$elm_datepicker$DatePicker$initFromDate(date),
		ck: $elm$core$Maybe$Just(date)
	};
};
var $author$project$Page$Community$Settings$News$Editor$emptyForm = function (shared) {
	return $author$project$Form$init(
		{
			aR: A2($author$project$Form$RichText$initModel, 'description-input', $elm$core$Maybe$Nothing),
			d_: $elm$core$Maybe$Nothing,
			ch: $author$project$Form$DatePicker$initModel(
				A2($justinmimbs$date$Date$fromPosix, shared.i2, shared.ce)),
			c2: 0,
			fu: '13:00',
			fN: ''
		});
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$int = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$int(value));
};
var $author$project$Cambiatus$Query$news = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'news',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'newsId', requiredArgs.bG, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Session$LoggedIn$RequestQuery = function (a) {
	return {$: 11, a: a};
};
var $author$project$Session$LoggedIn$RequiredAuthToken = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Graphql$errorToString = function (errorData) {
	if (!errorData.$) {
		var graphqlErrors = errorData.b;
		return A2(
			$elm$core$String$join,
			'\n',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.of;
				},
				graphqlErrors));
	} else {
		return 'Http Error';
	}
};
var $author$project$Api$Graphql$isCertainError = F2(
	function (errorString, error) {
		return A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(errorString),
			$elm$core$String$toLower(
				$author$project$Api$Graphql$errorToString(error)));
	});
var $author$project$Api$Graphql$isAuthError = $author$project$Api$Graphql$isCertainError('Please sign in first');
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Session$LoggedIn$graphqlOperation = F4(
	function (operation, model, selectionSet, toMsg) {
		var operationCmd = F2(
			function (loggedIn, authToken) {
				return A4(
					operation,
					loggedIn,
					$elm$core$Maybe$Just(authToken),
					selectionSet,
					$elm$core$Basics$identity);
			});
		var treatAuthError = function (operationResult) {
			switch (operationResult.$) {
				case 3:
					var success = operationResult.a;
					return $elm$core$Result$Ok(
						toMsg(
							$krisajenkins$remotedata$RemoteData$Success(success)));
				case 2:
					var err = operationResult.a;
					return $author$project$Api$Graphql$isAuthError(err) ? $elm$core$Result$Err(
						{
							jo: function (newModel) {
								return A2(
									$elm$core$Basics$composeR,
									operationCmd(newModel),
									$elm$core$Platform$Cmd$map(toMsg));
							}
						}) : $elm$core$Result$Ok(
						toMsg(
							$krisajenkins$remotedata$RemoteData$Failure(err)));
				default:
					return $elm$core$Result$Ok(
						toMsg(operationResult));
			}
		};
		var _v0 = model.jk;
		if (_v0.$ === 1) {
			return $author$project$Session$LoggedIn$RequiredAuthToken(
				{
					jo: A2(
						$elm$core$Basics$composeR,
						operationCmd(model),
						$elm$core$Platform$Cmd$map(toMsg))
				});
		} else {
			var authToken = _v0.a;
			return $author$project$Session$LoggedIn$RequestQuery(
				A2(
					$elm$core$Platform$Cmd$map,
					treatAuthError,
					A2(operationCmd, model, authToken)));
		}
	});
var $author$project$Api$Graphql$withLoggedInCommunityDomain = function (loggedIn) {
	var _v0 = loggedIn.pC;
	if (_v0.$ === 3) {
		var subdomain = _v0.a.pP;
		return A2($dillonkearns$elm_graphql$Graphql$Http$withHeader, 'Community-Domain', 'https://' + subdomain);
	} else {
		return $author$project$Api$Graphql$withCommunityDomain(loggedIn.A);
	}
};
var $author$project$Api$Graphql$loggedInQuery = F4(
	function (loggedIn, maybeAuthToken, query_, toMsg) {
		var shared = loggedIn.A;
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, toMsg),
			A2(
				$author$project$Api$Graphql$withAuthToken,
				maybeAuthToken,
				A2(
					$author$project$Api$Graphql$withLoggedInCommunityDomain,
					loggedIn,
					A2($dillonkearns$elm_graphql$Graphql$Http$queryRequest, shared.jN.gx, query_))));
	});
var $author$project$Session$LoggedIn$query = F3(
	function (model, selectionSet, toMsg) {
		return A4($author$project$Session$LoggedIn$graphqlOperation, $author$project$Api$Graphql$loggedInQuery, model, selectionSet, toMsg);
	});
var $author$project$Community$News$Model = F9(
	function (description, id, title, receipt, reactions, scheduling, insertedAt, updatedAt, creator) {
		return {jz: creator, aR: description, w: id, nL: insertedAt, la: reactions, iK: receipt, iL: scheduling, fN: title, qe: updatedAt};
	});
var $author$project$Cambiatus$Object$News$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$News$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Scalar$Date = $elm$core$Basics$identity;
var $author$project$Cambiatus$Scalar$DateTime = $elm$core$Basics$identity;
var $author$project$Cambiatus$Scalar$Id = $elm$core$Basics$identity;
var $author$project$Cambiatus$Scalar$NaiveDateTime = $elm$core$Basics$identity;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$core$String$fromFloat = _String_fromNumber;
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
			A2(
			$elm$json$Json$Decode$map,
			function (bool) {
				return bool ? 'true' : 'false';
			},
			$elm$json$Json$Decode$bool)
		]));
var $author$project$Cambiatus$Scalar$defaultCodecs = {
	my: {
		jE: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		eW: function (_v0) {
			var raw = _v0;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	mz: {
		jE: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		eW: function (_v1) {
			var raw = _v1;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	eJ: {
		jE: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		eW: function (_v2) {
			var raw = _v2;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	jv: {
		jE: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		eW: function (_v3) {
			var raw = _v3;
			return $elm$json$Json$Encode$string(raw);
		}
	}
};
var $author$project$Cambiatus$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$Cambiatus$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $author$project$Cambiatus$ScalarCodecs$codecs = $author$project$Cambiatus$Scalar$defineCodecs(
	{my: $author$project$Cambiatus$Scalar$defaultCodecs.my, mz: $author$project$Cambiatus$Scalar$defaultCodecs.mz, eJ: $author$project$Cambiatus$Scalar$defaultCodecs.eJ, jv: $author$project$Cambiatus$Scalar$defaultCodecs.jv});
var $author$project$Cambiatus$Scalar$unwrapCodecs = function (_v0) {
	var unwrappedCodecs = _v0;
	return unwrappedCodecs;
};
var $author$project$Cambiatus$Object$News$insertedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.NaiveDateTime',
	'insertedAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).jv.jE);
var $author$project$Community$News$ReactionWithCount = F2(
	function (count, reaction) {
		return {mO: count, fw: reaction};
	});
var $author$project$Cambiatus$Object$ReactionType$count = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'count', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Enum$ReactionEnum$ClappingHands = 0;
var $author$project$Cambiatus$Enum$ReactionEnum$FaceWithRaisedEyebrow = 1;
var $author$project$Cambiatus$Enum$ReactionEnum$GrinningFaceWithBigEyes = 2;
var $author$project$Cambiatus$Enum$ReactionEnum$PartyPopper = 3;
var $author$project$Cambiatus$Enum$ReactionEnum$RedHeart = 4;
var $author$project$Cambiatus$Enum$ReactionEnum$Rocket = 5;
var $author$project$Cambiatus$Enum$ReactionEnum$SlightlyFrowningFace = 6;
var $author$project$Cambiatus$Enum$ReactionEnum$SmilingFaceWithHeartEyes = 7;
var $author$project$Cambiatus$Enum$ReactionEnum$ThumbsDown = 8;
var $author$project$Cambiatus$Enum$ReactionEnum$ThumbsUp = 9;
var $author$project$Cambiatus$Enum$ReactionEnum$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'CLAPPING_HANDS':
				return $elm$json$Json$Decode$succeed(0);
			case 'FACE_WITH_RAISED_EYEBROW':
				return $elm$json$Json$Decode$succeed(1);
			case 'GRINNING_FACE_WITH_BIG_EYES':
				return $elm$json$Json$Decode$succeed(2);
			case 'PARTY_POPPER':
				return $elm$json$Json$Decode$succeed(3);
			case 'RED_HEART':
				return $elm$json$Json$Decode$succeed(4);
			case 'ROCKET':
				return $elm$json$Json$Decode$succeed(5);
			case 'SLIGHTLY_FROWNING_FACE':
				return $elm$json$Json$Decode$succeed(6);
			case 'SMILING_FACE_WITH_HEART_EYES':
				return $elm$json$Json$Decode$succeed(7);
			case 'THUMBS_DOWN':
				return $elm$json$Json$Decode$succeed(8);
			case 'THUMBS_UP':
				return $elm$json$Json$Decode$succeed(9);
			default:
				return $elm$json$Json$Decode$fail('Invalid ReactionEnum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$ReactionType$reaction = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ReactionEnum.ReactionEnum', 'reaction', _List_Nil, $author$project$Cambiatus$Enum$ReactionEnum$decoder);
var $author$project$Community$News$reactionWithCountSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$ReactionType$reaction,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$ReactionType$count,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$News$ReactionWithCount)));
var $author$project$Cambiatus$Object$News$reactions = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'reactions',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$News$receipt = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'receipt',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Community$News$Receipt = function (reactions) {
	return {la: reactions};
};
var $author$project$Cambiatus$Object$NewsReceipt$reactions = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List Enum.ReactionEnum.ReactionEnum)',
	'reactions',
	_List_Nil,
	$elm$json$Json$Decode$list($author$project$Cambiatus$Enum$ReactionEnum$decoder));
var $author$project$Community$News$receiptSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$NewsReceipt$reactions,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$News$Receipt));
var $author$project$Cambiatus$Object$News$scheduling = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.DateTime)',
	'scheduling',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).mz.jE));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {jw: col, ph: problem, pA: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.pA, p.jw, p.ph);
};
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $author$project$Community$News$timeFromNaiveDateTime = function (_v0) {
	var dateTime = _v0;
	return A2(
		$elm$core$Result$withDefault,
		$elm$time$Time$millisToPosix(0),
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateTime));
};
var $author$project$Cambiatus$Object$News$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Cambiatus$Object$News$updatedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.NaiveDateTime',
	'updatedAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).jv.jE);
var $author$project$Cambiatus$Object$News$user = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'user', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Community$News$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$News$user($author$project$Profile$minimalSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Community$News$timeFromNaiveDateTime, $author$project$Cambiatus$Object$News$updatedAt),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Community$News$timeFromNaiveDateTime, $author$project$Cambiatus$Object$News$insertedAt),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					$elm$core$Maybe$andThen(
						function (_v0) {
							var dateTime = _v0;
							return $elm$core$Result$toMaybe(
								$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateTime));
						}),
					$author$project$Cambiatus$Object$News$scheduling),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$News$reactions($author$project$Community$News$reactionWithCountSelectionSet),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$News$receipt($author$project$Community$News$receiptSelectionSet),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$News$title,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$News$id,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$News$description),
									$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$News$Model))))))))));
var $author$project$Page$Community$Settings$News$Editor$init = F2(
	function (kind, loggedIn) {
		var queryForNews = function (newsId) {
			return $author$project$UpdateResult$addExt(
				A3(
					$author$project$Session$LoggedIn$query,
					loggedIn,
					A2(
						$author$project$Cambiatus$Query$news,
						{bG: newsId},
						$author$project$Community$News$selectionSet),
					$author$project$Page$Community$Settings$News$Editor$CompletedLoadNews));
		};
		var initWithCommunity = A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Community$Settings$News$Editor$CompletedLoadCommunity,
			function ($) {
				return $.pC;
			},
			loggedIn);
		switch (kind.$) {
			case 0:
				return A2(
					$author$project$UpdateResult$addCmd,
					initWithCommunity,
					$author$project$UpdateResult$init(
						A2(
							$author$project$Page$Community$Settings$News$Editor$Editing,
							$author$project$Page$Community$Settings$News$Editor$CreateNew,
							$author$project$Page$Community$Settings$News$Editor$emptyForm(loggedIn.A))));
			case 1:
				var newsId = kind.a;
				var model = $author$project$Page$Community$Settings$News$Editor$WaitingNewsToEdit;
				return A2(
					queryForNews,
					newsId,
					A2(
						$author$project$UpdateResult$addCmd,
						initWithCommunity,
						$author$project$UpdateResult$init(model)));
			default:
				var newsId = kind.a;
				var model = $author$project$Page$Community$Settings$News$Editor$WaitingNewsToCopy;
				return A2(
					queryForNews,
					newsId,
					A2(
						$author$project$UpdateResult$addCmd,
						initWithCommunity,
						$author$project$UpdateResult$init(model)));
		}
	});
var $author$project$Page$Community$Settings$Objectives$CompletedLoadCommunity = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Community$Settings$Objectives$Loading = 0;
var $author$project$Page$Community$Settings$Objectives$initModel = {d4: $elm$core$Maybe$Nothing, c1: $pzp1997$assoc_list$AssocList$empty, pN: 0};
var $author$project$Page$Community$Settings$Objectives$init = function (loggedIn) {
	return _Utils_Tuple2(
		$author$project$Page$Community$Settings$Objectives$initModel,
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Community$Settings$Objectives$CompletedLoadCommunity,
			function ($) {
				return $.pC;
			},
			loggedIn));
};
var $author$project$Page$Community$Settings$Settings$CompletedLoadCommunity = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Community$Settings$Settings$RequestedReloadCommunity = {$: 1};
var $author$project$Page$Community$Settings$Settings$Loading = 0;
var $author$project$Page$Community$Settings$Settings$initModel = 0;
var $author$project$Page$Community$Settings$Settings$init = function (loggedIn) {
	return _Utils_Tuple2(
		$author$project$Page$Community$Settings$Settings$initModel,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Task$perform,
					$elm$core$Basics$identity,
					$elm$core$Task$succeed($author$project$Page$Community$Settings$Settings$RequestedReloadCommunity)),
					A3(
					$author$project$Session$LoggedIn$maybeInitWith,
					$author$project$Page$Community$Settings$Settings$CompletedLoadCommunity,
					function ($) {
						return $.pC;
					},
					loggedIn)
				])));
};
var $author$project$Page$Community$Settings$Shop$Categories$Closed = {$: 0};
var $author$project$Page$Community$Settings$Shop$Categories$DropdownClosed = {$: 0};
var $author$project$Page$Community$Settings$Shop$Categories$NotEditing = {$: 0};
var $author$project$Community$ShopCategoriesField = 5;
var $Gizra$elm_all_set$EverySet$EverySet = $elm$core$Basics$identity;
var $Gizra$elm_all_set$EverySet$empty = $pzp1997$assoc_list$AssocList$empty;
var $author$project$Dnd$Model = $elm$core$Basics$identity;
var $author$project$Dnd$init = {dy: $elm$core$Maybe$Nothing, bw: $elm$core$Maybe$Nothing};
var $author$project$Page$Community$Settings$Shop$Categories$init = function (_v0) {
	return A2(
		$author$project$UpdateResult$addExt,
		$author$project$Session$LoggedIn$RequestedReloadCommunityField(5),
		$author$project$UpdateResult$init(
			{x: $author$project$Page$Community$Settings$Shop$Categories$DropdownClosed, cy: $elm$core$Maybe$Nothing, U: $author$project$Page$Community$Settings$Shop$Categories$Closed, ao: $author$project$Page$Community$Settings$Shop$Categories$Closed, aB: $Gizra$elm_all_set$EverySet$empty, aS: $author$project$Dnd$init, aD: $Gizra$elm_all_set$EverySet$empty, q: $author$project$Page$Community$Settings$Shop$Categories$NotEditing}));
};
var $author$project$Page$Community$Settings$Sponsorship$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$Sponsorship$init = function (loggedIn) {
	return _Utils_Tuple2(
		{},
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Community$Settings$Sponsorship$CompletedLoadCommunity,
			function ($) {
				return $.pC;
			},
			loggedIn));
};
var $author$project$Page$Community$Settings$Sponsorship$Fiat$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$Sponsorship$Fiat$init = function (loggedIn) {
	return _Utils_Tuple2(
		{},
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Community$Settings$Sponsorship$Fiat$CompletedLoadCommunity,
			function ($) {
				return $.pC;
			},
			loggedIn));
};
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$Loading = {$: 0};
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$init = function (loggedIn) {
	return _Utils_Tuple2(
		{hY: $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$Loading},
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$CompletedLoadCommunity,
			function ($) {
				return $.pC;
			},
			loggedIn));
};
var $author$project$Page$Community$Sponsor$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$PaypalButtons$BRL = 0;
var $author$project$View$PaypalButtons$USD = 1;
var $author$project$Page$Community$Sponsor$defaultPaypalCurrency = function (shared) {
	var _v0 = shared.m8;
	switch (_v0) {
		case 0:
			return 0;
		case 1:
			return 0;
		case 2:
			return 1;
		default:
			return 1;
	}
};
var $author$project$Page$Community$Sponsor$init = function (loggedIn) {
	return _Utils_Tuple2(
		{
			dB: $elm$core$Maybe$Nothing,
			hY: $author$project$Form$init(
				{
					ji: '',
					c6: $author$project$Page$Community$Sponsor$defaultPaypalCurrency(loggedIn.A)
				}),
			bi: false
		},
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Community$Sponsor$CompletedLoadCommunity,
			function ($) {
				return $.pC;
			},
			loggedIn));
};
var $author$project$Page$Community$Supporters$NoOp = {$: 0};
var $author$project$Page$Community$Supporters$init = function (_v0) {
	return A2(
		$author$project$UpdateResult$addExt,
		$author$project$Session$LoggedIn$RequestedReloadCommunityField(0),
		A2(
			$author$project$UpdateResult$addCmd,
			A2(
				$elm$core$Task$perform,
				function (_v1) {
					return $author$project$Page$Community$Supporters$NoOp;
				},
				A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
			$author$project$UpdateResult$init(
				{c1: _List_Nil})));
};
var $author$project$Page$Community$Transfer$CompletedLoadCommunity = function (a) {
	return {$: 0, a: a};
};
var $author$project$Community$MembersField = 3;
var $author$project$Page$Community$Transfer$EditingTransfer = {$: 0};
var $author$project$Form$UserPicker$SinglePickerModel = $elm$core$Basics$identity;
var $author$project$View$Select$PrivateState = $elm$core$Basics$identity;
var $author$project$View$Select$Models$newState = function (id) {
	return {nt: $elm$core$Maybe$Nothing, w: id, ed: $elm$core$Maybe$Nothing, pH: false};
};
var $author$project$View$Select$newState = function (id) {
	return $author$project$View$Select$Models$newState(id);
};
var $author$project$Form$UserPicker$initSingle = function (_v0) {
	var id = _v0.w;
	return {
		w: id,
		G: $author$project$View$Select$newState(id),
		H: $elm$core$Maybe$Nothing
	};
};
var $author$project$Page$Community$Transfer$initModel = function (maybeTo) {
	return {
		cA: $krisajenkins$remotedata$RemoteData$Loading,
		hY: $author$project$Form$init(
			{
				ji: '',
				kE: A2($author$project$Form$RichText$initModel, 'memo-editor', $elm$core$Maybe$Nothing),
				H: $author$project$Form$UserPicker$initSingle(
					{w: 'transfer-profile-select'})
			}),
		oe: maybeTo,
		p5: $krisajenkins$remotedata$RemoteData$Loading,
		a0: $author$project$Page$Community$Transfer$EditingTransfer
	};
};
var $author$project$Page$Community$Transfer$init = F2(
	function (loggedIn, maybeTo) {
		return A2(
			$author$project$UpdateResult$addExt,
			$author$project$Session$LoggedIn$RequestedReloadCommunityField(3),
			A2(
				$author$project$UpdateResult$addCmd,
				A3(
					$author$project$Session$LoggedIn$maybeInitWith,
					$author$project$Page$Community$Transfer$CompletedLoadCommunity,
					function ($) {
						return $.pC;
					},
					loggedIn),
				$author$project$UpdateResult$init(
					$author$project$Page$Community$Transfer$initModel(maybeTo))));
	});
var $author$project$Page$Dashboard$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Claim$Closed = {$: 3};
var $author$project$Page$Dashboard$InviteModalClosed = {$: 0};
var $author$project$Page$Dashboard$LoadingGraphql = function (a) {
	return {$: 0, a: a};
};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$Profile$Contact$Single = function (a) {
	return {$: 0, a: a};
};
var $author$project$Profile$Contact$defaultContactType = 5;
var $robinheghan$elm_phone_numbers$PhoneNumber$FixedLine = 0;
var $robinheghan$elm_phone_numbers$PhoneNumber$Mobile = 1;
var $robinheghan$elm_phone_numbers$PhoneNumber$NoInternationalDialling = 15;
var $robinheghan$elm_phone_numbers$PhoneNumber$PremiumRate = 3;
var $robinheghan$elm_phone_numbers$PhoneNumber$SharedCost = 4;
var $robinheghan$elm_phone_numbers$PhoneNumber$TollFree = 2;
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBR = {
	eO: '55',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}')),
	w: 'BR',
	ki: $elm$core$Maybe$Just('00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4020\\d{4}|[34]00\\d{5}'))
		},
			{
			nb: '1123456789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}'))
		},
			{
			nb: '11961234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6,7}'))
		},
			{
			nb: '300123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('300\\d{6}|[59]00\\d{6,7}'))
		},
			{
			nb: '40041234',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('300\\d{7}|[34]00\\d{5}|4(?:02|37)0\\d{4}'))
		}
		])
};
var $author$project$Profile$Contact$defaultCountry = {mP: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBR, aU: '/icons/flag-brazil.svg', aJ: '11 91234 5678'};
var $author$project$Profile$Contact$initBasic = function (contactType) {
	return {mD: '', mE: contactType, jO: $elm$core$Maybe$Nothing, b$: $elm$core$Maybe$Nothing, n$: $elm$core$Maybe$Nothing, co: false, aM: $author$project$Profile$Contact$defaultCountry};
};
var $author$project$Profile$Contact$initSingle = {
	cC: $elm$core$Maybe$Nothing,
	z: $author$project$Profile$Contact$Single(
		$author$project$Profile$Contact$initBasic($author$project$Profile$Contact$defaultContactType)),
	Z: $krisajenkins$remotedata$RemoteData$NotAsked
};
var $author$project$Page$Dashboard$initTransfersFilters = {dw: $elm$core$Maybe$Nothing, F: $elm$core$Maybe$Nothing, d9: $elm$core$Maybe$Nothing};
var $author$project$Page$Dashboard$initModel = function (shared) {
	return {
		dj: $author$project$Page$Dashboard$LoadingGraphql($elm$core$Maybe$Nothing),
		cA: $krisajenkins$remotedata$RemoteData$NotAsked,
		hF: $author$project$Claim$Closed,
		eM: $author$project$Profile$Contact$initSingle,
		cD: false,
		bg: $author$project$Page$Dashboard$InviteModalClosed,
		kw: '',
		bN: false,
		cp: false,
		c8: false,
		fU: $author$project$Form$init(
			{
				dw: $author$project$Form$DatePicker$initModel(
					A2($justinmimbs$date$Date$fromPosix, shared.i2, shared.ce)),
				F: $elm$core$Maybe$Nothing,
				qg: $author$project$Form$UserPicker$initSingle(
					{w: 'transfer-filters-user-picker'})
			}),
		av: $author$project$Page$Dashboard$LoadingGraphql($elm$core$Maybe$Nothing),
		cs: $author$project$Page$Dashboard$initTransfersFilters
	};
};
var $author$project$Page$Dashboard$init = function (loggedIn) {
	var model = $author$project$Page$Dashboard$initModel(loggedIn.A);
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Dashboard$CompletedLoadCommunity,
			function ($) {
				return $.pC;
			},
			loggedIn));
};
var $author$project$Page$Dashboard$Analysis$Analyzed = 1;
var $author$project$Session$LoggedIn$ReloadResource = function (a) {
	return {$: 5, a: a};
};
var $author$project$Session$LoggedIn$TimeResource = 2;
var $author$project$Page$Dashboard$Analysis$WaitingToVote = 0;
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent = {$: 1};
var $author$project$Cambiatus$Enum$Direction$Asc = 0;
var $author$project$Page$Dashboard$Analysis$ClaimsLoaded = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Cambiatus$Enum$Direction$Desc = 1;
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum = F2(
	function (enumToString, value) {
		return $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue(
			enumToString(value));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject = function (maybeValues) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object(
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var key = _v0.a;
				var value = _v0.b;
				return A2(
					$elm$core$Maybe$andThen,
					function (actualValue) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(key, actualValue));
					},
					value);
			},
			maybeValues));
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$null = $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$null);
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$optional = F2(
	function (optionalValue, toValue) {
		switch (optionalValue.$) {
			case 0:
				var value = optionalValue.a;
				return $elm$core$Maybe$Just(
					toValue(value));
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$null);
		}
	});
var $author$project$Cambiatus$Enum$Direction$toString = function (_enum) {
	if (!_enum) {
		return 'ASC';
	} else {
		return 'DESC';
	}
};
var $author$project$Cambiatus$InputObject$encodeClaimsFilter = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'claimer',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.gb, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'direction',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input.F,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$Direction$toString))),
				_Utils_Tuple2(
				'status',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.pN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional = F3(
	function (fieldName, maybeValue, toValue) {
		switch (maybeValue.$) {
			case 0:
				var value = maybeValue.a;
				return $elm$core$Maybe$Just(
					A2(
						$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument,
						fieldName,
						toValue(value)));
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument, fieldName, $dillonkearns$elm_graphql$Graphql$Internal$Encode$null));
		}
	});
var $author$project$Cambiatus$Query$analyzedClaims = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{hu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, id: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'after', filledInOptionals.hu, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'before', filledInOptionals.hy, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'filter', filledInOptionals.hV, $author$project$Cambiatus$InputObject$encodeClaimsFilter),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'first', filledInOptionals.hX, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'last', filledInOptionals.id, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'analyzedClaims',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Claim$Paginated = F3(
	function (edges, pageInfo, count) {
		return {mO: count, m5: edges, o2: pageInfo};
	});
var $author$project$Api$Relay$Edge = F2(
	function (cursor, node) {
		return {mV: cursor, os: node};
	});
var $author$project$Cambiatus$Object$ClaimEdge$cursor = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'cursor',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$ClaimEdge$node = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'node',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Claim$ActionCompleted = 2;
var $author$project$Claim$Cancelled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Claim$DeadlineReached = 0;
var $author$project$Claim$Model = F8(
	function (id, status, claimer, action, checks, createdAt, proofPhoto, proofCode) {
		return {dh: action, aa: checks, gb: claimer, gl: createdAt, w: id, g3: proofCode, ft: proofPhoto, pN: status};
	});
var $author$project$Claim$UsagesReached = 1;
var $author$project$Cambiatus$Object$Claim$action = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'action', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Claim$Check = F2(
	function (isApproved, validator) {
		return {bC: isApproved, aN: validator};
	});
var $author$project$Cambiatus$Object$Check$isVerified = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isVerified', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Check$validator = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'validator', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Claim$checkSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Check$validator($author$project$Profile$minimalSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Check$isVerified,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Claim$Check)));
var $author$project$Cambiatus$InputObject$encodeChecksInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'validator',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.aN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$Cambiatus$Object$Claim$checks = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{nG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'input', filledInOptionals.nG, $author$project$Cambiatus$InputObject$encodeChecksInput)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'checks',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Claim$Approved = {$: 0};
var $author$project$Claim$Pending = {$: 2};
var $author$project$Claim$Rejected = {$: 1};
var $author$project$Claim$claimStatusMap = function (v) {
	switch (v) {
		case 0:
			return $author$project$Claim$Approved;
		case 2:
			return $author$project$Claim$Rejected;
		default:
			return $author$project$Claim$Pending;
	}
};
var $author$project$Cambiatus$Object$Claim$claimer = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'claimer', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$Claim$createdAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'createdAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).mz.jE);
var $author$project$Claim$emptyStringToNothing = function (maybeString) {
	return A2(
		$elm$core$Maybe$andThen,
		function (s) {
			return $elm$core$String$isEmpty(s) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
		},
		maybeString);
};
var $author$project$Utils$fromDateTime = function (_v0) {
	var dateTime = _v0;
	return A2(
		$elm$core$Result$withDefault,
		$elm$time$Time$millisToPosix(0),
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateTime));
};
var $author$project$Cambiatus$Object$Claim$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Claim$proofCode = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'proofCode',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Claim$proofPhoto = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'proofPhoto',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Action$Action = function (id) {
	return function (description) {
		return function (image) {
			return function (objective) {
				return function (reward) {
					return function (verifierReward) {
						return function (creator) {
							return function (validators) {
								return function (usages) {
									return function (usagesLeft) {
										return function (deadline) {
											return function (verificationType) {
												return function (verifications) {
													return function (isCompleted) {
														return function (hasProofPhoto) {
															return function (hasProofCode) {
																return function (photoProofInstructions) {
																	return function (position) {
																		return function (claimCount) {
																			return {hE: claimCount, jz: creator, go: deadline, aR: description, dI: hasProofCode, gB: hasProofPhoto, w: id, h2: image, b7: isCompleted, ad: objective, iG: photoProofInstructions, bq: position, fA: reward, ja: usages, jb: usagesLeft, lV: validators, jc: verificationType, lX: verifications, lY: verifierReward};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Cambiatus$Enum$ClaimStatus$toString = function (_enum) {
	switch (_enum) {
		case 0:
			return 'APPROVED';
		case 1:
			return 'PENDING';
		default:
			return 'REJECTED';
	}
};
var $author$project$Cambiatus$Object$Action$claimCount = function (fillInOptionals) {
	var filledInOptionals = fillInOptionals(
		{pN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	var optionalArgs = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A3(
				$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
				'status',
				filledInOptionals.pN,
				$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$ClaimStatus$toString))
			]));
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'claimCount', optionalArgs, $elm$json$Json$Decode$int);
};
var $author$project$Cambiatus$Object$Action$creatorId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'creatorId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Action$deadline = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.DateTime)',
	'deadline',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).mz.jE));
var $author$project$Cambiatus$Object$Action$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Action$emptyStringToNothing = function (maybeString) {
	if (maybeString.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		if (maybeString.a === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			var nonEmptyString = maybeString.a;
			return $elm$core$Maybe$Just(nonEmptyString);
		}
	}
};
var $author$project$Cambiatus$Object$Action$hasProofCode = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Bool)',
	'hasProofCode',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool));
var $author$project$Cambiatus$Object$Action$hasProofPhoto = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Bool)',
	'hasProofPhoto',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool));
var $author$project$Cambiatus$Object$Action$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Action$idSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Action$id);
var $author$project$Cambiatus$Object$Action$image = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'image',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Action$isCompleted = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isCompleted', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Action$objective = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'objective', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Action$Objective = F4(
	function (id, description, community, isCompleted) {
		return {V: community, aR: description, w: id, b7: isCompleted};
	});
var $author$project$Cambiatus$Object$Objective$community = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'community', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Action$Community = F2(
	function (symbol, name) {
		return {fj: name, as: symbol};
	});
var $author$project$Cambiatus$Object$Community$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Community$symbol = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'symbol', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Action$communitySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Community$name,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Community$symbol),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Action$Community)));
var $author$project$Cambiatus$Object$Objective$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Objective$isCompleted = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isCompleted', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Objective$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Action$objectiveIdSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Objective$id);
var $author$project$Action$objectiveSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Objective$isCompleted,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Objective$community($author$project$Action$communitySelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$Objective$description),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Action$objectiveIdSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Action$Objective)))));
var $author$project$Cambiatus$Object$Action$photoProofInstructions = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'photoProofInstructions',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Action$position = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'position',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Cambiatus$Object$Action$reward = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'reward', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Cambiatus$Object$Action$usages = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'usages', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Action$usagesLeft = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'usagesLeft', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Action$validators = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'validators',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Enum$VerificationType$Automatic = 0;
var $author$project$Cambiatus$Enum$VerificationType$Claimable = 1;
var $author$project$Cambiatus$Enum$VerificationType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'AUTOMATIC':
				return $elm$json$Json$Decode$succeed(0);
			case 'CLAIMABLE':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid VerificationType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Action$verificationType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.VerificationType.VerificationType', 'verificationType', _List_Nil, $author$project$Cambiatus$Enum$VerificationType$decoder);
var $author$project$Cambiatus$Object$Action$verifications = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'verifications', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Action$verifierReward = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'verifierReward', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Action$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Action$claimCount(
		function (optionals) {
			return _Utils_update(
				optionals,
				{pN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		}),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Action$position,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$Action$photoProofInstructions),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					$elm$core$Maybe$withDefault(false),
					$author$project$Cambiatus$Object$Action$hasProofCode),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
						$elm$core$Maybe$withDefault(false),
						$author$project$Cambiatus$Object$Action$hasProofPhoto),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Action$isCompleted,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Action$verifications,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$Action$verificationType,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Cambiatus$Object$Action$deadline,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Cambiatus$Object$Action$usagesLeft,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Cambiatus$Object$Action$usages,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Cambiatus$Object$Action$validators($author$project$Profile$minimalSelectionSet),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Action$creatorId),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Cambiatus$Object$Action$verifierReward,
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Cambiatus$Object$Action$reward,
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																	function (o) {
																		return {V: o.V, aR: o.aR, w: o.w, b7: o.b7};
																	},
																	$author$project$Cambiatus$Object$Action$objective($author$project$Action$objectiveSelectionSet)),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Action$emptyStringToNothing, $author$project$Cambiatus$Object$Action$image),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$Action$description),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$Action$idSelectionSet,
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Action$Action))))))))))))))))))));
var $author$project$Cambiatus$Enum$ClaimStatus$Approved = 0;
var $author$project$Cambiatus$Enum$ClaimStatus$Pending = 1;
var $author$project$Cambiatus$Enum$ClaimStatus$Rejected = 2;
var $author$project$Cambiatus$Enum$ClaimStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'APPROVED':
				return $elm$json$Json$Decode$succeed(0);
			case 'PENDING':
				return $elm$json$Json$Decode$succeed(1);
			case 'REJECTED':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid ClaimStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Claim$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ClaimStatus.ClaimStatus', 'status', _List_Nil, $author$project$Cambiatus$Enum$ClaimStatus$decoder);
var $author$project$Claim$selectionSet = function (now) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		function (claim) {
			var _v1 = claim.pN;
			if (_v1.$ === 2) {
				if (claim.dh.b7) {
					return _Utils_update(
						claim,
						{
							pN: $author$project$Claim$Cancelled(2)
						});
				} else {
					if ((!claim.dh.jb) && (claim.dh.ja > 0)) {
						return _Utils_update(
							claim,
							{
								pN: $author$project$Claim$Cancelled(1)
							});
					} else {
						var _v2 = claim.dh.go;
						if (_v2.$ === 1) {
							return claim;
						} else {
							var deadline = _v2.a;
							return (_Utils_cmp(
								$elm$time$Time$posixToMillis(
									$author$project$Utils$fromDateTime(deadline)),
								$elm$time$Time$posixToMillis(now)) < 0) ? _Utils_update(
								claim,
								{
									pN: $author$project$Claim$Cancelled(0)
								}) : claim;
						}
					}
				}
			} else {
				return claim;
			}
		},
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Claim$emptyStringToNothing, $author$project$Cambiatus$Object$Claim$proofCode),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Claim$emptyStringToNothing, $author$project$Cambiatus$Object$Claim$proofPhoto),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Claim$createdAt,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$author$project$Cambiatus$Object$Claim$checks,
							function (_v0) {
								return {nG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent};
							},
							$author$project$Claim$checkSelectionSet),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Claim$action($author$project$Action$selectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$Claim$claimer($author$project$Profile$minimalSelectionSet),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Claim$claimStatusMap, $author$project$Cambiatus$Object$Claim$status),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Cambiatus$Object$Claim$id,
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Claim$Model))))))))));
};
var $author$project$Claim$claimEdgeSelectionSet = function (now) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$ClaimEdge$node(
			$author$project$Claim$selectionSet(now)),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$ClaimEdge$cursor,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Relay$Edge)));
};
var $author$project$Cambiatus$Object$ClaimConnection$count = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'count',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Cambiatus$Object$ClaimConnection$edges = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'edges',
		_List_Nil,
		object_,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$nullable,
				A2($elm$core$Basics$composeR, $elm$json$Json$Decode$list, $elm$json$Json$Decode$nullable))));
};
var $author$project$Cambiatus$Object$ClaimConnection$pageInfo = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'pageInfo', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Api$Relay$PageInfo = F4(
	function (endCursor, hasNextPage, hasPreviousPage, startCursor) {
		return {m7: endCursor, np: hasNextPage, nq: hasPreviousPage, pL: startCursor};
	});
var $author$project$Cambiatus$Object$PageInfo$endCursor = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'endCursor',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$PageInfo$hasNextPage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasNextPage', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$PageInfo$hasPreviousPage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasPreviousPage', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$PageInfo$startCursor = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'startCursor',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Api$Relay$pageInfoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$PageInfo$startCursor,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$PageInfo$hasPreviousPage,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$PageInfo$hasNextPage,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$PageInfo$endCursor,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Relay$PageInfo)))));
var $author$project$Claim$claimPaginatedSelectionSet = function (now) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$ClaimConnection$count,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$ClaimConnection$pageInfo($author$project$Api$Relay$pageInfoSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$ClaimConnection$edges(
					$author$project$Claim$claimEdgeSelectionSet(now)),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Claim$Paginated))));
};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe = function (maybeValue) {
	if (!maybeValue.$) {
		var value = maybeValue.a;
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value);
	} else {
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
	}
};
var $author$project$Eos$Account$nameToString = function (_v0) {
	var name = _v0;
	return name;
};
var $author$project$Cambiatus$Query$pendingClaims = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{hu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, id: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'after', filledInOptionals.hu, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'before', filledInOptionals.hy, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'filter', filledInOptionals.hV, $author$project$Cambiatus$InputObject$encodeClaimsFilter),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'first', filledInOptionals.hX, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'last', filledInOptionals.id, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'pendingClaims',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Page$Dashboard$Analysis$fetchAnalysis = F4(
	function (loggedIn, model, maybeCursorAfter, tab) {
		var queryFn = function () {
			if (!tab) {
				return $author$project$Cambiatus$Query$pendingClaims;
			} else {
				return $author$project$Cambiatus$Query$analyzedClaims;
			}
		}();
		var optionalStatus = function () {
			var _v2 = model.hW.iR;
			switch (_v2) {
				case 0:
					return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
				case 1:
					return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present('approved');
				default:
					return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present('rejected');
			}
		}();
		var optionalClaimer = $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.l8;
					},
					$author$project$Eos$Account$nameToString),
				model.hW.pl));
		var direction = function () {
			var _v1 = model.F;
			if (!_v1) {
				return 0;
			} else {
				return 1;
			}
		}();
		var filterRecord = {
			gb: optionalClaimer,
			F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(direction),
			pN: optionalStatus
		};
		var cursorAfter = function () {
			if (maybeCursorAfter.$ === 1) {
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
			} else {
				if (maybeCursorAfter.a === '') {
					return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
				} else {
					var cursor = maybeCursorAfter.a;
					return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(cursor);
				}
			}
		}();
		var optionals = function (opts) {
			return _Utils_update(
				opts,
				{
					hu: cursorAfter,
					hV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(filterRecord),
					hX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(16)
				});
		};
		var query = A2(
			queryFn,
			optionals,
			$author$project$Claim$claimPaginatedSelectionSet(loggedIn.A.ce));
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			query,
			$author$project$Page$Dashboard$Analysis$ClaimsLoaded(tab));
	});
var $author$project$Page$Dashboard$Analysis$ASC = 0;
var $author$project$Page$Dashboard$Analysis$All = 0;
var $author$project$View$Components$PreventScrollAlways = 1;
var $author$project$View$Components$PreventScrollOnMobile = 0;
var $author$project$Profile$Summary$init = function (isLarge) {
	return {
		gu: _List_Nil,
		e4: isLarge ? 'w-20 h-20' : 'h-10 w-10',
		dS: false,
		g1: 0,
		fx: $elm$core$Maybe$Nothing,
		fB: $elm$core$Maybe$Nothing,
		hc: true,
		hd: true
	};
};
var $author$project$Page$Dashboard$Analysis$initFilter = {pl: $elm$core$Maybe$Nothing, iR: 0};
var $author$project$Profile$Summary$withPreventScrolling = F2(
	function (preventScrolling, model) {
		return _Utils_update(
			model,
			{g1: preventScrolling});
	});
var $author$project$Page$Dashboard$Analysis$initModel = {
	hF: $author$project$Claim$Closed,
	F: 0,
	jU: A2(
		$author$project$Profile$Summary$withPreventScrolling,
		1,
		$author$project$Profile$Summary$init(false)),
	hW: $author$project$Page$Dashboard$Analysis$initFilter,
	eZ: $author$project$Form$init(
		{
			pN: 0,
			qg: $author$project$Form$UserPicker$initSingle(
				{w: 'filters-user-picker'})
		}),
	bM: false,
	aZ: 0,
	c7: false,
	pN: $krisajenkins$remotedata$RemoteData$Loading,
	a$: {dk: $elm$core$Maybe$Nothing, ew: $elm$core$Maybe$Nothing}
};
var $author$project$Page$Dashboard$Analysis$init = function (loggedIn) {
	var model = $author$project$Page$Dashboard$Analysis$initModel;
	return A2(
		$author$project$UpdateResult$addExt,
		$author$project$Session$LoggedIn$ReloadResource(2),
		A2(
			$author$project$UpdateResult$addExt,
			A4($author$project$Page$Dashboard$Analysis$fetchAnalysis, loggedIn, model, $elm$core$Maybe$Nothing, 1),
			A2(
				$author$project$UpdateResult$addExt,
				A4($author$project$Page$Dashboard$Analysis$fetchAnalysis, loggedIn, model, $elm$core$Maybe$Nothing, 0),
				$author$project$UpdateResult$init(model))));
};
var $author$project$Page$Dashboard$Claim$ClaimLoaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Cambiatus$Query$claim = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'claim',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object_,
			$elm$core$Basics$identity);
	});
var $author$project$Page$Dashboard$Claim$fetchClaim = F2(
	function (claimId, loggedIn) {
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Cambiatus$Query$claim,
				{w: claimId},
				$author$project$Claim$selectionSet(loggedIn.A.ce)),
			$author$project$Page$Dashboard$Claim$ClaimLoaded);
	});
var $author$project$Page$Dashboard$Claim$Loading = {$: 0};
var $author$project$Page$Dashboard$Claim$initModel = function (claimId) {
	return {js: claimId, hF: $author$project$Claim$Closed, fa: false, an: $author$project$Page$Dashboard$Claim$Loading};
};
var $author$project$Page$Dashboard$Claim$init = F2(
	function (loggedIn, claimId) {
		var model = $author$project$Page$Dashboard$Claim$initModel(claimId);
		return A2(
			$author$project$UpdateResult$addExt,
			A2($author$project$Page$Dashboard$Claim$fetchClaim, claimId, loggedIn),
			$author$project$UpdateResult$init(model));
	});
var $author$project$Page$Join$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Join$init = F2(
	function (session, maybeRedirect) {
		return _Utils_Tuple2(
			{kD: maybeRedirect},
			function () {
				if (!session.$) {
					return $elm$core$Platform$Cmd$none;
				} else {
					var loggedIn = session.a;
					return A3(
						$author$project$Session$LoggedIn$maybeInitWith,
						$author$project$Page$Join$CompletedLoadCommunity,
						function ($) {
							return $.pC;
						},
						loggedIn);
				}
			}());
	});
var $author$project$Page$Login$EnteringPassphrase = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Login$GotBip39 = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ports$JavascriptOut = $elm$core$Basics$identity;
var $author$project$Ports$javascriptOut = $elm$core$Basics$identity;
var $author$project$UpdateResult$addPort = F2(
	function (port_, uResult) {
		return _Utils_update(
			uResult,
			{
				k0: _Utils_ap(
					uResult.k0,
					_List_fromArray(
						[
							$author$project$Ports$javascriptOut(port_)
						]))
			});
	});
var $author$project$Page$Login$initPassphraseModel = {
	hY: $author$project$Form$init(
		{bp: ''}),
	bA: false
};
var $author$project$Page$Login$init = function (guest) {
	var requestBip39 = function () {
		var _v0 = guest.A.f4;
		if (!_v0.$) {
			return $elm$core$Basics$identity;
		} else {
			return $author$project$UpdateResult$addPort(
				{
					bZ: $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string('getBip39'))
							])),
					fy: $author$project$Page$Login$GotBip39(
						{gr: $elm$core$Set$empty, g$: $elm$core$Set$empty, hf: $elm$core$Set$empty}),
					fz: $elm$json$Json$Encode$null
				});
		}
	}();
	return requestBip39(
		$author$project$UpdateResult$init(
			$author$project$Page$Login$EnteringPassphrase($author$project$Page$Login$initPassphraseModel)));
};
var $author$project$Page$News$NoOp = {$: 0};
var $author$project$Page$News$init = F2(
	function (_v0, _v1) {
		var selectedNews = _v0.pD;
		var showOthers = _v0.pJ;
		return A2(
			$author$project$UpdateResult$addCmd,
			A2(
				$elm$core$Task$perform,
				function (_v2) {
					return $author$project$Page$News$NoOp;
				},
				A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
			A2(
				$author$project$UpdateResult$addExt,
				$author$project$Session$LoggedIn$RequestedReloadCommunityField(4),
				$author$project$UpdateResult$init(
					{
						fd: $author$project$Profile$Summary$init(false),
						bG: selectedNews,
						pI: showOthers,
						cq: false
					})));
	});
var $author$project$Page$Notification$CompletedLoadNotificationHistory = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Notification$Loading = {$: 0};
var $author$project$Page$Notification$initModel = $author$project$Page$Notification$Loading;
var $author$project$Cambiatus$Query$notificationHistory = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'notificationHistory',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Notification$History = F6(
	function (id, type_, isRead, payload, insertedAt, recipientId) {
		return {w: id, nL: insertedAt, nT: isRead, o4: payload, pr: recipientId, eq: type_};
	});
var $author$project$Cambiatus$Object$NotificationHistory$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$NotificationHistory$insertedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'insertedAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).mz.jE);
var $author$project$Cambiatus$Object$NotificationHistory$isRead = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isRead', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$NotificationHistory$payload = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'payload', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$NotificationHistory$recipientId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'recipientId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Notification$Mint = function (a) {
	return {$: 2, a: a};
};
var $author$project$Notification$SaleHistory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Notification$Transfer = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment = F2(
	function (fragmentTypeName, _v0) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet, fragmentTypeName, fields, decoder);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage = F2(
	function (typeSpecificSelections, typeName) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'Unhandled type `{0}` in exhaustive fragment handling. The following types had handlers registered to handle them: [{1}]. This happens if you are parsing either a Union or Interface. Do you need to rerun the `@dillonkearns/elm-graphql` command line tool?',
			_List_fromArray(
				[
					typeName,
					A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$map,
						function (_v0) {
							var fragmentType = _v0.a;
							var fields = _v0.b;
							var decoder = _v0.c;
							return fragmentType;
						},
						typeSpecificSelections))
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection = function (typeSpecificSelections) {
	var selections = A2(
		$elm$core$List$map,
		function (_v1) {
			var typeName = _v1.a;
			var fields = _v1.b;
			var decoder = _v1.c;
			return A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, '...on ' + typeName, _List_Nil, fields);
		},
		typeSpecificSelections);
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
		A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, selections),
		A2(
			$elm$json$Json$Decode$andThen,
			function (typeName) {
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Decode$fail(
						A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage, typeSpecificSelections, typeName)),
					A2(
						$elm$core$Dict$get,
						typeName,
						$elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (_v0) {
									var thisTypeName = _v0.a;
									var fields = _v0.b;
									var decoder = _v0.c;
									return _Utils_Tuple2(thisTypeName, decoder);
								},
								typeSpecificSelections))));
			},
			A2(
				$elm$json$Json$Decode$field,
				$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName($dillonkearns$elm_graphql$Graphql$RawField$typename),
				$elm$json$Json$Decode$string)));
};
var $author$project$Cambiatus$Union$NotificationType$fragments = function (selections) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Mint', selections.iy),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Order', selections.iz),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Transfer', selections.iA)
			]));
};
var $author$project$Notification$MintData = F3(
	function (quantity, memo, community) {
		return {V: community, kE: memo, po: quantity};
	});
var $author$project$Cambiatus$Object$Mint$community = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'community', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Notification$Community = F3(
	function (logo, symbol, subdomain) {
		return {fe: logo, pP: subdomain, as: symbol};
	});
var $author$project$Cambiatus$Object$Community$logo = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'logo',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Community$subdomain = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'subdomain',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Notification$logoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$withDefault(''),
		$author$project$Cambiatus$Object$Community$subdomain($author$project$Cambiatus$Object$Subdomain$name)),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Community$symbol),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Constants$defaultCommunityLogo, $author$project$Cambiatus$Object$Community$logo),
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Notification$Community))));
var $author$project$Cambiatus$Object$Mint$memo = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'memo',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Mint$quantity = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'quantity', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Notification$mintSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Mint$community($author$project$Notification$logoSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Mint$memo,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Mint$quantity,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Notification$MintData))));
var $author$project$Notification$OrderData = F4(
	function (amount, fromId, toId, product) {
		return {ji: amount, jX: fromId, pi: product, lE: toId};
	});
var $author$project$Notification$Product = F4(
	function (id, title, images, community) {
		return {V: community, w: id, h5: images, fN: title};
	});
var $author$project$Cambiatus$Object$Order$amount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'amount', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Cambiatus$Object$Product$community = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'community', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$Order$fromId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'fromId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Shop$Id = $elm$core$Basics$identity;
var $author$project$Cambiatus$Object$Product$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Shop$idSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Product$id);
var $author$project$Cambiatus$Object$Product$images = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'images',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Order$product = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'product', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$Product$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Order$toId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'toId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$ProductImage$uri = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'uri', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Notification$saleHistorySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Order$product(
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Product$community($author$project$Notification$logoSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Product$images($author$project$Cambiatus$Object$ProductImage$uri),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Product$title,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Shop$idSelectionSet,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Notification$Product)))))),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Order$toId),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Order$fromId),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Order$amount,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Notification$OrderData)))));
var $author$project$Notification$TransferData = F7(
	function (id, amount, fromId, toId, memo, symbol, community) {
		return {ji: amount, V: community, jX: fromId, w: id, kE: memo, as: symbol, lE: toId};
	});
var $author$project$Cambiatus$Object$Transfer$amount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'amount', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Cambiatus$Object$Transfer$community = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'community', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$Transfer$communityId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'communityId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Transfer$fromId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'fromId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Transfer$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Transfer$memo = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'memo',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Transfer$toId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'toId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Notification$transferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Transfer$community($author$project$Notification$logoSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Transfer$communityId),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Transfer$memo,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Transfer$toId,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Transfer$fromId,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Transfer$amount,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Transfer$id,
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Notification$TransferData))))))));
var $author$project$Notification$typeUnionSelectionSet = $author$project$Cambiatus$Union$NotificationType$fragments(
	{
		iy: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Notification$Mint, $author$project$Notification$mintSelectionSet),
		iz: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Notification$SaleHistory, $author$project$Notification$saleHistorySelectionSet),
		iA: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Notification$Transfer, $author$project$Notification$transferSelectionSet)
	});
var $author$project$Cambiatus$Object$NotificationHistory$type_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'type', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Notification$notificationHistorySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$NotificationHistory$recipientId),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$NotificationHistory$insertedAt,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$NotificationHistory$payload($author$project$Notification$typeUnionSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$NotificationHistory$isRead,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$NotificationHistory$type_,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$NotificationHistory$id,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Notification$History)))))));
var $author$project$Notification$notificationHistoryQuery = function (account) {
	return $author$project$Cambiatus$Query$notificationHistory($author$project$Notification$notificationHistorySelectionSet);
};
var $author$project$Page$Notification$init = function (loggedIn) {
	return A2(
		$author$project$UpdateResult$addExt,
		A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			$author$project$Notification$notificationHistoryQuery(loggedIn._),
			$author$project$Page$Notification$CompletedLoadNotificationHistory),
		$author$project$UpdateResult$init($author$project$Page$Notification$initModel));
};
var $author$project$Page$PaymentHistory$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PaymentHistory$Loading = {$: 0};
var $author$project$Avatar$empty = $elm$core$Maybe$Nothing;
var $author$project$Page$PaymentHistory$init = F2(
	function (recipientAccountName, loggedIn) {
		var recipientProfile = {l8: recipientAccountName, dl: $author$project$Avatar$empty, dm: $elm$core$Maybe$Nothing, az: _List_Nil, jK: $elm$core$Maybe$Nothing, fj: $elm$core$Maybe$Nothing};
		var initModel = {
			eD: _List_Nil,
			f2: $elm$core$Maybe$Nothing,
			eS: $author$project$Form$DatePicker$initModel(
				A2($justinmimbs$date$Date$fromPosix, loggedIn.A.i2, loggedIn.A.ce)),
			cO: $elm$core$Maybe$Nothing,
			cP: $elm$core$Maybe$Nothing,
			fv: $author$project$Page$PaymentHistory$Loading,
			ps: recipientProfile,
			ck: $elm$core$Maybe$Nothing,
			dd: $author$project$Form$UserPicker$initSingle(
				{w: 'user-picker'})
		};
		return _Utils_Tuple2(
			initModel,
			A3(
				$author$project$Session$LoggedIn$maybeInitWith,
				$author$project$Page$PaymentHistory$CompletedLoadCommunity,
				function ($) {
					return $.pC;
				},
				loggedIn));
	});
var $author$project$Page$Profile$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$CompletedLoadProfile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Profile$Loading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Profile$Model = function (name) {
	return function (account) {
		return function (avatar) {
			return function (email) {
				return function (bio) {
					return function (localization) {
						return function (contacts) {
							return function (interests) {
								return function (communities) {
									return function (roles) {
										return function (analysisCount) {
											return function (kyc) {
												return function (address) {
													return function (claimNotification) {
														return function (digest) {
															return function (transferNotification) {
																return function (preferredLanguage) {
																	return function (latestAcceptedTerms) {
																		return {l8: account, ht: address, mg: analysisCount, dl: avatar, dm: bio, dq: claimNotification, eK: communities, az: contacts, dx: digest, jK: email, dN: interests, ib: kyc, n3: latestAcceptedTerms, n9: localization, fj: name, pc: preferredLanguage, pz: roles, ep: transferNotification};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Cambiatus$Object$User$address = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Cambiatus$Object$User$analysisCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'analysisCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$User$claimNotification = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'claimNotification', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$User$communities = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'communities',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Profile$CommunityInfo = F7(
	function (symbol, name, logo, subdomain, hasShop, hasActions, hasKyc) {
		return {nn: hasActions, by: hasKyc, bB: hasShop, fe: logo, fj: name, pP: subdomain, as: symbol};
	});
var $author$project$Cambiatus$Object$Community$hasKyc = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasKyc', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Community$hasObjectives = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasObjectives', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Community$hasShop = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasShop', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Profile$communityInfoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Community$hasKyc,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Community$hasObjectives,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Community$hasShop,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					$elm$core$Maybe$withDefault(''),
					$author$project$Cambiatus$Object$Community$subdomain($author$project$Cambiatus$Object$Subdomain$name)),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Constants$defaultCommunityLogo, $author$project$Cambiatus$Object$Community$logo),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Community$name,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Community$symbol),
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$CommunityInfo))))))));
var $author$project$Cambiatus$Object$User$digest = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'digest', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Utils$fromNaiveDateTime = function (_v0) {
	var dateTime = _v0;
	return A2(
		$elm$core$Result$withDefault,
		$elm$time$Time$millisToPosix(0),
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateTime));
};
var $author$project$Cambiatus$Object$User$interests = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'interests',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$User$kyc = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'kyc',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Translation$Amharic = 4;
var $author$project$Translation$English = 0;
var $author$project$Translation$Portuguese = 1;
var $author$project$Translation$Spanish = 2;
var $author$project$Cambiatus$Enum$Language$Amheth = 0;
var $author$project$Cambiatus$Enum$Language$Enus = 1;
var $author$project$Cambiatus$Enum$Language$Eses = 2;
var $author$project$Cambiatus$Enum$Language$Ptbr = 3;
var $author$project$Cambiatus$Enum$Language$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'AMHETH':
				return $elm$json$Json$Decode$succeed(0);
			case 'ENUS':
				return $elm$json$Json$Decode$succeed(1);
			case 'ESES':
				return $elm$json$Json$Decode$succeed(2);
			case 'PTBR':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid Language type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$User$language = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.Language.Language)',
	'language',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$Cambiatus$Enum$Language$decoder));
var $author$project$Profile$languageSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Maybe$map(
		function (language) {
			switch (language) {
				case 0:
					return 4;
				case 1:
					return 0;
				case 2:
					return 2;
				default:
					return 1;
			}
		}),
	$author$project$Cambiatus$Object$User$language);
var $author$project$Cambiatus$Object$User$latestAcceptedTerms = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.NaiveDateTime)',
	'latestAcceptedTerms',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).jv.jE));
var $author$project$Cambiatus$Object$User$location = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'location',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Profile$Role = F3(
	function (color, name, permissions) {
		return {mA: color, fj: name, o6: permissions};
	});
var $author$project$Cambiatus$Object$Role$color = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'color',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Role$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Enum$Permission$Award = 0;
var $author$project$Cambiatus$Enum$Permission$Claim = 1;
var $author$project$Cambiatus$Enum$Permission$Invite = 2;
var $author$project$Cambiatus$Enum$Permission$Order = 3;
var $author$project$Cambiatus$Enum$Permission$Sell = 4;
var $author$project$Cambiatus$Enum$Permission$Transfer = 5;
var $author$project$Cambiatus$Enum$Permission$Verify = 6;
var $author$project$Cambiatus$Enum$Permission$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'AWARD':
				return $elm$json$Json$Decode$succeed(0);
			case 'CLAIM':
				return $elm$json$Json$Decode$succeed(1);
			case 'INVITE':
				return $elm$json$Json$Decode$succeed(2);
			case 'ORDER':
				return $elm$json$Json$Decode$succeed(3);
			case 'SELL':
				return $elm$json$Json$Decode$succeed(4);
			case 'TRANSFER':
				return $elm$json$Json$Decode$succeed(5);
			case 'VERIFY':
				return $elm$json$Json$Decode$succeed(6);
			default:
				return $elm$json$Json$Decode$fail('Invalid Permission type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Role$permissions = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List Enum.Permission.Permission)',
	'permissions',
	_List_Nil,
	$elm$json$Json$Decode$list($author$project$Cambiatus$Enum$Permission$decoder));
var $author$project$Profile$roleSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Role$permissions,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Role$name,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Role$color,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Role))));
var $author$project$Cambiatus$Object$User$roles = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'roles',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Kyc$ProfileKyc = F5(
	function (userType, documentType, document, phone, isVerified) {
		return {eT: document, eU: documentType, nW: isVerified, fq: phone, lU: userType};
	});
var $author$project$Cambiatus$Object$KycData$document = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'document', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$KycData$documentType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentType', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$KycData$isVerified = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isVerified', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$KycData$phone = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'phone', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$KycData$userType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userType', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Kyc$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$KycData$isVerified,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$KycData$phone,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$KycData$document,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$KycData$documentType,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$KycData$userType,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Kyc$ProfileKyc))))));
var $author$project$Profile$Address$Address = F7(
	function (country, state, city, neighborhood, street, number, zip) {
		return {mt: city, mP: country, op: neighborhood, d2: number, Z: state, fK: street, fY: zip};
	});
var $author$project$Cambiatus$Object$Address$city = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'city', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Profile$Address$City = function (name) {
	return {fj: name};
};
var $author$project$Cambiatus$Object$City$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Profile$Address$citySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$City$name,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Address$City));
var $author$project$Cambiatus$Object$Address$country = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'country', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Profile$Address$Country = function (name) {
	return {fj: name};
};
var $author$project$Cambiatus$Object$Country$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Profile$Address$countrySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Country$name,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Address$Country));
var $author$project$Cambiatus$Object$Address$neighborhood = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'neighborhood', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Profile$Address$Neighborhood = function (name) {
	return {fj: name};
};
var $author$project$Cambiatus$Object$Neighborhood$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Profile$Address$neighborhoodSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Neighborhood$name,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Address$Neighborhood));
var $author$project$Cambiatus$Object$Address$number = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'number',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Address$state = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'state', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Profile$Address$State = function (name) {
	return {fj: name};
};
var $author$project$Cambiatus$Object$State$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Profile$Address$stateSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$State$name,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Address$State));
var $author$project$Cambiatus$Object$Address$street = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'street', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Address$zip = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'zip', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Profile$Address$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Address$zip,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$elm$core$Maybe$withDefault(''),
			$author$project$Cambiatus$Object$Address$number),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Address$street,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					function ($) {
						return $.fj;
					},
					$author$project$Cambiatus$Object$Address$neighborhood($author$project$Profile$Address$neighborhoodSelectionSet)),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
						function ($) {
							return $.fj;
						},
						$author$project$Cambiatus$Object$Address$city($author$project$Profile$Address$citySelectionSet)),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
							function ($) {
								return $.fj;
							},
							$author$project$Cambiatus$Object$Address$state($author$project$Profile$Address$stateSelectionSet)),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
								function ($) {
									return $.fj;
								},
								$author$project$Cambiatus$Object$Address$country($author$project$Profile$Address$countrySelectionSet)),
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Address$Address))))))));
var $author$project$Cambiatus$Object$User$transferNotification = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'transferNotification', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Profile$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$map($author$project$Utils$fromNaiveDateTime),
		$author$project$Cambiatus$Object$User$latestAcceptedTerms),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Profile$languageSelectionSet,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$User$transferNotification,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$User$digest,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$User$claimNotification,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$User$address($author$project$Profile$Address$selectionSet),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$User$kyc($author$project$Kyc$selectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$User$analysisCount,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Cambiatus$Object$User$roles($author$project$Profile$roleSelectionSet),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Cambiatus$Object$User$communities($author$project$Profile$communityInfoSelectionSet),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
												function (maybeInterests) {
													return A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														A2(
															$elm$core$Maybe$map,
															$elm$core$String$split(','),
															maybeInterests));
												},
												$author$project$Cambiatus$Object$User$interests),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Profile$userContactSelectionSet,
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Cambiatus$Object$User$location,
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$User$bio),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Cambiatus$Object$User$email,
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$Avatar$selectionSet($author$project$Cambiatus$Object$User$avatar),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$User$account),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		$author$project$Cambiatus$Object$User$name,
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Model)))))))))))))))))));
var $author$project$Cambiatus$Query$user = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'user',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'account', requiredArgs.l8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Profile$query = function (account) {
	var nameString = $author$project$Eos$Account$nameToString(account);
	return A2(
		$author$project$Cambiatus$Query$user,
		{l8: nameString},
		$author$project$Profile$selectionSet);
};
var $author$project$Page$Profile$init = F2(
	function (loggedIn, profileName) {
		var model = {
			cA: $krisajenkins$remotedata$RemoteData$Loading,
			gf: $elm$core$Maybe$Nothing,
			b1: $krisajenkins$remotedata$RemoteData$Loading,
			pl: $krisajenkins$remotedata$RemoteData$Loading,
			k5: profileName,
			a1: $author$project$Page$Profile$Loading(_List_Nil)
		};
		var fetchProfile = _Utils_eq(loggedIn._, profileName) ? $author$project$UpdateResult$addCmd(
			A3(
				$author$project$Session$LoggedIn$maybeInitWith,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$Just,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$Success, $author$project$Page$Profile$CompletedLoadProfile)),
				function ($) {
					return $.pl;
				},
				loggedIn)) : $author$project$UpdateResult$addExt(
			A3(
				$author$project$Session$LoggedIn$query,
				loggedIn,
				$author$project$Profile$query(profileName),
				$author$project$Page$Profile$CompletedLoadProfile));
		return A2(
			$author$project$UpdateResult$addExt,
			$author$project$Session$LoggedIn$RequestedCommunityField(0),
			A2(
				$author$project$UpdateResult$addCmd,
				A3(
					$author$project$Session$LoggedIn$maybeInitWith,
					$author$project$Page$Profile$CompletedLoadCommunity,
					function ($) {
						return $.pC;
					},
					loggedIn),
				fetchProfile(
					$author$project$UpdateResult$init(model))));
	});
var $author$project$Page$Profile$AddContact$CompletedLoadProfile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$AddContact$init = function (loggedIn) {
	return _Utils_Tuple2(
		$krisajenkins$remotedata$RemoteData$Loading,
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Profile$AddContact$CompletedLoadProfile,
			function ($) {
				return $.pl;
			},
			loggedIn));
};
var $author$project$Profile$EditKycForm$CedulaDoc = 0;
var $author$project$Profile$EditKycForm$init = {
	hY: $author$project$Form$init(
		{eT: '', eU: 0, o7: ''})
};
var $author$project$Page$Profile$AddKyc$init = function (_v0) {
	return _Utils_Tuple2($author$project$Profile$EditKycForm$init, $elm$core$Platform$Cmd$none);
};
var $author$project$Page$Profile$Claims$CompletedLoadCommunity = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Profile$Claims$All = 0;
var $author$project$Page$Profile$Claims$Asc = 0;
var $author$project$Page$Profile$Claims$Loading = {$: 0};
var $author$project$Page$Profile$Claims$WaitingVote = 0;
var $author$project$Page$Profile$Claims$initModel = function (account) {
	return {l9: account, hF: $author$project$Claim$Closed, gn: 0, eV: 0, d7: 0, aZ: 0, em: false, pN: $author$project$Page$Profile$Claims$Loading};
};
var $author$project$Page$Profile$Claims$init = F2(
	function (loggedIn, account) {
		return _Utils_Tuple2(
			$author$project$Page$Profile$Claims$initModel(account),
			A3(
				$author$project$Session$LoggedIn$maybeInitWith,
				$author$project$Page$Profile$Claims$CompletedLoadCommunity,
				function ($) {
					return $.pC;
				},
				loggedIn));
	});
var $author$project$Page$Profile$Contributions$CompletedLoadCommunity = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Profile$Contributions$init = F2(
	function (loggedIn, profileName) {
		return _Utils_Tuple2(
			{eN: $krisajenkins$remotedata$RemoteData$NotAsked, k5: profileName},
			A3(
				$author$project$Session$LoggedIn$maybeInitWith,
				$author$project$Page$Profile$Contributions$CompletedLoadCommunity,
				function ($) {
					return $.pC;
				},
				loggedIn));
	});
var $author$project$Page$Profile$Editor$CompletedLoadProfile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Profile$Editor$Loading = {$: 0};
var $author$project$Page$Profile$Editor$initModel = {hY: $author$project$Page$Profile$Editor$Loading};
var $author$project$Page$Profile$Editor$init = function (loggedIn) {
	return _Utils_Tuple2(
		$author$project$Page$Profile$Editor$initModel,
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Profile$Editor$CompletedLoadProfile,
			function ($) {
				return $.pl;
			},
			loggedIn));
};
var $author$project$Page$Register$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Register$CompletedLoadInvite = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Register$FillForm = 0;
var $author$project$Page$Register$Loading = {$: 0};
var $author$project$Session$Guest$maybeInitWith = F3(
	function (toMsg, attribute, model) {
		var _v0 = attribute(model);
		if (_v0.$ === 3) {
			var value = _v0.a;
			return A2(
				$elm$core$Task$perform,
				toMsg,
				$elm$core$Task$succeed(value));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Page$Register$init = F2(
	function (invitationId, guest) {
		var shared = guest.A;
		var loadInvitationData = function () {
			if (!invitationId.$) {
				var id = invitationId.a;
				return A4(
					$author$project$Api$Graphql$query,
					shared,
					$elm$core$Maybe$Nothing,
					$author$project$Community$inviteQuery(id),
					$author$project$Page$Register$CompletedLoadInvite);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		var initialModel = {fZ: $elm$core$Maybe$Nothing, mP: $elm$core$Maybe$Nothing, e0: false, dO: $elm$core$Maybe$Nothing, kk: invitationId, gI: false, pN: $author$project$Page$Register$Loading, fJ: 0};
		return _Utils_Tuple2(
			initialModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						loadInvitationData,
						A3(
						$author$project$Session$Guest$maybeInitWith,
						$author$project$Page$Register$CompletedLoadCommunity,
						function ($) {
							return $.V;
						},
						guest)
					])));
	});
var $author$project$Page$Settings$NotUpdating = {$: 0};
var $author$project$Page$Settings$GotPinMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$View$Pin$Ignored = {$: 0};
var $author$project$View$Pin$Light = 0;
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$View$Pin$init = function (_v0) {
	var label = _v0.n$;
	var id = _v0.w;
	var withConfirmation = _v0.ql;
	var submitLabel = _v0.pQ;
	var submittingLabel = _v0.pS;
	var pinVisibility = _v0.o9;
	var lastKnownPin = _v0.n2;
	return _Utils_Tuple2(
		{
			f3: 0,
			b_: false,
			hY: $author$project$Form$init(
				{dt: '', o8: ''}),
			w: id,
			e7: pinVisibility,
			cS: pinVisibility,
			cT: false,
			n$: label,
			n2: lastKnownPin,
			ir: withConfirmation,
			bL: _List_Nil,
			pQ: submitLabel,
			pS: submittingLabel
		},
		A2(
			$elm$core$Task$attempt,
			function (_v1) {
				return $author$project$View$Pin$Ignored;
			},
			$elm$browser$Browser$Dom$focus('pin-input')));
};
var $author$project$Page$Settings$initPin = function (loggedIn) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Platform$Cmd$map($author$project$Page$Settings$GotPinMsg),
		$author$project$View$Pin$init(
			{w: 'new-pin-input', n$: 'profile.newPin', n2: loggedIn.ml.ak.n2, o9: loggedIn.A.o9, pQ: 'profile.pin.button', pS: 'profile.pin.button', ql: false}));
};
var $author$project$Page$Settings$init = function (loggedIn) {
	var _v0 = $author$project$Page$Settings$initPin(loggedIn);
	var pinModel = _v0.a;
	var pinCmd = _v0.b;
	return _Utils_Tuple2(
		{cB: $author$project$Page$Settings$NotUpdating, cG: $author$project$Page$Settings$NotUpdating, dQ: false, dT: false, dV: false, c_: pinModel, da: $author$project$Page$Settings$NotUpdating},
		pinCmd);
};
var $author$project$Page$Shop$CompletedLoadBalances = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Shop$CompletedSalesLoad = function (a) {
	return {$: 2, a: a};
};
var $author$project$Eos$TableQuery = F4(
	function (code, scope, table, limit) {
		return {ds: code, kx: limit, ln: scope, lB: table};
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Api$blockchainUrl = F3(
	function (_v0, paths, queryParams) {
		var endpoints = _v0.jN;
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			endpoints.m9,
			A2($elm$core$List$cons, 'v1', paths),
			queryParams);
	});
var $author$project$Api$Balance = F2(
	function (asset, lastActivity) {
		return {mk: asset, n1: lastActivity};
	});
var $author$project$Eos$Asset = F2(
	function (amount, symbol) {
		return {ji: amount, as: symbol};
	});
var $author$project$Eos$assetStringToFloat = function (s) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$String$toFloat,
		$elm$core$List$head(
			A2($elm$core$String$split, ' ', s)));
};
var $author$project$Eos$getSymbolFromAssetString = function (s) {
	var assetArr = A2($elm$core$String$split, ' ', s);
	var precision = A2(
		$elm$core$Maybe$map,
		function (amountArr) {
			if ((amountArr.b && amountArr.b.b) && (!amountArr.b.b.b)) {
				var _v2 = amountArr.b;
				var p = _v2.a;
				return $elm$core$String$length(p);
			} else {
				return 0;
			}
		},
		A2(
			$elm$core$Maybe$map,
			function (amount) {
				return A2($elm$core$String$split, '.', amount);
			},
			$elm$core$List$head(assetArr)));
	var symbol = $elm$core$List$head(
		$elm$core$List$reverse(assetArr));
	var _v0 = _Utils_Tuple2(symbol, precision);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var symbolString = _v0.a.a;
		var p = _v0.b.a;
		return $elm$core$Maybe$Just(
			A2($author$project$Eos$Symbol, symbolString, p));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Eos$decodeAsset = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var value = A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Fail to decode asset amount'),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Eos$assetStringToFloat(s)));
		var symbol = A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Fail to decode asset symbol'),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Eos$getSymbolFromAssetString(s)));
		return A3($elm$json$Json$Decode$map2, $author$project$Eos$Asset, value, symbol);
	},
	$elm$json$Json$Decode$string);
var $author$project$Utils$decodeTimestamp = A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Api$decodeBalance = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'last_activity',
	$author$project$Utils$decodeTimestamp,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'balance',
		$author$project$Eos$decodeAsset,
		$elm$json$Json$Decode$succeed($author$project$Api$Balance)));
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Eos$encodeTableQuery = function (query) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'code',
				$elm$json$Json$Encode$string(query.ds)),
				_Utils_Tuple2(
				'scope',
				$elm$json$Json$Encode$string(query.ln)),
				_Utils_Tuple2(
				'table',
				$elm$json$Json$Encode$string(query.lB)),
				_Utils_Tuple2(
				'limit',
				$elm$json$Json$Encode$int(query.kx)),
				_Utils_Tuple2(
				'json',
				$elm$json$Json$Encode$bool(true))
			]));
};
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.pO));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$post = function (r) {
	return $elm$http$Http$request(
		{f6: r.f6, gt: r.gt, nr: _List_Nil, cd: 'POST', au: $elm$core$Maybe$Nothing, lK: $elm$core$Maybe$Nothing, hn: r.hn});
};
var $author$project$Api$getBalances = F3(
	function (shared, accountName, toMsg) {
		var query = A4(
			$author$project$Eos$TableQuery,
			shared.hL.p5,
			$author$project$Eos$Account$nameToString(accountName),
			'accounts',
			1000);
		return $elm$http$Http$post(
			{
				f6: $elm$http$Http$jsonBody(
					$author$project$Eos$encodeTableQuery(query)),
				gt: A2(
					$elm$http$Http$expectJson,
					toMsg,
					A2(
						$elm$json$Json$Decode$field,
						'rows',
						$elm$json$Json$Decode$list($author$project$Api$decodeBalance))),
				hn: A3(
					$author$project$Api$blockchainUrl,
					shared,
					_List_fromArray(
						['chain', 'get_table_rows']),
					_List_Nil)
			});
	});
var $author$project$Page$Shop$Loading = {$: 0};
var $author$project$Page$Shop$initModel = function (filter) {
	return {
		hx: _List_Nil,
		a2: $author$project$Page$Shop$Loading,
		N: filter,
		eZ: $author$project$Form$init(
			{dn: $pzp1997$assoc_list$AssocList$empty, o1: filter.o1}),
		dU: false
	};
};
var $author$project$Shop$Category$idToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Shop$NoTracking = {$: 0};
var $author$project$Shop$UnitTracking = function (a) {
	return {$: 1, a: a};
};
var $author$project$Cambiatus$Object$Product$categories = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'categories',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Product$communityId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'communityId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Product$creator = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'creator', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$Product$creatorId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'creatorId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Product$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Product$price = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'price', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Shop$Category$Model = function (id) {
	return function (name) {
		return function (slug) {
			return function (description) {
				return function (icon) {
					return function (image) {
						return function (parentId) {
							return function (metaTitle) {
								return function (metaDescription) {
									return function (metaKeywords) {
										return function (position) {
											return {aR: description, p: icon, w: id, h2: image, ii: metaDescription, ij: metaKeywords, ik: metaTitle, fj: name, iE: parentId, bq: position, iP: slug};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Cambiatus$Object$Category$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Category$iconUri = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'iconUri',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Shop$Category$Id = $elm$core$Basics$identity;
var $author$project$Cambiatus$Object$Category$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Shop$Category$idSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Category$id);
var $author$project$Cambiatus$Object$Category$imageUri = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'imageUri',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Category$metaDescription = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'metaDescription',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Category$metaKeywords = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'metaKeywords',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Category$metaTitle = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'metaTitle',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Category$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Category$parent = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'parent',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $hecrj$elm_slug$Slug$Slug = $elm$core$Basics$identity;
var $hecrj$elm_slug$Slug$isAlphanumeric = function (c) {
	return ((c >= '0') && (c <= '9')) || ((c >= 'a') && (c <= 'z'));
};
var $elm$core$String$map = _String_map;
var $hecrj$elm_slug$Slug$simpleQuoteRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\''));
var $elm$core$String$words = _String_words;
var $hecrj$elm_slug$Slug$processWords = function () {
	var mapHelp = function (c) {
		return $hecrj$elm_slug$Slug$isAlphanumeric(c) ? c : ' ';
	};
	return A2(
		$elm$core$Basics$composeR,
		A2(
			$elm$regex$Regex$replace,
			$hecrj$elm_slug$Slug$simpleQuoteRegex,
			function (_v0) {
				return '';
			}),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toLower,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$map(mapHelp),
				$elm$core$String$words)));
}();
var $hecrj$elm_slug$Slug$generate = function (text) {
	var words = $hecrj$elm_slug$Slug$processWords(text);
	return _Utils_eq(
		words,
		_List_fromArray(
			[''])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2($elm$core$String$join, '-', words));
};
var $hecrj$elm_slug$Slug$toString = function (_v0) {
	var s = _v0;
	return s;
};
var $hecrj$elm_slug$Slug$parse = function (slug) {
	var _v0 = $hecrj$elm_slug$Slug$generate(slug);
	if (!_v0.$) {
		var s = _v0.a;
		return _Utils_eq(
			slug,
			$hecrj$elm_slug$Slug$toString(s)) ? $elm$core$Maybe$Just(s) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Cambiatus$Object$Category$position = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'position', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Category$slug = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'slug',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Shop$Category$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Category$position,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$split(','),
						$elm$core$List$map($elm$core$String$trim))),
				$elm$core$Maybe$withDefault(_List_Nil)),
			$author$project$Cambiatus$Object$Category$metaKeywords),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Category$metaDescription,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Category$metaTitle,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Category$parent($author$project$Shop$Category$idSelectionSet),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Category$imageUri,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Category$iconUri,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$Category$description),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
										$elm$core$Maybe$andThen($hecrj$elm_slug$Slug$parse),
										$author$project$Cambiatus$Object$Category$slug),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Cambiatus$Object$Category$name,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Shop$Category$idSelectionSet,
											$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Shop$Category$Model))))))))))));
var $author$project$Cambiatus$Object$Product$trackStock = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'trackStock', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Product$units = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'units',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Shop$productSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Product$categories($author$project$Shop$Category$selectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Product$creator($author$project$Profile$minimalSelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Product$trackStock,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Product$units,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Product$images($author$project$Cambiatus$Object$ProductImage$uri),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Product$communityId),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Product$price,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Product$creatorId),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$Product$description),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Cambiatus$Object$Product$title,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Shop$idSelectionSet,
											$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
												function (id) {
													return function (title) {
														return function (description) {
															return function (creatorId) {
																return function (price) {
																	return function (symbol) {
																		return function (images) {
																			return function (maybeUnits) {
																				return function (trackStock) {
																					return function (creator) {
																						return function (categories) {
																							return {
																								dn: categories,
																								jz: creator,
																								mR: creatorId,
																								aR: description,
																								w: id,
																								h5: A2(
																									$elm$core$List$filter,
																									A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
																									images),
																								iJ: price,
																								iT: function () {
																									if (trackStock) {
																										if (maybeUnits.$ === 1) {
																											return $author$project$Shop$NoTracking;
																										} else {
																											var units = maybeUnits.a;
																											return $author$project$Shop$UnitTracking(
																												{jl: units});
																										}
																									} else {
																										return $author$project$Shop$NoTracking;
																									}
																								}(),
																								as: symbol,
																								fN: title
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												}))))))))))));
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$bool(value));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$list = F2(
	function (toValue, value) {
		return $dillonkearns$elm_graphql$Graphql$Internal$Encode$List(
			A2($elm$core$List$map, toValue, value));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($dillonkearns$elm_graphql$Graphql$Internal$Encode$null));
};
var $author$project$Cambiatus$InputObject$encodeProductsFilterInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'account',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.l8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'categoriesIds',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input.$7,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$maybe($dillonkearns$elm_graphql$Graphql$Internal$Encode$int)))),
				_Utils_Tuple2(
				'inStock',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.dK, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool))
			]));
};
var $author$project$Cambiatus$Query$products = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{hW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'filters', filledInOptionals.hW, $author$project$Cambiatus$InputObject$encodeProductsFilterInput)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'products',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Shop$productsQuery = function (_v0) {
	var user = _v0.qg;
	var categories = _v0.dn;
	return A2(
		$author$project$Cambiatus$Query$products,
		function (_v1) {
			return {
				hW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					{
						l8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
							A2($elm$core$Maybe$map, $author$project$Eos$Account$nameToString, user)),
						$7: $elm$core$List$isEmpty(categories) ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							A2(
								$elm$core$List$map,
								A2($elm$core$Basics$composeR, $author$project$Shop$Category$idToInt, $elm$core$Maybe$Just),
								categories)),
						dK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
					})
			};
		},
		$author$project$Shop$productSelectionSet);
};
var $author$project$Page$Shop$init = F2(
	function (loggedIn, filter) {
		return A2(
			$author$project$UpdateResult$addExt,
			$author$project$Session$LoggedIn$RequestedCommunityField(5),
			A2(
				$author$project$UpdateResult$addExt,
				A3(
					$author$project$Session$LoggedIn$query,
					loggedIn,
					$author$project$Shop$productsQuery(
						{dn: filter.dn, qg: filter.o1}),
					$author$project$Page$Shop$CompletedSalesLoad),
				A2(
					$author$project$UpdateResult$addCmd,
					A3($author$project$Api$getBalances, loggedIn.A, loggedIn._, $author$project$Page$Shop$CompletedLoadBalances),
					$author$project$UpdateResult$init(
						$author$project$Page$Shop$initModel(filter)))));
	});
var $author$project$Page$Shop$Viewer$AsGuest = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Shop$Viewer$AsGuestMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Shop$Viewer$AsLoggedIn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Viewer$AsLoggedInMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Shop$Viewer$Closed = 0;
var $author$project$Page$Shop$Viewer$CompletedLoadBalances = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Shop$Viewer$CompletedSaleLoad = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Viewer$CompletedSalePreviewLoad = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$LoggedInExternal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Log$map = F2(
	function (transform, event) {
		return {
			mL: event.mL,
			n4: event.n4,
			oa: event.oa,
			of: event.of,
			pY: event.pY,
			p7: transform(event.p7),
			qh: event.qh
		};
	});
var $author$project$Ports$mapAddress = F2(
	function (transform, _v0) {
		var js = _v0;
		return {
			bZ: js.bZ,
			fy: transform(js.fy),
			fz: js.fz
		};
	});
var $author$project$Log$mapBreadcrumb = F2(
	function (transform, breadcrumb) {
		return {
			f7: transform(breadcrumb.f7),
			bZ: breadcrumb.bZ,
			n4: breadcrumb.n4,
			of: breadcrumb.of,
			eq: breadcrumb.eq
		};
	});
var $author$project$UpdateResult$map = F4(
	function (toModel, toMsg, handleExtMsg, updateResult) {
		return A3(
			$elm$core$List$foldl,
			handleExtMsg,
			{
				af: A2(
					$elm$core$List$map,
					$author$project$Log$mapBreadcrumb(toMsg),
					updateResult.af),
				ju: _List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						toMsg,
						$elm$core$Platform$Cmd$batch(updateResult.ju))
					]),
				jQ: A2(
					$elm$core$List$map,
					$author$project$Log$map(toMsg),
					updateResult.jQ),
				jS: _List_Nil,
				ok: toModel(updateResult.ok),
				k0: A2(
					$elm$core$List$map,
					$author$project$Ports$mapAddress(toMsg),
					updateResult.k0)
			},
			updateResult.jS);
	});
var $author$project$Cambiatus$Query$productPreview = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'productPreview',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object_,
			$elm$core$Basics$identity);
	});
var $author$project$Cambiatus$Object$ProductPreview$communityId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'communityId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$ProductPreview$creatorId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'creatorId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$ProductPreview$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$ProductPreview$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$ProductPreview$images = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'images',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$ProductPreview$price = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'price', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Shop$productPreviewProfile = function (accountName) {
	return {
		l8: accountName,
		dl: $author$project$Avatar$empty,
		dm: $elm$core$Maybe$Nothing,
		az: _List_Nil,
		jK: $elm$core$Maybe$Nothing,
		fj: $elm$core$Maybe$Just(
			$author$project$Eos$Account$nameToString(accountName))
	};
};
var $author$project$Cambiatus$Object$ProductPreview$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Shop$productPreviewSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$ProductPreview$title,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$ProductPreview$price,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$ProductPreview$images($author$project$Cambiatus$Object$ProductImage$uri),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$ProductPreview$id),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$ProductPreview$description),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
							$author$project$Shop$productPreviewProfile,
							$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$ProductPreview$creatorId)),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$ProductPreview$communityId),
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
								F7(
									function (communityId, creator, description, id, images, price, title) {
										return {
											jz: creator,
											aR: description,
											w: id,
											h5: A2(
												$elm$core$List$filter,
												A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
												images),
											iJ: price,
											as: communityId,
											fN: title
										};
									})))))))));
var $author$project$Shop$productPreviewQuery = function (_v0) {
	var productId = _v0;
	return A2(
		$author$project$Cambiatus$Query$productPreview,
		{w: productId},
		$author$project$Shop$productPreviewSelectionSet);
};
var $author$project$Cambiatus$Query$product = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'product',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Shop$productQuery = function (_v0) {
	var saleId = _v0;
	return A2(
		$author$project$Cambiatus$Query$product,
		{w: saleId},
		$author$project$Shop$productSelectionSet);
};
var $author$project$Page$Shop$Viewer$init = F2(
	function (session, saleId) {
		if (session.$ === 1) {
			var loggedIn = session.a;
			var shared = loggedIn.A;
			var accountName = loggedIn._;
			var model = {
				cE: $elm$core$Maybe$Nothing,
				cQ: false,
				c0: $elm$core$Maybe$Nothing,
				pN: $author$project$Page$Shop$Viewer$AsLoggedIn(
					{
						hx: _List_Nil,
						a5: 0,
						hY: $author$project$Form$init(
							{
								kE: A2($author$project$Form$RichText$initModel, 'memo-input', $elm$core$Maybe$Nothing),
								i8: '1'
							}),
						j1: false,
						e6: false,
						dR: false,
						pN: $krisajenkins$remotedata$RemoteData$Loading
					})
			};
			return A4(
				$author$project$UpdateResult$map,
				$elm$core$Basics$identity,
				$elm$core$Basics$identity,
				A2($elm$core$Basics$composeR, $author$project$Page$LoggedInExternal, $author$project$UpdateResult$addExt),
				A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$RequestedCommunityField(5),
					A2(
						$author$project$UpdateResult$addCmd,
						A3(
							$author$project$Api$getBalances,
							shared,
							accountName,
							A2($elm$core$Basics$composeR, $author$project$Page$Shop$Viewer$CompletedLoadBalances, $author$project$Page$Shop$Viewer$AsLoggedInMsg)),
						A2(
							$author$project$UpdateResult$addExt,
							A3(
								$author$project$Session$LoggedIn$query,
								loggedIn,
								$author$project$Shop$productQuery(saleId),
								A2($elm$core$Basics$composeR, $author$project$Page$Shop$Viewer$CompletedSaleLoad, $author$project$Page$Shop$Viewer$AsLoggedInMsg)),
							$author$project$UpdateResult$init(model)))));
		} else {
			var guest = session.a;
			return A2(
				$author$project$UpdateResult$addCmd,
				A4(
					$author$project$Api$Graphql$query,
					guest.A,
					$elm$core$Maybe$Nothing,
					$author$project$Shop$productPreviewQuery(saleId),
					A2($elm$core$Basics$composeR, $author$project$Page$Shop$Viewer$CompletedSalePreviewLoad, $author$project$Page$Shop$Viewer$AsGuestMsg)),
				$author$project$UpdateResult$init(
					{
						cE: $elm$core$Maybe$Nothing,
						cQ: false,
						c0: $elm$core$Maybe$Nothing,
						pN: $author$project$Page$Shop$Viewer$AsGuest(
							{
								hY: $author$project$Form$init(
									{
										kE: A2($author$project$Form$RichText$initModel, 'memo-input', $elm$core$Maybe$Nothing),
										i8: '1'
									}),
								ec: $krisajenkins$remotedata$RemoteData$Loading,
								lk: saleId
							})
					}));
		}
	});
var $author$project$Page$ViewTransfer$CompletedTransferLoad = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$ViewTransfer$Loading = {$: 0};
var $author$project$Cambiatus$Query$transfer = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'transfer',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Transfer$CreatedTx = $elm$core$Basics$identity;
var $author$project$Transfer$Transfer = F9(
	function (id, to, from, value, memo, communityId, community, blockTime, createdTx) {
		return {f5: blockTime, V: community, gd: communityId, mQ: createdTx, e_: from, w: id, kE: memo, fO: to, lW: value};
	});
var $author$project$Transfer$Cmm = F2(
	function (symbol, subdomain) {
		return {pP: subdomain, as: symbol};
	});
var $author$project$Transfer$communitySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$withDefault(''),
		$author$project$Cambiatus$Object$Community$subdomain($author$project$Cambiatus$Object$Subdomain$name)),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Community$symbol),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Transfer$Cmm)));
var $author$project$Cambiatus$Object$Transfer$createdAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'createdAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).mz.jE);
var $author$project$Cambiatus$Object$Transfer$createdTx = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'createdTx', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Transfer$from = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'from', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$Transfer$to = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'to', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Transfer$transferItemSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Transfer$createdTx),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Transfer$createdAt,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Transfer$community($author$project$Transfer$communitySelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Transfer$community($author$project$Cambiatus$Object$Community$name),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$Transfer$memo),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Transfer$amount,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Transfer$from($author$project$Profile$selectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$Transfer$to($author$project$Profile$selectionSet),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Cambiatus$Object$Transfer$id,
									$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Transfer$Transfer))))))))));
var $author$project$Transfer$transferQuery = function (tID) {
	var args = {w: tID};
	return A2($author$project$Cambiatus$Query$transfer, args, $author$project$Transfer$transferItemSelectionSet);
};
var $author$project$Page$ViewTransfer$init = F2(
	function (loggedIn, transferId) {
		var model = {pN: $author$project$Page$ViewTransfer$Loading, lM: transferId};
		return A2(
			$author$project$UpdateResult$addExt,
			A3(
				$author$project$Session$LoggedIn$query,
				loggedIn,
				$author$project$Transfer$transferQuery(transferId),
				$author$project$Page$ViewTransfer$CompletedTransferLoad),
			$author$project$UpdateResult$init(model));
	});
var $author$project$Page$Shop$Editor$EditingCreate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Shop$Editor$MainInformation = {$: 0};
var $author$project$Page$Shop$Editor$initFormData = {
	dn: $author$project$Form$init($pzp1997$assoc_list$AssocList$empty),
	C: $author$project$Page$Shop$Editor$MainInformation,
	h5: $author$project$Form$init(
		$author$project$Form$File$initMultiple(
			{mj: $elm$core$Maybe$Nothing, nj: _List_Nil})),
	bF: $author$project$Form$init(
		{
			aR: A2($author$project$Form$RichText$initModel, 'product-description-editor', $elm$core$Maybe$Nothing),
			fN: ''
		}),
	cg: $author$project$Form$init(
		{iJ: '0', eo: false, db: '0'})
};
var $author$project$Page$Shop$Editor$initCreate = function (_v0) {
	return A2(
		$author$project$UpdateResult$addExt,
		$author$project$Session$LoggedIn$RequestedReloadCommunityField(5),
		$author$project$UpdateResult$init(
			{
				dW: false,
				pN: $author$project$Page$Shop$Editor$EditingCreate($author$project$Page$Shop$Editor$initFormData)
			}));
};
var $author$project$Page$Community$Settings$ObjectiveEditor$CompletedLoadCommunity = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Community$Settings$ObjectiveEditor$Loading = {$: 0};
var $author$project$Page$Community$Settings$ObjectiveEditor$initEdit = F2(
	function (loggedIn, objectiveId) {
		return _Utils_Tuple2(
			{
				kP: $elm$core$Maybe$Just(objectiveId),
				pN: $author$project$Page$Community$Settings$ObjectiveEditor$Loading
			},
			A3(
				$author$project$Session$LoggedIn$maybeInitWith,
				$author$project$Page$Community$Settings$ObjectiveEditor$CompletedLoadCommunity,
				function ($) {
					return $.pC;
				},
				loggedIn));
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$initNew = function (loggedIn) {
	return _Utils_Tuple2(
		{kP: $elm$core$Maybe$Nothing, pN: $author$project$Page$Community$Settings$ObjectiveEditor$Loading},
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Community$Settings$ObjectiveEditor$CompletedLoadCommunity,
			function ($) {
				return $.pC;
			},
			loggedIn));
};
var $author$project$Page$Shop$Editor$CompletedLoadCommunity = {$: 1};
var $author$project$Page$Shop$Editor$LoadingSaleUpdate = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$initUpdate = F3(
	function (productId, step, loggedIn) {
		return A2(
			$author$project$UpdateResult$addExt,
			$author$project$Session$LoggedIn$RequestedReloadCommunityField(5),
			A2(
				$author$project$UpdateResult$addCmd,
				A3(
					$author$project$Session$LoggedIn$maybeInitWith,
					function (_v0) {
						return $author$project$Page$Shop$Editor$CompletedLoadCommunity;
					},
					function ($) {
						return $.pC;
					},
					loggedIn),
				$author$project$UpdateResult$init(
					{
						dW: false,
						pN: A2($author$project$Page$Shop$Editor$LoadingSaleUpdate, productId, step)
					})));
	});
var $author$project$Page$GotGuestMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$Login = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Session$Guest$CompletedLoadCommunityPreview = function (a) {
	return {$: 5, a: a};
};
var $author$project$Eos$cambiatusSymbol = A2($author$project$Eos$Symbol, 'CMB', 0);
var $author$project$Cambiatus$Query$communityPreview = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{pP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, as: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'subdomain', filledInOptionals.pP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'symbol', filledInOptionals.as, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'communityPreview',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Community$communityPreviewQuery = function (subdomain) {
	return A2(
		$author$project$Cambiatus$Query$communityPreview,
		function (optionals) {
			return _Utils_update(
				optionals,
				{
					pP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(subdomain)
				});
		},
		$author$project$Community$communityPreviewSelectionSet);
};
var $author$project$Eos$symbolToString = function (_v0) {
	var symbol = _v0.a;
	var precision = _v0.b;
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$elm$core$String$fromInt(precision),
				',',
				symbol
			]));
};
var $author$project$Community$communityPreviewSymbolQuery = function (symbol) {
	return A2(
		$author$project$Cambiatus$Query$communityPreview,
		function (optionals) {
			return _Utils_update(
				optionals,
				{
					as: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Eos$symbolToString(symbol))
				});
		},
		$author$project$Community$communityPreviewSelectionSet);
};
var $author$project$Session$Guest$fetchCommunity = function (shared) {
	if (shared.qf) {
		return A4(
			$author$project$Api$Graphql$query,
			shared,
			$elm$core$Maybe$Nothing,
			$author$project$Community$communityPreviewQuery(
				$author$project$Environment$communityDomain(shared.hn)),
			$author$project$Session$Guest$CompletedLoadCommunityPreview);
	} else {
		var symbol = A2($elm$core$Maybe$withDefault, $author$project$Eos$cambiatusSymbol, shared.pC);
		return A4(
			$author$project$Api$Graphql$query,
			shared,
			$elm$core$Maybe$Nothing,
			$author$project$Community$communityPreviewSymbolQuery(symbol),
			$author$project$Session$Guest$CompletedLoadCommunityPreview);
	}
};
var $author$project$View$Feedback$Hidden = {$: 0};
var $author$project$Session$Guest$initModel = function (shared) {
	return {me: $elm$core$Maybe$Nothing, V: $krisajenkins$remotedata$RemoteData$Loading, hU: $author$project$View$Feedback$Hidden, kC: $elm$core$Maybe$Nothing, A: shared, bt: false};
};
var $author$project$Session$Guest$init = function (shared) {
	return _Utils_Tuple2(
		$author$project$Session$Guest$initModel(shared),
		$author$project$Session$Guest$fetchCommunity(shared));
};
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Route$boolToString = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Shop$idToString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Shop$Category$idToString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Route$queryBuilder = F3(
	function (fn, maybeRedirect, queryParam) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			$elm$core$List$singleton(
				A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string(queryParam),
					A2($elm$core$Maybe$map, fn, maybeRedirect))));
	});
var $author$project$Route$saleStepToString = function (step) {
	switch (step) {
		case 0:
			return 'mainInformation';
		case 1:
			return 'images';
		case 2:
			return 'categories';
		default:
			return 'priceAndInventory';
	}
};
var $author$project$Route$routeToString = function (route) {
	var _v0 = function () {
		switch (route.$) {
			case 0:
				return _Utils_Tuple2(_List_Nil, _List_Nil);
			case 1:
				return _Utils_Tuple2(
					_List_fromArray(
						['coming-soon']),
					_List_Nil);
			case 2:
				if (route.a.$ === 1) {
					var _v2 = route.a;
					var maybeRedirect = route.b;
					return _Utils_Tuple2(
						_List_fromArray(
							['register']),
						A3($author$project$Route$queryBuilder, $author$project$Route$routeToString, maybeRedirect, 'redirect'));
				} else {
					var invitation = route.a.a;
					var maybeRedirect = route.b;
					return _Utils_Tuple2(
						_List_fromArray(
							['register', invitation]),
						A3($author$project$Route$queryBuilder, $author$project$Route$routeToString, maybeRedirect, 'redirect'));
				}
			case 3:
				if (route.a.$ === 1) {
					var _v3 = route.a;
					var maybeRedirect = route.b;
					return _Utils_Tuple2(
						_List_fromArray(
							['login']),
						A3($author$project$Route$queryBuilder, $author$project$Route$routeToString, maybeRedirect, 'redirect'));
				} else {
					var invitation = route.a.a;
					var maybeRedirect = route.b;
					return _Utils_Tuple2(
						_List_fromArray(
							['login', invitation]),
						A3($author$project$Route$queryBuilder, $author$project$Route$routeToString, maybeRedirect, 'redirect'));
				}
			case 4:
				return _Utils_Tuple2(
					_List_fromArray(
						['logout']),
					_List_Nil);
			case 5:
				return _Utils_Tuple2(
					_List_fromArray(
						['notification']),
					_List_Nil);
			case 6:
				return _Utils_Tuple2(
					_List_fromArray(
						['profile', 'edit']),
					_List_Nil);
			case 7:
				return _Utils_Tuple2(
					_List_fromArray(
						['profile', 'add-kyc']),
					_List_Nil);
			case 8:
				var account = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['profile', account, 'claims']),
					_List_Nil);
			case 9:
				return _Utils_Tuple2(
					_List_fromArray(
						['profile', 'add-contact']),
					_List_Nil);
			case 10:
				var accountName = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'payments',
							$author$project$Eos$Account$nameToString(accountName)
						]),
					_List_Nil);
			case 11:
				var accountName = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'profile',
							$author$project$Eos$Account$nameToString(accountName)
						]),
					_List_Nil);
			case 12:
				var accountName = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'profile',
							$author$project$Eos$Account$nameToString(accountName),
							'contributions'
						]),
					_List_Nil);
			case 13:
				return _Utils_Tuple2(
					_List_fromArray(
						['dashboard']),
					_List_Nil);
			case 14:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'about']),
					_List_Nil);
			case 15:
				var selectedObjective = route.a;
				var params = function () {
					if (selectedObjective.$ === 1) {
						return _List_Nil;
					} else {
						var id = selectedObjective.a.w;
						var action = selectedObjective.a.dh;
						if (action.$ === 1) {
							return _List_fromArray(
								[
									$elm$core$String$fromInt(id)
								]);
						} else {
							var actionId = action.a;
							return _List_fromArray(
								[
									$elm$core$String$fromInt(id),
									'action',
									$elm$core$String$fromInt(actionId)
								]);
						}
					}
				}();
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						'community',
						A2($elm$core$List$cons, 'objectives', params)),
					_List_Nil);
			case 18:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings']),
					_List_Nil);
			case 19:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'features']),
					_List_Nil);
			case 20:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'info']),
					_List_Nil);
			case 21:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'news']),
					_List_Nil);
			case 22:
				switch (route.a.$) {
					case 0:
						var _v6 = route.a;
						return _Utils_Tuple2(
							_List_fromArray(
								['community', 'settings', 'news', 'new']),
							_List_Nil);
					case 1:
						var newsId = route.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[
									'community',
									'settings',
									'news',
									'edit',
									$elm$core$String$fromInt(newsId)
								]),
							_List_Nil);
					default:
						var newsId = route.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[
									'community',
									'settings',
									'news',
									'copy',
									$elm$core$String$fromInt(newsId)
								]),
							_List_Nil);
				}
			case 23:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'currency']),
					_List_Nil);
			case 24:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'sponsorship']),
					_List_Nil);
			case 25:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'sponsorship', 'fiat']),
					_List_Nil);
			case 26:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'sponsorship', 'thank-you']),
					_List_Nil);
			case 34:
				var maybeRedirect = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'selector']),
					A3($author$project$Route$queryBuilder, $author$project$Route$routeToString, maybeRedirect, 'redirect'));
			case 35:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'thank-you']),
					_List_Nil);
			case 36:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'sponsor']),
					_List_Nil);
			case 37:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'supporters']),
					_List_Nil);
			case 16:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'new']),
					_List_Nil);
			case 17:
				var selectedNews = route.a.pD;
				var showOthers = route.a.pJ;
				if (selectedNews.$ === 1) {
					return _Utils_Tuple2(
						_List_fromArray(
							['news']),
						_List_Nil);
				} else {
					var newsId = selectedNews.a;
					return _Utils_Tuple2(
						_List_fromArray(
							[
								'news',
								$elm$core$String$fromInt(newsId)
							]),
						showOthers ? _List_Nil : A3(
							$author$project$Route$queryBuilder,
							$author$project$Route$boolToString,
							$elm$core$Maybe$Just(showOthers),
							'showOthers'));
				}
			case 27:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'objectives']),
					_List_Nil);
			case 28:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'objectives', 'new']),
					_List_Nil);
			case 29:
				var objectiveId = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'community',
							'settings',
							'objectives',
							$elm$core$String$fromInt(objectiveId),
							'edit'
						]),
					_List_Nil);
			case 30:
				var objectiveId = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'community',
							'settings',
							'objectives',
							$elm$core$String$fromInt(objectiveId),
							'action',
							'new'
						]),
					_List_Nil);
			case 31:
				var objectiveId = route.a;
				var actionId = route.b;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'community',
							'settings',
							'objectives',
							$elm$core$String$fromInt(objectiveId),
							'action',
							$elm$core$String$fromInt(actionId),
							'edit'
						]),
					_List_Nil);
			case 32:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'contacts']),
					_List_Nil);
			case 33:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'shop', 'categories']),
					_List_Nil);
			case 38:
				var objectiveId = route.a;
				var actionId = route.b;
				var claimId = route.c;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'objectives',
							$elm$core$String$fromInt(objectiveId),
							'action',
							$elm$core$String$fromInt(actionId),
							'claim',
							$elm$core$String$fromInt(claimId)
						]),
					_List_Nil);
			case 39:
				return _Utils_Tuple2(
					_List_fromArray(
						['settings']),
					_List_Nil);
			case 40:
				var owner = route.a.o1;
				var categories = route.a.dn;
				return _Utils_Tuple2(
					_List_fromArray(
						['shop']),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Eos$Account$nameToString,
									$elm$url$Url$Builder$string('from')),
								owner),
								$elm$core$List$isEmpty(categories) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								A2(
									$elm$url$Url$Builder$string,
									'categories',
									A2(
										$elm$core$String$join,
										',',
										A2($elm$core$List$map, $author$project$Shop$Category$idToString, categories))))
							])));
			case 41:
				var saleStep = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['shop', 'new', 'sell']),
					A3(
						$author$project$Route$queryBuilder,
						$author$project$Route$saleStepToString,
						$elm$core$Maybe$Just(saleStep),
						'step'));
			case 42:
				var saleId = route.a;
				var saleStep = route.b;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'shop',
							$author$project$Shop$idToString(saleId),
							'edit'
						]),
					A3(
						$author$project$Route$queryBuilder,
						$author$project$Route$saleStepToString,
						$elm$core$Maybe$Just(saleStep),
						'step'));
			case 43:
				var saleId = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'shop',
							$author$project$Shop$idToString(saleId)
						]),
					_List_Nil);
			case 44:
				var transferId = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'transfer',
							$elm$core$String$fromInt(transferId)
						]),
					_List_Nil);
			case 45:
				var invitationId = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['invite', invitationId]),
					_List_Nil);
			case 46:
				var maybeRedirect = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['join']),
					A3($author$project$Route$queryBuilder, $author$project$Route$routeToString, maybeRedirect, 'redirect'));
			case 47:
				var maybeTo = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'transfer']),
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'to',
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Eos$Account$nameToString, maybeTo)))
						]));
			default:
				return _Utils_Tuple2(
					_List_fromArray(
						['dashboard', 'analysis']),
					_List_Nil);
		}
	}();
	var paths = _v0.a;
	var queries = _v0.b;
	return A2($elm$url$Url$Builder$absolute, paths, queries);
};
var $author$project$Route$replaceUrl = F2(
	function (key, route) {
		return A2(
			$elm$browser$Browser$Navigation$replaceUrl,
			key,
			$author$project$Route$routeToString(route));
	});
var $author$project$Page$logout = function (_v0) {
	var shared = _v0.A;
	var _v1 = $author$project$Session$Guest$init(shared);
	var guest = _v1.a;
	var guestCmd = _v1.b;
	return _Utils_Tuple2(
		$author$project$Page$Guest(
			_Utils_update(
				guest,
				{
					A: _Utils_update(
						shared,
						{kA: $elm$core$Maybe$Nothing})
				})),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$author$project$Route$replaceUrl,
					shared.kK,
					A2($author$project$Route$Login, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
					A2($elm$core$Platform$Cmd$map, $author$project$Page$GotGuestMsg, guestCmd)
				])));
};
var $author$project$Page$Shop$Editor$Categories = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$CategoriesImageTarget = 0;
var $author$project$Page$Shop$Editor$CategoriesMainInformationTarget = 1;
var $author$project$Page$Shop$Editor$CategoriesMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Shop$Editor$GotFormMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Shop$Editor$Images = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Editor$ImagesMainInformationTarget = 0;
var $author$project$Page$Shop$Editor$ImagesMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Editor$MainInformationMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Shop$Editor$PriceAndInventoryImageTarget = 1;
var $author$project$Page$Shop$Editor$PriceAndInventoryMainInformationTarget = 2;
var $author$project$Page$Shop$Editor$SubmittedCategories = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Shop$Editor$SubmittedImages = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$SubmittedMainInformation = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$UpdateResult$addMsg = F2(
	function (msg, uResult) {
		return _Utils_update(
			uResult,
			{
				ju: _Utils_ap(
					uResult.ju,
					_List_fromArray(
						[
							A2(
							$elm$core$Task$perform,
							function (_v0) {
								return msg;
							},
							$elm$core$Task$succeed(0))
						]))
			});
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $author$project$Form$Arbitrary = function (a) {
	return {$: 10, a: a};
};
var $author$project$Form$Form = $elm$core$Basics$identity;
var $author$project$OptionalResult$OptNothing = {$: 2};
var $author$project$Form$ValidateOnBlur = 0;
var $author$project$Form$arbitrary = function (html) {
	return function (_v0) {
		return {
			e: _List_fromArray(
				[
					{
					na: $elm$core$Maybe$Nothing,
					nV: false,
					Z: $author$project$Form$Arbitrary(html),
					ax: 0
				}
				]),
			g: $author$project$OptionalResult$OptNothing
		};
	};
};
var $author$project$Form$Checkbox = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$OptionalResult$OptErr = function (a) {
	return {$: 0, a: a};
};
var $author$project$OptionalResult$OptOk = function (a) {
	return {$: 1, a: a};
};
var $author$project$OptionalResult$fromResult = function (result) {
	if (!result.$) {
		var success = result.a;
		return $author$project$OptionalResult$OptOk(success);
	} else {
		var error = result.a;
		return $author$project$OptionalResult$OptErr(error);
	}
};
var $author$project$Form$Checkbox$getId = function (_v0) {
	var options = _v0;
	return options.w;
};
var $author$project$Form$DatePicker$getId = function (_v0) {
	var options = _v0;
	return options.w;
};
var $author$project$Form$File$getId = function (_v0) {
	var options = _v0;
	return options.w;
};
var $author$project$Form$Radio$getId = function (_v0) {
	var options = _v0;
	return options.w;
};
var $author$project$Form$RichText$getId = function (_v0) {
	var model = _v0;
	return model.w;
};
var $author$project$Form$Select$getId = function (_v0) {
	var options = _v0;
	return options.w;
};
var $author$project$Form$Text$getId = function (_v0) {
	var options = _v0;
	return options.w;
};
var $author$project$Form$Toggle$getId = function (_v0) {
	var options = _v0;
	return options.w;
};
var $author$project$Form$UserPicker$getId = function (_v0) {
	var model = _v0;
	return model.w;
};
var $author$project$Form$getId = function (state) {
	switch (state.$) {
		case 0:
			var options = state.a;
			return $author$project$Form$Text$getId(options);
		case 1:
			var baseField = state.b;
			return $author$project$Form$RichText$getId(baseField.lW);
		case 2:
			var options = state.a;
			return $author$project$Form$Toggle$getId(options);
		case 3:
			var options = state.a;
			return $author$project$Form$Checkbox$getId(options);
		case 4:
			var options = state.a;
			return $author$project$Form$Radio$getId(options);
		case 5:
			var options = state.a;
			return $author$project$Form$File$getId(options);
		case 6:
			var options = state.a;
			return $author$project$Form$Select$getId(options);
		case 7:
			var options = state.a;
			return $author$project$Form$DatePicker$getId(options);
		case 8:
			var baseField = state.b;
			return $author$project$Form$UserPicker$getId(baseField.lW);
		case 9:
			var fields = state.b;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Z;
						},
						$author$project$Form$getId),
					$elm$core$List$head(fields)));
		case 10:
			return '';
		default:
			return '';
	}
};
var $author$project$OptionalResult$mapError = F2(
	function (fn, optionalResult) {
		switch (optionalResult.$) {
			case 0:
				var error = optionalResult.a;
				return $author$project$OptionalResult$OptErr(
					fn(error));
			case 1:
				var success = optionalResult.a;
				return $author$project$OptionalResult$OptOk(success);
			default:
				return $author$project$OptionalResult$OptNothing;
		}
	});
var $author$project$Form$field = F2(
	function (build, config) {
		var parse_ = function (values) {
			return $author$project$OptionalResult$fromResult(
				A2(
					$elm$core$Result$andThen,
					function (output) {
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Result$Ok(output),
							A2(
								$elm$core$Maybe$map,
								function (error) {
									return $elm$core$Result$Err(error);
								},
								config.ne(values)));
					},
					config.o3(
						config.lW(values))));
		};
		var field_ = function (values) {
			return build(
				{
					be: config.lW,
					qd: function (newValue) {
						return A2(config.qd, newValue, values);
					},
					bv: config.qd,
					lW: config.lW(values)
				});
		};
		return function (values) {
			var result = parse_(values);
			return {
				e: _List_fromArray(
					[
						{
						na: function () {
							switch (result.$) {
								case 0:
									var err = result.a;
									return $elm$core$Maybe$Just(err);
								case 1:
									return $elm$core$Maybe$Nothing;
								default:
									return $elm$core$Maybe$Nothing;
							}
						}(),
						nV: true,
						Z: field_(values),
						ax: 0
					}
					]),
				g: A2(
					$author$project$OptionalResult$mapError,
					function (_v1) {
						return _Utils_Tuple2(
							$author$project$Form$getId(
								field_(values)),
							_List_Nil);
					},
					result)
			};
		};
	});
var $author$project$Form$checkbox = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			$author$project$Form$Checkbox(options),
			config);
	});
var $zwilias$elm_rosetree$Tree$children = function (_v0) {
	var c = _v0.b;
	return c;
};
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $zwilias$elm_rosetree$Tree$label = function (_v0) {
	var v = _v0.a;
	return v;
};
var $zwilias$elm_rosetree$Tree$Zipper$tree = function (_v0) {
	var focus = _v0.v;
	return focus;
};
var $zwilias$elm_rosetree$Tree$Zipper$label = function (zipper) {
	return $zwilias$elm_rosetree$Tree$label(
		$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
};
var $zwilias$elm_rosetree$Tree$Zipper$find = F3(
	function (predicate, move, zipper) {
		find:
		while (true) {
			var _v0 = move(zipper);
			if (!_v0.$) {
				var next = _v0.a;
				if (predicate(
					$zwilias$elm_rosetree$Tree$Zipper$label(next))) {
					return $elm$core$Maybe$Just(next);
				} else {
					var $temp$predicate = predicate,
						$temp$move = move,
						$temp$zipper = next;
					predicate = $temp$predicate;
					move = $temp$move;
					zipper = $temp$zipper;
					continue find;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $zwilias$elm_rosetree$Tree$Zipper$Zipper = $elm$core$Basics$identity;
var $zwilias$elm_rosetree$Tree$Zipper$firstChild = function (_v0) {
	var zipper = _v0;
	var _v1 = $zwilias$elm_rosetree$Tree$children(zipper.v);
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var c = _v1.a;
		var cs = _v1.b;
		return $elm$core$Maybe$Just(
			{
				hu: cs,
				hy: _List_Nil,
				W: A2(
					$elm$core$List$cons,
					{
						hu: zipper.hu,
						hy: zipper.hy,
						n$: $zwilias$elm_rosetree$Tree$label(zipper.v)
					},
					zipper.W),
				v: c
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$firstOf = F2(
	function (options, v) {
		firstOf:
		while (true) {
			if (!options.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var option = options.a;
				var rest = options.b;
				var _v1 = option(v);
				if (!_v1.$) {
					var r = _v1.a;
					return $elm$core$Maybe$Just(r);
				} else {
					var $temp$options = rest,
						$temp$v = v;
					options = $temp$options;
					v = $temp$v;
					continue firstOf;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$Zipper$nextSibling = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.hu;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var next = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				hu: rest,
				hy: A2($elm$core$List$cons, zipper.v, zipper.hy),
				W: zipper.W,
				v: next
			});
	}
};
var $zwilias$elm_rosetree$Tree$Tree = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $zwilias$elm_rosetree$Tree$tree = $zwilias$elm_rosetree$Tree$Tree;
var $zwilias$elm_rosetree$Tree$Zipper$reconstruct = F4(
	function (focus, before, after, l) {
		return A2(
			$zwilias$elm_rosetree$Tree$tree,
			l,
			_Utils_ap(
				$elm$core$List$reverse(before),
				_Utils_ap(
					_List_fromArray(
						[focus]),
					after)));
	});
var $zwilias$elm_rosetree$Tree$Zipper$parent = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.W;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var crumb = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				hu: crumb.hu,
				hy: crumb.hy,
				W: rest,
				v: A4($zwilias$elm_rosetree$Tree$Zipper$reconstruct, zipper.v, zipper.hy, zipper.hu, crumb.n$)
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$nextSiblingOfAncestor = function (zipper) {
	nextSiblingOfAncestor:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var parent_ = _v0.a;
			var _v1 = $zwilias$elm_rosetree$Tree$Zipper$nextSibling(parent_);
			if (_v1.$ === 1) {
				var $temp$zipper = parent_;
				zipper = $temp$zipper;
				continue nextSiblingOfAncestor;
			} else {
				var s = _v1.a;
				return $elm$core$Maybe$Just(s);
			}
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$forward = function (zipper) {
	return A2(
		$zwilias$elm_rosetree$Tree$Zipper$firstOf,
		_List_fromArray(
			[$zwilias$elm_rosetree$Tree$Zipper$firstChild, $zwilias$elm_rosetree$Tree$Zipper$nextSibling, $zwilias$elm_rosetree$Tree$Zipper$nextSiblingOfAncestor]),
		zipper);
};
var $zwilias$elm_rosetree$Tree$Zipper$findNext = F2(
	function (f, zipper) {
		return A3($zwilias$elm_rosetree$Tree$Zipper$find, f, $zwilias$elm_rosetree$Tree$Zipper$forward, zipper);
	});
var $zwilias$elm_rosetree$Tree$Zipper$previousSibling = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.hy;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var previous = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				hu: A2($elm$core$List$cons, zipper.v, zipper.hu),
				hy: rest,
				W: zipper.W,
				v: previous
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$firstSibling = function (zipper) {
	firstSibling:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$previousSibling(zipper);
		if (_v0.$ === 1) {
			return zipper;
		} else {
			var z = _v0.a;
			var $temp$zipper = z;
			zipper = $temp$zipper;
			continue firstSibling;
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$root = function (zipper) {
	root:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
		if (_v0.$ === 1) {
			return $zwilias$elm_rosetree$Tree$Zipper$firstSibling(zipper);
		} else {
			var z = _v0.a;
			var $temp$zipper = z;
			zipper = $temp$zipper;
			continue root;
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$findFromRoot = F2(
	function (f, zipper) {
		var r = $zwilias$elm_rosetree$Tree$Zipper$root(zipper);
		return f(
			$zwilias$elm_rosetree$Tree$Zipper$label(r)) ? $elm$core$Maybe$Just(r) : A2($zwilias$elm_rosetree$Tree$Zipper$findNext, f, r);
	});
var $zwilias$elm_rosetree$Tree$Zipper$fromForest = F2(
	function (t, ts) {
		return {hu: ts, hy: _List_Nil, W: _List_Nil, v: t};
	});
var $author$project$Utils$Tree$fromFlatForest = function (trees) {
	if (trees.b) {
		var first = trees.a;
		var others = trees.b;
		return $elm$core$Maybe$Just(
			A2($zwilias$elm_rosetree$Tree$Zipper$fromForest, first, others));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = rest;
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $author$project$Utils$Tree$getAllAncestorsHelper = F2(
	function (zipper, ancestors) {
		getAllAncestorsHelper:
		while (true) {
			var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
			if (_v0.$ === 1) {
				return ancestors;
			} else {
				var parent = _v0.a;
				var $temp$zipper = parent,
					$temp$ancestors = A2($elm$core$List$cons, parent, ancestors);
				zipper = $temp$zipper;
				ancestors = $temp$ancestors;
				continue getAllAncestorsHelper;
			}
		}
	});
var $author$project$Utils$Tree$getAllAncestors = function (zipper) {
	return A2($author$project$Utils$Tree$getAllAncestorsHelper, zipper, _List_Nil);
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$Form$Checkbox$Options = $elm$core$Basics$identity;
var $author$project$Form$Checkbox$init = function (_v0) {
	var label = _v0.n$;
	var id = _v0.w;
	return {mF: _List_Nil, b_: false, w: id, n$: label};
};
var $author$project$Form$Group = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Form$fill = function (_v0) {
	var fill_ = _v0;
	return fill_;
};
var $author$project$Form$list = F2(
	function (groupAttrs, current) {
		return function (values) {
			var filledForms = A2(
				$elm$core$List$map,
				function (f) {
					return A2($author$project$Form$fill, f, values);
				},
				current);
			var combinedResult = A3(
				$elm$core$List$foldr,
				F2(
					function (currFilled, currResult) {
						var _v0 = _Utils_Tuple2(currFilled.g, currResult);
						_v0$3:
						while (true) {
							switch (_v0.a.$) {
								case 0:
									if (!_v0.b.$) {
										var _v1 = _v0.a.a;
										var currError = _v1.a;
										var currErrors = _v1.b;
										var _v2 = _v0.b.a;
										var resultError = _v2.a;
										var resultErrors = _v2.b;
										return $author$project$OptionalResult$OptErr(
											_Utils_Tuple2(
												currError,
												_Utils_ap(
													currErrors,
													A2($elm$core$List$cons, resultError, resultErrors))));
									} else {
										var _v3 = _v0.a.a;
										var currError = _v3.a;
										var currErrors = _v3.b;
										return $author$project$OptionalResult$OptErr(
											_Utils_Tuple2(currError, currErrors));
									}
								case 1:
									switch (_v0.b.$) {
										case 1:
											var currOk = _v0.a.a;
											var resultOk = _v0.b.a;
											return $author$project$OptionalResult$OptOk(
												A2($elm$core$List$cons, currOk, resultOk));
										case 0:
											break _v0$3;
										default:
											var currOk = _v0.a.a;
											var _v5 = _v0.b;
											return $author$project$OptionalResult$OptOk(
												_List_fromArray(
													[currOk]));
									}
								default:
									switch (_v0.b.$) {
										case 0:
											break _v0$3;
										case 1:
											var _v6 = _v0.a;
											var resultOk = _v0.b.a;
											return $author$project$OptionalResult$OptOk(resultOk);
										default:
											var _v7 = _v0.a;
											var _v8 = _v0.b;
											return $author$project$OptionalResult$OptNothing;
									}
							}
						}
						var _v4 = _v0.b.a;
						var resultError = _v4.a;
						var resultErrors = _v4.b;
						return $author$project$OptionalResult$OptErr(
							_Utils_Tuple2(resultError, resultErrors));
					}),
				$author$project$OptionalResult$OptOk(_List_Nil),
				filledForms);
			return {
				e: _List_fromArray(
					[
						{
						na: $elm$core$Maybe$Nothing,
						nV: false,
						Z: A2(
							$author$project$Form$Group,
							groupAttrs,
							A2(
								$elm$core$List$concatMap,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.e;
									},
									$elm$core$List$reverse),
								filledForms)),
						ax: 0
					}
					]),
				g: combinedResult
			};
		};
	});
var $author$project$OptionalResult$map = F2(
	function (fn, optionalResult) {
		switch (optionalResult.$) {
			case 1:
				var a = optionalResult.a;
				return $author$project$OptionalResult$OptOk(
					fn(a));
			case 0:
				var error = optionalResult.a;
				return $author$project$OptionalResult$OptErr(error);
			default:
				return $author$project$OptionalResult$OptNothing;
		}
	});
var $author$project$Form$mapOutput = F2(
	function (fn, form) {
		return function (values) {
			var filledForm = A2($author$project$Form$fill, form, values);
			return {
				e: filledForm.e,
				g: A2($author$project$OptionalResult$map, fn, filledForm.g)
			};
		};
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Form$succeed = function (output) {
	return function (_v0) {
		return {
			e: _List_Nil,
			g: $author$project$OptionalResult$OptOk(output)
		};
	};
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Form$with = F2(
	function (_new, current) {
		return function (values) {
			var filledNew = A2($author$project$Form$fill, _new, values);
			var filledCurrent = A2($author$project$Form$fill, current, values);
			return {
				e: _Utils_ap(filledNew.e, filledCurrent.e),
				g: function () {
					var _v0 = filledCurrent.g;
					switch (_v0.$) {
						case 1:
							var fn = _v0.a;
							return A2($author$project$OptionalResult$map, fn, filledNew.g);
						case 2:
							var _v1 = filledNew.g;
							switch (_v1.$) {
								case 0:
									var errors = _v1.a;
									return $author$project$OptionalResult$OptErr(errors);
								case 1:
									return $author$project$OptionalResult$OptNothing;
								default:
									return $author$project$OptionalResult$OptNothing;
							}
						default:
							var _v2 = _v0.a;
							var firstError = _v2.a;
							var otherErrors = _v2.b;
							var _v3 = filledNew.g;
							switch (_v3.$) {
								case 1:
									return $author$project$OptionalResult$OptErr(
										_Utils_Tuple2(firstError, otherErrors));
								case 2:
									return $author$project$OptionalResult$OptErr(
										_Utils_Tuple2(firstError, otherErrors));
								default:
									var _v4 = _v3.a;
									var secondFirstError = _v4.a;
									var secondOtherErrors = _v4.b;
									return $author$project$OptionalResult$OptErr(
										_Utils_Tuple2(
											firstError,
											_Utils_ap(
												otherErrors,
												A2($elm$core$List$cons, secondFirstError, secondOtherErrors))));
							}
					}
				}()
			};
		};
	});
var $author$project$Form$Checkbox$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mF: _Utils_ap(options.mF, attrs)
			});
	});
var $author$project$OptionalResult$map2 = F3(
	function (fn, first, second) {
		var _v0 = _Utils_Tuple2(first, second);
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				switch (_v0.a.$) {
					case 1:
						switch (_v0.b.$) {
							case 1:
								var firstOk = _v0.a.a;
								var secondOk = _v0.b.a;
								return $author$project$OptionalResult$OptOk(
									A2(fn, firstOk, secondOk));
							case 0:
								break _v0$2;
							default:
								break _v0$3;
						}
					case 0:
						var error = _v0.a.a;
						return $author$project$OptionalResult$OptErr(error);
					default:
						if (!_v0.b.$) {
							break _v0$2;
						} else {
							break _v0$3;
						}
				}
			}
			return $author$project$OptionalResult$OptNothing;
		}
		var error = _v0.b.a;
		return $author$project$OptionalResult$OptErr(error);
	});
var $author$project$Form$accumulateResults = F3(
	function (first, second, combinator) {
		var getErrors = function (result) {
			if (!result.$) {
				var _v4 = result.a;
				var firstError = _v4.a;
				var otherErrors = _v4.b;
				return $elm$core$Maybe$Just(
					A2($elm$core$List$cons, firstError, otherErrors));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var allErrors = $elm$core$List$concat(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						getErrors(first),
						getErrors(second)
					])));
		switch (combinator.$) {
			case 1:
				var fn = combinator.a;
				return A3($author$project$OptionalResult$map2, fn, first, second);
			case 0:
				var _v1 = combinator.a;
				var error = _v1.a;
				var errors = _v1.b;
				return $author$project$OptionalResult$OptErr(
					_Utils_Tuple2(
						error,
						_Utils_ap(errors, allErrors)));
			default:
				if (allErrors.b) {
					var error = allErrors.a;
					var errors = allErrors.b;
					return $author$project$OptionalResult$OptErr(
						_Utils_Tuple2(error, errors));
				} else {
					return $author$project$OptionalResult$OptNothing;
				}
		}
	});
var $author$project$Form$withGroup = F4(
	function (attributes, leftSide, rightSide, current) {
		return function (values) {
			var filledRight = A2($author$project$Form$fill, rightSide, values);
			var filledLeft = A2($author$project$Form$fill, leftSide, values);
			var filledCurrent = A2($author$project$Form$fill, current, values);
			return {
				e: A2(
					$elm$core$List$cons,
					{
						na: $elm$core$Maybe$Nothing,
						nV: false,
						Z: A2(
							$author$project$Form$Group,
							attributes,
							_Utils_ap(filledLeft.e, filledRight.e)),
						ax: 0
					},
					filledCurrent.e),
				g: A3($author$project$Form$accumulateResults, filledLeft.g, filledRight.g, filledCurrent.g)
			};
		};
	});
var $author$project$Form$withNoOutput = F2(
	function (_new, current) {
		return function (values) {
			var filledNew = A2($author$project$Form$fill, _new, values);
			var filledCurrent = A2($author$project$Form$fill, current, values);
			return {
				e: _Utils_ap(filledNew.e, filledCurrent.e),
				g: filledCurrent.g
			};
		};
	});
var $author$project$Page$Shop$Editor$categoriesForm = F2(
	function (translators, allCategories) {
		var checkbox = function (category) {
			return A2(
				$author$project$Form$checkbox,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: function (value) {
						return value ? $elm$core$Result$Ok(
							$elm$core$Maybe$Just(category.w)) : $elm$core$Result$Ok($elm$core$Maybe$Nothing);
					},
					qd: F2(
						function (input, values) {
							var ancestors = A2(
								$elm$core$List$map,
								$zwilias$elm_rosetree$Tree$Zipper$label,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										$author$project$Utils$Tree$getAllAncestors,
										A2(
											$elm$core$Maybe$andThen,
											$zwilias$elm_rosetree$Tree$Zipper$findFromRoot(
												function (zipperCategory) {
													return _Utils_eq(zipperCategory.w, category.w);
												}),
											$author$project$Utils$Tree$fromFlatForest(allCategories)))));
							return input ? A3(
								$pzp1997$assoc_list$AssocList$insert,
								category,
								input,
								A3(
									$elm$core$List$foldl,
									function (ancestor) {
										return A2($pzp1997$assoc_list$AssocList$insert, ancestor, true);
									},
									values,
									ancestors)) : A3($pzp1997$assoc_list$AssocList$insert, category, input, values);
						}),
					lW: function (input) {
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2($pzp1997$assoc_list$AssocList$get, category, input));
					}
				},
				A2(
					$author$project$Form$Checkbox$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex')
						]),
					$author$project$Form$Checkbox$init(
						{
							w: 'category-' + $author$project$Shop$Category$idToString(category.w),
							n$: A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center gap-x-2')
									]),
								_List_fromArray(
									[
										function () {
										var _v1 = category.p;
										if (_v1.$ === 1) {
											return $elm$html$Html$text('');
										} else {
											var icon = _v1.a;
											return A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-5 h-5 rounded-full'),
														$elm$html$Html$Attributes$alt(''),
														$elm$html$Html$Attributes$src(icon)
													]),
												_List_Nil);
										}
									}(),
										$elm$html$Html$text(category.fj)
									]))
						})));
		};
		var treeToForm = function (tree) {
			return A4(
				$author$project$Form$withGroup,
				_List_Nil,
				checkbox(
					$zwilias$elm_rosetree$Tree$label(tree)),
				$elm$core$List$isEmpty(
					$zwilias$elm_rosetree$Tree$children(tree)) ? $author$project$Form$succeed(_List_Nil) : A2(
					$author$project$Form$mapOutput,
					$elm$core$List$concat,
					A2(
						$author$project$Form$list,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-4 mt-6 flex flex-col gap-y-6')
							]),
						A2(
							$elm$core$List$map,
							treeToForm,
							$zwilias$elm_rosetree$Tree$children(tree)))),
				$author$project$Form$succeed(
					F2(
						function (label, children) {
							if (label.$ === 1) {
								return children;
							} else {
								var head = label.a;
								return A2($elm$core$List$cons, head, children);
							}
						})));
		};
		return A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$mapOutput,
				$elm$core$List$concat,
				A2(
					$author$project$Form$list,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-y-6')
						]),
					A2($elm$core$List$map, treeToForm, allCategories))),
			A2(
				$author$project$Form$withNoOutput,
				$author$project$Form$arbitrary(
					A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-4')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								translators.fL('shop.steps.categories.guidance'))
							]))),
				$author$project$Form$succeed($elm$core$Basics$identity)));
	});
var $author$project$Community$CommunityError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Community$FieldError = function (a) {
	return {$: 1, a: a};
};
var $krisajenkins$remotedata$RemoteData$andThen = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var a = data.a;
				return f(a);
			case 2:
				var e = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(e);
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				return $krisajenkins$remotedata$RemoteData$Loading;
		}
	});
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $krisajenkins$remotedata$RemoteData$mapError = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var x = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(x);
			case 2:
				var e = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(
					f(e));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			default:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
		}
	});
var $author$project$Community$getField = F2(
	function (remoteDataModel, accessor) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andThen,
			function (model) {
				return A2(
					$krisajenkins$remotedata$RemoteData$mapError,
					$author$project$Community$FieldError,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (field) {
							return _Utils_Tuple2(model, field);
						},
						accessor(model)));
			},
			A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Community$CommunityError, remoteDataModel));
	});
var $author$project$Page$Shop$Editor$getFormData = function (model) {
	var _v0 = model.pN;
	switch (_v0.$) {
		case 0:
			var formData = _v0.a;
			return $elm$core$Maybe$Just(formData);
		case 1:
			var formData = _v0.a;
			return $elm$core$Maybe$Just(formData);
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			var formData = _v0.b;
			return $elm$core$Maybe$Just(formData);
		case 4:
			var formData = _v0.b;
			return $elm$core$Maybe$Just(formData);
		case 5:
			var formData = _v0.b;
			return $elm$core$Maybe$Just(formData);
		case 6:
			var formData = _v0.b;
			return $elm$core$Maybe$Just(formData);
		case 7:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Form$File = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Form$File$Model = $elm$core$Basics$identity;
var $author$project$Form$File$MultipleEntries = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$File$fromMultipleModel = function (_v0) {
	var model = _v0;
	return {
		mj: model.mj,
		i: $author$project$Form$File$MultipleEntries(model.i),
		aj: model.aj,
		Y: model.Y,
		r: model.r
	};
};
var $author$project$Form$mapBaseField = F3(
	function (fn, reverseFn, baseField) {
		return {
			be: A2($elm$core$Basics$composeR, baseField.be, fn),
			qd: A2($elm$core$Basics$composeR, reverseFn, baseField.qd),
			bv: A2($elm$core$Basics$composeR, reverseFn, baseField.bv),
			lW: fn(baseField.lW)
		};
	});
var $author$project$Form$File$parseUrlStatus = F2(
	function (_v0, urlStatus) {
		var t = _v0.fL;
		switch (urlStatus.$) {
			case 0:
				return $elm$core$Result$Err(
					t('error.wait_file_upload'));
			case 1:
				var url = urlStatus.a;
				return $elm$core$Result$Ok(url);
			case 2:
				return $elm$core$Result$Err(
					t('error.wait_file_upload'));
			case 3:
				return $elm$core$Result$Err(
					t('error.wait_file_upload'));
			case 4:
				var croppedUrl = urlStatus.a.dv;
				return $elm$core$Result$Ok(croppedUrl);
			default:
				return $elm$core$Result$Err(
					t('error.file_upload'));
		}
	});
var $author$project$Form$File$parserMultiple = F2(
	function (translators, _v0) {
		var model = _v0;
		return A3(
			$elm$core$List$foldr,
			F2(
				function (entry, result) {
					var _v1 = A2($author$project$Form$File$parseUrlStatus, translators, entry.hn);
					if (_v1.$ === 1) {
						var err = _v1.a;
						return $elm$core$Result$Err(err);
					} else {
						var url = _v1.a;
						if (result.$ === 1) {
							var err = result.a;
							return $elm$core$Result$Err(err);
						} else {
							var validEntries = result.a;
							return $elm$core$Result$Ok(
								A2($elm$core$List$cons, url, validEntries));
						}
					}
				}),
			$elm$core$Result$Ok(_List_Nil),
			model.i);
	});
var $author$project$Form$File$toMultipleModel = function (_v0) {
	var model = _v0;
	return {
		mj: model.mj,
		i: function () {
			var _v1 = model.i;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var entry = _v1.a.a;
					return _List_fromArray(
						[entry]);
				} else {
					var _v2 = _v1.a;
					return _List_Nil;
				}
			} else {
				var entries = _v1.a;
				return entries;
			}
		}(),
		aj: model.aj,
		Y: model.Y,
		r: model.r
	};
};
var $author$project$Form$fileMultiple = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Form$mapBaseField, $author$project$Form$File$fromMultipleModel, $author$project$Form$File$toMultipleModel),
				$author$project$Form$File(options)),
			{
				ne: config.ne,
				o3: A2(
					$elm$core$Basics$composeR,
					$author$project$Form$File$parserMultiple(config.aw),
					$elm$core$Result$andThen(config.o3)),
				qd: config.qd,
				lW: config.lW
			});
	});
var $author$project$Form$File$DeleteEntry = {$: 0};
var $author$project$Form$File$Image = 1;
var $author$project$Form$File$Options = $elm$core$Basics$identity;
var $author$project$Form$File$ReplaceEntry = {$: 2};
var $author$project$Form$File$SaveEntry = {$: 3};
var $author$project$Form$File$init = function (_v0) {
	var id = _v0.w;
	return {
		f$: _List_Nil,
		hs: $elm$core$Maybe$Nothing,
		du: _List_Nil,
		b_: false,
		dA: function (_v1) {
			return _List_fromArray(
				[$author$project$Form$File$DeleteEntry, $author$project$Form$File$ReplaceEntry, $author$project$Form$File$SaveEntry]);
		},
		cH: function (_v2) {
			return _List_Nil;
		},
		dE: _List_fromArray(
			[1]),
		w: id,
		b3: '',
		gE: _List_Nil,
		h3: $elm$core$Maybe$Nothing,
		n$: $elm$core$Maybe$Nothing
	};
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$clipRule = _VirtualDom_attribute('clip-rule');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Icons$edit = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$height('26'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 26'),
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M20.3091 24.2273H1.84628V1.77273H12.3085V0H1.84628C0.826607 0 0 0.793677 0 1.77273V24.2273C0 25.2063 0.826607 26 1.84628 26H20.3091C21.3287 26 22.1553 25.2063 22.1553 24.2273V13H20.3091V24.2273Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M23.46 2.20989L22.1553 0.957161C21.4345 0.265907 20.2668 0.265907 19.5459 0.957161C19.5459 0.957161 9.28678 10.7958 9.13292 11.3926L8.67135 13.1653C8.51335 13.7699 8.69759 14.4096 9.15659 14.8503C9.61558 15.2911 10.2819 15.468 10.9115 15.3163L12.7578 14.8731C13.3732 14.7194 23.46 4.72125 23.46 4.72125C24.18 4.02914 24.18 2.90791 23.46 2.2158V2.20989ZM13.4901 11.7826L12.2285 10.5713L12.1854 10.5358L20.8506 2.2158L22.1553 3.46852L13.4901 11.7826Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_Nil)
			]));
};
var $author$project$Form$File$withEntryContainerAttributes = F2(
	function (attributes, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				cH: function (index) {
					return _Utils_ap(
						options.cH(index),
						attributes(index));
				}
			});
	});
var $author$project$Form$File$withImageSiblingElement = F2(
	function (sibling, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				h3: $elm$core$Maybe$Just(sibling)
			});
	});
var $author$project$Form$File$withEditIconOverlay = function (_v0) {
	var options = _v0;
	return A2(
		$author$project$Form$File$withEntryContainerAttributes,
		function (_v1) {
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative')
				]);
		},
		A2(
			$author$project$Form$File$withImageSiblingElement,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute top-0 bottom-0 left-0 right-0 bg-black/40 grid place-items-center hover:bg-black/50'),
						$elm$html$Html$Attributes$class(options.b3)
					]),
				_List_fromArray(
					[
						$author$project$Icons$edit('text-white')
					])),
			options));
};
var $author$project$Form$File$withImageClass = F2(
	function (class_, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{b3: options.b3 + (' ' + class_)});
	});
var $author$project$Form$File$withImageCropperAttributes = F2(
	function (attributes, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gE: _Utils_ap(options.gE, attributes)
			});
	});
var $author$project$Page$Shop$Editor$imagesForm = function (translators) {
	return A2(
		$author$project$Form$with,
		A2(
			$author$project$Form$fileMultiple,
			{
				ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				o3: $elm$core$Result$Ok,
				aw: translators,
				qd: F2(
					function (_new, _v1) {
						return _new;
					}),
				lW: $elm$core$Basics$identity
			},
			$author$project$Form$File$withEditIconOverlay(
				A2(
					$author$project$Form$File$withImageCropperAttributes,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rounded')
						]),
					A2(
						$author$project$Form$File$withImageClass,
						'max-w-24 max-h-24',
						A2(
							$author$project$Form$File$withEntryContainerAttributes,
							function (_v0) {
								return _List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-24 h-24 bg-gray-100 rounded grid place-items-center overflow-hidden')
									]);
							},
							$author$project$Form$File$init(
								{w: 'product-images-input'})))))),
		A2(
			$author$project$Form$withNoOutput,
			$author$project$Form$arbitrary(
				A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							translators.fL('shop.steps.images.guidance'))
						]))),
			$author$project$Form$succeed($elm$core$Basics$identity)));
};
var $author$project$Page$Shop$Editor$MainInformationFormOutput = F2(
	function (title, description) {
		return {aR: description, fN: title};
	});
var $author$project$Form$RichText$Options = $elm$core$Basics$identity;
var $author$project$Form$RichText$init = function (_v0) {
	var label = _v0.n$;
	return {mF: _List_Nil, b_: false, gq: _List_Nil, n$: label, pa: $elm$core$Maybe$Nothing};
};
var $author$project$Form$Text$Options = $elm$core$Basics$identity;
var $author$project$Form$Text$Text = 0;
var $author$project$Form$Text$TextInput = {$: 0};
var $author$project$Form$Text$init = function (_v0) {
	var label = _v0.n$;
	var id = _v0.w;
	return {bX: $elm$core$Basics$identity, hz: $elm$core$Basics$identity, mF: _List_Nil, gj: $elm$core$Maybe$Nothing, gk: _List_Nil, b_: false, gs: _List_Nil, gu: _List_Nil, dD: _List_Nil, w: id, gF: _List_Nil, gG: $author$project$Form$Text$TextInput, n$: label, dY: _List_Nil, gR: $elm$core$Maybe$Nothing, pa: $elm$core$Maybe$Nothing, eq: 0};
};
var $author$project$Form$Validate$Validator = $elm$core$Basics$identity;
var $author$project$Form$Validate$custom = F2(
	function (validation, _v0) {
		var validator = _v0;
		return A2($elm$core$Result$andThen, validation, validator);
	});
var $elm_community$maybe_extra$Maybe$Extra$combineHelp = F2(
	function (list, acc) {
		combineHelp:
		while (true) {
			if (list.b) {
				var head = list.a;
				var tail = list.b;
				if (!head.$) {
					var a = head.a;
					var $temp$list = tail,
						$temp$acc = A2($elm$core$List$cons, a, acc);
					list = $temp$list;
					acc = $temp$acc;
					continue combineHelp;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(
					$elm$core$List$reverse(acc));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$combine = function (list) {
	return A2($elm_community$maybe_extra$Maybe$Extra$combineHelp, list, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Block$foldl = F3(
	function (_function, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var block = list.a;
				var remainingBlocks = list.b;
				switch (block.$) {
					case 0:
						var html = block.a;
						if (!html.$) {
							var children = html.c;
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = _Utils_ap(children, remainingBlocks);
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						} else {
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = remainingBlocks;
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						}
					case 1:
						var tight = block.a;
						var blocks = block.b;
						var childBlocks = A2(
							$elm$core$List$concatMap,
							function (_v3) {
								var children = _v3.b;
								return children;
							},
							blocks);
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(childBlocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 2:
						var _int = block.b;
						var blocks = block.c;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(
							$elm$core$List$concat(blocks),
							remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 3:
						var blocks = block.a;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(blocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 4:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 5:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 6:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 7:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					default:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText = function (block) {
	switch (block.$) {
		case 5:
			var inlines = block.a;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 0:
			var html = block.a;
			if (!html.$) {
				var blocks = html.c;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Block$foldl,
					F2(
						function (nestedBlock, soFar) {
							return _Utils_ap(
								soFar,
								$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(nestedBlock));
						}),
					'',
					blocks);
			} else {
				return '';
			}
		case 1:
			var tight = block.a;
			var items = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (_v4) {
						var task = _v4.a;
						var blocks = _v4.b;
						return A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 2:
			var tight = block.a;
			var _int = block.b;
			var items = block.c;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (blocks) {
						return A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 3:
			var blocks = block.a;
			return A2(
				$elm$core$String$join,
				'\n',
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
		case 4:
			var headingLevel = block.a;
			var inlines = block.b;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 6:
			var header = block.a;
			var rows = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$dillonkearns$elm_markdown$Markdown$Block$extractInlineText,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.n$;
								},
								header)),
							$elm$core$List$concat(
							A2(
								$elm$core$List$map,
								$elm$core$List$map($dillonkearns$elm_markdown$Markdown$Block$extractInlineText),
								rows))
						])));
		case 7:
			var body = block.a.f6;
			return body;
		default:
			return '';
	}
};
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineText = function (inlines) {
	return A3($elm$core$List$foldl, $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp, '', inlines);
};
var $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp = F2(
	function (inline, text) {
		switch (inline.$) {
			case 7:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 8:
				return text + ' ';
			case 6:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 1:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 2:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 0:
				var html = inline.a;
				if (!html.$) {
					var blocks = html.c;
					return A3(
						$dillonkearns$elm_markdown$Markdown$Block$foldl,
						F2(
							function (block, soFar) {
								return _Utils_ap(
									soFar,
									$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(block));
							}),
						text,
						blocks);
				} else {
					return text;
				}
			case 4:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 3:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			default:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
		}
	});
var $author$project$Markdown$removeFormattingFromBlock = function (block) {
	var removeFormattingFromList = F2(
		function (lineStarter, blocks) {
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, blockChild) {
							return $elm$core$String$concat(
								A2(
									$elm$core$List$map,
									function (line) {
										return _Utils_ap(
											lineStarter(index),
											line);
									},
									A2($elm$core$List$filterMap, $author$project$Markdown$removeFormattingFromBlock, blockChild)));
						}),
					blocks));
		});
	_v0$5:
	while (true) {
		switch (block.$) {
			case 1:
				var children = block.b;
				return $elm$core$Maybe$Just(
					A2(
						removeFormattingFromList,
						function (_v2) {
							return '- ';
						},
						A2(
							$elm$core$List$map,
							function (_v1) {
								var children_ = _v1.b;
								return children_;
							},
							children)));
			case 2:
				var children = block.c;
				return $elm$core$Maybe$Just(
					A2(
						removeFormattingFromList,
						function (index) {
							return $elm$core$String$fromInt(index + 1) + '. ';
						},
						children));
			case 4:
				var inlines = block.b;
				return $elm$core$Maybe$Just(
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 5:
				var inlines = block.a;
				return $elm$core$Maybe$Just(
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 0:
				if (!block.a.$) {
					var _v3 = block.a;
					var children = _v3.c;
					return A2(
						$elm$core$Maybe$map,
						$elm$core$String$join(' '),
						$elm_community$maybe_extra$Maybe$Extra$combine(
							A2($elm$core$List$map, $author$project$Markdown$removeFormattingFromBlock, children)));
				} else {
					break _v0$5;
				}
			default:
				break _v0$5;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Markdown$toUnformattedString = function (_v0) {
	var markdown = _v0;
	var _v1 = $dillonkearns$elm_markdown$Markdown$Parser$parse(markdown);
	if (!_v1.$) {
		var blocks = _v1.a;
		return $elm$core$String$trim(
			A2(
				$elm$core$Maybe$withDefault,
				markdown,
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$join('\n'),
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2($elm$core$List$map, $author$project$Markdown$removeFormattingFromBlock, blocks)))));
	} else {
		return markdown;
	}
};
var $author$project$Form$Validate$markdownLongerThan = function (minLength) {
	return $author$project$Form$Validate$custom(
		function (markdownInput) {
			return (_Utils_cmp(
				$elm$core$String$length(
					$author$project$Markdown$toUnformattedString(markdownInput)),
				minLength) < 0) ? $elm$core$Result$Err(
				function (_v0) {
					var tr = _v0.i4;
					return A2(
						tr,
						'error.validator.text.longer_than',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'base',
								$elm$core$String$fromInt(minLength))
							]));
				}) : $elm$core$Result$Ok(markdownInput);
		});
};
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $author$project$Form$RichText = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$Markdown$formattingStrings = function (formatting) {
	switch (formatting.$) {
		case 0:
			return _Utils_Tuple2('**', '**');
		case 1:
			return _Utils_Tuple2('_', '_');
		case 2:
			return _Utils_Tuple2('~~', '~~');
		case 3:
			return _Utils_Tuple2('<u>', '</u>');
		case 4:
			var link = formatting.a;
			return _Utils_Tuple2('[', '](' + (link + ')'));
		case 5:
			var level = formatting.a;
			return _Utils_Tuple2(
				A2($elm$core$String$repeat, level, '#') + ' ',
				'');
		case 6:
			return _Utils_Tuple2('\n1. ', '');
		default:
			return _Utils_Tuple2('\n- ', '');
	}
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $elm_community$list_extra$List$Extra$takeWhile = function (predicate) {
	var takeWhileMemo = F2(
		function (memo, list) {
			takeWhileMemo:
			while (true) {
				if (!list.b) {
					return $elm$core$List$reverse(memo);
				} else {
					var x = list.a;
					var xs = list.b;
					if (predicate(x)) {
						var $temp$memo = A2($elm$core$List$cons, x, memo),
							$temp$list = xs;
						memo = $temp$memo;
						list = $temp$list;
						continue takeWhileMemo;
					} else {
						return $elm$core$List$reverse(memo);
					}
				}
			}
		});
	return takeWhileMemo(_List_Nil);
};
var $author$project$Markdown$quillOpToMarkdown = function (_v0) {
	var quillOp = _v0;
	var addFormatting = F2(
		function (formatting, unformattedText) {
			var shouldAddSurroundingSpaces = function () {
				switch (formatting.$) {
					case 0:
						return true;
					case 1:
						return true;
					case 2:
						return true;
					case 3:
						return true;
					default:
						return false;
				}
			}();
			var spacesAfter = shouldAddSurroundingSpaces ? $elm$core$List$length(
				A2(
					$elm_community$list_extra$List$Extra$takeWhile,
					$elm$core$Basics$eq(' '),
					$elm$core$List$reverse(
						$elm$core$String$toList(unformattedText)))) : 0;
			var spacesBefore = shouldAddSurroundingSpaces ? $elm$core$List$length(
				A2(
					$elm_community$list_extra$List$Extra$takeWhile,
					$elm$core$Basics$eq(' '),
					$elm$core$String$toList(unformattedText))) : 0;
			var maybeTrim = shouldAddSurroundingSpaces ? $elm$core$String$trim : $elm$core$Basics$identity;
			var _v1 = $author$project$Markdown$formattingStrings(formatting);
			var formatBefore = _v1.a;
			var formatAfter = _v1.b;
			return _Utils_ap(
				A2($elm$core$String$repeat, spacesBefore, ' '),
				_Utils_ap(
					formatBefore,
					_Utils_ap(
						maybeTrim(unformattedText),
						_Utils_ap(
							formatAfter,
							A2($elm$core$String$repeat, spacesAfter, ' ')))));
		});
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(quillOp.aI)) ? '' : A3(
		$elm$core$String$replace,
		'___',
		'*_*',
		A3(
			$elm$core$String$replace,
			'_____',
			'**_**',
			A3(
				$elm$core$String$replace,
				'***',
				'_*_',
				A3(
					$elm$core$String$replace,
					'*****',
					'__*__',
					A3($elm$core$List$foldr, addFormatting, quillOp.aI, quillOp.y)))));
};
var $author$project$Markdown$fromQuillOps = function (quillOps) {
	var isHeader = function (formatting) {
		if (formatting.$ === 5) {
			return true;
		} else {
			return false;
		}
	};
	var headerLevel = function (formattings) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (formatting) {
					if (formatting.$ === 5) {
						var level = formatting.a;
						return $elm$core$Maybe$Just(level);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				formattings));
	};
	var foldFn = F2(
		function (_v2, _v3) {
			var currItem = _v2;
			var previousItems = _v3.c$;
			var currString = _v3.bY;
			if (A2($elm$core$List$member, $author$project$Markdown$OrderedList, currItem.y)) {
				return {
					bY: currString + ('1. ' + ($elm$core$String$concat(
						A2(
							$elm$core$List$map,
							$author$project$Markdown$quillOpToMarkdown,
							$elm$core$List$reverse(previousItems))) + '\n')),
					c$: _List_Nil
				};
			} else {
				if (A2($elm$core$List$member, $author$project$Markdown$UnorderedList, currItem.y)) {
					return {
						bY: currString + ('- ' + ($elm$core$String$concat(
							A2(
								$elm$core$List$map,
								$author$project$Markdown$quillOpToMarkdown,
								$elm$core$List$reverse(previousItems))) + '\n')),
						c$: _List_Nil
					};
				} else {
					if (A2($elm$core$List$any, isHeader, currItem.y)) {
						return {
							bY: currString + (function (level) {
								return A2($elm$core$String$repeat, level, '#');
							}(
								A2(
									$elm$core$Maybe$withDefault,
									0,
									headerLevel(currItem.y))) + (' ' + ($elm$core$String$concat(
								A2(
									$elm$core$List$map,
									$author$project$Markdown$quillOpToMarkdown,
									$elm$core$List$reverse(previousItems))) + '\n'))),
							c$: _List_Nil
						};
					} else {
						if (A2($elm$core$String$endsWith, '\n', currItem.aI)) {
							return {
								bY: _Utils_ap(
									currString,
									$elm$core$String$concat(
										A2(
											$elm$core$List$map,
											$author$project$Markdown$quillOpToMarkdown,
											$elm$core$List$reverse(
												A2($elm$core$List$cons, currItem, previousItems))))),
								c$: _List_Nil
							};
						} else {
							var currItems = A2(
								$elm$core$List$map,
								function (insert) {
									return {y: currItem.y, aI: insert};
								},
								A2($elm$core$String$split, '\n', currItem.aI));
							var _v0 = _Utils_Tuple2(
								A2(
									$elm$core$List$map,
									$author$project$Markdown$quillOpToMarkdown,
									A2(
										$elm$core$List$take,
										$elm$core$List$length(currItems) - 1,
										currItems)),
								$elm_community$list_extra$List$Extra$last(currItems));
							var firstItems = _v0.a;
							var lastItem = _v0.b;
							return {
								bY: $elm$core$List$isEmpty(firstItems) ? currString : (currString + ($elm$core$String$concat(
									A2(
										$elm$core$List$map,
										$author$project$Markdown$quillOpToMarkdown,
										$elm$core$List$reverse(previousItems))) + (A2($elm$core$String$join, '\n', firstItems) + '\n'))),
								c$: function () {
									if (lastItem.$ === 1) {
										return _List_Nil;
									} else {
										var lastItem_ = lastItem.a;
										return $elm$core$List$isEmpty(firstItems) ? A2($elm$core$List$cons, lastItem_, previousItems) : _List_fromArray(
											[lastItem_]);
									}
								}()
							};
						}
					}
				}
			}
		});
	return A3(
		$elm$core$List$foldl,
		foldFn,
		{bY: '', c$: _List_Nil},
		quillOps).bY;
};
var $author$project$Form$RichText$getMarkdownContent = function (_v0) {
	var model = _v0;
	return $author$project$Markdown$fromQuillOps(model.ge);
};
var $author$project$Form$richText = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			$author$project$Form$RichText(options),
			{
				ne: config.ne,
				o3: A2($elm$core$Basics$composeR, $author$project$Form$RichText$getMarkdownContent, config.o3),
				qd: config.qd,
				lW: config.lW
			});
	});
var $author$project$Form$Validate$stringLongerThan = function (minLength) {
	return $author$project$Form$Validate$custom(
		function (stringInput) {
			return (_Utils_cmp(
				$elm$core$String$length(stringInput),
				minLength) < 0) ? $elm$core$Result$Err(
				function (_v0) {
					var tr = _v0.i4;
					return A2(
						tr,
						'error.validator.text.longer_than',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'base',
								$elm$core$String$fromInt(minLength))
							]));
				}) : $elm$core$Result$Ok(stringInput);
		});
};
var $author$project$Form$Validate$stringShorterThan = function (maxLength) {
	return $author$project$Form$Validate$custom(
		function (stringInput) {
			return (_Utils_cmp(
				$elm$core$String$length(stringInput),
				maxLength) > 0) ? $elm$core$Result$Err(
				function (_v0) {
					var tr = _v0.i4;
					return A2(
						tr,
						'error.valdator.text.shorter_than',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'base',
								$elm$core$String$fromInt(maxLength))
							]));
				}) : $elm$core$Result$Ok(stringInput);
		});
};
var $author$project$Form$Validate$succeed = function (output) {
	return $elm$core$Result$Ok(output);
};
var $author$project$Form$Text = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Form$textField = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			$author$project$Form$Text(options),
			config);
	});
var $author$project$Form$Validate$validate = F2(
	function (translators, _v0) {
		var result = _v0;
		return A2(
			$elm$core$Result$mapError,
			function (error) {
				return error(translators);
			},
			result);
	});
var $author$project$Form$Text$withExtraAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gu: _Utils_ap(options.gu, attrs)
			});
	});
var $author$project$Form$RichText$withPlaceholder = F2(
	function (placeholder, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				pa: $elm$core$Maybe$Just(placeholder)
			});
	});
var $author$project$Form$Text$withPlaceholder = F2(
	function (placeholder, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				pa: $elm$core$Maybe$Just(placeholder)
			});
	});
var $author$project$Page$Shop$Editor$mainInformationForm = function (translators) {
	var t = translators.fL;
	return A2(
		$author$project$Form$with,
		A2(
			$author$project$Form$richText,
			{
				ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				o3: A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Validate$succeed,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$markdownLongerThan(10),
						$author$project$Form$Validate$validate(translators))),
				qd: F2(
					function (newDescription, values) {
						return _Utils_update(
							values,
							{aR: newDescription});
					}),
				lW: function ($) {
					return $.aR;
				}
			},
			A2(
				$author$project$Form$RichText$withPlaceholder,
				t('shop.steps.main_information.description_placeholder'),
				$author$project$Form$RichText$init(
					{
						n$: t('shop.steps.main_information.description_label')
					}))),
		A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$textField,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$succeed,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$stringShorterThan(255),
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$stringLongerThan(3),
								$author$project$Form$Validate$validate(translators)))),
					qd: F2(
						function (newTitle, values) {
							return _Utils_update(
								values,
								{fN: newTitle});
						}),
					lW: function ($) {
						return $.fN;
					}
				},
				A2(
					$author$project$Form$Text$withPlaceholder,
					t('shop.steps.main_information.name_placeholder'),
					A2(
						$author$project$Form$Text$withExtraAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$maxlength(255)
							]),
						$author$project$Form$Text$init(
							{
								w: 'product-title-input',
								n$: t('shop.steps.main_information.name_label')
							})))),
			$author$project$Form$succeed($author$project$Page$Shop$Editor$MainInformationFormOutput)));
};
var $author$project$Form$ClickedSubmitWithErrors = function (a) {
	return {$: 7, a: a};
};
var $author$project$Form$NoOp = {$: 0};
var $author$project$Form$parse = F3(
	function (form, _v0, _v1) {
		var model = _v0;
		var onError = _v1.oM;
		var onSuccess = _v1.oV;
		var filledForm = A2($author$project$Form$fill, form, model.o);
		var _v2 = filledForm.g;
		switch (_v2.$) {
			case 0:
				var errors = _v2.a;
				return onError(
					$author$project$Form$ClickedSubmitWithErrors(errors));
			case 1:
				var validForm = _v2.a;
				return onSuccess(validForm);
			default:
				return onError($author$project$Form$NoOp);
		}
	});
var $author$project$Page$Shop$Editor$Creating = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Editor$EditingUpdate = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$EditingUpdateAsAdmin = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$Saving = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$SavingAsAdmin = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$setCurrentStep = F2(
	function (newStep, model) {
		var _v0 = model.pN;
		switch (_v0.$) {
			case 0:
				var formData = _v0.a;
				return _Utils_update(
					model,
					{
						pN: $author$project$Page$Shop$Editor$EditingCreate(
							_Utils_update(
								formData,
								{C: newStep}))
					});
			case 1:
				var formData = _v0.a;
				return _Utils_update(
					model,
					{
						pN: $author$project$Page$Shop$Editor$Creating(
							_Utils_update(
								formData,
								{C: newStep}))
					});
			case 2:
				return model;
			case 3:
				var product = _v0.a;
				var formData = _v0.b;
				return _Utils_update(
					model,
					{
						pN: A2(
							$author$project$Page$Shop$Editor$EditingUpdate,
							product,
							_Utils_update(
								formData,
								{C: newStep}))
					});
			case 4:
				var product = _v0.a;
				var formData = _v0.b;
				return _Utils_update(
					model,
					{
						pN: A2(
							$author$project$Page$Shop$Editor$Saving,
							product,
							_Utils_update(
								formData,
								{C: newStep}))
					});
			case 5:
				var product = _v0.a;
				var formData = _v0.b;
				return _Utils_update(
					model,
					{
						pN: A2(
							$author$project$Page$Shop$Editor$EditingUpdateAsAdmin,
							product,
							_Utils_update(
								formData,
								{C: newStep}))
					});
			case 6:
				var product = _v0.a;
				var formData = _v0.b;
				return _Utils_update(
					model,
					{
						pN: A2(
							$author$project$Page$Shop$Editor$SavingAsAdmin,
							product,
							_Utils_update(
								formData,
								{C: newStep}))
					});
			case 7:
				return model;
			default:
				return model;
		}
	});
var $author$project$Page$Shop$Editor$maybeSetStep = F3(
	function (loggedIn, step, model) {
		var translators = loggedIn.A.aw;
		var maybeModelCmd = A2(
			$elm$core$Maybe$map,
			function (formData) {
				var _v1 = formData.C;
				switch (_v1.$) {
					case 0:
						switch (step) {
							case 0:
								return $author$project$UpdateResult$init(model);
							case 1:
								return A2(
									$author$project$UpdateResult$addMsg,
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$mainInformationForm(translators),
										formData.bF,
										{
											oM: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$MainInformationMsg),
											oV: $author$project$Page$Shop$Editor$SubmittedMainInformation(0)
										}),
									$author$project$UpdateResult$init(model));
							case 2:
								return A2(
									$author$project$UpdateResult$addMsg,
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$mainInformationForm(translators),
										formData.bF,
										{
											oM: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$MainInformationMsg),
											oV: $author$project$Page$Shop$Editor$SubmittedMainInformation(1)
										}),
									$author$project$UpdateResult$init(model));
							default:
								return A2(
									$author$project$UpdateResult$addMsg,
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$mainInformationForm(translators),
										formData.bF,
										{
											oM: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$MainInformationMsg),
											oV: $author$project$Page$Shop$Editor$SubmittedMainInformation(2)
										}),
									$author$project$UpdateResult$init(model));
						}
					case 1:
						switch (step) {
							case 0:
								return $author$project$UpdateResult$init(
									A2($author$project$Page$Shop$Editor$setCurrentStep, $author$project$Page$Shop$Editor$MainInformation, model));
							case 1:
								return $author$project$UpdateResult$init(model);
							case 2:
								return A2(
									$author$project$UpdateResult$addMsg,
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$imagesForm(translators),
										formData.h5,
										{
											oM: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$ImagesMsg),
											oV: $author$project$Page$Shop$Editor$SubmittedImages(0)
										}),
									$author$project$UpdateResult$init(model));
							default:
								return A2(
									$author$project$UpdateResult$addMsg,
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$imagesForm(translators),
										formData.h5,
										{
											oM: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$ImagesMsg),
											oV: $author$project$Page$Shop$Editor$SubmittedImages(1)
										}),
									$author$project$UpdateResult$init(model));
						}
					case 2:
						var mainInformationOutput = _v1.a;
						switch (step) {
							case 0:
								return $author$project$UpdateResult$init(
									A2($author$project$Page$Shop$Editor$setCurrentStep, $author$project$Page$Shop$Editor$MainInformation, model));
							case 1:
								return $author$project$UpdateResult$init(
									A2(
										$author$project$Page$Shop$Editor$setCurrentStep,
										$author$project$Page$Shop$Editor$Images(mainInformationOutput),
										model));
							case 2:
								return $author$project$UpdateResult$init(model);
							default:
								var _v5 = A2(
									$author$project$Community$getField,
									loggedIn.pC,
									function ($) {
										return $.fC;
									});
								if (_v5.$ === 3) {
									var _v6 = _v5.a;
									var categories = _v6.b;
									return A2(
										$author$project$UpdateResult$addMsg,
										A3(
											$author$project$Form$parse,
											A2($author$project$Page$Shop$Editor$categoriesForm, translators, categories),
											formData.dn,
											{
												oM: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$CategoriesMsg),
												oV: $author$project$Page$Shop$Editor$SubmittedCategories
											}),
										$author$project$UpdateResult$init(model));
								} else {
									return $author$project$UpdateResult$init(
										_Utils_update(
											model,
											{dW: true}));
								}
						}
					default:
						var mainInformationOutput = _v1.a;
						var imagesOutput = _v1.b;
						switch (step) {
							case 0:
								return $author$project$UpdateResult$init(
									A2($author$project$Page$Shop$Editor$setCurrentStep, $author$project$Page$Shop$Editor$MainInformation, model));
							case 1:
								return $author$project$UpdateResult$init(
									A2(
										$author$project$Page$Shop$Editor$setCurrentStep,
										$author$project$Page$Shop$Editor$Images(mainInformationOutput),
										model));
							case 2:
								return $author$project$UpdateResult$init(
									A2(
										$author$project$Page$Shop$Editor$setCurrentStep,
										A2($author$project$Page$Shop$Editor$Categories, mainInformationOutput, imagesOutput),
										model));
							default:
								return $author$project$UpdateResult$init(model);
						}
				}
			},
			$author$project$Page$Shop$Editor$getFormData(model));
		if (maybeModelCmd.$ === 1) {
			return $author$project$UpdateResult$init(model);
		} else {
			var ur = maybeModelCmd.a;
			return ur;
		}
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Route$CommunityThankYou = {$: 35};
var $author$project$Route$CreateNews = {$: 0};
var $author$project$Route$Register = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Route$WithNoObjectiveSelected = {$: 1};
var $author$project$Route$SaleMainInformation = 0;
var $author$project$Route$SaleCategories = 2;
var $author$project$Route$SaleImages = 1;
var $author$project$Route$SalePriceAndInventory = 3;
var $author$project$Page$Shop$Editor$getCurrentStepFromFormData = function (formData) {
	var _v0 = formData.C;
	switch (_v0.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Page$Shop$Editor$getCurrentStep = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			$author$project$Page$Shop$Editor$getCurrentStepFromFormData,
			$author$project$Page$Shop$Editor$getFormData(model)));
};
var $author$project$Action$idToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Action$objectiveIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Main$statusToRoute = F2(
	function (status, session) {
		switch (status.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				return $elm$core$Maybe$Nothing;
			case 2:
				return $elm$core$Maybe$Nothing;
			case 3:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$PaymentHistory(subModel.ps.l8));
			case 4:
				return $elm$core$Maybe$Just($author$project$Route$CommunityAbout);
			case 5:
				return $elm$core$Maybe$Just(
					$author$project$Route$CommunityObjectives($author$project$Route$WithNoObjectiveSelected));
			case 6:
				return $elm$core$Maybe$Just($author$project$Route$NewCommunity);
			case 7:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySettings);
			case 8:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySettingsShopCategories);
			case 9:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySettingsFeatures);
			case 10:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySettingsInfo);
			case 11:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySettingsNews);
			case 12:
				return $elm$core$Maybe$Just(
					$author$project$Route$CommunitySettingsNewsEditor($author$project$Route$CreateNews));
			case 13:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySettingsCurrency);
			case 14:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySettingsSponsorship);
			case 15:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySettingsSponsorshipFiat);
			case 16:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySettingsSponsorshipThankYouMessage);
			case 17:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$CommunitySelector(subModel.kD));
			case 18:
				return $elm$core$Maybe$Just($author$project$Route$CommunityThankYou);
			case 19:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySponsor);
			case 20:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySupporters);
			case 21:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySettingsObjectives);
			case 22:
				var subModel = status.a;
				var _v1 = subModel.kP;
				if (_v1.$ === 1) {
					return $elm$core$Maybe$Just($author$project$Route$CommunitySettingsNewObjective);
				} else {
					var objectiveId = _v1.a;
					return $elm$core$Maybe$Just(
						$author$project$Route$CommunitySettingsEditObjective(
							$author$project$Action$objectiveIdToInt(objectiveId)));
				}
			case 23:
				var subModel = status.a;
				var _v2 = subModel.f_;
				if (_v2.$ === 1) {
					return $elm$core$Maybe$Just(
						$author$project$Route$CommunitySettingsNewAction(
							$author$project$Action$objectiveIdToInt(subModel.kP)));
				} else {
					var actionId = _v2.a;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$Route$CommunitySettingsEditAction,
							$author$project$Action$objectiveIdToInt(subModel.kP),
							$author$project$Action$idToInt(actionId)));
				}
			case 24:
				return $elm$core$Maybe$Just($author$project$Route$CommunitySettingsContacts);
			case 25:
				var objectiveId = status.a;
				var actionId = status.b;
				var subModel = status.c;
				return $elm$core$Maybe$Just(
					A3($author$project$Route$Claim, objectiveId, actionId, subModel.js));
			case 26:
				return $elm$core$Maybe$Just($author$project$Route$Notification);
			case 27:
				return $elm$core$Maybe$Just($author$project$Route$Dashboard);
			case 28:
				var maybeRedirect = status.a;
				var maybeInvitation = function () {
					if (session.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var guest = session.a;
						return guest.kC;
					}
				}();
				return $elm$core$Maybe$Just(
					A2($author$project$Route$Login, maybeInvitation, maybeRedirect));
			case 29:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$News(
						{pD: subModel.bG, pJ: subModel.pI}));
			case 30:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$Profile(subModel.k5));
			case 31:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$ProfileContributions(subModel.k5));
			case 32:
				return $elm$core$Maybe$Just($author$project$Route$ProfileEditor);
			case 33:
				return $elm$core$Maybe$Just($author$project$Route$ProfileAddKyc);
			case 34:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$ProfileClaims(subModel.l9));
			case 35:
				return $elm$core$Maybe$Just($author$project$Route$ProfileAddContact);
			case 36:
				var inviteId = status.a;
				var maybeRedirect = status.b;
				return $elm$core$Maybe$Just(
					A2($author$project$Route$Register, inviteId, maybeRedirect));
			case 37:
				return $elm$core$Maybe$Just($author$project$Route$Settings);
			case 38:
				var filter = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$Shop(filter));
			case 39:
				var maybeSaleId = status.a;
				var subModel = status.b;
				if (maybeSaleId.$ === 1) {
					return $elm$core$Maybe$Just(
						$author$project$Route$NewSale(
							$author$project$Page$Shop$Editor$getCurrentStep(subModel)));
				} else {
					var saleId = maybeSaleId.a;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$Route$EditSale,
							saleId,
							$author$project$Page$Shop$Editor$getCurrentStep(subModel)));
				}
			case 40:
				var saleId = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$ViewSale(saleId));
			case 41:
				var transferId = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$ViewTransfer(transferId));
			case 42:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$Invite(subModel.kk));
			case 43:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$Join(subModel.kD));
			case 44:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$Transfer(subModel.oe));
			default:
				return $elm$core$Maybe$Just($author$project$Route$Analysis);
		}
	});
var $author$project$Log$Info = 3;
var $author$project$Log$InfoBreadcrumb = 3;
var $author$project$Log$addBreadcrumbPort = _Platform_outgoingPort('addBreadcrumbPort', $elm$core$Basics$identity);
var $author$project$Log$breadcrumbTypeToString = function (breadcrumbType) {
	switch (breadcrumbType) {
		case 0:
			return 'default';
		case 1:
			return 'debug';
		case 2:
			return 'error';
		case 3:
			return 'info';
		default:
			return 'query';
	}
};
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Log$levelToString = function (level) {
	switch (level) {
		case 0:
			return 'fatal';
		case 1:
			return 'error';
		case 2:
			return 'warning';
		case 3:
			return 'info';
		default:
			return 'debug';
	}
};
var $author$project$Log$addBreadcrumb = F2(
	function (msgToString, breadcrumb) {
		return $author$project$Log$addBreadcrumbPort(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string(
							$author$project$Log$breadcrumbTypeToString(breadcrumb.eq))),
						_Utils_Tuple2(
						'category',
						$elm$json$Json$Encode$string(
							A2(
								$elm$core$String$join,
								'.',
								msgToString(breadcrumb.f7)))),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(breadcrumb.of)),
						_Utils_Tuple2(
						'data',
						A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity, breadcrumb.bZ)),
						_Utils_Tuple2(
						'level',
						$elm$json$Json$Encode$string(
							$author$project$Log$levelToString(breadcrumb.n4)))
					])));
	});
var $author$project$Ports$createAbsintheSocket = _Platform_outgoingPort('createAbsintheSocket', $elm$json$Json$Encode$string);
var $author$project$Api$Graphql$createAbsintheSocket = function (_v0) {
	var token = _v0;
	return $author$project$Ports$createAbsintheSocket(token);
};
var $author$project$Eos$Account$encodeName = function (_v0) {
	var name = _v0;
	return $elm$json$Json$Encode$string(name);
};
var $author$project$Session$LoggedIn$CompletedLoadProfile = function (a) {
	return {$: 3, a: a};
};
var $author$project$Session$LoggedIn$CompletedLoadCommunity = function (a) {
	return {$: 4, a: a};
};
var $author$project$Session$LoggedIn$RequestedNewAuthTokenPhrase = function (a) {
	return {$: 30, a: a};
};
var $author$project$Session$LoggedIn$RequestedQueryInternal = function (a) {
	return {$: 37, a: a};
};
var $author$project$Utils$spawnMessage = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $author$project$Session$LoggedIn$internalGraphqlOperation = F4(
	function (operation, model, selectionSet, toMsg) {
		var operationCmd = function (authToken) {
			return A4(
				operation,
				model,
				$elm$core$Maybe$Just(authToken),
				selectionSet,
				$elm$core$Basics$identity);
		};
		var treatAuthError = function (operationResult) {
			switch (operationResult.$) {
				case 3:
					var success = operationResult.a;
					return $elm$core$Result$Ok(
						toMsg(
							$krisajenkins$remotedata$RemoteData$Success(success)));
				case 2:
					var err = operationResult.a;
					return $author$project$Api$Graphql$isAuthError(err) ? $elm$core$Result$Err(
						function (newAuthToken) {
							return A2(
								$elm$core$Platform$Cmd$map,
								toMsg,
								operationCmd(newAuthToken));
						}) : $elm$core$Result$Ok(
						toMsg(operationResult));
				default:
					return $elm$core$Result$Ok(
						toMsg(operationResult));
			}
		};
		var _v0 = model.jk;
		if (_v0.$ === 1) {
			return $author$project$Utils$spawnMessage(
				$author$project$Session$LoggedIn$RequestedNewAuthTokenPhrase(
					A2(
						$elm$core$Basics$composeR,
						operationCmd,
						$elm$core$Platform$Cmd$map(toMsg))));
		} else {
			var authToken = _v0.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				A2($elm$core$Basics$composeR, treatAuthError, $author$project$Session$LoggedIn$RequestedQueryInternal),
				operationCmd(authToken));
		}
	});
var $author$project$Session$LoggedIn$internalQuery = F3(
	function (model, selectionSet, toMsg) {
		return A4($author$project$Session$LoggedIn$internalGraphqlOperation, $author$project$Api$Graphql$loggedInQuery, model, selectionSet, toMsg);
	});
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 1) {
			return mb;
		} else {
			return ma;
		}
	});
var $author$project$Cambiatus$Query$community = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{pP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, as: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'subdomain', filledInOptionals.pP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'symbol', filledInOptionals.as, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'community',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Community$Model = function (name) {
	return function (description) {
		return function (symbol) {
			return function (logo) {
				return function (subdomain) {
					return function (creator) {
						return function (inviterReward) {
							return function (invitedReward) {
								return function (minBalance) {
									return function (maxSupply) {
										return function (memberCount) {
											return function (actionCount) {
												return function (claimCount) {
													return function (transferCount) {
														return function (productCount) {
															return function (orderCount) {
																return function (members) {
																	return function (contributions) {
																		return function (contributionConfiguration) {
																			return function (news) {
																				return function (highlightedNews) {
																					return function (objectives) {
																						return function (hasObjectives) {
																							return function (hasShop) {
																								return function (hasKyc) {
																									return function (hasAutoInvite) {
																										return function (hasNews) {
																											return function (validators) {
																												return function (uploads) {
																													return function (website) {
																														return function (contacts) {
																															return function (shopCategories) {
																																return {ma: actionCount, hE: claimCount, az: contacts, mM: contributionConfiguration, eN: contributions, jz: creator, aR: description, bx: hasAutoInvite, by: hasKyc, dH: hasNews, bz: hasObjectives, bB: hasShop, nu: highlightedNews, b5: invitedReward, b6: inviterReward, fe: logo, od: maxSupply, gT: memberCount, ih: members, oh: minBalance, fj: name, fl: news, cV: objectives, o_: orderCount, pj: productCount, fC: shopCategories, pP: subdomain, as: symbol, p8: transferCount, bQ: uploads, lV: validators, bT: website};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Cambiatus$Object$Community$actionCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'actionCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Community$autoInvite = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'autoInvite', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Community$claimCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'claimCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Community$contacts = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'contacts',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Community$contributionConfiguration = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'contributionConfiguration',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Community$ContributionConfiguration = F4(
	function (acceptedCurrencies, paypalAccount, thankYouDescription, thankYouTitle) {
		return {l6: acceptedCurrencies, o5: paypalAccount, p$: thankYouDescription, p0: thankYouTitle};
	});
var $author$project$Cambiatus$Enum$CurrencyType$Brl = 0;
var $author$project$Cambiatus$Enum$CurrencyType$Btc = 1;
var $author$project$Cambiatus$Enum$CurrencyType$Crc = 2;
var $author$project$Cambiatus$Enum$CurrencyType$Eos = 3;
var $author$project$Cambiatus$Enum$CurrencyType$Eth = 4;
var $author$project$Cambiatus$Enum$CurrencyType$Usd = 5;
var $author$project$Cambiatus$Enum$CurrencyType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'BRL':
				return $elm$json$Json$Decode$succeed(0);
			case 'BTC':
				return $elm$json$Json$Decode$succeed(1);
			case 'CRC':
				return $elm$json$Json$Decode$succeed(2);
			case 'EOS':
				return $elm$json$Json$Decode$succeed(3);
			case 'ETH':
				return $elm$json$Json$Decode$succeed(4);
			case 'USD':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('Invalid CurrencyType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$ContributionConfig$acceptedCurrencies = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List Enum.CurrencyType.CurrencyType)',
	'acceptedCurrencies',
	_List_Nil,
	$elm$json$Json$Decode$list($author$project$Cambiatus$Enum$CurrencyType$decoder));
var $author$project$Cambiatus$Object$ContributionConfig$paypalAccount = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'paypalAccount',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$ContributionConfig$thankYouDescription = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'thankYouDescription',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$ContributionConfig$thankYouTitle = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'thankYouTitle',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Community$contributionConfigurationSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$ContributionConfig$thankYouTitle,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$ContributionConfig$thankYouDescription),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$ContributionConfig$paypalAccount,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$ContributionConfig$acceptedCurrencies,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$ContributionConfiguration)))));
var $author$project$Cambiatus$Object$Community$creator = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'creator', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Community$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded = F2(
	function (constant, _v0) {
		var objectFields = _v0.a;
		var objectDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			objectFields,
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Basics$apR,
				$elm$json$Json$Decode$succeed(constant),
				objectDecoder));
	});
var $author$project$Cambiatus$Object$Community$hasNews = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasNews', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Community$highlightedNews = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'highlightedNews',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Cambiatus$Object$Community$invitedReward = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'invitedReward', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Cambiatus$Object$Community$inviterReward = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'inviterReward', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Cambiatus$Object$Community$maxSupply = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Float)',
	'maxSupply',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float));
var $author$project$Cambiatus$Object$Community$memberCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'memberCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Community$members = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'members',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Community$minBalance = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Float)',
	'minBalance',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float));
var $author$project$Cambiatus$Object$Community$orderCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'orderCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Community$productCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'productCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Contact$Valid = $elm$core$Basics$identity;
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Contact$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Contact$label,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Contact$externalId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Contact$type_,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
				F3(
					function (maybeType_, maybeExternalId, label) {
						return A3(
							$elm$core$Maybe$map2,
							F2(
								function (type_, externalId) {
									return {n$: label, eq: type_, lW: externalId};
								}),
							maybeType_,
							maybeExternalId);
					})))));
var $author$project$Cambiatus$Object$Community$transferCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'transferCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Community$validators = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'validators',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Community$website = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'website',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Community$communitySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$krisajenkins$remotedata$RemoteData$NotAsked,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			$author$project$Cambiatus$Object$Community$contacts($author$project$Contact$selectionSet)),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Community$website,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				$krisajenkins$remotedata$RemoteData$NotAsked,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Community$validators(
						$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$User$account)),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Community$hasNews,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Community$autoInvite,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$Community$hasKyc,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Cambiatus$Object$Community$hasShop,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Cambiatus$Object$Community$hasObjectives,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
											$krisajenkins$remotedata$RemoteData$NotAsked,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Cambiatus$Object$Community$highlightedNews($author$project$Community$News$selectionSet),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
													$krisajenkins$remotedata$RemoteData$NotAsked,
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Cambiatus$Object$Community$contributionConfiguration($author$project$Community$contributionConfigurationSelectionSet),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
															$krisajenkins$remotedata$RemoteData$NotAsked,
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$Cambiatus$Object$Community$members($author$project$Profile$minimalSelectionSet),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	$author$project$Cambiatus$Object$Community$orderCount,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		$author$project$Cambiatus$Object$Community$productCount,
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$Cambiatus$Object$Community$transferCount,
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Cambiatus$Object$Community$claimCount,
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Cambiatus$Object$Community$actionCount,
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Cambiatus$Object$Community$memberCount,
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Cambiatus$Object$Community$maxSupply,
																							A2(
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																								$author$project$Cambiatus$Object$Community$minBalance,
																								A2(
																									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																									$author$project$Cambiatus$Object$Community$invitedReward,
																									A2(
																										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																										$author$project$Cambiatus$Object$Community$inviterReward,
																										A2(
																											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																											$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Community$creator),
																											A2(
																												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																												A2(
																													$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																													$elm$core$Maybe$withDefault(''),
																													$author$project$Cambiatus$Object$Community$subdomain($author$project$Cambiatus$Object$Subdomain$name)),
																												A2(
																													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																													A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Constants$defaultCommunityLogo, $author$project$Cambiatus$Object$Community$logo),
																													A2(
																														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																														$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Community$symbol),
																														A2(
																															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																															$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$Community$description),
																															A2(
																																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																																$author$project$Cambiatus$Object$Community$name,
																																$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$Model)))))))))))))))))))))))))))))))));
var $author$project$Community$subdomainQuery = function (subdomain) {
	return A2(
		$author$project$Cambiatus$Query$community,
		function (optionals) {
			return _Utils_update(
				optionals,
				{
					pP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(subdomain)
				});
		},
		$author$project$Community$communitySelectionSet);
};
var $author$project$Community$symbolQuery = function (symbol) {
	return A2(
		$author$project$Cambiatus$Query$community,
		function (optionals) {
			return _Utils_update(
				optionals,
				{
					as: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Eos$symbolToString(symbol))
				});
		},
		$author$project$Community$communitySelectionSet);
};
var $author$project$Session$LoggedIn$fetchCommunity = F2(
	function (model, maybeSymbol) {
		if (model.A.qf) {
			return A3(
				$author$project$Session$LoggedIn$internalQuery,
				model,
				$author$project$Community$subdomainQuery(
					$author$project$Environment$communityDomain(model.A.hn)),
				$author$project$Session$LoggedIn$CompletedLoadCommunity);
		} else {
			var symbol = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Eos$cambiatusSymbol,
				A2($elm_community$maybe_extra$Maybe$Extra$or, maybeSymbol, model.A.pC));
			return A3(
				$author$project$Session$LoggedIn$internalQuery,
				model,
				$author$project$Community$symbolQuery(symbol),
				$author$project$Session$LoggedIn$CompletedLoadCommunity);
		}
	});
var $author$project$Session$LoggedIn$CodeOfConductNotShown = {$: 0};
var $author$project$Session$LoggedIn$GotAuthMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Auth$WithPrivateKey = function (a) {
	return {$: 1, a: a};
};
var $author$project$Auth$WithoutPrivateKey = {$: 0};
var $author$project$Auth$GotPinMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Pin$withDisabled = F2(
	function (disabled, model) {
		return _Utils_update(
			model,
			{b_: disabled});
	});
var $author$project$Auth$initPinModel = F3(
	function (lastKnownPin, pinVisibility, status) {
		var _v0 = $author$project$View$Pin$init(
			{w: 'pinPopup', n$: 'auth.pinPopup.label', n2: lastKnownPin, o9: pinVisibility, pQ: 'auth.login.continue', pS: 'auth.login.continue', ql: false});
		var pinModel = _v0.a;
		var pinCmd = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$View$Pin$withDisabled,
				function () {
					if (!status.$) {
						return false;
					} else {
						return true;
					}
				}(),
				pinModel),
			A2($elm$core$Platform$Cmd$map, $author$project$Auth$GotPinMsg, pinCmd));
	});
var $author$project$Auth$init = F3(
	function (lastKnownPin, pinVisibility, maybePrivateKey_) {
		var status = function () {
			if (maybePrivateKey_.$ === 1) {
				return $author$project$Auth$WithoutPrivateKey;
			} else {
				var privateKey = maybePrivateKey_.a;
				return $author$project$Auth$WithPrivateKey(privateKey);
			}
		}();
		var _v0 = A3($author$project$Auth$initPinModel, lastKnownPin, pinVisibility, status);
		var pinModel = _v0.a;
		var pinCmd = _v0.b;
		return _Utils_Tuple2(
			{na: $elm$core$Maybe$Nothing, ak: pinModel, pN: status},
			pinCmd);
	});
var $author$project$Notification$init = {j4: false, lb: _List_Nil, lS: _List_Nil};
var $author$project$Search$Inactive = {$: 0};
var $Gizra$elm_debouncer$Debouncer$Internal$Config = $elm$core$Basics$identity;
var $Gizra$elm_debouncer$Debouncer$Internal$lastInput = F2(
	function (i, o) {
		return $elm$core$Maybe$Just(i);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$manual = {cx: $Gizra$elm_debouncer$Debouncer$Internal$lastInput, ba: $elm$core$Maybe$Nothing, bb: $elm$core$Maybe$Nothing, br: $elm$core$Maybe$Nothing};
var $Gizra$elm_debouncer$Debouncer$Basic$manual = $Gizra$elm_debouncer$Debouncer$Internal$manual;
var $Gizra$elm_debouncer$Debouncer$Internal$settleWhenQuietFor = F2(
	function (time, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{br: time});
	});
var $Gizra$elm_debouncer$Debouncer$Basic$settleWhenQuietFor = $Gizra$elm_debouncer$Debouncer$Internal$settleWhenQuietFor;
var $Gizra$elm_debouncer$Debouncer$Basic$debounce = function (interval) {
	return A2(
		$Gizra$elm_debouncer$Debouncer$Basic$settleWhenQuietFor,
		$elm$core$Maybe$Just(interval),
		$Gizra$elm_debouncer$Debouncer$Basic$manual);
};
var $Gizra$elm_debouncer$Debouncer$Internal$fromSeconds = function (s) {
	return $elm$core$Basics$round(s * 1000);
};
var $Gizra$elm_debouncer$Debouncer$Basic$fromSeconds = $Gizra$elm_debouncer$Debouncer$Internal$fromSeconds;
var $Gizra$elm_debouncer$Debouncer$Internal$Debouncer = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $Gizra$elm_debouncer$Debouncer$Internal$Settled = {$: 0};
var $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative = $elm$core$Maybe$andThen(
	function (num) {
		return (num < 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(num);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$sanitizeConfig = function (_v0) {
	var config = _v0;
	return {
		cx: config.cx,
		ba: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.ba),
		bb: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.bb),
		br: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.br)
	};
};
var $Gizra$elm_debouncer$Debouncer$Internal$toDebouncer = function (config) {
	return A2(
		$Gizra$elm_debouncer$Debouncer$Internal$Debouncer,
		$Gizra$elm_debouncer$Debouncer$Internal$sanitizeConfig(config),
		$Gizra$elm_debouncer$Debouncer$Internal$Settled);
};
var $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer = $Gizra$elm_debouncer$Debouncer$Internal$toDebouncer;
var $author$project$Search$init = {
	gp: $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer(
		$Gizra$elm_debouncer$Debouncer$Basic$debounce(
			$Gizra$elm_debouncer$Debouncer$Basic$fromSeconds(0.3))),
	hY: $author$project$Form$init(
		{ed: ''}),
	cj: _List_Nil,
	Z: $author$project$Search$Inactive
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Action$NotClaiming = {$: 0};
var $author$project$Action$notClaiming = $author$project$Action$NotClaiming;
var $author$project$Session$LoggedIn$initModel = F5(
	function (shared, lastKnownPin, maybePrivateKey_, accountName, authToken) {
		var _v0 = A3($author$project$Auth$init, lastKnownPin, shared.o9, maybePrivateKey_);
		var authModel = _v0.a;
		var authCmd = _v0.b;
		return _Utils_Tuple2(
			{
				_: accountName,
				ml: authModel,
				jk: authToken,
				eI: $author$project$Action$notClaiming,
				ab: $author$project$Session$LoggedIn$CodeOfConductNotShown,
				mN: $krisajenkins$remotedata$RemoteData$NotAsked,
				hU: $author$project$View$Feedback$Hidden,
				gz: true,
				gC: false,
				b9: false,
				kB: $elm$core$Maybe$Nothing,
				gW: $elm_community$maybe_extra$Maybe$Extra$isNothing(authToken),
				kN: $author$project$Notification$init,
				pl: $krisajenkins$remotedata$RemoteData$Loading,
				ci: _List_Nil,
				g6: _List_Nil,
				al: $author$project$Search$init,
				pC: $krisajenkins$remotedata$RemoteData$Loading,
				A: shared,
				el: false,
				cl: false,
				cm: false,
				bs: false,
				fF: false,
				fG: false,
				fH: false,
				aL: false,
				er: 0,
				hm: 60 * 1000
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Session$LoggedIn$GotAuthMsg, authCmd));
	});
var $author$project$Session$LoggedIn$initLogin = F5(
	function (shared, pin, maybePrivateKey_, profile_, authToken) {
		var loadedProfile = A2(
			$elm$core$Task$perform,
			$author$project$Session$LoggedIn$CompletedLoadProfile,
			$elm$core$Task$succeed(
				$krisajenkins$remotedata$RemoteData$Success(
					$elm$core$Maybe$Just(profile_))));
		var _v0 = A5(
			$author$project$Session$LoggedIn$initModel,
			shared,
			$elm$core$Maybe$Just(pin),
			maybePrivateKey_,
			profile_.l8,
			$elm$core$Maybe$Just(authToken));
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						loadedProfile,
						A2($author$project$Session$LoggedIn$fetchCommunity, model, $elm$core$Maybe$Nothing),
						A2($elm$core$Task$perform, $author$project$Session$LoggedIn$GotTimeInternal, $elm$time$Time$now),
						cmd,
						$author$project$Api$Graphql$createAbsintheSocket(authToken)
					])));
	});
var $author$project$Ports$javascriptOutPort = _Platform_outgoingPort('javascriptOutPort', $elm$core$Basics$identity);
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Ports$javascriptOutCmd = F2(
	function (toJsAddress, _v0) {
		var js = _v0;
		return $author$project$Ports$javascriptOutPort(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'responseAddress',
						A2(
							$elm$json$Json$Encode$list,
							$elm$json$Json$Encode$string,
							toJsAddress(js.fy))),
						_Utils_Tuple2('responseData', js.fz),
						_Utils_Tuple2('data', js.bZ)
					])));
	});
var $author$project$UpdateResult$remoteDataToString = function (r) {
	switch (r.$) {
		case 0:
			return 'NotAsked';
		case 1:
			return 'Loading';
		case 3:
			return 'Success';
		default:
			return 'Failure';
	}
};
var $author$project$UpdateResult$resultToString = function (r) {
	if (!r.$) {
		return 'Ok';
	} else {
		return 'Err';
	}
};
var $author$project$Session$Guest$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedLoadTranslation',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 1:
			return _List_fromArray(
				['ClickedTryAgainTranslation']);
		case 2:
			return _List_fromArray(
				['ShowLanguageNav']);
		case 3:
			return _List_fromArray(
				['ClickedLanguage']);
		case 4:
			return _List_fromArray(
				['PressedEsc']);
		case 5:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadCommunityPreview',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		default:
			return _List_fromArray(
				['GotFeedbackMsg']);
	}
};
var $author$project$Form$DatePicker$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['GotDatePickerMsg']);
		case 2:
			return _List_fromArray(
				['ClickedCalendarIcon']);
		case 3:
			return _List_fromArray(
				['ClickedClear']);
		default:
			return _List_fromArray(
				['ClickedKey']);
	}
};
var $author$project$View$ImageCropper$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['ImageLoaded']);
		case 1:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotImageDimmensions',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 2:
			return _List_fromArray(
				['StartedDragging']);
		case 4:
			return _List_fromArray(
				['Dragged']);
		case 3:
			return _List_fromArray(
				['StoppedDragging']);
		case 5:
			return _List_fromArray(
				['ChangedDimmensions']);
		case 6:
			return _List_fromArray(
				['CompletedChangingDimmensions']);
		case 7:
			return _List_fromArray(
				['ClickedZoomOperation']);
		default:
			return _List_fromArray(
				['GotCroppedImage']);
	}
};
var $author$project$Form$File$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['RequestedUploadFiles']);
		case 1:
			return _List_fromArray(
				['RequestedReplaceFile']);
		case 2:
			return _List_fromArray(
				['CompletedUploadingFile']);
		case 3:
			return _List_fromArray(
				['ClickedEntry']);
		case 4:
			return _List_fromArray(
				['ClickedCloseEntryModal']);
		case 5:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotImageCropperMsg',
				$author$project$View$ImageCropper$msgToString(subMsg));
		case 6:
			return _List_fromArray(
				['DiscoveredFileType']);
		case 7:
			return _List_fromArray(
				['ClickedDeleteEntry']);
		default:
			return _List_fromArray(
				['ClickedSaveEntry']);
	}
};
var $author$project$Form$RichText$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['ClickedIncludeLink']);
		case 2:
			return _List_fromArray(
				['ClosedLinkModal']);
		case 3:
			return _List_fromArray(
				['EnteredLinkLabel']);
		case 4:
			return _List_fromArray(
				['EnteredLinkUrl']);
		case 5:
			return _List_fromArray(
				['ClickedAcceptLink']);
		case 6:
			return _List_fromArray(
				['ChangedText']);
		default:
			return _List_fromArray(
				['ComponentLoaded']);
	}
};
var $author$project$Profile$Summary$msgToString = function (msg) {
	switch (msg) {
		case 0:
			return _List_fromArray(
				['Ignored']);
		case 1:
			return _List_fromArray(
				['OpenedInfo']);
		default:
			return _List_fromArray(
				['ClosedInfo']);
	}
};
var $author$project$Form$UserPicker$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['GotSelectMsg']);
		case 2:
			return _List_fromArray(
				['SelectedUser']);
		case 3:
			var subMsg = msg.b;
			return A2(
				$elm$core$List$cons,
				'GotProfileSummaryMsg',
				$author$project$Profile$Summary$msgToString(subMsg));
		case 4:
			return _List_fromArray(
				['ClickedRemoveProfile']);
		default:
			return _List_fromArray(
				['BlurredPicker']);
	}
};
var $author$project$Form$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 2:
			var subMsg = msg.c;
			return A2(
				$elm$core$List$cons,
				'GotRichTextMsg',
				$author$project$Form$RichText$msgToString(subMsg));
		case 3:
			var subMsg = msg.d;
			return A2(
				$elm$core$List$cons,
				'GotFileMsg',
				$author$project$Form$File$msgToString(subMsg));
		case 4:
			var subMsg = msg.e;
			return A2(
				$elm$core$List$cons,
				'GotDatePickerMsg',
				$author$project$Form$DatePicker$msgToString(subMsg));
		case 5:
			var subMsg = msg.e;
			return A2(
				$elm$core$List$cons,
				'GotUserPickerMsg',
				$author$project$Form$UserPicker$msgToString(subMsg));
		case 1:
			return _List_fromArray(
				['ChangedValues']);
		case 6:
			return _List_fromArray(
				['BlurredField']);
		default:
			return _List_fromArray(
				['ClickedSubmitWithErrors']);
	}
};
var $author$project$Action$claimingActionMsgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['ClickedCloseClaimModal']);
		case 1:
			return _List_fromArray(
				['ConfirmedClaimAction']);
		case 2:
			return _List_fromArray(
				['ConfirmedClaimActionWithPhotoProof']);
		case 3:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPhotoProofFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 4:
			return _List_fromArray(
				['GotUint64Name']);
		default:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedClaimingAction',
					$author$project$UpdateResult$resultToString(r)
				]);
	}
};
var $author$project$Action$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['ClickedClaimAction']);
		case 2:
			return _List_fromArray(
				['ClickedShareAction']);
		case 3:
			return _List_fromArray(
				['CopiedShareLinkToClipboard']);
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotClaimingActionMsg',
				$author$project$Action$claimingActionMsgToString(subMsg));
	}
};
var $author$project$View$Pin$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['Ignored']);
		case 1:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 2:
			return _List_fromArray(
				['SubmittedForm']);
		default:
			return _List_fromArray(
				['ToggledPinVisibility']);
	}
};
var $author$project$Auth$msgToString = function (msg) {
	switch (msg.$) {
		case 1:
			return _List_fromArray(
				['SubmittedPin']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotPrivateKey',
					$author$project$UpdateResult$resultToString(r)
				]);
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPinMsg',
				$author$project$View$Pin$msgToString(subMsg));
	}
};
var $author$project$Session$LoggedIn$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 25:
			return _List_fromArray(
				['GotTimeInternal']);
		case 23:
			return _List_fromArray(
				['ClickedNavLink']);
		case 24:
			return _List_fromArray(
				['ClosedSearch']);
		case 21:
			return _List_fromArray(
				['GotSearchMsg']);
		case 22:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotActionMsg',
				$author$project$Action$msgToString(subMsg));
		case 1:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedLoadTranslation',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 2:
			return _List_fromArray(
				['ClickedTryAgainTranslation']);
		case 3:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadProfile',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 4:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadCommunity',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 5:
			return _List_fromArray(
				['CompletedLoadCommunityField']);
		case 6:
			return _List_fromArray(
				['CompletedLoadCommunityFields']);
		case 7:
			return _List_fromArray(
				['ClickedTryAgainProfile']);
		case 8:
			return _List_fromArray(
				['ClickedLogout']);
		case 9:
			return _List_fromArray(
				['ShowUserNav']);
		case 10:
			return _List_fromArray(
				['ToggleLanguageItems']);
		case 11:
			return _List_fromArray(
				['ClickedLanguage']);
		case 12:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedSendingLanguagePreference',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 13:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 14:
			return _List_fromArray(
				['ClosedInsufficientPermissionsModal']);
		case 15:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotAuthMsg',
				$author$project$Auth$msgToString(subMsg));
		case 16:
			return _List_fromArray(
				['CompletedLoadUnread']);
		case 17:
			return _List_fromArray(
				['OpenCommunitySelector']);
		case 18:
			return _List_fromArray(
				['CloseCommunitySelector']);
		case 19:
			return _List_fromArray(
				['SelectedCommunity']);
		case 20:
			return _List_fromArray(
				['GotFeedbackMsg']);
		case 26:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadContributionCount',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 28:
			return _List_fromArray(
				['ClosedHighlightedNews']);
		case 27:
			return _List_fromArray(
				['ClickedReadHighlightedNews']);
		case 29:
			return _List_fromArray(
				['ReceivedNewHighlightedNews']);
		case 30:
			return _List_fromArray(
				['RequestedNewAuthTokenPhrase']);
		case 31:
			return _List_fromArray(
				['RequestedNewAuthTokenPhraseExternal']);
		case 32:
			var r = msg.b;
			return _List_fromArray(
				[
					'GotAuthTokenPhrase',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 33:
			var r = msg.b;
			return _List_fromArray(
				[
					'GotAuthTokenPhraseExternal',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 34:
			return _List_fromArray(
				['SignedAuthTokenPhrase']);
		case 35:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedGeneratingAuthToken',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 36:
			var r = msg.a;
			return _List_fromArray(
				[
					'RequestedQuery',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 37:
			var r = msg.a;
			return _List_fromArray(
				[
					'RequestedQueryInternal',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 38:
			return _List_fromArray(
				['ClickedAcceptCodeOfConduct']);
		case 39:
			return _List_fromArray(
				['ClickedDenyCodeOfConduct']);
		case 40:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedAcceptingCodeOfConduct',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 41:
			return _List_fromArray(
				['EndedCodeOfConductWarningAnimation']);
		case 42:
			return _List_fromArray(
				['ClickedOpenCommunityContactsModal']);
		default:
			return _List_fromArray(
				['ClosedCommunityContactsModal']);
	}
};
var $author$project$Page$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['Ignored']);
		case 1:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedLoadTranslation',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotTimezone',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 3:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotGuestMsg',
				$author$project$Session$Guest$msgToString(subMsg));
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotLoggedInMsg',
				$author$project$Session$LoggedIn$msgToString(subMsg));
	}
};
var $author$project$Page$Community$About$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotTokenInfo',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 3:
			return _List_fromArray(
				['ClickedShareCommunity']);
		default:
			return _List_fromArray(
				['CopiedShareLinkToClipboard']);
	}
};
var $author$project$Page$Community$Invite$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadInvite',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 1:
			return _List_fromArray(
				['CompletedLoadProfile']);
		case 2:
			return _List_fromArray(
				['OpenConfirmationModal']);
		case 3:
			return _List_fromArray(
				['CloseConfirmationModal']);
		case 4:
			return _List_fromArray(
				['InvitationRejected']);
		case 5:
			return _List_fromArray(
				['InvitationAccepted']);
		case 7:
			return _List_fromArray(
				['FormMsg']);
		default:
			return _List_fromArray(
				['SignedIn']);
	}
};
var $author$project$Page$Community$New$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 1:
			return _List_fromArray(
				['SelectedEntry']);
		case 2:
			return _List_fromArray(
				['SubmittedForm']);
		case 3:
			var r = msg.b;
			return _List_fromArray(
				[
					'GotDomainAvailableResponse',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 4:
			return _List_fromArray(
				['StartedCreatingCommunity']);
		case 5:
			return _List_fromArray(
				['GotCreateCommunityResponse']);
		case 6:
			return _List_fromArray(
				['Redirect']);
		default:
			return _List_fromArray(
				['ClosedAuthModal']);
	}
};
var $author$project$Page$Community$Objectives$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadObjectives']);
		case 2:
			return _List_fromArray(
				['ClickedToggleObjectiveVisibility']);
		case 3:
			return _List_fromArray(
				['FinishedOpeningActions']);
		case 4:
			return _List_fromArray(
				['FinishedClosingObjective']);
		case 5:
			return _List_fromArray(
				['GotObjectiveDetailsHeight']);
		case 6:
			return _List_fromArray(
				['GotObjectiveSummaryHeight']);
		case 7:
			return _List_fromArray(
				['GotVisibleActionViewport']);
		case 8:
			return _List_fromArray(
				['ClickedScrollToAction']);
		case 9:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotActionMsg',
				$author$project$Action$msgToString(subMsg));
		case 10:
			return _List_fromArray(
				['StartedIntersecting']);
		default:
			return _List_fromArray(
				['StoppedIntersecting']);
	}
};
var $author$project$Page$Community$Settings$ActionEditor$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadObjectives']);
		case 2:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 3:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 4:
			return _List_fromArray(
				['SubmittedForm']);
		case 5:
			return _List_fromArray(
				['ClickedToggleCompleted']);
		default:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedSavingAction',
					$author$project$UpdateResult$resultToString(r)
				]);
	}
};
var $author$project$Page$Community$Settings$Contacts$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 1:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 2:
			return _List_fromArray(
				['SubmittedForm']);
		default:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedSubmittingForm',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
	}
};
var $author$project$Page$Community$Settings$Currency$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 1:
			return _List_fromArray(
				['ClickedSubmit']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotSubmitResponse',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 3:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 4:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadExpiryOpts',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 5:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadToken',
					$author$project$UpdateResult$resultToString(r)
				]);
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
	}
};
var $author$project$Page$Community$Settings$Features$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 2:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 3:
			return _List_fromArray(
				['ToggleShop']);
		case 4:
			return _List_fromArray(
				['ToggleObjectives']);
		case 5:
			return _List_fromArray(
				['ToggleKyc']);
		case 6:
			return _List_fromArray(
				['ToggleSponsorship']);
		case 7:
			return _List_fromArray(
				['ToggleNews']);
		default:
			return _List_fromArray(
				['SaveSuccess']);
	}
};
var $author$project$Page$Community$Settings$Info$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 1:
			return _List_fromArray(
				['CompletedLoadUploads']);
		case 2:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 3:
			return _List_fromArray(
				['ClickedSave']);
		case 4:
			var r = msg.b;
			return _List_fromArray(
				[
					'GotDomainAvailableResponse',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 5:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedAddingCoverPhoto',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 6:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotSaveResponse',
					$author$project$UpdateResult$resultToString(r)
				]);
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
	}
};
var $author$project$Page$Community$Settings$News$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 2:
			return _List_fromArray(
				['ToggledHighlightNews']);
		case 3:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedSettingHighlightedNews',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 4:
			return _List_fromArray(
				['ClosedHighlightNewsConfirmationModal']);
		default:
			return _List_fromArray(
				['ConfirmedHighlightNews']);
	}
};
var $author$project$Page$Community$Settings$News$Editor$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 1:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadNews',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 2:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 3:
			return _List_fromArray(
				['SubmittedForm']);
		default:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedSaving',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
	}
};
var $author$project$Page$Community$Settings$ObjectiveEditor$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 1:
			return _List_fromArray(
				['CompletedLoadObjectives']);
		case 2:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 4:
			return _List_fromArray(
				['ClickedSaveObjective']);
		case 5:
			return _List_fromArray(
				['ClickedCompleteObjective']);
		case 6:
			return _List_fromArray(
				['DeniedCompleteObjective']);
		case 7:
			return _List_fromArray(
				['AcceptedCompleteObjective']);
		case 8:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotCompleteActionResponse',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 9:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotCompleteObjectiveResponse',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 10:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotSaveObjectiveResponse',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 3:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		default:
			return _List_fromArray(
				['ClosedCelebrateObjectiveModal']);
	}
};
var $author$project$Page$Community$Settings$Objectives$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 1:
			return _List_fromArray(
				['OpenObjective']);
		default:
			var subMsg = msg.c;
			return A2(
				$elm$core$List$cons,
				'GotProfileSummaryMsg',
				$author$project$Profile$Summary$msgToString(subMsg));
	}
};
var $author$project$Page$Community$Settings$Settings$msgToString = function (msg) {
	if (!msg.$) {
		return _List_fromArray(
			['CompletedLoadCommunity']);
	} else {
		return _List_fromArray(
			['RequestedReloadCommunity']);
	}
};
var $author$project$Dnd$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['StartedDragging']);
		case 1:
			return _List_fromArray(
				['StoppedDragging']);
		case 2:
			return _List_fromArray(
				['DroppedOn']);
		case 3:
			return _List_fromArray(
				['DragLeft']);
		default:
			return _List_fromArray(
				['DraggedOverInternal']);
	}
};
var $author$project$Page$Community$Settings$Shop$Categories$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['PressedEsc']);
		case 2:
			return _List_fromArray(
				['ClickedToggleExpandCategory']);
		case 3:
			return _List_fromArray(
				['ClickedAddCategory']);
		case 4:
			return _List_fromArray(
				['ClickedCancelAddCategory']);
		case 5:
			return _List_fromArray(
				['ClickedEditCategory']);
		case 6:
			return _List_fromArray(
				['ClosedCategoryModal']);
		case 7:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotAddCategoryFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 10:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotUpdateCategoryFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 8:
			return _List_fromArray(
				['SubmittedAddCategoryForm']);
		case 9:
			var r = msg.a;
			return _List_fromArray(
				[
					'FinishedCreatingCategory',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 11:
			return _List_fromArray(
				['SubmittedUpdateCategoryForm']);
		case 12:
			var r = msg.a;
			return _List_fromArray(
				[
					'FinishedUpdatingCategory',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 13:
			return _List_fromArray(
				['ClickedDeleteCategory']);
		case 14:
			return _List_fromArray(
				['ClosedConfirmDeleteModal']);
		case 15:
			return _List_fromArray(
				['ConfirmedDeleteCategory']);
		case 16:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedDeletingCategory',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 17:
			return _List_fromArray(
				['ClickedShowActionsDropdown']);
		case 18:
			return _List_fromArray(
				['OpenedContextMenuForAction']);
		case 19:
			return _List_fromArray(
				['GotViewportForContextMenuForAction']);
		case 20:
			return _List_fromArray(
				['ClosedActionsDropdown']);
		case 21:
			return _List_fromArray(
				['ClickedOpenMetadataModal']);
		case 22:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotMetadataFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 23:
			return _List_fromArray(
				['SubmittedMetadataForm']);
		case 24:
			return _List_fromArray(
				['ClosedMetadataModal']);
		case 25:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotDndMsg',
				$author$project$Dnd$msgToString(subMsg));
		case 26:
			return _List_fromArray(
				['DraggedOverCategoryForAWhile']);
		case 27:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedMovingCategory',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 28:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedMovingCategoryToRoot',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 29:
			return _List_fromArray(
				['ClickedMoveUp']);
		case 30:
			return _List_fromArray(
				['ClickedMoveDown']);
		case 31:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotKeywordDndMsg',
				$author$project$Dnd$msgToString(subMsg));
		default:
			return _List_fromArray(
				['ClickedRemoveMetaKeyword']);
	}
};
var $author$project$Page$Community$Settings$Sponsorship$msgToString = function (msg) {
	if (!msg.$) {
		return _List_fromArray(
			['NoOp']);
	} else {
		return _List_fromArray(
			['CompletedLoadCommunity']);
	}
};
var $author$project$Page$Community$Settings$Sponsorship$Fiat$msgToString = function (msg) {
	if (!msg.$) {
		return _List_fromArray(
			['NoOp']);
	} else {
		return _List_fromArray(
			['CompletedLoadCommunity']);
	}
};
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
	}
};
var $author$project$Page$Community$Sponsor$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 2:
			return _List_fromArray(
				['RequestedPaypalInfoFromJs']);
		case 3:
			return _List_fromArray(
				['StartedCreatingContribution']);
		case 4:
			return _List_fromArray(
				['CreatedContribution']);
		case 5:
			return _List_fromArray(
				['PaypalApproved']);
		case 6:
			return _List_fromArray(
				['PaypalCanceled']);
		case 7:
			return _List_fromArray(
				['PaypalErrored']);
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
	}
};
var $author$project$Page$Community$Supporters$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadContributions']);
		default:
			var subMsg = msg.b;
			return A2(
				$elm$core$List$cons,
				'GotProfileSummaryMsg',
				$author$project$Profile$Summary$msgToString(subMsg));
	}
};
var $author$project$Page$Community$Transfer$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 1:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadBalance',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadToken',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 3:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 4:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 5:
			return _List_fromArray(
				['SubmittedForm']);
		case 6:
			return _List_fromArray(
				['CreatedTransferSubscription']);
		case 7:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotTransferTransactionResult',
					$author$project$UpdateResult$resultToString(r)
				]);
		default:
			return _List_fromArray(
				['GotTransferResultFromWebSocket']);
	}
};
var $author$project$Page$Dashboard$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 2:
			var result = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadBalance',
					$author$project$UpdateResult$resultToString(result)
				]);
		case 3:
			var result = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadUserTransfers',
					$author$project$UpdateResult$remoteDataToString(result)
				]);
		case 4:
			var result = msg.a;
			return _List_fromArray(
				[
					'ClaimsLoaded',
					$author$project$UpdateResult$remoteDataToString(result)
				]);
		case 5:
			return _List_fromArray(
				['GotTransferCardProfileSummaryMsg']);
		case 6:
			return _List_fromArray(
				['RequestedMoreTransfers']);
		case 7:
			return _List_fromArray(
				['ClickedOpenTransferFilters']);
		case 8:
			return _List_fromArray(
				['ClosedTransfersFilters']);
		case 9:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotTransfersFiltersFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 10:
			return _List_fromArray(
				['SubmittedTransfersFiltersForm']);
		case 11:
			return _List_fromArray(
				['ClickedTransferCard']);
		case 12:
			return _List_fromArray(
				['ClickedSupportUsButton']);
		case 13:
			return _List_fromArray(
				['CreateInvite']);
		case 14:
			return _List_fromArray(
				['GotContactMsg']);
		case 15:
			return _List_fromArray(
				['ClosedAddContactModal']);
		case 16:
			return _List_fromArray(
				['CloseInviteModal']);
		case 17:
			return _List_fromArray(
				['CompletedInviteCreation']);
		case 18:
			return _List_fromArray(
				['CopyToClipboard']);
		case 19:
			return _List_fromArray(
				['CopiedToClipboard']);
		case 20:
			return _List_fromArray(
				['ClosedModalRequestingSponsor']);
		default:
			return _List_fromArray(
				['ClickedAcceptCodeOfConduct']);
	}
};
var $author$project$Page$Dashboard$Analysis$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.b;
			return _List_fromArray(
				[
					'ClaimsLoaded',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 1:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 2:
			return _List_fromArray(
				['ClaimMsg']);
		case 3:
			var claimId = msg.a;
			return _List_fromArray(
				[
					'VoteClaim',
					$elm$core$String$fromInt(claimId)
				]);
		case 4:
			var r = msg.b;
			return _List_fromArray(
				[
					'GotVoteResult',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 5:
			return _List_fromArray(
				['OpenedFilterModal']);
		case 6:
			return _List_fromArray(
				['ClosedFilterModal']);
		case 7:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFilterFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 8:
			return _List_fromArray(
				['SubmittedFilterForm']);
		case 9:
			return _List_fromArray(
				['SelectedTab']);
		case 10:
			return _List_fromArray(
				['ShowMore']);
		case 12:
			return _List_fromArray(
				['ClearFilters']);
		default:
			return _List_fromArray(
				['ToggleSorting']);
	}
};
var $author$project$Page$Dashboard$Claim$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.a;
			return _List_fromArray(
				[
					'ClaimLoaded',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 1:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 2:
			var claimId = msg.a;
			return _List_fromArray(
				[
					'VoteClaim',
					$elm$core$String$fromInt(claimId)
				]);
		case 3:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotVoteResult',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 4:
			return _List_fromArray(
				['ClaimMsg']);
		default:
			var subMsg = msg.b;
			return A2(
				$elm$core$List$cons,
				'GotProfileSummaryMsg',
				$author$project$Profile$Summary$msgToString(subMsg));
	}
};
var $author$project$Page$Join$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['ClickedJoinCommunity']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		default:
			return _List_fromArray(
				['SignedIn']);
	}
};
var $author$project$Page$Login$passphraseMsgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['PassphraseIgnored']);
		case 1:
			return _List_fromArray(
				['ClickedPaste']);
		case 2:
			return _List_fromArray(
				['GotClipboardResponse']);
		case 3:
			return _List_fromArray(
				['ScrolledTextArea']);
		case 4:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPassphraseFormMsg',
				$author$project$Form$msgToString(subMsg));
		default:
			return _List_fromArray(
				['ClickedNextStep']);
	}
};
var $author$project$Page$Login$pinMsgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['PinIgnored']);
		case 1:
			return _List_fromArray(
				['SubmittedPinWithSuccess']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotAccountName',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 3:
			return _List_fromArray(
				['GeneratedAuthPhrase']);
		case 4:
			return _List_fromArray(
				['SignedAuthPhrase']);
		case 5:
			var r = msg.c;
			return _List_fromArray(
				[
					'GotSignInResult',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPinComponentMsg',
				$author$project$View$Pin$msgToString(subMsg));
	}
};
var $author$project$Page$Login$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['WentToPin']);
		case 1:
			var passphraseMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPassphraseMsg',
				$author$project$Page$Login$passphraseMsgToString(passphraseMsg));
		case 2:
			var pinMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPinMsg',
				$author$project$Page$Login$pinMsgToString(pinMsg));
		default:
			return _List_fromArray(
				['GotBip39']);
	}
};
var $author$project$Page$News$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadNews']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedMarkingNewsAsRead',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 3:
			return _List_fromArray(
				['ClickedToggleReactions']);
		case 4:
			return _List_fromArray(
				['ToggledReaction']);
		case 5:
			return _List_fromArray(
				['CompletedTogglingReaction']);
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotLastEditorSummaryMsg',
				$author$project$Profile$Summary$msgToString(subMsg));
	}
};
var $author$project$Page$Notification$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadNotificationHistory',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 1:
			return _List_fromArray(
				['MarkAsRead']);
		default:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedReading',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
	}
};
var $author$project$Page$PaymentHistory$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 6:
			return _List_fromArray(
				['ShowMore']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'RecipientProfileWithTransfersLoaded',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 3:
			var r = msg.a;
			return _List_fromArray(
				[
					'AutocompleteProfilesLoaded',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 4:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotUserPickerMsg',
				$author$project$Form$UserPicker$msgToString(subMsg));
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotDatePickerMsg',
				$author$project$Form$DatePicker$msgToString(subMsg));
	}
};
var $author$project$Page$Profile$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadProfile',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 2:
			return _List_fromArray(
				['CompletedLoadContributions']);
		case 3:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadBalance',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 4:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadGraphqlInfo',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 5:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadUserTransfers',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 6:
			var subMsg = msg.b;
			return A2(
				$elm$core$List$cons,
				'GotTransferCardProfileSummaryMsg',
				$author$project$Profile$Summary$msgToString(subMsg));
		case 7:
			return _List_fromArray(
				['ClickedTransferCard']);
		default:
			return _List_fromArray(
				['RequestedMoreTransfers']);
	}
};
var $author$project$Page$Profile$AddContact$msgToString = function (msg) {
	if (msg.$ === 1) {
		return _List_fromArray(
			['CompletedLoadProfile']);
	} else {
		return _List_fromArray(
			['GotContactMsg']);
	}
};
var $author$project$Page$Profile$AddKyc$msgToString = function (msg) {
	return _List_fromArray(
		['FormMsg']);
};
var $author$project$Page$Profile$Claims$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			var r = msg.a;
			return _List_fromArray(
				[
					'ClaimsLoaded',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 2:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 3:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 4:
			return _List_fromArray(
				['ClaimMsg']);
		case 5:
			var claimId = msg.a;
			return _List_fromArray(
				[
					'VoteClaim',
					$elm$core$String$fromInt(claimId)
				]);
		case 6:
			var r = msg.b;
			return _List_fromArray(
				[
					'GotVoteResult',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 7:
			return _List_fromArray(
				['SelectedTab']);
		case 8:
			return _List_fromArray(
				['OpenedFilterModal']);
		case 9:
			return _List_fromArray(
				['ClosedFilterModal']);
		case 10:
			return _List_fromArray(
				['ToggledSorting']);
		case 11:
			return _List_fromArray(
				['SelectedStatusFilter']);
		case 12:
			return _List_fromArray(
				['ClickedApplyFilters']);
		default:
			return _List_fromArray(
				['ClickedAcceptCodeOfConduct']);
	}
};
var $author$project$Page$Profile$Contributions$msgToString = function (msg) {
	if (!msg.$) {
		return _List_fromArray(
			['CompletedLoadCommunity']);
	} else {
		var r = msg.a;
		return _List_fromArray(
			[
				'CompletedLoadContributions',
				$author$project$UpdateResult$remoteDataToString(r)
			]);
	}
};
var $author$project$Page$Profile$Editor$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['CompletedLoadProfile']);
		case 1:
			return _List_fromArray(
				['ClickedSave']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotSaveResult',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
	}
};
var $author$project$Page$Register$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 2:
			return _List_fromArray(
				['GotAccountAvailabilityResponse']);
		case 3:
			var r = msg.b;
			return _List_fromArray(
				[
					'AccountKeysGenerated',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 4:
			return _List_fromArray(
				['AgreedToSave12Words']);
		case 7:
			return _List_fromArray(
				['CopyToClipboard']);
		case 8:
			return _List_fromArray(
				['CopiedToClipboard']);
		case 5:
			return _List_fromArray(
				['DownloadPdf']);
		case 6:
			return _List_fromArray(
				['PdfDownloaded']);
		case 9:
			return _List_fromArray(
				['CompletedLoadInvite']);
		case 11:
			return _List_fromArray(
				['AccountTypeSelected']);
		case 12:
			return _List_fromArray(
				['CompletedSignUp']);
		case 10:
			return _List_fromArray(
				['CompletedLoadCountry']);
		case 13:
			var subMsg = msg.a;
			var formMsgToString = function () {
				switch (subMsg.$) {
					case 0:
						var innerMsg = subMsg.a;
						return $author$project$Form$msgToString(innerMsg);
					case 1:
						var innerMsg = subMsg.a;
						return $author$project$Form$msgToString(innerMsg);
					default:
						var innerMsg = subMsg.a;
						return $author$project$Form$msgToString(innerMsg);
				}
			}();
			return A2($elm$core$List$cons, 'GotFormMsg', formMsgToString);
		default:
			return _List_fromArray(
				['SubmittedForm']);
	}
};
var $author$project$Page$Settings$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['ClickedDownloadPdf']);
		case 2:
			return _List_fromArray(
				['ClickedExportToSimpleos']);
		case 3:
			return _List_fromArray(
				['ClickedCopyPrivateKey']);
		case 4:
			return _List_fromArray(
				['CopiedPrivateKey']);
		case 5:
			return _List_fromArray(
				['ClosedExportToSimpleosModal']);
		case 6:
			return _List_fromArray(
				['ClickedChangePin']);
		case 7:
			return _List_fromArray(
				['ClosedNewPinModal']);
		case 8:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPinMsg',
				$author$project$View$Pin$msgToString(subMsg));
		case 9:
			return _List_fromArray(
				['SubmittedNewPin']);
		case 10:
			return _List_fromArray(
				['ChangedToNewPin']);
		case 11:
			return _List_fromArray(
				['ClickedDeleteKyc']);
		case 12:
			return _List_fromArray(
				['ClosedDeleteKycModal']);
		case 13:
			return _List_fromArray(
				['AcceptedDeleteKyc']);
		case 14:
			var r = msg.a;
			return _List_fromArray(
				[
					'FinishedDeletingKyc',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 15:
			return _List_fromArray(
				['ToggledClaimNotification']);
		case 16:
			return _List_fromArray(
				['ToggledTransferNotification']);
		case 17:
			return _List_fromArray(
				['ToggledDigestNotification']);
		default:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedTogglingNotification',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
	}
};
var $author$project$Page$Shop$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadingShopCategories']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedSalesLoad',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 3:
			return _List_fromArray(
				['CompletedLoadBalances']);
		case 4:
			return _List_fromArray(
				['ClickedAcceptCodeOfConduct']);
		case 5:
			return _List_fromArray(
				['ClickedScrollToImage']);
		case 6:
			return _List_fromArray(
				['ImageStartedIntersecting']);
		case 7:
			return _List_fromArray(
				['ImageStoppedIntersecting']);
		case 8:
			return _List_fromArray(
				['ClickedOpenFiltersModal']);
		case 9:
			return _List_fromArray(
				['ClosedFiltersModal']);
		case 10:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFiltersFormMsg',
				$author$project$Form$msgToString(subMsg));
		default:
			return _List_fromArray(
				['SubmittedFiltersForm']);
	}
};
var $author$project$Page$Shop$Editor$formMsgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'MainInformationMsg',
				$author$project$Form$msgToString(subMsg));
		case 1:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'ImagesMsg',
				$author$project$Form$msgToString(subMsg));
		case 2:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'CategoriesMsg',
				$author$project$Form$msgToString(subMsg));
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'PriceAndInventoryMsg',
				$author$project$Form$msgToString(subMsg));
	}
};
var $author$project$Page$Shop$Editor$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedSaleLoad',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 8:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotSaveResponse',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 3:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Page$Shop$Editor$formMsgToString(subMsg));
		case 4:
			return _List_fromArray(
				['SubmittedMainInformation']);
		case 5:
			return _List_fromArray(
				['SubmittedImages']);
		case 6:
			return _List_fromArray(
				['SubmittedCategories']);
		case 7:
			return _List_fromArray(
				['SubmittedPriceAndInventory']);
		case 9:
			return _List_fromArray(
				['ClickedDecrementStockUnits']);
		default:
			return _List_fromArray(
				['ClickedIncrementStockUnits']);
	}
};
var $author$project$Page$Shop$Viewer$formInteractionMsgToString = function (msg) {
	if (!msg) {
		return _List_fromArray(
			['ClickedDecrementUnits']);
	} else {
		return _List_fromArray(
			['ClickedIncrementUnits']);
	}
};
var $author$project$Page$Shop$Viewer$guestMsgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedSalePreviewLoad',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 1:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormInteractionMsgAsGuest',
				$author$project$Page$Shop$Viewer$formInteractionMsgToString(subMsg));
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsgAsGuest',
				$author$project$Form$msgToString(subMsg));
	}
};
var $author$project$Page$Shop$Viewer$loggedInMsgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 1:
			return _List_fromArray(
				['CompletedSaleLoad']);
		case 5:
			return _List_fromArray(
				['GotTransferResult']);
		case 3:
			return _List_fromArray(
				['ClickedTransfer']);
		case 4:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 2:
			return _List_fromArray(
				['CompletedLoadBalances']);
		case 6:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormInteractionMsg',
				$author$project$Page$Shop$Viewer$formInteractionMsgToString(subMsg));
		case 7:
			return _List_fromArray(
				['ClickedEditSale']);
		case 8:
			return _List_fromArray(
				['ClosedEditSaleModal']);
		case 9:
			return _List_fromArray(
				['ClickedDelete']);
		case 10:
			return _List_fromArray(
				['ClosedConfirmDeleteModal']);
		case 11:
			return _List_fromArray(
				['ClickedConfirmDelete']);
		default:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedDeleteProduct',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
	}
};
var $author$project$Page$Shop$Viewer$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['ClickedScrollToImage']);
		case 2:
			return _List_fromArray(
				['ImageStartedIntersecting']);
		case 3:
			return _List_fromArray(
				['ImageStoppedIntersecting']);
		case 4:
			return _List_fromArray(
				['ClickedOpenDetails']);
		case 5:
			return _List_fromArray(
				['ClosedDetailsModal']);
		case 6:
			return _List_fromArray(
				['ClickedShareOffer']);
		case 7:
			return _List_fromArray(
				['CopiedToClipboard']);
		case 8:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'AsGuestMsg',
				$author$project$Page$Shop$Viewer$guestMsgToString(subMsg));
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'AsLoggedInMsg',
				$author$project$Page$Shop$Viewer$loggedInMsgToString(subMsg));
	}
};
var $author$project$Page$ViewTransfer$msgToString = function (msg) {
	if (!msg.$) {
		var r = msg.a;
		return _List_fromArray(
			[
				'CompletedTransferLoad',
				$author$project$UpdateResult$remoteDataToString(r)
			]);
	} else {
		var subMsg = msg.b;
		return A2(
			$elm$core$List$cons,
			'GotProfileSummaryMsg',
			$author$project$Profile$Summary$msgToString(subMsg));
	}
};
var $author$project$Main$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['Ignored']);
		case 1:
			return _List_fromArray(
				['ChangedUrl']);
		case 2:
			return _List_fromArray(
				['ClickedLink']);
		case 3:
			return _List_fromArray(
				['GotJavascriptData']);
		case 4:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPageMsg',
				$author$project$Page$msgToString(subMsg));
		case 6:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunityAboutMsg',
				$author$project$Page$Community$About$msgToString(subMsg));
		case 7:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunityObjectivesMsg',
				$author$project$Page$Community$Objectives$msgToString(subMsg));
		case 8:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunityEditorMsg',
				$author$project$Page$Community$New$msgToString(subMsg));
		case 9:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsMsg',
				$author$project$Page$Community$Settings$Settings$msgToString(subMsg));
		case 10:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsShopCategoriesMsg',
				$author$project$Page$Community$Settings$Shop$Categories$msgToString(subMsg));
		case 11:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsFeaturesMsg',
				$author$project$Page$Community$Settings$Features$msgToString(subMsg));
		case 12:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsInfoMsg',
				$author$project$Page$Community$Settings$Info$msgToString(subMsg));
		case 13:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsNewsMsg',
				$author$project$Page$Community$Settings$News$msgToString(subMsg));
		case 14:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsNewsEditorMsg',
				$author$project$Page$Community$Settings$News$Editor$msgToString(subMsg));
		case 15:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsCurrencyMsg',
				$author$project$Page$Community$Settings$Currency$msgToString(subMsg));
		case 16:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsSponsorshipMsg',
				$author$project$Page$Community$Settings$Sponsorship$msgToString(subMsg));
		case 17:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsSponsorshipFiatMsg',
				$author$project$Page$Community$Settings$Sponsorship$Fiat$msgToString(subMsg));
		case 18:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsSponsorshipThankYouMessageMsg',
				$author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$msgToString(subMsg));
		case 19:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySponsorMsg',
				$author$project$Page$Community$Sponsor$msgToString(subMsg));
		case 20:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySupportersMsg',
				$author$project$Page$Community$Supporters$msgToString(subMsg));
		case 21:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsObjectivesMsg',
				$author$project$Page$Community$Settings$Objectives$msgToString(subMsg));
		case 22:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsObjectiveEditorMsg',
				$author$project$Page$Community$Settings$ObjectiveEditor$msgToString(subMsg));
		case 23:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsActionEditorMsg',
				$author$project$Page$Community$Settings$ActionEditor$msgToString(subMsg));
		case 24:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunitySettingsContactsMsg',
				$author$project$Page$Community$Settings$Contacts$msgToString(subMsg));
		case 25:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotVerifyClaimMsg',
				$author$project$Page$Dashboard$Claim$msgToString(subMsg));
		case 5:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotNotificationMsg',
				$author$project$Page$Notification$msgToString(subMsg));
		case 26:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotDashboardMsg',
				$author$project$Page$Dashboard$msgToString(subMsg));
		case 27:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotLoginMsg',
				$author$project$Page$Login$msgToString(subMsg));
		case 28:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotNewsMsg',
				$author$project$Page$News$msgToString(subMsg));
		case 29:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPaymentHistoryMsg',
				$author$project$Page$PaymentHistory$msgToString(subMsg));
		case 30:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotProfileMsg',
				$author$project$Page$Profile$msgToString(subMsg));
		case 31:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotProfileContributionsMsg',
				$author$project$Page$Profile$Contributions$msgToString(subMsg));
		case 32:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotProfileEditorMsg',
				$author$project$Page$Profile$Editor$msgToString(subMsg));
		case 33:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotProfileAddKycMsg',
				$author$project$Page$Profile$AddKyc$msgToString(subMsg));
		case 34:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotProfileClaimsMsg',
				$author$project$Page$Profile$Claims$msgToString(subMsg));
		case 35:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotProfileAddContactMsg',
				$author$project$Page$Profile$AddContact$msgToString(subMsg));
		case 36:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotRegisterMsg',
				$author$project$Page$Register$msgToString(subMsg));
		case 37:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotSettingsMsg',
				$author$project$Page$Settings$msgToString(subMsg));
		case 38:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotShopMsg',
				$author$project$Page$Shop$msgToString(subMsg));
		case 39:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotShopEditorMsg',
				$author$project$Page$Shop$Editor$msgToString(subMsg));
		case 40:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotShopViewerMsg',
				$author$project$Page$Shop$Viewer$msgToString(subMsg));
		case 41:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotViewTransferScreenMsg',
				$author$project$Page$ViewTransfer$msgToString(subMsg));
		case 42:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotInviteMsg',
				$author$project$Page$Community$Invite$msgToString(subMsg));
		case 43:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotJoinMsg',
				$author$project$Page$Join$msgToString(subMsg));
		case 44:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotTransferMsg',
				$author$project$Page$Community$Transfer$msgToString(subMsg));
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotAnalysisMsg',
				$author$project$Page$Dashboard$Analysis$msgToString(subMsg));
	}
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Route$pushUrl = F2(
	function (key, route) {
		return A2(
			$elm$browser$Browser$Navigation$pushUrl,
			key,
			$author$project$Route$routeToString(route));
	});
var $author$project$Log$contextFromLocation = function (location) {
	return {
		ng: $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'module',
					$elm$json$Json$Encode$string(location.fi)),
					_Utils_Tuple2(
					'function',
					$elm$json$Json$Encode$string(location.e$))
				])),
		fj: 'Location'
	};
};
var $author$project$Log$encodeContext = function (context) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(context.fj)),
				_Utils_Tuple2(
				'extras',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity, context.ng))
			]));
};
var $author$project$Log$encodeTag = function (tag) {
	if (!tag.$) {
		var errorType = tag.a;
		var value = function () {
			switch (errorType) {
				case 0:
					return 'incompatible msg';
				case 1:
					return 'impossible error';
				case 2:
					return 'decoding error';
				case 3:
					return 'http error';
				case 4:
					return 'graphql error';
				case 5:
					return 'unknown error';
				case 6:
					return 'json value';
				case 7:
					return 'unsupported feature';
				default:
					return 'paypal error';
			}
		}();
		return _Utils_Tuple2(
			'cambiatus.type',
			$elm$json$Json$Encode$string(value));
	} else {
		var expectedAuthentication = tag.a;
		var value = function () {
			if (expectedAuthentication === 1) {
				return 'guest';
			} else {
				return 'logged in';
			}
		}();
		return _Utils_Tuple2(
			'cambiatus.expected-authentication',
			$elm$json$Json$Encode$string(value));
	}
};
var $author$project$Log$logEvent = _Platform_outgoingPort('logEvent', $elm$core$Basics$identity);
var $author$project$Log$send = F2(
	function (msgToString, event) {
		return $author$project$Log$logEvent(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'user',
						function () {
							var _v0 = event.qh;
							if (_v0.$ === 1) {
								return $elm$json$Json$Encode$null;
							} else {
								var username = _v0.a;
								return $author$project$Eos$Account$encodeName(username);
							}
						}()),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(event.of)),
						_Utils_Tuple2(
						'tags',
						A3(
							$elm$json$Json$Encode$dict,
							$elm$core$Basics$identity,
							$elm$core$Basics$identity,
							$elm$core$Dict$fromList(
								A2($elm$core$List$map, $author$project$Log$encodeTag, event.pY)))),
						_Utils_Tuple2(
						'contexts',
						A2(
							$elm$json$Json$Encode$list,
							$author$project$Log$encodeContext,
							A2(
								$elm$core$List$cons,
								$author$project$Log$contextFromLocation(event.oa),
								event.mL))),
						_Utils_Tuple2(
						'transaction',
						$elm$json$Json$Encode$string(
							A2(
								$elm$core$String$join,
								'.',
								msgToString(event.p7)))),
						_Utils_Tuple2(
						'level',
						$elm$json$Json$Encode$string(
							$author$project$Log$levelToString(event.n4)))
					])));
	});
var $author$project$Main$updateGuestUResult = F4(
	function (toStatus, toMsg, model, uResult) {
		return function (_v7) {
			var model_ = _v7.a;
			var cmds_ = _v7.b;
			return _Utils_Tuple2(
				model_,
				$elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$cons,
						A2(
							$elm$core$Platform$Cmd$map,
							toMsg,
							$elm$core$Platform$Cmd$batch(uResult.ju)),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Ports$mapAddress(toMsg),
									$author$project$Ports$javascriptOutCmd($author$project$Main$msgToString)),
								uResult.k0),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Log$map(toMsg),
										$author$project$Log$send($author$project$Main$msgToString)),
									uResult.jQ),
								cmds_)))));
		}(
			A3(
				$elm$core$List$foldl,
				F2(
					function (commExtMsg, _v0) {
						var m = _v0.a;
						var cmds_ = _v0.b;
						var _v1 = m.c;
						if (_v1.$ === 1) {
							return _Utils_Tuple2(m, cmds_);
						} else {
							var guest = _v1.a;
							switch (commExtMsg.$) {
								case 0:
									var pin = commExtMsg.a.o8;
									var privateKey = commExtMsg.a.pg;
									var signInResponse = commExtMsg.a.pK;
									var shared = guest.A;
									var redirectRoute = function () {
										var _v6 = guest.me;
										if (!_v6.$) {
											if (_v6.a.$ === 45) {
												return $author$project$Route$Dashboard;
											} else {
												var route = _v6.a;
												return route;
											}
										} else {
											return $author$project$Route$Dashboard;
										}
									}();
									var _v3 = signInResponse;
									var profile = _v3.pl;
									var token = _v3.p5;
									var userWithCommunity = _Utils_update(
										profile,
										{
											eK: function () {
												var _v5 = guest.V;
												if (_v5.$ === 3) {
													var community = _v5.a;
													return A2(
														$elm$core$List$any,
														function (c) {
															return _Utils_eq(c.as, community.as);
														},
														profile.eK) ? profile.eK : A2(
														$elm$core$List$cons,
														{nn: community.bz, by: community.by, bB: community.bB, fe: community.fe, fj: community.fj, pP: community.pP, as: community.as},
														profile.eK);
												} else {
													return profile.eK;
												}
											}()
										});
									var _v4 = A5(
										$author$project$Session$LoggedIn$initLogin,
										shared,
										pin,
										$elm$core$Maybe$Just(privateKey),
										userWithCommunity,
										token);
									var session = _v4.a;
									var cmd = _v4.b;
									return _Utils_Tuple2(
										_Utils_update(
											m,
											{
												c: $author$project$Page$LoggedIn(session)
											}),
										A2(
											$elm$core$List$cons,
											A2(
												$elm$core$Platform$Cmd$map,
												A2($elm$core$Basics$composeR, $author$project$Page$GotLoggedInMsg, $author$project$Main$GotPageMsg),
												cmd),
											A2(
												$elm$core$List$cons,
												$author$project$Api$Graphql$createAbsintheSocket(token),
												A2(
													$elm$core$List$cons,
													A2($author$project$Route$pushUrl, guest.A.kK, redirectRoute),
													A2(
														$elm$core$List$cons,
														A2(
															$author$project$Log$addBreadcrumb,
															$author$project$Main$msgToString,
															{
																f7: $author$project$Main$Ignored,
																bZ: $elm$core$Dict$fromList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2(
																			'username',
																			$author$project$Eos$Account$encodeName(profile.l8))
																		])),
																n4: 3,
																of: 'Guest logged in',
																eq: 3
															}),
														cmds_)))));
								case 1:
									var feedback = commExtMsg.a;
									return _Utils_Tuple2(
										_Utils_update(
											m,
											{
												c: $author$project$Page$Guest(
													_Utils_update(
														guest,
														{hU: feedback}))
											}),
										cmds_);
								default:
									var newShared = commExtMsg.a;
									return _Utils_Tuple2(
										_Utils_update(
											m,
											{
												c: $author$project$Page$Guest(
													_Utils_update(
														guest,
														{A: newShared}))
											}),
										cmds_);
							}
						}
					}),
				_Utils_Tuple2(
					_Utils_update(
						model,
						{
							pN: toStatus(uResult.ok)
						}),
					_List_Nil),
				uResult.jS));
	});
var $author$project$Page$Community$About$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$About$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Invite$receiveBroadcast = function (broadcastMsg) {
	if (broadcastMsg.$ === 2) {
		return $elm$core$Maybe$Just($author$project$Page$Community$Invite$CompletedLoadProfile);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Objectives$CompletedLoadObjectives = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Objectives$receiveBroadcast = function (broadcastMsg) {
	if ((broadcastMsg.$ === 1) && (broadcastMsg.b.$ === 1)) {
		var objectives = broadcastMsg.b.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Objectives$CompletedLoadObjectives(objectives));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$ActionEditor$CompletedLoadObjectives = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$Community$Settings$ActionEditor$receiveBroadcast = function (broadcastMsg) {
	if ((broadcastMsg.$ === 1) && (broadcastMsg.b.$ === 1)) {
		var community = broadcastMsg.a;
		var objectives = broadcastMsg.b.a;
		return $elm$core$Maybe$Just(
			A2($author$project$Page$Community$Settings$ActionEditor$CompletedLoadObjectives, community, objectives));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$Contacts$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Settings$Contacts$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$Currency$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Settings$Currency$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$Features$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Settings$Features$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$Info$CompletedLoadUploads = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$Info$receiveBroadcast = function (broadcastMsg) {
	_v0$2:
	while (true) {
		switch (broadcastMsg.$) {
			case 0:
				var community = broadcastMsg.a;
				return $elm$core$Maybe$Just(
					$author$project$Page$Community$Settings$Info$CompletedLoadCommunity(community));
			case 1:
				if (broadcastMsg.b.$ === 2) {
					var uploads = broadcastMsg.b.a;
					return $elm$core$Maybe$Just(
						$author$project$Page$Community$Settings$Info$CompletedLoadUploads(uploads));
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Page$Community$Settings$News$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Settings$News$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$News$Editor$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Settings$News$Editor$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$ObjectiveEditor$CompletedLoadObjectives = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$ObjectiveEditor$receiveBroadcast = function (broadcastMsg) {
	_v0$2:
	while (true) {
		switch (broadcastMsg.$) {
			case 0:
				var community = broadcastMsg.a;
				return $elm$core$Maybe$Just(
					$author$project$Page$Community$Settings$ObjectiveEditor$CompletedLoadCommunity(community));
			case 1:
				if (broadcastMsg.b.$ === 1) {
					var objectives = broadcastMsg.b.a;
					return $elm$core$Maybe$Just(
						$author$project$Page$Community$Settings$ObjectiveEditor$CompletedLoadObjectives(objectives));
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Page$Community$Settings$Objectives$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Settings$Objectives$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$Settings$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Settings$Settings$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$Sponsorship$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Settings$Sponsorship$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$Sponsorship$Fiat$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Settings$Sponsorship$Fiat$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Sponsor$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Sponsor$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Supporters$CompletedLoadContributions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Supporters$receiveBroadcast = function (broadcastMsg) {
	if ((broadcastMsg.$ === 1) && (!broadcastMsg.b.$)) {
		var contributions = broadcastMsg.b.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Supporters$CompletedLoadContributions(contributions));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Transfer$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Transfer$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Dashboard$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Dashboard$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Join$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Join$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$News$CompletedLoadNews = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$News$receiveBroadcast = function (broadcastMsg) {
	if ((broadcastMsg.$ === 1) && (broadcastMsg.b.$ === 4)) {
		var news = broadcastMsg.b.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$News$CompletedLoadNews(news));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$PaymentHistory$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$PaymentHistory$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Profile$CompletedLoadContributions = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Profile$receiveBroadcast = function (broadcastMsg) {
	_v0$3:
	while (true) {
		switch (broadcastMsg.$) {
			case 2:
				var profile = broadcastMsg.a;
				return $elm$core$Maybe$Just(
					$author$project$Page$Profile$CompletedLoadProfile(
						$krisajenkins$remotedata$RemoteData$Success(
							$elm$core$Maybe$Just(profile))));
			case 0:
				var community = broadcastMsg.a;
				return $elm$core$Maybe$Just(
					$author$project$Page$Profile$CompletedLoadCommunity(community));
			case 1:
				if (!broadcastMsg.b.$) {
					var contributions = broadcastMsg.b.a;
					return $elm$core$Maybe$Just(
						$author$project$Page$Profile$CompletedLoadContributions(contributions));
				} else {
					break _v0$3;
				}
			default:
				break _v0$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Page$Profile$AddContact$receiveBroadcast = function (broadcastMsg) {
	if (broadcastMsg.$ === 2) {
		var profile = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Profile$AddContact$CompletedLoadProfile(profile));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Profile$Claims$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Profile$Claims$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Profile$Contributions$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Profile$Contributions$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Profile$Editor$receiveBroadcast = function (broadcastMsg) {
	if (broadcastMsg.$ === 2) {
		var profile = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Profile$Editor$CompletedLoadProfile(profile));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Shop$CompletedLoadingShopCategories = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$receiveBroadcast = function (broadcastMsg) {
	if ((broadcastMsg.$ === 1) && (broadcastMsg.b.$ === 5)) {
		var categories = broadcastMsg.b.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Shop$CompletedLoadingShopCategories(categories));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Shop$Editor$receiveBroadcast = F3(
	function (translators, broadcastMsg, model) {
		_v0$2:
		while (true) {
			switch (broadcastMsg.$) {
				case 0:
					return $elm$core$Maybe$Just($author$project$Page$Shop$Editor$CompletedLoadCommunity);
				case 1:
					if (broadcastMsg.b.$ === 5) {
						var community = broadcastMsg.a;
						var categories = broadcastMsg.b.a;
						if (model.dW) {
							var _v1 = $author$project$Page$Shop$Editor$getFormData(model);
							if (_v1.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var formData = _v1.a;
								return $elm$core$Maybe$Just(
									A3(
										$author$project$Form$parse,
										A2($author$project$Page$Shop$Editor$categoriesForm, translators, categories),
										formData.dn,
										{
											oM: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$CategoriesMsg),
											oV: $author$project$Page$Shop$Editor$SubmittedCategories
										}));
							}
						} else {
							return $elm$core$Maybe$Nothing;
						}
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Main$broadcast = F3(
	function (loggedIn, broadcastMessage, status) {
		var maybeMsg = function () {
			switch (status.$) {
				case 27:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotDashboardMsg,
						$author$project$Page$Dashboard$receiveBroadcast(broadcastMessage));
				case 44:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotTransferMsg,
						$author$project$Page$Community$Transfer$receiveBroadcast(broadcastMessage));
				case 34:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotProfileClaimsMsg,
						$author$project$Page$Profile$Claims$receiveBroadcast(broadcastMessage));
				case 23:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsActionEditorMsg,
						$author$project$Page$Community$Settings$ActionEditor$receiveBroadcast(broadcastMessage));
				case 21:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsObjectivesMsg,
						$author$project$Page$Community$Settings$Objectives$receiveBroadcast(broadcastMessage));
				case 4:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunityAboutMsg,
						$author$project$Page$Community$About$receiveBroadcast(broadcastMessage));
				case 5:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunityObjectivesMsg,
						$author$project$Page$Community$Objectives$receiveBroadcast(broadcastMessage));
				case 9:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsFeaturesMsg,
						$author$project$Page$Community$Settings$Features$receiveBroadcast(broadcastMessage));
				case 10:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsInfoMsg,
						$author$project$Page$Community$Settings$Info$receiveBroadcast(broadcastMessage));
				case 11:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsNewsMsg,
						$author$project$Page$Community$Settings$News$receiveBroadcast(broadcastMessage));
				case 12:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsNewsEditorMsg,
						$author$project$Page$Community$Settings$News$Editor$receiveBroadcast(broadcastMessage));
				case 13:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsCurrencyMsg,
						$author$project$Page$Community$Settings$Currency$receiveBroadcast(broadcastMessage));
				case 14:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsSponsorshipMsg,
						$author$project$Page$Community$Settings$Sponsorship$receiveBroadcast(broadcastMessage));
				case 15:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsSponsorshipFiatMsg,
						$author$project$Page$Community$Settings$Sponsorship$Fiat$receiveBroadcast(broadcastMessage));
				case 16:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsSponsorshipThankYouMessageMsg,
						$author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$receiveBroadcast(broadcastMessage));
				case 7:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsMsg,
						$author$project$Page$Community$Settings$Settings$receiveBroadcast(broadcastMessage));
				case 19:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySponsorMsg,
						$author$project$Page$Community$Sponsor$receiveBroadcast(broadcastMessage));
				case 20:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySupportersMsg,
						$author$project$Page$Community$Supporters$receiveBroadcast(broadcastMessage));
				case 22:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsObjectiveEditorMsg,
						$author$project$Page$Community$Settings$ObjectiveEditor$receiveBroadcast(broadcastMessage));
				case 24:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunitySettingsContactsMsg,
						$author$project$Page$Community$Settings$Contacts$receiveBroadcast(broadcastMessage));
				case 35:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotProfileAddContactMsg,
						$author$project$Page$Profile$AddContact$receiveBroadcast(broadcastMessage));
				case 32:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotProfileEditorMsg,
						$author$project$Page$Profile$Editor$receiveBroadcast(broadcastMessage));
				case 30:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotProfileMsg,
						$author$project$Page$Profile$receiveBroadcast(broadcastMessage));
				case 31:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotProfileContributionsMsg,
						$author$project$Page$Profile$Contributions$receiveBroadcast(broadcastMessage));
				case 39:
					var subModel = status.b;
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotShopEditorMsg,
						A3($author$project$Page$Shop$Editor$receiveBroadcast, loggedIn.A.aw, broadcastMessage, subModel));
				case 38:
					var subModel = status.b;
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotShopMsg,
						$author$project$Page$Shop$receiveBroadcast(broadcastMessage));
				case 42:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotInviteMsg,
						$author$project$Page$Community$Invite$receiveBroadcast(broadcastMessage));
				case 43:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotJoinMsg,
						$author$project$Page$Join$receiveBroadcast(broadcastMessage));
				case 29:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotNewsMsg,
						$author$project$Page$News$receiveBroadcast(broadcastMessage));
				case 3:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotPaymentHistoryMsg,
						$author$project$Page$PaymentHistory$receiveBroadcast(broadcastMessage));
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		if (!maybeMsg.$) {
			var msg = maybeMsg.a;
			return $author$project$Utils$spawnMessage(msg);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Session$LoggedIn$ClickedAcceptCodeOfConduct = {$: 38};
var $author$project$Session$LoggedIn$ClickedDenyCodeOfConduct = {$: 39};
var $author$project$Session$LoggedIn$ClickedLanguage = function (a) {
	return {$: 11, a: a};
};
var $author$project$Session$LoggedIn$ClickedLogout = {$: 8};
var $author$project$Session$LoggedIn$ClickedNavLink = {$: 23};
var $author$project$Session$LoggedIn$ClickedOpenCommunityContactsModal = {$: 42};
var $author$project$Session$LoggedIn$ClickedReadHighlightedNews = {$: 27};
var $author$project$Session$LoggedIn$ClickedTryAgainProfile = function (a) {
	return {$: 7, a: a};
};
var $author$project$Session$LoggedIn$ClickedTryAgainTranslation = {$: 2};
var $author$project$Session$LoggedIn$CloseCommunitySelector = {$: 18};
var $author$project$Session$LoggedIn$ClosedAuthModal = {$: 13};
var $author$project$Session$LoggedIn$ClosedCommunityContactsModal = {$: 43};
var $author$project$Session$LoggedIn$ClosedHighlightedNews = {$: 28};
var $author$project$Session$LoggedIn$ClosedInsufficientPermissionsModal = {$: 14};
var $author$project$Session$LoggedIn$ClosedSearch = {$: 24};
var $author$project$Session$LoggedIn$CompletedAcceptingCodeOfConduct = function (a) {
	return {$: 40, a: a};
};
var $author$project$Session$LoggedIn$CompletedGeneratingAuthToken = function (a) {
	return {$: 35, a: a};
};
var $author$project$Session$LoggedIn$CompletedLoadCommunityField = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Session$LoggedIn$CompletedLoadCommunityFields = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Session$LoggedIn$CompletedLoadContributionCount = function (a) {
	return {$: 26, a: a};
};
var $author$project$Session$LoggedIn$CompletedLoadTranslation = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Session$LoggedIn$CompletedLoadUnread = function (a) {
	return {$: 16, a: a};
};
var $author$project$Session$LoggedIn$CompletedSendingLanguagePreference = function (a) {
	return {$: 12, a: a};
};
var $author$project$Session$LoggedIn$EndedCodeOfConductWarningAnimation = {$: 41};
var $author$project$Session$LoggedIn$GotActionMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Session$LoggedIn$GotAuthTokenPhrase = F2(
	function (a, b) {
		return {$: 32, a: a, b: b};
	});
var $author$project$Session$LoggedIn$GotAuthTokenPhraseExternal = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$Session$LoggedIn$GotFeedbackMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Session$LoggedIn$GotSearchMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Session$LoggedIn$NoOp = {$: 0};
var $author$project$Session$LoggedIn$OpenCommunitySelector = {$: 17};
var $author$project$Session$LoggedIn$ReceivedNewHighlightedNews = function (a) {
	return {$: 29, a: a};
};
var $author$project$Session$LoggedIn$RequestedNewAuthTokenPhraseExternal = function (a) {
	return {$: 31, a: a};
};
var $author$project$Session$LoggedIn$RequestedQuery = function (a) {
	return {$: 36, a: a};
};
var $author$project$Session$LoggedIn$SelectedCommunity = function (a) {
	return {$: 19, a: a};
};
var $author$project$Session$LoggedIn$ShowUserNav = function (a) {
	return {$: 9, a: a};
};
var $author$project$Session$LoggedIn$SignedAuthTokenPhrase = function (a) {
	return {$: 34, a: a};
};
var $author$project$Session$LoggedIn$ToggleLanguageItems = {$: 10};
var $author$project$Session$LoggedIn$mapMsg = F2(
	function (mapFn, msg) {
		switch (msg.$) {
			case 0:
				return $author$project$Session$LoggedIn$NoOp;
			case 1:
				var language = msg.a;
				var result = msg.b;
				return A2($author$project$Session$LoggedIn$CompletedLoadTranslation, language, result);
			case 2:
				return $author$project$Session$LoggedIn$ClickedTryAgainTranslation;
			case 3:
				var result = msg.a;
				return $author$project$Session$LoggedIn$CompletedLoadProfile(result);
			case 4:
				var result = msg.a;
				return $author$project$Session$LoggedIn$CompletedLoadCommunity(result);
			case 5:
				var community = msg.a;
				var result = msg.b;
				return A2($author$project$Session$LoggedIn$CompletedLoadCommunityField, community, result);
			case 6:
				var community = msg.a;
				var result = msg.b;
				return A2($author$project$Session$LoggedIn$CompletedLoadCommunityFields, community, result);
			case 7:
				var account = msg.a;
				return $author$project$Session$LoggedIn$ClickedTryAgainProfile(account);
			case 8:
				return $author$project$Session$LoggedIn$ClickedLogout;
			case 9:
				var showUserNav = msg.a;
				return $author$project$Session$LoggedIn$ShowUserNav(showUserNav);
			case 10:
				return $author$project$Session$LoggedIn$ToggleLanguageItems;
			case 11:
				var language = msg.a;
				return $author$project$Session$LoggedIn$ClickedLanguage(language);
			case 12:
				var result = msg.a;
				return $author$project$Session$LoggedIn$CompletedSendingLanguagePreference(result);
			case 13:
				return $author$project$Session$LoggedIn$ClosedAuthModal;
			case 14:
				return $author$project$Session$LoggedIn$ClosedInsufficientPermissionsModal;
			case 15:
				var subMsg = msg.a;
				return $author$project$Session$LoggedIn$GotAuthMsg(subMsg);
			case 16:
				var jsonValue = msg.a;
				return $author$project$Session$LoggedIn$CompletedLoadUnread(jsonValue);
			case 17:
				return $author$project$Session$LoggedIn$OpenCommunitySelector;
			case 18:
				return $author$project$Session$LoggedIn$CloseCommunitySelector;
			case 19:
				var communityInfo = msg.a;
				return $author$project$Session$LoggedIn$SelectedCommunity(communityInfo);
			case 20:
				var subMsg = msg.a;
				return $author$project$Session$LoggedIn$GotFeedbackMsg(subMsg);
			case 21:
				var subMsg = msg.a;
				return $author$project$Session$LoggedIn$GotSearchMsg(subMsg);
			case 22:
				var subMsg = msg.a;
				return $author$project$Session$LoggedIn$GotActionMsg(subMsg);
			case 23:
				return $author$project$Session$LoggedIn$ClickedNavLink;
			case 24:
				return $author$project$Session$LoggedIn$ClosedSearch;
			case 25:
				var time = msg.a;
				return $author$project$Session$LoggedIn$GotTimeInternal(time);
			case 26:
				var result = msg.a;
				return $author$project$Session$LoggedIn$CompletedLoadContributionCount(result);
			case 27:
				return $author$project$Session$LoggedIn$ClickedReadHighlightedNews;
			case 28:
				return $author$project$Session$LoggedIn$ClosedHighlightedNews;
			case 29:
				var jsonValue = msg.a;
				return $author$project$Session$LoggedIn$ReceivedNewHighlightedNews(jsonValue);
			case 30:
				var callback = msg.a;
				return $author$project$Session$LoggedIn$RequestedNewAuthTokenPhrase(
					A2(
						$elm$core$Basics$composeR,
						callback,
						$elm$core$Platform$Cmd$map(
							$author$project$Session$LoggedIn$mapMsg(mapFn))));
			case 31:
				var callback = msg.a;
				return $author$project$Session$LoggedIn$RequestedNewAuthTokenPhraseExternal(
					A2(
						$elm$core$Basics$composeR,
						callback,
						$elm$core$Platform$Cmd$map(mapFn)));
			case 32:
				var callback = msg.a;
				var result = msg.b;
				return A2(
					$author$project$Session$LoggedIn$GotAuthTokenPhrase,
					A2(
						$elm$core$Basics$composeR,
						callback,
						$elm$core$Platform$Cmd$map(
							$author$project$Session$LoggedIn$mapMsg(mapFn))),
					result);
			case 33:
				var callback = msg.a;
				var result = msg.b;
				return A2(
					$author$project$Session$LoggedIn$GotAuthTokenPhraseExternal,
					A2(
						$elm$core$Basics$composeR,
						callback,
						$elm$core$Platform$Cmd$map(mapFn)),
					result);
			case 34:
				var password = msg.a;
				return $author$project$Session$LoggedIn$SignedAuthTokenPhrase(password);
			case 35:
				var result = msg.a;
				return $author$project$Session$LoggedIn$CompletedGeneratingAuthToken(result);
			case 36:
				var result = msg.a;
				return $author$project$Session$LoggedIn$RequestedQuery(
					function () {
						if (result.$ === 1) {
							var callbackCmd = result.a.jo;
							return $elm$core$Result$Err(
								{
									jo: F2(
										function (shared, authToken) {
											return A2(
												$elm$core$Platform$Cmd$map,
												mapFn,
												A2(callbackCmd, shared, authToken));
										})
								});
						} else {
							var extMsg = result.a;
							return $elm$core$Result$Ok(
								mapFn(extMsg));
						}
					}());
			case 37:
				var result = msg.a;
				return $author$project$Session$LoggedIn$RequestedQueryInternal(
					function () {
						if (result.$ === 1) {
							var callbackCmd = result.a;
							return $elm$core$Result$Err(
								A2(
									$elm$core$Basics$composeR,
									callbackCmd,
									$elm$core$Platform$Cmd$map(
										$author$project$Session$LoggedIn$mapMsg(mapFn))));
						} else {
							var resultMsg = result.a;
							return $elm$core$Result$Ok(
								A2($author$project$Session$LoggedIn$mapMsg, mapFn, resultMsg));
						}
					}());
			case 38:
				return $author$project$Session$LoggedIn$ClickedAcceptCodeOfConduct;
			case 39:
				return $author$project$Session$LoggedIn$ClickedDenyCodeOfConduct;
			case 40:
				var result = msg.a;
				return $author$project$Session$LoggedIn$CompletedAcceptingCodeOfConduct(result);
			case 41:
				return $author$project$Session$LoggedIn$EndedCodeOfConductWarningAnimation;
			case 42:
				return $author$project$Session$LoggedIn$ClickedOpenCommunityContactsModal;
			default:
				return $author$project$Session$LoggedIn$ClosedCommunityContactsModal;
		}
	});
var $author$project$Session$LoggedIn$CodeOfConductShown = {$: 1};
var $author$project$Session$LoggedIn$CommunityFieldLoaded = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$View$Feedback$Visible = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Session$LoggedIn$askedAuthentication = function (model) {
	return _Utils_update(
		model,
		{el: true, cl: false, bs: false, fG: false, fH: false, aL: false});
};
var $author$project$View$Pin$withLastKnownPin = F2(
	function (newPin, model) {
		return _Utils_update(
			model,
			{
				n2: $elm$core$Maybe$Just(newPin)
			});
	});
var $author$project$Auth$changeLastKnownPin = F2(
	function (newPin, model) {
		return _Utils_update(
			model,
			{
				ak: A2($author$project$View$Pin$withLastKnownPin, newPin, model.ak)
			});
	});
var $author$project$Eos$encodeSymbol = function (symbol) {
	return $elm$json$Json$Encode$string(
		$author$project$Eos$symbolToString(symbol));
};
var $author$project$Log$contextFromCommunity = function (remoteData) {
	return {
		ng: function () {
			if (remoteData.$ === 3) {
				var community = remoteData.a;
				return $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'symbol',
							$author$project$Eos$encodeSymbol(community.as)),
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(community.fj))
						]));
			} else {
				return $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'error',
							$elm$json$Json$Encode$string('Impossible error: loggedIn.selectedCommunity /= RemoteData.Success'))
						]));
			}
		}(),
		fj: 'Community'
	};
};
var $elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $author$project$Session$LoggedIn$externalMsgToString = function (externalMsg) {
	switch (externalMsg.$) {
		case 0:
			return _List_fromArray(
				['UpdatedLoggedIn']);
		case 1:
			return _List_fromArray(
				['PopFromRouteHistory']);
		case 2:
			return _List_fromArray(
				['ShowInsufficientPermissionsModal']);
		case 3:
			return _List_fromArray(
				['AddedCommunity']);
		case 4:
			return _List_fromArray(
				['ExternalBroadcast']);
		case 5:
			return _List_fromArray(
				['ReloadResource']);
		case 6:
			return _List_fromArray(
				['RequestedReloadCommunityField']);
		case 7:
			return _List_fromArray(
				['RequestedCommunityField']);
		case 8:
			return _List_fromArray(
				['SetCommunityField']);
		case 9:
			return _List_fromArray(
				['RequiredPrivateKey']);
		case 10:
			return _List_fromArray(
				['RequiredAuthToken']);
		case 11:
			return _List_fromArray(
				['RequestQuery']);
		case 12:
			return _List_fromArray(
				['ShowFeedback']);
		case 13:
			return _List_fromArray(
				['HideFeedback']);
		case 14:
			return _List_fromArray(
				['ShowCodeOfConductModal']);
		case 15:
			var subMsg = externalMsg.a;
			return A2(
				$elm$core$List$cons,
				'ExternalActionMsg',
				$author$project$Action$msgToString(subMsg));
		default:
			return _List_fromArray(
				['ChangedPin']);
	}
};
var $author$project$Community$ContributionsValue = function (a) {
	return {$: 0, a: a};
};
var $author$project$Cambiatus$Enum$ContributionStatusType$Created = 2;
var $author$project$Community$MembersValue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Community$NewsValue = function (a) {
	return {$: 4, a: a};
};
var $author$project$Community$ObjectivesValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Community$ShopCategories = function (a) {
	return {$: 5, a: a};
};
var $author$project$Community$UploadsValue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Cambiatus$Object$Community$categories = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'categories',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Community$Contribution = F5(
	function (user, amount, currency, id, insertedAt) {
		return {ji: amount, jA: currency, w: id, nL: insertedAt, qg: user};
	});
var $author$project$Cambiatus$Object$Contribution$amount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'amount', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Cambiatus$Object$Contribution$currency = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.CurrencyType.CurrencyType', 'currency', _List_Nil, $author$project$Cambiatus$Enum$CurrencyType$decoder);
var $author$project$Cambiatus$Object$Contribution$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Contribution$insertedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.NaiveDateTime',
	'insertedAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).jv.jE);
var $author$project$Cambiatus$Object$Contribution$user = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'user', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Community$contributionSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		function (_v0) {
			var naiveDateTime = _v0;
			return A2(
				$elm$core$Result$withDefault,
				$elm$time$Time$millisToPosix(0),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(naiveDateTime));
		},
		$author$project$Cambiatus$Object$Contribution$insertedAt),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Contribution$id,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Contribution$currency,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Contribution$amount,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Contribution$user($author$project$Profile$minimalSelectionSet),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$Contribution))))));
var $author$project$Cambiatus$Enum$ContributionStatusType$toString = function (_enum) {
	switch (_enum) {
		case 0:
			return 'APPROVED';
		case 1:
			return 'CAPTURED';
		case 2:
			return 'CREATED';
		case 3:
			return 'FAILED';
		default:
			return 'REJECTED';
	}
};
var $author$project$Cambiatus$Object$Community$contributions = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{pN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'status',
					filledInOptionals.pN,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$ContributionStatusType$toString))
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'contributions',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Cambiatus$Object$Community$news = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'news',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Community$Objective = F6(
	function (id, description, creator, actions, community, isCompleted) {
		return {mb: actions, V: community, jz: creator, aR: description, w: id, b7: isCompleted};
	});
var $author$project$Cambiatus$Enum$VerificationType$toString = function (_enum) {
	if (!_enum) {
		return 'AUTOMATIC';
	} else {
		return 'CLAIMABLE';
	}
};
var $author$project$Cambiatus$InputObject$encodeActionsInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'creator',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.jz, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'isCompleted',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.b7, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'validator',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.aN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'verificationType',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input.jc,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$VerificationType$toString)))
			]));
};
var $author$project$Cambiatus$Object$Objective$actions = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{nG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'input', filledInOptionals.nG, $author$project$Cambiatus$InputObject$encodeActionsInput)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'actions',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Community$Metadata = F6(
	function (title, description, symbol, logo, creator, memberCount) {
		return {jz: creator, aR: description, fe: logo, gT: memberCount, as: symbol, fN: title};
	});
var $author$project$Community$communitiesSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Community$memberCount,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Community$creator),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Constants$defaultCommunityLogo, $author$project$Cambiatus$Object$Community$logo),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Community$symbol),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Community$description,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Community$name,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$Metadata)))))));
var $author$project$Cambiatus$Object$Objective$creatorId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'creatorId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Community$objectiveSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Objective$isCompleted,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Objective$community($author$project$Community$communitiesSelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($author$project$Cambiatus$Object$Objective$actions, $elm$core$Basics$identity, $author$project$Action$selectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Objective$creatorId),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$Objective$description),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Action$objectiveIdSelectionSet,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$Objective)))))));
var $author$project$Cambiatus$Object$Community$objectives = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'objectives',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Shop$Category$treesSelectionSet = function (categoriesSelectionSet) {
	var isRoot = function (category) {
		return $elm_community$maybe_extra$Maybe$Extra$isNothing(category.iE);
	};
	var createTree = F2(
		function (children, root) {
			return A2(
				$zwilias$elm_rosetree$Tree$tree,
				root,
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						$zwilias$elm_rosetree$Tree$label,
						function ($) {
							return $.bq;
						}),
					A2(
						$elm$core$List$filterMap,
						function (child) {
							return _Utils_eq(
								child.iE,
								$elm$core$Maybe$Just(root.w)) ? $elm$core$Maybe$Just(
								A2(createTree, children, child)) : $elm$core$Maybe$Nothing;
						},
						children)));
		});
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		function (allCategories) {
			return A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					$zwilias$elm_rosetree$Tree$label,
					function ($) {
						return $.bq;
					}),
				A2(
					$elm$core$List$filterMap,
					function (category) {
						return isRoot(category) ? $elm$core$Maybe$Just(
							A2(createTree, allCategories, category)) : $elm$core$Maybe$Nothing;
					},
					allCategories));
		},
		categoriesSelectionSet($author$project$Shop$Category$selectionSet));
};
var $author$project$Cambiatus$Object$Community$uploads = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'uploads',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Community$selectionSetForField = function (field) {
	switch (field) {
		case 0:
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Community$ContributionsValue,
				A2(
					$author$project$Cambiatus$Object$Community$contributions,
					function (optionals) {
						return _Utils_update(
							optionals,
							{
								pN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(2)
							});
					},
					$author$project$Community$contributionSelectionSet));
		case 1:
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Community$ObjectivesValue,
				$author$project$Cambiatus$Object$Community$objectives($author$project$Community$objectiveSelectionSet));
		case 2:
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Community$UploadsValue,
				$author$project$Cambiatus$Object$Community$uploads($author$project$Cambiatus$Object$Upload$url));
		case 3:
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Community$MembersValue,
				$author$project$Cambiatus$Object$Community$members($author$project$Profile$minimalSelectionSet));
		case 4:
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Community$NewsValue,
				$author$project$Cambiatus$Object$Community$news($author$project$Community$News$selectionSet));
		default:
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Community$ShopCategories,
				$author$project$Shop$Category$treesSelectionSet($author$project$Cambiatus$Object$Community$categories));
	}
};
var $author$project$Community$fieldSelectionSet = F2(
	function (symbol, field) {
		return A2(
			$author$project$Cambiatus$Query$community,
			function (optionals) {
				return _Utils_update(
					optionals,
					{
						as: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							$author$project$Eos$symbolToString(symbol))
					});
			},
			$author$project$Community$selectionSetForField(field));
	});
var $author$project$Log$Fatal = 0;
var $author$project$Log$ImpossibleError = 1;
var $author$project$Log$TypeTag = function (a) {
	return {$: 0, a: a};
};
var $author$project$Log$fromImpossible = F5(
	function (transaction, message, maybeUser, location, contexts) {
		return {
			mL: contexts,
			n4: 0,
			oa: location,
			of: message,
			pY: _List_fromArray(
				[
					$author$project$Log$TypeTag(1)
				]),
			p7: transaction,
			qh: maybeUser
		};
	});
var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Community$isFieldLoading = F2(
	function (field, model) {
		switch (field) {
			case 0:
				return $krisajenkins$remotedata$RemoteData$isLoading(model.eN);
			case 1:
				return $krisajenkins$remotedata$RemoteData$isLoading(model.cV);
			case 2:
				return $krisajenkins$remotedata$RemoteData$isLoading(model.bQ);
			case 3:
				return false;
			case 4:
				return $krisajenkins$remotedata$RemoteData$isLoading(model.fl);
			default:
				return $krisajenkins$remotedata$RemoteData$isLoading(model.fC);
		}
	});
var $author$project$Session$LoggedIn$loadCommunity = F2(
	function (model, maybeSymbol) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{pC: $krisajenkins$remotedata$RemoteData$Loading, cm: false}),
			A2($author$project$Session$LoggedIn$fetchCommunity, model, maybeSymbol));
	});
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $author$project$Community$maybeFieldValue = F2(
	function (field, model) {
		switch (field) {
			case 0:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Community$ContributionsValue,
					$krisajenkins$remotedata$RemoteData$toMaybe(model.eN));
			case 1:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Community$ObjectivesValue,
					$krisajenkins$remotedata$RemoteData$toMaybe(model.cV));
			case 2:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Community$UploadsValue,
					$krisajenkins$remotedata$RemoteData$toMaybe(model.bQ));
			case 3:
				return $elm$core$Maybe$Just(
					$author$project$Community$MembersValue(model.ih));
			case 4:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Community$NewsValue,
					$krisajenkins$remotedata$RemoteData$toMaybe(model.fl));
			default:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Community$ShopCategories,
					$krisajenkins$remotedata$RemoteData$toMaybe(model.fC));
		}
	});
var $author$project$Session$LoggedIn$profile = function (model) {
	return $krisajenkins$remotedata$RemoteData$toMaybe(model.pl);
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Session$LoggedIn$getInvitation = function (model) {
	var _v0 = $elm$core$List$head(model.g6);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 45:
					var invitation = _v0.a.a;
					return $elm$core$Maybe$Just(invitation);
				case 3:
					var _v1 = _v0.a;
					var maybeInvitation = _v1.a;
					return maybeInvitation;
				case 2:
					var _v2 = _v0.a;
					var maybeInvitation = _v2.a;
					return maybeInvitation;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Ports$storeSelectedCommunitySymbol = _Platform_outgoingPort('storeSelectedCommunitySymbol', $elm$json$Json$Encode$string);
var $elm_community$list_extra$List$Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var $author$project$Session$LoggedIn$setCommunity = F2(
	function (community, model) {
		var shared = model.A;
		var storeCommunityCmd = $author$project$Ports$storeSelectedCommunitySymbol(
			$author$project$Eos$symbolToString(community.as));
		var sharedWithCommunity = _Utils_update(
			shared,
			{
				pC: $elm$core$Maybe$Just(community.as)
			});
		var isMember = function () {
			var _v2 = $author$project$Session$LoggedIn$profile(model);
			if (!_v2.$) {
				var profile_ = _v2.a;
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.as;
						},
						$elm$core$Basics$eq(community.as)),
					profile_.eK);
			} else {
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.l8;
						},
						$elm$core$Basics$eq(model._)),
					community.ih);
			}
		}();
		if (isMember) {
			var newProfile = function () {
				var _v0 = $author$project$Session$LoggedIn$profile(model);
				if (_v0.$ === 1) {
					return model.pl;
				} else {
					var profile_ = _v0.a;
					return $krisajenkins$remotedata$RemoteData$Success(
						_Utils_update(
							profile_,
							{
								eK: A3(
									$elm_community$list_extra$List$Extra$updateIf,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.as;
										},
										$elm$core$Basics$eq(community.as)),
									function (c) {
										return _Utils_update(
											c,
											{by: community.by, fe: community.fe, fj: community.fj});
									},
									profile_.eK)
							}));
				}
			}();
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						pl: newProfile,
						pC: $krisajenkins$remotedata$RemoteData$Success(community),
						A: sharedWithCommunity
					}),
				storeCommunityCmd);
		} else {
			if (community.bx) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pC: $krisajenkins$remotedata$RemoteData$Success(community),
							A: sharedWithCommunity
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$author$project$Route$pushUrl,
								shared.kK,
								$author$project$Route$Join(
									$elm$core$List$head(model.g6))),
								storeCommunityCmd
							])));
			} else {
				var _v1 = $author$project$Session$LoggedIn$getInvitation(model);
				if (!_v1.$) {
					var invitation = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pC: $krisajenkins$remotedata$RemoteData$Success(community),
								A: sharedWithCommunity
							}),
						A2(
							$author$project$Route$pushUrl,
							shared.kK,
							$author$project$Route$Invite(invitation)));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pC: $krisajenkins$remotedata$RemoteData$Success(community),
								A: sharedWithCommunity
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$author$project$Route$pushUrl,
									shared.kK,
									$author$project$Route$CommunitySelector(
										$elm$core$List$head(model.g6))),
									storeCommunityCmd
								])));
				}
			}
		}
	});
var $author$project$Community$setFieldAsLoading = F2(
	function (field, model) {
		switch (field) {
			case 0:
				return _Utils_update(
					model,
					{eN: $krisajenkins$remotedata$RemoteData$Loading});
			case 1:
				return _Utils_update(
					model,
					{cV: $krisajenkins$remotedata$RemoteData$Loading});
			case 2:
				return _Utils_update(
					model,
					{bQ: $krisajenkins$remotedata$RemoteData$Loading});
			case 3:
				return model;
			case 4:
				return _Utils_update(
					model,
					{fl: $krisajenkins$remotedata$RemoteData$Loading});
			default:
				return _Utils_update(
					model,
					{fC: $krisajenkins$remotedata$RemoteData$Loading});
		}
	});
var $author$project$Community$setFieldValue = F2(
	function (fieldValue, model) {
		switch (fieldValue.$) {
			case 0:
				var contributions = fieldValue.a;
				return _Utils_update(
					model,
					{
						eN: $krisajenkins$remotedata$RemoteData$Success(contributions)
					});
			case 1:
				var objectives = fieldValue.a;
				return _Utils_update(
					model,
					{
						cV: $krisajenkins$remotedata$RemoteData$Success(objectives)
					});
			case 2:
				var uploads = fieldValue.a;
				return _Utils_update(
					model,
					{
						bQ: $krisajenkins$remotedata$RemoteData$Success(uploads)
					});
			case 3:
				var members = fieldValue.a;
				return _Utils_update(
					model,
					{ih: members});
			case 4:
				var news = fieldValue.a;
				return _Utils_update(
					model,
					{
						fl: $krisajenkins$remotedata$RemoteData$Success(news)
					});
			default:
				var categories = fieldValue.a;
				return _Utils_update(
					model,
					{
						fC: $krisajenkins$remotedata$RemoteData$Success(categories)
					});
		}
	});
var $author$project$Session$LoggedIn$signUpForCommunity = F2(
	function (model, communityInfo) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{pC: $krisajenkins$remotedata$RemoteData$Loading}),
			A3(
				$author$project$Session$LoggedIn$internalQuery,
				model,
				$author$project$Community$symbolQuery(communityInfo.as),
				$author$project$Session$LoggedIn$CompletedLoadCommunity));
	});
var $author$project$Session$LoggedIn$updateExternal = F2(
	function (externalMsg, model) {
		var shared = model.A;
		var defaultResult = {bU: $elm$core$Maybe$Nothing, mo: $elm$core$Maybe$Nothing, mx: $elm$core$Platform$Cmd$none, ok: model};
		switch (externalMsg.$) {
			case 0:
				var newModel = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{ok: newModel});
			case 1:
				var dropFn = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{
						ok: _Utils_update(
							model,
							{
								g6: A2($elm_community$list_extra$List$Extra$dropWhile, dropFn, model.g6)
							})
					});
			case 2:
				return _Utils_update(
					defaultResult,
					{
						ok: _Utils_update(
							model,
							{bs: true})
					});
			case 3:
				var communityInfo = externalMsg.a;
				var _v1 = A2($author$project$Session$LoggedIn$signUpForCommunity, model, communityInfo);
				var newModel = _v1.a;
				var cmd = _v1.b;
				var profileWithCommunity = function () {
					var _v2 = $author$project$Session$LoggedIn$profile(newModel);
					if (_v2.$ === 1) {
						return newModel.pl;
					} else {
						var profile_ = _v2.a;
						return $krisajenkins$remotedata$RemoteData$Success(
							_Utils_update(
								profile_,
								{
									eK: A2($elm$core$List$cons, communityInfo, profile_.eK)
								}));
					}
				}();
				return _Utils_update(
					defaultResult,
					{
						mx: cmd,
						ok: _Utils_update(
							newModel,
							{pl: profileWithCommunity})
					});
			case 4:
				var broadcastMsg = externalMsg.a;
				switch (broadcastMsg.$) {
					case 0:
						var community = broadcastMsg.a;
						var _v4 = A2($author$project$Session$LoggedIn$setCommunity, community, model);
						var newModel = _v4.a;
						var cmd = _v4.b;
						return _Utils_update(
							defaultResult,
							{
								mo: $elm$core$Maybe$Just(broadcastMsg),
								mx: cmd,
								ok: newModel
							});
					case 1:
						var community = broadcastMsg.a;
						var field = broadcastMsg.b;
						return _Utils_update(
							defaultResult,
							{
								mo: $elm$core$Maybe$Just(broadcastMsg),
								ok: _Utils_update(
									model,
									{
										pC: $krisajenkins$remotedata$RemoteData$Success(
											A2($author$project$Community$setFieldValue, field, community))
									})
							});
					case 2:
						var profile_ = broadcastMsg.a;
						return _Utils_update(
							defaultResult,
							{
								mo: $elm$core$Maybe$Just(broadcastMsg),
								ok: _Utils_update(
									model,
									{
										pl: $krisajenkins$remotedata$RemoteData$Success(profile_)
									})
							});
					case 3:
						var time = broadcastMsg.a;
						return _Utils_update(
							defaultResult,
							{
								mo: $elm$core$Maybe$Just(broadcastMsg),
								ok: _Utils_update(
									model,
									{
										A: _Utils_update(
											shared,
											{ce: time})
									})
							});
					default:
						return _Utils_update(
							defaultResult,
							{
								mo: $elm$core$Maybe$Just(broadcastMsg)
							});
				}
			case 5:
				switch (externalMsg.a) {
					case 0:
						var _v5 = externalMsg.a;
						return _Utils_update(
							defaultResult,
							{
								mx: A2(
									$author$project$Session$LoggedIn$loadCommunity,
									model,
									$krisajenkins$remotedata$RemoteData$toMaybe(
										A2(
											$krisajenkins$remotedata$RemoteData$map,
											function ($) {
												return $.as;
											},
											model.pC))).b
							});
					case 1:
						var _v6 = externalMsg.a;
						return _Utils_update(
							defaultResult,
							{
								mx: A3(
									$author$project$Session$LoggedIn$internalQuery,
									model,
									$author$project$Profile$query(model._),
									$author$project$Session$LoggedIn$CompletedLoadProfile)
							});
					default:
						var _v7 = externalMsg.a;
						return _Utils_update(
							defaultResult,
							{
								mx: A2($elm$core$Task$perform, $author$project$Session$LoggedIn$GotTimeInternal, $elm$time$Time$now)
							});
				}
			case 7:
				var field = externalMsg.a;
				var _v8 = model.pC;
				if (_v8.$ === 3) {
					var community = _v8.a;
					if (A2($author$project$Community$isFieldLoading, field, community)) {
						return defaultResult;
					} else {
						var _v9 = A2($author$project$Community$maybeFieldValue, field, community);
						if (!_v9.$) {
							var fieldValue = _v9.a;
							return _Utils_update(
								defaultResult,
								{
									mo: $elm$core$Maybe$Just(
										A2($author$project$Session$LoggedIn$CommunityFieldLoaded, community, fieldValue))
								});
						} else {
							return _Utils_update(
								defaultResult,
								{
									mx: A3(
										$author$project$Session$LoggedIn$internalQuery,
										model,
										A2($author$project$Community$fieldSelectionSet, community.as, field),
										$author$project$Session$LoggedIn$CompletedLoadCommunityField(community)),
									ok: _Utils_update(
										model,
										{
											pC: $krisajenkins$remotedata$RemoteData$Success(
												A2($author$project$Community$setFieldAsLoading, field, community))
										})
								});
						}
					}
				} else {
					return _Utils_update(
						defaultResult,
						{
							ok: _Utils_update(
								model,
								{
									ci: A2($elm$core$List$cons, field, model.ci)
								})
						});
				}
			case 6:
				var field = externalMsg.a;
				var _v10 = model.pC;
				if (_v10.$ === 3) {
					var community = _v10.a;
					return _Utils_update(
						defaultResult,
						{
							mx: A3(
								$author$project$Session$LoggedIn$internalQuery,
								model,
								A2($author$project$Community$fieldSelectionSet, community.as, field),
								$author$project$Session$LoggedIn$CompletedLoadCommunityField(community))
						});
				} else {
					return _Utils_update(
						defaultResult,
						{
							ok: _Utils_update(
								model,
								{
									ci: A2($elm$core$List$cons, field, model.ci)
								})
						});
				}
			case 8:
				var value = externalMsg.a;
				var _v11 = model.pC;
				if (_v11.$ === 3) {
					var community = _v11.a;
					return _Utils_update(
						defaultResult,
						{
							ok: _Utils_update(
								model,
								{
									pC: $krisajenkins$remotedata$RemoteData$Success(
										A2($author$project$Community$setFieldValue, value, community))
								})
						});
				} else {
					return _Utils_update(
						defaultResult,
						{
							mx: A2(
								$author$project$Log$send,
								$author$project$Session$LoggedIn$externalMsgToString,
								A5(
									$author$project$Log$fromImpossible,
									externalMsg,
									'Tried setting community field, but community wasn\'t loaded',
									$elm$core$Maybe$Just(model._),
									{e$: 'updateExternal', fi: 'Session.LoggedIn'},
									_List_fromArray(
										[
											$author$project$Log$contextFromCommunity(model.pC)
										])))
						});
				}
			case 9:
				var afterAuthMsg = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{
						bU: $elm$core$Maybe$Just(afterAuthMsg),
						ok: $author$project$Session$LoggedIn$askedAuthentication(model)
					});
			case 10:
				var callbackCmd = externalMsg.a.jo;
				return _Utils_update(
					defaultResult,
					{
						mx: $author$project$Utils$spawnMessage(
							$author$project$Session$LoggedIn$RequestedNewAuthTokenPhraseExternal(callbackCmd))
					});
			case 11:
				var queryCmd = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{
						mx: A2($elm$core$Platform$Cmd$map, $author$project$Session$LoggedIn$RequestedQuery, queryCmd)
					});
			case 12:
				var status = externalMsg.a;
				var message = externalMsg.b;
				return _Utils_update(
					defaultResult,
					{
						ok: _Utils_update(
							model,
							{
								hU: A2($author$project$View$Feedback$Visible, status, message)
							})
					});
			case 13:
				return _Utils_update(
					defaultResult,
					{
						ok: _Utils_update(
							model,
							{hU: $author$project$View$Feedback$Hidden})
					});
			case 14:
				return _Utils_update(
					defaultResult,
					{
						ok: _Utils_update(
							model,
							{ab: $author$project$Session$LoggedIn$CodeOfConductShown})
					});
			case 15:
				var subMsg = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{
						mx: $author$project$Utils$spawnMessage(
							$author$project$Session$LoggedIn$GotActionMsg(subMsg))
					});
			default:
				var newPin = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{
						ok: _Utils_update(
							model,
							{
								ml: A2($author$project$Auth$changeLastKnownPin, newPin, model.ml)
							})
					});
		}
	});
var $author$project$Main$updateLoggedInUResult = F4(
	function (toStatus, toMsg, model, uResult) {
		return function (_v4) {
			var model_ = _v4.a;
			var cmds_ = _v4.b;
			return _Utils_Tuple2(
				model_,
				$elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$cons,
						A2(
							$elm$core$Platform$Cmd$map,
							toMsg,
							$elm$core$Platform$Cmd$batch(uResult.ju)),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Ports$mapAddress(toMsg),
									$author$project$Ports$javascriptOutCmd($author$project$Main$msgToString)),
								uResult.k0),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Log$map(toMsg),
										$author$project$Log$send($author$project$Main$msgToString)),
									uResult.jQ),
								cmds_)))));
		}(
			A3(
				$elm$core$List$foldl,
				F2(
					function (commExtMsg, _v0) {
						var m = _v0.a;
						var cmds_ = _v0.b;
						var _v1 = _Utils_Tuple2(commExtMsg, m.c);
						if (_v1.b.$ === 1) {
							var loggedIn = _v1.b.a;
							var updateResult = A2($author$project$Session$LoggedIn$updateExternal, commExtMsg, loggedIn);
							var broadcastCmd = function () {
								var _v3 = updateResult.mo;
								if (_v3.$ === 1) {
									return $elm$core$Platform$Cmd$none;
								} else {
									var broadcastMsg = _v3.a;
									return A3($author$project$Main$broadcast, loggedIn, broadcastMsg, m.pN);
								}
							}();
							return _Utils_Tuple2(
								_Utils_update(
									m,
									{
										bU: A2(
											$elm$core$Maybe$map,
											function (_v2) {
												var successMsg = _v2.iX;
												var errorMsg = _v2.hS;
												return {
													hS: toMsg(errorMsg),
													iX: toMsg(successMsg)
												};
											},
											updateResult.bU),
										c: $author$project$Page$LoggedIn(updateResult.ok)
									}),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$core$Platform$Cmd$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Session$LoggedIn$mapMsg(toMsg),
											A2($elm$core$Basics$composeR, $author$project$Page$GotLoggedInMsg, $author$project$Main$GotPageMsg)),
										updateResult.mx),
									A2($elm$core$List$cons, broadcastCmd, cmds_)));
						} else {
							if (!_v1.a.$) {
								var loggedIn = _v1.a.a;
								return _Utils_Tuple2(
									_Utils_update(
										m,
										{
											c: $author$project$Page$LoggedIn(loggedIn)
										}),
									cmds_);
							} else {
								return _Utils_Tuple2(m, cmds_);
							}
						}
					}),
				_Utils_Tuple2(
					_Utils_update(
						model,
						{
							pN: toStatus(uResult.ok)
						}),
					_List_Nil),
				uResult.jS));
	});
var $author$project$Main$updatePageUResult = F4(
	function (toStatus, toMsg, model, uResult) {
		var _v0 = model.c;
		if (!_v0.$) {
			return A4(
				$author$project$Main$updateGuestUResult,
				toStatus,
				toMsg,
				model,
				A4(
					$author$project$UpdateResult$map,
					$elm$core$Basics$identity,
					$elm$core$Basics$identity,
					F2(
						function (extMsg, currUResult) {
							if (extMsg.$ === 1) {
								var guestMsg = extMsg.a;
								return A2($author$project$UpdateResult$addExt, guestMsg, currUResult);
							} else {
								return currUResult;
							}
						}),
					uResult));
		} else {
			return A4(
				$author$project$Main$updateLoggedInUResult,
				toStatus,
				toMsg,
				model,
				A4(
					$author$project$UpdateResult$map,
					$elm$core$Basics$identity,
					$elm$core$Basics$identity,
					F2(
						function (extMsg, currUResult) {
							if (extMsg.$ === 1) {
								return currUResult;
							} else {
								var loggedInMsg = extMsg.a;
								return A2($author$project$UpdateResult$addExt, loggedInMsg, currUResult);
							}
						}),
					uResult));
		}
	});
var $author$project$Main$updateSessionWith = F3(
	function (toMsg, model, _v0) {
		var session = _v0.a;
		var subCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{c: session}),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd));
	});
var $author$project$Main$updateStatusWith = F4(
	function (toStatus, toMsg, model, _v0) {
		var subModel = _v0.a;
		var subCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					pN: toStatus(subModel)
				}),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd));
	});
var $author$project$Main$changeRouteTo = F2(
	function (maybeRoute, model) {
		var updateStatus = F2(
			function (model_, newStatus) {
				return _Utils_update(
					model_,
					{pN: newStatus});
			});
		var session = model.c;
		var shared = function () {
			if (!session.$) {
				var guest = session.a;
				return guest.A;
			} else {
				var loggedIn = session.a;
				return loggedIn.A;
			}
		}();
		var noCmd = function (model_) {
			return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
		};
		var addRouteToHistory = F2(
			function (status, loggedIn) {
				var _v46 = A2(
					$author$project$Main$statusToRoute,
					status,
					$author$project$Page$LoggedIn(loggedIn));
				if (_v46.$ === 1) {
					return loggedIn;
				} else {
					var newRoute = _v46.a;
					var _v47 = loggedIn.g6;
					if (_v47.b && _v47.b.b) {
						var routeHistory = _v47;
						var _v48 = routeHistory.b;
						var second = _v48.a;
						var rest = _v48.b;
						return _Utils_eq(newRoute, second) ? _Utils_update(
							loggedIn,
							{
								gC: loggedIn.gC || _Utils_eq(second, $author$project$Route$Dashboard),
								g6: A2($elm$core$List$cons, newRoute, rest)
							}) : _Utils_update(
							loggedIn,
							{
								gC: loggedIn.gC || _Utils_eq(second, $author$project$Route$Dashboard),
								g6: A2($elm$core$List$cons, newRoute, routeHistory)
							});
					} else {
						var routeHistory = _v47;
						return _Utils_update(
							loggedIn,
							{
								g6: A2($elm$core$List$cons, newRoute, routeHistory)
							});
					}
				}
			});
		var withLoggedIn = F2(
			function (route, fn) {
				if (session.$ === 1) {
					var loggedIn = session.a;
					var _v44 = fn(loggedIn);
					var newModel = _v44.a;
					var newCmd = _v44.b;
					var newSession = function () {
						var _v45 = newModel.c;
						if (_v45.$ === 1) {
							var newLoggedIn = _v45.a;
							return $author$project$Page$LoggedIn(
								A2(addRouteToHistory, newModel.pN, newLoggedIn));
						} else {
							var guest = _v45.a;
							return $author$project$Page$Guest(guest);
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{c: newSession}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									newCmd,
									A2(
									$elm$core$Task$perform,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Session$LoggedIn$GotTimeInternal,
										A2($elm$core$Basics$composeR, $author$project$Page$GotLoggedInMsg, $author$project$Main$GotPageMsg)),
									$elm$time$Time$now)
								])));
				} else {
					var guest = session.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Page$Guest(
									A2($author$project$Session$Guest$addAfterLoginRedirect, route, guest)),
								pN: $author$project$Main$Redirect
							}),
						A2(
							$author$project$Route$replaceUrl,
							shared.kK,
							$author$project$Route$Join(
								$elm$core$Maybe$Just(route))));
				}
			});
		var addMaybeInvitation = F2(
			function (maybeInvitation, model_) {
				var _v42 = model_.c;
				if (_v42.$ === 1) {
					return model_;
				} else {
					var guest = _v42.a;
					return _Utils_update(
						model_,
						{
							c: $author$project$Page$Guest(
								_Utils_update(
									guest,
									{kC: maybeInvitation}))
						});
				}
			});
		var addAfterLoginRedirect = F2(
			function (maybeRedirect, model_) {
				var _v40 = model_.c;
				if (_v40.$ === 1) {
					return model_;
				} else {
					var guest = _v40.a;
					if (maybeRedirect.$ === 1) {
						return model_;
					} else {
						var redirect = maybeRedirect.a;
						return _Utils_update(
							model_,
							{
								c: $author$project$Page$Guest(
									A2($author$project$Session$Guest$addAfterLoginRedirect, redirect, guest))
							});
					}
				}
			});
		var withGuest = F3(
			function (maybeInvitation, maybeRedirect, fn) {
				if (session.$ === 1) {
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Route$replaceUrl,
							shared.kK,
							A2($elm$core$Maybe$withDefault, $author$project$Route$Dashboard, maybeRedirect)));
				} else {
					var guest = session.a;
					var _v39 = fn(guest);
					var newModel = _v39.a;
					var newCmd = _v39.b;
					return _Utils_Tuple2(
						A2(
							addMaybeInvitation,
							maybeInvitation,
							A2(addAfterLoginRedirect, maybeRedirect, newModel)),
						newCmd);
				}
			});
		var withSession = F2(
			function (route, fn) {
				var _v36 = fn(session);
				var newModel = _v36.a;
				var newCmd = _v36.b;
				var _v37 = newModel.c;
				if (_v37.$ === 1) {
					var loggedIn = _v37.a;
					var newSession = $author$project$Page$LoggedIn(
						A2(addRouteToHistory, newModel.pN, loggedIn));
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{c: newSession}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									newCmd,
									A2(
									$elm$core$Task$perform,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Session$LoggedIn$GotTimeInternal,
										A2($elm$core$Basics$composeR, $author$project$Page$GotLoggedInMsg, $author$project$Main$GotPageMsg)),
									$elm$time$Time$now)
								])));
				} else {
					return _Utils_Tuple2(
						A2(
							addAfterLoginRedirect,
							$elm$core$Maybe$Just(route),
							newModel),
						newCmd);
				}
			});
		if (maybeRoute.$ === 1) {
			return noCmd(
				A2(updateStatus, model, $author$project$Main$NotFound));
		} else {
			switch (maybeRoute.a.$) {
				case 0:
					var _v1 = maybeRoute.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Route$replaceUrl, shared.kK, $author$project$Route$Dashboard));
				case 1:
					var _v2 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$ComingSoon));
				case 2:
					var _v3 = maybeRoute.a;
					var invitation = _v3.a;
					var maybeRedirect = _v3.b;
					return A3(
						withGuest,
						invitation,
						maybeRedirect,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Register$init(invitation),
							A3(
								$author$project$Main$updateStatusWith,
								A2($author$project$Main$Register, invitation, maybeRedirect),
								$author$project$Main$GotRegisterMsg,
								model)));
				case 39:
					var _v4 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Settings,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Settings$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$Settings, $author$project$Main$GotSettingsMsg, model)));
				case 3:
					var _v5 = maybeRoute.a;
					var maybeInvitation = _v5.a;
					var maybeRedirect = _v5.b;
					return A3(
						withGuest,
						maybeInvitation,
						maybeRedirect,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Login$init,
							A3(
								$author$project$Main$updateGuestUResult,
								$author$project$Main$Login(maybeRedirect),
								$author$project$Main$GotLoginMsg,
								model)));
				case 17:
					var config = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$News(config),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$News$init(config),
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$News, $author$project$Main$GotNewsMsg, model)));
				case 10:
					var accountName = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$PaymentHistory(accountName),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PaymentHistory$init(accountName),
							A3($author$project$Main$updateStatusWith, $author$project$Main$PaymentHistory, $author$project$Main$GotPaymentHistoryMsg, model)));
				case 4:
					var _v6 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Dashboard,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$logout,
							A2($author$project$Main$updateSessionWith, $author$project$Main$GotPageMsg, model)));
				case 5:
					var _v7 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Notification,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Notification$init,
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Notification, $author$project$Main$GotNotificationMsg, model)));
				case 11:
					var profileName = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Profile(profileName),
						A2(
							$elm$core$Basics$composeR,
							function (loggedIn) {
								return A2($author$project$Page$Profile$init, loggedIn, profileName);
							},
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Profile, $author$project$Main$GotProfileMsg, model)));
				case 12:
					var profileName = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$ProfileContributions(profileName),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A2($author$project$Page$Profile$Contributions$init, l, profileName);
							},
							A3($author$project$Main$updateStatusWith, $author$project$Main$ProfileContributions, $author$project$Main$GotProfileContributionsMsg, model)));
				case 6:
					var _v8 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$ProfileEditor,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Profile$Editor$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$ProfileEditor, $author$project$Main$GotProfileEditorMsg, model)));
				case 7:
					var _v9 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$ProfileAddKyc,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Profile$AddKyc$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$ProfileAddKyc, $author$project$Main$GotProfileAddKycMsg, model)));
				case 8:
					var account = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$ProfileClaims(account),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A2($author$project$Page$Profile$Claims$init, l, account);
							},
							A3($author$project$Main$updateStatusWith, $author$project$Main$ProfileClaims, $author$project$Main$GotProfileClaimsMsg, model)));
				case 9:
					var _v10 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$ProfileAddContact,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Profile$AddContact$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$ProfileAddContact, $author$project$Main$GotProfileAddContactMsg, model)));
				case 13:
					var _v11 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Dashboard,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Dashboard$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$Dashboard, $author$project$Main$GotDashboardMsg, model)));
				case 14:
					var _v12 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunityAbout,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$About$init,
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunityAbout, $author$project$Main$GotCommunityAboutMsg, model)));
				case 15:
					var selectedObjective = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunityObjectives(selectedObjective),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Objectives$init(selectedObjective),
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunityObjectives, $author$project$Main$GotCommunityObjectivesMsg, model)));
				case 18:
					var _v13 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettings,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Settings$Settings$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunitySettings, $author$project$Main$GotCommunitySettingsMsg, model)));
				case 33:
					var _v14 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsShopCategories,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Settings$Shop$Categories$init,
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsShopCategories, $author$project$Main$GotCommunitySettingsShopCategoriesMsg, model)));
				case 19:
					var _v15 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsFeatures,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Settings$Features$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunitySettingsFeatures, $author$project$Main$GotCommunitySettingsFeaturesMsg, model)));
				case 20:
					var _v16 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsInfo,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Settings$Info$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunitySettingsInfo, $author$project$Main$GotCommunitySettingsInfoMsg, model)));
				case 21:
					var _v17 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsNews,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Settings$News$init,
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsNews, $author$project$Main$GotCommunitySettingsNewsMsg, model)));
				case 22:
					var editorKind = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsNewsEditor(editorKind),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Settings$News$Editor$init(editorKind),
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsNewsEditor, $author$project$Main$GotCommunitySettingsNewsEditorMsg, model)));
				case 23:
					var _v18 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsCurrency,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Settings$Currency$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunitySettingsCurrency, $author$project$Main$GotCommunitySettingsCurrencyMsg, model)));
				case 24:
					var _v19 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsSponsorship,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Settings$Sponsorship$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunitySettingsSponsorship, $author$project$Main$GotCommunitySettingsSponsorshipMsg, model)));
				case 25:
					var _v20 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsSponsorshipFiat,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Settings$Sponsorship$Fiat$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunitySettingsSponsorshipFiat, $author$project$Main$GotCommunitySettingsSponsorshipFiatMsg, model)));
				case 26:
					var _v21 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsSponsorshipThankYouMessage,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunitySettingsSponsorshipThankYouMessage, $author$project$Main$GotCommunitySettingsSponsorshipThankYouMessageMsg, model)));
				case 34:
					var maybeRedirect = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySelector(maybeRedirect),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Selector$init(maybeRedirect),
							A3(
								$author$project$Main$updateStatusWith,
								$author$project$Main$CommunitySelector,
								function (_v22) {
									return $author$project$Main$Ignored;
								},
								model)));
				case 35:
					var _v23 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$CommunityThankYou));
				case 36:
					var _v24 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySponsor,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Sponsor$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunitySponsor, $author$project$Main$GotCommunitySponsorMsg, model)));
				case 37:
					var _v25 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySupporters,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Supporters$init,
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySupporters, $author$project$Main$GotCommunitySupportersMsg, model)));
				case 16:
					var _v26 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$NewCommunity,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$New$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunityEditor, $author$project$Main$GotCommunityEditorMsg, model)));
				case 27:
					var _v27 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsObjectives,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Settings$Objectives$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunitySettingsObjectives, $author$project$Main$GotCommunitySettingsObjectivesMsg, model)));
				case 28:
					var _v28 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsNewObjective,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Settings$ObjectiveEditor$initNew,
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunitySettingsObjectiveEditor, $author$project$Main$GotCommunitySettingsObjectiveEditorMsg, model)));
				case 29:
					var objectiveId = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsEditObjective(objectiveId),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A2(
									$author$project$Page$Community$Settings$ObjectiveEditor$initEdit,
									l,
									$author$project$Action$objectiveIdFromInt(objectiveId));
							},
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunitySettingsObjectiveEditor, $author$project$Main$GotCommunitySettingsObjectiveEditorMsg, model)));
				case 30:
					var objectiveId = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsNewAction(objectiveId),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A3(
									$author$project$Page$Community$Settings$ActionEditor$init,
									l,
									$author$project$Action$objectiveIdFromInt(objectiveId),
									$elm$core$Maybe$Nothing);
							},
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsActionEditor, $author$project$Main$GotCommunitySettingsActionEditorMsg, model)));
				case 31:
					var _v29 = maybeRoute.a;
					var objectiveId = _v29.a;
					var actionId = _v29.b;
					return A2(
						withLoggedIn,
						A2($author$project$Route$CommunitySettingsEditAction, objectiveId, actionId),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A3(
									$author$project$Page$Community$Settings$ActionEditor$init,
									l,
									$author$project$Action$objectiveIdFromInt(objectiveId),
									$elm$core$Maybe$Just(
										$author$project$Action$idFromInt(actionId)));
							},
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsActionEditor, $author$project$Main$GotCommunitySettingsActionEditorMsg, model)));
				case 32:
					var _v30 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySettingsContacts,
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return $author$project$Page$Community$Settings$Contacts$init(l);
							},
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunitySettingsContacts, $author$project$Main$GotCommunitySettingsContactsMsg, model)));
				case 38:
					var _v31 = maybeRoute.a;
					var objectiveId = _v31.a;
					var actionId = _v31.b;
					var claimId = _v31.c;
					return A2(
						withLoggedIn,
						A3($author$project$Route$Claim, objectiveId, actionId, claimId),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A2($author$project$Page$Dashboard$Claim$init, l, claimId);
							},
							A3(
								$author$project$Main$updateLoggedInUResult,
								A2($author$project$Main$Claim, objectiveId, actionId),
								$author$project$Main$GotVerifyClaimMsg,
								model)));
				case 40:
					var maybeFilter = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Shop(maybeFilter),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A2($author$project$Page$Shop$init, l, maybeFilter);
							},
							A3(
								$author$project$Main$updateLoggedInUResult,
								$author$project$Main$Shop(maybeFilter),
								$author$project$Main$GotShopMsg,
								model)));
				case 41:
					var step = maybeRoute.a.a;
					var newModelCmd = function (l) {
						var _v32 = model.pN;
						if (_v32.$ === 39) {
							var shopEditorModel = _v32.b;
							return A3($author$project$Page$Shop$Editor$maybeSetStep, l, step, shopEditorModel);
						} else {
							return $author$project$Page$Shop$Editor$initCreate(l);
						}
					};
					return A2(
						withLoggedIn,
						$author$project$Route$NewSale(step),
						A2(
							$elm$core$Basics$composeR,
							newModelCmd,
							A3(
								$author$project$Main$updateLoggedInUResult,
								$author$project$Main$ShopEditor($elm$core$Maybe$Nothing),
								$author$project$Main$GotShopEditorMsg,
								model)));
				case 42:
					var _v33 = maybeRoute.a;
					var saleId = _v33.a;
					var saleStep = _v33.b;
					var newUpdateResult = function (l) {
						var _v34 = model.pN;
						if (_v34.$ === 39) {
							var shopEditorModel = _v34.b;
							return A3($author$project$Page$Shop$Editor$maybeSetStep, l, saleStep, shopEditorModel);
						} else {
							return A3($author$project$Page$Shop$Editor$initUpdate, saleId, saleStep, l);
						}
					};
					return A2(
						withLoggedIn,
						A2($author$project$Route$EditSale, saleId, saleStep),
						A2(
							$elm$core$Basics$composeR,
							newUpdateResult,
							A3(
								$author$project$Main$updateLoggedInUResult,
								$author$project$Main$ShopEditor(
									$elm$core$Maybe$Just(saleId)),
								$author$project$Main$GotShopEditorMsg,
								model)));
				case 43:
					var saleId = maybeRoute.a.a;
					return A2(
						withSession,
						$author$project$Route$ViewSale(saleId),
						A2(
							$elm$core$Basics$composeR,
							function (s) {
								return A2($author$project$Page$Shop$Viewer$init, s, saleId);
							},
							A3(
								$author$project$Main$updatePageUResult,
								$author$project$Main$ShopViewer(saleId),
								$author$project$Main$GotShopViewerMsg,
								model)));
				case 44:
					var transferId = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$ViewTransfer(transferId),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A2($author$project$Page$ViewTransfer$init, l, transferId);
							},
							A3(
								$author$project$Main$updateLoggedInUResult,
								$author$project$Main$ViewTransfer(transferId),
								$author$project$Main$GotViewTransferScreenMsg,
								model)));
				case 45:
					var invitationId = maybeRoute.a.a;
					return A2(
						withSession,
						$author$project$Route$Invite(invitationId),
						A2(
							$elm$core$Basics$composeR,
							function (s) {
								return A2($author$project$Page$Community$Invite$init, s, invitationId);
							},
							A3($author$project$Main$updateStatusWith, $author$project$Main$Invite, $author$project$Main$GotInviteMsg, model)));
				case 46:
					var maybeRedirect = maybeRoute.a.a;
					return A2(
						withSession,
						$author$project$Route$Join(maybeRedirect),
						A2(
							$elm$core$Basics$composeR,
							function (s) {
								return A2($author$project$Page$Join$init, s, maybeRedirect);
							},
							A3($author$project$Main$updateStatusWith, $author$project$Main$Join, $author$project$Main$GotJoinMsg, model)));
				case 47:
					var maybeTo = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Transfer(maybeTo),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A2($author$project$Page$Community$Transfer$init, l, maybeTo);
							},
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Transfer, $author$project$Main$GotTransferMsg, model)));
				default:
					var _v35 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Analysis,
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return $author$project$Page$Dashboard$Analysis$init(l);
							},
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Analysis, $author$project$Main$GotAnalysisMsg, model)));
			}
		}
	});
var $author$project$Flags$Flags = function (language) {
	return function (version) {
		return function (maybeAccount) {
			return function (endpoints) {
				return function (logo) {
					return function (logoMobile) {
						return function (now) {
							return function (allowCommunityCreation) {
								return function (tokenContract) {
									return function (communityContract) {
										return function (authToken) {
											return function (canReadClipboard) {
												return function (canShare) {
													return function (useSubdomain) {
														return function (selectedCommunity) {
															return function (pinVisibility) {
																return function (hasSeenSponsorModal) {
																	return {jh: allowCommunityCreation, jk: authToken, jp: canReadClipboard, jq: canShare, jx: communityContract, jN: endpoints, j2: hasSeenSponsorModal, ic: language, fe: logo, ky: logoMobile, kA: maybeAccount, ce: now, o9: pinVisibility, pC: selectedCommunity, lG: tokenContract, qf: useSubdomain, lZ: version};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Version$Version = $elm$core$Basics$identity;
var $author$project$Version$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Flags$Endpoints = F3(
	function (eosio, api, graphql) {
		return {mh: api, m9: eosio, gx: graphql};
	});
var $author$project$Flags$decodeEndpoints = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'graphql',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'api',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'eosio',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Flags$Endpoints))));
var $author$project$Eos$Account$nameDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Eos$maxSymbolLength = 7;
var $author$project$Eos$minSymbolLength = 3;
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Eos$symbolFromString = function (str) {
	var details = A2(
		$elm$core$List$take,
		2,
		A2($elm$core$String$split, ',', str));
	var maybePrecision = A2(
		$elm$core$Maybe$andThen,
		$elm$core$String$toInt,
		$elm$core$List$head(details));
	var maybeSymbolCode = $elm$core$List$head(
		$elm$core$List$reverse(details));
	var _v0 = _Utils_Tuple2(maybeSymbolCode, maybePrecision);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var symbolCode = _v0.a.a;
		var precision = _v0.b.a;
		return (A2($elm$core$String$all, $elm$core$Char$isAlpha, symbolCode) && ((_Utils_cmp(
			$elm$core$String$length(symbolCode),
			$author$project$Eos$minSymbolLength) > -1) || (_Utils_cmp(
			$elm$core$String$length(symbolCode),
			$author$project$Eos$maxSymbolLength) < 1))) ? $elm$core$Maybe$Just(
			A2(
				$author$project$Eos$Symbol,
				$elm$core$String$toUpper(symbolCode),
				precision)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Eos$symbolDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		if (string === 'undefined') {
			return $elm$json$Json$Decode$fail('Cannot decode \'undefined\' symbol, check Javascript');
		} else {
			var _v0 = $author$project$Eos$symbolFromString(string);
			if (!_v0.$) {
				var symbol = _v0.a;
				return $elm$json$Json$Decode$succeed(symbol);
			} else {
				return $elm$json$Json$Decode$fail('Cannot decode given symbol');
			}
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Graphql$Token = $elm$core$Basics$identity;
var $author$project$Api$Graphql$tokenDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Flags$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hasSeenSponsorModal',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pinVisibility',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'selectedCommunity',
			$elm$json$Json$Decode$nullable($author$project$Eos$symbolDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'useSubdomain',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'canShare',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'canReadClipboard',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'authToken',
							$elm$json$Json$Decode$nullable($author$project$Api$Graphql$tokenDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'communityContract',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'tokenContract',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'allowCommunityCreation',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'now',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'logoMobile',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'logo',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'endpoints',
														$author$project$Flags$decodeEndpoints,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'accountName',
															$elm$json$Json$Decode$nullable($author$project$Eos$Account$nameDecoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'version',
																$author$project$Version$decode,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'language',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Flags$Flags))))))))))))))))));
var $author$project$Version$default = '1.0.0';
var $author$project$Flags$defaultEndpoints = {mh: 'https://api.cambiatus.io', m9: 'https://eosio.cambiatus.io', gx: 'https://api.cambiatus.io/api/graph'};
var $author$project$Flags$default = {jh: true, jk: $elm$core$Maybe$Nothing, jp: false, jq: false, jx: 'bes.cmm', jN: $author$project$Flags$defaultEndpoints, j2: false, ic: 'en-US', fe: '/images/logo-cambiatus.png', ky: '/images/logo-cambiatus-mobile.svg', kA: $elm$core$Maybe$Nothing, ce: 0, o9: false, pC: $elm$core$Maybe$Nothing, lG: 'bes.token', qf: true, lZ: $author$project$Version$default};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {cJ: frag, cX: params, ct: unvisited, lW: value, de: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.ct;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.lW);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.lW);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.g_),
					$elm$url$Url$Parser$prepareQuery(url.ed),
					url.nl,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$ComingSoon = {$: 1};
var $author$project$Route$CopyNews = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$EditNews = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$Logout = {$: 4};
var $author$project$Route$Root = {$: 0};
var $author$project$Route$WithObjectiveSelected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Shop$Category$idFromString = function (id) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Basics$identity,
		$elm$core$String$toInt(id));
};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.de;
			var unvisited = _v0.ct;
			var params = _v0.cX;
			var frag = _v0.cJ;
			var value = _v0.lW;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.de;
		var unvisited = _v0.ct;
		var params = _v0.cX;
		var frag = _v0.cJ;
		var value = _v0.lW;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.de;
			var unvisited = _v1.ct;
			var params = _v1.cX;
			var frag = _v1.cJ;
			var value = _v1.lW;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $author$project$Shop$idUrlParser = A2($elm$url$Url$Parser$map, $elm$core$Basics$identity, $elm$url$Url$Parser$int);
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.de;
		var unvisited = _v1.ct;
		var params = _v1.cX;
		var frag = _v1.cJ;
		var value = _v1.lW;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.de;
		var unvisited = _v0.ct;
		var params = _v0.cX;
		var frag = _v0.cJ;
		var value = _v0.lW;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$Route$saleStepFromString = function (stepString) {
	_v0$4:
	while (true) {
		if (!stepString.$) {
			switch (stepString.a) {
				case 'mainInformation':
					return 0;
				case 'images':
					return 1;
				case 'categories':
					return 2;
				case 'priceAndInventory':
					return 3;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return 0;
};
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Eos$Account$stringToName = function (string) {
	return string;
};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$parseRedirect = F2(
	function (url, maybeQuery) {
		var protocol = function () {
			var _v1 = url.pn;
			if (!_v1) {
				return 'http://';
			} else {
				return 'https://';
			}
		}();
		var port_ = function () {
			var _v0 = url.pb;
			if (_v0.$ === 1) {
				return '';
			} else {
				var p = _v0.a;
				return ':' + $elm$core$String$fromInt(p);
			}
		}();
		var host = url.e3;
		return A2(
			$elm$core$Maybe$andThen,
			function (url_) {
				return A2(
					$elm$url$Url$Parser$parse,
					$author$project$Route$parser(url_),
					url_);
			},
			A2(
				$elm$core$Maybe$andThen,
				function (query) {
					return $elm$url$Url$fromString(
						_Utils_ap(
							protocol,
							_Utils_ap(
								host,
								_Utils_ap(port_, query))));
				},
				maybeQuery));
	});
var $author$project$Route$parser = function (url) {
	return $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2($elm$url$Url$Parser$map, $author$project$Route$Root, $elm$url$Url$Parser$top),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ComingSoon,
				$elm$url$Url$Parser$s('coming-soon')),
				A2(
				$elm$url$Url$Parser$map,
				A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Route$Register),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('register'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$Query$map,
							$author$project$Route$parseRedirect(url),
							$elm$url$Url$Parser$Query$string('redirect'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Register($elm$core$Maybe$Nothing),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('register'),
					A2(
						$elm$url$Url$Parser$Query$map,
						$author$project$Route$parseRedirect(url),
						$elm$url$Url$Parser$Query$string('redirect')))),
				A2(
				$elm$url$Url$Parser$map,
				A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Route$Login),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('login'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$Query$map,
							$author$project$Route$parseRedirect(url),
							$elm$url$Url$Parser$Query$string('redirect'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Login($elm$core$Maybe$Nothing),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('login'),
					A2(
						$elm$url$Url$Parser$Query$map,
						$author$project$Route$parseRedirect(url),
						$elm$url$Url$Parser$Query$string('redirect')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Logout,
				$elm$url$Url$Parser$s('logout')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ProfileEditor,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('profile'),
					$elm$url$Url$Parser$s('edit'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ProfileAddKyc,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('profile'),
					$elm$url$Url$Parser$s('add-kyc'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ProfileAddContact,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('profile'),
					$elm$url$Url$Parser$s('add-contact'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Profile,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('profile'),
					A2($elm$url$Url$Parser$map, $author$project$Eos$Account$stringToName, $elm$url$Url$Parser$string))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ProfileContributions,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('profile'),
					A2(
						$elm$url$Url$Parser$slash,
						A2($elm$url$Url$Parser$map, $author$project$Eos$Account$stringToName, $elm$url$Url$Parser$string),
						$elm$url$Url$Parser$s('contributions')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ProfileClaims,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('profile'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('claims')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$PaymentHistory,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('payments'),
					A2($elm$url$Url$Parser$map, $author$project$Eos$Account$stringToName, $elm$url$Url$Parser$string))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Notification,
				$elm$url$Url$Parser$s('notification')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Dashboard,
				$elm$url$Url$Parser$s('dashboard')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$NewCommunity,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					$elm$url$Url$Parser$s('new'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$News(
					{pD: $elm$core$Maybe$Nothing, pJ: true}),
				$elm$url$Url$Parser$s('news')),
				A2(
				$elm$url$Url$Parser$map,
				F2(
					function (newsId, showOthers) {
						return $author$project$Route$News(
							{
								pD: $elm$core$Maybe$Just(newsId),
								pJ: showOthers
							});
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('news'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$int,
						A2(
							$elm$url$Url$Parser$Query$map,
							function (showOthers) {
								return !_Utils_eq(
									showOthers,
									$elm$core$Maybe$Just('false'));
							},
							$elm$url$Url$Parser$Query$string('showOthers'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunityAbout,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					$elm$url$Url$Parser$s('about'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunityObjectives($author$project$Route$WithNoObjectiveSelected),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					$elm$url$Url$Parser$s('objectives'))),
				A2(
				$elm$url$Url$Parser$map,
				function (objectiveId) {
					return $author$project$Route$CommunityObjectives(
						$author$project$Route$WithObjectiveSelected(
							{dh: $elm$core$Maybe$Nothing, w: objectiveId}));
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('objectives'),
						$elm$url$Url$Parser$int))),
				A2(
				$elm$url$Url$Parser$map,
				F2(
					function (objectiveId, actionId) {
						return $author$project$Route$CommunityObjectives(
							$author$project$Route$WithObjectiveSelected(
								{
									dh: $elm$core$Maybe$Just(actionId),
									w: objectiveId
								}));
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('objectives'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$int,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('action'),
								$elm$url$Url$Parser$int))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettings,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					$elm$url$Url$Parser$s('settings'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsFeatures,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('features')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsInfo,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('info')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsNews,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('news')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsNewsEditor($author$project$Route$CreateNews),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('news'),
							$elm$url$Url$Parser$s('new'))))),
				A2(
				$elm$url$Url$Parser$map,
				A2($elm$core$Basics$composeR, $author$project$Route$EditNews, $author$project$Route$CommunitySettingsNewsEditor),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('news'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('edit'),
								$elm$url$Url$Parser$int))))),
				A2(
				$elm$url$Url$Parser$map,
				A2($elm$core$Basics$composeR, $author$project$Route$CopyNews, $author$project$Route$CommunitySettingsNewsEditor),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('news'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('copy'),
								$elm$url$Url$Parser$int))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsCurrency,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('currency')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsSponsorship,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('sponsorship')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsSponsorshipFiat,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('sponsorship'),
							$elm$url$Url$Parser$s('fiat'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsSponsorshipThankYouMessage,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('sponsorship'),
							$elm$url$Url$Parser$s('thank-you'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsObjectives,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('objectives')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySelector,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('selector'),
						A2(
							$elm$url$Url$Parser$Query$map,
							$author$project$Route$parseRedirect(url),
							$elm$url$Url$Parser$Query$string('redirect'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunityThankYou,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					$elm$url$Url$Parser$s('thank-you'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySponsor,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					$elm$url$Url$Parser$s('sponsor'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySupporters,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					$elm$url$Url$Parser$s('supporters'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsNewObjective,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('objectives'),
							$elm$url$Url$Parser$s('new'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsEditObjective,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('objectives'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								$elm$url$Url$Parser$s('edit')))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsNewAction,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('objectives'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('action'),
									$elm$url$Url$Parser$s('new'))))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsEditAction,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('objectives'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('action'),
									A2(
										$elm$url$Url$Parser$slash,
										$elm$url$Url$Parser$int,
										$elm$url$Url$Parser$s('edit')))))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsContacts,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('contacts')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsShopCategories,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('shop'),
							$elm$url$Url$Parser$s('categories'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Claim,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('objectives'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$int,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('action'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('claim'),
									$elm$url$Url$Parser$int)))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Settings,
				$elm$url$Url$Parser$s('settings')),
				A2(
				$elm$url$Url$Parser$map,
				F2(
					function (maybeOwner, categoriesIds) {
						return $author$project$Route$Shop(
							{dn: categoriesIds, o1: maybeOwner});
					}),
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('shop'),
						A2(
							$elm$url$Url$Parser$Query$map,
							$elm$core$Maybe$map($author$project$Eos$Account$stringToName),
							$elm$url$Url$Parser$Query$string('from'))),
					A2(
						$elm$url$Url$Parser$Query$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$split(','),
									$elm$core$List$filterMap($author$project$Shop$Category$idFromString))),
							$elm$core$Maybe$withDefault(_List_Nil)),
						$elm$url$Url$Parser$Query$string('categories')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$NewSale,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('shop'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('new'),
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('sell'),
							A2(
								$elm$url$Url$Parser$Query$map,
								$author$project$Route$saleStepFromString,
								$elm$url$Url$Parser$Query$string('step')))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ViewSale,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('shop'),
					$author$project$Shop$idUrlParser)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$EditSale,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('shop'),
					A2(
						$elm$url$Url$Parser$slash,
						$author$project$Shop$idUrlParser,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('edit'),
							A2(
								$elm$url$Url$Parser$Query$map,
								$author$project$Route$saleStepFromString,
								$elm$url$Url$Parser$Query$string('step')))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ViewTransfer,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('transfer'),
					$elm$url$Url$Parser$int)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Invite,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('invite'),
					$elm$url$Url$Parser$string)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Join,
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('join'),
					A2(
						$elm$url$Url$Parser$Query$map,
						$author$project$Route$parseRedirect(url),
						$elm$url$Url$Parser$Query$string('redirect')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Transfer,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('transfer'),
						A2(
							$elm$url$Url$Parser$Query$map,
							$elm$core$Maybe$map($author$project$Eos$Account$stringToName),
							$elm$url$Url$Parser$Query$string('to'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Analysis,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('dashboard'),
					$elm$url$Url$Parser$s('analysis')))
			]));
};
var $author$project$Route$fromUrl = function (url) {
	return A2(
		$elm$url$Url$Parser$parse,
		$author$project$Route$parser(url),
		url);
};
var $author$project$Page$Ignored = {$: 0};
var $author$project$Page$GotTimezone = function (a) {
	return {$: 2, a: a};
};
var $elm$time$Time$here = _Time_here(0);
var $author$project$Page$fetchTimezone = A2($elm$core$Task$attempt, $author$project$Page$GotTimezone, $elm$time$Time$here);
var $author$project$Page$CompletedLoadTranslation = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{f6: $elm$http$Http$emptyBody, gt: r.gt, nr: _List_Nil, cd: 'GET', au: $elm$core$Maybe$Nothing, lK: $elm$core$Maybe$Nothing, hn: r.hn});
};
var $author$project$Version$toString = function (_v0) {
	var version = _v0;
	return version;
};
var $author$project$I18Next$Translations = $elm$core$Basics$identity;
var $author$project$I18Next$foldTree = F3(
	function (initialValue, dict, namespace) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, val, acc) {
					var newNamespace = function (currentKey) {
						return $elm$core$String$isEmpty(namespace) ? currentKey : (namespace + ('.' + currentKey));
					};
					if (val.$ === 1) {
						var str = val.a;
						return A3(
							$elm$core$Dict$insert,
							newNamespace(key),
							str,
							acc);
					} else {
						var children = val.a;
						return A3(
							$author$project$I18Next$foldTree,
							acc,
							children,
							newNamespace(key));
					}
				}),
			initialValue,
			dict);
	});
var $author$project$I18Next$initialTranslations = $elm$core$Dict$empty;
var $author$project$I18Next$mapTreeToDict = function (tree) {
	if (!tree.$) {
		var dict = tree.a;
		return A3($author$project$I18Next$foldTree, $elm$core$Dict$empty, dict, '');
	} else {
		return $author$project$I18Next$initialTranslations;
	}
};
var $author$project$I18Next$Branch = function (a) {
	return {$: 0, a: a};
};
var $author$project$I18Next$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
function $author$project$I18Next$cyclic$treeDecoder() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $author$project$I18Next$Leaf, $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$I18Next$Branch,
						$elm$json$Json$Decode$dict(
							$author$project$I18Next$cyclic$treeDecoder()));
				})
			]));
}
var $author$project$I18Next$treeDecoder = $author$project$I18Next$cyclic$treeDecoder();
$author$project$I18Next$cyclic$treeDecoder = function () {
	return $author$project$I18Next$treeDecoder;
};
var $author$project$I18Next$translationsDecoder = A2($elm$json$Json$Decode$map, $author$project$I18Next$mapTreeToDict, $author$project$I18Next$treeDecoder);
var $author$project$Translation$get = F3(
	function (version, language, toMsg) {
		var translation = function () {
			switch (language) {
				case 0:
					return 'en-US.json';
				case 1:
					return 'pt-BR.json';
				case 2:
					return 'es-ES.json';
				case 3:
					return 'cat-CAT.json';
				default:
					return 'amh-ETH.json';
			}
		}();
		return $elm$http$Http$get(
			{
				gt: A2($elm$http$Http$expectJson, toMsg, $author$project$I18Next$translationsDecoder),
				hn: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						['translations', translation]),
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'version',
							$author$project$Version$toString(version))
						]))
			});
	});
var $author$project$Page$fetchTranslations = F2(
	function (version, language) {
		return A3(
			$author$project$Translation$get,
			version,
			language,
			$author$project$Page$CompletedLoadTranslation(language));
	});
var $author$project$Session$LoggedIn$init = F3(
	function (shared, accountName, authToken) {
		var _v0 = A5($author$project$Session$LoggedIn$initModel, shared, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, accountName, authToken);
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$author$project$Session$LoggedIn$internalQuery,
						model,
						$author$project$Profile$query(accountName),
						$author$project$Session$LoggedIn$CompletedLoadProfile),
						A2($author$project$Session$LoggedIn$fetchCommunity, model, $elm$core$Maybe$Nothing),
						A2($elm$core$Task$perform, $author$project$Session$LoggedIn$GotTimeInternal, $elm$time$Time$now),
						cmd,
						function () {
						if (authToken.$ === 1) {
							return $elm$core$Platform$Cmd$none;
						} else {
							var token = authToken.a;
							return $author$project$Api$Graphql$createAbsintheSocket(token);
						}
					}()
					])));
	});
var $author$project$Session$Shared$Bip39NotLoaded = {$: 1};
var $author$project$Session$Shared$LoadingTranslation = {$: 0};
var $author$project$Translation$defaultLanguage = 0;
var $author$project$Translation$Catalan = 3;
var $author$project$Translation$languageFromLanguageCode = function (locale) {
	var _v0 = $elm$core$String$toLower(locale);
	switch (_v0) {
		case 'en-us':
			return $elm$core$Maybe$Just(0);
		case 'pt-br':
			return $elm$core$Maybe$Just(1);
		case 'es':
			return $elm$core$Maybe$Just(2);
		case 'cat':
			return $elm$core$Maybe$Just(3);
		case 'amh':
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Translation$languageFromLocale = function (locale) {
	var _v0 = $elm$core$String$toLower(locale);
	switch (_v0) {
		case 'en-us':
			return $elm$core$Maybe$Just(0);
		case 'pt-br':
			return $elm$core$Maybe$Just(1);
		case 'es-es':
			return $elm$core$Maybe$Just(2);
		case 'ca-es':
			return $elm$core$Maybe$Just(3);
		case 'am-et':
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$I18Next$Curly = 0;
var $author$project$I18Next$t = F2(
	function (_v0, key) {
		var translations = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2($elm$core$Dict$get, key, translations));
	});
var $author$project$I18Next$delimsToTuple = function (delims) {
	return _Utils_Tuple2('{{', '}}');
};
var $author$project$I18Next$replacePlaceholders = F3(
	function (replacements, delims, string) {
		var _v0 = $author$project$I18Next$delimsToTuple(delims);
		var start = _v0.a;
		var end = _v0.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, acc) {
					var key = _v1.a;
					var value = _v1.b;
					return A3(
						$elm$core$String$replace,
						_Utils_ap(
							start,
							_Utils_ap(key, end)),
						value,
						acc);
				}),
			string,
			replacements);
	});
var $author$project$I18Next$tr = F4(
	function (_v0, delims, key, replacements) {
		var translations = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$I18Next$replacePlaceholders, replacements, delims),
				A2($elm$core$Dict$get, key, translations)));
	});
var $author$project$Session$Shared$makeTranslators = function (translations) {
	var tr = A2($author$project$I18Next$tr, translations, 0);
	var t = $author$project$I18Next$t(translations);
	return {fL: t, i4: tr};
};
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Session$Shared$init = F3(
	function (flags, navKey, url) {
		var maybeAccount = flags.kA;
		var endpoints = flags.jN;
		var allowCommunityCreation = flags.jh;
		var tokenContract = flags.lG;
		var communityContract = flags.jx;
		var environment = $author$project$Environment$fromUrl(url);
		var addMatomoScriptCmd = A2(
			$author$project$Ports$javascriptOutCmd,
			function (_v2) {
				return _List_Nil;
			},
			$author$project$Ports$javascriptOut(
				{
					bZ: $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string('addMatomoScript'))
							])),
					fy: 0,
					fz: $elm$json$Json$Encode$null
				}));
		return _Utils_Tuple2(
			{
				jh: allowCommunityCreation,
				f4: $author$project$Session$Shared$Bip39NotLoaded,
				jp: flags.jp,
				jq: flags.jq,
				hL: {V: communityContract, p5: tokenContract},
				jN: endpoints,
				m8: environment,
				j2: flags.j2,
				ic: function () {
					var _v0 = $author$project$Translation$languageFromLanguageCode(flags.ic);
					if (!_v0.$) {
						var lang = _v0.a;
						return lang;
					} else {
						return A2(
							$elm$core$Maybe$withDefault,
							$author$project$Translation$defaultLanguage,
							$author$project$Translation$languageFromLocale(flags.ic));
					}
				}(),
				fe: flags.fe,
				ky: flags.ky,
				kA: maybeAccount,
				kK: navKey,
				ce: $elm$time$Time$millisToPosix(flags.ce),
				o9: flags.o9,
				pC: flags.pC,
				i2: $elm$time$Time$utc,
				fV: $author$project$I18Next$initialTranslations,
				bP: $author$project$Session$Shared$LoadingTranslation,
				aw: $author$project$Session$Shared$makeTranslators($author$project$I18Next$initialTranslations),
				hn: url,
				qf: flags.qf,
				lZ: flags.lZ
			},
			function () {
				if (environment === 3) {
					return addMatomoScriptCmd;
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			}());
	});
var $author$project$Page$init = F3(
	function (flags, navKey, url) {
		var _v0 = A3($author$project$Session$Shared$init, flags, navKey, url);
		var shared = _v0.a;
		var sharedCmd = _v0.b;
		var initialCmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Page$fetchTranslations, shared.lZ, shared.ic),
					$author$project$Page$fetchTimezone,
					sharedCmd
				]));
		var _v1 = shared.kA;
		if (!_v1.$) {
			var accountName = _v1.a;
			var _v2 = A3($author$project$Session$LoggedIn$init, shared, accountName, flags.jk);
			var model = _v2.a;
			var cmd = _v2.b;
			return A2(
				$author$project$UpdateResult$addBreadcrumb,
				{f7: $author$project$Page$Ignored, bZ: $elm$core$Dict$empty, n4: 4, of: 'Started Elm app with loggedIn user', eq: 1},
				A2(
					$author$project$UpdateResult$addCmd,
					A2($elm$core$Platform$Cmd$map, $author$project$Page$GotLoggedInMsg, cmd),
					A2(
						$author$project$UpdateResult$addCmd,
						initialCmds,
						$author$project$UpdateResult$init(
							$author$project$Page$LoggedIn(model)))));
		} else {
			var _v3 = $author$project$Session$Guest$init(shared);
			var model = _v3.a;
			var cmd = _v3.b;
			return A2(
				$author$project$UpdateResult$addBreadcrumb,
				{f7: $author$project$Page$Ignored, bZ: $elm$core$Dict$empty, n4: 4, of: 'Started Elm app with guest user', eq: 1},
				A2(
					$author$project$UpdateResult$addCmd,
					A2($elm$core$Platform$Cmd$map, $author$project$Page$GotGuestMsg, cmd),
					A2(
						$author$project$UpdateResult$addCmd,
						initialCmds,
						$author$project$UpdateResult$init(
							$author$project$Page$Guest(model)))));
		}
	});
var $author$project$Log$DecodingError = 2;
var $author$project$Log$Error = 1;
var $author$project$Log$encodeDecodingError = function (error) {
	switch (error.$) {
		case 0:
			var fieldName = error.a;
			var fieldError = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Decode.Field')),
						_Utils_Tuple2(
						'fieldName',
						$elm$json$Json$Encode$string(fieldName)),
						_Utils_Tuple2(
						'fieldError',
						$author$project$Log$encodeDecodingError(fieldError))
					]));
		case 1:
			var index = error.a;
			var indexError = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Decode.Index')),
						_Utils_Tuple2(
						'index',
						$elm$json$Json$Encode$int(index)),
						_Utils_Tuple2(
						'indexError',
						$author$project$Log$encodeDecodingError(indexError))
					]));
		case 2:
			var errors = error.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Decode.OneOf')),
						_Utils_Tuple2(
						'errors',
						A2($elm$json$Json$Encode$list, $author$project$Log$encodeDecodingError, errors))
					]));
		default:
			var failureString = error.a;
			var failureValue = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Decode.Failure')),
						_Utils_Tuple2(
						'failureString',
						$elm$json$Json$Encode$string(failureString)),
						_Utils_Tuple2('failureValue', failureValue)
					]));
	}
};
var $author$project$Log$fromDecodeError = F6(
	function (transaction, maybeUser, description, location, contexts, error) {
		return {
			mL: A2(
				$elm$core$List$cons,
				{
					ng: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'Description',
								$elm$json$Json$Encode$string(description)),
								_Utils_Tuple2(
								'Error',
								$author$project$Log$encodeDecodingError(error))
							])),
					fj: 'Decode error'
				},
				contexts),
			n4: 1,
			oa: location,
			of: 'Got an error when trying to decode a JSON value',
			pY: _List_fromArray(
				[
					$author$project$Log$TypeTag(2)
				]),
			p7: transaction,
			qh: maybeUser
		};
	});
var $author$project$UpdateResult$logEvent = F2(
	function (event, uResult) {
		return _Utils_update(
			uResult,
			{
				jQ: A2($elm$core$List$cons, event, uResult.jQ)
			});
	});
var $author$project$UpdateResult$logDecodingError = F6(
	function (transaction, maybeUser, description, location, contexts, error) {
		return $author$project$UpdateResult$logEvent(
			A6($author$project$Log$fromDecodeError, transaction, maybeUser, description, location, contexts, error));
	});
var $author$project$UpdateResult$toModelCmd = F3(
	function (transformEMsg, msgToString, uResult) {
		toModelCmd:
		while (true) {
			var _v0 = uResult.jS;
			if (_v0.b) {
				var ext = _v0.a;
				var extTail = _v0.b;
				var _v1 = A2(transformEMsg, ext, uResult.ok);
				var newM = _v1.a;
				var newCmd = _v1.b;
				var $temp$transformEMsg = transformEMsg,
					$temp$msgToString = msgToString,
					$temp$uResult = _Utils_update(
					uResult,
					{
						ju: _Utils_ap(
							uResult.ju,
							_List_fromArray(
								[newCmd])),
						jS: extTail,
						ok: newM
					});
				transformEMsg = $temp$transformEMsg;
				msgToString = $temp$msgToString;
				uResult = $temp$uResult;
				continue toModelCmd;
			} else {
				return _Utils_Tuple2(
					uResult.ok,
					$elm$core$Platform$Cmd$batch(
						_Utils_ap(
							uResult.ju,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$author$project$Log$addBreadcrumb(msgToString),
									$elm$core$List$reverse(uResult.af)),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										$author$project$Ports$javascriptOutCmd(msgToString),
										uResult.k0),
									A2(
										$elm$core$List$map,
										$author$project$Log$send(msgToString),
										$elm$core$List$reverse(uResult.jQ)))))));
			}
		}
	});
var $author$project$Main$init = F3(
	function (flagsValue, url, navKey) {
		var _v0 = function () {
			var _v1 = A2($elm$json$Json$Decode$decodeValue, $author$project$Flags$decode, flagsValue);
			if (!_v1.$) {
				var flags = _v1.a;
				return A3(
					$author$project$UpdateResult$toModelCmd,
					F2(
						function (_v3, m) {
							return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
						}),
					$author$project$Main$msgToString,
					A2(
						$author$project$UpdateResult$addBreadcrumb,
						{f7: $author$project$Main$Ignored, bZ: $elm$core$Dict$empty, n4: 4, of: 'Started elm app with flags being decoded', eq: 1},
						A4(
							$author$project$UpdateResult$map,
							$elm$core$Basics$identity,
							$author$project$Main$GotPageMsg,
							F2(
								function (_v2, uR) {
									return uR;
								}),
							A3($author$project$Page$init, flags, navKey, url))));
			} else {
				var e = _v1.a;
				return A3(
					$author$project$UpdateResult$toModelCmd,
					F2(
						function (_v5, m) {
							return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
						}),
					$author$project$Main$msgToString,
					A7(
						$author$project$UpdateResult$logDecodingError,
						$author$project$Main$Ignored,
						$elm$core$Maybe$Nothing,
						'Could not decode flags',
						{e$: 'init', fi: 'Main'},
						_List_Nil,
						e,
						A4(
							$author$project$UpdateResult$map,
							$elm$core$Basics$identity,
							$author$project$Main$GotPageMsg,
							F2(
								function (_v4, uR) {
									return uR;
								}),
							A3($author$project$Page$init, $author$project$Flags$default, navKey, url))));
			}
		}();
		var session = _v0.a;
		var pageCmd = _v0.b;
		var _v6 = A2(
			$author$project$Main$changeRouteTo,
			$author$project$Route$fromUrl(url),
			{bU: $elm$core$Maybe$Nothing, bV: _List_Nil, di: _List_Nil, c: session, pN: $author$project$Main$Redirect});
		var model = _v6.a;
		var routeCmd = _v6.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[pageCmd, routeCmd])));
	});
var $author$project$Main$GotJavascriptData = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Ports$javascriptInPort = _Platform_incomingPort('javascriptInPort', $elm$json$Json$Decode$value);
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Session$Guest$PressedEsc = {$: 4};
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {k$: pids, lz: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {jP: event, kt: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.k$,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.kt;
		var event = _v0.jP;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.lz);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $author$project$Utils$escSubscription = function (toMsg) {
	return A2(
		$elm$core$Platform$Sub$map,
		function (_v0) {
			return toMsg;
		},
		$elm$browser$Browser$Events$onKeyDown(
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return ((key === 'Esc') || (key === 'Escape')) ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('Expecting Escape key');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
};
var $author$project$Session$Guest$subscriptions = function (_v0) {
	return $author$project$Utils$escSubscription($author$project$Session$Guest$PressedEsc);
};
var $author$project$Search$CancelClicked = {$: 2};
var $author$project$Search$closeMsg = $author$project$Search$CancelClicked;
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {k4: processes, lC: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.k4;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.lC);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Search$GotRecentSearches = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ports$gotRecentSearches = _Platform_incomingPort('gotRecentSearches', $elm$json$Json$Decode$string);
var $author$project$Search$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Ports$gotRecentSearches($author$project$Search$GotRecentSearches),
			$author$project$Utils$escSubscription($author$project$Search$CancelClicked)
		]));
var $author$project$Session$LoggedIn$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$core$Platform$Sub$map, $author$project$Session$LoggedIn$GotSearchMsg, $author$project$Search$subscriptions),
				A2($elm$time$Time$every, model.hm, $author$project$Session$LoggedIn$GotTimeInternal),
				model.aL ? $author$project$Utils$escSubscription(
				$author$project$Session$LoggedIn$ShowUserNav(false)) : $elm$core$Platform$Sub$none,
				function () {
				var _v0 = model.al.Z;
				if (!_v0.$) {
					return $elm$core$Platform$Sub$none;
				} else {
					return $author$project$Utils$escSubscription(
						$author$project$Session$LoggedIn$GotSearchMsg($author$project$Search$closeMsg));
				}
			}()
			]));
};
var $author$project$Page$subscriptions = function (session) {
	if (!session.$) {
		var guest = session.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Page$GotGuestMsg,
			$author$project$Session$Guest$subscriptions(guest));
	} else {
		var loggedIn = session.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Page$GotLoggedInMsg,
			$author$project$Session$LoggedIn$subscriptions(loggedIn));
	}
};
var $author$project$Page$Community$Settings$Shop$Categories$ClosedActionsDropdown = {$: 20};
var $author$project$Page$Community$Settings$Shop$Categories$PressedEsc = {$: 1};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$browser$Browser$Events$onClick = A2($elm$browser$Browser$Events$on, 0, 'click');
var $author$project$Page$Community$Settings$Shop$Categories$subscriptions = function (model) {
	var closeDropdownSubscription = $elm$browser$Browser$Events$onClick(
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$andThen,
					function (targetClass) {
						return A2($elm$core$String$contains, 'action-opener', targetClass) ? $elm$json$Json$Decode$fail('') : $elm$json$Json$Decode$succeed($author$project$Page$Community$Settings$Shop$Categories$ClosedActionsDropdown);
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['target', 'className']),
						$elm$json$Json$Decode$string)),
					$elm$json$Json$Decode$succeed($author$project$Page$Community$Settings$Shop$Categories$ClosedActionsDropdown)
				])));
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Utils$escSubscription($author$project$Page$Community$Settings$Shop$Categories$PressedEsc),
				function () {
				var _v0 = model.x;
				switch (_v0.$) {
					case 0:
						return $elm$core$Platform$Sub$none;
					case 2:
						return closeDropdownSubscription;
					default:
						return closeDropdownSubscription;
				}
			}()
			]));
};
var $author$project$Page$Community$Sponsor$RequestedPaypalInfoFromJs = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ports$requestPaypalInfoFromJs = _Platform_incomingPort('requestPaypalInfoFromJs', $elm$json$Json$Decode$string);
var $author$project$Page$Community$Sponsor$subscriptions = function (_v0) {
	return $author$project$Ports$requestPaypalInfoFromJs($author$project$Page$Community$Sponsor$RequestedPaypalInfoFromJs);
};
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$GotPageMsg,
				$author$project$Page$subscriptions(model.c)),
				$author$project$Ports$javascriptInPort($author$project$Main$GotJavascriptData),
				function () {
				var _v0 = model.pN;
				switch (_v0.$) {
					case 19:
						var subModel = _v0.a;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Main$GotCommunitySponsorMsg,
							$author$project$Page$Community$Sponsor$subscriptions(subModel));
					case 8:
						var subModel = _v0.a;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Main$GotCommunitySettingsShopCategoriesMsg,
							$author$project$Page$Community$Settings$Shop$Categories$subscriptions(subModel));
					default:
						return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Log$ExpectedGuest = 1;
var $author$project$Log$ExpectedLoggedIn = 0;
var $author$project$Log$IncompatibleAuthentication = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Register$receiveBroadcast = function (broadcastMsg) {
	var community = broadcastMsg;
	return $elm$core$Maybe$Just(
		$author$project$Page$Register$CompletedLoadCommunity(community));
};
var $author$project$Main$broadcastGuest = F2(
	function (broadcastMessage, status) {
		var maybeMsg = function () {
			if (status.$ === 36) {
				return A2(
					$elm$core$Maybe$map,
					$author$project$Main$GotRegisterMsg,
					$author$project$Page$Register$receiveBroadcast(broadcastMessage));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		if (!maybeMsg.$) {
			var msg = maybeMsg.a;
			return $author$project$Utils$spawnMessage(msg);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Main$hideFeedback = function (model) {
	var _v0 = model.c;
	if (_v0.$ === 1) {
		var loggedIn = _v0.a;
		return _Utils_update(
			model,
			{
				c: $author$project$Page$LoggedIn(
					_Utils_update(
						loggedIn,
						{hU: $author$project$View$Feedback$Hidden}))
			});
	} else {
		var guest = _v0.a;
		return _Utils_update(
			model,
			{
				c: $author$project$Page$Guest(
					_Utils_update(
						guest,
						{hU: $author$project$View$Feedback$Hidden}))
			});
	}
};
var $author$project$Api$Graphql$Password = $elm$core$Basics$identity;
var $author$project$Api$Graphql$decodeSignedPhrasePort = F2(
	function (toMsg, val) {
		return $elm$core$Result$toMaybe(
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2(
					$elm$json$Json$Decode$map,
					A2($elm$core$Basics$composeR, $elm$core$Basics$identity, toMsg),
					A2($elm$json$Json$Decode$field, 'signed', $elm$json$Json$Decode$string)),
				val));
	});
var $author$project$Action$CompletedClaimingAction = function (a) {
	return {$: 5, a: a};
};
var $author$project$Action$CopiedShareLinkToClipboard = function (a) {
	return {$: 3, a: a};
};
var $author$project$Action$GotClaimingActionMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Action$GotUint64Name = function (a) {
	return {$: 4, a: a};
};
var $author$project$Action$NoOp = {$: 0};
var $author$project$Action$decodeId = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$Action$jsAddressToMsg = F2(
	function (addr, val) {
		var decodeConfirmedClaimAction = $elm$core$Maybe$Just(
			$author$project$Action$GotClaimingActionMsg(
				$author$project$Action$CompletedClaimingAction(
					A2(
						$elm$core$Result$mapError,
						function (_v6) {
							return val;
						},
						A2(
							$elm$core$Result$map,
							function (_v5) {
								return 0;
							},
							A2(
								$elm$json$Json$Decode$decodeValue,
								A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string),
								val))))));
		_v0$4:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'ClickedShareAction':
						var _v1 = A2(
							$elm$json$Json$Decode$decodeValue,
							A3(
								$elm$json$Json$Decode$map2,
								F2(
									function (hasCopied, actionId) {
										return hasCopied ? $elm$core$Maybe$Just(actionId) : $elm$core$Maybe$Nothing;
									}),
								A2($elm$json$Json$Decode$field, 'copied', $elm$json$Json$Decode$bool),
								A2($elm$json$Json$Decode$field, 'addressData', $author$project$Action$decodeId)),
							val);
						if (!_v1.$) {
							if (!_v1.a.$) {
								var actionId = _v1.a.a;
								return $elm$core$Maybe$Just(
									$author$project$Action$CopiedShareLinkToClipboard(actionId));
							} else {
								var _v2 = _v1.a;
								return $elm$core$Maybe$Just($author$project$Action$NoOp);
							}
						} else {
							return $elm$core$Maybe$Just($author$project$Action$NoOp);
						}
					case 'ClickedClaimAction':
						return $elm$core$Result$toMaybe(
							A2(
								$elm$core$Result$map,
								A2($elm$core$Basics$composeR, $author$project$Action$GotUint64Name, $author$project$Action$GotClaimingActionMsg),
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2($elm$json$Json$Decode$field, 'uint64name', $elm$json$Json$Decode$string),
									val)));
					case 'GotClaimingActionMsg':
						if (addr.b.b) {
							switch (addr.b.a) {
								case 'ConfirmedClaimAction':
									var _v3 = addr.b;
									return decodeConfirmedClaimAction;
								case 'ConfirmedClaimActionWithPhotoProof':
									var _v4 = addr.b;
									return decodeConfirmedClaimAction;
								default:
									break _v0$4;
							}
						} else {
							break _v0$4;
						}
					default:
						break _v0$4;
				}
			} else {
				break _v0$4;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Auth$GotPrivateKey = function (a) {
	return {$: 2, a: a};
};
var $author$project$Eos$Account$PrivateKey = $elm$core$Basics$identity;
var $author$project$Eos$Account$privateKeyDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Auth$jsAddressToMsg = F2(
	function (addr, val) {
		if ((addr.b && (addr.a === 'SubmittedPin')) && (!addr.b.b)) {
			return $elm$core$Result$toMaybe(
				A2(
					$elm$json$Json$Decode$decodeValue,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$map,
								A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$Auth$GotPrivateKey),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'privateKey',
									$author$project$Eos$Account$privateKeyDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'accountName',
										$author$project$Eos$Account$nameDecoder,
										$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)))),
								A2(
								$elm$json$Json$Decode$map,
								A2($elm$core$Basics$composeR, $elm$core$Result$Err, $author$project$Auth$GotPrivateKey),
								A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string))
							])),
					val));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Session$LoggedIn$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$6:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'GotAuthMsg':
						var remainAddress = addr.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Session$LoggedIn$GotAuthMsg,
							A2($author$project$Auth$jsAddressToMsg, remainAddress, val));
					case 'CompletedLoadUnread':
						if (!addr.b.b) {
							return $elm$core$Result$toMaybe(
								A2(
									$elm$core$Result$map,
									$author$project$Session$LoggedIn$CompletedLoadUnread,
									A2(
										$elm$json$Json$Decode$decodeValue,
										A2($elm$json$Json$Decode$field, 'meta', $elm$json$Json$Decode$value),
										val)));
						} else {
							break _v0$6;
						}
					case 'ReceivedNewHighlightedNews':
						return $elm$core$Result$toMaybe(
							A2(
								$elm$core$Result$map,
								$author$project$Session$LoggedIn$ReceivedNewHighlightedNews,
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2($elm$json$Json$Decode$field, 'meta', $elm$json$Json$Decode$value),
									val)));
					case 'GotActionMsg':
						var remainAddress = addr.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Session$LoggedIn$GotActionMsg,
							A2($author$project$Action$jsAddressToMsg, remainAddress, val));
					case 'GotAuthTokenPhrase':
						return A2($author$project$Api$Graphql$decodeSignedPhrasePort, $author$project$Session$LoggedIn$SignedAuthTokenPhrase, val);
					case 'GotAuthTokenPhraseExternal':
						return A2($author$project$Api$Graphql$decodeSignedPhrasePort, $author$project$Session$LoggedIn$SignedAuthTokenPhrase, val);
					default:
						break _v0$6;
				}
			} else {
				break _v0$6;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$jsAddressToMsg = F2(
	function (addr, val) {
		if (addr.b && (addr.a === 'GotLoggedInMsg')) {
			var remainAddress = addr.b;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Page$GotLoggedInMsg,
				A2($author$project$Session$LoggedIn$jsAddressToMsg, remainAddress, val));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Community$About$CopiedShareLinkToClipboard = {$: 4};
var $author$project$Page$Community$About$jsAddressToMsg = F2(
	function (addr, val) {
		if (addr.b && (addr.a === 'ClickedShareCommunity')) {
			var _v1 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'copied', $elm$json$Json$Decode$bool),
				val);
			if (!_v1.$) {
				if (_v1.a) {
					return $elm$core$Maybe$Just($author$project$Page$Community$About$CopiedShareLinkToClipboard);
				} else {
					return $elm$core$Maybe$Just($author$project$Page$Community$About$NoOp);
				}
			} else {
				return $elm$core$Maybe$Just($author$project$Page$Community$About$NoOp);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Community$New$GotCreateCommunityResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Community$New$Redirect = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Community$New$StartedCreatingCommunity = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Community$CreateCommunityData = function (cmmAsset) {
	return function (creator) {
		return function (logoUrl) {
			return function (name) {
				return function (description) {
					return function (subdomain) {
						return function (inviterReward) {
							return function (invitedReward) {
								return function (hasShop) {
									return function (hasObjectives) {
										return function (hasKyc) {
											return function (hasAutoInvite) {
												return function (website) {
													return {hG: cmmAsset, jz: creator, aR: description, bx: hasAutoInvite, by: hasKyc, bz: hasObjectives, bB: hasShop, b5: invitedReward, b6: inviterReward, ff: logoUrl, fj: name, pP: subdomain, bT: website};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Markdown$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Eos$EosFalse = 1;
var $author$project$Eos$EosTrue = 0;
var $author$project$Eos$intToEosBool = function (v) {
	return (v === 1) ? 0 : 1;
};
var $author$project$Eos$eosBoolDecoder = A2($elm$json$Json$Decode$map, $author$project$Eos$intToEosBool, $elm$json$Json$Decode$int);
var $author$project$Community$createCommunityDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'website',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'auto_invite',
		$author$project$Eos$eosBoolDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'has_kyc',
			$author$project$Eos$eosBoolDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'has_objectives',
				$author$project$Eos$eosBoolDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'has_shop',
					$author$project$Eos$eosBoolDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'invited_reward',
						$author$project$Eos$decodeAsset,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'inviter_reward',
							$author$project$Eos$decodeAsset,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'subdomain',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'description',
									$author$project$Markdown$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'logo',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'creator',
												$author$project$Eos$Account$nameDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'cmm_asset',
													$author$project$Eos$decodeAsset,
													$elm$json$Json$Decode$succeed($author$project$Community$CreateCommunityData))))))))))))));
var $author$project$Token$CreateTokenData = F4(
	function (creator, maxSupply, minBalance, tokenType) {
		return {jz: creator, od: maxSupply, oh: minBalance, p6: tokenType};
	});
var $author$project$Token$Expiry = 1;
var $author$project$Token$Mcc = 0;
var $author$project$Token$tokenTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (typeString) {
		switch (typeString) {
			case 'mcc':
				return $elm$json$Json$Decode$succeed(0);
			case 'expiry':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Expected token type to be mcc or expiry');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Token$createTokenDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$author$project$Token$tokenTypeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min_balance',
		$author$project$Eos$decodeAsset,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'max_supply',
			$author$project$Eos$decodeAsset,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'issuer',
				$author$project$Eos$Account$nameDecoder,
				$elm$json$Json$Decode$succeed($author$project$Token$CreateTokenData)))));
var $author$project$Page$Community$New$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$2:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'GotDomainAvailableResponse':
						var response = A2(
							$elm$json$Json$Decode$decodeValue,
							A3(
								$elm$json$Json$Decode$map2,
								$elm$core$Tuple$pair,
								A2($elm$json$Json$Decode$field, 'state', $elm$json$Json$Decode$string),
								A2(
									$elm$json$Json$Decode$field,
									'addressData',
									A3(
										$elm$json$Json$Decode$map2,
										$elm$core$Tuple$pair,
										A2($elm$json$Json$Decode$field, 'createCommunityData', $author$project$Community$createCommunityDataDecoder),
										A2($elm$json$Json$Decode$field, 'createTokenData', $author$project$Token$createTokenDataDecoder)))),
							val);
						_v1$2:
						while (true) {
							if (!response.$) {
								switch (response.a.a) {
									case 'starting':
										var _v2 = response.a;
										var _v3 = _v2.b;
										var createCommunityData = _v3.a;
										var createTokenData = _v3.b;
										return $elm$core$Maybe$Just(
											A2($author$project$Page$Community$New$StartedCreatingCommunity, createCommunityData, createTokenData));
									case 'responded':
										var _v4 = response.a;
										var _v5 = _v4.b;
										var createCommunityData = _v5.a;
										return $elm$core$Maybe$Just(
											$author$project$Page$Community$New$Redirect(createCommunityData));
									default:
										break _v1$2;
								}
							} else {
								break _v1$2;
							}
						}
						return $elm$core$Maybe$Nothing;
					case 'StartedCreatingCommunity':
						if (!addr.b.b) {
							return $elm$core$Maybe$Just(
								$author$project$Page$Community$New$GotCreateCommunityResponse(
									A2(
										$elm$core$Result$mapError,
										function (_v7) {
											return val;
										},
										A2(
											$elm$json$Json$Decode$decodeValue,
											A3(
												$elm$json$Json$Decode$map2,
												F2(
													function (_v6, symbol) {
														return symbol;
													}),
												A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string),
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['addressData', 'symbol']),
													$author$project$Eos$symbolDecoder)),
											val))));
						} else {
							break _v0$2;
						}
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Community$Settings$ActionEditor$CompletedSavingAction = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Community$Settings$ActionEditor$jsAddressToMsg = F2(
	function (addr, val) {
		var decodeCompletedSavingAction = A2(
			$elm$core$Result$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Page$Community$Settings$ActionEditor$CompletedSavingAction),
				A2(
					$elm$json$Json$Decode$decodeValue,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$map,
								$elm$core$Result$Ok,
								A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string)),
								$elm$json$Json$Decode$succeed(
								$elm$core$Result$Err(val))
							])),
					val)));
		_v0$2:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'SubmittedForm':
						return decodeCompletedSavingAction;
					case 'ClickedToggleCompleted':
						return decodeCompletedSavingAction;
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Community$Settings$Currency$GotSubmitResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Token$UpdateTokenData = F2(
	function (maxSupply, minBalance) {
		return {od: maxSupply, oh: minBalance};
	});
var $author$project$Token$updateTokenDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'min_balance',
	$author$project$Eos$decodeAsset,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'max_supply',
		$author$project$Eos$decodeAsset,
		$elm$json$Json$Decode$succeed($author$project$Token$UpdateTokenData)));
var $author$project$Page$Community$Settings$Currency$jsAddressToMsg = F2(
	function (addr, val) {
		if ((addr.b && (addr.a === 'ClickedSubmit')) && (!addr.b.b)) {
			return $elm$core$Result$toMaybe(
				A2(
					$elm$core$Result$map,
					$author$project$Page$Community$Settings$Currency$GotSubmitResponse,
					A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A3(
									$elm$json$Json$Decode$map2,
									F2(
										function (_v1, updateTokenData) {
											return $elm$core$Result$Ok(updateTokenData);
										}),
									A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string),
									A2($elm$json$Json$Decode$field, 'addressData', $author$project$Token$updateTokenDataDecoder)),
									$elm$json$Json$Decode$succeed(
									$elm$core$Result$Err(val))
								])),
						val)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Community$Settings$Features$SaveSuccess = {$: 8};
var $author$project$Page$Community$Settings$Features$jsAddressToMsg = F2(
	function (addr, _v0) {
		if (addr.b && (addr.a === 'SaveSuccess')) {
			return $elm$core$Maybe$Just($author$project$Page$Community$Settings$Features$SaveSuccess);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Community$Settings$Info$GotSaveResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Community$Settings$Info$FormOutput = F9(
	function (logo, name, description, website, coverPhoto, subdomain, hasAutoInvite, inviterReward, invitedReward) {
		return {a7: coverPhoto, aR: description, bx: hasAutoInvite, b5: invitedReward, b6: inviterReward, fe: logo, fj: name, pP: subdomain, bT: website};
	});
var $author$project$Page$Community$Settings$Info$formOutputDecoder = function () {
	var urlDecoder = A2(
		$elm$json$Json$Decode$andThen,
		function (url) {
			var _v0 = $elm$url$Url$fromString(url);
			if (!_v0.$) {
				var validUrl = _v0.a;
				return $elm$json$Json$Decode$succeed(validUrl);
			} else {
				return $elm$json$Json$Decode$fail('Expecting a valid url. Got ' + (url + ' instead'));
			}
		},
		$elm$json$Json$Decode$string);
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invitedReward',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'inviterReward',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'hasAutoInvite',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'subdomain',
					urlDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'coverPhoto',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'website',
							$elm$json$Json$Decode$maybe(urlDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'description',
								$author$project$Markdown$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'logo',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Page$Community$Settings$Info$FormOutput))))))))));
}();
var $author$project$Page$Community$Settings$Info$jsAddressToMsg = F2(
	function (addr, val) {
		if (addr.b && (addr.a === 'GotDomainAvailableResponse')) {
			return A2(
				$elm$core$Result$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Result$map,
					A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Page$Community$Settings$Info$GotSaveResponse),
					A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A3(
									$elm$json$Json$Decode$map2,
									F2(
										function (_v1, formOutput) {
											return $elm$core$Result$Ok(formOutput);
										}),
									A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string),
									A2($elm$json$Json$Decode$field, 'addressData', $author$project$Page$Community$Settings$Info$formOutputDecoder)),
									$elm$json$Json$Decode$succeed(
									$elm$core$Result$Err(val))
								])),
						val)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$GotCompleteActionResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Community$Settings$ObjectiveEditor$GotSaveObjectiveResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Community$Settings$ObjectiveEditor$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$2:
		while (true) {
			if (addr.b && (!addr.b.b)) {
				switch (addr.a) {
					case 'ClickedSaveObjective':
						return A2(
							$elm$core$Result$withDefault,
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Result$map,
								A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Page$Community$Settings$ObjectiveEditor$GotSaveObjectiveResponse),
								A2(
									$elm$json$Json$Decode$decodeValue,
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												A2(
												$elm$json$Json$Decode$map,
												$elm$core$Result$Ok,
												A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string)),
												$elm$json$Json$Decode$succeed(
												$elm$core$Result$Err(val))
											])),
									val)));
					case 'AcceptedCompleteObjective':
						return $elm$core$Result$toMaybe(
							A2(
								$elm$core$Result$map,
								$author$project$Page$Community$Settings$ObjectiveEditor$GotCompleteActionResponse,
								A2(
									$elm$json$Json$Decode$decodeValue,
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												A2(
												$elm$json$Json$Decode$map,
												$elm$core$Result$Ok,
												A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string)),
												A2(
												$elm$json$Json$Decode$map,
												$elm$core$Result$Err,
												A2($elm$json$Json$Decode$field, 'addressData', $elm$json$Json$Decode$int))
											])),
									val)));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Community$Transfer$CreatedTransferSubscription = {$: 6};
var $author$project$Page$Community$Transfer$GotTransferResultFromWebSocket = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Community$Transfer$GotTransferTransactionResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Community$Transfer$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$2:
		while (true) {
			if (addr.b && (!addr.b.b)) {
				switch (addr.a) {
					case 'SubmittedForm':
						var result = A2(
							$elm$json$Json$Decode$decodeValue,
							A2($elm$json$Json$Decode$field, 'state', $elm$json$Json$Decode$string),
							val);
						_v1$2:
						while (true) {
							if (!result.$) {
								switch (result.a) {
									case 'starting':
										return $elm$core$Maybe$Just($author$project$Page$Community$Transfer$CreatedTransferSubscription);
									case 'responded':
										return $elm$core$Result$toMaybe(
											A2(
												$elm$core$Result$map,
												$author$project$Page$Community$Transfer$GotTransferResultFromWebSocket,
												A2(
													$elm$json$Json$Decode$decodeValue,
													A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value),
													val)));
									default:
										break _v1$2;
								}
							} else {
								break _v1$2;
							}
						}
						return $elm$core$Maybe$Nothing;
					case 'CreatedTransferSubscription':
						return A2(
							$elm$core$Result$withDefault,
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Result$map,
								A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Page$Community$Transfer$GotTransferTransactionResult),
								A2(
									$elm$json$Json$Decode$decodeValue,
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												A2(
												$elm$json$Json$Decode$map,
												$elm$core$Result$Ok,
												A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string)),
												A2(
												$elm$json$Json$Decode$map,
												$elm$core$Result$Err,
												A2(
													$elm$json$Json$Decode$field,
													'error',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$value)))
											])),
									val)));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Dashboard$CopiedToClipboard = {$: 19};
var $author$project$Page$Dashboard$jsAddressToMsg = F2(
	function (addr, _v0) {
		if (addr.b && (addr.a === 'CopiedToClipboard')) {
			return $elm$core$Maybe$Just($author$project$Page$Dashboard$CopiedToClipboard);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Dashboard$Analysis$GotVoteResult = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Page$Dashboard$Analysis$jsAddressToMsg = F2(
	function (addr, val) {
		if ((addr.b && (addr.a === 'VoteClaim')) && addr.b.b) {
			var _v1 = addr.b;
			var claimId = _v1.a;
			var id = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(claimId));
			return A2(
				$elm$core$Result$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Result$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Maybe$Just,
						$author$project$Page$Dashboard$Analysis$GotVoteResult(id)),
					A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$json$Json$Decode$map,
									$elm$core$Result$Ok,
									A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string)),
									A2(
									$elm$json$Json$Decode$map,
									$elm$core$Result$Err,
									A2(
										$elm$json$Json$Decode$field,
										'error',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$value)))
								])),
						val)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Dashboard$Claim$GotVoteResult = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Dashboard$Claim$jsAddressToMsg = F2(
	function (addr, val) {
		if (addr.b && (addr.a === 'VoteClaim')) {
			return A2(
				$elm$core$Result$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Result$map,
					A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Page$Dashboard$Claim$GotVoteResult),
					A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$json$Json$Decode$map,
									$elm$core$Result$Ok,
									A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string)),
									A2(
									$elm$json$Json$Decode$map,
									$elm$core$Result$Err,
									A2(
										$elm$json$Json$Decode$field,
										'error',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$value)))
								])),
						val)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Login$Denied = {$: 0};
var $author$project$Page$Login$GotAccountName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$GotClipboardResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$GotPassphraseMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Login$GotPinMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$NotSupported = {$: 1};
var $author$project$Page$Login$PinIgnored = {$: 0};
var $author$project$Page$Login$SignedAuthPhrase = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Login$WithContent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$WithError = {$: 3};
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Page$Login$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$5:
		while (true) {
			if (addr.b) {
				if (addr.b.b) {
					switch (addr.a) {
						case 'GotPassphraseMsg':
							if ((addr.b.a === 'ClickedPaste') && (!addr.b.b.b)) {
								var _v1 = addr.b;
								return $elm$core$Result$toMaybe(
									A2(
										$elm$json$Json$Decode$decodeValue,
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeL, $author$project$Page$Login$GotPassphraseMsg, $author$project$Page$Login$GotClipboardResponse),
											$elm$json$Json$Decode$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$json$Json$Decode$map,
														function (_v2) {
															return $author$project$Page$Login$Denied;
														},
														A2($elm$json$Json$Decode$field, 'isDenied', $elm$json$Json$Decode$bool)),
														A2(
														$elm$json$Json$Decode$map,
														function (_v3) {
															return $author$project$Page$Login$NotSupported;
														},
														A2($elm$json$Json$Decode$field, 'notSupported', $elm$json$Json$Decode$bool)),
														A2(
														$elm$json$Json$Decode$map,
														$author$project$Page$Login$WithContent,
														A2($elm$json$Json$Decode$field, 'clipboardContent', $elm$json$Json$Decode$string)),
														A2(
														$elm$json$Json$Decode$map,
														function (_v4) {
															return $author$project$Page$Login$WithError;
														},
														A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string))
													]))),
										val));
							} else {
								break _v0$5;
							}
						case 'GotPinMsg':
							switch (addr.b.a) {
								case 'SubmittedPinWithSuccess':
									if (!addr.b.b.b) {
										var _v5 = addr.b;
										return $elm$core$Result$toMaybe(
											A2(
												$elm$json$Json$Decode$decodeValue,
												$elm$json$Json$Decode$oneOf(
													_List_fromArray(
														[
															A2(
															$elm$json$Json$Decode$map,
															A2(
																$elm$core$Basics$composeR,
																$elm$core$Result$Ok,
																A2($elm$core$Basics$composeR, $author$project$Page$Login$GotAccountName, $author$project$Page$Login$GotPinMsg)),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'privateKey',
																$author$project$Eos$Account$privateKeyDecoder,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'accountName',
																	$author$project$Eos$Account$nameDecoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'addressData',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed(
																			F3(
																				function (pin, account, privateKey) {
																					return {_: account, o8: pin, pg: privateKey};
																				})))))),
															A2(
															$elm$json$Json$Decode$map,
															A2(
																$elm$core$Basics$composeR,
																$elm$core$Result$Err,
																A2($elm$core$Basics$composeR, $author$project$Page$Login$GotAccountName, $author$project$Page$Login$GotPinMsg)),
															A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string))
														])),
												val));
									} else {
										break _v0$5;
									}
								case 'GeneratedAuthPhrase':
									var _v6 = addr.b;
									return A2(
										$author$project$Api$Graphql$decodeSignedPhrasePort,
										A2($elm$core$Basics$composeR, $author$project$Page$Login$SignedAuthPhrase, $author$project$Page$Login$GotPinMsg),
										val);
								case 'PinIgnored':
									if (!addr.b.b.b) {
										var _v7 = addr.b;
										return $elm$core$Maybe$Just(
											$author$project$Page$Login$GotPinMsg($author$project$Page$Login$PinIgnored));
									} else {
										break _v0$5;
									}
								default:
									break _v0$5;
							}
						default:
							break _v0$5;
					}
				} else {
					if (addr.a === 'GotBip39') {
						var decodeLanguage = function (key) {
							return A2(
								$elm$json$Json$Decode$map,
								$elm$core$Set$fromList,
								A2(
									$elm$json$Json$Decode$field,
									key,
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
						};
						return $elm$core$Result$toMaybe(
							A2(
								$elm$core$Result$map,
								$author$project$Page$Login$GotBip39,
								A2(
									$elm$json$Json$Decode$decodeValue,
									A4(
										$elm$json$Json$Decode$map3,
										F3(
											function (english, portuguese, spanish) {
												return {gr: english, g$: portuguese, hf: spanish};
											}),
										decodeLanguage('english'),
										decodeLanguage('portuguese'),
										decodeLanguage('spanish')),
									val)));
					} else {
						break _v0$5;
					}
				}
			} else {
				break _v0$5;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Profile$Claims$GotVoteResult = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Page$Profile$Claims$jsAddressToMsg = F2(
	function (addr, val) {
		if ((addr.b && (addr.a === 'VoteClaim')) && addr.b.b) {
			var _v1 = addr.b;
			var claimId = _v1.a;
			var id = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(claimId));
			return A2(
				$elm$core$Result$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Result$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Maybe$Just,
						$author$project$Page$Profile$Claims$GotVoteResult(id)),
					A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$json$Json$Decode$map,
									$elm$core$Result$Ok,
									A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string)),
									A2(
									$elm$json$Json$Decode$map,
									$elm$core$Result$Err,
									A2(
										$elm$json$Json$Decode$field,
										'error',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$value)))
								])),
						val)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Register$AccountKeys = F5(
	function (ownerKey, activeKey, accountName, words, privateKey) {
		return {_: accountName, mc: activeKey, kW: ownerKey, pg: privateKey, hq: words};
	});
var $author$project$Page$Register$AccountKeysGenerated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Register$CopiedToClipboard = {$: 8};
var $author$project$Page$Register$GotAccountAvailabilityResponse = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Register$PdfDownloaded = {$: 6};
var $author$project$Page$Register$DefaultFormOutput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Register$JuridicalFormOutput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Register$NaturalFormOutput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Register$DefaultForm$FormOutput = F3(
	function (name, account, email) {
		return {l8: account, jK: email, fj: name};
	});
var $author$project$Page$Register$DefaultForm$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Page$Register$DefaultForm$FormOutput,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'account', $author$project$Eos$Account$nameDecoder),
	A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string));
var $author$project$Page$Register$JuridicalForm$FormOutput = function (companyType) {
	return function (document) {
		return function (name) {
			return function (email) {
				return function (phone) {
					return function (account) {
						return function (state) {
							return function (city) {
								return function (district) {
									return function (street) {
										return function (number) {
											return function (zip) {
												return {l8: account, mt: city, mC: companyType, m0: district, eT: document, jK: email, fj: name, d2: number, fq: phone, Z: state, fK: street, fY: zip};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Page$Register$JuridicalForm$Corporation = 1;
var $author$project$Page$Register$JuridicalForm$MIPYME = 0;
var $author$project$Page$Register$JuridicalForm$companyTypeFromString = function (type_) {
	switch (type_) {
		case 'mipyme':
			return $elm$core$Maybe$Just(0);
		case 'gran_empresa':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Register$JuridicalForm$decoder = function () {
	var decodeIdAndName = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (id, name) {
				return {w: id, fj: name};
			}),
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$string);
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'zip',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'number',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'street',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'district',
					decodeIdAndName,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'city',
						decodeIdAndName,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'state',
							decodeIdAndName,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'account',
								$author$project$Eos$Account$nameDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'phone',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'email',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'document',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'companyType',
													A2(
														$elm$json$Json$Decode$andThen,
														function (companyType) {
															var _v0 = $author$project$Page$Register$JuridicalForm$companyTypeFromString(companyType);
															if (_v0.$ === 1) {
																return $elm$json$Json$Decode$fail('Invalid company type');
															} else {
																var type_ = _v0.a;
																return $elm$json$Json$Decode$succeed(type_);
															}
														},
														$elm$json$Json$Decode$string),
													$elm$json$Json$Decode$succeed($author$project$Page$Register$JuridicalForm$FormOutput)))))))))))));
}();
var $author$project$Page$Register$NaturalForm$FormOutput = F6(
	function (documentType, document, name, email, phoneNumber, account) {
		return {l8: account, eT: document, eU: documentType, jK: email, fj: name, o7: phoneNumber};
	});
var $author$project$Page$Register$NaturalForm$DIMEX = 1;
var $author$project$Page$Register$NaturalForm$NITE = 2;
var $author$project$Page$Register$NaturalForm$SSN = 0;
var $author$project$Page$Register$NaturalForm$documentTypeFromString = function (document) {
	switch (document) {
		case 'cedula_de_identidad':
			return $elm$core$Maybe$Just(0);
		case 'dimex':
			return $elm$core$Maybe$Just(1);
		case 'nite':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Register$NaturalForm$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'account',
	$author$project$Eos$Account$nameDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'phoneNumber',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'document',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'documentType',
						A2(
							$elm$json$Json$Decode$andThen,
							function (documentType) {
								var _v0 = $author$project$Page$Register$NaturalForm$documentTypeFromString(documentType);
								if (_v0.$ === 1) {
									return $elm$json$Json$Decode$fail('Invalid document type');
								} else {
									var doc = _v0.a;
									return $elm$json$Json$Decode$succeed(doc);
								}
							},
							$elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed($author$project$Page$Register$NaturalForm$FormOutput)))))));
var $author$project$Page$Register$formOutputDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Page$Register$NaturalFormOutput, $author$project$Page$Register$NaturalForm$decoder),
			A2($elm$json$Json$Decode$map, $author$project$Page$Register$JuridicalFormOutput, $author$project$Page$Register$JuridicalForm$decoder),
			A2($elm$json$Json$Decode$map, $author$project$Page$Register$DefaultFormOutput, $author$project$Page$Register$DefaultForm$decoder)
		]));
var $author$project$Page$Register$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$4:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'SubmittedForm':
						return $elm$core$Result$toMaybe(
							A2(
								$elm$json$Json$Decode$decodeValue,
								A3(
									$elm$json$Json$Decode$map2,
									$author$project$Page$Register$GotAccountAvailabilityResponse,
									A2($elm$json$Json$Decode$field, 'addressData', $author$project$Page$Register$formOutputDecoder),
									A2($elm$json$Json$Decode$field, 'isAvailable', $elm$json$Json$Decode$bool)),
								val));
					case 'GotAccountAvailabilityResponse':
						var decodeAccount = A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'privateKey',
							$author$project$Eos$Account$privateKeyDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'words',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'accountName',
									$author$project$Eos$Account$nameDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'activeKey',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'ownerKey',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Page$Register$AccountKeys))))));
						var decodedAccount = A2(
							$elm$json$Json$Decode$decodeValue,
							A2($elm$json$Json$Decode$field, 'data', decodeAccount),
							val);
						return A2(
							$elm$core$Maybe$map,
							function (formOutput) {
								return A2($author$project$Page$Register$AccountKeysGenerated, formOutput, decodedAccount);
							},
							$elm$core$Result$toMaybe(
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2($elm$json$Json$Decode$field, 'addressData', $author$project$Page$Register$formOutputDecoder),
									val)));
					case 'PdfDownloaded':
						return $elm$core$Maybe$Just($author$project$Page$Register$PdfDownloaded);
					case 'CopiedToClipboard':
						return $elm$core$Maybe$Just($author$project$Page$Register$CopiedToClipboard);
					default:
						break _v0$4;
				}
			} else {
				break _v0$4;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Settings$ChangedToNewPin = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Settings$CopiedPrivateKey = {$: 4};
var $author$project$Page$Settings$NoOp = {$: 0};
var $author$project$Page$Settings$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$3:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'ClickedDownloadPdf':
						return $elm$core$Result$toMaybe(
							A2(
								$elm$core$Result$map,
								function (_v1) {
									return $author$project$Page$Settings$NoOp;
								},
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2($elm$json$Json$Decode$field, 'isDownloaded', $elm$json$Json$Decode$bool),
									val)));
					case 'ClickedCopyPrivateKey':
						var _v2 = A2(
							$elm$json$Json$Decode$decodeValue,
							A2($elm$json$Json$Decode$field, 'copied', $elm$json$Json$Decode$bool),
							val);
						if (!_v2.$) {
							if (_v2.a) {
								return $elm$core$Maybe$Just($author$project$Page$Settings$CopiedPrivateKey);
							} else {
								return $elm$core$Maybe$Just($author$project$Page$Settings$NoOp);
							}
						} else {
							return $elm$core$Maybe$Just($author$project$Page$Settings$NoOp);
						}
					case 'SubmittedNewPin':
						return $elm$core$Result$toMaybe(
							A2(
								$elm$core$Result$map,
								$author$project$Page$Settings$ChangedToNewPin,
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2($elm$json$Json$Decode$field, 'addressData', $elm$json$Json$Decode$string),
									val)));
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Shop$Viewer$CopiedToClipboard = {$: 7};
var $author$project$Page$Shop$Viewer$GotTransferResult = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Shop$Viewer$jsAddressToLoggedInMsg = F2(
	function (addr, val) {
		if ((addr.b && (addr.a === 'ClickedTransfer')) && (!addr.b.b)) {
			return A2(
				$elm$core$Result$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Result$map,
					A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Page$Shop$Viewer$GotTransferResult),
					A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$json$Json$Decode$map,
									$elm$core$Result$Ok,
									A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string)),
									A2(
									$elm$json$Json$Decode$map,
									$elm$core$Result$Err,
									A2(
										$elm$json$Json$Decode$field,
										'error',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$value)))
								])),
						val)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Shop$Viewer$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$2:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'ClickedShareOffer':
						return A2(
							$elm$core$Result$withDefault,
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Result$map,
								function (type_) {
									return (type_ === 'copyToClipboard') ? $elm$core$Maybe$Just($author$project$Page$Shop$Viewer$CopiedToClipboard) : $elm$core$Maybe$Nothing;
								},
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2(
										$elm$json$Json$Decode$at,
										_List_fromArray(
											['addressData', 'type']),
										$elm$json$Json$Decode$string),
									val)));
					case 'AsLoggedInMsg':
						var rAddress = addr.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Page$Shop$Viewer$AsLoggedInMsg,
							A2($author$project$Page$Shop$Viewer$jsAddressToLoggedInMsg, rAddress, val));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Main$jsAddressToMsg = F2(
	function (address, val) {
		_v0$17:
		while (true) {
			if (address.b) {
				switch (address.a) {
					case 'GotPageMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotPageMsg,
							A2($author$project$Page$jsAddressToMsg, rAddress, val));
					case 'GotLoginMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotLoginMsg,
							A2($author$project$Page$Login$jsAddressToMsg, rAddress, val));
					case 'GotDashboardMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotDashboardMsg,
							A2($author$project$Page$Dashboard$jsAddressToMsg, rAddress, val));
					case 'GotCommunityAboutMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotCommunityAboutMsg,
							A2($author$project$Page$Community$About$jsAddressToMsg, rAddress, val));
					case 'GotCommunityEditorMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotCommunityEditorMsg,
							A2($author$project$Page$Community$New$jsAddressToMsg, rAddress, val));
					case 'GotCommunitySettingsObjectiveEditorMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotCommunitySettingsObjectiveEditorMsg,
							A2($author$project$Page$Community$Settings$ObjectiveEditor$jsAddressToMsg, rAddress, val));
					case 'GotShopViewerMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotShopViewerMsg,
							A2($author$project$Page$Shop$Viewer$jsAddressToMsg, rAddress, val));
					case 'GotRegisterMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotRegisterMsg,
							A2($author$project$Page$Register$jsAddressToMsg, rAddress, val));
					case 'GotSettingsMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotSettingsMsg,
							A2($author$project$Page$Settings$jsAddressToMsg, rAddress, val));
					case 'GotCommunitySettingsFeaturesMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotCommunitySettingsFeaturesMsg,
							A2($author$project$Page$Community$Settings$Features$jsAddressToMsg, rAddress, val));
					case 'GotCommunitySettingsInfoMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotCommunitySettingsInfoMsg,
							A2($author$project$Page$Community$Settings$Info$jsAddressToMsg, rAddress, val));
					case 'GotCommunitySettingsCurrencyMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotCommunitySettingsCurrencyMsg,
							A2($author$project$Page$Community$Settings$Currency$jsAddressToMsg, rAddress, val));
					case 'GotCommunitySettingsActionEditorMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotCommunitySettingsActionEditorMsg,
							A2($author$project$Page$Community$Settings$ActionEditor$jsAddressToMsg, rAddress, val));
					case 'GotVerifyClaimMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotVerifyClaimMsg,
							A2($author$project$Page$Dashboard$Claim$jsAddressToMsg, rAddress, val));
					case 'GotTransferMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotTransferMsg,
							A2($author$project$Page$Community$Transfer$jsAddressToMsg, rAddress, val));
					case 'GotAnalysisMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotAnalysisMsg,
							A2($author$project$Page$Dashboard$Analysis$jsAddressToMsg, rAddress, val));
					case 'GotProfileClaimsMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotProfileClaimsMsg,
							A2($author$project$Page$Profile$Claims$jsAddressToMsg, rAddress, val));
					default:
						break _v0$17;
				}
			} else {
				break _v0$17;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Page$maybeAccountName = function (session) {
	if (session.$ === 1) {
		var loggedIn = session.a;
		return $elm$core$Maybe$Just(loggedIn._);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.pn;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.nl,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.ed,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.pb,
					_Utils_ap(http, url.e3)),
				url.g_)));
};
var $author$project$Session$LoggedIn$Broadcast = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$GuestBroadcastMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$LoggedInExternalMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Session$LoggedIn$TranslationsLoaded = {$: 4};
var $author$project$Translation$languageToLocale = function (language) {
	switch (language) {
		case 0:
			return 'en-us';
		case 1:
			return 'pt-br';
		case 2:
			return 'es-es';
		case 3:
			return 'ca-es';
		default:
			return 'am-et';
	}
};
var $author$project$Session$Shared$LoadedTranslation = {$: 2};
var $author$project$Session$Shared$LoadingAnotherTranslationFailed = {$: 4};
var $author$project$Session$Shared$LoadingTranslationFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Session$Shared$loadTranslation = F2(
	function (result, shared) {
		if (result.$ === 1) {
			var err = result.a;
			return _Utils_update(
				shared,
				{
					bP: function () {
						var _v1 = shared.bP;
						switch (_v1.$) {
							case 0:
								return $author$project$Session$Shared$LoadingTranslationFailed(err);
							case 3:
								return $author$project$Session$Shared$LoadingAnotherTranslationFailed;
							default:
								return shared.bP;
						}
					}()
				});
		} else {
			var _v2 = result.a;
			var language = _v2.a;
			var translations = _v2.b;
			return _Utils_update(
				shared,
				{
					ic: language,
					fV: translations,
					bP: $author$project$Session$Shared$LoadedTranslation,
					aw: $author$project$Session$Shared$makeTranslators(translations)
				});
		}
	});
var $author$project$Log$HttpErrorType = 3;
var $author$project$Log$encodeHttpError = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Http.BadUrl')),
						_Utils_Tuple2(
						'providedUrl',
						$elm$json$Json$Encode$string(url))
					]));
		case 1:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Http.Timeout'))
					]));
		case 2:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Http.NetworkError'))
					]));
		case 3:
			var status = error.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Http.BadStatus')),
						_Utils_Tuple2(
						'status',
						$elm$json$Json$Encode$int(status))
					]));
		default:
			var body = error.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Http.BadBody')),
						_Utils_Tuple2(
						'body',
						$elm$json$Json$Encode$string(body))
					]));
	}
};
var $author$project$Log$fromHttpError = F6(
	function (transaction, maybeUser, description, location, contexts, error) {
		return {
			mL: A2(
				$elm$core$List$cons,
				{
					ng: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'Description',
								$elm$json$Json$Encode$string(description)),
								_Utils_Tuple2(
								'Error',
								$author$project$Log$encodeHttpError(error))
							])),
					fj: 'HTTP error'
				},
				contexts),
			n4: 1,
			oa: location,
			of: 'Got an error when performing an HTTP request',
			pY: _List_fromArray(
				[
					$author$project$Log$TypeTag(3)
				]),
			p7: transaction,
			qh: maybeUser
		};
	});
var $author$project$UpdateResult$logHttpError = F6(
	function (transaction, maybeUser, description, location, contexts, error) {
		return $author$project$UpdateResult$logEvent(
			A6($author$project$Log$fromHttpError, transaction, maybeUser, description, location, contexts, error));
	});
var $author$project$Log$IncompatibleMsg = 0;
var $author$project$Log$fromIncompatibleMsg = F4(
	function (transaction, maybeUser, location, contexts) {
		return {
			mL: contexts,
			n4: 3,
			oa: location,
			of: 'Msg does not correspond with Model',
			pY: _List_fromArray(
				[
					$author$project$Log$TypeTag(0)
				]),
			p7: transaction,
			qh: maybeUser
		};
	});
var $author$project$UpdateResult$logIncompatibleMsg = F4(
	function (transaction, maybeUser, location, contexts) {
		return $author$project$UpdateResult$logEvent(
			A4($author$project$Log$fromIncompatibleMsg, transaction, maybeUser, location, contexts));
	});
var $author$project$Ports$storeLanguage = _Platform_outgoingPort('storeLanguage', $elm$json$Json$Encode$string);
var $author$project$Session$Guest$CommunityLoaded = $elm$core$Basics$identity;
var $author$project$Log$DefaultBreadcrumb = 0;
var $author$project$Log$ErrorBreadcrumb = 2;
var $author$project$Log$Warning = 2;
var $author$project$Session$Guest$CompletedLoadTranslation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Session$Guest$fetchTranslations = F2(
	function (version, language) {
		return A3(
			$author$project$Translation$get,
			version,
			language,
			$author$project$Session$Guest$CompletedLoadTranslation(language));
	});
var $author$project$Session$Guest$invalidCommunityRedirectUrl = F2(
	function (currentUrl, useSubdomain) {
		return useSubdomain ? (A2(
			$elm$core$String$contains,
			'localhost:',
			$elm$url$Url$toString(currentUrl)) ? $elm$core$Maybe$Just(
			$elm$url$Url$toString(
				_Utils_update(
					currentUrl,
					{e3: 'cambiatus.staging.localhost'}))) : (A2($elm$core$String$endsWith, 'staging.cambiatus.io', currentUrl.e3) ? $elm$core$Maybe$Just(
			$elm$url$Url$toString(
				_Utils_update(
					currentUrl,
					{e3: 'cambiatus.staging.cambiatus.io'}))) : (A2($elm$core$String$endsWith, 'demo.cambiatus.io', currentUrl.e3) ? $elm$core$Maybe$Just('https://www.cambiatus.com/welcome-demo') : $elm$core$Maybe$Just('https://www.cambiatus.com/welcome')))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Log$GraphqlErrorType = 4;
var $author$project$Log$encodeGraphqlError = function (error) {
	var encodeGraphqlInternalError = function (internalError) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string(internalError.of)),
					_Utils_Tuple2(
					'locations',
					function () {
						var _v3 = internalError.ob;
						if (_v3.$ === 1) {
							return $elm$json$Json$Encode$null;
						} else {
							var locations = _v3.a;
							return A2(
								$elm$json$Json$Encode$list,
								function (location) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'line',
												$elm$json$Json$Encode$int(location.n5)),
												_Utils_Tuple2(
												'column',
												$elm$json$Json$Encode$int(location.mB))
											]));
								},
								locations);
						}
					}()),
					_Utils_Tuple2(
					'details',
					A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity, internalError.m_))
				]));
	};
	if (!error.$) {
		var possiblyParsedData = error.a;
		var graphqlErrors = error.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Graphql.Http.GraphqlError')),
					_Utils_Tuple2(
					'data',
					function () {
						if (!possiblyParsedData.$) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'status',
										$elm$json$Json$Encode$string('Graphql.Http.GraphqlError.ParsedData'))
									]));
						} else {
							var unparsedData = possiblyParsedData.a;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'status',
										$elm$json$Json$Encode$string('Graphql.Http.GraphqlError.UnparsedData')),
										_Utils_Tuple2('unparsedData', unparsedData)
									]));
						}
					}()),
					_Utils_Tuple2(
					'errors',
					A2($elm$json$Json$Encode$list, encodeGraphqlInternalError, graphqlErrors))
				]));
	} else {
		var httpError = error.a;
		switch (httpError.$) {
			case 0:
				var url = httpError.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Graphql.Http.BadUrl')),
							_Utils_Tuple2(
							'providedUrl',
							$elm$json$Json$Encode$string(url))
						]));
			case 1:
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Graphql.Http.Timeout'))
						]));
			case 2:
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Graphql.Http.NetworkError'))
						]));
			case 3:
				var metadata = httpError.a;
				var body = httpError.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Graphql.Http.BadStatus')),
							_Utils_Tuple2(
							'metadata',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'url',
										$elm$json$Json$Encode$string(metadata.hn)),
										_Utils_Tuple2(
										'statusCode',
										$elm$json$Json$Encode$int(metadata.pO)),
										_Utils_Tuple2(
										'statusText',
										$elm$json$Json$Encode$string(metadata.iS)),
										_Utils_Tuple2(
										'headers',
										A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, metadata.nr))
									]))),
							_Utils_Tuple2(
							'body',
							$elm$json$Json$Encode$string(body))
						]));
			default:
				var jsonError = httpError.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Graphql.Http.BadPayload')),
							_Utils_Tuple2(
							'jsonError',
							$author$project$Log$encodeDecodingError(jsonError))
						]));
		}
	}
};
var $author$project$Log$fromGraphqlHttpError = F6(
	function (transaction, maybeUser, description, location, contexts, error) {
		return {
			mL: A2(
				$elm$core$List$cons,
				{
					ng: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'Description',
								$elm$json$Json$Encode$string(description)),
								_Utils_Tuple2(
								'Error',
								$author$project$Log$encodeGraphqlError(error))
							])),
					fj: 'Graphql error'
				},
				contexts),
			n4: 1,
			oa: location,
			of: 'Got an error when performing a GraphQL request',
			pY: _List_fromArray(
				[
					$author$project$Log$TypeTag(4)
				]),
			p7: transaction,
			qh: maybeUser
		};
	});
var $author$project$UpdateResult$logGraphqlError = F6(
	function (transaction, maybeUser, description, location, contexts, error) {
		return $author$project$UpdateResult$logEvent(
			A6($author$project$Log$fromGraphqlHttpError, transaction, maybeUser, description, location, contexts, error));
	});
var $author$project$Session$Shared$LoadingAnotherTranslation = {$: 3};
var $author$project$Session$Shared$toLoadingTranslation = function (shared) {
	return _Utils_update(
		shared,
		{
			bP: function () {
				var _v0 = shared.bP;
				switch (_v0.$) {
					case 2:
						return $author$project$Session$Shared$LoadingAnotherTranslation;
					case 4:
						return $author$project$Session$Shared$LoadingAnotherTranslation;
					default:
						return $author$project$Session$Shared$LoadingTranslation;
				}
			}()
		});
};
var $author$project$View$Feedback$update = F2(
	function (msg, _v0) {
		return $author$project$View$Feedback$Hidden;
	});
var $author$project$Session$Guest$update = F2(
	function (msg, model) {
		var shared = model.A;
		var currentUrl = shared.hn;
		switch (msg.$) {
			case 0:
				if (!msg.b.$) {
					var lang = msg.a;
					var transl = msg.b.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						$author$project$Ports$storeLanguage(
							$author$project$Translation$languageToLocale(lang)),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									A: A2(
										$author$project$Session$Shared$loadTranslation,
										$elm$core$Result$Ok(
											_Utils_Tuple2(lang, transl)),
										shared)
								})));
				} else {
					var err = msg.b.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Nothing,
						'Got an error when loading translation as a guest',
						{e$: 'update', fi: 'Session.Guest'},
						_List_Nil,
						err,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									A: A2(
										$author$project$Session$Shared$loadTranslation,
										$elm$core$Result$Err(err),
										shared)
								})));
				}
			case 1:
				return A2(
					$author$project$UpdateResult$addBreadcrumb,
					{f7: msg, bZ: $elm$core$Dict$empty, n4: 2, of: 'Clicked to fetch translation again', eq: 2},
					A2(
						$author$project$UpdateResult$addCmd,
						A2($author$project$Session$Guest$fetchTranslations, shared.lZ, shared.ic),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									A: $author$project$Session$Shared$toLoadingTranslation(shared)
								}))));
			case 2:
				var b = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{bt: b}));
			case 3:
				var lang = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2($author$project$Session$Guest$fetchTranslations, shared.lZ, lang),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								A: $author$project$Session$Shared$toLoadingTranslation(shared),
								bt: false
							})));
			case 4:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{bt: false}));
			case 5:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var communityPreview = msg.a.a.a;
							return A2(
								$author$project$UpdateResult$addPort,
								{
									bZ: $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string('setFavicon')),
												_Utils_Tuple2(
												'favicon',
												$elm$json$Json$Encode$string(communityPreview.fe))
											])),
									fy: msg,
									fz: $elm$json$Json$Encode$null
								},
								A2(
									$author$project$UpdateResult$addBreadcrumb,
									{
										f7: msg,
										bZ: $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'symbol',
													$author$project$Eos$encodeSymbol(communityPreview.as)),
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string(communityPreview.fj))
												])),
										n4: 3,
										of: 'Community preview loaded successfully',
										eq: 0
									},
									A2(
										$author$project$UpdateResult$addExt,
										communityPreview,
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{
													V: $krisajenkins$remotedata$RemoteData$Success(communityPreview)
												})))));
						} else {
							var _v1 = msg.a.a;
							return A2(
								$author$project$UpdateResult$addCmd,
								function () {
									var _v2 = A2($author$project$Session$Guest$invalidCommunityRedirectUrl, currentUrl, shared.qf);
									if (_v2.$ === 1) {
										return $elm$core$Platform$Cmd$none;
									} else {
										var redirectUrl = _v2.a;
										return $elm$browser$Browser$Navigation$load(redirectUrl);
									}
								}(),
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var err = msg.a.a;
						return A2(
							$author$project$UpdateResult$addCmd,
							function () {
								var _v3 = A2($author$project$Session$Guest$invalidCommunityRedirectUrl, currentUrl, shared.qf);
								if (_v3.$ === 1) {
									return $elm$core$Platform$Cmd$none;
								} else {
									var redirectUrl = _v3.a;
									return $elm$browser$Browser$Navigation$load(redirectUrl);
								}
							}(),
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Nothing,
								'Got an error when loading community preview as a guest',
								{e$: 'update', fi: 'Session.Guest'},
								_List_Nil,
								err,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											V: $krisajenkins$remotedata$RemoteData$Failure(err)
										}))));
					case 0:
						var _v4 = msg.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{V: $krisajenkins$remotedata$RemoteData$NotAsked}));
					default:
						var _v5 = msg.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{V: $krisajenkins$remotedata$RemoteData$Loading}));
				}
			default:
				var subMsg = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							hU: A2($author$project$View$Feedback$update, subMsg, model.hU)
						}));
		}
	});
var $author$project$Session$LoggedIn$AddAfterAuthTokenCallback = function (a) {
	return {$: 2, a: a};
};
var $author$project$Session$LoggedIn$AddAfterAuthTokenCallbackInternal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Session$LoggedIn$AddAfterPrivateKeyCallback = function (a) {
	return {$: 5, a: a};
};
var $author$project$Session$LoggedIn$AuthenticationFailed = {$: 1};
var $author$project$Session$LoggedIn$AuthenticationSucceed = {$: 0};
var $author$project$Session$LoggedIn$CodeOfConductShownWithWarning = function (a) {
	return {$: 2, a: a};
};
var $author$project$Session$LoggedIn$CommunityLoaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Feedback$Failure = 1;
var $author$project$Session$LoggedIn$GotTime = function (a) {
	return {$: 3, a: a};
};
var $author$project$Session$LoggedIn$ProfileLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Session$LoggedIn$RunAfterAuthTokenCallbacks = function (a) {
	return {$: 4, a: a};
};
var $author$project$Session$LoggedIn$RunAfterPrivateKeyCallbacks = {$: 6};
var $author$project$Session$LoggedIn$RunExternalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Cambiatus$Mutation$acceptTerms = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'acceptTerms',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Api$Graphql$Phrase = $elm$core$Basics$identity;
var $author$project$Cambiatus$Mutation$genAuth = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'genAuth',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'account', requiredArgs.l8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object_,
			$elm$core$Basics$identity);
	});
var $dillonkearns$elm_graphql$Graphql$Http$Mutation = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$mutationRequest = F2(
	function (baseUrl, mutationSelectionSet) {
		return {
			eE: baseUrl,
			m_: $dillonkearns$elm_graphql$Graphql$Http$Mutation(mutationSelectionSet),
			gt: $dillonkearns$elm_graphql$Graphql$Document$decoder(mutationSelectionSet),
			nr: _List_Nil,
			cW: $elm$core$Maybe$Nothing,
			c3: _List_Nil,
			au: $elm$core$Maybe$Nothing,
			dg: false
		};
	});
var $author$project$Api$Graphql$mutation = F4(
	function (shared, maybeAuthToken, mutation_, toMsg) {
		var endpoints = shared.jN;
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, toMsg),
			A2(
				$author$project$Api$Graphql$withAuthToken,
				maybeAuthToken,
				A2(
					$author$project$Api$Graphql$withCommunityDomain,
					shared,
					A2($dillonkearns$elm_graphql$Graphql$Http$mutationRequest, endpoints.gx, mutation_))));
	});
var $author$project$Cambiatus$Object$Request$phrase = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'phrase', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Api$Graphql$askForPhrase = F3(
	function (shared, account, toMsg) {
		return A4(
			$author$project$Api$Graphql$mutation,
			shared,
			$elm$core$Maybe$Nothing,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$elm$core$Basics$identity,
				A2(
					$author$project$Cambiatus$Mutation$genAuth,
					{
						l8: $author$project$Eos$Account$nameToString(account)
					},
					$author$project$Cambiatus$Object$Request$phrase)),
			toMsg);
	});
var $author$project$Session$LoggedIn$closeModal = function (uResult) {
	var model = uResult.ok;
	return _Utils_update(
		uResult,
		{
			ok: _Utils_update(
				model,
				{el: false, cl: false, bs: false, fG: false, fH: false, aL: false})
		});
};
var $author$project$Form$updateValues = F2(
	function (updateFn, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				o: updateFn(model.o)
			});
	});
var $author$project$Search$closeSearch = function (model) {
	return _Utils_update(
		model,
		{
			hY: A2(
				$author$project$Form$updateValues,
				function (form) {
					return _Utils_update(
						form,
						{ed: ''});
				},
				model.hY),
			Z: $author$project$Search$Inactive
		});
};
var $author$project$Cambiatus$Object$User$contributionCount = function (fillInOptionals) {
	var filledInOptionals = fillInOptionals(
		{gd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	var optionalArgs = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'communityId', filledInOptionals.gd, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
			]));
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'contributionCount', optionalArgs, $elm$json$Json$Decode$int);
};
var $author$project$Profile$contributionCountSelectionSet = function (symbol) {
	return $author$project$Cambiatus$Object$User$contributionCount(
		function (optionals) {
			return _Utils_update(
				optionals,
				{
					gd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Eos$symbolToString(symbol))
				});
		});
};
var $author$project$Profile$contributionCountQuery = F2(
	function (symbol, account) {
		return A2(
			$author$project$Cambiatus$Query$user,
			{
				l8: $author$project$Eos$Account$nameToString(account)
			},
			$author$project$Profile$contributionCountSelectionSet(symbol));
	});
var $author$project$Session$LoggedIn$fetchTranslations = F2(
	function (version, language) {
		return A3(
			$author$project$Translation$get,
			version,
			language,
			$author$project$Session$LoggedIn$CompletedLoadTranslation(language));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$empty = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
	_List_Nil,
	$elm$json$Json$Decode$succeed(0));
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map2 = F3(
	function (combine, _v0, _v1) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_Utils_ap(selectionFields1, selectionFields2),
			A3($elm$json$Json$Decode$map2, combine, selectionDecoder1, selectionDecoder2));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$list = function (selections) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$List$reverse,
		A3(
			$elm$core$List$foldl,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map2($elm$core$List$cons),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				function (_v0) {
					return _List_Nil;
				},
				$dillonkearns$elm_graphql$Graphql$SelectionSet$empty),
			selections));
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $author$project$Community$fieldsSelectionSet = F2(
	function (symbol, fields) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
			_List_Nil,
			A2(
				$author$project$Cambiatus$Query$community,
				function (optionals) {
					return _Utils_update(
						optionals,
						{
							as: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
								$author$project$Eos$symbolToString(symbol))
						});
				},
				$dillonkearns$elm_graphql$Graphql$SelectionSet$list(
					A2(
						$elm$core$List$map,
						$author$project$Community$selectionSetForField,
						$elm_community$list_extra$List$Extra$unique(fields)))));
	});
var $author$project$UpdateResult$addChild = F5(
	function (childResult, addChildModel, fromChildMsg, fromChildExt, parentResult) {
		var applyChildExts = function (parent) {
			return A3($elm$core$List$foldl, fromChildExt, parent, childResult.jS);
		};
		return applyChildExts(
			{
				af: _Utils_ap(
					A2(
						$elm$core$List$map,
						$author$project$Log$mapBreadcrumb(fromChildMsg),
						childResult.af),
					parentResult.af),
				ju: _Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$Platform$Cmd$map(fromChildMsg),
						childResult.ju),
					parentResult.ju),
				jQ: _Utils_ap(
					A2(
						$elm$core$List$map,
						$author$project$Log$map(fromChildMsg),
						childResult.jQ),
					parentResult.jQ),
				jS: parentResult.jS,
				ok: A2(addChildModel, childResult.ok, parentResult.ok),
				k0: _Utils_ap(
					A2(
						$elm$core$List$map,
						$author$project$Ports$mapAddress(fromChildMsg),
						childResult.k0),
					parentResult.k0)
			});
	});
var $author$project$UpdateResult$fromChild = F5(
	function (addChildModel, fromChildMsg, fromChildExt, parent, childResult) {
		return A5(
			$author$project$UpdateResult$addChild,
			childResult,
			F2(
				function (child, _v0) {
					return addChildModel(child);
				}),
			fromChildMsg,
			fromChildExt,
			$author$project$UpdateResult$init(parent));
	});
var $author$project$Ports$getRecentSearches = _Platform_outgoingPort(
	'getRecentSearches',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Cambiatus$Subscription$highlightedNews = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'highlightedNews',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Session$LoggedIn$highlightedNewsSubscription = $author$project$Cambiatus$Subscription$highlightedNews($author$project$Community$News$selectionSet);
var $author$project$Api$Graphql$loggedInMutation = F4(
	function (loggedIn, maybeAuthToken, mutation_, toMsg) {
		var shared = loggedIn.A;
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, toMsg),
			A2(
				$author$project$Api$Graphql$withAuthToken,
				maybeAuthToken,
				A2(
					$author$project$Api$Graphql$withLoggedInCommunityDomain,
					loggedIn,
					A2($dillonkearns$elm_graphql$Graphql$Http$mutationRequest, shared.jN.gx, mutation_))));
	});
var $author$project$Session$LoggedIn$internalMutation = F3(
	function (model, selectionSet, toMsg) {
		return A4($author$project$Session$LoggedIn$internalGraphqlOperation, $author$project$Api$Graphql$loggedInMutation, model, selectionSet, toMsg);
	});
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Api$Graphql$isNonExistingCommunityError = $author$project$Api$Graphql$isCertainError('no community found using the domain');
var $author$project$Search$isOpenMsg = function (msg) {
	if (msg.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$UpdateResult$logImpossible = F5(
	function (transaction, message, maybeUser, location, contexts) {
		return $author$project$UpdateResult$logEvent(
			A5($author$project$Log$fromImpossible, transaction, message, maybeUser, location, contexts));
	});
var $author$project$UpdateResult$mapModel = F2(
	function (transform, uResult) {
		return {
			af: uResult.af,
			ju: uResult.ju,
			jQ: uResult.jQ,
			jS: uResult.jS,
			ok: transform(uResult.ok),
			k0: uResult.k0
		};
	});
var $author$project$Community$mergeFields = F2(
	function (loadedCommunity, newCommunity) {
		if (loadedCommunity.$ === 3) {
			var oldCommunity = loadedCommunity.a;
			return _Utils_update(
				newCommunity,
				{cV: oldCommunity.cV, bQ: oldCommunity.bQ});
		} else {
			return newCommunity;
		}
	});
var $author$project$Auth$removePrivateKey = function (model) {
	return _Utils_update(
		model,
		{pN: $author$project$Auth$WithoutPrivateKey});
};
var $author$project$Route$externalCommunityLink = F3(
	function (shared, subdomain, route) {
		var environments = _List_fromArray(
			['staging', 'demo']);
		var defaultEnding = 'cambiatus.io';
		var possibleEndings = _List_fromArray(
			['localhost', defaultEnding]);
		var currentUrl = shared.hn;
		var ending = A2(
			$elm$core$Maybe$withDefault,
			defaultEnding,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (possibleEnding) {
						return A2($elm$core$String$endsWith, possibleEnding, currentUrl.e3);
					},
					possibleEndings)));
		var communitySubdomain = A2(
			$elm$core$Maybe$withDefault,
			subdomain,
			$elm$core$List$head(
				A2($elm$core$String$split, '.', subdomain)));
		var communityHost = function () {
			var _v0 = A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				A2(
					$elm$core$String$split,
					'.',
					A2(
						$elm$core$String$dropRight,
						$elm$core$String$length(ending),
						currentUrl.e3)));
			if (!_v0.b) {
				return A2(
					$elm$core$String$join,
					'.',
					_List_fromArray(
						[communitySubdomain, ending]));
			} else {
				if (!_v0.b.b) {
					var singlePart = _v0.a;
					return A2($elm$core$List$member, singlePart, environments) ? A2(
						$elm$core$String$join,
						'.',
						_List_fromArray(
							[communitySubdomain, singlePart, ending])) : A2(
						$elm$core$String$join,
						'.',
						_List_fromArray(
							[communitySubdomain, ending]));
				} else {
					var _v1 = _v0.b;
					var env = _v1.a;
					return A2(
						$elm$core$String$join,
						'.',
						_List_fromArray(
							[communitySubdomain, env, ending]));
				}
			}
		}();
		return _Utils_update(
			currentUrl,
			{
				e3: communityHost,
				g_: $author$project$Route$routeToString(route)
			});
	});
var $author$project$Route$loadExternalCommunity = F3(
	function (shared, community, route) {
		return shared.qf ? $elm$browser$Browser$Navigation$load(
			$elm$url$Url$toString(
				A3($author$project$Route$externalCommunityLink, shared, community.pP, route))) : A2($author$project$Route$pushUrl, shared.kK, route);
	});
var $author$project$Session$LoggedIn$selectCommunity = F3(
	function (model, community, route) {
		var shared = model.A;
		return shared.qf ? _Utils_Tuple2(
			model,
			A3($author$project$Route$loadExternalCommunity, shared, community, route)) : _Utils_Tuple2(
			_Utils_update(
				model,
				{pC: $krisajenkins$remotedata$RemoteData$Loading}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$Session$LoggedIn$fetchCommunity,
						model,
						$elm$core$Maybe$Just(community.as)),
						A2($author$project$Route$replaceUrl, shared.kK, route)
					])));
	});
var $author$project$Cambiatus$Enum$Language$toString = function (_enum) {
	switch (_enum) {
		case 0:
			return 'AMHETH';
		case 1:
			return 'ENUS';
		case 2:
			return 'ESES';
		default:
			return 'PTBR';
	}
};
var $author$project$Cambiatus$Mutation$preference = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{dq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ic: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ep: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'claimNotification', filledInOptionals.dq, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'digest', filledInOptionals.dx, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'language',
					filledInOptionals.ic,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$Language$toString)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'transferNotification', filledInOptionals.ep, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'preference',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Session$LoggedIn$sendPreferredLanguage = F2(
	function (model, language) {
		var languageEnum = function () {
			switch (language) {
				case 4:
					return $elm$core$Maybe$Just(0);
				case 0:
					return $elm$core$Maybe$Just(1);
				case 2:
					return $elm$core$Maybe$Just(2);
				case 1:
					return $elm$core$Maybe$Just(3);
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		if (languageEnum.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var languageArg = languageEnum.a;
			return A3(
				$author$project$Session$LoggedIn$internalMutation,
				model,
				A2(
					$author$project$Cambiatus$Mutation$preference,
					function (optionals) {
						return _Utils_update(
							optionals,
							{
								ic: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(languageArg)
							});
					},
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(0)),
				$author$project$Session$LoggedIn$CompletedSendingLanguagePreference);
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeSubscription = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'subscription', fields);
};
var $author$project$Api$Graphql$SignInResponse = F2(
	function (profile, token) {
		return {pl: profile, p5: token};
	});
var $author$project$Cambiatus$Mutation$signIn = F3(
	function (fillInOptionals, requiredArgs, object_) {
		var filledInOptionals = fillInOptionals(
			{kk: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'invitationId', filledInOptionals.kk, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'signIn',
			_Utils_ap(
				optionalArgs,
				_List_fromArray(
					[
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'account', requiredArgs.l8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'password', requiredArgs.kX, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
					])),
			object_,
			$elm$core$Basics$identity);
	});
var $author$project$Cambiatus$Object$Session$token = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'token', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Session$user = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'user', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Api$Graphql$signIn = F3(
	function (shared, _v0, toMsg) {
		var account = _v0.l8;
		var password = _v0.kX;
		var invitationId = _v0.kk;
		var _v1 = password;
		var unwrappedPassword = _v1;
		return A4(
			$author$project$Api$Graphql$mutation,
			shared,
			$elm$core$Maybe$Nothing,
			A3(
				$author$project$Cambiatus$Mutation$signIn,
				function (opts) {
					return _Utils_update(
						opts,
						{
							kk: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(invitationId)
						});
				},
				{
					l8: $author$project$Eos$Account$nameToString(account),
					kX: unwrappedPassword
				},
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Session$token),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Session$user($author$project$Profile$selectionSet),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Graphql$SignInResponse)))),
			toMsg);
	});
var $author$project$Eos$Account$encodePrivateKey = function (_v0) {
	var pk = _v0;
	return $elm$json$Json$Encode$string(pk);
};
var $author$project$Api$Graphql$signPhrasePort = F3(
	function (responseAddress, privateKey, _v0) {
		var phrase = _v0;
		return {
			bZ: $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string('signString')),
						_Utils_Tuple2(
						'input',
						$elm$json$Json$Encode$string(phrase)),
						_Utils_Tuple2(
						'privateKey',
						$author$project$Eos$Account$encodePrivateKey(privateKey))
					])),
			fy: responseAddress,
			fz: $elm$json$Json$Encode$null
		};
	});
var $author$project$Ports$storeAuthToken = _Platform_outgoingPort('storeAuthToken', $elm$json$Json$Encode$string);
var $author$project$Api$Graphql$storeToken = function (_v0) {
	var token = _v0;
	return $author$project$Ports$storeAuthToken(token);
};
var $author$project$Cambiatus$Object$UnreadNotifications$unreads = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'unreads', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Session$LoggedIn$unreadSelection = $author$project$Cambiatus$Object$UnreadNotifications$unreads;
var $author$project$Cambiatus$InputObject$encodeUnreadNotificationsSubscriptionInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'account',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input.l8)))
			]));
};
var $author$project$Cambiatus$Subscription$unreads = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'unreads',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs.nG, $author$project$Cambiatus$InputObject$encodeUnreadNotificationsSubscriptionInput)
				]),
			object_,
			$elm$core$Basics$identity);
	});
var $author$project$Session$LoggedIn$unreadCountSubscription = function (name) {
	var stringName = $author$project$Eos$Account$nameToString(name);
	var args = {
		nG: {l8: stringName}
	};
	return A2($author$project$Cambiatus$Subscription$unreads, args, $author$project$Session$LoggedIn$unreadSelection);
};
var $author$project$Action$Claiming = function (a) {
	return {$: 1, a: a};
};
var $author$project$Action$GeneratingCode = {$: 1};
var $author$project$Action$NoCodeNecessary = {$: 0};
var $author$project$Action$NoProofNecessary = {$: 0};
var $author$project$Action$SetUpdateTimeEvery = function (a) {
	return {$: 0, a: a};
};
var $author$project$Action$ShowFeedback = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Feedback$Success = 0;
var $author$project$Action$WithProof = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Route$addRouteToUrl = F2(
	function (shared, route) {
		var protocol = function () {
			var _v1 = shared.hn.pn;
			if (!_v1) {
				return 'http://';
			} else {
				return 'https://';
			}
		}();
		var port_ = function () {
			var _v0 = shared.hn.pb;
			if (_v0.$ === 1) {
				return '';
			} else {
				var p = _v0.a;
				return ':' + $elm$core$String$fromInt(p);
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			shared.hn,
			$elm$url$Url$fromString(
				_Utils_ap(
					protocol,
					_Utils_ap(
						shared.hn.e3,
						_Utils_ap(
							port_,
							$author$project$Route$routeToString(route))))));
	});
var $author$project$Markdown$encode = function (_v0) {
	var markdown = _v0;
	return $elm$json$Json$Encode$string(
		$elm$core$String$trim(markdown));
};
var $author$project$Action$encodeId = function (_v0) {
	var id = _v0;
	return $elm$json$Json$Encode$int(id);
};
var $author$project$Form$File$SingleModel = $elm$core$Basics$identity;
var $author$project$Form$File$initSingle = function (_v0) {
	var fileUrl = _v0.ni;
	var aspectRatio = _v0.mj;
	return {
		mj: aspectRatio,
		eY: A2(
			$elm$core$Maybe$map,
			function (file) {
				return {
					aG: $author$project$Form$File$LoadingFileType,
					X: function () {
						if (aspectRatio.$ === 1) {
							return $author$project$Form$File$WithoutImageCropper;
						} else {
							var validAspectRatio = aspectRatio.a;
							return $author$project$Form$File$WithImageCropper(
								$author$project$View$ImageCropper$init(
									{mj: validAspectRatio}));
						}
					}(),
					hn: $author$project$Form$File$Loaded(file)
				};
			},
			fileUrl),
		h9: false,
		gH: false,
		aj: false
	};
};
var $author$project$Action$shareActionButtonId = function (actionId) {
	return 'share-action-button-' + $elm$core$String$fromInt(
		$author$project$Action$idToInt(actionId));
};
var $author$project$Action$shareActionFallbackId = function (actionId) {
	return 'share-action-fallback-' + $elm$core$String$fromInt(
		$author$project$Action$idToInt(actionId));
};
var $author$project$Action$GotPhotoProofFormMsg = function (a) {
	return {$: 3, a: a};
};
var $justinmimbs$time_extra$Time$Extra$Minute = 13;
var $author$project$Action$RequiredPrivateKey = function (a) {
	return {$: 2, a: a};
};
var $author$project$Action$ShowInsufficientPermissionsModal = {$: 3};
var $author$project$Action$WithCode = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$date$Date$Months = 1;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {mX: d, ol: m, qn: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		iC: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		qn: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.qn, 0, date.iC);
};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.qn - 1)) + ($justinmimbs$date$Date$monthToNumber(date.ol) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.mX,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $author$project$Action$encodeClaimAction = function (c) {
	var encodeProofItem = F3(
		function (getter, _default, encoder) {
			return encoder(
				A2(
					$elm$core$Maybe$withDefault,
					_default,
					A2($elm$core$Maybe$map, getter, c.aY)));
		});
	var encodeProofCodeItem = F3(
		function (getter, _default, encoder) {
			return encoder(
				A2(
					$elm$core$Maybe$withDefault,
					_default,
					A2(
						$elm$core$Maybe$map,
						getter,
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.g3;
							},
							c.aY))));
		});
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'community_id',
				$author$project$Eos$encodeSymbol(c.gd)),
				_Utils_Tuple2(
				'action_id',
				$author$project$Action$encodeId(c.f_)),
				_Utils_Tuple2(
				'maker',
				$author$project$Eos$Account$encodeName(c.gb)),
				_Utils_Tuple2(
				'proof_photo',
				A3(
					encodeProofItem,
					function ($) {
						return $.kZ;
					},
					'',
					$elm$json$Json$Encode$string)),
				_Utils_Tuple2(
				'proof_code',
				A3(
					encodeProofCodeItem,
					function ($) {
						return $.ds;
					},
					'',
					$elm$json$Json$Encode$string)),
				_Utils_Tuple2(
				'proof_time',
				A3(
					encodeProofCodeItem,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.lD;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$time$Time$posixToMillis,
							function (time) {
								return (time / 1000) | 0;
							})),
					0,
					$elm$json$Json$Encode$int))
			]));
};
var $author$project$Eos$Account$encodePermissionName = function (_v0) {
	var permissionName = _v0;
	return $elm$json$Json$Encode$string(permissionName);
};
var $author$project$Eos$encodeAuthorization = function (authorization) {
	return A2(
		$elm$json$Json$Encode$list,
		function (a) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'actor',
						$author$project$Eos$Account$encodeName(a.hr)),
						_Utils_Tuple2(
						'permission',
						$author$project$Eos$Account$encodePermissionName(a.iF))
					]));
		},
		_List_fromArray(
			[authorization]));
};
var $author$project$Eos$encodeAction = function (action) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'account',
				$elm$json$Json$Encode$string(action._)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(action.fj)),
				_Utils_Tuple2(
				'authorization',
				$author$project$Eos$encodeAuthorization(action.hw)),
				_Utils_Tuple2('data', action.bZ)
			]));
};
var $author$project$Eos$encodeTransaction = function (transaction) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string('eosTransaction')),
				_Utils_Tuple2(
				'actions',
				A2($elm$json$Json$Encode$list, $author$project$Eos$encodeAction, transaction))
			]));
};
var $billstclair$elm_sha256$Sha256$initialHs = function (is224) {
	return is224 ? {L: 3238371032, aO: 914150663, aP: 812702999, aQ: 4144912697, O: 4290775857, bc: 1750603025, bd: 1694076839, aV: 3204075428} : {L: 1779033703, aO: 3144134277, aP: 1013904242, aQ: 2773480762, O: 1359893119, bc: 2600822924, bd: 528734635, aV: 1541459225};
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $billstclair$elm_sha256$Sha256$extra = _List_fromArray(
	[-2147483648, 8388608, 32768, 128]);
var $billstclair$elm_sha256$Sha256$get = F2(
	function (index, array) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Array$get, index, array));
	});
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $billstclair$elm_sha256$Sha256$getAt = F2(
	function (index, list) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm_community$list_extra$List$Extra$getAt, index, list));
	});
var $billstclair$elm_sha256$Sha256$getShift = F2(
	function (i, n) {
		return 8 * (3 - ((i + n) & 3));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $billstclair$elm_sha256$Sha256$orIntoBlocks = F3(
	function (idx, val, blocks) {
		return A3(
			$elm$core$Array$set,
			idx,
			val | A2($billstclair$elm_sha256$Sha256$get, idx, blocks),
			blocks);
	});
var $billstclair$elm_sha256$Sha256$sl = F2(
	function (num, shift) {
		return num << shift;
	});
var $billstclair$elm_sha256$Sha256$sr = F2(
	function (num, shift) {
		return num >> shift;
	});
var $billstclair$elm_sha256$Sha256$indexLoop = F5(
	function (i, index, message, length, blocks) {
		indexLoop:
		while (true) {
			if (!((_Utils_cmp(index, length) < 0) && (i < 64))) {
				return _Utils_Tuple3(i, index, blocks);
			} else {
				var shift = $billstclair$elm_sha256$Sha256$getShift(i);
				var code = A2($billstclair$elm_sha256$Sha256$get, index, message);
				var _v0 = (code < 128) ? _Utils_Tuple3(
					1,
					0,
					A2(
						$billstclair$elm_sha256$Sha256$sl,
						code,
						shift(0))) : ((code < 2048) ? _Utils_Tuple3(
					2,
					0,
					A2(
						$billstclair$elm_sha256$Sha256$sl,
						128 | (code & 63),
						shift(1)) | A2(
						$billstclair$elm_sha256$Sha256$sl,
						192 | A2($billstclair$elm_sha256$Sha256$sr, code, 6),
						shift(0))) : (((code < 55296) || (code >= 57344)) ? _Utils_Tuple3(
					3,
					0,
					A2(
						$billstclair$elm_sha256$Sha256$sl,
						128 | (code & 63),
						shift(2)) | (A2(
						$billstclair$elm_sha256$Sha256$sl,
						128 | (A2($billstclair$elm_sha256$Sha256$sr, code, 6) & 63),
						shift(1)) | A2(
						$billstclair$elm_sha256$Sha256$sl,
						224 | A2($billstclair$elm_sha256$Sha256$sr, code, 12),
						shift(0)))) : _Utils_Tuple3(
					4,
					1,
					function () {
						var code2 = (A2($billstclair$elm_sha256$Sha256$get, index + 1, message) & 1023) | (65536 + A2($billstclair$elm_sha256$Sha256$sl, code & 1023, 10));
						return A2(
							$billstclair$elm_sha256$Sha256$sl,
							128 | (code2 & 63),
							shift(3)) | (A2(
							$billstclair$elm_sha256$Sha256$sl,
							128 | (A2($billstclair$elm_sha256$Sha256$sr, code2, 6) & 63),
							shift(2)) | (A2(
							$billstclair$elm_sha256$Sha256$sl,
							128 | ((code2 >> 12) & 63),
							shift(1)) | A2(
							$billstclair$elm_sha256$Sha256$sl,
							240 | (code2 >> 18),
							shift(0))));
					}())));
				var iInc = _v0.a;
				var idxInc = _v0.b;
				var val = _v0.c;
				var blocks2 = A3(
					$billstclair$elm_sha256$Sha256$orIntoBlocks,
					A2($billstclair$elm_sha256$Sha256$sr, i, 2),
					val,
					blocks);
				var $temp$i = i + iInc,
					$temp$index = (index + idxInc) + 1,
					$temp$message = message,
					$temp$length = length,
					$temp$blocks = blocks2;
				i = $temp$i;
				index = $temp$index;
				message = $temp$message;
				length = $temp$length;
				blocks = $temp$blocks;
				continue indexLoop;
			}
		}
	});
var $billstclair$elm_sha256$Sha256$srz = F2(
	function (num, shift) {
		return num >>> shift;
	});
var $billstclair$elm_sha256$Sha256$jLoop1 = F2(
	function (j, blocks) {
		jLoop1:
		while (true) {
			var t2 = A2($billstclair$elm_sha256$Sha256$get, j - 2, blocks);
			var t1 = A2($billstclair$elm_sha256$Sha256$get, j - 15, blocks);
			var s1 = A2($billstclair$elm_sha256$Sha256$srz, t2, 10) ^ ((A2($billstclair$elm_sha256$Sha256$srz, t2, 19) | A2($billstclair$elm_sha256$Sha256$sl, t2, 13)) ^ (A2($billstclair$elm_sha256$Sha256$srz, t2, 17) | A2($billstclair$elm_sha256$Sha256$sl, t2, 15)));
			var s0 = A2($billstclair$elm_sha256$Sha256$srz, t1, 3) ^ ((A2($billstclair$elm_sha256$Sha256$srz, t1, 18) | A2($billstclair$elm_sha256$Sha256$sl, t1, 14)) ^ (A2($billstclair$elm_sha256$Sha256$srz, t1, 7) | A2($billstclair$elm_sha256$Sha256$sl, t1, 25)));
			var blocks2 = A3(
				$elm$core$Array$set,
				j,
				A2(
					$billstclair$elm_sha256$Sha256$sl,
					((A2($billstclair$elm_sha256$Sha256$get, j - 16, blocks) + s0) + A2($billstclair$elm_sha256$Sha256$get, j - 7, blocks)) + s1,
					0),
				blocks);
			if (j < 63) {
				var $temp$j = j + 1,
					$temp$blocks = blocks2;
				j = $temp$j;
				blocks = $temp$blocks;
				continue jLoop1;
			} else {
				return blocks2;
			}
		}
	});
var $billstclair$elm_sha256$Sha256$ks = $elm$core$Array$fromList(
	_List_fromArray(
		[1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298]));
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $billstclair$elm_sha256$Sha256$lognot = $elm$core$Bitwise$complement;
var $billstclair$elm_sha256$Sha256$jLoopBody2 = F4(
	function (j, ab, hs, blocks) {
		var h = hs.aV;
		var s1 = (A2($billstclair$elm_sha256$Sha256$srz, h, 25) | A2($billstclair$elm_sha256$Sha256$sl, h, 7)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, h, 11) | A2($billstclair$elm_sha256$Sha256$sl, h, 21)) ^ (A2($billstclair$elm_sha256$Sha256$srz, h, 6) | A2($billstclair$elm_sha256$Sha256$sl, h, 26)));
		var g = hs.bd;
		var f = hs.bc;
		var e = hs.O;
		var d = hs.aQ;
		var s0 = (A2($billstclair$elm_sha256$Sha256$srz, d, 22) | A2($billstclair$elm_sha256$Sha256$sl, d, 10)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, d, 13) | A2($billstclair$elm_sha256$Sha256$sl, d, 19)) ^ (A2($billstclair$elm_sha256$Sha256$srz, d, 2) | A2($billstclair$elm_sha256$Sha256$sl, d, 30)));
		var ch = ($billstclair$elm_sha256$Sha256$lognot(h) & f) ^ (h & e);
		var t1 = (((g + s1) + ch) + A2($billstclair$elm_sha256$Sha256$get, j + 1, $billstclair$elm_sha256$Sha256$ks)) + A2($billstclair$elm_sha256$Sha256$get, j + 1, blocks);
		var c = hs.aP;
		var g2 = A2($billstclair$elm_sha256$Sha256$sl, c + t1, 0);
		var ch2 = (g2 & h) ^ ($billstclair$elm_sha256$Sha256$lognot(g2) & e);
		var s3 = (A2($billstclair$elm_sha256$Sha256$srz, g2, 25) | A2($billstclair$elm_sha256$Sha256$sl, g2, 7)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, g2, 11) | A2($billstclair$elm_sha256$Sha256$sl, g2, 21)) ^ (A2($billstclair$elm_sha256$Sha256$srz, g2, 6) | A2($billstclair$elm_sha256$Sha256$sl, g2, 26)));
		var t3 = (((f + s3) + ch2) + A2($billstclair$elm_sha256$Sha256$get, j + 2, $billstclair$elm_sha256$Sha256$ks)) + A2($billstclair$elm_sha256$Sha256$get, j + 2, blocks);
		var b = hs.aO;
		var f2 = A2($billstclair$elm_sha256$Sha256$sl, b + t3, 0);
		var ch3 = (f2 & g2) ^ ($billstclair$elm_sha256$Sha256$lognot(f2) & h);
		var s5 = (A2($billstclair$elm_sha256$Sha256$srz, f2, 25) | A2($billstclair$elm_sha256$Sha256$sl, f2, 7)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, f2, 11) | A2($billstclair$elm_sha256$Sha256$sl, f2, 21)) ^ (A2($billstclair$elm_sha256$Sha256$srz, f2, 6) | A2($billstclair$elm_sha256$Sha256$sl, f2, 26)));
		var t5 = (((e + s5) + ch3) + A2($billstclair$elm_sha256$Sha256$get, j + 3, $billstclair$elm_sha256$Sha256$ks)) + A2($billstclair$elm_sha256$Sha256$get, j + 3, blocks);
		var a = hs.L;
		var da = d & a;
		var maj = ab ^ (da ^ (d & b));
		var t2 = s0 + maj;
		var c2 = A2($billstclair$elm_sha256$Sha256$sl, t1 + t2, 0);
		var cd = c2 & d;
		var s2 = (A2($billstclair$elm_sha256$Sha256$srz, c2, 22) | A2($billstclair$elm_sha256$Sha256$sl, c2, 10)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, c2, 13) | A2($billstclair$elm_sha256$Sha256$sl, c2, 19)) ^ (A2($billstclair$elm_sha256$Sha256$srz, c2, 2) | A2($billstclair$elm_sha256$Sha256$sl, c2, 30)));
		var e2 = A2($billstclair$elm_sha256$Sha256$sl, a + t5, 0);
		var maj2 = da ^ (cd ^ (c2 & a));
		var t4 = s2 + maj2;
		var b2 = A2($billstclair$elm_sha256$Sha256$sl, t3 + t4, 0);
		var bc = b2 & c2;
		var maj3 = cd ^ (bc ^ (b2 & d));
		var s4 = (A2($billstclair$elm_sha256$Sha256$srz, b2, 22) | A2($billstclair$elm_sha256$Sha256$sl, b2, 10)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, b2, 13) | A2($billstclair$elm_sha256$Sha256$sl, b2, 19)) ^ (A2($billstclair$elm_sha256$Sha256$srz, b2, 2) | A2($billstclair$elm_sha256$Sha256$sl, b2, 30)));
		var t6 = s4 + maj3;
		var a2 = A2($billstclair$elm_sha256$Sha256$sl, t5 + t6, 0);
		return {L: a2, aO: b2, aP: c2, aQ: d, O: e2, bc: f2, bd: g2, aV: h};
	});
var $billstclair$elm_sha256$Sha256$jLoop2 = F5(
	function (j, first, is224, hs, blocks) {
		jLoop2:
		while (true) {
			var jp4 = j + 4;
			var first2 = false;
			var _v0 = function () {
				if (first) {
					if (is224) {
						var t1 = A2($billstclair$elm_sha256$Sha256$get, 0, blocks) - 1413257819;
						return _Utils_Tuple3(
							300032,
							A2($billstclair$elm_sha256$Sha256$sl, t1 - 150054599, 0),
							A2($billstclair$elm_sha256$Sha256$sl, t1 + 24177077, 0));
					} else {
						var t2 = A2($billstclair$elm_sha256$Sha256$get, 0, blocks) - 210244248;
						return _Utils_Tuple3(
							704751109,
							A2($billstclair$elm_sha256$Sha256$sl, t2 - 1521486534, 0),
							A2($billstclair$elm_sha256$Sha256$sl, t2 + 143694565, 0));
					}
				} else {
					var s1 = (A2($billstclair$elm_sha256$Sha256$srz, hs.O, 25) | A2($billstclair$elm_sha256$Sha256$sl, hs.O, 7)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, hs.O, 11) | A2($billstclair$elm_sha256$Sha256$sl, hs.O, 21)) ^ (A2($billstclair$elm_sha256$Sha256$srz, hs.O, 6) | A2($billstclair$elm_sha256$Sha256$sl, hs.O, 26)));
					var s0 = (A2($billstclair$elm_sha256$Sha256$srz, hs.L, 22) | A2($billstclair$elm_sha256$Sha256$sl, hs.L, 10)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, hs.L, 13) | A2($billstclair$elm_sha256$Sha256$sl, hs.L, 19)) ^ (A2($billstclair$elm_sha256$Sha256$srz, hs.L, 2) | A2($billstclair$elm_sha256$Sha256$sl, hs.L, 30)));
					var ch = (hs.O & hs.bc) ^ ($billstclair$elm_sha256$Sha256$lognot(hs.O) & hs.bd);
					var t3 = (((hs.aV + s1) + ch) + A2($billstclair$elm_sha256$Sha256$get, j, $billstclair$elm_sha256$Sha256$ks)) + A2($billstclair$elm_sha256$Sha256$get, j, blocks);
					var ab2 = hs.L & hs.aO;
					var maj = (hs.aO & hs.aP) ^ (ab2 ^ (hs.L & hs.aP));
					var t4 = s0 + maj;
					return _Utils_Tuple3(
						ab2,
						A2($billstclair$elm_sha256$Sha256$sl, hs.aQ + t3, 0),
						A2($billstclair$elm_sha256$Sha256$sl, t3 + t4, 0));
				}
			}();
			var ab = _v0.a;
			var h = _v0.b;
			var d = _v0.c;
			var hs2 = _Utils_update(
				hs,
				{aQ: d, aV: h});
			var hs3 = A4($billstclair$elm_sha256$Sha256$jLoopBody2, j, ab, hs2, blocks);
			if (jp4 < 64) {
				var $temp$j = jp4,
					$temp$first = first2,
					$temp$is224 = is224,
					$temp$hs = hs3,
					$temp$blocks = blocks;
				j = $temp$j;
				first = $temp$first;
				is224 = $temp$is224;
				hs = $temp$hs;
				blocks = $temp$blocks;
				continue jLoop2;
			} else {
				return hs3;
			}
		}
	});
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $billstclair$elm_sha256$Sha256$makeBlocks = function (block) {
	return A3(
		$elm$core$Array$set,
		0,
		block,
		A2($elm$core$Array$repeat, 64, 0));
};
var $billstclair$elm_sha256$Sha256$sumHS = F2(
	function (hs1, hs2) {
		return {
			L: A2($billstclair$elm_sha256$Sha256$sl, hs1.L + hs2.L, 0),
			aO: A2($billstclair$elm_sha256$Sha256$sl, hs1.aO + hs2.aO, 0),
			aP: A2($billstclair$elm_sha256$Sha256$sl, hs1.aP + hs2.aP, 0),
			aQ: A2($billstclair$elm_sha256$Sha256$sl, hs1.aQ + hs2.aQ, 0),
			O: A2($billstclair$elm_sha256$Sha256$sl, hs1.O + hs2.O, 0),
			bc: A2($billstclair$elm_sha256$Sha256$sl, hs1.bc + hs2.bc, 0),
			bd: A2($billstclair$elm_sha256$Sha256$sl, hs1.bd + hs2.bd, 0),
			aV: A2($billstclair$elm_sha256$Sha256$sl, hs1.aV + hs2.aV, 0)
		};
	});
var $billstclair$elm_sha256$Sha256$outerLoop = F9(
	function (first, hs, block, start, bytes, index, is224, message, length) {
		outerLoop:
		while (true) {
			var blocks = $billstclair$elm_sha256$Sha256$makeBlocks(block);
			var _v0 = A5($billstclair$elm_sha256$Sha256$indexLoop, start, index, message, length, blocks);
			var i = _v0.a;
			var index2 = _v0.b;
			var blocks2 = _v0.c;
			var bytes2 = (bytes + i) - start;
			var start2 = i - 64;
			var _v1 = _Utils_eq(index2, length) ? _Utils_Tuple2(
				A3(
					$billstclair$elm_sha256$Sha256$orIntoBlocks,
					A2($billstclair$elm_sha256$Sha256$sr, i, 2),
					A2($billstclair$elm_sha256$Sha256$getAt, i & 3, $billstclair$elm_sha256$Sha256$extra),
					blocks2),
				index2 + 1) : _Utils_Tuple2(blocks2, index2);
			var blocks3 = _v1.a;
			var index3 = _v1.b;
			var block2 = A2($billstclair$elm_sha256$Sha256$get, 16, blocks3);
			var _v2 = ((_Utils_cmp(index3, length) > 0) && (i < 56)) ? _Utils_Tuple2(
				true,
				A3(
					$elm$core$Array$set,
					15,
					A2($billstclair$elm_sha256$Sha256$sl, bytes2, 3),
					blocks3)) : _Utils_Tuple2(false, blocks3);
			var end = _v2.a;
			var blocks4 = _v2.b;
			var blocks5 = A2($billstclair$elm_sha256$Sha256$jLoop1, 16, blocks4);
			var hs2 = A5($billstclair$elm_sha256$Sha256$jLoop2, 0, first, is224, hs, blocks5);
			var hs3 = A2($billstclair$elm_sha256$Sha256$sumHS, hs, hs2);
			if (!end) {
				var $temp$first = false,
					$temp$hs = hs3,
					$temp$block = block2,
					$temp$start = start2,
					$temp$bytes = bytes2,
					$temp$index = index3,
					$temp$is224 = is224,
					$temp$message = message,
					$temp$length = length;
				first = $temp$first;
				hs = $temp$hs;
				block = $temp$block;
				start = $temp$start;
				bytes = $temp$bytes;
				index = $temp$index;
				is224 = $temp$is224;
				message = $temp$message;
				length = $temp$length;
				continue outerLoop;
			} else {
				return hs3;
			}
		}
	});
var $billstclair$elm_sha256$Sha256$stringToMessage = function (string) {
	return $elm$core$Array$fromList(
		A2(
			$elm$core$List$map,
			$elm$core$Char$toCode,
			$elm$core$String$toList(string)));
};
var $elm$core$String$fromList = _String_fromList;
var $billstclair$elm_sha256$Sha256$toHex1 = function (x) {
	var x2 = x & 15;
	return $elm$core$Char$fromCode(
		x2 + ((x2 < 10) ? $elm$core$Char$toCode('0') : ((-10) + $elm$core$Char$toCode('a'))));
};
var $billstclair$elm_sha256$Sha256$toHex8 = function (x) {
	return $elm$core$String$fromList(
		A2(
			$elm$core$List$map,
			function (shift) {
				return $billstclair$elm_sha256$Sha256$toHex1(
					A2($billstclair$elm_sha256$Sha256$sr, x, shift));
			},
			_List_fromArray(
				[28, 24, 20, 16, 12, 8, 4, 0])));
};
var $billstclair$elm_sha256$Sha256$toHex56 = function (hs) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Basics$append,
		'',
		A2(
			$elm$core$List$map,
			$billstclair$elm_sha256$Sha256$toHex8,
			_List_fromArray(
				[hs.L, hs.aO, hs.aP, hs.aQ, hs.O, hs.bc, hs.bd])));
};
var $billstclair$elm_sha256$Sha256$toHex64 = function (hs) {
	return _Utils_ap(
		$billstclair$elm_sha256$Sha256$toHex56(hs),
		$billstclair$elm_sha256$Sha256$toHex8(hs.aV));
};
var $billstclair$elm_sha256$Sha256$hash = F2(
	function (string, is224) {
		var start = 0;
		var message = $billstclair$elm_sha256$Sha256$stringToMessage(string);
		var length = $elm$core$Array$length(message);
		var index = 0;
		var hs = $billstclair$elm_sha256$Sha256$initialHs(is224);
		var bytes = 0;
		var block = 0;
		var hs2 = A9($billstclair$elm_sha256$Sha256$outerLoop, true, hs, block, start, bytes, index, is224, message, length);
		return is224 ? $billstclair$elm_sha256$Sha256$toHex56(hs2) : $billstclair$elm_sha256$Sha256$toHex64(hs2);
	});
var $billstclair$elm_sha256$Sha256$sha256 = function (string) {
	return A2($billstclair$elm_sha256$Sha256$hash, string, false);
};
var $author$project$Action$generateProofCode = F3(
	function (action, claimerAccountUint64, time) {
		return A3(
			$elm$core$String$slice,
			0,
			8,
			$billstclair$elm_sha256$Sha256$sha256(
				_Utils_ap(
					$elm$core$String$fromInt(
						$author$project$Action$idToInt(action.w)),
					_Utils_ap(
						claimerAccountUint64,
						$elm$core$String$fromInt(
							($elm$time$Time$posixToMillis(time) / 1000) | 0)))));
	});
var $author$project$Log$JsonValue = 6;
var $author$project$Log$fromJsonValue = F6(
	function (transaction, maybeUser, message, location, contexts, value) {
		return {
			mL: A2(
				$elm$core$List$cons,
				{
					ng: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2('Value', value)
							])),
					fj: 'JSON value'
				},
				contexts),
			n4: 3,
			oa: location,
			of: message,
			pY: _List_fromArray(
				[
					$author$project$Log$TypeTag(6)
				]),
			p7: transaction,
			qh: maybeUser
		};
	});
var $author$project$UpdateResult$logJsonValue = F6(
	function (transaction, maybeUser, message, location, contexts, jsonValue) {
		return $author$project$UpdateResult$logEvent(
			A6($author$project$Log$fromJsonValue, transaction, maybeUser, message, location, contexts, jsonValue));
	});
var $author$project$Eos$Account$PermissionName = $elm$core$Basics$identity;
var $author$project$Eos$Account$samplePermission = 'active';
var $author$project$Eos$symbolToSymbolCodeString = function (_v0) {
	var s = _v0.a;
	return s;
};
var $author$project$Form$GotDatePickerMsg = F5(
	function (a, b, c, d, e) {
		return {$: 4, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Form$GotFileMsg = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $author$project$Form$GotRichTextMsg = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Form$GotUserPickerMsg = F5(
	function (a, b, c, d, e) {
		return {$: 5, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Form$DatePicker$NoOp = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$isOpen = function (_v0) {
	var model = _v0;
	return model.bH;
};
var $CurrySoftware$elm_datepicker$DatePicker$Focus = {$: 5};
var $CurrySoftware$elm_datepicker$DatePicker$open = $CurrySoftware$elm_datepicker$DatePicker$Focus;
var $CurrySoftware$elm_datepicker$DatePicker$Pick = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$pick = $CurrySoftware$elm_datepicker$DatePicker$Pick;
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$time$Time$Sun = 6;
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.mX;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.ol;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.iC;
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		l$: 1 + (((rd - week1Day1) / 7) | 0),
		l0: wy,
		qk: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.l$;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.l0;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.gV(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.ip(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.gV(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.hP(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.df(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.df(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.df(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.jd(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.df(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.df(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	hP: $justinmimbs$date$Date$withOrdinalSuffix,
	ip: $justinmimbs$date$Date$monthToName,
	gV: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	jd: $justinmimbs$date$Date$weekdayToName,
	df: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $CurrySoftware$elm_datepicker$DatePicker$formatCell = function (day) {
	return $elm$html$Html$text(day);
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.ph;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $CurrySoftware$elm_datepicker$DatePicker$Date$Off = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$off = $CurrySoftware$elm_datepicker$DatePicker$Date$Off;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $CurrySoftware$elm_datepicker$DatePicker$defaultSettings = {
	hB: $CurrySoftware$elm_datepicker$DatePicker$formatCell,
	mr: $CurrySoftware$elm_datepicker$DatePicker$off,
	dr: 'elm-datepicker--',
	mH: _List_Nil,
	mW: $justinmimbs$date$Date$format('yyyy-MM-dd'),
	hO: $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay,
	gv: 6,
	nH: _List_fromArray(
		[
			$elm$html$Html$Attributes$required(false)
		]),
	nJ: _List_Nil,
	nK: $elm$core$Maybe$Nothing,
	h7: $elm$core$Maybe$Nothing,
	nP: $elm$core$Basics$always(false),
	io: $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth,
	o3: $justinmimbs$date$Date$fromIsoString,
	pa: 'Please pick a date...',
	jf: $elm$core$String$fromInt
};
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Form$DatePicker$settings = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		var defaultSettings_ = $CurrySoftware$elm_datepicker$DatePicker$defaultSettings;
		return _Utils_update(
			defaultSettings_,
			{
				mr: $CurrySoftware$elm_datepicker$DatePicker$off,
				mH: _List_fromArray(
					[
						_Utils_Tuple2('relative-table w-full', !options.ex)
					]),
				mW: $justinmimbs$date$Date$format('E, d MMM y'),
				nH: _List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(options.b_),
						A2($elm$html$Html$Attributes$attribute, 'inputmode', 'none')
					]),
				nJ: _List_fromArray(
					[
						_Utils_Tuple2('input w-full', true),
						_Utils_Tuple2('with-error', viewConfig.no)
					]),
				nK: $elm$core$Maybe$Just(options.w),
				nP: function (_v1) {
					return options.b_;
				},
				pa: viewConfig.aw.fL('dates.select')
			});
	});
var $CurrySoftware$elm_datepicker$DatePicker$Disabled = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$EmptyString = {$: 1};
var $CurrySoftware$elm_datepicker$DatePicker$FailedInput = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$Invalid = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$None = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$Picked = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var forceOpen = model.b0;
		var focused = model.aH;
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aH: $elm$core$Maybe$Just(date),
							p4: date
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aH: $elm$core$Maybe$Just(date)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aH: $elm$core$Maybe$Nothing, bf: $elm$core$Maybe$Nothing, bH: false}),
					$CurrySoftware$elm_datepicker$DatePicker$Picked(date));
			case 3:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bf: $elm$core$Maybe$Just(text)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 4:
				if (forceOpen) {
					return _Utils_Tuple2(model, $CurrySoftware$elm_datepicker$DatePicker$None);
				} else {
					var dateEvent = function () {
						var _v5 = model.bf;
						if (_v5.$ === 1) {
							return $CurrySoftware$elm_datepicker$DatePicker$FailedInput($CurrySoftware$elm_datepicker$DatePicker$EmptyString);
						} else {
							if (_v5.a === '') {
								return $CurrySoftware$elm_datepicker$DatePicker$FailedInput($CurrySoftware$elm_datepicker$DatePicker$EmptyString);
							} else {
								var rawInput = _v5.a;
								var _v6 = settings.o3(rawInput);
								if (!_v6.$) {
									var date = _v6.a;
									return settings.nP(date) ? $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
										$CurrySoftware$elm_datepicker$DatePicker$Disabled(date)) : $CurrySoftware$elm_datepicker$DatePicker$Picked(date);
								} else {
									var e = _v6.a;
									return $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
										$CurrySoftware$elm_datepicker$DatePicker$Invalid(e));
								}
							}
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aH: function () {
									if (dateEvent.$ === 2) {
										var date = dateEvent.a;
										return $elm$core$Maybe$Just(date);
									} else {
										return model.aH;
									}
								}(),
								bf: function () {
									if (dateEvent.$ === 2) {
										return $elm$core$Maybe$Nothing;
									} else {
										return model.bf;
									}
								}()
							}),
						dateEvent);
				}
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b0: false, bH: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bH: forceOpen}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b0: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b0: false}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
		}
	});
var $author$project$Form$DatePicker$updateDatePicker = F5(
	function (_v0, options, viewConfig, msg, _v1) {
		var usingArrowKeys = _v0.et;
		var model = _v1;
		var openWithArrowKeys = function (newModel) {
			return usingArrowKeys ? A5(
				$author$project$Form$DatePicker$updateDatePicker,
				{et: false},
				options,
				viewConfig,
				$CurrySoftware$elm_datepicker$DatePicker$open,
				newModel) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
		};
		var _v2 = A3(
			$CurrySoftware$elm_datepicker$DatePicker$update,
			A2($author$project$Form$DatePicker$settings, options, viewConfig),
			msg,
			model.cZ);
		if (_v2.b.$ === 2) {
			var newPicker = _v2.a;
			var newDate = _v2.b.a;
			return openWithArrowKeys(
				_Utils_update(
					model,
					{
						cZ: newPicker,
						ck: $elm$core$Maybe$Just(newDate)
					}));
		} else {
			var newPicker = _v2.a;
			return openWithArrowKeys(
				_Utils_update(
					model,
					{cZ: newPicker}));
		}
	});
var $author$project$Form$DatePicker$update = F4(
	function (wrappedOptions, viewConfig, msg, _v0) {
		var options = wrappedOptions;
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var usingArrowKeys = msg.a;
				var subMsg = msg.b;
				return A5($author$project$Form$DatePicker$updateDatePicker, usingArrowKeys, wrappedOptions, viewConfig, subMsg, model);
			case 2:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						function (_v2) {
							return $author$project$Form$DatePicker$NoOp;
						},
						$elm$browser$Browser$Dom$focus(options.w)));
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ck: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			default:
				var key = msg.a;
				var pickOrOpen = function () {
					if ($CurrySoftware$elm_datepicker$DatePicker$isOpen(model.cZ)) {
						var _v5 = model.ck;
						if (_v5.$ === 1) {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						} else {
							var selectedDate = _v5.a;
							return A5(
								$author$project$Form$DatePicker$updateDatePicker,
								{et: false},
								wrappedOptions,
								viewConfig,
								$CurrySoftware$elm_datepicker$DatePicker$pick(selectedDate),
								model);
						}
					} else {
						return A5(
							$author$project$Form$DatePicker$updateDatePicker,
							{et: false},
							wrappedOptions,
							viewConfig,
							$CurrySoftware$elm_datepicker$DatePicker$open,
							model);
					}
				}();
				var addDays = function (amount) {
					var _v4 = model.ck;
					if (_v4.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var selectedDate = _v4.a;
						return A5(
							$author$project$Form$DatePicker$updateDatePicker,
							{et: true},
							wrappedOptions,
							viewConfig,
							$CurrySoftware$elm_datepicker$DatePicker$pick(
								A3($justinmimbs$date$Date$add, 3, amount, selectedDate)),
							model);
					}
				};
				switch (key) {
					case 2:
						return pickOrOpen;
					case 1:
						return pickOrOpen;
					case 3:
						return addDays(-7);
					case 4:
						return addDays(7);
					case 5:
						return addDays(-1);
					case 6:
						return addDays(1);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Form$File$GotImageCropperMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Form$File$LoadedFileType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$File$LoadedWithCropped = function (a) {
	return {$: 2, a: a};
};
var $author$project$Form$File$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$File$LoadingWithCropped = function (a) {
	return {$: 3, a: a};
};
var $author$project$Form$File$SetLoadingState = $elm$core$Basics$identity;
var $author$project$Form$File$SingleEntry = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$File$WithError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Form$File$Pdf = 0;
var $author$project$Form$File$fileTypeFromString = function (fileType) {
	if (fileType === 'application/pdf') {
		return $elm$core$Maybe$Just(0);
	} else {
		return A2($elm$core$String$startsWith, 'image/', fileType) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing;
	}
};
var $elm$file$File$mime = _File_mime;
var $author$project$Form$File$entryFromFile = F2(
	function (_v0, file) {
		var aspectRatio = _v0.mj;
		return A2(
			$elm$core$Maybe$map,
			function (fileType) {
				return {
					aG: $author$project$Form$File$LoadedFileType(fileType),
					X: function () {
						if (aspectRatio.$ === 1) {
							return $author$project$Form$File$WithoutImageCropper;
						} else {
							var validAspectRatio = aspectRatio.a;
							if (!fileType) {
								return $author$project$Form$File$WithoutImageCropper;
							} else {
								return $author$project$Form$File$WithImageCropper(
									$author$project$View$ImageCropper$init(
										{mj: validAspectRatio}));
							}
						}
					}(),
					hn: $author$project$Form$File$Loading(file)
				};
			},
			$author$project$Form$File$fileTypeFromString(
				$elm$file$File$mime(file)));
	});
var $author$project$Form$File$fileTypeFromPdfViewerFileType = function (fileType) {
	if (!fileType) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Form$File$originalUrlFromUrlStatus = function (urlStatus) {
	switch (urlStatus.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var url = urlStatus.a;
			return $elm$core$Maybe$Just(url);
		case 2:
			var original = urlStatus.a.s;
			return $elm$core$Maybe$Just(original);
		case 3:
			var original = urlStatus.a.s;
			return $elm$core$Maybe$Just(original);
		case 4:
			var original = urlStatus.a.s;
			return $elm$core$Maybe$Just(original);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Form$File$imageCropperFromPreviousEntry = function (_v0) {
	var previous = _v0.iH;
	var _new = _v0.it;
	var previousImageCropper = _v0.iI;
	var _v1 = _Utils_Tuple2(
		$author$project$Form$File$originalUrlFromUrlStatus(previous),
		$author$project$Form$File$originalUrlFromUrlStatus(_new));
	if ((!_v1.a.$) && (!_v1.b.$)) {
		var previousUrl = _v1.a.a;
		var newUrl = _v1.b.a;
		return _Utils_eq(previousUrl, newUrl) ? previousImageCropper : $author$project$Form$File$WithoutImageCropper;
	} else {
		return $author$project$Form$File$WithoutImageCropper;
	}
};
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var _v0 = A2($elm$core$List$drop, index, l);
			if (!_v0.b) {
				return l;
			} else {
				var rest = _v0.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, l),
					rest);
			}
		}
	});
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$View$ImageCropper$CompletedCropping = $elm$core$Basics$identity;
var $author$project$View$ImageCropper$GotImageDimmensions = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$ImageCropper$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$ImageCropper$StartedDragging = {$: 2};
var $author$project$View$ImageCropper$calculateSelectionDimmensions = F2(
	function (model, dimmensions) {
		var calculatedSelectionWidth = dimmensions.M.l1 * dimmensions.a_;
		var calculatedSelectionHeight = calculatedSelectionWidth / model.mj;
		var selectionWidth = (_Utils_cmp(calculatedSelectionHeight, dimmensions.M.gD) > 0) ? (dimmensions.M.gD * model.mj) : calculatedSelectionWidth;
		return {gD: selectionWidth / model.mj, l1: selectionWidth};
	});
var $author$project$View$ImageCropper$entireImageId = 'image-cropper-bg-image';
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$View$ImageCropper$imageContainerId = 'image-cropper-image-container';
var $author$project$View$ImageCropper$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						$author$project$View$ImageCropper$GotImageDimmensions,
						A2(
							$elm$core$Task$andThen,
							function (imageElement) {
								return A2(
									$elm$core$Task$map,
									function (containerElement) {
										return {jy: containerElement, j9: imageElement};
									},
									$elm$browser$Browser$Dom$getElement($author$project$View$ImageCropper$imageContainerId));
							},
							$elm$browser$Browser$Dom$getElement($author$project$View$ImageCropper$entireImageId))),
					$author$project$UpdateResult$init(model));
			case 1:
				if (!msg.a.$) {
					var imageElement = msg.a.a.j9;
					var containerElement = msg.a.a.jy;
					var image = imageElement.jJ;
					var isExistingImage = function () {
						var _v3 = model.ah;
						if (!_v3.$) {
							return false;
						} else {
							var existingDimmensions = _v3.a;
							return _Utils_eq(existingDimmensions.h2.l1, image.l1) && _Utils_eq(existingDimmensions.h2.gD, image.gD);
						}
					}();
					var normalizeFromExisting = function (dimmensions) {
						var _v2 = model.ah;
						if (!_v2.$) {
							return dimmensions;
						} else {
							var existingDimmensions = _v2.a;
							return isExistingImage ? _Utils_update(
								dimmensions,
								{ca: (existingDimmensions.ca + dimmensions.M.bE) - existingDimmensions.M.bE, a_: existingDimmensions.a_, cr: (existingDimmensions.cr + dimmensions.M.bO) - existingDimmensions.M.bO}) : dimmensions;
						}
					};
					var container = containerElement.jJ;
					var maximumWidthPossible = A2($elm$core$Basics$min, container.l1, container.gD * model.mj);
					var center = function (dimmensions) {
						if (isExistingImage) {
							return dimmensions;
						} else {
							var selection = A2($author$project$View$ImageCropper$calculateSelectionDimmensions, model, dimmensions);
							return _Utils_update(
								dimmensions,
								{ca: dimmensions.ca - (selection.l1 / 2), cr: dimmensions.cr - (selection.gD / 2)});
						}
					};
					var newDimmensions = center(
						normalizeFromExisting(
							{
								M: {gD: container.gD, bE: container.l2, bO: container.l3, l1: container.l1},
								h2: {gD: image.gD, bE: image.l2, bO: image.l3, l1: image.l1},
								ca: image.l2 + (image.l1 / 2),
								fh: maximumWidthPossible / container.l1,
								a_: (maximumWidthPossible / image.l1) * 0.75,
								cr: image.l3 + (image.gD / 2)
							}));
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								ah: $author$project$View$ImageCropper$Loaded(newDimmensions),
								e8: function () {
									var _v1 = model.ah;
									if (!_v1.$) {
										return false;
									} else {
										var existingDimmensions = _v1.a;
										return ($elm$core$Basics$abs(existingDimmensions.h2.l1 - newDimmensions.h2.l1) > 50) || ($elm$core$Basics$abs(existingDimmensions.h2.gD - newDimmensions.h2.gD) > 50);
									}
								}()
							}));
				} else {
					var id = msg.a.a;
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Could not get image dimmensions',
						$elm$core$Maybe$Nothing,
						{e$: 'update', fi: 'View.ImageCropper'},
						_List_fromArray(
							[
								{
								ng: $elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'id',
											$elm$json$Json$Encode$string(id))
										])),
								fj: 'Browser.Dom error'
							}
							]),
						$author$project$UpdateResult$init(model));
				}
			case 2:
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('addClassToDocument')),
									_Utils_Tuple2(
									'className',
									$elm$json$Json$Encode$string('cursor-move'))
								])),
						fy: $author$project$View$ImageCropper$StartedDragging,
						fz: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{b8: true})));
			case 3:
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('removeClassFromDocument')),
									_Utils_Tuple2(
									'className',
									$elm$json$Json$Encode$string('cursor-move'))
								])),
						fy: $author$project$View$ImageCropper$StartedDragging,
						fz: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{b8: false, nU: true})));
			case 4:
				var x = msg.a.l2;
				var y = msg.a.l3;
				var _v4 = model.ah;
				if (!_v4.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var dimmensions = _v4.a;
					if (!model.b8) {
						return $author$project$UpdateResult$init(model);
					} else {
						var selection = A2($author$project$View$ImageCropper$calculateSelectionDimmensions, model, dimmensions);
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									ah: $author$project$View$ImageCropper$Loaded(
										_Utils_update(
											dimmensions,
											{ca: x - (selection.l1 / 2), cr: y - (selection.gD / 2)}))
								}));
					}
				}
			case 5:
				var percentageString = msg.a;
				var _v5 = model.ah;
				if (!_v5.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var dimmensions = _v5.a;
					var _v6 = $elm$core$String$toFloat(percentageString);
					if (_v6.$ === 1) {
						return $author$project$UpdateResult$init(model);
					} else {
						var percentageValue = _v6.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									ah: $author$project$View$ImageCropper$Loaded(
										_Utils_update(
											dimmensions,
											{a_: percentageValue})),
									dP: $elm$core$Basics$abs(percentageValue - dimmensions.a_) <= 0.05
								}));
					}
				}
			case 6:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dP: false, nU: true}));
			case 7:
				var operation = msg.a;
				var _v7 = model.ah;
				if (!_v7.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var dimmensions = _v7.a;
					var entireRange = dimmensions.fh - 0.1;
					var delta = 0.1 * entireRange;
					var clampPossibleValues = A2($elm$core$Basics$clamp, 0.1, dimmensions.fh);
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								ah: $author$project$View$ImageCropper$Loaded(
									_Utils_update(
										dimmensions,
										{
											a_: function () {
												if (!operation) {
													return clampPossibleValues(dimmensions.a_ - delta);
												} else {
													return clampPossibleValues(dimmensions.a_ + delta);
												}
											}()
										}))
							}));
				}
			default:
				var file = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					file,
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{nU: false})));
		}
	});
var $author$project$Form$File$LoadedWithCroppedUploaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Form$File$urlStatusFromResult = function (result) {
	if (!result.$) {
		var url = result.a;
		return $author$project$Form$File$Loaded(url);
	} else {
		var err = result.a;
		return $author$project$Form$File$WithError(err);
	}
};
var $author$project$Form$File$updateUrlStatusWithResult = F2(
	function (result, maybePreviousStatus) {
		if (maybePreviousStatus.$ === 1) {
			return $author$project$Form$File$urlStatusFromResult(result);
		} else {
			var previousStatus = maybePreviousStatus.a;
			if (result.$ === 1) {
				var err = result.a;
				return $author$project$Form$File$WithError(err);
			} else {
				var url = result.a;
				switch (previousStatus.$) {
					case 0:
						return $author$project$Form$File$Loaded(url);
					case 1:
						return $author$project$Form$File$Loaded(url);
					case 2:
						var original = previousStatus.a.s;
						var cropped = previousStatus.a.ag;
						return $author$project$Form$File$LoadedWithCroppedUploaded(
							{ag: cropped, dv: url, s: original});
					case 3:
						var original = previousStatus.a.s;
						var cropped = previousStatus.a.ag;
						return $author$project$Form$File$LoadedWithCroppedUploaded(
							{ag: cropped, dv: url, s: original});
					case 4:
						var original = previousStatus.a.s;
						var cropped = previousStatus.a.ag;
						return $author$project$Form$File$LoadedWithCroppedUploaded(
							{ag: cropped, dv: url, s: original});
					default:
						return $author$project$Form$File$Loaded(url);
				}
			}
		}
	});
var $author$project$Form$File$CompletedUploadingFile = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Api$backendUrl = F3(
	function (_v0, paths, queryParams) {
		var endpoints = _v0.jN;
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			endpoints.mh,
			A2($elm$core$List$cons, 'api', paths),
			queryParams);
	});
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$Api$uploadImage = F3(
	function (shared, file, toMsg) {
		return $elm$http$Http$post(
			{
				f6: $elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'file', file)
						])),
				gt: A2(
					$elm$http$Http$expectJson,
					toMsg,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data']),
						$elm$json$Json$Decode$string)),
				hn: A3(
					$author$project$Api$backendUrl,
					shared,
					_List_fromArray(
						['upload']),
					_List_Nil)
			});
	});
var $author$project$Form$File$uploadEntry = F3(
	function (shared, index, entry) {
		var _v0 = entry.hn;
		switch (_v0.$) {
			case 0:
				var file = _v0.a;
				return A3(
					$author$project$Api$uploadImage,
					shared,
					file,
					$author$project$Form$File$CompletedUploadingFile(index));
			case 1:
				return $elm$core$Platform$Cmd$none;
			case 2:
				var cropped = _v0.a.ag;
				return A3(
					$author$project$Api$uploadImage,
					shared,
					cropped,
					$author$project$Form$File$CompletedUploadingFile(index));
			case 3:
				var cropped = _v0.a.ag;
				return A3(
					$author$project$Api$uploadImage,
					shared,
					cropped,
					$author$project$Form$File$CompletedUploadingFile(index));
			case 4:
				return $elm$core$Platform$Cmd$none;
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Form$File$update = F3(
	function (shared, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var files = msg.a;
				var _v2 = model.i;
				if (!_v2.$) {
					var _v3 = A2(
						$elm$core$Maybe$andThen,
						$author$project$Form$File$entryFromFile(
							{mj: model.mj}),
						$elm$core$List$head(files));
					if (!_v3.$) {
						var newEntry = _v3.a;
						return A2(
							$author$project$UpdateResult$addExt,
							true,
							A2(
								$author$project$UpdateResult$addCmd,
								A3($author$project$Form$File$uploadEntry, shared, 0, newEntry),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											i: $author$project$Form$File$SingleEntry(
												$elm$core$Maybe$Just(newEntry)),
											Y: 1
										}))));
					} else {
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Input file is not a valid entry',
							$elm$core$Maybe$Nothing,
							{e$: 'update', fi: 'Form.File'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					}
				} else {
					var entries = _v2.a;
					var newEntries = A2(
						$elm$core$List$filterMap,
						$author$project$Form$File$entryFromFile(
							{mj: model.mj}),
						files);
					var uploadNewEntries = $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, entry) {
									return A3(
										$author$project$Form$File$uploadEntry,
										shared,
										index + $elm$core$List$length(entries),
										entry);
								}),
							newEntries));
					return A2(
						$author$project$UpdateResult$addExt,
						true,
						A2(
							$author$project$UpdateResult$addCmd,
							uploadNewEntries,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										i: $author$project$Form$File$MultipleEntries(
											_Utils_ap(entries, newEntries)),
										Y: model.Y + $elm$core$List$length(newEntries)
									}))));
				}
			case 1:
				var file = msg.a;
				var _v4 = A2(
					$author$project$Form$File$entryFromFile,
					{mj: model.mj},
					file);
				if (!_v4.$) {
					var newEntry = _v4.a;
					var _v5 = function () {
						var _v6 = model.i;
						if (!_v6.$) {
							return _Utils_Tuple3(
								$author$project$Form$File$SingleEntry(
									$elm$core$Maybe$Just(newEntry)),
								A3($author$project$Form$File$uploadEntry, shared, 0, newEntry),
								true);
						} else {
							var entries = _v6.a;
							var _v7 = model.r;
							if (!_v7.$) {
								var index = _v7.a;
								return _Utils_Tuple3(
									$author$project$Form$File$MultipleEntries(
										A3($elm_community$list_extra$List$Extra$setAt, index, newEntry, entries)),
									A3($author$project$Form$File$uploadEntry, shared, index, newEntry),
									true);
							} else {
								return _Utils_Tuple3(model.i, $elm$core$Platform$Cmd$none, false);
							}
						}
					}();
					var newEntries = _v5.a;
					var uploadEntryCmd = _v5.b;
					var succeeded = _v5.c;
					var addMaybeExtMsg = succeeded ? $author$project$UpdateResult$addExt(true) : $elm$core$Basics$identity;
					return addMaybeExtMsg(
						A2(
							$author$project$UpdateResult$addCmd,
							uploadEntryCmd,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										i: newEntries,
										Y: succeeded ? (model.Y + 1) : model.Y
									}))));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Input file is not a valid entry to replace',
						$elm$core$Maybe$Nothing,
						{e$: 'update', fi: 'Form.File'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 2:
				var index = msg.a;
				var result = msg.b;
				var maybeSetLoadingStateAsFalse = (model.Y === 1) ? $author$project$UpdateResult$addExt(false) : $elm$core$Basics$identity;
				return maybeSetLoadingStateAsFalse(
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								i: function () {
									var _v8 = model.i;
									if (!_v8.$) {
										var previousEntry = _v8.a;
										var newUrlStatus = A2(
											$author$project$Form$File$updateUrlStatusWithResult,
											result,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.hn;
												},
												previousEntry));
										return $author$project$Form$File$SingleEntry(
											$elm$core$Maybe$Just(
												{
													aG: $author$project$Form$File$LoadingFileType,
													X: function () {
														if (previousEntry.$ === 1) {
															return $author$project$Form$File$WithoutImageCropper;
														} else {
															var previous = previousEntry.a;
															return $author$project$Form$File$imageCropperFromPreviousEntry(
																{it: newUrlStatus, iH: previous.hn, iI: previous.X});
														}
													}(),
													hn: newUrlStatus
												}));
									} else {
										var entries = _v8.a;
										return $author$project$Form$File$MultipleEntries(
											A3(
												$elm_community$list_extra$List$Extra$updateAt,
												index,
												function (previousEntry) {
													var newUrlStatus = A2(
														$author$project$Form$File$updateUrlStatusWithResult,
														result,
														$elm$core$Maybe$Just(previousEntry.hn));
													return {
														aG: $author$project$Form$File$LoadingFileType,
														X: $author$project$Form$File$imageCropperFromPreviousEntry(
															{it: newUrlStatus, iH: previousEntry.hn, iI: previousEntry.X}),
														hn: newUrlStatus
													};
												},
												entries));
									}
								}(),
								aj: false,
								Y: model.Y - 1,
								r: function () {
									var _v10 = model.i;
									if (!_v10.$) {
										return model.aj ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(0);
									} else {
										return model.r;
									}
								}()
							})));
			case 3:
				var index = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							r: $elm$core$Maybe$Just(index)
						}));
			case 4:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{r: $elm$core$Maybe$Nothing}));
			case 5:
				var subMsg = msg.a;
				var setEntryFile = F2(
					function (file, entry) {
						return _Utils_update(
							entry,
							{
								hn: function () {
									var _v20 = entry.hn;
									switch (_v20.$) {
										case 1:
											var original = _v20.a;
											return $author$project$Form$File$LoadedWithCropped(
												{ag: file, s: original});
										case 2:
											var original = _v20.a.s;
											return $author$project$Form$File$LoadedWithCropped(
												{ag: file, s: original});
										case 3:
											var original = _v20.a.s;
											return $author$project$Form$File$LoadingWithCropped(
												{ag: file, s: original});
										case 4:
											var original = _v20.a.s;
											return $author$project$Form$File$LoadedWithCropped(
												{ag: file, s: original});
										case 5:
											var err = _v20.a;
											return $author$project$Form$File$WithError(err);
										default:
											var loading = _v20.a;
											return $author$project$Form$File$Loading(loading);
									}
								}()
							});
					});
				var handleExt = F3(
					function (getEntry, updateEntryInModel, _v19) {
						var newFile = _v19;
						return $author$project$UpdateResult$mapModel(
							function (m) {
								var _v18 = getEntry(m);
								if (_v18.$ === 1) {
									return m;
								} else {
									var entry = _v18.a;
									return A2(
										updateEntryInModel,
										m,
										A2(setEntryFile, newFile, entry));
								}
							});
					});
				var updateEntry = F2(
					function (getEntry, updateEntryInModel) {
						var _v16 = getEntry(model);
						if (_v16.$ === 1) {
							return $author$project$UpdateResult$init(model);
						} else {
							var entry = _v16.a;
							var _v17 = entry.X;
							if (!_v17.$) {
								return $author$project$UpdateResult$init(model);
							} else {
								var imageCropper = _v17.a;
								return A5(
									$author$project$UpdateResult$fromChild,
									function (newImageCropper) {
										return A2(
											updateEntryInModel,
											model,
											_Utils_update(
												entry,
												{
													X: $author$project$Form$File$WithImageCropper(newImageCropper)
												}));
									},
									$author$project$Form$File$GotImageCropperMsg,
									A2(handleExt, getEntry, updateEntryInModel),
									model,
									A2($author$project$View$ImageCropper$update, subMsg, imageCropper));
							}
						}
					});
				return A2(
					updateEntry,
					function (_v11) {
						var m = _v11;
						var _v12 = m.i;
						if (!_v12.$) {
							var maybeEntry = _v12.a;
							return maybeEntry;
						} else {
							var entries = _v12.a;
							return A2(
								$elm$core$Maybe$andThen,
								function (index) {
									return A2($elm_community$list_extra$List$Extra$getAt, index, entries);
								},
								m.r);
						}
					},
					F2(
						function (_v13, newEntry) {
							var m = _v13;
							var _v14 = m.i;
							if (!_v14.$) {
								return _Utils_update(
									m,
									{
										i: $author$project$Form$File$SingleEntry(
											$elm$core$Maybe$Just(newEntry))
									});
							} else {
								var entries = _v14.a;
								var _v15 = m.r;
								if (_v15.$ === 1) {
									return m;
								} else {
									var index = _v15.a;
									return _Utils_update(
										m,
										{
											i: $author$project$Form$File$MultipleEntries(
												A3($elm_community$list_extra$List$Extra$setAt, index, newEntry, entries))
										});
								}
							}
						}));
			case 6:
				var index = msg.a;
				var fileType = msg.b;
				var updateEntry = function (entry) {
					return _Utils_update(
						entry,
						{
							aG: $author$project$Form$File$LoadedFileType(
								$author$project$Form$File$fileTypeFromPdfViewerFileType(fileType)),
							X: function () {
								var _v23 = $author$project$Form$File$fileTypeFromPdfViewerFileType(fileType);
								if (_v23 === 1) {
									var _v24 = model.mj;
									if (_v24.$ === 1) {
										return $author$project$Form$File$WithoutImageCropper;
									} else {
										var aspectRatio = _v24.a;
										var _v25 = entry.X;
										if (!_v25.$) {
											return $author$project$Form$File$WithImageCropper(
												$author$project$View$ImageCropper$init(
													{mj: aspectRatio}));
										} else {
											var cropper = _v25.a;
											return $author$project$Form$File$WithImageCropper(cropper);
										}
									}
								} else {
									return $author$project$Form$File$WithoutImageCropper;
								}
							}()
						});
				};
				var _v21 = model.i;
				if (!_v21.$) {
					if (_v21.a.$ === 1) {
						var _v22 = _v21.a;
						return $author$project$UpdateResult$init(model);
					} else {
						var entry = _v21.a.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									i: $author$project$Form$File$SingleEntry(
										$elm$core$Maybe$Just(
											updateEntry(entry)))
								}));
					}
				} else {
					var entries = _v21.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								i: $author$project$Form$File$MultipleEntries(
									A3($elm_community$list_extra$List$Extra$updateAt, index, updateEntry, entries))
							}));
				}
			case 7:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							i: function () {
								var _v26 = model.i;
								if (!_v26.$) {
									return $author$project$Form$File$SingleEntry($elm$core$Maybe$Nothing);
								} else {
									var entries = _v26.a;
									var _v27 = model.r;
									if (_v27.$ === 1) {
										return $author$project$Form$File$MultipleEntries(entries);
									} else {
										var index = _v27.a;
										return $author$project$Form$File$MultipleEntries(
											A2($elm_community$list_extra$List$Extra$removeAt, index, entries));
									}
								}
							}(),
							r: $elm$core$Maybe$Nothing
						}));
			default:
				var updateEntry = F2(
					function (index, entry) {
						var fromOriginalAndCropped = function (data) {
							var newEntry = _Utils_update(
								entry,
								{
									hn: $author$project$Form$File$LoadingWithCropped(data)
								});
							return _Utils_Tuple2(
								newEntry,
								A3($author$project$Form$File$uploadEntry, shared, index, newEntry));
						};
						var _v34 = entry.hn;
						switch (_v34.$) {
							case 2:
								var data = _v34.a;
								return fromOriginalAndCropped(data);
							case 3:
								var data = _v34.a;
								return fromOriginalAndCropped(data);
							case 4:
								var original = _v34.a.s;
								var cropped = _v34.a.ag;
								return fromOriginalAndCropped(
									{ag: cropped, s: original});
							case 0:
								return _Utils_Tuple2(entry, $elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple2(entry, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple2(entry, $elm$core$Platform$Cmd$none);
						}
					});
				var _v28 = model.i;
				if (!_v28.$) {
					if (_v28.a.$ === 1) {
						var _v29 = _v28.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{aj: true, r: $elm$core$Maybe$Nothing}));
					} else {
						var entry = _v28.a.a;
						var _v30 = A2(updateEntry, 0, entry);
						var newEntry = _v30.a;
						var cmd = _v30.b;
						return A2(
							$author$project$UpdateResult$addCmd,
							cmd,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										i: $author$project$Form$File$SingleEntry(
											$elm$core$Maybe$Just(newEntry)),
										aj: true,
										r: $elm$core$Maybe$Nothing
									})));
					}
				} else {
					var entries = _v28.a;
					var _v31 = model.r;
					if (_v31.$ === 1) {
						return $author$project$UpdateResult$init(model);
					} else {
						var openImageCropperIndex = _v31.a;
						var _v32 = A2($elm_community$list_extra$List$Extra$getAt, openImageCropperIndex, entries);
						if (_v32.$ === 1) {
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{r: $elm$core$Maybe$Nothing}));
						} else {
							var entry = _v32.a;
							var _v33 = A2(updateEntry, openImageCropperIndex, entry);
							var newEntry = _v33.a;
							var cmd = _v33.b;
							return A2(
								$author$project$UpdateResult$addCmd,
								cmd,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											i: $author$project$Form$File$MultipleEntries(
												A3($elm_community$list_extra$List$Extra$setAt, openImageCropperIndex, newEntry, entries)),
											r: $elm$core$Maybe$Nothing
										})));
						}
					}
				}
		}
	});
var $author$project$Form$RichText$Showing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Markdown$encodeFormatting = function (formatting) {
	switch (formatting.$) {
		case 0:
			return _Utils_Tuple2(
				'bold',
				$elm$json$Json$Encode$bool(true));
		case 1:
			return _Utils_Tuple2(
				'italic',
				$elm$json$Json$Encode$bool(true));
		case 2:
			return _Utils_Tuple2(
				'strike',
				$elm$json$Json$Encode$bool(true));
		case 3:
			return _Utils_Tuple2(
				'underline',
				$elm$json$Json$Encode$bool(true));
		case 4:
			var url = formatting.a;
			return _Utils_Tuple2(
				'link',
				$elm$json$Json$Encode$string(url));
		case 5:
			var level = formatting.a;
			return _Utils_Tuple2(
				'header',
				$elm$json$Json$Encode$int(level));
		case 6:
			return _Utils_Tuple2(
				'list',
				$elm$json$Json$Encode$string('ordered'));
		default:
			return _Utils_Tuple2(
				'list',
				$elm$json$Json$Encode$string('bullet'));
	}
};
var $author$project$Markdown$encodeQuillOp = function (_v0) {
	var quillOp = _v0;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'insert',
				$elm$json$Json$Encode$string(quillOp.aI)),
				_Utils_Tuple2(
				'attributes',
				$elm$json$Json$Encode$object(
					A2($elm$core$List$map, $author$project$Markdown$encodeFormatting, quillOp.y)))
			]));
};
var $author$project$Ports$markdownLink = _Platform_outgoingPort('markdownLink', $elm$core$Basics$identity);
var $author$project$Ports$sendMarkdownLink = function (_v0) {
	var id = _v0.w;
	var label = _v0.n$;
	var url = _v0.hn;
	return $author$project$Ports$markdownLink(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'label',
					$elm$json$Json$Encode$string(label)),
					_Utils_Tuple2(
					'url',
					$elm$json$Json$Encode$string(url))
				])));
};
var $author$project$Ports$setMarkdown = _Platform_outgoingPort('setMarkdown', $elm$core$Basics$identity);
var $author$project$Ports$setMarkdownContent = function (_v0) {
	var id = _v0.w;
	var content = _v0.mJ;
	return $author$project$Ports$setMarkdown(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2('content', content)
				])));
};
var $author$project$Form$RichText$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var link = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: $author$project$Form$RichText$Showing(link)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bj: $author$project$Form$RichText$NotShowing}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var label = msg.a;
				var _v2 = model.bj;
				if (_v2.$ === 1) {
					var link = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bj: $author$project$Form$RichText$Showing(
									_Utils_update(
										link,
										{n$: label}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				var url = msg.a;
				var _v3 = model.bj;
				if (_v3.$ === 1) {
					var link = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bj: $author$project$Form$RichText$Showing(
									_Utils_update(
										link,
										{hn: url}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				var _v4 = model.bj;
				if (_v4.$ === 1) {
					var label = _v4.a.n$;
					var url = _v4.a.hn;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bj: $author$project$Form$RichText$NotShowing}),
						$author$project$Ports$sendMarkdownLink(
							{w: model.w, n$: label, hn: url}));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				var quillOps = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ge: quillOps}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Ports$setMarkdownContent(
						{
							mJ: A2($elm$json$Json$Encode$list, $author$project$Markdown$encodeQuillOp, model.ge),
							w: model.w
						}));
		}
	});
var $author$project$Form$UserPicker$Model = $elm$core$Basics$identity;
var $author$project$Form$UserPicker$Multiple = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$UserPicker$Single = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$UserPicker$BlurredPicker = {$: 5};
var $author$project$Form$UserPicker$NoOp = {$: 0};
var $author$project$Form$UserPicker$SelectedUser = function (a) {
	return {$: 2, a: a};
};
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$isJust = function (maybeThing) {
	if (!maybeThing.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$String$filter = _String_filter;
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$root = function (string) {
	return A2(
		$elm$core$String$filter,
		function (c) {
			return $elm$core$Char$isLower(c) || $elm$core$Char$isDigit(c);
		},
		$elm$core$String$toLower(string));
};
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$searchHelper = F2(
	function (letter, restOfWord) {
		if (!restOfWord.$) {
			var string = restOfWord.a;
			var _v1 = A2(
				$elm$core$String$indexes,
				$elm$core$String$fromChar(letter),
				string);
			if (!_v1.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var found = _v1.a;
				return $elm$core$Maybe$Just(
					A2($elm$core$String$dropLeft, found + 1, string));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$match = F2(
	function (needle, haystack) {
		return $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$isJust(
			A3(
				$elm$core$String$foldl,
				$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$searchHelper,
				$elm$core$Maybe$Just(
					$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$root(haystack)),
				$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$root(needle)));
	});
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$filter = F3(
	function (map, needle, records) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$match(needle),
				map),
			records);
	});
var $author$project$View$Select$PrivateConfig = $elm$core$Basics$identity;
var $author$project$View$Select$Styles$inputId = 'elm-select-input';
var $author$project$View$Select$Config$newConfig = function (requiredConfig) {
	return {jC: $elm$core$Maybe$Nothing, b_: false, jL: '', jM: false, hV: requiredConfig.hV, j6: '', j7: _List_Nil, nI: '', nJ: _List_Nil, kb: '', kc: _List_Nil, nK: $author$project$View$Select$Styles$inputId, kd: _List_Nil, ke: '', kf: _List_Nil, kp: false, nZ: '', n_: $elm$core$Maybe$Nothing, ks: _List_Nil, d$: '', kF: _List_Nil, kG: '', kH: '', kI: _List_Nil, kJ: _List_Nil, oA: 'No results found', oB: '', kL: true, kM: _List_Nil, oF: $elm$core$Maybe$Nothing, kS: $elm$core$Maybe$Nothing, oN: requiredConfig.oN, kT: $elm$core$Maybe$Nothing, kU: $elm$core$Maybe$Nothing, kV: requiredConfig.kV, pm: '', k6: '', k7: _List_Nil, lc: '', ld: _List_Nil, lo: 2000, p3: requiredConfig.p3, lN: $elm$core$Basics$identity, lQ: '', lR: _List_Nil};
};
var $author$project$View$Select$newConfig = function (requiredConfig) {
	return $author$project$View$Select$Config$newConfig(requiredConfig);
};
var $author$project$Icons$accountCircleSolid = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 43 43'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M21.5 0C33.378 0 43 9.622 43 21.5 43 33.306 33.426 43 21.5 43 9.598 43 0 33.33 0 21.5 0 9.622 9.622 0 21.5 0zm14.853 32.418c2.232-3.071 3.576-6.839 3.576-10.918 0-10.15-8.279-18.429-18.429-18.429-10.15 0-18.429 8.279-18.429 18.429 0 4.08 1.344 7.847 3.576 10.918.864-4.295 2.951-7.847 7.342-7.847 1.944 1.896 4.584 3.072 7.511 3.072 2.927 0 5.567-1.176 7.51-3.072 4.392 0 6.48 3.552 7.343 7.847zm-5.639-15.525c0 5.087-4.127 9.214-9.214 9.214-5.087 0-9.214-4.127-9.214-9.214 0-5.087 4.127-9.214 9.214-9.214 5.087 0 9.214 4.127 9.214 9.214z')
					]),
				_List_Nil)
			]));
};
var $author$project$Avatar$view = F2(
	function (_v0, cls) {
		var maybeUrl = _v0;
		if (maybeUrl.$ === 1) {
			return $author$project$Icons$accountCircleSolid(cls);
		} else {
			var url = maybeUrl.a;
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(url)) ? $author$project$Icons$accountCircleSolid(cls) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(cls)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('object-cover rounded-full ' + cls),
								$elm$html$Html$Attributes$src(url),
								$elm$html$Html$Attributes$alt('')
							]),
						_List_Nil)
					]));
		}
	});
var $author$project$Form$UserPicker$viewUserItem = function (_v0) {
	var avatar = _v0.dl;
	var name = _v0.fj;
	var account = _v0.l8;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-row items-center z-30 pt-4 pb-2 px-4')
			]),
		_List_fromArray(
			[
				A2($author$project$Avatar$view, avatar, 'h-10 w-10 mr-4'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col border-dotted border-b border-gray-500 pb-1 w-full text-white text-left')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-bold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '', name))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-light')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Eos$Account$nameToString(account))
							]))
					]))
			]));
};
var $author$project$View$Select$unwrapConfig = function (config) {
	var c = config;
	return c;
};
var $author$project$View$Select$mapConfig = F2(
	function (fn, config) {
		var config_ = $author$project$View$Select$unwrapConfig(config);
		return fn(config_);
	});
var $author$project$View$Select$withDisabled = F2(
	function (isDisabled, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{b_: isDisabled});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withEmptyMenuClass = F2(
	function (classes, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{
					jL: A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[c.jL, classes]))
				});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withInputClass = F2(
	function (classes, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{nI: classes});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withInputClassList = F2(
	function (classes, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{nJ: classes});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withItemClass = F2(
	function (classes, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{nZ: classes});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withItemHtml = F2(
	function (html, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{
					n_: $elm$core$Maybe$Just(html)
				});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withMenuClass = F2(
	function (classes, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{
					d$: A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[c.d$, classes]))
				});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withNotFound = F2(
	function (text, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{oA: text});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withNotFoundClass = F2(
	function (_class, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{oB: _class});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withOnBlur = F2(
	function (msg, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{
					oF: $elm$core$Maybe$Just(msg)
				});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withPrompt = F2(
	function (prompt, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{pm: prompt});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$Form$UserPicker$settings = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		var toLabel = function (p) {
			return $author$project$Eos$Account$nameToString(p.l8);
		};
		var minQueryLength = 2;
		var _v1 = viewConfig.aw;
		var t = _v1.fL;
		return A2(
			$author$project$View$Select$withOnBlur,
			$author$project$Form$UserPicker$BlurredPicker,
			A2(
				$author$project$View$Select$withEmptyMenuClass,
				'bg-indigo-500 px-4 py-1',
				A2(
					$author$project$View$Select$withMenuClass,
					'flex flex-col w-full border-t-none border-solid border-gray-100 border rounded-sm z-30 bg-white max-h-80 overflow-auto ' + options.d$,
					A2(
						$author$project$View$Select$withNotFoundClass,
						'text-red border-solid border-gray-100 border rounded !bg-white px-8 max-w-max',
						A2(
							$author$project$View$Select$withNotFound,
							t('community.actions.form.verifier_not_found'),
							A2(
								$author$project$View$Select$withItemHtml,
								$author$project$Form$UserPicker$viewUserItem,
								A2(
									$author$project$View$Select$withPrompt,
									t('community.actions.form.verifier_placeholder'),
									A2(
										$author$project$View$Select$withItemClass,
										'bg-indigo-500 hover:bg-opacity-80 focus:bg-opacity-80 active:bg-opacity-90',
										A2(
											$author$project$View$Select$withDisabled,
											options.b_,
											A2(
												$author$project$View$Select$withInputClassList,
												_List_fromArray(
													[
														_Utils_Tuple2('with-error', viewConfig.no)
													]),
												A2(
													$author$project$View$Select$withInputClass,
													'w-full input',
													$author$project$View$Select$newConfig(
														{
															hV: F2(
																function (query, items) {
																	if (_Utils_cmp(
																		$elm$core$String$length(query),
																		minQueryLength) < 0) {
																		return $elm$core$Maybe$Nothing;
																	} else {
																		var nameItems = A3(
																			$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$filter,
																			function (profile) {
																				return A2($elm$core$Maybe$withDefault, '', profile.fj);
																			},
																			query,
																			items);
																		var accountItems = A3($NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$filter, toLabel, query, items);
																		return $elm$core$Maybe$Just(
																			$elm_community$list_extra$List$Extra$unique(
																				_Utils_ap(accountItems, nameItems)));
																	}
																}),
															oN: $author$project$Form$UserPicker$NoOp,
															kV: $author$project$Form$UserPicker$SelectedUser,
															p3: toLabel
														}))))))))))));
	});
var $author$project$Profile$Summary$update = F2(
	function (msg, model) {
		switch (msg) {
			case 0:
				return model;
			case 1:
				return _Utils_update(
					model,
					{dS: true});
			default:
				return _Utils_update(
					model,
					{dS: false});
		}
	});
var $author$project$View$Select$unwrapModel = function (model) {
	var m = model;
	return m;
};
var $author$project$View$Select$unwrapMsg = function (msg) {
	var m = msg;
	return m;
};
var $author$project$View$Select$Update$focusItem = F2(
	function (_v0, onFocusItem) {
		var inputId = _v0.nK;
		var itemIndex = _v0.gK;
		return A2(
			$elm$core$Task$attempt,
			function (_v1) {
				return onFocusItem;
			},
			$elm$browser$Browser$Dom$focus(
				inputId + ('-menu-item-' + $elm$core$String$fromInt(itemIndex))));
	});
var $author$project$View$Select$Update$update = F3(
	function (config, msg, model) {
		var queryChangeCmd = function (value) {
			var _v13 = config.kT;
			if (_v13.$ === 1) {
				return $elm$core$Platform$Cmd$none;
			} else {
				var constructor = _v13.a;
				return A2(
					$elm$core$Task$perform,
					constructor,
					$elm$core$Task$succeed(value));
			}
		};
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pH: false}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var newHightlightedItem = function () {
					var _v1 = model.nt;
					if (_v1.$ === 1) {
						return 0;
					} else {
						var n = _v1.a;
						return n + 1;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							nt: $elm$core$Maybe$Just(newHightlightedItem)
						}),
					A2(
						$author$project$View$Select$Update$focusItem,
						{nK: config.nK, gK: newHightlightedItem},
						config.oN));
			case 6:
				var newHightlightedItem = function () {
					var _v4 = model.nt;
					if (_v4.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						if (!_v4.a) {
							return $elm$core$Maybe$Nothing;
						} else {
							var n = _v4.a;
							return $elm$core$Maybe$Just(n - 1);
						}
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nt: newHightlightedItem}),
					function () {
						if (newHightlightedItem.$ === 1) {
							return A2(
								$elm$core$Task$attempt,
								function (_v3) {
									return A2($elm$core$Maybe$withDefault, config.oN, config.kS);
								},
								$elm$browser$Browser$Dom$focus(config.nK));
						} else {
							var highlightedItem = newHightlightedItem.a;
							return A2(
								$author$project$View$Select$Update$focusItem,
								{nK: config.nK, gK: highlightedItem},
								config.oN);
						}
					}());
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							nt: $elm$core$Maybe$Just(0)
						}),
					A2(
						$author$project$View$Select$Update$focusItem,
						{nK: config.nK, gK: 0},
						config.oN));
			case 1:
				var cmd = function () {
					var _v5 = config.kS;
					if (_v5.$ === 1) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var focusMessage = _v5.a;
						return A2(
							$elm$core$Task$perform,
							function (_v6) {
								return focusMessage;
							},
							$elm$core$Task$succeed($elm$core$Maybe$Nothing));
					}
				}();
				return config.jM ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ed: $elm$core$Maybe$Just(''),
							pH: true
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								queryChangeCmd('')
							]))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{pH: true}),
					cmd);
			case 2:
				var cmd = function () {
					var _v7 = config.oF;
					if (_v7.$ === 1) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var blurMessage = _v7.a;
						return A2(
							$elm$core$Task$perform,
							function (_v8) {
								return blurMessage;
							},
							$elm$core$Task$succeed($elm$core$Maybe$Nothing));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pH: false}),
					cmd);
			case 3:
				var item = msg.a;
				var cmd = function () {
					var _v9 = config.kU;
					if (!_v9.$) {
						var onRemoveItem = _v9.a;
						return A2(
							$elm$core$Task$perform,
							onRemoveItem,
							$elm$core$Task$succeed(item));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(model, cmd);
			case 8:
				var value = msg.a;
				var newQuery = config.lN(value);
				var cmd = function () {
					if (newQuery === '') {
						return $elm$core$Platform$Cmd$none;
					} else {
						return queryChangeCmd(newQuery);
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							nt: $elm$core$Maybe$Nothing,
							ed: $elm$core$Maybe$Just(value)
						}),
					cmd);
			default:
				var item = msg.a;
				var cmd = A2(
					$elm$core$Task$perform,
					config.kV,
					$elm$core$Task$succeed(item));
				var blurCmd = function () {
					var _v11 = config.oF;
					if (_v11.$ === 1) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var blurMessage = _v11.a;
						return A2(
							$elm$core$Task$perform,
							function (_v12) {
								return blurMessage;
							},
							$elm$core$Task$succeed($elm$core$Maybe$Nothing));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ed: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd, blurCmd])));
		}
	});
var $author$project$View$Select$update = F3(
	function (config, msg, model) {
		var msg_ = $author$project$View$Select$unwrapMsg(msg);
		var model_ = $author$project$View$Select$unwrapModel(model);
		var config_ = $author$project$View$Select$unwrapConfig(config);
		var _v0 = A3($author$project$View$Select$Update$update, config_, msg_, model_);
		var mdl = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(mdl, cmd);
	});
var $author$project$Form$UserPicker$update = F4(
	function (options, viewConfig, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
			case 1:
				var subMsg = msg.a;
				var _v2 = A3(
					$author$project$View$Select$update,
					A2($author$project$Form$UserPicker$settings, options, viewConfig),
					subMsg,
					model.G);
				var newState = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{G: newState}),
					cmd,
					$elm$core$Maybe$Nothing);
			case 2:
				var profile = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							H: function () {
								var _v3 = model.H;
								if (!_v3.$) {
									return $author$project$Form$UserPicker$Single(
										$elm$core$Maybe$Just(
											{
												pl: profile,
												bu: $author$project$Profile$Summary$init(false)
											}));
								} else {
									var profiles = _v3.a;
									return $author$project$Form$UserPicker$Multiple(
										A2(
											$elm$core$List$cons,
											{
												pl: profile,
												bu: $author$project$Profile$Summary$init(false)
											},
											profiles));
								}
							}()
						}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 3:
				var targetProfile = msg.a;
				var subMsg = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							H: function () {
								var _v4 = model.H;
								if (!_v4.$) {
									if (_v4.a.$ === 1) {
										var _v5 = _v4.a;
										return $author$project$Form$UserPicker$Single($elm$core$Maybe$Nothing);
									} else {
										var profile = _v4.a.a;
										return $author$project$Form$UserPicker$Single(
											$elm$core$Maybe$Just(
												_Utils_update(
													profile,
													{
														bu: A2($author$project$Profile$Summary$update, subMsg, profile.bu)
													})));
									}
								} else {
									var profiles = _v4.a;
									return $author$project$Form$UserPicker$Multiple(
										A3(
											$elm_community$list_extra$List$Extra$updateIf,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.pl;
												},
												$elm$core$Basics$eq(targetProfile)),
											function (profile) {
												return _Utils_update(
													profile,
													{
														bu: A2($author$project$Profile$Summary$update, subMsg, profile.bu)
													});
											},
											profiles));
								}
							}()
						}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 4:
				var profileToRemove = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							H: function () {
								var _v6 = model.H;
								if (!_v6.$) {
									return $author$project$Form$UserPicker$Single($elm$core$Maybe$Nothing);
								} else {
									var profiles = _v6.a;
									return $author$project$Form$UserPicker$Multiple(
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.pl;
												},
												$elm$core$Basics$neq(profileToRemove)),
											profiles));
								}
							}()
						}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			default:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just(viewConfig.oF));
		}
	});
var $author$project$Form$update = F3(
	function (shared, msg, _v0) {
		var model = _v0;
		var _v1 = model.aT;
		var errorTracking = _v1;
		var removeFieldError = function (fieldId) {
			return _Utils_update(
				errorTracking,
				{
					cn: A2($elm$core$Set$remove, fieldId, errorTracking.cn)
				});
		};
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var fieldId = msg.a.ai;
				var newValues = msg.b;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							aT: removeFieldError(fieldId),
							o: newValues
						}));
			case 2:
				var getModel = msg.a;
				var updateFn = msg.b;
				var subMsg = msg.c;
				var _v3 = A2(
					$author$project$Form$RichText$update,
					subMsg,
					getModel(model.o));
				var newModel = _v3.a;
				var cmd = _v3.b;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Platform$Cmd$map,
						A2($author$project$Form$GotRichTextMsg, getModel, updateFn),
						cmd),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								aT: removeFieldError(
									$author$project$Form$RichText$getId(newModel)),
								o: A2(updateFn, newModel, model.o)
							})));
			case 3:
				var fieldId = msg.a.ai;
				var getModel = msg.b;
				var updateFn = msg.c;
				var subMsg = msg.d;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newFile) {
						return _Utils_update(
							model,
							{
								o: A2(updateFn, newFile, model.o)
							});
					},
					A3(
						$author$project$Form$GotFileMsg,
						{ai: fieldId},
						getModel,
						updateFn),
					function (_v4) {
						var isLoading = _v4;
						return $author$project$UpdateResult$mapModel(
							function (_v5) {
								var m = _v5;
								var insertOrRemove = isLoading ? $elm$core$Set$insert : $elm$core$Set$remove;
								return _Utils_update(
									m,
									{
										gP: A2(insertOrRemove, fieldId, m.gP)
									});
							});
					},
					model,
					A3(
						$author$project$Form$File$update,
						shared,
						subMsg,
						getModel(model.o)));
			case 4:
				var options = msg.a;
				var viewConfig = msg.b;
				var getModel = msg.c;
				var updateFn = msg.d;
				var subMsg = msg.e;
				var _v6 = A4(
					$author$project$Form$DatePicker$update,
					options,
					viewConfig,
					subMsg,
					getModel(model.o));
				var newModel = _v6.a;
				var cmd = _v6.b;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Platform$Cmd$map,
						A4($author$project$Form$GotDatePickerMsg, options, viewConfig, getModel, updateFn),
						cmd),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								o: A2(updateFn, newModel, model.o)
							})));
			case 5:
				var options = msg.a;
				var viewConfig = msg.b;
				var getModel = msg.c;
				var updateFn = msg.d;
				var subMsg = msg.e;
				var maybeAddMsg = function (maybeMsg) {
					if (maybeMsg.$ === 1) {
						return $elm$core$Basics$identity;
					} else {
						var externalMsg = maybeMsg.a;
						return $author$project$UpdateResult$addMsg(externalMsg);
					}
				};
				var _v7 = A4(
					$author$project$Form$UserPicker$update,
					options,
					viewConfig,
					subMsg,
					getModel(model.o));
				var newModel = _v7.a;
				var cmd = _v7.b;
				var maybeExternalMsg = _v7.c;
				return A2(
					maybeAddMsg,
					maybeExternalMsg,
					A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$elm$core$Platform$Cmd$map,
							A4($author$project$Form$GotUserPickerMsg, options, viewConfig, getModel, updateFn),
							cmd),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									o: A2(updateFn, newModel, model.o)
								}))));
			case 6:
				var fieldInfo = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							aT: _Utils_update(
								errorTracking,
								{
									cn: fieldInfo.h8 ? A2($elm$core$Set$insert, fieldInfo.ai, errorTracking.cn) : A2($elm$core$Set$remove, fieldInfo.ai, errorTracking.cn)
								})
						}));
			default:
				var _v9 = msg.a;
				var firstError = _v9.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v10) {
							return $author$project$Form$NoOp;
						},
						$elm$browser$Browser$Dom$focus(firstError)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								aT: _Utils_update(
									errorTracking,
									{fD: true})
							})));
		}
	});
var $author$project$Auth$withPrivateKey = F4(
	function (model, _v0, config, successfulUR) {
		var requiredPermissions = _v0.pv;
		var currentPermissions = _v0.mU;
		var actWithPrivateKey = function () {
			var _v2 = model.pN;
			if (!_v2.$) {
				return config.oE(
					$author$project$UpdateResult$init(config.mZ));
			} else {
				var privateKey = _v2.a;
				return successfulUR(privateKey);
			}
		}();
		if ($elm$core$List$isEmpty(requiredPermissions)) {
			return actWithPrivateKey;
		} else {
			if (currentPermissions.$ === 1) {
				return config.oC(
					$author$project$UpdateResult$init(config.mZ));
			} else {
				var permissions = currentPermissions.a;
				return A2(
					$elm$core$List$all,
					function (permission) {
						return A2($elm$core$List$member, permission, permissions);
					},
					requiredPermissions) ? actWithPrivateKey : config.oO(
					$author$project$UpdateResult$init(config.mZ));
			}
		}
	});
var $author$project$Action$updateClaimingAction = F5(
	function (msg, action, proof, _v0, loggedIn) {
		var position = _v0.bq;
		var status = {dh: action, bq: position, aY: proof};
		var withPrivateKey = F2(
			function (requiredPermissions, ur) {
				return A4(
					$author$project$Auth$withPrivateKey,
					loggedIn.ml,
					{
						mU: A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.pz;
								},
								$elm$core$List$concatMap(
									function ($) {
										return $.o6;
									})),
							$krisajenkins$remotedata$RemoteData$toMaybe(loggedIn.pl)),
						pv: requiredPermissions
					},
					{
						mZ: $author$project$Action$Claiming(status),
						oC: A5(
							$author$project$UpdateResult$logImpossible,
							$author$project$Action$GotClaimingActionMsg(msg),
							'Tried signing eos transaction, but profile wasn\'t loaded',
							$elm$core$Maybe$Just(loggedIn._),
							{e$: 'updateClaimingAction', fi: 'Action'},
							_List_Nil),
						oE: $author$project$UpdateResult$addExt(
							$author$project$Action$RequiredPrivateKey(
								$author$project$Action$GotClaimingActionMsg(msg))),
						oO: $author$project$UpdateResult$addExt($author$project$Action$ShowInsufficientPermissionsModal)
					},
					function (_v6) {
						return ur;
					});
			});
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Action$SetUpdateTimeEvery(60 * 1000),
					$author$project$UpdateResult$init($author$project$Action$NotClaiming));
			case 1:
				return A2(
					withPrivateKey,
					_List_fromArray(
						[1]),
					A2(
						$author$project$UpdateResult$addPort,
						{
							bZ: $author$project$Eos$encodeTransaction(
								_List_fromArray(
									[
										{
										_: loggedIn.A.hL.V,
										hw: {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission},
										bZ: $author$project$Action$encodeClaimAction(
											{f_: action.w, gb: loggedIn._, gd: action.ad.V.as, aY: $elm$core$Maybe$Nothing}),
										fj: 'claimaction'
									}
									])),
							fy: $author$project$Action$GotClaimingActionMsg(msg),
							fz: $elm$json$Json$Encode$null
						},
						$author$project$UpdateResult$init(
							$author$project$Action$Claiming(status))));
			case 2:
				var photoProofUrl = msg.a.k_;
				var proofCode = msg.a.g3;
				var claimPort = function (maybeProofCode) {
					return {
						bZ: $author$project$Eos$encodeTransaction(
							_List_fromArray(
								[
									{
									_: loggedIn.A.hL.V,
									hw: {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission},
									bZ: $author$project$Action$encodeClaimAction(
										{
											f_: action.w,
											gb: loggedIn._,
											gd: action.ad.V.as,
											aY: $elm$core$Maybe$Just(
												{kZ: photoProofUrl, g3: maybeProofCode})
										}),
									fj: 'claimaction'
								}
								])),
						fy: $author$project$Action$GotClaimingActionMsg(msg),
						fz: $elm$json$Json$Encode$null
					};
				};
				if (proofCode.$ === 1) {
					return action.dI ? A6(
						$author$project$UpdateResult$logImpossible,
						$author$project$Action$GotClaimingActionMsg(msg),
						'Claimed action that requires proof code, but no proof code was provided',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'updateClaimingAction', fi: 'Action'},
						_List_Nil,
						$author$project$UpdateResult$init(
							$author$project$Action$Claiming(status))) : A2(
						withPrivateKey,
						_List_fromArray(
							[1]),
						A2(
							$author$project$UpdateResult$addPort,
							claimPort($elm$core$Maybe$Nothing),
							$author$project$UpdateResult$init(
								$author$project$Action$Claiming(status))));
				} else {
					var code = proofCode.a;
					return A2(
						withPrivateKey,
						_List_fromArray(
							[1]),
						A2(
							$author$project$UpdateResult$addPort,
							claimPort(
								$elm$core$Maybe$Just(
									{ds: code.ds, lD: code.h_})),
							$author$project$UpdateResult$init(
								$author$project$Action$Claiming(status))));
				}
			case 3:
				var subMsg = msg.a;
				if (!proof.$) {
					return $author$project$UpdateResult$init(
						$author$project$Action$Claiming(status));
				} else {
					var photoProofForm = proof.a;
					var proofCodeStatus = proof.b;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newForm) {
							return $author$project$Action$Claiming(
								_Utils_update(
									status,
									{
										aY: A2($author$project$Action$WithProof, newForm, proofCodeStatus)
									}));
						},
						A2($elm$core$Basics$composeL, $author$project$Action$GotClaimingActionMsg, $author$project$Action$GotPhotoProofFormMsg),
						function (ext) {
							return $author$project$UpdateResult$addExt(
								$author$project$Action$ShowFeedback(ext));
						},
						$author$project$Action$Claiming(status),
						A3($author$project$Form$update, loggedIn.A, subMsg, photoProofForm));
				}
			case 4:
				var uint64Name = msg.a;
				if (!proof.$) {
					return $author$project$UpdateResult$init(
						$author$project$Action$Claiming(status));
				} else {
					var formModel = proof.a;
					var proofCode = A3($author$project$Action$generateProofCode, action, uint64Name, loggedIn.A.ce);
					var expiration = A4($justinmimbs$time_extra$Time$Extra$add, 13, 30, loggedIn.A.i2, loggedIn.A.ce);
					var proofCodeStatus = action.dI ? $author$project$Action$WithCode(
						{ds: proofCode, hT: expiration, h_: loggedIn.A.ce}) : $author$project$Action$NoCodeNecessary;
					return $author$project$UpdateResult$init(
						$author$project$Action$Claiming(
							_Utils_update(
								status,
								{
									aY: A2($author$project$Action$WithProof, formModel, proofCodeStatus)
								})));
				}
			default:
				if (!msg.a.$) {
					var _v5 = loggedIn.pC;
					if (_v5.$ === 3) {
						var community = _v5.a;
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$author$project$Route$pushUrl,
								loggedIn.A.kK,
								$author$project$Route$ProfileClaims(
									$author$project$Eos$Account$nameToString(loggedIn._))),
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Action$SetUpdateTimeEvery(60 * 1000),
								A2(
									$author$project$UpdateResult$addExt,
									$author$project$Action$ShowFeedback(
										A2(
											$author$project$View$Feedback$Visible,
											0,
											A2(
												loggedIn.A.aw.i4,
												'dashboard.check_claim.success',
												_List_fromArray(
													[
														_Utils_Tuple2(
														'symbolCode',
														$author$project$Eos$symbolToSymbolCodeString(community.as))
													])))),
									$author$project$UpdateResult$init($author$project$Action$NotClaiming))));
					} else {
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$author$project$Route$pushUrl,
								loggedIn.A.kK,
								$author$project$Route$ProfileClaims(
									$author$project$Eos$Account$nameToString(loggedIn._))),
							A6(
								$author$project$UpdateResult$logImpossible,
								$author$project$Action$GotClaimingActionMsg(msg),
								'Completed claiming action, but community wasn\'t loaded',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'updateClaimingAction', fi: 'Action'},
								_List_Nil,
								A2(
									$author$project$UpdateResult$addExt,
									$author$project$Action$SetUpdateTimeEvery(60 * 1000),
									$author$project$UpdateResult$init($author$project$Action$NotClaiming))));
					}
				} else {
					var val = msg.a.a;
					return A7(
						$author$project$UpdateResult$logJsonValue,
						$author$project$Action$GotClaimingActionMsg(msg),
						$elm$core$Maybe$Just(loggedIn._),
						'Got an error when claiming an action',
						{e$: 'updateClaimingAction', fi: 'Action'},
						_List_Nil,
						val,
						A2(
							$author$project$UpdateResult$addExt,
							$author$project$Action$SetUpdateTimeEvery(60 * 1000),
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Action$ShowFeedback(
									A2(
										$author$project$View$Feedback$Visible,
										1,
										loggedIn.A.aw.fL('dashboard.check_claim.failure'))),
								$author$project$UpdateResult$init($author$project$Action$NotClaiming))));
				}
		}
	});
var $author$project$Action$update = F3(
	function (msg, status, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(status);
			case 2:
				var action = msg.a;
				var sharePort = loggedIn.A.jq ? {
					bZ: $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string('share')),
								_Utils_Tuple2(
								'title',
								$author$project$Markdown$encode(action.aR)),
								_Utils_Tuple2(
								'url',
								$elm$json$Json$Encode$string(
									$elm$url$Url$toString(
										A2(
											$author$project$Route$addRouteToUrl,
											loggedIn.A,
											$author$project$Route$CommunityObjectives(
												$author$project$Route$WithObjectiveSelected(
													{
														dh: $elm$core$Maybe$Just(
															$author$project$Action$idToInt(action.w)),
														w: $author$project$Action$objectiveIdToInt(action.ad.w)
													}))))))
							])),
					fy: msg,
					fz: $elm$json$Json$Encode$null
				} : {
					bZ: $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string('copyToClipboard')),
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(
									$author$project$Action$shareActionFallbackId(action.w)))
							])),
					fy: msg,
					fz: $author$project$Action$encodeId(action.w)
				};
				return A2(
					$author$project$UpdateResult$addPort,
					sharePort,
					$author$project$UpdateResult$init(status));
			case 3:
				var actionId = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v1) {
							return $author$project$Action$NoOp;
						},
						$elm$browser$Browser$Dom$focus(
							$author$project$Action$shareActionButtonId(actionId))),
					A2(
						$author$project$UpdateResult$addExt,
						$author$project$Action$ShowFeedback(
							A2(
								$author$project$View$Feedback$Visible,
								0,
								loggedIn.A.aw.fL('copied_to_clipboard'))),
						$author$project$UpdateResult$init(status)));
			case 1:
				var position = msg.a.bq;
				var action = msg.b;
				var proofCode = action.dI ? $author$project$Action$GeneratingCode : $author$project$Action$NoCodeNecessary;
				var generateProofCodePort = action.dI ? $author$project$UpdateResult$addPort(
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('accountNameToUint64')),
									_Utils_Tuple2(
									'accountName',
									$author$project$Eos$Account$encodeName(loggedIn._))
								])),
						fy: msg,
						fz: $elm$json$Json$Encode$null
					}) : $elm$core$Basics$identity;
				var form = $author$project$Form$init(
					$author$project$Form$File$initSingle(
						{mj: $elm$core$Maybe$Nothing, ni: $elm$core$Maybe$Nothing}));
				var proof = action.gB ? A2($author$project$Action$WithProof, form, proofCode) : $author$project$Action$NoProofNecessary;
				return generateProofCodePort(
					A2(
						$author$project$UpdateResult$addExt,
						$author$project$Action$SetUpdateTimeEvery(1000),
						$author$project$UpdateResult$init(
							$author$project$Action$Claiming(
								{dh: action, bq: position, aY: proof}))));
			default:
				var subMsg = msg.a;
				if (!status.$) {
					return A5(
						$author$project$UpdateResult$logIncompatibleMsg,
						msg,
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Action'},
						_List_Nil,
						$author$project$UpdateResult$init(status));
				} else {
					var action = status.a.dh;
					var proof = status.a.aY;
					var position = status.a.bq;
					return A5(
						$author$project$Action$updateClaimingAction,
						subMsg,
						action,
						proof,
						{bq: position},
						loggedIn);
				}
		}
	});
var $author$project$Auth$CompletedAuth = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$View$Pin$Pin = 0;
var $author$project$Auth$SetFeedback = function (a) {
	return {$: 2, a: a};
};
var $author$project$Auth$SubmittedPin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Log$UnknownError = 5;
var $author$project$Auth$UpdatedShared = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ports$storePinVisibility = _Platform_outgoingPort('storePinVisibility', $elm$json$Json$Encode$bool);
var $author$project$View$Pin$postSubmitAction = F4(
	function (model, pin, shared, toMsg) {
		return _Utils_Tuple2(
			_Utils_update(
				shared,
				{o9: model.cS}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Task$perform,
						toMsg,
						$elm$core$Task$succeed(pin)),
						$author$project$Ports$storePinVisibility(model.cS)
					])));
	});
var $author$project$View$Pin$GotFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Pin$PinConfirmation = 1;
var $author$project$View$Pin$SendFeedback = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Pin$SubmitPin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$getValue = F2(
	function (getter, _v0) {
		var model = _v0;
		return getter(model.o);
	});
var $author$project$View$Pin$update = F3(
	function (shared, msg, model) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var subMsg = msg.a;
				var hasChangedField = F2(
					function (field, newForm) {
						return !_Utils_eq(
							A2($author$project$Form$getValue, field, model.hY),
							A2($author$project$Form$getValue, field, newForm));
					});
				var clearFieldErrors = F3(
					function (field, fieldAccessor, ur) {
						var newForm = ur.ok.hY;
						return A2(hasChangedField, fieldAccessor, newForm) ? A2(
							$author$project$UpdateResult$mapModel,
							function (m) {
								return _Utils_update(
									m,
									{
										bL: A2(
											$elm$core$List$filter,
											function (_v1) {
												var field_ = _v1.a;
												return !_Utils_eq(field, field_);
											},
											m.bL)
									});
							},
							ur) : ur;
					});
				return A3(
					clearFieldErrors,
					1,
					function ($) {
						return $.dt;
					},
					A3(
						clearFieldErrors,
						0,
						function ($) {
							return $.o8;
						},
						A5(
							$author$project$UpdateResult$fromChild,
							function (newForm) {
								return _Utils_update(
									model,
									{hY: newForm});
							},
							$author$project$View$Pin$GotFormMsg,
							function (feedback) {
								return $author$project$UpdateResult$addExt(
									$author$project$View$Pin$SendFeedback(feedback));
							},
							model,
							A3($author$project$Form$update, shared, subMsg, model.hY))));
			case 2:
				var pin = msg.a.o8;
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$View$Pin$SubmitPin(pin),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								cT: true,
								n2: $elm$core$Maybe$Just(pin),
								bL: _List_Nil
							})));
			default:
				var field = msg.a;
				if (!field) {
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$elm$core$Task$attempt,
							function (_v3) {
								return $author$project$View$Pin$Ignored;
							},
							$elm$browser$Browser$Dom$focus('pin-input')),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{cS: !model.cS})));
				} else {
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$elm$core$Task$attempt,
							function (_v4) {
								return $author$project$View$Pin$Ignored;
							},
							$elm$browser$Browser$Dom$focus('pin-confirmation-input')),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{e7: !model.e7})));
				}
		}
	});
var $author$project$View$Pin$withIsSubmitting = F2(
	function (isSubmitting, model) {
		return _Utils_update(
			model,
			{cT: isSubmitting});
	});
var $author$project$View$Pin$withProblem = F3(
	function (field, problem, model) {
		return _Utils_update(
			model,
			{
				bL: A2(
					$elm$core$List$cons,
					_Utils_Tuple2(field, problem),
					model.bL)
			});
	});
var $author$project$Auth$update = F3(
	function (msg, shared, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (pinModel) {
						return _Utils_update(
							model,
							{ak: pinModel});
					},
					$author$project$Auth$GotPinMsg,
					F2(
						function (ext, ur) {
							if (ext.$ === 1) {
								var feedback = ext.a;
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Auth$SetFeedback(feedback),
									ur);
							} else {
								var pin = ext.a;
								var _v2 = A4($author$project$View$Pin$postSubmitAction, ur.ok.ak, pin, shared, $author$project$Auth$SubmittedPin);
								var newShared = _v2.a;
								var submitCmd = _v2.b;
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Auth$UpdatedShared(newShared),
									A2($author$project$UpdateResult$addCmd, submitCmd, ur));
							}
						}),
					model,
					A3($author$project$View$Pin$update, shared, subMsg, model.ak));
			case 1:
				var pin = msg.a;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('getPrivateKey')),
									_Utils_Tuple2(
									'pin',
									$elm$json$Json$Encode$string(pin))
								])),
						fy: $author$project$Auth$SubmittedPin(pin),
						fz: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								ak: A2($author$project$View$Pin$withDisabled, true, model.ak)
							})));
			default:
				if (!msg.a.$) {
					var _v3 = msg.a.a;
					var accountName = _v3.a;
					var privateKey = _v3.b;
					var newModel = _Utils_update(
						model,
						{
							ak: A2(
								$author$project$View$Pin$withIsSubmitting,
								false,
								A2($author$project$View$Pin$withDisabled, false, model.ak)),
							pN: $author$project$Auth$WithPrivateKey(privateKey)
						});
					return A2(
						$author$project$UpdateResult$addExt,
						A2($author$project$Auth$CompletedAuth, accountName, newModel),
						$author$project$UpdateResult$init(newModel));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$UpdateResult$logEvent,
						{
							mL: _List_fromArray(
								[
									{
									ng: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'errorValue',
												$elm$json$Json$Encode$string(err))
											])),
									fj: 'Error'
								}
								]),
							n4: 1,
							oa: {e$: 'update', fi: 'Auth'},
							of: 'Got an error when submitting PIN',
							pY: _List_fromArray(
								[
									$author$project$Log$TypeTag(5)
								]),
							p7: msg,
							qh: $elm$core$Maybe$Nothing
						},
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									na: $elm$core$Maybe$Nothing,
									ak: A2(
										$author$project$View$Pin$withIsSubmitting,
										false,
										A2(
											$author$project$View$Pin$withDisabled,
											false,
											A3($author$project$View$Pin$withProblem, 0, err, model.ak))),
									pN: $author$project$Auth$WithoutPrivateKey
								})));
				}
		}
	});
var $author$project$Search$GotDebouncerMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Search$GotFormMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Search$NoOp = {$: 0};
var $author$project$Search$QuerySubmitted = {$: 7};
var $author$project$Search$RecentSearchesShowed = {$: 1};
var $author$project$Search$RequestedNewResults = function (a) {
	return {$: 10, a: a};
};
var $author$project$Search$ResultsShowed = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Search$SetFeedback = function (a) {
	return {$: 0, a: a};
};
var $author$project$Search$maximumRecentSearches = 10;
var $Gizra$elm_debouncer$Debouncer$Basic$ProvideInput = function (a) {
	return {$: 0, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Basic$provideInput = $Gizra$elm_debouncer$Debouncer$Basic$ProvideInput;
var $author$project$Search$GotSearchResults = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Search$RequestQuery = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Cambiatus$Query$search = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'search', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$SearchResult$actions = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{ed: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'query', filledInOptionals.ed, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'actions',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Cambiatus$Enum$OrderByFields$toString = function (_enum) {
	switch (_enum) {
		case 0:
			return 'account';
		case 1:
			return 'created_at';
		default:
			return 'name';
	}
};
var $author$project$Cambiatus$Enum$SearchByFields$toString = function (_enum) {
	switch (_enum) {
		case 0:
			return 'account';
		case 1:
			return 'bio';
		case 2:
			return 'email';
		default:
			return 'name';
	}
};
var $author$project$Cambiatus$InputObject$encodeMembersFilterInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'orderDirection',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input.d7,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$Direction$toString))),
				_Utils_Tuple2(
				'orderMembersBy',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input.d8,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$OrderByFields$toString))),
				_Utils_Tuple2(
				'searchMembersBy',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input.eh,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$maybe(
							$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$SearchByFields$toString))))),
				_Utils_Tuple2(
				'searchString',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.ei, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$Cambiatus$Object$SearchResult$members = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{hW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'filters', filledInOptionals.hW, $author$project$Cambiatus$InputObject$encodeMembersFilterInput)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'members',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Cambiatus$Object$SearchResult$products = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{ed: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'query', filledInOptionals.ed, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'products',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Search$searchResultSelectionSet = function (queryString) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$author$project$Cambiatus$Object$SearchResult$members,
			function (_v2) {
				return {
					hW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						{
							d7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
							d8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
							eh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
							ei: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(queryString)
						})
				};
			},
			$author$project$Profile$minimalSelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$author$project$Cambiatus$Object$SearchResult$actions,
				function (_v1) {
					return {
						ed: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(queryString)
					};
				},
				$author$project$Action$selectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$author$project$Cambiatus$Object$SearchResult$products,
					function (_v0) {
						return {
							ed: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(queryString)
						};
					},
					$author$project$Shop$productSelectionSet),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
					F3(
						function (products, actions, members) {
							return {
								mb: actions,
								ih: members,
								bm: A2(
									$elm$core$List$map,
									function (product) {
										return {cE: $elm$core$Maybe$Nothing, c0: $elm$core$Maybe$Nothing, pi: product};
									},
									products)
							};
						})))));
};
var $author$project$Search$sendSearchQuery = function (queryString) {
	return A2(
		$author$project$Search$RequestQuery,
		$author$project$Cambiatus$Query$search(
			$author$project$Search$searchResultSelectionSet(queryString)),
		$author$project$Search$GotSearchResults(
			{jW: queryString}));
};
var $author$project$Ports$storeRecentSearches = _Platform_outgoingPort('storeRecentSearches', $elm$json$Json$Encode$string);
var $author$project$Search$storeRecentSearches = function (recentSearches) {
	return $author$project$Ports$storeRecentSearches(
		A2(
			$elm$json$Json$Encode$encode,
			0,
			A2(
				$elm$json$Json$Encode$list,
				$elm$json$Json$Encode$string,
				A2(
					$elm$core$List$take,
					$author$project$Search$maximumRecentSearches,
					$elm_community$list_extra$List$Extra$unique(recentSearches)))));
};
var $Gizra$elm_debouncer$Debouncer$Internal$Check = function (a) {
	return {$: 4, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Internal$InputProvidedAt = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $Gizra$elm_debouncer$Debouncer$Internal$ManualEmitAt = function (a) {
	return {$: 3, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Process$sleep = _Process_sleep;
var $Gizra$elm_debouncer$Debouncer$Internal$Unsettled = function (a) {
	return {$: 1, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Internal$cancel = function (_v0) {
	var config = _v0.a;
	var state = _v0.b;
	return A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, config, $Gizra$elm_debouncer$Debouncer$Internal$Settled);
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$update = F2(
	function (msg, debouncer) {
		var wrappedConfig = debouncer.a;
		var config = wrappedConfig;
		var state = debouncer.b;
		switch (msg.$) {
			case 0:
				var input = msg.a;
				var time = msg.b;
				var newState = function () {
					if (!state.$) {
						return $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
							{
								dZ: $elm$core$Maybe$Nothing,
								gN: time,
								aX: A2(config.cx, input, $elm$core$Maybe$Nothing),
								hl: time
							});
					} else {
						var unsettled = state.a;
						return $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
							_Utils_update(
								unsettled,
								{
									gN: time,
									aX: A2(config.cx, input, unsettled.aX)
								}));
					}
				}();
				var newDebouncer = A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState);
				var checks = function () {
					if (!state.$) {
						return $elm_community$list_extra$List$Extra$unique(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[config.ba, config.bb, config.br])));
					} else {
						return A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[config.br]));
					}
				}();
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
					A2(
						$elm$core$List$partition,
						function (interval) {
							return interval <= 0;
						},
						checks));
				var checkNow = _v1.a;
				var checkLater = _v1.b;
				var _v2 = checkNow ? A2(
					$Gizra$elm_debouncer$Debouncer$Internal$update,
					$Gizra$elm_debouncer$Debouncer$Internal$Check(time),
					newDebouncer) : _Utils_Tuple3(newDebouncer, _List_Nil, $elm$core$Maybe$Nothing);
				var checkedDebouncer = _v2.a;
				var checkedIntervals = _v2.b;
				var emit = _v2.c;
				return _Utils_Tuple3(
					checkedDebouncer,
					_Utils_ap(checkedIntervals, checkLater),
					emit);
			case 1:
				return _Utils_Tuple3(
					$Gizra$elm_debouncer$Debouncer$Internal$cancel(debouncer),
					_List_Nil,
					$elm$core$Maybe$Nothing);
			case 2:
				var emit = function () {
					if (!state.$) {
						return $elm$core$Maybe$Nothing;
					} else {
						var unsettled = state.a;
						return unsettled.aX;
					}
				}();
				return _Utils_Tuple3(
					$Gizra$elm_debouncer$Debouncer$Internal$cancel(debouncer),
					_List_Nil,
					emit);
			case 3:
				var time = msg.a;
				if (!state.$) {
					return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
				} else {
					var unsettled = state.a;
					var _v7 = unsettled.aX;
					if (!_v7.$) {
						var newState = $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
							_Utils_update(
								unsettled,
								{
									dZ: $elm$core$Maybe$Just(time),
									aX: $elm$core$Maybe$Nothing
								}));
						var intervals = function () {
							var _v8 = config.ba;
							if (!_v8.$) {
								var emit = _v8.a;
								return _List_fromArray(
									[emit]);
							} else {
								return _List_Nil;
							}
						}();
						return _Utils_Tuple3(
							A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState),
							intervals,
							unsettled.aX);
					} else {
						return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
					}
				}
			default:
				var time = msg.a;
				if (!state.$) {
					return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
				} else {
					var unsettled = state.a;
					var shouldSettle = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (interval) {
								return _Utils_cmp(unsettled.gN + interval, time) < 1;
							},
							config.br));
					var becauseEmitWhileUnsettled = function () {
						var _v13 = config.bb;
						if (!_v13.$) {
							var interval = _v13.a;
							var _v14 = unsettled.dZ;
							if (!_v14.$) {
								var lastEmittedAt = _v14.a;
								return _Utils_cmp(lastEmittedAt + interval, time) < 1;
							} else {
								return _Utils_cmp(unsettled.hl + interval, time) < 1;
							}
						} else {
							return false;
						}
					}();
					var becauseEmitWhenUnsettled = function () {
						var _v11 = config.ba;
						if (!_v11.$) {
							var interval = _v11.a;
							var _v12 = unsettled.dZ;
							if (!_v12.$) {
								return false;
							} else {
								return _Utils_cmp(unsettled.hl + interval, time) < 1;
							}
						} else {
							return false;
						}
					}();
					var shouldEmit = (!_Utils_eq(unsettled.aX, $elm$core$Maybe$Nothing)) && (shouldSettle || (becauseEmitWhenUnsettled || becauseEmitWhileUnsettled));
					var emit = shouldEmit ? unsettled.aX : $elm$core$Maybe$Nothing;
					var intervals = function () {
						if (shouldEmit && (!shouldSettle)) {
							var _v10 = config.bb;
							if (!_v10.$) {
								var interval = _v10.a;
								return _List_fromArray(
									[interval]);
							} else {
								return _List_Nil;
							}
						} else {
							return _List_Nil;
						}
					}();
					var newState = shouldSettle ? $Gizra$elm_debouncer$Debouncer$Internal$Settled : (shouldEmit ? $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
						_Utils_update(
							unsettled,
							{
								dZ: $elm$core$Maybe$Just(time),
								aX: $elm$core$Maybe$Nothing
							})) : state);
					return _Utils_Tuple3(
						A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState),
						intervals,
						emit);
				}
		}
	});
var $Gizra$elm_debouncer$Debouncer$Basic$update = F2(
	function (msg, debouncer) {
		switch (msg.$) {
			case 0:
				var input = msg.a;
				return _Utils_Tuple3(
					debouncer,
					A2(
						$elm$core$Task$perform,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$Gizra$elm_debouncer$Debouncer$Basic$MsgInternal,
								$Gizra$elm_debouncer$Debouncer$Internal$InputProvidedAt(input)),
							$elm$time$Time$posixToMillis),
						$elm$time$Time$now),
					$elm$core$Maybe$Nothing);
			case 1:
				return _Utils_Tuple3(
					debouncer,
					A2(
						$elm$core$Task$perform,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal, $Gizra$elm_debouncer$Debouncer$Internal$ManualEmitAt),
							$elm$time$Time$posixToMillis),
						$elm$time$Time$now),
					$elm$core$Maybe$Nothing);
			default:
				var subMsg = msg.a;
				var _v1 = A2($Gizra$elm_debouncer$Debouncer$Internal$update, subMsg, debouncer);
				var updatedDebouncer = _v1.a;
				var intervals = _v1.b;
				var output = _v1.c;
				var cmds = $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						function (interval) {
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal, $Gizra$elm_debouncer$Debouncer$Internal$Check),
									$elm$time$Time$posixToMillis),
								A2(
									$elm$core$Task$andThen,
									$elm$core$Basics$always($elm$time$Time$now),
									$elm$core$Process$sleep(interval)));
						},
						intervals));
				return _Utils_Tuple3(updatedDebouncer, cmds, output);
		}
	});
var $author$project$Search$update = F3(
	function (shared, model, msg) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return $author$project$UpdateResult$init(model);
				case 1:
					var subMsg = msg.a;
					var _v1 = A2($Gizra$elm_debouncer$Debouncer$Basic$update, subMsg, model.gp);
					var subModel = _v1.a;
					var subCmd = _v1.b;
					var emittedMsg = _v1.c;
					var mappedCmd = A2($elm$core$Platform$Cmd$map, $author$project$Search$GotDebouncerMsg, subCmd);
					var updatedModel = _Utils_update(
						model,
						{gp: subModel});
					if (!emittedMsg.$) {
						var emitted = emittedMsg.a;
						return A2(
							$author$project$UpdateResult$addCmd,
							mappedCmd,
							A3($author$project$Search$update, shared, updatedModel, emitted));
					} else {
						return A2(
							$author$project$UpdateResult$addCmd,
							mappedCmd,
							$author$project$UpdateResult$init(updatedModel));
					}
				case 12:
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								hY: A2(
									$author$project$Form$updateValues,
									function (form) {
										return _Utils_update(
											form,
											{ed: ''});
									},
									model.hY),
								Z: $author$project$Search$Inactive
							}));
				case 5:
					var q = msg.a;
					var $temp$shared = shared,
						$temp$model = _Utils_update(
						model,
						{
							hY: A2(
								$author$project$Form$updateValues,
								function (form) {
									return _Utils_update(
										form,
										{ed: q});
								},
								model.hY),
							Z: A2($author$project$Search$ResultsShowed, $krisajenkins$remotedata$RemoteData$Loading, $elm$core$Maybe$Nothing)
						}),
						$temp$msg = $author$project$Search$QuerySubmitted;
					shared = $temp$shared;
					model = $temp$model;
					msg = $temp$msg;
					continue update;
				case 8:
					var activeTab = msg.a;
					var _v3 = model.Z;
					if (_v3.$ === 2) {
						var r = _v3.a;
						var previousActiveTab = _v3.b;
						var newRecentQueries = A2(
							$elm$core$List$take,
							$author$project$Search$maximumRecentSearches,
							$elm_community$list_extra$List$Extra$unique(
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Form$getValue,
										function ($) {
											return $.ed;
										},
										model.hY),
									model.cj)));
						return A2(
							$author$project$UpdateResult$addCmd,
							function () {
								if (previousActiveTab.$ === 1) {
									return $author$project$Search$storeRecentSearches(newRecentQueries);
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}(),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										cj: newRecentQueries,
										Z: A2(
											$author$project$Search$ResultsShowed,
											r,
											$elm$core$Maybe$Just(activeTab))
									})));
					} else {
						return $author$project$UpdateResult$init(model);
					}
				case 6:
					var _for = msg.a.jW;
					var res = msg.b;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								Z: $elm$core$String$isEmpty(
									A2(
										$author$project$Form$getValue,
										function ($) {
											return $.ed;
										},
										model.hY)) ? model.Z : (_Utils_eq(
									_for,
									A2(
										$author$project$Form$getValue,
										function ($) {
											return $.ed;
										},
										model.hY)) ? A2($author$project$Search$ResultsShowed, res, $elm$core$Maybe$Nothing) : model.Z)
							}));
				case 4:
					var queries = msg.a;
					var _v5 = A2(
						$elm$json$Json$Decode$decodeString,
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						queries);
					if (!_v5.$) {
						var queryList = _v5.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{cj: queryList}));
					} else {
						return $author$project$UpdateResult$init(model);
					}
				case 2:
					return $author$project$UpdateResult$init(
						$author$project$Search$closeSearch(model));
				case 9:
					var subMsg = msg.a;
					var updateResult = A5(
						$author$project$UpdateResult$fromChild,
						function (newForm) {
							return _Utils_update(
								model,
								{hY: newForm});
						},
						$author$project$Search$GotFormMsg,
						A2($elm$core$Basics$composeR, $author$project$Search$SetFeedback, $author$project$UpdateResult$addExt),
						model,
						A3($author$project$Form$update, shared, subMsg, model.hY));
					var oldQuery = A2(
						$author$project$Form$getValue,
						function ($) {
							return $.ed;
						},
						model.hY);
					var newQuery = A2(
						$author$project$Form$getValue,
						function ($) {
							return $.ed;
						},
						updateResult.ok.hY);
					var actOnQueryChange = $elm$core$String$isEmpty(newQuery) ? $author$project$UpdateResult$mapModel(
						function (m) {
							return _Utils_update(
								m,
								{Z: $author$project$Search$RecentSearchesShowed});
						}) : ((!_Utils_eq(oldQuery, newQuery)) ? $author$project$UpdateResult$addMsg(
						$author$project$Search$GotDebouncerMsg(
							$Gizra$elm_debouncer$Debouncer$Basic$provideInput(
								$author$project$Search$RequestedNewResults(newQuery)))) : $elm$core$Basics$identity);
					return actOnQueryChange(updateResult);
				case 10:
					var queryString = msg.a;
					return A2(
						$author$project$UpdateResult$addExt,
						$author$project$Search$sendSearchQuery(queryString),
						$author$project$UpdateResult$init(model));
				case 11:
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$elm$core$Task$attempt,
							function (_v6) {
								return $author$project$Search$NoOp;
							},
							$elm$browser$Browser$Dom$focus('searchInput')),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									hY: A2(
										$author$project$Form$updateValues,
										function (form) {
											return _Utils_update(
												form,
												{ed: ''});
										},
										model.hY),
									Z: $author$project$Search$RecentSearchesShowed
								})));
				case 3:
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								Z: function () {
									var _v7 = model.Z;
									if (!_v7.$) {
										return $author$project$Search$RecentSearchesShowed;
									} else {
										return model.Z;
									}
								}()
							}));
				case 7:
					var currentQuery = A2(
						$author$project$Form$getValue,
						function ($) {
							return $.ed;
						},
						model.hY);
					var newRecentSearches = A2(
						$elm$core$List$take,
						$author$project$Search$maximumRecentSearches,
						$elm_community$list_extra$List$Extra$unique(
							A2($elm$core$List$cons, currentQuery, model.cj)));
					return A2(
						$author$project$UpdateResult$addExt,
						$author$project$Search$sendSearchQuery(currentQuery),
						A2(
							$author$project$UpdateResult$addCmd,
							$author$project$Search$storeRecentSearches(newRecentSearches),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										cj: newRecentSearches,
										Z: A2($author$project$Search$ResultsShowed, $krisajenkins$remotedata$RemoteData$Loading, $elm$core$Maybe$Nothing)
									}))));
				case 13:
					var containerId = msg.a.mI;
					var imageId = msg.a.nA;
					return A2(
						$author$project$UpdateResult$addPort,
						{
							bZ: $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string('smoothHorizontalScroll')),
										_Utils_Tuple2(
										'containerId',
										$elm$json$Json$Encode$string(containerId)),
										_Utils_Tuple2(
										'targetId',
										$elm$json$Json$Encode$string(imageId))
									])),
							fy: $author$project$Search$NoOp,
							fz: $elm$json$Json$Encode$null
						},
						$author$project$UpdateResult$init(model));
				case 14:
					var productId = msg.a;
					var imageId = msg.b;
					var _v8 = model.Z;
					if ((_v8.$ === 2) && (_v8.a.$ === 3)) {
						var searchResults = _v8.a.a;
						var activeTab = _v8.b;
						var newOffers = A3(
							$elm_community$list_extra$List$Extra$updateIf,
							function (_v9) {
								var product = _v9.pi;
								return _Utils_eq(product.w, productId);
							},
							function (productInfo) {
								return _Utils_update(
									productInfo,
									{
										cE: $elm$core$Maybe$Just(imageId),
										c0: productInfo.cE
									});
							},
							searchResults.bm);
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									Z: A2(
										$author$project$Search$ResultsShowed,
										$krisajenkins$remotedata$RemoteData$Success(
											_Utils_update(
												searchResults,
												{bm: newOffers})),
										activeTab)
								}));
					} else {
						return $author$project$UpdateResult$init(model);
					}
				default:
					var productId = msg.a;
					var imageId = msg.b;
					var _v10 = model.Z;
					if ((_v10.$ === 2) && (_v10.a.$ === 3)) {
						var searchResults = _v10.a.a;
						var activeTab = _v10.b;
						var newOffers = A3(
							$elm_community$list_extra$List$Extra$updateIf,
							function (_v11) {
								var product = _v11.pi;
								return _Utils_eq(product.w, productId);
							},
							function (productInfo) {
								return _Utils_eq(
									$elm$core$Maybe$Just(imageId),
									productInfo.cE) ? _Utils_update(
									productInfo,
									{cE: productInfo.c0, c0: $elm$core$Maybe$Nothing}) : (_Utils_eq(
									$elm$core$Maybe$Just(imageId),
									productInfo.c0) ? _Utils_update(
									productInfo,
									{c0: $elm$core$Maybe$Nothing}) : productInfo);
							},
							searchResults.bm);
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									Z: A2(
										$author$project$Search$ResultsShowed,
										$krisajenkins$remotedata$RemoteData$Success(
											_Utils_update(
												searchResults,
												{bm: newOffers})),
										activeTab)
								}));
					} else {
						return $author$project$UpdateResult$init(model);
					}
			}
		}
	});
var $author$project$Session$LoggedIn$withPrivateKeyInternal = F4(
	function (msg, model, requiredPermissions, successfulUR) {
		return A4(
			$author$project$Auth$withPrivateKey,
			model.ml,
			{
				mU: A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pz;
						},
						$elm$core$List$concatMap(
							function ($) {
								return $.o6;
							})),
					$author$project$Session$LoggedIn$profile(model)),
				pv: requiredPermissions
			},
			{
				mZ: model,
				oC: A5(
					$author$project$UpdateResult$logImpossible,
					msg,
					'Tried signing eos transaction internally, but profile wasn\'t loaded',
					$elm$core$Maybe$Just(model._),
					{e$: 'withPrivateKeyInternal', fi: 'Session.LoggedIn'},
					_List_Nil),
				oE: A2(
					$elm$core$Basics$composeR,
					$author$project$UpdateResult$mapModel($author$project$Session$LoggedIn$askedAuthentication),
					$author$project$UpdateResult$addExt(
						$author$project$Session$LoggedIn$AddAfterPrivateKeyCallback(msg))),
				oO: $author$project$UpdateResult$mapModel(
					function (m) {
						return _Utils_update(
							m,
							{bs: true});
					})
			},
			successfulUR);
	});
var $author$project$Session$LoggedIn$update = F2(
	function (msg, model) {
		var shared = model.A;
		var closeAllModals = _Utils_update(
			model,
			{el: false, cl: false, bs: false, fG: false, fH: false, aL: false});
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 25:
				var time = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$Broadcast(
						$author$project$Session$LoggedIn$GotTime(time)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								A: _Utils_update(
									shared,
									{ce: time})
							})));
			case 22:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newClaimingAction) {
						return _Utils_update(
							model,
							{eI: newClaimingAction});
					},
					$author$project$Session$LoggedIn$GotActionMsg,
					function (ext) {
						switch (ext.$) {
							case 0:
								var interval = ext.a;
								return $author$project$UpdateResult$mapModel(
									function (m) {
										return _Utils_update(
											m,
											{hm: interval});
									});
							case 1:
								var feedbackModel = ext.a;
								return $author$project$UpdateResult$mapModel(
									function (m) {
										return _Utils_update(
											m,
											{hU: feedbackModel});
									});
							case 2:
								var afterAuthMsg = ext.a;
								return A2(
									$elm$core$Basics$composeR,
									$author$project$UpdateResult$mapModel($author$project$Session$LoggedIn$askedAuthentication),
									$author$project$UpdateResult$addExt(
										$author$project$Session$LoggedIn$AddAfterPrivateKeyCallback(
											$author$project$Session$LoggedIn$GotActionMsg(afterAuthMsg))));
							default:
								return $author$project$UpdateResult$mapModel(
									function (m) {
										return _Utils_update(
											m,
											{bs: true});
									});
						}
					},
					model,
					A3($author$project$Action$update, subMsg, model.eI, model));
			case 23:
				return $author$project$UpdateResult$init(
					_Utils_update(
						closeAllModals,
						{
							al: $author$project$Search$closeSearch(model.al)
						}));
			case 24:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							al: $author$project$Search$closeSearch(model.al)
						}));
			case 21:
				var searchMsg = msg.a;
				return A2(
					$author$project$UpdateResult$mapModel,
					function (newModel) {
						return _Utils_update(
							newModel,
							{
								gC: newModel.gC || $author$project$Search$isOpenMsg(searchMsg)
							});
					},
					A5(
						$author$project$UpdateResult$fromChild,
						function (searchModel) {
							return _Utils_update(
								model,
								{al: searchModel});
						},
						$author$project$Session$LoggedIn$GotSearchMsg,
						F2(
							function (extMsg, ur) {
								if (!extMsg.$) {
									var feedback = extMsg.a;
									return A2(
										$author$project$UpdateResult$mapModel,
										function (newModel) {
											return _Utils_update(
												newModel,
												{hU: feedback});
										},
										ur);
								} else {
									var selectionSet = extMsg.a;
									var resultMsg = extMsg.b;
									return A2(
										$author$project$UpdateResult$addCmd,
										A3(
											$author$project$Session$LoggedIn$internalQuery,
											ur.ok,
											selectionSet,
											A2($elm$core$Basics$composeR, resultMsg, $author$project$Session$LoggedIn$GotSearchMsg)),
										ur);
								}
							}),
						_Utils_update(
							model,
							{
								gC: model.gC || $author$project$Search$isOpenMsg(searchMsg)
							}),
						A3($author$project$Search$update, shared, model.al, searchMsg)));
			case 1:
				if (!msg.b.$) {
					var lang = msg.a;
					var transl = msg.b.a;
					var _v3 = model.pl;
					if (_v3.$ === 3) {
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$Broadcast($author$project$Session$LoggedIn$TranslationsLoaded),
							A2(
								$author$project$UpdateResult$addCmd,
								$author$project$Ports$storeLanguage(
									$author$project$Translation$languageToLocale(lang)),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											A: A2(
												$author$project$Session$Shared$loadTranslation,
												$elm$core$Result$Ok(
													_Utils_Tuple2(lang, transl)),
												shared)
										}))));
					} else {
						return $author$project$UpdateResult$init(model);
					}
				} else {
					var err = msg.b.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(model._),
						'Got an error when loading translation as a logged in user',
						{e$: 'update', fi: 'Session.LoggedIn'},
						_List_Nil,
						err,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									A: A2(
										$author$project$Session$Shared$loadTranslation,
										$elm$core$Result$Err(err),
										shared)
								})));
				}
			case 2:
				return A2(
					$author$project$UpdateResult$addBreadcrumb,
					{f7: msg, bZ: $elm$core$Dict$empty, n4: 2, of: 'Clicked to fetch translation again', eq: 2},
					A2(
						$author$project$UpdateResult$addCmd,
						A2($author$project$Session$LoggedIn$fetchTranslations, shared.lZ, shared.ic),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									A: $author$project$Session$Shared$toLoadingTranslation(shared)
								}))));
			case 3:
				switch (msg.a.$) {
					case 3:
						var profile_ = msg.a.a;
						var subscriptionDoc = $dillonkearns$elm_graphql$Graphql$Document$serializeSubscription(
							$author$project$Session$LoggedIn$unreadCountSubscription(model._));
						if (!profile_.$) {
							var p = profile_.a;
							var sendLanguagePreference = function () {
								var _v5 = p.pc;
								if (_v5.$ === 1) {
									return A2($author$project$Session$LoggedIn$sendPreferredLanguage, model, model.A.ic);
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}();
							var hasAcceptedCodeOfConduct = $elm_community$maybe_extra$Maybe$Extra$isJust(p.n3);
							return A2(
								$author$project$UpdateResult$addBreadcrumb,
								{
									f7: msg,
									bZ: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'username',
												$author$project$Eos$Account$encodeName(p.l8))
											])),
									n4: 3,
									of: 'User profile successfully loaded',
									eq: 0
								},
								A2(
									$author$project$UpdateResult$addPort,
									{
										bZ: $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string('subscribeToUnreadCount')),
													_Utils_Tuple2(
													'subscription',
													$elm$json$Json$Encode$string(subscriptionDoc))
												])),
										fy: $author$project$Session$LoggedIn$CompletedLoadUnread(
											$elm$json$Json$Encode$string('')),
										fz: $elm$json$Json$Encode$null
									},
									A2(
										$author$project$UpdateResult$addExt,
										$author$project$Session$LoggedIn$Broadcast(
											$author$project$Session$LoggedIn$ProfileLoaded(p)),
										A2(
											$author$project$UpdateResult$addCmd,
											sendLanguagePreference,
											$author$project$UpdateResult$init(
												_Utils_update(
													model,
													{
														ab: hasAcceptedCodeOfConduct ? $author$project$Session$LoggedIn$CodeOfConductNotShown : $author$project$Session$LoggedIn$CodeOfConductShown,
														gz: model.gz || hasAcceptedCodeOfConduct,
														pl: $krisajenkins$remotedata$RemoteData$Success(p)
													}))))));
						} else {
							return A2(
								$author$project$UpdateResult$addCmd,
								A2($author$project$Route$replaceUrl, shared.kK, $author$project$Route$Logout),
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model._),
							'Got an error when trying to load profile',
							{e$: 'update', fi: 'Session.LoggedIn'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pl: function () {
											var _v6 = model.pl;
											if (_v6.$ === 1) {
												return $krisajenkins$remotedata$RemoteData$Failure(err);
											} else {
												return model.pl;
											}
										}()
									})));
					case 0:
						var _v7 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v8 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 4:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var community = msg.a.a.a;
							var _v9 = A2(
								$author$project$Session$LoggedIn$setCommunity,
								A2($author$project$Community$mergeFields, model.pC, community),
								model);
							var newModel = _v9.a;
							var cmd = _v9.b;
							var newCommunity = function (comm) {
								return A3($elm$core$List$foldl, $author$project$Community$setFieldAsLoading, comm, newModel.ci);
							}(
								A2($author$project$Community$mergeFields, newModel.pC, community));
							var queryForContributionCount = A3(
								$author$project$Session$LoggedIn$internalQuery,
								newModel,
								A2($author$project$Profile$contributionCountQuery, community.as, model._),
								$author$project$Session$LoggedIn$CompletedLoadContributionCount);
							return A2(
								$author$project$UpdateResult$addBreadcrumb,
								{
									f7: msg,
									bZ: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'symbol',
												$author$project$Eos$encodeSymbol(community.as)),
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string(community.fj))
											])),
									n4: 3,
									of: 'Community successfully loaded',
									eq: 0
								},
								A2(
									$author$project$UpdateResult$addCmd,
									queryForContributionCount,
									A2(
										$author$project$UpdateResult$addCmd,
										A3(
											$author$project$Session$LoggedIn$internalQuery,
											newModel,
											A2($author$project$Community$fieldsSelectionSet, community.as, newModel.ci),
											$author$project$Session$LoggedIn$CompletedLoadCommunityFields(newCommunity)),
										A2(
											$author$project$UpdateResult$addExt,
											$author$project$Session$LoggedIn$Broadcast(
												$author$project$Session$LoggedIn$CommunityLoaded(newCommunity)),
											A2(
												$author$project$UpdateResult$addPort,
												{
													bZ: $elm$json$Json$Encode$object(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'name',
																$elm$json$Json$Encode$string('subscribeToHighlightedNewsChanged')),
																_Utils_Tuple2(
																'subscription',
																$elm$json$Json$Encode$string(
																	$dillonkearns$elm_graphql$Graphql$Document$serializeSubscription($author$project$Session$LoggedIn$highlightedNewsSubscription)))
															])),
													fy: $author$project$Session$LoggedIn$ReceivedNewHighlightedNews($elm$json$Json$Encode$null),
													fz: $elm$json$Json$Encode$null
												},
												A2(
													$author$project$UpdateResult$addPort,
													{
														bZ: $elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'name',
																	$elm$json$Json$Encode$string('setFavicon')),
																	_Utils_Tuple2(
																	'favicon',
																	$elm$json$Json$Encode$string(community.fe))
																])),
														fy: $author$project$Session$LoggedIn$NoOp,
														fz: $elm$json$Json$Encode$null
													},
													A2(
														$author$project$UpdateResult$addCmd,
														$author$project$Ports$getRecentSearches(0),
														A2(
															$author$project$UpdateResult$addCmd,
															cmd,
															$author$project$UpdateResult$init(
																_Utils_update(
																	newModel,
																	{
																		kB: community.nu,
																		pC: $krisajenkins$remotedata$RemoteData$Success(newCommunity)
																	}))))))))));
						} else {
							var _v10 = msg.a.a;
							return A2(
								$author$project$UpdateResult$addCmd,
								A2(
									$author$project$Route$pushUrl,
									shared.kK,
									$author$project$Route$CommunitySelector(
										$elm$core$List$head(model.g6))),
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var e = msg.a.a;
						var communityExists = !$author$project$Api$Graphql$isNonExistingCommunityError(e);
						return (communityExists ? $elm$core$Basics$identity : $author$project$UpdateResult$addCmd(
							A2(
								$author$project$Route$pushUrl,
								shared.kK,
								$author$project$Route$CommunitySelector(
									$elm$core$List$head(model.g6)))))(
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Just(model._),
								'Got an error when loading community as logged in',
								{e$: 'update', fi: 'Session.LoggedIn'},
								_List_Nil,
								e,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											pC: $krisajenkins$remotedata$RemoteData$Failure(e)
										}))));
					case 0:
						var _v11 = msg.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{pC: $krisajenkins$remotedata$RemoteData$NotAsked}));
					default:
						var _v12 = msg.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{pC: $krisajenkins$remotedata$RemoteData$Loading}));
				}
			case 5:
				switch (msg.b.$) {
					case 3:
						if (!msg.b.a.$) {
							var community = msg.a;
							var fieldValue = msg.b.a.a;
							var newCommunity = A2(
								$author$project$Community$setFieldValue,
								fieldValue,
								A2($krisajenkins$remotedata$RemoteData$withDefault, community, model.pC));
							return A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$Broadcast(
									A2($author$project$Session$LoggedIn$CommunityFieldLoaded, newCommunity, fieldValue)),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											pC: $krisajenkins$remotedata$RemoteData$Success(newCommunity)
										})));
						} else {
							var community = msg.a;
							var _v13 = msg.b.a;
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Tried loading community field, but got Nothing in return',
								$elm$core$Maybe$Just(model._),
								{e$: 'update', fi: 'Session.LoggedIn'},
								_List_fromArray(
									[
										$author$project$Log$contextFromCommunity(
										$krisajenkins$remotedata$RemoteData$Success(community))
									]),
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var err = msg.b.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model._),
							'Got an error when loading community field',
							{e$: 'update', fi: 'Session.LoggedIn'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(model));
					case 0:
						var _v14 = msg.b;
						return $author$project$UpdateResult$init(model);
					default:
						var _v15 = msg.b;
						return $author$project$UpdateResult$init(model);
				}
			case 6:
				switch (msg.b.$) {
					case 3:
						var community = msg.a;
						var fieldValues = msg.b.a;
						var newCommunity = A3(
							$elm$core$List$foldl,
							$author$project$Community$setFieldValue,
							A2($krisajenkins$remotedata$RemoteData$withDefault, community, model.pC),
							fieldValues);
						var addBroadcasts = function (uResult) {
							return A3(
								$elm$core$List$foldl,
								function (field) {
									return $author$project$UpdateResult$addExt(
										$author$project$Session$LoggedIn$Broadcast(
											A2($author$project$Session$LoggedIn$CommunityFieldLoaded, community, field)));
								},
								uResult,
								fieldValues);
						};
						return addBroadcasts(
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pC: $krisajenkins$remotedata$RemoteData$Success(newCommunity)
									})));
					case 2:
						var err = msg.b.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model._),
							'Got an error when loading multiple community fields',
							{e$: 'update', fi: 'Session.LoggedIn'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(model));
					case 0:
						var _v16 = msg.b;
						return $author$project$UpdateResult$init(model);
					default:
						var _v17 = msg.b;
						return $author$project$UpdateResult$init(model);
				}
			case 7:
				var accountName = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A3(
						$author$project$Session$LoggedIn$internalQuery,
						model,
						$author$project$Profile$query(accountName),
						$author$project$Session$LoggedIn$CompletedLoadProfile),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{pl: $krisajenkins$remotedata$RemoteData$Loading})));
			case 8:
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('logout'))
								])),
						fy: $author$project$Session$LoggedIn$ClickedLogout,
						fz: $elm$json$Json$Encode$null
					},
					A2(
						$author$project$UpdateResult$addCmd,
						A2($author$project$Route$replaceUrl, shared.kK, $author$project$Route$Logout),
						$author$project$UpdateResult$init(model)));
			case 9:
				var b = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						closeAllModals,
						{aL: b}));
			case 10:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{fF: !model.fF}));
			case 11:
				var lang = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2($author$project$Session$LoggedIn$sendPreferredLanguage, model, lang),
					A2(
						$author$project$UpdateResult$addCmd,
						A2($author$project$Session$LoggedIn$fetchTranslations, shared.lZ, lang),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									A: $author$project$Session$Shared$toLoadingTranslation(shared),
									aL: false
								}))));
			case 12:
				if (msg.a.$ === 2) {
					var err = msg.a.a;
					return A7(
						$author$project$UpdateResult$logGraphqlError,
						msg,
						$elm$core$Maybe$Just(model._),
						'Got an error when sending language preference',
						{e$: 'update', fi: 'Session.LoggedIn'},
						_List_Nil,
						err,
						$author$project$UpdateResult$init(model));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 13:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$AuthenticationFailed,
					$author$project$UpdateResult$init(closeAllModals));
			case 14:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{bs: false}));
			case 15:
				var authMsg = msg.a;
				return A4(
					$author$project$UpdateResult$map,
					function (a) {
						return _Utils_update(
							model,
							{ml: a});
					},
					$author$project$Session$LoggedIn$GotAuthMsg,
					F2(
						function (extMsg, uResult) {
							switch (extMsg.$) {
								case 0:
									var accountName = extMsg.a;
									var auth = extMsg.b;
									return A2(
										$author$project$UpdateResult$addBreadcrumb,
										{
											f7: msg,
											bZ: $elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'username',
														$author$project$Eos$Account$encodeName(accountName))
													])),
											n4: 3,
											of: 'Successfully authenticated user through PIN',
											eq: 0
										},
										A2(
											$author$project$UpdateResult$addExt,
											$author$project$Session$LoggedIn$RunAfterPrivateKeyCallbacks,
											A2(
												$author$project$UpdateResult$addExt,
												$author$project$Session$LoggedIn$AuthenticationSucceed,
												A2(
													$author$project$UpdateResult$mapModel,
													function (m) {
														return _Utils_update(
															m,
															{ml: auth});
													},
													$author$project$Session$LoggedIn$closeModal(uResult)))));
								case 1:
									var newShared = extMsg.a;
									return A2(
										$author$project$UpdateResult$mapModel,
										function (m) {
											return _Utils_update(
												m,
												{A: newShared});
										},
										uResult);
								default:
									var feedbackModel = extMsg.a;
									return A2(
										$author$project$UpdateResult$mapModel,
										function (m) {
											return _Utils_update(
												m,
												{hU: feedbackModel});
										},
										uResult);
							}
						}),
					A3($author$project$Auth$update, authMsg, shared, model.ml));
			case 16:
				var payload = msg.a;
				var _v19 = A2(
					$elm$json$Json$Decode$decodeValue,
					$dillonkearns$elm_graphql$Graphql$Document$decoder(
						$author$project$Session$LoggedIn$unreadCountSubscription(model._)),
					payload);
				if (!_v19.$) {
					var res = _v19.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{er: res}));
				} else {
					var err = _v19.a;
					return A7(
						$author$project$UpdateResult$logDecodingError,
						msg,
						$elm$core$Maybe$Just(model._),
						'Got an error when loading unread notifications',
						{e$: 'update', fi: 'Session.LoggedIn'},
						_List_Nil,
						err,
						$author$project$UpdateResult$init(model));
				}
			case 20:
				var subMsg = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							hU: A2($author$project$View$Feedback$update, subMsg, model.hU)
						}));
			case 17:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cm: true}));
			case 18:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cm: false}));
			case 19:
				var newCommunity = msg.a;
				var symbol = newCommunity.as;
				var _v20 = A2(
					$author$project$Session$LoggedIn$loadCommunity,
					model,
					$elm$core$Maybe$Just(symbol));
				var loadCommunityModel = _v20.a;
				var loadCommunityCmd = _v20.b;
				var _v21 = model.pC;
				switch (_v21.$) {
					case 3:
						var selectedCommunity = _v21.a;
						if (_Utils_eq(symbol, selectedCommunity.as)) {
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{cm: false}));
						} else {
							var _v22 = A3(
								$author$project$Session$LoggedIn$selectCommunity,
								model,
								newCommunity,
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Route$Dashboard,
									$elm$core$List$head(model.g6)));
							var newModel = _v22.a;
							var cmd = _v22.b;
							return A2(
								$author$project$UpdateResult$addCmd,
								cmd,
								$author$project$UpdateResult$init(
									_Utils_update(
										newModel,
										{cm: false})));
						}
					case 0:
						return A2(
							$author$project$UpdateResult$addCmd,
							loadCommunityCmd,
							$author$project$UpdateResult$init(loadCommunityModel));
					case 2:
						return A2(
							$author$project$UpdateResult$addCmd,
							loadCommunityCmd,
							$author$project$UpdateResult$init(loadCommunityModel));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 26:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var contributionCount = msg.a.a.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										mN: $krisajenkins$remotedata$RemoteData$Success(contributionCount)
									}));
						} else {
							var _v23 = msg.a.a;
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Got contribution count successfully, but it returned `Nothing`',
								$elm$core$Maybe$Just(model._),
								{e$: 'update', fi: 'Session.LoggedIn'},
								_List_fromArray(
									[
										$author$project$Log$contextFromCommunity(model.pC)
									]),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											mN: $krisajenkins$remotedata$RemoteData$Success(0)
										})));
						}
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model._),
							'Got an error when loading contribution count',
							{e$: 'update', fi: 'Session.LoggedIn'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(model.pC)
								]),
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										mN: $krisajenkins$remotedata$RemoteData$Failure(err)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 28:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{kB: $elm$core$Maybe$Nothing}));
			case 27:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{kB: $elm$core$Maybe$Nothing}));
			case 29:
				var payload = msg.a;
				var _v24 = model.pC;
				if (_v24.$ === 3) {
					var community = _v24.a;
					var _v25 = A2(
						$elm$json$Json$Decode$decodeValue,
						$dillonkearns$elm_graphql$Graphql$Document$decoder($author$project$Session$LoggedIn$highlightedNewsSubscription),
						payload);
					if (!_v25.$) {
						var highlightedNews = _v25.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									kB: highlightedNews,
									pC: $krisajenkins$remotedata$RemoteData$Success(
										_Utils_update(
											community,
											{nu: highlightedNews}))
								}));
					} else {
						var err = _v25.a;
						return A7(
							$author$project$UpdateResult$logDecodingError,
							msg,
							$elm$core$Maybe$Just(model._),
							'Got an error when loading highlighted news',
							{e$: 'update', fi: 'Session.LoggedIn'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(model));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Received new highlighted news, but community wasn\'t loaded',
						$elm$core$Maybe$Just(model._),
						{e$: 'update', fi: 'Session.LoggedIn'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(model.pC)
							]),
						$author$project$UpdateResult$init(model));
				}
			case 30:
				var callback = msg.a;
				return model.b9 ? A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$AddAfterAuthTokenCallbackInternal(callback),
					$author$project$UpdateResult$init(model)) : A2(
					$author$project$UpdateResult$addCmd,
					A3(
						$author$project$Api$Graphql$askForPhrase,
						model.A,
						model._,
						$author$project$Session$LoggedIn$GotAuthTokenPhrase(callback)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{b9: true})));
			case 31:
				var callback = msg.a;
				return model.b9 ? A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$AddAfterAuthTokenCallback(callback),
					$author$project$UpdateResult$init(model)) : A2(
					$author$project$UpdateResult$addCmd,
					A3(
						$author$project$Api$Graphql$askForPhrase,
						model.A,
						model._,
						$author$project$Session$LoggedIn$GotAuthTokenPhraseExternal(callback)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{b9: true})));
			case 32:
				switch (msg.b.$) {
					case 3:
						var callback = msg.a;
						var phrase = msg.b.a;
						return A4(
							$author$project$Session$LoggedIn$withPrivateKeyInternal,
							msg,
							model,
							_List_Nil,
							function (privateKey) {
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$LoggedIn$AddAfterAuthTokenCallbackInternal(callback),
									A2(
										$author$project$UpdateResult$addPort,
										A3($author$project$Api$Graphql$signPhrasePort, msg, privateKey, phrase),
										$author$project$UpdateResult$init(model)));
							});
					case 2:
						var err = msg.b.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model._),
							'Got an error when fetching phrase to sign for auth token',
							{e$: 'update', fi: 'Session.LoggedIn'},
							_List_Nil,
							err,
							A2(
								$author$project$UpdateResult$addPort,
								{
									bZ: $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string('logout'))
											])),
									fy: $author$project$Session$LoggedIn$NoOp,
									fz: $elm$json$Json$Encode$null
								},
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											ml: $author$project$Auth$removePrivateKey(model.ml),
											hU: A2(
												$author$project$View$Feedback$Visible,
												1,
												shared.aw.fL('auth.failed'))
										}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 33:
				switch (msg.b.$) {
					case 3:
						var callback = msg.a;
						var phrase = msg.b.a;
						return A4(
							$author$project$Session$LoggedIn$withPrivateKeyInternal,
							msg,
							model,
							_List_Nil,
							function (privateKey) {
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$LoggedIn$AddAfterAuthTokenCallback(callback),
									A2(
										$author$project$UpdateResult$addPort,
										A3($author$project$Api$Graphql$signPhrasePort, msg, privateKey, phrase),
										$author$project$UpdateResult$init(model)));
							});
					case 2:
						var err = msg.b.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model._),
							'Got an error when fetching phrase to sign for auth token (using an external msg)',
							{e$: 'update', fi: 'Session.LoggedIn'},
							_List_Nil,
							err,
							A2(
								$author$project$UpdateResult$addPort,
								{
									bZ: $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string('logout'))
											])),
									fy: $author$project$Session$LoggedIn$NoOp,
									fz: $elm$json$Json$Encode$null
								},
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											ml: $author$project$Auth$removePrivateKey(model.ml),
											hU: A2(
												$author$project$View$Feedback$Visible,
												1,
												shared.aw.fL('auth.failed'))
										}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 34:
				var signedPhrase = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A3(
						$author$project$Api$Graphql$signIn,
						shared,
						{
							l8: model._,
							kk: $author$project$Session$LoggedIn$getInvitation(model),
							kX: signedPhrase
						},
						$author$project$Session$LoggedIn$CompletedGeneratingAuthToken),
					$author$project$UpdateResult$init(model));
			case 35:
				switch (msg.a.$) {
					case 3:
						var signInResponse = msg.a.a;
						var createAbsintheSocket = model.gW ? $author$project$Api$Graphql$createAbsintheSocket(signInResponse.p5) : $elm$core$Platform$Cmd$none;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$RunAfterAuthTokenCallbacks(signInResponse.p5),
							A2(
								$author$project$UpdateResult$addCmd,
								createAbsintheSocket,
								A2(
									$author$project$UpdateResult$addCmd,
									$author$project$Api$Graphql$storeToken(signInResponse.p5),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{
												jk: $elm$core$Maybe$Just(signInResponse.p5),
												b9: false,
												gW: false,
												pl: $krisajenkins$remotedata$RemoteData$Success(signInResponse.pl)
											})))));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model._),
							'Got an error when signing in',
							{e$: 'update', fi: 'Session.LoggedIn'},
							_List_Nil,
							err,
							A2(
								$author$project$UpdateResult$addPort,
								{
									bZ: $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string('logout'))
											])),
									fy: $author$project$Session$LoggedIn$NoOp,
									fz: $elm$json$Json$Encode$null
								},
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											ml: $author$project$Auth$removePrivateKey(model.ml),
											hU: A2(
												$author$project$View$Feedback$Visible,
												1,
												shared.aw.fL('auth.failed')),
											b9: false
										}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 36:
				if (!msg.a.$) {
					var externalMsg = msg.a.a;
					return A2(
						$author$project$UpdateResult$addExt,
						$author$project$Session$LoggedIn$RunExternalMsg(externalMsg),
						$author$project$UpdateResult$init(model));
				} else {
					var callbackCmd = msg.a.a.jo;
					return A2(
						$author$project$UpdateResult$addMsg,
						$author$project$Session$LoggedIn$RequestedNewAuthTokenPhraseExternal(
							callbackCmd(model)),
						$author$project$UpdateResult$init(model));
				}
			case 37:
				if (!msg.a.$) {
					var resultMsg = msg.a.a;
					return A2(
						$author$project$UpdateResult$addMsg,
						resultMsg,
						$author$project$UpdateResult$init(model));
				} else {
					var callbackCmd = msg.a.a;
					return A2(
						$author$project$UpdateResult$addMsg,
						$author$project$Session$LoggedIn$RequestedNewAuthTokenPhrase(callbackCmd),
						$author$project$UpdateResult$init(model));
				}
			case 38:
				return A2(
					$author$project$UpdateResult$addCmd,
					A3(
						$author$project$Session$LoggedIn$internalMutation,
						model,
						$author$project$Cambiatus$Mutation$acceptTerms(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(0)),
						$author$project$Session$LoggedIn$CompletedAcceptingCodeOfConduct),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{ab: $author$project$Session$LoggedIn$CodeOfConductNotShown})));
			case 39:
				var _v26 = model.ab;
				switch (_v26.$) {
					case 0:
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Denied code of conduct, but modal wasn\'t shown',
							$elm$core$Maybe$Just(model._),
							{e$: 'update', fi: 'Session.LoggedIn'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					case 1:
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									ab: $author$project$Session$LoggedIn$CodeOfConductShownWithWarning(
										{gA: false})
								}));
					default:
						var hasCompletedAnimation = _v26.a.gA;
						return (!hasCompletedAnimation) ? $author$project$UpdateResult$init(model) : $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{ab: $author$project$Session$LoggedIn$CodeOfConductNotShown, gz: false}));
				}
			case 40:
				if (msg.a.$ === 2) {
					var err = msg.a.a;
					return A7(
						$author$project$UpdateResult$logGraphqlError,
						msg,
						$elm$core$Maybe$Just(model._),
						'Got an error when accepting code of conduct',
						{e$: 'update', fi: 'Session.LoggedIn'},
						_List_Nil,
						err,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									hU: A2(
										$author$project$View$Feedback$Visible,
										1,
										shared.aw.fL('terms_of_conduct.error_accepting'))
								})));
				} else {
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{gz: true}));
				}
			case 41:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							ab: function () {
								var _v27 = model.ab;
								if (_v27.$ === 2) {
									return $author$project$Session$LoggedIn$CodeOfConductShownWithWarning(
										{gA: true});
								} else {
									return model.ab;
								}
							}()
						}));
			case 42:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cl: true}));
			default:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cl: false}));
		}
	});
var $author$project$Page$updateShared = F2(
	function (session, transform) {
		if (!session.$) {
			var subModel = session.a;
			return $author$project$Page$Guest(
				_Utils_update(
					subModel,
					{
						A: transform(subModel.A)
					}));
		} else {
			var subModel = session.a;
			return $author$project$Page$LoggedIn(
				_Utils_update(
					subModel,
					{
						A: transform(subModel.A)
					}));
		}
	});
var $author$project$Page$update = F2(
	function (msg, session) {
		var _v0 = _Utils_Tuple2(msg, session);
		_v0$7:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return $author$project$UpdateResult$init(session);
				case 1:
					if (!_v0.a.b.$) {
						var _v2 = _v0.a;
						var lang = _v2.a;
						var transl = _v2.b.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$LoggedInExternalMsg(
								$author$project$Session$LoggedIn$Broadcast($author$project$Session$LoggedIn$TranslationsLoaded)),
							A2(
								$author$project$UpdateResult$addCmd,
								$author$project$Ports$storeLanguage(
									$author$project$Translation$languageToLocale(lang)),
								$author$project$UpdateResult$init(
									A2(
										$author$project$Page$updateShared,
										session,
										$author$project$Session$Shared$loadTranslation(
											$elm$core$Result$Ok(
												_Utils_Tuple2(lang, transl)))))));
					} else {
						var _v3 = _v0.a;
						var err = _v3.b.a;
						return A7(
							$author$project$UpdateResult$logHttpError,
							msg,
							$author$project$Page$maybeAccountName(session),
							'Got an error when loading translations',
							{e$: 'update', fi: 'Page'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								A2(
									$author$project$Page$updateShared,
									session,
									$author$project$Session$Shared$loadTranslation(
										$elm$core$Result$Err(err)))));
					}
				case 2:
					if (!_v0.a.a.$) {
						var zone = _v0.a.a.a;
						return $author$project$UpdateResult$init(
							A2(
								$author$project$Page$updateShared,
								session,
								function (shared) {
									return _Utils_update(
										shared,
										{i2: zone});
								}));
					} else {
						return $author$project$UpdateResult$init(session);
					}
				case 3:
					if (!_v0.b.$) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A4(
							$author$project$UpdateResult$map,
							$author$project$Page$Guest,
							$author$project$Page$GotGuestMsg,
							F2(
								function (extMsg, uR) {
									return A2(
										$author$project$UpdateResult$addExt,
										$author$project$Page$GuestBroadcastMsg(extMsg),
										uR);
								}),
							A2($author$project$Session$Guest$update, subMsg, subModel));
					} else {
						break _v0$7;
					}
				default:
					if (_v0.b.$ === 1) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A4(
							$author$project$UpdateResult$map,
							$author$project$Page$LoggedIn,
							$author$project$Page$GotLoggedInMsg,
							F2(
								function (extMsg, uR) {
									return A2(
										$author$project$UpdateResult$addExt,
										$author$project$Page$LoggedInExternalMsg(extMsg),
										uR);
								}),
							A2($author$project$Session$LoggedIn$update, subMsg, subModel));
					} else {
						break _v0$7;
					}
			}
		}
		return A5(
			$author$project$UpdateResult$logIncompatibleMsg,
			msg,
			$author$project$Page$maybeAccountName(session),
			{e$: 'update', fi: 'Page'},
			_List_Nil,
			$author$project$UpdateResult$init(session));
	});
var $author$project$Page$Community$About$GotTokenInfo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Session$LoggedIn$ShowFeedback = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Token$Model = F5(
	function (supply, maxSupply, minBalance, issuer, type_) {
		return {nY: issuer, od: maxSupply, oh: minBalance, pU: supply, eq: type_};
	});
var $author$project$Token$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$author$project$Token$tokenTypeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'issuer',
		$author$project$Eos$Account$nameDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'min_balance',
			$author$project$Eos$decodeAsset,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'max_supply',
				$author$project$Eos$decodeAsset,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'supply',
					$author$project$Eos$decodeAsset,
					$elm$json$Json$Decode$succeed($author$project$Token$Model))))));
var $author$project$Api$getFromBlockchain = F4(
	function (shared, query, decoder, toMsg) {
		return $elm$http$Http$post(
			{
				f6: $elm$http$Http$jsonBody(
					$author$project$Eos$encodeTableQuery(query)),
				gt: A2($elm$http$Http$expectJson, toMsg, decoder),
				hn: A3(
					$author$project$Api$blockchainUrl,
					shared,
					_List_fromArray(
						['chain', 'get_table_rows']),
					_List_Nil)
			});
	});
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Token$getToken = F3(
	function (shared, symbol, toMsg) {
		return A4(
			$author$project$Api$getFromBlockchain,
			shared,
			{
				ds: shared.hL.p5,
				kx: 1,
				ln: $author$project$Eos$symbolToSymbolCodeString(symbol),
				lB: 'stat'
			},
			A2(
				$elm$json$Json$Decode$field,
				'rows',
				A2($elm$json$Json$Decode$index, 0, $author$project$Token$decoder)),
			toMsg);
	});
var $author$project$Page$Community$About$urlToShareable = function (url) {
	return _Utils_update(
		url,
		{nl: $elm$core$Maybe$Nothing, g_: '', ed: $elm$core$Maybe$Nothing});
};
var $author$project$Page$Community$About$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var community = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A3($author$project$Token$getToken, loggedIn.A, community.as, $author$project$Page$Community$About$GotTokenInfo),
					$author$project$UpdateResult$init(model));
			case 2:
				if (!msg.a.$) {
					var tokenInfo = msg.a.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								fR: $krisajenkins$remotedata$RemoteData$Success(tokenInfo)
							}));
				} else {
					var err = msg.a.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(loggedIn._),
						'Got an error when retrieving token info',
						{e$: 'update', fi: 'Page.Community.About'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.pC)
							]),
						err,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									fR: $krisajenkins$remotedata$RemoteData$Failure(err)
								})));
				}
			case 3:
				var _v1 = loggedIn.pC;
				if (_v1.$ === 3) {
					var community = _v1.a;
					var sharePort = loggedIn.A.jq ? {
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('share')),
									_Utils_Tuple2(
									'title',
									$elm$json$Json$Encode$string(community.fj)),
									_Utils_Tuple2(
									'url',
									$elm$json$Json$Encode$string(
										$elm$url$Url$toString(
											$author$project$Page$Community$About$urlToShareable(loggedIn.A.hn))))
								])),
						fy: msg,
						fz: $elm$json$Json$Encode$null
					} : {
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('copyToClipboard')),
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string('share-fallback-input'))
								])),
						fy: msg,
						fz: $elm$json$Json$Encode$null
					};
					return A2(
						$author$project$UpdateResult$addPort,
						sharePort,
						$author$project$UpdateResult$init(model));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Tried sharing community, but community wasn\'t loaded',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.About'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			default:
				return A2(
					$author$project$UpdateResult$addExt,
					A2(
						$author$project$Session$LoggedIn$ShowFeedback,
						0,
						loggedIn.A.aw.fL('copied_to_clipboard')),
					$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Session$LoggedIn$AddedCommunity = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Invite$AlreadyMemberNotice = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$Invite$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Community$Invite$FormMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Community$Invite$JoinConfirmation = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Invite$KycInfo = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Community$Invite$NotFound = {$: 1};
var $author$project$Page$Community$Invite$Open = 1;
var $author$project$Page$Community$Invite$SignedIn = {$: 6};
var $author$project$Session$LoggedIn$HideFeedback = {$: 13};
var $author$project$Session$LoggedIn$executeFeedback = function (feedback) {
	if (feedback.$ === 1) {
		var status = feedback.a;
		var message = feedback.b;
		return A2($author$project$Session$LoggedIn$ShowFeedback, status, message);
	} else {
		return $author$project$Session$LoggedIn$HideFeedback;
	}
};
var $author$project$Session$LoggedIn$addFeedback = F2(
	function (feedback, ur) {
		return A2(
			$author$project$UpdateResult$addExt,
			$author$project$Session$LoggedIn$executeFeedback(feedback),
			ur);
	});
var $author$project$Page$Community$Invite$getInvite = function (model) {
	var _v0 = model.bI;
	switch (_v0.$) {
		case 3:
			var invite = _v0.a;
			return $elm$core$Maybe$Just(invite);
		case 4:
			var invite = _v0.a;
			return $elm$core$Maybe$Just(invite);
		case 5:
			var invite = _v0.a;
			return $elm$core$Maybe$Just(invite);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Session$LoggedIn$ChangedPin = function (a) {
	return {$: 16, a: a};
};
var $author$project$Session$LoggedIn$DropFromRouteHistoryWhile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Session$LoggedIn$ExternalActionMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Session$LoggedIn$ExternalBroadcast = function (a) {
	return {$: 4, a: a};
};
var $author$project$Session$LoggedIn$RequiredPrivateKey = function (a) {
	return {$: 9, a: a};
};
var $author$project$Session$LoggedIn$SetCommunityField = function (a) {
	return {$: 8, a: a};
};
var $author$project$Session$LoggedIn$ShowCodeOfConductModal = {$: 14};
var $author$project$Session$LoggedIn$ShowInsufficientPermissionsModal = {$: 2};
var $author$project$Session$LoggedIn$UpdatedLoggedIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Session$LoggedIn$mapExternal = F2(
	function (mapFn, msg) {
		switch (msg.$) {
			case 0:
				var model = msg.a;
				return $author$project$Session$LoggedIn$UpdatedLoggedIn(model);
			case 1:
				var dropFn = msg.a;
				return $author$project$Session$LoggedIn$DropFromRouteHistoryWhile(dropFn);
			case 2:
				return $author$project$Session$LoggedIn$ShowInsufficientPermissionsModal;
			case 3:
				var communityInfo = msg.a;
				return $author$project$Session$LoggedIn$AddedCommunity(communityInfo);
			case 4:
				var broadcastMsg = msg.a;
				return $author$project$Session$LoggedIn$ExternalBroadcast(broadcastMsg);
			case 5:
				var resource = msg.a;
				return $author$project$Session$LoggedIn$ReloadResource(resource);
			case 7:
				var field = msg.a;
				return $author$project$Session$LoggedIn$RequestedCommunityField(field);
			case 8:
				var value = msg.a;
				return $author$project$Session$LoggedIn$SetCommunityField(value);
			case 6:
				var field = msg.a;
				return $author$project$Session$LoggedIn$RequestedReloadCommunityField(field);
			case 9:
				var successMsg = msg.a.iX;
				var errorMsg = msg.a.hS;
				return $author$project$Session$LoggedIn$RequiredPrivateKey(
					{
						hS: mapFn(errorMsg),
						iX: mapFn(successMsg)
					});
			case 10:
				var callbackCmd = msg.a.jo;
				return $author$project$Session$LoggedIn$RequiredAuthToken(
					{
						jo: A2(
							$elm$core$Basics$composeR,
							callbackCmd,
							$elm$core$Platform$Cmd$map(mapFn))
					});
			case 11:
				var externalCmdResult = msg.a;
				return $author$project$Session$LoggedIn$RequestQuery(
					A2(
						$elm$core$Platform$Cmd$map,
						function (result) {
							if (result.$ === 1) {
								var callbackCmd = result.a.jo;
								return $elm$core$Result$Err(
									{
										jo: F2(
											function (model, authToken) {
												return A2(
													$elm$core$Platform$Cmd$map,
													mapFn,
													A2(callbackCmd, model, authToken));
											})
									});
							} else {
								var callbackMsg = result.a;
								return $elm$core$Result$Ok(
									mapFn(callbackMsg));
							}
						},
						externalCmdResult));
			case 12:
				var status = msg.a;
				var message = msg.b;
				return A2($author$project$Session$LoggedIn$ShowFeedback, status, message);
			case 13:
				return $author$project$Session$LoggedIn$HideFeedback;
			case 14:
				return $author$project$Session$LoggedIn$ShowCodeOfConductModal;
			case 15:
				var subMsg = msg.a;
				return $author$project$Session$LoggedIn$ExternalActionMsg(subMsg);
			default:
				var newPin = msg.a;
				return $author$project$Session$LoggedIn$ChangedPin(newPin);
		}
	});
var $author$project$Profile$EditKycForm$Saved = function (a) {
	return {$: 2, a: a};
};
var $author$project$Profile$EditKycForm$docToString = function (docType) {
	switch (docType) {
		case 1:
			return 'DIMEX';
		case 2:
			return 'NITE';
		default:
			return 'cedula_de_identidad';
	}
};
var $author$project$Session$LoggedIn$mutation = F3(
	function (model, selectionSet, toMsg) {
		return A4($author$project$Session$LoggedIn$graphqlOperation, $author$project$Api$Graphql$loggedInMutation, model, selectionSet, toMsg);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson = function (jsonValue) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(jsonValue);
};
var $author$project$Cambiatus$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).eW,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$Cambiatus$InputObject$encodeKycDataUpdateInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'countryId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.eJ;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs)(input.a6))),
				_Utils_Tuple2(
				'document',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input.eT))),
				_Utils_Tuple2(
				'documentType',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input.eU))),
				_Utils_Tuple2(
				'phone',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input.fq))),
				_Utils_Tuple2(
				'userType',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input.lU)))
			]));
};
var $author$project$Cambiatus$Mutation$upsertKyc = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'upsertKyc',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs.nG, $author$project$Cambiatus$InputObject$encodeKycDataUpdateInput)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Profile$upsertKycMutation = function (data) {
	return A2(
		$author$project$Cambiatus$Mutation$upsertKyc,
		{
			nG: {a6: '1', eT: data.eT, eU: data.eU, fq: data.fq, lU: 'natural'}
		},
		$author$project$Kyc$selectionSet);
};
var $author$project$Profile$EditKycForm$saveKycData = F2(
	function (loggedIn, formOutput) {
		var data = {
			eT: formOutput.eT,
			eU: $elm$core$String$toLower(
				$author$project$Profile$EditKycForm$docToString(formOutput.eU)),
			nW: false,
			fq: formOutput.o7,
			lU: 'natural'
		};
		return A3(
			$author$project$Session$LoggedIn$mutation,
			loggedIn,
			$author$project$Profile$upsertKycMutation(data),
			$author$project$Profile$EditKycForm$Saved);
	});
var $author$project$Profile$EditKycForm$GotFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Profile$EditKycForm$update = F3(
	function (shared, model, msg) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{hY: newForm});
					},
					$author$project$Profile$EditKycForm$GotFormMsg,
					$author$project$UpdateResult$addExt,
					model,
					A3($author$project$Form$update, shared, subMsg, model.hY));
			case 1:
				return $author$project$UpdateResult$init(model);
			default:
				return $author$project$UpdateResult$init(model);
		}
	});
var $author$project$Page$Community$Invite$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 7:
				var kycFormMsg = msg.a;
				if (session.$ === 1) {
					var loggedIn = session.a;
					var shared = loggedIn.A;
					var formUpdateResult = function () {
						var _v5 = model.fc;
						if (!_v5.$) {
							var f = _v5.a;
							return A3($author$project$Profile$EditKycForm$update, shared, f, kycFormMsg);
						} else {
							return A3($author$project$Profile$EditKycForm$update, shared, $author$project$Profile$EditKycForm$init, kycFormMsg);
						}
					}();
					var newModel = A5(
						$author$project$UpdateResult$fromChild,
						function (newForm) {
							return _Utils_update(
								model,
								{
									fc: $elm$core$Maybe$Just(newForm)
								});
						},
						$author$project$Page$Community$Invite$FormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						formUpdateResult);
					switch (kycFormMsg.$) {
						case 1:
							var formOutput = kycFormMsg.a;
							return A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$mapExternal,
									$author$project$Page$Community$Invite$FormMsg,
									A2($author$project$Profile$EditKycForm$saveKycData, loggedIn, formOutput)),
								newModel);
						case 2:
							var result = kycFormMsg.a;
							if (result.$ === 2) {
								return A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										1,
										shared.aw.fL('error.unknown')),
									newModel);
							} else {
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$LoggedIn$RequiredAuthToken(
										{
											jo: function (_v4) {
												return $author$project$Utils$spawnMessage($author$project$Page$Community$Invite$SignedIn);
											}
										}),
									newModel);
							}
						default:
							return newModel;
					}
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 0:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var invite = msg.a.a.a;
							var userCommunities = function () {
								if (session.$ === 1) {
									var profile = session.a.pl;
									if (profile.$ === 3) {
										var p = profile.a;
										return p.eK;
									} else {
										return _List_Nil;
									}
								} else {
									return _List_Nil;
								}
							}();
							var isAlreadyMember = function () {
								var isMember = function (c) {
									return _Utils_eq(
										$author$project$Eos$symbolToString(c.as),
										$author$project$Eos$symbolToString(invite.V.as));
								};
								return A2($elm$core$List$any, isMember, userCommunities);
							}();
							var newPageStatus = isAlreadyMember ? $author$project$Page$Community$Invite$AlreadyMemberNotice : $author$project$Page$Community$Invite$JoinConfirmation;
							return A2(
								$author$project$UpdateResult$addBreadcrumb,
								{f7: msg, bZ: $elm$core$Dict$empty, n4: 4, of: 'Completed loading invite', eq: 1},
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											bI: newPageStatus(invite)
										})));
						} else {
							var _v8 = msg.a.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{bI: $author$project$Page$Community$Invite$NotFound}));
						}
					case 2:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$author$project$Page$maybeAccountName(session),
							'Got an error when trying to load invite',
							{e$: 'update', fi: 'Page.Community.Invite'},
							_List_Nil,
							error,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										bI: $author$project$Page$Community$Invite$Failed(error)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 1:
				return A2(
					$author$project$UpdateResult$addCmd,
					A4(
						$author$project$Api$Graphql$query,
						$author$project$Page$toShared(session),
						$elm$core$Maybe$Nothing,
						$author$project$Community$inviteQuery(model.kk),
						$author$project$Page$Community$Invite$CompletedLoadInvite),
					$author$project$UpdateResult$init(model));
			case 2:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{eL: 1}));
			case 3:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{eL: 0}));
			case 4:
				var addBreadcrumb = $author$project$UpdateResult$addBreadcrumb(
					{f7: msg, bZ: $elm$core$Dict$empty, n4: 4, of: 'Rejected invitation', eq: 1});
				if (session.$ === 1) {
					var loggedIn = session.a;
					return addBreadcrumb(
						A2(
							$author$project$UpdateResult$addCmd,
							A2($author$project$Route$replaceUrl, loggedIn.A.kK, $author$project$Route$Dashboard),
							$author$project$UpdateResult$init(model)));
				} else {
					var guest = session.a;
					return addBreadcrumb(
						A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$author$project$Route$replaceUrl,
								guest.A.kK,
								A2($author$project$Route$Register, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
							$author$project$UpdateResult$init(model)));
				}
			case 5:
				var invitationId = msg.a;
				var invite = msg.b;
				var userKyc = function () {
					if (session.$ === 1) {
						var profile = session.a.pl;
						if (profile.$ === 3) {
							var p = profile.a;
							return p.ib;
						} else {
							return $elm$core$Maybe$Nothing;
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var areUserKycFieldsFilled = function () {
					if (!userKyc.$) {
						return true;
					} else {
						return false;
					}
				}();
				var allowedToJoinCommunity = (invite.V.by && areUserKycFieldsFilled) || (!invite.V.by);
				var addBreadcrumb = $author$project$UpdateResult$addBreadcrumb(
					{f7: msg, bZ: $elm$core$Dict$empty, n4: 4, of: 'Accepted invitation', eq: 1});
				if (session.$ === 1) {
					return allowedToJoinCommunity ? addBreadcrumb(
						A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$RequiredAuthToken(
								{
									jo: function (_v11) {
										return $author$project$Utils$spawnMessage($author$project$Page$Community$Invite$SignedIn);
									}
								}),
							$author$project$UpdateResult$init(model))) : addBreadcrumb(
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									bI: $author$project$Page$Community$Invite$KycInfo(invite)
								})));
				} else {
					var guest = session.a;
					return addBreadcrumb(
						A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$author$project$Route$replaceUrl,
								guest.A.kK,
								A2(
									$author$project$Route$Register,
									$elm$core$Maybe$Just(invitationId),
									$elm$core$Maybe$Nothing)),
							$author$project$UpdateResult$init(model)));
				}
			default:
				var _v15 = $author$project$Page$Community$Invite$getInvite(model);
				if (_v15.$ === 1) {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Completed signin in, but invite was unavailable',
						$author$project$Page$maybeAccountName(session),
						{e$: 'update', fi: 'Page.Community.Invite'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				} else {
					var community = _v15.a.V;
					var redirectRoute = function () {
						if (session.$ === 1) {
							return $author$project$Route$Dashboard;
						} else {
							var guest = session.a;
							return A2($elm$core$Maybe$withDefault, $author$project$Route$Dashboard, guest.me);
						}
					}();
					var navKey = $author$project$Page$toShared(session).kK;
					var communityInfo = {nn: community.bz, by: community.by, bB: community.bB, fe: community.fe, fj: community.fj, pP: community.pP, as: community.as};
					return A2(
						$author$project$UpdateResult$addBreadcrumb,
						{f7: msg, bZ: $elm$core$Dict$empty, n4: 3, of: 'Signed in', eq: 3},
						A2(
							$author$project$UpdateResult$addCmd,
							A2($author$project$Route$pushUrl, navKey, redirectRoute),
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$AddedCommunity(communityInfo),
								$author$project$UpdateResult$init(model))));
				}
		}
	});
var $author$project$Page$Community$New$ClosedAuthModal = {$: 7};
var $author$project$Page$Community$New$GotDomainAvailableResponse = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Community$New$GotFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Eos$boolToEosBool = function (b) {
	return b ? 0 : 1;
};
var $author$project$Community$createCommunityData = function (params) {
	return {
		hG: {ji: 0, as: params.as},
		jz: params._,
		aR: params.aR,
		bx: $author$project$Eos$boolToEosBool(params.bx),
		by: $author$project$Eos$boolToEosBool(params.by),
		bz: $author$project$Eos$boolToEosBool(params.bz),
		bB: $author$project$Eos$boolToEosBool(params.bB),
		b5: {ji: params.b5, as: params.as},
		b6: {ji: params.b6, as: params.as},
		ff: params.ff,
		fj: params.fj,
		pP: params.pP,
		bT: params.bT
	};
};
var $author$project$Cambiatus$Query$domainAvailable = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'domainAvailable',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'domain', requiredArgs.jH, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Cambiatus$Object$Exists$exists = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Bool)',
	'exists',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool));
var $author$project$Community$domainAvailableSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Maybe$withDefault(false),
	$author$project$Cambiatus$Object$Exists$exists);
var $author$project$Community$domainAvailableQuery = function (domain) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$core$Basics$not),
			$elm$core$Maybe$withDefault(false)),
		A2(
			$author$project$Cambiatus$Query$domainAvailable,
			{jH: domain},
			$author$project$Community$domainAvailableSelectionSet));
};
var $henriquecbuss$elm_mask$Mask$Precisely = function (a) {
	return {$: 0, a: a};
};
var $henriquecbuss$elm_mask$Mask$addThousandsSeparator = F2(
	function (separator, value) {
		return A2(
			$elm$core$String$join,
			separator,
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				function (_v1) {
					var currentGroups = _v1.eQ;
					var currentGroup = _v1.eP;
					return A2($elm$core$List$cons, currentGroup, currentGroups);
				}(
					A3(
						$elm$core$String$foldr,
						F2(
							function (currentChar, _v0) {
								var currentCount = _v0.gm;
								var currentGroups = _v0.eQ;
								var currentGroup = _v0.eP;
								return (currentCount === 2) ? {
									gm: 0,
									eP: '',
									eQ: A2(
										$elm$core$List$cons,
										A2($elm$core$String$cons, currentChar, currentGroup),
										currentGroups)
								} : {
									gm: currentCount + 1,
									eP: A2($elm$core$String$cons, currentChar, currentGroup),
									eQ: currentGroups
								};
							}),
						{gm: 0, eP: '', eQ: _List_Nil},
						value))));
	});
var $henriquecbuss$elm_mask$Mask$padFloat = F2(
	function (decimalDigits, maybeAfterSeparator) {
		var emptyStringToNothing = function (str) {
			return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
		};
		if (!decimalDigits.$) {
			var n = decimalDigits.a;
			if (maybeAfterSeparator.$ === 1) {
				return emptyStringToNothing(
					A2($elm$core$String$repeat, n, '0'));
			} else {
				var afterSeparator = maybeAfterSeparator.a;
				return emptyStringToNothing(
					A2(
						$elm$core$String$left,
						n,
						_Utils_ap(
							afterSeparator,
							A2(
								$elm$core$String$repeat,
								n - $elm$core$String$length(afterSeparator),
								'0'))));
			}
		} else {
			var n = decimalDigits.a;
			return A2(
				$elm$core$Maybe$andThen,
				emptyStringToNothing,
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$left(n),
					maybeAfterSeparator));
		}
	});
var $henriquecbuss$elm_mask$Mask$float = F3(
	function (decimalDigits, _v0, value) {
		var decimalSeparator = _v0.jD;
		var thousandsSeparator = _v0.p1;
		var _v1 = A2(
			$elm$core$String$split,
			'.',
			$elm$core$String$fromFloat(value));
		if (!_v1.b) {
			return $elm$core$String$fromFloat(value);
		} else {
			if (!_v1.b.b) {
				var noSeparator = _v1.a;
				return A2(
					$elm$core$String$join,
					decimalSeparator,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A2($henriquecbuss$elm_mask$Mask$addThousandsSeparator, thousandsSeparator, noSeparator)),
								A2($henriquecbuss$elm_mask$Mask$padFloat, decimalDigits, $elm$core$Maybe$Nothing)
							])));
			} else {
				var beforeSeparator = _v1.a;
				var _v2 = _v1.b;
				var afterSeparator = _v2.a;
				return A2(
					$elm$core$String$join,
					decimalSeparator,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A2($henriquecbuss$elm_mask$Mask$addThousandsSeparator, thousandsSeparator, beforeSeparator)),
								A2(
								$henriquecbuss$elm_mask$Mask$padFloat,
								decimalDigits,
								$elm$core$Maybe$Just(afterSeparator))
							])));
			}
		}
	});
var $author$project$Utils$formatFloat = F3(
	function (maybeTranslators, decimalCases, number) {
		return A3(
			$henriquecbuss$elm_mask$Mask$float,
			$henriquecbuss$elm_mask$Mask$Precisely(decimalCases),
			function () {
				if (!maybeTranslators.$) {
					var t = maybeTranslators.a.fL;
					return {
						jD: t('decimal_separator'),
						p1: t('thousands_separator')
					};
				} else {
					return {jD: '.', p1: ''};
				}
			}(),
			number);
	});
var $author$project$Eos$getSymbolPrecision = function (_v0) {
	var precision = _v0.b;
	return precision;
};
var $author$project$Eos$encodeAsset = function (asset) {
	return $elm$json$Json$Encode$string(
		A3(
			$author$project$Utils$formatFloat,
			$elm$core$Maybe$Nothing,
			$author$project$Eos$getSymbolPrecision(asset.as),
			asset.ji) + (' ' + $author$project$Eos$symbolToSymbolCodeString(asset.as)));
};
var $author$project$Eos$encodeEosBool = function (eosBool) {
	if (!eosBool) {
		return $elm$json$Json$Encode$int(1);
	} else {
		return $elm$json$Json$Encode$int(0);
	}
};
var $author$project$Community$encodeCreateCommunityData = function (c) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'cmm_asset',
				$author$project$Eos$encodeAsset(c.hG)),
				_Utils_Tuple2(
				'creator',
				$author$project$Eos$Account$encodeName(c.jz)),
				_Utils_Tuple2(
				'logo',
				$elm$json$Json$Encode$string(c.ff)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(c.fj)),
				_Utils_Tuple2(
				'description',
				$author$project$Markdown$encode(c.aR)),
				_Utils_Tuple2(
				'subdomain',
				$elm$json$Json$Encode$string(c.pP)),
				_Utils_Tuple2(
				'inviter_reward',
				$author$project$Eos$encodeAsset(c.b6)),
				_Utils_Tuple2(
				'invited_reward',
				$author$project$Eos$encodeAsset(c.b5)),
				_Utils_Tuple2(
				'has_objectives',
				$author$project$Eos$encodeEosBool(c.bz)),
				_Utils_Tuple2(
				'has_shop',
				$author$project$Eos$encodeEosBool(c.bB)),
				_Utils_Tuple2(
				'has_kyc',
				$author$project$Eos$encodeEosBool(c.by)),
				_Utils_Tuple2(
				'auto_invite',
				$author$project$Eos$encodeEosBool(c.bx)),
				_Utils_Tuple2(
				'website',
				$elm$json$Json$Encode$string(c.bT))
			]));
};
var $author$project$Token$tokenTypeToString = function (tokenType) {
	if (!tokenType) {
		return 'mcc';
	} else {
		return 'expiry';
	}
};
var $author$project$Token$encodeTokenType = A2($elm$core$Basics$composeR, $author$project$Token$tokenTypeToString, $elm$json$Json$Encode$string);
var $author$project$Token$encodeCreateTokenData = function (c) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'issuer',
				$author$project$Eos$Account$encodeName(c.jz)),
				_Utils_Tuple2(
				'max_supply',
				$author$project$Eos$encodeAsset(c.od)),
				_Utils_Tuple2(
				'min_balance',
				$author$project$Eos$encodeAsset(c.oh)),
				_Utils_Tuple2(
				'type',
				$author$project$Token$encodeTokenType(c.p6))
			]));
};
var $author$project$Eos$eosBoolToBool = function (eosBool) {
	if (!eosBool) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Cambiatus$InputObject$encodeNewCommunityInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'symbol',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input.as)))
			]));
};
var $author$project$Cambiatus$Subscription$newcommunity = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'newcommunity',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs.nG, $author$project$Cambiatus$InputObject$encodeNewCommunityInput)
				]),
			object_,
			$elm$core$Basics$identity);
	});
var $author$project$Community$newCommunitySubscription = function (symbol) {
	var stringSymbol = $elm$core$String$toUpper(
		$author$project$Eos$symbolToString(symbol));
	var selectionSet = $author$project$Cambiatus$Object$Community$name;
	var args = {
		nG: {as: stringSymbol}
	};
	return A2($author$project$Cambiatus$Subscription$newcommunity, args, selectionSet);
};
var $author$project$Session$LoggedIn$withPrivateKey = F5(
	function (model, requiredPermissions, subModel, subMsg, successfulUR) {
		return A4(
			$author$project$Auth$withPrivateKey,
			model.ml,
			{
				mU: A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pz;
						},
						$elm$core$List$concatMap(
							function ($) {
								return $.o6;
							})),
					$author$project$Session$LoggedIn$profile(model)),
				pv: requiredPermissions
			},
			{
				mZ: subModel,
				oC: A5(
					$author$project$UpdateResult$logImpossible,
					subMsg.iX,
					'Tried signing eos transaction, but profile wasn\'t loaded',
					$elm$core$Maybe$Just(model._),
					{e$: 'withPrivateKey', fi: 'Session.LoggedIn'},
					_List_Nil),
				oE: $author$project$UpdateResult$addExt(
					$author$project$Session$LoggedIn$RequiredPrivateKey(subMsg)),
				oO: $author$project$UpdateResult$addExt($author$project$Session$LoggedIn$ShowInsufficientPermissionsModal)
			},
			function (_v0) {
				return successfulUR;
			});
	});
var $author$project$Page$Community$New$update = F3(
	function (msg, model, loggedIn) {
		var t = loggedIn.A.aw.fL;
		switch (msg.$) {
			case 2:
				var formOutput = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					A3(
						$author$project$Session$LoggedIn$query,
						loggedIn,
						$author$project$Community$domainAvailableQuery(formOutput.hn.e3),
						$author$project$Page$Community$New$GotDomainAvailableResponse(formOutput)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{nP: true})));
			case 1:
				var index = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							hY: A2(
								$author$project$Form$updateValues,
								function (form) {
									return _Utils_update(
										form,
										{ha: index});
								},
								model.hY)
						}));
			case 3:
				switch (msg.b.$) {
					case 3:
						if (msg.b.a) {
							var formOutput = msg.a;
							var createTokenData = {
								jz: loggedIn._,
								od: {ji: 21000000.0, as: formOutput.as},
								oh: {ji: formOutput.d0, as: formOutput.as},
								p6: 0
							};
							var createCommunityData = $author$project$Community$createCommunityData(
								{
									_: loggedIn._,
									aR: formOutput.aR,
									bx: !formOutput.eg,
									by: false,
									bz: true,
									bB: true,
									b5: formOutput.b5,
									b6: formOutput.b6,
									ff: formOutput.fe,
									fj: formOutput.fj,
									pP: formOutput.hn.e3,
									as: formOutput.as,
									bT: function () {
										var _v1 = formOutput.bT;
										if (_v1.$ === 1) {
											return '';
										} else {
											var website = _v1.a;
											return (A2($elm$core$String$startsWith, 'https://', website) || A2($elm$core$String$startsWith, 'http://', website)) ? website : ('http://' + website);
										}
									}()
								});
							var subscriptionDoc = $dillonkearns$elm_graphql$Graphql$Document$serializeSubscription(
								$author$project$Community$newCommunitySubscription(createCommunityData.hG.as));
							return A2(
								$author$project$UpdateResult$addBreadcrumb,
								{
									f7: msg,
									bZ: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'domain',
												$elm$json$Json$Encode$string(formOutput.hn.e3))
											])),
									n4: 4,
									of: 'Checked that domain is available',
									eq: 1
								},
								A5(
									$author$project$Session$LoggedIn$withPrivateKey,
									loggedIn,
									_List_Nil,
									model,
									{hS: $author$project$Page$Community$New$ClosedAuthModal, iX: msg},
									A2(
										$author$project$UpdateResult$addPort,
										{
											bZ: $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'name',
														$elm$json$Json$Encode$string('subscribeToNewCommunity')),
														_Utils_Tuple2(
														'subscription',
														$elm$json$Json$Encode$string(subscriptionDoc))
													])),
											fy: A2(
												$author$project$Page$Community$New$GotDomainAvailableResponse,
												formOutput,
												$krisajenkins$remotedata$RemoteData$Success(true)),
											fz: $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'createCommunityData',
														$author$project$Community$encodeCreateCommunityData(createCommunityData)),
														_Utils_Tuple2(
														'createTokenData',
														$author$project$Token$encodeCreateTokenData(createTokenData))
													]))
										},
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{nP: true})))));
						} else {
							var formOutput = msg.a;
							return A2(
								$author$project$UpdateResult$addBreadcrumb,
								{
									f7: msg,
									bZ: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'domain',
												$elm$json$Json$Encode$string(formOutput.hn.e3))
											])),
									n4: 4,
									of: 'Tried domain that is unavailable',
									eq: 1
								},
								A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										1,
										loggedIn.A.aw.fL('settings.community_info.errors.url.already_taken')),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{nP: false}))));
						}
					case 2:
						var formOutput = msg.a;
						var err = msg.b.a;
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								loggedIn.A.aw.fL('error.unknown')),
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Just(loggedIn._),
								'Got an error when checking if community domain is available',
								{e$: 'update', fi: 'Page.Community.New'},
								_List_fromArray(
									[
										{
										ng: $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'tried',
													$elm$json$Json$Encode$string(formOutput.hn.e3))
												])),
										fj: 'Domain'
									}
									]),
								err,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{nP: false}))));
					case 0:
						var _v2 = msg.b;
						return $author$project$UpdateResult$init(model);
					default:
						var _v3 = msg.b;
						return $author$project$UpdateResult$init(model);
				}
			case 4:
				var createCommunityData = msg.a;
				var createTokenData = msg.b;
				var authorization = {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission};
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $author$project$Eos$encodeTransaction(
							_List_fromArray(
								[
									{
									_: loggedIn.A.hL.V,
									hw: authorization,
									bZ: $author$project$Community$encodeCreateCommunityData(createCommunityData),
									fj: 'create'
								},
									{
									_: loggedIn.A.hL.p5,
									hw: authorization,
									bZ: $author$project$Token$encodeCreateTokenData(createTokenData),
									fj: 'create'
								}
								])),
						fy: A2($author$project$Page$Community$New$StartedCreatingCommunity, createCommunityData, createTokenData),
						fz: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'symbol',
									$author$project$Eos$encodeSymbol(createCommunityData.hG.as)),
									_Utils_Tuple2(
									'subdomain',
									$elm$json$Json$Encode$string(createCommunityData.pP))
								]))
					},
					$author$project$UpdateResult$init(model));
			case 5:
				if (!msg.a.$) {
					return A2(
						$author$project$UpdateResult$addCmd,
						A2($author$project$Route$pushUrl, loggedIn.A.kK, $author$project$Route$Dashboard),
						A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								0,
								loggedIn.A.aw.fL('community.create.created')),
							$author$project$UpdateResult$init(model)));
				} else {
					var val = msg.a.a;
					return A7(
						$author$project$UpdateResult$logJsonValue,
						msg,
						$elm$core$Maybe$Just(loggedIn._),
						'Got an error when creating a community',
						{e$: 'update', fi: 'Page.Community.New'},
						_List_Nil,
						val,
						A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								t('error.unknown')),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{nP: false}))));
				}
			case 6:
				var communityData = msg.a;
				var communityInfo = {
					nn: $author$project$Eos$eosBoolToBool(communityData.bz),
					by: $author$project$Eos$eosBoolToBool(communityData.by),
					bB: $author$project$Eos$eosBoolToBool(communityData.bB),
					fe: communityData.ff,
					fj: communityData.fj,
					pP: communityData.pP,
					as: communityData.hG.as
				};
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$AddedCommunity(communityInfo),
					$author$project$UpdateResult$init(model));
			case 7:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{nP: false}));
			default:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{hY: newForm});
					},
					$author$project$Page$Community$New$GotFormMsg,
					$author$project$Session$LoggedIn$addFeedback,
					model,
					A3($author$project$Form$update, loggedIn.A, subMsg, model.hY));
		}
	});
var $author$project$Page$Community$Objectives$GotObjectiveDetailsHeight = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Community$Objectives$GotObjectiveSummaryHeight = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Page$Community$Objectives$GotVisibleActionViewport = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Action$idToString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Page$Community$Objectives$actionCardId = function (actionId) {
	return 'action-card-' + $author$project$Action$idToString(actionId);
};
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $pzp1997$assoc_list$AssocList$foldl = F3(
	function (func, initialResult, _v0) {
		var alist = _v0;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, result) {
					var key = _v1.a;
					var value = _v1.b;
					return A3(func, key, value, result);
				}),
			initialResult,
			alist);
	});
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $author$project$Action$idFromString = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toInt,
	$elm$core$Maybe$map($elm$core$Basics$identity));
var $author$project$Page$Community$Objectives$idFromActionCardId = function (elementId) {
	return $author$project$Action$idFromString(
		A2($elm$core$String$dropLeft, 12, elementId));
};
var $author$project$Page$Community$Objectives$objectiveContainerId = function (objective) {
	return 'objective-container-' + $elm$core$String$fromInt(
		$author$project$Action$objectiveIdToInt(objective.w));
};
var $author$project$Page$Community$Objectives$objectiveDetailsId = function (objective) {
	return 'objective-details-' + $elm$core$String$fromInt(
		$author$project$Action$objectiveIdToInt(objective.w));
};
var $author$project$Page$Community$Objectives$objectiveSummaryId = function (objective) {
	return 'objective-summary-' + $elm$core$String$fromInt(
		$author$project$Action$objectiveIdToInt(objective.w));
};
var $author$project$Action$ClickedClaimAction = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Action$startClaiming = F2(
	function (position, action) {
		return A2($author$project$Action$ClickedClaimAction, position, action);
	});
var $pzp1997$assoc_list$AssocList$update = F3(
	function (targetKey, alter, dict) {
		var alist = dict;
		var maybeValue = A2($pzp1997$assoc_list$AssocList$get, targetKey, dict);
		if (!maybeValue.$) {
			var _v1 = alter(maybeValue);
			if (!_v1.$) {
				var alteredValue = _v1.a;
				return A2(
					$elm$core$List$map,
					function (entry) {
						var key = entry.a;
						return _Utils_eq(key, targetKey) ? _Utils_Tuple2(targetKey, alteredValue) : entry;
					},
					alist);
			} else {
				return A2($pzp1997$assoc_list$AssocList$remove, targetKey, dict);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (!_v2.$) {
				var alteredValue = _v2.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(targetKey, alteredValue),
					alist);
			} else {
				return dict;
			}
		}
	});
var $author$project$Page$Community$Objectives$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var objectives = msg.a;
				var startClaimingAction = function () {
					var _v4 = model.b2;
					if (_v4.$ === 1) {
						return $elm$core$Basics$identity;
					} else {
						var objectiveId = _v4.a.kP;
						var actionId = _v4.a.f_;
						var maybeActionAndPosition = A2(
							$elm$core$Maybe$andThen,
							function (foundObjective) {
								return A3(
									$elm$core$Maybe$map2,
									$elm$core$Tuple$pair,
									A2(
										$elm_community$list_extra$List$Extra$find,
										function (action) {
											return _Utils_eq(
												$elm$core$Maybe$Just(action.w),
												actionId);
										},
										foundObjective.mb),
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$add(1),
										A2(
											$elm_community$list_extra$List$Extra$findIndex,
											function (action) {
												return _Utils_eq(
													$elm$core$Maybe$Just(action.w),
													actionId);
											},
											foundObjective.mb)));
							},
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (objective) {
									return _Utils_eq(objective.w, objectiveId);
								},
								objectives));
						if (maybeActionAndPosition.$ === 1) {
							return $elm$core$Basics$identity;
						} else {
							var _v6 = maybeActionAndPosition.a;
							var action = _v6.a;
							var position = _v6.b;
							return $author$project$UpdateResult$addExt(
								$author$project$Session$LoggedIn$ExternalActionMsg(
									A2(
										$author$project$Action$startClaiming,
										{
											bq: $elm$core$Maybe$Just(position)
										},
										action)));
						}
					}
				}();
				var scrollActionIntoView = function () {
					var _v1 = model.b2;
					if (_v1.$ === 1) {
						return $elm$core$Basics$identity;
					} else {
						var objectiveId = _v1.a.kP;
						var actionId = _v1.a.f_;
						var maybeAction = A2(
							$elm$core$Maybe$andThen,
							function (foundObjective) {
								return A2(
									$elm_community$list_extra$List$Extra$find,
									function (action) {
										return _Utils_eq(
											$elm$core$Maybe$Just(action.w),
											actionId);
									},
									foundObjective.mb);
							},
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (objective) {
									return _Utils_eq(objective.w, objectiveId);
								},
								objectives));
						var getHighlightedObjectiveSummaryHeight = function () {
							var _v3 = A2(
								$elm_community$list_extra$List$Extra$find,
								function (objective) {
									return _Utils_eq(objective.w, objectiveId);
								},
								objectives);
							if (!_v3.$) {
								var objective = _v3.a;
								return $author$project$UpdateResult$addCmd(
									A2(
										$elm$core$Task$attempt,
										$author$project$Page$Community$Objectives$GotObjectiveSummaryHeight(objective),
										$elm$browser$Browser$Dom$getElement(
											$author$project$Page$Community$Objectives$objectiveSummaryId(objective))));
							} else {
								return $elm$core$Basics$identity;
							}
						}();
						if (maybeAction.$ === 1) {
							var hasObjective = A2(
								$elm$core$List$any,
								function (objective) {
									return _Utils_eq(objective.w, objectiveId);
								},
								objectives);
							return hasObjective ? A2(
								$elm$core$Basics$composeR,
								$author$project$UpdateResult$addPort(
									{
										bZ: $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string('scrollIntoView')),
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(
														$author$project$Page$Community$Objectives$objectiveDetailsId(
															{w: objectiveId})))
												])),
										fy: $author$project$Page$Community$Objectives$NoOp,
										fz: $elm$json$Json$Encode$null
									}),
								getHighlightedObjectiveSummaryHeight) : $elm$core$Basics$identity;
						} else {
							var highlightedAction = maybeAction.a;
							return A2(
								$elm$core$Basics$composeR,
								$author$project$UpdateResult$addPort(
									{
										bZ: $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string('scrollIntoView')),
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(
														$author$project$Page$Community$Objectives$actionCardId(highlightedAction.w)))
												])),
										fy: $author$project$Page$Community$Objectives$NoOp,
										fz: $elm$json$Json$Encode$null
									}),
								getHighlightedObjectiveSummaryHeight);
						}
					}
				}();
				return startClaimingAction(
					scrollActionIntoView(
						$author$project$UpdateResult$init(model)));
			case 2:
				var objective = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						$author$project$Page$Community$Objectives$GotObjectiveSummaryHeight(objective),
						$elm$browser$Browser$Dom$getElement(
							$author$project$Page$Community$Objectives$objectiveSummaryId(objective))),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								b2: $elm$core$Maybe$Nothing,
								E: A3(
									$pzp1997$assoc_list$AssocList$update,
									objective.w,
									function (currentValue) {
										if (currentValue.$ === 1) {
											return $elm$core$Maybe$Just(
												{a3: $elm$core$Maybe$Nothing, bh: false, bn: $elm$core$Maybe$Nothing, bJ: $elm$core$Maybe$Nothing, bK: $elm$core$Maybe$Nothing, bR: $elm$core$Maybe$Nothing, bS: $elm$core$Maybe$Nothing});
										} else {
											var value = currentValue.a;
											return $elm$core$Maybe$Just(
												_Utils_update(
													value,
													{bh: true}));
										}
									},
									model.E)
							})));
			case 3:
				var objective = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						$author$project$Page$Community$Objectives$GotObjectiveDetailsHeight(objective),
						$elm$browser$Browser$Dom$getElement(
							$author$project$Page$Community$Objectives$objectiveDetailsId(objective))),
					$author$project$UpdateResult$init(model));
			case 4:
				var objective = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							E: A2($pzp1997$assoc_list$AssocList$remove, objective.w, model.E)
						}));
			case 5:
				if (!msg.b.$) {
					var objective = msg.a;
					var element = msg.b.a.jJ;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								E: A3(
									$pzp1997$assoc_list$AssocList$update,
									objective.w,
									$elm$core$Maybe$map(
										function (value) {
											return _Utils_update(
												value,
												{
													bn: $elm$core$Maybe$Just(element.gD)
												});
										}),
									model.E)
							}));
				} else {
					var id = msg.b.a;
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Couldn\'t get objective details height',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Objectives'},
						_List_fromArray(
							[
								{
								ng: $elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'type',
											$elm$json$Json$Encode$string('Browser.Dom.NotFound')),
											_Utils_Tuple2(
											'id',
											$elm$json$Json$Encode$string(id))
										])),
								fj: 'Error'
							}
							]),
						$author$project$UpdateResult$init(model));
				}
			case 6:
				if (!msg.b.$) {
					var objective = msg.a;
					var element = msg.b.a.jJ;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								E: A3(
									$pzp1997$assoc_list$AssocList$update,
									objective.w,
									$elm$core$Maybe$map(
										function (value) {
											return _Utils_update(
												value,
												{
													a3: $elm$core$Maybe$Just(element.gD)
												});
										}),
									model.E)
							}));
				} else {
					var id = msg.b.a;
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Couldn\'t get objective summary height',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Objectives'},
						_List_fromArray(
							[
								{
								ng: $elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'type',
											$elm$json$Json$Encode$string('Browser.Dom.NotFound')),
											_Utils_Tuple2(
											'id',
											$elm$json$Json$Encode$string(id))
										])),
								fj: 'Error'
							}
							]),
						$author$project$UpdateResult$init(model));
				}
			case 7:
				if (!msg.b.$) {
					var objectiveId = msg.a.kP;
					var actionId = msg.a.f_;
					var viewport = msg.b.a.qj;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								E: A3(
									$pzp1997$assoc_list$AssocList$update,
									objectiveId,
									function (maybeValue) {
										if (maybeValue.$ === 1) {
											return $elm$core$Maybe$Just(
												{
													a3: $elm$core$Maybe$Nothing,
													bh: false,
													bn: $elm$core$Maybe$Nothing,
													bJ: $elm$core$Maybe$Nothing,
													bK: $elm$core$Maybe$Nothing,
													bR: $elm$core$Maybe$Just(actionId),
													bS: $elm$core$Maybe$Just(viewport.gD)
												});
										} else {
											var value = maybeValue.a;
											return $elm$core$Maybe$Just(
												_Utils_update(
													value,
													{
														bS: $elm$core$Maybe$Just(viewport.gD)
													}));
										}
									},
									model.E)
							}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 8:
				var action = msg.a;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('smoothHorizontalScroll')),
									_Utils_Tuple2(
									'containerId',
									$elm$json$Json$Encode$string(
										$author$project$Page$Community$Objectives$objectiveContainerId(action.ad))),
									_Utils_Tuple2(
									'targetId',
									$elm$json$Json$Encode$string(
										$author$project$Page$Community$Objectives$actionCardId(action.w)))
								])),
						fy: $author$project$Page$Community$Objectives$NoOp,
						fz: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(model));
			case 9:
				var subMsg = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$ExternalActionMsg(subMsg),
					$author$project$UpdateResult$init(model));
			case 10:
				var actionCard = msg.a;
				var _v9 = A2(
					$author$project$Community$getField,
					loggedIn.pC,
					function ($) {
						return $.cV;
					});
				if (_v9.$ === 3) {
					var _v10 = _v9.a;
					var objectives = _v10.b;
					var maybeActionIdAndParentObjective = A2(
						$elm$core$Maybe$andThen,
						function (actionId) {
							return A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$pair(actionId),
								A2(
									$elm_community$list_extra$List$Extra$find,
									function (objective) {
										return A2(
											$elm$core$List$member,
											actionId,
											A2(
												$elm$core$List$map,
												function ($) {
													return $.w;
												},
												objective.mb));
									},
									objectives));
						},
						$author$project$Page$Community$Objectives$idFromActionCardId(actionCard));
					if (maybeActionIdAndParentObjective.$ === 1) {
						return $author$project$UpdateResult$init(model);
					} else {
						var _v12 = maybeActionIdAndParentObjective.a;
						var actionId = _v12.a;
						var parentObjective = _v12.b;
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$elm$core$Task$attempt,
								$author$project$Page$Community$Objectives$GotVisibleActionViewport(
									{f_: actionId, kP: parentObjective.w}),
								$elm$browser$Browser$Dom$getViewportOf(actionCard)),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										E: A3(
											$pzp1997$assoc_list$AssocList$update,
											parentObjective.w,
											function (maybeValue) {
												if (maybeValue.$ === 1) {
													return $elm$core$Maybe$Just(
														{
															a3: $elm$core$Maybe$Nothing,
															bh: false,
															bn: $elm$core$Maybe$Nothing,
															bJ: $elm$core$Maybe$Nothing,
															bK: $elm$core$Maybe$Nothing,
															bR: $elm$core$Maybe$Just(actionId),
															bS: $elm$core$Maybe$Nothing
														});
												} else {
													var value = maybeValue.a;
													return $elm$core$Maybe$Just(
														{
															a3: value.a3,
															bh: value.bh,
															bn: value.bn,
															bJ: value.bR,
															bK: value.bS,
															bR: $elm$core$Maybe$Just(actionId),
															bS: $elm$core$Maybe$Nothing
														});
												}
											},
											model.E)
									})));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Action started showing up, but objectives weren\'t loaded',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Objectives'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.pC)
							]),
						$author$project$UpdateResult$init(model));
				}
			default:
				var targetId = msg.a;
				var newShownObjectives = A3(
					$pzp1997$assoc_list$AssocList$foldl,
					F3(
						function (objectiveId, value, currDict) {
							return _Utils_eq(
								value.bR,
								$author$project$Page$Community$Objectives$idFromActionCardId(targetId)) ? A3(
								$pzp1997$assoc_list$AssocList$insert,
								objectiveId,
								{a3: value.a3, bh: value.bh, bn: value.bn, bJ: $elm$core$Maybe$Nothing, bK: $elm$core$Maybe$Nothing, bR: value.bJ, bS: value.bK},
								currDict) : (_Utils_eq(
								value.bJ,
								$author$project$Page$Community$Objectives$idFromActionCardId(targetId)) ? A3(
								$pzp1997$assoc_list$AssocList$insert,
								objectiveId,
								_Utils_update(
									value,
									{bJ: $elm$core$Maybe$Nothing, bK: $elm$core$Maybe$Nothing}),
								currDict) : A3($pzp1997$assoc_list$AssocList$insert, objectiveId, value, currDict));
						}),
					$pzp1997$assoc_list$AssocList$empty,
					model.E);
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{E: newShownObjectives}));
		}
	});
var $author$project$Page$Community$Settings$ActionEditor$Authorized = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$Community$Settings$ActionEditor$ClosedAuthModal = {$: 2};
var $author$project$Page$Community$Settings$ActionEditor$GotFormMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Settings$ActionEditor$NotFound = {$: 2};
var $author$project$Page$Community$Settings$ActionEditor$Unauthorized = {$: 3};
var $author$project$Page$Community$Settings$ActionEditor$Three = 0;
var $author$project$Eos$formatSymbolAmount = F3(
	function (translators, _v0, amount) {
		var precision = _v0.b;
		return A3(
			$author$project$Utils$formatFloat,
			$elm$core$Maybe$Just(translators),
			precision,
			amount);
	});
var $author$project$Utils$fromMaybeDateTime = function (maybeDateTime) {
	if (maybeDateTime.$ === 1) {
		return $elm$time$Time$millisToPosix(0);
	} else {
		var dateTime = maybeDateTime.a;
		return $author$project$Utils$fromDateTime(dateTime);
	}
};
var $author$project$Form$UserPicker$MultiplePickerModel = $elm$core$Basics$identity;
var $author$project$Form$UserPicker$initMultiple = function (_v0) {
	var id = _v0.w;
	var selectedProfiles = _v0.ej;
	return {
		w: id,
		G: $author$project$View$Select$newState(id),
		ej: A2(
			$elm$core$List$map,
			function (profile) {
				return {
					pl: profile,
					bu: $author$project$Profile$Summary$init(false)
				};
			},
			selectedProfiles)
	};
};
var $author$project$Page$Community$Settings$ActionEditor$Five = 1;
var $author$project$Page$Community$Settings$ActionEditor$Nine = 3;
var $author$project$Page$Community$Settings$ActionEditor$Seven = 2;
var $author$project$Page$Community$Settings$ActionEditor$minVotesFromInt = function (minVotes) {
	switch (minVotes) {
		case 3:
			return $elm$core$Maybe$Just(0);
		case 5:
			return $elm$core$Maybe$Just(1);
		case 7:
			return $elm$core$Maybe$Just(2);
		case 9:
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$ActionEditor$initFormInput = F3(
	function (shared, community, maybeAction) {
		var afterNow = function (posix) {
			return (_Utils_cmp(
				$elm$time$Time$posixToMillis(posix),
				$elm$time$Time$posixToMillis(shared.ce)) > -1) ? posix : shared.ce;
		};
		return $author$project$Form$init(
			{
				aR: A2(
					$author$project$Form$RichText$initModel,
					'description-editor',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.aR;
						},
						maybeAction)),
				cI: $author$project$Form$DatePicker$initModel(
					A2(
						$justinmimbs$date$Date$fromPosix,
						shared.i2,
						A2(
							$elm$core$Maybe$withDefault,
							shared.ce,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.go;
									},
									A2($elm$core$Basics$composeR, $author$project$Utils$fromMaybeDateTime, afterNow)),
								maybeAction)))),
				h2: $author$project$Form$File$initSingle(
					{
						mj: $elm$core$Maybe$Just(388 / 144),
						ni: A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.h2;
							},
							maybeAction)
					}),
				cb: $elm$core$String$fromInt(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ja;
							},
							maybeAction))),
				fA: A3(
					$author$project$Eos$formatSymbolAmount,
					shared.aw,
					community.as,
					A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fA;
							},
							maybeAction))),
				jb: A2(
					$elm$core$Maybe$andThen,
					function (action) {
						return (action.ja > 0) ? $elm$core$Maybe$Just(
							$elm$core$String$fromInt(action.jb)) : $elm$core$Maybe$Nothing;
					},
					maybeAction),
				dc: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.go;
							},
							$elm_community$maybe_extra$Maybe$Extra$isJust),
						maybeAction)),
				cu: function (usages) {
					return usages > 0;
				}(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ja;
							},
							maybeAction))),
				hp: {
					dF: {
						dM: A2($author$project$Form$RichText$initModel, 'proof-instructions-input', $elm$core$Maybe$Nothing),
						fX: A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.gB;
								},
								maybeAction)),
						es: A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.dI;
								},
								maybeAction))
					},
					bk: A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.lX;
								},
								$author$project$Page$Community$Settings$ActionEditor$minVotesFromInt),
							maybeAction)),
					jc: A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.jc;
							},
							maybeAction)),
					lY: A3(
						$author$project$Eos$formatSymbolAmount,
						shared.aw,
						community.as,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.lY;
								},
								maybeAction))),
					eu: $author$project$Form$UserPicker$initMultiple(
						{
							w: 'verifiers-picker',
							ej: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.lV;
									},
									maybeAction))
						})
				}
			});
	});
var $author$project$Markdown$empty = '';
var $author$project$Action$encodeObjectiveId = function (_v0) {
	var id = _v0;
	return $elm$json$Json$Encode$int(id);
};
var $author$project$Page$Community$Settings$ActionEditor$minVotesToInt = function (minVotes) {
	switch (minVotes) {
		case 0:
			return 3;
		case 1:
			return 5;
		case 2:
			return 7;
		default:
			return 9;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.qn;
		var month = _v0.ol;
		var day = _v0.mX;
		var hour = _v0.nv;
		var minute = _v0.oi;
		var second = _v0.pB;
		var millisecond = _v0.og;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Page$Community$Settings$ActionEditor$verificationToString = function (verificationOutput) {
	if (!verificationOutput.$) {
		return 'automatic';
	} else {
		return 'claimable';
	}
};
var $author$project$Page$Community$Settings$ActionEditor$upsertAction = F5(
	function (msg, maybeAction, loggedIn, model, formOutput) {
		var posixDeadline = function (date) {
			return A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				loggedIn.A.i2,
				{
					mX: $justinmimbs$date$Date$day(date),
					nv: 23,
					og: 0,
					oi: 59,
					ol: $justinmimbs$date$Date$month(date),
					pB: 59,
					qn: $justinmimbs$date$Date$year(date)
				});
		};
		var getFromVerification = function (accessor) {
			var _v4 = formOutput.ho;
			if (!_v4.$) {
				return $elm$core$Maybe$Nothing;
			} else {
				var manual = _v4.a;
				return $elm$core$Maybe$Just(
					accessor(manual));
			}
		};
		var getFromFileValidation = function (accessor) {
			return A2(
				$elm$core$Maybe$andThen,
				function (fileValidation) {
					if (!fileValidation.$) {
						return $elm$core$Maybe$Nothing;
					} else {
						var file = fileValidation.a;
						return $elm$core$Maybe$Just(
							accessor(file));
					}
				},
				getFromVerification(
					function ($) {
						return $.dF;
					}));
		};
		var encodeBool = A2($elm$core$Basics$composeR, $author$project$Eos$boolToEosBool, $author$project$Eos$encodeEosBool);
		return {
			bZ: $author$project$Eos$encodeTransaction(
				_List_fromArray(
					[
						{
						_: loggedIn.A.hL.V,
						hw: {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission},
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'community_id',
									$author$project$Eos$encodeSymbol(formOutput.fA.as)),
									_Utils_Tuple2(
									'action_id',
									$author$project$Action$encodeId(
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Action$idFromInt(0),
											model.f_))),
									_Utils_Tuple2(
									'objective_id',
									$author$project$Action$encodeObjectiveId(model.kP)),
									_Utils_Tuple2(
									'creator',
									$author$project$Eos$Account$encodeName(loggedIn._)),
									_Utils_Tuple2(
									'description',
									$author$project$Markdown$encode(formOutput.aR)),
									_Utils_Tuple2(
									'reward',
									$author$project$Eos$encodeAsset(formOutput.fA)),
									_Utils_Tuple2(
									'deadline',
									$elm$json$Json$Encode$int(
										A2(
											$elm$core$Maybe$withDefault,
											0,
											A2(
												$elm$core$Maybe$map,
												A2($elm$core$Basics$composeR, posixDeadline, $elm$time$Time$posixToMillis),
												formOutput.cI)))),
									_Utils_Tuple2(
									'usages',
									$elm$json$Json$Encode$int(
										A2($elm$core$Maybe$withDefault, 0, formOutput.cb))),
									_Utils_Tuple2(
									'usages_left',
									$elm$json$Json$Encode$int(
										A2(
											$elm$core$Maybe$withDefault,
											0,
											A2($elm_community$maybe_extra$Maybe$Extra$orElse, formOutput.cb, formOutput.jb)))),
									_Utils_Tuple2(
									'verifications',
									$elm$json$Json$Encode$int(
										A2(
											$elm$core$Maybe$withDefault,
											0,
											getFromVerification(
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.bk;
													},
													$author$project$Page$Community$Settings$ActionEditor$minVotesToInt))))),
									_Utils_Tuple2(
									'verification_type',
									$elm$json$Json$Encode$string(
										$author$project$Page$Community$Settings$ActionEditor$verificationToString(formOutput.ho))),
									_Utils_Tuple2(
									'validators_str',
									$elm$json$Json$Encode$string(
										A2(
											$elm$core$String$join,
											'-',
											A2(
												$elm$core$List$map,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.l8;
													},
													$author$project$Eos$Account$nameToString),
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													getFromVerification(
														function ($) {
															return $.eu;
														})))))),
									_Utils_Tuple2(
									'verifier_reward',
									$author$project$Eos$encodeAsset(
										A2(
											$elm$core$Maybe$withDefault,
											{ji: 0, as: formOutput.fA.as},
											getFromVerification(
												function ($) {
													return $.lY;
												})))),
									_Utils_Tuple2(
									'has_proof_photo',
									encodeBool(
										A2(
											$elm$core$Maybe$withDefault,
											false,
											getFromFileValidation(
												function (_v0) {
													return true;
												})))),
									_Utils_Tuple2(
									'has_proof_code',
									encodeBool(
										A2(
											$elm$core$Maybe$withDefault,
											false,
											getFromFileValidation(
												function ($) {
													return $.es;
												})))),
									_Utils_Tuple2(
									'photo_proof_instructions',
									$author$project$Markdown$encode(
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Markdown$empty,
											getFromFileValidation(
												function ($) {
													return $.dM;
												})))),
									_Utils_Tuple2(
									'is_completed',
									function () {
										if (maybeAction.$ === 1) {
											return encodeBool(false);
										} else {
											var action = maybeAction.a;
											return encodeBool(action.b7);
										}
									}()),
									_Utils_Tuple2(
									'image',
									function () {
										var _v2 = formOutput.h2;
										if (_v2.$ === 1) {
											return $elm$json$Json$Encode$string('');
										} else {
											var image = _v2.a;
											return $elm$json$Json$Encode$string(image);
										}
									}())
								])),
						fj: 'upsertaction'
					}
					])),
			fy: msg,
			fz: $elm$json$Json$Encode$null
		};
	});
var $author$project$Form$withDisabled = F2(
	function (disabled, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{b_: disabled});
	});
var $author$project$Page$Community$Settings$ActionEditor$update = F3(
	function (msg, model, loggedIn) {
		var shared = loggedIn.A;
		var mapForm = F2(
			function (fn, status) {
				if (!status.$) {
					var form_ = status.a;
					var maybeAction = status.b;
					return A2(
						$author$project$Page$Community$Settings$ActionEditor$Authorized,
						fn(form_),
						maybeAction);
				} else {
					return status;
				}
			});
		var _v0 = shared.aw;
		var t = _v0.fL;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var community = msg.a;
				var objectives = msg.b;
				if (_Utils_eq(community.jz, loggedIn._)) {
					var maybeObjective = A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.w;
							},
							$elm$core$Basics$eq(model.kP)),
						objectives);
					var _v2 = _Utils_Tuple2(maybeObjective, model.f_);
					if (!_v2.a.$) {
						if (!_v2.b.$) {
							var objective = _v2.a.a;
							var actionId = _v2.b.a;
							var maybeAction = A2(
								$elm_community$list_extra$List$Extra$find,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.w;
									},
									$elm$core$Basics$eq(actionId)),
								objective.mb);
							if (!maybeAction.$) {
								var action = maybeAction.a;
								return $author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											pN: A2(
												$author$project$Page$Community$Settings$ActionEditor$Authorized,
												A3(
													$author$project$Page$Community$Settings$ActionEditor$initFormInput,
													shared,
													community,
													$elm$core$Maybe$Just(action)),
												$elm$core$Maybe$Just(action))
										}));
							} else {
								return $author$project$UpdateResult$init(
									_Utils_update(
										model,
										{pN: $author$project$Page$Community$Settings$ActionEditor$NotFound}));
							}
						} else {
							var _v4 = _v2.b;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pN: A2(
											$author$project$Page$Community$Settings$ActionEditor$Authorized,
											A3($author$project$Page$Community$Settings$ActionEditor$initFormInput, shared, community, $elm$core$Maybe$Nothing),
											$elm$core$Maybe$Nothing)
									}));
						}
					} else {
						var _v5 = _v2.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{pN: $author$project$Page$Community$Settings$ActionEditor$NotFound}));
					}
				} else {
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{pN: $author$project$Page$Community$Settings$ActionEditor$Unauthorized}));
				}
			case 2:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							pN: A2(
								mapForm,
								$author$project$Form$withDisabled(false),
								model.pN)
						}));
			case 3:
				var subMsg = msg.a;
				var _v6 = model.pN;
				if (!_v6.$) {
					var formModel = _v6.a;
					var maybeAction = _v6.b;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (form_) {
							return _Utils_update(
								model,
								{
									pN: A2($author$project$Page$Community$Settings$ActionEditor$Authorized, form_, maybeAction)
								});
						},
						$author$project$Page$Community$Settings$ActionEditor$GotFormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, shared, subMsg, formModel));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 4:
				var maybeAction = msg.a;
				var formOutput = msg.b;
				return A5(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_Nil,
					model,
					{hS: $author$project$Page$Community$Settings$ActionEditor$ClosedAuthModal, iX: msg},
					A2(
						$author$project$UpdateResult$addPort,
						A5($author$project$Page$Community$Settings$ActionEditor$upsertAction, msg, maybeAction, loggedIn, model, formOutput),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									pN: A2(
										mapForm,
										$author$project$Form$withDisabled(true),
										model.pN)
								}))));
			case 5:
				var action = msg.a;
				var formOutput = msg.b;
				return A5(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_Nil,
					model,
					{hS: $author$project$Page$Community$Settings$ActionEditor$ClosedAuthModal, iX: msg},
					A2(
						$author$project$UpdateResult$addPort,
						A5(
							$author$project$Page$Community$Settings$ActionEditor$upsertAction,
							msg,
							$elm$core$Maybe$Just(
								_Utils_update(
									action,
									{b7: !action.b7})),
							loggedIn,
							model,
							formOutput),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									pN: A2(
										mapForm,
										$author$project$Form$withDisabled(true),
										model.pN)
								}))));
			default:
				if (!msg.a.$) {
					return A2(
						$author$project$UpdateResult$addBreadcrumb,
						{f7: msg, bZ: $elm$core$Dict$empty, n4: 4, of: 'Saved action', eq: 1},
						A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$RequestedReloadCommunityField(1),
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									0,
									t('community.actions.save_success')),
								A2(
									$author$project$UpdateResult$addCmd,
									A2($author$project$Route$replaceUrl, loggedIn.A.kK, $author$project$Route$CommunitySettingsObjectives),
									$author$project$UpdateResult$init(model)))));
				} else {
					var val = msg.a.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A2(
							$author$project$Session$LoggedIn$ShowFeedback,
							1,
							t('error.unknown')),
						A7(
							$author$project$UpdateResult$logJsonValue,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when saving action',
							{e$: 'update', fi: 'Page.Community.Settings.ActionEditor'},
							_List_Nil,
							val,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pN: A2(
											mapForm,
											$author$project$Form$withDisabled(false),
											model.pN)
									}))));
				}
		}
	});
var $author$project$Page$Community$Settings$Contacts$Authorized = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Community$Settings$Contacts$CompletedSubmittingForm = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Settings$Contacts$GotFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$Contacts$Unauthorized = {$: 2};
var $author$project$Cambiatus$Enum$ContactType$toString = function (_enum) {
	switch (_enum) {
		case 0:
			return 'EMAIL';
		case 1:
			return 'INSTAGRAM';
		case 2:
			return 'LINK';
		case 3:
			return 'PHONE';
		case 4:
			return 'TELEGRAM';
		default:
			return 'WHATSAPP';
	}
};
var $author$project$Cambiatus$InputObject$encodeContactInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'externalId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.dC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'label',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.n$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input.eq,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$ContactType$toString)))
			]));
};
var $author$project$Cambiatus$InputObject$encodeCommunityUpdateInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'contacts',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input.az,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Cambiatus$InputObject$encodeContactInput))),
				_Utils_Tuple2(
				'hasNews',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.dH, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool))
			]));
};
var $author$project$Cambiatus$Mutation$community = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'community',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs.nG, $author$project$Cambiatus$InputObject$encodeCommunityUpdateInput)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Contact$FormInput = $elm$core$Basics$identity;
var $author$project$Contact$NotDeleted = 0;
var $author$project$Contact$initFormInput = function (valids) {
	var validToInput = function (_v1) {
		var valid = _v1;
		return {
			a9: 0,
			n$: A2($elm$core$Maybe$withDefault, '', valid.n$),
			eq: valid.eq,
			lW: function () {
				var _v0 = valid.eq;
				switch (_v0) {
					case 0:
						return valid.lW;
					case 1:
						return A2($elm$core$String$dropLeft, 22, valid.lW);
					case 2:
						return A2($elm$core$String$startsWith, 'http://', valid.lW) ? A2($elm$core$String$dropLeft, 7, valid.lW) : (A2($elm$core$String$startsWith, 'https://', valid.lW) ? A2($elm$core$String$dropLeft, 8, valid.lW) : valid.lW);
					case 3:
						return valid.lW;
					case 4:
						return A2($elm$core$String$dropLeft, 13, valid.lW);
					default:
						return valid.lW;
				}
			}()
		};
	};
	return {
		dL: $elm$core$Dict$fromList(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, valid) {
						return _Utils_Tuple2(
							index,
							validToInput(valid));
					}),
				valids)),
		e9: false,
		gM: $elm$core$List$length(valids)
	};
};
var $author$project$Contact$toGraphqlInput = function (_v0) {
	var valid = _v0;
	return {
		dC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(valid.lW),
		n$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(valid.n$),
		eq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(valid.eq)
	};
};
var $author$project$Page$Community$Settings$Contacts$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				var community = msg.a;
				return _Utils_eq(community.jz, loggedIn._) ? $author$project$UpdateResult$init(
					$author$project$Page$Community$Settings$Contacts$Authorized(
						$author$project$Form$init(
							$author$project$Contact$initFormInput(community.az)))) : $author$project$UpdateResult$init($author$project$Page$Community$Settings$Contacts$Unauthorized);
			case 1:
				var subMsg = msg.a;
				if (!model.$) {
					var formModel = model.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newFormModel) {
							return $author$project$Page$Community$Settings$Contacts$Authorized(newFormModel);
						},
						$author$project$Page$Community$Settings$Contacts$GotFormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, loggedIn.A, subMsg, formModel));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Got form msg, but wasn\'t authorized',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Settings.Contacts'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 2:
				var formOutput = msg.a;
				if (!model.$) {
					var formModel = model.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$mutation,
							loggedIn,
							A2(
								$author$project$Cambiatus$Mutation$community,
								{
									nG: {
										az: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
											A2($elm$core$List$map, $author$project$Contact$toGraphqlInput, formOutput)),
										dH: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
									}
								},
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
									$elm$core$List$filterMap($elm$core$Basics$identity),
									$author$project$Cambiatus$Object$Community$contacts($author$project$Contact$selectionSet))),
							$author$project$Page$Community$Settings$Contacts$CompletedSubmittingForm),
						$author$project$UpdateResult$init(
							$author$project$Page$Community$Settings$Contacts$Authorized(
								A2($author$project$Form$withDisabled, true, formModel))));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Submitted form, but wasn\'t authorized',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Settings.Contacts'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			default:
				switch (msg.a.$) {
					case 3:
						var maybeContacts = msg.a.a;
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								0,
								loggedIn.A.aw.fL('contact_form.feedback.community.success')),
							A2(
								$author$project$UpdateResult$addCmd,
								A2($author$project$Route$pushUrl, loggedIn.A.kK, $author$project$Route$CommunityAbout),
								A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$LoggedIn$UpdatedLoggedIn(
										_Utils_update(
											loggedIn,
											{
												pC: A2(
													$krisajenkins$remotedata$RemoteData$map,
													function (community) {
														return _Utils_update(
															community,
															{
																az: A2($elm$core$Maybe$withDefault, _List_Nil, maybeContacts)
															});
													},
													loggedIn.pC)
											})),
									$author$project$UpdateResult$init(model))));
					case 2:
						var err = msg.a.a;
						var newModel = function () {
							if (!model.$) {
								var formModel = model.a;
								return $author$project$Page$Community$Settings$Contacts$Authorized(
									A2($author$project$Form$withDisabled, false, formModel));
							} else {
								return model;
							}
						}();
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								loggedIn.A.aw.fL('contact_form.feedback.community.failure')),
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Just(loggedIn._),
								'Got an error when saving community contacts',
								{e$: 'update', fi: 'Page.Community.Settings.Contacts'},
								_List_Nil,
								err,
								$author$project$UpdateResult$init(newModel)));
					default:
						var newModel = function () {
							if (!model.$) {
								var formModel = model.a;
								return $author$project$Page$Community$Settings$Contacts$Authorized(
									A2($author$project$Form$withDisabled, false, formModel));
							} else {
								return model;
							}
						}();
						return $author$project$UpdateResult$init(newModel);
				}
		}
	});
var $author$project$Page$Community$Settings$Currency$ClickedSubmit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$Currency$ClosedAuthModal = {$: 0};
var $author$project$Page$Community$Settings$Currency$CompletedLoadExpiryOpts = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$Settings$Currency$CompletedLoadToken = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Community$Settings$Currency$GotFormMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Community$Settings$Currency$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Token$encodeExpiryOpts = function (expiryOptsData) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'currency',
				$author$project$Eos$encodeSymbol(expiryOptsData.jA)),
				_Utils_Tuple2(
				'natural_expiration_period',
				$elm$json$Json$Encode$int(expiryOptsData.d1)),
				_Utils_Tuple2(
				'juridical_expiration_period',
				$elm$json$Json$Encode$int(expiryOptsData.dX)),
				_Utils_Tuple2(
				'renovation_amount',
				$author$project$Eos$encodeAsset(expiryOptsData.ef))
			]));
};
var $author$project$Token$encodeUpdateTokenData = function (c) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'max_supply',
				$author$project$Eos$encodeAsset(c.od)),
				_Utils_Tuple2(
				'min_balance',
				$author$project$Eos$encodeAsset(c.oh))
			]));
};
var $author$project$Token$ExpiryOptsData = F4(
	function (currency, naturalExpirationPeriod, juridicalExpirationPeriod, renovationAmount) {
		return {jA: currency, dX: juridicalExpirationPeriod, d1: naturalExpirationPeriod, ef: renovationAmount};
	});
var $author$project$Token$expiryOptsDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'renovation_amount',
	$author$project$Eos$decodeAsset,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'juridical_expiration_period',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'natural_expiration_period',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'currency',
				$author$project$Eos$symbolDecoder,
				$elm$json$Json$Decode$succeed($author$project$Token$ExpiryOptsData)))));
var $author$project$Token$getExpiryOpts = F3(
	function (shared, symbol, toMsg) {
		return A4(
			$author$project$Api$getFromBlockchain,
			shared,
			{ds: shared.hL.p5, kx: 1000, ln: shared.hL.p5, lB: 'expiryopts'},
			A2(
				$elm$json$Json$Decode$field,
				'rows',
				A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filter(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.jA;
								},
								$elm$core$Basics$eq(symbol))),
						$elm$core$List$head),
					$elm$json$Json$Decode$list($author$project$Token$expiryOptsDataDecoder))),
			toMsg);
	});
var $author$project$Page$Community$Settings$Currency$update = F3(
	function (msg, model, loggedIn) {
		var shared = loggedIn.A;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{ap: false}));
			case 1:
				var formOutput = msg.a;
				var _v1 = loggedIn.pC;
				if (_v1.$ === 3) {
					var community = _v1.a;
					var authorization = {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission};
					var asset = function (amount) {
						return {ji: amount, as: community.as};
					};
					var updateTokenData = {
						od: asset(formOutput.cU),
						oh: asset(formOutput.d0)
					};
					return A5(
						$author$project$Session$LoggedIn$withPrivateKey,
						loggedIn,
						_List_Nil,
						model,
						{hS: $author$project$Page$Community$Settings$Currency$ClosedAuthModal, iX: msg},
						A2(
							$author$project$UpdateResult$addPort,
							{
								bZ: $author$project$Eos$encodeTransaction(
									A2(
										$elm$core$List$cons,
										{
											_: loggedIn.A.hL.p5,
											hw: authorization,
											bZ: $author$project$Token$encodeUpdateTokenData(updateTokenData),
											fj: 'update'
										},
										function () {
											var _v2 = formOutput.fR;
											if (!_v2.$) {
												return _List_Nil;
											} else {
												var expiryOpts = _v2.a;
												return _List_fromArray(
													[
														{
														_: loggedIn.A.hL.p5,
														hw: authorization,
														bZ: $author$project$Token$encodeExpiryOpts(expiryOpts),
														fj: 'setexpiry'
													}
													]);
											}
										}())),
								fy: $author$project$Page$Community$Settings$Currency$ClickedSubmit(formOutput),
								fz: $author$project$Token$encodeUpdateTokenData(updateTokenData)
							},
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{ap: true}))));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Tried submitting token edit, but community wasn\'t loaded',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Settings.Currency'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 2:
				if (!msg.a.$) {
					var updateTokenData = msg.a.a;
					return function () {
						var _v3 = loggedIn.pC;
						if (_v3.$ === 3) {
							var community = _v3.a;
							return A2(
								$elm$core$Basics$composeR,
								$author$project$UpdateResult$addExt(
									$author$project$Session$LoggedIn$ExternalBroadcast(
										$author$project$Session$LoggedIn$CommunityLoaded(
											_Utils_update(
												community,
												{
													oh: $elm$core$Maybe$Just(updateTokenData.oh.ji)
												})))),
								A2(
									$elm$core$Basics$composeR,
									$author$project$UpdateResult$addExt(
										A2(
											$author$project$Session$LoggedIn$ShowFeedback,
											0,
											shared.aw.fL('community.create.success'))),
									A2(
										$elm$core$Basics$composeR,
										$author$project$UpdateResult$addCmd(
											A2($author$project$Route$pushUrl, shared.kK, $author$project$Route$CommunitySettings)),
										$author$project$UpdateResult$addBreadcrumb(
											{f7: msg, bZ: $elm$core$Dict$empty, n4: 4, of: 'Submitted Currency page', eq: 1}))));
						} else {
							return A5(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed updating token, but community wasn\'t loaded',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Community.Settings.Currency'},
								_List_Nil);
						}
					}()(
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{ap: false})));
				} else {
					var val = msg.a.a;
					return A7(
						$author$project$UpdateResult$logJsonValue,
						msg,
						$elm$core$Maybe$Just(loggedIn._),
						'Got an error when submitting currency form',
						{e$: 'update', fi: 'Page.Community.Settings.Currency'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.pC)
							]),
						val,
						A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								shared.aw.fL('community.error_saving')),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{ap: false}))));
				}
			case 3:
				var community = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A3($author$project$Token$getToken, shared, community.as, $author$project$Page$Community$Settings$Currency$CompletedLoadToken),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{ap: true})));
			case 5:
				if (!msg.a.$) {
					var token = msg.a.a;
					var _v4 = loggedIn.pC;
					if (_v4.$ === 3) {
						var community = _v4.a;
						var fetchExpiryOptsData = function () {
							var _v7 = token.eq;
							if (!_v7) {
								return $elm$core$Basics$identity;
							} else {
								return $author$project$UpdateResult$addCmd(
									A3($author$project$Token$getExpiryOpts, shared, community.as, $author$project$Page$Community$Settings$Currency$CompletedLoadExpiryOpts));
							}
						}();
						return fetchExpiryOptsData(
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										hY: function () {
											var _v5 = token.eq;
											if (!_v5) {
												return $author$project$Page$Community$Settings$Currency$Loaded(
													$author$project$Form$init(
														{
															dX: '15',
															cU: $elm$core$String$fromFloat(
																A2($elm$core$Maybe$withDefault, 21000000, community.od)),
															d0: $elm$core$String$fromFloat(
																A2($elm$core$Maybe$withDefault, 0, community.oh)),
															d1: '10',
															ef: '100',
															p6: 0
														}));
											} else {
												return $author$project$Page$Community$Settings$Currency$Loading;
											}
										}(),
										ap: function () {
											var _v6 = token.eq;
											if (!_v6) {
												return false;
											} else {
												return true;
											}
										}()
									})));
					} else {
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Completed loading token information, but community wasn\'t loaded',
							$elm$core$Maybe$Just(loggedIn._),
							{e$: 'update', fi: 'Page.Community.Settings.Currency'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					}
				} else {
					var err = msg.a.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(loggedIn._),
						'Got an error when trying to load token information',
						{e$: 'update', fi: 'Page.Community.Settings.Currency'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.pC)
							]),
						err,
						A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								shared.aw.fL('settings.community_currency.token_error')),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{ap: false}))));
				}
			case 4:
				if (!msg.a.$) {
					if (!msg.a.a.$) {
						var expiryOptsData = msg.a.a.a;
						var _v8 = loggedIn.pC;
						if (_v8.$ === 3) {
							var community = _v8.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										hY: $author$project$Page$Community$Settings$Currency$Loaded(
											$author$project$Form$init(
												{
													dX: $elm$core$String$fromInt(expiryOptsData.dX),
													cU: $elm$core$String$fromFloat(
														A2($elm$core$Maybe$withDefault, 21000000, community.od)),
													d0: $elm$core$String$fromFloat(
														A2($elm$core$Maybe$withDefault, 0, community.oh)),
													d1: $elm$core$String$fromInt(expiryOptsData.d1),
													ef: $elm$core$String$fromFloat(expiryOptsData.ef.ji),
													p6: 1
												})),
										ap: false
									}));
						} else {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed loading token expiry opts, but community wasn\'t loaded',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Community.Settings.Currency'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						}
					} else {
						var _v9 = msg.a.a;
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Completed loading expiry_opts, but got Nothing',
							$elm$core$Maybe$Just(loggedIn._),
							{e$: 'update', fi: 'Page.Community.Settings.Currency'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.pC)
								]),
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									1,
									shared.aw.fL('settings.community_currency.expiryopts_not_found')),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{ap: false}))));
					}
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A2(
							$author$project$Session$LoggedIn$ShowFeedback,
							1,
							shared.aw.fL('error.unknown')),
						A7(
							$author$project$UpdateResult$logHttpError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when loading expiry_opts for a community',
							{e$: 'update', fi: 'Page.Community.Settings.Currency'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.pC)
								]),
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{ap: false}))));
				}
			default:
				var subMsg = msg.a;
				var _v10 = model.hY;
				if (!_v10.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var form = _v10.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newForm) {
							return _Utils_update(
								model,
								{
									hY: $author$project$Page$Community$Settings$Currency$Loaded(newForm)
								});
						},
						$author$project$Page$Community$Settings$Currency$GotFormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, shared, subMsg, form));
				}
		}
	});
var $author$project$Page$Community$Settings$Features$Authorized = 1;
var $author$project$Page$Community$Settings$Features$ClosedAuthModal = {$: 2};
var $author$project$Page$Community$Settings$Features$Objectives = 1;
var $author$project$Page$Community$Settings$Features$Shop = 0;
var $author$project$Page$Community$Settings$Features$Unauthorized = 2;
var $author$project$Page$Community$Settings$Features$saveFeature = F5(
	function (feature, state, authorization, _v0, community) {
		var shared = _v0.A;
		var accountName = _v0._;
		var hasShop = function () {
			if (!feature) {
				return state;
			} else {
				return community.bB;
			}
		}();
		var hasObjectives = function () {
			if (feature === 1) {
				return state;
			} else {
				return community.bz;
			}
		}();
		var data = {
			_: accountName,
			aR: community.aR,
			bx: community.bx,
			by: community.by,
			bz: hasObjectives,
			bB: hasShop,
			b5: community.b5,
			b6: community.b6,
			ff: community.fe,
			fj: community.fj,
			pP: community.pP,
			as: community.as,
			bT: A2($elm$core$Maybe$withDefault, '', community.bT)
		};
		return {
			bZ: $author$project$Eos$encodeTransaction(
				_List_fromArray(
					[
						{
						_: shared.hL.V,
						hw: authorization,
						bZ: $author$project$Community$encodeCreateCommunityData(
							$author$project$Community$createCommunityData(data)),
						fj: 'update'
					}
					])),
			fy: $author$project$Page$Community$Settings$Features$SaveSuccess,
			fz: $elm$json$Json$Encode$null
		};
	});
var $author$project$Page$Community$Settings$Features$saveFeaturePort = F4(
	function (loggedIn, feature, status, state) {
		var shared = loggedIn.A;
		var authorization = {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission};
		var _v0 = _Utils_Tuple2(loggedIn.pC, status);
		switch (_v0.b) {
			case 1:
				if (_v0.a.$ === 3) {
					var community = _v0.a.a;
					var _v1 = _v0.b;
					return $author$project$UpdateResult$addPort(
						A5($author$project$Page$Community$Settings$Features$saveFeature, feature, state, authorization, loggedIn, community));
				} else {
					var _v2 = _v0.b;
					return $elm$core$Basics$identity;
				}
			case 0:
				var _v3 = _v0.b;
				return $author$project$UpdateResult$addExt(
					A2(
						$author$project$Session$LoggedIn$ShowFeedback,
						1,
						shared.aw.fL('error.unknown')));
			default:
				var _v4 = _v0.b;
				return $author$project$UpdateResult$addExt(
					A2(
						$author$project$Session$LoggedIn$ShowFeedback,
						1,
						shared.aw.fL('error.unknown')));
		}
	});
var $author$project$Page$Community$Settings$Features$updateCommunity = F2(
	function (community, model) {
		return _Utils_update(
			community,
			{by: model.by, dH: model.dH, bz: model.bz, bB: model.bB});
	});
var $author$project$Page$Community$Settings$Features$update = F3(
	function (msg, model, loggedIn) {
		var translate = loggedIn.A.aw.fL;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var community = msg.a;
				var newStatus = _Utils_eq(community.jz, loggedIn._) ? 1 : 2;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{by: community.by, dH: community.dH, bz: community.bz, bB: community.bB, pN: newStatus}));
			case 2:
				return $author$project$UpdateResult$init(model);
			case 3:
				var state = msg.a;
				return A5(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_Nil,
					model,
					{hS: $author$project$Page$Community$Settings$Features$ClosedAuthModal, iX: msg},
					A5(
						$author$project$Page$Community$Settings$Features$saveFeaturePort,
						loggedIn,
						0,
						model.pN,
						state,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{bB: state}))));
			case 4:
				var state = msg.a;
				return A5(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_Nil,
					model,
					{hS: $author$project$Page$Community$Settings$Features$ClosedAuthModal, iX: msg},
					A5(
						$author$project$Page$Community$Settings$Features$saveFeaturePort,
						loggedIn,
						1,
						model.pN,
						state,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{bz: state}))));
			case 5:
				return $author$project$UpdateResult$init(model);
			case 6:
				return $author$project$UpdateResult$init(model);
			case 7:
				var newsValue = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					A3(
						$author$project$Session$LoggedIn$mutation,
						loggedIn,
						A2(
							$author$project$Cambiatus$Mutation$community,
							{
								nG: {
									az: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
									dH: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(newsValue)
								}
							},
							$dillonkearns$elm_graphql$Graphql$SelectionSet$empty),
						function (_v1) {
							return $author$project$Page$Community$Settings$Features$SaveSuccess;
						}),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{dH: newsValue})));
			default:
				var addBroadcast = function (uResult) {
					var _v2 = loggedIn.pC;
					if (_v2.$ === 3) {
						var community = _v2.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$ExternalBroadcast(
								$author$project$Session$LoggedIn$CommunityLoaded(
									A2($author$project$Page$Community$Settings$Features$updateCommunity, community, model))),
							uResult);
					} else {
						return uResult;
					}
				};
				return A2(
					$author$project$UpdateResult$addBreadcrumb,
					{
						f7: msg,
						bZ: $elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'hasShop',
									$elm$json$Json$Encode$bool(model.bB)),
									_Utils_Tuple2(
									'hasObjectives',
									$elm$json$Json$Encode$bool(model.bz)),
									_Utils_Tuple2(
									'hasKyc',
									$elm$json$Json$Encode$bool(model.by))
								])),
						n4: 4,
						of: 'Saved community feature',
						eq: 1
					},
					addBroadcast(
						A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								0,
								translate('settings.success')),
							$author$project$UpdateResult$init(model))));
		}
	});
var $author$project$Page$Community$Settings$Info$ClosedAuthModal = {$: 2};
var $author$project$Page$Community$Settings$Info$CompletedAddingCoverPhoto = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Community$Settings$Info$GotDomainAvailableResponse = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Page$Community$Settings$Info$GotFormMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Community$Settings$Info$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Cambiatus$Mutation$addCommunityPhotos = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'addCommunityPhotos',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'symbol', requiredArgs.as, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'urls',
					requiredArgs.lT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Community$addPhotosMutation = F2(
	function (symbol, photos) {
		return A2(
			$author$project$Cambiatus$Mutation$addCommunityPhotos,
			{
				as: $author$project$Eos$symbolToString(symbol),
				lT: photos
			},
			$author$project$Community$communitySelectionSet);
	});
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Page$Community$Settings$Info$encodeFormOutput = function (o) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'logo',
				$elm$json$Json$Encode$string(o.fe)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(o.fj)),
				_Utils_Tuple2(
				'description',
				$author$project$Markdown$encode(o.aR)),
				_Utils_Tuple2(
				'website',
				function () {
					var _v0 = o.bT;
					if (_v0.$ === 1) {
						return $elm$json$Json$Encode$null;
					} else {
						var website = _v0.a;
						return $elm$json$Json$Encode$string(
							$elm$url$Url$toString(website));
					}
				}()),
				_Utils_Tuple2(
				'coverPhoto',
				function () {
					var _v1 = o.a7;
					if (_v1.$ === 1) {
						return $elm$json$Json$Encode$null;
					} else {
						var coverPhoto = _v1.a;
						return $elm$json$Json$Encode$string(coverPhoto);
					}
				}()),
				_Utils_Tuple2(
				'subdomain',
				$elm$json$Json$Encode$string(
					$elm$url$Url$toString(o.pP))),
				_Utils_Tuple2(
				'hasAutoInvite',
				$elm$json$Json$Encode$bool(o.bx)),
				_Utils_Tuple2(
				'inviterReward',
				$elm$json$Json$Encode$float(o.b6)),
				_Utils_Tuple2(
				'invitedReward',
				$elm$json$Json$Encode$float(o.b5))
			]));
};
var $author$project$Community$encodeUpdateData = function (c) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'logo',
				$elm$json$Json$Encode$string(c.fe)),
				_Utils_Tuple2(
				'cmm_asset',
				$author$project$Eos$encodeAsset(c.mk)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(c.fj)),
				_Utils_Tuple2(
				'description',
				$author$project$Markdown$encode(c.aR)),
				_Utils_Tuple2(
				'subdomain',
				$elm$json$Json$Encode$string(c.pP)),
				_Utils_Tuple2(
				'inviter_reward',
				$author$project$Eos$encodeAsset(c.b6)),
				_Utils_Tuple2(
				'invited_reward',
				$author$project$Eos$encodeAsset(c.b5)),
				_Utils_Tuple2(
				'has_objectives',
				$author$project$Eos$encodeEosBool(c.bz)),
				_Utils_Tuple2(
				'has_shop',
				$author$project$Eos$encodeEosBool(c.bB)),
				_Utils_Tuple2(
				'has_kyc',
				$author$project$Eos$encodeEosBool(c.by)),
				_Utils_Tuple2(
				'auto_invite',
				$author$project$Eos$encodeEosBool(c.bx)),
				_Utils_Tuple2(
				'website',
				$elm$json$Json$Encode$string(c.bT))
			]));
};
var $author$project$Page$Community$Settings$Info$update = F3(
	function (msg, model, loggedIn) {
		update:
		while (true) {
			var shared = loggedIn.A;
			switch (msg.$) {
				case 0:
					var community = msg.a;
					var _v1 = function () {
						var _v2 = community.bQ;
						switch (_v2.$) {
							case 3:
								var uploads = _v2.a;
								return _Utils_Tuple2(
									$elm$core$List$head(uploads),
									$elm$core$Basics$identity);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Basics$identity);
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									$author$project$UpdateResult$addExt(
										$author$project$Session$LoggedIn$RequestedCommunityField(2)));
						}
					}();
					var maybeCoverPhoto = _v1.a;
					var maybeRequestUploads = _v1.b;
					return maybeRequestUploads(
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									hY: $author$project$Page$Community$Settings$Info$Loaded(
										$author$project$Form$init(
											{
												a7: $author$project$Form$File$initSingle(
													{
														mj: $elm$core$Maybe$Just(1),
														ni: maybeCoverPhoto
													}),
												aR: A2(
													$author$project$Form$RichText$initModel,
													'description-input',
													$elm$core$Maybe$Just(community.aR)),
												bx: community.bx,
												b5: $elm$core$String$fromFloat(community.b5),
												b6: $elm$core$String$fromFloat(community.b6),
												fe: $author$project$Form$File$initSingle(
													{
														mj: $elm$core$Maybe$Just(1),
														ni: $elm$core$Maybe$Just(community.fe)
													}),
												fj: community.fj,
												pP: A2(
													$elm$core$Maybe$withDefault,
													'',
													$elm$core$List$head(
														A2($elm$core$String$split, '.', community.pP))),
												bT: A2($elm$core$Maybe$withDefault, '', community.bT)
											})),
									ap: false
								})));
				case 1:
					var uploads = msg.a;
					var _v3 = model.hY;
					if (!_v3.$) {
						return $author$project$UpdateResult$init(model);
					} else {
						var form = _v3.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									hY: $author$project$Page$Community$Settings$Info$Loaded(
										A2(
											$author$project$Form$updateValues,
											function (values) {
												return _Utils_update(
													values,
													{
														a7: $author$project$Form$File$initSingle(
															{
																mj: $elm$core$Maybe$Just(1),
																ni: $elm$core$List$head(uploads)
															})
													});
											},
											form))
								}));
					}
				case 2:
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{ap: false}));
				case 3:
					var formOutput = msg.a;
					var maybeCommunity = $krisajenkins$remotedata$RemoteData$toMaybe(loggedIn.pC);
					var isSameSubdomain = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$eq(formOutput.pP.e3),
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.pP;
								},
								maybeCommunity)));
					if (isSameSubdomain) {
						var $temp$msg = A2(
							$author$project$Page$Community$Settings$Info$GotDomainAvailableResponse,
							formOutput,
							$krisajenkins$remotedata$RemoteData$Success(true)),
							$temp$model = _Utils_update(
							model,
							{ap: true}),
							$temp$loggedIn = loggedIn;
						msg = $temp$msg;
						model = $temp$model;
						loggedIn = $temp$loggedIn;
						continue update;
					} else {
						return A2(
							$author$project$UpdateResult$addExt,
							A3(
								$author$project$Session$LoggedIn$query,
								loggedIn,
								$author$project$Community$domainAvailableQuery(formOutput.pP.e3),
								$author$project$Page$Community$Settings$Info$GotDomainAvailableResponse(formOutput)),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{ap: true})));
					}
				case 4:
					switch (msg.b.$) {
						case 3:
							if (msg.b.a) {
								var formOutput = msg.a;
								var _v4 = A2(
									$author$project$Community$getField,
									loggedIn.pC,
									function ($) {
										return $.bQ;
									});
								if (_v4.$ === 3) {
									var _v5 = _v4.a;
									var community = _v5.a;
									var communityUploads = _v5.b;
									var newUpload = _Utils_eq(
										$elm$core$List$head(communityUploads),
										formOutput.a7) ? $elm$core$Maybe$Nothing : formOutput.a7;
									var authorization = {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission};
									var asset = function (amount) {
										return {ji: amount, as: community.as};
									};
									var addCoverPhoto = function () {
										if (newUpload.$ === 1) {
											return $elm$core$Basics$identity;
										} else {
											var url = newUpload.a;
											return $author$project$UpdateResult$addExt(
												A3(
													$author$project$Session$LoggedIn$mutation,
													loggedIn,
													A2(
														$author$project$Community$addPhotosMutation,
														community.as,
														A2($elm$core$List$cons, url, communityUploads)),
													$author$project$Page$Community$Settings$Info$CompletedAddingCoverPhoto(formOutput)));
										}
									}();
									return A2(
										$author$project$UpdateResult$addBreadcrumb,
										{
											f7: msg,
											bZ: $elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'domain',
														$elm$json$Json$Encode$string(formOutput.pP.e3))
													])),
											n4: 4,
											of: 'Checked that domain is available',
											eq: 1
										},
										A5(
											$author$project$Session$LoggedIn$withPrivateKey,
											loggedIn,
											_List_Nil,
											model,
											{hS: $author$project$Page$Community$Settings$Info$ClosedAuthModal, iX: msg},
											addCoverPhoto(
												A2(
													$author$project$UpdateResult$addPort,
													{
														bZ: $author$project$Eos$encodeTransaction(
															_List_fromArray(
																[
																	{
																	_: loggedIn.A.hL.V,
																	hw: authorization,
																	bZ: $author$project$Community$encodeUpdateData(
																		{
																			mk: asset(0),
																			aR: formOutput.aR,
																			bx: $author$project$Eos$boolToEosBool(!formOutput.bx),
																			by: $author$project$Eos$boolToEosBool(community.by),
																			bz: $author$project$Eos$boolToEosBool(community.bz),
																			bB: $author$project$Eos$boolToEosBool(community.bB),
																			b5: asset(formOutput.b5),
																			b6: asset(formOutput.b6),
																			fe: formOutput.fe,
																			fj: formOutput.fj,
																			pP: formOutput.pP.e3,
																			bT: A2(
																				$elm$core$Maybe$withDefault,
																				'',
																				A2($elm$core$Maybe$map, $elm$url$Url$toString, formOutput.bT))
																		}),
																	fj: 'update'
																}
																])),
														fy: A2(
															$author$project$Page$Community$Settings$Info$GotDomainAvailableResponse,
															formOutput,
															$krisajenkins$remotedata$RemoteData$Success(true)),
														fz: $author$project$Page$Community$Settings$Info$encodeFormOutput(formOutput)
													},
													$author$project$UpdateResult$init(
														_Utils_update(
															model,
															{
																e1: $elm_community$maybe_extra$Maybe$Extra$isNothing(newUpload),
																ap: true
															}))))));
								} else {
									return A6(
										$author$project$UpdateResult$logImpossible,
										msg,
										'Community is not loaded when checking if domain is available in Community Info',
										$elm$core$Maybe$Just(loggedIn._),
										{e$: 'update', fi: 'Page.Community.Settings.Info'},
										_List_Nil,
										$author$project$UpdateResult$init(model));
								}
							} else {
								var formOutput = msg.a;
								return A2(
									$author$project$UpdateResult$addBreadcrumb,
									{
										f7: msg,
										bZ: $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'domain',
													$elm$json$Json$Encode$string(formOutput.pP.e3))
												])),
										n4: 4,
										of: 'Tried domain that is unavailable',
										eq: 1
									},
									A2(
										$author$project$UpdateResult$addExt,
										A2(
											$author$project$Session$LoggedIn$ShowFeedback,
											1,
											shared.aw.fL('settings.community_info.errors.url.already_taken')),
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{ap: false}))));
							}
						case 2:
							var formOutput = msg.a;
							var err = msg.b.a;
							return A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									1,
									shared.aw.fL('error.unknown')),
								A7(
									$author$project$UpdateResult$logGraphqlError,
									msg,
									$elm$core$Maybe$Just(loggedIn._),
									'Got an error when trying to check if domain is available',
									{e$: 'update', fi: 'Page.Community.Settings.Info'},
									_List_fromArray(
										[
											$author$project$Log$contextFromCommunity(loggedIn.pC),
											{
											ng: $elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'tried',
														$elm$json$Json$Encode$string(formOutput.pP.e3))
													])),
											fj: 'Domain'
										}
										]),
									err,
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{ap: false}))));
						case 1:
							var _v7 = msg.b;
							return $author$project$UpdateResult$init(model);
						default:
							var _v8 = msg.b;
							return $author$project$UpdateResult$init(model);
					}
				case 5:
					switch (msg.b.$) {
						case 3:
							var formOutput = msg.a;
							return A2(
								$author$project$UpdateResult$addMsg,
								$author$project$Page$Community$Settings$Info$GotSaveResponse(
									$elm$core$Result$Ok(formOutput)),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{e1: true})));
						case 2:
							var err = msg.b.a;
							return A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									1,
									shared.aw.fL('settings.community_info.errors.cover_upload')),
								A7(
									$author$project$UpdateResult$logGraphqlError,
									msg,
									$elm$core$Maybe$Just(loggedIn._),
									'Got an error when trying to add a cover photo',
									{e$: 'update', fi: 'Page.Community.Settings.Info'},
									_List_fromArray(
										[
											$author$project$Log$contextFromCommunity(loggedIn.pC)
										]),
									err,
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{ap: false}))));
						default:
							return $author$project$UpdateResult$init(model);
					}
				case 6:
					if (!msg.a.$) {
						var formOutput = msg.a.a;
						if (!model.e1) {
							return $author$project$UpdateResult$init(model);
						} else {
							var _v9 = loggedIn.pC;
							if (_v9.$ === 3) {
								var community = _v9.a;
								var newUploads = function () {
									var _v10 = community.bQ;
									if (_v10.$ === 3) {
										var uploads = _v10.a;
										var _v11 = formOutput.a7;
										if (_v11.$ === 1) {
											return $krisajenkins$remotedata$RemoteData$Success(uploads);
										} else {
											var coverPhoto = _v11.a;
											return $krisajenkins$remotedata$RemoteData$Success(
												A2($elm$core$List$cons, coverPhoto, uploads));
										}
									} else {
										return community.bQ;
									}
								}();
								var newCommunity = {pP: formOutput.pP.e3, as: community.as};
								var redirectToCommunity = (_Utils_eq(newCommunity.pP, community.pP) || (!shared.qf)) ? A2($author$project$Route$replaceUrl, shared.kK, $author$project$Route$Dashboard) : A3($author$project$Route$loadExternalCommunity, loggedIn.A, newCommunity, $author$project$Route$Dashboard);
								return A2(
									$author$project$UpdateResult$addBreadcrumb,
									{f7: msg, bZ: $elm$core$Dict$empty, n4: 4, of: 'Saved community information', eq: 1},
									A2(
										$author$project$UpdateResult$addExt,
										$author$project$Session$LoggedIn$ExternalBroadcast(
											$author$project$Session$LoggedIn$CommunityLoaded(
												_Utils_update(
													community,
													{
														aR: formOutput.aR,
														bx: formOutput.bx,
														b5: formOutput.b5,
														b6: formOutput.b6,
														fe: formOutput.fe,
														fj: formOutput.fj,
														bQ: newUploads,
														bT: A2($elm$core$Maybe$map, $elm$url$Url$toString, formOutput.bT)
													}))),
										A2(
											$author$project$UpdateResult$addCmd,
											redirectToCommunity,
											A2(
												$author$project$UpdateResult$addExt,
												A2(
													$author$project$Session$LoggedIn$ShowFeedback,
													0,
													shared.aw.fL('community.create.success')),
												$author$project$UpdateResult$init(
													_Utils_update(
														model,
														{ap: false}))))));
							} else {
								return A6(
									$author$project$UpdateResult$logImpossible,
									msg,
									'Saved community, but it wasn\'t loaded',
									$elm$core$Maybe$Just(loggedIn._),
									{e$: 'update', fi: 'Page.Community.Settings.Info'},
									_List_Nil,
									$author$project$UpdateResult$init(model));
							}
						}
					} else {
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								shared.aw.fL('community.error_saving')),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{ap: false})));
					}
				default:
					var subMsg = msg.a;
					var _v12 = model.hY;
					if (!_v12.$) {
						return $author$project$UpdateResult$init(model);
					} else {
						var form = _v12.a;
						return A5(
							$author$project$UpdateResult$fromChild,
							function (newForm) {
								return _Utils_update(
									model,
									{
										hY: $author$project$Page$Community$Settings$Info$Loaded(newForm)
									});
							},
							$author$project$Page$Community$Settings$Info$GotFormMsg,
							$author$project$Session$LoggedIn$addFeedback,
							model,
							A3($author$project$Form$update, loggedIn.A, subMsg, form));
					}
			}
		}
	});
var $author$project$Page$Community$Settings$News$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$News$CompletedSettingHighlightedNews = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Null = {$: 2};
var $author$project$Cambiatus$Mutation$highlightedNews = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{bG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'newsId', filledInOptionals.bG, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'highlightedNews',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Page$Community$Settings$News$setHighlightNews = F3(
	function (loggedIn, newsId, isHighlighted) {
		return $author$project$UpdateResult$addExt(
			A3(
				$author$project$Session$LoggedIn$mutation,
				loggedIn,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					$elm$core$Maybe$andThen($elm$core$Basics$identity),
					A2(
						$author$project$Cambiatus$Mutation$highlightedNews,
						function (optionals) {
							return _Utils_update(
								optionals,
								{
									bG: isHighlighted ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(newsId) : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Null
								});
						},
						$author$project$Cambiatus$Object$Community$highlightedNews($author$project$Community$News$selectionSet))),
				$author$project$Page$Community$Settings$News$CompletedSettingHighlightedNews(isHighlighted)));
	});
var $author$project$Page$Community$Settings$News$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var community = msg.a;
				return _Utils_eq(community.jz, loggedIn._) ? $author$project$UpdateResult$init(model) : A2(
					$author$project$UpdateResult$addCmd,
					A2($author$project$Route$pushUrl, loggedIn.A.kK, $author$project$Route$Dashboard),
					$author$project$UpdateResult$init(model));
			case 2:
				var newsId = msg.a;
				var isHighlighted = msg.b;
				var _v1 = loggedIn.pC;
				if (_v1.$ === 3) {
					var community = _v1.a;
					var _v2 = community.nu;
					if (_v2.$ === 1) {
						return A4(
							$author$project$Page$Community$Settings$News$setHighlightNews,
							loggedIn,
							newsId,
							isHighlighted,
							$author$project$UpdateResult$init(model));
					} else {
						var highlightedNews = _v2.a;
						return _Utils_eq(highlightedNews.w, newsId) ? A4(
							$author$project$Page$Community$Settings$News$setHighlightNews,
							loggedIn,
							newsId,
							isHighlighted,
							$author$project$UpdateResult$init(model)) : $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									cL: $author$project$Page$Community$Settings$News$Visible(
										{nR: isHighlighted, bG: newsId})
								}));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Tried toggling highlighted news, but community wasn\'t loaded',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Settings.News'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.pC)
							]),
						$author$project$UpdateResult$init(model));
				}
			case 3:
				switch (msg.b.$) {
					case 3:
						var isHighlighted = msg.a;
						var maybeNews = msg.b.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$UpdatedLoggedIn(
								_Utils_update(
									loggedIn,
									{
										pC: A2(
											$krisajenkins$remotedata$RemoteData$map,
											function (community) {
												return _Utils_update(
													community,
													{
														nu: isHighlighted ? maybeNews : $elm$core$Maybe$Nothing
													});
											},
											loggedIn.pC)
									})),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{cL: $author$project$Page$Community$Settings$News$NotVisible})));
					case 2:
						var err = msg.b.a;
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								loggedIn.A.aw.fL('news.error_highlighting')),
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Just(loggedIn._),
								'Got an error when highlighting news',
								{e$: 'update', fi: 'Page.Community.Settings.News'},
								_List_fromArray(
									[
										$author$project$Log$contextFromCommunity(loggedIn.pC)
									]),
								err,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{cL: $author$project$Page$Community$Settings$News$NotVisible}))));
					case 0:
						var _v3 = msg.b;
						return $author$project$UpdateResult$init(model);
					default:
						var _v4 = msg.b;
						return $author$project$UpdateResult$init(model);
				}
			case 4:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cL: $author$project$Page$Community$Settings$News$NotVisible}));
			default:
				var newsId = msg.a;
				return A4(
					$author$project$Page$Community$Settings$News$setHighlightNews,
					loggedIn,
					newsId,
					true,
					$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Community$Settings$News$Editor$CompletedSaving = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$Settings$News$Editor$EditExisting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$News$Editor$GotFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Community$Settings$News$Editor$NewsNotFound = {$: 3};
var $author$project$Page$Community$Settings$News$Editor$WithError = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$Settings$News$Editor$SchedulePublication = 1;
var $author$project$Page$Community$Settings$News$Editor$formFromExistingNews = F2(
	function (shared, news) {
		return $author$project$Form$init(
			{
				aR: A2(
					$author$project$Form$RichText$initModel,
					'description-input',
					$elm$core$Maybe$Just(news.aR)),
				d_: _Utils_eq(news.qe, news.nL) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					{
						jz: news.jz,
						g2: $author$project$Profile$Summary$init(false),
						qe: news.qe
					}),
				ch: $author$project$Form$DatePicker$initModel(
					A2(
						$justinmimbs$date$Date$fromPosix,
						shared.i2,
						A2($elm$core$Maybe$withDefault, shared.ce, news.iL))),
				c2: function () {
					var _v0 = news.iL;
					if (_v0.$ === 1) {
						return 0;
					} else {
						return 1;
					}
				}(),
				fu: A2(
					$elm$core$Maybe$withDefault,
					'13:00',
					A2(
						$elm$core$Maybe$map,
						function (posix) {
							return $elm$core$String$fromInt(
								A2($elm$time$Time$toHour, shared.i2, posix)) + (':' + $elm$core$String$fromInt(
								A2($elm$time$Time$toMinute, shared.i2, posix)));
						},
						news.iL)),
				fN: news.fN
			});
	});
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybeWithNull = function (maybeValue) {
	if (!maybeValue.$) {
		var value = maybeValue.a;
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value);
	} else {
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Null;
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $author$project$Api$Graphql$isNewsNotFoundError = $author$project$Api$Graphql$isCertainError('news not found');
var $author$project$Cambiatus$Mutation$news = F3(
	function (fillInOptionals, requiredArgs, object_) {
		var filledInOptionals = fillInOptionals(
			{w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, iL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'id', filledInOptionals.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'scheduling',
					filledInOptionals.iL,
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.mz;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs))
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'news',
			_Utils_ap(
				optionalArgs,
				_List_fromArray(
					[
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'description', requiredArgs.aR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'title', requiredArgs.fN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
					])),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Page$Community$Settings$News$Editor$setDisabled = F2(
	function (isDisabled, model) {
		if (model.$ === 2) {
			var action = model.a;
			var form = model.b;
			return A2(
				$author$project$Page$Community$Settings$News$Editor$Editing,
				action,
				A2($author$project$Form$withDisabled, isDisabled, form));
		} else {
			return model;
		}
	});
var $author$project$Markdown$toRawString = function (_v0) {
	var markdown = _v0;
	return $elm$core$String$trim(markdown);
};
var $author$project$Page$Community$Settings$News$Editor$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				var community = msg.a;
				return _Utils_eq(community.jz, loggedIn._) ? A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$ReloadResource(2),
					$author$project$UpdateResult$init(model)) : A2(
					$author$project$UpdateResult$addCmd,
					A2($author$project$Route$pushUrl, loggedIn.A.kK, $author$project$Route$Dashboard),
					$author$project$UpdateResult$init(model));
			case 1:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var news = msg.a.a.a;
							switch (model.$) {
								case 2:
									return A6(
										$author$project$UpdateResult$logImpossible,
										msg,
										'Loaded news, but was already editing',
										$elm$core$Maybe$Just(loggedIn._),
										{e$: 'update', fi: 'Page.Community.Settings.News.Editor'},
										_List_fromArray(
											[
												$author$project$Log$contextFromCommunity(loggedIn.pC)
											]),
										$author$project$UpdateResult$init(model));
								case 3:
									return A6(
										$author$project$UpdateResult$logImpossible,
										msg,
										'Loaded news, but state said news haven\'t been found',
										$elm$core$Maybe$Just(loggedIn._),
										{e$: 'update', fi: 'Page.Community.Settings.News.Editor'},
										_List_fromArray(
											[
												$author$project$Log$contextFromCommunity(loggedIn.pC)
											]),
										$author$project$UpdateResult$init(model));
								case 4:
									return A6(
										$author$project$UpdateResult$logImpossible,
										msg,
										'Loaded news, but state said there was already an error',
										$elm$core$Maybe$Just(loggedIn._),
										{e$: 'update', fi: 'Page.Community.Settings.News.Editor'},
										_List_fromArray(
											[
												$author$project$Log$contextFromCommunity(loggedIn.pC)
											]),
										$author$project$UpdateResult$init(model));
								case 0:
									return $author$project$UpdateResult$init(
										A2(
											$author$project$Page$Community$Settings$News$Editor$Editing,
											$author$project$Page$Community$Settings$News$Editor$CreateNew,
											A2($author$project$Page$Community$Settings$News$Editor$formFromExistingNews, loggedIn.A, news)));
								default:
									return $author$project$UpdateResult$init(
										A2(
											$author$project$Page$Community$Settings$News$Editor$Editing,
											$author$project$Page$Community$Settings$News$Editor$EditExisting(news),
											A2($author$project$Page$Community$Settings$News$Editor$formFromExistingNews, loggedIn.A, news)));
							}
						} else {
							var _v2 = msg.a.a;
							return $author$project$UpdateResult$init($author$project$Page$Community$Settings$News$Editor$NewsNotFound);
						}
					case 2:
						var err = msg.a.a;
						return $author$project$Api$Graphql$isNewsNotFoundError(err) ? $author$project$UpdateResult$init($author$project$Page$Community$Settings$News$Editor$NewsNotFound) : A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when loading news to edit',
							{e$: 'update', fi: 'Page.Community.Settings.News.Editor'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								$author$project$Page$Community$Settings$News$Editor$WithError(err)));
					case 0:
						var _v3 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v4 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 2:
				var subMsg = msg.a;
				switch (model.$) {
					case 2:
						var action = model.a;
						var form = model.b;
						return A5(
							$author$project$UpdateResult$fromChild,
							$author$project$Page$Community$Settings$News$Editor$Editing(action),
							$author$project$Page$Community$Settings$News$Editor$GotFormMsg,
							$author$project$Session$LoggedIn$addFeedback,
							model,
							A3($author$project$Form$update, loggedIn.A, subMsg, form));
					case 0:
						return A5(
							$author$project$UpdateResult$logIncompatibleMsg,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							{e$: 'update', fi: 'Page.Community.Settings.News.Editor'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					case 1:
						return A5(
							$author$project$UpdateResult$logIncompatibleMsg,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							{e$: 'update', fi: 'Page.Community.Settings.News.Editor'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					case 3:
						return A5(
							$author$project$UpdateResult$logIncompatibleMsg,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							{e$: 'update', fi: 'Page.Community.Settings.News.Editor'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					default:
						return A5(
							$author$project$UpdateResult$logIncompatibleMsg,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							{e$: 'update', fi: 'Page.Community.Settings.News.Editor'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
				}
			case 3:
				var formOutput = msg.a;
				if (model.$ === 2) {
					var action = model.a;
					var schedulingTime = A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$core$Basics$identity),
						formOutput.ch);
					var optionalArgs = function (optionals) {
						if (!action.$) {
							return _Utils_update(
								optionals,
								{
									iL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(schedulingTime)
								});
						} else {
							var news = action.a;
							return _Utils_update(
								optionals,
								{
									w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(news.w),
									iL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybeWithNull(schedulingTime)
								});
						}
					};
					var mutation = A3(
						$author$project$Cambiatus$Mutation$news,
						optionalArgs,
						{
							aR: $author$project$Markdown$toRawString(formOutput.aR),
							fN: formOutput.fN
						},
						$author$project$Community$News$selectionSet);
					return A2(
						$author$project$UpdateResult$addExt,
						A3($author$project$Session$LoggedIn$mutation, loggedIn, mutation, $author$project$Page$Community$Settings$News$Editor$CompletedSaving),
						$author$project$UpdateResult$init(
							A2($author$project$Page$Community$Settings$News$Editor$setDisabled, true, model)));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Tried saving communication, but wasn\'t editing',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Settings.News.Editor'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.pC)
							]),
						$author$project$UpdateResult$init(model));
				}
			default:
				switch (msg.a.$) {
					case 3:
						var maybeNews = msg.a.a;
						var setHighlighted = function (news) {
							return $author$project$UpdateResult$addExt(
								$author$project$Session$LoggedIn$UpdatedLoggedIn(
									_Utils_update(
										loggedIn,
										{
											pC: A2(
												$krisajenkins$remotedata$RemoteData$map,
												function (community) {
													return _Utils_update(
														community,
														{
															nu: $elm$core$Maybe$Just(news)
														});
												},
												loggedIn.pC)
										})));
						};
						var setAsHighlighted = function () {
							if (maybeNews.$ === 1) {
								return $elm$core$Basics$identity;
							} else {
								var news = maybeNews.a;
								var _v9 = news.iL;
								if (_v9.$ === 1) {
									return setHighlighted(news);
								} else {
									var scheduling = _v9.a;
									return (_Utils_cmp(
										$elm$time$Time$posixToMillis(scheduling),
										$elm$time$Time$posixToMillis(loggedIn.A.ce)) < 1) ? setHighlighted(news) : $elm$core$Basics$identity;
								}
							}
						}();
						return A2(
							$author$project$UpdateResult$addCmd,
							A2($author$project$Route$pushUrl, loggedIn.A.kK, $author$project$Route$CommunitySettingsNews),
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									0,
									loggedIn.A.aw.fL('news.saved')),
								setAsHighlighted(
									$author$project$UpdateResult$init(
										A2($author$project$Page$Community$Settings$News$Editor$setDisabled, false, model)))));
					case 2:
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								loggedIn.A.aw.fL('news.failed_saving')),
							$author$project$UpdateResult$init(
								A2($author$project$Page$Community$Settings$News$Editor$setDisabled, false, model)));
					case 0:
						var _v10 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v11 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
		}
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$Authorized = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$ClickedSaveObjective = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$Settings$ObjectiveEditor$ClosedAuthModal = {$: 2};
var $author$project$Page$Community$Settings$ObjectiveEditor$CompletedObjective = {$: 4};
var $author$project$Page$Community$Settings$ObjectiveEditor$CompletingActions = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Settings$ObjectiveEditor$Creating = 0;
var $author$project$Page$Community$Settings$ObjectiveEditor$CreatingObjective = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Community$Settings$ObjectiveEditor$Editing = {$: 0};
var $author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$GotFormMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Settings$ObjectiveEditor$NotFound = {$: 3};
var $author$project$Page$Community$Settings$ObjectiveEditor$RequestingConfirmation = {$: 2};
var $author$project$Page$Community$Settings$ObjectiveEditor$SavingCreation = 1;
var $author$project$Page$Community$Settings$ObjectiveEditor$SavingEdit = {$: 1};
var $author$project$Page$Community$Settings$ObjectiveEditor$Unauthorized = {$: 2};
var $author$project$Page$Community$Settings$ObjectiveEditor$AcceptedCompleteObjective = {$: 7};
var $author$project$Page$Community$Settings$ObjectiveEditor$GotCompleteObjectiveResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Cambiatus$Mutation$completeObjective = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'completeObjective',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Action$completeObjectiveSelectionSet = function (_v0) {
	var id = _v0;
	return $author$project$Cambiatus$Mutation$completeObjective(
		{w: id});
};
var $author$project$Page$Community$Settings$ObjectiveEditor$Objective = F3(
	function (id, description, isCompleted) {
		return {aR: description, w: id, b7: isCompleted};
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$objectiveSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Objective$isCompleted,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Objective$description,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Objective$id,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Community$Settings$ObjectiveEditor$Objective))));
var $author$project$Action$encode = function (action) {
	var makeAsset = function (amount) {
		return {ji: amount, as: action.ad.V.as};
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'community_id',
				$author$project$Eos$encodeSymbol(action.ad.V.as)),
				_Utils_Tuple2(
				'action_id',
				$author$project$Action$encodeId(action.w)),
				_Utils_Tuple2(
				'objective_id',
				$author$project$Action$encodeObjectiveId(action.ad.w)),
				_Utils_Tuple2(
				'description',
				$author$project$Markdown$encode(action.aR)),
				_Utils_Tuple2(
				'reward',
				$author$project$Eos$encodeAsset(
					makeAsset(action.fA))),
				_Utils_Tuple2(
				'verifier_reward',
				$author$project$Eos$encodeAsset(
					makeAsset(action.lY))),
				_Utils_Tuple2(
				'deadline',
				$elm$json$Json$Encode$int(
					$elm$time$Time$posixToMillis(
						$author$project$Utils$fromMaybeDateTime(action.go)))),
				_Utils_Tuple2(
				'usages',
				$elm$json$Json$Encode$int(action.ja)),
				_Utils_Tuple2(
				'usages_left',
				$elm$json$Json$Encode$int(action.jb)),
				_Utils_Tuple2(
				'verifications',
				$elm$json$Json$Encode$int(action.lX)),
				_Utils_Tuple2(
				'verification_type',
				$elm$json$Json$Encode$string(
					$elm$core$String$toLower(
						$author$project$Cambiatus$Enum$VerificationType$toString(action.jc)))),
				_Utils_Tuple2(
				'validators_str',
				$elm$json$Json$Encode$string(
					A2(
						$elm$core$String$join,
						'-',
						A2(
							$elm$core$List$map,
							function (v) {
								return $author$project$Eos$Account$nameToString(v.l8);
							},
							action.lV)))),
				_Utils_Tuple2(
				'is_completed',
				$author$project$Eos$encodeEosBool(
					$author$project$Eos$boolToEosBool(action.b7))),
				_Utils_Tuple2(
				'creator',
				$author$project$Eos$Account$encodeName(action.jz)),
				_Utils_Tuple2(
				'has_proof_photo',
				$author$project$Eos$encodeEosBool(
					$author$project$Eos$boolToEosBool(action.gB))),
				_Utils_Tuple2(
				'has_proof_code',
				$author$project$Eos$encodeEosBool(
					$author$project$Eos$boolToEosBool(action.dI))),
				_Utils_Tuple2(
				'photo_proof_instructions',
				$author$project$Markdown$encode(
					A2($elm$core$Maybe$withDefault, $author$project$Markdown$empty, action.iG))),
				_Utils_Tuple2(
				'image',
				$elm$json$Json$Encode$string(''))
			]));
};
var $author$project$Action$updateAction = F3(
	function (accountName, shared, action) {
		return {
			_: shared.hL.V,
			hw: {hr: accountName, iF: $author$project$Eos$Account$samplePermission},
			bZ: $author$project$Action$encode(action),
			fj: 'upsertaction'
		};
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$completeActionOrObjective = F5(
	function (loggedIn, model, msg, completionStatus, objective) {
		var _v0 = $elm$core$List$head(completionStatus.bE);
		if (_v0.$ === 1) {
			return $author$project$UpdateResult$addExt(
				A3(
					$author$project$Session$LoggedIn$mutation,
					loggedIn,
					A2($author$project$Action$completeObjectiveSelectionSet, objective.w, $author$project$Page$Community$Settings$ObjectiveEditor$objectiveSelectionSet),
					$author$project$Page$Community$Settings$ObjectiveEditor$GotCompleteObjectiveResponse));
		} else {
			var action = _v0.a.dh;
			return A2(
				$elm$core$Basics$composeR,
				$author$project$UpdateResult$addPort(
					function (completedAction) {
						return {
							bZ: $author$project$Eos$encodeTransaction(
								_List_fromArray(
									[completedAction])),
							fy: $author$project$Page$Community$Settings$ObjectiveEditor$AcceptedCompleteObjective,
							fz: $author$project$Action$encodeId(action.w)
						};
					}(
						A3(
							$author$project$Action$updateAction,
							loggedIn._,
							loggedIn.A,
							_Utils_update(
								action,
								{b7: true})))),
				A4(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_Nil,
					model,
					{hS: $author$project$Page$Community$Settings$ObjectiveEditor$ClosedAuthModal, iX: msg}));
		}
	});
var $author$project$Community$encodeCreateObjectiveAction = function (c) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'community_id',
				$author$project$Eos$encodeSymbol(c.gd)),
				_Utils_Tuple2(
				'objective_id',
				$elm$json$Json$Encode$int(0)),
				_Utils_Tuple2(
				'description',
				$author$project$Markdown$encode(c.aR)),
				_Utils_Tuple2(
				'editor',
				$author$project$Eos$Account$encodeName(c.jz))
			]));
};
var $author$project$Community$encodeUpdateObjectiveAction = function (c) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'community_id',
				$author$project$Eos$encodeSymbol(c.gd)),
				_Utils_Tuple2(
				'objective_id',
				$author$project$Action$encodeObjectiveId(c.kP)),
				_Utils_Tuple2(
				'description',
				$author$project$Markdown$encode(c.aR)),
				_Utils_Tuple2(
				'editor',
				$author$project$Eos$Account$encodeName(c.jI))
			]));
};
var $author$project$Page$Community$Settings$ObjectiveEditor$initForm = function (maybeMarkdown) {
	return $author$project$Form$init(
		A2($author$project$Form$RichText$initModel, 'description-input', maybeMarkdown));
};
var $author$project$Page$Community$Settings$ObjectiveEditor$update = F3(
	function (msg, model, loggedIn) {
		var t = loggedIn.A.aw.fL;
		switch (msg.$) {
			case 0:
				var community = msg.a;
				if (_Utils_eq(community.jz, loggedIn._)) {
					if (_Utils_eq(model.pN, $author$project$Page$Community$Settings$ObjectiveEditor$Loading)) {
						var _v1 = model.kP;
						if (!_v1.$) {
							return A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$RequestedCommunityField(1),
								$author$project$UpdateResult$init(model));
						} else {
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pN: A2(
											$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
											$author$project$Page$Community$Settings$ObjectiveEditor$initForm($elm$core$Maybe$Nothing),
											$author$project$Page$Community$Settings$ObjectiveEditor$CreatingObjective(0))
									}));
						}
					} else {
						return $author$project$UpdateResult$init(model);
					}
				} else {
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{pN: $author$project$Page$Community$Settings$ObjectiveEditor$Unauthorized}));
				}
			case 1:
				var objectives = msg.a;
				var _v2 = model.kP;
				if (_v2.$ === 1) {
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								pN: A2(
									$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
									$author$project$Page$Community$Settings$ObjectiveEditor$initForm($elm$core$Maybe$Nothing),
									$author$project$Page$Community$Settings$ObjectiveEditor$CreatingObjective(0))
							}));
				} else {
					var objectiveId = _v2.a;
					var _v3 = A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.w;
							},
							$elm$core$Basics$eq(objectiveId)),
						objectives);
					if (_v3.$ === 1) {
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{pN: $author$project$Page$Community$Settings$ObjectiveEditor$NotFound}));
					} else {
						var objective = _v3.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									pN: A2(
										$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
										$author$project$Page$Community$Settings$ObjectiveEditor$initForm(
											$elm$core$Maybe$Just(objective.aR)),
										A2($author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective, objective, $author$project$Page$Community$Settings$ObjectiveEditor$Editing))
								}));
					}
				}
			case 2:
				var _v4 = model.pN;
				if (_v4.$ === 1) {
					if (!_v4.b.$) {
						var form = _v4.a;
						var creatingStatus = _v4.b.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									pN: A2(
										$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
										A2($author$project$Form$withDisabled, false, form),
										$author$project$Page$Community$Settings$ObjectiveEditor$CreatingObjective(creatingStatus))
								}));
					} else {
						if (_v4.b.b.$ === 1) {
							var form = _v4.a;
							var _v5 = _v4.b;
							var objective = _v5.a;
							var _v6 = _v5.b;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pN: A2(
											$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
											A2($author$project$Form$withDisabled, false, form),
											A2($author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective, objective, $author$project$Page$Community$Settings$ObjectiveEditor$Editing))
									}));
						} else {
							var form = _v4.a;
							var status = _v4.b;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pN: A2(
											$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
											A2($author$project$Form$withDisabled, false, form),
											status)
									}));
						}
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Closed auth modal, but isn\'t authorized',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 5:
				var _v7 = model.pN;
				if (((_v7.$ === 1) && (_v7.b.$ === 1)) && (!_v7.b.b.$)) {
					var form = _v7.a;
					var _v8 = _v7.b;
					var objective = _v8.a;
					var _v9 = _v8.b;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								pN: A2(
									$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
									A2($author$project$Form$withDisabled, true, form),
									A2($author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective, objective, $author$project$Page$Community$Settings$ObjectiveEditor$RequestingConfirmation))
							}));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Requested to complete objective, but isn\'t authorized',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 6:
				var _v10 = model.pN;
				if (((_v10.$ === 1) && (_v10.b.$ === 1)) && (_v10.b.b.$ === 2)) {
					var form = _v10.a;
					var _v11 = _v10.b;
					var objective = _v11.a;
					var _v12 = _v11.b;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								pN: A2(
									$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
									form,
									A2($author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective, objective, $author$project$Page$Community$Settings$ObjectiveEditor$Editing))
							}));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Denied to complete objective, but isn\'t authorized',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 7:
				var _v13 = model.pN;
				if (((_v13.$ === 1) && (_v13.b.$ === 1)) && (_v13.b.b.$ === 2)) {
					var form = _v13.a;
					var _v14 = _v13.b;
					var objective = _v14.a;
					var _v15 = _v14.b;
					var completionStatus = {
						a4: A2(
							$elm$core$List$filter,
							function ($) {
								return $.b7;
							},
							objective.mb),
						bE: A2(
							$elm$core$List$filterMap,
							function (action) {
								return action.b7 ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									{dh: action, i6: 0});
							},
							objective.mb)
					};
					return A6(
						$author$project$Page$Community$Settings$ObjectiveEditor$completeActionOrObjective,
						loggedIn,
						model,
						msg,
						completionStatus,
						objective,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									pN: A2(
										$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
										form,
										A2(
											$author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective,
											objective,
											$author$project$Page$Community$Settings$ObjectiveEditor$CompletingActions(completionStatus)))
								})));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Accepted to complete objective, but isn\'t authorized',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 8:
				if (!msg.a.$) {
					var _v16 = model.pN;
					if (((_v16.$ === 1) && (_v16.b.$ === 1)) && (_v16.b.b.$ === 3)) {
						var form = _v16.a;
						var _v17 = _v16.b;
						var objective = _v17.a;
						var completionStatus = _v17.b.a;
						var _v18 = completionStatus.bE;
						if (!_v18.b) {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Finished completing an action successfully, but there were none left',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						} else {
							var action = _v18.a.dh;
							var left = _v18.b;
							var newCompletionStatus = _Utils_update(
								completionStatus,
								{
									a4: A2($elm$core$List$cons, action, completionStatus.a4),
									bE: left
								});
							return A6(
								$author$project$Page$Community$Settings$ObjectiveEditor$completeActionOrObjective,
								loggedIn,
								model,
								msg,
								newCompletionStatus,
								objective,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											pN: A2(
												$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
												form,
												A2(
													$author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective,
													objective,
													$author$project$Page$Community$Settings$ObjectiveEditor$CompletingActions(newCompletionStatus)))
										})));
						}
					} else {
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Completed an action, but isn\'t authorized',
							$elm$core$Maybe$Just(loggedIn._),
							{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					}
				} else {
					var _v19 = model.pN;
					if (((_v19.$ === 1) && (_v19.b.$ === 1)) && (_v19.b.b.$ === 3)) {
						var form = _v19.a;
						var _v20 = _v19.b;
						var objective = _v20.a;
						var completionStatus = _v20.b.a;
						var _v21 = completionStatus.bE;
						if (!_v21.b) {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Finished completing an action with an error, but there were none left',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						} else {
							var tries = _v21.a.i6;
							var action = _v21.a.dh;
							var left = _v21.b;
							var maxRetries = 2;
							if (_Utils_cmp(tries, maxRetries) > -1) {
								var newCompletionStatus = _Utils_update(
									completionStatus,
									{
										a4: A2($elm$core$List$cons, action, completionStatus.a4),
										bE: left
									});
								return A2(
									$author$project$UpdateResult$logEvent,
									{
										mL: _List_fromArray(
											[
												{
												ng: $elm$core$Dict$fromList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'actionId',
															$author$project$Action$encodeId(action.w)),
															_Utils_Tuple2(
															'objectiveId',
															$author$project$Action$encodeObjectiveId(objective.w)),
															_Utils_Tuple2(
															'tries',
															$elm$json$Json$Encode$int(tries)),
															_Utils_Tuple2(
															'maximumRetries',
															$elm$json$Json$Encode$int(maxRetries))
														])),
												fj: 'Details'
											}
											]),
										n4: 2,
										oa: {e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
										of: 'Error when trying to complete action with objective',
										pY: _List_Nil,
										p7: msg,
										qh: $elm$core$Maybe$Just(loggedIn._)
									},
									A6(
										$author$project$Page$Community$Settings$ObjectiveEditor$completeActionOrObjective,
										loggedIn,
										model,
										msg,
										newCompletionStatus,
										objective,
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{
													pN: A2(
														$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
														form,
														A2(
															$author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective,
															objective,
															$author$project$Page$Community$Settings$ObjectiveEditor$CompletingActions(newCompletionStatus)))
												}))));
							} else {
								var newCompletionStatus = _Utils_update(
									completionStatus,
									{
										bE: A2(
											$elm$core$List$cons,
											{dh: action, i6: tries + 1},
											left)
									});
								return A2(
									$author$project$UpdateResult$addBreadcrumb,
									{
										f7: msg,
										bZ: $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'tries',
													$elm$json$Json$Encode$int(tries)),
													_Utils_Tuple2(
													'actionId',
													$author$project$Action$encodeId(action.w))
												])),
										n4: 2,
										of: 'Failed to complete action',
										eq: 2
									},
									A6(
										$author$project$Page$Community$Settings$ObjectiveEditor$completeActionOrObjective,
										loggedIn,
										model,
										msg,
										newCompletionStatus,
										objective,
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{
													pN: A2(
														$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
														form,
														A2(
															$author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective,
															objective,
															$author$project$Page$Community$Settings$ObjectiveEditor$CompletingActions(newCompletionStatus)))
												}))));
							}
						}
					} else {
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Completed an action without being authorized',
							$elm$core$Maybe$Just(loggedIn._),
							{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					}
				}
			case 9:
				switch (msg.a.$) {
					case 3:
						var _v22 = model.pN;
						if (_v22.$ === 1) {
							var formModel = _v22.a;
							var formStatus = _v22.b;
							if (formStatus.$ === 1) {
								var objective = formStatus.a;
								return $author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											pN: A2(
												$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
												formModel,
												A2($author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective, objective, $author$project$Page$Community$Settings$ObjectiveEditor$CompletedObjective))
										}));
							} else {
								return A6(
									$author$project$UpdateResult$logImpossible,
									msg,
									'Completed objective, but was just creating an objective',
									$elm$core$Maybe$Just(loggedIn._),
									{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
									_List_Nil,
									$author$project$UpdateResult$init(model));
							}
						} else {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed objective, but was not authorized',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when completing objective',
							{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
							_List_Nil,
							err,
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									1,
									t('community.objectives.editor.error_marking_as_complete')),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											pN: function () {
												var _v24 = model.pN;
												if ((_v24.$ === 1) && (_v24.b.$ === 1)) {
													var form = _v24.a;
													var _v25 = _v24.b;
													var objective = _v25.a;
													return A2(
														$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
														A2($author$project$Form$withDisabled, false, form),
														A2($author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective, objective, $author$project$Page$Community$Settings$ObjectiveEditor$Editing));
												} else {
													return model.pN;
												}
											}()
										}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 4:
				var description = msg.a;
				var _v26 = _Utils_Tuple2(loggedIn.pC, model.pN);
				_v26$2:
				while (true) {
					if ((_v26.a.$ === 3) && (_v26.b.$ === 1)) {
						if (!_v26.b.b.$) {
							if (!_v26.b.b.a) {
								var community = _v26.a.a;
								var _v27 = _v26.b;
								var form = _v27.a;
								var _v28 = _v27.b.a;
								return A5(
									$author$project$Session$LoggedIn$withPrivateKey,
									loggedIn,
									_List_Nil,
									model,
									{hS: $author$project$Page$Community$Settings$ObjectiveEditor$ClosedAuthModal, iX: msg},
									A2(
										$author$project$UpdateResult$addPort,
										{
											bZ: $author$project$Eos$encodeTransaction(
												_List_fromArray(
													[
														{
														_: loggedIn.A.hL.V,
														hw: {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission},
														bZ: $author$project$Community$encodeCreateObjectiveAction(
															{gd: community.as, jz: loggedIn._, aR: description}),
														fj: 'upsertobjctv'
													}
													])),
											fy: $author$project$Page$Community$Settings$ObjectiveEditor$ClickedSaveObjective(description),
											fz: $elm$json$Json$Encode$null
										},
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{
													pN: A2(
														$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
														A2($author$project$Form$withDisabled, true, form),
														$author$project$Page$Community$Settings$ObjectiveEditor$CreatingObjective(1))
												}))));
							} else {
								break _v26$2;
							}
						} else {
							var _v29 = _v26.b;
							var form = _v29.a;
							var _v30 = _v29.b;
							var objective = _v30.a;
							return A5(
								$author$project$Session$LoggedIn$withPrivateKey,
								loggedIn,
								_List_Nil,
								model,
								{hS: $author$project$Page$Community$Settings$ObjectiveEditor$ClosedAuthModal, iX: msg},
								A2(
									$author$project$UpdateResult$addPort,
									{
										bZ: $author$project$Eos$encodeTransaction(
											_List_fromArray(
												[
													{
													_: loggedIn.A.hL.V,
													hw: {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission},
													bZ: $author$project$Community$encodeUpdateObjectiveAction(
														{gd: objective.V.as, aR: description, jI: loggedIn._, kP: objective.w}),
													fj: 'upsertobjctv'
												}
												])),
										fy: $author$project$Page$Community$Settings$ObjectiveEditor$ClickedSaveObjective(description),
										fz: $elm$json$Json$Encode$null
									},
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{
												pN: A2(
													$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
													A2($author$project$Form$withDisabled, true, form),
													A2($author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective, objective, $author$project$Page$Community$Settings$ObjectiveEditor$SavingEdit))
											}))));
						}
					} else {
						break _v26$2;
					}
				}
				return A6(
					$author$project$UpdateResult$logImpossible,
					msg,
					'Tried saving objective without having the community loaded or without being authorized',
					$elm$core$Maybe$Just(loggedIn._),
					{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
					_List_Nil,
					$author$project$UpdateResult$init(model));
			case 10:
				if (!msg.a.$) {
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$author$project$Route$replaceUrl,
							loggedIn.A.kK,
							$author$project$Route$CommunityObjectives($author$project$Route$WithNoObjectiveSelected)),
						A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$RequestedReloadCommunityField(1),
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									0,
									t('community.objectives.create_success')),
								$author$project$UpdateResult$init(model))));
				} else {
					var v = msg.a.a;
					var newModel = function () {
						var _v31 = model.pN;
						_v31$2:
						while (true) {
							if (_v31.$ === 1) {
								if (!_v31.b.$) {
									if (_v31.b.a === 1) {
										var form = _v31.a;
										var _v32 = _v31.b.a;
										return A7(
											$author$project$UpdateResult$logJsonValue,
											msg,
											$elm$core$Maybe$Just(loggedIn._),
											'Got an error when creating an objective',
											{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
											_List_Nil,
											v,
											$author$project$UpdateResult$init(
												_Utils_update(
													model,
													{
														pN: A2(
															$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
															A2($author$project$Form$withDisabled, false, form),
															$author$project$Page$Community$Settings$ObjectiveEditor$CreatingObjective(0))
													})));
									} else {
										break _v31$2;
									}
								} else {
									if (_v31.b.b.$ === 1) {
										var form = _v31.a;
										var _v33 = _v31.b;
										var objective = _v33.a;
										var _v34 = _v33.b;
										return A7(
											$author$project$UpdateResult$logJsonValue,
											msg,
											$elm$core$Maybe$Just(loggedIn._),
											'Got an error when updating an objective',
											{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
											_List_fromArray(
												[
													{
													ng: $elm$core$Dict$fromList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'ID',
																$author$project$Action$encodeObjectiveId(objective.w))
															])),
													fj: 'Objective'
												}
												]),
											v,
											$author$project$UpdateResult$init(
												_Utils_update(
													model,
													{
														pN: A2(
															$author$project$Page$Community$Settings$ObjectiveEditor$Authorized,
															A2($author$project$Form$withDisabled, false, form),
															A2($author$project$Page$Community$Settings$ObjectiveEditor$EditingObjective, objective, $author$project$Page$Community$Settings$ObjectiveEditor$Editing))
													})));
									} else {
										break _v31$2;
									}
								}
							} else {
								break _v31$2;
							}
						}
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Saved objective without being authorized',
							$elm$core$Maybe$Just(loggedIn._),
							{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					}();
					return A2(
						$author$project$UpdateResult$addExt,
						A2(
							$author$project$Session$LoggedIn$ShowFeedback,
							1,
							t('error.unknown')),
						newModel);
				}
			case 3:
				var subMsg = msg.a;
				var _v35 = model.pN;
				if (_v35.$ === 1) {
					var form = _v35.a;
					var status = _v35.b;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newForm) {
							return _Utils_update(
								model,
								{
									pN: A2($author$project$Page$Community$Settings$ObjectiveEditor$Authorized, newForm, status)
								});
						},
						$author$project$Page$Community$Settings$ObjectiveEditor$GotFormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, loggedIn.A, subMsg, form));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Tried updating objective editor form, but wasn\'t authorized',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Community.Settings.ObjectiveEditor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			default:
				return A2(
					$author$project$UpdateResult$addCmd,
					A2($author$project$Route$pushUrl, loggedIn.A.kK, $author$project$Route$CommunitySettingsObjectives),
					$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Community$Settings$Objectives$Loaded = 1;
var $author$project$Page$Community$Settings$Objectives$Unauthorized = 2;
var $author$project$Profile$Summary$initMany = F2(
	function (isLarge, amount) {
		return A2(
			$elm$core$List$repeat,
			amount,
			$author$project$Profile$Summary$init(isLarge));
	});
var $author$project$Page$Community$Settings$Objectives$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				var community = msg.a;
				var _v1 = (community.bz && _Utils_eq(community.jz, loggedIn._)) ? _Utils_Tuple2(
					1,
					$author$project$UpdateResult$addExt(
						$author$project$Session$LoggedIn$RequestedReloadCommunityField(1))) : _Utils_Tuple2(2, $elm$core$Basics$identity);
				var status = _v1.a;
				var maybeRequestObjectives = _v1.b;
				return maybeRequestObjectives(
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{pN: status})));
			case 1:
				var index = msg.a;
				return _Utils_eq(
					model.d4,
					$elm$core$Maybe$Just(index)) ? A2(
					$author$project$UpdateResult$addBreadcrumb,
					{
						f7: msg,
						bZ: $elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'objectiveId',
									$author$project$Action$encodeObjectiveId(index))
								])),
						n4: 4,
						of: 'Closed objective',
						eq: 1
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{d4: $elm$core$Maybe$Nothing, c1: $pzp1997$assoc_list$AssocList$empty}))) : A2(
					$author$project$UpdateResult$addBreadcrumb,
					{
						f7: msg,
						bZ: $elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'objectiveId',
									$author$project$Action$encodeObjectiveId(index))
								])),
						n4: 4,
						of: 'Closed objective',
						eq: 1
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								d4: $elm$core$Maybe$Just(index),
								c1: $pzp1997$assoc_list$AssocList$fromList(
									A2(
										$elm$core$List$map,
										function (action) {
											return _Utils_Tuple2(
												action.w,
												A2(
													$author$project$Profile$Summary$initMany,
													false,
													$elm$core$List$length(action.lV)));
										},
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.mb;
												},
												A2(
													$elm$core$Maybe$andThen,
													$elm_community$list_extra$List$Extra$find(
														function (objective) {
															return _Utils_eq(objective.w, index);
														}),
													A2(
														$elm$core$Maybe$andThen,
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.cV;
															},
															$krisajenkins$remotedata$RemoteData$toMaybe),
														$krisajenkins$remotedata$RemoteData$toMaybe(loggedIn.pC)))))))
							})));
			default:
				var actionIndex = msg.a;
				var validatorIndex = msg.b;
				var subMsg = msg.c;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							c1: A3(
								$pzp1997$assoc_list$AssocList$update,
								actionIndex,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$withDefault(_List_Nil),
									A2(
										$elm$core$Basics$composeR,
										A2(
											$elm_community$list_extra$List$Extra$updateAt,
											validatorIndex,
											$author$project$Profile$Summary$update(subMsg)),
										$elm$core$Maybe$Just)),
								model.c1)
						}));
		}
	});
var $author$project$Page$Community$Settings$Settings$Authorized = 1;
var $author$project$Session$LoggedIn$CommunityResource = 0;
var $author$project$Page$Community$Settings$Settings$Unauthorized = 2;
var $author$project$Page$Community$Settings$Settings$update = F3(
	function (msg, model, loggedIn) {
		if (!msg.$) {
			var community = msg.a;
			return _Utils_eq(community.jz, loggedIn._) ? $author$project$UpdateResult$init(1) : $author$project$UpdateResult$init(2);
		} else {
			return A2(
				$author$project$UpdateResult$addExt,
				$author$project$Session$LoggedIn$ReloadResource(0),
				$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Community$Settings$Shop$Categories$CompletedDeletingCategory = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Page$Community$Settings$Shop$Categories$CompletedMovingCategory = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Page$Community$Settings$Shop$Categories$CompletedMovingCategoryToRoot = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Page$Community$Settings$Shop$Categories$DropdownOpenOnButton = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$DropdownOpenOnMouse = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Page$Community$Settings$Shop$Categories$EditingNewCategory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$FinishedCreatingCategory = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$FinishedUpdatingCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$GotAddCategoryFormMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$GotDndMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$GotKeywordDndMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$GotMetadataFormMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$GotUpdateCategoryFormMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$GotViewportForContextMenuForAction = F3(
	function (a, b, c) {
		return {$: 19, a: a, b: b, c: c};
	});
var $author$project$Page$Community$Settings$Shop$Categories$NoOp = {$: 0};
var $author$project$Page$Community$Settings$Shop$Categories$Open = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Cambiatus$InputObject$encodeSubcategoryInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input.w))),
				_Utils_Tuple2(
				'position',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input.bq)))
			]));
};
var $author$project$Cambiatus$Mutation$category = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{dn: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, h1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, h4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ii: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ij: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ik: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, fj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, iE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, iP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'categories',
					filledInOptionals.dn,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Cambiatus$InputObject$encodeSubcategoryInput)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'description', filledInOptionals.aR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'iconUri', filledInOptionals.h1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'id', filledInOptionals.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'imageUri', filledInOptionals.h4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'metaDescription', filledInOptionals.ii, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'metaKeywords', filledInOptionals.ij, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'metaTitle', filledInOptionals.ik, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'name', filledInOptionals.fj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'parentId', filledInOptionals.iE, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'position', filledInOptionals.bq, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'slug', filledInOptionals.iP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'category',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Shop$Category$addChild = F2(
	function (tree, newChildId) {
		var toSubcategoryInput = F2(
			function (index, categoryId) {
				return {
					w: $author$project$Shop$Category$idToInt(categoryId),
					bq: 0
				};
			});
		return $author$project$Cambiatus$Mutation$category(
			function (optionals) {
				return _Utils_update(
					optionals,
					{
						dn: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							A2(
								$elm$core$List$indexedMap,
								toSubcategoryInput,
								function (childrenIds) {
									return A2($elm$core$List$cons, newChildId, childrenIds);
								}(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$zwilias$elm_rosetree$Tree$label,
											function ($) {
												return $.w;
											}),
										$zwilias$elm_rosetree$Tree$children(tree))))),
						w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							$author$project$Shop$Category$idToInt(
								$zwilias$elm_rosetree$Tree$label(tree).w))
					});
			});
	});
var $zwilias$elm_rosetree$Tree$appendChild = F2(
	function (c, _v0) {
		var v = _v0.a;
		var cs = _v0.b;
		return A2(
			$zwilias$elm_rosetree$Tree$Tree,
			v,
			_Utils_ap(
				cs,
				_List_fromArray(
					[c])));
	});
var $author$project$Shop$Category$create = function (_v0) {
	var icon = _v0.p;
	var name = _v0.fj;
	var slug = _v0.iP;
	var description = _v0.aR;
	var image = _v0.h2;
	var parentId = _v0.iE;
	var position = _v0.bq;
	return $author$project$Cambiatus$Mutation$category(
		function (optionals) {
			return _Utils_update(
				optionals,
				{
					aR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Markdown$toRawString(description)),
					h1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(icon),
					h4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(image),
					fj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(name),
					iE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
						A2(
							$elm$core$Maybe$map,
							function (_v1) {
								var id = _v1;
								return id;
							},
							parentId)),
					bq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(position),
					iP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$hecrj$elm_slug$Slug$toString(slug))
				});
		});
};
var $author$project$Cambiatus$Mutation$deleteCategory = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'deleteCategory',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Shop$Category$delete = function (_v0) {
	var id = _v0;
	return $author$project$Cambiatus$Mutation$deleteCategory(
		{w: id});
};
var $author$project$Shop$Category$encodeId = function (_v0) {
	var id = _v0;
	return $elm$json$Json$Encode$int(id);
};
var $author$project$Utils$Tree$findZipperInForest = F2(
	function (fn, trees) {
		if (!trees.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var firstTree = trees.a;
			var otherTrees = trees.b;
			return A2(
				$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
				fn,
				A2($zwilias$elm_rosetree$Tree$Zipper$fromForest, firstTree, otherTrees));
		}
	});
var $author$project$Dnd$getDraggingOverElement = function (_v0) {
	var model = _v0;
	return model.bw;
};
var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
var $author$project$Utils$Tree$goDownWithoutChildren = function (zipper) {
	var _v0 = $zwilias$elm_rosetree$Tree$Zipper$nextSibling(zipper);
	if (_v0.$ === 1) {
		return A2(
			$elm$core$Maybe$andThen,
			$zwilias$elm_rosetree$Tree$Zipper$parent,
			$zwilias$elm_rosetree$Tree$Zipper$parent(zipper));
	} else {
		var firstSibling = _v0.a;
		return $elm$core$Maybe$Just(firstSibling);
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$lastChild = function (_v0) {
	var zipper = _v0;
	var _v1 = $elm$core$List$reverse(
		$zwilias$elm_rosetree$Tree$children(zipper.v));
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var c = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				hu: _List_Nil,
				hy: rest,
				W: A2(
					$elm$core$List$cons,
					{
						hu: zipper.hu,
						hy: zipper.hy,
						n$: $zwilias$elm_rosetree$Tree$label(zipper.v)
					},
					zipper.W),
				v: c
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$lastDescendant = function (zipper) {
	lastDescendant:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$lastChild(zipper);
		if (_v0.$ === 1) {
			return zipper;
		} else {
			var child = _v0.a;
			var $temp$zipper = child;
			zipper = $temp$zipper;
			continue lastDescendant;
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$backward = function (zipper) {
	return A2(
		$zwilias$elm_rosetree$Tree$Zipper$firstOf,
		_List_fromArray(
			[
				A2(
				$elm$core$Basics$composeR,
				$zwilias$elm_rosetree$Tree$Zipper$previousSibling,
				$elm$core$Maybe$map($zwilias$elm_rosetree$Tree$Zipper$lastDescendant)),
				$zwilias$elm_rosetree$Tree$Zipper$parent
			]),
		zipper);
};
var $author$project$Utils$Tree$goUpWithoutChildren = function (zipper) {
	return A2(
		$elm$core$Maybe$andThen,
		function (backwardZipper) {
			return _Utils_eq(
				$zwilias$elm_rosetree$Tree$Zipper$parent(zipper),
				$elm$core$Maybe$Just(backwardZipper)) ? $zwilias$elm_rosetree$Tree$Zipper$parent(backwardZipper) : $elm$core$Maybe$Just(backwardZipper);
		},
		$zwilias$elm_rosetree$Tree$Zipper$backward(zipper));
};
var $Gizra$elm_all_set$EverySet$insert = F2(
	function (k, _v0) {
		var d = _v0;
		return A3($pzp1997$assoc_list$AssocList$insert, k, 0, d);
	});
var $author$project$Page$Community$Settings$Shop$Categories$isAncestorOf = F2(
	function (childId, parentTree) {
		var parentId = $zwilias$elm_rosetree$Tree$label(parentTree).w;
		var isItself = _Utils_eq(childId, parentId);
		var isIndirectAncestor = A2(
			$elm$core$List$any,
			function (childTree) {
				return _Utils_eq(
					childId,
					$zwilias$elm_rosetree$Tree$label(childTree).w) ? true : A2($author$project$Page$Community$Settings$Shop$Categories$isAncestorOf, childId, childTree);
			},
			$zwilias$elm_rosetree$Tree$children(parentTree));
		return isItself || isIndirectAncestor;
	});
var $author$project$Api$Graphql$DeleteStatus$reasonToErrorString = function (reason) {
	switch (reason.$) {
		case 0:
			var apiMessage = reason.a;
			return 'Error returned from API: ' + apiMessage;
		case 1:
			return 'Invalid status (`status` field was not `success` or `error`)';
		default:
			return 'UnknownError - API returned a null object instead of a DeleteStatus object';
	}
};
var $author$project$Log$fromDeletionStatusError = F5(
	function (transaction, maybeUser, location, contexts, reason) {
		return {
			mL: contexts,
			n4: 1,
			oa: location,
			of: $author$project$Api$Graphql$DeleteStatus$reasonToErrorString(reason),
			pY: _List_fromArray(
				[
					$author$project$Log$TypeTag(4)
				]),
			p7: transaction,
			qh: maybeUser
		};
	});
var $author$project$UpdateResult$logDeletionStatusError = F5(
	function (transaction, maybeUser, location, contexts, reason) {
		return $author$project$UpdateResult$logEvent(
			A5($author$project$Log$fromDeletionStatusError, transaction, maybeUser, location, contexts, reason));
	});
var $zwilias$elm_rosetree$Tree$Zipper$mapTree = F2(
	function (f, _v0) {
		var zipper = _v0;
		return _Utils_update(
			zipper,
			{
				v: f(zipper.v)
			});
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pzp1997$assoc_list$AssocList$member = F2(
	function (targetKey, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$get, targetKey, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $Gizra$elm_all_set$EverySet$member = F2(
	function (k, _v0) {
		var d = _v0;
		return A2($pzp1997$assoc_list$AssocList$member, k, d);
	});
var $zwilias$elm_rosetree$Tree$mapChildren = F2(
	function (f, _v0) {
		var v = _v0.a;
		var cs = _v0.b;
		return A2(
			$zwilias$elm_rosetree$Tree$Tree,
			v,
			f(cs));
	});
var $zwilias$elm_rosetree$Tree$prependChild = F2(
	function (c, _v0) {
		var v = _v0.a;
		var cs = _v0.b;
		return A2(
			$zwilias$elm_rosetree$Tree$Tree,
			v,
			A2($elm$core$List$cons, c, cs));
	});
var $zwilias$elm_rosetree$Tree$Zipper$reconstructWithoutFocus = F3(
	function (l, before, after) {
		return A2(
			$zwilias$elm_rosetree$Tree$tree,
			l,
			_Utils_ap(
				$elm$core$List$reverse(before),
				after));
	});
var $zwilias$elm_rosetree$Tree$Zipper$removeTree = function (_v0) {
	var zipper = _v0;
	var _v1 = _Utils_Tuple3(zipper.W, zipper.hy, zipper.hu);
	if (_v1.a.b) {
		var _v2 = _v1.a;
		var crumb = _v2.a;
		var rest = _v2.b;
		var before = _v1.b;
		var after = _v1.c;
		return $elm$core$Maybe$Just(
			{
				hu: crumb.hu,
				hy: crumb.hy,
				W: rest,
				v: A3($zwilias$elm_rosetree$Tree$Zipper$reconstructWithoutFocus, crumb.n$, before, after)
			});
	} else {
		if (_v1.b.b) {
			var _v3 = _v1.b;
			var b = _v3.a;
			var bs = _v3.b;
			var after = _v1.c;
			return $elm$core$Maybe$Just(
				{hu: after, hy: bs, W: _List_Nil, v: b});
		} else {
			if (!_v1.c.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v4 = _v1.c;
				var a = _v4.a;
				var as_ = _v4.b;
				return $elm$core$Maybe$Just(
					{hu: as_, hy: _List_Nil, W: _List_Nil, v: a});
			}
		}
	}
};
var $author$project$Page$Community$Settings$Shop$Categories$moveChild = function (_v0) {
	var childZipper = _v0.ga;
	var parentId = _v0.iE;
	var _v1 = $zwilias$elm_rosetree$Tree$Zipper$removeTree(childZipper);
	if (_v1.$ === 1) {
		return childZipper;
	} else {
		var zipperWithoutChild = _v1.a;
		var _v2 = A2(
			$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
			function (_v3) {
				var id = _v3.w;
				return _Utils_eq(id, parentId);
			},
			zipperWithoutChild);
		if (_v2.$ === 1) {
			return childZipper;
		} else {
			var newParentZipper = _v2.a;
			return A2(
				$zwilias$elm_rosetree$Tree$Zipper$mapTree,
				function (parentTree) {
					return A2(
						$zwilias$elm_rosetree$Tree$mapChildren,
						function (newChildren) {
							return A2(
								$elm$core$List$sortBy,
								A2(
									$elm$core$Basics$composeR,
									$zwilias$elm_rosetree$Tree$label,
									function ($) {
										return $.fj;
									}),
								newChildren);
						},
						A2(
							$zwilias$elm_rosetree$Tree$prependChild,
							$zwilias$elm_rosetree$Tree$Zipper$tree(childZipper),
							parentTree));
				},
				newParentZipper);
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$toForest = function (input) {
	var _v0 = $zwilias$elm_rosetree$Tree$Zipper$root(input);
	var focus = _v0.v;
	var after = _v0.hu;
	return _Utils_Tuple2(focus, after);
};
var $author$project$Utils$Tree$toFlatForest = function (zipper) {
	return function (_v0) {
		var first = _v0.a;
		var others = _v0.b;
		return A2($elm$core$List$cons, first, others);
	}(
		$zwilias$elm_rosetree$Tree$Zipper$toForest(zipper));
};
var $author$project$Page$Community$Settings$Shop$Categories$moveToRoot = function (_v0) {
	var childZipper = _v0.ga;
	var insertNewChild = function (forest) {
		return function (newChild) {
			return A2($elm$core$List$cons, newChild, forest);
		}(
			$zwilias$elm_rosetree$Tree$Zipper$tree(childZipper));
	};
	return A2(
		$elm$core$Maybe$withDefault,
		childZipper,
		A2(
			$elm$core$Maybe$andThen,
			function (zipperWithoutChild) {
				return $author$project$Utils$Tree$fromFlatForest(
					A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							$zwilias$elm_rosetree$Tree$label,
							function ($) {
								return $.fj;
							}),
						insertNewChild(
							$author$project$Utils$Tree$toFlatForest(zipperWithoutChild))));
			},
			$zwilias$elm_rosetree$Tree$Zipper$removeTree(childZipper)));
};
var $author$project$Shop$Category$moveToRoot = function (_v0) {
	var id = _v0;
	return $author$project$Cambiatus$Mutation$category(
		function (optionals) {
			return _Utils_update(
				optionals,
				{
					w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(id),
					iE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Null
				});
		});
};
var $author$project$Page$Community$Settings$Shop$Categories$newDescriptionInputId = function (maybeParentId) {
	if (maybeParentId.$ === 1) {
		return 'new-description-input-root';
	} else {
		var parentId = maybeParentId.a;
		return 'new-description-input-' + $author$project$Shop$Category$idToString(parentId);
	}
};
var $Gizra$elm_all_set$EverySet$remove = F2(
	function (k, _v0) {
		var d = _v0;
		return A2($pzp1997$assoc_list$AssocList$remove, k, d);
	});
var $zwilias$elm_rosetree$Tree$mapLabel = F2(
	function (f, _v0) {
		var v = _v0.a;
		var cs = _v0.b;
		return A2(
			$zwilias$elm_rosetree$Tree$Tree,
			f(v),
			cs);
	});
var $zwilias$elm_rosetree$Tree$Zipper$mapLabel = F2(
	function (f, zipper) {
		return A2(
			$zwilias$elm_rosetree$Tree$Zipper$mapTree,
			$zwilias$elm_rosetree$Tree$mapLabel(f),
			zipper);
	});
var $zwilias$elm_rosetree$Tree$Zipper$replaceLabel = F2(
	function (l, zipper) {
		return A2(
			$zwilias$elm_rosetree$Tree$Zipper$mapLabel,
			$elm$core$Basics$always(l),
			zipper);
	});
var $author$project$Api$Graphql$DeleteStatus$Error = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Graphql$DeleteStatus$UnknownError = {$: 2};
var $author$project$Api$Graphql$DeleteStatus$ApiError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Graphql$DeleteStatus$Deleted = {$: 0};
var $author$project$Api$Graphql$DeleteStatus$InvalidStatus = {$: 1};
var $author$project$Cambiatus$Object$DeleteStatus$reason = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'reason', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$DeleteStatus$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'status', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Api$Graphql$DeleteStatus$internalSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$DeleteStatus$status,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$DeleteStatus$reason,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
			F2(
				function (reason, status) {
					switch (status) {
						case 'success':
							return $author$project$Api$Graphql$DeleteStatus$Deleted;
						case 'error':
							return $author$project$Api$Graphql$DeleteStatus$Error(
								$author$project$Api$Graphql$DeleteStatus$ApiError(reason));
						default:
							return $author$project$Api$Graphql$DeleteStatus$Error($author$project$Api$Graphql$DeleteStatus$InvalidStatus);
					}
				}))));
var $author$project$Api$Graphql$DeleteStatus$selectionSet = function (fn) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$withDefault(
			$author$project$Api$Graphql$DeleteStatus$Error($author$project$Api$Graphql$DeleteStatus$UnknownError)),
		fn($author$project$Api$Graphql$DeleteStatus$internalSelectionSet));
};
var $zwilias$elm_rosetree$Tree$singleton = function (v) {
	return A2($zwilias$elm_rosetree$Tree$Tree, v, _List_Nil);
};
var $author$project$Dnd$DraggedOver = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dnd$Dropped = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dnd$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var elementId = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							dy: $elm$core$Maybe$Just(elementId)
						}));
			case 1:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dy: $elm$core$Maybe$Nothing, bw: $elm$core$Maybe$Nothing}));
			case 2:
				var elementId = msg.a;
				var _v2 = model.dy;
				if (_v2.$ === 1) {
					return $author$project$UpdateResult$init(model);
				} else {
					var draggingElement = _v2.a;
					return A2(
						$author$project$UpdateResult$addExt,
						$author$project$Dnd$Dropped(
							{m3: draggingElement, m4: elementId}),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{dy: $elm$core$Maybe$Nothing, bw: $elm$core$Maybe$Nothing})));
				}
			case 3:
				var dropZone_ = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							bw: _Utils_eq(
								model.bw,
								$elm$core$Maybe$Just(dropZone_)) ? $elm$core$Maybe$Nothing : model.bw
						}));
			default:
				var dropZone_ = msg.a;
				var fireDraggedOver = _Utils_eq(
					model.bw,
					$elm$core$Maybe$Just(dropZone_)) ? $elm$core$Basics$identity : $author$project$UpdateResult$addExt(
					$author$project$Dnd$DraggedOver(dropZone_));
				return fireDraggedOver(
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								bw: $elm$core$Maybe$Just(dropZone_)
							})));
		}
	});
var $author$project$Shop$Category$update = F2(
	function (model, _v0) {
		var icon = _v0.p;
		var name = _v0.fj;
		var description = _v0.aR;
		var slug = _v0.iP;
		var image = _v0.h2;
		return $author$project$Cambiatus$Mutation$category(
			function (optionals) {
				return _Utils_update(
					optionals,
					{
						aR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							$author$project$Markdown$toRawString(description)),
						h1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybeWithNull(icon),
						w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							$author$project$Shop$Category$idToInt(model.w)),
						h4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybeWithNull(image),
						fj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(name),
						iP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							$hecrj$elm_slug$Slug$toString(slug))
					});
			});
	});
var $author$project$Page$Community$Settings$Shop$Categories$DraggedOverCategoryForAWhile = function (a) {
	return {$: 26, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$updateDnd = F3(
	function (loggedIn, ext, ur) {
		if (!ext.$) {
			var draggedElement = ext.a.m3;
			var dropZone = ext.a.m4;
			var _v1 = A2(
				$author$project$Community$getField,
				loggedIn.pC,
				function ($) {
					return $.fC;
				});
			if (_v1.$ === 3) {
				var _v2 = _v1.a;
				var categories = _v2.b;
				if (!dropZone.$) {
					var parentId = dropZone.a;
					var _v4 = A2(
						$author$project$Utils$Tree$findZipperInForest,
						function (_v5) {
							var id = _v5.w;
							return _Utils_eq(id, parentId);
						},
						categories);
					if (_v4.$ === 1) {
						return ur;
					} else {
						var parentZipper = _v4.a;
						return A2(
							$author$project$UpdateResult$addExt,
							A3(
								$author$project$Session$LoggedIn$mutation,
								loggedIn,
								A3(
									$author$project$Shop$Category$addChild,
									$zwilias$elm_rosetree$Tree$Zipper$tree(parentZipper),
									draggedElement,
									$author$project$Shop$Category$idSelectionSet),
								$author$project$Page$Community$Settings$Shop$Categories$CompletedMovingCategory(draggedElement)),
							ur);
					}
				} else {
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$mutation,
							loggedIn,
							A2(
								$author$project$Shop$Category$moveToRoot,
								draggedElement,
								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(0)),
							$author$project$Page$Community$Settings$Shop$Categories$CompletedMovingCategoryToRoot(draggedElement)),
						ur);
				}
			} else {
				return ur;
			}
		} else {
			if (!ext.a.$) {
				var categoryId = ext.a.a;
				var millisToWait = 250;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$perform,
						function (_v6) {
							return $author$project$Page$Community$Settings$Shop$Categories$DraggedOverCategoryForAWhile(categoryId);
						},
						$elm$core$Process$sleep(millisToWait)),
					ur);
			} else {
				var _v7 = ext.a;
				return ur;
			}
		}
	});
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $elm_community$list_extra$List$Extra$uncons = function (list) {
	if (!list.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var first = list.a;
		var rest = list.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(first, rest));
	}
};
var $elm_community$list_extra$List$Extra$swapAt = F3(
	function (index1, index2, l) {
		swapAt:
		while (true) {
			if (_Utils_eq(index1, index2) || (index1 < 0)) {
				return l;
			} else {
				if (_Utils_cmp(index1, index2) > 0) {
					var $temp$index1 = index2,
						$temp$index2 = index1,
						$temp$l = l;
					index1 = $temp$index1;
					index2 = $temp$index2;
					l = $temp$l;
					continue swapAt;
				} else {
					var _v0 = A2($elm_community$list_extra$List$Extra$splitAt, index1, l);
					var part1 = _v0.a;
					var tail1 = _v0.b;
					var _v1 = A2($elm_community$list_extra$List$Extra$splitAt, index2 - index1, tail1);
					var head2 = _v1.a;
					var tail2 = _v1.b;
					var _v2 = _Utils_Tuple2(
						$elm_community$list_extra$List$Extra$uncons(head2),
						$elm_community$list_extra$List$Extra$uncons(tail2));
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var _v3 = _v2.a.a;
						var value1 = _v3.a;
						var part2 = _v3.b;
						var _v4 = _v2.b.a;
						var value2 = _v4.a;
						var part3 = _v4.b;
						return $elm$core$List$concat(
							_List_fromArray(
								[
									part1,
									A2($elm$core$List$cons, value2, part2),
									A2($elm$core$List$cons, value1, part3)
								]));
					} else {
						return l;
					}
				}
			}
		}
	});
var $author$project$Page$Community$Settings$Shop$Categories$updateKeywordsDnd = F2(
	function (ext, ur) {
		if (!ext.$) {
			var draggedElement = ext.a.m3;
			var dropZone = ext.a.m4;
			var _v1 = ur.ok.U;
			if (!_v1.$) {
				return ur;
			} else {
				var categoryId = _v1.a;
				var formModel = _v1.b;
				return A2(
					$author$project$UpdateResult$mapModel,
					function (model) {
						return _Utils_update(
							model,
							{
								U: A2(
									$author$project$Page$Community$Settings$Shop$Categories$Open,
									categoryId,
									A2(
										$author$project$Form$updateValues,
										function (values) {
											return _Utils_update(
												values,
												{
													ij: A3($elm_community$list_extra$List$Extra$swapAt, draggedElement, dropZone, values.ij)
												});
										},
										formModel))
							});
					},
					ur);
			}
		} else {
			return ur;
		}
	});
var $author$project$Shop$Category$updateMetadata = F2(
	function (model, _v0) {
		var metaTitle = _v0.ik;
		var metaDescription = _v0.ii;
		var metaKeywords = _v0.ij;
		return $author$project$Cambiatus$Mutation$category(
			function (optionals) {
				return _Utils_update(
					optionals,
					{
						w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							$author$project$Shop$Category$idToInt(model.w)),
						ii: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(metaDescription),
						ij: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							A2($elm$core$String$join, ', ', metaKeywords)),
						ik: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(metaTitle)
					});
			});
	});
var $author$project$Page$Community$Settings$Shop$Categories$update = F3(
	function (msg, model, loggedIn) {
		var getCategoryZipper = function (categoryId) {
			var _v48 = A2(
				$author$project$Community$getField,
				loggedIn.pC,
				function ($) {
					return $.fC;
				});
			if (_v48.$ === 3) {
				var _v49 = _v48.a;
				var categories = _v49.b;
				return A2(
					$author$project$Utils$Tree$findZipperInForest,
					function (category) {
						return _Utils_eq(category.w, categoryId);
					},
					categories);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{x: $author$project$Page$Community$Settings$Shop$Categories$DropdownClosed, cy: $elm$core$Maybe$Nothing, ao: $author$project$Page$Community$Settings$Shop$Categories$Closed, q: $author$project$Page$Community$Settings$Shop$Categories$NotEditing}));
			case 2:
				var categoryId = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							aD: A2($Gizra$elm_all_set$EverySet$member, categoryId, model.aD) ? A2($Gizra$elm_all_set$EverySet$remove, categoryId, model.aD) : A2($Gizra$elm_all_set$EverySet$insert, categoryId, model.aD),
							q: function () {
								var _v2 = model.q;
								if (!_v2.$) {
									return $author$project$Page$Community$Settings$Shop$Categories$NotEditing;
								} else {
									var parent = _v2.a.ea;
									if (parent.$ === 1) {
										return model.q;
									} else {
										var parentId = parent.a;
										return A2(
											$elm$core$Maybe$withDefault,
											model.q,
											A2(
												$elm$core$Maybe$map,
												function (categoryZipper) {
													return A2(
														$author$project$Page$Community$Settings$Shop$Categories$isAncestorOf,
														parentId,
														$zwilias$elm_rosetree$Tree$Zipper$tree(categoryZipper)) ? $author$project$Page$Community$Settings$Shop$Categories$NotEditing : model.q;
												},
												getCategoryZipper(categoryId)));
									}
								}
							}()
						}));
			case 3:
				var maybeParentId = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v4) {
							return $author$project$Page$Community$Settings$Shop$Categories$NoOp;
						},
						$elm$browser$Browser$Dom$focus('new-category-icon')),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								q: $author$project$Page$Community$Settings$Shop$Categories$EditingNewCategory(
									{
										hY: $author$project$Form$init(
											{
												aR: A2(
													$author$project$Form$RichText$initModel,
													$author$project$Page$Community$Settings$Shop$Categories$newDescriptionInputId(maybeParentId),
													$elm$core$Maybe$Nothing),
												p: $author$project$Form$File$initSingle(
													{
														mj: $elm$core$Maybe$Just(1),
														ni: $elm$core$Maybe$Nothing
													}),
												h2: $author$project$Form$File$initSingle(
													{mj: $elm$core$Maybe$Nothing, ni: $elm$core$Maybe$Nothing}),
												fj: ''
											}),
										ea: maybeParentId
									})
							})));
			case 4:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{q: $author$project$Page$Community$Settings$Shop$Categories$NotEditing}));
			case 5:
				var categoryId = msg.a;
				var _v5 = A2(
					$elm$core$Maybe$map,
					$zwilias$elm_rosetree$Tree$Zipper$label,
					getCategoryZipper(categoryId));
				if (!_v5.$) {
					var category = _v5.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								x: $author$project$Page$Community$Settings$Shop$Categories$DropdownClosed,
								ao: A2(
									$author$project$Page$Community$Settings$Shop$Categories$Open,
									categoryId,
									$author$project$Form$init(
										{
											aR: A2(
												$author$project$Form$RichText$initModel,
												'update-category-description-' + $author$project$Shop$Category$idToString(categoryId),
												$elm$core$Maybe$Just(category.aR)),
											p: $author$project$Form$File$initSingle(
												{
													mj: $elm$core$Maybe$Just(1),
													ni: category.p
												}),
											h2: $author$project$Form$File$initSingle(
												{mj: $elm$core$Maybe$Nothing, ni: category.h2}),
											fj: category.fj
										}))
							}));
				} else {
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{x: $author$project$Page$Community$Settings$Shop$Categories$DropdownClosed}));
				}
			case 6:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{ao: $author$project$Page$Community$Settings$Shop$Categories$Closed}));
			case 7:
				var subMsg = msg.a;
				var _v6 = model.q;
				if (!_v6.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var newCategoryData = _v6.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newForm) {
							return _Utils_update(
								model,
								{
									q: $author$project$Page$Community$Settings$Shop$Categories$EditingNewCategory(
										_Utils_update(
											newCategoryData,
											{hY: newForm}))
								});
						},
						$author$project$Page$Community$Settings$Shop$Categories$GotAddCategoryFormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, loggedIn.A, subMsg, newCategoryData.hY));
				}
			case 8:
				var icon = msg.a.p;
				var name = msg.a.fj;
				var slug = msg.a.iP;
				var description = msg.a.aR;
				var image = msg.a.h2;
				var parentId = function () {
					var _v11 = model.q;
					if (!_v11.$) {
						return $elm$core$Maybe$Nothing;
					} else {
						var parent = _v11.a.ea;
						return parent;
					}
				}();
				var position = function () {
					var _v8 = A2(
						$author$project$Community$getField,
						loggedIn.pC,
						function ($) {
							return $.fC;
						});
					if (_v8.$ === 3) {
						var _v9 = _v8.a;
						var categories = _v9.b;
						if (parentId.$ === 1) {
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$add(1),
									$elm$core$List$maximum(
										A2(
											$elm$core$List$map,
											A2(
												$elm$core$Basics$composeR,
												$zwilias$elm_rosetree$Tree$label,
												function ($) {
													return $.bq;
												}),
											categories))));
						} else {
							var validParentId = parentId.a;
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$andThen,
									A2(
										$elm$core$Basics$composeR,
										$zwilias$elm_rosetree$Tree$Zipper$tree,
										A2(
											$elm$core$Basics$composeR,
											$zwilias$elm_rosetree$Tree$children,
											A2(
												$elm$core$Basics$composeR,
												$elm$core$List$map(
													A2(
														$elm$core$Basics$composeR,
														$zwilias$elm_rosetree$Tree$label,
														function ($) {
															return $.bq;
														})),
												A2(
													$elm$core$Basics$composeR,
													$elm$core$List$maximum,
													$elm$core$Maybe$map(
														$elm$core$Basics$add(1)))))),
									A2(
										$author$project$Utils$Tree$findZipperInForest,
										function (category) {
											return _Utils_eq(category.w, validParentId);
										},
										categories)));
						}
					} else {
						return 0;
					}
				}();
				return A2(
					$author$project$UpdateResult$addExt,
					A3(
						$author$project$Session$LoggedIn$mutation,
						loggedIn,
						A2(
							$author$project$Shop$Category$create,
							{aR: description, p: icon, h2: image, fj: name, iE: parentId, bq: position, iP: slug},
							$author$project$Shop$Category$selectionSet),
						$author$project$Page$Community$Settings$Shop$Categories$FinishedCreatingCategory),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								q: function () {
									var _v7 = model.q;
									if (!_v7.$) {
										return $author$project$Page$Community$Settings$Shop$Categories$NotEditing;
									} else {
										var newCategoryData = _v7.a;
										return $author$project$Page$Community$Settings$Shop$Categories$EditingNewCategory(
											_Utils_update(
												newCategoryData,
												{
													hY: A2($author$project$Form$withDisabled, true, newCategoryData.hY)
												}));
									}
								}()
							})));
			case 9:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var category = msg.a.a.a;
							var insertInForest = function (forest) {
								var _v14 = category.iE;
								if (_v14.$ === 1) {
									return _Utils_ap(
										forest,
										_List_fromArray(
											[
												$zwilias$elm_rosetree$Tree$singleton(category)
											]));
								} else {
									var parentId = _v14.a;
									var _v15 = A2(
										$author$project$Utils$Tree$findZipperInForest,
										function (parent) {
											return _Utils_eq(parent.w, parentId);
										},
										forest);
									if (_v15.$ === 1) {
										return _Utils_ap(
											forest,
											_List_fromArray(
												[
													$zwilias$elm_rosetree$Tree$singleton(category)
												]));
									} else {
										var zipper = _v15.a;
										return $author$project$Utils$Tree$toFlatForest(
											A2(
												$zwilias$elm_rosetree$Tree$Zipper$mapTree,
												$zwilias$elm_rosetree$Tree$appendChild(
													$zwilias$elm_rosetree$Tree$singleton(category)),
												zipper));
									}
								}
							};
							var insertInCommunity = function () {
								var _v12 = A2(
									$author$project$Community$getField,
									loggedIn.pC,
									function ($) {
										return $.fC;
									});
								if (_v12.$ === 3) {
									var _v13 = _v12.a;
									var categories = _v13.b;
									return $author$project$UpdateResult$addExt(
										$author$project$Session$LoggedIn$SetCommunityField(
											$author$project$Community$ShopCategories(
												insertInForest(categories))));
								} else {
									return $elm$core$Basics$identity;
								}
							}();
							return insertInCommunity(
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{q: $author$project$Page$Community$Settings$Shop$Categories$NotEditing})));
						} else {
							var _v16 = msg.a.a;
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Got Nothing after creating category',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Community.Settings.Shop.Categories'},
								_List_Nil,
								A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										1,
										t('shop.categories.create_error')),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{
												q: function () {
													var _v17 = model.q;
													if (!_v17.$) {
														return $author$project$Page$Community$Settings$Shop$Categories$NotEditing;
													} else {
														var newCategoryData = _v17.a;
														return $author$project$Page$Community$Settings$Shop$Categories$EditingNewCategory(
															_Utils_update(
																newCategoryData,
																{
																	hY: A2($author$project$Form$withDisabled, false, newCategoryData.hY)
																}));
													}
												}()
											}))));
						}
					case 2:
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								t('shop.categories.create_error')),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										q: function () {
											var _v18 = model.q;
											if (!_v18.$) {
												return $author$project$Page$Community$Settings$Shop$Categories$NotEditing;
											} else {
												var newCategoryData = _v18.a;
												return $author$project$Page$Community$Settings$Shop$Categories$EditingNewCategory(
													_Utils_update(
														newCategoryData,
														{
															hY: A2($author$project$Form$withDisabled, false, newCategoryData.hY)
														}));
											}
										}()
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 10:
				var subMsg = msg.a;
				var _v19 = model.ao;
				if (!_v19.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var categoryId = _v19.a;
					var formModel = _v19.b;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newFormModel) {
							return _Utils_update(
								model,
								{
									ao: A2($author$project$Page$Community$Settings$Shop$Categories$Open, categoryId, newFormModel)
								});
						},
						$author$project$Page$Community$Settings$Shop$Categories$GotUpdateCategoryFormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, loggedIn.A, subMsg, formModel));
				}
			case 11:
				var formOutput = msg.a;
				var _v20 = getCategoryZipper(formOutput.w);
				if (_v20.$ === 1) {
					return $author$project$UpdateResult$init(model);
				} else {
					var zipper = _v20.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$mutation,
							loggedIn,
							A3(
								$author$project$Shop$Category$update,
								$zwilias$elm_rosetree$Tree$Zipper$label(zipper),
								{aR: formOutput.aR, p: formOutput.p, h2: formOutput.h2, fj: formOutput.fj, iP: formOutput.iP},
								$author$project$Shop$Category$selectionSet),
							$author$project$Page$Community$Settings$Shop$Categories$FinishedUpdatingCategory),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									ao: function () {
										var _v21 = model.ao;
										if (!_v21.$) {
											return $author$project$Page$Community$Settings$Shop$Categories$Closed;
										} else {
											var categoryId = _v21.a;
											var formModel = _v21.b;
											return A2(
												$author$project$Page$Community$Settings$Shop$Categories$Open,
												categoryId,
												A2($author$project$Form$withDisabled, true, formModel));
										}
									}()
								})));
				}
			case 12:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var category = msg.a.a.a;
							var updateInCommunity = function () {
								var _v22 = getCategoryZipper(category.w);
								if (_v22.$ === 1) {
									return $elm$core$Basics$identity;
								} else {
									var zipper = _v22.a;
									return $author$project$UpdateResult$addExt(
										$author$project$Session$LoggedIn$SetCommunityField(
											$author$project$Community$ShopCategories(
												$author$project$Utils$Tree$toFlatForest(
													A2($zwilias$elm_rosetree$Tree$Zipper$replaceLabel, category, zipper)))));
								}
							}();
							return updateInCommunity(
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{U: $author$project$Page$Community$Settings$Shop$Categories$Closed, ao: $author$project$Page$Community$Settings$Shop$Categories$Closed})));
						} else {
							var _v23 = msg.a.a;
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Got Nothing after updating category',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Community.Settings.Shop.Categories'},
								_List_Nil,
								A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										1,
										t('shop.categories.update_error')),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{ao: $author$project$Page$Community$Settings$Shop$Categories$Closed}))));
						}
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when updating category',
							{e$: 'update', fi: 'Page.Community.Settings.Shop.Categories'},
							_List_Nil,
							err,
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									1,
									t('shop.categories.update_error')),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{ao: $author$project$Page$Community$Settings$Shop$Categories$Closed}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 13:
				var categoryId = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							cy: $elm$core$Maybe$Just(categoryId)
						}));
			case 14:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cy: $elm$core$Maybe$Nothing}));
			case 15:
				var categoryId = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					A3(
						$author$project$Session$LoggedIn$mutation,
						loggedIn,
						$author$project$Api$Graphql$DeleteStatus$selectionSet(
							$author$project$Shop$Category$delete(categoryId)),
						$author$project$Page$Community$Settings$Shop$Categories$CompletedDeletingCategory(categoryId)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								cy: $elm$core$Maybe$Nothing,
								aB: A2($Gizra$elm_all_set$EverySet$insert, categoryId, model.aB)
							})));
			case 16:
				switch (msg.b.$) {
					case 3:
						if (!msg.b.a.$) {
							var categoryId = msg.a;
							var _v24 = msg.b.a;
							var removeFromForest = function (zipper) {
								return A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										$author$project$Utils$Tree$toFlatForest,
										$zwilias$elm_rosetree$Tree$Zipper$removeTree(zipper)));
							};
							var removeFromCommunity = function () {
								var _v25 = getCategoryZipper(categoryId);
								if (_v25.$ === 1) {
									return $elm$core$Basics$identity;
								} else {
									var zipper = _v25.a;
									return $author$project$UpdateResult$addExt(
										$author$project$Session$LoggedIn$SetCommunityField(
											$author$project$Community$ShopCategories(
												removeFromForest(zipper))));
								}
							}();
							return removeFromCommunity(
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											aB: A2($Gizra$elm_all_set$EverySet$remove, categoryId, model.aB)
										})));
						} else {
							var categoryId = msg.a;
							var reason = msg.b.a.a;
							return A6(
								$author$project$UpdateResult$logDeletionStatusError,
								msg,
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Community.Settings.Shop.Categories'},
								_List_fromArray(
									[
										{
										ng: $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$author$project$Shop$Category$encodeId(categoryId))
												])),
										fj: 'Category'
									}
									]),
								reason,
								A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										1,
										t('shop.categories.delete_error')),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{
												aB: A2($Gizra$elm_all_set$EverySet$remove, categoryId, model.aB)
											}))));
						}
					case 2:
						var categoryId = msg.a;
						var err = msg.b.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when trying to delete category',
							{e$: 'update', fi: 'Page.Community.Settings.Shop.Categories'},
							_List_fromArray(
								[
									{
									ng: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'id',
												$author$project$Shop$Category$encodeId(categoryId))
											])),
									fj: 'Category'
								}
								]),
							err,
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									1,
									loggedIn.A.aw.fL('error.unknown')),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											aB: A2($Gizra$elm_all_set$EverySet$remove, categoryId, model.aB)
										}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 17:
				var categoryId = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							x: function () {
								var _v26 = model.x;
								switch (_v26.$) {
									case 0:
										return $author$project$Page$Community$Settings$Shop$Categories$DropdownOpenOnButton(categoryId);
									case 2:
										return $author$project$Page$Community$Settings$Shop$Categories$DropdownClosed;
									default:
										return $author$project$Page$Community$Settings$Shop$Categories$DropdownOpenOnButton(categoryId);
								}
							}()
						}));
			case 18:
				var coordinates = msg.a;
				var categoryId = msg.b;
				var getViewport = A2(
					$elm$core$Task$perform,
					function (viewport) {
						return A3($author$project$Page$Community$Settings$Shop$Categories$GotViewportForContextMenuForAction, coordinates, categoryId, viewport);
					},
					$elm$browser$Browser$Dom$getViewport);
				return A2(
					$author$project$UpdateResult$addCmd,
					getViewport,
					$author$project$UpdateResult$init(model));
			case 19:
				var coordinates = msg.a;
				var categoryId = msg.b;
				var viewport = msg.c;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							x: function () {
								var _v27 = model.x;
								switch (_v27.$) {
									case 0:
										return A3($author$project$Page$Community$Settings$Shop$Categories$DropdownOpenOnMouse, coordinates, categoryId, viewport);
									case 2:
										return A3($author$project$Page$Community$Settings$Shop$Categories$DropdownOpenOnMouse, coordinates, categoryId, viewport);
									default:
										return $author$project$Page$Community$Settings$Shop$Categories$DropdownClosed;
								}
							}()
						}));
			case 20:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{x: $author$project$Page$Community$Settings$Shop$Categories$DropdownClosed}));
			case 21:
				var categoryId = msg.a;
				var _v28 = getCategoryZipper(categoryId);
				if (_v28.$ === 1) {
					return $author$project$UpdateResult$init(model);
				} else {
					var zipper = _v28.a;
					var category = $zwilias$elm_rosetree$Tree$Zipper$label(zipper);
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								U: A2(
									$author$project$Page$Community$Settings$Shop$Categories$Open,
									categoryId,
									$author$project$Form$init(
										{
											fb: $author$project$Dnd$init,
											ii: A2(
												$elm$core$Maybe$withDefault,
												$author$project$Markdown$toUnformattedString(category.aR),
												category.ii),
											cc: '',
											ij: category.ij,
											ik: A2($elm$core$Maybe$withDefault, category.fj, category.ik)
										}))
							}));
				}
			case 22:
				var subMsg = msg.a;
				var _v29 = model.U;
				if (!_v29.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var categoryId = _v29.a;
					var formModel = _v29.b;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newFormModel) {
							return _Utils_update(
								model,
								{
									U: A2($author$project$Page$Community$Settings$Shop$Categories$Open, categoryId, newFormModel)
								});
						},
						$author$project$Page$Community$Settings$Shop$Categories$GotMetadataFormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, loggedIn.A, subMsg, formModel));
				}
			case 23:
				var formOutput = msg.a;
				var _v30 = getCategoryZipper(formOutput.w);
				if (_v30.$ === 1) {
					return $author$project$UpdateResult$init(model);
				} else {
					var zipper = _v30.a;
					var category = $zwilias$elm_rosetree$Tree$Zipper$label(zipper);
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$mutation,
							loggedIn,
							A3(
								$author$project$Shop$Category$updateMetadata,
								category,
								{
									ii: ($elm_community$maybe_extra$Maybe$Extra$isNothing(category.ii) && _Utils_eq(
										formOutput.ii,
										$author$project$Markdown$toUnformattedString(category.aR))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(formOutput.ii),
									ij: formOutput.ij,
									ik: ($elm_community$maybe_extra$Maybe$Extra$isNothing(category.ik) && _Utils_eq(formOutput.ik, category.fj)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(formOutput.ik)
								},
								$author$project$Shop$Category$selectionSet),
							$author$project$Page$Community$Settings$Shop$Categories$FinishedUpdatingCategory),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									U: function () {
										var _v31 = model.U;
										if (!_v31.$) {
											return $author$project$Page$Community$Settings$Shop$Categories$Closed;
										} else {
											var categoryId = _v31.a;
											var formModel = _v31.b;
											return A2(
												$author$project$Page$Community$Settings$Shop$Categories$Open,
												categoryId,
												A2($author$project$Form$withDisabled, true, formModel));
										}
									}()
								})));
				}
			case 24:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{U: $author$project$Page$Community$Settings$Shop$Categories$Closed}));
			case 25:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newDnd) {
						return _Utils_update(
							model,
							{aS: newDnd});
					},
					$author$project$Page$Community$Settings$Shop$Categories$GotDndMsg,
					$author$project$Page$Community$Settings$Shop$Categories$updateDnd(loggedIn),
					model,
					A2($author$project$Dnd$update, subMsg, model.aS));
			case 26:
				var categoryId = msg.a;
				var _v32 = $author$project$Dnd$getDraggingOverElement(model.aS);
				if (_v32.$ === 1) {
					return $author$project$UpdateResult$init(model);
				} else {
					if (!_v32.a.$) {
						var currentCategoryId = _v32.a.a;
						return _Utils_eq(currentCategoryId, categoryId) ? $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aD: A2($Gizra$elm_all_set$EverySet$insert, categoryId, model.aD)
								})) : $author$project$UpdateResult$init(model);
					} else {
						var _v33 = _v32.a;
						return $author$project$UpdateResult$init(model);
					}
				}
			case 27:
				switch (msg.b.$) {
					case 3:
						if (!msg.b.a.$) {
							var categoryId = msg.a;
							var parentId = msg.b.a.a;
							var _v34 = getCategoryZipper(categoryId);
							if (!_v34.$) {
								var childZipper = _v34.a;
								var zipperWithMovedChild = $author$project$Page$Community$Settings$Shop$Categories$moveChild(
									{ga: childZipper, iE: parentId});
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$LoggedIn$SetCommunityField(
										$author$project$Community$ShopCategories(
											$author$project$Utils$Tree$toFlatForest(zipperWithMovedChild))),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{
												aD: A2(
													$elm$core$Maybe$withDefault,
													model.aD,
													A2(
														$elm$core$Maybe$map,
														A2(
															$elm$core$Basics$composeR,
															$author$project$Utils$Tree$getAllAncestors,
															A2(
																$elm$core$List$foldl,
																A2(
																	$elm$core$Basics$composeR,
																	$zwilias$elm_rosetree$Tree$Zipper$label,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.w;
																		},
																		$Gizra$elm_all_set$EverySet$insert)),
																model.aD)),
														A2(
															$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
															function (_v35) {
																var id = _v35.w;
																return _Utils_eq(id, categoryId);
															},
															zipperWithMovedChild)))
											})));
							} else {
								return $author$project$UpdateResult$init(model);
							}
						} else {
							var categoryId = msg.a;
							var _v36 = msg.b.a;
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Got Nothing when trying to move a child category',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Community.Settings.Shop.Categories'},
								_List_fromArray(
									[
										{
										ng: $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$author$project$Shop$Category$encodeId(categoryId))
												])),
										fj: 'Category'
									}
									]),
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var categoryId = msg.a;
						var err = msg.b.a;
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								t('shop.categories.reorder_error')),
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Just(loggedIn._),
								'Got an error when trying to move a child category',
								{e$: 'update', fi: 'Page.Community.Settings.Shop.Categories'},
								_List_fromArray(
									[
										{
										ng: $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$author$project$Shop$Category$encodeId(categoryId))
												])),
										fj: 'Category'
									}
									]),
								err,
								$author$project$UpdateResult$init(model)));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 28:
				switch (msg.b.$) {
					case 3:
						if (!msg.b.a.$) {
							var categoryId = msg.a;
							var _v37 = A2(
								$author$project$Community$getField,
								loggedIn.pC,
								function ($) {
									return $.fC;
								});
							if (_v37.$ === 3) {
								var _v38 = _v37.a;
								var categories = _v38.b;
								var _v39 = A2(
									$author$project$Utils$Tree$findZipperInForest,
									function (_v40) {
										var id = _v40.w;
										return _Utils_eq(id, categoryId);
									},
									categories);
								if (_v39.$ === 1) {
									return $author$project$UpdateResult$init(model);
								} else {
									var childZipper = _v39.a;
									var zipperWithMovedChild = $author$project$Page$Community$Settings$Shop$Categories$moveToRoot(
										{ga: childZipper});
									return A2(
										$author$project$UpdateResult$addExt,
										$author$project$Session$LoggedIn$SetCommunityField(
											$author$project$Community$ShopCategories(
												$author$project$Utils$Tree$toFlatForest(zipperWithMovedChild))),
										$author$project$UpdateResult$init(model));
								}
							} else {
								return $author$project$UpdateResult$init(model);
							}
						} else {
							var categoryId = msg.a;
							var _v41 = msg.b.a;
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Got Nothing when trying to move a child category to root',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Community.Settings.Shop.Categories'},
								_List_fromArray(
									[
										{
										ng: $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$author$project$Shop$Category$encodeId(categoryId))
												])),
										fj: 'Category'
									}
									]),
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var categoryId = msg.a;
						var err = msg.b.a;
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								t('shop.categories.reorder_error')),
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Just(loggedIn._),
								'Got an error when trying to move a child category to root',
								{e$: 'update', fi: 'Page.Community.Settings.Shop.Categories'},
								_List_fromArray(
									[
										{
										ng: $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$author$project$Shop$Category$encodeId(categoryId))
												])),
										fj: 'Category'
									}
									]),
								err,
								$author$project$UpdateResult$init(model)));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 29:
				var categoryId = msg.a;
				var _v42 = getCategoryZipper(categoryId);
				if (!_v42.$) {
					var zipper = _v42.a;
					var _v43 = $author$project$Utils$Tree$goUpWithoutChildren(zipper);
					if (_v43.$ === 1) {
						return A2(
							$author$project$UpdateResult$addExt,
							A3(
								$author$project$Session$LoggedIn$mutation,
								loggedIn,
								A2(
									$author$project$Shop$Category$moveToRoot,
									categoryId,
									$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(0)),
								$author$project$Page$Community$Settings$Shop$Categories$CompletedMovingCategoryToRoot(categoryId)),
							$author$project$UpdateResult$init(model));
					} else {
						var newParentZipper = _v43.a;
						return A2(
							$author$project$UpdateResult$addExt,
							A3(
								$author$project$Session$LoggedIn$mutation,
								loggedIn,
								A3(
									$author$project$Shop$Category$addChild,
									$zwilias$elm_rosetree$Tree$Zipper$tree(newParentZipper),
									categoryId,
									$author$project$Shop$Category$idSelectionSet),
								$author$project$Page$Community$Settings$Shop$Categories$CompletedMovingCategory(categoryId)),
							$author$project$UpdateResult$init(model));
					}
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 30:
				var categoryId = msg.a;
				var _v44 = getCategoryZipper(categoryId);
				if (!_v44.$) {
					var zipper = _v44.a;
					var _v45 = $author$project$Utils$Tree$goDownWithoutChildren(zipper);
					if (_v45.$ === 1) {
						return A2(
							$author$project$UpdateResult$addExt,
							A3(
								$author$project$Session$LoggedIn$mutation,
								loggedIn,
								A2(
									$author$project$Shop$Category$moveToRoot,
									categoryId,
									$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(0)),
								$author$project$Page$Community$Settings$Shop$Categories$CompletedMovingCategoryToRoot(categoryId)),
							$author$project$UpdateResult$init(model));
					} else {
						var newParentZipper = _v45.a;
						return A2(
							$author$project$UpdateResult$addExt,
							A3(
								$author$project$Session$LoggedIn$mutation,
								loggedIn,
								A3(
									$author$project$Shop$Category$addChild,
									$zwilias$elm_rosetree$Tree$Zipper$tree(newParentZipper),
									categoryId,
									$author$project$Shop$Category$idSelectionSet),
								$author$project$Page$Community$Settings$Shop$Categories$CompletedMovingCategory(categoryId)),
							$author$project$UpdateResult$init(model));
					}
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 31:
				var subMsg = msg.a;
				var _v46 = model.U;
				if (!_v46.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var categoryId = _v46.a;
					var formModel = _v46.b;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newDnd) {
							return _Utils_update(
								model,
								{
									U: A2(
										$author$project$Page$Community$Settings$Shop$Categories$Open,
										categoryId,
										A2(
											$author$project$Form$updateValues,
											function (values) {
												return _Utils_update(
													values,
													{fb: newDnd});
											},
											formModel))
								});
						},
						$author$project$Page$Community$Settings$Shop$Categories$GotKeywordDndMsg,
						$author$project$Page$Community$Settings$Shop$Categories$updateKeywordsDnd,
						model,
						A2(
							$author$project$Dnd$update,
							subMsg,
							A2(
								$author$project$Form$getValue,
								function ($) {
									return $.fb;
								},
								formModel)));
				}
			default:
				var index = msg.a;
				var _v47 = model.U;
				if (!_v47.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var categoryId = _v47.a;
					var formModel = _v47.b;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								U: A2(
									$author$project$Page$Community$Settings$Shop$Categories$Open,
									categoryId,
									A2(
										$author$project$Form$updateValues,
										function (values) {
											return _Utils_update(
												values,
												{
													ij: A2($elm_community$list_extra$List$Extra$removeAt, index, values.ij)
												});
										},
										formModel))
							}));
				}
		}
	});
var $author$project$Page$Community$Settings$Sponsorship$update = F3(
	function (msg, model, loggedIn) {
		if (!msg.$) {
			return $author$project$UpdateResult$init(model);
		} else {
			var community = msg.a;
			var maybeRedirect = (!_Utils_eq(community.jz, loggedIn._)) ? $author$project$UpdateResult$addCmd(
				A2($author$project$Route$pushUrl, loggedIn.A.kK, $author$project$Route$Dashboard)) : $elm$core$Basics$identity;
			return maybeRedirect(
				$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Community$Settings$Sponsorship$Fiat$update = F3(
	function (msg, model, loggedIn) {
		if (!msg.$) {
			return $author$project$UpdateResult$init(model);
		} else {
			var community = msg.a;
			var maybeRedirect = (!_Utils_eq(community.jz, loggedIn._)) ? $author$project$UpdateResult$addCmd(
				A2($author$project$Route$pushUrl, loggedIn.A.kK, $author$project$Route$Dashboard)) : $elm$core$Basics$identity;
			return maybeRedirect(
				$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$GotFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Markdown$fromTranslation = F2(
	function (_v0, key) {
		var t = _v0.fL;
		return t(key);
	});
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var community = msg.a;
				var maybeRedirect = (!_Utils_eq(community.jz, loggedIn._)) ? $author$project$UpdateResult$addCmd(
					A2($author$project$Route$pushUrl, loggedIn.A.kK, $author$project$Route$Dashboard)) : $elm$core$Basics$identity;
				var defaultTitle = A2(
					loggedIn.A.aw.i4,
					'sponsorship.thank_you_message.default_title',
					_List_fromArray(
						[
							_Utils_Tuple2('community', community.fj)
						]));
				var defaultMessage = A2($author$project$Markdown$fromTranslation, loggedIn.A.aw, 'sponsorship.thank_you_message.default_message');
				return maybeRedirect(
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								hY: $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$Loaded(
									$author$project$Form$init(
										{
											of: A2(
												$author$project$Form$RichText$initModel,
												'message-input',
												$elm$core$Maybe$Just(
													A2(
														$elm$core$Maybe$withDefault,
														defaultMessage,
														A2(
															$elm$core$Maybe$andThen,
															function ($) {
																return $.p$;
															},
															community.mM)))),
											fN: A2(
												$elm$core$Maybe$withDefault,
												defaultTitle,
												A2(
													$elm$core$Maybe$andThen,
													function ($) {
														return $.p0;
													},
													community.mM))
										}))
							})));
			default:
				var subMsg = msg.a;
				var _v1 = model.hY;
				if (!_v1.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var form = _v1.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newForm) {
							return _Utils_update(
								model,
								{
									hY: $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$Loaded(newForm)
								});
						},
						$author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$GotFormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, loggedIn.A, subMsg, form));
				}
		}
	});
var $author$project$Page$Community$Sponsor$AmountTooBig = 2;
var $author$project$Page$Community$Sponsor$AmountTooSmall = 1;
var $author$project$Ports$ContributionWithError = {$: 1};
var $author$project$Page$Community$Sponsor$CreatedContribution = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Page$Community$Sponsor$GotFormMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Community$Sponsor$InvalidAmount = 0;
var $author$project$Log$PaypalError = 8;
var $author$project$Page$Community$Sponsor$StartedCreatingContribution = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Ports$SuccessfulContribution = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Community$Sponsor$Contribution = F4(
	function (amount, communityName, currency, id) {
		return {ji: amount, hK: communityName, jA: currency, w: id};
	});
var $author$project$Cambiatus$Object$Contribution$community = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'community', _List_Nil, object_, $elm$core$Basics$identity);
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$float = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$float(value));
};
var $author$project$Cambiatus$Enum$CurrencyType$toString = function (_enum) {
	switch (_enum) {
		case 0:
			return 'BRL';
		case 1:
			return 'BTC';
		case 2:
			return 'CRC';
		case 3:
			return 'EOS';
		case 4:
			return 'ETH';
		default:
			return 'USD';
	}
};
var $author$project$Cambiatus$Mutation$contribution = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'contribution',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'amount', requiredArgs.ji, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'currency',
					requiredArgs.jA,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$CurrencyType$toString))
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Page$Community$Sponsor$createContributionSelectionSet = function (_v0) {
	var amount = _v0.ji;
	var currency = _v0.jA;
	return A2(
		$author$project$Cambiatus$Mutation$contribution,
		{ji: amount, jA: currency},
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Contribution$id,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Contribution$currency,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Contribution$community($author$project$Cambiatus$Object$Community$name),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Contribution$amount,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Community$Sponsor$Contribution))))));
};
var $author$project$Page$Community$Sponsor$FormOutput = F2(
	function (amount, currency) {
		return {ji: amount, jA: currency};
	});
var $author$project$Page$Community$Sponsor$amountFieldId = 'sponsor-amount-input';
var $author$project$View$PaypalButtons$currencyToString = function (currency) {
	if (!currency) {
		return 'BRL';
	} else {
		return 'USD';
	}
};
var $author$project$View$PaypalButtons$maximumAmount = 9999999.99;
var $author$project$View$PaypalButtons$minimumAmount = 1;
var $author$project$Page$Community$Sponsor$amountProblemToString = F3(
	function (translators, currency, amountProblem) {
		switch (amountProblem) {
			case 0:
				return translators.fL('sponsorship.invalid_amount');
			case 1:
				return A2(
					translators.i4,
					'sponsorship.amount_too_small',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'minimum',
							A3(
								$author$project$Utils$formatFloat,
								$elm$core$Maybe$Just(translators),
								2,
								$author$project$View$PaypalButtons$minimumAmount)),
							_Utils_Tuple2(
							'currency',
							$author$project$View$PaypalButtons$currencyToString(currency))
						]));
			default:
				return A2(
					translators.i4,
					'sponsorship.amount_too_big',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'maximum',
							A3(
								$author$project$Utils$formatFloat,
								$elm$core$Maybe$Just(translators),
								2,
								$author$project$View$PaypalButtons$maximumAmount)),
							_Utils_Tuple2(
							'currency',
							$author$project$View$PaypalButtons$currencyToString(currency))
						]));
		}
	});
var $author$project$View$PaypalButtons$currencyFromString = function (currency) {
	switch (currency) {
		case 'BRL':
			return $elm$core$Maybe$Just(0);
		case 'USD':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$PaypalButtons$currencyToSymbol = function (currency) {
	if (!currency) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Eos$cambiatusSymbol,
			$author$project$Eos$symbolFromString('2,BRL'));
	} else {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Eos$cambiatusSymbol,
			$author$project$Eos$symbolFromString('2,USD'));
	}
};
var $author$project$Form$Select$Options = $elm$core$Basics$identity;
var $author$project$Form$Select$init = function (_v0) {
	var label = _v0.n$;
	var id = _v0.w;
	var optionToString = _v0.d5;
	return {mF: _List_Nil, b_: false, w: id, n$: label, dY: _List_Nil, d5: optionToString, d6: _List_Nil};
};
var $author$project$Form$introspect = function (buildForm) {
	return function (values) {
		return A2(
			$author$project$Form$fill,
			buildForm(values),
			values);
	};
};
var $author$project$Form$Validate$number = function (fromString) {
	return $author$project$Form$Validate$custom(
		A2(
			$elm$core$Basics$composeR,
			fromString,
			$elm$core$Result$fromMaybe(
				function (_v0) {
					var t = _v0.fL;
					return t('error.validator.text.only_numbers');
				})));
};
var $author$project$Form$Validate$float = $author$project$Form$Validate$number($elm$core$String$toFloat);
var $author$project$Translation$decimalSeparators = function (translators) {
	return {
		jD: translators.fL('decimal_separator'),
		p1: translators.fL('thousands_separator')
	};
};
var $henriquecbuss$elm_mask$Mask$removeFloat = F2(
	function (_v0, value) {
		var decimalSeparator = _v0.jD;
		var thousandsSeparator = _v0.p1;
		return A3(
			$elm$core$String$replace,
			decimalSeparator,
			'.',
			A3($elm$core$String$replace, thousandsSeparator, '', value));
	});
var $author$project$Translation$floatStringFromSeparatedString = function (translators) {
	return $henriquecbuss$elm_mask$Mask$removeFloat(
		$author$project$Translation$decimalSeparators(translators));
};
var $author$project$Form$Validate$mapValidation = F2(
	function (fn, _v0) {
		var validator = _v0;
		return A2($elm$core$Result$map, fn, validator);
	});
var $author$project$Form$Validate$maskedFloat = function (translators) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Form$Validate$mapValidation(
			$author$project$Translation$floatStringFromSeparatedString(translators)),
		$author$project$Form$Validate$float);
};
var $author$project$Form$Select = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Form$Select$getOptionToString = function (_v0) {
	var options = _v0;
	return options.d5;
};
var $author$project$Form$Select$map = F3(
	function (fn, reverseFn, _v0) {
		var options = _v0;
		return {
			mF: options.mF,
			b_: options.b_,
			w: options.w,
			n$: options.n$,
			dY: options.dY,
			d5: A2($elm$core$Basics$composeR, reverseFn, options.d5),
			d6: A2(
				$elm$core$List$map,
				function (_v1) {
					var option = _v1.gY;
					var label = _v1.n$;
					return {
						n$: label,
						gY: fn(option)
					};
				},
				options.d6)
		};
	});
var $author$project$Form$mapFieldConfig = F3(
	function (fn, reverseFn, config) {
		return {
			ne: config.ne,
			o3: A2($elm$core$Basics$composeR, reverseFn, config.o3),
			qd: function (mappedInput) {
				return config.qd(
					reverseFn(mappedInput));
			},
			lW: A2($elm$core$Basics$composeR, config.lW, fn)
		};
	});
var $author$project$Form$select = F3(
	function (optionFromString, config, options) {
		var optionToString = $author$project$Form$Select$getOptionToString(options);
		return A2(
			$author$project$Form$field,
			$author$project$Form$Select(
				A3($author$project$Form$Select$map, optionToString, optionFromString, options)),
			A3($author$project$Form$mapFieldConfig, optionToString, optionFromString, config));
	});
var $author$project$Page$Community$Sponsor$toHumanString = F2(
	function (_v0, currency) {
		var t = _v0.fL;
		if (!currency) {
			return t('currency.brl_plural');
		} else {
			return t('currency.usd_plural');
		}
	});
var $author$project$Page$Community$Sponsor$toPaypalCurrency = function (currencyType) {
	switch (currencyType) {
		case 0:
			return $elm$core$Maybe$Just(0);
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			return $elm$core$Maybe$Nothing;
		case 4:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Just(1);
	}
};
var $author$project$Form$Select$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mF: _Utils_ap(options.mF, attrs)
			});
	});
var $author$project$Form$Text$asNumeric = $author$project$Form$Text$withExtraAttrs(
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric')
		]));
var $fapian$elm_html_aria$Html$Attributes$Aria$boolAttribute = F2(
	function (name, val) {
		return A2(
			$elm$html$Html$Attributes$attribute,
			name,
			A2(
				$elm$json$Json$Encode$encode,
				0,
				$elm$json$Json$Encode$bool(val)));
	});
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden = $fapian$elm_html_aria$Html$Attributes$Aria$boolAttribute('aria-hidden');
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$Form$Text$viewCurrencyElement = F2(
	function (symbol, _v0) {
		var hasError = _v0.no;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('\n            absolute right-0 inset-y-0 ml-px\n            bg-purple-500 text-white uppercase\n            px-4 flex items-center rounded-r-md\n            border-r border-t border-b\n            '),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('border-red', hasError),
							_Utils_Tuple2('border-gray-500 peer-focus:border-green', !hasError)
						])),
					$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Eos$symbolToSymbolCodeString(symbol))
				]));
	});
var $author$project$Form$Text$withElementsWithConfig = F2(
	function (elements, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				dD: _Utils_ap(options.dD, elements)
			});
	});
var $author$project$Form$Text$NumberMask = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$Text$withNumberMask = F2(
	function (decimalDigits, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gR: $elm$core$Maybe$Just(
					$author$project$Form$Text$NumberMask(decimalDigits))
			});
	});
var $author$project$Form$Text$withCurrency = F2(
	function (symbol, options) {
		return $author$project$Form$Text$asNumeric(
			A2(
				$author$project$Form$Text$withNumberMask,
				$henriquecbuss$elm_mask$Mask$Precisely(
					$author$project$Eos$getSymbolPrecision(symbol)),
				A2(
					$author$project$Form$Text$withExtraAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pr-20')
						]),
					A2(
						$author$project$Form$Text$withElementsWithConfig,
						_List_fromArray(
							[
								$author$project$Form$Text$viewCurrencyElement(symbol)
							]),
						options))));
	});
var $author$project$Form$Select$withLabelAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				dY: _Utils_ap(options.dY, attrs)
			});
	});
var $author$project$Form$Text$withLabelAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				dY: _Utils_ap(options.dY, attrs)
			});
	});
var $author$project$Form$Select$withOptions = F2(
	function (newOptions, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				d6: _Utils_ap(newOptions, options.d6)
			});
	});
var $author$project$Page$Community$Sponsor$createForm = F3(
	function (shared, contributionConfiguration, model) {
		var translators = shared.aw;
		var defaultCurrency = $author$project$Page$Community$Sponsor$defaultPaypalCurrency(shared);
		return A2(
			$author$project$Form$with,
			function () {
				var _v2 = A2($elm$core$List$filterMap, $author$project$Page$Community$Sponsor$toPaypalCurrency, contributionConfiguration.l6);
				if (!_v2.b) {
					return $author$project$Form$succeed(defaultCurrency);
				} else {
					if (!_v2.b.b) {
						var currency = _v2.a;
						return $author$project$Form$succeed(currency);
					} else {
						var currencies = _v2;
						var toOption = function (currency) {
							return {
								n$: A2($author$project$Page$Community$Sponsor$toHumanString, translators, currency) + (' (' + ($author$project$View$PaypalButtons$currencyToString(currency) + ')')),
								gY: currency
							};
						};
						return A3(
							$author$project$Form$select,
							A2(
								$elm$core$Basics$composeR,
								$author$project$View$PaypalButtons$currencyFromString,
								$elm$core$Maybe$withDefault(defaultCurrency)),
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: $elm$core$Result$Ok,
								qd: F2(
									function (currency, input) {
										return _Utils_update(
											input,
											{c6: currency});
									}),
								lW: function ($) {
									return $.c6;
								}
							},
							A2(
								$author$project$Form$Select$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-10')
									]),
								A2(
									$author$project$Form$Select$withLabelAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-purple-500 text-lg text-center normal-case')
										]),
									A2(
										$author$project$Form$Select$withOptions,
										A2($elm$core$List$map, toOption, currencies),
										$author$project$Form$Select$init(
											{
												w: 'currency-select',
												n$: translators.fL('sponsorship.select_currency'),
												d5: $author$project$View$PaypalButtons$currencyToString
											})))));
					}
				}
			}(),
			A2(
				$author$project$Form$with,
				$author$project$Form$introspect(
					function (_v0) {
						var selectedCurrency = _v0.c6;
						return A2(
							$author$project$Form$textField,
							{
								ne: function (_v1) {
									return A2(
										$elm$core$Maybe$map,
										A2($author$project$Page$Community$Sponsor$amountProblemToString, translators, selectedCurrency),
										model.dB);
								},
								o3: A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$succeed,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$maskedFloat(translators),
										A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$custom(
												function (x) {
													return (_Utils_cmp(x, $author$project$View$PaypalButtons$minimumAmount) < 0) ? $elm$core$Result$Err(
														function (translators_) {
															return A3($author$project$Page$Community$Sponsor$amountProblemToString, translators_, selectedCurrency, 1);
														}) : ((_Utils_cmp(x, $author$project$View$PaypalButtons$maximumAmount) > 0) ? $elm$core$Result$Err(
														function (translators_) {
															return A3($author$project$Page$Community$Sponsor$amountProblemToString, translators_, selectedCurrency, 2);
														}) : $elm$core$Result$Ok(x));
												}),
											$author$project$Form$Validate$validate(translators)))),
								qd: F2(
									function (amount, input) {
										return _Utils_update(
											input,
											{ji: amount});
									}),
								lW: function ($) {
									return $.ji;
								}
							},
							A2(
								$author$project$Form$Text$withLabelAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-purple-500 text-lg text-center normal-case')
									]),
								A2(
									$author$project$Form$Text$withCurrency,
									$author$project$View$PaypalButtons$currencyToSymbol(selectedCurrency),
									$author$project$Form$Text$init(
										{
											w: $author$project$Page$Community$Sponsor$amountFieldId,
											n$: translators.fL('sponsorship.enter_amount')
										}))));
					}),
				$author$project$Form$succeed($author$project$Page$Community$Sponsor$FormOutput)));
	});
var $author$project$Page$Community$Sponsor$NoOp = {$: 0};
var $author$project$Page$Community$Sponsor$focusAmountField = A2(
	$elm$core$Task$attempt,
	function (_v0) {
		return $author$project$Page$Community$Sponsor$NoOp;
	},
	$elm$browser$Browser$Dom$focus($author$project$Page$Community$Sponsor$amountFieldId));
var $author$project$Page$Community$Sponsor$getPaypalCurrency = F2(
	function (maybeConfig, shared) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Page$Community$Sponsor$defaultPaypalCurrency(shared),
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$List$head,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.l6;
						},
						$elm$core$List$filterMap($author$project$Page$Community$Sponsor$toPaypalCurrency)),
					maybeConfig)));
	});
var $author$project$Ports$paypalInfo = _Platform_outgoingPort('paypalInfo', $elm$core$Basics$identity);
var $author$project$Ports$sendPaypalInfo = function (contributionData) {
	if (!contributionData.$) {
		var contribution = contributionData.a;
		return $author$project$Ports$paypalInfo(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'amount',
						$elm$json$Json$Encode$float(contribution.ji)),
						_Utils_Tuple2(
						'communityName',
						$elm$json$Json$Encode$string(contribution.hK)),
						_Utils_Tuple2(
						'targetId',
						$elm$json$Json$Encode$string(contribution.pZ)),
						_Utils_Tuple2(
						'invoiceId',
						$elm$json$Json$Encode$string(contribution.nO)),
						_Utils_Tuple2(
						'currency',
						$elm$json$Json$Encode$string(
							$author$project$Cambiatus$Enum$CurrencyType$toString(contribution.jA)))
					])));
	} else {
		return $author$project$Ports$paypalInfo(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'error',
						$elm$json$Json$Encode$bool(true))
					])));
	}
};
var $author$project$Page$Community$Sponsor$toCurrencyType = function (currency) {
	if (!currency) {
		return 0;
	} else {
		return 5;
	}
};
var $author$project$Page$Community$Sponsor$update = F3(
	function (msg, model, loggedIn) {
		_v0$6:
		while (true) {
			switch (msg.$) {
				case 0:
					return $author$project$UpdateResult$init(model);
				case 1:
					var community = msg.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						$author$project$Page$Community$Sponsor$focusAmountField,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									hY: A2(
										$author$project$Form$updateValues,
										function (values) {
											return _Utils_update(
												values,
												{
													c6: A2($author$project$Page$Community$Sponsor$getPaypalCurrency, community.mM, loggedIn.A)
												});
										},
										model.hY)
								})));
				case 2:
					var id = msg.a;
					var _v1 = A2(
						$krisajenkins$remotedata$RemoteData$map,
						function ($) {
							return $.mM;
						},
						loggedIn.pC);
					if ((_v1.$ === 3) && (!_v1.a.$)) {
						var configuration = _v1.a.a;
						return A2(
							$author$project$UpdateResult$addMsg,
							A3(
								$author$project$Form$parse,
								A3($author$project$Page$Community$Sponsor$createForm, loggedIn.A, configuration, model),
								model.hY,
								{
									oM: $author$project$Page$Community$Sponsor$GotFormMsg,
									oV: $author$project$Page$Community$Sponsor$StartedCreatingContribution(id)
								}),
							$author$project$UpdateResult$init(model));
					} else {
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Tried creating a contribution, but community wasn\'t loaded, so couldn\'t get contribution configuration',
							$elm$core$Maybe$Just(loggedIn._),
							{e$: 'update', fi: 'Page.Community.Sponsor'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					}
				case 3:
					var id = msg.a;
					var formOutput = msg.b;
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$mutation,
							loggedIn,
							$author$project$Page$Community$Sponsor$createContributionSelectionSet(
								{
									ji: formOutput.ji,
									jA: $author$project$Page$Community$Sponsor$toCurrencyType(formOutput.jA)
								}),
							$author$project$Page$Community$Sponsor$CreatedContribution(id)),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{bi: true})));
				case 4:
					switch (msg.b.$) {
						case 3:
							if (!msg.b.a.$) {
								var id = msg.a;
								var contribution = msg.b.a.a;
								return A2(
									$author$project$UpdateResult$addCmd,
									$author$project$Ports$sendPaypalInfo(
										$author$project$Ports$SuccessfulContribution(
											{ji: contribution.ji, hK: contribution.hK, jA: contribution.jA, nO: contribution.w, pZ: id})),
									$author$project$UpdateResult$init(model));
							} else {
								break _v0$6;
							}
						case 2:
							var err = msg.b.a;
							return A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Just(loggedIn._),
								'Got an error when creating a contribution',
								{e$: 'update', fi: 'Page.Community.Sponsor'},
								_List_fromArray(
									[
										$author$project$Log$contextFromCommunity(loggedIn.pC)
									]),
								err,
								A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										1,
										loggedIn.A.aw.fL('sponsorship.contribution_error')),
									A2(
										$author$project$UpdateResult$addCmd,
										$author$project$Ports$sendPaypalInfo($author$project$Ports$ContributionWithError),
										$author$project$UpdateResult$init(model))));
						default:
							break _v0$6;
					}
				case 5:
					return A2(
						$author$project$UpdateResult$addCmd,
						A2($author$project$Route$pushUrl, loggedIn.A.kK, $author$project$Route$CommunityThankYou),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{bi: false})));
				case 6:
					return A2(
						$author$project$UpdateResult$addBreadcrumb,
						{f7: msg, bZ: $elm$core$Dict$empty, n4: 3, of: 'Canceled PayPal contribution', eq: 3},
						A2(
							$author$project$UpdateResult$addCmd,
							$author$project$Page$Community$Sponsor$focusAmountField,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{bi: false}))));
				case 7:
					switch (msg.a.$) {
						case 0:
							var _v2 = msg.a;
							return A2(
								$author$project$UpdateResult$addCmd,
								$author$project$Page$Community$Sponsor$focusAmountField,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											dB: $elm$core$Maybe$Just(1),
											bi: false
										})));
						case 1:
							var _v3 = msg.a;
							return A2(
								$author$project$UpdateResult$addCmd,
								$author$project$Page$Community$Sponsor$focusAmountField,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											dB: $elm$core$Maybe$Just(2),
											bi: false
										})));
						case 2:
							var _v4 = msg.a;
							return A2(
								$author$project$UpdateResult$addCmd,
								$author$project$Page$Community$Sponsor$focusAmountField,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											dB: $elm$core$Maybe$Just(0),
											bi: false
										})));
						case 3:
							var loadError = msg.a.a;
							return A2(
								$author$project$UpdateResult$logEvent,
								{
									mL: _List_fromArray(
										[
											$author$project$Log$contextFromCommunity(loggedIn.pC),
											{
											ng: $elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2('JSON error', loadError)
													])),
											fj: 'Paypal Error'
										}
										]),
									n4: 1,
									oa: {e$: 'update', fi: 'Page.Community.Sponsor'},
									of: 'Error loading paypal buttons',
									pY: _List_fromArray(
										[
											$author$project$Log$TypeTag(8)
										]),
									p7: msg,
									qh: $elm$core$Maybe$Just(loggedIn._)
								},
								A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										1,
										loggedIn.A.aw.fL('sponsorship.load_error')),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{bi: false}))));
						default:
							var unknownError = msg.a.a;
							return A2(
								$author$project$UpdateResult$logEvent,
								{
									mL: _List_fromArray(
										[
											$author$project$Log$contextFromCommunity(loggedIn.pC),
											{
											ng: $elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2('JSON error', unknownError)
													])),
											fj: 'Paypal Error'
										}
										]),
									n4: 1,
									oa: {e$: 'update', fi: 'Page.Community.Sponsor'},
									of: 'Something went wrong with PayPal buttons',
									pY: _List_fromArray(
										[
											$author$project$Log$TypeTag(8)
										]),
									p7: msg,
									qh: $elm$core$Maybe$Just(loggedIn._)
								},
								A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										1,
										loggedIn.A.aw.fL('sponsorship.unknown_error')),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{bi: false}))));
					}
				default:
					var subMsg = msg.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newForm) {
							return _Utils_update(
								model,
								{hY: newForm});
						},
						$author$project$Page$Community$Sponsor$GotFormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, loggedIn.A, subMsg, model.hY));
			}
		}
		return $author$project$UpdateResult$init(model);
	});
var $author$project$Page$Community$Supporters$update = F3(
	function (msg, model, _v0) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var contributions = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							c1: A2(
								$author$project$Profile$Summary$initMany,
								false,
								$elm$core$List$length(contributions))
						}));
			default:
				var index = msg.a;
				var subMsg = msg.b;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							c1: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								$author$project$Profile$Summary$update(subMsg),
								model.c1)
						}));
		}
	});
var $author$project$Page$Community$Transfer$BalanceNotFound = {$: 0};
var $author$project$Page$Community$Transfer$ClosedAuthModal = {$: 3};
var $author$project$Page$Community$Transfer$CompletedLoadToken = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Community$Transfer$CreatingSubscription = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Transfer$GotFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$Transfer$SendingTransfer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Community$Transfer$SubmittedForm = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Community$Transfer$WithHttpError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Transfer$encodeEosActionWithMarkdown = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from',
				$author$project$Eos$Account$encodeName(data.e_)),
				_Utils_Tuple2(
				'to',
				$author$project$Eos$Account$encodeName(data.fO)),
				_Utils_Tuple2(
				'quantity',
				$author$project$Eos$encodeAsset(data.lW)),
				_Utils_Tuple2(
				'memo',
				$author$project$Markdown$encode(data.kE))
			]));
};
var $author$project$Page$Community$Transfer$CompletedLoadBalance = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Transfer$fetchBalance = F3(
	function (shared, accountName, community) {
		return A3(
			$author$project$Api$getBalances,
			shared,
			accountName,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map(
					function (balances) {
						return A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.mk;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.as;
									},
									$elm$core$Basics$eq(community.as))),
							balances);
					}),
				$author$project$Page$Community$Transfer$CompletedLoadBalance));
	});
var $author$project$Eos$EosError$decodeErrorDetails = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['error', 'details']),
	$elm$json$Json$Decode$list(
		A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)));
var $author$project$Eos$EosError$extractFailure = function (json) {
	var eosErrorMessages = A2($elm$json$Json$Decode$decodeValue, $author$project$Eos$EosError$decodeErrorDetails, json);
	if ((!eosErrorMessages.$) && eosErrorMessages.a.b) {
		var _v1 = eosErrorMessages.a;
		var firstMessage = _v1.a;
		var _v2 = A2($elm$core$String$split, ': ', firstMessage);
		if ((_v2.b && _v2.b.b) && (!_v2.b.b.b)) {
			var _v3 = _v2.b;
			var msg = _v3.a;
			return msg;
		} else {
			return firstMessage;
		}
	} else {
		return 'error.unknown';
	}
};
var $author$project$Eos$EosError$parseErrorMessage = F4(
	function (_v0, translationPrefix, translationDefault, eosErrorString) {
		var t = _v0.fL;
		return t(
			function () {
				if (!eosErrorString.$) {
					var err = eosErrorString.a;
					return _Utils_ap(
						translationPrefix,
						$author$project$Eos$EosError$extractFailure(err));
				} else {
					return translationDefault;
				}
			}());
	});
var $author$project$Eos$EosError$parseTransferError = F2(
	function (translators, eosErrorString) {
		return A4($author$project$Eos$EosError$parseErrorMessage, translators, 'error.contracts.transfer.', 'account.my_wallet.transfer.error', eosErrorString);
	});
var $author$project$Form$UserPicker$setSingle = F2(
	function (maybeProfile, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				H: A2(
					$elm$core$Maybe$map,
					function (profile) {
						return {
							pl: profile,
							bu: $author$project$Profile$Summary$init(false)
						};
					},
					maybeProfile)
			});
	});
var $author$project$Cambiatus$InputObject$encodeTransferSucceedInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input.e_))),
				_Utils_Tuple2(
				'symbol',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input.as))),
				_Utils_Tuple2(
				'to',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input.fO)))
			]));
};
var $author$project$Cambiatus$Subscription$transfersucceed = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'transfersucceed',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs.nG, $author$project$Cambiatus$InputObject$encodeTransferSucceedInput)
				]),
			object_,
			$elm$core$Basics$identity);
	});
var $author$project$Transfer$transferSucceedSubscription = F2(
	function (symbol, _v0) {
		var from = _v0.e_;
		var to = _v0.fO;
		var args = {
			nG: {
				e_: $author$project$Eos$Account$nameToString(from),
				as: $elm$core$String$toUpper(
					$author$project$Eos$symbolToString(symbol)),
				fO: $author$project$Eos$Account$nameToString(to)
			}
		};
		return A2($author$project$Cambiatus$Subscription$transfersucceed, args, $author$project$Transfer$transferItemSelectionSet);
	});
var $author$project$Page$Community$Transfer$update = F3(
	function (msg, model, loggedIn) {
		var shared = loggedIn.A;
		var onlyLogImpossible = function (desc) {
			return A6(
				$author$project$UpdateResult$logImpossible,
				msg,
				desc,
				$elm$core$Maybe$Just(loggedIn._),
				{e$: 'update', fi: 'Page.Community.Transfer'},
				_List_Nil,
				$author$project$UpdateResult$init(model));
		};
		switch (msg.$) {
			case 0:
				var community = msg.a;
				var newModel = function () {
					var _v1 = model.oe;
					if (_v1.$ === 1) {
						return model;
					} else {
						var toAccount = _v1.a;
						return _Utils_update(
							model,
							{
								hY: A2(
									$author$project$Form$updateValues,
									function (values) {
										return _Utils_update(
											values,
											{
												H: A2(
													$author$project$Form$UserPicker$setSingle,
													A2(
														$elm_community$list_extra$List$Extra$find,
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.l8;
															},
															$elm$core$Basics$eq(toAccount)),
														community.ih),
													values.H)
											});
									},
									model.hY)
							});
					}
				}();
				return A2(
					$author$project$UpdateResult$addCmd,
					A3($author$project$Token$getToken, shared, community.as, $author$project$Page$Community$Transfer$CompletedLoadToken),
					A2(
						$author$project$UpdateResult$addCmd,
						A3($author$project$Page$Community$Transfer$fetchBalance, shared, loggedIn._, community),
						$author$project$UpdateResult$init(newModel)));
			case 1:
				if (!msg.a.$) {
					if (!msg.a.a.$) {
						var balance = msg.a.a.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									cA: $krisajenkins$remotedata$RemoteData$Success(balance)
								}));
					} else {
						var _v2 = msg.a.a;
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Couldn\'t find balance related to community on transfer page',
							$elm$core$Maybe$Just(loggedIn._),
							{e$: 'update', fi: 'Page.Community.Transfer'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.pC)
								]),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										cA: $krisajenkins$remotedata$RemoteData$Failure($author$project$Page$Community$Transfer$BalanceNotFound)
									})));
					}
				} else {
					var httpError = msg.a.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(loggedIn._),
						'Got an error when loading balance on the transfer page',
						{e$: 'update', fi: 'Page.Community.Transfer'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.pC)
							]),
						httpError,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									cA: $krisajenkins$remotedata$RemoteData$Failure(
										$author$project$Page$Community$Transfer$WithHttpError(httpError))
								})));
				}
			case 2:
				if (!msg.a.$) {
					var token = msg.a.a;
					return A2(
						$author$project$UpdateResult$addBreadcrumb,
						{f7: msg, bZ: $elm$core$Dict$empty, n4: 3, of: 'Completed loading token on transfer page', eq: 3},
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									p5: $krisajenkins$remotedata$RemoteData$Success(token)
								})));
				} else {
					var httpError = msg.a.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(loggedIn._),
						'Got an error when loading token on the transfer page',
						{e$: 'update', fi: 'Page.Community.Transfer'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.pC)
							]),
						httpError,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									p5: $krisajenkins$remotedata$RemoteData$Failure(httpError)
								})));
				}
			case 3:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{a0: $author$project$Page$Community$Transfer$EditingTransfer}));
			case 4:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (formModel) {
						return _Utils_update(
							model,
							{hY: formModel});
					},
					$author$project$Page$Community$Transfer$GotFormMsg,
					$author$project$Session$LoggedIn$addFeedback,
					model,
					A3($author$project$Form$update, shared, subMsg, model.hY));
			case 5:
				var formOutput = msg.a;
				if (!_Utils_eq(model.a0, $author$project$Page$Community$Transfer$EditingTransfer)) {
					return $author$project$UpdateResult$init(model);
				} else {
					var subscriptionDoc = $dillonkearns$elm_graphql$Graphql$Document$serializeSubscription(
						A2(
							$author$project$Transfer$transferSucceedSubscription,
							formOutput.ji.as,
							{e_: loggedIn._, fO: formOutput.H.l8}));
					return A2(
						$author$project$UpdateResult$addPort,
						{
							bZ: $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string('subscribeToTransfer')),
										_Utils_Tuple2(
										'subscription',
										$elm$json$Json$Encode$string(subscriptionDoc))
									])),
							fy: $author$project$Page$Community$Transfer$SubmittedForm(formOutput),
							fz: $elm$json$Json$Encode$null
						},
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									a0: $author$project$Page$Community$Transfer$CreatingSubscription(formOutput)
								})));
				}
			case 6:
				var _v3 = model.a0;
				if (_v3.$ === 1) {
					var formOutput = _v3.a;
					return A5(
						$author$project$Session$LoggedIn$withPrivateKey,
						loggedIn,
						_List_Nil,
						model,
						{hS: $author$project$Page$Community$Transfer$ClosedAuthModal, iX: msg},
						A2(
							$author$project$UpdateResult$addPort,
							{
								bZ: $author$project$Eos$encodeTransaction(
									_List_fromArray(
										[
											{
											_: loggedIn.A.hL.p5,
											hw: {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission},
											bZ: $author$project$Transfer$encodeEosActionWithMarkdown(
												{e_: loggedIn._, kE: formOutput.kE, fO: formOutput.H.l8, lW: formOutput.ji}),
											fj: 'transfer'
										}
										])),
								fy: $author$project$Page$Community$Transfer$CreatedTransferSubscription,
								fz: $elm$json$Json$Encode$null
							},
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										a0: $author$project$Page$Community$Transfer$SendingTransfer(formOutput)
									}))));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 7:
				if (!msg.a.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var eosErrorString = msg.a.a;
					var _v4 = model.a0;
					if (_v4.$ === 2) {
						var errorMessage = A2($author$project$Eos$EosError$parseTransferError, loggedIn.A.aw, eosErrorString);
						return A2(
							$author$project$UpdateResult$addExt,
							A2($author$project$Session$LoggedIn$ShowFeedback, 1, errorMessage),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{a0: $author$project$Page$Community$Transfer$EditingTransfer})));
					} else {
						return onlyLogImpossible('Got transfer result with error, but wasn\'t sending transfer');
					}
				}
			default:
				var value = msg.a;
				var _v5 = model.a0;
				if (_v5.$ === 2) {
					var formOutput = _v5.a;
					var subscriptionDecoder = $dillonkearns$elm_graphql$Graphql$Document$decoder(
						A2(
							$author$project$Transfer$transferSucceedSubscription,
							formOutput.ji.as,
							{e_: loggedIn._, fO: formOutput.H.l8}));
					var _v6 = A2($elm$json$Json$Decode$decodeValue, subscriptionDecoder, value);
					if (!_v6.$) {
						var res = _v6.a;
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$author$project$Route$replaceUrl,
								shared.kK,
								$author$project$Route$ViewTransfer(res.w)),
							$author$project$UpdateResult$init(model));
					} else {
						var err = _v6.a;
						return A7(
							$author$project$UpdateResult$logDecodingError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when decoding transfer subscription',
							{e$: 'update', fi: 'Page.Community.Transfer'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(model));
					}
				} else {
					return $author$project$UpdateResult$init(model);
				}
		}
	});
var $author$project$Page$Dashboard$CompletedInviteCreation = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$Dashboard$FailedGraphql = {$: 2};
var $author$project$Page$Dashboard$GotContactMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$Dashboard$GotTransfersFiltersFormMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Dashboard$InviteModalFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Dashboard$InviteModalLoaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Dashboard$InviteModalLoading = {$: 1};
var $author$project$Page$Dashboard$LoadedGraphql = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$Dashboard$NoOp = {$: 0};
var $author$project$Api$communityInvite = F4(
	function (shared, symbol, inviter, toMsg) {
		return $elm$http$Http$post(
			{
				f6: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'creator_id',
								$author$project$Eos$Account$encodeName(inviter)),
								_Utils_Tuple2(
								'community_id',
								$elm$json$Json$Encode$string(
									$author$project$Eos$symbolToString(symbol)))
							]))),
				gt: A2(
					$elm$http$Http$expectJson,
					toMsg,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'id']),
						$elm$json$Json$Decode$string)),
				hn: A3(
					$author$project$Api$backendUrl,
					shared,
					_List_fromArray(
						['invite']),
					_List_Nil)
			});
	});
var $author$project$Page$Dashboard$ClaimsLoaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Cambiatus$InputObject$buildClaimsFilter = function (fillOptionals) {
	var optionals = fillOptionals(
		{gb: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, pN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {gb: optionals.gb, F: optionals.F, pN: optionals.pN};
};
var $author$project$Page$Dashboard$fetchAvailableAnalysis = F2(
	function (loggedIn, maybeCursor) {
		var optionalArguments = function (a) {
			return _Utils_update(
				a,
				{
					hu: function () {
						if (maybeCursor.$ === 1) {
							return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
						} else {
							if (maybeCursor.a === '') {
								return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
							} else {
								var cursor = maybeCursor.a;
								return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(cursor);
							}
						}
					}(),
					hV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Cambiatus$InputObject$buildClaimsFilter(
							function (claimsFilter) {
								return _Utils_update(
									claimsFilter,
									{
										F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(0)
									});
							})),
					hX: function () {
						if (!maybeCursor.$) {
							return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(1);
						} else {
							return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(5);
						}
					}()
				});
		};
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Cambiatus$Query$pendingClaims,
				optionalArguments,
				$author$project$Claim$claimPaginatedSelectionSet(loggedIn.A.ce)),
			$author$project$Page$Dashboard$ClaimsLoaded);
	});
var $author$project$Page$Dashboard$CompletedLoadBalance = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Dashboard$fetchBalance = F3(
	function (shared, accountName, community) {
		return A3(
			$author$project$Api$getBalances,
			shared,
			accountName,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map(
					function (balances) {
						var maybeBalance = A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.mk;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.as;
									},
									$elm$core$Basics$eq(community.as))),
							balances);
						if (!maybeBalance.$) {
							var b = maybeBalance.a;
							return $elm$core$Maybe$Just(b);
						} else {
							return $elm$core$List$head(balances);
						}
					}),
				$author$project$Page$Dashboard$CompletedLoadBalance));
	});
var $author$project$Page$Dashboard$CompletedLoadUserTransfers = function (a) {
	return {$: 3, a: a};
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Transfer$QueryTransfers = function (transfers) {
	return {av: transfers};
};
var $author$project$Api$Relay$PageConnection = F2(
	function (edges, pageInfo) {
		return {m5: edges, o2: pageInfo};
	});
var $author$project$Cambiatus$Object$TransferConnection$edges = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'edges',
		_List_Nil,
		object_,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$nullable,
				A2($elm$core$Basics$composeR, $elm$json$Json$Decode$list, $elm$json$Json$Decode$nullable))));
};
var $author$project$Cambiatus$Object$TransferConnection$pageInfo = function (object_) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'pageInfo', _List_Nil, object_, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$TransferEdge$cursor = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'cursor',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$TransferEdge$node = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'node',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Transfer$transferEdgeSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$TransferEdge$node($author$project$Transfer$transferItemSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$TransferEdge$cursor,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Relay$Edge)));
var $author$project$Transfer$transferConnectionSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$TransferConnection$pageInfo($author$project$Api$Relay$pageInfoSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$TransferConnection$edges($author$project$Transfer$transferEdgeSelectionSet),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Relay$PageConnection)));
var $author$project$Cambiatus$Enum$TransferDirectionValue$toString = function (_enum) {
	if (!_enum) {
		return 'RECEIVING';
	} else {
		return 'SENDING';
	}
};
var $author$project$Cambiatus$InputObject$encodeTransferDirection = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'direction',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input.F,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$TransferDirectionValue$toString))),
				_Utils_Tuple2(
				'otherAccount',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.d9, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$Cambiatus$InputObject$encodeTransferFilter = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'communityId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.gd, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input.dw,
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.my;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'direction',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.F, $author$project$Cambiatus$InputObject$encodeTransferDirection))
			]));
};
var $author$project$Cambiatus$Object$User$transfers = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{hu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, id: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'after', filledInOptionals.hu, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'before', filledInOptionals.hy, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'filter', filledInOptionals.hV, $author$project$Cambiatus$InputObject$encodeTransferFilter),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'first', filledInOptionals.hX, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'last', filledInOptionals.id, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'transfers',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Transfer$profileTransfersSelectionSet = function (paginateArgs) {
	var transfers = A2($author$project$Cambiatus$Object$User$transfers, paginateArgs, $author$project$Transfer$transferConnectionSelectionSet);
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		transfers,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Transfer$QueryTransfers));
};
var $author$project$Transfer$transfersUserQuery = F2(
	function (name, paginateArgs) {
		return A2(
			$author$project$Cambiatus$Query$user,
			{
				l8: $author$project$Eos$Account$nameToString(name)
			},
			$author$project$Transfer$profileTransfersSelectionSet(paginateArgs));
	});
var $author$project$Page$Dashboard$fetchTransfers = F4(
	function (loggedIn, community, maybeCursor, model) {
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Transfer$transfersUserQuery,
				loggedIn._,
				function (args) {
					return _Utils_update(
						args,
						{
							hu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(maybeCursor),
							hV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
								{
									gd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
										$author$project$Eos$symbolToString(community.as)),
									dw: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$core$Basics$identity),
											model.cs.dw)),
									F: function () {
										var _v0 = _Utils_Tuple2(model.cs.F, model.cs.d9);
										if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
											var _v1 = _v0.a;
											var _v2 = _v0.b;
											return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
										} else {
											return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
												{
													F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(model.cs.F),
													d9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
														A2(
															$elm$core$Maybe$map,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.l8;
																},
																$author$project$Eos$Account$nameToString),
															model.cs.d9))
												});
										}
									}()
								}),
							hX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(10)
						});
				}),
			$author$project$Page$Dashboard$CompletedLoadUserTransfers);
	});
var $author$project$Transfer$getTransfers = function (maybeObj) {
	var toNodes = function (maybeNodes) {
		return A2($elm$core$List$filterMap, $elm$core$Basics$identity, maybeNodes);
	};
	var toMaybeNodes = function (edges) {
		return A2(
			$elm$core$List$map,
			function (a) {
				return A2(
					$elm$core$Maybe$andThen,
					function (b) {
						return b.os;
					},
					a);
			},
			edges);
	};
	var toMaybeEdges = function (maybeConn) {
		return A2(
			$elm$core$Maybe$andThen,
			function (a) {
				return a.m5;
			},
			maybeConn);
	};
	var toMaybeConn = function (maybeObj_) {
		return A2(
			$elm$core$Maybe$andThen,
			function (a) {
				return a.av;
			},
			maybeObj_);
	};
	var toEdges = function (maybeEdges) {
		return A2($elm$core$Maybe$withDefault, _List_Nil, maybeEdges);
	};
	return toNodes(
		toMaybeNodes(
			toEdges(
				toMaybeEdges(
					toMaybeConn(maybeObj)))));
};
var $author$project$Session$LoggedIn$hasPermissions = F2(
	function (profile_, permissions) {
		var allPermissions = A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.o6;
			},
			profile_.pz);
		return A2(
			$elm$core$List$all,
			function (permission) {
				return A2($elm$core$List$member, permission, allPermissions);
			},
			permissions);
	});
var $author$project$Claim$paginatedPageInfo = function (maybePaginated) {
	return A2(
		$elm$core$Maybe$map,
		function (a) {
			return a.o2;
		},
		maybePaginated);
};
var $author$project$Claim$paginatedToList = function (maybeObj) {
	var toNodes = function (maybeNodes) {
		return A2($elm$core$List$filterMap, $elm$core$Basics$identity, maybeNodes);
	};
	var toMaybeNodes = function (edges) {
		return A2(
			$elm$core$List$map,
			function (a) {
				return A2(
					$elm$core$Maybe$andThen,
					function (b) {
						return b.os;
					},
					a);
			},
			edges);
	};
	var toMaybeEdges = function (maybeConn) {
		return A2(
			$elm$core$Maybe$andThen,
			function (a) {
				return a.m5;
			},
			maybeConn);
	};
	var toEdges = function (maybeEdges) {
		return A2($elm$core$Maybe$withDefault, _List_Nil, maybeEdges);
	};
	return toNodes(
		toMaybeNodes(
			toEdges(
				toMaybeEdges(maybeObj))));
};
var $author$project$Page$Dashboard$shouldShowContactModal = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.pl;
		if (_v0.$ === 3) {
			var profile = _v0.a;
			var addContactLimitDate = 1643374799000;
			var showContactModalFromDate = (addContactLimitDate - $elm$time$Time$posixToMillis(loggedIn.A.ce)) > 0;
			return showContactModalFromDate && ($elm$core$List$isEmpty(profile.az) && (!model.cp));
		} else {
			return false;
		}
	});
var $author$project$Ports$storeHasSeenSponsorModal = _Platform_outgoingPort('storeHasSeenSponsorModal', $elm$json$Json$Encode$bool);
var $author$project$Profile$Contact$CompletedDeleteContact = function (a) {
	return {$: 10, a: a};
};
var $author$project$Profile$Contact$CompletedUpdateContact = function (a) {
	return {$: 9, a: a};
};
var $author$project$Profile$Contact$GotContacts = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Profile$Contact$GotContactsError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Profile$Contact$GotMutationRequest = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Profile$Contact$Multiple = function (a) {
	return {$: 1, a: a};
};
var $author$project$Profile$Contact$NoOp = {$: 0};
var $robinheghan$elm_phone_numbers$PhoneNumber$PersonalNumber = 5;
var $robinheghan$elm_phone_numbers$PhoneNumber$Voip = 6;
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCA = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[2-8]\\d|90)\\d{8}')),
	w: 'CA',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '5062345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}'))
		},
			{
			nb: '5062345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}'))
		},
			{
			nb: '6002012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('600[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCR = {
	eO: '506',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}')),
	w: 'CR',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '22123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}'))
		},
			{
			nb: '83123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7}'))
		},
			{
			nb: '9001234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[059]\\d{7}'))
		},
			{
			nb: '40001234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:210[0-6]|4\\d{3}|5100)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryET = {
	eO: '251',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:11|[2-59]\\d)\\d{7}')),
	w: 'ET',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '111112345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[78]|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}'))
		},
			{
			nb: '911234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9\\d{8}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Pager = 7;
var $robinheghan$elm_phone_numbers$PhoneNumber$Uan = 8;
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGB = {
	eO: '44',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}')),
	w: 'GB',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '1212345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|(?:4[0-5]|5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:0\\d|20)))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}'))
		},
			{
			nb: '7400123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}'))
		},
			{
			nb: '7640123456',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[08]\\d{7}|800\\d{6}|8001111'))
		},
			{
			nb: '9012345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d'))
		},
			{
			nb: '7012345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70\\d{8}'))
		},
			{
			nb: '5612345678',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('56\\d{8}'))
		},
			{
			nb: '5512345678',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3[0347]|55)\\d{8}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNZ = {
	eO: '64',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}')),
	w: 'NZ',
	ki: $elm$core$Maybe$Just('0(?:0|161)'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '32345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}'))
		},
			{
			nb: '211234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2[0-27-9]\\d{7,8}|21\\d{6}'))
		},
			{
			nb: '26123456',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[28]6\\d{6,7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('508\\d{6,7}|80\\d{6,8}'))
		},
			{
			nb: '900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:11\\d{5}|50(?:0[08]|30|66|77))\\d{3}|90\\d{6,8}'))
		},
			{
			nb: '701234567',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70\\d{7}'))
		},
			{
			nb: '83012378',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('83\\d{3,8}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Voicemail = 10;
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPT = {
	eO: '351',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[26-9]\\d|30)\\d{7}')),
	w: 'PT',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '212345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}'))
		},
			{
			nb: '912345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6[356]9230\\d{3}|(?:6[036]93|9(?:[1-36]\\d\\d|480))\\d{5}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[02]\\d{6}'))
		},
			{
			nb: '760123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}'))
		},
			{
			nb: '808123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80(?:8\\d|9[1579])\\d{5}'))
		},
			{
			nb: '884123456',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('884[0-4689]\\d{5}'))
		},
			{
			nb: '301234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('30\\d{7}'))
		},
			{
			nb: '707123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70(?:7\\d|8[17])\\d{5}'))
		},
			{
			nb: '600110000',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('600\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUS = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-9]\\d{9}')),
	w: 'US',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '2015550123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}'))
		},
			{
			nb: '2015550123',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}'))
		},
			{
			nb: '8002345678',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZA = {
	eO: '27',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[1-79]\\d{8}|8\\d{4,9}')),
	w: 'ZA',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '101234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}'))
		},
			{
			nb: '711234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}'))
		},
			{
			nb: '801234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{7}'))
		},
			{
			nb: '862345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:86[2-9]|9[0-2]\\d)\\d{6}'))
		},
			{
			nb: '860123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('860\\d{6}'))
		},
			{
			nb: '871234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}'))
		},
			{
			nb: '861123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('861\\d{6,7}'))
		}
		])
};
var $author$project$Profile$Contact$supportedCountries = _List_fromArray(
	[
		$author$project$Profile$Contact$defaultCountry,
		{mP: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCA, aU: '/icons/flag-canada.svg', aJ: '123 456 7890'},
		{mP: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCR, aU: '/icons/flag-costa-rica.svg', aJ: '8123 4567'},
		{mP: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryET, aU: '/icons/flag-ethiopia.svg', aJ: '91 234 5678'},
		{mP: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGB, aU: '/icons/flag-united-kingdom.svg', aJ: '20 1234 5678'},
		{mP: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNZ, aU: '/icons/flag-new-zealand.svg', aJ: '2123 4567(89)'},
		{mP: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPT, aU: '/icons/flag-portugal.svg', aJ: '12 345 6789'},
		{mP: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUS, aU: '/icons/flag-usa.svg', aJ: '209 123 4567'},
		{mP: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZA, aU: '/icons/flag-south-africa.svg', aJ: '71 123 4567'}
	]);
var $author$project$Profile$Contact$countryOptions = function (supportedCountry) {
	return A2(
		$elm$core$List$cons,
		supportedCountry,
		A2(
			$elm$core$List$filter,
			function (country) {
				return !_Utils_eq(country, supportedCountry);
			},
			$author$project$Profile$Contact$supportedCountries));
};
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Profile$Contact$flagId = F2(
	function (supportedCountry, contactType) {
		return 'flag-' + (supportedCountry.mP.w + ('-' + $author$project$Cambiatus$Enum$ContactType$toString(contactType)));
	});
var $author$project$Profile$Contact$flagSelectorId = function (contactType) {
	return $author$project$Cambiatus$Enum$ContactType$toString(contactType) + '_select';
};
var $author$project$Profile$Contact$Profile = F2(
	function (account, contacts) {
		return {l8: account, az: contacts};
	});
var $author$project$Profile$Contact$profileSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$author$project$Cambiatus$Object$User$contacts($author$project$Profile$Contact$selectionSet)),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$User$account),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Contact$Profile)));
var $author$project$Cambiatus$InputObject$encodeUserUpdateInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'avatar',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.dl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'bio',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.dm, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'claimNotification',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.dq, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'contacts',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input.az,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Cambiatus$InputObject$encodeContactInput))),
				_Utils_Tuple2(
				'digest',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.dx, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'email',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.jK, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'interests',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.dN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'location',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.oa, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.fj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'transferNotification',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.ep, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool))
			]));
};
var $author$project$Cambiatus$Mutation$user = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'user',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs.nG, $author$project$Cambiatus$InputObject$encodeUserUpdateInput)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Profile$Contact$mutation = function (contacts) {
	var contactInput = function (_v0) {
		var contactType = _v0.mE;
		var contact = _v0.mD;
		var label = _v0.n$;
		return {
			dC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(contact),
			n$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(label),
			eq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(contactType)
		};
	};
	return A2(
		$author$project$Cambiatus$Mutation$user,
		{
			nG: {
				dl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				dm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				dq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				az: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					A2($elm$core$List$map, contactInput, contacts)),
				dx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				jK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				dN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				oa: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				fj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				ep: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
			}
		},
		$author$project$Profile$Contact$profileSelectionSet);
};
var $author$project$Profile$Contact$removeErrors = function (kind) {
	if (!kind.$) {
		var contact = kind.a;
		return $author$project$Profile$Contact$Single(
			_Utils_update(
				contact,
				{jO: $elm$core$Maybe$Nothing}));
	} else {
		var contacts = kind.a;
		return $author$project$Profile$Contact$Multiple(
			A2(
				$elm$core$List$map,
				function (contact) {
					return _Utils_update(
						contact,
						{jO: $elm$core$Maybe$Nothing});
				},
				contacts));
	}
};
var $author$project$Profile$Contact$addErrors = F2(
	function (errors, basic) {
		if (!errors.b) {
			return _Utils_update(
				basic,
				{jO: $elm$core$Maybe$Nothing});
		} else {
			var err = errors.a;
			return _Utils_update(
				basic,
				{
					jO: $elm$core$Maybe$Just(
						_List_fromArray(
							[err]))
				});
		}
	});
var $rtfeldman$elm_validate$Validate$fromValid = function (_v0) {
	var subject = _v0;
	return subject;
};
var $author$project$Profile$Contact$normalize = F2(
	function (_v0, validatedContact) {
		var country = _v0.mP;
		var _v1 = $rtfeldman$elm_validate$Validate$fromValid(validatedContact);
		var contactType = _v1.mE;
		var contact = _v1.mD;
		var label = _v1.n$;
		return {
			mD: function () {
				switch (contactType) {
					case 1:
						return 'https://instagram.com/' + contact;
					case 3:
						return A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								['+' + country.eO, contact]));
					case 4:
						return 'https://t.me/' + contact;
					case 5:
						return A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								['+' + country.eO, contact]));
					case 0:
						return contact;
					default:
						return contact;
				}
			}(),
			mE: contactType,
			n$: label
		};
	});
var $rtfeldman$elm_validate$Validate$Valid = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$validate = F2(
	function (_v0, subject) {
		var getErrors = _v0;
		var _v1 = getErrors(subject);
		if (!_v1.b) {
			return $elm$core$Result$Ok(subject);
		} else {
			var errors = _v1;
			return $elm$core$Result$Err(errors);
		}
	});
var $rtfeldman$elm_validate$Validate$Validator = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$all = function (validators) {
	var newGetErrors = function (subject) {
		var accumulateErrors = F2(
			function (_v0, totalErrors) {
				var getErrors = _v0;
				return _Utils_ap(
					totalErrors,
					getErrors(subject));
			});
		return A3($elm$core$List$foldl, accumulateErrors, _List_Nil, validators);
	};
	return newGetErrors;
};
var $rtfeldman$elm_validate$Validate$fromErrors = function (toErrors) {
	return toErrors;
};
var $rtfeldman$elm_validate$Validate$ifTrue = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? _List_fromArray(
				[error]) : _List_Nil;
		};
		return getErrors;
	});
var $rtfeldman$elm_validate$Validate$isWhitespaceChar = function (_char) {
	return (_char === ' ') || ((_char === '\n') || ((_char === '\t') || (_char === '\u000D')));
};
var $rtfeldman$elm_validate$Validate$isBlank = function (str) {
	isBlank:
	while (true) {
		var _v0 = $elm$core$String$uncons(str);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var _char = _v1.a;
			var rest = _v1.b;
			if ($rtfeldman$elm_validate$Validate$isWhitespaceChar(_char)) {
				var $temp$str = rest;
				str = $temp$str;
				continue isBlank;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
};
var $rtfeldman$elm_validate$Validate$ifBlank = F2(
	function (subjectToString, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return $rtfeldman$elm_validate$Validate$isBlank(
					subjectToString(subject));
			},
			error);
	});
var $rtfeldman$elm_validate$Validate$validEmail = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{mp: true, om: false},
		'^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$'));
var $rtfeldman$elm_validate$Validate$isValidEmail = function (email) {
	return A2($elm$regex$Regex$contains, $rtfeldman$elm_validate$Validate$validEmail, email);
};
var $rtfeldman$elm_validate$Validate$ifInvalidEmail = F2(
	function (subjectToEmail, errorFromEmail) {
		var getErrors = function (subject) {
			var email = subjectToEmail(subject);
			return $rtfeldman$elm_validate$Validate$isValidEmail(email) ? _List_Nil : _List_fromArray(
				[
					errorFromEmail(email)
				]);
		};
		return getErrors;
	});
var $author$project$Profile$Contact$instagramRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[\\w](?!.*?\\.{2})[\\w.]{1,28}[\\w]$'));
var $author$project$Profile$Contact$telegramRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[\\w]{5,32}$'));
var $robinheghan$elm_phone_numbers$PhoneNumber$CarrierSpecific = 13;
var $robinheghan$elm_phone_numbers$PhoneNumber$Emergency = 9;
var $robinheghan$elm_phone_numbers$PhoneNumber$ShortCode = 11;
var $robinheghan$elm_phone_numbers$PhoneNumber$SmsServices = 14;
var $robinheghan$elm_phone_numbers$PhoneNumber$StandardRate = 12;
var $robinheghan$elm_phone_numbers$PhoneNumber$anyType = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
var $robinheghan$elm_phone_numbers$PhoneNumber$localizeNumber = F2(
	function (country, number) {
		var _v0 = country.ki;
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Just(number);
		} else {
			var prefix = _v0.a;
			var prefixLength = $elm$core$String$length(prefix);
			var countryCodeLength = $elm$core$String$length(country.eO);
			return A2($elm$core$String$startsWith, '+', number) ? (_Utils_eq(
				country.eO,
				A2(
					$elm$core$String$left,
					countryCodeLength,
					A2($elm$core$String$dropLeft, 1, number))) ? $elm$core$Maybe$Just(
				A2($elm$core$String$dropLeft, countryCodeLength + 1, number)) : $elm$core$Maybe$Nothing) : (A2($elm$core$String$startsWith, prefix, number) ? (_Utils_eq(
				country.eO,
				A2(
					$elm$core$String$left,
					countryCodeLength,
					A2($elm$core$String$dropLeft, prefixLength, number))) ? $elm$core$Maybe$Just(
				A2($elm$core$String$dropLeft, prefixLength + countryCodeLength, number)) : $elm$core$Maybe$Nothing) : $elm$core$Maybe$Just(number));
		}
	});
var $robinheghan$elm_phone_numbers$PhoneNumber$regexExactMatch = F2(
	function (regex, str) {
		var _v0 = A2($elm$regex$Regex$find, regex, str);
		if (_v0.b && (!_v0.b.b)) {
			var match = _v0.a;
			return _Utils_eq(match.fg, str);
		} else {
			return false;
		}
	});
var $robinheghan$elm_phone_numbers$PhoneNumber$matchingCountry = F4(
	function (number, defaultCountry, relevantTypes, country) {
		var maybeLocalNumber = A2($robinheghan$elm_phone_numbers$PhoneNumber$localizeNumber, country, number);
		var matchesSpec = F2(
			function (localNumber, desc) {
				return A2($robinheghan$elm_phone_numbers$PhoneNumber$regexExactMatch, desc.kY, localNumber);
			});
		var isDefaultCountry = _Utils_eq(defaultCountry.w, country.w);
		if (maybeLocalNumber.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var localNumber = maybeLocalNumber.a;
			if (_Utils_eq(localNumber, number) && (!isDefaultCountry)) {
				return $elm$core$Maybe$Nothing;
			} else {
				var matchingTypes = A2(
					$elm$core$List$map,
					function ($) {
						return $.iv;
					},
					A2(
						$elm$core$List$filter,
						matchesSpec(localNumber),
						A2(
							$elm$core$List$filter,
							function (nt) {
								return A2($elm$core$List$member, nt.iv, relevantTypes);
							},
							country.kO)));
				if (!matchingTypes.b) {
					return A2($robinheghan$elm_phone_numbers$PhoneNumber$regexExactMatch, country.jY, localNumber) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(country, _List_Nil)) : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(country, matchingTypes));
				}
			}
		}
	});
var $robinheghan$elm_phone_numbers$PhoneNumber$sanitizeNumber = function (str) {
	return A2(
		$elm$core$String$filter,
		function (c) {
			return c !== ' ';
		},
		str);
};
var $robinheghan$elm_phone_numbers$PhoneNumber$matches = F2(
	function (config, number) {
		var sanitizedNumber = $robinheghan$elm_phone_numbers$PhoneNumber$sanitizeNumber(number);
		return A2(
			$elm$core$List$filterMap,
			A3($robinheghan$elm_phone_numbers$PhoneNumber$matchingCountry, sanitizedNumber, config.mY, config.qb),
			A2($elm$core$List$cons, config.mY, config.o0));
	});
var $robinheghan$elm_phone_numbers$PhoneNumber$valid = F2(
	function (config, number) {
		var _v0 = A2($robinheghan$elm_phone_numbers$PhoneNumber$matches, config, number);
		if (!_v0.b) {
			return false;
		} else {
			return true;
		}
	});
var $author$project$Profile$Contact$validatePhone = function (error) {
	return $rtfeldman$elm_validate$Validate$fromErrors(
		function (_v0) {
			var supportedCountry = _v0.aM;
			var contact = _v0.mD;
			return A2(
				$robinheghan$elm_phone_numbers$PhoneNumber$valid,
				{mY: supportedCountry.mP, o0: _List_Nil, qb: $robinheghan$elm_phone_numbers$PhoneNumber$anyType},
				contact) ? _List_Nil : _List_fromArray(
				[error]);
		});
};
var $author$project$Profile$Contact$validateRegex = F2(
	function (regex, error) {
		return $rtfeldman$elm_validate$Validate$fromErrors(
			function (_v0) {
				var contact = _v0.mD;
				return A2($elm$regex$Regex$contains, regex, contact) ? _List_Nil : _List_fromArray(
					[error]);
			});
	});
var $author$project$Profile$Contact$validator = F2(
	function (contactType, translators) {
		var baseTranslation = 'contact_form.validation';
		var _v0 = function () {
			switch (contactType) {
				case 3:
					return _Utils_Tuple2($author$project$Profile$Contact$validatePhone, 'phone');
				case 5:
					return _Utils_Tuple2($author$project$Profile$Contact$validatePhone, 'phone');
				case 1:
					return _Utils_Tuple2(
						$author$project$Profile$Contact$validateRegex($author$project$Profile$Contact$instagramRegex),
						'username');
				case 4:
					return _Utils_Tuple2(
						$author$project$Profile$Contact$validateRegex($author$project$Profile$Contact$telegramRegex),
						'username');
				case 0:
					return _Utils_Tuple2(
						function (error) {
							return A2(
								$rtfeldman$elm_validate$Validate$ifInvalidEmail,
								function ($) {
									return $.mD;
								},
								function (_v2) {
									return error;
								});
						},
						'email');
				default:
					return _Utils_Tuple2(
						function (error) {
							return $rtfeldman$elm_validate$Validate$fromErrors(
								function (_v3) {
									var contact = _v3.mD;
									var withProtocol = $elm$core$String$isEmpty(contact) ? '' : ((A2($elm$core$String$startsWith, 'https://', contact) || A2($elm$core$String$startsWith, 'http://', contact)) ? contact : ('http://' + contact));
									var _v4 = $elm$url$Url$fromString(withProtocol);
									if (_v4.$ === 1) {
										return _List_fromArray(
											[error]);
									} else {
										return _List_Nil;
									}
								});
						},
						'link');
			}
		}();
		var specificValidation = _v0.a;
		var field = _v0.b;
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.mD;
					},
					translators.fL(
						A2(
							$elm$core$String$join,
							'.',
							_List_fromArray(
								[baseTranslation, field, 'blank'])))),
					specificValidation(
					translators.fL(
						A2(
							$elm$core$String$join,
							'.',
							_List_fromArray(
								[baseTranslation, field, 'invalid']))))
				]));
	});
var $author$project$Profile$Contact$submitSingle = F2(
	function (translators, basic) {
		return A2(
			$elm$core$Result$map,
			function (valid) {
				return A2($author$project$Profile$Contact$normalize, basic.aM, valid);
			},
			A2(
				$elm$core$Result$mapError,
				function (errors) {
					return A2($author$project$Profile$Contact$addErrors, errors, basic);
				},
				A2(
					$rtfeldman$elm_validate$Validate$validate,
					A2($author$project$Profile$Contact$validator, basic.mE, translators),
					basic)));
	});
var $author$project$Profile$Contact$submitMultiple = F2(
	function (translators, basics) {
		var _v0 = A3(
			$elm$core$List$foldr,
			F2(
				function (basic, _v1) {
					var basicsAcc = _v1.a;
					var normalizedsAcc = _v1.b;
					var _v2 = A2($author$project$Profile$Contact$submitSingle, translators, basic);
					if (_v2.$ === 1) {
						var basicWithErrors = _v2.a;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, basicWithErrors, basicsAcc),
							normalizedsAcc);
					} else {
						var normalized = _v2.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_update(
									basic,
									{jO: $elm$core$Maybe$Nothing}),
								basicsAcc),
							A2($elm$core$List$cons, normalized, normalizedsAcc));
					}
				}),
			_Utils_Tuple2(_List_Nil, _List_Nil),
			basics);
		var withError = _v0.a;
		var valid = _v0.b;
		return A2(
			$elm$core$List$all,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.mD;
				},
				$elm$core$String$isEmpty),
			basics) ? $elm$core$Result$Ok(_List_Nil) : (($elm$core$List$length(valid) > 0) ? $elm$core$Result$Ok(valid) : $elm$core$Result$Err(withError));
	});
var $author$project$Profile$Contact$submit = F2(
	function (translators, kind) {
		if (!kind.$) {
			var contact = kind.a;
			return A2(
				$elm$core$Result$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Result$mapError,
					$author$project$Profile$Contact$Single,
					A2($author$project$Profile$Contact$submitSingle, translators, contact)));
		} else {
			var contacts = kind.a;
			return A2(
				$elm$core$Result$mapError,
				$author$project$Profile$Contact$Multiple,
				A2($author$project$Profile$Contact$submitMultiple, translators, contacts));
		}
	});
var $author$project$Profile$Contact$updateIfContactType = F3(
	function (contactType, fn, contacts) {
		return A3(
			$elm_community$list_extra$List$Extra$updateIf,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.mE;
				},
				$elm$core$Basics$eq(contactType)),
			fn,
			contacts);
	});
var $author$project$Profile$Contact$update = F4(
	function (msg, model, translators, profileContacts) {
		var updateKind = F2(
			function (contactType, updateFn) {
				return _Utils_update(
					model,
					{
						z: function () {
							var _v15 = model.z;
							if (!_v15.$) {
								var contact = _v15.a;
								return $author$project$Profile$Contact$Single(
									updateFn(contact));
							} else {
								var contacts = _v15.a;
								return $author$project$Profile$Contact$Multiple(
									A3($author$project$Profile$Contact$updateIfContactType, contactType, updateFn, contacts));
							}
						}()
					});
			});
		var toggleFlags = function (contact) {
			var showFlags = contact.co;
			return _Utils_update(
				contact,
				{
					b$: showFlags ? $elm$core$Maybe$Nothing : contact.b$,
					co: !showFlags
				});
		};
		var setFocusedFlag = F2(
			function (supportedCountry, contact) {
				return _Utils_update(
					contact,
					{
						b$: $elm$core$Maybe$Just(supportedCountry)
					});
			});
		var setCountry = F2(
			function (newCountry, contact) {
				return _Utils_update(
					contact,
					{jO: $elm$core$Maybe$Nothing, b$: $elm$core$Maybe$Nothing, aM: newCountry});
			});
		var setContact = F2(
			function (newContact, contact) {
				return _Utils_update(
					contact,
					{mD: newContact});
			});
		var feedbackScope = function () {
			var _v14 = model.z;
			if (!_v14.$) {
				return 'single';
			} else {
				return 'multiple';
			}
		}();
		var currentFocusedFlag = function (contactType) {
			var _v13 = model.z;
			if (!_v13.$) {
				var contact = _v13.a;
				return A2($elm$core$Maybe$withDefault, $author$project$Profile$Contact$defaultCountry, contact.b$);
			} else {
				var contacts = _v13.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Profile$Contact$defaultCountry,
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.b$;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.mE;
									},
									$elm$core$Basics$eq(contactType)),
								contacts))));
			}
		};
		var currentCountry = function (contactType) {
			var _v12 = model.z;
			if (!_v12.$) {
				var contact = _v12.a;
				return contact.aM;
			} else {
				var contacts = _v12.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Profile$Contact$defaultCountry,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.aM;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.mE;
									},
									$elm$core$Basics$eq(contactType)),
								contacts))));
			}
		};
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var contactType = msg.a;
				var country = msg.b;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v1) {
							return $author$project$Profile$Contact$NoOp;
						},
						$elm$browser$Browser$Dom$focus(
							$author$project$Profile$Contact$flagSelectorId(contactType))),
					$author$project$UpdateResult$init(
						A2(
							updateKind,
							contactType,
							setCountry(country))));
			case 2:
				var contactType = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v2) {
							return $author$project$Profile$Contact$NoOp;
						},
						$elm$browser$Browser$Dom$focus(
							$author$project$Profile$Contact$flagSelectorId(contactType))),
					$author$project$UpdateResult$init(
						A2(updateKind, contactType, toggleFlags)));
			case 3:
				var contactType = msg.a;
				var newContact = msg.b;
				return $author$project$UpdateResult$init(
					A2(
						updateKind,
						contactType,
						setContact(newContact)));
			case 5:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cC: $elm$core$Maybe$Nothing}));
			case 4:
				var contactType = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							cC: $elm$core$Maybe$Just(contactType)
						}));
			case 6:
				var contactTypeToDelete = msg.a;
				var withoutContact = A2(
					updateKind,
					contactTypeToDelete,
					function (basic) {
						return _Utils_update(
							basic,
							{mD: '', jO: $elm$core$Maybe$Nothing});
					});
				var newContacts = A2(
					$elm$core$List$filter,
					function (_v3) {
						var contactType = _v3.mE;
						return !_Utils_eq(contactType, contactTypeToDelete);
					},
					profileContacts);
				return A2(
					$author$project$UpdateResult$addExt,
					A2(
						$author$project$Profile$Contact$GotMutationRequest,
						$author$project$Profile$Contact$mutation(newContacts),
						$author$project$Profile$Contact$CompletedDeleteContact),
					$author$project$UpdateResult$init(
						_Utils_update(
							withoutContact,
							{cC: $elm$core$Maybe$Nothing, Z: $krisajenkins$remotedata$RemoteData$Loading})));
			case 7:
				var option = msg.a;
				var _v4 = model.z;
				if (!_v4.$) {
					var contact = _v4.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								z: $author$project$Profile$Contact$Single(
									_Utils_update(
										contact,
										{mD: '', mE: option, jO: $elm$core$Maybe$Nothing}))
							}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 8:
				var _v5 = A2($author$project$Profile$Contact$submit, translators, model.z);
				if (_v5.$ === 1) {
					var withError = _v5.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{z: withError}));
				} else {
					var normalized = _v5.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A2(
							$author$project$Profile$Contact$GotMutationRequest,
							$author$project$Profile$Contact$mutation(normalized),
							$author$project$Profile$Contact$CompletedUpdateContact),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									z: $author$project$Profile$Contact$removeErrors(model.z),
									Z: $krisajenkins$remotedata$RemoteData$Loading
								})));
				}
			case 9:
				var result = msg.a;
				var feedbackString = function (isSuccess) {
					return translators.fL(
						A2(
							$elm$core$String$join,
							'.',
							_List_fromArray(
								[
									'contact_form.feedback',
									feedbackScope,
									isSuccess ? 'success' : 'failure'
								])));
				};
				var addContactResponse = function () {
					switch (result.$) {
						case 3:
							if (!result.a.$) {
								var profile = result.a.a;
								return $author$project$UpdateResult$addExt(
									A3(
										$author$project$Profile$Contact$GotContacts,
										feedbackString(true),
										profile.az,
										true));
							} else {
								var _v7 = result.a;
								return $author$project$UpdateResult$addExt(
									$author$project$Profile$Contact$GotContactsError(
										feedbackString(false)));
							}
						case 2:
							return $author$project$UpdateResult$addExt(
								$author$project$Profile$Contact$GotContactsError(
									feedbackString(false)));
						case 0:
							return $elm$core$Basics$identity;
						default:
							return $elm$core$Basics$identity;
					}
				}();
				return addContactResponse(
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{Z: result})));
			case 10:
				var result = msg.a;
				var feedbackString = function (isSuccess) {
					return translators.fL(
						A2(
							$elm$core$String$join,
							'.',
							_List_fromArray(
								[
									'contact_form.feedback.delete',
									isSuccess ? 'success' : 'failure'
								])));
				};
				var addContactResponse = function () {
					switch (result.$) {
						case 3:
							if (!result.a.$) {
								var profile = result.a.a;
								return $author$project$UpdateResult$addExt(
									A3(
										$author$project$Profile$Contact$GotContacts,
										feedbackString(true),
										profile.az,
										false));
							} else {
								var _v9 = result.a;
								return $author$project$UpdateResult$addExt(
									$author$project$Profile$Contact$GotContactsError(
										feedbackString(false)));
							}
						case 2:
							return $author$project$UpdateResult$addExt(
								$author$project$Profile$Contact$GotContactsError(
									feedbackString(false)));
						case 0:
							return $elm$core$Basics$identity;
						default:
							return $elm$core$Basics$identity;
					}
				}();
				return addContactResponse(
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{Z: $krisajenkins$remotedata$RemoteData$NotAsked})));
			case 11:
				var contactType = msg.a;
				var countries = $author$project$Profile$Contact$countryOptions(
					currentCountry(contactType));
				var nextCountry = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Profile$Contact$defaultCountry,
					A2(
						$elm$core$Maybe$andThen,
						function (index) {
							return A2($elm_community$list_extra$List$Extra$getAt, index, countries);
						},
						A2(
							$elm$core$Maybe$map,
							function (nextIndex) {
								return (nextIndex <= 0) ? ($elm$core$List$length(countries) - 1) : (nextIndex - 1);
							},
							A2(
								$elm_community$list_extra$List$Extra$elemIndex,
								currentFocusedFlag(contactType),
								countries))));
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v10) {
							return $author$project$Profile$Contact$NoOp;
						},
						$elm$browser$Browser$Dom$focus(
							A2($author$project$Profile$Contact$flagId, nextCountry, contactType))),
					$author$project$UpdateResult$init(
						A2(
							updateKind,
							contactType,
							setFocusedFlag(nextCountry))));
			default:
				var contactType = msg.a;
				var countries = $author$project$Profile$Contact$countryOptions(
					currentCountry(contactType));
				var nextCountry = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Profile$Contact$defaultCountry,
					A2(
						$elm$core$Maybe$andThen,
						function (index) {
							return A2($elm_community$list_extra$List$Extra$getAt, index, countries);
						},
						A2(
							$elm$core$Maybe$map,
							function (nextIndex) {
								return (_Utils_cmp(
									nextIndex,
									$elm$core$List$length(countries) - 1) > -1) ? 0 : (nextIndex + 1);
							},
							A2(
								$elm_community$list_extra$List$Extra$elemIndex,
								currentFocusedFlag(contactType),
								countries))));
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v11) {
							return $author$project$Profile$Contact$NoOp;
						},
						$elm$browser$Browser$Dom$focus(
							A2($author$project$Profile$Contact$flagId, nextCountry, contactType))),
					$author$project$UpdateResult$init(
						A2(
							updateKind,
							contactType,
							setFocusedFlag(nextCountry))));
		}
	});
var $author$project$Page$Dashboard$update = F3(
	function (msg, model, loggedIn) {
		var shared = loggedIn.A;
		var accountName = loggedIn._;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var community = msg.a;
				var hasContributionConfiguration = function () {
					var _v1 = A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.o5;
						},
						community.mM);
					if (!_v1.$) {
						return true;
					} else {
						return false;
					}
				}();
				var markSponsorModalAsSeen = hasContributionConfiguration ? A2(
					$elm$core$Basics$composeR,
					$author$project$UpdateResult$addExt(
						$author$project$Session$LoggedIn$UpdatedLoggedIn(
							_Utils_update(
								loggedIn,
								{
									A: _Utils_update(
										shared,
										{j2: true})
								}))),
					$author$project$UpdateResult$addCmd(
						$author$project$Ports$storeHasSeenSponsorModal(true))) : $elm$core$Basics$identity;
				var showModalRequestingSponsor = hasContributionConfiguration && (!shared.j2);
				return markSponsorModalAsSeen(
					A2(
						$author$project$UpdateResult$addExt,
						A4($author$project$Page$Dashboard$fetchTransfers, loggedIn, community, $elm$core$Maybe$Nothing, model),
						A2(
							$author$project$UpdateResult$addExt,
							A2($author$project$Page$Dashboard$fetchAvailableAnalysis, loggedIn, $elm$core$Maybe$Nothing),
							A2(
								$author$project$UpdateResult$addCmd,
								A3($author$project$Page$Dashboard$fetchBalance, shared, accountName, community),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											dj: $author$project$Page$Dashboard$LoadingGraphql($elm$core$Maybe$Nothing),
											cA: $krisajenkins$remotedata$RemoteData$Loading,
											bN: (!showModalRequestingSponsor) && A2($author$project$Page$Dashboard$shouldShowContactModal, loggedIn, model),
											cp: showModalRequestingSponsor
										}))))));
			case 2:
				if (!msg.a.$) {
					var balance = msg.a.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								cA: $krisajenkins$remotedata$RemoteData$Success(balance)
							}));
				} else {
					var httpError = msg.a.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(loggedIn._),
						'Got an error when loading balance on the dashboard',
						{e$: 'update', fi: 'Page.Dashboard'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.pC)
							]),
						httpError,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									cA: $krisajenkins$remotedata$RemoteData$Failure(httpError)
								})));
				}
			case 4:
				switch (msg.a.$) {
					case 3:
						var claims = msg.a.a;
						var analysis = {
							jt: $author$project$Claim$paginatedToList(claims),
							mO: A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.mO;
									},
									claims))
						};
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									dj: A2(
										$author$project$Page$Dashboard$LoadedGraphql,
										analysis,
										$author$project$Claim$paginatedPageInfo(claims))
								}));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when loading claims on the dashboard',
							{e$: 'update', fi: 'Page.Dashboard'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.pC)
								]),
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{dj: $author$project$Page$Dashboard$FailedGraphql})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 3:
				switch (msg.a.$) {
					case 3:
						var maybeTransfers = msg.a.a;
						var previousTransfers = function () {
							var _v2 = model.av;
							_v2$2:
							while (true) {
								switch (_v2.$) {
									case 1:
										var previousTransfers_ = _v2.a;
										return previousTransfers_;
									case 0:
										if (!_v2.a.$) {
											var previousTransfers_ = _v2.a.a;
											return previousTransfers_;
										} else {
											break _v2$2;
										}
									default:
										break _v2$2;
								}
							}
							return _List_Nil;
						}();
						var maybePageInfo = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.o2;
							},
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.av;
								},
								maybeTransfers));
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									av: function (transfers) {
										return A2(
											$author$project$Page$Dashboard$LoadedGraphql,
											_Utils_ap(previousTransfers, transfers),
											maybePageInfo);
									}(
										A2(
											$elm$core$List$map,
											function (transfer) {
												return _Utils_Tuple2(
													transfer,
													$author$project$Profile$Summary$init(false));
											},
											$author$project$Transfer$getTransfers(maybeTransfers)))
								}));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when trying to load user\'s transfers',
							{e$: 'update', fi: 'Page.Dashboard'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.pC)
								]),
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{av: $author$project$Page$Dashboard$FailedGraphql})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 5:
				var transferId = msg.a;
				var subMsg = msg.b;
				var updateTransfers = function (transfers) {
					return A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (_v4) {
							var transfer = _v4.a;
							return _Utils_eq(transfer.w, transferId);
						},
						function (_v5) {
							var transfer = _v5.a;
							var profileSummary = _v5.b;
							return _Utils_Tuple2(
								transfer,
								A2($author$project$Profile$Summary$update, subMsg, profileSummary));
						},
						transfers);
				};
				var _v3 = model.av;
				switch (_v3.$) {
					case 1:
						var transfers = _v3.a;
						var pageInfo = _v3.b;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									av: A2(
										$author$project$Page$Dashboard$LoadedGraphql,
										updateTransfers(transfers),
										pageInfo)
								}));
					case 0:
						var maybeTransfers = _v3.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									av: $author$project$Page$Dashboard$LoadingGraphql(
										A2($elm$core$Maybe$map, updateTransfers, maybeTransfers))
								}));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 6:
				var _v6 = _Utils_Tuple2(model.av, loggedIn.pC);
				if ((_v6.a.$ === 1) && (_v6.b.$ === 3)) {
					var _v7 = _v6.a;
					var transfers = _v7.a;
					var maybePageInfo = _v7.b;
					var community = _v6.b.a;
					var maybeCursor = A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.m7;
						},
						maybePageInfo);
					return A2(
						$author$project$UpdateResult$addExt,
						A4($author$project$Page$Dashboard$fetchTransfers, loggedIn, community, maybeCursor, model),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									av: $author$project$Page$Dashboard$LoadingGraphql(
										$elm$core$Maybe$Just(transfers))
								})));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 7:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{c8: true}));
			case 8:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{c8: false}));
			case 9:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{fU: newForm});
					},
					$author$project$Page$Dashboard$GotTransfersFiltersFormMsg,
					$author$project$Session$LoggedIn$addFeedback,
					model,
					A3($author$project$Form$update, shared, subMsg, model.fU));
			case 10:
				var formOutput = msg.a;
				var _v8 = loggedIn.pC;
				if (_v8.$ === 3) {
					var community = _v8.a;
					var newModel = _Utils_update(
						model,
						{
							c8: false,
							av: $author$project$Page$Dashboard$LoadingGraphql($elm$core$Maybe$Nothing),
							cs: formOutput
						});
					return A2(
						$author$project$UpdateResult$addExt,
						A4($author$project$Page$Dashboard$fetchTransfers, loggedIn, community, $elm$core$Maybe$Nothing, newModel),
						$author$project$UpdateResult$init(newModel));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Applied filters on transfer list, but community wasn\'t loaded',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Dashboard'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 11:
				var transferId = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$author$project$Route$pushUrl,
						loggedIn.A.kK,
						$author$project$Route$ViewTransfer(transferId)),
					$author$project$UpdateResult$init(model));
			case 12:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cp: true}));
			case 13:
				var _v9 = loggedIn.pl;
				if (_v9.$ === 3) {
					var profile = _v9.a;
					if (A2(
						$author$project$Session$LoggedIn$hasPermissions,
						profile,
						_List_fromArray(
							[2]))) {
						var _v10 = model.cA;
						if ((_v10.$ === 3) && (!_v10.a.$)) {
							var b = _v10.a.a;
							return A2(
								$author$project$UpdateResult$addCmd,
								A4($author$project$Api$communityInvite, loggedIn.A, b.mk.as, loggedIn._, $author$project$Page$Dashboard$CompletedInviteCreation),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{bg: $author$project$Page$Dashboard$InviteModalLoading})));
						} else {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Created invitation, but balance wasn\'t loaded',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Dashboard'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						}
					} else {
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$ShowInsufficientPermissionsModal,
							$author$project$UpdateResult$init(model));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Tried creating invitation, but profile wasn\'t loaded',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Dashboard'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 14:
				var subMsg = msg.a;
				var _v11 = $author$project$Session$LoggedIn$profile(loggedIn);
				if (!_v11.$) {
					var userProfile = _v11.a;
					var handleExtMsg = function (extMsg) {
						switch (extMsg.$) {
							case 0:
								var successMessage = extMsg.a;
								var contacts = extMsg.b;
								return A2(
									$elm$core$Basics$composeR,
									$author$project$UpdateResult$mapModel(
										function (model_) {
											return _Utils_update(
												model_,
												{bN: false});
										}),
									A2(
										$elm$core$Basics$composeR,
										$author$project$UpdateResult$addExt(
											A2($author$project$Session$LoggedIn$ShowFeedback, 0, successMessage)),
										$author$project$UpdateResult$addExt(
											$author$project$Session$LoggedIn$ExternalBroadcast(
												$author$project$Session$LoggedIn$ProfileLoaded(
													_Utils_update(
														userProfile,
														{az: contacts}))))));
							case 1:
								var errorMessage = extMsg.a;
								return A2(
									$elm$core$Basics$composeR,
									$author$project$UpdateResult$mapModel(
										function (model_) {
											return _Utils_update(
												model_,
												{bN: false});
										}),
									$author$project$UpdateResult$addExt(
										A2($author$project$Session$LoggedIn$ShowFeedback, 1, errorMessage)));
							default:
								var selectionSet = extMsg.a;
								var responseMsg = extMsg.b;
								return $author$project$UpdateResult$addExt(
									A3(
										$author$project$Session$LoggedIn$mutation,
										loggedIn,
										selectionSet,
										A2($elm$core$Basics$composeR, responseMsg, $author$project$Page$Dashboard$GotContactMsg)));
						}
					};
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newContactModel) {
							return _Utils_update(
								model,
								{eM: newContactModel});
						},
						$author$project$Page$Dashboard$GotContactMsg,
						handleExtMsg,
						model,
						A4($author$project$Profile$Contact$update, subMsg, model.eM, loggedIn.A.aw, userProfile.az));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 15:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{bN: false}));
			case 16:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cD: false, bg: $author$project$Page$Dashboard$InviteModalClosed}));
			case 17:
				if (!msg.a.$) {
					var invitationId = msg.a.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$elm$core$Task$attempt,
							function (_v13) {
								return $author$project$Page$Dashboard$NoOp;
							},
							$elm$browser$Browser$Dom$focus('copy-invite-button')),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									bg: $author$project$Page$Dashboard$InviteModalLoaded(invitationId)
								})));
				} else {
					var httpError = msg.a.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(loggedIn._),
						'Got an error when creating an invite',
						{e$: 'update', fi: 'Page.Dashboard'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.pC)
							]),
						httpError,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									bg: $author$project$Page$Dashboard$InviteModalFailed(
										loggedIn.A.aw.fL('community.invite.failed'))
								})));
				}
			case 18:
				var elementId = msg.a;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(elementId)),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('copyToClipboard'))
								])),
						fy: $author$project$Page$Dashboard$CopiedToClipboard,
						fz: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(model));
			case 19:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cD: true}));
			case 20:
				var newModel = _Utils_update(
					model,
					{cp: false});
				return $author$project$UpdateResult$init(
					_Utils_update(
						newModel,
						{
							bN: A2($author$project$Page$Dashboard$shouldShowContactModal, loggedIn, newModel)
						}));
			default:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$ShowCodeOfConductModal,
					$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Dashboard$Analysis$ClosedAuthModal = {$: 1};
var $author$project$Page$Dashboard$Analysis$DESC = 1;
var $author$project$Page$Dashboard$Analysis$GotFilterFormMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Claim$Loading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Log$QueryBreadcrumb = 4;
var $author$project$Eos$assetToString = F2(
	function (translators, asset) {
		return A3($author$project$Eos$formatSymbolAmount, translators, asset.as, asset.ji) + (' ' + $author$project$Eos$symbolToSymbolCodeString(asset.as));
	});
var $author$project$Claim$encodeVerification = F4(
	function (claimId, validator, vote, communityId) {
		var encodedVote = $author$project$Eos$encodeEosBool(
			$author$project$Eos$boolToEosBool(vote));
		var encodedVerifier = $author$project$Eos$Account$encodeName(validator);
		var encodedClaimId = $elm$json$Json$Encode$int(claimId);
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'community_id',
					$author$project$Eos$encodeSymbol(communityId)),
					_Utils_Tuple2('claim_id', encodedClaimId),
					_Utils_Tuple2('verifier', encodedVerifier),
					_Utils_Tuple2('vote', encodedVote)
				]));
	});
var $author$project$Claim$pendingValidators = function (claim) {
	return A2(
		$elm$core$List$filter,
		function (validator) {
			return !A2(
				$elm$core$List$member,
				validator.l8,
				A2(
					$elm$core$List$map,
					function (c) {
						return c.aN.l8;
					},
					claim.aa));
		},
		claim.dh.lV);
};
var $author$project$Claim$initClaimProfileSummaries = function (claim) {
	return {
		eF: $author$project$Profile$Summary$init(false),
		cY: A2(
			$author$project$Profile$Summary$initMany,
			false,
			$elm$core$List$length(
				$author$project$Claim$pendingValidators(claim))),
		fE: false,
		fT: $author$project$Profile$Summary$init(true),
		cw: A2(
			$author$project$Profile$Summary$initMany,
			false,
			$elm$core$List$length(claim.aa))
	};
};
var $author$project$Eos$EosError$parseClaimError = F2(
	function (translators, eosErrorString) {
		return A4($author$project$Eos$EosError$parseErrorMessage, translators, 'error.contracts.verifyclaim.', 'community.verifyClaim.error', eosErrorString);
	});
var $author$project$Claim$PhotoModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Claim$VoteConfirmationModal = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Claim$updateClaimModalStatus = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var claimId = msg.a;
				var vote = msg.b;
				return _Utils_update(
					model,
					{
						hF: A2($author$project$Claim$VoteConfirmationModal, claimId, vote)
					});
			case 1:
				return _Utils_update(
					model,
					{hF: $author$project$Claim$Closed});
			case 2:
				var claimId = msg.a;
				return _Utils_update(
					model,
					{
						hF: $author$project$Claim$PhotoModal(claimId)
					});
			default:
				return model;
		}
	});
var $author$project$Claim$updateProfileSummaries = F2(
	function (externalMsg, claimProfileSummaries) {
		switch (externalMsg.$) {
			case 0:
				return _Utils_update(
					claimProfileSummaries,
					{fE: true});
			case 1:
				return _Utils_update(
					claimProfileSummaries,
					{fE: false});
			default:
				var profileSummaryKind = externalMsg.a;
				var subMsg = externalMsg.b;
				switch (profileSummaryKind.$) {
					case 0:
						return _Utils_update(
							claimProfileSummaries,
							{
								eF: A2($author$project$Profile$Summary$update, subMsg, claimProfileSummaries.eF)
							});
					case 1:
						return _Utils_update(
							claimProfileSummaries,
							{
								fT: A2($author$project$Profile$Summary$update, subMsg, claimProfileSummaries.fT)
							});
					case 2:
						var index = profileSummaryKind.a;
						return _Utils_update(
							claimProfileSummaries,
							{
								cw: A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									$author$project$Profile$Summary$update(subMsg),
									claimProfileSummaries.cw)
							});
					default:
						var index = profileSummaryKind.a;
						return _Utils_update(
							claimProfileSummaries,
							{
								cY: A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									$author$project$Profile$Summary$update(subMsg),
									claimProfileSummaries.cY)
							});
				}
		}
	});
var $author$project$Page$Dashboard$Analysis$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				switch (msg.b.$) {
					case 3:
						var tab = msg.a;
						var results = msg.b.a;
						var oldTabCounts = model.a$;
						var newTabCounts = function () {
							var newTabCount = A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.mO;
								},
								results);
							if (!tab) {
								return _Utils_update(
									oldTabCounts,
									{ew: newTabCount});
							} else {
								return _Utils_update(
									oldTabCounts,
									{dk: newTabCount});
							}
						}();
						var initProfileSummaries = function (claims) {
							return A2($elm$core$List$map, $author$project$Claim$initClaimProfileSummaries, claims);
						};
						if (!_Utils_eq(tab, model.aZ)) {
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{a$: newTabCounts}));
						} else {
							var _v1 = model.pN;
							if (_v1.$ === 3) {
								var claims = _v1.a.jt;
								var newClaims = model.bM ? $author$project$Claim$paginatedToList(results) : _Utils_ap(
									claims,
									$author$project$Claim$paginatedToList(results));
								return $author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											bM: false,
											pN: $krisajenkins$remotedata$RemoteData$Success(
												{
													jt: newClaims,
													o2: $author$project$Claim$paginatedPageInfo(results),
													c1: initProfileSummaries(newClaims)
												}),
											a$: newTabCounts
										}));
							} else {
								return $author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											bM: false,
											pN: $krisajenkins$remotedata$RemoteData$Success(
												{
													jt: $author$project$Claim$paginatedToList(results),
													o2: $author$project$Claim$paginatedPageInfo(results),
													c1: initProfileSummaries(
														$author$project$Claim$paginatedToList(results))
												}),
											a$: newTabCounts
										}));
							}
						}
					case 2:
						var err = msg.b.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									pN: $krisajenkins$remotedata$RemoteData$Failure(err)
								}));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 1:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{hF: $author$project$Claim$Closed}));
			case 2:
				var claimIndex = msg.a;
				var m = msg.b;
				var updatedModel = function () {
					var _v3 = _Utils_Tuple2(model.pN, m);
					if ((_v3.a.$ === 3) && (_v3.b.$ === 3)) {
						var loadedModel = _v3.a.a;
						var profileSummaries = loadedModel.c1;
						var subMsg = _v3.b.a;
						return _Utils_update(
							model,
							{
								pN: $krisajenkins$remotedata$RemoteData$Success(
									_Utils_update(
										loadedModel,
										{
											c1: A3(
												$elm_community$list_extra$List$Extra$updateAt,
												claimIndex,
												$author$project$Claim$updateProfileSummaries(subMsg),
												profileSummaries)
										}))
							});
					} else {
						return model;
					}
				}();
				return $author$project$UpdateResult$init(
					A2($author$project$Claim$updateClaimModalStatus, m, updatedModel));
			case 3:
				var claimId = msg.a;
				var vote = msg.b;
				var _v4 = _Utils_Tuple2(model.pN, loggedIn.pC);
				if ((_v4.a.$ === 3) && (_v4.b.$ === 3)) {
					var community = _v4.b.a;
					var newModel = _Utils_update(
						model,
						{
							hF: A2($author$project$Claim$Loading, claimId, vote)
						});
					return A5(
						$author$project$Session$LoggedIn$withPrivateKey,
						loggedIn,
						_List_fromArray(
							[6]),
						model,
						{hS: $author$project$Page$Dashboard$Analysis$ClosedAuthModal, iX: msg},
						A2(
							$author$project$UpdateResult$addPort,
							{
								bZ: $author$project$Eos$encodeTransaction(
									_List_fromArray(
										[
											{
											_: loggedIn.A.hL.V,
											hw: {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission},
											bZ: A4($author$project$Claim$encodeVerification, claimId, loggedIn._, vote, community.as),
											fj: 'verifyclaim'
										}
										])),
								fy: msg,
								fz: $elm$json$Json$Encode$null
							},
							$author$project$UpdateResult$init(newModel)));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 4:
				if (!msg.b.$) {
					var claimId = msg.a;
					var _v5 = model.pN;
					if (_v5.$ === 3) {
						var loadedModel = _v5.a;
						var claims = loadedModel.jt;
						var message = function (val) {
							return A2(
								loggedIn.A.aw.i4,
								'claim.reward',
								_List_fromArray(
									[
										_Utils_Tuple2('value', val)
									]));
						};
						var maybeClaim = A2(
							$elm_community$list_extra$List$Extra$find,
							function (c) {
								return _Utils_eq(c.w, claimId);
							},
							claims);
						if (!maybeClaim.$) {
							var claim = maybeClaim.a;
							var updatedClaims = A2(
								$elm$core$List$filter,
								function (c) {
									return !_Utils_eq(c.w, claim.w);
								},
								claims);
							var updateCount = F2(
								function (operator, maybeCount) {
									return A2(
										$elm$core$Maybe$map,
										function (count) {
											return A2(operator, count, 1);
										},
										maybeCount);
								});
							var symbol = claim.dh.ad.V.as;
							var value = A2(
								$author$project$Eos$assetToString,
								loggedIn.A.aw,
								{ji: claim.dh.lY, as: symbol});
							return A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									0,
									message(value)),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											hF: $author$project$Claim$Closed,
											pN: $krisajenkins$remotedata$RemoteData$Success(
												_Utils_update(
													loadedModel,
													{jt: updatedClaims})),
											a$: {
												dk: A2(updateCount, $elm$core$Basics$add, model.a$.dk),
												ew: A2(updateCount, $elm$core$Basics$sub, model.a$.ew)
											}
										})));
						} else {
							return $author$project$UpdateResult$init(model);
						}
					} else {
						return $author$project$UpdateResult$init(model);
					}
				} else {
					var eosErrorString = msg.b.a;
					var errorMessage = A2($author$project$Eos$EosError$parseClaimError, loggedIn.A.aw, eosErrorString);
					var _v7 = model.pN;
					if (_v7.$ === 3) {
						var loadedModel = _v7.a;
						var hideClaimModal = function (profileSummary) {
							return _Utils_update(
								profileSummary,
								{fE: false});
						};
						return A2(
							$author$project$UpdateResult$addExt,
							A2($author$project$Session$LoggedIn$ShowFeedback, 1, errorMessage),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										hF: $author$project$Claim$Closed,
										pN: $krisajenkins$remotedata$RemoteData$Success(
											_Utils_update(
												loadedModel,
												{
													c1: A2($elm$core$List$map, hideClaimModal, loadedModel.c1)
												}))
									})));
					} else {
						return $author$project$UpdateResult$init(model);
					}
				}
			case 5:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{c7: true}));
			case 6:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{c7: false}));
			case 7:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{eZ: newForm});
					},
					$author$project$Page$Dashboard$Analysis$GotFilterFormMsg,
					$author$project$Session$LoggedIn$addFeedback,
					model,
					A3($author$project$Form$update, loggedIn.A, subMsg, model.eZ));
			case 8:
				var filters = msg.a;
				if (_Utils_eq(filters, model.hW)) {
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{c7: false}));
				} else {
					var newModel = _Utils_update(
						model,
						{hW: filters, bM: true, c7: false, pN: $krisajenkins$remotedata$RemoteData$Loading});
					return A2(
						$author$project$UpdateResult$addExt,
						A4($author$project$Page$Dashboard$Analysis$fetchAnalysis, loggedIn, newModel, $elm$core$Maybe$Nothing, model.aZ),
						$author$project$UpdateResult$init(newModel));
				}
			case 9:
				var tab = msg.a;
				var tabToString = function (tab_) {
					if (!tab_) {
						return 'waiting to vote';
					} else {
						return 'analyzed';
					}
				};
				var newModel = _Utils_update(
					model,
					{hW: $author$project$Page$Dashboard$Analysis$initFilter, bM: true, aZ: tab, pN: $krisajenkins$remotedata$RemoteData$Loading});
				return A2(
					$author$project$UpdateResult$addBreadcrumb,
					{
						f7: msg,
						bZ: $elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'tab',
									$elm$json$Json$Encode$string(
										tabToString(tab)))
								])),
						n4: 3,
						of: 'Selected tab',
						eq: 3
					},
					A2(
						$author$project$UpdateResult$addExt,
						A4($author$project$Page$Dashboard$Analysis$fetchAnalysis, loggedIn, newModel, $elm$core$Maybe$Nothing, tab),
						$author$project$UpdateResult$init(newModel)));
			case 10:
				var _v9 = model.pN;
				if (_v9.$ === 3) {
					var pageInfo = _v9.a.o2;
					var cursor = A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.m7;
						},
						pageInfo);
					return A2(
						$author$project$UpdateResult$addBreadcrumb,
						{f7: msg, bZ: $elm$core$Dict$empty, n4: 3, of: 'Requested to show more items', eq: 4},
						A2(
							$author$project$UpdateResult$addExt,
							A4($author$project$Page$Dashboard$Analysis$fetchAnalysis, loggedIn, model, cursor, model.aZ),
							$author$project$UpdateResult$init(model)));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 12:
				var newModel = _Utils_update(
					model,
					{F: 0, hW: $author$project$Page$Dashboard$Analysis$initFilter, bM: true, pN: $krisajenkins$remotedata$RemoteData$Loading});
				return A2(
					$author$project$UpdateResult$addExt,
					A4($author$project$Page$Dashboard$Analysis$fetchAnalysis, loggedIn, newModel, $elm$core$Maybe$Nothing, model.aZ),
					$author$project$UpdateResult$init(newModel));
			default:
				var sortDirection = (!model.F) ? 1 : 0;
				var newModel = _Utils_update(
					model,
					{F: sortDirection, bM: true, pN: $krisajenkins$remotedata$RemoteData$Loading});
				return A2(
					$author$project$UpdateResult$addExt,
					A4($author$project$Page$Dashboard$Analysis$fetchAnalysis, loggedIn, newModel, $elm$core$Maybe$Nothing, model.aZ),
					$author$project$UpdateResult$init(newModel));
		}
	});
var $author$project$Page$Dashboard$Claim$ClosedAuthModal = {$: 1};
var $author$project$Page$Dashboard$Claim$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Dashboard$Claim$Loaded = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Claim$isValidated = F2(
	function (claim, user) {
		return (!_Utils_eq(claim.pN, $author$project$Claim$Pending)) || A2(
			$elm$core$List$any,
			function (c) {
				return _Utils_eq(c.aN.l8, user);
			},
			claim.aa);
	});
var $author$project$Page$Dashboard$Claim$pendingValidators = function (claim) {
	return A2(
		$elm$core$List$filter,
		function (validator) {
			return !A2(
				$elm$core$List$member,
				validator.l8,
				A2(
					$elm$core$List$map,
					function (c) {
						return c.aN.l8;
					},
					claim.aa));
		},
		claim.dh.lV);
};
var $author$project$Page$Dashboard$Claim$update = F3(
	function (msg, model, loggedIn) {
		var _v0 = loggedIn.A.aw;
		var tr = _v0.i4;
		switch (msg.$) {
			case 0:
				switch (msg.a.$) {
					case 3:
						var response = msg.a.a;
						var voterSummaries = A2(
							$author$project$Profile$Summary$initMany,
							false,
							$elm$core$List$length(response.aa));
						var pendingCount = $elm$core$List$length(
							$author$project$Page$Dashboard$Claim$pendingValidators(response));
						var pendingSummaries = A2($author$project$Profile$Summary$initMany, false, pendingCount);
						var claimerSummary = $author$project$Profile$Summary$init(true);
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									fa: A2($author$project$Claim$isValidated, response, loggedIn._),
									an: A2(
										$author$project$Page$Dashboard$Claim$Loaded,
										response,
										{gb: claimerSummary, eb: pendingSummaries, cv: voterSummaries})
								}));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when trying to load claim',
							{e$: 'update', fi: 'Page.Dashboard.Claim'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										an: $author$project$Page$Dashboard$Claim$Failed(err)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 1:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{hF: $author$project$Claim$Closed}));
			case 4:
				var m = msg.a;
				return $author$project$UpdateResult$init(
					A2($author$project$Claim$updateClaimModalStatus, m, model));
			case 2:
				var claimId = msg.a;
				var vote = msg.b;
				var _v2 = model.an;
				if (_v2.$ === 1) {
					var claim = _v2.a;
					var newModel = _Utils_update(
						model,
						{
							hF: A2($author$project$Claim$Loading, claimId, vote)
						});
					return A5(
						$author$project$Session$LoggedIn$withPrivateKey,
						loggedIn,
						_List_fromArray(
							[6]),
						model,
						{hS: $author$project$Page$Dashboard$Claim$ClosedAuthModal, iX: msg},
						A2(
							$author$project$UpdateResult$addBreadcrumb,
							{
								f7: msg,
								bZ: $elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'claimId',
											$elm$json$Json$Encode$int(claimId)),
											_Utils_Tuple2(
											'vote',
											$elm$json$Json$Encode$bool(vote))
										])),
								n4: 3,
								of: 'Requested to vote on claim',
								eq: 4
							},
							A2(
								$author$project$UpdateResult$addPort,
								{
									bZ: $author$project$Eos$encodeTransaction(
										_List_fromArray(
											[
												{
												_: loggedIn.A.hL.V,
												hw: {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission},
												bZ: A4($author$project$Claim$encodeVerification, claimId, loggedIn._, vote, claim.dh.ad.V.as),
												fj: 'verifyclaim'
											}
											])),
									fy: msg,
									fz: $elm$json$Json$Encode$null
								},
								$author$project$UpdateResult$init(newModel))));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 3:
				if (!msg.a.$) {
					var _v3 = model.an;
					if (_v3.$ === 1) {
						var claim = _v3.a;
						var value = $elm$core$String$fromFloat(claim.dh.lY) + (' ' + $author$project$Eos$symbolToSymbolCodeString(claim.dh.ad.V.as));
						var message = function (val) {
							return A2(
								tr,
								'claim.reward',
								_List_fromArray(
									[
										_Utils_Tuple2('value', val)
									]));
						};
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								0,
								message(value)),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{hF: $author$project$Claim$Closed, fa: true})));
					} else {
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{hF: $author$project$Claim$Closed}));
					}
				} else {
					var eosErrorString = msg.a.a;
					var errorMsg = A2($author$project$Eos$EosError$parseClaimError, loggedIn.A.aw, eosErrorString);
					var _v4 = model.an;
					if (_v4.$ === 1) {
						var claim = _v4.a;
						var profileSummaries = _v4.b;
						return A2(
							$author$project$UpdateResult$addExt,
							A2($author$project$Session$LoggedIn$ShowFeedback, 1, errorMsg),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										hF: $author$project$Claim$Closed,
										an: A2($author$project$Page$Dashboard$Claim$Loaded, claim, profileSummaries)
									})));
					} else {
						return $author$project$UpdateResult$init(model);
					}
				}
			default:
				var profileSummaryKind = msg.a;
				var subMsg = msg.b;
				var _v5 = model.an;
				if (_v5.$ === 1) {
					var claim = _v5.a;
					var profileSummaries = _v5.b;
					switch (profileSummaryKind.$) {
						case 1:
							var index = profileSummaryKind.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										an: A2(
											$author$project$Page$Dashboard$Claim$Loaded,
											claim,
											_Utils_update(
												profileSummaries,
												{
													eb: A3(
														$elm_community$list_extra$List$Extra$updateAt,
														index,
														$author$project$Profile$Summary$update(subMsg),
														profileSummaries.eb)
												}))
									}));
						case 2:
							var index = profileSummaryKind.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										an: A2(
											$author$project$Page$Dashboard$Claim$Loaded,
											claim,
											_Utils_update(
												profileSummaries,
												{
													cv: A3(
														$elm_community$list_extra$List$Extra$updateAt,
														index,
														$author$project$Profile$Summary$update(subMsg),
														profileSummaries.cv)
												}))
									}));
						default:
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										an: A2(
											$author$project$Page$Dashboard$Claim$Loaded,
											claim,
											_Utils_update(
												profileSummaries,
												{
													gb: A2($author$project$Profile$Summary$update, subMsg, profileSummaries.gb)
												}))
									}));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Got a Profile.Summary.Msg, but claims aren\'t loaded',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Dashboard.Claim'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
		}
	});
var $author$project$Page$Join$SignedIn = {$: 2};
var $author$project$Page$Join$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				if (!session.$) {
					var guest = session.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$author$project$Route$pushUrl,
							guest.A.kK,
							A2($author$project$Route$Register, $elm$core$Maybe$Nothing, model.kD)),
						$author$project$UpdateResult$init(model));
				} else {
					return A2(
						$author$project$UpdateResult$addExt,
						$author$project$Session$LoggedIn$RequiredAuthToken(
							{
								jo: function (_v2) {
									return $author$project$Utils$spawnMessage($author$project$Page$Join$SignedIn);
								}
							}),
						$author$project$UpdateResult$init(model));
				}
			case 1:
				var community = msg.a;
				if (!session.$) {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Completed load community, but is still guest',
						$elm$core$Maybe$Nothing,
						{e$: 'update', fi: 'Page.Join'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				} else {
					var loggedIn = session.a;
					var isMember = A2(
						$elm$core$List$member,
						loggedIn._,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.l8;
							},
							community.ih));
					var addAction = isMember ? $author$project$UpdateResult$addCmd(
						A2(
							$author$project$Route$pushUrl,
							loggedIn.A.kK,
							A2($elm$core$Maybe$withDefault, $author$project$Route$Dashboard, model.kD))) : $author$project$UpdateResult$addExt(
						$author$project$Session$LoggedIn$RequestedCommunityField(2));
					return addAction(
						$author$project$UpdateResult$init(model));
				}
			default:
				if (!session.$) {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Signed in, but is still guest',
						$elm$core$Maybe$Nothing,
						{e$: 'update', fi: 'Page.Join'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				} else {
					var loggedIn = session.a;
					var addCommunity = function () {
						var _v5 = _Utils_Tuple2(loggedIn.pC, loggedIn.pl);
						if ((_v5.a.$ === 3) && (_v5.b.$ === 3)) {
							var community = _v5.a.a;
							var profile = _v5.b.a;
							var minimalProfile = {l8: profile.l8, dl: profile.dl, dm: profile.dm, az: profile.az, jK: profile.jK, fj: profile.fj};
							var communityInfo = {nn: community.bz, by: community.by, bB: community.bB, fe: community.fe, fj: community.fj, pP: community.pP, as: community.as};
							return A2(
								$elm$core$Basics$composeR,
								$author$project$UpdateResult$addExt(
									$author$project$Session$LoggedIn$ExternalBroadcast(
										$author$project$Session$LoggedIn$CommunityLoaded(
											_Utils_update(
												community,
												{
													ih: A2($elm$core$List$cons, minimalProfile, community.ih)
												})))),
								$author$project$UpdateResult$addExt(
									$author$project$Session$LoggedIn$ExternalBroadcast(
										$author$project$Session$LoggedIn$ProfileLoaded(
											_Utils_update(
												profile,
												{
													eK: A2($elm$core$List$cons, communityInfo, profile.eK)
												})))));
						} else {
							return A5(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed sign in, but community or profile weren\'t loaded',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Join'},
								_List_Nil);
						}
					}();
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$author$project$Route$replaceUrl,
							loggedIn.A.kK,
							A2($elm$core$Maybe$withDefault, $author$project$Route$Dashboard, model.kD)),
						addCommunity(
							$author$project$UpdateResult$init(model)));
				}
		}
	});
var $author$project$Session$Shared$Bip39Loaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Login$EnteringPin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Session$Guest$UpdatedShared = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$WentToPin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Login$GotPinComponentMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Login$InputtingPin = {$: 0};
var $author$project$Page$Login$initPinModel = F2(
	function (pinVisibility, passphrase) {
		var _v0 = $author$project$View$Pin$init(
			{w: 'pinInput', n$: 'auth.pin.label', n2: $elm$core$Maybe$Nothing, o9: pinVisibility, pQ: 'auth.login.submit', pS: 'auth.login.submitting', ql: true});
		var pinModel = _v0.a;
		var pinCmd = _v0.b;
		return _Utils_Tuple2(
			{bp: passphrase, ak: pinModel, pN: $author$project$Page$Login$InputtingPin},
			A2($elm$core$Platform$Cmd$map, $author$project$Page$Login$GotPinComponentMsg, pinCmd));
	});
var $author$project$UpdateResult$setModel = F2(
	function (uResult, model) {
		return {af: uResult.af, ju: uResult.ju, jQ: uResult.jQ, jS: uResult.jS, ok: model, k0: uResult.k0};
	});
var $author$project$Page$Login$ClickedPaste = {$: 1};
var $author$project$Page$Login$FinishedEnteringPassphrase = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Login$GotPassphraseFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Login$PassphraseGuestExternal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Login$PassphraseIgnored = {$: 0};
var $author$project$Session$Guest$SetFeedback = function (a) {
	return {$: 1, a: a};
};
var $author$project$Log$UnsupportedFeature = 7;
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$Page$Login$updateWithPassphrase = F3(
	function (msg, model, _v0) {
		var shared = _v0.A;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Page$Login$PassphraseGuestExternal(
						$author$project$Session$Guest$SetFeedback($author$project$View$Feedback$Hidden)),
					A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$elm$core$Task$attempt,
							function (_v2) {
								return $author$project$Page$Login$PassphraseIgnored;
							},
							$elm$browser$Browser$Dom$focus('passphrase-input')),
						A2(
							$author$project$UpdateResult$addPort,
							{
								bZ: $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'name',
											$elm$json$Json$Encode$string('readClipboard'))
										])),
								fy: $author$project$Page$Login$ClickedPaste,
								fz: $elm$json$Json$Encode$null
							},
							$author$project$UpdateResult$init(model))));
			case 2:
				switch (msg.a.$) {
					case 0:
						var _v3 = msg.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$PassphraseGuestExternal(
								$author$project$Session$Guest$SetFeedback(
									A2(
										$author$project$View$Feedback$Visible,
										1,
										shared.aw.fL('error.clipboard.permissionDenied')))),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{bA: false})));
					case 1:
						var _v4 = msg.a;
						return A2(
							$author$project$UpdateResult$logEvent,
							{
								mL: _List_Nil,
								n4: 2,
								oa: {e$: 'updateWithPassphrase', fi: 'Page.Login'},
								of: 'Clipboard API not supported',
								pY: _List_fromArray(
									[
										$author$project$Log$TypeTag(7)
									]),
								p7: msg,
								qh: $elm$core$Maybe$Nothing
							},
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Page$Login$PassphraseGuestExternal(
									$author$project$Session$Guest$SetFeedback(
										A2(
											$author$project$View$Feedback$Visible,
											1,
											shared.aw.fL('error.clipboard.paste.notSupported')))),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{bA: false}))));
					case 3:
						var _v5 = msg.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$PassphraseGuestExternal(
								$author$project$Session$Guest$SetFeedback(
									A2(
										$author$project$View$Feedback$Visible,
										1,
										shared.aw.fL('error.unknown')))),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{bA: false})));
					default:
						var content = msg.a.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$PassphraseGuestExternal(
								$author$project$Session$Guest$SetFeedback($author$project$View$Feedback$Hidden)),
							A2(
								$author$project$UpdateResult$addCmd,
								A2(
									$elm$core$Task$attempt,
									function (_v6) {
										return $author$project$Page$Login$PassphraseIgnored;
									},
									$elm$browser$Browser$Dom$focus('passphrase-input')),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											hY: A2(
												$author$project$Form$updateValues,
												function (oldForm) {
													return _Utils_update(
														oldForm,
														{bp: content});
												},
												model.hY),
											bA: true
										}))));
				}
			case 3:
				var scrollTop = msg.a.lp;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v7) {
							return $author$project$Page$Login$PassphraseIgnored;
						},
						A3($elm$browser$Browser$Dom$setViewportOf, 'highlights', 0, scrollTop)),
					$author$project$UpdateResult$init(model));
			case 4:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{hY: newForm});
					},
					$author$project$Page$Login$GotPassphraseFormMsg,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Session$Guest$SetFeedback,
						A2($elm$core$Basics$composeR, $author$project$Page$Login$PassphraseGuestExternal, $author$project$UpdateResult$addExt)),
					model,
					A3($author$project$Form$update, shared, subMsg, model.hY));
			default:
				var passphrase = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Page$Login$FinishedEnteringPassphrase(passphrase),
					$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Login$GeneratedAuthPhrase = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Login$GettingAccountName = {$: 1};
var $author$project$Page$Login$GotSignInResult = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Session$Guest$LoggedIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Login$LoggingIn = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$PinGuestExternal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Login$RevertProcess = {$: 1};
var $author$project$Page$Login$SubmittedPinWithSuccess = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Login$updateWithPin = F3(
	function (msg, model, guest) {
		var shared = guest.A;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var pin = msg.a;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('getAccountFrom12Words')),
									_Utils_Tuple2(
									'passphrase',
									$elm$json$Json$Encode$string(model.bp))
								])),
						fy: $author$project$Page$Login$SubmittedPinWithSuccess(pin),
						fz: $elm$json$Json$Encode$string(pin)
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{pN: $author$project$Page$Login$GettingAccountName})));
			case 2:
				if (!msg.a.$) {
					var userData = msg.a.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						A3($author$project$Api$Graphql$askForPhrase, shared, userData._, $author$project$Page$Login$GeneratedAuthPhrase),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									pN: $author$project$Page$Login$LoggingIn(userData)
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$UpdateResult$addExt,
						$author$project$Page$Login$RevertProcess,
						A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$PinGuestExternal(
								$author$project$Session$Guest$SetFeedback(
									A2(
										$author$project$View$Feedback$Visible,
										1,
										shared.aw.fL(err)))),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{pN: $author$project$Page$Login$InputtingPin}))));
				}
			case 3:
				switch (msg.a.$) {
					case 3:
						var phrase = msg.a.a;
						var _v1 = model.pN;
						if (_v1.$ === 2) {
							var privateKey = _v1.a.pg;
							return A2(
								$author$project$UpdateResult$addPort,
								A3($author$project$Api$Graphql$signPhrasePort, msg, privateKey, phrase),
								$author$project$UpdateResult$init(model));
						} else {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Generated auth phrase, but wasn\'t logging in',
								$elm$core$Maybe$Nothing,
								{e$: 'updateWithPin', fi: 'Page.Login'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var err = msg.a.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$RevertProcess,
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Nothing,
								'Got an error when generating auth phrase for login',
								{e$: 'updateWithPin', fi: 'Page.Login'},
								_List_Nil,
								err,
								A2(
									$author$project$UpdateResult$addExt,
									$author$project$Page$Login$PinGuestExternal(
										$author$project$Session$Guest$SetFeedback(
											A2(
												$author$project$View$Feedback$Visible,
												1,
												shared.aw.fL('auth.failed_generating_phrase')))),
									$author$project$UpdateResult$init(model))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 4:
				var signedPhrase = msg.a;
				var _v2 = model.pN;
				if (_v2.$ === 2) {
					var userData = _v2.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						A3(
							$author$project$Api$Graphql$signIn,
							shared,
							{l8: userData._, kk: guest.kC, kX: signedPhrase},
							A2($author$project$Page$Login$GotSignInResult, userData.pg, userData.o8)),
						$author$project$UpdateResult$init(model));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Signed auth phrase, but wasn\'t logging in',
						$elm$core$Maybe$Nothing,
						{e$: 'updateWithPin', fi: 'Page.Login'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 5:
				switch (msg.c.$) {
					case 3:
						var privateKey = msg.a;
						var pin = msg.b;
						var signInResponse = msg.c.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$PinGuestExternal(
								$author$project$Session$Guest$LoggedIn(
									{o8: pin, pg: privateKey, pK: signInResponse})),
							A2(
								$author$project$UpdateResult$addPort,
								{
									bZ: $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string('login')),
												_Utils_Tuple2(
												'privateKey',
												$author$project$Eos$Account$encodePrivateKey(privateKey)),
												_Utils_Tuple2(
												'passphrase',
												$elm$json$Json$Encode$string(model.bp)),
												_Utils_Tuple2(
												'accountName',
												$author$project$Eos$Account$encodeName(signInResponse.pl.l8)),
												_Utils_Tuple2(
												'pin',
												$elm$json$Json$Encode$string(pin))
											])),
									fy: $author$project$Page$Login$PinIgnored,
									fz: $elm$json$Json$Encode$null
								},
								A2(
									$author$project$UpdateResult$addCmd,
									$author$project$Api$Graphql$storeToken(signInResponse.p5),
									$author$project$UpdateResult$init(model))));
					case 2:
						var err = msg.c.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$RevertProcess,
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Page$Login$PinGuestExternal(
									$author$project$Session$Guest$SetFeedback(
										A2(
											$author$project$View$Feedback$Visible,
											1,
											shared.aw.fL('auth.failed')))),
								A2(
									$author$project$UpdateResult$addPort,
									{
										bZ: $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string('logout'))
												])),
										fy: $author$project$Page$Login$PinIgnored,
										fz: $elm$json$Json$Encode$null
									},
									A7(
										$author$project$UpdateResult$logGraphqlError,
										msg,
										$elm$core$Maybe$Nothing,
										'Got an error when trying to login',
										{e$: 'updateWithPin', fi: 'Page.Login'},
										_List_Nil,
										err,
										$author$project$UpdateResult$init(model)))));
					case 0:
						var _v3 = msg.c;
						return $author$project$UpdateResult$init(model);
					default:
						var _v4 = msg.c;
						return $author$project$UpdateResult$init(model);
				}
			default:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (pinModel) {
						return _Utils_update(
							model,
							{ak: pinModel});
					},
					$author$project$Page$Login$GotPinComponentMsg,
					F2(
						function (ext, ur) {
							if (ext.$ === 1) {
								var feedback = ext.a;
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Page$Login$PinGuestExternal(
										$author$project$Session$Guest$SetFeedback(feedback)),
									ur);
							} else {
								var pin = ext.a;
								var _v6 = A4($author$project$View$Pin$postSubmitAction, ur.ok.ak, pin, shared, $author$project$Page$Login$SubmittedPinWithSuccess);
								var newShared = _v6.a;
								var submitCmd = _v6.b;
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Page$Login$PinGuestExternal(
										$author$project$Session$Guest$UpdatedShared(newShared)),
									A2($author$project$UpdateResult$addCmd, submitCmd, ur));
							}
						}),
					model,
					A3($author$project$View$Pin$update, shared, subMsg, model.ak));
		}
	});
var $author$project$Page$Login$update = F3(
	function (msg, model, guest) {
		var _v0 = _Utils_Tuple2(msg, model);
		switch (_v0.a.$) {
			case 3:
				var bip39 = _v0.a.a;
				var oldShared = guest.A;
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$Guest$UpdatedShared(
						_Utils_update(
							oldShared,
							{
								f4: $author$project$Session$Shared$Bip39Loaded(bip39)
							})),
					$author$project$UpdateResult$init(model));
			case 1:
				if (!_v0.b.$) {
					var passphraseMsg = _v0.a.a;
					var passphraseModel = _v0.b.a;
					return A4(
						$author$project$UpdateResult$map,
						$author$project$Page$Login$EnteringPassphrase,
						$author$project$Page$Login$GotPassphraseMsg,
						F2(
							function (ext, ur) {
								if (!ext.$) {
									var validPassphrase = ext.a;
									return A2(
										$author$project$UpdateResult$addMsg,
										$author$project$Page$Login$WentToPin(validPassphrase),
										ur);
								} else {
									var guestExternal = ext.a;
									return A2($author$project$UpdateResult$addExt, guestExternal, ur);
								}
							}),
						A3($author$project$Page$Login$updateWithPassphrase, passphraseMsg, passphraseModel, guest));
				} else {
					return A5(
						$author$project$UpdateResult$logIncompatibleMsg,
						msg,
						$elm$core$Maybe$Nothing,
						{e$: 'update', fi: 'Page.Login'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 0:
				if (!_v0.b.$) {
					var passphrase = _v0.a.a;
					var _v2 = A2($author$project$Page$Login$initPinModel, guest.A.o9, passphrase);
					var pinModel = _v2.a;
					var pinCmd = _v2.b;
					return A2(
						$author$project$UpdateResult$addCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Page$Login$GotPinMsg, pinCmd),
						$author$project$UpdateResult$init(
							$author$project$Page$Login$EnteringPin(pinModel)));
				} else {
					return A5(
						$author$project$UpdateResult$logIncompatibleMsg,
						msg,
						$elm$core$Maybe$Nothing,
						{e$: 'update', fi: 'Page.Login'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			default:
				if (_v0.b.$ === 1) {
					var pinMsg = _v0.a.a;
					var pinModel = _v0.b.a;
					return A4(
						$author$project$UpdateResult$map,
						$author$project$Page$Login$EnteringPin,
						$author$project$Page$Login$GotPinMsg,
						F2(
							function (ext, ur) {
								if (!ext.$) {
									var guestExternal = ext.a;
									return A2($author$project$UpdateResult$addExt, guestExternal, ur);
								} else {
									return A2(
										$author$project$UpdateResult$setModel,
										ur,
										$author$project$Page$Login$EnteringPassphrase($author$project$Page$Login$initPassphraseModel));
								}
							}),
						A3($author$project$Page$Login$updateWithPin, pinMsg, pinModel, guest));
				} else {
					return A5(
						$author$project$UpdateResult$logIncompatibleMsg,
						msg,
						$elm$core$Maybe$Nothing,
						{e$: 'update', fi: 'Page.Login'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
		}
	});
var $author$project$Page$News$CompletedMarkingNewsAsRead = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$News$CompletedTogglingReaction = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Cambiatus$Enum$ReactionEnum$toString = function (_enum) {
	switch (_enum) {
		case 0:
			return 'CLAPPING_HANDS';
		case 1:
			return 'FACE_WITH_RAISED_EYEBROW';
		case 2:
			return 'GRINNING_FACE_WITH_BIG_EYES';
		case 3:
			return 'PARTY_POPPER';
		case 4:
			return 'RED_HEART';
		case 5:
			return 'ROCKET';
		case 6:
			return 'SLIGHTLY_FROWNING_FACE';
		case 7:
			return 'SMILING_FACE_WITH_HEART_EYES';
		case 8:
			return 'THUMBS_DOWN';
		default:
			return 'THUMBS_UP';
	}
};
var $author$project$Cambiatus$Mutation$reactToNews = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'reactToNews',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'newsId', requiredArgs.bG, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'reactions',
					requiredArgs.la,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$ReactionEnum$toString)))
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Community$News$reactToNews = F2(
	function (news, args) {
		return A2(
			$author$project$Cambiatus$Mutation$reactToNews,
			{
				bG: args.bG,
				la: function () {
					var _v0 = news.iK;
					if (_v0.$ === 1) {
						return _List_fromArray(
							[args.fw]);
					} else {
						var receipt = _v0.a;
						return A2($elm$core$List$member, args.fw, receipt.la) ? A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(args.fw),
							receipt.la) : A2($elm$core$List$cons, args.fw, receipt.la);
					}
				}()
			},
			$author$project$Community$News$receiptSelectionSet);
	});
var $author$project$Cambiatus$Mutation$read = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'read',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'newsId', requiredArgs.bG, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Page$News$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var news = msg.a;
				var markNewsAsRead = function () {
					var _v1 = A2(
						$elm$core$Maybe$andThen,
						function (newsId) {
							return A2(
								$elm_community$list_extra$List$Extra$find,
								function (_v2) {
									var id = _v2.w;
									return _Utils_eq(id, newsId);
								},
								news);
						},
						model.bG);
					if (_v1.$ === 1) {
						return $elm$core$Basics$identity;
					} else {
						var selectedNews = _v1.a;
						var _v3 = selectedNews.iK;
						if (!_v3.$) {
							return $elm$core$Basics$identity;
						} else {
							return $author$project$UpdateResult$addExt(
								A3(
									$author$project$Session$LoggedIn$mutation,
									loggedIn,
									A2(
										$author$project$Cambiatus$Mutation$read,
										{bG: selectedNews.w},
										$author$project$Community$News$receiptSelectionSet),
									$author$project$Page$News$CompletedMarkingNewsAsRead));
						}
					}
				}();
				return markNewsAsRead(
					$author$project$UpdateResult$init(model));
			case 2:
				switch (msg.a.$) {
					case 3:
						var maybeReceipt = msg.a.a;
						return A2(
							$author$project$UpdateResult$addBreadcrumb,
							{
								f7: msg,
								bZ: function () {
									var _v4 = model.bG;
									if (_v4.$ === 1) {
										return $elm$core$Dict$empty;
									} else {
										var newsId = _v4.a;
										return $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'News id',
													$elm$json$Json$Encode$int(newsId))
												]));
									}
								}(),
								n4: 3,
								of: 'Completed marking news as read',
								eq: 3
							},
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$UpdatedLoggedIn(
									_Utils_update(
										loggedIn,
										{
											kB: A2(
												$elm$core$Maybe$map,
												function (highlightedNews) {
													return _Utils_update(
														highlightedNews,
														{iK: maybeReceipt});
												},
												loggedIn.kB)
										})),
								$author$project$UpdateResult$init(model)));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when marking news as read',
							{e$: 'update', fi: 'Page.News'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(model));
					case 0:
						var _v5 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v6 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 3:
				return A2(
					$author$project$UpdateResult$addCmd,
					model.cq ? A2(
						$elm$core$Task$attempt,
						function (_v7) {
							return $author$project$Page$News$NoOp;
						},
						$elm$browser$Browser$Dom$focus('reaction-picker')) : A2(
						$elm$core$Task$attempt,
						function (_v8) {
							return $author$project$Page$News$NoOp;
						},
						$elm$browser$Browser$Dom$focus('reaction-0')),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{cq: !model.cq})));
			case 4:
				var reaction = msg.a;
				var maybeSelectedNews = A2(
					$elm$core$Maybe$andThen,
					function (news) {
						return A2(
							$elm$core$Maybe$andThen,
							function (currentId) {
								return A2(
									$elm_community$list_extra$List$Extra$find,
									function (_v10) {
										var id = _v10.w;
										return _Utils_eq(id, currentId);
									},
									news);
							},
							model.bG);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$krisajenkins$remotedata$RemoteData$toMaybe(
							A2(
								$author$project$Community$getField,
								loggedIn.pC,
								function ($) {
									return $.fl;
								}))));
				if (!maybeSelectedNews.$) {
					var selectedNews = maybeSelectedNews.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$mutation,
							loggedIn,
							A2(
								$author$project$Community$News$reactToNews,
								selectedNews,
								{bG: selectedNews.w, fw: reaction}),
							A2($author$project$Page$News$CompletedTogglingReaction, reaction, selectedNews)),
						$author$project$UpdateResult$init(model));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 5:
				switch (msg.c.$) {
					case 3:
						var reaction = msg.a;
						var selectedNews = msg.b;
						var receipt = msg.c.a;
						var _v11 = A2(
							$author$project$Community$getField,
							loggedIn.pC,
							function ($) {
								return $.fl;
							});
						if (_v11.$ === 3) {
							var _v12 = _v11.a;
							var news = _v12.b;
							var reactionAlreadyExists = A2(
								$elm$core$List$any,
								function (reactionWithCount) {
									return _Utils_eq(reactionWithCount.fw, reaction);
								},
								selectedNews.la);
							var hasAdded = A2(
								$elm$core$List$member,
								reaction,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.la;
										},
										receipt)));
							var newReactions = reactionAlreadyExists ? A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (reactionWithCount) {
									return _Utils_eq(reactionWithCount.fw, reaction);
								},
								function (prevReaction) {
									return {
										mO: hasAdded ? (prevReaction.mO + 1) : (prevReaction.mO - 1),
										fw: reaction
									};
								},
								selectedNews.la) : A2(
								$elm$core$List$cons,
								{mO: 1, fw: reaction},
								selectedNews.la);
							var newNews = A3(
								$elm_community$list_extra$List$Extra$updateIf,
								$elm$core$Basics$eq(selectedNews),
								function (_v13) {
									return _Utils_update(
										selectedNews,
										{la: newReactions, iK: receipt});
								},
								news);
							return A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$SetCommunityField(
									$author$project$Community$NewsValue(newNews)),
								$author$project$UpdateResult$init(model));
						} else {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed toggling reaction, but community wasn\'t loaded',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.News'},
								_List_fromArray(
									[
										$author$project$Log$contextFromCommunity(loggedIn.pC)
									]),
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var err = msg.c.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when reacting to news',
							{e$: 'update', fi: 'Page.News'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(model));
					case 1:
						var _v14 = msg.c;
						return $author$project$UpdateResult$init(model);
					default:
						var _v15 = msg.c;
						return $author$project$UpdateResult$init(model);
				}
			default:
				var subMsg = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							fd: A2($author$project$Profile$Summary$update, subMsg, model.fd)
						}));
		}
	});
var $author$project$Page$Notification$CompletedReading = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Notification$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Cambiatus$InputObject$encodeReadNotificationInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input.w)))
			]));
};
var $author$project$Cambiatus$Mutation$readNotification = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'readNotification',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs.nG, $author$project$Cambiatus$InputObject$encodeReadNotificationInput)
				]),
			object_,
			$elm$core$Basics$identity);
	});
var $author$project$Notification$markAsReadMutation = function (id) {
	return A2(
		$author$project$Cambiatus$Mutation$readNotification,
		{
			nG: {w: id}
		},
		$author$project$Notification$notificationHistorySelectionSet);
};
var $author$project$Page$Notification$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				switch (msg.a.$) {
					case 3:
						var notifications = msg.a.a;
						return $author$project$UpdateResult$init(
							$author$project$Page$Notification$Loaded(notifications));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when trying to load notification history',
							{e$: 'update', fi: 'Page.Notification'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.pC)
								]),
							err,
							$author$project$UpdateResult$init(model));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 1:
				var notificationId = msg.a;
				var data = msg.b;
				var redirectCmd = function (newCommunity) {
					var _v2 = loggedIn.pC;
					if (_v2.$ === 3) {
						var community = _v2.a;
						return _Utils_eq(community.as, newCommunity.as) ? $author$project$Route$replaceUrl(loggedIn.A.kK) : A2($author$project$Route$loadExternalCommunity, loggedIn.A, newCommunity);
					} else {
						return function (_v3) {
							return $elm$core$Platform$Cmd$none;
						};
					}
				};
				var markAsRead = A3(
					$author$project$Session$LoggedIn$mutation,
					loggedIn,
					$author$project$Notification$markAsReadMutation(notificationId),
					$author$project$Page$Notification$CompletedReading);
				switch (data.$) {
					case 0:
						var transfer = data.a;
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								redirectCmd,
								transfer.V,
								$author$project$Route$ViewTransfer(transfer.w)),
							A2(
								$author$project$UpdateResult$addExt,
								markAsRead,
								$author$project$UpdateResult$init(model)));
					case 2:
						return A2(
							$author$project$UpdateResult$addExt,
							markAsRead,
							$author$project$UpdateResult$init(model));
					default:
						var sale = data.a;
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								redirectCmd,
								sale.pi.V,
								$author$project$Route$ViewSale(sale.pi.w)),
							A2(
								$author$project$UpdateResult$addExt,
								markAsRead,
								$author$project$UpdateResult$init(model)));
				}
			default:
				switch (msg.a.$) {
					case 3:
						var hist = msg.a.a;
						if (model.$ === 1) {
							var histories = model.a;
							var updatedHistories = A2(
								$elm$core$List$map,
								function (h) {
									return _Utils_eq(h.w, hist.w) ? _Utils_update(
										h,
										{nT: true}) : h;
								},
								histories);
							return $author$project$UpdateResult$init(
								$author$project$Page$Notification$Loaded(updatedHistories));
						} else {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed reading notification, but notifications weren\'t loaded',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Notification'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var e = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when reading notification',
							{e$: 'update', fi: 'Page.Notification'},
							_List_Nil,
							e,
							$author$project$UpdateResult$init(model));
					default:
						return $author$project$UpdateResult$init(model);
				}
		}
	});
var $author$project$Page$PaymentHistory$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$PaymentHistory$GotDatePickerMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$PaymentHistory$GotUserPickerMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$PaymentHistory$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PaymentHistory$NoOp = {$: 0};
var $author$project$Form$DatePicker$Options = $elm$core$Basics$identity;
var $author$project$Form$DatePicker$init = function (_v0) {
	var label = _v0.n$;
	var id = _v0.w;
	return {ex: true, mF: _List_Nil, b_: false, w: id, n$: label};
};
var $author$project$Form$DatePicker$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mF: _Utils_ap(options.mF, attrs)
			});
	});
var $author$project$Page$PaymentHistory$datePickerOptions = function (_v0) {
	var translators = _v0.aw;
	return A2(
		$author$project$Form$DatePicker$withContainerAttrs,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('my-4')
			]),
		$author$project$Form$DatePicker$init(
			{
				w: 'date-picker',
				n$: translators.fL('payment_history.date')
			}));
};
var $author$project$Page$PaymentHistory$datePickerViewConfig = F2(
	function (_v0, model) {
		var translators = _v0.aw;
		return {
			na: $elm$html$Html$text(''),
			no: false,
			nV: false,
			aw: translators,
			lW: model.eS
		};
	});
var $author$project$Page$PaymentHistory$RecipientProfileWithTransfersLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$PaymentHistory$ProfileWithTransfers = F7(
	function (name, account, avatar, email, bio, contacts, transfers) {
		return {l8: account, dl: avatar, dm: bio, az: contacts, jK: email, fj: name, av: transfers};
	});
var $author$project$Cambiatus$Enum$TransferDirectionValue$Receiving = 0;
var $author$project$Page$PaymentHistory$profileWithTransfersSelectionSet = F2(
	function (community, model) {
		var optionalFromAccount = function () {
			var _v2 = model.f2;
			if (!_v2.$) {
				var p = _v2.a;
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Eos$Account$nameToString(p.l8));
			} else {
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
			}
		}();
		var optionalDate = function () {
			var _v1 = model.ck;
			if (!_v1.$) {
				var d = _v1.a;
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$justinmimbs$date$Date$toIsoString(d));
			} else {
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
			}
		}();
		var endCursor = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.m7;
			},
			model.cP);
		var afterOption = function () {
			if (!endCursor.$) {
				var ec = endCursor.a;
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(ec);
			} else {
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
			}
		}();
		var optionalArgsFn = function (r) {
			return _Utils_update(
				r,
				{
					hu: afterOption,
					hV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						{
							gd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
								$author$project$Eos$symbolToString(community.as)),
							dw: optionalDate,
							F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
								{
									F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(0),
									d9: optionalFromAccount
								})
						}),
					hX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(16)
				});
		};
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($author$project$Cambiatus$Object$User$transfers, optionalArgsFn, $author$project$Transfer$transferConnectionSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Profile$userContactSelectionSet,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$User$bio),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$User$email,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Avatar$selectionSet($author$project$Cambiatus$Object$User$avatar),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$User$account),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Cambiatus$Object$User$name,
									$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$PaymentHistory$ProfileWithTransfers))))))));
	});
var $author$project$Page$PaymentHistory$fetchProfileWithTransfers = F3(
	function (loggedIn, community, model) {
		var accountName = $author$project$Eos$Account$nameToString(model.ps.l8);
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Cambiatus$Query$user,
				{l8: accountName},
				A2($author$project$Page$PaymentHistory$profileWithTransfersSelectionSet, community, model)),
			$author$project$Page$PaymentHistory$RecipientProfileWithTransfersLoaded);
	});
var $author$project$Page$PaymentHistory$AutocompleteProfilesLoaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$PaymentHistory$ProfileWithOnlyAutocomplete = function (getPayersByAccount) {
	return {j_: getPayersByAccount};
};
var $author$project$Cambiatus$Object$User$getPayersByAccount = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'getPayersByAccount',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'account', requiredArgs.l8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object_,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$identity,
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$nullable,
					A2($elm$core$Basics$composeR, $elm$json$Json$Decode$list, $elm$json$Json$Decode$nullable))));
	});
var $author$project$Page$PaymentHistory$fetchProfilesForAutocomplete = F3(
	function (loggedIn, model, payerAccount) {
		var autocompleteSelectionSet = A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Profile$userContactSelectionSet,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$User$bio),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$User$email,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Avatar$selectionSet($author$project$Cambiatus$Object$User$avatar),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$User$account),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$User$name,
								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Minimal)))))));
		var selectionSet = A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$author$project$Page$PaymentHistory$ProfileWithOnlyAutocomplete,
			A2(
				$author$project$Cambiatus$Object$User$getPayersByAccount,
				{l8: payerAccount},
				autocompleteSelectionSet));
		var accountName = $author$project$Eos$Account$nameToString(model.ps.l8);
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Cambiatus$Query$user,
				{l8: accountName},
				selectionSet),
			$author$project$Page$PaymentHistory$AutocompleteProfilesLoaded);
	});
var $author$project$Form$UserPicker$fromSinglePicker = function (_v0) {
	var model = _v0;
	return {
		w: model.w,
		G: model.G,
		H: $author$project$Form$UserPicker$Single(model.H)
	};
};
var $author$project$View$Select$queryFromState = function (model) {
	return $author$project$View$Select$unwrapModel(model).ed;
};
var $author$project$Form$UserPicker$getCurrentQuery = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$View$Select$queryFromState(model.G));
};
var $author$project$Form$DatePicker$getDate = function (_v0) {
	var model = _v0;
	return model.ck;
};
var $author$project$Form$UserPicker$getSingleProfile = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.pl;
		},
		model.H);
};
var $author$project$Page$PaymentHistory$getTransfers = function (maybeObj) {
	var toNodes = function (maybeNodes) {
		return A2($elm$core$List$filterMap, $elm$core$Basics$identity, maybeNodes);
	};
	var toMaybeNodes = function (edges) {
		return A2(
			$elm$core$List$map,
			function (a) {
				return A2(
					$elm$core$Maybe$andThen,
					function (b) {
						return b.os;
					},
					a);
			},
			edges);
	};
	var toMaybeEdges = function (maybeConn) {
		return A2(
			$elm$core$Maybe$andThen,
			function (a) {
				return a.m5;
			},
			maybeConn);
	};
	var toEdges = function (maybeEdges) {
		return A2($elm$core$Maybe$withDefault, _List_Nil, maybeEdges);
	};
	return toNodes(
		toMaybeNodes(
			toEdges(
				toMaybeEdges(maybeObj))));
};
var $author$project$Form$UserPicker$toSinglePicker = function (_v0) {
	var model = _v0;
	var _v1 = model.H;
	if (!_v1.$) {
		var maybeProfile = _v1.a;
		return {w: model.w, G: model.G, H: maybeProfile};
	} else {
		var selectedProfiles = _v1.a;
		return {
			w: model.w,
			G: model.G,
			H: $elm$core$List$head(selectedProfiles)
		};
	}
};
var $author$project$Form$UserPicker$Options = $elm$core$Basics$identity;
var $author$project$Form$UserPicker$init = function (_v0) {
	var label = _v0.n$;
	var currentUser = _v0.eR;
	var profiles = _v0.fs;
	return {
		eA: true,
		mF: _List_Nil,
		eR: currentUser,
		b_: false,
		n$: label,
		d$: '',
		fr: {ee: $elm$core$Maybe$Nothing, g9: $elm$core$Maybe$Nothing},
		fs: profiles
	};
};
var $author$project$Form$UserPicker$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mF: _Utils_ap(options.mF, attrs)
			});
	});
var $author$project$Page$PaymentHistory$userPickerOptions = F2(
	function (loggedIn, profiles) {
		return A2(
			$author$project$Form$UserPicker$withContainerAttrs,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('my-4')
				]),
			$author$project$Form$UserPicker$init(
				{
					eR: loggedIn._,
					n$: loggedIn.A.aw.fL('payment_history.user'),
					fs: profiles
				}));
	});
var $author$project$Page$PaymentHistory$userPickerViewConfig = F2(
	function (_v0, model) {
		var translators = _v0.aw;
		return {
			na: $elm$html$Html$text(''),
			no: false,
			oF: $author$project$Page$PaymentHistory$NoOp,
			aw: translators,
			lW: $author$project$Form$UserPicker$fromSinglePicker(model.dd)
		};
	});
var $author$project$Page$PaymentHistory$update = F3(
	function (msg, model, loggedIn) {
		var shared = loggedIn.A;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var community = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					A3($author$project$Page$PaymentHistory$fetchProfileWithTransfers, loggedIn, community, model),
					$author$project$UpdateResult$init(model));
			case 3:
				switch (msg.a.$) {
					case 3:
						var maybeProfileWithPayers = msg.a.a;
						if (!maybeProfileWithPayers.$) {
							var profileWithPayers = maybeProfileWithPayers.a;
							var toList = function (p) {
								if (!p.$) {
									var val = p.a;
									return _List_fromArray(
										[val]);
								} else {
									return _List_Nil;
								}
							};
							var payers = A2($elm$core$Maybe$withDefault, _List_Nil, profileWithPayers.j_);
							var profiles = A2($elm$core$List$concatMap, toList, payers);
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{eD: profiles}));
						} else {
							return $author$project$UpdateResult$init(model);
						}
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when loading profiles for auto complete',
							{e$: 'update', fi: 'Page.PaymentHistory'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.pC)
								]),
							err,
							$author$project$UpdateResult$init(model));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 2:
				switch (msg.a.$) {
					case 3:
						var maybeProfile = msg.a.a;
						if (!maybeProfile.$) {
							var profile = maybeProfile.a;
							var recipientProfile = {l8: profile.l8, dl: profile.dl, dm: profile.dm, az: profile.az, jK: profile.jK, fj: profile.fj};
							var pageInfo = A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.o2;
								},
								profile.av);
							var newIncomingTransfers = function () {
								var _v4 = model.cO;
								if (!_v4.$) {
									var transfers = _v4.a;
									return _Utils_ap(
										transfers,
										$author$project$Page$PaymentHistory$getTransfers(profile.av));
								} else {
									return $author$project$Page$PaymentHistory$getTransfers(profile.av);
								}
							}();
							var newModel = _Utils_update(
								model,
								{
									cO: $elm$core$Maybe$Just(newIncomingTransfers),
									cP: pageInfo,
									fv: $author$project$Page$PaymentHistory$Loaded(profile),
									ps: recipientProfile
								});
							return $author$project$UpdateResult$init(newModel);
						} else {
							return $author$project$UpdateResult$init(model);
						}
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when loading recipient profile with transfers',
							{e$: 'update', fi: 'Page.PaymentHistory'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										fv: $author$project$Page$PaymentHistory$Failed(err)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 6:
				var _v5 = loggedIn.pC;
				if (_v5.$ === 3) {
					var community = _v5.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A3($author$project$Page$PaymentHistory$fetchProfileWithTransfers, loggedIn, community, model),
						$author$project$UpdateResult$init(model));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Clicked show more, but community wasn\'t loaded',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.PaymentHistory'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 4:
				var subMsg = msg.a;
				var _v6 = function (_v7) {
					var userPicker = _v7.a;
					var cmd = _v7.b;
					var maybeMsg_ = _v7.c;
					return _Utils_Tuple3(
						$author$project$Form$UserPicker$toSinglePicker(userPicker),
						cmd,
						maybeMsg_);
				}(
					A4(
						$author$project$Form$UserPicker$update,
						A2($author$project$Page$PaymentHistory$userPickerOptions, loggedIn, model.eD),
						A2($author$project$Page$PaymentHistory$userPickerViewConfig, loggedIn.A, model),
						subMsg,
						$author$project$Form$UserPicker$fromSinglePicker(model.dd)));
				var newUserPicker = _v6.a;
				var userPickerCmd = _v6.b;
				var maybeMsg = _v6.c;
				var fetchProfileInfo = _Utils_eq(
					$author$project$Form$UserPicker$getCurrentQuery(
						$author$project$Form$UserPicker$fromSinglePicker(newUserPicker)),
					$author$project$Form$UserPicker$getCurrentQuery(
						$author$project$Form$UserPicker$fromSinglePicker(model.dd))) ? $elm$core$Basics$identity : $author$project$UpdateResult$addExt(
					A3(
						$author$project$Page$PaymentHistory$fetchProfilesForAutocomplete,
						loggedIn,
						model,
						$author$project$Form$UserPicker$getCurrentQuery(
							$author$project$Form$UserPicker$fromSinglePicker(newUserPicker))));
				var modelWithUserPicker = _Utils_update(
					model,
					{
						f2: $author$project$Form$UserPicker$getSingleProfile(newUserPicker),
						dd: newUserPicker
					});
				var _v8 = function () {
					if (_Utils_eq(
						$author$project$Form$UserPicker$getSingleProfile(newUserPicker),
						$author$project$Form$UserPicker$getSingleProfile(model.dd))) {
						return _Utils_Tuple2(modelWithUserPicker, $elm$core$Basics$identity);
					} else {
						var _v9 = loggedIn.pC;
						if (_v9.$ === 3) {
							var community = _v9.a;
							var newModel_ = _Utils_update(
								modelWithUserPicker,
								{cO: $elm$core$Maybe$Nothing, cP: $elm$core$Maybe$Nothing});
							return _Utils_Tuple2(
								newModel_,
								$author$project$UpdateResult$addExt(
									A3($author$project$Page$PaymentHistory$fetchProfileWithTransfers, loggedIn, community, newModel_)));
						} else {
							return _Utils_Tuple2(
								modelWithUserPicker,
								A5(
									$author$project$UpdateResult$logImpossible,
									msg,
									'Picked a user, but community wasn\'t loaded',
									$elm$core$Maybe$Just(loggedIn._),
									{e$: 'update', fi: 'Page.PaymentHistory'},
									_List_Nil));
						}
					}
				}();
				var newModel = _v8.a;
				var fetchProfiles = _v8.b;
				return fetchProfileInfo(
					fetchProfiles(
						A2(
							$author$project$UpdateResult$addMsg,
							A2($elm$core$Maybe$withDefault, $author$project$Page$PaymentHistory$NoOp, maybeMsg),
							A2(
								$author$project$UpdateResult$addCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Page$PaymentHistory$GotUserPickerMsg, userPickerCmd),
								$author$project$UpdateResult$init(newModel)))));
			default:
				var subMsg = msg.a;
				var _v10 = A4(
					$author$project$Form$DatePicker$update,
					$author$project$Page$PaymentHistory$datePickerOptions(shared),
					A2($author$project$Page$PaymentHistory$datePickerViewConfig, shared, model),
					subMsg,
					model.eS);
				var newDatePicker = _v10.a;
				var datePickerCmd = _v10.b;
				var modelWithDatePicker = _Utils_update(
					model,
					{
						eS: newDatePicker,
						ck: $author$project$Form$DatePicker$getDate(newDatePicker)
					});
				var _v11 = function () {
					if (_Utils_eq(modelWithDatePicker.ck, model.ck)) {
						return _Utils_Tuple2(modelWithDatePicker, $elm$core$Basics$identity);
					} else {
						var _v12 = loggedIn.pC;
						if (_v12.$ === 3) {
							var community = _v12.a;
							var newModel_ = _Utils_update(
								modelWithDatePicker,
								{cO: $elm$core$Maybe$Nothing, cP: $elm$core$Maybe$Nothing});
							return _Utils_Tuple2(
								newModel_,
								$author$project$UpdateResult$addExt(
									A3($author$project$Page$PaymentHistory$fetchProfileWithTransfers, loggedIn, community, newModel_)));
						} else {
							return _Utils_Tuple2(
								modelWithDatePicker,
								A5(
									$author$project$UpdateResult$logImpossible,
									msg,
									'Picked a date, but community wasn\'t loaded',
									$elm$core$Maybe$Just(loggedIn._),
									{e$: 'update', fi: 'Page.PaymentHistory'},
									_List_Nil));
						}
					}
				}();
				var newModel = _v11.a;
				var fetchProfile = _v11.b;
				return fetchProfile(
					A2(
						$author$project$UpdateResult$addCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Page$PaymentHistory$GotDatePickerMsg, datePickerCmd),
						$author$project$UpdateResult$init(newModel)));
		}
	});
var $author$project$Page$Profile$CompletedLoadBalance = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Profile$CompletedLoadGraphqlInfo = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Profile$FailedLoading = {$: 2};
var $author$project$Page$Profile$Loaded = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$Profile$ResultNotFound = {$: 0};
var $author$project$Page$Profile$ResultWithError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$CompletedLoadUserTransfers = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Profile$fetchTransfers = F3(
	function (loggedIn, community, maybeCursor) {
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Transfer$transfersUserQuery,
				loggedIn._,
				function (args) {
					return _Utils_update(
						args,
						{
							hu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(maybeCursor),
							hV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
								{
									gd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
										$author$project$Eos$symbolToString(community.as)),
									dw: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
									F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
								}),
							hX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(10)
						});
				}),
			$author$project$Page$Profile$CompletedLoadUserTransfers);
	});
var $author$project$Page$Profile$GraphqlInfo = F4(
	function (totalTransfers, totalClaims, totalProducts, createdDate) {
		return {hM: createdDate, lH: totalClaims, lI: totalProducts, lJ: totalTransfers};
	});
var $author$project$Page$Profile$claimSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Claim$id,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
		function (id) {
			return {w: id};
		}));
var $author$project$Cambiatus$Object$User$claims = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{gd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'communityId', filledInOptionals.gd, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'claims',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Cambiatus$Object$User$network = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'network',
		_List_Nil,
		object_,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$nullable,
				A2($elm$core$Basics$composeR, $elm$json$Json$Decode$list, $elm$json$Json$Decode$nullable))));
};
var $author$project$Page$Profile$Network = F2(
	function (symbol, createdAt) {
		return {gl: createdAt, as: symbol};
	});
var $author$project$Cambiatus$Object$Network$communityId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'communityId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Network$createdAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'createdAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).mz.jE);
var $author$project$Page$Profile$networkSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Utils$fromDateTime, $author$project$Cambiatus$Object$Network$createdAt),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Network$communityId),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Profile$Network)));
var $author$project$Page$Profile$productSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Product$communityId),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Product$id,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
			F2(
				function (id, symbol) {
					return {w: id, as: symbol};
				}))));
var $author$project$Cambiatus$Object$User$products = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'products',
		_List_Nil,
		object_,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, $elm$json$Json$Decode$nullable, $elm$json$Json$Decode$list)));
};
var $author$project$Cambiatus$Object$TransferConnection$count = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'count',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Page$Profile$transfersSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$withDefault(0),
		$author$project$Cambiatus$Object$TransferConnection$count),
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Basics$identity));
var $author$project$Page$Profile$graphqlInfoSelectionSet = function (communitySymbol) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			function (networks) {
				return A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.gl;
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (network) {
							return _Utils_eq(network.as, communitySymbol);
						},
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							A2($elm$core$Maybe$withDefault, _List_Nil, networks))));
			},
			$author$project$Cambiatus$Object$User$network($author$project$Page$Profile$networkSelectionSet)),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				function (products) {
					return $elm$core$List$length(
						A2(
							$elm$core$List$filter,
							function (_v0) {
								var symbol = _v0.as;
								return _Utils_eq(symbol, communitySymbol);
							},
							A2($elm$core$List$filterMap, $elm$core$Basics$identity, products)));
				},
				$author$project$Cambiatus$Object$User$products($author$project$Page$Profile$productSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					$elm$core$List$length,
					A2($author$project$Cambiatus$Object$User$claims, $elm$core$Basics$identity, $author$project$Page$Profile$claimSelectionSet)),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
						$elm$core$Maybe$withDefault(0),
						A2(
							$author$project$Cambiatus$Object$User$transfers,
							function (optionals) {
								return _Utils_update(
									optionals,
									{
										hV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
											{
												gd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
													$author$project$Eos$symbolToString(communitySymbol)),
												dw: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
												F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
											}),
										hX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(0)
									});
							},
							$author$project$Page$Profile$transfersSelectionSet)),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Profile$GraphqlInfo)))));
};
var $author$project$Page$Profile$graphqlInfoQuery = F2(
	function (profileName, communitySymbol) {
		return A2(
			$author$project$Cambiatus$Query$user,
			{
				l8: $author$project$Eos$Account$nameToString(profileName)
			},
			$author$project$Page$Profile$graphqlInfoSelectionSet(communitySymbol));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Page$Profile$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var profile = msg.a.a.a;
							return _Utils_eq(profile.l8, model.k5) ? $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pl: $krisajenkins$remotedata$RemoteData$Success(profile)
									})) : $author$project$UpdateResult$init(model);
						} else {
							var _v1 = msg.a.a;
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Profile was not found',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Profile'},
								_List_Nil,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											pl: $krisajenkins$remotedata$RemoteData$Failure($author$project$Page$Profile$ResultNotFound)
										})));
						}
					case 2:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got a graphql error when loading profile page',
							{e$: 'update', fi: 'Page.Profile'},
							_List_Nil,
							error,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pl: $krisajenkins$remotedata$RemoteData$Failure(
											$author$project$Page$Profile$ResultWithError(error))
									})));
					case 1:
						var _v2 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v3 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 1:
				var community = msg.a;
				var fetchBalance = A3(
					$author$project$Api$getBalances,
					loggedIn.A,
					model.k5,
					function (balancesResult) {
						if (!balancesResult.$) {
							var balances = balancesResult.a;
							return $author$project$Page$Profile$CompletedLoadBalance(
								A2(
									$elm$core$Result$fromMaybe,
									$author$project$Page$Profile$ResultNotFound,
									A2(
										$elm_community$list_extra$List$Extra$find,
										function (balance) {
											return _Utils_eq(balance.mk.as, community.as);
										},
										balances)));
						} else {
							var error = balancesResult.a;
							return $author$project$Page$Profile$CompletedLoadBalance(
								$elm$core$Result$Err(
									$author$project$Page$Profile$ResultWithError(error)));
						}
					});
				return A2(
					$author$project$UpdateResult$addExt,
					A3($author$project$Page$Profile$fetchTransfers, loggedIn, community, $elm$core$Maybe$Nothing),
					A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$query,
							loggedIn,
							A2($author$project$Page$Profile$graphqlInfoQuery, model.k5, community.as),
							$author$project$Page$Profile$CompletedLoadGraphqlInfo),
						A2(
							$author$project$UpdateResult$addCmd,
							fetchBalance,
							$author$project$UpdateResult$init(model))));
			case 2:
				var contributions = msg.a;
				var userContributions = A2(
					$elm$core$List$filter,
					function (contribution) {
						return _Utils_eq(contribution.qg.l8, loggedIn._);
					},
					contributions);
				var contributionInfo = function () {
					if (!userContributions.b) {
						return $elm$core$Maybe$Nothing;
					} else {
						var first = userContributions.a;
						var rest = userContributions.b;
						return $elm$core$Maybe$Just(
							{
								ji: $elm$core$List$sum(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.ji;
										},
										A2($elm$core$List$cons, first, rest))),
								jA: first.jA
							});
					}
				}();
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{gf: contributionInfo}));
			case 3:
				if (!msg.a.$) {
					var balance = msg.a.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								cA: $krisajenkins$remotedata$RemoteData$Success(
									_Utils_update(
										balance,
										{
											n1: $elm$time$Time$millisToPosix(
												1000 * $elm$time$Time$posixToMillis(balance.n1))
										}))
							}));
				} else {
					var err = msg.a.a;
					var logError = function () {
						if (!err.$) {
							return A5(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Balance was not found on profile page',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Profile'},
								_List_Nil);
						} else {
							var httpError = err.a;
							return A6(
								$author$project$UpdateResult$logHttpError,
								msg,
								$elm$core$Maybe$Just(loggedIn._),
								'Got an HTTP error when loading balance on profile page',
								{e$: 'update', fi: 'Page.Profile'},
								_List_Nil,
								httpError);
						}
					}();
					return logError(
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									cA: $krisajenkins$remotedata$RemoteData$Failure(err)
								})));
				}
			case 4:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var graphqlInfo = msg.a.a.a;
							var reportCreatedDateNotFound = function () {
								var _v7 = graphqlInfo.hM;
								if (_v7.$ === 1) {
									return A5(
										$author$project$UpdateResult$logImpossible,
										msg,
										'Profile\'s createdDate is null',
										$elm$core$Maybe$Just(loggedIn._),
										{e$: 'update', fi: 'Page.Profile'},
										_List_Nil);
								} else {
									return $elm$core$Basics$identity;
								}
							}();
							return reportCreatedDateNotFound(
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											b1: $krisajenkins$remotedata$RemoteData$Success(graphqlInfo)
										})));
						} else {
							var _v8 = msg.a.a;
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Profile\'s graphql info not found',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Profile'},
								_List_Nil,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											b1: $krisajenkins$remotedata$RemoteData$Failure($author$project$Page$Profile$ResultNotFound)
										})));
						}
					case 2:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when loading profile\'s graphql info',
							{e$: 'update', fi: 'Page.Profile'},
							_List_Nil,
							error,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										b1: $krisajenkins$remotedata$RemoteData$Failure(
											$author$project$Page$Profile$ResultWithError(error))
									})));
					case 1:
						var _v9 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v10 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 5:
				switch (msg.a.$) {
					case 3:
						var maybeTransfers = msg.a.a;
						var previousTransfers = function () {
							var _v11 = model.a1;
							switch (_v11.$) {
								case 0:
									var previousTransfers_ = _v11.a;
									return previousTransfers_;
								case 1:
									var previousTransfers_ = _v11.a;
									return previousTransfers_;
								default:
									return _List_Nil;
							}
						}();
						var maybePageInfo = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.o2;
							},
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.av;
								},
								maybeTransfers));
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									a1: function (transfers) {
										return A2(
											$author$project$Page$Profile$Loaded,
											_Utils_ap(previousTransfers, transfers),
											maybePageInfo);
									}(
										A2(
											$elm$core$List$map,
											function (transfer) {
												return _Utils_Tuple2(
													transfer,
													$author$project$Profile$Summary$init(false));
											},
											$author$project$Transfer$getTransfers(maybeTransfers)))
								}));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when trying to load user\'s transfers on profile',
							{e$: 'update', fi: 'Page.Profile'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.pC)
								]),
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{a1: $author$project$Page$Profile$FailedLoading})));
					case 1:
						var _v12 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v13 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 6:
				var transferId = msg.a;
				var subMsg = msg.b;
				var updateTransfers = function (transfers) {
					return A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (_v15) {
							var transfer = _v15.a;
							return _Utils_eq(transfer.w, transferId);
						},
						function (_v16) {
							var transfer = _v16.a;
							var profileSummary = _v16.b;
							return _Utils_Tuple2(
								transfer,
								A2($author$project$Profile$Summary$update, subMsg, profileSummary));
						},
						transfers);
				};
				var _v14 = model.a1;
				switch (_v14.$) {
					case 0:
						var transfers = _v14.a;
						var pageInfo = _v14.b;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									a1: A2(
										$author$project$Page$Profile$Loaded,
										updateTransfers(transfers),
										pageInfo)
								}));
					case 1:
						var transfers = _v14.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									a1: $author$project$Page$Profile$Loading(
										updateTransfers(transfers))
								}));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 7:
				var transferId = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$author$project$Route$pushUrl,
						loggedIn.A.kK,
						$author$project$Route$ViewTransfer(transferId)),
					$author$project$UpdateResult$init(model));
			default:
				var _v17 = _Utils_Tuple2(model.a1, loggedIn.pC);
				if ((!_v17.a.$) && (_v17.b.$ === 3)) {
					var _v18 = _v17.a;
					var transfers = _v18.a;
					var maybePageInfo = _v18.b;
					var community = _v17.b.a;
					var maybeCursor = A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.m7;
						},
						maybePageInfo);
					return A2(
						$author$project$UpdateResult$addExt,
						A3($author$project$Page$Profile$fetchTransfers, loggedIn, community, maybeCursor),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									a1: $author$project$Page$Profile$Loading(transfers)
								})));
				} else {
					return $author$project$UpdateResult$init(model);
				}
		}
	});
var $author$project$Page$Profile$AddContact$GotContactMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Profile$Contact$usesPhone = function (contactType) {
	return A2(
		$elm$core$List$member,
		contactType,
		_List_fromArray(
			[5, 3]));
};
var $author$project$Profile$Contact$countryFromNormalized = function (_v0) {
	var contactType = _v0.mE;
	var contact = _v0.mD;
	if ($author$project$Profile$Contact$usesPhone(contactType)) {
		var countryCode = $elm$core$String$fromList(
			A2(
				$elm_community$list_extra$List$Extra$takeWhile,
				$elm$core$Basics$neq(' '),
				$elm$core$String$toList(
					A2($elm$core$String$dropLeft, 1, contact))));
		var supportedCountry = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.mP;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.eO;
						},
						$elm$core$Basics$eq(countryCode))),
				$author$project$Profile$Contact$supportedCountries));
		var newContact = function (n) {
			return $elm$core$String$trim(
				A2($elm$core$String$dropLeft, n, contact));
		}(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.mP;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.eO;
							},
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$length,
								$elm$core$Basics$add(1)))),
					supportedCountry)));
		return _Utils_Tuple2(supportedCountry, newContact);
	} else {
		return _Utils_Tuple2($elm$core$Maybe$Nothing, contact);
	}
};
var $author$project$Profile$Contact$initBasicWith = function (normalized) {
	var contactType = normalized.mE;
	var initial = $author$project$Profile$Contact$initBasic(contactType);
	var _v0 = $author$project$Profile$Contact$countryFromNormalized(normalized);
	var maybeCountry = _v0.a;
	var newPhoneContact = _v0.b;
	var newContact = function () {
		switch (contactType) {
			case 3:
				return newPhoneContact;
			case 5:
				return newPhoneContact;
			case 4:
				return A2($elm$core$String$dropLeft, 13, newPhoneContact);
			case 1:
				return A2($elm$core$String$dropLeft, 22, newPhoneContact);
			case 0:
				return newPhoneContact;
			default:
				return newPhoneContact;
		}
	}();
	return _Utils_update(
		initial,
		{
			mD: newContact,
			aM: A2($elm$core$Maybe$withDefault, $author$project$Profile$Contact$defaultCountry, maybeCountry)
		});
};
var $author$project$Cambiatus$Enum$ContactType$list = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $author$project$Profile$Contact$initMultiple = function (initialContacts) {
	return {
		cC: $elm$core$Maybe$Nothing,
		z: $author$project$Profile$Contact$Multiple(
			A2(
				$elm$core$List$map,
				function (type_) {
					return A2(
						$elm$core$Maybe$withDefault,
						$author$project$Profile$Contact$initBasic(type_),
						A2(
							$elm$core$Maybe$map,
							$author$project$Profile$Contact$initBasicWith,
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (_v0) {
									var contactType = _v0.mE;
									return _Utils_eq(type_, contactType);
								},
								initialContacts)));
				},
				$author$project$Cambiatus$Enum$ContactType$list)),
		Z: $krisajenkins$remotedata$RemoteData$NotAsked
	};
};
var $author$project$Page$Profile$AddContact$update = F3(
	function (msg, model, loggedIn) {
		var shared = loggedIn.A;
		if (msg.$ === 1) {
			var profile = msg.a;
			return $author$project$UpdateResult$init(
				$krisajenkins$remotedata$RemoteData$Success(
					$author$project$Profile$Contact$initMultiple(profile.az)));
		} else {
			var subMsg = msg.a;
			var _v1 = _Utils_Tuple2(
				model,
				$author$project$Session$LoggedIn$profile(loggedIn));
			if ((_v1.a.$ === 3) && (!_v1.b.$)) {
				var contactModel = _v1.a.a;
				var profile_ = _v1.b.a;
				var handleExtMsg = function (extMsg) {
					switch (extMsg.$) {
						case 0:
							var successMessage = extMsg.a;
							var contacts = extMsg.b;
							var shouldRedirect = extMsg.c;
							var _v3 = loggedIn.pl;
							if (_v3.$ === 3) {
								var profile = _v3.a;
								return A2(
									$elm$core$Basics$composeR,
									$author$project$UpdateResult$addExt(
										A2($author$project$Session$LoggedIn$ShowFeedback, 0, successMessage)),
									A2(
										$elm$core$Basics$composeR,
										$author$project$UpdateResult$addExt(
											$author$project$Session$LoggedIn$ExternalBroadcast(
												$author$project$Session$LoggedIn$ProfileLoaded(
													_Utils_update(
														profile,
														{az: contacts})))),
										shouldRedirect ? $author$project$UpdateResult$addCmd(
											A2(
												$author$project$Route$replaceUrl,
												shared.kK,
												$author$project$Route$Profile(loggedIn._))) : $elm$core$Basics$identity));
							} else {
								return A5(
									$author$project$UpdateResult$logImpossible,
									msg,
									'Tried updating contacts, but profile is not loaded',
									$elm$core$Maybe$Just(loggedIn._),
									{e$: 'update', fi: 'Page.Profile.AddContact'},
									_List_Nil);
							}
						case 1:
							var errorMessage = extMsg.a;
							return $author$project$UpdateResult$addExt(
								A2($author$project$Session$LoggedIn$ShowFeedback, 1, errorMessage));
						default:
							var selectionSet = extMsg.a;
							var responseMsg = extMsg.b;
							return $author$project$UpdateResult$addExt(
								A3(
									$author$project$Session$LoggedIn$mutation,
									loggedIn,
									selectionSet,
									A2($elm$core$Basics$composeR, responseMsg, $author$project$Page$Profile$AddContact$GotContactMsg)));
					}
				};
				return A5(
					$author$project$UpdateResult$fromChild,
					$krisajenkins$remotedata$RemoteData$Success,
					$author$project$Page$Profile$AddContact$GotContactMsg,
					handleExtMsg,
					model,
					A4($author$project$Profile$Contact$update, subMsg, contactModel, shared.aw, profile_.az));
			} else {
				return $author$project$UpdateResult$init(model);
			}
		}
	});
var $author$project$Page$Profile$AddKyc$FormMsg = $elm$core$Basics$identity;
var $author$project$Session$LoggedIn$ProfileResource = 1;
var $author$project$Page$Profile$AddKyc$update = F3(
	function (msg, model, loggedIn) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var kycFormMsg = msg;
		var formUpdateResult = A5(
			$author$project$UpdateResult$fromChild,
			$elm$core$Basics$identity,
			$elm$core$Basics$identity,
			$author$project$Session$LoggedIn$addFeedback,
			model,
			A3($author$project$Profile$EditKycForm$update, loggedIn.A, model, kycFormMsg));
		switch (kycFormMsg.$) {
			case 1:
				var formOutput = kycFormMsg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					A2(
						$author$project$Session$LoggedIn$mapExternal,
						$elm$core$Basics$identity,
						A2($author$project$Profile$EditKycForm$saveKycData, loggedIn, formOutput)),
					A2(
						$author$project$UpdateResult$addExt,
						$author$project$Session$LoggedIn$UpdatedLoggedIn(
							_Utils_update(
								loggedIn,
								{pl: $krisajenkins$remotedata$RemoteData$Loading})),
						formUpdateResult));
			case 2:
				var result = kycFormMsg.a;
				if (result.$ === 2) {
					return A2(
						$author$project$UpdateResult$addExt,
						A2(
							$author$project$Session$LoggedIn$ShowFeedback,
							1,
							t('error.unknown')),
						formUpdateResult);
				} else {
					return A2(
						$author$project$UpdateResult$addExt,
						A2(
							$author$project$Session$LoggedIn$ShowFeedback,
							0,
							t('community.kyc.add.success')),
						A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$ReloadResource(1),
							A2(
								$author$project$UpdateResult$addCmd,
								A2(
									$author$project$Route$replaceUrl,
									loggedIn.A.kK,
									$author$project$Route$Profile(loggedIn._)),
								formUpdateResult)));
				}
			default:
				return formUpdateResult;
		}
	});
var $author$project$Page$Profile$Claims$ClosedAuthModal = {$: 2};
var $author$project$Page$Profile$Claims$Desc = 1;
var $author$project$Page$Profile$Claims$Failed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Profile$Claims$Loaded = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$Profile$Claims$NotFound = {$: 2};
var $author$project$Page$Profile$Claims$ClaimsLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$Claims$selectionSet = F2(
	function (now, communityId) {
		return A2(
			$author$project$Cambiatus$Object$User$claims,
			function (_v0) {
				return {
					gd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Eos$symbolToString(communityId))
				};
			},
			$author$project$Claim$selectionSet(now));
	});
var $author$project$Page$Profile$Claims$profileClaimQuery = F3(
	function (loggedIn, accountName, symbol) {
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Cambiatus$Query$user,
				{l8: accountName},
				A2($author$project$Page$Profile$Claims$selectionSet, loggedIn.A.ce, symbol)),
			$author$project$Page$Profile$Claims$ClaimsLoaded);
	});
var $author$project$Page$Profile$Claims$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				switch (msg.a.$) {
					case 3:
						var results = msg.a.a;
						if (!results.$) {
							var claims = results.a;
							var profileSummaries = A2($elm$core$List$map, $author$project$Claim$initClaimProfileSummaries, claims);
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pN: A2(
											$author$project$Page$Profile$Claims$Loaded,
											profileSummaries,
											$elm$core$List$reverse(claims))
									}));
						} else {
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{pN: $author$project$Page$Profile$Claims$NotFound}));
						}
					case 2:
						var e = msg.a.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									pN: $author$project$Page$Profile$Claims$Failed(e)
								}));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 2:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{hF: $author$project$Claim$Closed}));
			case 3:
				var community = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					A3($author$project$Page$Profile$Claims$profileClaimQuery, loggedIn, model.l9, community.as),
					$author$project$UpdateResult$init(model));
			case 4:
				var claimIndex = msg.a;
				var m = msg.b;
				var updatedModel = function () {
					var _v2 = _Utils_Tuple2(model.pN, m);
					if ((_v2.a.$ === 1) && (_v2.b.$ === 3)) {
						var _v3 = _v2.a;
						var profileSummaries = _v3.a;
						var profileClaims = _v3.b;
						var subMsg = _v2.b.a;
						return _Utils_update(
							model,
							{
								pN: A2(
									$author$project$Page$Profile$Claims$Loaded,
									A3(
										$elm_community$list_extra$List$Extra$updateAt,
										claimIndex,
										$author$project$Claim$updateProfileSummaries(subMsg),
										profileSummaries),
									profileClaims)
							});
					} else {
						return model;
					}
				}();
				return $author$project$UpdateResult$init(
					A2($author$project$Claim$updateClaimModalStatus, m, updatedModel));
			case 5:
				var claimId = msg.a;
				var vote = msg.b;
				var _v4 = _Utils_Tuple2(model.pN, loggedIn.pC);
				if ((_v4.a.$ === 1) && (_v4.b.$ === 3)) {
					var _v5 = _v4.a;
					var community = _v4.b.a;
					var newModel = _Utils_update(
						model,
						{
							hF: A2($author$project$Claim$Loading, claimId, vote)
						});
					return A5(
						$author$project$Session$LoggedIn$withPrivateKey,
						loggedIn,
						_List_fromArray(
							[6]),
						model,
						{hS: $author$project$Page$Profile$Claims$ClosedAuthModal, iX: msg},
						A2(
							$author$project$UpdateResult$addPort,
							{
								bZ: $author$project$Eos$encodeTransaction(
									_List_fromArray(
										[
											{
											_: loggedIn.A.hL.V,
											hw: {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission},
											bZ: A4($author$project$Claim$encodeVerification, claimId, loggedIn._, vote, community.as),
											fj: 'verifyclaim'
										}
										])),
								fy: msg,
								fz: $elm$json$Json$Encode$null
							},
							$author$project$UpdateResult$init(newModel)));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 6:
				if (!msg.b.$) {
					var claimId = msg.a;
					var _v6 = model.pN;
					if (_v6.$ === 1) {
						var profileClaims = _v6.b;
						var message = function (val) {
							return A2(
								loggedIn.A.aw.i4,
								'claim.reward',
								_List_fromArray(
									[
										_Utils_Tuple2('value', val)
									]));
						};
						var maybeClaim = A2(
							$elm_community$list_extra$List$Extra$find,
							function (c) {
								return _Utils_eq(c.w, claimId);
							},
							profileClaims);
						if (!maybeClaim.$) {
							var claim = maybeClaim.a;
							var symbol = claim.dh.ad.V.as;
							var value = A2(
								$author$project$Eos$assetToString,
								loggedIn.A.aw,
								{ji: claim.dh.lY, as: symbol});
							return A2(
								$author$project$UpdateResult$addExt,
								A3($author$project$Page$Profile$Claims$profileClaimQuery, loggedIn, model.l9, symbol),
								A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										0,
										message(value)),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{hF: $author$project$Claim$Closed, pN: $author$project$Page$Profile$Claims$Loading}))));
						} else {
							return $author$project$UpdateResult$init(model);
						}
					} else {
						return $author$project$UpdateResult$init(model);
					}
				} else {
					var eosErrorString = msg.b.a;
					var errorMessage = A2($author$project$Eos$EosError$parseClaimError, loggedIn.A.aw, eosErrorString);
					var _v8 = model.pN;
					if (_v8.$ === 1) {
						var profileSummaries = _v8.a;
						var claims = _v8.b;
						var updateShowClaimModal = function (profileSummary) {
							return _Utils_update(
								profileSummary,
								{fE: false});
						};
						return A2(
							$author$project$UpdateResult$addExt,
							A2($author$project$Session$LoggedIn$ShowFeedback, 1, errorMessage),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										hF: $author$project$Claim$Closed,
										pN: A2(
											$author$project$Page$Profile$Claims$Loaded,
											A2($elm$core$List$map, updateShowClaimModal, profileSummaries),
											claims)
									})));
					} else {
						return $author$project$UpdateResult$init(model);
					}
				}
			case 7:
				var tab = msg.a;
				var tabToString = function (tab_) {
					if (!tab_) {
						return 'waiting vote';
					} else {
						return 'analyzed';
					}
				};
				return A2(
					$author$project$UpdateResult$addBreadcrumb,
					{
						f7: msg,
						bZ: $elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'tab',
									$elm$json$Json$Encode$string(
										tabToString(tab)))
								])),
						n4: 3,
						of: 'Selected claims tab',
						eq: 3
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{aZ: tab})));
			case 8:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{em: true}));
			case 9:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{em: false}));
			case 10:
				var newDirection = function () {
					var _v11 = model.d7;
					if (!_v11) {
						return 1;
					} else {
						return 0;
					}
				}();
				var directionToString = function (direction) {
					if (!direction) {
						return 'ASC';
					} else {
						return 'DESC';
					}
				};
				return A2(
					$author$project$UpdateResult$addBreadcrumb,
					{
						f7: msg,
						bZ: $elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'newSorting',
									$elm$json$Json$Encode$string(
										directionToString(newDirection)))
								])),
						n4: 3,
						of: 'Toggled sorting',
						eq: 4
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{d7: newDirection})));
			case 11:
				var statusFilter = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{eV: statusFilter}));
			case 12:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{gn: model.eV, em: false}));
			default:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$ShowCodeOfConductModal,
					$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Profile$Contributions$CompletedLoadContributions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Profile$Contribution = F4(
	function (amount, insertedAt, currency, status) {
		return {ji: amount, jA: currency, nL: insertedAt, pN: status};
	});
var $author$project$Cambiatus$Object$User$contributions = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{gd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, pN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'communityId', filledInOptionals.gd, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'status',
					filledInOptionals.pN,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$ContributionStatusType$toString))
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'contributions',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Cambiatus$Enum$ContributionStatusType$Approved = 0;
var $author$project$Cambiatus$Enum$ContributionStatusType$Captured = 1;
var $author$project$Cambiatus$Enum$ContributionStatusType$Failed = 3;
var $author$project$Cambiatus$Enum$ContributionStatusType$Rejected = 4;
var $author$project$Cambiatus$Enum$ContributionStatusType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'APPROVED':
				return $elm$json$Json$Decode$succeed(0);
			case 'CAPTURED':
				return $elm$json$Json$Decode$succeed(1);
			case 'CREATED':
				return $elm$json$Json$Decode$succeed(2);
			case 'FAILED':
				return $elm$json$Json$Decode$succeed(3);
			case 'REJECTED':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid ContributionStatusType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Contribution$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ContributionStatusType.ContributionStatusType', 'status', _List_Nil, $author$project$Cambiatus$Enum$ContributionStatusType$decoder);
var $author$project$Profile$contributionSelectionSet = function (symbol) {
	var selectionSet_ = A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Contribution$status,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Contribution$currency,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					function (_v0) {
						var naiveDateTime = _v0;
						return A2(
							$elm$core$Result$withDefault,
							$elm$time$Time$millisToPosix(0),
							$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(naiveDateTime));
					},
					$author$project$Cambiatus$Object$Contribution$insertedAt),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Contribution$amount,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Contribution)))));
	return A2(
		$author$project$Cambiatus$Object$User$contributions,
		function (optionals) {
			return _Utils_update(
				optionals,
				{
					gd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Eos$symbolToString(symbol))
				});
		},
		selectionSet_);
};
var $author$project$Profile$contributionsQuery = F2(
	function (symbol, account) {
		return A2(
			$author$project$Cambiatus$Query$user,
			{
				l8: $author$project$Eos$Account$nameToString(account)
			},
			$author$project$Profile$contributionSelectionSet(symbol));
	});
var $author$project$Page$Profile$Contributions$update = F3(
	function (msg, model, loggedIn) {
		if (!msg.$) {
			var community = msg.a;
			return A2(
				$author$project$UpdateResult$addExt,
				A3(
					$author$project$Session$LoggedIn$query,
					loggedIn,
					A2($author$project$Profile$contributionsQuery, community.as, model.k5),
					$author$project$Page$Profile$Contributions$CompletedLoadContributions),
				$author$project$UpdateResult$init(
					_Utils_update(
						model,
						{eN: $krisajenkins$remotedata$RemoteData$Loading})));
		} else {
			switch (msg.a.$) {
				case 3:
					var contributions = msg.a.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								eN: $krisajenkins$remotedata$RemoteData$Success(
									A2($elm$core$Maybe$withDefault, _List_Nil, contributions))
							}));
				case 2:
					var err = msg.a.a;
					return A7(
						$author$project$UpdateResult$logGraphqlError,
						msg,
						$elm$core$Maybe$Just(loggedIn._),
						'Got an error when loading profile contributions',
						{e$: 'update', fi: 'Page.Profile.Contributions'},
						_List_fromArray(
							[
								{
								ng: $elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'profile',
											$author$project$Eos$Account$encodeName(model.k5))
										])),
								fj: 'Profile'
							}
							]),
						err,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									eN: $krisajenkins$remotedata$RemoteData$Failure(err)
								})));
				case 0:
					var _v1 = msg.a;
					return $author$project$UpdateResult$init(model);
				default:
					var _v2 = msg.a;
					return $author$project$UpdateResult$init(model);
			}
		}
	});
var $author$project$Page$Profile$Editor$GotFormMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Profile$Editor$GotSaveResult = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Profile$Editor$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Avatar$fromString = A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$identity);
var $author$project$Profile$Contact$unwrap = function (_v0) {
	var contact = _v0;
	return contact;
};
var $author$project$Profile$mutation = function (form) {
	var interestString = A2(
		$elm$core$String$join,
		',',
		A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(''),
			A2($elm$core$List$cons, form.b4, form.dN)));
	var contactInput = function (_v0) {
		var contactType = _v0.mE;
		var contact = _v0.mD;
		var label = _v0.n$;
		return {
			dC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(contact),
			n$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(label),
			eq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(contactType)
		};
	};
	var avatarInput = A2(
		$elm$core$Maybe$withDefault,
		$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
		A2($elm$core$Maybe$map, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present, form.dl));
	return A2(
		$author$project$Cambiatus$Mutation$user,
		{
			nG: {
				dl: avatarInput,
				dm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Markdown$toRawString(form.dm)),
				dq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				az: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, $author$project$Profile$Contact$unwrap, contactInput),
						form.az)),
				dx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				jK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(form.jK),
				dN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(interestString),
				oa: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(form.n9),
				fj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(form.fj),
				ep: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
			}
		},
		$author$project$Profile$selectionSet);
};
var $author$project$Avatar$toMaybeString = function (_v0) {
	var s = _v0;
	return s;
};
var $author$project$Profile$profileToForm = function (_v0) {
	var name = _v0.fj;
	var email = _v0.jK;
	var bio = _v0.dm;
	var localization = _v0.n9;
	var avatar = _v0.dl;
	var interests = _v0.dN;
	var contacts = _v0.az;
	return {
		dl: $author$project$Avatar$toMaybeString(avatar),
		dm: A2($elm$core$Maybe$withDefault, $author$project$Markdown$empty, bio),
		az: contacts,
		jK: A2($elm$core$Maybe$withDefault, '', email),
		jO: $elm$core$Dict$empty,
		b4: '',
		dN: interests,
		n9: A2($elm$core$Maybe$withDefault, '', localization),
		fj: A2($elm$core$Maybe$withDefault, '', name)
	};
};
var $author$project$Page$Profile$Editor$update = F3(
	function (msg, model, loggedIn) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		switch (msg.$) {
			case 0:
				var profile = msg.a;
				var nullable = function (a) {
					return A2($elm$core$Maybe$withDefault, '', a);
				};
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							hY: $author$project$Page$Profile$Editor$Loaded(
								$author$project$Form$init(
									{
										dl: $author$project$Form$File$initSingle(
											{
												mj: $elm$core$Maybe$Just(1),
												ni: $author$project$Avatar$toMaybeString(profile.dl)
											}),
										dm: A2($author$project$Form$RichText$initModel, 'bio-input', profile.dm),
										jK: nullable(profile.jK),
										dG: nullable(profile.fj),
										b4: '',
										dN: profile.dN,
										oa: nullable(profile.n9)
									}))
						}));
			case 1:
				var formOutput = msg.a;
				var _v2 = loggedIn.pl;
				if (_v2.$ === 3) {
					var profile = _v2.a;
					var newProfile = _Utils_update(
						profile,
						{
							dl: A2(
								$elm$core$Maybe$withDefault,
								profile.dl,
								A2($elm$core$Maybe$map, $author$project$Avatar$fromString, formOutput.dl)),
							dm: $elm$core$Maybe$Just(formOutput.dm),
							jK: $elm$core$Maybe$Just(formOutput.jK),
							dN: formOutput.dN,
							n9: $elm$core$Maybe$Just(formOutput.oa),
							fj: $elm$core$Maybe$Just(formOutput.dG)
						});
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$mutation,
							loggedIn,
							$author$project$Profile$mutation(
								$author$project$Profile$profileToForm(newProfile)),
							$author$project$Page$Profile$Editor$GotSaveResult),
						A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$UpdatedLoggedIn(
								_Utils_update(
									loggedIn,
									{pl: $krisajenkins$remotedata$RemoteData$Loading})),
							$author$project$UpdateResult$init(model)));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Tried saving profile, but current profile wasn\'t loaded',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Profile.Editor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 2:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var profile = msg.a.a.a;
							return A2(
								$author$project$UpdateResult$addBreadcrumb,
								{f7: msg, bZ: $elm$core$Dict$empty, n4: 4, of: 'Successfully saved profile', eq: 1},
								A2(
									$author$project$UpdateResult$addCmd,
									A2(
										$author$project$Route$pushUrl,
										loggedIn.A.kK,
										$author$project$Route$Profile(loggedIn._)),
									A2(
										$author$project$UpdateResult$addExt,
										A2(
											$author$project$Session$LoggedIn$ShowFeedback,
											0,
											t('profile.edit_success')),
										A2(
											$author$project$UpdateResult$addExt,
											$author$project$Session$LoggedIn$ExternalBroadcast(
												$author$project$Session$LoggedIn$ProfileLoaded(profile)),
											$author$project$UpdateResult$init(model)))));
						} else {
							var _v3 = msg.a.a;
							return $author$project$UpdateResult$init(model);
						}
					case 2:
						var e = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when trying to save profile',
							{e$: 'update', fi: 'Page.Profile.Editor'},
							_List_Nil,
							e,
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$UpdatedLoggedIn(
									_Utils_update(
										loggedIn,
										{
											pl: $krisajenkins$remotedata$RemoteData$Failure(e)
										})),
								$author$project$UpdateResult$init(model)));
					default:
						return $author$project$UpdateResult$init(model);
				}
			default:
				var subMsg = msg.a;
				var _v4 = model.hY;
				if (!_v4.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var form = _v4.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newForm) {
							return _Utils_update(
								model,
								{
									hY: $author$project$Page$Profile$Editor$Loaded(newForm)
								});
						},
						$author$project$Page$Profile$Editor$GotFormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, loggedIn.A, subMsg, form));
				}
		}
	});
var $author$project$Page$Register$AccountCreated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Register$AccountTypeSelectorShowed = {$: 1};
var $author$project$Page$Register$DefaultForm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Register$DefaultFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Register$ErrorShowed = {$: 4};
var $author$project$Page$Register$FormShowed = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Register$GotFormMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$Register$JuridicalForm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Register$JuridicalFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Register$NaturalForm = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Register$NaturalFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Register$NoOp = {$: 0};
var $author$project$Page$Register$NotFound = {$: 5};
var $author$project$Page$Register$SavePassphrase = 1;
var $author$project$Page$Register$SubmittedForm = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$Register$DefaultForm$encode = function (output) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(output.fj)),
				_Utils_Tuple2(
				'account',
				$author$project$Eos$Account$encodeName(output.l8)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(output.jK))
			]));
};
var $author$project$Page$Register$JuridicalForm$companyTypeToString = function (type_) {
	if (!type_) {
		return 'mipyme';
	} else {
		return 'gran_empresa';
	}
};
var $author$project$Page$Register$JuridicalForm$encode = function (output) {
	var encodeIdAndName = function (_v0) {
		var id = _v0.w;
		var name = _v0.fj;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name))
				]));
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'companyType',
				$elm$json$Json$Encode$string(
					$author$project$Page$Register$JuridicalForm$companyTypeToString(output.mC))),
				_Utils_Tuple2(
				'document',
				$elm$json$Json$Encode$string(output.eT)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(output.fj)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(output.jK)),
				_Utils_Tuple2(
				'phone',
				$elm$json$Json$Encode$string(output.fq)),
				_Utils_Tuple2(
				'account',
				$author$project$Eos$Account$encodeName(output.l8)),
				_Utils_Tuple2(
				'state',
				encodeIdAndName(output.Z)),
				_Utils_Tuple2(
				'city',
				encodeIdAndName(output.mt)),
				_Utils_Tuple2(
				'district',
				encodeIdAndName(output.m0)),
				_Utils_Tuple2(
				'street',
				$elm$json$Json$Encode$string(output.fK)),
				_Utils_Tuple2(
				'number',
				$elm$json$Json$Encode$string(output.d2)),
				_Utils_Tuple2(
				'zip',
				$elm$json$Json$Encode$string(output.fY))
			]));
};
var $author$project$Page$Register$NaturalForm$documentTypeToString = function (document) {
	switch (document) {
		case 0:
			return 'cedula_de_identidad';
		case 1:
			return 'dimex';
		default:
			return 'nite';
	}
};
var $author$project$Page$Register$NaturalForm$encode = function (output) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'documentType',
				$elm$json$Json$Encode$string(
					$author$project$Page$Register$NaturalForm$documentTypeToString(output.eU))),
				_Utils_Tuple2(
				'document',
				$elm$json$Json$Encode$string(output.eT)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(output.fj)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(output.jK)),
				_Utils_Tuple2(
				'phoneNumber',
				$elm$json$Json$Encode$string(output.o7)),
				_Utils_Tuple2(
				'account',
				$author$project$Eos$Account$encodeName(output.l8))
			]));
};
var $author$project$Page$Register$encodeFormOutput = function (output) {
	switch (output.$) {
		case 0:
			var natural = output.a;
			return $author$project$Page$Register$NaturalForm$encode(natural);
		case 1:
			var juridical = output.a;
			return $author$project$Page$Register$JuridicalForm$encode(juridical);
		default:
			var _default = output.a;
			return $author$project$Page$Register$DefaultForm$encode(_default);
	}
};
var $author$project$Page$Register$getSignUpFields = function (form) {
	var extract = function (f) {
		return {l8: f.l8, jK: f.jK, fj: f.fj};
	};
	switch (form.$) {
		case 1:
			var f = form.a;
			return extract(f);
		case 0:
			var f = form.a;
			return extract(f);
		default:
			var f = form.a;
			return extract(f);
	}
};
var $author$project$Page$Register$JuridicalForm$init = function (country) {
	return $author$project$Form$init(
		{l8: '', mt: $elm$core$Maybe$Nothing, mC: 0, mP: country, m0: $elm$core$Maybe$Nothing, eT: '', jK: '', fj: '', d2: '', o7: '', Z: $elm$core$Maybe$Nothing, fK: '', fY: ''});
};
var $author$project$Page$Register$NaturalForm$init = $author$project$Form$init(
	{l8: '', eT: '', eU: 0, jK: '', fj: '', o7: ''});
var $author$project$Page$Register$CompletedLoadCountry = function (a) {
	return {$: 10, a: a};
};
var $author$project$Cambiatus$InputObject$encodeCountryInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input.fj)))
			]));
};
var $author$project$Cambiatus$Query$country = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'country',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs.nG, $author$project$Cambiatus$InputObject$encodeCountryInput)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Address$Country = F3(
	function (id, name, states) {
		return {w: id, fj: name, pM: states};
	});
var $author$project$Cambiatus$Object$Country$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Id',
	'id',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).eJ.jE);
var $author$project$Address$State = F3(
	function (id, name, cities) {
		return {ms: cities, w: id, fj: name};
	});
var $author$project$Cambiatus$Object$State$cities = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'cities',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Address$City = F3(
	function (id, name, neighborhoods) {
		return {w: id, fj: name, oq: neighborhoods};
	});
var $author$project$Cambiatus$Object$City$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Id',
	'id',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).eJ.jE);
var $author$project$Address$Neighborhood = F2(
	function (id, name) {
		return {w: id, fj: name};
	});
var $author$project$Cambiatus$Object$Neighborhood$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Id',
	'id',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).eJ.jE);
var $author$project$Address$neighborhoodSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Neighborhood$name,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Neighborhood$id,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Address$Neighborhood)));
var $author$project$Cambiatus$Object$City$neighborhoods = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'neighborhoods',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Address$citySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$City$neighborhoods($author$project$Address$neighborhoodSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$City$name,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$City$id,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Address$City))));
var $author$project$Cambiatus$Object$State$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Id',
	'id',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).eJ.jE);
var $author$project$Address$stateSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$State$cities($author$project$Address$citySelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$State$name,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$State$id,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Address$State))));
var $author$project$Cambiatus$Object$Country$states = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'states',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Address$countrySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Country$states($author$project$Address$stateSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Country$name,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Country$id,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Address$Country))));
var $author$project$Address$countryQuery = function (name) {
	return A2(
		$author$project$Cambiatus$Query$country,
		{
			nG: {fj: name}
		},
		$author$project$Address$countrySelectionSet);
};
var $author$project$Page$Register$DefaultForm$init = $author$project$Form$init(
	{l8: '', jK: '', fj: ''});
var $author$project$Page$Register$loadedCommunity = F4(
	function (shared, model, community, maybeInvite) {
		if (community.by) {
			var loadCountryData = A4(
				$author$project$Api$Graphql$query,
				shared,
				$elm$core$Maybe$Nothing,
				$author$project$Address$countryQuery('Costa Rica'),
				$author$project$Page$Register$CompletedLoadCountry);
			return A2(
				$author$project$UpdateResult$addCmd,
				loadCountryData,
				$author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dO: maybeInvite, pN: $author$project$Page$Register$Loading})));
		} else {
			return $author$project$UpdateResult$init(
				_Utils_update(
					model,
					{
						dO: maybeInvite,
						pN: A2(
							$author$project$Page$Register$FormShowed,
							{hk: $elm$core$Set$empty},
							$author$project$Page$Register$DefaultForm($author$project$Page$Register$DefaultForm$init))
					}));
		}
	});
var $author$project$Page$Register$CompletedSignUp = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Graphql$SignUpResponse = F2(
	function (profile, token) {
		return {pl: profile, p5: token};
	});
var $author$project$Cambiatus$InputObject$encodeAddressUpdateInput = function (input) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'cityId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.eJ;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs)(input.eG))),
				_Utils_Tuple2(
				'countryId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.eJ;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs)(input.a6))),
				_Utils_Tuple2(
				'neighborhoodId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.eJ;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs)(input.fk))),
				_Utils_Tuple2(
				'number',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input.d2, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'stateId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.eJ;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs)(input.fI))),
				_Utils_Tuple2(
				'street',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input.fK))),
				_Utils_Tuple2(
				'zip',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input.fY)))
			]));
};
var $author$project$Cambiatus$Mutation$signUp = F3(
	function (fillInOptionals, requiredArgs, object_) {
		var filledInOptionals = fillInOptionals(
			{ht: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, kk: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ib: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'address', filledInOptionals.ht, $author$project$Cambiatus$InputObject$encodeAddressUpdateInput),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'invitationId', filledInOptionals.kk, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'kyc', filledInOptionals.ib, $author$project$Cambiatus$InputObject$encodeKycDataUpdateInput)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'signUp',
			_Utils_ap(
				optionalArgs,
				_List_fromArray(
					[
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'account', requiredArgs.l8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'email', requiredArgs.jK, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'name', requiredArgs.fj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'publicKey', requiredArgs.k8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'userType', requiredArgs.lU, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
					])),
			object_,
			$elm$core$Basics$identity);
	});
var $author$project$Api$Graphql$signUp = F4(
	function (shared, requiredArgs, fillOptionals, toMsg) {
		return A4(
			$author$project$Api$Graphql$mutation,
			shared,
			$elm$core$Maybe$Nothing,
			A3(
				$author$project$Cambiatus$Mutation$signUp,
				fillOptionals,
				{
					l8: $author$project$Eos$Account$nameToString(requiredArgs._),
					jK: requiredArgs.jK,
					fj: requiredArgs.fj,
					k8: requiredArgs.k8,
					lU: requiredArgs.lU
				},
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Session$token),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Session$user($author$project$Profile$minimalSelectionSet),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Graphql$SignUpResponse)))),
			toMsg);
	});
var $author$project$Page$Register$signUp = F4(
	function (shared, _v0, invitationId, formOutput) {
		var accountName = _v0._;
		var ownerKey = _v0.kW;
		var _v1 = $author$project$Page$Register$getSignUpFields(formOutput);
		var email = _v1.jK;
		var name = _v1.fj;
		var _v2 = function () {
			switch (formOutput.$) {
				case 2:
					return _Utils_Tuple2($dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent);
				case 0:
					var f = formOutput.a;
					return _Utils_Tuple2(
						$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							{
								a6: '1',
								eT: f.eT,
								eU: $author$project$Page$Register$NaturalForm$documentTypeToString(f.eU),
								fq: f.o7,
								lU: 'natural'
							}),
						$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent);
				default:
					var f = formOutput.a;
					return _Utils_Tuple2(
						$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							{
								a6: '1',
								eT: f.eT,
								eU: $author$project$Page$Register$JuridicalForm$companyTypeToString(f.mC),
								fq: f.fq,
								lU: 'juridical'
							}),
						$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							{
								eG: f.mt.w,
								a6: '1',
								fk: f.m0.w,
								d2: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(f.d2),
								fI: f.Z.w,
								fK: f.fK,
								fY: f.fY
							}));
			}
		}();
		var kycOpts = _v2.a;
		var addressOpts = _v2.b;
		var fillOptionals = function (opts) {
			return _Utils_update(
				opts,
				{
					ht: addressOpts,
					kk: A2(
						$elm$core$Maybe$withDefault,
						$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
						A2($elm$core$Maybe$map, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present, invitationId)),
					ib: kycOpts
				});
		};
		return A4(
			$author$project$Api$Graphql$signUp,
			shared,
			{
				_: accountName,
				jK: email,
				fj: name,
				k8: ownerKey,
				lU: function () {
					if (formOutput.$ === 1) {
						return 'juridical';
					} else {
						return 'natural';
					}
				}()
			},
			fillOptionals,
			$author$project$Page$Register$CompletedSignUp);
	});
var $author$project$Form$withShowAllErrors = F2(
	function (showAllErrors, _v0) {
		var model = _v0;
		var _v1 = model.aT;
		var errorTracking = _v1;
		return _Utils_update(
			model,
			{
				aT: _Utils_update(
					errorTracking,
					{fD: showAllErrors})
			});
	});
var $author$project$Page$Register$withShowAllErrors = F2(
	function (showAllErrors, formModel) {
		switch (formModel.$) {
			case 0:
				var form = formModel.a;
				return $author$project$Page$Register$NaturalForm(
					A2($author$project$Form$withShowAllErrors, showAllErrors, form));
			case 1:
				var form = formModel.a;
				return $author$project$Page$Register$JuridicalForm(
					A2($author$project$Form$withShowAllErrors, showAllErrors, form));
			default:
				var form = formModel.a;
				return $author$project$Page$Register$DefaultForm(
					A2($author$project$Form$withShowAllErrors, showAllErrors, form));
		}
	});
var $author$project$Page$Register$update = F4(
	function (_v0, msg, model, guest) {
		var shared = guest.A;
		var scrollTop = $author$project$UpdateResult$addCmd(
			A2(
				$elm$core$Task$attempt,
				function (_v13) {
					return $author$project$Page$Register$NoOp;
				},
				A2($elm$browser$Browser$Dom$setViewport, 0, 0)));
		var _v1 = shared.aw;
		var t = _v1.fL;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var community = msg.a;
				var canRegister = community.bx || (!_Utils_eq(model.kk, $elm$core$Maybe$Nothing));
				return canRegister ? A4($author$project$Page$Register$loadedCommunity, shared, model, community, model.dO) : A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$author$project$Route$pushUrl,
						shared.kK,
						$author$project$Route$Join(guest.me)),
					$author$project$UpdateResult$init(model));
			case 11:
				var accountType = msg.a;
				var selectedKycForm = function () {
					if (!accountType.$) {
						return $author$project$Page$Register$NaturalForm($author$project$Page$Register$NaturalForm$init);
					} else {
						var country = accountType.a;
						return $author$project$Page$Register$JuridicalForm(
							$author$project$Page$Register$JuridicalForm$init(country));
					}
				}();
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							pN: A2(
								$author$project$Page$Register$FormShowed,
								{hk: $elm$core$Set$empty},
								selectedKycForm)
						}));
			case 2:
				var formOutput = msg.a;
				var isAvailable = msg.b;
				var account = $author$project$Page$Register$getSignUpFields(formOutput).l8;
				if (isAvailable) {
					return A2(
						$author$project$UpdateResult$addPort,
						{
							bZ: $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string('generateKeys')),
										_Utils_Tuple2(
										'account',
										$author$project$Eos$Account$encodeName(account))
									])),
							fy: A2($author$project$Page$Register$GotAccountAvailabilityResponse, formOutput, isAvailable),
							fz: $author$project$Page$Register$encodeFormOutput(formOutput)
						},
						$author$project$UpdateResult$init(model));
				} else {
					var newStatus = function () {
						var _v4 = model.pN;
						if (_v4.$ === 2) {
							var unavailableAccounts = _v4.a.hk;
							var formModel = _v4.b;
							return A2(
								$author$project$Page$Register$FormShowed,
								{
									hk: A2(
										$elm$core$Set$insert,
										$author$project$Eos$Account$nameToString(account),
										unavailableAccounts)
								},
								A2($author$project$Page$Register$withShowAllErrors, true, formModel));
						} else {
							return model.pN;
						}
					}();
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{pN: newStatus}));
				}
			case 3:
				if (msg.b.$ === 1) {
					var v = msg.b.a;
					return A7(
						$author$project$UpdateResult$logDecodingError,
						msg,
						$elm$core$Maybe$Nothing,
						'Could not decode account keys',
						{e$: 'update', fi: 'Page.Register'},
						_List_Nil,
						v,
						$author$project$UpdateResult$init(model));
				} else {
					var formOutput = msg.a;
					var accountKeys = msg.b.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						A4($author$project$Page$Register$signUp, shared, accountKeys, model.kk, formOutput),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									fZ: $elm$core$Maybe$Just(accountKeys)
								})));
				}
			case 4:
				var val = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{e0: val}));
			case 7:
				var elementId = msg.a;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(elementId)),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('copyToClipboard'))
								])),
						fy: $author$project$Page$Register$CopiedToClipboard,
						fz: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(model));
			case 8:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{gI: true}));
			case 5:
				var passphrase = msg.a.bp;
				var accountName = msg.a._;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('downloadAuthPdfFromRegistration')),
									_Utils_Tuple2(
									'accountName',
									$elm$json$Json$Encode$string(accountName)),
									_Utils_Tuple2(
									'passphrase',
									$elm$json$Json$Encode$string(passphrase))
								])),
						fy: $author$project$Page$Register$PdfDownloaded,
						fz: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(model));
			case 6:
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$author$project$Route$replaceUrl,
						shared.kK,
						A2($author$project$Route$Login, guest.kC, guest.me)),
					$author$project$UpdateResult$init(model));
			case 12:
				switch (msg.a.$) {
					case 3:
						var _v5 = model.fZ;
						if (_v5.$ === 1) {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed signing up, but didn\'t have account keys',
								$elm$core$Maybe$Nothing,
								{e$: 'update', fi: 'Page.Register'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						} else {
							var accountKeys = _v5.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pN: $author$project$Page$Register$AccountCreated(accountKeys),
										fJ: 1
									}));
						}
					case 2:
						var error = msg.a.a;
						return scrollTop(
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Nothing,
								'Got an error when trying to sign up',
								{e$: 'update', fi: 'Page.Register'},
								_List_Nil,
								error,
								A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$Guest$SetFeedback(
										A2(
											$author$project$View$Feedback$Visible,
											1,
											t('register.account_error.title'))),
									$author$project$UpdateResult$init(model))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 9:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var invitation = msg.a.a.a;
							return A4(
								$author$project$Page$Register$loadedCommunity,
								shared,
								model,
								invitation.V,
								$elm$core$Maybe$Just(invitation));
						} else {
							var _v6 = msg.a.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{pN: $author$project$Page$Register$NotFound}));
						}
					case 2:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Nothing,
							'Got an error when trying to load invite',
							{e$: 'update', fi: 'Page.Register'},
							_List_Nil,
							error,
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$Guest$SetFeedback(
									A2(
										$author$project$View$Feedback$Visible,
										1,
										t('error.unknown'))),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{pN: $author$project$Page$Register$ErrorShowed}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 10:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var country = msg.a.a.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										mP: $elm$core$Maybe$Just(country),
										pN: $author$project$Page$Register$AccountTypeSelectorShowed
									}));
						} else {
							var _v7 = msg.a.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{pN: $author$project$Page$Register$NotFound}));
						}
					case 2:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Nothing,
							'Got an error when loading country data',
							{e$: 'update', fi: 'Page.Register'},
							_List_Nil,
							error,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{pN: $author$project$Page$Register$ErrorShowed})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 13:
				var subMsg = msg.a;
				var _v8 = _Utils_Tuple2(model.pN, subMsg);
				_v8$3:
				while (true) {
					if (_v8.a.$ === 2) {
						switch (_v8.a.b.$) {
							case 0:
								if (_v8.b.$ === 1) {
									var _v9 = _v8.a;
									var isAccountTaken = _v9.a;
									var formModel = _v9.b.a;
									var formMsg = _v8.b.a;
									return A5(
										$author$project$UpdateResult$fromChild,
										function (newForm) {
											return _Utils_update(
												model,
												{
													pN: A2(
														$author$project$Page$Register$FormShowed,
														isAccountTaken,
														$author$project$Page$Register$NaturalForm(newForm))
												});
										},
										A2($elm$core$Basics$composeR, $author$project$Page$Register$NaturalFormMsg, $author$project$Page$Register$GotFormMsg),
										A2($elm$core$Basics$composeR, $author$project$Session$Guest$SetFeedback, $author$project$UpdateResult$addExt),
										model,
										A3($author$project$Form$update, shared, formMsg, formModel));
								} else {
									break _v8$3;
								}
							case 1:
								if (!_v8.b.$) {
									var _v10 = _v8.a;
									var isAccountTaken = _v10.a;
									var formModel = _v10.b.a;
									var formMsg = _v8.b.a;
									return A5(
										$author$project$UpdateResult$fromChild,
										function (newForm) {
											return _Utils_update(
												model,
												{
													pN: A2(
														$author$project$Page$Register$FormShowed,
														isAccountTaken,
														$author$project$Page$Register$JuridicalForm(newForm))
												});
										},
										A2($elm$core$Basics$composeR, $author$project$Page$Register$JuridicalFormMsg, $author$project$Page$Register$GotFormMsg),
										A2($elm$core$Basics$composeR, $author$project$Session$Guest$SetFeedback, $author$project$UpdateResult$addExt),
										model,
										A3($author$project$Form$update, shared, formMsg, formModel));
								} else {
									break _v8$3;
								}
							default:
								if (_v8.b.$ === 2) {
									var _v11 = _v8.a;
									var isAccountTaken = _v11.a;
									var formModel = _v11.b.a;
									var formMsg = _v8.b.a;
									return A5(
										$author$project$UpdateResult$fromChild,
										function (newForm) {
											return _Utils_update(
												model,
												{
													pN: A2(
														$author$project$Page$Register$FormShowed,
														isAccountTaken,
														$author$project$Page$Register$DefaultForm(newForm))
												});
										},
										A2($elm$core$Basics$composeR, $author$project$Page$Register$DefaultFormMsg, $author$project$Page$Register$GotFormMsg),
										A2($elm$core$Basics$composeR, $author$project$Session$Guest$SetFeedback, $author$project$UpdateResult$addExt),
										model,
										A3($author$project$Form$update, shared, formMsg, formModel));
								} else {
									break _v8$3;
								}
						}
					} else {
						break _v8$3;
					}
				}
				return $author$project$UpdateResult$init(model);
			default:
				var formOutput = msg.a;
				var account = function () {
					switch (formOutput.$) {
						case 0:
							var output = formOutput.a;
							return output.l8;
						case 1:
							var output = formOutput.a;
							return output.l8;
						default:
							var output = formOutput.a;
							return output.l8;
					}
				}();
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('checkAccountAvailability')),
									_Utils_Tuple2(
									'account',
									$author$project$Eos$Account$encodeName(account))
								])),
						fy: $author$project$Page$Register$SubmittedForm(formOutput),
						fz: $author$project$Page$Register$encodeFormOutput(formOutput)
					},
					$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Settings$Claim = 0;
var $author$project$Page$Settings$Digest = 2;
var $author$project$Page$Settings$FinishedDeletingKyc = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$Settings$SubmittedNewPin = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Settings$Transfer = 1;
var $author$project$Page$Settings$CompletedTogglingNotification = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Page$Settings$UpdatingTo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Settings$Preferences = F3(
	function (transferNotification, claimNotification, digest) {
		return {dq: claimNotification, dx: digest, ep: transferNotification};
	});
var $author$project$Page$Settings$preferencesSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$User$digest,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$User$claimNotification,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$User$transferNotification,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Settings$Preferences))));
var $author$project$Page$Settings$actOnNotificationPreferenceToggle = F3(
	function (loggedIn, notification, newValue) {
		var updatePreferencesMutation = A3(
			$author$project$Session$LoggedIn$mutation,
			loggedIn,
			A2(
				$author$project$Cambiatus$Mutation$preference,
				function (optionalArgs) {
					switch (notification) {
						case 1:
							return _Utils_update(
								optionalArgs,
								{
									ep: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(newValue)
								});
						case 0:
							return _Utils_update(
								optionalArgs,
								{
									dq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(newValue)
								});
						default:
							return _Utils_update(
								optionalArgs,
								{
									dx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(newValue)
								});
					}
				},
				$author$project$Page$Settings$preferencesSelectionSet),
			$author$project$Page$Settings$CompletedTogglingNotification(notification));
		var updateModel = function (model) {
			switch (notification) {
				case 1:
					return _Utils_update(
						model,
						{
							da: $author$project$Page$Settings$UpdatingTo(newValue)
						});
				case 0:
					return _Utils_update(
						model,
						{
							cB: $author$project$Page$Settings$UpdatingTo(newValue)
						});
				default:
					return _Utils_update(
						model,
						{
							cG: $author$project$Page$Settings$UpdatingTo(newValue)
						});
			}
		};
		return A2(
			$elm$core$Basics$composeR,
			$author$project$UpdateResult$mapModel(updateModel),
			$author$project$UpdateResult$addExt(updatePreferencesMutation));
	});
var $author$project$Cambiatus$Mutation$deleteKyc = function (object_) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'deleteKyc',
		_List_Nil,
		object_,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Page$Settings$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var addDownloadPdfPort = function () {
					var _v1 = loggedIn.ml.ak.n2;
					if (_v1.$ === 1) {
						return $elm$core$Basics$identity;
					} else {
						var pin = _v1.a;
						return $author$project$UpdateResult$addPort(
							{
								bZ: $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'name',
											$elm$json$Json$Encode$string('downloadAuthPdfFromProfile')),
											_Utils_Tuple2(
											'pin',
											$elm$json$Json$Encode$string(pin))
										])),
								fy: msg,
								fz: $elm$json$Json$Encode$null
							});
					}
				}();
				return A5(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_Nil,
					model,
					{hS: $author$project$Page$Settings$NoOp, iX: msg},
					addDownloadPdfPort(
						$author$project$UpdateResult$init(model)));
			case 2:
				return A5(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_Nil,
					model,
					{hS: $author$project$Page$Settings$NoOp, iX: msg},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{dT: true})));
			case 3:
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('copyToClipboard')),
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string('private-key-copy-input'))
								])),
						fy: msg,
						fz: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(model));
			case 4:
				return A2(
					$author$project$UpdateResult$addExt,
					A2(
						$author$project$Session$LoggedIn$ShowFeedback,
						0,
						loggedIn.A.aw.fL('settings.account.copied_private_key')),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{dT: false})));
			case 5:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dT: false}));
			case 6:
				var _v2 = $author$project$Page$Settings$initPin(loggedIn);
				var newPin = _v2.a;
				var pinCmd = _v2.b;
				return A2(
					$author$project$UpdateResult$addCmd,
					pinCmd,
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{dV: true, c_: newPin})));
			case 7:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dV: false}));
			case 8:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newPinInput) {
						return _Utils_update(
							model,
							{c_: newPinInput});
					},
					$author$project$Page$Settings$GotPinMsg,
					F2(
						function (ext, ur) {
							if (ext.$ === 1) {
								var feedback = ext.a;
								return A2($author$project$Session$LoggedIn$addFeedback, feedback, ur);
							} else {
								var pin = ext.a;
								var _v4 = A4($author$project$View$Pin$postSubmitAction, ur.ok.c_, pin, loggedIn.A, $author$project$Page$Settings$SubmittedNewPin);
								var newShared = _v4.a;
								var submitCmd = _v4.b;
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$LoggedIn$UpdatedLoggedIn(
										_Utils_update(
											loggedIn,
											{A: newShared})),
									A2(
										$author$project$UpdateResult$addCmd,
										submitCmd,
										A2(
											$author$project$UpdateResult$mapModel,
											function (m) {
												return _Utils_update(
													m,
													{dV: false});
											},
											ur)));
							}
						}),
					model,
					A3($author$project$View$Pin$update, loggedIn.A, subMsg, model.c_));
			case 9:
				var newPin = msg.a;
				var addChangePinPort = function () {
					var _v5 = loggedIn.ml.ak.n2;
					if (_v5.$ === 1) {
						return $elm$core$Basics$identity;
					} else {
						var currentPin = _v5.a;
						return $author$project$UpdateResult$addPort(
							{
								bZ: $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'name',
											$elm$json$Json$Encode$string('changePin')),
											_Utils_Tuple2(
											'currentPin',
											$elm$json$Json$Encode$string(currentPin)),
											_Utils_Tuple2(
											'newPin',
											$elm$json$Json$Encode$string(newPin))
										])),
								fy: msg,
								fz: $elm$json$Json$Encode$string(newPin)
							});
					}
				}();
				return A5(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_Nil,
					model,
					{hS: $author$project$Page$Settings$NoOp, iX: msg},
					addChangePinPort(
						$author$project$UpdateResult$init(model)));
			case 10:
				var newPin = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$ChangedPin(newPin),
					A2(
						$author$project$UpdateResult$addExt,
						A2(
							$author$project$Session$LoggedIn$ShowFeedback,
							0,
							loggedIn.A.aw.fL('profile.pin.successMsg')),
						$author$project$UpdateResult$init(model)));
			case 11:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dQ: true}));
			case 12:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dQ: false}));
			case 13:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$UpdatedLoggedIn(
						_Utils_update(
							loggedIn,
							{pl: $krisajenkins$remotedata$RemoteData$Loading})),
					A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$mutation,
							loggedIn,
							$author$project$Cambiatus$Mutation$deleteKyc($dillonkearns$elm_graphql$Graphql$SelectionSet$empty),
							$author$project$Page$Settings$FinishedDeletingKyc),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{dQ: false}))));
			case 14:
				switch (msg.a.$) {
					case 3:
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								0,
								loggedIn.A.aw.fL('community.kyc.delete.success')),
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$ReloadResource(1),
								$author$project$UpdateResult$init(model)));
					case 1:
						var _v6 = msg.a;
						return $author$project$UpdateResult$init(model);
					case 0:
						var _v7 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when trying to delete KYC',
							{e$: 'update', fi: 'Page.Settings'},
							_List_Nil,
							error,
							$author$project$UpdateResult$init(model));
				}
			case 15:
				var newValue = msg.a;
				return A4(
					$author$project$Page$Settings$actOnNotificationPreferenceToggle,
					loggedIn,
					0,
					newValue,
					$author$project$UpdateResult$init(model));
			case 16:
				var newValue = msg.a;
				return A4(
					$author$project$Page$Settings$actOnNotificationPreferenceToggle,
					loggedIn,
					1,
					newValue,
					$author$project$UpdateResult$init(model));
			case 17:
				var newValue = msg.a;
				return A4(
					$author$project$Page$Settings$actOnNotificationPreferenceToggle,
					loggedIn,
					2,
					newValue,
					$author$project$UpdateResult$init(model));
			default:
				switch (msg.b.$) {
					case 3:
						if (!msg.b.a.$) {
							var preference = msg.a;
							var preferences = msg.b.a.a;
							var newProfile = function () {
								var _v9 = loggedIn.pl;
								if (_v9.$ === 3) {
									var oldProfile = _v9.a;
									return $krisajenkins$remotedata$RemoteData$Success(
										_Utils_update(
											oldProfile,
											{dq: preferences.dq, dx: preferences.dx, ep: preferences.ep}));
								} else {
									return loggedIn.pl;
								}
							}();
							var newModel = function () {
								switch (preference) {
									case 1:
										return _Utils_update(
											model,
											{da: $author$project$Page$Settings$NotUpdating});
									case 0:
										return _Utils_update(
											model,
											{cB: $author$project$Page$Settings$NotUpdating});
									default:
										return _Utils_update(
											model,
											{cG: $author$project$Page$Settings$NotUpdating});
								}
							}();
							return A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$UpdatedLoggedIn(
									_Utils_update(
										loggedIn,
										{pl: newProfile})),
								$author$project$UpdateResult$init(newModel));
						} else {
							var preference = msg.a;
							var _v10 = msg.b.a;
							var newModel = function () {
								switch (preference) {
									case 1:
										return _Utils_update(
											model,
											{da: $author$project$Page$Settings$NotUpdating});
									case 0:
										return _Utils_update(
											model,
											{cB: $author$project$Page$Settings$NotUpdating});
									default:
										return _Utils_update(
											model,
											{cG: $author$project$Page$Settings$NotUpdating});
								}
							}();
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Got Nothing when toggling notification preference',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Settings'},
								_List_Nil,
								A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										1,
										loggedIn.A.aw.fL('profile.preferences.error')),
									$author$project$UpdateResult$init(newModel)));
						}
					case 2:
						var preference = msg.a;
						var err = msg.b.a;
						var newModel = function () {
							switch (preference) {
								case 1:
									return _Utils_update(
										model,
										{da: $author$project$Page$Settings$NotUpdating});
								case 0:
									return _Utils_update(
										model,
										{cB: $author$project$Page$Settings$NotUpdating});
								default:
									return _Utils_update(
										model,
										{cG: $author$project$Page$Settings$NotUpdating});
							}
						}();
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when settings notification preferences',
							{e$: 'update', fi: 'Page.Settings'},
							_List_Nil,
							err,
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									1,
									loggedIn.A.aw.fL('profile.preferences.error')),
								$author$project$UpdateResult$init(newModel)));
					default:
						return $author$project$UpdateResult$init(model);
				}
		}
	});
var $author$project$Page$Shop$GotFiltersFormMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Shop$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$LoadingFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Shop$NoOp = {$: 0};
var $author$project$Shop$isOutOfStock = function (product) {
	var _v0 = product.iT;
	if (!_v0.$) {
		return false;
	} else {
		var availableUnits = _v0.a.jl;
		return !availableUnits;
	}
};
var $author$project$Page$Shop$cardFromSale = function (p) {
	return {
		cE: $elm$core$Maybe$Nothing,
		bD: !$author$project$Shop$isOutOfStock(p),
		c0: $elm$core$Maybe$Nothing,
		pi: p,
		g2: $author$project$Profile$Summary$init(false)
	};
};
var $author$project$Utils$Tree$findInForest = F2(
	function (fn, trees) {
		return A2(
			$elm$core$Maybe$map,
			$zwilias$elm_rosetree$Tree$Zipper$label,
			A2($author$project$Utils$Tree$findZipperInForest, fn, trees));
	});
var $author$project$Page$Shop$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var categories = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							eZ: A2(
								$author$project$Form$updateValues,
								function (values) {
									return _Utils_update(
										values,
										{
											dn: $pzp1997$assoc_list$AssocList$fromList(
												A2(
													$elm$core$List$filterMap,
													function (categoryId) {
														return A2(
															$elm$core$Maybe$map,
															function (category) {
																return _Utils_Tuple2(category, true);
															},
															A2(
																$author$project$Utils$Tree$findInForest,
																function (category) {
																	return _Utils_eq(category.w, categoryId);
																},
																categories));
													},
													model.N.dn))
										});
								},
								model.eZ)
						}));
			case 2:
				switch (msg.a.$) {
					case 3:
						var sales = msg.a.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									a2: $author$project$Page$Shop$Loaded(
										A2($elm$core$List$map, $author$project$Page$Shop$cardFromSale, sales))
								}));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when loading sales from shop',
							{e$: 'update', fi: 'Page.Shop'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										a2: $author$project$Page$Shop$LoadingFailed(err)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 3:
				var res = msg.a;
				if (!res.$) {
					var bals = res.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{hx: bals}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 4:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$ShowCodeOfConductModal,
					$author$project$UpdateResult$init(model));
			case 5:
				var containerId = msg.a.mI;
				var imageId = msg.a.nA;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('smoothHorizontalScroll')),
									_Utils_Tuple2(
									'containerId',
									$elm$json$Json$Encode$string(containerId)),
									_Utils_Tuple2(
									'targetId',
									$elm$json$Json$Encode$string(imageId))
								])),
						fy: $author$project$Page$Shop$NoOp,
						fz: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(model));
			case 6:
				var cardId = msg.a;
				var imageId = msg.b;
				var _v2 = model.a2;
				if (_v2.$ === 1) {
					var cards = _v2.a;
					var newCards = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (card) {
							return _Utils_eq(card.pi.w, cardId);
						},
						function (card) {
							return _Utils_update(
								card,
								{
									cE: $elm$core$Maybe$Just(imageId),
									c0: card.cE
								});
						},
						cards);
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								a2: $author$project$Page$Shop$Loaded(newCards)
							}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 7:
				var cardId = msg.a;
				var imageId = msg.b;
				var _v3 = model.a2;
				if (_v3.$ === 1) {
					var cards = _v3.a;
					var newCards = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (card) {
							return _Utils_eq(card.pi.w, cardId);
						},
						function (card) {
							return _Utils_eq(
								$elm$core$Maybe$Just(imageId),
								card.cE) ? _Utils_update(
								card,
								{cE: card.c0, c0: $elm$core$Maybe$Nothing}) : (_Utils_eq(
								$elm$core$Maybe$Just(imageId),
								card.c0) ? _Utils_update(
								card,
								{c0: $elm$core$Maybe$Nothing}) : card);
						},
						cards);
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								a2: $author$project$Page$Shop$Loaded(newCards)
							}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 8:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dU: true}));
			case 9:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dU: false}));
			case 10:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{eZ: newForm});
					},
					$author$project$Page$Shop$GotFiltersFormMsg,
					$author$project$Session$LoggedIn$addFeedback,
					model,
					A3($author$project$Form$update, loggedIn.A, subMsg, model.eZ));
			default:
				var formOutput = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$author$project$Route$pushUrl,
						loggedIn.A.kK,
						$author$project$Route$Shop(formOutput)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{dU: false})));
		}
	});
var $author$project$Page$Shop$Editor$CompletedSaleLoad = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Shop$Editor$GotSaveResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Shop$Editor$LoadSaleFailed = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Shop$Editor$NoOp = {$: 0};
var $author$project$Page$Shop$Editor$PriceAndInventory = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Page$Shop$Editor$UnauthorizedToEdit = {$: 8};
var $author$project$Cambiatus$Mutation$product = F2(
	function (fillInOptionals, object_) {
		var filledInOptionals = fillInOptionals(
			{dn: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, h5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, iJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, fN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, i5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, i8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'categories',
					filledInOptionals.dn,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'description', filledInOptionals.aR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'id', filledInOptionals.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'images',
					filledInOptionals.h5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'price', filledInOptionals.iJ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'title', filledInOptionals.fN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'trackStock', filledInOptionals.i5, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'units', filledInOptionals.i8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'product',
			optionalArgs,
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Shop$upsert = function (_v0) {
	var id = _v0.w;
	var title = _v0.fN;
	var description = _v0.aR;
	var images = _v0.h5;
	var categories = _v0.dn;
	var price = _v0.iJ;
	var stockTracking = _v0.iT;
	return $author$project$Cambiatus$Mutation$product(
		function (_v1) {
			return {
				dn: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					A2($elm$core$List$map, $author$project$Shop$Category$idToInt, categories)),
				aR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Markdown$toRawString(description)),
				w: function () {
					if (id.$ === 1) {
						return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
					} else {
						var unwrappedId = id.a;
						return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(unwrappedId);
					}
				}(),
				h5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(images),
				iJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(price),
				fN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(title),
				i5: function () {
					if (!stockTracking.$) {
						return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(false);
					} else {
						return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(true);
					}
				}(),
				i8: function () {
					if (!stockTracking.$) {
						return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(0);
					} else {
						var availableUnits = stockTracking.a.jl;
						return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(availableUnits);
					}
				}()
			};
		});
};
var $author$project$Shop$createProduct = F2(
	function (options, selectionSet) {
		return A2(
			$author$project$Shop$upsert,
			{dn: options.dn, aR: options.aR, w: $elm$core$Maybe$Nothing, h5: options.h5, iJ: options.iJ, iT: options.iT, fN: options.fN},
			selectionSet);
	});
var $author$project$Shop$hasUnitTracking = function (product) {
	var _v0 = product.iT;
	if (!_v0.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Page$Shop$Editor$initEditingFormData = F3(
	function (translators, product, step) {
		return {
			dn: $author$project$Form$init(
				A3(
					$elm$core$List$foldl,
					function (category) {
						return A2($pzp1997$assoc_list$AssocList$insert, category, true);
					},
					$pzp1997$assoc_list$AssocList$empty,
					product.dn)),
			C: function () {
				switch (step) {
					case 0:
						return $author$project$Page$Shop$Editor$MainInformation;
					case 1:
						return $author$project$Page$Shop$Editor$Images(
							{aR: product.aR, fN: product.fN});
					case 2:
						return A2(
							$author$project$Page$Shop$Editor$Categories,
							{aR: product.aR, fN: product.fN},
							product.h5);
					default:
						return A3(
							$author$project$Page$Shop$Editor$PriceAndInventory,
							{aR: product.aR, fN: product.fN},
							product.h5,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.w;
								},
								product.dn));
				}
			}(),
			h5: $author$project$Form$init(
				$author$project$Form$File$initMultiple(
					{mj: $elm$core$Maybe$Nothing, nj: product.h5})),
			bF: $author$project$Form$init(
				{
					aR: A2(
						$author$project$Form$RichText$initModel,
						'product-description-editor',
						$elm$core$Maybe$Just(product.aR)),
					fN: product.fN
				}),
			cg: $author$project$Form$init(
				{
					iJ: A3($author$project$Eos$formatSymbolAmount, translators, product.as, product.iJ),
					eo: $author$project$Shop$hasUnitTracking(product),
					db: function () {
						var _v1 = product.iT;
						if (!_v1.$) {
							return $elm$core$String$fromInt(0);
						} else {
							var availableUnits = _v1.a.jl;
							return $elm$core$String$fromInt(availableUnits);
						}
					}()
				})
		};
	});
var $author$project$Page$Shop$Editor$setCurrentStepInRoute = F2(
	function (model, step) {
		var _v0 = model.pN;
		switch (_v0.$) {
			case 0:
				return $elm$core$Maybe$Just(
					$author$project$Route$NewSale(step));
			case 1:
				return $elm$core$Maybe$Just(
					$author$project$Route$NewSale(step));
			case 2:
				return $elm$core$Maybe$Nothing;
			case 3:
				var product = _v0.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Route$EditSale, product.w, step));
			case 4:
				var product = _v0.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Route$EditSale, product.w, step));
			case 5:
				var product = _v0.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Route$EditSale, product.w, step));
			case 6:
				var product = _v0.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Route$EditSale, product.w, step));
			case 7:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Shop$Editor$setCurrentStepInUrl = F3(
	function (shared, model, step) {
		var _v0 = A2($author$project$Page$Shop$Editor$setCurrentStepInRoute, model, step);
		if (_v0.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var route = _v0.a;
			return A2($author$project$Route$replaceUrl, shared.kK, route);
		}
	});
var $author$project$Page$Shop$Editor$PriceAndInventoryMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Shop$Editor$updateForm = F3(
	function (shared, formMsg, model) {
		var maybeFormInfo = function () {
			var _v3 = model.pN;
			switch (_v3.$) {
				case 0:
					var form = _v3.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(form, $author$project$Page$Shop$Editor$EditingCreate));
				case 1:
					var form = _v3.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(form, $author$project$Page$Shop$Editor$Creating));
				case 3:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$EditingUpdate(product)));
				case 4:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$Saving(product)));
				case 5:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$EditingUpdateAsAdmin(product)));
				case 6:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$SavingAsAdmin(product)));
				case 2:
					return $elm$core$Maybe$Nothing;
				case 7:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		if (maybeFormInfo.$ === 1) {
			return $author$project$UpdateResult$init(model);
		} else {
			var _v1 = maybeFormInfo.a;
			var formData = _v1.a;
			var updateStatus = _v1.b;
			switch (formMsg.$) {
				case 0:
					var subMsg = formMsg.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newMainInformation) {
							return _Utils_update(
								model,
								{
									pN: updateStatus(
										_Utils_update(
											formData,
											{bF: newMainInformation}))
								});
						},
						A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$MainInformationMsg),
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, shared, subMsg, formData.bF));
				case 1:
					var subMsg = formMsg.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newImagesForm) {
							return _Utils_update(
								model,
								{
									pN: updateStatus(
										_Utils_update(
											formData,
											{h5: newImagesForm}))
								});
						},
						A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$ImagesMsg),
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, shared, subMsg, formData.h5));
				case 2:
					var subMsg = formMsg.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newCategoriesForm) {
							return _Utils_update(
								model,
								{
									pN: updateStatus(
										_Utils_update(
											formData,
											{dn: newCategoriesForm}))
								});
						},
						A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$CategoriesMsg),
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, shared, subMsg, formData.dn));
				default:
					var subMsg = formMsg.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newPriceAndInventory) {
							return _Utils_update(
								model,
								{
									pN: updateStatus(
										_Utils_update(
											formData,
											{cg: newPriceAndInventory}))
								});
						},
						A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$PriceAndInventoryMsg),
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, shared, subMsg, formData.cg));
			}
		}
	});
var $author$project$Page$Shop$Editor$updateFormStockUnits = F2(
	function (updateFn, model) {
		var maybeFormInfo = function () {
			var _v3 = model.pN;
			switch (_v3.$) {
				case 0:
					var form = _v3.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(form, $author$project$Page$Shop$Editor$EditingCreate));
				case 1:
					var form = _v3.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(form, $author$project$Page$Shop$Editor$Creating));
				case 2:
					return $elm$core$Maybe$Nothing;
				case 3:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$EditingUpdate(product)));
				case 4:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$Saving(product)));
				case 5:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$EditingUpdateAsAdmin(product)));
				case 6:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$SavingAsAdmin(product)));
				case 7:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		if (maybeFormInfo.$ === 1) {
			return $author$project$UpdateResult$init(model);
		} else {
			var _v1 = maybeFormInfo.a;
			var formData = _v1.a;
			var updateStatus = _v1.b;
			return $author$project$UpdateResult$init(
				function (newFormData) {
					return _Utils_update(
						model,
						{
							pN: updateStatus(newFormData)
						});
				}(
					function (priceAndInventory) {
						return _Utils_update(
							formData,
							{cg: priceAndInventory});
					}(
						A2(
							$author$project$Form$updateValues,
							function (values) {
								var _v2 = $elm$core$String$toInt(values.db);
								if (!_v2.$) {
									var unitsInStock = _v2.a;
									return _Utils_update(
										values,
										{
											db: $elm$core$String$fromInt(
												A2(
													$elm$core$Basics$max,
													0,
													updateFn(unitsInStock)))
										});
								} else {
									return values;
								}
							},
							formData.cg))));
		}
	});
var $author$project$Shop$updateProduct = F2(
	function (options, selectionSet) {
		return A2(
			$author$project$Shop$upsert,
			{
				dn: options.dn,
				aR: options.aR,
				w: $elm$core$Maybe$Just(options.w),
				h5: options.h5,
				iJ: options.iJ,
				iT: options.iT,
				fN: options.fN
			},
			selectionSet);
	});
var $author$project$Shop$updateProductCategories = F2(
	function (_v0, selectionSet) {
		var id = _v0.w;
		var categories = _v0.dn;
		var _v1 = id;
		var unwrappedId = _v1;
		return A2(
			$author$project$Cambiatus$Mutation$product,
			function (optionals) {
				return _Utils_update(
					optionals,
					{
						dn: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							A2($elm$core$List$map, $author$project$Shop$Category$idToInt, categories)),
						w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(unwrappedId)
					});
			},
			selectionSet);
	});
var $author$project$Page$Shop$Editor$update = F3(
	function (msg, model, loggedIn) {
		var t = loggedIn.A.aw.fL;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var _v1 = model.pN;
				if (_v1.$ === 2) {
					var productId = _v1.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$query,
							loggedIn,
							$author$project$Shop$productQuery(productId),
							$author$project$Page$Shop$Editor$CompletedSaleLoad),
						$author$project$UpdateResult$init(model));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 2:
				switch (msg.a.$) {
					case 3:
						var maybeSale = msg.a.a;
						var _v2 = _Utils_Tuple2(model.pN, maybeSale);
						if ((_v2.a.$ === 2) && (!_v2.b.$)) {
							var _v3 = _v2.a;
							var step = _v3.b;
							var sale = _v2.b.a;
							if (_Utils_eq(sale.mR, loggedIn._)) {
								return $author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											pN: A2(
												$author$project$Page$Shop$Editor$EditingUpdate,
												sale,
												A3($author$project$Page$Shop$Editor$initEditingFormData, loggedIn.A.aw, sale, step))
										}));
							} else {
								var _v4 = loggedIn.pC;
								if (_v4.$ === 3) {
									var community = _v4.a;
									return _Utils_eq(community.jz, loggedIn._) ? $author$project$UpdateResult$init(
										_Utils_update(
											model,
											{
												pN: A2(
													$author$project$Page$Shop$Editor$EditingUpdateAsAdmin,
													sale,
													A3($author$project$Page$Shop$Editor$initEditingFormData, loggedIn.A.aw, sale, step))
											})) : $author$project$UpdateResult$init(
										_Utils_update(
											model,
											{pN: $author$project$Page$Shop$Editor$UnauthorizedToEdit}));
								} else {
									return A6(
										$author$project$UpdateResult$logImpossible,
										msg,
										'Completed loading sale, but community wasn\'t loaded',
										$elm$core$Maybe$Just(loggedIn._),
										{e$: 'update', fi: 'Page.Shop.Editor'},
										_List_fromArray(
											[
												$author$project$Log$contextFromCommunity(loggedIn.pC)
											]),
										$author$project$UpdateResult$init(model));
								}
							}
						} else {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed loading sale, but sale was unavailable or user wasn\'t editing sale',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Shop.Editor'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when loading sale',
							{e$: 'update', fi: 'Page.Shop.Editor'},
							_List_Nil,
							error,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pN: $author$project$Page$Shop$Editor$LoadSaleFailed(error)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 8:
				switch (msg.a.$) {
					case 3:
						var maybeId = msg.a.a;
						var redirectUrl = function () {
							if (maybeId.$ === 1) {
								return $author$project$Route$Shop(
									{dn: _List_Nil, o1: $elm$core$Maybe$Nothing});
							} else {
								var id = maybeId.a;
								return $author$project$Route$ViewSale(id);
							}
						}();
						var maybeFeedbackMessage = function () {
							var _v7 = model.pN;
							switch (_v7.$) {
								case 1:
									return $elm$core$Maybe$Just('shop.create_offer_success');
								case 4:
									return $elm$core$Maybe$Just('shop.update_offer_success');
								case 6:
									return $elm$core$Maybe$Just('shop.update_offer_success');
								default:
									return $elm$core$Maybe$Nothing;
							}
						}();
						var maybeAddFeedback = function () {
							if (maybeFeedbackMessage.$ === 1) {
								return $elm$core$Basics$identity;
							} else {
								var feedbackMessage = maybeFeedbackMessage.a;
								return $author$project$UpdateResult$addExt(
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										0,
										t(feedbackMessage)));
							}
						}();
						return maybeAddFeedback(
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$DropFromRouteHistoryWhile(
									function (route) {
										switch (route.$) {
											case 41:
												return true;
											case 42:
												return true;
											case 43:
												return true;
											default:
												return false;
										}
									}),
								A2(
									$author$project$UpdateResult$addCmd,
									A2($author$project$Route$replaceUrl, loggedIn.A.kK, redirectUrl),
									$author$project$UpdateResult$init(model))));
					case 2:
						var error = msg.a.a;
						var internalError = loggedIn.A.aw.fL('error.unknown');
						var _v9 = model.pN;
						switch (_v9.$) {
							case 1:
								var form = _v9.a;
								return A7(
									$author$project$UpdateResult$logGraphqlError,
									msg,
									$elm$core$Maybe$Just(loggedIn._),
									'Got an error when creating a shop offer',
									{e$: 'update', fi: 'Page.Shop.Editor'},
									_List_Nil,
									error,
									A2(
										$author$project$UpdateResult$addExt,
										A2($author$project$Session$LoggedIn$ShowFeedback, 1, internalError),
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{
													pN: $author$project$Page$Shop$Editor$EditingCreate(form)
												}))));
							case 4:
								var sale = _v9.a;
								var form = _v9.b;
								return A7(
									$author$project$UpdateResult$logGraphqlError,
									msg,
									$elm$core$Maybe$Just(loggedIn._),
									'Got an error when editing a shop offer',
									{e$: 'update', fi: 'Page.Shop.Editor'},
									_List_Nil,
									error,
									A2(
										$author$project$UpdateResult$addExt,
										A2($author$project$Session$LoggedIn$ShowFeedback, 1, internalError),
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{
													pN: A2($author$project$Page$Shop$Editor$EditingUpdate, sale, form)
												}))));
							case 6:
								var sale = _v9.a;
								var form = _v9.b;
								return A7(
									$author$project$UpdateResult$logGraphqlError,
									msg,
									$elm$core$Maybe$Just(loggedIn._),
									'Got an error when editing a shop offer',
									{e$: 'update', fi: 'Page.Shop.Editor'},
									_List_Nil,
									error,
									A2(
										$author$project$UpdateResult$addExt,
										A2($author$project$Session$LoggedIn$ShowFeedback, 1, internalError),
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{
													pN: A2($author$project$Page$Shop$Editor$EditingUpdateAsAdmin, sale, form)
												}))));
							default:
								return A6(
									$author$project$UpdateResult$logImpossible,
									msg,
									'Saved shop item, but wasn\'t creating or editing',
									$elm$core$Maybe$Just(loggedIn._),
									{e$: 'update', fi: 'Page.Shop.Editor'},
									_List_Nil,
									$author$project$UpdateResult$init(model));
						}
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 3:
				var subMsg = msg.a;
				return A3($author$project$Page$Shop$Editor$updateForm, loggedIn.A, subMsg, model);
			case 4:
				var target = msg.a;
				var formOutput = msg.b;
				var targetCmd = function () {
					switch (target) {
						case 0:
							return A3($author$project$Page$Shop$Editor$setCurrentStepInUrl, loggedIn.A, model, 1);
						case 1:
							var _v13 = $author$project$Page$Shop$Editor$getFormData(model);
							if (_v13.$ === 1) {
								return $elm$core$Platform$Cmd$none;
							} else {
								var formData = _v13.a;
								return $author$project$Utils$spawnMessage(
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$imagesForm(loggedIn.A.aw),
										formData.h5,
										{
											oM: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$ImagesMsg),
											oV: $author$project$Page$Shop$Editor$SubmittedImages(0)
										}));
							}
						default:
							var _v14 = $author$project$Page$Shop$Editor$getFormData(model);
							if (_v14.$ === 1) {
								return $elm$core$Platform$Cmd$none;
							} else {
								var formData = _v14.a;
								return $author$project$Utils$spawnMessage(
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$imagesForm(loggedIn.A.aw),
										formData.h5,
										{
											oM: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$ImagesMsg),
											oV: $author$project$Page$Shop$Editor$SubmittedImages(1)
										}));
							}
					}
				}();
				var maybeCurrentStep = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.C;
					},
					$author$project$Page$Shop$Editor$getFormData(model));
				if ((!maybeCurrentStep.$) && (!maybeCurrentStep.a.$)) {
					var _v11 = maybeCurrentStep.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						targetCmd,
						$author$project$UpdateResult$init(
							A2(
								$author$project$Page$Shop$Editor$setCurrentStep,
								$author$project$Page$Shop$Editor$Images(formOutput),
								model)));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Submitted main information, but was in another step',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Shop.Editor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 5:
				var target = msg.a;
				var formOutput = msg.b;
				var targetTransformation = function () {
					if (!target) {
						return $author$project$UpdateResult$addCmd(
							A3($author$project$Page$Shop$Editor$setCurrentStepInUrl, loggedIn.A, model, 2));
					} else {
						var _v17 = $author$project$Page$Shop$Editor$getFormData(model);
						if (_v17.$ === 1) {
							return $elm$core$Basics$identity;
						} else {
							var formData = _v17.a;
							var _v18 = A2(
								$author$project$Community$getField,
								loggedIn.pC,
								function ($) {
									return $.fC;
								});
							if (_v18.$ === 3) {
								var _v19 = _v18.a;
								var categories = _v19.b;
								return $author$project$UpdateResult$addMsg(
									A3(
										$author$project$Form$parse,
										A2($author$project$Page$Shop$Editor$categoriesForm, loggedIn.A.aw, categories),
										formData.dn,
										{
											oM: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$CategoriesMsg),
											oV: $author$project$Page$Shop$Editor$SubmittedCategories
										}));
							} else {
								return $author$project$UpdateResult$mapModel(
									function (m) {
										return _Utils_update(
											m,
											{dW: true});
									});
							}
						}
					}
				}();
				var maybeCurrentStep = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.C;
					},
					$author$project$Page$Shop$Editor$getFormData(model));
				if ((!maybeCurrentStep.$) && (maybeCurrentStep.a.$ === 1)) {
					var mainInformation = maybeCurrentStep.a.a;
					return targetTransformation(
						$author$project$UpdateResult$init(
							A2(
								$author$project$Page$Shop$Editor$setCurrentStep,
								A2($author$project$Page$Shop$Editor$Categories, mainInformation, formOutput),
								model)));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Submitted images, but was in another step',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Shop.Editor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 6:
				var formOutput = msg.a;
				var maybeCurrentStep = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.C;
					},
					$author$project$Page$Shop$Editor$getFormData(model));
				if ((!maybeCurrentStep.$) && (maybeCurrentStep.a.$ === 2)) {
					var _v21 = maybeCurrentStep.a;
					var mainInformation = _v21.a;
					var images = _v21.b;
					var _v22 = model.pN;
					if (_v22.$ === 5) {
						var sale = _v22.a;
						var formData = _v22.b;
						return A2(
							$author$project$UpdateResult$addExt,
							A3(
								$author$project$Session$LoggedIn$mutation,
								loggedIn,
								A2(
									$author$project$Shop$updateProductCategories,
									{dn: formOutput, w: sale.w},
									$author$project$Shop$idSelectionSet),
								$author$project$Page$Shop$Editor$GotSaveResponse),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pN: A2($author$project$Page$Shop$Editor$SavingAsAdmin, sale, formData)
									})));
					} else {
						return A2(
							$author$project$UpdateResult$addCmd,
							A3($author$project$Page$Shop$Editor$setCurrentStepInUrl, loggedIn.A, model, 3),
							$author$project$UpdateResult$init(
								A2(
									$author$project$Page$Shop$Editor$setCurrentStep,
									A3($author$project$Page$Shop$Editor$PriceAndInventory, mainInformation, images, formOutput),
									model)));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Submitted categories, but was in another step',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Shop.Editor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 7:
				var priceAndInventory = msg.a;
				var maybeCurrentStep = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.C;
					},
					$author$project$Page$Shop$Editor$getFormData(model));
				if ((!maybeCurrentStep.$) && (maybeCurrentStep.a.$ === 3)) {
					var _v24 = maybeCurrentStep.a;
					var mainInformation = _v24.a;
					var images = _v24.b;
					var categories = _v24.c;
					var _v25 = model.pN;
					switch (_v25.$) {
						case 0:
							var formData = _v25.a;
							return A5(
								$author$project$Session$LoggedIn$withPrivateKey,
								loggedIn,
								_List_fromArray(
									[4]),
								model,
								{hS: $author$project$Page$Shop$Editor$NoOp, iX: msg},
								A2(
									$author$project$UpdateResult$addExt,
									A3(
										$author$project$Session$LoggedIn$mutation,
										loggedIn,
										A2(
											$author$project$Shop$createProduct,
											{dn: categories, aR: mainInformation.aR, h5: images, iJ: priceAndInventory.iJ.ji, iT: priceAndInventory.i7, fN: mainInformation.fN},
											$author$project$Shop$idSelectionSet),
										$author$project$Page$Shop$Editor$GotSaveResponse),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{
												pN: $author$project$Page$Shop$Editor$Creating(formData)
											}))));
						case 3:
							var sale = _v25.a;
							var formData = _v25.b;
							return A5(
								$author$project$Session$LoggedIn$withPrivateKey,
								loggedIn,
								_List_fromArray(
									[4]),
								model,
								{hS: $author$project$Page$Shop$Editor$NoOp, iX: msg},
								A2(
									$author$project$UpdateResult$addExt,
									A3(
										$author$project$Session$LoggedIn$mutation,
										loggedIn,
										A2(
											$author$project$Shop$updateProduct,
											{dn: categories, aR: mainInformation.aR, w: sale.w, h5: images, iJ: priceAndInventory.iJ.ji, iT: priceAndInventory.i7, fN: mainInformation.fN},
											$author$project$Shop$idSelectionSet),
										$author$project$Page$Shop$Editor$GotSaveResponse),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{
												pN: A2($author$project$Page$Shop$Editor$Saving, sale, formData)
											}))));
						default:
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Clicked save shop item, but wasn\'t editing or creating shop offer',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'update', fi: 'Page.Shop.Editor'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Submitted price and inventory, but was in another step',
						$elm$core$Maybe$Just(loggedIn._),
						{e$: 'update', fi: 'Page.Shop.Editor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 9:
				return A2(
					$author$project$Page$Shop$Editor$updateFormStockUnits,
					function (price) {
						return price - 1;
					},
					model);
			default:
				return A2(
					$author$project$Page$Shop$Editor$updateFormStockUnits,
					function (price) {
						return price + 1;
					},
					model);
		}
	});
var $author$project$Page$GuestExternal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Viewer$NoOp = {$: 0};
var $author$project$Page$Shop$Viewer$GotFormMsgAsGuest = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Shop$Viewer$updateFormInteraction = F3(
	function (msg, _v0, model) {
		var maxUnits = _v0.$8;
		return A2(
			$author$project$Form$updateValues,
			function (values) {
				return _Utils_update(
					values,
					{
						i8: function () {
							var _v1 = $elm$core$String$toInt(values.i8);
							if (_v1.$ === 1) {
								return values.i8;
							} else {
								var units = _v1.a;
								var newUnits = function () {
									if (msg === 1) {
										if (maxUnits.$ === 1) {
											return units + 1;
										} else {
											var maximum = maxUnits.a;
											return A2($elm$core$Basics$min, maximum, units + 1);
										}
									} else {
										return A2($elm$core$Basics$max, 1, units - 1);
									}
								}();
								return $elm$core$String$fromInt(newUnits);
							}
						}()
					});
			},
			model);
	});
var $author$project$Page$Shop$Viewer$updateAsGuest = F3(
	function (msg, model, guest) {
		switch (msg.$) {
			case 0:
				switch (msg.a.$) {
					case 3:
						var productPreview = msg.a.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									ec: $krisajenkins$remotedata$RemoteData$Success(productPreview)
								}));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Nothing,
							'Got an error when loading sale preview',
							{e$: 'updateAsGuest', fi: 'Page.Shop.Viewer'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										ec: $krisajenkins$remotedata$RemoteData$Failure(err)
									})));
					case 0:
						var _v1 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v2 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 1:
				var subMsg = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							hY: A3(
								$author$project$Page$Shop$Viewer$updateFormInteraction,
								subMsg,
								{$8: $elm$core$Maybe$Nothing},
								model.hY)
						}));
			default:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{hY: newForm});
					},
					$author$project$Page$Shop$Viewer$GotFormMsgAsGuest,
					A2($elm$core$Basics$composeR, $author$project$Session$Guest$SetFeedback, $author$project$UpdateResult$addExt),
					model,
					A3($author$project$Form$update, guest.A, subMsg, model.hY));
		}
	});
var $author$project$Page$Shop$Viewer$ClickedTransfer = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Shop$Viewer$ClosedAuthModal = {$: 0};
var $author$project$Page$Shop$Viewer$CompletedDeleteProduct = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$Shop$Viewer$Deleting = 2;
var $author$project$Page$Shop$Viewer$GotFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Shop$Viewer$Open = 1;
var $author$project$Cambiatus$Mutation$deleteProduct = F2(
	function (requiredArgs, object_) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'deleteProduct',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs.w, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object_,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Shop$deleteProduct = function (_v0) {
	var id = _v0;
	return $author$project$Cambiatus$Mutation$deleteProduct(
		{w: id});
};
var $author$project$Transfer$encodeEosActionData = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from',
				$author$project$Eos$Account$encodeName(data.e_)),
				_Utils_Tuple2(
				'to',
				$author$project$Eos$Account$encodeName(data.fO)),
				_Utils_Tuple2(
				'quantity',
				$author$project$Eos$encodeAsset(data.lW)),
				_Utils_Tuple2(
				'memo',
				$author$project$Markdown$encode(data.kE))
			]));
};
var $author$project$Shop$encodeId = function (_v0) {
	var id = _v0;
	return $elm$json$Json$Encode$int(id);
};
var $author$project$Shop$encodeTransferSale = function (t) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sale_id',
				$author$project$Shop$encodeId(t.w)),
				_Utils_Tuple2(
				'from',
				$author$project$Eos$Account$encodeName(t.e_)),
				_Utils_Tuple2(
				'to',
				$author$project$Eos$Account$encodeName(t.fO)),
				_Utils_Tuple2(
				'quantity',
				$author$project$Eos$encodeAsset(t.po)),
				_Utils_Tuple2(
				'units',
				$elm$json$Json$Encode$int(t.i8))
			]));
};
var $author$project$Shop$getAvailableUnits = function (product) {
	var _v0 = product.iT;
	if (!_v0.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var availableUnits = _v0.a.jl;
		return $elm$core$Maybe$Just(availableUnits);
	}
};
var $author$project$Page$Shop$Viewer$updateAsLoggedIn = F3(
	function (msg, model, loggedIn) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 5:
				if (!msg.a.$) {
					var _v3 = model.pN;
					if (_v3.$ === 3) {
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$author$project$Route$replaceUrl,
								loggedIn.A.kK,
								$author$project$Route$Shop(
									{dn: _List_Nil, o1: $elm$core$Maybe$Nothing})),
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									0,
									t('shop.transfer.success')),
								$author$project$UpdateResult$init(model)));
					} else {
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{e6: false}));
					}
				} else {
					var eosErrorString = msg.a.a;
					var errorMessage = A2($author$project$Eos$EosError$parseTransferError, loggedIn.A.aw, eosErrorString);
					return A2(
						$author$project$UpdateResult$addExt,
						A2($author$project$Session$LoggedIn$ShowFeedback, 1, errorMessage),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{e6: false})));
				}
			case 1:
				switch (msg.a.$) {
					case 3:
						var maybeSale = msg.a.a;
						if (maybeSale.$ === 1) {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Couldn\'t find the sale',
								$elm$core$Maybe$Just(loggedIn._),
								{e$: 'updateAsLoggedIn', fi: 'Page.Shop.Viewer'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						} else {
							var sale = maybeSale.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pN: $krisajenkins$remotedata$RemoteData$Success(sale)
									}));
						}
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn._),
							'Got an error when trying to load shop sale',
							{e$: 'updateAsLoggedIn', fi: 'Page.Shop.Viewer'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										pN: $krisajenkins$remotedata$RemoteData$Failure(err)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 3:
				var sale = msg.a;
				var formOutput = msg.b;
				var value = {ji: sale.iJ * formOutput.i8, as: sale.as};
				var unitPrice = {ji: sale.iJ, as: sale.as};
				var authorization = {hr: loggedIn._, iF: $author$project$Eos$Account$samplePermission};
				return A5(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_fromArray(
						[3]),
					model,
					{hS: $author$project$Page$Shop$Viewer$ClosedAuthModal, iX: msg},
					A2(
						$author$project$UpdateResult$addPort,
						{
							bZ: $author$project$Eos$encodeTransaction(
								_List_fromArray(
									[
										{
										_: loggedIn.A.hL.p5,
										hw: authorization,
										bZ: $author$project$Transfer$encodeEosActionData(
											{e_: loggedIn._, kE: formOutput.kE, fO: sale.mR, lW: value}),
										fj: 'transfer'
									},
										{
										_: loggedIn.A.hL.V,
										hw: authorization,
										bZ: $author$project$Shop$encodeTransferSale(
											{e_: loggedIn._, w: sale.w, po: unitPrice, fO: sale.mR, i8: formOutput.i8}),
										fj: 'transfersale'
									}
									])),
							fy: A2($author$project$Page$Shop$Viewer$ClickedTransfer, sale, formOutput),
							fz: $elm$json$Json$Encode$null
						},
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{e6: true}))));
			case 4:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{hY: newForm});
					},
					$author$project$Page$Shop$Viewer$GotFormMsg,
					$author$project$Session$LoggedIn$addFeedback,
					model,
					A3($author$project$Form$update, loggedIn.A, subMsg, model.hY));
			case 2:
				var res = msg.a;
				if (!res.$) {
					var bals = res.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{hx: bals}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 6:
				var subMsg = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							hY: A3(
								$author$project$Page$Shop$Viewer$updateFormInteraction,
								subMsg,
								{
									$8: function () {
										var _v5 = model.pN;
										if (_v5.$ === 3) {
											var product = _v5.a;
											return $author$project$Shop$getAvailableUnits(product);
										} else {
											return $elm$core$Maybe$Nothing;
										}
									}()
								},
								model.hY)
						}));
			case 7:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dR: true}));
			case 8:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dR: false}));
			case 9:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{a5: 1}));
			case 10:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{a5: 0}));
			case 11:
				var _v6 = model.pN;
				if (_v6.$ === 3) {
					var sale = _v6.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$mutation,
							loggedIn,
							A2($author$project$Shop$deleteProduct, sale.w, $dillonkearns$elm_graphql$Graphql$SelectionSet$empty),
							$author$project$Page$Shop$Viewer$CompletedDeleteProduct),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{a5: 2})));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			default:
				switch (msg.a.$) {
					case 3:
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$author$project$Route$pushUrl,
								loggedIn.A.kK,
								$author$project$Route$Shop(
									{dn: _List_Nil, o1: $elm$core$Maybe$Nothing})),
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									0,
									t('shop.delete_offer_success')),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{a5: 0}))));
					case 2:
						var err = msg.a.a;
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								t('shop.delete_offer_failure')),
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Just(loggedIn._),
								'Got an error when deleting product',
								{e$: 'updateAsLoggedIn', fi: 'Page.Shop.Viewer'},
								_List_Nil,
								err,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{a5: 0, dR: false}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
		}
	});
var $author$project$Page$Shop$Viewer$update = F3(
	function (msg, model, session) {
		var _v0 = _Utils_Tuple3(msg, model.pN, session);
		_v0$10:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return $author$project$UpdateResult$init(model);
				case 1:
					var containerId = _v0.a.a.mI;
					var imageId = _v0.a.a.nA;
					return A2(
						$author$project$UpdateResult$addPort,
						{
							bZ: $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string('smoothHorizontalScroll')),
										_Utils_Tuple2(
										'containerId',
										$elm$json$Json$Encode$string(containerId)),
										_Utils_Tuple2(
										'targetId',
										$elm$json$Json$Encode$string(imageId))
									])),
							fy: $author$project$Page$Shop$Viewer$NoOp,
							fz: $elm$json$Json$Encode$null
						},
						$author$project$UpdateResult$init(model));
				case 2:
					var imageId = _v0.a.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								cE: $elm$core$Maybe$Just(imageId),
								c0: model.cE
							}));
				case 3:
					var imageId = _v0.a.a;
					return _Utils_eq(
						$elm$core$Maybe$Just(imageId),
						model.cE) ? $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{cE: model.c0, c0: $elm$core$Maybe$Nothing})) : (_Utils_eq(
						$elm$core$Maybe$Just(imageId),
						model.c0) ? $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{c0: $elm$core$Maybe$Nothing})) : $author$project$UpdateResult$init(model));
				case 4:
					var _v2 = _v0.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{cQ: true}));
				case 5:
					var _v3 = _v0.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{cQ: false}));
				case 6:
					var sale = _v0.a.a;
					var shared = $author$project$Page$toShared(session);
					var sharePort = shared.jq ? {
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('share')),
									_Utils_Tuple2(
									'title',
									$elm$json$Json$Encode$string(sale.fN)),
									_Utils_Tuple2(
									'text',
									$elm$json$Json$Encode$string(
										$author$project$Markdown$toUnformattedString(sale.aR))),
									_Utils_Tuple2(
									'url',
									$elm$json$Json$Encode$string(
										$elm$url$Url$toString(
											A2(
												$author$project$Route$addRouteToUrl,
												shared,
												$author$project$Route$ViewSale(sale.w)))))
								])),
						fy: msg,
						fz: $elm$json$Json$Encode$null
					} : {
						bZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('copyToClipboard')),
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string('share-fallback-input'))
								])),
						fy: msg,
						fz: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'type',
									$elm$json$Json$Encode$string('copyToClipboard'))
								]))
					};
					return A2(
						$author$project$UpdateResult$addPort,
						sharePort,
						$author$project$UpdateResult$init(model));
				case 7:
					var _v4 = _v0.a;
					var shared = $author$project$Page$toShared(session);
					var feedbackExternalMsg = function () {
						if (session.$ === 1) {
							return $author$project$Page$LoggedInExternal(
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									0,
									shared.aw.fL('copied_to_clipboard')));
						} else {
							return $author$project$Page$GuestExternal(
								$author$project$Session$Guest$SetFeedback(
									A2(
										$author$project$View$Feedback$Visible,
										0,
										shared.aw.fL('copied_to_clipboard'))));
						}
					}();
					return A2(
						$author$project$UpdateResult$addExt,
						feedbackExternalMsg,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{cQ: false})));
				case 8:
					if ((!_v0.b.$) && (!_v0.c.$)) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						var guest = _v0.c.a;
						return A4(
							$author$project$UpdateResult$map,
							function (guestModel) {
								return _Utils_update(
									model,
									{
										pN: $author$project$Page$Shop$Viewer$AsGuest(guestModel)
									});
							},
							$author$project$Page$Shop$Viewer$AsGuestMsg,
							A2($elm$core$Basics$composeR, $author$project$Page$GuestExternal, $author$project$UpdateResult$addExt),
							A3($author$project$Page$Shop$Viewer$updateAsGuest, subMsg, subModel, guest));
					} else {
						break _v0$10;
					}
				default:
					if ((_v0.b.$ === 1) && (_v0.c.$ === 1)) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						var loggedIn = _v0.c.a;
						return A4(
							$author$project$UpdateResult$map,
							function (loggedInModel) {
								return _Utils_update(
									model,
									{
										pN: $author$project$Page$Shop$Viewer$AsLoggedIn(loggedInModel)
									});
							},
							$author$project$Page$Shop$Viewer$AsLoggedInMsg,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Session$LoggedIn$mapExternal($author$project$Page$Shop$Viewer$AsLoggedInMsg),
								A2($elm$core$Basics$composeR, $author$project$Page$LoggedInExternal, $author$project$UpdateResult$addExt)),
							A3($author$project$Page$Shop$Viewer$updateAsLoggedIn, subMsg, subModel, loggedIn));
					} else {
						break _v0$10;
					}
			}
		}
		return A5(
			$author$project$UpdateResult$logIncompatibleMsg,
			msg,
			$author$project$Page$maybeAccountName(session),
			{e$: 'update', fi: 'Page.Shop.Viewer'},
			_List_Nil,
			$author$project$UpdateResult$init(model));
	});
var $author$project$Page$ViewTransfer$LoadFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$ViewTransfer$Loaded = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Cambiatus$Enum$TransferDirectionValue$Sending = 1;
var $author$project$Page$ViewTransfer$findDirection = F2(
	function (maybeTransfer, _v0) {
		var accountName = _v0._;
		if (!maybeTransfer.$) {
			var transfer = maybeTransfer.a;
			return _Utils_eq(transfer.fO.l8, accountName) ? 0 : 1;
		} else {
			return 1;
		}
	});
var $author$project$Transfer$updateProfileSummaries = F3(
	function (profileSummaries, isLeft, profileSummaryMsg) {
		return isLeft ? _Utils_update(
			profileSummaries,
			{
				bE: A2($author$project$Profile$Summary$update, profileSummaryMsg, profileSummaries.bE)
			}) : _Utils_update(
			profileSummaries,
			{
				li: A2($author$project$Profile$Summary$update, profileSummaryMsg, profileSummaries.li)
			});
	});
var $author$project$Page$ViewTransfer$updateStatus = F2(
	function (status, model) {
		return _Utils_update(
			model,
			{pN: status});
	});
var $author$project$Page$ViewTransfer$update = F3(
	function (msg, model, user) {
		if (!msg.$) {
			switch (msg.a.$) {
				case 3:
					var transfer = msg.a.a;
					var summary = $author$project$Profile$Summary$init(false);
					var direction = A2($author$project$Page$ViewTransfer$findDirection, transfer, user);
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								pN: A3(
									$author$project$Page$ViewTransfer$Loaded,
									transfer,
									direction,
									{bE: summary, li: summary})
							}));
				case 2:
					var error = msg.a.a;
					return A7(
						$author$project$UpdateResult$logGraphqlError,
						msg,
						$elm$core$Maybe$Just(user._),
						'Got an error when loading transfer',
						{e$: 'update', fi: 'Page.ViewTransfer'},
						_List_Nil,
						error,
						$author$project$UpdateResult$init(
							A2(
								$author$project$Page$ViewTransfer$updateStatus,
								$author$project$Page$ViewTransfer$LoadFailed(error),
								model)));
				default:
					return $author$project$UpdateResult$init(model);
			}
		} else {
			var isLeft = msg.a;
			var subMsg = msg.b;
			var _v1 = model.pN;
			if (_v1.$ === 2) {
				var maybeTransfer = _v1.a;
				var direction = _v1.b;
				var profileSummaries = _v1.c;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							pN: A3(
								$author$project$Page$ViewTransfer$Loaded,
								maybeTransfer,
								direction,
								A3($author$project$Transfer$updateProfileSummaries, profileSummaries, isLeft, subMsg))
						}));
			} else {
				return A6(
					$author$project$UpdateResult$logImpossible,
					msg,
					'Got a Profile.Summary.Msg, but transfer wasn\'t loaded',
					$elm$core$Maybe$Just(user._),
					{e$: 'update', fi: 'Page.ViewTransfer'},
					_List_Nil,
					$author$project$UpdateResult$init(model));
			}
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		update:
		while (true) {
			var withSession = function (fn) {
				return fn(model.c);
			};
			var withLoggedIn = function (fn) {
				var _v20 = model.c;
				if (!_v20.$) {
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Log$send,
							$author$project$Main$msgToString,
							{
								mL: _List_Nil,
								n4: 1,
								oa: {e$: 'update', fi: 'Main'},
								of: 'Expected user to be logged in, but they\'re a guest',
								pY: _List_fromArray(
									[
										$author$project$Log$IncompatibleAuthentication(0)
									]),
								p7: msg,
								qh: $elm$core$Maybe$Nothing
							}));
				} else {
					var loggedIn = _v20.a;
					return fn(loggedIn);
				}
			};
			var withGuest = function (fn) {
				var _v19 = model.c;
				if (!_v19.$) {
					var guest = _v19.a;
					return fn(guest);
				} else {
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Log$send,
							$author$project$Main$msgToString,
							{
								mL: _List_Nil,
								n4: 1,
								oa: {e$: 'update', fi: 'Main'},
								of: 'Expected user to be a guest, but they\'re logged in',
								pY: _List_fromArray(
									[
										$author$project$Log$IncompatibleAuthentication(1)
									]),
								p7: msg,
								qh: $elm$core$Maybe$Nothing
							}));
				}
			};
			var _v7 = _Utils_Tuple2(msg, model.pN);
			_v7$46:
			while (true) {
				switch (_v7.a.$) {
					case 0:
						var _v8 = _v7.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 1:
						var url = _v7.a.a;
						return A2(
							$author$project$Main$changeRouteTo,
							$author$project$Route$fromUrl(url),
							model);
					case 2:
						var urlRequest = _v7.a.a;
						if (!urlRequest.$) {
							var url = urlRequest.a;
							return _Utils_Tuple2(
								$author$project$Main$hideFeedback(model),
								A2(
									$elm$browser$Browser$Navigation$pushUrl,
									function ($) {
										return $.kK;
									}(
										$author$project$Page$toShared(model.c)),
									$elm$url$Url$toString(url)));
						} else {
							var href = urlRequest.a;
							return _Utils_Tuple2(
								$author$project$Main$hideFeedback(model),
								$elm$browser$Browser$Navigation$load(href));
						}
					case 3:
						var val = _v7.a.a;
						var jsAddressResult = A2(
							$elm$json$Json$Decode$decodeValue,
							A2(
								$elm$json$Json$Decode$field,
								'address',
								$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
							val);
						if (!jsAddressResult.$) {
							var jsAddress = jsAddressResult.a;
							var _v11 = A2($author$project$Main$jsAddressToMsg, jsAddress, val);
							if (_v11.$ === 1) {
								return _Utils_Tuple2(
									model,
									A2(
										$author$project$Log$send,
										$author$project$Main$msgToString,
										A5(
											$author$project$Log$fromImpossible,
											msg,
											'Got invalid address from JavaScript',
											$author$project$Page$maybeAccountName(model.c),
											{e$: 'update', fi: 'Main'},
											_List_fromArray(
												[
													{
													ng: $elm$core$Dict$fromList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'address',
																A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, jsAddress))
															])),
													fj: 'Data'
												}
												]))));
							} else {
								var jsMsg = _v11.a;
								var $temp$msg = jsMsg,
									$temp$model = model;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
							}
						} else {
							var decodeError = jsAddressResult.a;
							return _Utils_Tuple2(
								model,
								A2(
									$author$project$Log$send,
									$author$project$Main$msgToString,
									A6(
										$author$project$Log$fromDecodeError,
										msg,
										$author$project$Page$maybeAccountName(model.c),
										'Could not decode JavaScript address',
										{e$: 'update', fi: 'Main'},
										_List_Nil,
										decodeError)));
						}
					case 4:
						var subMsg = _v7.a.a;
						return A3(
							$author$project$UpdateResult$toModelCmd,
							$author$project$Main$updateExternal,
							$author$project$Main$msgToString,
							A4(
								$author$project$UpdateResult$map,
								function (s) {
									return _Utils_update(
										model,
										{c: s});
								},
								$author$project$Main$GotPageMsg,
								F2(
									function (extMsg, uR) {
										return A2($author$project$UpdateResult$addExt, extMsg, uR);
									}),
								A2($author$project$Page$update, subMsg, model.c)));
					case 36:
						if (_v7.b.$ === 36) {
							var subMsg = _v7.a.a;
							var _v12 = _v7.b;
							var maybeInvitation = _v12.a;
							var maybeRedirect = _v12.b;
							var subModel = _v12.c;
							return withGuest(
								A2(
									$elm$core$Basics$composeR,
									A3($author$project$Page$Register$update, maybeInvitation, subMsg, subModel),
									A3(
										$author$project$Main$updateGuestUResult,
										A2($author$project$Main$Register, maybeInvitation, maybeRedirect),
										$author$project$Main$GotRegisterMsg,
										model)));
						} else {
							break _v7$46;
						}
					case 37:
						if (_v7.b.$ === 37) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Settings$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Settings, $author$project$Main$GotSettingsMsg, model)));
						} else {
							break _v7$46;
						}
					case 29:
						if (_v7.b.$ === 3) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$PaymentHistory$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$PaymentHistory, $author$project$Main$GotPaymentHistoryMsg, model)));
						} else {
							break _v7$46;
						}
					case 27:
						if (_v7.b.$ === 28) {
							var subMsg = _v7.a.a;
							var _v13 = _v7.b;
							var maybeRedirect = _v13.a;
							var subModel = _v13.b;
							return withGuest(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Login$update, subMsg, subModel),
									A3(
										$author$project$Main$updateGuestUResult,
										$author$project$Main$Login(maybeRedirect),
										$author$project$Main$GotLoginMsg,
										model)));
						} else {
							break _v7$46;
						}
					case 28:
						if (_v7.b.$ === 29) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$News$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$News, $author$project$Main$GotNewsMsg, model)));
						} else {
							break _v7$46;
						}
					case 5:
						if (_v7.b.$ === 26) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Notification$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Notification, $author$project$Main$GotNotificationMsg, model)));
						} else {
							break _v7$46;
						}
					case 6:
						if (_v7.b.$ === 4) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$About$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunityAbout, $author$project$Main$GotCommunityAboutMsg, model)));
						} else {
							break _v7$46;
						}
					case 7:
						if (_v7.b.$ === 5) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Objectives$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunityObjectives, $author$project$Main$GotCommunityObjectivesMsg, model)));
						} else {
							break _v7$46;
						}
					case 8:
						if (_v7.b.$ === 6) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$New$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunityEditor, $author$project$Main$GotCommunityEditorMsg, model)));
						} else {
							break _v7$46;
						}
					case 21:
						if (_v7.b.$ === 21) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$Objectives$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsObjectives, $author$project$Main$GotCommunitySettingsObjectivesMsg, model)));
						} else {
							break _v7$46;
						}
					case 22:
						if (_v7.b.$ === 22) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$ObjectiveEditor$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsObjectiveEditor, $author$project$Main$GotCommunitySettingsObjectiveEditorMsg, model)));
						} else {
							break _v7$46;
						}
					case 26:
						if (_v7.b.$ === 27) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Dashboard$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Dashboard, $author$project$Main$GotDashboardMsg, model)));
						} else {
							break _v7$46;
						}
					case 30:
						if (_v7.b.$ === 30) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Profile$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Profile, $author$project$Main$GotProfileMsg, model)));
						} else {
							break _v7$46;
						}
					case 31:
						if (_v7.b.$ === 31) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Profile$Contributions$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$ProfileContributions, $author$project$Main$GotProfileContributionsMsg, model)));
						} else {
							break _v7$46;
						}
					case 32:
						if (_v7.b.$ === 32) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Profile$Editor$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$ProfileEditor, $author$project$Main$GotProfileEditorMsg, model)));
						} else {
							break _v7$46;
						}
					case 33:
						if (_v7.b.$ === 33) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Profile$AddKyc$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$ProfileAddKyc, $author$project$Main$GotProfileAddKycMsg, model)));
						} else {
							break _v7$46;
						}
					case 34:
						if (_v7.b.$ === 34) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Profile$Claims$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$ProfileClaims, $author$project$Main$GotProfileClaimsMsg, model)));
						} else {
							break _v7$46;
						}
					case 35:
						if (_v7.b.$ === 35) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Profile$AddContact$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$ProfileAddContact, $author$project$Main$GotProfileAddContactMsg, model)));
						} else {
							break _v7$46;
						}
					case 9:
						if (_v7.b.$ === 7) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$Settings$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettings, $author$project$Main$GotCommunitySettingsMsg, model)));
						} else {
							break _v7$46;
						}
					case 10:
						if (_v7.b.$ === 8) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$Shop$Categories$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsShopCategories, $author$project$Main$GotCommunitySettingsShopCategoriesMsg, model)));
						} else {
							break _v7$46;
						}
					case 11:
						if (_v7.b.$ === 9) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$Features$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsFeatures, $author$project$Main$GotCommunitySettingsFeaturesMsg, model)));
						} else {
							break _v7$46;
						}
					case 12:
						if (_v7.b.$ === 10) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$Info$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsInfo, $author$project$Main$GotCommunitySettingsInfoMsg, model)));
						} else {
							break _v7$46;
						}
					case 13:
						if (_v7.b.$ === 11) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$News$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsNews, $author$project$Main$GotCommunitySettingsNewsMsg, model)));
						} else {
							break _v7$46;
						}
					case 14:
						if (_v7.b.$ === 12) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$News$Editor$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsNewsEditor, $author$project$Main$GotCommunitySettingsNewsEditorMsg, model)));
						} else {
							break _v7$46;
						}
					case 15:
						if (_v7.b.$ === 13) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$Currency$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsCurrency, $author$project$Main$GotCommunitySettingsCurrencyMsg, model)));
						} else {
							break _v7$46;
						}
					case 16:
						if (_v7.b.$ === 14) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$Sponsorship$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsSponsorship, $author$project$Main$GotCommunitySettingsSponsorshipMsg, model)));
						} else {
							break _v7$46;
						}
					case 17:
						if (_v7.b.$ === 15) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$Sponsorship$Fiat$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsSponsorshipFiat, $author$project$Main$GotCommunitySettingsSponsorshipFiatMsg, model)));
						} else {
							break _v7$46;
						}
					case 18:
						if (_v7.b.$ === 16) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsSponsorshipThankYouMessage, $author$project$Main$GotCommunitySettingsSponsorshipThankYouMessageMsg, model)));
						} else {
							break _v7$46;
						}
					case 19:
						if (_v7.b.$ === 19) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Sponsor$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySponsor, $author$project$Main$GotCommunitySponsorMsg, model)));
						} else {
							break _v7$46;
						}
					case 20:
						if (_v7.b.$ === 20) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Supporters$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySupporters, $author$project$Main$GotCommunitySupportersMsg, model)));
						} else {
							break _v7$46;
						}
					case 38:
						if (_v7.b.$ === 38) {
							var subMsg = _v7.a.a;
							var _v14 = _v7.b;
							var maybeFilter = _v14.a;
							var subModel = _v14.b;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Shop$update, subMsg, subModel),
									A3(
										$author$project$Main$updateLoggedInUResult,
										$author$project$Main$Shop(maybeFilter),
										$author$project$Main$GotShopMsg,
										model)));
						} else {
							break _v7$46;
						}
					case 39:
						if (_v7.b.$ === 39) {
							var subMsg = _v7.a.a;
							var _v15 = _v7.b;
							var id = _v15.a;
							var subModel = _v15.b;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Shop$Editor$update, subMsg, subModel),
									A3(
										$author$project$Main$updateLoggedInUResult,
										$author$project$Main$ShopEditor(id),
										$author$project$Main$GotShopEditorMsg,
										model)));
						} else {
							break _v7$46;
						}
					case 40:
						if (_v7.b.$ === 40) {
							var subMsg = _v7.a.a;
							var _v16 = _v7.b;
							var saleId = _v16.a;
							var subModel = _v16.b;
							return withSession(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Shop$Viewer$update, subMsg, subModel),
									A3(
										$author$project$Main$updatePageUResult,
										$author$project$Main$ShopViewer(saleId),
										$author$project$Main$GotShopViewerMsg,
										model)));
						} else {
							break _v7$46;
						}
					case 23:
						if (_v7.b.$ === 23) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$ActionEditor$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsActionEditor, $author$project$Main$GotCommunitySettingsActionEditorMsg, model)));
						} else {
							break _v7$46;
						}
					case 24:
						if (_v7.b.$ === 24) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Settings$Contacts$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunitySettingsContacts, $author$project$Main$GotCommunitySettingsContactsMsg, model)));
						} else {
							break _v7$46;
						}
					case 25:
						if (_v7.b.$ === 25) {
							var subMsg = _v7.a.a;
							var _v17 = _v7.b;
							var objectiveId = _v17.a;
							var actionId = _v17.b;
							var subModel = _v17.c;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Dashboard$Claim$update, subMsg, subModel),
									A3(
										$author$project$Main$updateLoggedInUResult,
										A2($author$project$Main$Claim, objectiveId, actionId),
										$author$project$Main$GotVerifyClaimMsg,
										model)));
						} else {
							break _v7$46;
						}
					case 41:
						if (_v7.b.$ === 41) {
							var subMsg = _v7.a.a;
							var _v18 = _v7.b;
							var transferId = _v18.a;
							var subModel = _v18.b;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$ViewTransfer$update, subMsg, subModel),
									A3(
										$author$project$Main$updateLoggedInUResult,
										$author$project$Main$ViewTransfer(transferId),
										$author$project$Main$GotViewTransferScreenMsg,
										model)));
						} else {
							break _v7$46;
						}
					case 42:
						if (_v7.b.$ === 42) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return A4(
								$author$project$Main$updateLoggedInUResult,
								$author$project$Main$Invite,
								$author$project$Main$GotInviteMsg,
								model,
								A3($author$project$Page$Community$Invite$update, model.c, subMsg, subModel));
						} else {
							break _v7$46;
						}
					case 43:
						if (_v7.b.$ === 43) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return A4(
								$author$project$Main$updateLoggedInUResult,
								$author$project$Main$Join,
								$author$project$Main$GotJoinMsg,
								model,
								A3($author$project$Page$Join$update, model.c, subMsg, subModel));
						} else {
							break _v7$46;
						}
					case 44:
						if (_v7.b.$ === 44) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Transfer$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Transfer, $author$project$Main$GotTransferMsg, model)));
						} else {
							break _v7$46;
						}
					default:
						if (_v7.b.$ === 45) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Dashboard$Analysis$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Analysis, $author$project$Main$GotAnalysisMsg, model)));
						} else {
							break _v7$46;
						}
				}
			}
			return _Utils_Tuple2(
				model,
				A2(
					$author$project$Log$addBreadcrumb,
					$author$project$Main$msgToString,
					{f7: msg, bZ: $elm$core$Dict$empty, n4: 3, of: 'Msg does not correspond with Model', eq: 3}));
		}
	});
var $author$project$Main$updateExternal = F2(
	function (extMsg, model) {
		if (!extMsg.$) {
			switch (extMsg.a.$) {
				case 0:
					var _v1 = extMsg.a;
					var _v2 = model.bU;
					if (_v2.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var aMsg = _v2.a;
						return A2(
							$author$project$Main$update,
							aMsg.iX,
							_Utils_update(
								model,
								{bU: $elm$core$Maybe$Nothing}));
					}
				case 1:
					var _v3 = extMsg.a;
					var _v4 = model.bU;
					if (_v4.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var aMsg = _v4.a;
						return A2(
							$author$project$Main$update,
							aMsg.hS,
							_Utils_update(
								model,
								{bU: $elm$core$Maybe$Nothing}));
					}
				case 2:
					var callback = extMsg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bV: A2($elm$core$List$cons, callback, model.bV)
							}),
						$elm$core$Platform$Cmd$none);
				case 3:
					var callback = extMsg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bV: A2(
									$elm$core$List$cons,
									function (token) {
										return A2(
											$elm$core$Platform$Cmd$map,
											A2($elm$core$Basics$composeR, $author$project$Page$GotLoggedInMsg, $author$project$Main$GotPageMsg),
											callback(token));
									},
									model.bV)
							}),
						$elm$core$Platform$Cmd$none);
				case 4:
					var authToken = extMsg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bV: _List_Nil}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								function (callback) {
									return callback(authToken);
								},
								model.bV)));
				case 5:
					var callbackMsg = extMsg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								di: A2(
									$elm$core$List$cons,
									$author$project$Main$GotPageMsg(
										$author$project$Page$GotLoggedInMsg(callbackMsg)),
									model.di)
							}),
						$elm$core$Platform$Cmd$none);
				case 6:
					var _v5 = extMsg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{di: _List_Nil}),
						$elm$core$Platform$Cmd$batch(
							A2($elm$core$List$map, $author$project$Utils$spawnMessage, model.di)));
				case 7:
					var broadcastMsg = extMsg.a.a;
					var _v6 = model.c;
					if (_v6.$ === 1) {
						var loggedIn = _v6.a;
						return _Utils_Tuple2(
							model,
							A3($author$project$Main$broadcast, loggedIn, broadcastMsg, model.pN));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				default:
					var subExternalMsg = extMsg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$Utils$spawnMessage(subExternalMsg));
			}
		} else {
			var broadcastMsg = extMsg.a;
			return _Utils_Tuple2(
				model,
				A2($author$project$Main$broadcastGuest, broadcastMsg, model.pN));
		}
	});
var $author$project$Session$LoggedIn$Analysis = {$: 43};
var $author$project$Session$LoggedIn$Claim = {$: 27};
var $author$project$Session$Guest$ComingSoon = 2;
var $author$project$Session$LoggedIn$ComingSoon = {$: 2};
var $author$project$Session$LoggedIn$CommunityAbout = {$: 6};
var $author$project$Session$LoggedIn$CommunityEditor = {$: 18};
var $author$project$Session$LoggedIn$CommunityObjectives = {$: 7};
var $author$project$Session$LoggedIn$CommunitySelector = {$: 19};
var $author$project$Session$LoggedIn$CommunitySettings = {$: 8};
var $author$project$Session$LoggedIn$CommunitySettingsActionEditor = {$: 25};
var $author$project$Session$LoggedIn$CommunitySettingsContacts = {$: 26};
var $author$project$Session$LoggedIn$CommunitySettingsCurrency = {$: 13};
var $author$project$Session$LoggedIn$CommunitySettingsFeatures = {$: 14};
var $author$project$Session$LoggedIn$CommunitySettingsInfo = {$: 10};
var $author$project$Session$LoggedIn$CommunitySettingsNews = {$: 11};
var $author$project$Session$LoggedIn$CommunitySettingsNewsEditor = {$: 12};
var $author$project$Session$LoggedIn$CommunitySettingsObjectiveEditor = {$: 24};
var $author$project$Session$LoggedIn$CommunitySettingsObjectives = {$: 23};
var $author$project$Session$LoggedIn$CommunitySettingsShopCategories = {$: 9};
var $author$project$Session$LoggedIn$CommunitySettingsSponsorship = {$: 15};
var $author$project$Session$LoggedIn$CommunitySettingsSponsorshipFiat = {$: 16};
var $author$project$Session$LoggedIn$CommunitySettingsSponsorshipThankYouMessage = {$: 17};
var $author$project$Session$LoggedIn$CommunitySponsor = {$: 21};
var $author$project$Session$LoggedIn$CommunitySupporters = {$: 22};
var $author$project$Session$LoggedIn$CommunityThankYou = {$: 20};
var $author$project$Session$LoggedIn$Dashboard = {$: 4};
var $elm$browser$Browser$Document = F2(
	function (title, body) {
		return {f6: body, fN: title};
	});
var $author$project$Session$Guest$Invite = 5;
var $author$project$Session$LoggedIn$Invite = {$: 3};
var $author$project$Session$Guest$Join = 6;
var $author$project$Session$LoggedIn$Join = {$: 44};
var $author$project$Session$Guest$Login = 4;
var $author$project$Session$LoggedIn$News = function (a) {
	return {$: 5, a: a};
};
var $author$project$Session$Guest$NotFound = 1;
var $author$project$Session$LoggedIn$NotFound = {$: 1};
var $author$project$Session$LoggedIn$Notification = {$: 28};
var $author$project$Session$LoggedIn$PaymentHistory = {$: 40};
var $author$project$Session$LoggedIn$Profile = {$: 33};
var $author$project$Session$LoggedIn$ProfileAddContact = {$: 39};
var $author$project$Session$LoggedIn$ProfileAddKyc = {$: 37};
var $author$project$Session$LoggedIn$ProfileClaims = {$: 38};
var $author$project$Session$LoggedIn$ProfileContributions = {$: 35};
var $author$project$Session$LoggedIn$ProfileEditor = {$: 36};
var $author$project$Session$Guest$Redirect = 0;
var $author$project$Session$LoggedIn$Redirect = {$: 0};
var $author$project$Session$Guest$Register = 3;
var $author$project$Session$LoggedIn$Settings = {$: 29};
var $author$project$Session$LoggedIn$Shop = {$: 30};
var $author$project$Session$LoggedIn$ShopEditor = {$: 31};
var $author$project$Session$Guest$ShopViewer = 7;
var $author$project$Session$LoggedIn$ShopViewer = {$: 32};
var $author$project$Session$LoggedIn$Transfer = {$: 41};
var $author$project$Session$LoggedIn$ViewTransfer = {$: 42};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Page$viewTitle = function (text_) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-lg font-bold my-3')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text_)
			]));
};
var $author$project$Page$ComingSoon$view = function (session) {
	var shared = $author$project$Page$toShared(session);
	return {
		mJ: A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$viewTitle(
					shared.aw.fL('menu.coming_soon')),
					$elm$html$Html$text(
					shared.aw.fL('menu.coming_soon'))
				])),
		fN: shared.aw.fL('menu.coming_soon')
	};
};
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel = $elm$html$Html$Attributes$attribute('aria-label');
var $author$project$Page$fullPageGraphQLError = F2(
	function (title_, e) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto container p-16 flex flex-wrap')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-2xl font-bold text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title_)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Graphql$errorToString(e))
								]))
						])),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full'),
							$elm$html$Html$Attributes$src('/images/error.svg')
						]),
					_List_Nil)
				]));
	});
var $author$project$View$Components$loadingLogoWithCustomText = F3(
	function (_v0, customTextKey, class_) {
		var t = _v0.fL;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full text-center ' + class_)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-16 mx-auto mt-8'),
							$elm$html$Html$Attributes$src('/images/loading.svg')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold text-xl')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('loading.title'))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-sm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t(customTextKey))
						]))
				]));
	});
var $author$project$View$Components$loadingLogoAnimated = F2(
	function (translators, class_) {
		return A3($author$project$View$Components$loadingLogoWithCustomText, translators, 'loading.subtitle', class_);
	});
var $author$project$Page$fullPageLoading = function (_v0) {
	var translators = _v0.aw;
	return A2($author$project$View$Components$loadingLogoAnimated, translators, '');
};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$Attributes$media = _VirtualDom_attribute('media');
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Page$Community$About$showNewsCard = function (community) {
	return community.dH;
};
var $author$project$Page$Community$About$showSupportersCard = function (community) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.o5;
			},
			community.mM));
};
var $elm$html$Html$source = _VirtualDom_node('source');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Page$Community$About$ClickedShareCommunity = {$: 3};
var $author$project$Form$Text$TextareaInput = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $author$project$Contact$typeToAriaLabel = F2(
	function (_v0, type_) {
		var t = _v0.fL;
		switch (type_) {
			case 3:
				return t('contact_form.reach_out.phone');
			case 1:
				return t('contact_form.reach_out.instagram');
			case 4:
				return t('contact_form.reach_out.telegram');
			case 5:
				return t('contact_form.reach_out.whatsapp');
			case 0:
				return t('contact_form.reach_out.email');
			default:
				return t('contact_form.reach_out.link');
		}
	});
var $author$project$Icons$instagram = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('#E1306C'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12.0005 0.36364C8.84036 0.36364 8.44377 0.377458 7.20259 0.433943C5.96384 0.49067 5.11829 0.686791 4.37843 0.974549C3.61312 1.27176 2.96393 1.66934 2.31716 2.31637C1.66991 2.96316 1.27235 3.61237 0.974173 4.37746C0.685697 5.11758 0.48934 5.9634 0.433584 7.2017C0.37807 8.44291 0.363525 8.83976 0.363525 12C0.363525 15.1602 0.377586 15.5556 0.433827 16.7969C0.490794 18.0356 0.68691 18.8812 0.974416 19.6211C1.27186 20.3864 1.66943 21.0356 2.31644 21.6824C2.96296 22.3297 3.61215 22.7282 4.37698 23.0255C5.11732 23.3132 5.96311 23.5093 7.20162 23.5661C8.4428 23.6226 8.83915 23.6364 11.9991 23.6364C15.1594 23.6364 15.5548 23.6226 16.796 23.5661C18.0347 23.5093 18.8813 23.3132 19.6216 23.0255C20.3867 22.7282 21.0349 22.3297 21.6814 21.6824C22.3287 21.0356 22.7262 20.3864 23.0244 19.6213C23.3105 18.8812 23.5068 18.0354 23.565 16.7971C23.6208 15.5559 23.6353 15.1602 23.6353 12C23.6353 8.83976 23.6208 8.44316 23.565 7.20194C23.5068 5.96316 23.3105 5.11758 23.0244 4.3777C22.7262 3.61237 22.3287 2.96316 21.6814 2.31637C21.0342 1.66909 20.3869 1.27152 19.6209 0.974549C18.8791 0.686791 18.0331 0.49067 16.7943 0.433943C15.5531 0.377458 15.158 0.36364 11.9969 0.36364H12.0005ZM10.9567 2.46061C11.2665 2.46012 11.6122 2.46061 12.0005 2.46061C15.1073 2.46061 15.4756 2.47176 16.7024 2.52752C17.8369 2.5794 18.4527 2.76897 18.8628 2.92825C19.4059 3.13916 19.793 3.39128 20.2 3.79855C20.6073 4.20582 20.8594 4.5937 21.0708 5.13673C21.23 5.54643 21.4199 6.16219 21.4715 7.29673C21.5272 8.5234 21.5394 8.89188 21.5394 11.9973C21.5394 15.1028 21.5272 15.4713 21.4715 16.6979C21.4196 17.8325 21.23 18.4482 21.0708 18.8579C20.8599 19.401 20.6073 19.7876 20.2 20.1947C19.7928 20.6019 19.4061 20.8541 18.8628 21.065C18.4532 21.225 17.8369 21.4141 16.7024 21.4659C15.4758 21.5217 15.1073 21.5338 12.0005 21.5338C8.89345 21.5338 8.52522 21.5217 7.29859 21.4659C6.16408 21.4136 5.54834 21.224 5.13793 21.0647C4.59491 20.8538 4.20705 20.6017 3.79978 20.1944C3.39252 19.7872 3.14041 19.4002 2.92902 18.857C2.76976 18.4473 2.57994 17.8315 2.52831 16.697C2.47255 15.4703 2.4614 15.1018 2.4614 11.9944C2.4614 8.88703 2.47255 8.52049 2.52831 7.29382C2.58019 6.15928 2.76976 5.54352 2.92902 5.13334C3.13993 4.59031 3.39252 4.20243 3.79978 3.79516C4.20705 3.38788 4.59491 3.13576 5.13793 2.92437C5.5481 2.76437 6.16408 2.57528 7.29859 2.52316C8.37201 2.47467 8.788 2.46012 10.9567 2.4577V2.46061ZM18.2117 4.39273C17.4408 4.39273 16.8154 5.01746 16.8154 5.78861C16.8154 6.55952 17.4408 7.18497 18.2117 7.18497C18.9826 7.18497 19.608 6.55952 19.608 5.78861C19.608 5.0177 18.9826 4.39225 18.2117 4.39225V4.39273ZM12.0005 6.02425C8.70048 6.02425 6.02493 8.69988 6.02493 12C6.02493 15.3001 8.70048 17.9746 12.0005 17.9746C15.3005 17.9746 17.9751 15.3001 17.9751 12C17.9751 8.69988 15.3003 6.02425 12.0003 6.02425H12.0005ZM12.0005 8.12122C14.1425 8.12122 15.8792 9.8577 15.8792 12C15.8792 14.1421 14.1425 15.8788 12.0005 15.8788C9.85827 15.8788 8.12184 14.1421 8.12184 12C8.12184 9.8577 9.85827 8.12122 12.0005 8.12122Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$link = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('32'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M17.8712 5.87117C18.9662 4.77614 20.4514 4.16095 22 4.16095C23.5486 4.16095 25.0338 4.77614 26.1288 5.87117C27.2239 6.96621 27.839 8.45139 27.839 10C27.839 11.5486 27.2239 13.0338 26.1288 14.1288L20.7994 19.4583C20.261 20.0067 19.6188 20.4424 18.9103 20.7401C18.2 21.0386 17.4372 21.1923 16.6667 21.1923C15.8961 21.1923 15.1334 21.0386 14.423 20.7401C13.7127 20.4416 13.069 20.0044 12.5298 19.454C12.0949 19.0102 12.1022 18.2979 12.546 17.8631C12.9898 17.4283 13.7021 17.4355 14.1369 17.8793C14.4667 18.2159 14.8603 18.4833 15.2947 18.6658C15.729 18.8483 16.1955 18.9423 16.6667 18.9423C17.1378 18.9423 17.6043 18.8483 18.0387 18.6658C18.4731 18.4833 18.8667 18.2159 19.1964 17.8793L19.2045 17.8711L19.2045 17.8712L24.5378 12.5378C25.2109 11.8648 25.589 10.9519 25.589 10C25.589 9.04813 25.2109 8.13524 24.5378 7.46216C23.8648 6.78908 22.9519 6.41095 22 6.41095C21.0481 6.41095 20.1352 6.78908 19.4622 7.46216L18.7955 8.12883C18.3562 8.56817 17.6438 8.56817 17.2045 8.12883C16.7652 7.68949 16.7652 6.97718 17.2045 6.53784L17.8712 5.87117Z'),
						$elm$svg$Svg$Attributes$fill('#F99D33')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M13.0897 11.2599C13.8 10.9614 14.5628 10.8077 15.3333 10.8077C16.1039 10.8077 16.8666 10.9614 17.577 11.2599C18.2873 11.5584 18.931 11.9956 19.4702 12.546C19.9051 12.9898 19.8978 13.7021 19.454 14.1369C19.0102 14.5717 18.2979 14.5645 17.8631 14.1207C17.5333 13.7841 17.1397 13.5167 16.7053 13.3342C16.271 13.1517 15.8045 13.0577 15.3333 13.0577C14.8622 13.0577 14.3957 13.1517 13.9613 13.3342C13.5269 13.5167 13.1333 13.7841 12.8036 14.1207L12.7955 14.1289L12.7955 14.1288L7.46216 19.4622C6.78908 20.1352 6.41095 21.0481 6.41095 22C6.41095 22.9519 6.78908 23.8648 7.46216 24.5378C8.13524 25.2109 9.04813 25.589 10 25.589C10.9519 25.589 11.8648 25.2109 12.5378 24.5378L13.2045 23.8712C13.6438 23.4318 14.3562 23.4318 14.7955 23.8712C15.2348 24.3105 15.2348 25.0228 14.7955 25.4622L14.1288 26.1288C13.0338 27.2239 11.5486 27.839 10 27.839C8.45139 27.839 6.9662 27.2239 5.87117 26.1288C4.77614 25.0338 4.16095 23.5486 4.16095 22C4.16095 20.4514 4.77614 18.9662 5.87117 17.8712L11.2007 12.5417C11.7391 11.9933 12.3812 11.5576 13.0897 11.2599Z'),
						$elm$svg$Svg$Attributes$fill('#F99D33')
					]),
				_List_Nil)
			]));
};
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$Attributes$strokeOpacity = _VirtualDom_attribute('stroke-opacity');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $author$project$Icons$mail = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 20'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M6 5H18C18.825 5 19.5 5.5625 19.5 6.25V13.75C19.5 14.4375 18.825 15 18 15H6C5.175 15 4.5 14.4375 4.5 13.75V6.25C4.5 5.5625 5.175 5 6 5Z'),
						$elm$svg$Svg$Attributes$stroke('#F99D33'),
						$elm$svg$Svg$Attributes$strokeOpacity('0.8'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M19.5 6.25L12 10.625L4.5 6.25'),
						$elm$svg$Svg$Attributes$stroke('#F99D33'),
						$elm$svg$Svg$Attributes$strokeOpacity('0.8'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$phoneInverted = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M18.4342 14.729L16.6993 12.9878C16.351 12.6268 15.93 12.4337 15.4804 12.4337C15.034 12.4337 14.6098 12.6237 14.252 12.9814L13.3593 13.871C13.3498 13.8647 13.3403 13.8615 13.3276 13.8552C13.2991 13.8425 13.2738 13.8267 13.2453 13.8109C13.1345 13.7571 13.0332 13.7032 12.9509 13.6526C12.0328 13.0701 11.197 12.3071 10.396 11.3257C10.0509 10.8888 9.8103 10.5247 9.62984 10.1543C9.82613 9.96749 10.0129 9.78071 10.1934 9.59708L10.2599 9.5306C10.3042 9.48628 10.3485 9.43879 10.3928 9.39447C10.4371 9.35015 10.4815 9.30582 10.5258 9.2615C10.8899 8.89742 11.0862 8.46686 11.0862 8.02047C11.0862 7.57408 10.893 7.14669 10.5258 6.77944L9.6615 5.91515C9.56336 5.81701 9.46522 5.71887 9.37024 5.61756C9.18345 5.42444 8.98084 5.21866 8.76872 5.02237C8.42364 4.68046 8.00574 4.5 7.56568 4.5C7.12562 4.5 6.70139 4.68046 6.34365 5.02554L5.26091 6.11777C4.82085 6.55783 4.57075 7.09603 4.51376 7.71971C4.43461 8.68214 4.71321 9.57176 4.93166 10.1574C5.45403 11.5694 6.23601 12.8706 7.38839 14.2573C8.79405 15.9384 10.4878 17.2617 12.419 18.1956C13.1693 18.5502 14.1697 18.9681 15.2841 19.0378C15.3569 19.0409 15.4266 19.0441 15.4931 19.0441C16.2846 19.0441 16.9494 18.7592 17.4718 18.1925L17.4939 18.1672V18.164C17.4939 18.1608 17.4971 18.1608 17.4971 18.1577C17.6396 17.9835 17.8073 17.8221 17.9846 17.6511L18.0258 17.61C18.1904 17.4517 18.3234 17.3187 18.4437 17.1952C18.7951 16.8311 18.9787 16.4038 18.9787 15.9574C18.9819 15.511 18.7919 15.0836 18.4342 14.729ZM9.36391 8.63782L9.36074 8.64099C9.07898 8.92908 8.83837 9.16652 8.5756 9.40713C8.56927 9.41346 8.55661 9.42296 8.54394 9.43879C8.17037 9.82186 8.297 10.2239 8.34133 10.3569L8.35399 10.3917L8.35716 10.3981C8.58827 10.9553 8.91119 11.484 9.40823 12.114L9.41773 12.1266C10.3073 13.2189 11.2413 14.0705 12.2734 14.7227C12.4127 14.8113 12.5488 14.8778 12.6818 14.9443C12.7926 14.9981 12.8939 15.0519 12.9794 15.1026L12.9984 15.1121C13.011 15.1184 13.0237 15.1279 13.0332 15.1342C13.1693 15.2007 13.3023 15.2355 13.4384 15.2355C13.7867 15.2355 13.9956 15.0266 14.0653 14.9569L15.148 13.8742C15.2303 13.7919 15.3506 13.6969 15.4804 13.6969C15.6134 13.6969 15.7274 13.7982 15.7843 13.8615L17.5414 15.6186C17.7662 15.8402 17.782 16.0333 17.5952 16.2581C17.5952 16.2581 16.7404 17.1066 16.5378 17.344C16.2592 17.6416 15.93 17.7777 15.4994 17.7777C15.4551 17.7777 15.4076 17.7777 15.3664 17.7746C14.461 17.7176 13.6125 17.3599 12.973 17.0528C11.2065 16.198 9.65517 14.9823 8.36982 13.4468C7.30924 12.1678 6.59375 10.9806 6.1252 9.71106C5.84344 8.95441 5.73896 8.37189 5.78328 7.81785C5.81178 7.4981 5.93525 7.23216 6.16003 7.00422L7.23643 5.92782C7.35357 5.81701 7.47071 5.76002 7.57518 5.76002C7.70498 5.76002 7.81895 5.84867 7.89177 5.92149L7.90443 5.93415C8.08489 6.10194 8.25901 6.27923 8.46796 6.49451C8.51545 6.54517 8.5661 6.59582 8.61359 6.64331L8.61992 6.64964C8.67058 6.70029 8.71807 6.75095 8.77189 6.80477L9.63618 7.66906C9.89261 7.92549 9.89261 8.10595 9.63618 8.35922C9.60452 8.39088 9.57286 8.42254 9.54436 8.45103C9.48105 8.52068 9.42406 8.57767 9.36391 8.63782Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$telegramInverted = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M3.32359 11.7622L7.90888 14.0601C8.08622 14.1481 8.29561 14.1418 8.46514 14.042L12.5465 11.6561L10.0761 13.8574C9.95034 13.9698 9.87846 14.13 9.87846 14.2989V19.6607C9.87846 20.2263 10.5965 20.4644 10.9332 20.015L12.9153 17.3651L17.817 20.1721C18.1607 20.3709 18.6014 20.1713 18.6811 19.7762L21.7382 4.45683C21.8296 3.99647 21.3741 3.62095 20.9507 3.79221L3.37203 10.6859C2.90014 10.8713 2.86967 11.5352 3.32359 11.7622ZM20.3788 5.28172L17.692 18.7447L13.0473 16.0846C12.7942 15.9393 12.4684 16.0037 12.2887 16.2425L11.0504 17.8978V14.5637L17.731 8.61191C18.26 8.14133 17.6521 7.30466 17.0482 7.66132L8.14951 12.8636L5.03067 11.301L20.3788 5.28172Z'),
						$elm$svg$Svg$Attributes$fill('#0088CC')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$whatsappInverted = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M2.18182 21.8182L3.56867 16.7748C2.71144 15.2958 2.26119 13.6181 2.26332 11.9107C2.26332 6.54637 6.65123 2.18182 12.0404 2.18182C13.3251 2.182 14.5971 2.43408 15.7839 2.92364C16.9706 3.41321 18.0488 4.13067 18.9568 5.03504C19.8649 5.93941 20.5849 7.01296 21.0759 8.19436C21.5669 9.37575 21.8191 10.6418 21.8182 11.9203C21.8182 17.2846 17.4296 21.6498 12.0411 21.6498H12.037C10.4046 21.6498 8.7983 21.2425 7.36486 20.4653L2.18182 21.8182ZM7.60456 18.7036L7.90179 18.8787C9.15391 19.6167 10.5824 20.0061 12.0377 20.006H12.0411C16.5201 20.006 20.1656 16.3782 20.1677 11.9189C20.1677 10.6659 19.8752 9.43006 19.3132 8.30882C18.7512 7.18758 17.935 6.21163 16.9292 5.45797C15.9233 4.70431 14.7552 4.19355 13.517 3.96598C12.2789 3.73841 11.0045 3.80026 9.79449 4.14665C8.58445 4.49304 7.47185 5.1145 6.54446 5.96199C5.61706 6.80948 4.90023 7.85983 4.45053 9.03017C4.00083 10.2005 3.83055 11.4588 3.95313 12.7059C4.0757 13.9529 4.48779 15.1545 5.15686 16.216L5.34999 16.522L4.52816 19.5064L7.60456 18.7036Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M16.9666 14.2334C16.9057 14.1318 16.7427 14.0712 16.4982 13.9492C16.2537 13.8272 15.0531 13.2397 14.8292 13.1593C14.6052 13.0789 14.4422 13.0373 14.2813 13.2813C14.1203 13.5253 13.6505 14.0726 13.5081 14.2354C13.3656 14.3983 13.2232 14.4181 12.9787 14.2961C12.7342 14.1741 11.9473 13.9178 11.0145 13.0891C10.2878 12.4444 9.79748 11.6483 9.65572 11.405C9.51395 11.1617 9.64065 11.0302 9.76255 10.9089C9.87282 10.7998 10.007 10.6247 10.129 10.4829C10.2297 10.3589 10.312 10.2212 10.3735 10.074C10.4058 10.0069 10.4209 9.93279 10.4173 9.85843C10.4137 9.78406 10.3916 9.71176 10.3529 9.64803C10.292 9.52604 9.80501 8.32994 9.59956 7.84333C9.40163 7.36626 9.1996 7.43441 9.05167 7.42555C8.90374 7.41669 8.74622 7.41737 8.58322 7.41737C8.45947 7.42062 8.33772 7.44929 8.22564 7.5016C8.11356 7.55391 8.01356 7.62872 7.93192 7.72134C7.70797 7.96464 7.07721 8.55281 7.07721 9.74958C7.07721 10.9464 7.95246 12.1022 8.07505 12.2644C8.19764 12.4266 9.79748 14.8822 12.2486 15.9352C12.7035 16.1304 13.1685 16.3015 13.6416 16.4477C14.1399 16.5983 14.6665 16.6312 15.1798 16.5438C15.6496 16.4756 16.6256 15.9556 16.829 15.3852C17.0324 14.8147 17.0276 14.3349 16.9666 14.2334Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Contact$typeToIconInverted = F2(
	function (class_, type_) {
		switch (type_) {
			case 3:
				return $author$project$Icons$phoneInverted(class_);
			case 1:
				return $author$project$Icons$instagram(class_);
			case 4:
				return $author$project$Icons$telegramInverted(class_);
			case 5:
				return $author$project$Icons$whatsappInverted(class_);
			case 0:
				return $author$project$Icons$mail(class_);
			default:
				return $author$project$Icons$link(class_);
		}
	});
var $author$project$Contact$circularIconWithGrayBgInternal = F3(
	function (attrs, translators, type_) {
		var defaultClass = function () {
			switch (type_) {
				case 5:
					return 'fill-current text-green ';
				case 3:
					return 'fill-current text-orange-500';
				default:
					return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map($elm$core$Basics$never),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('p-2 flex-shrink-0 bg-gray-100 rounded-full flex items-center justify-center'),
					A2(
						$elm$core$List$cons,
						$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							A2($author$project$Contact$typeToAriaLabel, translators, type_)),
						attrs))),
			_List_fromArray(
				[
					A2($author$project$Contact$typeToIconInverted, defaultClass, type_)
				]));
	});
var $author$project$Contact$circularIconWithGrayBg = F3(
	function (attrs, translators, _v0) {
		var valid = _v0;
		return A3($author$project$Contact$circularIconWithGrayBgInternal, attrs, translators, valid.eq);
	});
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Route$href = function (targetRoute) {
	return $elm$html$Html$Attributes$href(
		$author$project$Route$routeToString(targetRoute));
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $author$project$Icons$share = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('20'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M5.42829 12.2863C6.69066 12.2863 7.71401 11.2629 7.71401 10.0006C7.71401 8.73819 6.69066 7.71484 5.42829 7.71484C4.16593 7.71484 3.14258 8.73819 3.14258 10.0006C3.14258 11.2629 4.16593 12.2863 5.42829 12.2863Z'),
								$elm$svg$Svg$Attributes$stroke('#F99D33'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M14.5714 7.71401C15.8337 7.71401 16.8571 6.69066 16.8571 5.42829C16.8571 4.16593 15.8337 3.14258 14.5714 3.14258C13.309 3.14258 12.2856 4.16593 12.2856 5.42829C12.2856 6.69066 13.309 7.71401 14.5714 7.71401Z'),
								$elm$svg$Svg$Attributes$stroke('#F99D33'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M14.5714 16.8576C15.8337 16.8576 16.8571 15.8342 16.8571 14.5718C16.8571 13.3095 15.8337 12.2861 14.5714 12.2861C13.309 12.2861 12.2856 13.3095 12.2856 14.5718C12.2856 15.8342 13.309 16.8576 14.5714 16.8576Z'),
								$elm$svg$Svg$Attributes$stroke('#F99D33'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M7.48535 9.0104L12.5139 6.41992'),
								$elm$svg$Svg$Attributes$stroke('#F99D33'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M7.48535 10.9902L12.5139 13.5807'),
								$elm$svg$Svg$Attributes$stroke('#F99D33'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round')
							]),
						_List_Nil)
					]))
			]));
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Contact$toHref = function (_v0) {
	var valid = _v0;
	var _v1 = valid.eq;
	switch (_v1) {
		case 0:
			return 'mailto:' + valid.lW;
		case 1:
			return valid.lW;
		case 2:
			return valid.lW;
		case 3:
			return 'tel:' + valid.lW;
		case 4:
			return valid.lW;
		default:
			return 'https://api.whatsapp.com/send?phone=' + A2($elm$core$String$filter, $elm$core$Char$isAlphaNum, valid.lW);
	}
};
var $author$project$Contact$typeToString = F2(
	function (translators, type_) {
		return translators.fL(
			function (asString) {
				return 'contact_form.types.' + asString;
			}(
				$elm$core$String$toLower(
					$author$project$Cambiatus$Enum$ContactType$toString(type_))));
	});
var $author$project$Contact$toLabel = F2(
	function (translators, _v0) {
		var valid = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Contact$typeToString, translators, valid.eq),
			valid.n$);
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$View$Components$label = F2(
	function (attrs, _v0) {
		var targetId = _v0.pZ;
		var labelText = _v0.n0;
		return A2(
			$elm$html$Html$label,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('label'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$for(targetId),
					attrs)),
			_List_fromArray(
				[
					$elm$html$Html$text(labelText)
				]));
	});
var $henriquecbuss$elm_mask$Mask$floatString = F3(
	function (decimalDigits, separators, value) {
		var needsZeroDigits = function () {
			_v1$2:
			while (true) {
				if (!decimalDigits.$) {
					if (!decimalDigits.a) {
						return true;
					} else {
						break _v1$2;
					}
				} else {
					if (!decimalDigits.a) {
						return true;
					} else {
						break _v1$2;
					}
				}
			}
			return false;
		}();
		var valueWithTrailingZero = (A2($elm$core$String$endsWith, '.', value) && (!needsZeroDigits)) ? (value + '0') : value;
		return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Just(
			A3($henriquecbuss$elm_mask$Mask$float, decimalDigits, separators, 0)) : A2(
			$elm$core$Maybe$map,
			function (floatValue) {
				var formattedFloat = A3($henriquecbuss$elm_mask$Mask$float, decimalDigits, separators, floatValue);
				if (!decimalDigits.$) {
					return formattedFloat;
				} else {
					var n = decimalDigits.a;
					return ((n > 0) && A2($elm$core$String$endsWith, '.', value)) ? _Utils_ap(formattedFloat, separators.jD) : formattedFloat;
				}
			},
			$elm$core$String$toFloat(valueWithTrailingZero));
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Form$Text$typeToString = function (type_) {
	switch (type_) {
		case 0:
			return 'text';
		case 1:
			return 'tel';
		case 2:
			return 'number';
		case 3:
			return 'url';
		case 4:
			return 'time';
		default:
			return 'password';
	}
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $henriquecbuss$elm_mask$Mask$updateFloatString = F3(
	function (decimalDigits, separators, _v0) {
		var decimalSeparator = separators.jD;
		var previousValue = _v0.pd;
		var newValue = _v0.or;
		var removeZeroes = function (value) {
			var _v6 = $elm$core$String$toFloat(previousValue);
			if (_v6.$ === 1) {
				return value;
			} else {
				var floatValue = _v6.a;
				if (!floatValue) {
					var _v7 = $elm$core$String$toFloat(value);
					if (_v7.$ === 1) {
						return A3($elm$core$String$replace, '0', '', value);
					} else {
						var currentFloatValue = _v7.a;
						return (currentFloatValue >= 1) ? A3($elm$core$String$replace, '0', '', value) : value;
					}
				} else {
					return value;
				}
			}
		};
		var decimalDigitsAmount = function () {
			if (!decimalDigits.$) {
				var x = decimalDigits.a;
				return x;
			} else {
				var x = decimalDigits.a;
				return x;
			}
		}();
		var handleDeletingSeparator = function (value) {
			if (A2($elm$core$String$contains, '.', previousValue) && (!A2($elm$core$String$contains, '.', newValue))) {
				var _v3 = A2($elm$core$String$split, decimalSeparator, value);
				if ((_v3.b && _v3.b.b) && (!_v3.b.b.b)) {
					var beforeSeparator = _v3.a;
					var _v4 = _v3.b;
					var afterSeparator = _v4.a;
					return A2(
						$elm$core$String$endsWith,
						A2($elm$core$String$repeat, decimalDigitsAmount, '0'),
						beforeSeparator) ? _Utils_ap(
						A2($elm$core$String$dropRight, decimalDigitsAmount, beforeSeparator),
						_Utils_ap(decimalSeparator, afterSeparator)) : _Utils_ap(
						beforeSeparator,
						_Utils_ap(decimalSeparator, afterSeparator));
				} else {
					return value;
				}
			} else {
				return value;
			}
		};
		var multiplyBy10 = function (value) {
			var _v1 = A2($elm$core$String$split, '.', value);
			_v1$2:
			while (true) {
				if (_v1.b) {
					if (!_v1.b.b) {
						var beforeSeparator = _v1.a;
						return ($elm$core$String$length(beforeSeparator) === 1) ? ('0.' + (A2($elm$core$String$repeat, decimalDigitsAmount - 1, '0') + beforeSeparator)) : beforeSeparator;
					} else {
						if (!_v1.b.b.b) {
							var beforeSeparator = _v1.a;
							var _v2 = _v1.b;
							var afterSeparator = _v2.a;
							return (_Utils_cmp(
								$elm$core$String$length(afterSeparator),
								decimalDigitsAmount) > 0) ? A2(
								$elm$core$String$join,
								'.',
								_List_fromArray(
									[
										_Utils_ap(
										beforeSeparator,
										A2($elm$core$String$left, 1, afterSeparator)),
										A2($elm$core$String$dropLeft, 1, afterSeparator)
									])) : ((_Utils_cmp(
								$elm$core$String$length(afterSeparator),
								decimalDigitsAmount) < 0) ? A2(
								$elm$core$String$join,
								'.',
								_List_fromArray(
									[
										A2($elm$core$String$dropRight, 1, beforeSeparator),
										_Utils_ap(
										A2($elm$core$String$right, 1, beforeSeparator),
										afterSeparator)
									])) : value);
						} else {
							break _v1$2;
						}
					}
				} else {
					break _v1$2;
				}
			}
			return value;
		};
		return A2(
			$elm$core$Maybe$withDefault,
			previousValue,
			A2(
				$elm$core$Maybe$map,
				handleDeletingSeparator,
				A3(
					$henriquecbuss$elm_mask$Mask$floatString,
					decimalDigits,
					separators,
					removeZeroes(
						multiplyBy10(
							A2($henriquecbuss$elm_mask$Mask$removeFloat, separators, newValue))))));
	});
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Form$Text$viewInput = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		var onChange = viewConfig.oH;
		var value = viewConfig.lW;
		var hasError = viewConfig.no;
		var onBlur = viewConfig.oF;
		var translators = viewConfig.aw;
		var isRequired = viewConfig.nV;
		var paddedTimeValue = function () {
			var _v6 = options.eq;
			if (_v6 === 4) {
				var _v7 = A2($elm$core$String$split, ':', value);
				if ((_v7.b && _v7.b.b) && (!_v7.b.b.b)) {
					var hour = _v7.a;
					var _v8 = _v7.b;
					var minute = _v8.a;
					return A2(
						$elm$core$String$join,
						':',
						_List_fromArray(
							[
								_Utils_ap(
								A2(
									$elm$core$String$repeat,
									2 - $elm$core$String$length(hour),
									'0'),
								hour),
								_Utils_ap(
								A2(
									$elm$core$String$repeat,
									2 - $elm$core$String$length(minute),
									'0'),
								minute)
							]));
				} else {
					return value;
				}
			} else {
				return value;
			}
		}();
		var _v1 = function () {
			var _v2 = options.gG;
			if (!_v2.$) {
				return _Utils_Tuple2(
					$elm$html$Html$input,
					$elm$html$Html$Attributes$type_(
						$author$project$Form$Text$typeToString(options.eq)));
			} else {
				return _Utils_Tuple2(
					$elm$html$Html$textarea,
					$elm$html$Html$Attributes$class(''));
			}
		}();
		var inputElement = _v1.a;
		var typeAttr = _v1.b;
		var _v3 = function () {
			var _v4 = options.gR;
			if ((!_v4.$) && (!_v4.a.$)) {
				var decimalDigits = _v4.a.a;
				var separators = $author$project$Translation$decimalSeparators(translators);
				var decimalDigitsAmount = function () {
					if (!decimalDigits.$) {
						var x = decimalDigits.a;
						return x;
					} else {
						var x = decimalDigits.a;
						return x;
					}
				}();
				var previousDecimalSeparator = (!decimalDigitsAmount) ? separators.jD : A2(
					$elm$core$String$right,
					1,
					A2($elm$core$String$dropRight, decimalDigitsAmount, value));
				var valueWithoutSeparator = A2(
					$elm$core$Basics$composeR,
					$elm$core$String$filter(
						function (_char) {
							return $elm$core$Char$isDigit(_char) || (_Utils_eq(
								$elm$core$String$fromChar(_char),
								previousDecimalSeparator) || (_char === '-'));
						}),
					A2($elm$core$String$replace, previousDecimalSeparator, '.'));
				return _Utils_Tuple3(
					function (v) {
						return A2(
							$elm$core$Maybe$withDefault,
							valueWithoutSeparator(v),
							A3(
								$henriquecbuss$elm_mask$Mask$floatString,
								decimalDigits,
								separators,
								valueWithoutSeparator(v)));
					},
					function (v) {
						return A3(
							$henriquecbuss$elm_mask$Mask$updateFloatString,
							decimalDigits,
							separators,
							{or: v, pd: value});
					},
					A3(
						$elm$html$Html$node,
						'masked-input-helper',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'target-id', options.w),
								A2($elm$html$Html$Attributes$attribute, 'mask-type', 'number'),
								A2($elm$html$Html$Attributes$attribute, 'decimal-separator', separators.jD)
							]),
						_List_Nil));
			} else {
				return _Utils_Tuple3(
					options.hz,
					options.bX,
					$elm$html$Html$text(''));
			}
		}();
		var beforeRenderingValue = _v3.a;
		var beforeChangeEvent = _v3.b;
		var maskHelper = _v3.c;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('relative'),
				options.gF),
			A2(
				$elm$core$List$cons,
				A2(
					inputElement,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$id(options.w),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeR, beforeChangeEvent, onChange)),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Events$onBlur(onBlur),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('w-full input peer'),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('with-error', hasError)
												])),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$disabled(options.b_),
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$value(
													beforeRenderingValue(paddedTimeValue)),
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Attributes$placeholder(
														A2($elm$core$Maybe$withDefault, '', options.pa)),
													A2(
														$elm$core$List$cons,
														typeAttr,
														A2(
															$elm$core$List$cons,
															$elm$html$Html$Attributes$required(isRequired),
															options.gu)))))))))),
					_List_Nil),
				A2(
					$elm$core$List$cons,
					maskHelper,
					A2(
						$elm$core$List$map,
						function (element) {
							return element(viewConfig);
						},
						options.dD))));
	});
var $author$project$Form$Text$view = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('relative mb-10'),
				options.mF),
			_List_fromArray(
				[
					$elm$core$String$isEmpty(options.n$) ? $elm$html$Html$text('') : A2(
					$author$project$View$Components$label,
					options.dY,
					{n0: options.n$, pZ: options.w}),
					A2($author$project$Form$Text$viewInput, options, viewConfig),
					((!viewConfig.no) && $elm_community$maybe_extra$Maybe$Extra$isNothing(options.gj)) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex w-full px-1')
						]),
					_List_fromArray(
						[
							viewConfig.na,
							function () {
							var _v1 = options.gj;
							if (_v1.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var counter = _v1.a;
								var _v2 = function () {
									if (!counter.$) {
										var maxLetters = counter.a;
										return _Utils_Tuple2(
											$elm$core$String$length(viewConfig.lW),
											maxLetters);
									} else {
										var maxWords = counter.a;
										return _Utils_Tuple2(
											$elm$core$List$length(
												A2(
													$elm$core$List$filter,
													A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
													$elm$core$String$words(viewConfig.lW))),
											maxWords);
									}
								}();
								var currentLength = _v2.a;
								var max = _v2.b;
								return A2(
									$elm$html$Html$p,
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('text-purple-100 mt-2 ml-auto uppercase font-bold text-sm flex-shrink-0'),
										options.gk),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												viewConfig.aw.i4,
												'edit.input_counter',
												_List_fromArray(
													[
														_Utils_Tuple2(
														'current',
														$elm$core$String$fromInt(currentLength)),
														_Utils_Tuple2(
														'max',
														$elm$core$String$fromInt(max))
													])))
										]));
							}
						}()
						]))
				]));
	});
var $elm$html$Html$Attributes$align = $elm$html$Html$Attributes$stringProperty('align');
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$code = _VirtualDom_node('code');
var $elm$html$Html$del = _VirtualDom_node('del');
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $dillonkearns$elm_markdown$Markdown$HtmlRenderer$HtmlRenderer = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Html$resultOr = F2(
	function (ra, rb) {
		if (ra.$ === 1) {
			var singleError = ra.a;
			if (!rb.$) {
				var okValue = rb.a;
				return $elm$core$Result$Ok(okValue);
			} else {
				var errorsSoFar = rb.a;
				return $elm$core$Result$Err(
					A2($elm$core$List$cons, singleError, errorsSoFar));
			}
		} else {
			var okValue = ra.a;
			return $elm$core$Result$Ok(okValue);
		}
	});
var $dillonkearns$elm_markdown$Markdown$Html$attributesToString = function (attributes) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			function (_v0) {
				var name = _v0.fj;
				var value = _v0.lW;
				return name + ('=\"' + (value + '\"'));
			},
			attributes));
};
var $dillonkearns$elm_markdown$Markdown$Html$tagToString = F2(
	function (tagName, attributes) {
		return $elm$core$List$isEmpty(attributes) ? ('<' + (tagName + '>')) : ('<' + (tagName + (' ' + ($dillonkearns$elm_markdown$Markdown$Html$attributesToString(attributes) + '>'))));
	});
var $dillonkearns$elm_markdown$Markdown$Html$oneOf = function (decoders) {
	var unwrappedDecoders = A2(
		$elm$core$List$map,
		function (_v1) {
			var rawDecoder = _v1;
			return rawDecoder;
		},
		decoders);
	return function (rawDecoder) {
		return F3(
			function (tagName, attributes, innerBlocks) {
				return A2(
					$elm$core$Result$mapError,
					function (errors) {
						if (!errors.b) {
							return 'Ran into a oneOf with no possibilities!';
						} else {
							if (!errors.b.b) {
								var singleError = errors.a;
								return 'Problem with the given value:\n\n' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\n' + (singleError + '\n')));
							} else {
								return 'oneOf failed parsing this value:\n    ' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\nParsing failed in the following 2 ways:\n\n\n' + (A2(
									$elm$core$String$join,
									'\n\n',
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (index, error) {
												return '(' + ($elm$core$String$fromInt(index + 1) + (') ' + error));
											}),
										errors)) + '\n')));
							}
						}
					},
					A3(rawDecoder, tagName, attributes, innerBlocks));
			});
	}(
		A3(
			$elm$core$List$foldl,
			F2(
				function (decoder, soFar) {
					return F3(
						function (tagName, attributes, children) {
							return A2(
								$dillonkearns$elm_markdown$Markdown$Html$resultOr,
								A3(decoder, tagName, attributes, children),
								A3(soFar, tagName, attributes, children));
						});
				}),
			F3(
				function (tagName, attributes, children) {
					return $elm$core$Result$Err(_List_Nil);
				}),
			unwrappedDecoders));
};
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$html$Html$Attributes$start = function (n) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'start',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer = {
	hA: $elm$html$Html$blockquote(_List_Nil),
	hH: function (_v0) {
		var body = _v0.f6;
		var language = _v0.ic;
		var classes = function () {
			var _v1 = A2($elm$core$Maybe$map, $elm$core$String$words, language);
			if ((!_v1.$) && _v1.a.b) {
				var _v2 = _v1.a;
				var actualLanguage = _v2.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('language-' + actualLanguage)
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$pre,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$code,
					classes,
					_List_fromArray(
						[
							$elm$html$Html$text(body)
						]))
				]));
	},
	hI: function (content) {
		return A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]));
	},
	hR: function (children) {
		return A2($elm$html$Html$em, _List_Nil, children);
	},
	h$: A2($elm$html$Html$br, _List_Nil, _List_Nil),
	h0: function (_v3) {
		var level = _v3.n4;
		var children = _v3.hD;
		switch (level) {
			case 0:
				return A2($elm$html$Html$h1, _List_Nil, children);
			case 1:
				return A2($elm$html$Html$h2, _List_Nil, children);
			case 2:
				return A2($elm$html$Html$h3, _List_Nil, children);
			case 3:
				return A2($elm$html$Html$h4, _List_Nil, children);
			case 4:
				return A2($elm$html$Html$h5, _List_Nil, children);
			default:
				return A2($elm$html$Html$h6, _List_Nil, children);
		}
	},
	nw: $dillonkearns$elm_markdown$Markdown$Html$oneOf(_List_Nil),
	h2: function (imageInfo) {
		var _v5 = imageInfo.fN;
		if (!_v5.$) {
			var title = _v5.a;
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.iQ),
						$elm$html$Html$Attributes$alt(imageInfo.hv),
						$elm$html$Html$Attributes$title(title)
					]),
				_List_Nil);
		} else {
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.iQ),
						$elm$html$Html$Attributes$alt(imageInfo.hv)
					]),
				_List_Nil);
		}
	},
	n6: F2(
		function (link, content) {
			var _v6 = link.fN;
			if (!_v6.$) {
				var title = _v6.a;
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.jG),
							$elm$html$Html$Attributes$title(title)
						]),
					content);
			} else {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.jG)
						]),
					content);
			}
		}),
	iB: F2(
		function (startingIndex, items) {
			return A2(
				$elm$html$Html$ol,
				function () {
					if (startingIndex === 1) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$start(startingIndex)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2(
					$elm$core$List$map,
					function (itemBlocks) {
						return A2($elm$html$Html$li, _List_Nil, itemBlocks);
					},
					items));
		}),
	iD: $elm$html$Html$p(_List_Nil),
	iU: function (children) {
		return A2($elm$html$Html$del, _List_Nil, children);
	},
	iV: function (children) {
		return A2($elm$html$Html$strong, _List_Nil, children);
	},
	lB: $elm$html$Html$table(_List_Nil),
	iY: $elm$html$Html$tbody(_List_Nil),
	iZ: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment) {
								case 0:
									return 'left';
								case 2:
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$td(attrs);
	},
	i_: $elm$html$Html$thead(_List_Nil),
	i$: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment) {
								case 0:
									return 'left';
								case 2:
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$th(attrs);
	},
	hh: $elm$html$Html$tr(_List_Nil),
	n: $elm$html$Html$text,
	i1: A2($elm$html$Html$hr, _List_Nil, _List_Nil),
	i9: function (items) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (item) {
					var task = item.a;
					var children = item.b;
					var checkbox = function () {
						switch (task) {
							case 0:
								return $elm$html$Html$text('');
							case 1:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(false),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
							default:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(true),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
						}
					}();
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						A2($elm$core$List$cons, checkbox, children));
				},
				items));
	}
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$combineResults = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml = F5(
	function (tagName, attributes, children, _v0, renderedChildren) {
		var htmlRenderer = _v0;
		return A2(
			$elm$core$Result$andThen,
			function (okChildren) {
				return A2(
					$elm$core$Result$map,
					function (myRenderer) {
						return myRenderer(okChildren);
					},
					A3(htmlRenderer, tagName, attributes, children));
			},
			$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(renderedChildren));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$foldThing = F3(
	function (renderer, topLevelInline, soFar) {
		var _v12 = A2($dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline, renderer, topLevelInline);
		if (!_v12.$) {
			var inline = _v12.a;
			return A2($elm$core$List$cons, inline, soFar);
		} else {
			return soFar;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper = F2(
	function (renderer, blocks) {
		return A2(
			$elm$core$List$filterMap,
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle(renderer),
			blocks);
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle = function (renderer) {
	return function (block) {
		switch (block.$) {
			case 4:
				var level = block.a;
				var content = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (children) {
							return renderer.h0(
								{
									hD: children,
									n4: level,
									pp: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(content)
								});
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 5:
				var content = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.iD,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 0:
				var html = block.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 1:
				var tight = block.a;
				var items = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return renderer.i9(
								A2(
									$elm$core$List$map,
									function (_v7) {
										var task = _v7.a;
										var children = _v7.b;
										return A2(
											$dillonkearns$elm_markdown$Markdown$Block$ListItem,
											task,
											$elm$core$List$concat(children));
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (_v4) {
									var task = _v4.a;
									var children = _v4.b;
									return A2(
										$elm$core$Result$map,
										$dillonkearns$elm_markdown$Markdown$Block$ListItem(task),
										$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
											function (blocks) {
												return A2(
													$elm$core$List$filterMap,
													function (listItemBlock) {
														var _v5 = _Utils_Tuple2(tight, listItemBlock);
														if ((_v5.a === 1) && (_v5.b.$ === 5)) {
															var _v6 = _v5.a;
															var content = _v5.b.a;
															return $elm$core$Maybe$Just(
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
														} else {
															return A2(
																$elm$core$Maybe$map,
																$elm$core$Result$map($elm$core$List$singleton),
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
														}
													},
													blocks);
											}(children)));
								},
								items))));
			case 2:
				var tight = block.a;
				var startingIndex = block.b;
				var items = block.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return A2(
								renderer.iB,
								startingIndex,
								A2(
									$elm$core$List$map,
									function (children) {
										return $elm$core$List$concat(children);
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (itemsblocks) {
									return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
										function (blocks) {
											return A2(
												$elm$core$List$filterMap,
												function (listItemBlock) {
													var _v8 = _Utils_Tuple2(tight, listItemBlock);
													if ((_v8.a === 1) && (_v8.b.$ === 5)) {
														var _v9 = _v8.a;
														var content = _v8.b.a;
														return $elm$core$Maybe$Just(
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
													} else {
														return A2(
															$elm$core$Maybe$map,
															$elm$core$Result$map($elm$core$List$singleton),
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
													}
												},
												blocks);
										}(itemsblocks));
								},
								items))));
			case 7:
				var codeBlock = block.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.hH(codeBlock)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.i1));
			case 3:
				var nestedBlocks = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.hA,
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, nestedBlocks))));
			default:
				var header = block.a;
				var rows = block.b;
				var renderedHeaderCells = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2(
						$elm$core$List$map,
						function (_v11) {
							var label = _v11.n$;
							var alignment = _v11.f0;
							return A2(
								$elm$core$Result$map,
								$elm$core$Tuple$pair(alignment),
								A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, label));
						},
						header));
				var renderedHeader = A2(
					$elm$core$Result$map,
					function (listListView) {
						return renderer.i_(
							$elm$core$List$singleton(
								renderer.hh(
									A2(
										$elm$core$List$map,
										function (_v10) {
											var maybeAlignment = _v10.a;
											var item = _v10.b;
											return A2(renderer.i$, maybeAlignment, item);
										},
										listListView))));
					},
					renderedHeaderCells);
				var renderedBody = function (r) {
					return $elm$core$List$isEmpty(r) ? _List_Nil : _List_fromArray(
						[
							renderer.iY(r)
						]);
				};
				var alignmentForColumn = function (columnIndex) {
					return A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.f0;
						},
						$elm$core$List$head(
							A2($elm$core$List$drop, columnIndex, header)));
				};
				var renderRow = function (cells) {
					return A2(
						$elm$core$Result$map,
						renderer.hh,
						A2(
							$elm$core$Result$map,
							$elm$core$List$indexedMap(
								F2(
									function (index, cell) {
										return A2(
											renderer.iZ,
											alignmentForColumn(index),
											cell);
									})),
							$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
								A2(
									$elm$core$List$map,
									$dillonkearns$elm_markdown$Markdown$Renderer$renderStyled(renderer),
									cells))));
				};
				var renderedRows = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2($elm$core$List$map, renderRow, rows));
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$Result$map2,
						F2(
							function (h, r) {
								return renderer.lB(
									A2(
										$elm$core$List$cons,
										h,
										renderedBody(r)));
							}),
						renderedHeader,
						renderedRows));
		}
	};
};
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode = F4(
	function (renderer, tag, attributes, children) {
		return A5(
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHtml,
			tag,
			attributes,
			children,
			renderer.nw,
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, children));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline = F2(
	function (renderer, inline) {
		switch (inline.$) {
			case 4:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.iV,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 3:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.hR,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 5:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.iU,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 2:
				var src = inline.a;
				var title = inline.b;
				var children = inline.c;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.h2(
							{
								hv: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(children),
								iQ: src,
								fN: title
							})));
			case 7:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.n(string)));
			case 6:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.hI(string)));
			case 1:
				var destination = inline.a;
				var title = inline.b;
				var inlines = inline.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$andThen,
						function (children) {
							return $elm$core$Result$Ok(
								A2(
									renderer.n6,
									{jG: destination, fN: title},
									children));
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, inlines)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.h$));
			default:
				var html = inline.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled = F2(
	function (renderer, styledStrings) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A3(
				$elm$core$List$foldr,
				$dillonkearns$elm_markdown$Markdown$Renderer$foldThing(renderer),
				_List_Nil,
				styledStrings));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$render = F2(
	function (renderer, ast) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, ast));
	});
var $dillonkearns$elm_markdown$Markdown$Html$tag = F2(
	function (expectedTag, a) {
		return F3(
			function (tagName, attributes, children) {
				return _Utils_eq(tagName, expectedTag) ? $elm$core$Result$Ok(a) : $elm$core$Result$Err('Expected ' + (expectedTag + (' but was ' + tagName)));
			});
	});
var $elm$html$Html$u = _VirtualDom_node('u');
var $author$project$Markdown$view = F2(
	function (attributes, _v0) {
		var content = _v0;
		var _v1 = $dillonkearns$elm_markdown$Markdown$Parser$parse(content);
		if (!_v1.$) {
			var blocks = _v1.a;
			var defaultRenderer = $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer;
			var renderer = _Utils_update(
				defaultRenderer,
				{
					nw: $dillonkearns$elm_markdown$Markdown$Html$oneOf(
						_List_fromArray(
							[
								A2(
								$dillonkearns$elm_markdown$Markdown$Html$tag,
								'u',
								function (children) {
									return A2(
										$elm$html$Html$u,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('inline-children')
											]),
										children);
								})
							])),
					n6: F2(
						function (link, linkContent) {
							var _v3 = link.fN;
							if (!_v3.$) {
								var title = _v3.a;
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(link.jG),
											$elm$html$Html$Attributes$title(title),
											$elm$html$Html$Attributes$target('_blank')
										]),
									linkContent);
							} else {
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(link.jG),
											$elm$html$Html$Attributes$target('_blank')
										]),
									linkContent);
							}
						})
				});
			var _v2 = A2($dillonkearns$elm_markdown$Markdown$Renderer$render, renderer, blocks);
			if (!_v2.$) {
				var asHtml = _v2.a;
				return A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('markdown-viewer break-words'),
						attributes),
					asHtml);
			} else {
				return $elm$html$Html$text('');
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Form$Text$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mF: _Utils_ap(options.mF, attrs)
			});
	});
var $author$project$Form$Text$withInputElement = F2(
	function (inputElement, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{gG: inputElement});
	});
var $elm$core$Basics$xor = _Basics_xor;
var $author$project$Page$Community$About$viewCommunityCard = F2(
	function (shared, community) {
		var translators = shared.aw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'lg:col-start-2 lg:col-span-4',
							(!$author$project$Page$Community$About$showSupportersCard(community)) && (!$author$project$Page$Community$About$showNewsCard(community))),
							_Utils_Tuple2(
							'lg:col-span-2',
							(!$author$project$Page$Community$About$showSupportersCard(community)) !== (!$author$project$Page$Community$About$showNewsCard(community)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-4 opacity-0 pointer-events-none hidden lg:block')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('hidden text')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col bg-white rounded relative px-4 pt-4 pb-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute w-full top-0 left-0 flex justify-center -translate-y-1/2 pointer-events-none')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('h-21 w-21 bg-white p-4 flex items-center justify-center rounded-full shadow-sm')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(community.fe),
													$elm$html$Html$Attributes$class('max-w-full max-h-full'),
													$elm$html$Html$Attributes$alt(
													A2(
														translators.i4,
														'community.index.logo',
														_List_fromArray(
															[
																_Utils_Tuple2('community', community.fj)
															])))
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-gray-100 p-2 rounded-full ml-auto focus-ring hover:opacity-60 active:opacity-80'),
									$elm$html$Html$Events$onClick($author$project$Page$Community$About$ClickedShareCommunity),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
									translators.fL('community.share'))
								]),
							_List_fromArray(
								[
									$author$project$Icons$share('')
								])),
							(!shared.jq) ? A2(
							$author$project$Form$Text$view,
							A2(
								$author$project$Form$Text$withInputElement,
								$author$project$Form$Text$TextareaInput(
									{pR: false}),
								A2(
									$author$project$Form$Text$withContainerAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-0 overflow-hidden')
										]),
									A2(
										$author$project$Form$Text$withExtraAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('absolute opacity-0 left-[-9999em]'),
												$elm$html$Html$Attributes$tabindex(-1),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										$author$project$Form$Text$init(
											{w: 'share-fallback-input', n$: ''})))),
							{
								na: $elm$html$Html$text(''),
								no: false,
								nV: false,
								oF: $author$project$Page$Community$About$NoOp,
								oH: function (_v0) {
									return $author$project$Page$Community$About$NoOp;
								},
								aw: shared.aw,
								lW: A2(
									translators.i4,
									'community.learn_about',
									_List_fromArray(
										[
											_Utils_Tuple2('community_name', community.fj),
											_Utils_Tuple2(
											'url',
											$elm$url$Url$toString(
												$author$project$Page$Community$About$urlToShareable(shared.hn)))
										]))
							}) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-lg font-bold text-center'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('mt-10', !shared.jq)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(community.fj)
								])),
							function () {
							var _v1 = community.bT;
							if (_v1.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var website = _v1.a;
								var removeTrailingSlash = function (site) {
									return A2($elm$core$String$endsWith, '/', site) ? A2($elm$core$String$dropRight, 1, site) : site;
								};
								var removeProtocol = function (site) {
									return A2($elm$core$String$startsWith, 'http://', site) ? A2($elm$core$String$dropLeft, 7, site) : (A2($elm$core$String$startsWith, 'https://', website) ? A2($elm$core$String$dropLeft, 8, site) : site);
								};
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(website),
											$elm$html$Html$Attributes$class('mx-auto text-sm font-bold text-gray-900 hover:underline focus-ring')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											removeTrailingSlash(
												removeProtocol(website)))
										]));
							}
						}(),
							A2(
							$author$project$Markdown$view,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-6')
								]),
							community.aR),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap mt-8 gap-6 items-start justify-center')
								]),
							A2(
								$elm$core$List$map,
								function (contact) {
									return A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-10')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex flex-col items-center hover:opacity-60'),
														$elm$html$Html$Attributes$href(
														$author$project$Contact$toHref(contact)),
														$elm$html$Html$Attributes$target('blank'),
														$elm$html$Html$Attributes$title(
														A2($author$project$Contact$toLabel, translators, contact))
													]),
												_List_fromArray(
													[
														A3(
														$author$project$Contact$circularIconWithGrayBg,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('w-10 h-10')
															]),
														translators,
														contact),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-gray-900 text-sm text-center mt-2 font-semibold line-clamp-2')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2($author$project$Contact$toLabel, translators, contact))
															]))
													]))
											]));
								},
								community.az)),
							community.bz ? A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary w-full mt-8'),
									$author$project$Route$href(
									$author$project$Route$CommunityObjectives($author$project$Route$WithNoObjectiveSelected))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										translators.i4,
										'community.earn',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'symbol',
												$author$project$Eos$symbolToSymbolCodeString(community.as))
											])))
								])) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Community$News$isPublished = F2(
	function (now, model) {
		var _v0 = model.iL;
		if (_v0.$ === 1) {
			return true;
		} else {
			var scheduling = _v0.a;
			return _Utils_cmp(
				$elm$time$Time$posixToMillis(now),
				$elm$time$Time$posixToMillis(scheduling)) > -1;
		}
	});
var $author$project$Utils$areSameDay = F3(
	function (timezone, first, second) {
		return _Utils_eq(
			A2($justinmimbs$date$Date$fromPosix, timezone, first),
			A2($justinmimbs$date$Date$fromPosix, timezone, second));
	});
var $author$project$View$Components$dateFormatter = F2(
	function (attrs, _v0) {
		var language = _v0.ic;
		var date = _v0.dw;
		var translationString = _v0.lO;
		return A3(
			$elm$html$Html$node,
			'date-formatter',
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$Attributes$attribute,
					'elm-locale',
					$author$project$Translation$languageToLocale(language)),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Attributes$attribute,
						'elm-date',
						$elm$core$String$fromInt(
							$elm$time$Time$posixToMillis(date))),
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$attribute, 'elm-translation', translationString),
						attrs))),
			_List_Nil);
	});
var $author$project$Utils$previousDay = function (time) {
	var day = ((1000 * 60) * 60) * 24;
	return $elm$time$Time$millisToPosix(
		$elm$time$Time$posixToMillis(time) - day);
};
var $author$project$View$Components$dateViewer = F4(
	function (attrs, fillInTranslations, shared, time) {
		var yesterday = $author$project$Utils$previousDay(shared.ce);
		var translations = fillInTranslations(
			{
				o$: '{{date}}',
				p4: $elm$core$Maybe$Just(
					shared.aw.fL('dates.today')),
				qo: $elm$core$Maybe$Just(
					shared.aw.fL('dates.yesterday'))
			});
		var translationString = A3($author$project$Utils$areSameDay, shared.i2, shared.ce, time) ? A2($elm$core$Maybe$withDefault, translations.o$, translations.p4) : (A3($author$project$Utils$areSameDay, shared.i2, shared.ce, yesterday) ? A2($elm$core$Maybe$withDefault, translations.o$, translations.qo) : translations.o$);
		return A2($elm$core$String$contains, '{{date}}', translationString) ? A2(
			$author$project$View$Components$dateFormatter,
			attrs,
			{dw: time, ic: shared.ic, lO: translationString}) : (A3($author$project$Utils$areSameDay, shared.i2, shared.ce, time) ? A2(
			$elm$html$Html$span,
			attrs,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, translations.o$, translations.p4))
				])) : (A3($author$project$Utils$areSameDay, shared.i2, shared.ce, yesterday) ? A2(
			$elm$html$Html$span,
			attrs,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, translations.o$, translations.qo))
				])) : $elm$html$Html$text('')));
	});
var $elm_community$list_extra$List$Extra$groupWhile = F2(
	function (isSameGroup, items) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					if (!acc.b) {
						return _List_fromArray(
							[
								_Utils_Tuple2(x, _List_Nil)
							]);
					} else {
						var _v1 = acc.a;
						var y = _v1.a;
						var restOfGroup = _v1.b;
						var groups = acc.b;
						return A2(isSameGroup, x, y) ? A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								x,
								A2($elm$core$List$cons, y, restOfGroup)),
							groups) : A2(
							$elm$core$List$cons,
							_Utils_Tuple2(x, _List_Nil),
							acc);
					}
				}),
			_List_Nil,
			items);
	});
var $author$project$Icons$arrowDown = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('32'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M14.9881 19.8182C15.0302 19.8496 15.0749 19.8773 15.1217 19.9009C15.1713 19.9401 15.2246 19.9742 15.2808 20.0028C15.3388 20.0213 15.3985 20.0341 15.459 20.0409C15.5747 20.0793 15.6997 20.0793 15.8154 20.0409C15.8759 20.0341 15.9356 20.0213 15.9935 20.0028C16.0498 19.9742 16.1031 19.9401 16.1526 19.9009C16.1995 19.8773 16.2442 19.8496 16.2863 19.8182L21.059 14.7273C21.4113 14.3414 21.3878 13.7439 21.0064 13.3869C20.6249 13.0298 20.0272 13.0458 19.6654 13.4228L15.5863 17.7691L11.5072 13.4228C11.1454 13.0458 10.5477 13.0298 10.1662 13.3869C9.78469 13.7439 9.76124 14.3414 10.1135 14.7273L14.9881 19.8182Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$speechBubble = F2(
	function (attrs, class_) {
		return A2(
			$elm$svg$Svg$svg,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$width('28'),
				A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$height('28'),
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$viewBox('0 0 28 28'),
						A2(
							$elm$core$List$cons,
							$elm$svg$Svg$Attributes$fill('none'),
							A2(
								$elm$core$List$cons,
								$elm$svg$Svg$Attributes$class(class_),
								attrs))))),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M24.5 13.4167C24.504 14.9565 24.1442 16.4756 23.45 17.85C22.6268 19.4971 21.3614 20.8824 19.7954 21.8509C18.2293 22.8193 16.4246 23.3327 14.5833 23.3334C13.0435 23.3374 11.5245 22.9776 10.15 22.2834L3.5 24.5L5.71667 17.85C5.02242 16.4756 4.66265 14.9565 4.66667 13.4167C4.66738 11.5754 5.18071 9.77069 6.14917 8.20467C7.11763 6.63866 8.50296 5.37319 10.15 4.55003C11.5245 3.85579 13.0435 3.49602 14.5833 3.50003H15.1667C17.5984 3.63419 19.8952 4.66059 21.6173 6.3827C23.3394 8.10482 24.3658 10.4016 24.5 12.8334V13.4167Z'),
							$elm$svg$Svg$Attributes$strokeWidth('2'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$strokeLinejoin('round')
						]),
					_List_Nil)
				]));
	});
var $author$project$Community$News$viewSummary = F3(
	function (_v0, hasRead, news) {
		var t = _v0.fL;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid items-center py-4 focus-ring rounded-sm hover:opacity-70'),
					A2($elm$html$Html$Attributes$style, 'grid-template-columns', '32px 1fr 80px'),
					$elm$html$Html$Attributes$title(news.fN),
					$author$project$Route$href(
					$author$project$Route$News(
						{
							pD: $elm$core$Maybe$Just(news.w),
							pJ: false
						}))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Icons$speechBubble,
					_List_fromArray(
						[
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
						]),
					'h-8 w-8 stroke-current text-blue bg-gray-100 rounded-full p-[6px] overflow-visible'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('truncate mx-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold truncate'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('text-purple-500', !hasRead),
											_Utils_Tuple2('text-gray-333', hasRead)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(news.fN)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('truncate text-gray-333'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Markdown$toUnformattedString(news.aR))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sr-only')
								]),
							_List_fromArray(
								[
									hasRead ? $elm$html$Html$text(
									t('news.already_read')) : $elm$html$Html$text(
									t('news.not_read_yet'))
								]))
						])),
					$author$project$Icons$arrowDown('-rotate-90 fill-current text-orange-300 ml-auto rounded-full bg-gray-100')
				]));
	});
var $author$project$Community$News$viewList = F3(
	function (shared, attrs, news) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('divide-y divide-gray-100 space-y-4'),
				attrs),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var firstNews = _v0.a;
					var otherNews = _v0.b;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pt-4 first:pt-0')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$View$Components$dateViewer,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-black text-sm font-bold uppercase')
											]),
										$elm$core$Basics$identity,
										shared,
										firstNews.nL)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('divide-y divide-gray-100')
									]),
								A2(
									$elm$core$List$map,
									function (theseNews) {
										return A3(
											$author$project$Community$News$viewSummary,
											shared.aw,
											$elm_community$maybe_extra$Maybe$Extra$isJust(theseNews.iK),
											theseNews);
									},
									A2($elm$core$List$cons, firstNews, otherNews)))
							]));
				},
				A2(
					$elm_community$list_extra$List$Extra$groupWhile,
					F2(
						function (news1, news2) {
							return A3($author$project$Utils$areSameDay, shared.i2, news1.nL, news2.nL);
						}),
					news)));
	});
var $author$project$Page$Community$About$viewNewsCard = F2(
	function (shared, community) {
		var translators = shared.aw;
		var _v0 = translators;
		var t = _v0.fL;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-4 lg:mt-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							t('community.index.our_messages') + (' ' + t('community.index.messages')))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.index.our_messages'))
								])),
							$elm$html$Html$text(' '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.index.messages'))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded px-4 pt-4 pb-6 mt-4 relative')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/images/doggo-announcing.svg'),
									$elm$html$Html$Attributes$class('absolute top-0 right-0 -translate-y-full'),
									$elm$html$Html$Attributes$alt('')
								]),
							_List_Nil),
						function () {
							var _v1 = community.fl;
							switch (_v1.$) {
								case 3:
									var news = _v1.a;
									return $elm$core$List$isEmpty(news) ? _List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-center text-gray-900 pt-10 pb-8')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('menu.coming_soon'))
												]))
										]) : _List_fromArray(
										[
											A3(
											$author$project$Community$News$viewList,
											shared,
											_List_Nil,
											A2(
												$elm$core$List$take,
												3,
												A2(
													$elm$core$List$filter,
													$author$project$Community$News$isPublished(shared.ce),
													news))),
											A2(
											$elm$html$Html$hr,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mb-4 border-gray-100'),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button button-secondary w-full'),
													$author$project$Route$href(
													$author$project$Route$News(
														{pD: $elm$core$Maybe$Nothing, pJ: true}))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('news.view_more'))
												]))
										]);
								case 1:
									return _List_fromArray(
										[
											A2($author$project$View$Components$loadingLogoAnimated, translators, 'mb-10')
										]);
								case 0:
									return _List_fromArray(
										[
											A2($author$project$View$Components$loadingLogoAnimated, translators, 'mb-10')
										]);
								default:
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-center text-gray-900 pt-10 pb-8')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('news.error_fetching'))
												]))
										]);
							}
						}()))
				]));
	});
var $author$project$Utils$formatInt = F2(
	function (maybeTranslators, number) {
		return A3($author$project$Utils$formatFloat, maybeTranslators, 0, number);
	});
var $author$project$Page$Community$About$viewStatsCard = F2(
	function (translators, _v0) {
		var number = _v0.d2;
		var description = _v0.aR;
		var imgSrc = _v0.cN;
		var imgClass = _v0.cM;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid grid-cols-3 bg-white rounded')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(imgSrc),
							$elm$html$Html$Attributes$alt(''),
							$elm$html$Html$Attributes$class(imgClass)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-span-2 py-6 text-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sr-only')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									translators.fL(description) + (': ' + $elm$core$String$fromInt(number)))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xl font-bold text-green'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Utils$formatInt,
										$elm$core$Maybe$Just(translators),
										number))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('uppercase text-sm font-bold text-gray-900'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]))
				]));
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Page$Community$About$viewSupportersCard = F2(
	function (_v0, community) {
		var t = _v0.fL;
		var viewLoading = A2(
			$elm$core$List$map,
			function (index) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-14 h-14 rounded-full -mr-2 border border-white bg-gray-300 animate-skeleton-loading last:mr-0'),
							A2(
							$elm$html$Html$Attributes$style,
							'animation-delay',
							$elm$core$String$fromInt(index * 100) + 'ms')
						]),
					_List_Nil);
			},
			A2($elm$core$List$range, 0, 4));
		var compareAvatars = F2(
			function (first, second) {
				var _v2 = _Utils_Tuple2(
					$author$project$Avatar$toMaybeString(first),
					$author$project$Avatar$toMaybeString(second));
				if (!_v2.a.$) {
					if (!_v2.b.$) {
						return 1;
					} else {
						var _v3 = _v2.b;
						return 0;
					}
				} else {
					if (!_v2.b.$) {
						var _v4 = _v2.a;
						return 2;
					} else {
						var _v5 = _v2.a;
						var _v6 = _v2.b;
						return 1;
					}
				}
			});
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							t('community.index.our_supporters') + (' ' + t('community.index.supporters')))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.index.our_supporters'))
								])),
							$elm$html$Html$text(' '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.index.supporters'))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded px-4 pt-4 pb-6 mt-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.index.you_can_support'))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary w-full mt-6'),
									$author$project$Route$href($author$project$Route$CommunitySponsor)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.index.support_us'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-8 text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.index.see_supporters'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap mt-4 justify-center')
								]),
							function () {
								var _v1 = community.eN;
								switch (_v1.$) {
									case 3:
										var contributions = _v1.a;
										return A2(
											$elm$core$List$map,
											function (avatar) {
												return A2($author$project$Avatar$view, avatar, 'w-14 h-14 object-cover rounded-full -mr-2 border border-white last:mr-0');
											},
											A2(
												$elm$core$List$take,
												5,
												A2(
													$elm$core$List$sortWith,
													compareAvatars,
													$elm_community$list_extra$List$Extra$unique(
														A2(
															$elm$core$List$map,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.qg;
																},
																function ($) {
																	return $.dl;
																}),
															contributions)))));
									case 1:
										return viewLoading;
									case 0:
										return viewLoading;
									default:
										return _List_Nil;
								}
							}()),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary w-full mt-4'),
									$author$project$Route$href($author$project$Route$CommunitySupporters)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.index.see_all_supporters'))
								]))
						]))
				]));
	});
var $author$project$Page$Community$About$view = F2(
	function (loggedIn, model) {
		var defaultCoverPhoto = A3(
			$elm$html$Html$node,
			'picture',
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$source,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'srcset', '/images/community-bg-mobile.svg'),
							$elm$html$Html$Attributes$media('(min-width:768px)')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/images/community-bg-desktop.svg'),
							$elm$html$Html$Attributes$class('mb-6 object-cover min-w-full max-h-43 sm:max-h-60 lg:max-h-80'),
							A2($elm$html$Html$Attributes$style, 'object-position', '50% 62%'),
							$elm$html$Html$Attributes$alt('')
						]),
					_List_Nil)
				]));
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var tr = _v0.i4;
		return {
			mJ: function () {
				var _v1 = loggedIn.pC;
				switch (_v1.$) {
					case 3:
						var community = _v1.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-20')
								]),
							_List_fromArray(
								[
									function () {
									var _v2 = A2($krisajenkins$remotedata$RemoteData$map, $elm$core$List$head, community.bQ);
									_v2$2:
									while (true) {
										switch (_v2.$) {
											case 3:
												if (!_v2.a.$) {
													var upload = _v2.a.a;
													return A2(
														$elm$html$Html$img,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$src(upload),
																$elm$html$Html$Attributes$class('mb-6 object-cover min-w-full max-h-43 sm:max-h-60 lg:max-h-80'),
																$elm$html$Html$Attributes$alt('')
															]),
														_List_Nil);
												} else {
													break _v2$2;
												}
											case 1:
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-full h-43 sm:h-60 lg:h-80 animate-skeleton-loading')
														]),
													_List_Nil);
											default:
												break _v2$2;
										}
									}
									return defaultCoverPhoto;
								}(),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container mx-auto px-4 py-10')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('grid grid-cols-1 lg:grid-cols-3 gap-6'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'lg:grid-cols-6',
															(!$author$project$Page$Community$About$showSupportersCard(community)) && (!$author$project$Page$Community$About$showNewsCard(community)))
														]))
												]),
											_List_fromArray(
												[
													A2($author$project$Page$Community$About$viewCommunityCard, loggedIn.A, community),
													$author$project$Page$Community$About$showSupportersCard(community) ? A2($author$project$Page$Community$About$viewSupportersCard, loggedIn.A.aw, community) : $elm$html$Html$text(''),
													$author$project$Page$Community$About$showNewsCard(community) ? A2($author$project$Page$Community$About$viewNewsCard, loggedIn.A, community) : $elm$html$Html$text('')
												])),
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-6'),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
													t('community.index.our_numbers') + (' ' + t('community.index.numbers')))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															t('community.index.our_numbers'))
														])),
													$elm$html$Html$text(' '),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('font-bold'),
															$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															t('community.index.numbers'))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-4 grid sm:grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4')
												]),
											_List_fromArray(
												[
													function () {
													var _v3 = model.fR;
													switch (_v3.$) {
														case 3:
															var tokenInfo = _v3.a;
															return A2(
																$author$project$Page$Community$About$viewStatsCard,
																loggedIn.A.aw,
																{
																	aR: A2(
																		tr,
																		'community.index.amount_in_circulation',
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'currency_name',
																				$author$project$Eos$symbolToSymbolCodeString(community.as))
																			])),
																	cM: 'place-self-center',
																	cN: '/images/three_coins.svg',
																	d2: $elm$core$Basics$round(tokenInfo.pU.ji)
																});
														case 1:
															return A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('rounded animate-skeleton-loading')
																	]),
																_List_Nil);
														default:
															return $elm$html$Html$text('');
													}
												}(),
													A2(
													$author$project$Page$Community$About$viewStatsCard,
													loggedIn.A.aw,
													{
														aR: t('community.index.members'),
														cM: 'mt-auto mx-auto',
														cN: '/images/man_sipping_coconut_water.svg',
														d2: community.gT
													}),
													A2(
													$author$project$Page$Community$About$viewStatsCard,
													loggedIn.A.aw,
													{
														aR: t('community.index.claims'),
														cM: 'self-center',
														cN: '/images/woman_driving_truck.svg',
														d2: community.hE
													}),
													A2(
													$author$project$Page$Community$About$viewStatsCard,
													loggedIn.A.aw,
													{
														aR: t('community.index.transfers'),
														cM: 'mt-auto mx-auto',
														cN: '/images/people_trading_bread.svg',
														d2: community.p8
													}),
													A2(
													$author$project$Page$Community$About$viewStatsCard,
													loggedIn.A.aw,
													{
														aR: t('community.index.products'),
														cM: 'mt-auto',
														cN: '/images/man_in_shop.svg',
														d2: community.pj
													}),
													A2(
													$author$project$Page$Community$About$viewStatsCard,
													loggedIn.A.aw,
													{
														aR: t('community.index.orders'),
														cM: 'place-self-center',
														cN: '/images/dog_walking_with_purse.svg',
														d2: community.o_
													})
												]))
										]))
								]));
					case 1:
						return $author$project$Page$fullPageLoading(loggedIn.A);
					case 0:
						return $author$project$Page$fullPageLoading(loggedIn.A);
					default:
						var e = _v1.a;
						return A2(
							$author$project$Page$fullPageGraphQLError,
							t('community.index.about_title'),
							e);
				}
			}(),
			fN: t('community.index.about_title')
		};
	});
var $author$project$Profile$EditKycForm$Submitted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Profile$EditKycForm$DimexDoc = 1;
var $author$project$Profile$EditKycForm$FormOutput = F3(
	function (documentType, document, phoneNumber) {
		return {eT: document, eU: documentType, o7: phoneNumber};
	});
var $author$project$Profile$EditKycForm$NiteDoc = 2;
var $author$project$Form$Text$Telephone = 1;
var $author$project$Profile$EditKycForm$docFromString = function (docType) {
	switch (docType) {
		case 'DIMEX':
			return $elm$core$Maybe$Just(1);
		case 'NITE':
			return $elm$core$Maybe$Just(2);
		case 'cedula_de_identidad':
			return $elm$core$Maybe$Just(0);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Kyc$CostaRica$CedulaDeIdentidad$validNumber = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[1-9]-?\\d{4}-?\\d{4}$'));
var $author$project$Kyc$CostaRica$CedulaDeIdentidad$isValid = function (n) {
	return A2($elm$regex$Regex$contains, $author$project$Kyc$CostaRica$CedulaDeIdentidad$validNumber, n);
};
var $author$project$Kyc$CostaRica$Dimex$validNumber = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[1-9]{1}\\d{10,11}$'));
var $author$project$Kyc$CostaRica$Dimex$isValid = function (n) {
	return A2($elm$regex$Regex$contains, $author$project$Kyc$CostaRica$Dimex$validNumber, n);
};
var $author$project$Kyc$CostaRica$Nite$validNumber = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[1-9]{1}\\d{9}$'));
var $author$project$Kyc$CostaRica$Nite$isValid = function (n) {
	return A2($elm$regex$Regex$contains, $author$project$Kyc$CostaRica$Nite$validNumber, n);
};
var $author$project$Kyc$CostaRica$Phone$validPhone = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[1-9]{1}\\d{3}-?\\d{4}$'));
var $author$project$Kyc$CostaRica$Phone$isValid = function (phone) {
	return A2($elm$regex$Regex$contains, $author$project$Kyc$CostaRica$Phone$validPhone, phone);
};
var $author$project$Form$Validate$stringLengthExactly = function (length) {
	return $author$project$Form$Validate$custom(
		function (stringInput) {
			return _Utils_eq(
				$elm$core$String$length(stringInput),
				length) ? $elm$core$Result$Ok(stringInput) : $elm$core$Result$Err(
				function (_v0) {
					var tr = _v0.i4;
					return A2(
						tr,
						'error.validator.text.exactly',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'base',
								$elm$core$String$fromInt(length))
							]));
				});
		});
};
var $author$project$Form$Select$withOption = F3(
	function (optionValue, optionLabel, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				d6: A2(
					$elm$core$List$cons,
					{n$: optionLabel, gY: optionValue},
					options.d6)
			});
	});
var $author$project$Form$Text$withType = F2(
	function (type_, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{eq: type_});
	});
var $author$project$Profile$EditKycForm$createForm = function (translators) {
	var t = translators.fL;
	return A2(
		$author$project$Form$with,
		A2(
			$author$project$Form$textField,
			{
				ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				o3: A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Validate$succeed,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$stringLengthExactly(8),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$custom(
								function (stringPhone) {
									return $author$project$Kyc$CostaRica$Phone$isValid(stringPhone) ? $elm$core$Result$Ok(stringPhone) : $elm$core$Result$Err(
										function (translators_) {
											return translators_.fL('error.phone');
										});
								}),
							$author$project$Form$Validate$validate(translators)))),
				qd: F2(
					function (phoneNumber, input) {
						return _Utils_update(
							input,
							{
								o7: A2($elm$core$String$filter, $elm$core$Char$isDigit, phoneNumber)
							});
					}),
				lW: function ($) {
					return $.o7;
				}
			},
			A2(
				$author$project$Form$Text$withExtraAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$maxlength(8)
					]),
				$author$project$Form$Text$asNumeric(
					A2(
						$author$project$Form$Text$withType,
						1,
						A2(
							$author$project$Form$Text$withPlaceholder,
							t('register.form.phone.placeholder'),
							$author$project$Form$Text$init(
								{
									w: 'phone_number_field',
									n$: t('register.form.phone.label')
								})))))),
		A2(
			$author$project$Form$with,
			$author$project$Form$introspect(
				function (_v0) {
					var documentType = _v0.eU;
					var _v1 = function () {
						switch (documentType) {
							case 0:
								return {
									gJ: $author$project$Kyc$CostaRica$CedulaDeIdentidad$isValid,
									n$: t('register.form.document.cedula_de_identidad.label'),
									gS: 9,
									pa: t('register.form.document.cedula_de_identidad.placeholder')
								};
							case 1:
								return {
									gJ: $author$project$Kyc$CostaRica$Dimex$isValid,
									n$: t('register.form.document.dimex.label'),
									gS: 12,
									pa: t('register.form.document.dimex.placeholder')
								};
							default:
								return {
									gJ: $author$project$Kyc$CostaRica$Nite$isValid,
									n$: t('register.form.document.nite.label'),
									gS: 10,
									pa: t('register.form.document.nite.placeholder')
								};
						}
					}();
					var label = _v1.n$;
					var placeholder = _v1.pa;
					var maxLength = _v1.gS;
					var isValid = _v1.gJ;
					return A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$stringLongerThan(0),
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$custom(
											function (stringInput) {
												return isValid(stringInput) ? $elm$core$Result$Ok(stringInput) : $elm$core$Result$Err(
													function (translators_) {
														return translators_.fL('register.form.document.errorInvalid');
													});
											}),
										$author$project$Form$Validate$validate(translators)))),
							qd: F2(
								function (document, input) {
									return _Utils_update(
										input,
										{
											eT: A2($elm$core$String$filter, $elm$core$Char$isDigit, document)
										});
								}),
							lW: function ($) {
								return $.eT;
							}
						},
						A2(
							$author$project$Form$Text$withExtraAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$maxlength(maxLength)
								]),
							$author$project$Form$Text$asNumeric(
								A2(
									$author$project$Form$Text$withPlaceholder,
									placeholder,
									$author$project$Form$Text$init(
										{w: 'document.input', n$: label})))));
				}),
			A2(
				$author$project$Form$with,
				A3(
					$author$project$Form$select,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Profile$EditKycForm$docFromString,
						$elm$core$Maybe$withDefault(0)),
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: $elm$core$Result$Ok,
						qd: F2(
							function (documentType, input) {
								return _Utils_update(
									input,
									{eU: documentType});
							}),
						lW: function ($) {
							return $.eU;
						}
					},
					A2(
						$author$project$Form$Select$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-10')
							]),
						A3(
							$author$project$Form$Select$withOption,
							2,
							t('register.form.document.nite.label'),
							A3(
								$author$project$Form$Select$withOption,
								1,
								t('register.form.document.dimex.label'),
								A3(
									$author$project$Form$Select$withOption,
									0,
									t('register.form.document.cedula_de_identidad.label'),
									$author$project$Form$Select$init(
										{
											w: 'document-type-select',
											n$: t('register.form.document.type'),
											d5: $author$project$Profile$EditKycForm$docToString
										})))))),
				$author$project$Form$succeed($author$project$Profile$EditKycForm$FormOutput))));
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Form$hasFieldsLoading = function (_v0) {
	var model = _v0;
	return !$elm$core$Set$isEmpty(model.gP);
};
var $elm$html$Html$Attributes$novalidate = $elm$html$Html$Attributes$boolProperty('noValidate');
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Form$BlurredField = function (a) {
	return {$: 6, a: a};
};
var $author$project$Form$ChangedValues = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Form$Text$getErrorAttrs = function (_v0) {
	var options = _v0;
	return options.gs;
};
var $author$project$Form$Text$getSubmitOnEnter = function (_v0) {
	var options = _v0;
	var _v1 = options.gG;
	if (_v1.$ === 1) {
		var submitOnEnter = _v1.a.pR;
		return submitOnEnter;
	} else {
		return false;
	}
};
var $author$project$Form$File$isUrlStatusEmpty = function (urlStatus) {
	switch (urlStatus.$) {
		case 0:
			return true;
		case 1:
			return false;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return false;
		default:
			return true;
	}
};
var $author$project$Form$File$isEmpty = function (_v0) {
	var model = _v0;
	var _v1 = model.i;
	if (!_v1.$) {
		if (_v1.a.$ === 1) {
			var _v2 = _v1.a;
			return true;
		} else {
			var entry = _v1.a.a;
			return $author$project$Form$File$isUrlStatusEmpty(entry.hn);
		}
	} else {
		var entries = _v1.a;
		return $elm$core$List$isEmpty(entries) || A2(
			$elm$core$List$any,
			function (entry) {
				return !$author$project$Form$File$isUrlStatusEmpty(entry.hn);
			},
			entries);
	}
};
var $author$project$Form$UserPicker$isEmpty = function (_v0) {
	var model = _v0;
	var _v1 = model.H;
	if (!_v1.$) {
		var maybeProfile = _v1.a;
		return $elm_community$maybe_extra$Maybe$Extra$isNothing(maybeProfile);
	} else {
		var profiles = _v1.a;
		return $elm$core$List$isEmpty(profiles);
	}
};
var $author$project$Form$isEmpty = function (field_) {
	switch (field_.$) {
		case 0:
			var value = field_.b.lW;
			return $elm$core$String$isEmpty(value);
		case 1:
			var value = field_.b.lW;
			return $elm$core$String$isEmpty(
				$author$project$Markdown$toUnformattedString(
					$author$project$Form$RichText$getMarkdownContent(value)));
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			var value = field_.b.lW;
			return $author$project$Form$File$isEmpty(value);
		case 6:
			return false;
		case 7:
			var value = field_.b.lW;
			return $elm_community$maybe_extra$Maybe$Extra$isNothing(
				$author$project$Form$DatePicker$getDate(value));
		case 8:
			var value = field_.b.lW;
			return $author$project$Form$UserPicker$isEmpty(value);
		case 9:
			var fields = field_.b;
			return A2(
				$elm$core$List$any,
				$author$project$Form$isEmpty,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.Z;
					},
					fields));
		case 10:
			return false;
		default:
			return false;
	}
};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Form$submitOnEnter = F3(
	function (form, model, msgs) {
		var enterKeyCode = 13;
		return A2(
			$elm$html$Html$Events$custom,
			'keyup',
			A2(
				$elm$json$Json$Decode$map,
				function (code) {
					return _Utils_eq(code, enterKeyCode) ? {
						of: A3($author$project$Form$parse, form, model, msgs),
						k3: true,
						lw: true
					} : {
						of: msgs.oM($author$project$Form$NoOp),
						k3: false,
						lw: false
					};
				},
				$elm$html$Html$Events$keyCode));
	});
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$Form$Checkbox$view = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		return A2(
			$elm$html$Html$div,
			options.mF,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$class('form-checkbox mr-2'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('with-error', viewConfig.no)
								])),
							$elm$html$Html$Attributes$checked(viewConfig.lW),
							$elm$html$Html$Events$onCheck(viewConfig.oI),
							$elm$html$Html$Attributes$id(options.w),
							$elm$html$Html$Attributes$disabled(options.b_),
							$elm$html$Html$Events$onBlur(viewConfig.oF),
							$elm$html$Html$Attributes$required(viewConfig.nV),
							$elm$html$Html$Attributes$autocomplete(false)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(options.w),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('text-green', viewConfig.lW),
									_Utils_Tuple2('text-gray-900', options.b_),
									_Utils_Tuple2('with-error', viewConfig.no)
								]))
						]),
					_List_fromArray(
						[options.n$])),
					viewConfig.na
				]));
	});
var $author$project$View$Components$ArrowDown = 4;
var $author$project$View$Components$ArrowLeft = 5;
var $author$project$View$Components$ArrowRight = 6;
var $author$project$View$Components$ArrowUp = 3;
var $author$project$Form$DatePicker$ClickedCalendarIcon = {$: 2};
var $author$project$Form$DatePicker$ClickedClear = {$: 3};
var $author$project$Form$DatePicker$ClickedKey = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$Components$Enter = 1;
var $author$project$Form$DatePicker$GotDatePickerMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$View$Components$Space = 2;
var $elm$svg$Svg$Attributes$enableBackground = _VirtualDom_attribute('enable-background');
var $author$project$Icons$calendar = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$enableBackground('new 0 0 24 24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('#999')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m18.1 7.6h-2.5v-1.6h-.9v1.6h-5.4v-1.6h-.9v1.6h-2.5c-.4 0-.7.3-.7.7v9.4c0 .4.3.7.7.7h12.2c.4 0 .7-.3.7-.7v-9.5c-.1-.3-.4-.6-.7-.6zm-.2 9.9h-11.7v-9h2.2v1.1h.9v-1.1h5.4v1.1h.9v-1.1h2.2v9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m7.9 11.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m10.4 11.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m12.7 11.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m15.1 11.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m7.9 13.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m10.4 13.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m12.7 13.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m15.1 13.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m7.9 15.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m10.4 15.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m12.7 15.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m15.1 15.2h.9v.9h-.9z')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$View$Components$Escape = 0;
var $author$project$View$Components$boolToString = function (b) {
	return b ? 'true' : 'false';
};
var $author$project$View$Components$keyListener = function (_v0) {
	var acceptedKeys = _v0.l7;
	var toMsg = _v0.lF;
	var stopPropagation = _v0.lw;
	var preventDefault = _v0.k3;
	var keyToString = function (key) {
		switch (key) {
			case 0:
				return _List_fromArray(
					['esc', 'escape']);
			case 2:
				return _List_fromArray(
					[' ']);
			case 1:
				return _List_fromArray(
					['enter']);
			case 3:
				return _List_fromArray(
					['arrowup']);
			case 4:
				return _List_fromArray(
					['arrowdown']);
			case 5:
				return _List_fromArray(
					['arrowleft']);
			default:
				return _List_fromArray(
					['arrowright']);
		}
	};
	var keyFromString = function (rawKey) {
		var _v2 = $elm$core$String$toLower(rawKey);
		switch (_v2) {
			case 'esc':
				return $elm$core$Maybe$Just(0);
			case 'escape':
				return $elm$core$Maybe$Just(0);
			case ' ':
				return $elm$core$Maybe$Just(2);
			case 'enter':
				return $elm$core$Maybe$Just(1);
			case 'arrowup':
				return $elm$core$Maybe$Just(3);
			case 'arrowdown':
				return $elm$core$Maybe$Just(4);
			case 'arrowleft':
				return $elm$core$Maybe$Just(5);
			case 'arrowright':
				return $elm$core$Maybe$Just(6);
			default:
				return $elm$core$Maybe$Nothing;
		}
	};
	var keyDecoder = F2(
		function (acceptedKeys_, toMsg_) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (rawKey) {
					var _v1 = keyFromString(rawKey);
					if (!_v1.$) {
						var key = _v1.a;
						return A2($elm$core$List$member, key, acceptedKeys_) ? $elm$json$Json$Decode$succeed(
							toMsg_(key)) : $elm$json$Json$Decode$fail('This key is not being listened to');
					} else {
						return $elm$json$Json$Decode$fail('The given key is not registered as a Key that the keyListener can listen to');
					}
				},
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['detail', 'key']),
					$elm$json$Json$Decode$string));
		});
	return A3(
		$elm$html$Html$node,
		'key-listener',
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Events$on,
				'listener-keydown',
				A2(keyDecoder, acceptedKeys, toMsg)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'keydown-stop-propagation',
				$author$project$View$Components$boolToString(stopPropagation)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'keydown-prevent-default',
				$author$project$View$Components$boolToString(preventDefault)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'accepted-keys',
				A2(
					$elm$core$String$join,
					',',
					A2($elm$core$List$concatMap, keyToString, acceptedKeys)))
			]),
		_List_Nil);
};
var $author$project$Icons$trash = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenOdd'),
						$elm$svg$Svg$Attributes$d('M20.3077 5.16788H16.3477C15.6644 3.41192 13.9331 2.25 12 2.25C10.0669 2.25 8.33558 3.41192 7.65231 5.16788H3.69231C3.30996 5.16788 3 5.46885 3 5.84013C3 6.2114 3.30996 6.51237 3.69231 6.51237H4.15385V20.4055C4.15385 21.148 4.77376 21.75 5.53846 21.75H18C18.7647 21.75 19.3846 21.148 19.3846 20.4055V6.51237H20.3077C20.69 6.51237 21 6.2114 21 5.84013C21 5.46885 20.69 5.16788 20.3077 5.16788ZM12 3.5993C13.26 3.5993 14.3538 4.04746 14.8938 5.16788H9.10615C9.64615 4.04298 10.74 3.5993 12 3.5993ZM18 20.4055H16.1538V12.7867C16.1538 12.4154 15.8439 12.1144 15.4615 12.1144C15.0792 12.1144 14.7692 12.4154 14.7692 12.7867V20.4055H12.4615V10.0977C12.4615 9.72643 12.1516 9.42545 11.7692 9.42545C11.3869 9.42545 11.0769 9.72643 11.0769 10.0977V20.4055H8.76923V12.7867C8.76923 12.4154 8.45927 12.1144 8.07692 12.1144C7.69457 12.1144 7.38462 12.4154 7.38462 12.7867V20.4055H5.53846V6.51237H18V20.4055Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $CurrySoftware$elm_datepicker$DatePicker$Blur = {$: 6};
var $CurrySoftware$elm_datepicker$DatePicker$SubmitText = {$: 4};
var $CurrySoftware$elm_datepicker$DatePicker$Text = function (a) {
	return {$: 3, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$ChangeFocus = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$MouseDown = {$: 7};
var $CurrySoftware$elm_datepicker$DatePicker$MouseUp = {$: 8};
var $CurrySoftware$elm_datepicker$DatePicker$Date$changeYear = F2(
	function (current, newYear) {
		var _v0 = $elm$core$String$toInt(newYear);
		if (!_v0.$) {
			var year = _v0.a;
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				year,
				$justinmimbs$date$Date$month(current),
				$justinmimbs$date$Date$day(current));
		} else {
			return current;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 6) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $CurrySoftware$elm_datepicker$DatePicker$maybeOr = F2(
	function (lhs, rhs) {
		if (!rhs.$) {
			return rhs;
		} else {
			return lhs;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$mkClass = F2(
	function (_v0, c) {
		var classNamespace = _v0.dr;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(classNamespace, c));
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$option = _VirtualDom_node('option');
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			var week = interval;
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval = function (weekday) {
	switch (weekday) {
		case 0:
			return 4;
		case 1:
			return 5;
		case 2:
			return 6;
		case 3:
			return 7;
		case 4:
			return 8;
		case 5:
			return 9;
		default:
			return 10;
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var weekdayAsInterval = $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
		var start = A2(
			$justinmimbs$date$Date$floor,
			weekdayAsInterval,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				1));
		var firstOfMonth = A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			1);
		var end = A2(
			$justinmimbs$date$Date$ceiling,
			weekdayAsInterval,
			A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
		return {
			jB: A4($justinmimbs$date$Date$range, 11, 1, start, end),
			hN: date
		};
	});
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $CurrySoftware$elm_datepicker$DatePicker$mkClassList = F2(
	function (_v0, cs) {
		var classNamespace = _v0.dr;
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var c = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						_Utils_ap(classNamespace, c),
						b);
				},
				cs));
	});
var $CurrySoftware$elm_datepicker$DatePicker$viewDay = F5(
	function (settings, picked, isOtherMonth, isToday, d) {
		var disabled = settings.nP(d);
		var props = (!disabled) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$CurrySoftware$elm_datepicker$DatePicker$Pick(d))
			]) : _List_Nil;
		var classList = $CurrySoftware$elm_datepicker$DatePicker$mkClassList(settings);
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				_List_fromArray(
					[
						classList(
						_List_fromArray(
							[
								_Utils_Tuple2('day', true),
								_Utils_Tuple2('disabled', disabled),
								_Utils_Tuple2(
								'picked',
								picked(d)),
								_Utils_Tuple2(
								'today',
								isToday(d)),
								_Utils_Tuple2(
								'other-month',
								isOtherMonth(d))
							]))
					]),
				props),
			_List_fromArray(
				[
					settings.hB(
					$elm$core$String$fromInt(
						$justinmimbs$date$Date$day(d)))
				]));
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$yearRange = F2(
	function (_v0, range) {
		var currentMonth = _v0.hN;
		var today = _v0.p4;
		switch (range.$) {
			case 1:
				var num = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth) - num,
					$justinmimbs$date$Date$year(currentMonth) + num);
			case 2:
				var start = range.a;
				var end = range.b;
				return A2($elm$core$List$range, start, end);
			case 3:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					year_,
					$justinmimbs$date$Date$year(today));
			case 4:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(today),
					year_);
			default:
				return _List_Nil;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$yearRangeActive = function (yearRange) {
	return !_Utils_eq(yearRange, $CurrySoftware$elm_datepicker$DatePicker$Date$Off);
};
var $CurrySoftware$elm_datepicker$DatePicker$datePicker = F3(
	function (pickedDate, settings, model) {
		var focused = model.aH;
		var today = model.p4;
		var picked = function (d) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (pdate) {
						return _Utils_eq(
							$justinmimbs$date$Date$toRataDie(pdate),
							$justinmimbs$date$Date$toRataDie(d));
					},
					pickedDate));
		};
		var onChange = function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
		};
		var isToday = function (d) {
			return _Utils_eq(
				$justinmimbs$date$Date$toRataDie(d),
				$justinmimbs$date$Date$toRataDie(today));
		};
		var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.gv) - 1;
		var dpClass = $CurrySoftware$elm_datepicker$DatePicker$mkClass(settings);
		var currentDate = A2(
			$elm$core$Maybe$withDefault,
			today,
			A2($CurrySoftware$elm_datepicker$DatePicker$maybeOr, pickedDate, focused));
		var isOtherMonth = function (d) {
			return !_Utils_eq(
				$justinmimbs$date$Date$month(currentDate),
				$justinmimbs$date$Date$month(d));
		};
		var arrow = F2(
			function (className, message) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							dpClass(className),
							$elm$html$Html$Events$onClick(message),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_Nil);
			});
		var _v0 = A2($CurrySoftware$elm_datepicker$DatePicker$prepareDates, currentDate, settings.gv);
		var currentMonth = _v0.hN;
		var currentDates = _v0.jB;
		var dayList = A2(
			$elm$core$List$map,
			function (rowDays) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							dpClass('row')
						]),
					A2(
						$elm$core$List$map,
						A4($CurrySoftware$elm_datepicker$DatePicker$viewDay, settings, picked, isOtherMonth, isToday),
						rowDays));
			},
			$CurrySoftware$elm_datepicker$DatePicker$groupDates(currentDates));
		var isCurrentYear = function (selectedYear) {
			return _Utils_eq(
				$justinmimbs$date$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(index),
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(selectedYear)),
								$elm$html$Html$Attributes$selected(
								isCurrentYear(selectedYear))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedYear))
							])));
			});
		var _v1 = function () {
			var front = function (to_) {
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth),
					to_);
			};
			var back = function (from_) {
				return A2(
					$elm$core$List$range,
					from_,
					$justinmimbs$date$Date$year(currentMonth));
			};
			var _v2 = settings.mr;
			switch (_v2.$) {
				case 3:
					var from_ = _v2.a;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(
							$justinmimbs$date$Date$year(today) + 1));
				case 4:
					var to_ = _v2.a;
					return _Utils_Tuple2(
						front(
							$justinmimbs$date$Date$year(today) - 1),
						back(to_ + 1));
				case 2:
					var from_ = _v2.a;
					var to_ = _v2.b;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(to_ + 1));
				case 1:
					var y = _v2.a;
					return _Utils_Tuple2(_List_Nil, _List_Nil);
				default:
					return _Utils_Tuple2(_List_Nil, _List_Nil);
			}
		}();
		var addedYearsFront = _v1.a;
		var addedYearsBack = _v1.b;
		var dropdownYear = A3(
			$elm$html$Html$Keyed$node,
			'select',
			_List_fromArray(
				[
					onChange(
					A2(
						$elm$core$Basics$composeR,
						$CurrySoftware$elm_datepicker$DatePicker$Date$changeYear(currentDate),
						$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus)),
					dpClass('year-menu')
				]),
			A2(
				$elm$core$List$indexedMap,
				yearOption,
				$elm$core$List$concat(
					_List_fromArray(
						[
							addedYearsFront,
							A2(
							$CurrySoftware$elm_datepicker$DatePicker$Date$yearRange,
							{hN: currentMonth, p4: today},
							settings.mr),
							addedYearsBack
						]))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					dpClass('picker'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mousedown',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseDown, true))),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseup',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseUp, true)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							dpClass('picker-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('prev-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'prev',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('month-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('month')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											settings.io(
												$justinmimbs$date$Date$month(currentMonth)))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('year')
										]),
									_List_fromArray(
										[
											(!$CurrySoftware$elm_datepicker$DatePicker$yearRangeActive(settings.mr)) ? $elm$html$Html$text(
											settings.jf(
												$justinmimbs$date$Date$year(currentMonth))) : A3(
											$elm$html$Html$Keyed$node,
											'span',
											_List_Nil,
											_List_fromArray(
												[
													_Utils_Tuple2(
													$elm$core$String$fromInt(
														$justinmimbs$date$Date$year(currentMonth)),
													dropdownYear)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('next-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'next',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
								]))
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							dpClass('table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									dpClass('weekdays')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (d) {
											return A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														dpClass('dow')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														settings.hO(d))
													]));
										},
										A2(
											$elm$core$List$take,
											7,
											A2(
												$elm$core$List$drop,
												firstDayOffset,
												$elm$core$List$concat(
													A2(
														$elm$core$List$repeat,
														2,
														_List_fromArray(
															[0, 1, 2, 3, 4, 5, 6])))))))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_fromArray(
								[
									dpClass('days')
								]),
							dayList)
						]))
				]));
	});
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $CurrySoftware$elm_datepicker$DatePicker$view = F3(
	function (pickedDate, settings, _v0) {
		var datepicker = _v0;
		var model = datepicker;
		var potentialInputId = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.nK));
		var inputClasses = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(settings.dr + 'input', true)
				]),
			settings.nJ);
		var inputCommon = function (xs) {
			return A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(inputClasses),
							$elm$html$Html$Attributes$name(
							A2($elm$core$Maybe$withDefault, '', settings.h7)),
							$elm$html$Html$Attributes$type_('text'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed($CurrySoftware$elm_datepicker$DatePicker$SubmitText)),
							$elm$html$Html$Events$onInput($CurrySoftware$elm_datepicker$DatePicker$Text),
							$elm$html$Html$Events$onBlur($CurrySoftware$elm_datepicker$DatePicker$Blur),
							$elm$html$Html$Events$onClick($CurrySoftware$elm_datepicker$DatePicker$Focus),
							$elm$html$Html$Events$onFocus($CurrySoftware$elm_datepicker$DatePicker$Focus)
						]),
					_Utils_ap(
						settings.nH,
						_Utils_ap(potentialInputId, xs))),
				_List_Nil);
		};
		var dateInput = inputCommon(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$placeholder(settings.pa),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, settings.mW, pickedDate)),
						model.bf))
				]));
		var containerClassList = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.dr + 'container', true),
			settings.mH);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(containerClassList)
				]),
			_List_fromArray(
				[
					dateInput,
					model.bH ? A3($CurrySoftware$elm_datepicker$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Form$DatePicker$view = F3(
	function (wrappedOptions, viewConfig, toMsg) {
		var options = wrappedOptions;
		var _v0 = viewConfig.lW;
		var model = _v0;
		return A2(
			$elm$html$Html$div,
			options.mF,
			_List_fromArray(
				[
					A2(
					$author$project$View$Components$label,
					_List_Nil,
					{n0: options.n$, pZ: options.w}),
					A2(
					$elm$html$Html$map,
					toMsg,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('relative w-full')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Form$DatePicker$GotDatePickerMsg(
											{et: false}),
										A3(
											$CurrySoftware$elm_datepicker$DatePicker$view,
											model.ck,
											A2($author$project$Form$DatePicker$settings, wrappedOptions, viewConfig),
											model.cZ)),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('absolute right-0 top-0 focus:outline-none'),
												$elm$html$Html$Attributes$tabindex(-1),
												$elm$html$Html$Events$onClick($author$project$Form$DatePicker$ClickedCalendarIcon),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
												viewConfig.aw.fL('dates.select')),
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Attributes$disabled(options.b_)
											]),
										_List_fromArray(
											[
												$author$project$Icons$calendar('h-12')
											]))
									])),
								$elm_community$maybe_extra$Maybe$Extra$isJust(model.ck) ? A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h-12 ml-4 group focus-ring rounded-sm focus-visible:ring-red focus-visible:ring-opacity-30'),
										$elm$html$Html$Events$onClick($author$project$Form$DatePicker$ClickedClear),
										$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
										viewConfig.aw.fL('dates.clear')),
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$disabled(options.b_)
									]),
								_List_fromArray(
									[
										$author$project$Icons$trash('text-red group-hover:opacity-80')
									])) : $elm$html$Html$text('')
							]))),
					viewConfig.na,
					$CurrySoftware$elm_datepicker$DatePicker$isOpen(model.cZ) ? $author$project$View$Components$keyListener(
					{
						l7: _List_fromArray(
							[2, 1, 3, 4, 5, 6]),
						k3: true,
						lw: true,
						lF: A2($elm$core$Basics$composeR, $author$project$Form$DatePicker$ClickedKey, toMsg)
					}) : $elm$html$Html$text('')
				]));
	});
var $author$project$Form$File$toSingleModel = function (_v0) {
	var model = _v0;
	return {
		mj: model.mj,
		eY: function () {
			var _v1 = model.i;
			if (!_v1.$) {
				var maybeEntry = _v1.a;
				return maybeEntry;
			} else {
				var entries = _v1.a;
				return $elm$core$List$head(entries);
			}
		}(),
		h9: model.Y > 0,
		gH: $elm_community$maybe_extra$Maybe$Extra$isJust(model.r),
		aj: model.aj
	};
};
var $author$project$Form$File$fromNeverAttributes = $elm$core$List$map(
	$elm$html$Html$Attributes$map($elm$core$Basics$never));
var $elm$html$Html$Keyed$ul = $elm$html$Html$Keyed$node('ul');
var $author$project$Form$File$ClickedEntry = function (a) {
	return {$: 3, a: a};
};
var $author$project$Icons$plus = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('26'),
				$elm$svg$Svg$Attributes$height('26'),
				$elm$svg$Svg$Attributes$viewBox('0 0 26 26'),
				$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M24.2829 12.0329H13.9671V1.71711C13.9671 1.18299 13.5341 0.75 13 0.75C12.4659 0.75 12.0329 1.18299 12.0329 1.71711V12.0329H1.71711C1.18299 12.0329 0.75 12.4659 0.75 13C0.75 13.5341 1.18299 13.9671 1.71711 13.9671H12.0329V24.2829C12.0329 24.817 12.4659 25.25 13 25.25C13.5341 25.25 13.9671 24.817 13.9671 24.2829V13.9671H24.2829C24.817 13.9671 25.25 13.5341 25.25 13C25.25 12.4659 24.817 12.0329 24.2829 12.0329Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Form$File$defaultAddImagesView = function (attrs) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('p-2 bg-gray-100 flex items-center justify-center w-24 h-24 rounded hover:bg-gray-200'),
				attrs),
			_List_fromArray(
				[
					$author$project$Icons$plus('text-orange-300 fill-current')
				]))
		]);
};
var $author$project$Form$File$RequestedUploadFiles = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Attributes$accept = $elm$html$Html$Attributes$stringProperty('accept');
var $author$project$Form$File$fileTypeToString = function (fileType) {
	if (fileType === 1) {
		return 'image/*';
	} else {
		return 'application/pdf';
	}
};
var $author$project$Form$File$acceptFileTypes = function (fileTypes) {
	return $elm$html$Html$Attributes$accept(
		A2(
			$elm$core$String$join,
			',',
			A2($elm$core$List$map, $author$project$Form$File$fileTypeToString, fileTypes)));
};
var $elm$file$File$decoder = _File_decoder;
var $elm$html$Html$Attributes$multiple = $elm$html$Html$Attributes$boolProperty('multiple');
var $author$project$Form$File$viewInput = F3(
	function (_v0, viewConfig, _v1) {
		var options = _v0;
		var allowMultiple = _v1.ez;
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('file'),
					$elm$html$Html$Attributes$id(options.w),
					$elm$html$Html$Attributes$class('sr-only form-file'),
					A2(
					$elm$html$Html$Events$on,
					'change',
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Form$File$RequestedUploadFiles,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['target', 'files']),
							$elm$json$Json$Decode$list($elm$file$File$decoder)))),
					$elm$html$Html$Attributes$multiple(allowMultiple),
					$author$project$Form$File$acceptFileTypes(options.dE),
					$elm$html$Html$Attributes$disabled(options.b_),
					$elm$html$Html$Attributes$required(viewConfig.nV)
				]),
			_List_Nil);
	});
var $author$project$Form$File$viewAddImages = F4(
	function (_v0, _v1, viewConfig, toMsg) {
		var allowMultiple = _v0.ez;
		var options = _v1;
		return A2(
			$elm$html$Html$map,
			toMsg,
			A2(
				$elm$html$Html$div,
				allowMultiple ? _List_Nil : A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('flex flex-col'),
					$author$project$Form$File$fromNeverAttributes(options.du)),
				_List_fromArray(
					[
						function () {
						if (allowMultiple) {
							return $elm$html$Html$text('');
						} else {
							var _v2 = options.n$;
							if (_v2.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var label = _v2.a;
								return A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('label w-max focus-ring'),
											$elm$html$Html$Events$onClick(
											$author$project$Form$File$ClickedEntry(0)),
											$elm$html$Html$Attributes$disabled(options.b_),
											$elm$html$Html$Attributes$type_('button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]));
							}
						}
					}(),
						A3(
						$author$project$Form$File$viewInput,
						options,
						viewConfig,
						{ez: allowMultiple}),
						A2(
						$elm$html$Html$label,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$for(options.w),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('cursor-pointer flex file-decoration w-max'),
								$author$project$Form$File$fromNeverAttributes(options.f$))),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($elm$core$Basics$never),
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$Form$File$defaultAddImagesView(_List_Nil),
								options.hs)))
					])));
	});
var $author$project$Form$File$DiscoveredFileType = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Icons$exclamation = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M12.25 5.75C11.8358 5.75 11.5 6.08579 11.5 6.5V13.5C11.5 13.9142 11.8358 14.25 12.25 14.25C12.6642 14.25 13 13.9142 13 13.5V6.5C13 6.08579 12.6642 5.75 12.25 5.75Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M12.25 17C12.6642 17 13 16.6642 13 16.25C13 15.8358 12.6642 15.5 12.25 15.5C11.8358 15.5 11.5 15.8358 11.5 16.25C11.5 16.6642 11.8358 17 12.25 17Z')
					]),
				_List_Nil)
			]));
};
var $author$project$View$Components$loadingLogoWithNoText = function (class_) {
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(class_),
				$elm$html$Html$Attributes$src('/images/loading.svg')
			]),
		_List_Nil);
};
var $author$project$View$Components$Image = 1;
var $author$project$View$Components$Pdf = 0;
var $author$project$View$Components$pdfViewer = F2(
	function (attrs, _v0) {
		var url = _v0.hn;
		var childClass = _v0.hC;
		var maybeTranslators = _v0.ig;
		var onFileTypeDiscovered = _v0.ix;
		var loadingAttributes = function () {
			if (maybeTranslators.$ === 1) {
				return _List_Nil;
			} else {
				var t = maybeTranslators.a.fL;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-loading-title',
						t('loading.title')),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-loading-subtitle',
						t('loading.subtitle'))
					]);
			}
		}();
		var fileTypeDiscoveredListener = function () {
			if (onFileTypeDiscovered.$ === 1) {
				return $elm$html$Html$Attributes$class('');
			} else {
				var eventListener = onFileTypeDiscovered.a;
				return A2(
					$elm$html$Html$Events$on,
					'file-type-discovered',
					A2(
						$elm$json$Json$Decode$andThen,
						function (stringFileType) {
							switch (stringFileType) {
								case 'image':
									return $elm$json$Json$Decode$succeed(
										eventListener(1));
								case 'pdf':
									return $elm$json$Json$Decode$succeed(
										eventListener(0));
								default:
									return $elm$json$Json$Decode$fail('I was expecting either `image` or `pdf`, but got ' + (stringFileType + ' instead'));
							}
						},
						A2($elm$json$Json$Decode$field, 'detail', $elm$json$Json$Decode$string)));
			}
		}();
		return A3(
			$elm$html$Html$node,
			'pdf-viewer',
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'elm-url', url),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'elm-child-class', childClass),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('flex flex-col items-center justify-center'),
						A2(
							$elm$core$List$cons,
							fileTypeDiscoveredListener,
							_Utils_ap(loadingAttributes, attrs))))),
			_List_Nil);
	});
var $author$project$Form$File$viewEntry = F4(
	function (translators, _v0, index, entry) {
		var options = _v0;
		var buttonAriaLabel = function () {
			var _v5 = entry.aG;
			if ((_v5.$ === 1) && (_v5.a === 1)) {
				var _v6 = _v5.a;
				var _v7 = entry.X;
				if (_v7.$ === 1) {
					return translators.fL('form.file.edit_image');
				} else {
					return translators.fL('form.file.edit_file');
				}
			} else {
				return translators.fL('form.file.edit_file');
			}
		}();
		var viewWithUrl = function (url) {
			return A2(
				$elm$html$Html$button,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(
						$author$project$Form$File$ClickedEntry(index)),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$type_('button'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('hover:opacity-60 focus-ring'),
							A2(
								$elm$core$List$cons,
								$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(buttonAriaLabel),
								$author$project$Form$File$fromNeverAttributes(
									options.cH(index)))))),
				_List_fromArray(
					[
						function () {
						var _v2 = entry.aG;
						if (_v2.$ === 1) {
							if (_v2.a === 1) {
								var _v3 = _v2.a;
								return A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(url),
											$elm$html$Html$Attributes$alt(''),
											$elm$html$Html$Attributes$class(options.b3)
										]),
									_List_Nil);
							} else {
								var _v4 = _v2.a;
								return A2(
									$author$project$View$Components$pdfViewer,
									_List_Nil,
									{
										hC: options.b3,
										ig: $elm$core$Maybe$Just(translators),
										ix: $elm$core$Maybe$Nothing,
										hn: url
									});
							}
						} else {
							return A2(
								$author$project$View$Components$pdfViewer,
								_List_Nil,
								{
									hC: options.b3,
									ig: $elm$core$Maybe$Just(translators),
									ix: $elm$core$Maybe$Just(
										$author$project$Form$File$DiscoveredFileType(index)),
									hn: url
								});
						}
					}(),
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							options.h3))
					]));
		};
		var _v1 = entry.hn;
		switch (_v1.$) {
			case 0:
				return A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('p-4 bg-gray-100 grid place-items-center'),
						$author$project$Form$File$fromNeverAttributes(
							options.cH(index))),
					_List_fromArray(
						[
							$author$project$View$Components$loadingLogoWithNoText('max-w-27')
						]));
			case 1:
				var url = _v1.a;
				return viewWithUrl(url);
			case 2:
				var original = _v1.a.s;
				return viewWithUrl(original);
			case 3:
				return A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('p-4 bg-gray-100 grid place-items-center'),
						$author$project$Form$File$fromNeverAttributes(
							options.cH(index))),
					_List_fromArray(
						[
							$author$project$View$Components$loadingLogoWithNoText('w-full h-full max-w-27')
						]));
			case 4:
				var croppedUrl = _v1.a.dv;
				return viewWithUrl(croppedUrl);
			default:
				return A2(
					$elm$html$Html$button,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onClick(
							$author$project$Form$File$ClickedEntry(index)),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$type_('button'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('grid place-items-center bg-gray-100'),
								$author$project$Form$File$fromNeverAttributes(
									options.cH(index))))),
					_List_fromArray(
						[
							$author$project$Icons$exclamation('text-red w-1/2 h-1/2 ' + options.b3)
						]));
		}
	});
var $author$project$Form$File$ClickedCloseEntryModal = {$: 4};
var $author$project$View$Modal$FullScreen = 1;
var $author$project$Form$File$OpenEntry = {$: 1};
var $author$project$Form$File$ClickedDeleteEntry = {$: 7};
var $author$project$Form$File$isImageCropperLoading = function (entry) {
	var _v0 = entry.X;
	if (!_v0.$) {
		return false;
	} else {
		var imageCropper = _v0.a;
		return imageCropper.nU;
	}
};
var $author$project$Form$File$isUrlStatusLoading = function (urlStatus) {
	switch (urlStatus.$) {
		case 0:
			return true;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return true;
		case 4:
			return false;
		default:
			return false;
	}
};
var $author$project$Form$File$isEntryLoading = function (entry) {
	return $author$project$Form$File$isUrlStatusLoading(entry.hn) || $author$project$Form$File$isImageCropperLoading(entry);
};
var $author$project$Form$File$deleteEntryAction = F2(
	function (_v0, entry) {
		var t = _v0.fL;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-center w-full md:w-auto uppercase text-orange-300 font-bold md:mr-auto focus-ring rounded-sm hover:opacity-60'),
					$elm$html$Html$Events$onClick($author$project$Form$File$ClickedDeleteEntry),
					$elm$html$Html$Attributes$disabled(
					$author$project$Form$File$isEntryLoading(entry)),
					$elm$html$Html$Attributes$type_('button')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					t('form.file.delete'))
				]));
	});
var $author$project$View$Modal$Default = 2;
var $author$project$View$Modal$Modal = $elm$core$Basics$identity;
var $author$project$View$Modal$initWith = function (reqOpts) {
	return {eB: _List_Nil, f6: $elm$core$Maybe$Nothing, mw: reqOpts.mw, gw: $elm$core$Maybe$Nothing, e2: $elm$core$Maybe$Nothing, nX: reqOpts.nX, g1: 1, he: 2};
};
var $author$project$Icons$externalLink = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m16 10a1 1 0 0 0 -1 1v6a1 1 0 0 1 -1 1h-11a1 1 0 0 1 -1-1v-11a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2h-6a3 3 0 0 0 -3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-6a1 1 0 0 0 -1-1z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m19.92.62a1 1 0 0 0 -.54-.54 1 1 0 0 0 -.38-.08h-6a1 1 0 0 0 0 2h3.59l-9.3 9.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l9.29-9.3v3.59a1 1 0 0 0 2 0v-6a1 1 0 0 0 -.08-.38z')
					]),
				_List_Nil)
			]));
};
var $author$project$Form$File$openEntryAction = F2(
	function (_v0, entry) {
		var t = _v0.fL;
		var maybeUrl = function () {
			var _v2 = entry.hn;
			switch (_v2.$) {
				case 1:
					var url = _v2.a;
					return $elm$core$Maybe$Just(url);
				case 2:
					var original = _v2.a.s;
					return $elm$core$Maybe$Just(original);
				case 4:
					var croppedUrl = _v2.a.dv;
					return $elm$core$Maybe$Just(croppedUrl);
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		if (maybeUrl.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var url = maybeUrl.a;
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center justify-center gap-2 w-full md:w-auto uppercase text-orange-300 font-bold focus-ring rounded-sm hover:opacity-60'),
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$href(url)
					]),
				_List_fromArray(
					[
						$author$project$Icons$externalLink('w-4 h-4 fill-current'),
						$elm$html$Html$text(
						t('form.file.open'))
					]));
		}
	});
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $author$project$Icons$camera = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$style('fill: none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$clipPath,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('a')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m0 0h16v16h-16z')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$clipPath('url(#a)'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeWidth('2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m15.3334 12.6667c0 .3536-.1405.6927-.3906.9428-.25.25-.5892.3905-.9428.3905h-11.99998c-.35362 0-.69276-.1405-.94281-.3905-.250047-.2501-.390523-.5892-.390523-.9428v-7.33337c0-.35362.140476-.69276.390523-.94281.25005-.25004.58919-.39052.94281-.39052h2.66667l1.33333-2h3.99998l1.3334 2h2.6666c.3536 0 .6928.14048.9428.39052.2501.25005.3906.58919.3906.94281z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m7.99998 11.3333c1.47276 0 2.66662-1.1939 2.66662-2.66663 0-1.47276-1.19386-2.66667-2.66662-2.66667s-2.66667 1.19391-2.66667 2.66667c0 1.47273 1.19391 2.66663 2.66667 2.66663z')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Form$File$replaceInputId = F2(
	function (_v0, index) {
		var options = _v0;
		return options.w + ('-replace-image-' + $elm$core$String$fromInt(index));
	});
var $author$project$Form$File$RequestedReplaceFile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$File$viewReplaceImageInput = F2(
	function (_v0, _v1) {
		var options = _v0;
		var isDisabled = _v1.nP;
		var index = _v1.e5;
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('file'),
					$elm$html$Html$Attributes$id(
					A2($author$project$Form$File$replaceInputId, options, index)),
					$elm$html$Html$Attributes$class('sr-only form-file'),
					A2(
					$elm$html$Html$Events$on,
					'change',
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Form$File$RequestedReplaceFile,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['target', 'files']),
							A2($elm$json$Json$Decode$index, 0, $elm$file$File$decoder)))),
					$elm$html$Html$Attributes$multiple(false),
					$author$project$Form$File$acceptFileTypes(options.dE),
					$elm$html$Html$Attributes$disabled(isDisabled || options.b_)
				]),
			_List_Nil);
	});
var $author$project$Form$File$replaceEntryAction = F4(
	function (_v0, options, index, entry) {
		var t = _v0.fL;
		var _v1 = options;
		var unwrappedOptions = _v1;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full md:w-40 flex-shrink-0')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Form$File$viewReplaceImageInput,
					options,
					{
						e5: index,
						nP: $author$project$Form$File$isEntryLoading(entry)
					}),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(
							A2($author$project$Form$File$replaceInputId, options, index)),
							$elm$html$Html$Attributes$class('cursor-pointer file-decoration button button-secondary w-full'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'button-disabled',
									unwrappedOptions.b_ || $author$project$Form$File$isEntryLoading(entry)),
									_Utils_Tuple2(
									'!bg-white !text-orange-300',
									$author$project$Form$File$isImageCropperLoading(entry))
								]))
						]),
					_List_fromArray(
						[
							$author$project$Icons$camera('w-4 mr-1'),
							$elm$html$Html$text(
							t('form.file.change'))
						]))
				]));
	});
var $author$project$Form$File$ClickedSaveEntry = {$: 8};
var $author$project$Form$File$saveEntryAction = F2(
	function (_v0, entry) {
		var t = _v0.fL;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button button-primary w-full flex-shrink-0 md:w-40'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'!bg-orange-300 !text-white cursor-wait',
							$author$project$Form$File$isImageCropperLoading(entry))
						])),
					$elm$html$Html$Events$onClick($author$project$Form$File$ClickedSaveEntry),
					$elm$html$Html$Attributes$disabled(
					$author$project$Form$File$isEntryLoading(entry)),
					$elm$html$Html$Attributes$type_('button')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					t('form.file.save'))
				]));
	});
var $author$project$View$Components$bgNoScroll = F2(
	function (attrs, preventScroll) {
		var preventScrollClass = function () {
			if (!preventScroll) {
				return 'overflow-hidden fixed w-full h-full md:overflow-auto md:static md:w-auto md:h-auto';
			} else {
				return 'overflow-hidden fixed w-full h-full md:static md:w-auto md:h-auto';
			}
		}();
		return A3(
			$elm$html$Html$node,
			'bg-no-scroll',
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'elm-prevent-scroll-class', preventScrollClass),
				attrs),
			_List_Nil);
	});
var $author$project$Icons$close = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M13.6299 12.0242L22.2329 3.25164C22.603 2.84787 22.5865 2.22339 22.1956 1.83974C21.8046 1.4561 21.18 1.45137 20.7833 1.82906L12.1938 10.5881L3.25206 1.81551C2.99607 1.54661 2.6138 1.43874 2.25501 1.53415C1.89622 1.62956 1.61802 1.91306 1.5294 2.2736C1.44078 2.63414 1.55584 3.01431 1.82951 3.26519L10.7577 12.0242L1.82951 20.7832C1.45184 21.1799 1.45656 21.8046 1.8402 22.1956C2.22383 22.5865 2.8483 22.603 3.25206 22.2329L12.1938 13.4603L20.7833 22.2194C21.18 22.597 21.8046 22.5923 22.1956 22.2087C22.5865 21.825 22.603 21.2005 22.2329 20.7968L13.6299 12.0242Z')
					]),
				_List_Nil)
			]));
};
var $author$project$View$Components$optionalAttr = F2(
	function (attr, maybeAttr) {
		if (maybeAttr.$ === 1) {
			return $elm$html$Html$Attributes$class('');
		} else {
			var attrValue = maybeAttr.a;
			return A2($elm$html$Html$Attributes$attribute, attr, attrValue);
		}
	});
var $author$project$View$Components$focusTrap = F3(
	function (_v0, attrs, children) {
		var initialFocusId = _v0.nF;
		return A3(
			$elm$html$Html$node,
			'focus-trap',
			A2(
				$elm$core$List$cons,
				A2($author$project$View$Components$optionalAttr, 'initial-focus-id', initialFocusId),
				attrs),
			children);
	});
var $author$project$Utils$onClickNoBubble = function (message) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{of: message, k3: false, lw: true}));
};
var $author$project$Utils$preventAll = F2(
	function (eventName, message) {
		return A2(
			$elm$html$Html$Events$custom,
			eventName,
			$elm$json$Json$Decode$succeed(
				{of: message, k3: true, lw: true}));
	});
var $author$project$Utils$onClickPreventAll = $author$project$Utils$preventAll('click');
var $author$project$View$Modal$viewModalDetails = function (options) {
	var header = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-header')
			]),
		_List_fromArray(
			[
				function () {
				var _v4 = options.e2;
				if (!_v4.$) {
					var headerElement = _v4.a;
					return headerElement;
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ml-auto text-gray-400 hover:text-red focus:text-red focus:outline-none'),
						$author$project$Utils$onClickNoBubble(options.mw)
					]),
				_List_fromArray(
					[
						$author$project$Icons$close('fill-current')
					]))
			]));
	var footer = function () {
		var _v3 = options.gw;
		if (!_v3.$) {
			var f = _v3.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-footer')
					]),
				f);
		} else {
			return $elm$html$Html$text('');
		}
	}();
	var content = function () {
		var _v2 = options.he;
		switch (_v2) {
			case 2:
				return 'modal-content';
			case 0:
				return 'modal-content modal-content-lg';
			default:
				return 'modal-content modal-content-full';
		}
	}();
	var body = function () {
		var _v1 = options.f6;
		if (!_v1.$) {
			var b = _v1.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-body'),
						$elm$html$Html$Attributes$tabindex(-1)
					]),
				b);
		} else {
			return $elm$html$Html$text('');
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal fade-in')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$View$Components$bgNoScroll,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-bg'),
						$author$project$Utils$onClickPreventAll(options.mw)
					]),
				options.g1),
				A3(
				$author$project$View$Components$focusTrap,
				{
					nF: $elm$core$Maybe$Just('modal-first-focus')
				},
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class(content),
					options.eB),
				_List_fromArray(
					[
						header,
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('modal-first-focus'),
								$elm$html$Html$Attributes$tabindex(-1),
								$elm$html$Html$Attributes$class('sr-only'),
								$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
							]),
						_List_Nil),
						body,
						footer
					])),
				$author$project$View$Components$keyListener(
				{
					l7: _List_fromArray(
						[0]),
					k3: false,
					lw: true,
					lF: function (_v0) {
						return options.mw;
					}
				})
			]));
};
var $author$project$View$Modal$toHtml = function (_v0) {
	var options = _v0;
	return options.nX ? $author$project$View$Modal$viewModalDetails(options) : $elm$html$Html$text('');
};
var $author$project$View$ImageCropper$ImageLoaded = {$: 0};
var $author$project$View$ImageCropper$Dragged = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$ImageCropper$GotCroppedImage = function (a) {
	return {$: 8, a: a};
};
var $author$project$View$ImageCropper$StoppedDragging = {$: 3};
var $elm$html$Html$Attributes$draggable = _VirtualDom_attribute('draggable');
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$View$Components$optionalListener = F2(
	function (eventName, maybeMsg) {
		if (maybeMsg.$ === 1) {
			return $elm$html$Html$Attributes$class('');
		} else {
			var msg = maybeMsg.a;
			return A2(
				$elm$html$Html$Events$on,
				eventName,
				$elm$json$Json$Decode$succeed(msg));
		}
	});
var $author$project$View$Components$optionalListenerWithArgs = F3(
	function (eventName, maybeMsg, decoder) {
		if (maybeMsg.$ === 1) {
			return $elm$html$Html$Attributes$class('');
		} else {
			var msg = maybeMsg.a;
			return A2(
				$elm$html$Html$Events$on,
				eventName,
				A2($elm$json$Json$Decode$map, msg, decoder));
		}
	});
var $author$project$View$Components$pointerListener = F3(
	function (_v0, attrs, children) {
		var document = _v0.eT;
		var element = _v0.jJ;
		return A3(
			$elm$html$Html$node,
			'pointer-listener',
			A2(
				$elm$core$List$cons,
				A3(
					$author$project$View$Components$optionalListenerWithArgs,
					'document-dragover',
					document.oL,
					A2(
						$elm$json$Json$Decode$field,
						'detail',
						A5(
							$elm$json$Json$Decode$map4,
							F4(
								function (x, y, previousX, previousY) {
									return {pe: previousX, pf: previousY, l2: x, l3: y};
								}),
							A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
							A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float),
							A2($elm$json$Json$Decode$field, 'previousX', $elm$json$Json$Decode$float),
							A2($elm$json$Json$Decode$field, 'previousY', $elm$json$Json$Decode$float)))),
				A2(
					$elm$core$List$cons,
					A2($author$project$View$Components$optionalListener, 'element-dragend', element.oK),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$View$Components$optionalListener,
							'element-dragstart',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.n8;
								},
								element.kR)),
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$View$Components$optionalAttr,
								'element-pointerdown-drag-image',
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.m2;
									},
									element.kR)),
							attrs)))),
			children);
	});
var $author$project$View$ImageCropper$viewCropper = F3(
	function (model, dimmensions, _v0) {
		var imageUrl = _v0.nC;
		var cropperAttributes = _v0.mS;
		var selection = A2($author$project$View$ImageCropper$calculateSelectionDimmensions, model, dimmensions);
		var topOffset = A3($elm$core$Basics$clamp, 0, dimmensions.M.gD - selection.gD, dimmensions.cr - dimmensions.M.bO);
		var leftOffset = A3($elm$core$Basics$clamp, 0, dimmensions.M.l1 - selection.l1, dimmensions.ca - dimmensions.M.bE);
		var floatToPx = function (offset) {
			return $elm$core$String$fromFloat(offset) + 'px';
		};
		return _List_fromArray(
			[
				A3(
				$author$project$View$Components$pointerListener,
				{
					eT: {
						oL: model.b8 ? $elm$core$Maybe$Just($author$project$View$ImageCropper$Dragged) : $elm$core$Maybe$Nothing
					},
					jJ: {
						oK: $elm$core$Maybe$Just($author$project$View$ImageCropper$StoppedDragging),
						kR: $elm$core$Maybe$Just(
							{m2: $elm$core$Maybe$Nothing, n8: $author$project$View$ImageCropper$StartedDragging})
					}
				},
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('absolute overflow-hidden border border-dashed border-gray-400 cursor-move z-20 select-none mx-auto'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('transition-all origin-center', (!model.b8) && ((!model.dP) && (!model.e8)))
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$Attributes$style,
								'top',
								floatToPx(topOffset)),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$Attributes$style,
									'left',
									floatToPx(leftOffset)),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$Attributes$style,
										'width',
										floatToPx(selection.l1)),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$Attributes$style,
											'height',
											floatToPx(selection.gD)),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$draggable('true'),
											A2(
												$elm$core$List$map,
												$elm$html$Html$Attributes$map($elm$core$Basics$never),
												cropperAttributes)))))))),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(imageUrl),
								$elm$html$Html$Attributes$alt(''),
								$elm$html$Html$Attributes$class('absolute object-cover max-w-none pointer-events-none select-none'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('transition-all origin-center', (!model.b8) && ((!model.dP) && (!model.e8)))
									])),
								A2(
								$elm$html$Html$Attributes$style,
								'width',
								floatToPx(dimmensions.h2.l1)),
								A2(
								$elm$html$Html$Attributes$style,
								'height',
								floatToPx(dimmensions.h2.gD)),
								A2(
								$elm$html$Html$Attributes$style,
								'top',
								floatToPx(((dimmensions.h2.bO - dimmensions.M.bO) - topOffset) - 1)),
								A2(
								$elm$html$Html$Attributes$style,
								'left',
								floatToPx(((dimmensions.h2.bE - dimmensions.M.bE) - leftOffset) - 1))
							]),
						_List_Nil)
					])),
				A3(
				$elm$html$Html$node,
				'image-cropper',
				_List_fromArray(
					[
						model.nU ? A2($elm$html$Html$Attributes$attribute, 'elm-generate-new-cropped-image', 'true') : $elm$html$Html$Attributes$class(''),
						A2($elm$html$Html$Attributes$attribute, 'elm-url', imageUrl),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-image-width',
						$elm$core$String$fromFloat(dimmensions.h2.l1)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-image-height',
						$elm$core$String$fromFloat(dimmensions.h2.gD)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-image-left',
						$elm$core$String$fromFloat(dimmensions.h2.bE)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-image-top',
						$elm$core$String$fromFloat(dimmensions.h2.bO)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-container-left',
						$elm$core$String$fromFloat(dimmensions.M.bE)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-container-top',
						$elm$core$String$fromFloat(dimmensions.M.bO)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-selection-left',
						$elm$core$String$fromFloat(leftOffset)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-selection-top',
						$elm$core$String$fromFloat(topOffset)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-selection-width',
						$elm$core$String$fromFloat(selection.l1)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-selection-height',
						$elm$core$String$fromFloat(selection.gD)),
						A2(
						$elm$html$Html$Events$on,
						'crop-image',
						A2(
							$elm$json$Json$Decode$map,
							$author$project$View$ImageCropper$GotCroppedImage,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['detail', 'image']),
								$elm$file$File$decoder))),
						A2(
						$elm$html$Html$Events$on,
						'document-resize',
						$elm$json$Json$Decode$succeed($author$project$View$ImageCropper$ImageLoaded))
					]),
				_List_Nil)
			]);
	});
var $author$project$View$ImageCropper$ChangedDimmensions = function (a) {
	return {$: 5, a: a};
};
var $author$project$View$ImageCropper$ClickedZoomOperation = function (a) {
	return {$: 7, a: a};
};
var $author$project$View$ImageCropper$CompletedChangingDimmensions = {$: 6};
var $author$project$View$ImageCropper$Minus = 0;
var $author$project$View$ImageCropper$Plus = 1;
var $author$project$Icons$magnifyingGlassWithMinus = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7 10H13'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M21 21L15 15'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$magnifyingGlassWithPlus = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7 10H13'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M10 7V13'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M21 21L15 15'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$View$ImageCropper$viewSlider = function (dimmensions) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex mt-6 flex-grow-0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$View$ImageCropper$ClickedZoomOperation(0)),
						$elm$html$Html$Attributes$class('flex-shrink-0 bg-gray-100 p-2 w-10 h-10 rounded-full focus-ring'),
						$elm$html$Html$Attributes$type_('button')
					]),
				_List_fromArray(
					[
						$author$project$Icons$magnifyingGlassWithMinus('')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('range'),
						$elm$html$Html$Attributes$class('w-full mx-2'),
						$elm$html$Html$Attributes$value(
						$elm$core$String$fromFloat(dimmensions.a_)),
						$elm$html$Html$Events$onInput($author$project$View$ImageCropper$ChangedDimmensions),
						A2(
						$elm$html$Html$Events$on,
						'change',
						$elm$json$Json$Decode$succeed($author$project$View$ImageCropper$CompletedChangingDimmensions)),
						$elm$html$Html$Attributes$min('0.1'),
						$elm$html$Html$Attributes$max(
						$elm$core$String$fromFloat(dimmensions.fh)),
						$elm$html$Html$Attributes$step('0.001')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$View$ImageCropper$ClickedZoomOperation(1)),
						$elm$html$Html$Attributes$class('flex-shrink-0 bg-gray-100 p-2 w-10 h-10 rounded-full focus-ring'),
						$elm$html$Html$Attributes$type_('button')
					]),
				_List_fromArray(
					[
						$author$project$Icons$magnifyingGlassWithPlus('')
					]))
			]));
};
var $author$project$View$ImageCropper$view = F2(
	function (model, _v0) {
		var imageUrl = _v0.nC;
		var cropperAttributes = _v0.mS;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto w-full md:flex md:flex-col md:w-auto')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative max-w-max mx-auto flex items-center justify-center max-h-[35vh] lg:max-h-[60vh]'),
							A2(
							$elm$html$Html$Attributes$style,
							'aspect-ratio',
							$elm$core$String$fromFloat(model.mj)),
							$elm$html$Html$Attributes$id($author$project$View$ImageCropper$imageContainerId)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(imageUrl),
									$elm$html$Html$Attributes$alt(''),
									$elm$html$Html$Attributes$id($author$project$View$ImageCropper$entireImageId),
									$elm$html$Html$Attributes$class('opacity-20 pointer-events-none select-none max-w-full max-h-[35vh] lg:max-h-[60vh]'),
									A2(
									$elm$html$Html$Events$on,
									'load',
									$elm$json$Json$Decode$succeed($author$project$View$ImageCropper$ImageLoaded))
								]),
							_List_Nil),
						function () {
							var _v1 = model.ah;
							if (!_v1.$) {
								return _List_Nil;
							} else {
								var dimmensions = _v1.a;
								return A3(
									$author$project$View$ImageCropper$viewCropper,
									model,
									dimmensions,
									{mS: cropperAttributes, nC: imageUrl});
							}
						}())),
					function () {
					var _v2 = model.ah;
					if (!_v2.$) {
						return $elm$html$Html$text('');
					} else {
						var dimmensions = _v2.a;
						return $author$project$View$ImageCropper$viewSlider(dimmensions);
					}
				}()
				]));
	});
var $author$project$View$Modal$withBody = F2(
	function (body, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				f6: $elm$core$Maybe$Just(body)
			});
	});
var $author$project$View$Modal$withFooter = F2(
	function (footer, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gw: $elm$core$Maybe$Just(footer)
			});
	});
var $author$project$View$Modal$withHeader = F2(
	function (header, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				e2: $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(header)
							])))
			});
	});
var $author$project$View$Modal$withSize = F2(
	function (size, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{he: size});
	});
var $author$project$Form$File$viewEntryModal = F5(
	function (_v0, viewConfig, _v1, entry, toMsg) {
		var options = _v0;
		var isVisible = _v1.nX;
		var index = _v1.e5;
		var addOpenEntryAction = function (actions) {
			return _Utils_ap(
				A2(
					$elm_community$list_extra$List$Extra$takeWhile,
					function (action) {
						return !_Utils_eq(action, $author$project$Form$File$ReplaceEntry);
					},
					actions),
				A2(
					$elm$core$List$cons,
					$author$project$Form$File$OpenEntry,
					A2(
						$elm_community$list_extra$List$Extra$dropWhile,
						function (action) {
							return !_Utils_eq(action, $author$project$Form$File$ReplaceEntry);
						},
						actions)));
		};
		var actionsWithOpenAction = A2(
			$elm$core$List$member,
			$author$project$Form$File$OpenEntry,
			options.dA(index)) ? options.dA(index) : (_Utils_eq(
			entry.aG,
			$author$project$Form$File$LoadedFileType(0)) ? addOpenEntryAction(
			options.dA(index)) : options.dA(index));
		var _v2 = viewConfig;
		var translators = _v2.aw;
		var viewWithUrl = function (url) {
			var _v10 = entry.aG;
			if (_v10.$ === 1) {
				if (_v10.a === 1) {
					var _v11 = _v10.a;
					var _v12 = entry.X;
					if (!_v12.$) {
						return A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(url),
									$elm$html$Html$Attributes$alt(''),
									$elm$html$Html$Attributes$class('mx-auto w-full md:w-auto max-h-[35vh] lg:max-h-[60vh]')
								]),
							_List_Nil);
					} else {
						var imageCropper = _v12.a;
						return A2(
							$elm$html$Html$map,
							A2($elm$core$Basics$composeR, $author$project$Form$File$GotImageCropperMsg, toMsg),
							A2(
								$author$project$View$ImageCropper$view,
								imageCropper,
								{mS: options.gE, nC: url}));
					}
				} else {
					var _v13 = _v10.a;
					return A2(
						$author$project$View$Components$pdfViewer,
						_List_Nil,
						{
							hC: 'mx-auto w-full md:w-auto max-h-full max-h-[35vh] lg:max-h-[60vh]',
							ig: $elm$core$Maybe$Just(translators),
							ix: $elm$core$Maybe$Nothing,
							hn: url
						});
				}
			} else {
				return A2(
					$author$project$View$Components$pdfViewer,
					_List_Nil,
					{
						hC: 'mx-auto w-full md:w-auto max-h-full max-h-[35vh] lg:max-h-[60vh]',
						ig: $elm$core$Maybe$Just(translators),
						ix: $elm$core$Maybe$Nothing,
						hn: url
					});
			}
		};
		var _v3 = function () {
			var _v4 = entry.aG;
			if (_v4.$ === 1) {
				if (_v4.a === 1) {
					var _v5 = _v4.a;
					var _v6 = entry.X;
					if (_v6.$ === 1) {
						return _Utils_Tuple2(
							translators.fL('form.file.edit_image'),
							translators.fL('form.file.body_image'));
					} else {
						return _Utils_Tuple2(
							translators.fL('form.file.edit_file'),
							translators.fL('form.file.body_file'));
					}
				} else {
					var _v7 = _v4.a;
					return _Utils_Tuple2(
						translators.fL('form.file.edit_file'),
						translators.fL('form.file.body_file'));
				}
			} else {
				return _Utils_Tuple2('', '');
			}
		}();
		var header = _v3.a;
		var bodyText = _v3.b;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withSize,
				1,
				A2(
					$author$project$View$Modal$withFooter,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap items-center justify-center md:flex gap-6 w-full px-10')
								]),
							A3(
								$elm$core$List$foldr,
								F2(
									function (action, actions) {
										var viewAction = function () {
											switch (action.$) {
												case 0:
													return A2(
														$elm$html$Html$map,
														toMsg,
														A2($author$project$Form$File$deleteEntryAction, translators, entry));
												case 1:
													return A2(
														$elm$html$Html$map,
														toMsg,
														A2($author$project$Form$File$openEntryAction, translators, entry));
												case 2:
													return A2(
														$elm$html$Html$map,
														toMsg,
														A4($author$project$Form$File$replaceEntryAction, translators, options, index, entry));
												case 3:
													return A2(
														$elm$html$Html$map,
														toMsg,
														A2($author$project$Form$File$saveEntryAction, translators, entry));
												default:
													var customView = action.a;
													return customView;
											}
										}();
										return A2($elm$core$List$cons, viewAction, actions);
									}),
								_List_Nil,
								actionsWithOpenAction))
						]),
					A2(
						$author$project$View$Modal$withBody,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(bodyText)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center justify-center mt-4')
									]),
								_List_fromArray(
									[
										function () {
										var _v8 = entry.hn;
										switch (_v8.$) {
											case 0:
												return A2($author$project$View$Components$loadingLogoAnimated, translators, '');
											case 1:
												var url = _v8.a;
												return viewWithUrl(url);
											case 2:
												var original = _v8.a.s;
												return viewWithUrl(original);
											case 3:
												var original = _v8.a.s;
												return viewWithUrl(original);
											case 4:
												var original = _v8.a.s;
												return viewWithUrl(original);
											default:
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-full')
														]),
													_List_fromArray(
														[
															$author$project$Icons$exclamation('mb-4 mx-auto bg-gray-100 p-4 w-1/4 text-red w-full h-full rounded-sm'),
															A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('form-error text-center')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	translators.fL('error.file_upload'))
																]))
														]));
										}
									}()
									]))
							]),
						A2(
							$author$project$View$Modal$withHeader,
							header,
							$author$project$View$Modal$initWith(
								{
									mw: toMsg($author$project$Form$File$ClickedCloseEntryModal),
									nX: isVisible
								}))))));
	});
var $author$project$Form$File$viewMultiple = F4(
	function (_v0, _v1, viewConfig, toMsg) {
		var model = _v0;
		var options = _v1;
		var maybeOpenEntry = A2(
			$elm$core$Maybe$andThen,
			function (index) {
				return A2($elm_community$list_extra$List$Extra$getAt, index, model.i);
			},
			model.r);
		return A2(
			$elm$html$Html$div,
			$author$project$Form$File$fromNeverAttributes(options.du),
			_List_fromArray(
				[
					function () {
					var _v2 = options.n$;
					if (_v2.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var label = _v2.a;
						return A2(
							$author$project$View$Components$label,
							_List_Nil,
							{n0: label, pZ: options.w});
					}
				}(),
					A2(
					$elm$html$Html$Keyed$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-wrap gap-4')
						]),
					_Utils_ap(
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, entry) {
									return _Utils_Tuple2(
										'entry-' + $elm$core$String$fromInt(index),
										A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													toMsg,
													A4($author$project$Form$File$viewEntry, viewConfig.aw, options, index, entry))
												])));
								}),
							model.i),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'add-images-input',
								A4(
									$author$project$Form$File$viewAddImages,
									{ez: true},
									options,
									viewConfig,
									toMsg))
							]))),
					function () {
					if (maybeOpenEntry.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var entry = maybeOpenEntry.a;
						return A5(
							$author$project$Form$File$viewEntryModal,
							options,
							viewConfig,
							{
								e5: A2($elm$core$Maybe$withDefault, 0, model.r),
								nX: true
							},
							entry,
							toMsg);
					}
				}()
				]));
	});
var $author$project$Form$File$viewSingle = F4(
	function (_v0, _v1, viewConfig, toMsg) {
		var model = _v0;
		var options = _v1;
		var _v2 = model.eY;
		if (_v2.$ === 1) {
			return A4(
				$author$project$Form$File$viewAddImages,
				{ez: false},
				options,
				viewConfig,
				toMsg);
		} else {
			var entry = _v2.a;
			return A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('flex flex-col'),
					$author$project$Form$File$fromNeverAttributes(options.du)),
				_List_fromArray(
					[
						function () {
						var _v3 = options.n$;
						if (_v3.$ === 1) {
							return $elm$html$Html$text('');
						} else {
							var label = _v3.a;
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label w-max focus-ring'),
										$elm$html$Html$Events$onClick(
										toMsg(
											$author$project$Form$File$ClickedEntry(0))),
										$elm$html$Html$Attributes$disabled(options.b_),
										$elm$html$Html$Attributes$type_('button')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									]));
						}
					}(),
						A2(
						$elm$html$Html$map,
						toMsg,
						A4($author$project$Form$File$viewEntry, viewConfig.aw, options, 0, entry)),
						A5(
						$author$project$Form$File$viewEntryModal,
						options,
						viewConfig,
						{e5: 0, nX: model.gH},
						entry,
						toMsg)
					]));
		}
	});
var $author$project$Form$File$view = F3(
	function (options, viewConfig, toMsg) {
		var _v0 = viewConfig.lW;
		var model = _v0;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v1 = model.i;
					if (!_v1.$) {
						return A4(
							$author$project$Form$File$viewSingle,
							$author$project$Form$File$toSingleModel(model),
							options,
							viewConfig,
							toMsg);
					} else {
						return A4(
							$author$project$Form$File$viewMultiple,
							$author$project$Form$File$toMultipleModel(model),
							options,
							viewConfig,
							toMsg);
					}
				}(),
					viewConfig.no ? viewConfig.na : $elm$html$Html$text('')
				]));
	});
var $author$project$Form$Radio$Horizontal = 0;
var $author$project$Form$Radio$Vertical = 1;
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$Form$Radio$view = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		var viewOption = function (_v1) {
			var option = _v1.gY;
			var label = _v1.n$;
			var isSelected = _Utils_eq(option, viewConfig.lW);
			return A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center transition-colors duration-100'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('text-green', isSelected && (!options.b_)),
								_Utils_Tuple2('text-red', isSelected && viewConfig.no),
								_Utils_Tuple2('text-gray-900', options.b_)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('radio'),
								$elm$html$Html$Attributes$name(options.w),
								$elm$html$Html$Attributes$value(
								options.d5(option)),
								$elm$html$Html$Attributes$checked(isSelected),
								$elm$html$Html$Events$onClick(
								viewConfig.kV(option)),
								$elm$html$Html$Events$onBlur(viewConfig.oF),
								$elm$html$Html$Attributes$class('form-radio mr-2 shadow-form-control'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('with-error', isSelected && viewConfig.no),
										_Utils_Tuple2('hover:border-green', (!viewConfig.no) && (!options.b_)),
										_Utils_Tuple2('hover:border-red', viewConfig.no && (!options.b_)),
										_Utils_Tuple2('sr-only', options.cK)
									]))
							]),
						_List_Nil),
						label
					]));
		};
		return A2(
			$elm$html$Html$fieldset,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$disabled(options.b_),
				options.mF),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$legend,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('label'),
						options.dY),
					_List_fromArray(
						[
							$elm$html$Html$text(options.n$)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-wrap'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('flex-col gap-4', options.F === 1),
									_Utils_Tuple2('gap-4', (!options.F) && options.cK),
									_Utils_Tuple2('gap-x-8 gap-y-4', (!options.F) && (!options.cK))
								]))
						]),
					A2(
						$elm$core$List$map,
						viewOption,
						$elm$core$List$reverse(options.d6))),
					viewConfig.na
				]));
	});
var $author$project$Form$RichText$ChangedText = function (a) {
	return {$: 6, a: a};
};
var $author$project$Form$RichText$ClickedAcceptLink = {$: 5};
var $author$project$Form$RichText$ClickedIncludeLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$RichText$ClosedLinkModal = {$: 2};
var $author$project$Form$RichText$ComponentLoaded = {$: 7};
var $author$project$Form$RichText$EnteredLinkLabel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Form$RichText$EnteredLinkUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Form$RichText$NoOp = {$: 0};
var $author$project$Form$Text$Url = 3;
var $author$project$Form$RichText$Link = F2(
	function (label, url) {
		return {n$: label, hn: url};
	});
var $author$project$Form$RichText$linkDecoder = A2(
	$elm$json$Json$Decode$field,
	'detail',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Form$RichText$Link))));
var $author$project$Utils$onSubmitPreventAll = $author$project$Utils$preventAll('submit');
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Markdown$formattingObjectDecoder = function () {
	var baseDecoder = F2(
		function (key, formattingDecoder) {
			return A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				key,
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, formattingDecoder),
				$elm$core$Maybe$Nothing);
		});
	var simpleFormatting = F2(
		function (key, formatting) {
			return A2(
				baseDecoder,
				key,
				$elm$json$Json$Decode$succeed(formatting));
		});
	return A3(
		baseDecoder,
		'list',
		A2(
			$elm$json$Json$Decode$andThen,
			function (decodedString) {
				switch (decodedString) {
					case 'bullet':
						return $elm$json$Json$Decode$succeed($author$project$Markdown$UnorderedList);
					case 'ordered':
						return $elm$json$Json$Decode$succeed($author$project$Markdown$OrderedList);
					default:
						return $elm$json$Json$Decode$fail('Expected either `bullet` or `ordered` as a list type');
				}
			},
			$elm$json$Json$Decode$string),
		A3(
			baseDecoder,
			'header',
			A2($elm$json$Json$Decode$map, $author$project$Markdown$Header, $elm$json$Json$Decode$int),
			A3(
				baseDecoder,
				'link',
				A2($elm$json$Json$Decode$map, $author$project$Markdown$LinkFormatting, $elm$json$Json$Decode$string),
				A3(
					simpleFormatting,
					'underline',
					$author$project$Markdown$Underline,
					A3(
						simpleFormatting,
						'strike',
						$author$project$Markdown$Strike,
						A3(
							simpleFormatting,
							'italic',
							$author$project$Markdown$Italic,
							A3(
								simpleFormatting,
								'bold',
								$author$project$Markdown$Bold,
								$elm$json$Json$Decode$succeed(
									F7(
										function (bold, italic, strike, underline, link, header, list) {
											return A2(
												$elm$core$List$filterMap,
												$elm$core$Basics$identity,
												_List_fromArray(
													[bold, italic, strike, underline, link, header, list]));
										})))))))));
}();
var $author$project$Markdown$quillOpDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'attributes',
	$author$project$Markdown$formattingObjectDecoder,
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'insert',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed(
			F2(
				function (insert, attributes) {
					return {y: attributes, aI: insert};
				}))));
var $author$project$Form$RichText$textChangeDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail', 'ops']),
	$elm$json$Json$Decode$list($author$project$Markdown$quillOpDecoder));
var $author$project$Form$RichText$view = F3(
	function (_v0, viewConfig, toMsg) {
		var options = _v0;
		var model = function () {
			var _v3 = viewConfig.lW;
			var model_ = _v3;
			return model_;
		}();
		var boolToString = function (x) {
			return x ? 'true' : 'false';
		};
		var _v1 = viewConfig.aw;
		var t = _v1.fL;
		return A2(
			$elm$html$Html$div,
			options.mF,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					options.gq,
					_List_fromArray(
						[
							$elm$core$String$isEmpty(options.n$) ? $elm$html$Html$text('') : A2(
							$author$project$View$Components$label,
							_List_Nil,
							{n0: options.n$, pZ: model.w}),
							A2(
							$elm$html$Html$map,
							toMsg,
							A3(
								$elm$html$Html$node,
								'richtext-editor',
								_List_fromArray(
									[
										A2(
										$elm$html$Html$Attributes$attribute,
										'elm-placeholder',
										A2($elm$core$Maybe$withDefault, '', options.pa)),
										A2($elm$html$Html$Attributes$attribute, 'elm-id', model.w),
										A2(
										$elm$html$Html$Attributes$attribute,
										'elm-has-error',
										boolToString(viewConfig.no)),
										A2(
										$elm$html$Html$Attributes$attribute,
										'elm-edit-text',
										t('markdown.link_tooltip.edit')),
										A2(
										$elm$html$Html$Attributes$attribute,
										'elm-remove-text',
										t('markdown.link_tooltip.remove')),
										A2(
										$elm$html$Html$Attributes$attribute,
										'elm-disabled',
										boolToString(options.b_)),
										A2(
										$elm$html$Html$Events$on,
										'clicked-include-link',
										A2($elm$json$Json$Decode$map, $author$project$Form$RichText$ClickedIncludeLink, $author$project$Form$RichText$linkDecoder)),
										A2(
										$elm$html$Html$Events$on,
										'text-change',
										A2($elm$json$Json$Decode$map, $author$project$Form$RichText$ChangedText, $author$project$Form$RichText$textChangeDecoder)),
										A2(
										$elm$html$Html$Events$on,
										'component-loaded',
										$elm$json$Json$Decode$succeed($author$project$Form$RichText$ComponentLoaded))
									]),
								_List_Nil)),
							viewConfig.na
						])),
					function () {
					var _v2 = model.bj;
					if (!_v2.$) {
						return $elm$html$Html$text('');
					} else {
						var linkModal = _v2.a;
						return A2(
							$elm$html$Html$map,
							toMsg,
							$author$project$View$Modal$toHtml(
								A2(
									$author$project$View$Modal$withBody,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$form,
											_List_fromArray(
												[
													$author$project$Utils$onSubmitPreventAll($author$project$Form$RichText$ClickedAcceptLink),
													$elm$html$Html$Attributes$novalidate(true)
												]),
											_List_fromArray(
												[
													function (config) {
													return A2(
														$author$project$Form$Text$view,
														config,
														{
															na: $elm$html$Html$text(''),
															no: false,
															nV: true,
															oF: $author$project$Form$RichText$NoOp,
															oH: $author$project$Form$RichText$EnteredLinkLabel,
															aw: viewConfig.aw,
															lW: linkModal.n$
														});
												}(
													$author$project$Form$Text$init(
														{
															w: model.w + '-link-modal-label',
															n$: t('markdown.link_form.label')
														})),
													function (config) {
													return A2(
														$author$project$Form$Text$view,
														config,
														{
															na: $elm$html$Html$text(''),
															no: false,
															nV: true,
															oF: $author$project$Form$RichText$NoOp,
															oH: $author$project$Form$RichText$EnteredLinkUrl,
															aw: viewConfig.aw,
															lW: linkModal.hn
														});
												}(
													A2(
														$author$project$Form$Text$withType,
														3,
														$author$project$Form$Text$init(
															{
																w: model.w + '-link-modal-url',
																n$: t('markdown.link_form.url')
															}))),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex justify-center items-center')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('modal-cancel'),
																	$elm$html$Html$Events$onClick($author$project$Form$RichText$ClosedLinkModal),
																	$elm$html$Html$Attributes$type_('button')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('menu.cancel'))
																])),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('modal-accept'),
																	$elm$html$Html$Attributes$type_('submit')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('menu.save'))
																]))
														]))
												]))
										]),
									A2(
										$author$project$View$Modal$withHeader,
										t('markdown.link_form.header'),
										$author$project$View$Modal$initWith(
											{mw: $author$project$Form$RichText$ClosedLinkModal, nX: true})))));
					}
				}()
				]));
	});
var $author$project$Form$Select$customOnInput = F2(
	function (optionFromString, optionToMsg) {
		return A2(
			$elm$html$Html$Events$stopPropagationOn,
			'input',
			A2(
				$elm$json$Json$Decode$map,
				function (optionMsg) {
					return _Utils_Tuple2(optionMsg, true);
				},
				A2(
					$elm$json$Json$Decode$andThen,
					function (targetValue) {
						var _v0 = optionFromString(targetValue);
						if (_v0.$ === 1) {
							return $elm$json$Json$Decode$fail('The selected value is not a valid option');
						} else {
							var optionValue = _v0.a;
							return $elm$json$Json$Decode$succeed(
								optionToMsg(optionValue));
						}
					},
					$elm$html$Html$Events$targetValue)));
	});
var $elm_community$list_extra$List$Extra$findMap = F2(
	function (f, list) {
		findMap:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var a = list.a;
				var tail = list.b;
				var _v1 = f(a);
				if (!_v1.$) {
					var b = _v1.a;
					return $elm$core$Maybe$Just(b);
				} else {
					var $temp$f = f,
						$temp$list = tail;
					f = $temp$f;
					list = $temp$list;
					continue findMap;
				}
			}
		}
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$Form$Select$view = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		var viewOption = function (_v2) {
			var option = _v2.gY;
			var label = _v2.n$;
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(
						options.d5(option)),
						$elm$html$Html$Attributes$selected(
						_Utils_eq(viewConfig.lW, option))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]));
		};
		var optionFromValue = function (newValue) {
			return A2(
				$elm_community$list_extra$List$Extra$findMap,
				function (_v1) {
					var option = _v1.gY;
					return _Utils_eq(
						options.d5(option),
						newValue) ? $elm$core$Maybe$Just(option) : $elm$core$Maybe$Nothing;
				},
				options.d6);
		};
		return A2(
			$elm$html$Html$div,
			options.mF,
			_List_fromArray(
				[
					A2(
					$author$project$View$Components$label,
					options.dY,
					{n0: options.n$, pZ: options.w}),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('input pr-10 form-select-icon w-full'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('with-error', viewConfig.no)
								])),
							$elm$html$Html$Attributes$required(viewConfig.nV),
							$elm$html$Html$Attributes$disabled(options.b_),
							$elm$html$Html$Events$onBlur(viewConfig.oF),
							A2($author$project$Form$Select$customOnInput, optionFromValue, viewConfig.kV)
						]),
					A2(
						$elm$core$List$map,
						viewOption,
						$elm$core$List$reverse(options.d6))),
					viewConfig.na
				]));
	});
var $author$project$Form$Toggle$Options = $elm$core$Basics$identity;
var $author$project$Icons$question = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M8 4C6.02353 4 5.5 5.44412 5.5 6.20588C5.5 6.44954 5.69752 6.64706 5.94118 6.64706C6.18483 6.64706 6.38235 6.44954 6.38235 6.20588C6.38235 6.07059 6.42647 4.88235 8 4.88235C9.49706 4.88235 9.61765 5.71176 9.61765 6.79412C9.61765 6.96176 9.20588 7.22647 8.90294 7.41765C8.31471 7.8 7.55882 8.27353 7.55882 9.14706C7.55882 9.39071 7.75635 9.58823 8 9.58823C8.24366 9.58823 8.44118 9.39071 8.44118 9.14706C8.44118 8.78529 8.81176 8.52353 9.37647 8.16176C9.94118 7.8 10.5 7.44706 10.5 6.79412C10.5 5.95882 10.5 4 8 4Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M7.85329 11.5C8.09694 11.5 8.29446 11.3025 8.29446 11.0589C8.29446 10.8152 8.09694 10.6177 7.85329 10.6177C7.60963 10.6177 7.41211 10.8152 7.41211 11.0589C7.41211 11.3025 7.60963 11.5 7.85329 11.5Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$View$Components$tooltip = function (_v0) {
	var message = _v0.of;
	var iconClass = _v0.nx;
	var containerClass = _v0.mG;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('icon-tooltip ml-1 z-10 ' + containerClass)
			]),
		_List_fromArray(
			[
				$author$project$Icons$question('inline-block ' + iconClass),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('icon-tooltip-content')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]))
			]));
};
var $author$project$Form$Toggle$viewLabel = function (_v0) {
	var options = _v0;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for(options.w),
						$elm$html$Html$Attributes$class('cursor-pointer')
					]),
				_List_fromArray(
					[options.n$])),
				function () {
				var _v1 = options.i3;
				if (_v1.$ === 1) {
					return $elm$html$Html$text('');
				} else {
					var tooltip = _v1.a;
					return $author$project$View$Components$tooltip(tooltip);
				}
			}()
			]));
};
var $author$project$Form$Toggle$statusText = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		var _v1 = options.iS;
		if (!_v1) {
			return viewConfig.lW ? viewConfig.aw.fL('settings.features.enabled') : viewConfig.aw.fL('settings.features.disabled');
		} else {
			return viewConfig.lW ? viewConfig.aw.fL('community.actions.form.yes') : viewConfig.aw.fL('community.actions.form.no');
		}
	});
var $author$project$Form$Toggle$viewStatusText = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-semibold lowercase text-sm my-auto'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('text-indigo-500', viewConfig.lW && ((!options.b_) && (!viewConfig.no))),
							_Utils_Tuple2('text-gray-600', ((!viewConfig.lW) || options.b_) && (!viewConfig.no)),
							_Utils_Tuple2('text-red', viewConfig.no)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Form$Toggle$statusText, options, viewConfig))
				]));
	});
var $author$project$Form$Toggle$viewToggle = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('select-none')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$id(options.w),
							$elm$html$Html$Attributes$checked(viewConfig.lW),
							$elm$html$Html$Events$onCheck(viewConfig.oW),
							$elm$html$Html$Events$onBlur(viewConfig.oF),
							$elm$html$Html$Attributes$disabled(options.b_),
							$elm$html$Html$Attributes$required(viewConfig.nV),
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative block border-2 border-gray-100 rounded-full h-6 w-12 transition-colors ease-in duration-200 input form-switch-label2'),
							$elm$html$Html$Attributes$class('before:block before:bg-gray-900 before:w-4 before:h-4 before:rounded-full before:absolute before:inset-y-0.5 before:mx-0.5 before:transition-all before:duration-200 before:ease-in before:right-6'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('bg-indigo-500 before:bg-white before:right-0', viewConfig.lW),
									_Utils_Tuple2('bg-white', !viewConfig.lW),
									_Utils_Tuple2('border-red with-error', viewConfig.no)
								]))
						]),
					_List_Nil)
				]));
	});
var $author$project$Form$Toggle$view = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		return A2(
			$elm$html$Html$div,
			options.mF,
			_List_fromArray(
				[
					function () {
					var _v1 = options.fS;
					if (_v1.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var topLabel = _v1.a;
						return A2(
							$author$project$View$Components$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-6')
								]),
							{n0: topLabel, pZ: options.w});
					}
				}(),
					function () {
					var _v2 = options.iO;
					if (!_v2.$) {
						return A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('flex space-x-2 text-sm'),
								$elm_community$maybe_extra$Maybe$Extra$isNothing(options.fS) ? options.mF : _List_Nil),
							_List_fromArray(
								[
									A2($author$project$Form$Toggle$viewToggle, options, viewConfig),
									$author$project$Form$Toggle$viewLabel(options)
								]));
					} else {
						var invert = _v2.a.kj;
						return A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('flex'),
								$elm_community$maybe_extra$Maybe$Extra$isNothing(options.fS) ? options.mF : _List_Nil),
							_List_fromArray(
								[
									$author$project$Form$Toggle$viewLabel(options),
									A2(
									$elm$html$Html$label,
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('flex cursor-pointer ml-auto space-x-7 pl-4'),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$for(options.w),
											options.hi)),
									invert ? _List_fromArray(
										[
											A2($author$project$Form$Toggle$viewToggle, options, viewConfig),
											A2($author$project$Form$Toggle$viewStatusText, options, viewConfig)
										]) : _List_fromArray(
										[
											A2($author$project$Form$Toggle$viewStatusText, options, viewConfig),
											A2($author$project$Form$Toggle$viewToggle, options, viewConfig)
										]))
								]));
					}
				}(),
					viewConfig.na
				]));
	});
var $author$project$Form$UserPicker$GotSelectMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Select$PrivateMsg = $elm$core$Basics$identity;
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaExpanded = $elm$html$Html$Attributes$attribute('aria-expanded');
var $author$project$View$Select$Styles$inputControlClass = 'elm-select-input-control ';
var $author$project$View$Select$Styles$inputControlStyles = _List_fromArray(
	[
		_Utils_Tuple2('position', 'relative'),
		_Utils_Tuple2('background', 'white')
	]);
var $author$project$View$Select$Styles$inputWrapperClass = 'elm-select-input-wrapper ';
var $author$project$View$Select$Styles$inputWrapperStyles = _List_fromArray(
	[
		_Utils_Tuple2('display', 'flex'),
		_Utils_Tuple2('flex', '1'),
		_Utils_Tuple2('flex-direction', 'row'),
		_Utils_Tuple2('flex-wrap', 'wrap')
	]);
var $author$project$View$Select$Utils$difference = F2(
	function (listA, listB) {
		return A2(
			$elm$core$List$filter,
			function (x) {
				return !A2(
					$elm$core$List$any,
					function (y) {
						return _Utils_eq(x, y);
					},
					listB);
			},
			listA);
	});
var $author$project$View$Select$Search$filterItems = F3(
	function (config, availableItems, selectedItems) {
		return config.kp ? A2($author$project$View$Select$Utils$difference, availableItems, selectedItems) : availableItems;
	});
var $author$project$View$Select$Search$maybeCuttoff = F2(
	function (config, items) {
		var _v0 = config.jC;
		if (!_v0.$) {
			var cutoff = _v0.a;
			return A2($elm$core$List$take, cutoff, items);
		} else {
			return items;
		}
	});
var $author$project$View$Select$Search$matchedItemsWithCutoff = F4(
	function (config, maybeQuery, availableItems, selectedItems) {
		if (!maybeQuery.$) {
			if (maybeQuery.a === '') {
				return config.jM ? $elm$core$Maybe$Just(
					A2(
						$author$project$View$Select$Search$maybeCuttoff,
						config,
						A3($author$project$View$Select$Search$filterItems, config, availableItems, selectedItems))) : $elm$core$Maybe$Nothing;
			} else {
				var query = maybeQuery.a;
				return A2(
					$elm$core$Maybe$map,
					$author$project$View$Select$Search$maybeCuttoff(config),
					A2(
						config.hV,
						query,
						A3($author$project$View$Select$Search$filterItems, config, availableItems, selectedItems)));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$View$Select$Messages$OnRemoveItem = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$Select$Messages$OnFocus = {$: 1};
var $author$project$View$Select$Messages$OnQueryChange = function (a) {
	return {$: 8, a: a};
};
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaActiveDescendant = $elm$html$Html$Attributes$attribute('aria-activedescendant');
var $author$project$View$Select$Styles$inputClass = 'elm-select-input input';
var $author$project$View$Select$Styles$inputStyles = _List_Nil;
var $author$project$View$Select$Utils$menuItemId = F2(
	function (config, index) {
		return config.nK + ('-menu-item-' + $elm$core$String$fromInt(index));
	});
var $author$project$View$Select$Messages$OnBlur = {$: 2};
var $author$project$View$Select$Events$onBlurAttribute = F2(
	function (config, state) {
		var dataDecoder = A2(
			$elm$json$Json$Decode$andThen,
			function (targetId) {
				if (A2($elm$core$String$startsWith, config.nK + '-menu-item-', targetId)) {
					var _v0 = state.nt;
					if (_v0.$ === 1) {
						return $elm$json$Json$Decode$fail('Focus is not leaving select container');
					} else {
						var highlightedItem = _v0.a;
						return A2(
							$elm$core$String$endsWith,
							$elm$core$String$fromInt(highlightedItem),
							targetId) ? $elm$json$Json$Decode$fail('Focus is not leaving select container') : $elm$json$Json$Decode$succeed($author$project$View$Select$Messages$OnBlur);
					}
				} else {
					return $elm$json$Json$Decode$succeed($author$project$View$Select$Messages$OnBlur);
				}
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['relatedTarget', 'id']),
				$elm$json$Json$Decode$string));
		return A2($elm$html$Html$Events$on, 'focusout', dataDecoder);
	});
var $author$project$View$Select$Messages$OnSelect = function (a) {
	return {$: 9, a: a};
};
var $author$project$View$Select$Internal$Input$onKeyPressAttribute = function (maybeItem) {
	var fn = function (code) {
		switch (code) {
			case 9:
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Decode$fail('nothing selected'),
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$View$Select$Messages$OnSelect),
						maybeItem));
			case 13:
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Decode$fail('nothing selected'),
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$View$Select$Messages$OnSelect),
						maybeItem));
			default:
				return $elm$json$Json$Decode$fail('not TAB or ENTER');
		}
	};
	return A2(
		$elm$html$Html$Events$on,
		'keypress',
		A2($elm$json$Json$Decode$andThen, fn, $elm$html$Html$Events$keyCode));
};
var $author$project$View$Select$Messages$OnDownArrow = {$: 5};
var $author$project$View$Select$Messages$OnEsc = {$: 4};
var $author$project$View$Select$Messages$OnUpArrow = {$: 6};
var $author$project$View$Select$Internal$Input$onKeyUpAttribute = function (maybeItem) {
	var selectItem = function () {
		if (maybeItem.$ === 1) {
			return $elm$json$Json$Decode$fail('not Enter');
		} else {
			var item = maybeItem.a;
			return $elm$json$Json$Decode$succeed(
				$author$project$View$Select$Messages$OnSelect(item));
		}
	}();
	var fn = function (code) {
		switch (code) {
			case 13:
				return selectItem;
			case 38:
				return $elm$json$Json$Decode$succeed($author$project$View$Select$Messages$OnUpArrow);
			case 40:
				return $elm$json$Json$Decode$succeed($author$project$View$Select$Messages$OnDownArrow);
			case 27:
				return $elm$json$Json$Decode$succeed($author$project$View$Select$Messages$OnEsc);
			default:
				return $elm$json$Json$Decode$fail('not ENTER');
		}
	};
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2($elm$json$Json$Decode$andThen, fn, $elm$html$Html$Events$keyCode));
};
var $fapian$elm_html_aria$Html$Attributes$Aria$role = $elm$html$Html$Attributes$attribute('role');
var $author$project$View$Select$Utils$stylesToAttrs = function (styles) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var k = _v0.a;
			var v = _v0.b;
			return A2($elm$html$Html$Attributes$style, k, v);
		},
		styles);
};
var $author$project$View$Select$Internal$Input$inputAttributes = F5(
	function (config, model, _v0, selectedItems, maybeMatchedItems) {
		var preselectedItem = function () {
			if (!maybeMatchedItems.$) {
				var matchedItems = maybeMatchedItems.a;
				if (config.kp) {
					var _v4 = model.nt;
					if (_v4.$ === 1) {
						return $elm$core$List$head(matchedItems);
					} else {
						var n = _v4.a;
						return A2(
							$elm$core$Array$get,
							n % $elm$core$List$length(matchedItems),
							$elm$core$Array$fromList(matchedItems));
					}
				} else {
					return $elm$core$List$head(matchedItems);
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var activeDescendant = function () {
			var _v2 = model.nt;
			if (_v2.$ === 1) {
				return $elm$html$Html$Attributes$class('');
			} else {
				var highlightedItem = _v2.a;
				return $fapian$elm_html_aria$Html$Attributes$Aria$ariaActiveDescendant(
					A2($author$project$View$Select$Utils$menuItemId, config, highlightedItem));
			}
		}();
		var _v1 = $elm$core$List$isEmpty(selectedItems) ? _Utils_Tuple2(config.k6, config.k7) : _Utils_Tuple2('', _List_Nil);
		var promptClass = _v1.a;
		var promptStyles = _v1.b;
		var inputClasses = A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[$author$project$View$Select$Styles$inputClass, config.nI, promptClass]));
		var inputStyles = $elm$core$List$concat(
			_List_fromArray(
				[$author$project$View$Select$Styles$inputStyles, config.kd, promptStyles]));
		var inputStylesAttrs = $author$project$View$Select$Utils$stylesToAttrs(inputStyles);
		return A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$autocomplete(false),
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'autocorrect', 'off'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'off'),
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$attribute, 'autocapitalize', 'off'),
						A2(
							$elm$core$List$cons,
							A2($elm$html$Html$Attributes$attribute, 'spellcheck', 'false'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$id(config.nK),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(config.b_),
									A2(
										$elm$core$List$cons,
										A2($author$project$View$Select$Events$onBlurAttribute, config, model),
										A2(
											$elm$core$List$cons,
											$author$project$View$Select$Internal$Input$onKeyUpAttribute(preselectedItem),
											A2(
												$elm$core$List$cons,
												$author$project$View$Select$Internal$Input$onKeyPressAttribute(preselectedItem),
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Events$onInput($author$project$View$Select$Messages$OnQueryChange),
													A2(
														$elm$core$List$cons,
														$elm$html$Html$Events$onFocus($author$project$View$Select$Messages$OnFocus),
														A2(
															$elm$core$List$cons,
															$elm$html$Html$Attributes$class(inputClasses),
															A2(
																$elm$core$List$cons,
																$elm$html$Html$Attributes$classList(config.nJ),
																A2(
																	$elm$core$List$cons,
																	$fapian$elm_html_aria$Html$Attributes$Aria$role('combobox'),
																	A2(
																		$elm$core$List$cons,
																		activeDescendant,
																		A2(
																			$elm$core$List$cons,
																			A2($elm$html$Html$Attributes$attribute, 'aria-owns', model.w + '-items-list'),
																			A2(
																				$elm$core$List$cons,
																				$fapian$elm_html_aria$Html$Attributes$Aria$ariaExpanded(
																					model.pH ? 'true' : 'false'),
																				A2(
																					$elm$core$List$cons,
																					A2($elm$html$Html$Attributes$attribute, 'aria-autocomplete', 'list'),
																					inputStylesAttrs)))))))))))))))))));
	});
var $author$project$View$Select$Styles$multiInputItemClass = 'elm-select-multi-input-item ';
var $author$project$View$Select$Styles$multiInputItemContainerClass = 'elm-select-multi-input-item-container ';
var $author$project$View$Select$Styles$multiInputItemContainerStyles = _List_fromArray(
	[
		_Utils_Tuple2('display', 'flex'),
		_Utils_Tuple2('flex-direction', 'row'),
		_Utils_Tuple2('align-items', 'center'),
		_Utils_Tuple2('justify-content', 'center')
	]);
var $author$project$View$Select$Styles$multiInputItemStyles = _List_fromArray(
	[
		_Utils_Tuple2('display', 'flex'),
		_Utils_Tuple2('border-width', '0.1rem'),
		_Utils_Tuple2('border-radius', '0.2em'),
		_Utils_Tuple2('border-color', '#E3E5E8'),
		_Utils_Tuple2('background-color', '#E3E5E8'),
		_Utils_Tuple2('font-size', '.75rem'),
		_Utils_Tuple2('margin-right', '.2rem')
	]);
var $author$project$View$Select$Styles$multiInputItemText = _List_fromArray(
	[
		_Utils_Tuple2('text-overflow', 'ellipsis'),
		_Utils_Tuple2('padding-left', '.5rem'),
		_Utils_Tuple2('padding-right', '.3rem'),
		_Utils_Tuple2('padding-top', '.05rem'),
		_Utils_Tuple2('padding-bottom', '.05rem'),
		_Utils_Tuple2('display', 'none')
	]);
var $author$project$View$Select$Styles$multiInputRemoveItem = _List_fromArray(
	[
		_Utils_Tuple2('display', 'flex'),
		_Utils_Tuple2('alignItems', 'center'),
		_Utils_Tuple2('justifyContent', 'center'),
		_Utils_Tuple2('padding-right', '.1rem')
	]);
var $author$project$View$Select$Internal$Input$onClickWithoutPropagation = function (msg) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, false)));
};
var $author$project$View$Select$Styles$removeItemSvgStyles = _List_fromArray(
	[
		_Utils_Tuple2('cursor', 'pointer')
	]);
var $author$project$View$Select$Internal$RemoveItem$svgPath = 'M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z';
var $author$project$View$Select$Internal$RemoveItem$view = function (config) {
	return A2(
		$elm$svg$Svg$svg,
		A2(
			$elm$core$List$cons,
			$elm$svg$Svg$Attributes$class(config.lc),
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$width('14'),
				A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$height('14'),
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var f = _v0.a;
								var s = _v0.b;
								return A2($elm$html$Html$Attributes$style, f, s);
							},
							_Utils_ap(config.ld, $author$project$View$Select$Styles$removeItemSvgStyles)))))),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d($author$project$View$Select$Internal$RemoveItem$svgPath)
					]),
				_List_Nil)
			]));
};
var $author$project$View$Select$Internal$Input$multiInput = F5(
	function (config, model, availableItems, selected, maybeMatchedItems) {
		var val = A2($elm$core$Maybe$withDefault, '', model.ed);
		var multiInputItemStyles = A2($elm$core$List$append, $author$project$View$Select$Styles$multiInputItemStyles, config.kJ);
		var multiInputItemStylesAttrs = $author$project$View$Select$Utils$stylesToAttrs(multiInputItemStyles);
		var multiInputItemContainerStyles = A2($elm$core$List$append, $author$project$View$Select$Styles$multiInputItemContainerStyles, config.kI);
		var multiInputItemContainerStylesAttrs = $author$project$View$Select$Utils$stylesToAttrs(multiInputItemContainerStyles);
		var multiInputItemContainerClasses = _Utils_ap($author$project$View$Select$Styles$multiInputItemContainerClass, config.kH);
		var multiInputItemClasses = _Utils_ap($author$project$View$Select$Styles$multiInputItemClass, config.kG);
		var viewMultiItems = function (subItems) {
			return A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class(multiInputItemContainerClasses),
					multiInputItemContainerStylesAttrs),
				A2(
					$elm$core$List$map,
					function (item) {
						return A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class(multiInputItemClasses),
								multiInputItemStylesAttrs),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									A2(
										$elm$core$List$map,
										function (_v0) {
											var f = _v0.a;
											var s = _v0.b;
											return A2($elm$html$Html$Attributes$style, f, s);
										},
										$author$project$View$Select$Styles$multiInputItemText),
									_List_fromArray(
										[
											$elm$html$Html$text(
											config.p3(item))
										])),
									A2(
									$elm$core$Maybe$withDefault,
									A2($elm$html$Html$span, _List_Nil, _List_Nil),
									A2(
										$elm$core$Maybe$map,
										function (_v1) {
											return A2(
												$elm$html$Html$div,
												A2(
													$elm$core$List$cons,
													$author$project$View$Select$Internal$Input$onClickWithoutPropagation(
														$author$project$View$Select$Messages$OnRemoveItem(item)),
													A2(
														$elm$core$List$map,
														function (_v2) {
															var f = _v2.a;
															var s = _v2.b;
															return A2($elm$html$Html$Attributes$style, f, s);
														},
														$author$project$View$Select$Styles$multiInputRemoveItem)),
												_List_fromArray(
													[
														$author$project$View$Select$Internal$RemoveItem$view(config)
													]));
										},
										config.kU))
								]));
					},
					subItems));
		};
		return _List_fromArray(
			[
				viewMultiItems(selected),
				A2(
				$elm$html$Html$input,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$value(val),
					_Utils_ap(
						A5($author$project$View$Select$Internal$Input$inputAttributes, config, model, availableItems, selected, maybeMatchedItems),
						$elm$core$List$isEmpty(selected) ? _List_fromArray(
							[
								$elm$html$Html$Attributes$placeholder(config.pm)
							]) : _List_Nil)),
				_List_Nil)
			]);
	});
var $author$project$View$Select$Internal$Input$singleInput = F5(
	function (config, model, availableItems, selectedItems, maybeMatchedItems) {
		var val = A2($elm$core$Maybe$withDefault, '', model.ed);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_Utils_ap(
					A5($author$project$View$Select$Internal$Input$inputAttributes, config, model, availableItems, selectedItems, maybeMatchedItems),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(val),
							$elm$html$Html$Attributes$placeholder(config.pm)
						])),
				_List_Nil)
			]);
	});
var $author$project$View$Select$Styles$underlineStyles = _List_Nil;
var $author$project$View$Select$Internal$Input$view = F4(
	function (config, model, availableItems, selectedItems) {
		var underlineStyles = A2($elm$core$List$append, $author$project$View$Select$Styles$underlineStyles, config.lR);
		var underline = A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(config.lQ),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var f = _v0.a;
						var s = _v0.b;
						return A2($elm$html$Html$Attributes$style, f, s);
					},
					underlineStyles)),
			_List_Nil);
		var maybeMatchedItems = A4($author$project$View$Select$Search$matchedItemsWithCutoff, config, model.ed, availableItems, selectedItems);
		var inputWrapperStyles = A2($elm$core$List$append, $author$project$View$Select$Styles$inputWrapperStyles, config.kf);
		var inputWrapperStylesAttrs = $author$project$View$Select$Utils$stylesToAttrs(inputWrapperStyles);
		var inputWrapperClass = _Utils_ap($author$project$View$Select$Styles$inputWrapperClass, config.ke);
		var inputControlStyles = A2($elm$core$List$append, $author$project$View$Select$Styles$inputControlStyles, config.kc);
		var inputControlStylesAttrs = $author$project$View$Select$Utils$stylesToAttrs(inputControlStyles);
		var inputControlClass = _Utils_ap($author$project$View$Select$Styles$inputControlClass, config.kb);
		var input = config.kp ? A5($author$project$View$Select$Internal$Input$multiInput, config, model, availableItems, selectedItems, maybeMatchedItems) : A5($author$project$View$Select$Internal$Input$singleInput, config, model, availableItems, selectedItems, maybeMatchedItems);
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(inputControlClass),
				inputControlStylesAttrs),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class(inputWrapperClass),
						inputWrapperStylesAttrs),
					input),
					underline
				]));
	});
var $author$project$View$Select$Styles$hiddenMenuStyles = _List_fromArray(
	[
		_Utils_Tuple2('display', 'none')
	]);
var $author$project$View$Select$Messages$OnResetFocusToFirstItem = {$: 7};
var $author$project$View$Select$Internal$Menu$keyListener = F2(
	function (model, itemCount) {
		return $author$project$View$Components$keyListener(
			{
				l7: _List_fromArray(
					[0, 3, 4]),
				k3: true,
				lw: false,
				lF: function (key) {
					switch (key) {
						case 0:
							return $author$project$View$Select$Messages$OnEsc;
						case 3:
							return $author$project$View$Select$Messages$OnUpArrow;
						case 4:
							var _v1 = model.nt;
							if (_v1.$ === 1) {
								return $author$project$View$Select$Messages$OnDownArrow;
							} else {
								var highlightedItem = _v1.a;
								return (_Utils_cmp(highlightedItem, itemCount - 1) > -1) ? $author$project$View$Select$Messages$OnResetFocusToFirstItem : $author$project$View$Select$Messages$OnDownArrow;
							}
						default:
							return $author$project$View$Select$Messages$OnDownArrow;
					}
				}
			});
	});
var $author$project$View$Select$Messages$NoOp = {$: 0};
var $author$project$View$Select$Internal$Item$baseItemStyles = function (config) {
	return config.ks;
};
var $author$project$View$Select$Styles$menuItemStyles = _List_fromArray(
	[
		_Utils_Tuple2('cursor', 'pointer')
	]);
var $author$project$View$Select$Internal$Item$view = F5(
	function (config, state, itemCount, index, item) {
		var itemHtml = function () {
			var _v3 = config.n_;
			if (_v3.$ === 1) {
				return $elm$html$Html$text(
					config.p3(item));
			} else {
				var fn = _v3.a;
				return A2(
					$elm$html$Html$map,
					function (_v4) {
						return $author$project$View$Select$Messages$NoOp;
					},
					fn(item));
			}
		}();
		var _v0 = function () {
			var _v1 = state.nt;
			if (_v1.$ === 1) {
				return _Utils_Tuple2('', _List_Nil);
			} else {
				var highlighted = _v1.a;
				return _Utils_eq(highlighted % itemCount, index) ? _Utils_Tuple2(config.j6, config.j7) : _Utils_Tuple2('', _List_Nil);
			}
		}();
		var highlightedItemClass = _v0.a;
		var highlightedItemStyles = _v0.b;
		var classes = A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[config.nZ, 'w-full', highlightedItemClass]));
		var styles = $elm$core$List$concat(
			_List_fromArray(
				[
					$author$project$View$Select$Styles$menuItemStyles,
					$author$project$View$Select$Internal$Item$baseItemStyles(config),
					highlightedItemStyles
				]));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block w-full'),
					$fapian$elm_html_aria$Html$Attributes$Aria$role('option')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class(classes),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Events$onClick(
								$author$project$View$Select$Messages$OnSelect(item)),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$tabindex(-1),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$type_('button'),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$id(
											A2($author$project$View$Select$Utils$menuItemId, config, index)),
										A2(
											$elm$core$List$map,
											function (_v2) {
												var f = _v2.a;
												var s = _v2.b;
												return A2($elm$html$Html$Attributes$style, f, s);
											},
											styles)))))),
					_List_fromArray(
						[itemHtml]))
				]));
	});
var $author$project$View$Select$Internal$Item$viewNotFound = function (config) {
	var styles = A2(
		$elm$core$List$append,
		$author$project$View$Select$Internal$Item$baseItemStyles(config),
		config.kM);
	var classes = A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[config.nZ, config.oB]));
	return (config.oA === '') ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class(classes),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var f = _v0.a;
					var s = _v0.b;
					return A2($elm$html$Html$Attributes$style, f, s);
				},
				styles)),
		_List_fromArray(
			[
				$elm$html$Html$text(config.oA)
			]));
};
var $author$project$View$Select$Styles$visibleMenuStyles = _List_fromArray(
	[
		_Utils_Tuple2('position', 'absolute')
	]);
var $author$project$View$Select$Internal$Menu$viewStyles = function (config) {
	return A2($elm$core$List$append, $author$project$View$Select$Styles$visibleMenuStyles, config.kF);
};
var $author$project$View$Select$Internal$Menu$menu = F3(
	function (config, model, matchedItems) {
		var noResultElement = _Utils_eq(matchedItems, _List_Nil) ? $author$project$View$Select$Internal$Item$viewNotFound(config) : $elm$html$Html$text('');
		var itemCount = $elm$core$List$length(matchedItems);
		var hideWhenNotFound = (!config.kL) && _Utils_eq(matchedItems, _List_Nil);
		var menuStyle = hideWhenNotFound ? A2(
			$elm$core$List$map,
			function (_v0) {
				var f = _v0.a;
				var s = _v0.b;
				return A2($elm$html$Html$Attributes$style, f, s);
			},
			$author$project$View$Select$Styles$hiddenMenuStyles) : A2(
			$elm$core$List$map,
			function (_v1) {
				var f = _v1.a;
				var s = _v1.b;
				return A2($elm$html$Html$Attributes$style, f, s);
			},
			$author$project$View$Select$Internal$Menu$viewStyles(config));
		var elements = A2(
			$elm$core$List$indexedMap,
			A3($author$project$View$Select$Internal$Item$view, config, model, itemCount),
			matchedItems);
		return model.pH ? A2(
			$elm$html$Html$ul,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(config.d$),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(config.jL, !itemCount)
							])),
					A2(
						$elm$core$List$cons,
						A2($author$project$View$Select$Events$onBlurAttribute, config, model),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$id(model.w + '-items-list'),
							menuStyle)))),
			A2(
				$elm$core$List$cons,
				noResultElement,
				A2(
					$elm$core$List$cons,
					A2($author$project$View$Select$Internal$Menu$keyListener, model, itemCount),
					elements))) : $elm$html$Html$text('');
	});
var $author$project$View$Select$Internal$Menu$view = F4(
	function (config, model, availableItems, selectedItems) {
		var searchResult = A4($author$project$View$Select$Search$matchedItemsWithCutoff, config, model.ed, availableItems, selectedItems);
		if (searchResult.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var matchedItems = searchResult.a;
			return A3($author$project$View$Select$Internal$Menu$menu, config, model, matchedItems);
		}
	});
var $author$project$View$Select$Internal$view = F4(
	function (config, model, availableItems, selectedItems) {
		var classes = 'elm-select';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.w),
					$elm$html$Html$Attributes$class(classes),
					A2($elm$html$Html$Attributes$style, 'position', 'relative'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					$fapian$elm_html_aria$Html$Attributes$Aria$ariaExpanded(
					model.pH ? 'true' : 'false')
				]),
			_List_fromArray(
				[
					A4($author$project$View$Select$Internal$Input$view, config, model, availableItems, selectedItems),
					A4($author$project$View$Select$Internal$Menu$view, config, model, availableItems, selectedItems)
				]));
	});
var $author$project$View$Select$view = F4(
	function (config, model, items, selected) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A4(
				$author$project$View$Select$Internal$view,
				$author$project$View$Select$unwrapConfig(config),
				$author$project$View$Select$unwrapModel(model),
				items,
				selected));
	});
var $author$project$Form$UserPicker$ClickedRemoveProfile = function (a) {
	return {$: 4, a: a};
};
var $author$project$Form$UserPicker$GotProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Profile$Summary$Ignored = 0;
var $author$project$Profile$Summary$ClosedInfo = 2;
var $author$project$Profile$Summary$OpenedInfo = 1;
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$View$Components$dialogBubble = F2(
	function (_v0, elements) {
		var class_ = _v0.mv;
		var relativeSelector = _v0.fx;
		var scrollSelector = _v0.fB;
		return A3(
			$elm$html$Html$node,
			'dialog-bubble',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'elm-class', class_),
					A2($author$project$View$Components$optionalAttr, 'elm-relative-selector', relativeSelector),
					A2($author$project$View$Components$optionalAttr, 'elm-scroll-selector', scrollSelector)
				]),
			elements);
	});
var $author$project$Icons$phone = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('20'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$fill('black'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M18.5789 13.6387L16.2657 11.317C15.8014 10.8358 15.24 10.5783 14.6406 10.5783C14.0454 10.5783 13.4797 10.8316 13.0027 11.3086L11.8124 12.4947C11.7997 12.4863 11.787 12.4821 11.7701 12.4736C11.7322 12.4567 11.6984 12.4356 11.6604 12.4145C11.5127 12.3428 11.3776 12.271 11.2678 12.2035C10.0437 11.4268 8.92928 10.4095 7.86132 9.10088C7.40121 8.51836 7.0804 8.03292 6.83979 7.53904C7.10151 7.28999 7.35056 7.04094 7.59116 6.79611L7.67981 6.70747C7.73891 6.64837 7.798 6.58505 7.8571 6.52596C7.9162 6.46686 7.97529 6.40776 8.03439 6.34867C8.51983 5.86323 8.78154 5.28915 8.78154 4.69396C8.78154 4.09877 8.52405 3.52891 8.03439 3.03926L6.882 1.88687C6.75115 1.75601 6.62029 1.62516 6.49366 1.49008C6.24461 1.23259 5.97445 0.95821 5.69163 0.696496C5.23152 0.240608 4.67432 0 4.08758 0C3.50083 0 2.93519 0.240608 2.4582 0.700717L1.01455 2.15703C0.427805 2.74377 0.0943304 3.46137 0.018349 4.29295C-0.0871808 5.57619 0.284284 6.76234 0.575546 7.54326C1.27204 9.42591 2.31468 11.1608 3.85119 13.0097C5.7254 15.2512 7.98374 17.0156 10.5587 18.2609C11.5591 18.7336 12.893 19.2908 14.3788 19.3837C14.4759 19.3879 14.5688 19.3921 14.6574 19.3921C15.7127 19.3921 16.5992 19.0122 17.2957 18.2566L17.3252 18.2229V18.2186C17.3252 18.2144 17.3295 18.2144 17.3295 18.2102C17.5194 17.978 17.7431 17.7628 17.9795 17.5348L18.0344 17.4799C18.2539 17.2689 18.4312 17.0916 18.5916 16.927C19.0601 16.4415 19.305 15.8717 19.305 15.2765C19.3092 14.6813 19.0559 14.1114 18.5789 13.6387ZM6.48521 5.51709L6.48099 5.52131C6.10531 5.90544 5.78449 6.22203 5.43414 6.54284C5.42569 6.55128 5.40881 6.56395 5.39192 6.58505C4.89382 7.09582 5.06267 7.63191 5.12177 7.8092L5.13865 7.85563L5.14287 7.86407C5.45102 8.607 5.88158 9.31194 6.54431 10.152L6.55697 10.1688C7.74313 11.6252 8.98838 12.7607 10.3645 13.6302C10.5502 13.7484 10.7317 13.8371 10.909 13.9257C11.0568 13.9975 11.1918 14.0692 11.3058 14.1368L11.3311 14.1494C11.348 14.1579 11.3649 14.1705 11.3776 14.179C11.5591 14.2676 11.7364 14.314 11.9179 14.314C12.3822 14.314 12.6608 14.0354 12.7537 13.9426L14.1973 12.4989C14.3071 12.3892 14.4675 12.2626 14.6406 12.2626C14.8178 12.2626 14.9698 12.3976 15.0458 12.4821L17.3885 14.8248C17.6883 15.1203 17.7094 15.3778 17.4603 15.6775C17.4603 15.6775 16.3206 16.8088 16.0504 17.1254C15.679 17.5222 15.24 17.7037 14.6659 17.7037C14.6068 17.7037 14.5435 17.7037 14.4886 17.6994C13.2813 17.6235 12.15 17.1465 11.2974 16.737C8.94195 15.5973 6.87356 13.9764 5.15976 11.9291C3.74566 10.2237 2.79167 8.64077 2.16693 6.94808C1.79125 5.93921 1.65195 5.16251 1.71105 4.42381C1.74904 3.99747 1.91366 3.64289 2.21337 3.33896L3.64857 1.90376C3.80476 1.75601 3.96094 1.68003 4.10024 1.68003C4.27331 1.68003 4.42527 1.79823 4.52236 1.89531L4.53924 1.9122C4.77985 2.13592 5.01202 2.37231 5.29062 2.65935C5.35393 2.72689 5.42147 2.79443 5.48479 2.85774L5.49323 2.86619C5.56077 2.93373 5.62409 3.00127 5.69585 3.07303L6.84824 4.22541C7.19015 4.56733 7.19015 4.80793 6.84824 5.14563C6.80602 5.18784 6.76381 5.23005 6.72582 5.26804C6.6414 5.36091 6.56542 5.43689 6.48521 5.51709Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$telegram = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('30'),
				$elm$svg$Svg$Attributes$height('30'),
				$elm$svg$Svg$Attributes$viewBox('0 0 30 30'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z'),
						$elm$svg$Svg$Attributes$fill('#30A8DB')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12.25 21.875C11.764 21.875 11.8466 21.6915 11.679 21.2287L10.25 16.5259L21.25 10'),
						$elm$svg$Svg$Attributes$fill('#C8DAEA')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12.25 21.875C12.625 21.875 12.7906 21.7035 13 21.5L15 19.5552L12.5052 18.0509'),
						$elm$svg$Svg$Attributes$fill('#A9C9DD')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12.505 18.0513L18.55 22.5174C19.2398 22.898 19.7376 22.7009 19.9095 21.877L22.3701 10.2816C22.622 9.27163 21.9851 8.81338 21.3251 9.113L6.87635 14.6844C5.8901 15.08 5.89597 15.6303 6.6966 15.8754L10.4045 17.0328L18.9886 11.6171C19.3938 11.3714 19.7658 11.5034 19.4606 11.7744'),
						$elm$svg$Svg$Attributes$fill('#FFFFFF')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$whatsapp = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('32'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M16 28C23.1797 28 29 22.4036 29 15.5C29 8.59644 23.1797 3 16 3C8.8203 3 3 8.59644 3 15.5C3 22.4036 8.8203 28 16 28Z'),
						$elm$svg$Svg$Attributes$fill('#25D366')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.71997 22.5337L9.74829 18.9204C9.11267 17.8608 8.77882 16.6588 8.7804 15.4355C8.7804 11.5923 12.034 8.46533 16.0299 8.46533C16.9825 8.46546 17.9257 8.64606 18.8056 8.9968C19.6856 9.34755 20.485 9.86157 21.1583 10.5095C21.8316 11.1574 22.3655 11.9266 22.7296 12.773C23.0936 13.6194 23.2806 14.5265 23.28 15.4424C23.28 19.2856 20.0259 22.4131 16.0304 22.4131H16.0274C14.817 22.413 13.626 22.1213 12.5631 21.5645L8.71997 22.5337ZM12.7408 20.3022L12.9612 20.4277C13.8896 20.9565 14.9488 21.2354 16.0279 21.2354H16.0304C19.3515 21.2354 22.0546 18.6362 22.0561 15.4414C22.0562 14.5437 21.8393 13.6583 21.4225 12.855C21.0058 12.0517 20.4007 11.3525 19.6548 10.8125C18.909 10.2726 18.0429 9.90662 17.1248 9.74358C16.2067 9.58054 15.2618 9.62485 14.3646 9.87302C13.4674 10.1212 12.6424 10.5664 11.9548 11.1736C11.2671 11.7808 10.7356 12.5333 10.4022 13.3718C10.0687 14.2103 9.94247 15.1118 10.0334 16.0052C10.1242 16.8987 10.4298 17.7596 10.9259 18.52L11.0691 18.7393L10.4597 20.8774L12.7408 20.3022Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M19.6826 17.0996C19.6374 17.0268 19.5165 16.9834 19.3353 16.896C19.154 16.8086 18.2638 16.3877 18.0977 16.3301C17.9317 16.2724 17.8108 16.2427 17.6915 16.4175C17.5721 16.5923 17.2238 16.9844 17.1182 17.1011C17.0125 17.2178 16.9069 17.2319 16.7256 17.1445C16.5443 17.0571 15.9608 16.8735 15.2692 16.2798C14.7304 15.8179 14.3668 15.2475 14.2617 15.0732C14.1566 14.8989 14.2505 14.8047 14.3409 14.7178C14.4227 14.6396 14.5222 14.5141 14.6126 14.4126C14.6873 14.3238 14.7483 14.2251 14.7939 14.1196C14.8179 14.0715 14.8291 14.0185 14.8264 13.9652C14.8238 13.9119 14.8073 13.8601 14.7787 13.8144C14.7335 13.727 14.3724 12.8701 14.2201 12.5215C14.0733 12.1797 13.9235 12.2285 13.8138 12.2222C13.7041 12.2158 13.5873 12.2163 13.4665 12.2163C13.3747 12.2186 13.2844 12.2392 13.2013 12.2767C13.1182 12.3141 13.0441 12.3677 12.9835 12.4341C12.8175 12.6084 12.3498 13.0298 12.3498 13.8872C12.3498 14.7446 12.9988 15.5727 13.0897 15.689C13.1806 15.8052 14.3668 17.5644 16.1843 18.3188C16.5216 18.4587 16.8664 18.5812 17.2172 18.686C17.5866 18.7939 17.9771 18.8175 18.3577 18.7549C18.7061 18.706 19.4297 18.3335 19.5805 17.9248C19.7314 17.5161 19.7278 17.1723 19.6826 17.0996Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil)
			]));
};
var $author$project$Profile$Contact$contactTypeToIcon = F3(
	function (class_, isInverted, contactType) {
		switch (contactType) {
			case 3:
				return isInverted ? $author$project$Icons$phoneInverted(class_) : $author$project$Icons$phone(class_);
			case 1:
				return $author$project$Icons$instagram(class_);
			case 4:
				return isInverted ? $author$project$Icons$telegramInverted(class_) : $author$project$Icons$telegram(class_);
			case 5:
				return isInverted ? $author$project$Icons$whatsappInverted(class_) : $author$project$Icons$whatsapp(class_);
			case 0:
				return $author$project$Icons$mail(class_);
			default:
				return $author$project$Icons$link(class_);
		}
	});
var $author$project$Profile$Contact$toHref = function (_v0) {
	var contactType = _v0.mE;
	var contact = _v0.mD;
	switch (contactType) {
		case 3:
			return $elm$html$Html$Attributes$href('tel:' + contact);
		case 1:
			return $elm$html$Html$Attributes$href(contact);
		case 4:
			return $elm$html$Html$Attributes$href(contact);
		case 5:
			return $elm$html$Html$Attributes$href(
				'https://api.whatsapp.com/send?phone=' + A2(
					$elm$core$String$filter,
					$elm$core$Char$isAlphaNum,
					A2($elm$core$String$dropLeft, 1, contact)));
		case 0:
			return $elm$html$Html$Attributes$href('mailto:' + contact);
		default:
			return $elm$html$Html$Attributes$href(contact);
	}
};
var $author$project$Profile$Contact$circularIcon = F2(
	function (class_, _v0) {
		var normalized = _v0;
		var _v1 = function () {
			var _v2 = normalized.mE;
			switch (_v2) {
				case 3:
					return _Utils_Tuple2('bg-orange-300', 'fill-current text-white');
				case 1:
					return _Utils_Tuple2('bg-instagram', '');
				case 4:
					return _Utils_Tuple2('bg-telegram', '');
				case 5:
					return _Utils_Tuple2('bg-whatsapp', '');
				case 0:
					return _Utils_Tuple2('bg-gray-500', 'fill-current text-orange-300');
				default:
					return _Utils_Tuple2('bg-gray-500', '');
			}
		}();
		var bgColor = _v1.a;
		var textColor = _v1.b;
		var _v3 = normalized.mE;
		if (_v3 === 4) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Profile$Contact$toHref(normalized),
						$elm$html$Html$Attributes$class('hover:opacity-80')
					]),
				_List_fromArray(
					[
						A3($author$project$Profile$Contact$contactTypeToIcon, class_, false, normalized.mE)
					]));
		} else {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								['p-2 rounded-full flex items-center justify-center hover:opacity-80', textColor, bgColor, class_]))),
						$author$project$Profile$Contact$toHref(normalized)
					]),
				_List_fromArray(
					[
						A3($author$project$Profile$Contact$contactTypeToIcon, 'fill-current text-white object-contain', true, normalized.mE)
					]));
		}
	});
var $author$project$Profile$Summary$viewUserInfo = function (profile) {
	var userName = A2($elm$core$Maybe$withDefault, '', profile.fj);
	var email = A2($elm$core$Maybe$withDefault, '', profile.jK);
	var bio = A2($elm$core$Maybe$withDefault, $author$project$Markdown$empty, profile.dm);
	var account = $author$project$Eos$Account$nameToString(profile.l8);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col w-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex mb-4 items-center justify-center')
					]),
				_List_fromArray(
					[
						A2($author$project$Avatar$view, profile.dl, 'w-20 h-20 mr-6 flex-shrink-0'),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex items-center justify-between')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm text-gray-900')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-semibold text-body-black text-2xl xs-max:text-xl')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(userName)
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('mailto:' + email),
														$elm$html$Html$Attributes$class('hover:underline hover:text-orange-300 focus:outline-none focus:underline focus:text-orange-300')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(email)
													]))
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(account)
											]))
									]))
							]))
					])),
				A2(
				$author$project$Markdown$view,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-sm text-gray-900')
					]),
				bio),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-evenly mt-6')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Profile$Contact$circularIcon('w-9 h-9 hover:opacity-75'),
					profile.az)),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button button-primary w-full mt-6 cursor-pointer'),
						$author$project$Route$href(
						$author$project$Route$Profile(profile.l8))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('View full profile')
					]))
			]));
};
var $author$project$Profile$Summary$viewUserImg = F5(
	function (_v0, profile, loggedInAccount, isMobile, model) {
		var t = _v0.fL;
		var tr = _v0.i4;
		var container = function (attrs) {
			return isMobile ? $elm$html$Html$button(
				A2(
					$elm$core$List$cons,
					$author$project$Utils$onClickNoBubble(1),
					_Utils_ap(model.gu, attrs))) : $elm$html$Html$a(
				A2(
					$elm$core$List$cons,
					$author$project$Route$href(
						$author$project$Route$Profile(profile.l8)),
					_Utils_ap(model.gu, attrs)));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rounded-full ' + model.e4)
						]),
					_List_fromArray(
						[
							A2(
							container,
							_List_fromArray(
								[
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
									_Utils_eq(loggedInAccount, profile.l8) ? t('profile.summary.your_summary') : A2(
										tr,
										'profile.summary.user_summary',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'user',
												A2(
													$elm$core$Maybe$withDefault,
													$author$project$Eos$Account$nameToString(profile.l8),
													profile.fj))
											])))
								]),
							_List_fromArray(
								[
									A2($author$project$Avatar$view, profile.dl, model.e4)
								])),
							((!isMobile) && model.dS) ? A2(
							$author$project$View$Components$dialogBubble,
							{mv: 'w-120 animate-fade-in opacity-0', fx: model.fx, fB: model.fB},
							_List_fromArray(
								[
									$author$project$Profile$Summary$viewUserInfo(profile)
								])) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Eos$Account$viewName = function (_v0) {
	var name = _v0;
	return $elm$html$Html$text(name);
};
var $author$project$Profile$viewProfileName = F3(
	function (translators, loggedInAccount, profile) {
		if (_Utils_eq(profile.l8, loggedInAccount)) {
			return $elm$html$Html$text(
				translators.fL('transfer_result.you'));
		} else {
			var _v0 = profile.fj;
			if (!_v0.$) {
				var u = _v0.a;
				return $elm$html$Html$text(u);
			} else {
				return $author$project$Eos$Account$viewName(profile.l8);
			}
		}
	});
var $author$project$Profile$viewProfileNameTag = F4(
	function (shared, _v0, loggedInAccount, profile) {
		var showBg = _v0.pG;
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-1 px-3 uppercase font-bold text-xs text-center truncate'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('bg-black text-white rounded-label', showBg)
						]))
				]),
			_List_fromArray(
				[
					A3($author$project$Profile$viewProfileName, shared, loggedInAccount, profile)
				]));
	});
var $author$project$Profile$Summary$viewUserNameTag = F4(
	function (translators, loggedInAccount, profile, model) {
		return model.hc ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-2 w-20'),
					$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Profile$viewProfileNameTag,
					translators,
					{pG: model.hd},
					loggedInAccount,
					profile)
				])) : $elm$html$Html$text('');
	});
var $author$project$Profile$Summary$desktopView = F4(
	function (translators, loggedInAccount, profile, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto hidden md:block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onMouseEnter(1),
							$elm$html$Html$Events$onMouseLeave(2)
						]),
					_List_fromArray(
						[
							A5($author$project$Profile$Summary$viewUserImg, translators, profile, loggedInAccount, false, model)
						])),
					A4($author$project$Profile$Summary$viewUserNameTag, translators, loggedInAccount, profile, model)
				]));
	});
var $author$project$View$Modal$withPreventScrolling = F2(
	function (preventScrolling, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{g1: preventScrolling});
	});
var $author$project$Profile$Summary$mobileView = F4(
	function (translators, loggedInAccount, profile, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('md:hidden cursor-auto')
				]),
			_List_fromArray(
				[
					A5($author$project$Profile$Summary$viewUserImg, translators, profile, loggedInAccount, true, model),
					A4($author$project$Profile$Summary$viewUserNameTag, translators, loggedInAccount, profile, model),
					$author$project$View$Modal$toHtml(
					A2(
						$author$project$View$Modal$withPreventScrolling,
						model.g1,
						A2(
							$author$project$View$Modal$withBody,
							_List_fromArray(
								[
									$author$project$Profile$Summary$viewUserInfo(profile)
								]),
							$author$project$View$Modal$initWith(
								{mw: 2, nX: model.dS}))))
				]));
	});
var $author$project$Profile$Summary$view = F4(
	function (translators, loggedInAccount, profile, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$onClickPreventAll(0)
				]),
			_List_fromArray(
				[
					A4($author$project$Profile$Summary$desktopView, translators, loggedInAccount, profile, model),
					A4($author$project$Profile$Summary$mobileView, translators, loggedInAccount, profile, model)
				]));
	});
var $author$project$Profile$Summary$withRelativeSelector = F2(
	function (relativeSelector, model) {
		return _Utils_update(
			model,
			{
				fx: $elm$core$Maybe$Just(relativeSelector)
			});
	});
var $author$project$Profile$Summary$withScrollSelector = F2(
	function (scrollSelector, model) {
		return _Utils_update(
			model,
			{
				fB: $elm$core$Maybe$Just(scrollSelector)
			});
	});
var $author$project$Form$UserPicker$viewSelectedProfile = F4(
	function (index, _v0, viewConfig, _v1) {
		var options = _v0;
		var profile = _v1.pl;
		var summary = _v1.bu;
		var addScrollSelector = function () {
			var _v4 = options.fr.ee;
			if (_v4.$ === 1) {
				return $elm$core$Basics$identity;
			} else {
				var selector = _v4.a;
				return $author$project$Profile$Summary$withScrollSelector(selector);
			}
		}();
		var _v2 = viewConfig.lW;
		var model = _v2;
		var addRelativeSelector = function () {
			var _v3 = options.fr.ee;
			if (_v3.$ === 1) {
				return $author$project$Profile$Summary$withRelativeSelector(
					'#' + (model.w + ('-' + $elm$core$String$fromInt(index))));
			} else {
				var selector = _v3.a;
				return $author$project$Profile$Summary$withRelativeSelector(selector);
			}
		}();
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('relative', options.eA)
						])),
					$elm$html$Html$Attributes$id(
					model.w + ('-' + $elm$core$String$fromInt(index)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Form$UserPicker$GotProfileSummaryMsg(profile),
					A4(
						$author$project$Profile$Summary$view,
						viewConfig.aw,
						options.eR,
						profile,
						addScrollSelector(
							addRelativeSelector(summary)))),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hover:opacity-80 focus-ring focus:ring-red focus:ring-opacity-30 rounded-sm mt-2'),
							$elm$html$Html$Events$onClick(
							$author$project$Form$UserPicker$ClickedRemoveProfile(profile)),
							$elm$html$Html$Attributes$type_('button'),
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							A2(
								viewConfig.aw.i4,
								'community.actions.form.unselect_user',
								_List_fromArray(
									[
										_Utils_Tuple2(
										'username',
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Eos$Account$nameToString(profile.l8),
											profile.fj))
									])))
						]),
					_List_fromArray(
						[
							$author$project$Icons$trash('text-red')
						]))
				]));
	});
var $author$project$Form$UserPicker$view = F3(
	function (wrappedOptions, viewConfig, toMsg) {
		var options = wrappedOptions;
		var _v0 = viewConfig.lW;
		var model = _v0;
		var selectedProfiles = function () {
			var _v1 = model.H;
			if (_v1.$ === 1) {
				var profiles_ = _v1.a;
				return profiles_;
			} else {
				if (_v1.a.$ === 1) {
					var _v2 = _v1.a;
					return _List_Nil;
				} else {
					var profile = _v1.a.a;
					return _List_fromArray(
						[profile]);
				}
			}
		}();
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mb-10'),
				options.mF),
			_List_fromArray(
				[
					A2(
					$author$project$View$Components$label,
					_List_Nil,
					{n0: options.n$, pZ: model.w}),
					A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, toMsg, $author$project$Form$UserPicker$GotSelectMsg),
					A4(
						$author$project$View$Select$view,
						A2($author$project$Form$UserPicker$settings, wrappedOptions, viewConfig),
						model.G,
						A2(
							$elm$core$List$filter,
							function (profile) {
								return !A2(
									$elm$core$List$member,
									profile,
									A2(
										$elm$core$List$map,
										function ($) {
											return $.pl;
										},
										selectedProfiles));
							},
							options.fs),
						A2(
							$elm$core$List$map,
							function ($) {
								return $.pl;
							},
							selectedProfiles))),
					viewConfig.na,
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-4 flex flex-wrap gap-6')
						]),
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, profile) {
								return A2(
									$elm$html$Html$map,
									toMsg,
									A4($author$project$Form$UserPicker$viewSelectedProfile, index, wrappedOptions, viewConfig, profile));
							}),
						selectedProfiles))
				]));
	});
var $author$project$Form$viewError = F3(
	function (attributes, showError, maybeError) {
		if (maybeError.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var error = maybeError.a;
			return showError ? A2(
				$elm$html$Html$p,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('form-error'),
					attributes),
				_List_fromArray(
					[
						$elm$html$Html$text(error)
					])) : $elm$html$Html$text('');
		}
	});
var $author$project$Form$Checkbox$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{b_: disabled});
	});
var $author$project$Form$DatePicker$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{b_: disabled});
	});
var $author$project$Form$File$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{b_: disabled});
	});
var $author$project$Form$Radio$Options = $elm$core$Basics$identity;
var $author$project$Form$Radio$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{b_: disabled});
	});
var $author$project$Form$RichText$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{b_: disabled});
	});
var $author$project$Form$Select$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{b_: disabled});
	});
var $author$project$Form$Text$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{b_: disabled});
	});
var $author$project$Form$Toggle$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{b_: disabled});
	});
var $author$project$Form$UserPicker$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{b_: disabled});
	});
var $author$project$Form$viewField = F2(
	function (_v0, _v1) {
		var showError = _v0.iN;
		var translators = _v0.aw;
		var disabled = _v0.b_;
		var values = _v0.o;
		var model = _v0.ok;
		var form = _v0.hY;
		var toMsg = _v0.lF;
		var onSuccess = _v0.oV;
		var state = _v1.Z;
		var error = _v1.na;
		var isRequired = _v1.nV;
		var hasError = showError && $elm_community$maybe_extra$Maybe$Extra$isJust(error);
		var fieldId = $author$project$Form$getId(state);
		var onBlur = toMsg(
			$author$project$Form$BlurredField(
				{
					ai: fieldId,
					h8: $author$project$Form$isEmpty(state)
				}));
		var disableIfNotAlreadyDisabled = F2(
			function (options, setDisabled) {
				return disabled ? A2(setDisabled, true, options) : options;
			});
		var _v2 = function () {
			var model_ = model;
			return model_.aT;
		}();
		var errorTracking = _v2;
		switch (state.$) {
			case 0:
				var options = state.a;
				var baseField = state.b;
				var addSubmitOnEnter = $author$project$Form$Text$getSubmitOnEnter(options) ? $author$project$Form$Text$withExtraAttrs(
					_List_fromArray(
						[
							A3(
							$author$project$Form$submitOnEnter,
							form,
							model,
							{oM: toMsg, oV: onSuccess})
						])) : $elm$core$Basics$identity;
				var transformedOptions = addSubmitOnEnter(
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$Text$withDisabled));
				return A2(
					$author$project$Form$Text$view,
					transformedOptions,
					{
						na: A3(
							$author$project$Form$viewError,
							$author$project$Form$Text$getErrorAttrs(options),
							showError,
							error),
						no: hasError,
						nV: isRequired,
						oF: onBlur,
						oH: A2(
							$elm$core$Basics$composeR,
							baseField.qd,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$ChangedValues(
									{ai: fieldId}),
								toMsg)),
						aw: translators,
						lW: baseField.lW
					});
			case 1:
				var options = state.a;
				var baseField = state.b;
				return A3(
					$author$project$Form$RichText$view,
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$RichText$withDisabled),
					{
						na: A3($author$project$Form$viewError, _List_Nil, showError, error),
						no: hasError,
						nV: isRequired,
						oF: onBlur,
						aw: translators,
						lW: baseField.lW
					},
					A2(
						$elm$core$Basics$composeR,
						A2($author$project$Form$GotRichTextMsg, baseField.be, baseField.bv),
						toMsg));
			case 2:
				var options = state.a;
				var baseField = state.b;
				return A2(
					$author$project$Form$Toggle$view,
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$Toggle$withDisabled),
					{
						na: A3($author$project$Form$viewError, _List_Nil, showError, error),
						no: hasError,
						nV: isRequired,
						oF: onBlur,
						oW: A2(
							$elm$core$Basics$composeR,
							baseField.qd,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$ChangedValues(
									{ai: fieldId}),
								toMsg)),
						aw: translators,
						lW: baseField.lW
					});
			case 3:
				var options = state.a;
				var baseField = state.b;
				return A2(
					$author$project$Form$Checkbox$view,
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$Checkbox$withDisabled),
					{
						na: A3($author$project$Form$viewError, _List_Nil, showError, error),
						no: hasError,
						nV: isRequired,
						oF: onBlur,
						oI: A2(
							$elm$core$Basics$composeR,
							baseField.qd,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$ChangedValues(
									{ai: fieldId}),
								toMsg)),
						lW: baseField.lW
					});
			case 4:
				var options = state.a;
				var baseField = state.b;
				return A2(
					$author$project$Form$Radio$view,
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$Radio$withDisabled),
					{
						na: A3($author$project$Form$viewError, _List_Nil, showError, error),
						no: hasError,
						oF: onBlur,
						kV: A2(
							$elm$core$Basics$composeR,
							baseField.qd,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$ChangedValues(
									{ai: fieldId}),
								toMsg)),
						lW: baseField.lW
					});
			case 5:
				var options = state.a;
				var baseField = state.b;
				return A3(
					$author$project$Form$File$view,
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$File$withDisabled),
					{
						na: A3($author$project$Form$viewError, _List_Nil, showError, error),
						no: hasError,
						nV: isRequired,
						aw: translators,
						lW: baseField.lW
					},
					A2(
						$elm$core$Basics$composeR,
						A3(
							$author$project$Form$GotFileMsg,
							{
								ai: $author$project$Form$File$getId(options)
							},
							baseField.be,
							baseField.bv),
						toMsg));
			case 6:
				var options = state.a;
				var baseField = state.b;
				return A2(
					$author$project$Form$Select$view,
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$Select$withDisabled),
					{
						na: A3($author$project$Form$viewError, _List_Nil, showError, error),
						no: hasError,
						nV: isRequired,
						oF: onBlur,
						kV: A2(
							$elm$core$Basics$composeR,
							baseField.qd,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$ChangedValues(
									{ai: fieldId}),
								toMsg)),
						lW: baseField.lW
					});
			case 7:
				var options = state.a;
				var baseField = state.b;
				var viewConfig = {
					na: A3($author$project$Form$viewError, _List_Nil, showError, error),
					no: hasError,
					nV: isRequired,
					aw: translators,
					lW: baseField.lW
				};
				return A2(
					$elm$html$Html$map,
					toMsg,
					A3(
						$author$project$Form$DatePicker$view,
						A2(disableIfNotAlreadyDisabled, options, $author$project$Form$DatePicker$withDisabled),
						viewConfig,
						A4($author$project$Form$GotDatePickerMsg, options, viewConfig, baseField.be, baseField.bv)));
			case 8:
				var options = state.a;
				var baseField = state.b;
				var viewConfig = {
					na: A3($author$project$Form$viewError, _List_Nil, showError, error),
					no: hasError,
					oF: $author$project$Form$BlurredField(
						{
							ai: $author$project$Form$getId(state),
							h8: $author$project$Form$isEmpty(state)
						}),
					aw: translators,
					lW: baseField.lW
				};
				return A2(
					$elm$html$Html$map,
					toMsg,
					A3(
						$author$project$Form$UserPicker$view,
						A2(disableIfNotAlreadyDisabled, options, $author$project$Form$UserPicker$withDisabled),
						viewConfig,
						A4($author$project$Form$GotUserPickerMsg, options, viewConfig, baseField.be, baseField.bv)));
			case 9:
				var attrs = state.a;
				var fields = state.b;
				return A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$map,
						$elm$html$Html$Attributes$map(
							function (_v5) {
								return toMsg($author$project$Form$NoOp);
							}),
						attrs),
					A2(
						$elm$core$List$map,
						function (field_) {
							var showChildError = A2(
								$elm$core$Set$member,
								$author$project$Form$getId(field_.Z),
								errorTracking.cn) && (!field_.ax);
							return A2(
								$author$project$Form$viewField,
								{b_: disabled, hY: form, ok: model, oV: onSuccess, iN: showError || showChildError, lF: toMsg, aw: translators, o: values},
								field_);
						},
						fields));
			case 10:
				var html = state.a;
				return A2(
					$elm$html$Html$map,
					function (fn) {
						return toMsg(
							A2(
								$author$project$Form$ChangedValues,
								{ai: fieldId},
								fn(values)));
					},
					html);
			default:
				var html = state.a;
				return html;
		}
	});
var $author$project$Form$viewFields = F5(
	function (translators, form, _v0, toMsg, onSuccess) {
		var model = _v0;
		var filledForm = A2($author$project$Form$fill, form, model.o);
		var _v1 = model.aT;
		var errorTracking = _v1;
		return A2(
			$elm$core$List$map,
			function (field_) {
				var shouldShowFieldError = A2(
					$elm$core$Set$member,
					$author$project$Form$getId(field_.Z),
					errorTracking.cn) && (!field_.ax);
				return A2(
					$author$project$Form$viewField,
					{b_: model.b_, hY: form, ok: model, oV: onSuccess, iN: shouldShowFieldError || errorTracking.fD, lF: toMsg, aw: translators, o: model.o},
					field_);
			},
			$elm$core$List$reverse(filledForm.e));
	});
var $author$project$Form$view = F6(
	function (formAttrs, translators, footer, form, _v0, _v1) {
		var model = _v0;
		var toMsg = _v1.lF;
		var onSubmit = _v1.oU;
		return A2(
			$elm$html$Html$form,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$novalidate(true),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onSubmit(
						A3(
							$author$project$Form$parse,
							form,
							model,
							{oM: toMsg, oV: onSubmit})),
					formAttrs)),
			_Utils_ap(
				A5($author$project$Form$viewFields, translators, form, model, toMsg, onSubmit),
				footer(
					function (attrs) {
						return $elm$html$Html$button(
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$type_('submit'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(
										model.b_ || $author$project$Form$hasFieldsLoading(model)),
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map(
											function (_v2) {
												return toMsg($author$project$Form$NoOp);
											}),
										attrs))));
					})));
	});
var $author$project$Profile$EditKycForm$view = F2(
	function (translators, model) {
		var t = translators.fL;
		return A6(
			$author$project$Form$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('md:max-w-sm md:mx-auto py-6')
				]),
			translators,
			function (submitButton) {
				return _List_fromArray(
					[
						A2(
						submitButton,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-primary w-full')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('profile.edit.submit'))
							]))
					]);
			},
			$author$project$Profile$EditKycForm$createForm(translators),
			model.hY,
			{oU: $author$project$Profile$EditKycForm$Submitted, lF: $author$project$Profile$EditKycForm$GotFormMsg});
	});
var $author$project$Page$Community$Invite$viewContent = F3(
	function (_v0, _v1, innerContent) {
		var t = _v0.fL;
		var creator = _v1.jz;
		var community = _v1.V;
		var inviter = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Eos$Account$nameToString(creator.l8),
			creator.fj);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white pb-20')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-wrap content-end')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex overflow-hidden items-center justify-center h-24 w-24 rounded-full mx-auto -mt-12 bg-white')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(community.fe),
											$elm$html$Html$Attributes$class('object-scale-down h-20 w-20')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-6')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-lg text-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-semibold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(inviter)
												])),
											$elm$html$Html$text(' '),
											$elm$html$Html$text(
											t('community.invitation.title')),
											$elm$html$Html$text(' '),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-semibold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(community.fj)
												]))
										]))
								])),
							innerContent
						]))
				]));
	});
var $author$project$Page$Community$Invite$viewExistingMemberNotice = F2(
	function (_v0, communityTitle) {
		var t = _v0.fL;
		var tr = _v0.i4;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-6 text-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('community.invitation.already_member'))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('max-w-lg md:mx-auto mt-3')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								tr,
								'community.invitation.choose_community_tip',
								_List_fromArray(
									[
										_Utils_Tuple2('communityTitle', communityTitle)
									])))
						]))
				]));
	});
var $author$project$Page$Community$Invite$viewHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('w-full h-16 flex px-4 items-center bg-indigo-500')
		]),
	_List_Nil);
var $author$project$Page$Community$Invite$CloseConfirmationModal = {$: 3};
var $author$project$Page$Community$Invite$InvitationAccepted = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Community$Invite$InvitationRejected = {$: 4};
var $author$project$Page$Community$Invite$viewModal = F4(
	function (_v0, modalStatus, invitationId, invite) {
		var t = _v0.fL;
		var isModalVisible = function () {
			if (!modalStatus) {
				return false;
			} else {
				return true;
			}
		}();
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withFooter,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-cancel'),
								$elm$html$Html$Events$onClick($author$project$Page$Community$Invite$InvitationRejected)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('community.invitation.modal.no'))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-accept'),
								$elm$html$Html$Events$onClick(
								A2($author$project$Page$Community$Invite$InvitationAccepted, invitationId, invite))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('community.invitation.modal.yes'))
							]))
					]),
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('community.invitation.modal.body'))
						]),
					A2(
						$author$project$View$Modal$withHeader,
						t('community.invitation.modal.title'),
						$author$project$View$Modal$initWith(
							{mw: $author$project$Page$Community$Invite$CloseConfirmationModal, nX: isModalVisible})))));
	});
var $author$project$Page$Community$Invite$OpenConfirmationModal = {$: 2};
var $author$project$Page$Community$Invite$viewNewMemberConfirmation = F3(
	function (_v0, invitationId, invite) {
		var t = _v0.fL;
		var community = invite.V;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-6 px-4 text-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mr-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.invitation.subtitle'))
								])),
							$elm$html$Html$text(community.fj),
							$elm$html$Html$text('?')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-wrap justify-center w-full mt-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary w-full md:w-48 uppercase mb-4 md:mr-8'),
									$elm$html$Html$Events$onClick($author$project$Page$Community$Invite$OpenConfirmationModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.invitation.no'))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary w-full md:w-48 uppercase'),
									$elm$html$Html$Events$onClick(
									A2($author$project$Page$Community$Invite$InvitationAccepted, invitationId, invite))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.invitation.yes'))
								]))
						]))
				]));
	});
var $author$project$Page$Community$Invite$view = F2(
	function (session, model) {
		var shared = $author$project$Page$toShared(session);
		var _v0 = shared.aw;
		var t = _v0.fL;
		var content = function () {
			var _v2 = model.bI;
			switch (_v2.$) {
				case 0:
					return $elm$html$Html$text('');
				case 1:
					return $elm$html$Html$text('');
				case 2:
					var e = _v2.a;
					return A2(
						$author$project$Page$fullPageGraphQLError,
						t(''),
						e);
				case 4:
					var invite = _v2.a;
					var inner = A2($author$project$Page$Community$Invite$viewExistingMemberNotice, shared.aw, invite.V.fj);
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Page$Community$Invite$viewHeader,
								A3($author$project$Page$Community$Invite$viewContent, shared.aw, invite, inner)
							]));
				case 3:
					var invite = _v2.a;
					var inner = A3($author$project$Page$Community$Invite$viewNewMemberConfirmation, shared.aw, model.kk, invite);
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Page$Community$Invite$viewHeader,
								A3($author$project$Page$Community$Invite$viewContent, shared.aw, invite, inner),
								A4($author$project$Page$Community$Invite$viewModal, shared.aw, model.eL, model.kk, invite)
							]));
				default:
					var invite = _v2.a;
					var formData = A2($elm$core$Maybe$withDefault, $author$project$Profile$EditKycForm$init, model.fc);
					var inner = A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('md:max-w-sm md:mx-auto my-6')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('community.invite.kycRequired'))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-2 mb-6')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('community.kyc.add.canRemove'))
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Page$Community$Invite$FormMsg,
								A2($author$project$Profile$EditKycForm$view, shared.aw, formData))
							]));
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Page$Community$Invite$viewHeader,
								A3($author$project$Page$Community$Invite$viewContent, shared.aw, invite, inner)
							]));
			}
		}();
		var title = function () {
			var _v1 = model.bI;
			if (_v1.$ === 3) {
				var invite = _v1.a;
				var inviter = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Eos$Account$nameToString(invite.jz.l8),
					invite.jz.fj);
				return inviter + (' ' + (t('community.invitation.title') + (' ' + invite.V.fj)));
			} else {
				return '';
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$New$SubmittedForm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Form$File$CustomAction = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$New$FormOutput = function (description) {
	return function (name) {
		return function (url) {
			return function (symbol) {
				return function (invitedReward) {
					return function (inviterReward) {
						return function (minimumBalance) {
							return function (website) {
								return function (requireInvitation) {
									return function (logo) {
										return {aR: description, b5: invitedReward, b6: inviterReward, fe: logo, d0: minimumBalance, fj: name, eg: requireInvitation, as: symbol, hn: url, bT: website};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Form$Text$Number = 2;
var $author$project$Page$Community$New$SelectedEntry = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$addEnvironmentToUrl = F2(
	function (environment, url) {
		var environmentString = function () {
			switch (environment) {
				case 0:
					return '.staging.cambiatus.io';
				case 1:
					return '.staging.cambiatus.io';
				case 2:
					return '.demo.cambiatus.io';
				default:
					return '.cambiatus.io';
			}
		}();
		return _Utils_update(
			url,
			{
				e3: _Utils_ap(url.e3, environmentString)
			});
	});
var $author$project$Form$Validate$map = F2(
	function (fn, _v0) {
		var validator = _v0;
		return A2($elm$core$Result$map, fn, validator);
	});
var $author$project$Form$optional = function (form) {
	return function (values) {
		var filledForm = A2($author$project$Form$fill, form, values);
		var isFilledFormEmpty = A2(
			$elm$core$List$all,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Z;
				},
				$author$project$Form$isEmpty),
			filledForm.e);
		return {
			e: A2(
				$elm$core$List$map,
				function (field_) {
					return _Utils_update(
						field_,
						{
							na: isFilledFormEmpty ? $elm$core$Maybe$Nothing : field_.na,
							nV: false
						});
				},
				filledForm.e),
			g: function () {
				if (isFilledFormEmpty) {
					return $author$project$OptionalResult$OptOk($elm$core$Maybe$Nothing);
				} else {
					var _v0 = filledForm.g;
					switch (_v0.$) {
						case 1:
							var ok = _v0.a;
							return $author$project$OptionalResult$OptOk(
								$elm$core$Maybe$Just(ok));
						case 0:
							return $author$project$OptionalResult$OptNothing;
						default:
							return $author$project$OptionalResult$OptNothing;
					}
				}
			}()
		};
	};
};
var $author$project$Form$arbitraryWith = F2(
	function (succeedValue, html) {
		return function (_v0) {
			return {
				e: _List_fromArray(
					[
						{
						na: $elm$core$Maybe$Nothing,
						nV: false,
						Z: $author$project$Form$Arbitrary(html),
						ax: 0
					}
					]),
				g: $author$project$OptionalResult$OptOk(succeedValue)
			};
		};
	});
var $author$project$Form$Toggle$EnabledDisabled = 0;
var $author$project$Form$Toggle$Right = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$Toggle$init = function (_v0) {
	var label = _v0.n$;
	var id = _v0.w;
	return {
		mF: _List_Nil,
		b_: false,
		w: id,
		n$: label,
		iO: $author$project$Form$Toggle$Right(
			{kj: false}),
		iS: 0,
		hi: _List_Nil,
		i3: $elm$core$Maybe$Nothing,
		fS: $elm$core$Maybe$Nothing
	};
};
var $author$project$Form$Toggle = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Form$toggle = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			$author$project$Form$Toggle(options),
			config);
	});
var $author$project$Form$Toggle$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mF: _Utils_ap(options.mF, attrs)
			});
	});
var $author$project$Form$Toggle$withTooltip = F2(
	function (tooltip, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				i3: $elm$core$Maybe$Just(tooltip)
			});
	});
var $author$project$Page$Community$New$requireInvitationToggle = function (_v0) {
	var t = _v0.fL;
	return A4(
		$author$project$Form$withGroup,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('border rounded-md px-3 py-2')
			]),
		A2(
			$author$project$Form$arbitraryWith,
			0,
			A2(
				$author$project$View$Components$label,
				_List_Nil,
				{
					n0: t('settings.community_info.invitation.title'),
					pZ: 'require-invitation-toggle'
				})),
		A2(
			$author$project$Form$toggle,
			{
				ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				o3: $elm$core$Result$Ok,
				qd: F2(
					function (requireInvitation, input) {
						return _Utils_update(
							input,
							{eg: requireInvitation});
					}),
				lW: function ($) {
					return $.eg;
				}
			},
			A2(
				$author$project$Form$Toggle$withContainerAttrs,
				_List_Nil,
				A2(
					$author$project$Form$Toggle$withTooltip,
					{
						mG: '',
						nx: 'text-orange-300',
						of: t('settings.community_info.invitation.description')
					},
					$author$project$Form$Toggle$init(
						{
							w: 'require-invitation-toggle',
							n$: $elm$html$Html$text(
								t('settings.community_info.fields.invitation'))
						})))),
		$author$project$Form$succeed(
			F2(
				function (_v1, requiresInvitation) {
					return requiresInvitation;
				})));
};
var $author$project$Form$Validate$url = $author$project$Form$Validate$custom(
	function (stringInput) {
		var withProtocol = $elm$core$String$isEmpty(stringInput) ? '' : ((A2($elm$core$String$startsWith, 'https://', stringInput) || A2($elm$core$String$startsWith, 'http://', stringInput)) ? stringInput : ('http://' + stringInput));
		var _v0 = $elm$url$Url$fromString(withProtocol);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				function (_v1) {
					var t = _v1.fL;
					return t('settings.community_info.errors.website.invalid');
				});
		} else {
			var url_ = _v0.a;
			return $elm$core$Result$Ok(url_);
		}
	});
var $author$project$Form$File$withAddImagesView = F2(
	function (newView, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				hs: $elm$core$Maybe$Just(newView)
			});
	});
var $author$project$Form$File$withContainerAttributes = F2(
	function (attributes, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				du: _Utils_ap(options.du, attributes)
			});
	});
var $author$project$Form$RichText$withEditorContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gq: _Utils_ap(options.gq, attrs)
			});
	});
var $author$project$Form$Text$withElements = F2(
	function (elements, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				dD: _Utils_ap(
					options.dD,
					A2($elm$core$List$map, $elm$core$Basics$always, elements))
			});
	});
var $author$project$Form$File$withEntryActions = F2(
	function (buildActions, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{dA: buildActions});
	});
var $author$project$Form$File$withLabel = F2(
	function (label, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				n$: $elm$core$Maybe$Just(label)
			});
	});
var $author$project$Form$Text$StringMask = {$: 1};
var $elm$core$String$reverse = _String_reverse;
var $henriquecbuss$elm_mask$Mask$stringHelp = F3(
	function (replaceChar, sourceChar, _v0) {
		var currentString = _v0.aA;
		var currentMask = _v0.a8;
		var _v1 = $elm$core$String$toList(currentMask);
		if (!_v1.b) {
			return {a8: currentMask, aA: currentString};
		} else {
			var firstOfMask = _v1.a;
			var restOfMask = _v1.b;
			return _Utils_eq(firstOfMask, replaceChar) ? {
				a8: $elm$core$String$fromList(restOfMask),
				aA: A2($elm$core$String$cons, sourceChar, currentString)
			} : A3(
				$henriquecbuss$elm_mask$Mask$stringHelp,
				replaceChar,
				sourceChar,
				{
					a8: $elm$core$String$fromList(restOfMask),
					aA: A2($elm$core$String$cons, firstOfMask, currentString)
				});
		}
	});
var $henriquecbuss$elm_mask$Mask$string = F2(
	function (_v0, source) {
		var mask = _v0.gR;
		var replace = _v0.pu;
		var forbiddenChars = $elm$core$String$toList(
			A2(
				$elm$core$String$filter,
				function (maskChar) {
					return (!_Utils_eq(maskChar, replace)) && (!$elm$core$Char$isAlphaNum(maskChar));
				},
				mask));
		return $elm$core$String$reverse(
			A3(
				$elm$core$String$foldl,
				$henriquecbuss$elm_mask$Mask$stringHelp(replace),
				{a8: mask, aA: ''},
				A2(
					$elm$core$String$filter,
					function (x) {
						return !A2($elm$core$List$member, x, forbiddenChars);
					},
					source)).aA);
	});
var $author$project$Form$Text$withMask = F2(
	function (mask, _v0) {
		var options = _v0;
		return A2(
			$author$project$Form$Text$withElements,
			_List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'masked-input-helper',
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'target-id', options.w),
							A2($elm$html$Html$Attributes$attribute, 'mask-type', 'string')
						]),
					_List_Nil)
				]),
			_Utils_update(
				options,
				{
					bX: A2(
						$elm$core$Basics$composeR,
						$henriquecbuss$elm_mask$Mask$string(mask),
						options.bX),
					hz: $henriquecbuss$elm_mask$Mask$string(mask),
					gR: $elm$core$Maybe$Just($author$project$Form$Text$StringMask)
				}));
	});
var $author$project$Page$Community$New$createForm = F3(
	function (translators, environment, _v0) {
		var t = translators.fL;
		var isDisabled = _v0.nP;
		return A2(
			$author$project$Form$with,
			$author$project$Form$introspect(
				function (_v1) {
					var selectedLogoIndex = _v1.ha;
					return A2(
						$author$project$Form$fileMultiple,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: A2(
								$elm$core$Basics$composeR,
								$elm_community$list_extra$List$Extra$getAt(selectedLogoIndex),
								$elm$core$Result$fromMaybe(
									t('settings.community_info.logo.choose_one'))),
							aw: translators,
							qd: F2(
								function (logo, input) {
									return _Utils_update(
										input,
										{fe: logo});
								}),
							lW: function ($) {
								return $.fe;
							}
						},
						A2(
							$author$project$Form$File$withEntryActions,
							function (entryIndex) {
								return _List_fromArray(
									[
										$author$project$Form$File$DeleteEntry,
										$author$project$Form$File$CustomAction(
										A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('uppercase text-orange-300 font-bold focus-ring rounded-sm hover:opacity-60'),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Community$New$SelectedEntry(entryIndex)),
													$elm$html$Html$Attributes$type_('button')
												]),
											_List_fromArray(
												[
													_Utils_eq(entryIndex, selectedLogoIndex) ? $elm$html$Html$text(
													t('settings.community_info.logo.selected')) : $elm$html$Html$text(
													t('settings.community_info.logo.select'))
												]))),
										$author$project$Form$File$ReplaceEntry,
										$author$project$Form$File$SaveEntry
									]);
							},
							A2(
								$author$project$Form$File$withAddImagesView,
								$author$project$Form$File$defaultAddImagesView(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('!w-22 !h-22')
										])),
								A2(
									$author$project$Form$File$withImageClass,
									'max-w-16 max-h-16',
									A2(
										$author$project$Form$File$withEntryContainerAttributes,
										function (index) {
											return _List_fromArray(
												[
													$elm$html$Html$Attributes$class('w-22 h-22 p-2 grid place-items-center border rounded-md'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'border-gray-900 shadow-lg',
															_Utils_eq(index, selectedLogoIndex)),
															_Utils_Tuple2(
															'border-transparent',
															!_Utils_eq(index, selectedLogoIndex))
														]))
												]);
										},
										A2(
											$author$project$Form$File$withContainerAttributes,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('w-full mt-10')
												]),
											A2(
												$author$project$Form$File$withLabel,
												t('settings.community_info.logo.title'),
												$author$project$Form$File$init(
													{w: 'logo-input'}))))))));
				}),
			A2(
				$author$project$Form$with,
				$author$project$Page$Community$New$requireInvitationToggle(translators),
				A2(
					$author$project$Form$with,
					$author$project$Form$optional(
						A2(
							$author$project$Form$textField,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: $elm$core$Result$Ok,
								qd: F2(
									function (website, input) {
										return _Utils_update(
											input,
											{bT: website});
									}),
								lW: function ($) {
									return $.bT;
								}
							},
							A2(
								$author$project$Form$Text$withPlaceholder,
								'cambiatus.com',
								$author$project$Form$Text$init(
									{
										w: 'website-input',
										n$: t('settings.community_info.fields.website')
									})))),
					A4(
						$author$project$Form$withGroup,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('grid grid-cols-2 gap-4')
							]),
						A2(
							$author$project$Form$textField,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$succeed,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$maskedFloat(translators),
										$author$project$Form$Validate$validate(translators))),
								qd: F2(
									function (inviterReward, input) {
										return _Utils_update(
											input,
											{b6: inviterReward});
									}),
								lW: function ($) {
									return $.b6;
								}
							},
							A2(
								$author$project$Form$Text$withType,
								2,
								$author$project$Form$Text$asNumeric(
									$author$project$Form$Text$init(
										{
											w: 'inviter-reward-input',
											n$: t('community.create.labels.inviter_reward')
										})))),
						A2(
							$author$project$Form$textField,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$succeed,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$maskedFloat(translators),
										$author$project$Form$Validate$validate(translators))),
								qd: F2(
									function (minimumBalance, input) {
										return _Utils_update(
											input,
											{d0: minimumBalance});
									}),
								lW: function ($) {
									return $.d0;
								}
							},
							A2(
								$author$project$Form$Text$withType,
								2,
								$author$project$Form$Text$asNumeric(
									$author$project$Form$Text$init(
										{
											w: 'minimum-balance-input',
											n$: t('community.create.labels.min_balance')
										})))),
						A4(
							$author$project$Form$withGroup,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('grid grid-cols-2 gap-4')
								]),
							A2(
								$author$project$Form$textField,
								{
									ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
									o3: A2(
										$elm$core$Basics$composeR,
										$author$project$Eos$symbolFromString,
										$elm$core$Result$fromMaybe(
											t('error.invalidSymbol'))),
									qd: F2(
										function (symbol, input) {
											return _Utils_update(
												input,
												{as: symbol});
										}),
									lW: function ($) {
										return $.as;
									}
								},
								A2(
									$author$project$Form$Text$withExtraAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('uppercase')
										]),
									A2(
										$author$project$Form$Text$withMask,
										{
											gR: '#,' + $elm$core$String$concat(
												A2($elm$core$List$repeat, $author$project$Eos$maxSymbolLength, '#')),
											pu: '#'
										},
										A2(
											$author$project$Form$Text$withPlaceholder,
											'_, ' + A2(
												$elm$core$String$join,
												' ',
												A2($elm$core$List$repeat, $author$project$Eos$maxSymbolLength, '_')),
											$author$project$Form$Text$init(
												{
													w: 'community-symbol-input',
													n$: t('community.create.labels.currency_symbol')
												}))))),
							A2(
								$author$project$Form$textField,
								{
									ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
									o3: A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$succeed,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$maskedFloat(translators),
											$author$project$Form$Validate$validate(translators))),
									qd: F2(
										function (invitedReward, input) {
											return _Utils_update(
												input,
												{b5: invitedReward});
										}),
									lW: function ($) {
										return $.b5;
									}
								},
								A2(
									$author$project$Form$Text$withType,
									2,
									$author$project$Form$Text$asNumeric(
										$author$project$Form$Text$init(
											{
												w: 'invited-reward-input',
												n$: t('community.create.labels.invited_reward')
											})))),
							A2(
								$author$project$Form$with,
								A2(
									$author$project$Form$textField,
									{
										ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
										o3: A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$succeed,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Form$Validate$map($elm$core$String$toLower),
												A2(
													$elm$core$Basics$composeR,
													$author$project$Form$Validate$url,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Form$Validate$map(
															$author$project$Route$addEnvironmentToUrl(environment)),
														$author$project$Form$Validate$validate(translators))))),
										qd: F2(
											function (url, input) {
												return _Utils_update(
													input,
													{hn: url});
											}),
										lW: function ($) {
											return $.hn;
										}
									},
									A2(
										$author$project$Form$Text$withElements,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('absolute inset-y-0 right-4 flex items-center bg-white pl-1 my-2'),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2('bg-gray-500', isDisabled)
															]))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('.cambiatus.io')
													]))
											]),
										$author$project$Form$Text$init(
											{
												w: 'subdomain-input',
												n$: t('settings.community_info.url.title')
											}))),
								A2(
									$author$project$Form$with,
									A2(
										$author$project$Form$textField,
										{
											ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
											o3: A2(
												$elm$core$Basics$composeR,
												$author$project$Form$Validate$succeed,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Form$Validate$stringLongerThan(1),
													$author$project$Form$Validate$validate(translators))),
											qd: F2(
												function (name, input) {
													return _Utils_update(
														input,
														{fj: name});
												}),
											lW: function ($) {
												return $.fj;
											}
										},
										$author$project$Form$Text$init(
											{
												w: 'currency-name-input',
												n$: t('community.create.labels.currency_name')
											})),
									A2(
										$author$project$Form$with,
										A2(
											$author$project$Form$richText,
											{
												ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
												o3: $elm$core$Result$Ok,
												qd: F2(
													function (description, input) {
														return _Utils_update(
															input,
															{aR: description});
													}),
												lW: function ($) {
													return $.aR;
												}
											},
											A2(
												$author$project$Form$RichText$withEditorContainerAttrs,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-10')
													]),
												$author$project$Form$RichText$init(
													{
														n$: t('community.create.labels.description')
													}))),
										$author$project$Form$succeed($author$project$Page$Community$New$FormOutput)))))))));
	});
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaLabelledby = $elm$html$Html$Attributes$attribute('aria-labelledby');
var $author$project$Icons$back = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('28'),
				$elm$svg$Svg$Attributes$height('28'),
				$elm$svg$Svg$Attributes$viewBox('0 0 28 28'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M10.1818 12.9881C10.1504 13.0302 10.1227 13.0749 10.0991 13.1217C10.0599 13.1713 10.0258 13.2246 9.99724 13.2808C9.97866 13.3388 9.96587 13.3985 9.95906 13.459C9.92071 13.5747 9.92071 13.6997 9.95906 13.8154C9.96587 13.8759 9.97866 13.9356 9.99724 13.9935C10.0258 14.0498 10.0599 14.1031 10.0991 14.1526C10.1227 14.1995 10.1504 14.2442 10.1818 14.2863L15.2727 19.059C15.6586 19.4113 16.2561 19.3878 16.6131 19.0064C16.9702 18.6249 16.9542 18.0272 16.5772 17.6654L12.2309 13.5863L16.5772 9.50718C16.9542 9.14536 16.9702 8.54766 16.6131 8.16617C16.2561 7.78469 15.6586 7.76124 15.2727 8.11354L10.1818 12.9881Z')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Page$viewHeader = F2(
	function (_v0, title) {
		var shared = _v0.A;
		var routeHistory = _v0.g6;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full h-16 flex items-center bg-indigo-500')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$nav,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center container mx-auto px-4 relative')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center sm:w-full'),
									$author$project$Route$href(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Route$Dashboard,
										$elm$core$List$head(
											A2($elm$core$List$drop, 1, routeHistory)))),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabelledby('previous-page-button')
								]),
							_List_fromArray(
								[
									$author$project$Icons$back(''),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-2 text-white text-sm hidden md:visible md:flex'),
											$elm$html$Html$Attributes$id('previous-page-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											shared.aw.fL('back'))
										]))
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-white truncate w-full text-center ml-1 mr-8 sm:ml-0 sm:mr-0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full hidden sm:inline'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Page$Community$New$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var t = shared.aw.fL;
		return {
			mJ: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-white pb-10')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Page$viewHeader,
						loggedIn,
						t('community.create.title')),
						A6(
						$author$project$Form$view,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container mx-auto px-4 mt-10')
							]),
						shared.aw,
						function (submitButton) {
							return _List_fromArray(
								[
									A2(
									submitButton,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-primary w-full mt-10'),
											$elm$html$Html$Attributes$disabled(!loggedIn.gz)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('community.create.submit'))
										]))
								]);
						},
						A3(
							$author$project$Page$Community$New$createForm,
							shared.aw,
							shared.m8,
							{nP: model.nP}),
						model.hY,
						{oU: $author$project$Page$Community$New$SubmittedForm, lF: $author$project$Page$Community$New$GotFormMsg})
					])),
			fN: t('community.create.title')
		};
	});
var $author$project$Page$fullPageNotFound = F2(
	function (title, subTitle) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto container p-8 md:p-24 flex flex-wrap')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-2xl font-bold text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(subTitle)
								]))
						])),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full md:w-auto md:mx-auto mt-4'),
							$elm$html$Html$Attributes$src('/images/not_found.svg')
						]),
					_List_Nil)
				]));
	});
var $author$project$View$Components$Lg = 1;
var $author$project$Page$Community$Objectives$StartedIntersecting = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Community$Objectives$StoppedIntersecting = function (a) {
	return {$: 11, a: a};
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$View$Components$breakpointToPixels = function (breakpoint) {
	switch (breakpoint) {
		case 0:
			return 640;
		case 1:
			return 1024;
		default:
			return 1280;
	}
};
var $author$project$View$Components$intersectionObserver = function (options) {
	var decodeTargetId = function (toMsg) {
		return A2(
			$elm$json$Json$Decode$map,
			toMsg,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['detail', 'targetId']),
				$elm$json$Json$Decode$string));
	};
	var optionalEvent = F2(
		function (eventName, maybeToMsg) {
			if (maybeToMsg.$ === 1) {
				return $elm$html$Html$Attributes$class('');
			} else {
				var toMsg = maybeToMsg.a;
				return A2(
					$elm$html$Html$Events$on,
					eventName,
					decodeTargetId(toMsg));
			}
		});
	return A3(
		$elm$html$Html$node,
		'intersection-observer',
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'elm-target',
				A2($elm$core$String$join, ' ', options.p_)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'elm-threshold',
				$elm$core$String$fromFloat(options.p2)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'elm-max-width',
				function () {
					var _v0 = options.mm;
					if (_v0.$ === 1) {
						return 'none';
					} else {
						var breakpointToExclude = _v0.a;
						return $elm$core$String$fromInt(
							$author$project$View$Components$breakpointToPixels(breakpointToExclude));
					}
				}()),
				A2(optionalEvent, 'started-intersecting', options.oS),
				A2(optionalEvent, 'stopped-intersecting', options.oT)
			]),
		_List_Nil);
};
var $pzp1997$assoc_list$AssocList$keys = function (_v0) {
	var alist = _v0;
	return A2($elm$core$List$map, $elm$core$Tuple$first, alist);
};
var $author$project$Page$Community$Objectives$ClickedScrollToAction = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Community$Objectives$ClickedToggleObjectiveVisibility = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Community$Objectives$FinishedClosingObjective = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$Objectives$FinishedOpeningActions = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Objectives$GotActionMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$View$Components$Xl = 2;
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaHasPopup = $elm$html$Html$Attributes$attribute('aria-haspopup');
var $author$project$Icons$cambiatusCoin = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('22'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 22 24'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M21.9997 10.3713C22.0307 6.50581 19.745 2.94991 16.0815 1.16421C12.418 -0.621488 7.99431 -0.335942 4.6275 1.90356C1.26068 4.14306 -0.481678 7.95897 0.116109 11.7839C0.0403256 12.2629 0.00152199 12.7465 0 13.2308C0 18.916 4.9248 23.5248 10.9998 23.5248C17.0749 23.5248 21.9997 18.916 21.9997 13.2308C21.9982 12.7465 21.9594 12.2629 21.8836 11.7839C21.9569 11.3161 21.9957 10.8441 21.9997 10.3713ZM10.9998 1.7929C16.0624 1.7929 20.1664 5.63358 20.1664 10.3713C20.1664 15.109 16.0624 18.9497 10.9998 18.9497C5.93729 18.9497 1.83329 15.109 1.83329 10.3713C1.83329 5.63358 5.93729 1.7929 10.9998 1.7929ZM10.9998 21.8092C7.70509 21.7947 4.6721 20.1266 3.0555 17.4399C5.12481 19.496 8.00917 20.6617 11.0273 20.6617C14.0455 20.6617 16.9298 19.496 18.9992 17.4399C17.3729 20.1426 14.3143 21.8133 10.9998 21.8092Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.2872 9.25496C8.8104 9.25496 9.23455 8.84746 9.23455 8.34479C9.23455 7.84211 8.8104 7.43461 8.2872 7.43461C7.76399 7.43461 7.33984 7.84211 7.33984 8.34479C7.33984 8.84746 7.76399 9.25496 8.2872 9.25496Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M11.004 9.25496C11.5272 9.25496 11.9513 8.84746 11.9513 8.34479C11.9513 7.84211 11.5272 7.43461 11.004 7.43461C10.4808 7.43461 10.0566 7.84211 10.0566 8.34479C10.0566 8.84746 10.4808 9.25496 11.004 9.25496Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.5217 9.72133C15.3808 9.63106 15.2242 9.58593 15.0598 9.58593C15.005 9.58593 14.9502 9.59345 14.8875 9.60097C14.6683 9.64611 14.4804 9.76646 14.3551 9.94699L13.0085 11.9027C12.8832 12.0833 12.8441 12.2939 12.8832 12.5045C12.9302 12.7151 13.0555 12.8957 13.2434 13.016C13.4313 13.1364 13.6505 13.174 13.8697 13.1364C14.0889 13.0912 14.2768 12.9709 14.4021 12.7904L15.7488 10.8346C15.874 10.6541 15.9132 10.4435 15.874 10.2328C15.8349 10.0222 15.7096 9.84168 15.5217 9.72133Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M6.25166 10.8346L7.5983 12.7904C7.72357 12.9709 7.91148 13.0912 8.1307 13.1364C8.34992 13.1815 8.56914 13.1364 8.75705 13.016C9.14069 12.7678 9.2503 12.2713 8.99193 11.9027L7.64528 9.94699C7.52001 9.76646 7.33211 9.64611 7.11288 9.60097C7.05808 9.59345 7.00327 9.58593 6.94064 9.58593C6.77622 9.58593 6.61963 9.63106 6.47871 9.72133C6.1029 9.96956 5.99329 10.466 6.25166 10.8346Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M13.7286 9.25496C14.2518 9.25496 14.676 8.84746 14.676 8.34479C14.676 7.84211 14.2518 7.43461 13.7286 7.43461C13.2054 7.43461 12.7812 7.84211 12.7812 8.34479C12.7812 8.84746 13.2054 9.25496 13.7286 9.25496Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M10.1037 9.72133C9.96281 9.63106 9.80622 9.58593 9.6418 9.58593C9.587 9.58593 9.53219 9.59345 9.46956 9.60097C9.25034 9.64611 9.06243 9.76646 8.93716 9.94699L7.59051 11.9027C7.46524 12.0833 7.4261 12.2939 7.46524 12.5045C7.51222 12.7151 7.63749 12.8957 7.82539 13.016C8.0133 13.1364 8.23252 13.174 8.45174 13.1364C8.67096 13.0912 8.85887 12.9709 8.98414 12.7904L10.3308 10.8346C10.4561 10.6541 10.4952 10.4435 10.4561 10.2328C10.4169 10.0222 10.2916 9.84168 10.1037 9.72133Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.83525 10.2328C8.78828 10.4435 8.83525 10.6541 8.96052 10.8346L10.3072 12.7904C10.4324 12.9709 10.6203 13.0912 10.8396 13.1364C11.0588 13.1815 11.2858 13.1364 11.4659 13.016C11.8496 12.7678 11.9592 12.2713 11.7008 11.9027L10.3541 9.94699C10.2289 9.76646 10.041 9.64611 9.82175 9.60097C9.76694 9.59345 9.71214 9.58593 9.6495 9.58593C9.48509 9.58593 9.3285 9.63106 9.18757 9.72133C9.0075 9.84168 8.88223 10.0222 8.83525 10.2328Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M11.654 9.94699L10.3073 11.9027C10.182 12.0833 10.1429 12.2939 10.182 12.5045C10.229 12.7151 10.3543 12.8957 10.5422 13.016C10.7301 13.1364 10.9493 13.174 11.1685 13.1364C11.3878 13.0912 11.5757 12.9709 11.7009 12.7904L13.0476 10.8346C13.2981 10.466 13.1963 9.96204 12.8127 9.72133C12.6718 9.63106 12.5152 9.58593 12.3508 9.58593C12.296 9.58593 12.2412 9.59345 12.1785 9.60097C11.9593 9.64611 11.7714 9.76646 11.654 9.94699Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M11.6618 10.8346L13.0084 12.7904C13.1337 12.9709 13.3216 13.0912 13.5408 13.1364C13.76 13.1815 13.9871 13.1364 14.1672 13.016C14.5508 12.7678 14.6604 12.2713 14.4021 11.9027L13.0554 9.94699C12.9301 9.76646 12.7422 9.64611 12.523 9.60097C12.4682 9.59345 12.4134 9.58593 12.3508 9.58593C12.1863 9.58593 12.0298 9.63106 11.8888 9.72133C11.513 9.96956 11.4112 10.466 11.6618 10.8346Z')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$details = _VirtualDom_node('details');
var $author$project$View$Components$masonryLayoutAttributes = F3(
	function (breakpoints, _v0, attrs) {
		var transitionWithParent = _v0.p9;
		var classesForBreakpoint = function (breakpoint) {
			switch (breakpoint) {
				case 0:
					return 'sm:gap-y-0 sm:grid sm:auto-rows-[1px]';
				case 1:
					return 'lg:gap-y-0 lg:grid lg:auto-rows-[1px]';
				default:
					return 'xl:gap-y-0 xl:grid xl:auto-rows-[1px]';
			}
		};
		return A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class(
				A2(
					$elm$core$String$join,
					' ',
					A2($elm$core$List$map, classesForBreakpoint, breakpoints))),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$Attributes$attribute,
					'elm-transition-with-parent',
					$author$project$View$Components$boolToString(transitionWithParent)),
				attrs));
	});
var $author$project$View$Components$masonryLayout = F4(
	function (breakpoints, transitionWithParent, attrs, children) {
		return A3(
			$elm$html$Html$node,
			'masonry-layout',
			A3($author$project$View$Components$masonryLayoutAttributes, breakpoints, transitionWithParent, attrs),
			children);
	});
var $elm$html$Html$summary = _VirtualDom_node('summary');
var $author$project$Action$ClickedShareAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Icons$flag = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('40'),
				$elm$svg$Svg$Attributes$height('46'),
				$elm$svg$Svg$Attributes$viewBox('0 0 40 46'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M0.439542 11.1667L19.5604 0.110077C19.829 -0.0366924 20.1709 -0.0366924 20.4395 0.110077L39.5604 11.1667C39.829 11.3135 40 11.607 40 11.925V34.0628C40 34.3808 39.829 34.6743 39.5604 34.8211L20.4395 45.8777C20.293 45.9511 20.1465 46 20 46C19.8535 46 19.7069 45.9511 19.5604 45.8777L0.439542 34.8211C0.170922 34.6743 0 34.3808 0 34.0628V11.925C0 11.607 0.170922 11.3135 0.439542 11.1667Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M27.0759 19.7659L29.3273 16.2036C29.6024 15.7688 29.599 15.2358 29.3182 14.8039C29.0375 14.372 28.5217 14.1064 27.9639 14.1065H13.2858C13.2858 13.7187 12.935 13.4043 12.5023 13.4043C12.0695 13.4043 11.7188 13.7187 11.7188 14.1065V31.8947C11.7188 32.2825 12.0695 32.5969 12.5023 32.5969C12.935 32.5969 13.2858 32.2825 13.2858 31.8947V25.8092H27.9117C28.4543 25.8086 28.9578 25.5565 29.2429 25.1428C29.528 24.7291 29.554 24.2127 29.3116 23.7776L27.0759 19.7659ZM13.2858 24.4049V15.5108H27.9117L25.2634 19.7238L27.8751 24.4049H13.2858Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil)
			]));
};
var $author$project$Action$isClaimable = function (action) {
	return action.jc === 1;
};
var $author$project$Action$isPastDeadline = F2(
	function (action, now) {
		var _v0 = action.go;
		if (!_v0.$) {
			return _Utils_cmp(
				$elm$time$Time$posixToMillis(now),
				$elm$time$Time$posixToMillis(
					$author$project$Utils$fromMaybeDateTime(action.go))) > 0;
		} else {
			return false;
		}
	});
var $author$project$Action$isClosed = F2(
	function (action, now) {
		return A2($author$project$Action$isPastDeadline, action, now) || ((action.ja > 0) && (!action.jb));
	});
var $author$project$Action$viewNotAbleToClaimNotice = function (noticeText) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center bg-gray-100 rounded-sm p-2 mb-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src('/images/transfer-doggo.svg'),
						$elm$html$Html$Attributes$alt(''),
						$elm$html$Html$Attributes$class('w-8 mr-2')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-sm text-gray-900')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(noticeText)
					]))
			]));
};
var $author$project$Action$viewCard = F3(
	function (loggedIn, _v0, action) {
		var containerAttrs = _v0.mF;
		var position = _v0.bq;
		var toMsg = _v0.lF;
		var canBeClaimed = $author$project$Action$isClaimable(action) && ((!A2($author$project$Action$isClosed, action, loggedIn.A.ce)) && (!action.b7));
		var translators = loggedIn.A.aw;
		var t = translators.fL;
		var tr = translators.i4;
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('bg-white rounded self-start w-full flex-shrink-0'),
				containerAttrs),
			_List_fromArray(
				[
					function () {
					var _v1 = action.h2;
					if (_v1.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						if (_v1.a === '') {
							return $elm$html$Html$text('');
						} else {
							var image = _v1.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-2 mx-2 relative h-36 flex')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src(image),
												$elm$html$Html$Attributes$alt(''),
												$elm$html$Html$Attributes$class('rounded object-cover mx-auto')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('bg-gradient-to-t from-[#01003a14] to-[#01003a00] absolute top-0 left-0 w-full h-full rounded')
											]),
										_List_Nil)
									]));
						}
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-4 pt-4 pb-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex mb-6')
								]),
							_List_fromArray(
								[
									function () {
									if (position.$ === 1) {
										return ((!A2($author$project$Action$isClosed, action, loggedIn.A.ce)) && (!action.b7)) ? $author$project$Icons$flag('w-8 text-green fill-current') : $author$project$Icons$flag('w-8 text-gray-900 fill-current');
									} else {
										var validPosition = position.a;
										return A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-lg text-gray-500 font-bold'),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(validPosition) + '.')
												]));
									}
								}(),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-5 mt-1 min-w-0 w-full')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(
													$author$project$Markdown$toRawString(action.aR))
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Markdown$view,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('line-clamp-3 hide-children-from-2')
														]),
													action.aR)
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('sr-only')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('community.objectives.reward') + (': ' + A2(
														$author$project$Eos$assetToString,
														translators,
														{ji: action.fA, as: action.ad.V.as})))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-bold text-sm text-gray-900 uppercase block mt-6'),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('community.objectives.reward'))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-1 text-green font-bold'),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-2xl mr-1')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A3($author$project$Eos$formatSymbolAmount, translators, action.ad.V.as, action.fA))
														])),
													$elm$html$Html$text(
													$author$project$Eos$symbolToSymbolCodeString(action.ad.V.as))
												]))
										]))
								])),
							(A2($author$project$Action$isClosed, action, loggedIn.A.ce) || action.b7) ? $author$project$Action$viewNotAbleToClaimNotice(
							t('community.objectives.action_completed_notice')) : ((!$author$project$Action$isClaimable(action)) ? $author$project$Action$viewNotAbleToClaimNotice(
							t('community.objectives.action_automatic_notice')) : $elm$html$Html$text('')),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('sm:grid-cols-1', !canBeClaimed)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-secondary w-full'),
											$elm$html$Html$Events$onClick(
											toMsg(
												$author$project$Action$ClickedShareAction(action))),
											$elm$html$Html$Attributes$id(
											$author$project$Action$shareActionButtonId(action.w))
										]),
									_List_fromArray(
										[
											$author$project$Icons$share('mr-2 flex-shrink-0'),
											$elm$html$Html$text(
											t('share'))
										])),
									canBeClaimed ? A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-primary w-full sm:col-span-1'),
											$elm$html$Html$Events$onClick(
											toMsg(
												A2(
													$author$project$Action$ClickedClaimAction,
													{bq: position},
													action)))
										]),
									_List_fromArray(
										[
											action.gB ? $author$project$Icons$camera('w-4 mr-2 flex-shrink-0') : $elm$html$Html$text(''),
											$elm$html$Html$text(
											t('dashboard.claim'))
										])) : $elm$html$Html$text('')
								]))
						])),
					(!loggedIn.A.jq) ? A2(
					$elm$html$Html$map,
					toMsg,
					A2(
						$author$project$Form$Text$view,
						A2(
							$author$project$Form$Text$withInputElement,
							$author$project$Form$Text$TextareaInput(
								{pR: false}),
							A2(
								$author$project$Form$Text$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h-0 absolute opacity-0 left-[-9999em] !mb-0 overflow-hidden'),
										$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
									]),
								A2(
									$author$project$Form$Text$withExtraAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$tabindex(-1),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
										]),
									$author$project$Form$Text$init(
										{
											w: $author$project$Action$shareActionFallbackId(action.w),
											n$: ''
										})))),
						{
							na: $elm$html$Html$text(''),
							no: false,
							nV: false,
							oF: $author$project$Action$NoOp,
							oH: function (_v3) {
								return $author$project$Action$NoOp;
							},
							aw: translators,
							lW: A2(
								tr,
								'community.objectives.share_action',
								_List_fromArray(
									[
										_Utils_Tuple2('community_name', action.ad.V.fj),
										_Utils_Tuple2(
										'objective_description',
										$author$project$Markdown$toRawString(action.ad.aR)),
										_Utils_Tuple2(
										'action_description',
										$author$project$Markdown$toRawString(action.aR)),
										_Utils_Tuple2(
										'url',
										$elm$url$Url$toString(
											A2(
												$author$project$Route$addRouteToUrl,
												loggedIn.A,
												$author$project$Route$CommunityObjectives(
													$author$project$Route$WithObjectiveSelected(
														{
															dh: $elm$core$Maybe$Just(
																$author$project$Action$idToInt(action.w)),
															w: $author$project$Action$objectiveIdToInt(action.ad.w)
														})))))
									]))
						})) : $elm$html$Html$text('')
				]));
	});
var $author$project$Page$Community$Objectives$viewObjective = F3(
	function (loggedIn, model, objective) {
		var maybeShownObjectivesInfo = A2($pzp1997$assoc_list$AssocList$get, objective.w, model.E);
		var openHeight = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.bn;
			},
			maybeShownObjectivesInfo);
		var previousVisibleActionHeight = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.bK;
			},
			maybeShownObjectivesInfo);
		var visibleActionHeight = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.bS;
			},
			maybeShownObjectivesInfo);
		var visibleActionId = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.bR;
			},
			maybeShownObjectivesInfo);
		var isOpen = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (_v7) {
					var isClosing = _v7.bh;
					return !isClosing;
				},
				A2($pzp1997$assoc_list$AssocList$get, objective.w, model.E)));
		var isObjectiveHighlighted = function () {
			var _v6 = model.b2;
			if (_v6.$ === 1) {
				return false;
			} else {
				var objectiveId = _v6.a.kP;
				var actionId = _v6.a.f_;
				return _Utils_eq(objectiveId, objective.w) && $elm_community$maybe_extra$Maybe$Extra$isNothing(actionId);
			}
		}();
		var isActionHighlighted = function (action) {
			var _v5 = model.b2;
			if (_v5.$ === 1) {
				return false;
			} else {
				var objectiveId = _v5.a.kP;
				var actionId = _v5.a.f_;
				return _Utils_eq(objectiveId, objective.w) && _Utils_eq(
					actionId,
					$elm$core$Maybe$Just(action.w));
			}
		};
		var filteredActions = A2(
			$elm$core$List$filter,
			function (action) {
				return !action.b7;
			},
			objective.mb);
		var closedHeight = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.a3;
			},
			maybeShownObjectivesInfo);
		var _v0 = loggedIn.A;
		var translators = _v0.aw;
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v1 = _Utils_Tuple2(
						openHeight,
						A2($elm_community$maybe_extra$Maybe$Extra$or, closedHeight, visibleActionHeight));
					if ((!_v1.a.$) && (!_v1.b.$)) {
						var open = _v1.a.a;
						var closed = _v1.b.a;
						return A3(
							$elm$html$Html$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3(
										$elm$core$String$replace,
										'{{closed-height}}',
										$elm$core$String$fromFloat(closed),
										A3(
											$elm$core$String$replace,
											'{{open-height}}',
											$elm$core$String$fromFloat(open),
											A3(
												$elm$core$String$replace,
												'{{id}}',
												$elm$core$String$fromInt(
													$author$project$Action$objectiveIdToInt(objective.w)),
												'\n                    @keyframes shrink-details-{{id}} {\n                        0% { height: calc({{open-height}}px - 16px); }\n                        100% { height: {{closed-height}}px; }\n                    }\n                    '))))
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					A2(
					$elm$html$Html$details,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							$author$project$Page$Community$Objectives$objectiveDetailsId(objective)),
							isOpen ? A2($elm$html$Html$Attributes$attribute, 'open', 'true') : $elm$html$Html$Attributes$class(''),
							A2($elm$html$Html$Attributes$style, 'animation-duration', '300ms'),
							A2($elm$html$Html$Attributes$style, 'animation-timing-function', 'ease-in-out'),
							isOpen ? $elm$html$Html$Attributes$class('') : A2(
							$elm$html$Html$Attributes$style,
							'animation-name',
							'shrink-details-' + $elm$core$String$fromInt(
								$author$project$Action$objectiveIdToInt(objective.w))),
							A2(
							$elm$html$Html$Events$on,
							'animationend',
							A2(
								$elm$json$Json$Decode$andThen,
								function (animationName) {
									return _Utils_eq(
										animationName,
										'shrink-details-' + $elm$core$String$fromInt(
											$author$project$Action$objectiveIdToInt(objective.w))) ? $elm$json$Json$Decode$succeed(
										$author$project$Page$Community$Objectives$FinishedClosingObjective(objective)) : $elm$json$Json$Decode$fail('animationName did not match');
								},
								A2($elm$json$Json$Decode$field, 'animationName', $elm$json$Json$Decode$string)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$summary,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(
									$author$project$Page$Community$Objectives$objectiveSummaryId(objective)),
									$elm$html$Html$Attributes$class('marker-hidden lg:w-2/3 lg:mx-auto focus-ring rounded'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('border border-green ring ring-green ring-opacity-30', isObjectiveHighlighted)
										])),
									$fapian$elm_html_aria$Html$Attributes$Aria$role('button'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHasPopup('true'),
									$elm$html$Html$Events$onClick(
									$author$project$Page$Community$Objectives$ClickedToggleObjectiveVisibility(objective))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex marker-hidden items-center bg-white rounded px-4 py-6 cursor-pointer')
										]),
									_List_fromArray(
										[
											$author$project$Icons$cambiatusCoin('text-blue fill-current flex-shrink-0 self-start mt-1'),
											A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(
													$author$project$Markdown$toRawString(objective.aR)),
													$elm$html$Html$Attributes$class('max-w-[calc(100%-64px)]')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Markdown$view,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('font-bold px-4 self-start mt-1'),
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('line-clamp-4 hide-children-from-2', !isOpen)
																]))
														]),
													objective.aR)
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('ml-auto flex-shrink-0 transition-transform duration-150 motion-reduce:transition-none'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('rotate-180', isOpen),
															_Utils_Tuple2('rotate-0', !isOpen)
														]))
												]),
											_List_fromArray(
												[
													$author$project$Icons$arrowDown('text-gray-900 fill-current')
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									function () {
									if (visibleActionHeight.$ === 1) {
										if (previousVisibleActionHeight.$ === 1) {
											return $elm$html$Html$Attributes$class('');
										} else {
											var height = previousVisibleActionHeight.a;
											return A2(
												$elm$html$Html$Attributes$style,
												'height',
												'calc(' + ($elm$core$String$fromInt(
													$elm$core$Basics$ceiling(height)) + 'px + 32px)'));
										}
									} else {
										var height = visibleActionHeight.a;
										return A2(
											$elm$html$Html$Attributes$style,
											'height',
											function (heightString) {
												return 'calc(' + (heightString + 'px + 32px');
											}(
												$elm$core$String$fromInt(
													A2(
														$elm$core$Basics$max,
														$elm$core$Basics$ceiling(height),
														$elm$core$Basics$ceiling(
															A2($elm$core$Maybe$withDefault, 0, previousVisibleActionHeight))))));
									}
								}(),
									$elm$html$Html$Attributes$class('overflow-y-hidden duration-300 ease-in-out origin-top motion-reduce:transition-none'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'transition-all',
											$elm_community$maybe_extra$Maybe$Extra$isJust(visibleActionHeight))
										])),
									$elm$html$Html$Attributes$tabindex(-1)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('duration-300 ease-in-out origin-top lg:!h-full motion-reduce:transition-none'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('lg:scale-0', !isOpen),
													_Utils_Tuple2('lg:scale-1', isOpen),
													_Utils_Tuple2(
													'transition-transform',
													$elm_community$maybe_extra$Maybe$Extra$isNothing(visibleActionHeight))
												]))
										]),
									_List_fromArray(
										[
											(!isOpen) ? $elm$html$Html$text('') : ($elm$core$List$isEmpty(filteredActions) ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lg:w-1/2 xl:w-1/3 lg:mx-auto flex flex-col items-center pt-4 pb-6 animate-fade-in-from-above'),
													A2(
													$elm$html$Html$Events$on,
													'animationend',
													$elm$json$Json$Decode$succeed(
														$author$project$Page$Community$Objectives$FinishedOpeningActions(objective))),
													A2(
													$elm$html$Html$Events$on,
													'animationcancel',
													$elm$json$Json$Decode$succeed(
														$author$project$Page$Community$Objectives$FinishedOpeningActions(objective)))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src('/images/doggo-laying-down.svg'),
															$elm$html$Html$Attributes$alt(
															translators.fL('community.objectives.empty_dog_alt'))
														]),
													_List_Nil),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('mt-4 text-black font-bold text-center')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															translators.fL('community.objectives.empty_title'))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-center mt-4')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															translators.fL('community.objectives.empty_line_1')),
															A2($elm$html$Html$br, _List_Nil, _List_Nil),
															A2($elm$html$Html$br, _List_Nil, _List_Nil),
															$elm$html$Html$text(
															A2(
																translators.i4,
																'community.objectives.empty_line_2',
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'symbol',
																		$author$project$Eos$symbolToSymbolCodeString(objective.V.as))
																	])))
														]))
												])) : A4(
											$author$project$View$Components$masonryLayout,
											_List_fromArray(
												[1, 2]),
											{
												p9: function () {
													var _v4 = model.b2;
													if (_v4.$ === 1) {
														return true;
													} else {
														var objectiveId = _v4.a.kP;
														return !_Utils_eq(objectiveId, objective.w);
													}
												}()
											},
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-4 mb-2 flex h-full overflow-y-hidden overflow-x-scroll snap-x scrollbar-hidden gap-4 transition-all lg:gap-x-6 lg:overflow-visible lg:-mb-4'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'lg:grid-cols-1 lg:w-1/2 lg:mx-auto xl:w-1/3',
															$elm$core$List$length(filteredActions) === 1),
															_Utils_Tuple2(
															'lg:grid-cols-2 xl:grid-cols-2 xl:w-2/3 xl:mx-auto',
															$elm$core$List$length(filteredActions) === 2),
															_Utils_Tuple2(
															'lg:grid-cols-2 xl:grid-cols-3',
															$elm$core$List$length(filteredActions) > 2)
														])),
													$elm$html$Html$Attributes$id(
													$author$project$Page$Community$Objectives$objectiveContainerId(objective)),
													$fapian$elm_html_aria$Html$Attributes$Aria$role('list')
												]),
											A2(
												$elm$core$List$indexedMap,
												F2(
													function (index, action) {
														return A3(
															$author$project$Action$viewCard,
															loggedIn,
															{
																mF: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-6 snap-center snap-always animate-fade-in-from-above motion-reduce:animate-none'),
																		$elm$html$Html$Attributes$classList(
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'border border-green ring ring-green ring-opacity-30',
																				isActionHighlighted(action))
																			])),
																		A2(
																		$elm$html$Html$Attributes$style,
																		'animation-delay',
																		'calc(75ms * ' + ($elm$core$String$fromInt(index) + ')')),
																		$elm$html$Html$Attributes$id(
																		$author$project$Page$Community$Objectives$actionCardId(action.w)),
																		A2(
																		$elm$html$Html$Events$on,
																		'animationend',
																		$elm$json$Json$Decode$succeed(
																			$author$project$Page$Community$Objectives$FinishedOpeningActions(objective)))
																	]),
																bq: $elm$core$Maybe$Just(index + 1),
																lF: $author$project$Page$Community$Objectives$GotActionMsg
															},
															action);
													}),
												filteredActions)))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex justify-center gap-2 lg:hidden')
								]),
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, action) {
										return A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('border border-gray-900 rounded-full w-3 h-3 transition-colors focus-ring'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'border-orange-300 bg-orange-300',
															_Utils_eq(
																$elm$core$Maybe$Just(action.w),
																visibleActionId)),
															_Utils_Tuple2(
															'hover:bg-orange-300/50 hover:border-orange-300/50',
															!_Utils_eq(
																$elm$core$Maybe$Just(action.w),
																visibleActionId))
														])),
													$elm$html$Html$Attributes$id(
													'go-to-action-' + $author$project$Action$idToString(action.w)),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Community$Objectives$ClickedScrollToAction(action)),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
													A2(
														translators.i4,
														'community.objectives.go_to_action',
														_List_fromArray(
															[
																_Utils_Tuple2(
																'index',
																$elm$core$String$fromInt(index + 1))
															]))),
													$fapian$elm_html_aria$Html$Attributes$Aria$role('link')
												]),
											_List_Nil);
									}),
								filteredActions))
						]))
				]));
	});
var $author$project$Page$Community$Objectives$viewPage = F3(
	function (loggedIn, community, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var tr = _v0.i4;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto px-4 pt-8 mb-20')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lg:w-2/3 lg:mx-auto'),
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							t('community.objectives.earn') + (' ' + $author$project$Eos$symbolToSymbolCodeString(community.as)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.objectives.earn'))
								])),
							$elm$html$Html$text(' '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Eos$symbolToSymbolCodeString(community.as))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-4 bg-white rounded relative lg:w-2/3 lg:mx-auto')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('p-4')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sr-only')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('community.objectives.complete_actions') + (' ' + $author$project$Eos$symbolToSymbolCodeString(community.as)))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('community.objectives.complete_actions'))
										])),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$b,
									_List_fromArray(
										[
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Eos$symbolToSymbolCodeString(community.as))
										]))
								])),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/images/doggo_holding_coins.svg'),
									$elm$html$Html$Attributes$alt(''),
									$elm$html$Html$Attributes$class('absolute right-1 top-0 -translate-y-2/3')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-6 lg:w-2/3 lg:mx-auto'),
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							t('community.objectives.objectives_and') + (' ' + t('community.objectives.actions')))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.objectives.objectives_and'))
								])),
							$elm$html$Html$text(' '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.objectives.actions'))
								]))
						])),
					function () {
					var _v1 = community.cV;
					switch (_v1.$) {
						case 3:
							var objectives = _v1.a;
							var filteredObjectives = A2(
								$elm$core$List$filter,
								function (objective) {
									return !objective.b7;
								},
								objectives);
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$core$List$isEmpty(filteredObjectives) ? A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('lg:w-1/2 xl:w-1/3 lg:mx-auto flex flex-col items-center pt-4 pb-6')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('/images/doggo-laying-down.svg'),
														$elm$html$Html$Attributes$alt(
														t('community.objectives.empty_dog_alt'))
													]),
												_List_Nil),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-4 text-black font-bold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('community.objectives.empty_title'))
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-center mt-4')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('community.objectives.empty_objectives_line_1')),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														$elm$html$Html$text(
														t('community.objectives.empty_objectives_line_2'))
													]))
											])) : A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('space-y-4 mt-4')
											]),
										A2(
											$elm$core$List$map,
											A2($author$project$Page$Community$Objectives$viewObjective, loggedIn, model),
											filteredObjectives)),
										$author$project$View$Components$intersectionObserver(
										{
											mm: $elm$core$Maybe$Just(1),
											oS: $elm$core$Maybe$Just($author$project$Page$Community$Objectives$StartedIntersecting),
											oT: $elm$core$Maybe$Just($author$project$Page$Community$Objectives$StoppedIntersecting),
											p_: A2(
												$elm$core$List$filterMap,
												function (action) {
													return action.b7 ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
														'#' + $author$project$Page$Community$Objectives$actionCardId(action.w));
												},
												A2(
													$elm$core$List$concatMap,
													function ($) {
														return $.mb;
													},
													A2(
														$elm$core$List$filter,
														function (objective) {
															return A2(
																$elm$core$List$member,
																objective.w,
																$pzp1997$assoc_list$AssocList$keys(model.E));
														},
														filteredObjectives))),
											p2: 0.01
										})
									]));
						case 1:
							return A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('space-y-4 mt-4')
									]),
								A2(
									$elm$core$List$map,
									function (_v2) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bg-white py-10 rounded animate-skeleton-loading lg:w-2/3 lg:mx-auto')
												]),
											_List_Nil);
									},
									A2($elm$core$List$range, 0, 4)));
						case 0:
							return A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('space-y-4 mt-4')
									]),
								A2(
									$elm$core$List$map,
									function (_v3) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bg-white py-10 rounded animate-skeleton-loading lg:w-2/3 lg:mx-auto')
												]),
											_List_Nil);
									},
									A2($elm$core$List$range, 0, 4)));
						default:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-4 bg-white rounded py-6 px-4 flex flex-col items-center lg:w-2/3 lg:mx-auto')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$alt(''),
												$elm$html$Html$Attributes$src('/images/not_found.svg'),
												$elm$html$Html$Attributes$class('max-h-40')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-center mt-4')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('community.objectives.error_loading'))
											]))
									]));
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded p-4 pb-6 relative mt-18 lg:w-2/3 lg:mx-auto')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center mt-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.objectives.visit_community_page'))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href($author$project$Route$CommunityAbout),
									$elm$html$Html$Attributes$class('button button-secondary w-full mt-4')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.objectives.go_to_community_page'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute top-0 left-0 w-full flex justify-center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/images/success-doggo.svg'),
											$elm$html$Html$Attributes$alt(''),
											$elm$html$Html$Attributes$class('-translate-y-3/4')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Page$Community$Objectives$view = F2(
	function (loggedIn, model) {
		var title = loggedIn.A.aw.fL('community.objectives.title');
		return {
			mJ: function () {
				var _v0 = loggedIn.pC;
				switch (_v0.$) {
					case 3:
						var community = _v0.a;
						return community.bz ? A3($author$project$Page$Community$Objectives$viewPage, loggedIn, community, model) : A2(
							$author$project$Page$fullPageNotFound,
							title,
							loggedIn.A.aw.fL('community.objectives.disabled_objectives_description'));
					case 1:
						return $author$project$Page$fullPageLoading(loggedIn.A);
					case 0:
						return $author$project$Page$fullPageLoading(loggedIn.A);
					default:
						var err = _v0.a;
						return A2($author$project$Page$fullPageGraphQLError, title, err);
				}
			}(),
			fN: title
		};
	});
var $author$project$Route$externalHref = F3(
	function (shared, community, route) {
		return $elm$html$Html$Attributes$href(
			$elm$url$Url$toString(
				A3($author$project$Route$externalCommunityLink, shared, community.pP, route)));
	});
var $author$project$Page$Community$Selector$viewCommunity = F3(
	function (shared, model, community) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex justify-between items-center py-6 text-black hover:text-orange-300'),
					A3(
					$author$project$Route$externalHref,
					shared,
					community,
					A2($elm$core$Maybe$withDefault, $author$project$Route$Dashboard, model.kD))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-10 h-10'),
									$elm$html$Html$Attributes$src(community.fe)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-4 text-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(community.fj)
								]))
						])),
					$author$project$Icons$arrowDown('-rotate-90 fill-current')
				]));
	});
var $author$project$Page$Community$Selector$view_ = F3(
	function (shared, model, profile) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex-grow flex flex-col')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/images/map.svg')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-semibold text-black text-xl')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Welcome')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black text-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Choose the community you would like to join')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white flex-grow mt-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto px-4 divide-y divide-solid divide-gray-500')
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$Page$Community$Selector$viewCommunity, shared, model),
								profile.eK))
						]))
				]));
	});
var $author$project$Page$Community$Selector$view = F2(
	function (loggedIn, model) {
		var title = 'Select community';
		var content = function () {
			var _v0 = loggedIn.pl;
			switch (_v0.$) {
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 2:
					var err = _v0.a;
					return A2($author$project$Page$fullPageGraphQLError, title, err);
				default:
					var profile = _v0.a;
					return A3($author$project$Page$Community$Selector$view_, loggedIn.A, model, profile);
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$Settings$ActionEditor$ClickedToggleCompleted = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Community$Settings$ActionEditor$SubmittedForm = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Form$Toggle$Left = {$: 0};
var $author$project$Form$DatePicker = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Form$datePicker = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			$author$project$Form$DatePicker(options),
			{
				ne: config.ne,
				o3: A2($elm$core$Basics$composeR, $author$project$Form$DatePicker$getDate, config.o3),
				qd: config.qd,
				lW: config.lW
			});
	});
var $author$project$Form$File$fromSingleModel = function (_v0) {
	var model = _v0;
	return {
		mj: model.mj,
		i: $author$project$Form$File$SingleEntry(model.eY),
		aj: model.aj,
		Y: model.h9 ? 1 : 0,
		r: model.gH ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing
	};
};
var $author$project$Form$File$parser = F2(
	function (translators, _v0) {
		var t = translators.fL;
		var model = _v0;
		var _v1 = model.eY;
		if (_v1.$ === 1) {
			return $elm$core$Result$Err(
				t('error.required'));
		} else {
			var entry = _v1.a;
			return A2($author$project$Form$File$parseUrlStatus, translators, entry.hn);
		}
	});
var $author$project$Form$file = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Form$mapBaseField, $author$project$Form$File$fromSingleModel, $author$project$Form$File$toSingleModel),
				$author$project$Form$File(options)),
			{
				ne: config.ne,
				o3: A2(
					$elm$core$Basics$composeR,
					$author$project$Form$File$parser(config.aw),
					$elm$core$Result$andThen(config.o3)),
				qd: config.qd,
				lW: config.lW
			});
	});
var $justinmimbs$date$Date$compare = F2(
	function (_v0, _v1) {
		var a = _v0;
		var b = _v1;
		return A2($elm$core$Basics$compare, a, b);
	});
var $author$project$Form$Validate$futureDate = F2(
	function (timezone, now) {
		return $author$project$Form$Validate$custom(
			function (selectedDate) {
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				return (!A2($justinmimbs$date$Date$compare, selectedDate, today)) ? $elm$core$Result$Err(
					function (_v0) {
						var t = _v0.fL;
						return t('error.validator.date.invalid');
					}) : $elm$core$Result$Ok(selectedDate);
			});
	});
var $author$project$Form$Validate$int = $author$project$Form$Validate$number($elm$core$String$toInt);
var $author$project$Form$Validate$numberGreaterThan = F2(
	function (numberToString, lowerBound) {
		return $author$project$Form$Validate$custom(
			function (x) {
				return (_Utils_cmp(x, lowerBound) > 0) ? $elm$core$Result$Ok(x) : $elm$core$Result$Err(
					function (_v0) {
						var tr = _v0.i4;
						return A2(
							tr,
							'error.validator.number.greater_than',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'base',
									numberToString(lowerBound))
								]));
					});
			});
	});
var $author$project$Form$Validate$intGreaterThan = $author$project$Form$Validate$numberGreaterThan($elm$core$String$fromInt);
var $author$project$Form$Validate$numberGreaterThanOrEqualTo = F2(
	function (numberToString, lowerBound) {
		return $author$project$Form$Validate$custom(
			function (x) {
				return (_Utils_cmp(x, lowerBound) > -1) ? $elm$core$Result$Ok(x) : $elm$core$Result$Err(
					function (_v0) {
						var tr = _v0.i4;
						return A2(
							tr,
							'error.validator.number.greater_than_or_equal',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'base',
									numberToString(lowerBound))
								]));
					});
			});
	});
var $author$project$Form$Validate$intGreaterThanOrEqualTo = $author$project$Form$Validate$numberGreaterThanOrEqualTo($elm$core$String$fromInt);
var $author$project$Form$Validate$required = $author$project$Form$Validate$custom(
	$elm$core$Result$fromMaybe(
		function (_v0) {
			var t = _v0.fL;
			return t('error.required');
		}));
var $author$project$Page$Community$Settings$ActionEditor$Automatic = {$: 0};
var $author$project$Page$Community$Settings$ActionEditor$Manual = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$ActionEditor$NoFileValidation = {$: 0};
var $author$project$Form$ValidateOnSubmit = 1;
var $author$project$Page$Community$Settings$ActionEditor$WithFileValidation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$ActionEditor$fileValidationForm = function (_v0) {
	var t = _v0.fL;
	return A2(
		$author$project$Form$with,
		$author$project$Form$introspect(
			function (_v2) {
				var useFileValidation = _v2.fX;
				return useFileValidation ? A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$richText,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: $elm$core$Result$Ok,
							qd: F2(
								function (instructions, input) {
									return _Utils_update(
										input,
										{dM: instructions});
								}),
							lW: function ($) {
								return $.dM;
							}
						},
						A2(
							$author$project$Form$RichText$withEditorContainerAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-8 sm:w-2/5')
								]),
							$author$project$Form$RichText$init(
								{
									n$: t('community.actions.form.verification_instructions')
								}))),
					A2(
						$author$project$Form$with,
						A2(
							$author$project$Form$checkbox,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: $elm$core$Result$Ok,
								qd: F2(
									function (useVerificationCode, input) {
										return _Utils_update(
											input,
											{es: useVerificationCode});
									}),
								lW: function ($) {
									return $.es;
								}
							},
							A2(
								$author$project$Form$Checkbox$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex ml-8 my-6 sm:w-2/5')
									]),
								$author$project$Form$Checkbox$init(
									{
										w: 'verification-code-checkbox',
										n$: A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('community.actions.form.verification_code'))
																]))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															t('community.actions.form.verification_code_hint'))
														]))
												]))
									}))),
						$author$project$Form$succeed(
							F2(
								function (useVerificationCode, instructions) {
									return $author$project$Page$Community$Settings$ActionEditor$WithFileValidation(
										{dM: instructions, es: useVerificationCode});
								})))) : $author$project$Form$succeed($author$project$Page$Community$Settings$ActionEditor$NoFileValidation);
			}),
		A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$checkbox,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: $elm$core$Result$Ok,
					qd: F2(
						function (useFileValidation, input) {
							return _Utils_update(
								input,
								{fX: useFileValidation});
						}),
					lW: function ($) {
						return $.fX;
					}
				},
				A2(
					$author$project$Form$Checkbox$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex ml-8 sm:w-2/5')
						]),
					$author$project$Form$Checkbox$init(
						{
							w: 'file-validation-checkbox',
							n$: A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$b,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('community.actions.form.proof_validation'))
													]))
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('community.actions.form.proof_validation_hint'))
											]))
									]))
						}))),
			$author$project$Form$succeed(
				F2(
					function (_v1, fileValidation) {
						return fileValidation;
					}))));
};
var $author$project$Cambiatus$Enum$VerificationType$fromString = function (enumString) {
	switch (enumString) {
		case 'AUTOMATIC':
			return $elm$core$Maybe$Just(0);
		case 'CLAIMABLE':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Form$Radio$init = function (_v0) {
	var label = _v0.n$;
	var id = _v0.w;
	var optionToString = _v0.d5;
	return {mF: _List_Nil, F: 0, b_: false, cK: false, w: id, n$: label, dY: _List_Nil, d5: optionToString, d6: _List_Nil};
};
var $author$project$Form$Validate$lengthGreaterThanOrEqualTo = function (minLength) {
	return $author$project$Form$Validate$custom(
		function (items) {
			return (_Utils_cmp(
				$elm$core$List$length(items),
				minLength) > -1) ? $elm$core$Result$Ok(items) : $elm$core$Result$Err(
				function (_v0) {
					var tr = _v0.i4;
					return A2(
						tr,
						'error.validator.number.length_greater_than_or_equal',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'count',
								$elm$core$String$fromInt(minLength))
							]));
				});
		});
};
var $author$project$Form$Radio = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Form$UnsafeArbitrary = function (a) {
	return {$: 11, a: a};
};
var $author$project$Form$UserPicker = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Form$DatePicker$map = F2(
	function (fn, _v0) {
		var options = _v0;
		return {
			ex: options.ex,
			mF: A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map(fn),
				options.mF),
			b_: options.b_,
			w: options.w,
			n$: options.n$
		};
	});
var $author$project$Form$UserPicker$map = F2(
	function (fn, _v0) {
		var options = _v0;
		return {
			eA: options.eA,
			mF: A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map(fn),
				options.mF),
			eR: options.eR,
			b_: options.b_,
			n$: options.n$,
			d$: options.d$,
			fr: {ee: $elm$core$Maybe$Nothing, g9: $elm$core$Maybe$Nothing},
			fs: options.fs
		};
	});
var $author$project$Form$mapBaseFieldValues = F3(
	function (fn, reverseFn, baseField) {
		return {
			be: A2($elm$core$Basics$composeR, reverseFn, baseField.be),
			qd: A2($elm$core$Basics$composeR, baseField.qd, fn),
			bv: F2(
				function (value, values) {
					return fn(
						A2(
							baseField.bv,
							value,
							reverseFn(values)));
				}),
			lW: baseField.lW
		};
	});
var $author$project$Form$DatePicker$mapViewConfig = F2(
	function (fn, viewConfig) {
		return {
			na: A2($elm$html$Html$map, fn, viewConfig.na),
			no: viewConfig.no,
			nV: viewConfig.nV,
			aw: viewConfig.aw,
			lW: viewConfig.lW
		};
	});
var $author$project$Form$UserPicker$mapViewConfig = F2(
	function (fn, viewConfig) {
		return {
			na: A2($elm$html$Html$map, fn, viewConfig.na),
			no: viewConfig.no,
			oF: fn(viewConfig.oF),
			aw: viewConfig.aw,
			lW: viewConfig.lW
		};
	});
var $author$project$Form$mapMsg = F3(
	function (fn, reverseFn, msg) {
		switch (msg.$) {
			case 0:
				return $author$project$Form$NoOp;
			case 1:
				var fieldId = msg.a;
				var values = msg.b;
				return A2(
					$author$project$Form$ChangedValues,
					fieldId,
					fn(values));
			case 2:
				var getModel = msg.a;
				var updateFn = msg.b;
				var subMsg = msg.c;
				return A3(
					$author$project$Form$GotRichTextMsg,
					A2($elm$core$Basics$composeR, reverseFn, getModel),
					F2(
						function (value, values) {
							return fn(
								A2(
									updateFn,
									value,
									reverseFn(values)));
						}),
					subMsg);
			case 3:
				var fieldId = msg.a;
				var getModel = msg.b;
				var updateFn = msg.c;
				var subMsg = msg.d;
				return A4(
					$author$project$Form$GotFileMsg,
					fieldId,
					A2($elm$core$Basics$composeR, reverseFn, getModel),
					F2(
						function (value, values) {
							return fn(
								A2(
									updateFn,
									value,
									reverseFn(values)));
						}),
					subMsg);
			case 4:
				var options = msg.a;
				var viewConfig = msg.b;
				var getModel = msg.c;
				var updateFn = msg.d;
				var subMsg = msg.e;
				return A5(
					$author$project$Form$GotDatePickerMsg,
					A2(
						$author$project$Form$DatePicker$map,
						A2($author$project$Form$mapMsg, fn, reverseFn),
						options),
					A2(
						$author$project$Form$DatePicker$mapViewConfig,
						A2($author$project$Form$mapMsg, fn, reverseFn),
						viewConfig),
					A2($elm$core$Basics$composeR, reverseFn, getModel),
					F2(
						function (value, values) {
							return fn(
								A2(
									updateFn,
									value,
									reverseFn(values)));
						}),
					subMsg);
			case 5:
				var options = msg.a;
				var viewConfig = msg.b;
				var getModel = msg.c;
				var updateFn = msg.d;
				var subMsg = msg.e;
				return A5(
					$author$project$Form$GotUserPickerMsg,
					A2(
						$author$project$Form$UserPicker$map,
						A2($author$project$Form$mapMsg, fn, reverseFn),
						options),
					A2(
						$author$project$Form$UserPicker$mapViewConfig,
						A2($author$project$Form$mapMsg, fn, reverseFn),
						viewConfig),
					A2($elm$core$Basics$composeR, reverseFn, getModel),
					F2(
						function (value, values) {
							return fn(
								A2(
									updateFn,
									value,
									reverseFn(values)));
						}),
					subMsg);
			case 6:
				var fieldInfo = msg.a;
				return $author$project$Form$BlurredField(fieldInfo);
			default:
				var errors = msg.a;
				return $author$project$Form$ClickedSubmitWithErrors(errors);
		}
	});
var $author$project$Form$mapField = F3(
	function (fn, reverseFn, field_) {
		var mapWithMsg = F4(
			function (fieldType, specificMap, options, baseField) {
				return A2(
					fieldType,
					A2(
						specificMap,
						A2($author$project$Form$mapMsg, fn, reverseFn),
						options),
					A3($author$project$Form$mapBaseFieldValues, fn, reverseFn, baseField));
			});
		var baseMap = F3(
			function (fieldType, options, baseField) {
				return A2(
					fieldType,
					options,
					A3($author$project$Form$mapBaseFieldValues, fn, reverseFn, baseField));
			});
		switch (field_.$) {
			case 0:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$Text, options, baseField);
			case 1:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$RichText, options, baseField);
			case 2:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$Toggle, options, baseField);
			case 3:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$Checkbox, options, baseField);
			case 4:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$Radio, options, baseField);
			case 5:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$File, options, baseField);
			case 6:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$Select, options, baseField);
			case 7:
				var options = field_.a;
				var baseField = field_.b;
				return A4(mapWithMsg, $author$project$Form$DatePicker, $author$project$Form$DatePicker$map, options, baseField);
			case 8:
				var options = field_.a;
				var baseField = field_.b;
				return A4(mapWithMsg, $author$project$Form$UserPicker, $author$project$Form$UserPicker$map, options, baseField);
			case 9:
				var attributes = field_.a;
				var fields = field_.b;
				return A2(
					$author$project$Form$Group,
					attributes,
					A2(
						$elm$core$List$map,
						A2($author$project$Form$mapFilledField, fn, reverseFn),
						fields));
			case 10:
				var html = field_.a;
				return $author$project$Form$Arbitrary(
					A2(
						$elm$html$Html$map,
						function (htmlFn) {
							return A2(
								$elm$core$Basics$composeR,
								reverseFn,
								A2($elm$core$Basics$composeR, htmlFn, fn));
						},
						html));
			default:
				var html = field_.a;
				return $author$project$Form$UnsafeArbitrary(html);
		}
	});
var $author$project$Form$mapFilledField = F3(
	function (fn, reverseFn, filledField) {
		return {
			na: filledField.na,
			nV: filledField.nV,
			Z: A3($author$project$Form$mapField, fn, reverseFn, filledField.Z),
			ax: filledField.ax
		};
	});
var $author$project$Form$mapValues = F2(
	function (mappings, child) {
		return function (values) {
			var filledChild = A2(
				$author$project$Form$fill,
				child,
				mappings.lW(values));
			return {
				e: A2(
					$elm$core$List$map,
					A2(
						$author$project$Form$mapFilledField,
						function (child_) {
							return A2(mappings.qd, child_, values);
						},
						mappings.lW),
					filledChild.e),
				g: filledChild.g
			};
		};
	});
var $author$project$Form$Radio$getOptionToString = function (_v0) {
	var options = _v0;
	return options.d5;
};
var $author$project$Form$Radio$map = F3(
	function (fn, reverseFn, _v0) {
		var options = _v0;
		return {
			mF: options.mF,
			F: options.F,
			b_: options.b_,
			cK: options.cK,
			w: options.w,
			n$: options.n$,
			dY: options.dY,
			d5: A2($elm$core$Basics$composeR, reverseFn, options.d5),
			d6: A2(
				$elm$core$List$map,
				function (_v1) {
					var option = _v1.gY;
					var label = _v1.n$;
					return {
						n$: label,
						gY: fn(option)
					};
				},
				options.d6)
		};
	});
var $author$project$Form$radio = F3(
	function (optionFromString, config, options) {
		var optionToString = $author$project$Form$Radio$getOptionToString(options);
		return A2(
			$author$project$Form$field,
			$author$project$Form$Radio(
				A3($author$project$Form$Radio$map, optionToString, optionFromString, options)),
			A3($author$project$Form$mapFieldConfig, optionToString, optionFromString, config));
	});
var $author$project$Form$UserPicker$fromMultiplePicker = function (_v0) {
	var model = _v0;
	return {
		w: model.w,
		G: model.G,
		H: $author$project$Form$UserPicker$Multiple(model.ej)
	};
};
var $author$project$Form$UserPicker$getMultipleProfiles = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.pl;
		},
		model.ej);
};
var $author$project$Form$UserPicker$toMultiplePicker = function (_v0) {
	var model = _v0;
	var _v1 = model.H;
	if (!_v1.$) {
		var maybeProfile = _v1.a;
		return {
			w: model.w,
			G: model.G,
			ej: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, maybeProfile))
		};
	} else {
		var profiles = _v1.a;
		return {w: model.w, G: model.G, ej: profiles};
	}
};
var $author$project$Form$userPickerMultiple = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Form$mapBaseField, $author$project$Form$UserPicker$fromMultiplePicker, $author$project$Form$UserPicker$toMultiplePicker),
				$author$project$Form$UserPicker(options)),
			{
				ne: config.ne,
				o3: A2($elm$core$Basics$composeR, $author$project$Form$UserPicker$getMultipleProfiles, config.o3),
				qd: config.qd,
				lW: config.lW
			});
	});
var $author$project$Form$Radio$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mF: _Utils_ap(options.mF, attrs)
			});
	});
var $author$project$Form$Radio$withDirection = F2(
	function (direction, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{F: direction});
	});
var $author$project$Form$Radio$withHiddenRadioButton = F2(
	function (hideRadioButton, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{cK: hideRadioButton});
	});
var $author$project$Form$Radio$withLabelAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				dY: _Utils_ap(options.dY, attrs)
			});
	});
var $author$project$Form$Radio$withOption = F3(
	function (optionValue, optionLabel, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				d6: A2(
					$elm$core$List$cons,
					{n$: optionLabel, gY: optionValue},
					options.d6)
			});
	});
var $author$project$Form$withValidationStrategy = F2(
	function (validationStrategy, form) {
		return function (values) {
			var filled = A2($author$project$Form$fill, form, values);
			return {
				e: A2(
					$elm$core$List$map,
					function (field_) {
						return _Utils_update(
							field_,
							{ax: validationStrategy});
					},
					filled.e),
				g: filled.g
			};
		};
	});
var $author$project$Page$Community$Settings$ActionEditor$verificationForm = F2(
	function (loggedIn, community) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var tr = _v0.i4;
		return A2(
			$author$project$Form$with,
			$author$project$Form$introspect(
				function (values) {
					var _v5 = values.jc;
					if (!_v5) {
						return $author$project$Form$succeed($author$project$Page$Community$Settings$ActionEditor$NoFileValidation);
					} else {
						return A2(
							$author$project$Form$mapValues,
							{
								qd: F2(
									function (fileValidation, input) {
										return _Utils_update(
											input,
											{dF: fileValidation});
									}),
								lW: function ($) {
									return $.dF;
								}
							},
							$author$project$Page$Community$Settings$ActionEditor$fileValidationForm(loggedIn.A.aw));
					}
				}),
			A2(
				$author$project$Form$with,
				$author$project$Form$introspect(
					function (values) {
						var _v4 = values.jc;
						if (!_v4) {
							return $author$project$Form$succeed(0);
						} else {
							return A2(
								$author$project$Form$textField,
								{
									ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
									o3: A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$succeed,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$maskedFloat(loggedIn.A.aw),
											$author$project$Form$Validate$validate(loggedIn.A.aw))),
									qd: F2(
										function (verifierReward, input) {
											return _Utils_update(
												input,
												{lY: verifierReward});
										}),
									lW: function ($) {
										return $.lY;
									}
								},
								A2(
									$author$project$Form$Text$withCurrency,
									community.as,
									A2(
										$author$project$Form$Text$withContainerAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ml-8 sm:w-2/5')
											]),
										$author$project$Form$Text$init(
											{
												w: 'verifier-reward-input',
												n$: t('community.actions.form.verifiers_reward_label')
											}))));
						}
					}),
				A2(
					$author$project$Form$with,
					$author$project$Form$introspect(
						function (values) {
							var _v3 = values.jc;
							if (!_v3) {
								return $author$project$Form$succeed(_List_Nil);
							} else {
								return A2(
									$author$project$Form$withValidationStrategy,
									1,
									A2(
										$author$project$Form$userPickerMultiple,
										{
											ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
											o3: A2(
												$elm$core$Basics$composeR,
												$author$project$Form$Validate$succeed,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Form$Validate$lengthGreaterThanOrEqualTo(
														$author$project$Page$Community$Settings$ActionEditor$minVotesToInt(values.bk)),
													$author$project$Form$Validate$validate(loggedIn.A.aw))),
											qd: F2(
												function (verifiers, input) {
													return _Utils_update(
														input,
														{eu: verifiers});
												}),
											lW: function ($) {
												return $.eu;
											}
										},
										A2(
											$author$project$Form$UserPicker$withContainerAttrs,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('ml-8 sm:w-2/5')
												]),
											$author$project$Form$UserPicker$init(
												{
													eR: loggedIn._,
													n$: A2(
														tr,
														'community.actions.form.verifiers_label_count',
														_List_fromArray(
															[
																_Utils_Tuple2(
																'count',
																$elm$core$String$fromInt(
																	$author$project$Page$Community$Settings$ActionEditor$minVotesToInt(values.bk)))
															])),
													fs: community.ih
												}))));
							}
						}),
					A2(
						$author$project$Form$with,
						$author$project$Form$introspect(
							function (values) {
								var _v2 = values.jc;
								if (!_v2) {
									return $author$project$Form$succeed(0);
								} else {
									var withOption = function (minVotes) {
										return A2(
											$author$project$Form$Radio$withOption,
											minVotes,
											A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('h-8 w-8 rounded-full border flex items-center justify-center cursor-pointer sibling-focus ring-orange-300 ring-opacity-50 transition-all'),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'bg-orange-300 border-orange-300 text-white',
																_Utils_eq(values.bk, minVotes)),
																_Utils_Tuple2(
																'hover:border-orange-300 hover:text-orange-500 border-gray-500',
																!_Utils_eq(values.bk, minVotes))
															]))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(
															$author$project$Page$Community$Settings$ActionEditor$minVotesToInt(minVotes)))
													])));
									};
									return A3(
										$author$project$Form$radio,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$String$toInt,
											A2(
												$elm$core$Basics$composeR,
												$elm$core$Maybe$andThen($author$project$Page$Community$Settings$ActionEditor$minVotesFromInt),
												$elm$core$Maybe$withDefault(0))),
										{
											ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
											o3: $elm$core$Result$Ok,
											qd: F2(
												function (minVotes, input) {
													return _Utils_update(
														input,
														{bk: minVotes});
												}),
											lW: function ($) {
												return $.bk;
											}
										},
										A2(
											$author$project$Form$Radio$withHiddenRadioButton,
											true,
											A2(
												$author$project$Form$Radio$withLabelAttrs,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-6')
													]),
												A2(
													$author$project$Form$Radio$withContainerAttrs,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('ml-8 mt-12 mb-6')
														]),
													A2(
														withOption,
														3,
														A2(
															withOption,
															2,
															A2(
																withOption,
																1,
																A2(
																	withOption,
																	0,
																	$author$project$Form$Radio$init(
																		{
																			w: 'min-votes-radio',
																			n$: t('community.actions.form.votes_label'),
																			d5: A2($elm$core$Basics$composeR, $author$project$Page$Community$Settings$ActionEditor$minVotesToInt, $elm$core$String$fromInt)
																		})))))))));
								}
							}),
						A2(
							$author$project$Form$with,
							A3(
								$author$project$Form$radio,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Cambiatus$Enum$VerificationType$fromString,
									$elm$core$Maybe$withDefault(0)),
								{
									ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
									o3: $elm$core$Result$Ok,
									qd: F2(
										function (verificationType, input) {
											return _Utils_update(
												input,
												{jc: verificationType});
										}),
									lW: function ($) {
										return $.jc;
									}
								},
								A2(
									$author$project$Form$Radio$withDirection,
									1,
									A2(
										$author$project$Form$Radio$withLabelAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-6')
											]),
										A2(
											$author$project$Form$Radio$withContainerAttrs,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('my-6')
												]),
											A3(
												$author$project$Form$Radio$withOption,
												1,
												A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('community.actions.form.manual'))
																])),
															$elm$html$Html$text(
															t('community.actions.form.manual_detail'))
														])),
												A3(
													$author$project$Form$Radio$withOption,
													0,
													A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('flex items-center space-x-2')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$p,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$b,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				t('community.actions.form.automatic'))
																			])),
																		$elm$html$Html$text(
																		t('community.actions.form.automatic_detail'))
																	])),
																$author$project$View$Components$tooltip(
																{
																	mG: '',
																	nx: '',
																	of: t('community.actions.form.automatic_tooltip')
																})
															])),
													$author$project$Form$Radio$init(
														{
															w: 'verification-type-radio',
															n$: t('community.actions.form.verification_label'),
															d5: $author$project$Cambiatus$Enum$VerificationType$toString
														}))))))),
							$author$project$Form$succeed(
								F5(
									function (verificationType, minVotes, verifiers, verifierReward, fileValidation) {
										if (!verificationType) {
											return $author$project$Page$Community$Settings$ActionEditor$Automatic;
										} else {
											return $author$project$Page$Community$Settings$ActionEditor$Manual(
												{
													dF: fileValidation,
													bk: minVotes,
													lY: {ji: verifierReward, as: community.as},
													eu: verifiers
												});
										}
									})))))));
	});
var $author$project$Form$File$withAddImagesContainerAttributes = F2(
	function (attributes, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				f$: _Utils_ap(options.f$, attributes)
			});
	});
var $author$project$Icons$addPhoto = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z')
					]),
				_List_Nil)
			]));
};
var $author$project$Form$File$withGrayBoxVariant = F2(
	function (translators, _v0) {
		var options = _v0;
		return A2(
			$author$project$Form$File$withImageCropperAttributes,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('rounded-sm')
				]),
			A2(
				$author$project$Form$File$withAddImagesContainerAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('!w-full rounded-sm')
					]),
				A2(
					$author$project$Form$File$withAddImagesView,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full bg-gray-100 rounded-sm flex flex-col justify-center items-center hover:bg-gray-200')
								]),
							_List_fromArray(
								[
									$author$project$Icons$addPhoto('fill-current text-body-black w-10 mb-2'),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('px-4 font-bold text-center')
										]),
									_List_fromArray(
										[
											((!A2($elm$core$List$member, 0, options.dE)) && A2($elm$core$List$member, 1, options.dE)) ? $elm$html$Html$text(
											translators.fL('upload_image')) : $elm$html$Html$text(
											translators.fL('community.actions.proof.upload_hint'))
										]))
								]))
						]),
					A2(
						$author$project$Form$File$withEntryContainerAttributes,
						function (_v1) {
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-gray-100 rounded-sm overflow-hidden grid place-items-center')
								]);
						},
						options))));
	});
var $author$project$Form$withNesting = F3(
	function (mappings, child, parent) {
		return A2(
			$author$project$Form$with,
			A2($author$project$Form$mapValues, mappings, child),
			parent);
	});
var $author$project$Form$Toggle$withToggleSide = F2(
	function (side, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{iO: side});
	});
var $author$project$Form$Toggle$withTopLabel = F2(
	function (topLabel, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				fS: $elm$core$Maybe$Just(topLabel)
			});
	});
var $author$project$Page$Community$Settings$ActionEditor$form = F2(
	function (loggedIn, community) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		return A3(
			$author$project$Form$withNesting,
			{
				qd: F2(
					function (child, parent) {
						return _Utils_update(
							parent,
							{hp: child});
					}),
				lW: function ($) {
					return $.hp;
				}
			},
			A2($author$project$Page$Community$Settings$ActionEditor$verificationForm, loggedIn, community),
			A2(
				$author$project$Form$with,
				$author$project$Form$introspect(
					function (values) {
						return (values.cu && $elm_community$maybe_extra$Maybe$Extra$isJust(values.jb)) ? A2(
							$author$project$Form$textField,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$succeed,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$int,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$intGreaterThanOrEqualTo(0),
											$author$project$Form$Validate$validate(loggedIn.A.aw)))),
								qd: F2(
									function (usagesLeft_, input) {
										return _Utils_update(
											input,
											{
												jb: $elm$core$Maybe$Just(usagesLeft_)
											});
									}),
								lW: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.jb;
									},
									$elm$core$Maybe$withDefault(''))
							},
							A2(
								$author$project$Form$Text$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sm:w-2/5')
									]),
								$author$project$Form$Text$asNumeric(
									A2(
										$author$project$Form$Text$withType,
										2,
										$author$project$Form$Text$init(
											{
												w: 'usages-left-input',
												n$: t('community.actions.form.usages_left_label')
											}))))) : $author$project$Form$succeed(0);
					}),
				A2(
					$author$project$Form$with,
					$author$project$Form$introspect(
						function (values) {
							return values.cu ? A2(
								$author$project$Form$textField,
								{
									ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
									o3: A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$succeed,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$int,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Form$Validate$intGreaterThan(0),
												$author$project$Form$Validate$validate(loggedIn.A.aw)))),
									qd: F2(
										function (maxUsages, input) {
											return _Utils_update(
												input,
												{cb: maxUsages});
										}),
									lW: function ($) {
										return $.cb;
									}
								},
								A2(
									$author$project$Form$Text$withContainerAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-6 sm:w-2/5')
										]),
									$author$project$Form$Text$asNumeric(
										A2(
											$author$project$Form$Text$withType,
											2,
											A2(
												$author$project$Form$Text$withPlaceholder,
												t('community.actions.form.usages_placeholder'),
												$author$project$Form$Text$init(
													{
														w: 'usages-validity-input',
														n$: t('community.actions.form.quantity_label')
													})))))) : $author$project$Form$succeed(0);
						}),
					A2(
						$author$project$Form$with,
						A2(
							$author$project$Form$checkbox,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: $elm$core$Result$Ok,
								qd: F2(
									function (useUsagesValidation, input) {
										return _Utils_update(
											input,
											{cu: useUsagesValidation});
									}),
								lW: function ($) {
									return $.cu;
								}
							},
							A2(
								$author$project$Form$Checkbox$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex mb-3 sm:w-2/5')
									]),
								$author$project$Form$Checkbox$init(
									{
										w: 'usages-validity-checkbox',
										n$: A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$b,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															t('community.actions.form.quantity_validity'))
														])),
													$elm$html$Html$text(
													t('community.actions.form.quantity_validity_details'))
												]))
									}))),
						A2(
							$author$project$Form$with,
							$author$project$Form$introspect(
								function (values) {
									return values.dc ? A2(
										$author$project$Form$datePicker,
										{
											ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
											o3: A2(
												$elm$core$Basics$composeR,
												$author$project$Form$Validate$succeed,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Form$Validate$required,
													A2(
														$elm$core$Basics$composeR,
														A2($author$project$Form$Validate$futureDate, loggedIn.A.i2, loggedIn.A.ce),
														$author$project$Form$Validate$validate(loggedIn.A.aw)))),
											qd: F2(
												function (expirationDate, input) {
													return _Utils_update(
														input,
														{cI: expirationDate});
												}),
											lW: function ($) {
												return $.cI;
											}
										},
										A2(
											$author$project$Form$DatePicker$withContainerAttrs,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mb-6')
												]),
											$author$project$Form$DatePicker$init(
												{
													w: 'date-validation-picker',
													n$: t('community.actions.form.date_label')
												}))) : $author$project$Form$succeed(
										A2($justinmimbs$date$Date$fromPosix, loggedIn.A.i2, loggedIn.A.ce));
								}),
							A2(
								$author$project$Form$with,
								A2(
									$author$project$Form$checkbox,
									{
										ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
										o3: $elm$core$Result$Ok,
										qd: F2(
											function (useDateValidation, input) {
												return _Utils_update(
													input,
													{dc: useDateValidation});
											}),
										lW: function ($) {
											return $.dc;
										}
									},
									A2(
										$author$project$Form$Checkbox$withContainerAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex mt-6 mb-3 sm:w-2/5')
											]),
										$author$project$Form$Checkbox$init(
											{
												w: 'date-validity-checkbox',
												n$: A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('community.actions.form.date_validity'))
																])),
															$elm$html$Html$text(
															t('community.actions.form.date_validity_details'))
														]))
											}))),
								A2(
									$author$project$Form$withNoOutput,
									$author$project$Form$introspect(
										function (values) {
											return A2(
												$author$project$Form$toggle,
												{
													ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
													o3: $elm$core$Result$Ok,
													qd: F2(
														function (_v2, input) {
															return input;
														}),
													lW: function (input) {
														return input.dc || input.cu;
													}
												},
												A2(
													$author$project$Form$Toggle$withToggleSide,
													$author$project$Form$Toggle$Left,
													A2(
														$author$project$Form$Toggle$withTopLabel,
														t('community.actions.form.validity_label'),
														$author$project$Form$Toggle$init(
															{
																w: 'expiration-toggle',
																n$: A2(
																	$elm$html$Html$p,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('text-green')
																		]),
																	(values.dc || values.cu) ? _List_fromArray(
																		[
																			A2(
																			$elm$html$Html$b,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					t('community.actions.form.validation_on'))
																				])),
																			$elm$html$Html$text(
																			t('community.actions.form.validation_on_detail'))
																		]) : _List_fromArray(
																		[
																			A2(
																			$elm$html$Html$b,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					t('community.actions.form.validation_off'))
																				])),
																			$elm$html$Html$text(
																			t('community.actions.form.validation_detail'))
																		]))
															}))));
										}),
									A2(
										$author$project$Form$with,
										A2(
											$author$project$Form$textField,
											{
												ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
												o3: A2(
													$elm$core$Basics$composeR,
													$author$project$Form$Validate$succeed,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Form$Validate$maskedFloat(loggedIn.A.aw),
														$author$project$Form$Validate$validate(loggedIn.A.aw))),
												qd: F2(
													function (reward, input) {
														return _Utils_update(
															input,
															{fA: reward});
													}),
												lW: function ($) {
													return $.fA;
												}
											},
											A2(
												$author$project$Form$Text$withCurrency,
												community.as,
												A2(
													$author$project$Form$Text$withContainerAttrs,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-full sm:w-2/5')
														]),
													A2(
														$author$project$Form$Text$withPlaceholder,
														A3($author$project$Eos$formatSymbolAmount, loggedIn.A.aw, community.as, 0),
														$author$project$Form$Text$init(
															{
																w: 'claimant-reward-input',
																n$: t('community.actions.form.reward_label')
															}))))),
										A2(
											$author$project$Form$withNoOutput,
											$author$project$Form$arbitrary(
												A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('sm:w-2/5 mb-10 text-gray-600')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															loggedIn.A.aw.fL('community.actions.form.image_guidance'))
														]))),
											A2(
												$author$project$Form$with,
												$author$project$Form$optional(
													A2(
														$author$project$Form$file,
														{
															ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
															o3: $elm$core$Result$Ok,
															aw: loggedIn.A.aw,
															qd: F2(
																function (image, input) {
																	return _Utils_update(
																		input,
																		{h2: image});
																}),
															lW: function ($) {
																return $.h2;
															}
														},
														$author$project$Form$File$withEditIconOverlay(
															A2(
																$author$project$Form$File$withImageCropperAttributes,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('rounded')
																	]),
																A2(
																	$author$project$Form$File$withContainerAttributes,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('w-full sm:w-2/5 mb-2')
																		]),
																	A2(
																		$author$project$Form$File$withImageClass,
																		'w-full rounded',
																		A2(
																			$author$project$Form$File$withEntryContainerAttributes,
																			function (_v1) {
																				return _List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('w-full min-h-36 max-h-40 rounded')
																					]);
																			},
																			A2(
																				$author$project$Form$File$withAddImagesContainerAttributes,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('w-full min-h-36 max-h-40 rounded overflow-hidden')
																					]),
																				A2(
																					$author$project$Form$File$withGrayBoxVariant,
																					loggedIn.A.aw,
																					A2(
																						$author$project$Form$File$withLabel,
																						loggedIn.A.aw.fL('community.actions.form.image_label'),
																						$author$project$Form$File$init(
																							{w: 'action-image-input '}))))))))))),
												A2(
													$author$project$Form$with,
													A2(
														$author$project$Form$richText,
														{
															ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
															o3: A2(
																$elm$core$Basics$composeR,
																$author$project$Form$Validate$succeed,
																A2(
																	$elm$core$Basics$composeR,
																	$author$project$Form$Validate$markdownLongerThan(10),
																	$author$project$Form$Validate$validate(loggedIn.A.aw))),
															qd: F2(
																function (description, input) {
																	return _Utils_update(
																		input,
																		{aR: description});
																}),
															lW: function ($) {
																return $.aR;
															}
														},
														A2(
															$author$project$Form$RichText$withEditorContainerAttrs,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('mb-10')
																]),
															$author$project$Form$RichText$init(
																{
																	n$: t('community.actions.form.description_label')
																}))),
													$author$project$Form$succeed(
														F9(
															function (description, image, reward, useDateValidation, expirationDate, useMaxUsages, maxUsages, usagesLeft, verification) {
																return {
																	aR: description,
																	cI: useDateValidation ? $elm$core$Maybe$Just(expirationDate) : $elm$core$Maybe$Nothing,
																	h2: image,
																	cb: useMaxUsages ? $elm$core$Maybe$Just(maxUsages) : $elm$core$Maybe$Nothing,
																	fA: {ji: reward, as: community.as},
																	jb: useMaxUsages ? $elm$core$Maybe$Just(usagesLeft) : $elm$core$Maybe$Nothing,
																	ho: verification
																};
															})))))))))))));
	});
var $author$project$Page$Community$Settings$ActionEditor$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var _v0 = shared.aw;
		var t = _v0.fL;
		var content = function () {
			var _v2 = _Utils_Tuple2(loggedIn.pC, model.pN);
			_v2$2:
			while (true) {
				switch (_v2.a.$) {
					case 1:
						var _v3 = _v2.a;
						return $author$project$Page$fullPageLoading(shared);
					case 0:
						var _v4 = _v2.a;
						return $author$project$Page$fullPageLoading(shared);
					case 3:
						switch (_v2.b.$) {
							case 1:
								break _v2$2;
							case 0:
								var community = _v2.a.a;
								var _v6 = _v2.b;
								var formModel = _v6.a;
								var maybeAction = _v6.b;
								var form_ = A2($author$project$Page$Community$Settings$ActionEditor$form, loggedIn, community);
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-white')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Page$viewHeader,
											loggedIn,
											t('community.actions.title')),
											A6(
											$author$project$Form$view,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('container mx-auto px-4 mt-6 mb-12')
												]),
											shared.aw,
											function (submitButton) {
												return _List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('mt-18 sm:flex sm:align-center')
															]),
														_List_fromArray(
															[
																A2(
																submitButton,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('button button-primary w-full sm:w-48'),
																		$elm$html$Html$Attributes$disabled(!loggedIn.gz)
																	]),
																_List_fromArray(
																	[
																		$elm_community$maybe_extra$Maybe$Extra$isJust(model.f_) ? $elm$html$Html$text(
																		t('menu.save')) : $elm$html$Html$text(
																		t('menu.create'))
																	])),
																function () {
																if (!maybeAction.$) {
																	var action = maybeAction.a;
																	return A2(
																		$elm$html$Html$button,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$type_('button'),
																				$elm$html$Html$Attributes$class('button button-secondary w-full mt-4 sm:w-48 sm:mt-0 sm:ml-4'),
																				$elm$html$Html$Attributes$disabled(!loggedIn.gz),
																				$elm$html$Html$Events$onClick(
																				A3(
																					$author$project$Form$parse,
																					form_,
																					formModel,
																					{
																						oM: $author$project$Page$Community$Settings$ActionEditor$GotFormMsg,
																						oV: $author$project$Page$Community$Settings$ActionEditor$ClickedToggleCompleted(action)
																					}))
																			]),
																		_List_fromArray(
																			[
																				action.b7 ? $elm$html$Html$text(
																				t('community.actions.form.mark_not_completed')) : $elm$html$Html$text(
																				t('community.actions.form.mark_completed'))
																			]));
																} else {
																	return $elm$html$Html$text('');
																}
															}()
															]))
													]);
											},
											form_,
											formModel,
											{
												oU: $author$project$Page$Community$Settings$ActionEditor$SubmittedForm(maybeAction),
												lF: $author$project$Page$Community$Settings$ActionEditor$GotFormMsg
											})
										]));
							case 3:
								var _v8 = _v2.b;
								return A2(
									$author$project$Page$fullPageNotFound,
									t('community.edit.unauthorized'),
									'');
							default:
								var _v9 = _v2.b;
								return A2(
									$author$project$Page$fullPageNotFound,
									t('community.actions.form.not_found'),
									'');
						}
					default:
						if (_v2.b.$ === 1) {
							break _v2$2;
						} else {
							var e = _v2.a.a;
							return A2(
								$author$project$Page$fullPageGraphQLError,
								t('error.invalidSymbol'),
								e);
						}
				}
			}
			var _v5 = _v2.b;
			return $author$project$Page$fullPageLoading(shared);
		}();
		var title = function () {
			var action = (!_Utils_eq(model.f_, $elm$core$Maybe$Nothing)) ? t('menu.edit') : t('menu.create');
			return action + (' ' + t('community.actions.title'));
		}();
		return {
			mJ: function () {
				var _v1 = A2(
					$krisajenkins$remotedata$RemoteData$map,
					function ($) {
						return $.bz;
					},
					loggedIn.pC);
				switch (_v1.$) {
					case 3:
						if (_v1.a) {
							return content;
						} else {
							return A2(
								$author$project$Page$fullPageNotFound,
								t('error.pageNotFound'),
								t('community.objectives.disabled.description'));
						}
					case 1:
						return $author$project$Page$fullPageLoading(shared);
					case 0:
						return $author$project$Page$fullPageLoading(shared);
					default:
						var e = _v1.a;
						return A2(
							$author$project$Page$fullPageGraphQLError,
							t('community.error_loading'),
							e);
				}
			}(),
			fN: title
		};
	});
var $author$project$Page$Community$Settings$Contacts$SubmittedForm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Contact$Deleted = 2;
var $author$project$Contact$addContactType = F2(
	function (contactType, _v0) {
		var values = _v0;
		var newEntry = {a9: 0, n$: '', eq: contactType, lW: ''};
		return _Utils_update(
			values,
			{
				dL: A3($elm$core$Dict$insert, values.gM + 1, newEntry, values.dL),
				e9: false,
				gM: values.gM + 1
			});
	});
var $author$project$Icons$circledPlus = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M6.6967 17.3035C9.62563 20.2324 14.3744 20.2324 17.3033 17.3035C20.2322 14.3745 20.2322 9.62579 17.3033 6.69686C14.3744 3.76792 9.62563 3.76792 6.6967 6.69686C3.76777 9.62579 3.76777 14.3745 6.6967 17.3035Z'),
						$elm$svg$Svg$Attributes$stroke('#F99D33'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.182 12.0003H8.81802'),
						$elm$svg$Svg$Attributes$stroke('#F99D33'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 8.81836V15.1823'),
						$elm$svg$Svg$Attributes$stroke('#F99D33'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Contact$closeTypeModal = function (_v0) {
	var values = _v0;
	return _Utils_update(
		values,
		{e9: false});
};
var $author$project$Icons$circularClose = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('18'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 18 16'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M5.45632 11.5353C7.57956 13.4879 11.022 13.4879 13.1452 11.5353C15.2685 9.58269 15.2685 6.41687 13.1452 4.46424C11.022 2.51162 7.57956 2.51162 5.45632 4.46424C3.33308 6.41687 3.33308 9.58269 5.45632 11.5353Z'),
						$elm$svg$Svg$Attributes$stroke('#DB1B1B'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M11.6075 8.00023L6.9941 8.00023'),
						$elm$svg$Svg$Attributes$stroke('#DB1B1B'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Form$Validate$isValidEmail = function () {
	var validEmailRegex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		A2(
			$elm$regex$Regex$fromStringWith,
			{mp: true, om: false},
			'^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$'));
	return $elm$regex$Regex$contains(validEmailRegex);
}();
var $author$project$Form$Validate$email = $author$project$Form$Validate$custom(
	function (stringInput) {
		return $author$project$Form$Validate$isValidEmail(stringInput) ? $elm$core$Result$Ok(stringInput) : $elm$core$Result$Err(
			function (_v0) {
				var t = _v0.fL;
				return t('error.email');
			});
	});
var $author$project$Contact$finishDeletingContact = function (values) {
	return _Utils_update(
		values,
		{a9: 2});
};
var $author$project$Contact$isNotDeleted = function (deletionStatus) {
	return !deletionStatus;
};
var $author$project$Contact$Deleting = 1;
var $author$project$Contact$startDeletingContact = function (values) {
	return _Utils_update(
		values,
		{a9: 1});
};
var $author$project$Contact$typeToPlaceholder = function (type_) {
	switch (type_) {
		case 0:
			return 'hola@cambiatus.com';
		case 1:
			return 'cambiatus';
		case 2:
			return 'cambiatus.com';
		case 3:
			return '+55 11 91234 5678';
		case 4:
			return 'cambiatus';
		default:
			return '+55 11 91234 5678';
	}
};
var $author$project$Contact$validateInstagram = function () {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^[\\w](?!.*?\\.{2})[\\w.]{1,28}[\\w]$'));
	return $author$project$Form$Validate$custom(
		function (instagram) {
			return A2($elm$regex$Regex$contains, regex, instagram) ? $elm$core$Result$Ok('https://instagram.com/' + instagram) : $elm$core$Result$Err(
				function (_v0) {
					var t = _v0.fL;
					return t('contact_form.validation.username.invalid');
				});
		});
}();
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAC = {
	eO: '247',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[01589]\\d|[46])\\d{4}')),
	w: 'AC',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '62889',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6[2-467]\\d{3}'))
		},
			{
			nb: '40123',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4\\d{4}'))
		},
			{
			nb: '542011',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:0[1-9]|[1589]\\d)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAD = {
	eO: '376',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:1|6\\d)\\d{7}|[135-9]\\d{5}')),
	w: 'AD',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1800\\d{4}'))
		},
			{
			nb: '712345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[78]\\d{5}'))
		},
			{
			nb: '312345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('690\\d{6}|[356]\\d{5}'))
		},
			{
			nb: '18001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('180[02]\\d{4}'))
		},
			{
			nb: '912345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[19]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAE = {
	eO: '971',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}')),
	w: 'AE',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '22345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[2-4679][2-8]\\d{6}'))
		},
			{
			nb: '501234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5[024-68]\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('400\\d{6}|800\\d{2,9}'))
		},
			{
			nb: '900234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[02]\\d{5}'))
		},
			{
			nb: '700012345',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('700[05]\\d{5}'))
		},
			{
			nb: '600212345',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('600[25]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAF = {
	eO: '93',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-7]\\d{8}')),
	w: 'AF',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '234567890',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}'))
		},
			{
			nb: '701234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7\\d{8}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAG = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:268|[58]\\d\\d|900)\\d{7}')),
	w: 'AG',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '2684601234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}'))
		},
			{
			nb: '2684641234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}'))
		},
			{
			nb: '2684061234',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('26840[69]\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '2684801234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('26848[01]\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAI = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:264|[58]\\d\\d|900)\\d{7}')),
	w: 'AI',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '2644612345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('264(?:292|4(?:6[12]|9[78]))\\d{4}'))
		},
			{
			nb: '2642351234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}'))
		},
			{
			nb: '2647241234',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('264724\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAL = {
	eO: '355',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}')),
	w: 'AL',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '22345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}'))
		},
			{
			nb: '672123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6(?:[78][2-9]|9\\d)\\d{6}'))
		},
			{
			nb: '8001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{4}'))
		},
			{
			nb: '900123',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[1-9]\\d\\d'))
		},
			{
			nb: '808123',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('808[1-9]\\d\\d'))
		},
			{
			nb: '70021234',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('700[2-9]\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAM = {
	eO: '374',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[1-489]\\d|55|60|77)\\d{6}')),
	w: 'AM',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '10123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}'))
		},
			{
			nb: '77123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:33|4[1349]|55|77|88|9[13-9])\\d{6}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{5}'))
		},
			{
			nb: '90012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[016]\\d{5}'))
		},
			{
			nb: '80112345',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[1-4]\\d{5}'))
		},
			{
			nb: '60271234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|90)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAO = {
	eO: '244',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[29]\\d{8}')),
	w: 'AO',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '222123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}'))
		},
			{
			nb: '923123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9[1-49]\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAR = {
	eO: '54',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('11\\d{8}|(?:[2368]|9\\d)\\d{9}')),
	w: 'AR',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('810\\d{7}'))
		},
			{
			nb: '1123456789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3888[013-9]\\d{5}|(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-7]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}'))
		},
			{
			nb: '91123456789',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('93888[013-9]\\d{5}|9(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-7]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7}'))
		},
			{
			nb: '6001234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('60[04579]\\d{7}'))
		},
			{
			nb: '8101234567',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('810\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAS = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[58]\\d\\d|684|900)\\d{7}')),
	w: 'AS',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '6846221234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6846(?:22|33|44|55|77|88|9[19])\\d{4}'))
		},
			{
			nb: '6847331234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('684(?:2(?:48|5[2468]|72)|7(?:3[13]|70|82))\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAT = {
	eO: '43',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}')),
	w: 'AT',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '1234567890',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}'))
		},
			{
			nb: '664123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6,10}'))
		},
			{
			nb: '900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:0[01]|3[019])\\d{6,10}'))
		},
			{
			nb: '810123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:10|2[018])\\d{6,10}|828\\d{5}'))
		},
			{
			nb: '780123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAU = {
	eO: '61',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}')),
	w: 'AU',
	ki: $elm$core$Maybe$Just('001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1[38]00\\d{6}|1(?:345[0-4]|802)\\d{3}|13\\d{4}'))
		},
			{
			nb: '212345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-7]|3[2-4]|[4-6]\\d))|91(?:[0-57-9]\\d|6[0135-9])\\d)\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:6[0-8]|[78]\\d|9[02-9]))\\d{6}'))
		},
			{
			nb: '412345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}'))
		},
			{
			nb: '1631234',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('163\\d{2,6}'))
		},
			{
			nb: '1800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('180(?:0\\d{3}|2)\\d{3}'))
		},
			{
			nb: '1900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('190[0-26]\\d{6}'))
		},
			{
			nb: '1300123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}'))
		},
			{
			nb: '147101234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAW = {
	eO: '297',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[25-79]\\d\\d|800)\\d{4}')),
	w: 'AW',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '5212345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5(?:2\\d|8[1-9])\\d{4}'))
		},
			{
			nb: '5601234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}'))
		},
			{
			nb: '8001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{4}'))
		},
			{
			nb: '9001234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900\\d{4}'))
		},
			{
			nb: '5011234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:28\\d|501)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAX = {
	eO: '358',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}')),
	w: 'AX',
	ki: $elm$core$Maybe$Just('00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '181234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('18[1-8]\\d{3,6}'))
		},
			{
			nb: '412345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:4[0-8]|50)\\d{4,8}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{4,6}'))
		},
			{
			nb: '600123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[67]00\\d{5,6}'))
		},
			{
			nb: '10112345',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAZ = {
	eO: '994',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('365\\d{6}|(?:[124579]\\d|60|88)\\d{7}')),
	w: 'AZ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '123123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:222[0-79]\\d|365(?:[0-46-9]\\d|5[0-35-9]))\\d{4}|(?:(?:1[28]|46)\\d|2(?:[045]2|1[24]|2[34]|33|6[23]))\\d{6}'))
		},
			{
			nb: '401234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:36554|99[2-9]\\d\\d)\\d{4}|(?:[16]0|4[04]|5[015]|7[07])\\d{7}'))
		},
			{
			nb: '881234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('88\\d{7}'))
		},
			{
			nb: '900200123',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900200\\d{3}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBA = {
	eO: '387',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('6\\d{8}|(?:[35689]\\d|49|70)\\d{6}')),
	w: 'BA',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '30212345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}'))
		},
			{
			nb: '61123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6040[0-4]\\d{4}|6(?:03|[1-356]|44|7\\d)\\d{6}'))
		},
			{
			nb: '80123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8[08]\\d{6}'))
		},
			{
			nb: '90123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9[0246]\\d{6}'))
		},
			{
			nb: '82123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8[12]\\d{6}'))
		},
			{
			nb: '70341234',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70(?:3[0146]|[56]0)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBB = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:246|[58]\\d\\d|900)\\d{7}')),
	w: 'BB',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '2464123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}'))
		},
			{
			nb: '2462501234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('246(?:2(?:[3568]\\d|4[0-57-9])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:246976|900[2-9]\\d\\d)\\d{4}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '2463101234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('24631\\d{5}'))
		},
			{
			nb: '2464301234',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('246(?:292|367|4(?:1[7-9]|3[01]|44|67)|7(?:36|53))\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBD = {
	eO: '880',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}')),
	w: 'BD',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '27111234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2[45]\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}'))
		},
			{
			nb: '1812345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[03]\\d{7}'))
		},
			{
			nb: '9604123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBE = {
	eO: '32',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('4\\d{8}|[1-9]\\d{7}')),
	w: 'BE',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '12345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}'))
		},
			{
			nb: '470123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4[5-9]\\d{7}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800[1-9]\\d{4}'))
		},
			{
			nb: '90012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:70(?:2[0-57]|3[0457]|44|69|7[0579])|90(?:0[0-35-8]|1[36]|2[0-3568]|3[0135689]|4[2-68]|5[1-68]|6[0-378]|7[23568]|9[34679]))\\d{4}'))
		},
			{
			nb: '78791234',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7879\\d{4}'))
		},
			{
			nb: '78102345',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('78(?:0[57]|1[0458]|2[25]|3[15-8]|48|[56]0|7[078])\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBF = {
	eO: '226',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[025-7]\\d{7}')),
	w: 'BF',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '20491234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:0(?:49|5[23]|6[56]|9[016-9])|4(?:4[569]|5[4-6]|6[56]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}'))
		},
			{
			nb: '70123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:0[127]|5[1-8]|[67]\\d)\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBG = {
	eO: '359',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}')),
	w: 'BG',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '2123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}'))
		},
			{
			nb: '48123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('43[07-9]\\d{5}|(?:48|8[7-9]\\d|9(?:8\\d|9[69]))\\d{6}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{5}'))
		},
			{
			nb: '90123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90\\d{6}'))
		},
			{
			nb: '70012345',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('700\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBH = {
	eO: '973',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[136-9]\\d{7}')),
	w: 'BH',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '17001234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}'))
		},
			{
			nb: '36001234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}'))
		},
			{
			nb: '80123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{6}'))
		},
			{
			nb: '90123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:87|9[014578])\\d{6}'))
		},
			{
			nb: '84123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('84\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBI = {
	eO: '257',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[267]\\d|31)\\d{6}')),
	w: 'BI',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '22201234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('22\\d{6}'))
		},
			{
			nb: '79561234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:29|31|6[1289]|7[125-9])\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBJ = {
	eO: '229',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[2689]\\d|51)\\d{6}')),
	w: 'BJ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '20211234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:02|1[037]|2[45]|3[68])\\d{5}'))
		},
			{
			nb: '90011234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:51|6\\d|9[013-9])\\d{6}'))
		},
			{
			nb: '85751234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('857[58]\\d{4}'))
		},
			{
			nb: '81123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('81\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBL = {
	eO: '590',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:590|69\\d|976)\\d{6}')),
	w: 'BL',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '590271234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('590(?:2[7-9]|5[12]|87)\\d{4}'))
		},
			{
			nb: '690001234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}'))
		},
			{
			nb: '976012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('976[01]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBM = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:441|[58]\\d\\d|900)\\d{7}')),
	w: 'BM',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '4414123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}'))
		},
			{
			nb: '4413701234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('441(?:[2378]\\d|5[0-39])\\d{5}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBN = {
	eO: '673',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-578]\\d{6}')),
	w: 'BN',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '2345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}'))
		},
			{
			nb: '7123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:22[89]|[78]\\d\\d)\\d{4}'))
		},
			{
			nb: '5345678',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5[34]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBO = {
	eO: '591',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[2-467]\\d\\d|8001)\\d{5}')),
	w: 'BO',
	ki: $elm$core$Maybe$Just('00(?:1\\d)?'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8001[07]\\d{4}'))
		},
			{
			nb: '22123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}'))
		},
			{
			nb: '71234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[67]\\d{7}'))
		},
			{
			nb: '800171234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8001[07]\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBQ = {
	eO: '599',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[34]1|7\\d)\\d{5}')),
	w: 'BQ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '7151234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}'))
		},
			{
			nb: '3181234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBS = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:242|[58]\\d\\d|900)\\d{7}')),
	w: 'BS',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '2423456789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}'))
		},
			{
			nb: '2423591234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '2422250123',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('242225\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBT = {
	eO: '975',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[17]\\d{7}|[2-8]\\d{6}')),
	w: 'BT',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '2345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}'))
		},
			{
			nb: '17123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1[67]|77)\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBW = {
	eO: '267',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('90\\d{5}|(?:[2-6]|7\\d)\\d{6}')),
	w: 'BW',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '2401234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[0389]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}'))
		},
			{
			nb: '71123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('77200\\d{3}|7(?:[1-6]\\d|7[013-9])\\d{5}'))
		},
			{
			nb: '9012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90\\d{5}'))
		},
			{
			nb: '79101234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('79(?:1(?:[01]\\d|20)|2[0-2]\\d)\\d{3}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBY = {
	eO: '375',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}')),
	w: 'BY',
	ki: $elm$core$Maybe$Just('810'),
	oo: $elm$core$Maybe$Just('8'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}'))
		},
			{
			nb: '152450911',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}'))
		},
			{
			nb: '294911911',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}'))
		},
			{
			nb: '8011234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}'))
		},
			{
			nb: '9021234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:810|902)\\d{7}'))
		},
			{
			nb: '249123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('249\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBZ = {
	eO: '501',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:0800\\d|[2-8])\\d{6}')),
	w: 'BZ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '2221234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:236|732)\\d{4}|[2-578][02]\\d{5}'))
		},
			{
			nb: '6221234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6[0-35-7]\\d{5}'))
		},
			{
			nb: '08001234123',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('0800\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCC = {
	eO: '61',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}')),
	w: 'CC',
	ki: $elm$core$Maybe$Just('001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '891621234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:51(?:0(?:02|31|60|89)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}'))
		},
			{
			nb: '412345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}'))
		},
			{
			nb: '1800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('180(?:0\\d{3}|2)\\d{3}'))
		},
			{
			nb: '1900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('190[0-26]\\d{6}'))
		},
			{
			nb: '1300123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}'))
		},
			{
			nb: '147101234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCD = {
	eO: '243',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[189]\\d{8}|[1-68]\\d{6}')),
	w: 'CD',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '1234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('12\\d{7}|[1-6]\\d{6}'))
		},
			{
			nb: '991234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('88\\d{5}|(?:8[0-2459]|9[017-9])\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCF = {
	eO: '236',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[27]\\d{3}|8776)\\d{4}')),
	w: 'CF',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '21612345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2[12]\\d{6}'))
		},
			{
			nb: '70012345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[0257]\\d{6}'))
		},
			{
			nb: '87761234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8776\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCG = {
	eO: '242',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('222\\d{6}|(?:0\\d|80)\\d{7}')),
	w: 'CG',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '222123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('222[1-589]\\d{5}'))
		},
			{
			nb: '061234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('0[14-6]\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80(?:0\\d\\d|11[0-4])\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCH = {
	eO: '41',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('8\\d{11}|[2-9]\\d{8}')),
	w: 'CH',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '212345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}'))
		},
			{
			nb: '781234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[35-9]\\d{7}'))
		},
			{
			nb: '740123456',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('74[0248]\\d{6}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6}'))
		},
			{
			nb: '900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[016]\\d{6}'))
		},
			{
			nb: '840123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('84[0248]\\d{6}'))
		},
			{
			nb: '878123456',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('878\\d{6}'))
		},
			{
			nb: '581234567',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5[18]\\d{7}'))
		},
			{
			nb: '860123456789',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('860\\d{9}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCI = {
	eO: '225',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[02-9]\\d{7}')),
	w: 'CI',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '21234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:0[023]|1[02357]|[23][045]|4[03-5])|3(?:0[06]|1[069]|[2-4][07]|5[09]|6[08]))\\d{5}'))
		},
			{
			nb: '01234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2[0-3]80|97[0-3]\\d)\\d{4}|(?:0[1-9]|[457]\\d|6[014-9]|8[4-9]|95)\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCK = {
	eO: '682',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-578]\\d{4}')),
	w: 'CK',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '21234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2\\d|3[13-7]|4[1-5])\\d{3}'))
		},
			{
			nb: '71234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[578]\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCL = {
	eO: '56',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}')),
	w: 'CL',
	ki: $elm$core$Maybe$Just('(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('600\\d{7,8}'))
		},
			{
			nb: '221234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:0\\d|1[0-35-9]|2[1-9]|3[0-2]|40)))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}'))
		},
			{
			nb: '221234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:0\\d|1[0-35-9]|2[1-9]|3[0-2]|40)))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:123|8)00\\d{6}'))
		},
			{
			nb: '6001234567',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('600\\d{7,8}'))
		},
			{
			nb: '441234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('44\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCM = {
	eO: '237',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[26]\\d\\d|88)\\d{6}')),
	w: 'CM',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '222123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:22|33)\\d{6}'))
		},
			{
			nb: '671234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:24[23]|6[5-9]\\d)\\d{6}'))
		},
			{
			nb: '88012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('88\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCN = {
	eO: '86',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}')),
	w: 'CN',
	ki: $elm$core$Maybe$Just('00|1(?:[12]\\d|79)\\d\\d00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}'))
		},
			{
			nb: '1012345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))'))
		},
			{
			nb: '13123456789',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|5[0-35-9]|6[25-7]|7[0-35-8]|9[0135-9])\\d{8}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:10|21)8|8)00\\d{7}'))
		},
			{
			nb: '16812345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('16[08]\\d{5}'))
		},
			{
			nb: '4001234567',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCO = {
	eO: '57',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:1\\d|3)\\d{9}|[124-8]\\d{7}')),
	w: 'CO',
	ki: $elm$core$Maybe$Just('00(?:4(?:[14]4|56)|[579])'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '12345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[124-8][2-9]\\d{6}'))
		},
			{
			nb: '3211234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|33(?:00|3[0-24-9])\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}'))
		},
			{
			nb: '18001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1800\\d{7}'))
		},
			{
			nb: '19001234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('19(?:0[01]|4[78])\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCU = {
	eO: '53',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}')),
	w: 'CU',
	ki: $elm$core$Maybe$Just('119'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '71234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3[23]|48)\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}'))
		},
			{
			nb: '51234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5\\d{7}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7}'))
		},
			{
			nb: '8071234567',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('807\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCV = {
	eO: '238',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[2-59]\\d\\d|800)\\d{4}')),
	w: 'CV',
	ki: $elm$core$Maybe$Just('0'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '2211234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}'))
		},
			{
			nb: '9911234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[34][36]|5[1-389]|9\\d)\\d{5}'))
		},
			{
			nb: '8001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCW = {
	eO: '599',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}')),
	w: 'CW',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '94351234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}'))
		},
			{
			nb: '95181234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}'))
		},
			{
			nb: '95581234',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('955\\d{5}'))
		},
			{
			nb: '6001234',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('60[0-2]\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCX = {
	eO: '61',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}')),
	w: 'CX',
	ki: $elm$core$Maybe$Just('001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '891641234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|235)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}'))
		},
			{
			nb: '412345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}'))
		},
			{
			nb: '1800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('180(?:0\\d{3}|2)\\d{3}'))
		},
			{
			nb: '1900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('190[0-26]\\d{6}'))
		},
			{
			nb: '1300123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}'))
		},
			{
			nb: '147101234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCY = {
	eO: '357',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[279]\\d|[58]0)\\d{6}')),
	w: 'CY',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '22345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2[2-6]\\d{6}'))
		},
			{
			nb: '96123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9[4-79]\\d{6}'))
		},
			{
			nb: '80001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{5}'))
		},
			{
			nb: '90012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[09]\\d{5}'))
		},
			{
			nb: '80112345',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[1-9]\\d{5}'))
		},
			{
			nb: '70012345',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('700\\d{5}'))
		},
			{
			nb: '77123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:50|77)\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCZ = {
	eO: '420',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}')),
	w: 'CZ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '212345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}'))
		},
			{
			nb: '601123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6}'))
		},
			{
			nb: '900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:0[05689]|76)\\d{6}'))
		},
			{
			nb: '811234567',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8[134]\\d{7}'))
		},
			{
			nb: '700123456',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70[01]\\d{6}'))
		},
			{
			nb: '910123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9[17]0\\d{6}'))
		},
			{
			nb: '972123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:5\\d|7[2-4])\\d{6}'))
		},
			{
			nb: '93123456789',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:3\\d{9}|6\\d{7,10})'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDE = {
	eO: '49',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2579]\\d{5,14}|49(?:[05]\\d{10}|[46][1-8]\\d{4,9})|49(?:[0-25]\\d|3[1-689]|7[1-7])\\d{4,8}|49(?:[0-2579]\\d|[34][1-9]|6[0-8])\\d{3}|49\\d{3,4}|(?:1|[368]\\d|4[0-8])\\d{3,13}')),
	w: 'DE',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '30123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:32|49[4-6]\\d)\\d{9}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}'))
		},
			{
			nb: '15123456789',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}'))
		},
			{
			nb: '16412345',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('16(?:4\\d{1,10}|[89]\\d{1,11})'))
		},
			{
			nb: '8001234567890',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7,12}'))
		},
			{
			nb: '9001234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:137[7-9]|900(?:[135]|9\\d))\\d{6}'))
		},
			{
			nb: '18012345',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}'))
		},
			{
			nb: '70012345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('700\\d{8}'))
		},
			{
			nb: '18500123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('18(?:1\\d{5,11}|[2-9]\\d{8})'))
		},
			{
			nb: '177991234567',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDJ = {
	eO: '253',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:2\\d|77)\\d{6}')),
	w: 'DJ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '21360003',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:1[2-5]|7[45])\\d{5}'))
		},
			{
			nb: '77831001',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('77\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDK = {
	eO: '45',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-9]\\d{7}')),
	w: 'DK',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '32123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}'))
		},
			{
			nb: '32123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}'))
		},
			{
			nb: '80123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{6}'))
		},
			{
			nb: '90123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDM = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[58]\\d\\d|767|900)\\d{7}')),
	w: 'DM',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '7674201234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}'))
		},
			{
			nb: '7672251234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-7]|70[1-6])\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDO = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[58]\\d\\d|900)\\d{7}')),
	w: 'DO',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '8092345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}'))
		},
			{
			nb: '8092345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8[024]9[2-9]\\d{6}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDZ = {
	eO: '213',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[1-4]|[5-79]\\d|80)\\d{7}')),
	w: 'DZ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '12345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}'))
		},
			{
			nb: '551234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:5(?:4[0-29]|5\\d|6[01])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6}'))
		},
			{
			nb: '808123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[3-689]1\\d{5}'))
		},
			{
			nb: '801123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[12]1\\d{5}'))
		},
			{
			nb: '983123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('98[23]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEC = {
	eO: '593',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}')),
	w: 'EC',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '22123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[2-7][2-7]\\d{6}'))
		},
			{
			nb: '991234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}'))
		},
			{
			nb: '18001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1800\\d{7}|1[78]00\\d{6}'))
		},
			{
			nb: '28901234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[2-7]890\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEE = {
	eO: '372',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}')),
	w: 'EE',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800[2-9]\\d{3}'))
		},
			{
			nb: '3212345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}'))
		},
			{
			nb: '51234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5(?:[0-35-9]\\d{6}|4(?:[0-57-9]\\d{5}|6(?:[0-24-9]\\d{4}|3(?:[0-35-9]\\d{3}|4000))))|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:23|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[24-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9]|8[2-4])\\d|7(?:[679]\\d|8[13-9]))\\d)|[349]\\d{4})\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}'))
		},
			{
			nb: '9001234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:40\\d\\d|900)\\d{4}'))
		},
			{
			nb: '70012345',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70[0-2]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEG = {
	eO: '20',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}')),
	w: 'EG',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '234567890',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}'))
		},
			{
			nb: '1001234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1[0-25]\\d{8}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7}'))
		},
			{
			nb: '9001234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEH = {
	eO: '212',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[5-8]\\d{8}')),
	w: 'EH',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '528812345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('528[89]\\d{5}'))
		},
			{
			nb: '650123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[016-8]|6[1267]|7[0-27]))\\d{6}'))
		},
			{
			nb: '801234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{7}'))
		},
			{
			nb: '891234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('89\\d{7}'))
		},
			{
			nb: '592401234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('592(?:4[0-2]|93)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryER = {
	eO: '291',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[178]\\d{6}')),
	w: 'ER',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '8370362',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}'))
		},
			{
			nb: '7123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:17[1-3]|7\\d\\d)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryES = {
	eO: '34',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[5-9]\\d{8}')),
	w: 'ES',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '810123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}'))
		},
			{
			nb: '612345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[89]00\\d{6}'))
		},
			{
			nb: '803123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[367]\\d{6}'))
		},
			{
			nb: '901123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[12]\\d{6}'))
		},
			{
			nb: '701234567',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70\\d{7}'))
		},
			{
			nb: '511234567',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('51\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFI = {
	eO: '358',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}')),
	w: 'FI',
	ki: $elm$core$Maybe$Just('00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}'))
		},
			{
			nb: '131234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}'))
		},
			{
			nb: '412345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:4[0-8]|50)\\d{4,8}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{4,6}'))
		},
			{
			nb: '600123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[67]00\\d{5,6}'))
		},
			{
			nb: '10112345',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFJ = {
	eO: '679',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('45\\d{5}|(?:0800\\d|[235-9])\\d{6}')),
	w: 'FJ',
	ki: $elm$core$Maybe$Just('0(?:0|52)'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '3212345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}'))
		},
			{
			nb: '7012345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[279]\\d|45|5[01568]|8[034679])\\d{5}'))
		},
			{
			nb: '08001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('0800\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFK = {
	eO: '500',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-7]\\d{4}')),
	w: 'FK',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '31234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[2-47]\\d{4}'))
		},
			{
			nb: '51234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[56]\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFM = {
	eO: '691',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[39]\\d\\d|820)\\d{4}')),
	w: 'FM',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '3201234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}'))
		},
			{
			nb: '3501234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFO = {
	eO: '298',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[2-8]\\d|90)\\d{4}')),
	w: 'FO',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '201234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:20|[34]\\d|8[19])\\d{4}'))
		},
			{
			nb: '211234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[27][1-9]|5\\d)\\d{4}'))
		},
			{
			nb: '802123',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[257-9]\\d{3}'))
		},
			{
			nb: '901123',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d'))
		},
			{
			nb: '601234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:6[0-36]|88)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFR = {
	eO: '33',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[1-9]\\d{8}')),
	w: 'FR',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '123456789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[1-35]\\d|4[1-9])\\d{7}'))
		},
			{
			nb: '612345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('700\\d{6}|(?:6\\d|7[3-9])\\d{7}'))
		},
			{
			nb: '801234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[0-5]\\d{6}'))
		},
			{
			nb: '891123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}'))
		},
			{
			nb: '884012345',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:1[01]|2[0156]|84)\\d{6}'))
		},
			{
			nb: '912345678',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9\\d{8}'))
		},
			{
			nb: '806123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[6-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGA = {
	eO: '241',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}')),
	w: 'GA',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '01441234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[01]1\\d{6}'))
		},
			{
			nb: '06031234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:0[2-7]|6[256]|7[47])\\d{6}|[2-7]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGD = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:473|[58]\\d\\d|900)\\d{7}')),
	w: 'GD',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '4732691234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}'))
		},
			{
			nb: '4734031234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGE = {
	eO: '995',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[3-57]\\d\\d|800)\\d{6}')),
	w: 'GE',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70[67]\\d{6}'))
		},
			{
			nb: '322123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}'))
		},
			{
			nb: '555123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5(?:0(?:0(?:0\\d|50)\\d|555[5-9])|(?:111\\d|8(?:58[89]|888))\\d|(?:2222|3333)[0-4]|52(?:00\\d|22[0-4])|75(?:00\\d|7(?:7[7-9]|8[01])))\\d{3}|(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6}'))
		},
			{
			nb: '706123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70[67]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGF = {
	eO: '594',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[56]94|976)\\d{6}')),
	w: 'GF',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '594101234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('594(?:[023]\\d|1[01]|4[03-9]|5[6-9]|6[0-3]|80|9[014])\\d{4}'))
		},
			{
			nb: '694201234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('694(?:[0-249]\\d|3[0-48])\\d{4}'))
		},
			{
			nb: '976012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('976\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGG = {
	eO: '44',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?')),
	w: 'GG',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '1481256789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1481[25-9]\\d{5}'))
		},
			{
			nb: '7781123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7(?:(?:781|839)\\d|911[17])\\d{5}'))
		},
			{
			nb: '7640123456',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[08]\\d{7}|800\\d{6}|8001111'))
		},
			{
			nb: '9012345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d'))
		},
			{
			nb: '7012345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70\\d{8}'))
		},
			{
			nb: '5612345678',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('56\\d{8}'))
		},
			{
			nb: '5512345678',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3[0347]|55)\\d{8}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGH = {
	eO: '233',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[235]\\d{3}|800)\\d{5}')),
	w: 'GH',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{5}'))
		},
			{
			nb: '302345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}'))
		},
			{
			nb: '231234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2[0346-8]\\d|5(?:[0457]\\d|6[01]|9[1-6]))\\d{6}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGI = {
	eO: '350',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[256]\\d{7}')),
	w: 'GI',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '20012345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('21(?:6[24-7]\\d|90[0-2])\\d{3}|2(?:00|2[25])\\d{5}'))
		},
			{
			nb: '57123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:5[146-8]\\d|6(?:06|29))\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGL = {
	eO: '299',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:19|[2-689]\\d)\\d{4}')),
	w: 'GL',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '321000',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:19|3[1-7]|6[14689]|8[14-79]|9\\d)\\d{4}'))
		},
			{
			nb: '221234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[245]\\d{5}'))
		},
			{
			nb: '801234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{4}'))
		},
			{
			nb: '381234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3[89]\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGM = {
	eO: '220',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-9]\\d{6}')),
	w: 'GM',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '5661234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}'))
		},
			{
			nb: '3012345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[23679]\\d|5[0-389])\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGN = {
	eO: '224',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('722\\d{6}|(?:3|6\\d)\\d{7}')),
	w: 'GN',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '30241234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}'))
		},
			{
			nb: '601123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6[02356]\\d{7}'))
		},
			{
			nb: '722123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('722\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGP = {
	eO: '590',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:590|69\\d|976)\\d{6}')),
	w: 'GP',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '590201234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}'))
		},
			{
			nb: '690001234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}'))
		},
			{
			nb: '976012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('976[01]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGQ = {
	eO: '240',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('222\\d{6}|(?:3\\d|55|[89]0)\\d{7}')),
	w: 'GQ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '333091234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}'))
		},
			{
			nb: '222123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:222|55[015])\\d{6}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d[1-9]\\d{5}'))
		},
			{
			nb: '900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90\\d[1-9]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGR = {
	eO: '30',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('5005000\\d{3}|(?:[2689]\\d|70)\\d{8}')),
	w: 'GR',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '2123456789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}'))
		},
			{
			nb: '6912345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('68[57-9]\\d{7}|(?:69|94)\\d{8}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7}'))
		},
			{
			nb: '9091234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[19]\\d{7}'))
		},
			{
			nb: '8011234567',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:0[16]|12|[27]5|50)\\d{7}'))
		},
			{
			nb: '7012345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70\\d{8}'))
		},
			{
			nb: '5005000123',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5005000\\d{3}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGT = {
	eO: '502',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:1\\d{3}|[2-7])\\d{7}')),
	w: 'GT',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '22456789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[267][2-9]\\d{6}'))
		},
			{
			nb: '51234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[3-5]\\d{7}'))
		},
			{
			nb: '18001112222',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('18[01]\\d{8}'))
		},
			{
			nb: '19001112222',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('19\\d{9}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGU = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[58]\\d\\d|671|900)\\d{7}')),
	w: 'GU',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '6713001234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}'))
		},
			{
			nb: '6713001234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGW = {
	eO: '245',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[49]\\d{8}|4\\d{6}')),
	w: 'GW',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '443201234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('443\\d{6}'))
		},
			{
			nb: '955012345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:5\\d|6[569]|77)\\d{6}'))
		},
			{
			nb: '4012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('40\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGY = {
	eO: '592',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}')),
	w: 'GY',
	ki: $elm$core$Maybe$Just('001'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '2201234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}'))
		},
			{
			nb: '6091234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6\\d{6}'))
		},
			{
			nb: '2891234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:289|862)\\d{4}'))
		},
			{
			nb: '9008123',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9008\\d{3}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHK = {
	eO: '852',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}')),
	w: 'HK',
	ki: $elm$core$Maybe$Just('00(?:30|5[09]|[126-9]?)'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '21234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:384[0-5]|58(?:0[1-8]|1[2-9]))\\d{4}|(?:2(?:[13-9]\\d|2[013-9])|3(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69]|89))\\d{5}'))
		},
			{
			nb: '51234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:46(?:[01][0-6]|4[0-57-9])|5730|626[01]|707[1-5]|848[015-9]|929[03-9])\\d{4}|(?:462|5(?:[1-59][0-46-9]|6[0-4689]|7[0-2469])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}'))
		},
			{
			nb: '71123456',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6}'))
		},
			{
			nb: '90012345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900(?:[0-24-9]\\d{7}|3\\d{1,4})'))
		},
			{
			nb: '81123456',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}'))
		},
			{
			nb: '30161234',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHN = {
	eO: '504',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('8\\d{10}|[237-9]\\d{7}')),
	w: 'HN',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8002\\d{7}'))
		},
			{
			nb: '22123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:2(?:0[0139]|1[1-36]|[23]\\d|4[04-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[78]|2[3-59]|3[13-689]|4[0-68]|5[1-35])|5(?:0[7-9]|16|4[03-5]|5\\d|6[014-6]|74|80)|6(?:[056]\\d|17|2[07]|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}'))
		},
			{
			nb: '91234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[37-9]\\d{7}'))
		},
			{
			nb: '80021234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8002\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHR = {
	eO: '385',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}')),
	w: 'HR',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '12345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}'))
		},
			{
			nb: '921234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:751\\d{5}|8\\d{6,7})|9(?:0[1-9]|[1259]\\d|7[0679])\\d{6}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[01]\\d{4,6}'))
		},
			{
			nb: '611234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6[01459]\\d{6}|6[01]\\d{4,5}'))
		},
			{
			nb: '74123456',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[45]\\d{6}'))
		},
			{
			nb: '62123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('62\\d{6,7}|72\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHT = {
	eO: '509',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-489]\\d{7}')),
	w: 'HT',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '22453300',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:2\\d|5[1-5]|81|9[149])\\d{5}'))
		},
			{
			nb: '34101234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[34]\\d{7}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8\\d{7}'))
		},
			{
			nb: '98901234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHU = {
	eO: '36',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[235-7]\\d{8}|[1-9]\\d{7}')),
	w: 'HU',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('06'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[48]0\\d|6802)\\d{5}'))
		},
			{
			nb: '12345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}'))
		},
			{
			nb: '201234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[257]0|3[01])\\d{7}'))
		},
			{
			nb: '80123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[48]0\\d|6802)\\d{5}'))
		},
			{
			nb: '90123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9[01]\\d{6}'))
		},
			{
			nb: '211234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('21\\d{7}'))
		},
			{
			nb: '381234567',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('38\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryID = {
	eO: '62',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:(?:007803|8\\d{4})\\d|[1-36])\\d{6}|[1-9]\\d{8,10}|[2-9]\\d{7}')),
	w: 'ID',
	ki: $elm$core$Maybe$Just('00[189]'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:007803\\d|8071)\\d{6}'))
		},
			{
			nb: '218350123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}'))
		},
			{
			nb: '812345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8[1-35-9]\\d{7,10}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('007803\\d{7}|(?:177\\d|800)\\d{5,7}'))
		},
			{
			nb: '8091234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('809\\d{7}'))
		},
			{
			nb: '8041234567',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('804\\d{7}'))
		},
			{
			nb: '8071123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1500|8071\\d{3})\\d{3}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIE = {
	eO: '353',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}')),
	w: 'IE',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('18[59]0\\d{6}'))
		},
			{
			nb: '2212345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}'))
		},
			{
			nb: '850123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:22|[35-9]\\d)\\d{6}'))
		},
			{
			nb: '1800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1800\\d{6}'))
		},
			{
			nb: '1520123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('15(?:1[2-8]|[2-8]0|9[089])\\d{6}'))
		},
			{
			nb: '1850123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('18[59]0\\d{6}'))
		},
			{
			nb: '700123456',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('700\\d{6}'))
		},
			{
			nb: '761234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('76\\d{7}'))
		},
			{
			nb: '818123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('818\\d{6}'))
		},
			{
			nb: '8551234567',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIL = {
	eO: '972',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}')),
	w: 'IL',
	ki: $elm$core$Maybe$Just('0(?:0|1[2-9])'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1700\\d{6}'))
		},
			{
			nb: '21234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}'))
		},
			{
			nb: '502345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-8]|3[23]|44|5[05689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}'))
		},
			{
			nb: '1800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1(?:255|80[019]\\d{3})\\d{3}'))
		},
			{
			nb: '1919123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1212\\d{4}|1(?:200|9(?:0[01]|19))\\d{6}'))
		},
			{
			nb: '1700123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1700\\d{6}'))
		},
			{
			nb: '771234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('78(?:33|55|77|81)\\d{5}|7(?:18|2[23]|3[237]|47|6[58]|7\\d|82|9[235-9])\\d{6}'))
		},
			{
			nb: '1599123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1599\\d{6}'))
		},
			{
			nb: '15112340000',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('151\\d{8,9}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIM = {
	eO: '44',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1624\\d{6}|(?:[3578]\\d|90)\\d{8}')),
	w: 'IM',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '1624756789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1624[5-8]\\d{5}'))
		},
			{
			nb: '7924123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}'))
		},
			{
			nb: '8081624567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('808162\\d{4}'))
		},
			{
			nb: '9016247890',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}'))
		},
			{
			nb: '7012345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70\\d{8}'))
		},
			{
			nb: '5612345678',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('56\\d{8}'))
		},
			{
			nb: '5512345678',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIN = {
	eO: '91',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}')),
	w: 'IN',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}'))
		},
			{
			nb: '7410410123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}'))
		},
			{
			nb: '8123456789',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}'))
		},
			{
			nb: '1800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))'))
		},
			{
			nb: '1861123456789',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('186[12]\\d{9}'))
		},
			{
			nb: '18603451234',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1860\\d{7}'))
		},
			{
			nb: '1409305260',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('140\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIO = {
	eO: '246',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('3\\d{6}')),
	w: 'IO',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '3709100',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('37\\d{5}'))
		},
			{
			nb: '3801234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('38\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIQ = {
	eO: '964',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}')),
	w: 'IQ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '12345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}'))
		},
			{
			nb: '7912345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[3-9]\\d{8}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIR = {
	eO: '98',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}')),
	w: 'IR',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))'))
		},
			{
			nb: '2123456789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}'))
		},
			{
			nb: '9123456789',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:(?:0(?:[1-35]\\d|4[4-6])|(?:[13]\\d|2[0-2])\\d)\\d|9(?:(?:[0-2]\\d|3[01]|4[45])\\d|5[15]0|8(?:1\\d|88)|9(?:0[013]|1\\d|21|77|9[6-9])))\\d{5}'))
		},
			{
			nb: '9932123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('993[2-9]\\d{6}'))
		},
			{
			nb: '9601',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIS = {
	eO: '354',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:38\\d|[4-9])\\d{6}')),
	w: 'IS',
	ki: $elm$core$Maybe$Just('00|1(?:0(?:01|[12]0)|100)'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '4101234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}'))
		},
			{
			nb: '6111234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[28]))\\d{4}'))
		},
			{
			nb: '8001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[08]\\d{4}'))
		},
			{
			nb: '9001234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}'))
		},
			{
			nb: '4921234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('49[0-24-79]\\d{4}'))
		},
			{
			nb: '8091234',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('809\\d{4}'))
		},
			{
			nb: '6891234',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:689|8(?:7[18]|80)|95[48])\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIT = {
	eO: '39',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}')),
	w: 'IT',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('848\\d{6}'))
		},
			{
			nb: '0212345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}'))
		},
			{
			nb: '3123456789',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3[1-9]\\d{8}|3[2-9]\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80(?:0\\d{3}|3)\\d{3}'))
		},
			{
			nb: '899123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}'))
		},
			{
			nb: '848123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('84(?:[08]\\d{3}|[17])\\d{3}'))
		},
			{
			nb: '1781234567',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1(?:78\\d|99)\\d{6}'))
		},
			{
			nb: '5512345678',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('55\\d{8}'))
		},
			{
			nb: '33101234501',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3[2-8]\\d{9,10}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJE = {
	eO: '44',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1534\\d{6}|(?:[3578]\\d|90)\\d{8}')),
	w: 'JE',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '1534456789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1534[0-24-8]\\d{5}'))
		},
			{
			nb: '7797712345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}'))
		},
			{
			nb: '7640123456',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}'))
		},
			{
			nb: '8007354567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80(?:07(?:35|81)|8901)\\d{4}'))
		},
			{
			nb: '9018105678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}'))
		},
			{
			nb: '7015115678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('701511\\d{4}'))
		},
			{
			nb: '5612345678',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('56\\d{8}'))
		},
			{
			nb: '5512345678',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJM = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[58]\\d\\d|658|900)\\d{7}')),
	w: 'JM',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '8765230123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:5(?:02|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}'))
		},
			{
			nb: '8762101234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:658295|876(?:2(?:[14-9]\\d|2[013-9]|3[7-9])|[348]\\d\\d|5(?:0[13-9]|1[579]|[2-57-9]\\d|6[0-24-9])|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJO = {
	eO: '962',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}')),
	w: 'JO',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '62001234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-467]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}'))
		},
			{
			nb: '790123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7(?:[78][0-25-9]|9\\d)\\d{6}'))
		},
			{
			nb: '746612345',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('74(?:66|77)\\d{5}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{6}'))
		},
			{
			nb: '90012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9\\d{7}'))
		},
			{
			nb: '85012345',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('85\\d{6}'))
		},
			{
			nb: '700123456',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70\\d{7}'))
		},
			{
			nb: '88101234',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:10|8\\d)\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJP = {
	eO: '81',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}')),
	w: 'JP',
	ki: $elm$core$Maybe$Just('010'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66)\\d{6,13}'))
		},
			{
			nb: '312345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}'))
		},
			{
			nb: '9012345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[7-9]0[1-9]\\d{7}'))
		},
			{
			nb: '2012345678',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('20\\d{8}'))
		},
			{
			nb: '120123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('00(?:(?:37|66)\\d{6,13}|(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d)|(?:120|800\\d)\\d{6}'))
		},
			{
			nb: '990123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('990\\d{6}'))
		},
			{
			nb: '601234567',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('60\\d{7}'))
		},
			{
			nb: '5012345678',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('50[1-9]\\d{7}'))
		},
			{
			nb: '570123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('570\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKE = {
	eO: '254',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}')),
	w: 'KE',
	ki: $elm$core$Maybe$Just('000'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '202012345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}'))
		},
			{
			nb: '712123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:0[0-2]|1[0-5])|7\\d\\d)\\d{6}'))
		},
			{
			nb: '800223456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800[24-8]\\d{5,6}'))
		},
			{
			nb: '900223456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[02-9]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKG = {
	eO: '996',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('8\\d{9}|(?:[235-8]\\d|99)\\d{7}')),
	w: 'KG',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '312123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}'))
		},
			{
			nb: '700123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:312(?:58\\d|973)|8801\\d\\d)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|7(?:[07]\\d|55)|99[05-9])\\d{6}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6,7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKH = {
	eO: '855',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1\\d{9}|[1-9]\\d{7,8}')),
	w: 'KH',
	ki: $elm$core$Maybe$Just('00[14-9]'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '23756789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})'))
		},
			{
			nb: '91234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}'))
		},
			{
			nb: '1800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1800(?:1\\d|2[019])\\d{4}'))
		},
			{
			nb: '1900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1900(?:1\\d|2[09])\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKI = {
	eO: '686',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}')),
	w: 'KI',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '31234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}'))
		},
			{
			nb: '72001234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:63\\d{3}|73(?:0[0-5]\\d|140))\\d{3}|[67]200[01]\\d{3}'))
		},
			{
			nb: '30010000',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('30(?:0[01]\\d\\d|12(?:11|20))\\d\\d'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKM = {
	eO: '269',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[3478]\\d{6}')),
	w: 'KM',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '7712345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[4-7]\\d{5}'))
		},
			{
			nb: '3212345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[34]\\d{6}'))
		},
			{
			nb: '8001234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKN = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[58]\\d\\d|900)\\d{7}')),
	w: 'KN',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '8692361234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}'))
		},
			{
			nb: '8697652917',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKP = {
	eO: '850',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('85\\d{6}|(?:19\\d|[2-7])\\d{7}')),
	w: 'KP',
	ki: $elm$core$Maybe$Just('00|99'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}'))
		},
			{
			nb: '21234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}'))
		},
			{
			nb: '1921234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('19[1-3]\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKR = {
	eO: '82',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}')),
	w: 'KR',
	ki: $elm$core$Maybe$Just('00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})'))
		},
			{
			nb: '22123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}'))
		},
			{
			nb: '1020000000',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}'))
		},
			{
			nb: '1523456789',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('15\\d{7,8}'))
		},
			{
			nb: '801234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}'))
		},
			{
			nb: '602345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('60[2-9]\\d{6}'))
		},
			{
			nb: '5012345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('50\\d{8,9}'))
		},
			{
			nb: '7012345678',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70\\d{8}'))
		},
			{
			nb: '15441234',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKW = {
	eO: '965',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:18|[2569]\\d\\d)\\d{5}')),
	w: 'KW',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '22345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}'))
		},
			{
			nb: '50012345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:5(?:2(?:22|5[25])|88[58])|6(?:222|444|70[013-9]|888|93[039])|9(?:11[01]|333|500))\\d{4}|(?:5(?:[05]\\d|1[0-7]|6[56])|6(?:0[034679]|5[015-9]|6\\d|7[67]|9[069])|9(?:0[09]|22|[4679]\\d|55|8[057-9]))\\d{5}'))
		},
			{
			nb: '1801234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('18\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKY = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:345|[58]\\d\\d|900)\\d{7}')),
	w: 'KY',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '3452221234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}'))
		},
			{
			nb: '3453231234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}'))
		},
			{
			nb: '3458491234',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('345849\\d{4}'))
		},
			{
			nb: '8002345678',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:345976|900[2-9]\\d\\d)\\d{4}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKZ = {
	eO: '7',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('33622\\d{5}|(?:7\\d|80)\\d{8}')),
	w: 'KZ',
	ki: $elm$core$Maybe$Just('810'),
	oo: $elm$core$Maybe$Just('8'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('751\\d{7}'))
		},
			{
			nb: '7123456789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}'))
		},
			{
			nb: '7710009998',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7(?:0[0-25-8]|47|6[02-4]|7[15-8]|85)\\d{7}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7}'))
		},
			{
			nb: '8091234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('809\\d{7}'))
		},
			{
			nb: '8081234567',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('808\\d{7}'))
		},
			{
			nb: '7511234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('751\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLA = {
	eO: '856',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}')),
	w: 'LA',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '21212862',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2[13]|[35-7][14]|41|8[1468])\\d{6}'))
		},
			{
			nb: '2023123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:20(?:[239]\\d|5[24-9]|7[6-8])|302\\d)\\d{6}'))
		},
			{
			nb: '301234567',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('30[013-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLB = {
	eO: '961',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[7-9]\\d{7}|[13-9]\\d{6}')),
	w: 'LB',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '1123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:[14-69]\\d|8[02-9])\\d|7(?:[2-57]\\d|62|8[0-7]|9[04-9]))\\d{4}'))
		},
			{
			nb: '71123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}'))
		},
			{
			nb: '90123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9[01]\\d{6}'))
		},
			{
			nb: '80123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLC = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[58]\\d\\d|758|900)\\d{7}')),
	w: 'LC',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '7584305678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}'))
		},
			{
			nb: '7582845678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLI = {
	eO: '423',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}')),
	w: 'LI',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '2345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}'))
		},
			{
			nb: '660234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:6(?:4(?:79|[89]\\d)|5[0-4]\\d|6(?:0\\d|10|2[0-26-9]|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}'))
		},
			{
			nb: '8002222',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80(?:02[28]|9\\d\\d)\\d\\d'))
		},
			{
			nb: '9002222',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d'))
		},
			{
			nb: '8702812',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('870(?:28|87)\\d\\d'))
		},
			{
			nb: '697861234',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('697(?:42|56|[78]\\d)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLK = {
	eO: '94',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[1-9]\\d{8}')),
	w: 'LK',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '112345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}'))
		},
			{
			nb: '712345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[0-25-8]\\d{7}'))
		},
			{
			nb: '197312345',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1973\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLR = {
	eO: '231',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}')),
	w: 'LR',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '21234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2\\d{3}|33333)\\d{4}'))
		},
			{
			nb: '770123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:330|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}'))
		},
			{
			nb: '332021234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('332(?:02|[34]\\d)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLS = {
	eO: '266',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[256]\\d\\d|800)\\d{5}')),
	w: 'LS',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '22123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2\\d{7}'))
		},
			{
			nb: '50123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[56]\\d{7}'))
		},
			{
			nb: '80021234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800[256]\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLT = {
	eO: '370',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[3469]\\d|52|[78]0)\\d{6}')),
	w: 'LT',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('8'),
	kO: _List_fromArray(
		[
			{
			nb: '31234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3[1478]|4[124-6]|52)\\d{6}'))
		},
			{
			nb: '61234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6\\d{7}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[02]\\d{5}'))
		},
			{
			nb: '90012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:0[0239]|10)\\d{5}'))
		},
			{
			nb: '80812345',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('808\\d{5}'))
		},
			{
			nb: '70012345',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70[05]\\d{5}'))
		},
			{
			nb: '80123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[89]01\\d{5}'))
		},
			{
			nb: '70712345',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70[67]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLU = {
	eO: '352',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}')),
	w: 'LU',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '27123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}'))
		},
			{
			nb: '628123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6(?:[269][18]|5[158]|7[189]|81)\\d{6}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{5}'))
		},
			{
			nb: '90012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[015]\\d{5}'))
		},
			{
			nb: '80112345',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('801\\d{5}'))
		},
			{
			nb: '20201234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('20(?:1\\d{5}|[2-689]\\d{1,7})'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLV = {
	eO: '371',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[268]\\d|90)\\d{6}')),
	w: 'LV',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '63123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6\\d{7}'))
		},
			{
			nb: '21234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2\\d{7}'))
		},
			{
			nb: '80123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{6}'))
		},
			{
			nb: '90123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90\\d{6}'))
		},
			{
			nb: '81123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('81\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLY = {
	eO: '218',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-9]\\d{8}')),
	w: 'LY',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '212345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}'))
		},
			{
			nb: '912345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9[1-6]\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMA = {
	eO: '212',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[5-8]\\d{8}')),
	w: 'MA',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '520123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}'))
		},
			{
			nb: '650123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[016-8]|6[1267]|7[0-27]))\\d{6}'))
		},
			{
			nb: '801234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{7}'))
		},
			{
			nb: '891234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('89\\d{7}'))
		},
			{
			nb: '592401234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('592(?:4[0-2]|93)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMC = {
	eO: '377',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('870\\d{5}|(?:[349]|6\\d)\\d{7}')),
	w: 'MC',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('870\\d{5}'))
		},
			{
			nb: '99123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:870|9[2-47-9]\\d)\\d{5}'))
		},
			{
			nb: '612345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}'))
		},
			{
			nb: '90123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMD = {
	eO: '373',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[235-7]\\d|[89]0)\\d{6}')),
	w: 'MD',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '22212345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}'))
		},
			{
			nb: '62112345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('562\\d{5}|(?:6\\d|7[16-9])\\d{6}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{5}'))
		},
			{
			nb: '90012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[056]\\d{5}'))
		},
			{
			nb: '80812345',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('808\\d{5}'))
		},
			{
			nb: '30123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3[08]\\d{6}'))
		},
			{
			nb: '80312345',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('803\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryME = {
	eO: '382',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}')),
	w: 'ME',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '30234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}'))
		},
			{
			nb: '67622901',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}'))
		},
			{
			nb: '80080002',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80(?:[0-2578]|9\\d)\\d{5}'))
		},
			{
			nb: '94515151',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:4[1568]|5[178])\\d{5}'))
		},
			{
			nb: '78108780',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('78[1-49]\\d{5}'))
		},
			{
			nb: '77273012',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('77[1-9]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMF = {
	eO: '590',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:590|69\\d|976)\\d{6}')),
	w: 'MF',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '590271234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}'))
		},
			{
			nb: '690001234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}'))
		},
			{
			nb: '976012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('976[01]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMG = {
	eO: '261',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[23]\\d{8}')),
	w: 'MG',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '202123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}'))
		},
			{
			nb: '321234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3[2-49]\\d{7}'))
		},
			{
			nb: '221234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('22\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMH = {
	eO: '692',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('329\\d{4}|(?:[256]\\d|45)\\d{5}')),
	w: 'MH',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '2471234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:247|528|625)\\d{4}'))
		},
			{
			nb: '2351234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:23|54)5|329|45[56])\\d{4}'))
		},
			{
			nb: '6351234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('635\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMK = {
	eO: '389',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-578]\\d{7}')),
	w: 'MK',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '22012345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:[23]\\d|5[0-24578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}'))
		},
			{
			nb: '72345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7(?:4(?:60\\d|747)|94(?:[01]\\d|2[0-4]))\\d{3}|7(?:[0-25-8]\\d|3[2-4]|42|9[23])\\d{5}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{5}'))
		},
			{
			nb: '50012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5[02-9]\\d{6}'))
		},
			{
			nb: '80123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:0[1-9]|[1-9]\\d)\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryML = {
	eO: '223',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[24-9]\\d{7}')),
	w: 'ML',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{6}'))
		},
			{
			nb: '20212345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}'))
		},
			{
			nb: '65012345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[239])\\d{6}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMM = {
	eO: '95',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}')),
	w: 'MM',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '1234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[2-469]|39|46|6[25]|7[0-3]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|2[246]|39|46|62|7[0-3]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[0-3])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|247[23]|3(?:20\\d|470)|4(?:2[04]\\d|47[23])|7(?:(?:3\\d|8[01459])\\d|4(?:39|60|7[013]))))\\d{4}|5(?:2(?:2\\d{5,6}|47[023]\\d{4})|(?:347[23]|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[0-2])|8(?:20\\d|47[02])|9(?:20\\d|47[01]))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:2\\d|4[1-9]|51)\\d|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}'))
		},
			{
			nb: '92123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}'))
		},
			{
			nb: '8008001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80080(?:[01][1-9]|2\\d)\\d{3}'))
		},
			{
			nb: '13331234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1333\\d{4}|[12]468\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMN = {
	eO: '976',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[12]\\d{7,9}|[57-9]\\d{7}')),
	w: 'MN',
	ki: $elm$core$Maybe$Just('001'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '53123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[12]2[1-3]\\d{5,6}|7(?:0[0-5]\\d|128)\\d{4}|(?:[12](?:1|27)|5[368])\\d{6}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}'))
		},
			{
			nb: '88123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:83[01]|920)\\d{5}|(?:5[05]|8[05689]|9[013-9])\\d{6}'))
		},
			{
			nb: '75123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('712[0-79]\\d{4}|7(?:1[013-9]|[5-8]\\d)\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMO = {
	eO: '853',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:28|[68]\\d)\\d{6}')),
	w: 'MO',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '28212345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}'))
		},
			{
			nb: '66123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:[02][5-9]|[146-8]\\d|[35][0-4]))\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMP = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[58]\\d{9}|(?:67|90)0\\d{7}')),
	w: 'MP',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '6702345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}'))
		},
			{
			nb: '6702345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMQ = {
	eO: '596',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('69\\d{7}|(?:59|97)6\\d{6}')),
	w: 'MQ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '596301234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('596(?:0[0-7]|10|2[7-9]|3[05-9]|4[0-46-8]|[5-7]\\d|8[09]|9[4-8])\\d{4}'))
		},
			{
			nb: '696201234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('69(?:6(?:[0-47-9]\\d|5[0-6]|6[0-4])|727)\\d{4}'))
		},
			{
			nb: '976612345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('976(?:6[1-9]|7[0-367])\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMR = {
	eO: '222',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[2-4]\\d\\d|800)\\d{5}')),
	w: 'MR',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '35123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:25[08]|35\\d|45[1-7])\\d{5}'))
		},
			{
			nb: '22123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[2-4][0-46-9]\\d{6}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMS = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[58]\\d\\d|664|900)\\d{7}')),
	w: 'MS',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '6644912345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6644(?:1[0-3]|91)\\d{4}'))
		},
			{
			nb: '6644923456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('664(?:3(?:49|9[1-6])|49[2-6])\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMT = {
	eO: '356',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}')),
	w: 'MT',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '21001234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:0(?:[19]\\d|3[1-4]|6[059])|[1-357]\\d\\d)\\d{4}'))
		},
			{
			nb: '96961234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}'))
		},
			{
			nb: '71171234',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7117\\d{4}'))
		},
			{
			nb: '80071234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800[3467]\\d{4}'))
		},
			{
			nb: '50037123',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}'))
		},
			{
			nb: '35501234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3550\\d{4}'))
		},
			{
			nb: '50112345',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('501\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMU = {
	eO: '230',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[2-468]|5\\d)\\d{6}')),
	w: 'MU',
	ki: $elm$core$Maybe$Just('0(?:0|[24-7]0|3[03])'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '54480123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-7])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}'))
		},
			{
			nb: '52512345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|5(?:2[589]|4[3-589]|7\\d|8[0-689]|9[0-8])\\d{5}'))
		},
			{
			nb: '8001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[0-2]\\d{4}'))
		},
			{
			nb: '3012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('30\\d{5}'))
		},
			{
			nb: '3201234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3(?:20|9\\d)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMV = {
	eO: '960',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}')),
	w: 'MV',
	ki: $elm$core$Maybe$Just('0(?:0|19)'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '6701234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024-68]|8[024689]))\\d{4}'))
		},
			{
			nb: '7712345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('46[46]\\d{4}|(?:7\\d|9[13-9])\\d{5}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7}'))
		},
			{
			nb: '9001234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900\\d{7}'))
		},
			{
			nb: '4001234',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4[05]0\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMW = {
	eO: '265',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}')),
	w: 'MW',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '1234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1[2-9]|21\\d\\d)\\d{5}'))
		},
			{
			nb: '991234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('111\\d{6}|(?:31|77|88|99)\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMX = {
	eO: '52',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}')),
	w: 'MX',
	ki: $elm$core$Maybe$Just('0[09]'),
	oo: $elm$core$Maybe$Just('01'),
	kO: _List_fromArray(
		[
			{
			nb: '2001234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:0[01]|2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}'))
		},
			{
			nb: '12221234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|88)\\d{7}'))
		},
			{
			nb: '9001234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900\\d{7}'))
		},
			{
			nb: '3001234567',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('300\\d{7}'))
		},
			{
			nb: '5001234567',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('500\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMY = {
	eO: '60',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1\\d{8,9}|(?:3\\d|[4-9])\\d{7}')),
	w: 'MY',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '323856789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}'))
		},
			{
			nb: '123456789',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1(?:4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[01]\\d|2[2-6]))|(?:(?:[269]|59)\\d|[37][1-9]|4[235-9])\\d|8(?:1[23]|[236]\\d|4[06]|5[7-9]|7[016-9]|8[01]|9[0-8]))\\d{5}'))
		},
			{
			nb: '1300123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1[378]00\\d{6}'))
		},
			{
			nb: '1600123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1600\\d{6}'))
		},
			{
			nb: '1546012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMZ = {
	eO: '258',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:2|8\\d)\\d{7}')),
	w: 'MZ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '21123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}'))
		},
			{
			nb: '821234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8[2-79]\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNA = {
	eO: '264',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[68]\\d{7,8}')),
	w: 'NA',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '61221234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}'))
		},
			{
			nb: '811234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:60|8[1245])\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{7}'))
		},
			{
			nb: '870123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8701\\d{5}'))
		},
			{
			nb: '88612345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:3\\d\\d|86)\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNC = {
	eO: '687',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-57-9]\\d{5}')),
	w: 'NC',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '201234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}'))
		},
			{
			nb: '751234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:5[0-4]|[79]\\d|8[0-79])\\d{4}'))
		},
			{
			nb: '366711',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('36\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNE = {
	eO: '227',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[027-9]\\d{7}')),
	w: 'NE',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '20201234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}'))
		},
			{
			nb: '93123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:23|7[04]|[89]\\d)\\d{6}'))
		},
			{
			nb: '08123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('08\\d{6}'))
		},
			{
			nb: '09123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('09\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNF = {
	eO: '672',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[13]\\d{5}')),
	w: 'NF',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '106609',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}'))
		},
			{
			nb: '381234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:14|3[58])\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNG = {
	eO: '234',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}')),
	w: 'NG',
	ki: $elm$core$Maybe$Just('009'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '18040123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}'))
		},
			{
			nb: '8021234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:702[0-24-9]|8(?:01|19)[01])\\d{6}|(?:70[13-689]|8(?:0[2-9]|1[0-8])|90[1-9])\\d{7}'))
		},
			{
			nb: '80017591759',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7,11}'))
		},
			{
			nb: '7001234567',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('700\\d{7,11}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNI = {
	eO: '505',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:1800|[25-8]\\d{3})\\d{4}')),
	w: 'NI',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '21234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2\\d{7}'))
		},
			{
			nb: '81234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}'))
		},
			{
			nb: '18001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1800\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNL = {
	eO: '31',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}')),
	w: 'NL',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d'))
		},
			{
			nb: '101234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}'))
		},
			{
			nb: '612345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6[1-58]\\d{7}'))
		},
			{
			nb: '662345678',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('66\\d{7}'))
		},
			{
			nb: '8001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{4,7}'))
		},
			{
			nb: '9061234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[069]\\d{4,7}'))
		},
			{
			nb: '851234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:85|91)\\d{7}'))
		},
			{
			nb: '14020',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNO = {
	eO: '47',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:0|[2-9]\\d{3})\\d{4}')),
	w: 'NO',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '21234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}'))
		},
			{
			nb: '40612345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:4[015-8]|5[89]|9\\d)\\d{6}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[01]\\d{5}'))
		},
			{
			nb: '82012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('82[09]\\d{5}'))
		},
			{
			nb: '81021234',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('810(?:0[0-6]|[2-8]\\d)\\d{3}'))
		},
			{
			nb: '88012345',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('880\\d{5}'))
		},
			{
			nb: '85012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('85[0-5]\\d{5}'))
		},
			{
			nb: '02000',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}'))
		},
			{
			nb: '81212345',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('81[23]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNP = {
	eO: '977',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('9\\d{9}|[1-9]\\d{7}')),
	w: 'NP',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '14567890',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}'))
		},
			{
			nb: '9841234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:6[0-3]|7[245]|8[0-24-68])\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNR = {
	eO: '674',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:444|(?:55|8\\d)\\d|666)\\d{4}')),
	w: 'NR',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '4441234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('444\\d{4}'))
		},
			{
			nb: '5551234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:55[3-9]|666|8\\d\\d)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNU = {
	eO: '683',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[47]|888\\d)\\d{3}')),
	w: 'NU',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '7012',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[47]\\d{3}'))
		},
			{
			nb: '8884012',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('888[4-9]\\d{3}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryOM = {
	eO: '968',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:1505|[279]\\d{3}|500)\\d{4}|8007\\d{4,5}')),
	w: 'OM',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '23123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2[2-6]\\d{6}'))
		},
			{
			nb: '92123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1505|90[1-9]\\d)\\d{4}|(?:7[1289]|9[1-9])\\d{6}'))
		},
			{
			nb: '80071234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('500\\d{4}|8007\\d{4,5}'))
		},
			{
			nb: '90012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPA = {
	eO: '507',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[1-57-9]|6\\d)\\d{6}')),
	w: 'PA',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '2001234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[258]|9[139])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[026-9])|3(?:[089]\\d|1[014-7]|2[0-5]|33|4[0-79]|55|6[068]|7[03-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[6-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}'))
		},
			{
			nb: '61234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1[16]1|21[89]|6(?:[02-9]\\d|1[0-6])\\d|8(?:1[01]|7[23]))\\d{4}'))
		},
			{
			nb: '8001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{4}'))
		},
			{
			nb: '8601234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPE = {
	eO: '51',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[14-8]|9\\d)\\d{7}')),
	w: 'PE',
	ki: $elm$core$Maybe$Just('19(?:1[124]|77|90)00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '11234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}'))
		},
			{
			nb: '912345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9\\d{8}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{5}'))
		},
			{
			nb: '80512345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('805\\d{5}'))
		},
			{
			nb: '80112345',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('801\\d{5}'))
		},
			{
			nb: '80212345',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[24]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPF = {
	eO: '689',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[48]\\d{7}|4\\d{5}')),
	w: 'PF',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('44\\d{4}'))
		},
			{
			nb: '40412345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4(?:0[4-689]|9[4-68])\\d{5}'))
		},
			{
			nb: '87123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8[7-9]\\d{6}'))
		},
			{
			nb: '49901234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('499\\d{5}'))
		},
			{
			nb: '440123',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('44\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPG = {
	eO: '675',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}')),
	w: 'PG',
	ki: $elm$core$Maybe$Just('00|140[1-3]'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '3123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:64[1-9]|7730|85[02-46-9])\\d{4}|(?:3[0-2]|4[257]|5[34]|77[0-24]|9[78])\\d{5}'))
		},
			{
			nb: '70123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('77(?:3[1-9]|[5-9]\\d)\\d{4}|(?:7[0-689]|81)\\d{6}'))
		},
			{
			nb: '2700123',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('27[01]\\d{4}'))
		},
			{
			nb: '1801234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('180\\d{4}'))
		},
			{
			nb: '2751234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:0[0-47]|7[568])\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPH = {
	eO: '63',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}')),
	w: 'PH',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '21234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|2\\d{5}(?:\\d{2})?|8[2-8]\\d{7}'))
		},
			{
			nb: '9051234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:81[37]|9(?:0[5-9]|1[0-24-9]|2[0-35-9]|[35]\\d|4[235-9]|6[0-35-8]|7[1-9]|8[189]|9[4-9]))\\d{7}'))
		},
			{
			nb: '180012345678',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1800\\d{7,9}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPK = {
	eO: '92',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}')),
	w: 'PK',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '2123456789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}'))
		},
			{
			nb: '3012345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{5}'))
		},
			{
			nb: '90012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900\\d{5}'))
		},
			{
			nb: '122044444',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('122\\d{6}'))
		},
			{
			nb: '21111825888',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPL = {
	eO: '48',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?')),
	w: 'PL',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '123456789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))'))
		},
			{
			nb: '512345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}'))
		},
			{
			nb: '641234567',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('64\\d{4,7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6,7}'))
		},
			{
			nb: '701234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70[01346-8]\\d{6}'))
		},
			{
			nb: '801234567',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('801\\d{6}'))
		},
			{
			nb: '391234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('39\\d{7}'))
		},
			{
			nb: '804123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('804\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPM = {
	eO: '508',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[45]\\d{5}')),
	w: 'PM',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '430123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:4[1-3]|50)\\d{4}'))
		},
			{
			nb: '551234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:4[02-4]|5[05])\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPR = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[589]\\d\\d|787)\\d{7}')),
	w: 'PR',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '7872345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:787|939)[2-9]\\d{6}'))
		},
			{
			nb: '7872345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:787|939)[2-9]\\d{6}'))
		},
			{
			nb: '8002345678',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPS = {
	eO: '970',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2489]2\\d{6}|(?:1\\d|5)\\d{8}')),
	w: 'PS',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '22234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}'))
		},
			{
			nb: '599123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5[69]\\d{7}'))
		},
			{
			nb: '1800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1800\\d{6}'))
		},
			{
			nb: '1700123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1700\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPW = {
	eO: '680',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[24-8]\\d\\d|345|900)\\d{4}')),
	w: 'PW',
	ki: $elm$core$Maybe$Just('01[12]'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '2771234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}'))
		},
			{
			nb: '6201234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:45[0-5]|6[2-4689]0|(?:77|88)\\d)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPY = {
	eO: '595',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('59\\d{4,6}|(?:[2-46-9]\\d|5[0-8])\\d{4,7}')),
	w: 'PY',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '212345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}'))
		},
			{
			nb: '961456789',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}'))
		},
			{
			nb: '870012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8700[0-4]\\d{4}'))
		},
			{
			nb: '201234567',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[2-9]0\\d{4,7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryQA = {
	eO: '974',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}')),
	w: 'QA',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '44123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:23|4[04])\\d{6}'))
		},
			{
			nb: '33123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:28|[35-7]\\d)\\d{6}'))
		},
			{
			nb: '2123456',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:[12]\\d|61)\\d{4}'))
		},
			{
			nb: '8001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRE = {
	eO: '262',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('9769\\d{5}|(?:26|[68]\\d)\\d{7}')),
	w: 'RE',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '262161234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('26(?:2\\d\\d|30[01])\\d{4}'))
		},
			{
			nb: '692123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[05]|6[0-36]|7[0-27]|8[0-8]|9[0-479]))|9769\\d)\\d{4}'))
		},
			{
			nb: '801234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{7}'))
		},
			{
			nb: '891123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('89[1-37-9]\\d{6}'))
		},
			{
			nb: '810123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:1[019]|2[0156]|84|90)\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRO = {
	eO: '40',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}')),
	w: 'RO',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '211234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d'))
		},
			{
			nb: '712034567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[01]20\\d{5}|7(?:0[013-9]|1[01]|[2-7]\\d|8[03-8]|9[09])\\d{6}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6}'))
		},
			{
			nb: '900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[0136]\\d{6}'))
		},
			{
			nb: '801123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('801\\d{6}'))
		},
			{
			nb: '372123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:37\\d|80[578])\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRS = {
	eO: '381',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}')),
	w: 'RS',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '10234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}'))
		},
			{
			nb: '601234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6(?:[0-689]|7\\d)\\d{6,7}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{3,9}'))
		},
			{
			nb: '90012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:78\\d|90[0169])\\d{3,7}'))
		},
			{
			nb: '700123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[06]\\d{4,10}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRU = {
	eO: '7',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[347-9]\\d{9}')),
	w: 'RU',
	ki: $elm$core$Maybe$Just('810'),
	oo: $elm$core$Maybe$Just('8'),
	kO: _List_fromArray(
		[
			{
			nb: '3011234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}'))
		},
			{
			nb: '9123456789',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9\\d{9}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[04]\\d{7}'))
		},
			{
			nb: '8091234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[39]\\d{7}'))
		},
			{
			nb: '8081234567',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('808\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRW = {
	eO: '250',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:06|[27]\\d\\d|[89]00)\\d{6}')),
	w: 'RW',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '250123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:06|2[23568]\\d)\\d{6}'))
		},
			{
			nb: '720123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[238]\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6}'))
		},
			{
			nb: '900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySA = {
	eO: '966',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('92\\d{7}|(?:[15]|8\\d)\\d{8}')),
	w: 'SA',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '112345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}'))
		},
			{
			nb: '512345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5(?:[013-689]\\d|7[0-36-8])\\d{6}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7}'))
		},
			{
			nb: '925012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('925\\d{6}'))
		},
			{
			nb: '920012345',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('920\\d{6}'))
		},
			{
			nb: '8110123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('811\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySB = {
	eO: '677',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[1-6]|[7-9]\\d\\d)\\d{4}')),
	w: 'SB',
	ki: $elm$core$Maybe$Just('0[01]'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '40123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}'))
		},
			{
			nb: '7421234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}'))
		},
			{
			nb: '18123',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1[38]\\d{3}'))
		},
			{
			nb: '51123',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5[12]\\d{3}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySC = {
	eO: '248',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('8000\\d{3}|(?:[249]\\d|64)\\d{5}')),
	w: 'SC',
	ki: $elm$core$Maybe$Just('010|0[0-2]'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '4217123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4[2-46]\\d{5}'))
		},
			{
			nb: '2510123',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2[5-8]\\d{5}'))
		},
			{
			nb: '8000000',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8000\\d{3}'))
		},
			{
			nb: '6412345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('971\\d{4}|(?:64|95)\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySD = {
	eO: '249',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[19]\\d{8}')),
	w: 'SD',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '153123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1(?:5\\d|8[35-7])\\d{6}'))
		},
			{
			nb: '911231234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1[0-2]|9[0-3569])\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySE = {
	eO: '46',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}')),
	w: 'SE',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '8123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}'))
		},
			{
			nb: '701234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[02369]\\d{7}'))
		},
			{
			nb: '740123456',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('74[02-9]\\d{6}'))
		},
			{
			nb: '20123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('20\\d{4,7}'))
		},
			{
			nb: '9001234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}'))
		},
			{
			nb: '771234567',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('77[0-7]\\d{6}'))
		},
			{
			nb: '751234567',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('75[1-8]\\d{6}'))
		},
			{
			nb: '102345678',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('10[1-8]\\d{6}'))
		},
			{
			nb: '254123456789',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:25[245]|67[3-68])\\d{9}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySG = {
	eO: '65',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}')),
	w: 'SG',
	ki: $elm$core$Maybe$Just('0[0-3]\\d'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '61234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('662[0-24-9]\\d{4}|6(?:[1-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}'))
		},
			{
			nb: '81234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:8(?:0(?:1[0-7]|3[01])|[1-8]\\d\\d|9(?:[0-24]\\d|3[0-489]|5[0-2]))|9[0-8]\\d\\d)\\d{4}'))
		},
			{
			nb: '18001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:18|8)00\\d{7}'))
		},
			{
			nb: '19001234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1900\\d{7}'))
		},
			{
			nb: '31234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3[12]\\d|666)\\d{5}'))
		},
			{
			nb: '70001234567',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7000\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySH = {
	eO: '290',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[256]\\d|8)\\d{3}')),
	w: 'SH',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '22158',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:[0-57-9]\\d|6[4-9])\\d\\d'))
		},
			{
			nb: '51234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[56]\\d{4}'))
		},
			{
			nb: '26212',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('262\\d\\d'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySI = {
	eO: '386',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}')),
	w: 'SI',
	ki: $elm$core$Maybe$Just('00|10(?:22|66|88|99)'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '12345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[1-357][2-8]|4[24-8])\\d{6}'))
		},
			{
			nb: '31234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}'))
		},
			{
			nb: '80123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{4,6}'))
		},
			{
			nb: '90123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('89[1-3]\\d{2,5}|90\\d{4,6}'))
		},
			{
			nb: '59012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-489])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySJ = {
	eO: '47',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('0\\d{4}|(?:[4589]\\d|79)\\d{6}')),
	w: 'SJ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '79123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('79\\d{6}'))
		},
			{
			nb: '41234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:4[015-8]|5[89]|9\\d)\\d{6}'))
		},
			{
			nb: '80012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[01]\\d{5}'))
		},
			{
			nb: '82012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('82[09]\\d{5}'))
		},
			{
			nb: '81021234',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('810(?:0[0-6]|[2-8]\\d)\\d{3}'))
		},
			{
			nb: '88012345',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('880\\d{5}'))
		},
			{
			nb: '85012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('85[0-5]\\d{5}'))
		},
			{
			nb: '02000',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}'))
		},
			{
			nb: '81212345',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('81[23]\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySK = {
	eO: '421',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}')),
	w: 'SK',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}'))
		},
			{
			nb: '221234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d'))
		},
			{
			nb: '912123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}'))
		},
			{
			nb: '9090123',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9090\\d{3}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6}'))
		},
			{
			nb: '900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:00|[78]\\d)\\d{6}'))
		},
			{
			nb: '850123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8[5-9]\\d{7}'))
		},
			{
			nb: '690123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6(?:02|5[0-4]|9[0-6])\\d{6}'))
		},
			{
			nb: '961234567',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('96\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySL = {
	eO: '232',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[2378]\\d|66|99)\\d{6}')),
	w: 'SL',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '22221234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('22[2-4][2-9]\\d{4}'))
		},
			{
			nb: '25123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:25|3[013-5]|66|7[4-9]|8[08]|99)\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySM = {
	eO: '378',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:0549|[5-7]\\d)\\d{6}')),
	w: 'SM',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '0549886377',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('0549(?:8[0157-9]|9\\d)\\d{4}'))
		},
			{
			nb: '66661212',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6[16]\\d{6}'))
		},
			{
			nb: '71123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[178]\\d{6}'))
		},
			{
			nb: '58001110',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('5[158]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySN = {
	eO: '221',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[378]\\d{4}|93330)\\d{4}')),
	w: 'SN',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '301012345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}'))
		},
			{
			nb: '701234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7(?:[06-8]\\d|21|90)\\d{6}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6}'))
		},
			{
			nb: '884123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('88[4689]\\d{6}'))
		},
			{
			nb: '810123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('81[02468]\\d{6}'))
		},
			{
			nb: '933301234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('93330\\d{4}|3(?:392|9[01]\\d)\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySO = {
	eO: '252',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}')),
	w: 'SO',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '4012345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}'))
		},
			{
			nb: '71123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('28\\d{5}|(?:6[1-9]|79)\\d{6,7}|(?:15|24|(?:3[59]|4[89]|8[08])\\d|60|7[1-8]|9(?:0\\d|[2-9]))\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySR = {
	eO: '597',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[2-5]|68|[78]\\d)\\d{5}')),
	w: 'SR',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '211234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}'))
		},
			{
			nb: '7412345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:7[124-7]|8[124-9])\\d{5}'))
		},
			{
			nb: '561234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('56\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySS = {
	eO: '211',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[19]\\d{8}')),
	w: 'SS',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '181234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1[89]\\d{7}'))
		},
			{
			nb: '977123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:12|9[12579])\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryST = {
	eO: '239',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:22|9\\d)\\d{5}')),
	w: 'ST',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '2221234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('22\\d{5}'))
		},
			{
			nb: '9812345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySV = {
	eO: '503',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?')),
	w: 'SV',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '21234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:[1-6]\\d{3}|[79]90[034]|890[0245])\\d{3}'))
		},
			{
			nb: '70123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}'))
		},
			{
			nb: '8001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{4}(?:\\d{4})?'))
		},
			{
			nb: '9001234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900\\d{4}(?:\\d{4})?'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySX = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}')),
	w: 'SX',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '7215425678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7215(?:4[2-8]|8[239]|9[056])\\d{4}'))
		},
			{
			nb: '7215205678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}'))
		},
			{
			nb: '8002123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySY = {
	eO: '963',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[1-39]\\d{8}|[1-5]\\d{7}')),
	w: 'SY',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '112345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}'))
		},
			{
			nb: '944567890',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9(?:22|[3-589]\\d|6[02-9])\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySZ = {
	eO: '268',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('0800\\d{4}|(?:[237]\\d|900)\\d{6}')),
	w: 'SZ',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('0800\\d{4}'))
		},
			{
			nb: '22171234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[23][2-5]\\d{6}'))
		},
			{
			nb: '76123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[6-9]\\d{6}'))
		},
			{
			nb: '08001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('0800\\d{4}'))
		},
			{
			nb: '900012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900\\d{6}'))
		},
			{
			nb: '70012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTA = {
	eO: '290',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('8\\d{3}')),
	w: 'TA',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '8999',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8\\d{3}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTC = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[58]\\d\\d|649|900)\\d{7}')),
	w: 'TC',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '6497121234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('649(?:266|712|9(?:4\\d|50))\\d{4}'))
		},
			{
			nb: '6492311234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}'))
		},
			{
			nb: '8002345678',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '6497101234',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('649(?:71[01]|966)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTD = {
	eO: '235',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:22|[69]\\d|77)\\d{6}')),
	w: 'TD',
	ki: $elm$core$Maybe$Just('00|16'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '22501234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('22(?:[37-9]0|5[0-5]|6[89])\\d{4}'))
		},
			{
			nb: '63012345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:6[023568]|77|9\\d)\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTG = {
	eO: '228',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[279]\\d{7}')),
	w: 'TG',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '22212345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}'))
		},
			{
			nb: '90112345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:7[09]|9[0-36-9])\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTH = {
	eO: '66',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}')),
	w: 'TH',
	ki: $elm$core$Maybe$Just('00[1-9]'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '21234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}'))
		},
			{
			nb: '812345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:14|6[1-6]|[89]\\d)\\d{7}'))
		},
			{
			nb: '1800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1800\\d{6}'))
		},
			{
			nb: '1900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1900\\d{6}'))
		},
			{
			nb: '601234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6[08]\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTJ = {
	eO: '992',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:00|11|[3-57-9]\\d)\\d{7}')),
	w: 'TJ',
	ki: $elm$core$Maybe$Just('810'),
	oo: $elm$core$Maybe$Just('8'),
	kO: _List_fromArray(
		[
			{
			nb: '372123456',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}'))
		},
			{
			nb: '917123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('41[18]\\d{6}|(?:[04]0|11|5[05]|7[07]|88|9\\d)\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTK = {
	eO: '690',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-47]\\d{3,6}')),
	w: 'TK',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '3101',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2[2-4]|[34]\\d)\\d{2,5}'))
		},
			{
			nb: '7290',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[2-4]\\d{2,5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTL = {
	eO: '670',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}')),
	w: 'TL',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '2112345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2[1-5]|3[1-9]|4[1-4])\\d{5}'))
		},
			{
			nb: '77212345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[2-8]\\d{6}'))
		},
			{
			nb: '8012345',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{5}'))
		},
			{
			nb: '9012345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90\\d{5}'))
		},
			{
			nb: '7012345',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTM = {
	eO: '993',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[1-6]\\d{7}')),
	w: 'TM',
	ki: $elm$core$Maybe$Just('810'),
	oo: $elm$core$Maybe$Just('8'),
	kO: _List_fromArray(
		[
			{
			nb: '12345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}'))
		},
			{
			nb: '66123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTN = {
	eO: '216',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-57-9]\\d{7}')),
	w: 'TN',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '30010123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}'))
		},
			{
			nb: '20123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}'))
		},
			{
			nb: '80101234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8010\\d{4}'))
		},
			{
			nb: '88123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('88\\d{6}'))
		},
			{
			nb: '81101234',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8[12]10\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTO = {
	eO: '676',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:0800|[5-8]\\d{3})\\d{3}|[2-8]\\d{4}')),
	w: 'TO',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '20123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}'))
		},
			{
			nb: '7715123',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6(?:3[02]|8[5-9])\\d{4}|(?:6[09]|7\\d|8[46-9])\\d{5}'))
		},
			{
			nb: '0800222',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('0800\\d{3}'))
		},
			{
			nb: '5501234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('55[04]\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTR = {
	eO: '90',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}')),
	w: 'TR',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('444\\d{4}'))
		},
			{
			nb: '2123456789',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}'))
		},
			{
			nb: '5012345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}'))
		},
			{
			nb: '5123456789',
			iv: 7,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('512\\d{7}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7}(?:\\d{2,3})?'))
		},
			{
			nb: '9001234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:8[89]8|900)\\d{7}'))
		},
			{
			nb: '5922121234',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('592(?:21[12]|461)\\d{4}'))
		},
			{
			nb: '8500123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('850\\d{7}'))
		},
			{
			nb: '4441444',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('444\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTT = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[58]\\d\\d|900)\\d{7}')),
	w: 'TT',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '8682211234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('868(?:2(?:0[13]|1[89]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}'))
		},
			{
			nb: '8682911234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('868(?:2(?:6[3-9]|[7-9]\\d)|(?:3\\d|4[6-9])\\d|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}'))
		},
			{
			nb: '8002345678',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '8686191234',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('868619\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTV = {
	eO: '688',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:2|7\\d\\d|90)\\d{4}')),
	w: 'TV',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '20123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2[02-9]\\d{3}'))
		},
			{
			nb: '901234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:7[01]\\d|90)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTW = {
	eO: '886',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}')),
	w: 'TW',
	ki: $elm$core$Maybe$Just('0(?:0[25-79]|19)'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '221234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}'))
		},
			{
			nb: '912345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:40001[0-2]|9[0-8]\\d{4})\\d{3}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[0-79]\\d{6}|800\\d{5}'))
		},
			{
			nb: '203123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('20(?:[013-9]\\d\\d|2)\\d{4}'))
		},
			{
			nb: '990123456',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('99\\d{7}'))
		},
			{
			nb: '7012345678',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}'))
		},
			{
			nb: '500123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('50[0-46-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTZ = {
	eO: '255',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[26-8]\\d|41|90)\\d{7}')),
	w: 'TZ',
	ki: $elm$core$Maybe$Just('00[056]'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:8(?:[04]0|6[01])|90\\d)\\d{6}'))
		},
			{
			nb: '222345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2[2-8]\\d{7}'))
		},
			{
			nb: '621234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('77[2-9]\\d{6}|(?:6[2-9]|7[13-689])\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[08]\\d{6}'))
		},
			{
			nb: '900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90\\d{7}'))
		},
			{
			nb: '840123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:40|6[01])\\d{6}'))
		},
			{
			nb: '412345678',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('41\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUA = {
	eO: '380',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[89]\\d{9}|[3-9]\\d{8}')),
	w: 'UA',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '311234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}'))
		},
			{
			nb: '501234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:50|6[36-8]|7[1-3]|9[1-9])\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800[1-8]\\d{5,6}'))
		},
			{
			nb: '900212345',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[239]\\d{5,6}'))
		},
			{
			nb: '891234567',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('89[1-579]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUG = {
	eO: '256',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('800\\d{6}|(?:[29]0|[347]\\d)\\d{7}')),
	w: 'UG',
	ki: $elm$core$Maybe$Just('00[057]'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '312345678',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('20(?:(?:(?:24|81)0|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[0147]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}'))
		},
			{
			nb: '712345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7260\\d{5}|7(?:[0157-9]\\d|20|36|4[0-4])\\d{6}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800[1-3]\\d{5}'))
		},
			{
			nb: '901123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[1-3]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUY = {
	eO: '598',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[249]\\d\\d|80)\\d{5}|9\\d{6}')),
	w: 'UY',
	ki: $elm$core$Maybe$Just('0(?:0|1[3-9]\\d)'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '21231234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2\\d|4[2-7])\\d{6}'))
		},
			{
			nb: '94231234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9[1-9]\\d{6}'))
		},
			{
			nb: '8001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[05]\\d{4}'))
		},
			{
			nb: '9001234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[0-8]\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUZ = {
	eO: '998',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('55501\\d{4}|(?:[679]\\d|88)\\d{7}')),
	w: 'UZ',
	ki: $elm$core$Maybe$Just('810'),
	oo: $elm$core$Maybe$Just('8'),
	kO: _List_fromArray(
		[
			{
			nb: '669050123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}'))
		},
			{
			nb: '912345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:55501|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07])))|(?:88|9[0-57-9])\\d{3})\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVA = {
	eO: '39',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}')),
	w: 'VA',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '0669812345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('06698\\d{1,6}'))
		},
			{
			nb: '3123456789',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3[1-9]\\d{8}|3[2-9]\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80(?:0\\d{3}|3)\\d{3}'))
		},
			{
			nb: '899123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}'))
		},
			{
			nb: '848123456',
			iv: 4,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('84(?:[08]\\d{3}|[17])\\d{3}'))
		},
			{
			nb: '1781234567',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1(?:78\\d|99)\\d{6}'))
		},
			{
			nb: '5512345678',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('55\\d{8}'))
		},
			{
			nb: '33101234501',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('3[2-8]\\d{9,10}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVC = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[58]\\d\\d|784|900)\\d{7}')),
	w: 'VC',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '7842661234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}'))
		},
			{
			nb: '7844301234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}'))
		},
			{
			nb: '8002345678',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVE = {
	eO: '58',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}')),
	w: 'VE',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '2121234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}'))
		},
			{
			nb: '4121234567',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4(?:1[24-8]|2[46])\\d{7}'))
		},
			{
			nb: '8001234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7}'))
		},
			{
			nb: '9001234567',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[01]\\d{7}'))
		},
			{
			nb: '5010123456',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('501\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVG = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:284|[58]\\d\\d|900)\\d{7}')),
	w: 'VG',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '2842291234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('284496[0-5]\\d{3}|284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}'))
		},
			{
			nb: '2843001234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('284496[6-9]\\d{3}|284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|5(?:4[0-7]|68|9[69]))\\d{4}'))
		},
			{
			nb: '8002345678',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVI = {
	eO: '1',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[58]\\d{9}|(?:34|90)0\\d{7}')),
	w: 'VI',
	ki: $elm$core$Maybe$Just('011'),
	oo: $elm$core$Maybe$Just('1'),
	kO: _List_fromArray(
		[
			{
			nb: '3406421234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('340(?:2(?:0[12]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}'))
		},
			{
			nb: '3406421234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('340(?:2(?:0[12]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}'))
		},
			{
			nb: '8002345678',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			nb: '9002345678',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			nb: '5002345678',
			iv: 5,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVN = {
	eO: '84',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}')),
	w: 'VN',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '',
			iv: 15,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[17]99\\d{4}|69\\d{5,6}'))
		},
			{
			nb: '2101234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|8[2-79]|9[0-4679])\\d{7}'))
		},
			{
			nb: '912345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:5(?:2[238]|59)|89[689]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}'))
		},
			{
			nb: '1800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1800\\d{4,6}|12(?:03|28)\\d{4}'))
		},
			{
			nb: '1900123456',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('1900\\d{4,6}'))
		},
			{
			nb: '672012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('672\\d{6}'))
		},
			{
			nb: '1992000',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[17]99|80\\d)\\d{4}|69\\d{5,6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVU = {
	eO: '678',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[23]\\d|[48]8)\\d{3}|(?:[57]\\d|90)\\d{5}')),
	w: 'VU',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '22123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}'))
		},
			{
			nb: '5912345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:5\\d|7[013-7])\\d{5}'))
		},
			{
			nb: '9010123',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[1-9]\\d{4}'))
		},
			{
			nb: '30123',
			iv: 8,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3[03]|900\\d)\\d{3}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryWF = {
	eO: '681',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[45]0|68|72|8\\d)\\d{4}')),
	w: 'WF',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '501234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:50|68|72)\\d{4}'))
		},
			{
			nb: '501234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:50|68|72|8[23])\\d{4}'))
		},
			{
			nb: '401234',
			iv: 10,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[48]0\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryWS = {
	eO: '685',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}')),
	w: 'WS',
	ki: $elm$core$Maybe$Just('0'),
	oo: $elm$core$Maybe$Nothing,
	kO: _List_fromArray(
		[
			{
			nb: '22123',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}'))
		},
			{
			nb: '7212345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:7[235-7]|8(?:[3-7]|9\\d{3}))\\d{5}'))
		},
			{
			nb: '800123',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{3}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryXK = {
	eO: '383',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}')),
	w: 'XK',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '28012345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2[89]|39)0\\d{6}|[23][89]\\d{6}'))
		},
			{
			nb: '43201234',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4[3-9]\\d{6}'))
		},
			{
			nb: '80001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{5}'))
		},
			{
			nb: '90001234',
			iv: 3,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900\\d{5}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryYE = {
	eO: '967',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:1|7\\d)\\d{7}|[1-7]\\d{6}')),
	w: 'YE',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '1234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}'))
		},
			{
			nb: '712345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7[0137]\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryYT = {
	eO: '262',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('80\\d{7}|(?:26|63)9\\d{6}')),
	w: 'YT',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '269601234',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('269(?:0[67]|5[0-2]|6\\d|[78]0)\\d{4}'))
		},
			{
			nb: '639012345',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('639(?:0[0-79]|1[019]|[267]\\d|3[09]|[45]0|9[04-79])\\d{4}'))
		},
			{
			nb: '801234567',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{7}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZM = {
	eO: '260',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}')),
	w: 'ZM',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '211234567',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('21[1-8]\\d{6}'))
		},
			{
			nb: '955123456',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:7[679]|9[5-8])\\d{7}'))
		},
			{
			nb: '800123456',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6}'))
		},
			{
			nb: '630012345',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('630\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZW = {
	eO: '263',
	jY: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}')),
	w: 'ZW',
	ki: $elm$core$Maybe$Just('00'),
	oo: $elm$core$Maybe$Just('0'),
	kO: _List_fromArray(
		[
			{
			nb: '1312345',
			iv: 0,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}'))
		},
			{
			nb: '712345678',
			iv: 1,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7(?:[17]\\d|[38][1-9])\\d{6}'))
		},
			{
			nb: '8001234',
			iv: 2,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80(?:[01]\\d|20|8[0-8])\\d{3}'))
		},
			{
			nb: '8686123456',
			iv: 6,
			kY: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('86(?:1[12]|22|30|44|55|77|8[368])\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$all = _List_fromArray(
	[$robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAX, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryAZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBB, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBJ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBQ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCV, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCX, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDJ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryDZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryEH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryER, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryES, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryET, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFJ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryFR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGB, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGP, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGQ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryHU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryID, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIQ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryIT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryJP, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKP, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryKZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLB, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLV, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryLY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryME, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryML, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMP, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMQ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMV, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMX, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryMZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNP, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryOM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryQA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryRW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySB, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySJ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryST, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySV, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySX, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countrySZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTD, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTH, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTJ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTL, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTO, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTR, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTV, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTW, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryTZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUY, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUZ, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVC, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVG, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVI, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVN, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryVU, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryWF, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryWS, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryXK, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryYE, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryYT, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZA, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZM, $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZW]);
var $author$project$Contact$validatePhone = $author$project$Form$Validate$custom(
	function (phoneNumber) {
		return A2(
			$robinheghan$elm_phone_numbers$PhoneNumber$valid,
			{mY: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBR, o0: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$all, qb: $robinheghan$elm_phone_numbers$PhoneNumber$anyType},
			phoneNumber) ? $elm$core$Result$Ok(phoneNumber) : $elm$core$Result$Err(
			function (_v0) {
				var t = _v0.fL;
				return t('contact_form.validation.phone.invalid');
			});
	});
var $author$project$Contact$validateTelegram = function () {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^[\\w](?!.*?\\.{2})[\\w.]{1,28}[\\w]$'));
	return $author$project$Form$Validate$custom(
		function (telegram) {
			return A2($elm$regex$Regex$contains, regex, telegram) ? $elm$core$Result$Ok('https://t.me/' + telegram) : $elm$core$Result$Err(
				function (_v0) {
					var t = _v0.fL;
					return t('contact_form.validation.username.invalid');
				});
		});
}();
var $author$project$OptionalResult$map3 = F4(
	function (fn, first, second, third) {
		var _v0 = _Utils_Tuple3(first, second, third);
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				_v0$4:
				while (true) {
					switch (_v0.a.$) {
						case 1:
							switch (_v0.b.$) {
								case 1:
									switch (_v0.c.$) {
										case 1:
											var firstOk = _v0.a.a;
											var secondOk = _v0.b.a;
											var thirdOk = _v0.c.a;
											return $author$project$OptionalResult$OptOk(
												A3(fn, firstOk, secondOk, thirdOk));
										case 0:
											break _v0$3;
										default:
											break _v0$4;
									}
								case 0:
									break _v0$2;
								default:
									if (!_v0.c.$) {
										break _v0$3;
									} else {
										break _v0$4;
									}
							}
						case 0:
							var error = _v0.a.a;
							return $author$project$OptionalResult$OptErr(error);
						default:
							if (!_v0.b.$) {
								break _v0$2;
							} else {
								if (!_v0.c.$) {
									break _v0$3;
								} else {
									break _v0$4;
								}
							}
					}
				}
				return $author$project$OptionalResult$OptNothing;
			}
			var error = _v0.c.a;
			return $author$project$OptionalResult$OptErr(error);
		}
		var error = _v0.b.a;
		return $author$project$OptionalResult$OptErr(error);
	});
var $author$project$Form$accumulateResults3 = F4(
	function (first, second, third, combinator) {
		var getErrors = function (result) {
			if (!result.$) {
				var _v4 = result.a;
				var firstError = _v4.a;
				var otherErrors = _v4.b;
				return $elm$core$Maybe$Just(
					A2($elm$core$List$cons, firstError, otherErrors));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var allErrors = $elm$core$List$concat(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						getErrors(first),
						getErrors(second),
						getErrors(third)
					])));
		switch (combinator.$) {
			case 1:
				var fn = combinator.a;
				return A4($author$project$OptionalResult$map3, fn, first, second, third);
			case 0:
				var _v1 = combinator.a;
				var error = _v1.a;
				var errors = _v1.b;
				return $author$project$OptionalResult$OptErr(
					_Utils_Tuple2(
						error,
						_Utils_ap(errors, allErrors)));
			default:
				if (allErrors.b) {
					var error = allErrors.a;
					var errors = allErrors.b;
					return $author$project$OptionalResult$OptErr(
						_Utils_Tuple2(error, errors));
				} else {
					return $author$project$OptionalResult$OptNothing;
				}
		}
	});
var $author$project$Form$withGroupOf3 = F5(
	function (attributes, first, second, third, current) {
		return function (values) {
			var filledThird = A2($author$project$Form$fill, third, values);
			var filledSecond = A2($author$project$Form$fill, second, values);
			var filledFirst = A2($author$project$Form$fill, first, values);
			var filledCurrent = A2($author$project$Form$fill, current, values);
			return {
				e: A2(
					$elm$core$List$cons,
					{
						na: $elm$core$Maybe$Nothing,
						nV: false,
						Z: A2(
							$author$project$Form$Group,
							attributes,
							_Utils_ap(
								filledFirst.e,
								_Utils_ap(filledSecond.e, filledThird.e))),
						ax: 0
					},
					filledCurrent.e),
				g: A4($author$project$Form$accumulateResults3, filledFirst.g, filledSecond.g, filledThird.g, filledCurrent.g)
			};
		};
	});
var $author$project$Contact$contactForm = F2(
	function (translators, id) {
		var slideUpAnimation = F2(
			function (heightClass, deletionStatus) {
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('motion-safe:duration-300 motion-safe:ease-in-out motion-safe:animate-fade-in-from-above motion-safe:fill-mode-none'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'transition-none ' + heightClass,
								$author$project$Contact$isNotDeleted(deletionStatus)),
								_Utils_Tuple2(
								'h-0 opacity-0 motion-safe:transition-all',
								!$author$project$Contact$isNotDeleted(deletionStatus))
							]))
					]);
			});
		var labelId = 'contact-label-' + $elm$core$String$fromInt(id);
		var inputId = 'contact-input-' + $elm$core$String$fromInt(id);
		return A2(
			$author$project$Form$withValidationStrategy,
			1,
			A5(
				$author$project$Form$withGroupOf3,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-2')
					]),
				$author$project$Form$introspect(
					function (_v2) {
						var deletionStatus = _v2.a9;
						var type_ = _v2.eq;
						return $author$project$Form$optional(
							A2(
								$author$project$Form$textField,
								{
									ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
									o3: A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$succeed,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$stringLongerThan(2),
											$author$project$Form$Validate$validate(translators))),
									qd: F2(
										function (newLabel, values) {
											return _Utils_update(
												values,
												{n$: newLabel});
										}),
									lW: function ($) {
										return $.n$;
									}
								},
								A2(
									$author$project$Form$Text$withContainerAttrs,
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('mb-0 w-1/3 sm:w-1/2 lg:w-1/3'),
										A2(slideUpAnimation, 'h-12', deletionStatus)),
									A2(
										$author$project$Form$Text$withPlaceholder,
										A2($author$project$Contact$typeToString, translators, type_),
										$author$project$Form$Text$init(
											{w: labelId, n$: ''})))));
					}),
				$author$project$Form$introspect(
					function (_v3) {
						var type_ = _v3.eq;
						var deletionStatus = _v3.a9;
						return A2(
							$author$project$Form$textField,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$succeed,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$stringLongerThan(0),
										A2(
											$elm$core$Basics$composeR,
											function () {
												switch (type_) {
													case 0:
														return $author$project$Form$Validate$email;
													case 1:
														return $author$project$Contact$validateInstagram;
													case 2:
														return A2(
															$elm$core$Basics$composeR,
															$author$project$Form$Validate$url,
															$author$project$Form$Validate$map($elm$url$Url$toString));
													case 3:
														return $author$project$Contact$validatePhone;
													case 4:
														return $author$project$Contact$validateTelegram;
													default:
														return $author$project$Contact$validatePhone;
												}
											}(),
											$author$project$Form$Validate$validate(translators)))),
								qd: F2(
									function (newValue, values) {
										return _Utils_update(
											values,
											{lW: newValue});
									}),
								lW: function ($) {
									return $.lW;
								}
							},
							A2(
								$author$project$Form$Text$withContainerAttrs,
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('mb-0 w-2/3 sm:w-1/2 lg:w-2/3'),
									A2(slideUpAnimation, 'h-12', deletionStatus)),
								A2(
									$author$project$Form$Text$withPlaceholder,
									$author$project$Contact$typeToPlaceholder(type_),
									$author$project$Form$Text$init(
										{w: inputId, n$: ''}))));
					}),
				$author$project$Form$introspect(
					function (_v5) {
						var deletionStatus = _v5.a9;
						return A2(
							$author$project$Form$arbitraryWith,
							0,
							A2(
								$elm$html$Html$button,
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onClick($author$project$Contact$startDeletingContact),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$Events$on,
											'transitionend',
											$elm$json$Json$Decode$succeed($author$project$Contact$finishDeletingContact)),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$type_('button'),
											A2(slideUpAnimation, 'h-12', deletionStatus)))),
								_List_fromArray(
									[
										$author$project$Icons$circularClose('')
									])));
					}),
				A2(
					$author$project$Form$with,
					$author$project$Form$introspect(
						function (_v1) {
							var type_ = _v1.eq;
							var deletionStatus = _v1.a9;
							return A2(
								$author$project$Form$arbitraryWith,
								type_,
								A2(
									$elm$html$Html$div,
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('flex items-end'),
										A2(slideUpAnimation, 'h-14', deletionStatus)),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex items-center')
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Contact$circularIconWithGrayBgInternal,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-5 h-5 mb-2 !p-1'),
															$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
														]),
													translators,
													type_),
													A2(
													$author$project$View$Components$label,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('ml-2')
														]),
													{
														n0: A2($author$project$Contact$typeToString, translators, type_),
														pZ: inputId
													})
												]))
										])));
						}),
					$author$project$Form$succeed(
						F4(
							function (type_, label, value, _v0) {
								return {n$: label, eq: type_, lW: value};
							})))));
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Contact$openTypeModal = function (_v0) {
	var values = _v0;
	return _Utils_update(
		values,
		{e9: true});
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Contact$form = function (translators) {
	var nestedContactForm = F2(
		function (id, contactFormInput) {
			return A2(
				$author$project$Form$mapValues,
				{
					qd: F2(
						function (newContactFormInput, _v4) {
							var values = _v4;
							return _Utils_update(
								values,
								{
									dL: A3($elm$core$Dict$insert, id, newContactFormInput, values.dL)
								});
						}),
					lW: function (_v5) {
						return contactFormInput;
					}
				},
				A2($author$project$Contact$contactForm, translators, id));
		});
	return A2(
		$author$project$Form$withNoOutput,
		$author$project$Form$introspect(
			function (_v3) {
				var isTypeModalOpen = _v3.e9;
				var newInputItem = function (contactType) {
					return A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center w-full py-2 text-gray-333 hover:text-orange-300 group focus-ring rounded-sm'),
										$elm$html$Html$Events$onClick(
										$author$project$Contact$addContactType(contactType)),
										$elm$html$Html$Attributes$type_('button')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Contact$circularIconWithGrayBgInternal,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-8 h-8 mr-2'),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										translators,
										contactType),
										$elm$html$Html$text(
										A2($author$project$Contact$typeToString, translators, contactType)),
										$author$project$Icons$arrowDown('-rotate-90 ml-auto text-gray-900 group-hover:text-orange-300 fill-current')
									]))
							]));
				};
				return $author$project$Form$arbitrary(
					$author$project$View$Modal$toHtml(
						A2(
							$author$project$View$Modal$withBody,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('divide-y divide-gray-100')
										]),
									A2($elm$core$List$map, newInputItem, $author$project$Cambiatus$Enum$ContactType$list))
								]),
							A2(
								$author$project$View$Modal$withHeader,
								translators.fL('contact_form.options'),
								$author$project$View$Modal$initWith(
									{mw: $author$project$Contact$closeTypeModal, nX: isTypeModalOpen})))));
			}),
		A2(
			$author$project$Form$withNoOutput,
			$author$project$Form$arbitrary(
				A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button button-secondary w-full md:w-56 mb-20 mt-10'),
							$elm$html$Html$Events$onClick($author$project$Contact$openTypeModal),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_fromArray(
						[
							$author$project$Icons$circledPlus(''),
							$elm$html$Html$text(
							translators.fL('contact_form.add'))
						]))),
			A2(
				$author$project$Form$with,
				$author$project$Form$introspect(
					function (_v0) {
						var inputs = _v0.dL;
						return A2(
							$author$project$Form$list,
							_List_Nil,
							$elm$core$Dict$values(
								A2(
									$elm$core$Dict$map,
									nestedContactForm,
									A2(
										$elm$core$Dict$filter,
										F2(
											function (_v1, _v2) {
												var deletionStatus = _v2.a9;
												return deletionStatus !== 2;
											}),
										inputs))));
					}),
				$author$project$Form$succeed($elm$core$Basics$identity))));
};
var $author$project$Page$Community$Settings$Contacts$view = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var title = t('settings.contacts.title');
		var content = function () {
			switch (model.$) {
				case 0:
					var formModel = model.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-grow flex flex-col')
							]),
						_List_fromArray(
							[
								A2($author$project$Page$viewHeader, loggedIn, title),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto lg:px-4 lg:mt-6 lg:mb-20')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('bg-white container mx-auto pt-6 pb-7 px-4 lg:px-6 lg:max-w-none lg:w-2/3 lg:rounded lg:shadow-lg')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-gray-900')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('contact_form.community_header'))
													])),
												A2(
												$elm$html$Html$h2,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('label mt-10')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('contact_form.options'))
													])),
												A6(
												$author$project$Form$view,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex flex-col flex-grow')
													]),
												loggedIn.A.aw,
												function (submitButton) {
													return _List_fromArray(
														[
															A2(
															submitButton,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('button button-primary mt-auto w-full md:w-56')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('contact_form.submit_multiple'))
																]))
														]);
												},
												$author$project$Contact$form(loggedIn.A.aw),
												formModel,
												{oU: $author$project$Page$Community$Settings$Contacts$SubmittedForm, lF: $author$project$Page$Community$Settings$Contacts$GotFormMsg})
											]))
									]))
							]));
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				default:
					return A2(
						$author$project$Page$fullPageNotFound,
						t('community.edit.unauthorized'),
						'');
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$Settings$Currency$FormOutput = F3(
	function (minimumBalance, maximumSupply, tokenInfo) {
		return {cU: maximumSupply, d0: minimumBalance, fR: tokenInfo};
	});
var $author$project$Page$Community$Settings$Currency$NoExpiryOpts = {$: 0};
var $author$project$Page$Community$Settings$Currency$WithExpiryOpts = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$withDecoration = function (decoration) {
	return $author$project$Form$withNoOutput(
		$author$project$Form$arbitrary(
			A2(
				$elm$html$Html$map,
				function (_v0) {
					return $elm$core$Basics$identity;
				},
				decoration)));
};
var $author$project$Page$Community$Settings$Currency$communityInfoForm = F2(
	function (translators, community) {
		var t = translators.fL;
		var tr = translators.i4;
		var symbolExample = function () {
			var _v8 = A2(
				$elm$core$String$split,
				'.',
				A3($author$project$Eos$formatSymbolAmount, translators, community.as, 100));
			if (!_v8.b) {
				return _List_Nil;
			} else {
				if (!_v8.b.b) {
					var withoutDecimalPlaces = _v8.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xl')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(withoutDecimalPlaces)
								]))
						]);
				} else {
					var beforeSeparator = _v8.a;
					var _v9 = _v8.b;
					var afterSeparator = _v9.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xl')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(beforeSeparator)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(',' + afterSeparator)
								]))
						]);
				}
			}
		}();
		return A2(
			$author$project$Form$withDecoration,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-gray-100 py-4 text-center mb-10')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-xl font-semibold mb-4')
							]),
						_Utils_ap(
							symbolExample,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-4 text-green')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Eos$symbolToSymbolCodeString(community.as))
										]))
								]))),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('uppercase text-black text-sm tracking-widest')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('settings.community_currency.format')),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text(
								A2(
									tr,
									'settings.community_currency.supports_decimal_places',
									_List_fromArray(
										[
											_Utils_Tuple2(
											'amount',
											$elm$core$String$fromInt(
												$author$project$Eos$getSymbolPrecision(community.as)))
										])))
							]))
					])),
			A2(
				$author$project$Form$withNoOutput,
				A4(
					$author$project$Form$withGroup,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grid grid-cols-2 gap-8')
						]),
					A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: $elm$core$Result$Ok,
							qd: F2(
								function (_v4, input) {
									return input;
								}),
							lW: function (_v5) {
								return $author$project$Eos$symbolToSymbolCodeString(community.as);
							}
						},
						A2(
							$author$project$Form$Text$withDisabled,
							true,
							$author$project$Form$Text$init(
								{
									w: 'currency-symbol-input',
									n$: t('community.create.labels.currency_symbol')
								}))),
					A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: $elm$core$Result$Ok,
							qd: F2(
								function (_v6, input) {
									return input;
								}),
							lW: function (_v7) {
								return $elm$core$String$fromInt(
									$author$project$Eos$getSymbolPrecision(community.as));
							}
						},
						A2(
							$author$project$Form$Text$withElements,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute right-0 inset-y-0 flex items-center pr-3 text-gray-900')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3($author$project$Eos$formatSymbolAmount, translators, community.as, 100))
										]))
								]),
							A2(
								$author$project$Form$Text$withDisabled,
								true,
								$author$project$Form$Text$init(
									{
										w: 'currency-precision-input',
										n$: t('settings.community_currency.decimal_places')
									})))),
					$author$project$Form$succeed(
						F2(
							function (_v2, _v3) {
								return 0;
							}))),
				A2(
					$author$project$Form$withNoOutput,
					A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: $elm$core$Result$Ok,
							qd: F2(
								function (_v0, input) {
									return input;
								}),
							lW: function (_v1) {
								return community.fj;
							}
						},
						A2(
							$author$project$Form$Text$withDisabled,
							true,
							$author$project$Form$Text$init(
								{
									w: 'currency-name-input',
									n$: t('community.create.labels.currency_name')
								}))),
					$author$project$Form$succeed(0))));
	});
var $author$project$Page$Community$Settings$Currency$expiryOptsForm = F2(
	function (translators, community) {
		var t = translators.fL;
		var withSeconds = function (input) {
			return A2(
				$author$project$Form$Text$withElements,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('absolute inset-y-0 right-4 flex items-center bg-white pl-1 my-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('settings.community_currency.seconds'))
							]))
					]),
				A2(
					$author$project$Form$Text$withExtraAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pr-20')
						]),
					input));
		};
		return A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$textField,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$succeed,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$maskedFloat(translators),
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$custom(
									function (amount) {
										return $elm$core$Result$Ok(
											{ji: amount, as: community.as});
									}),
								$author$project$Form$Validate$validate(translators)))),
					qd: F2(
						function (renovationAmount, input) {
							return _Utils_update(
								input,
								{ef: renovationAmount});
						}),
					lW: function ($) {
						return $.ef;
					}
				},
				A2(
					$author$project$Form$Text$withCurrency,
					community.as,
					A2(
						$author$project$Form$Text$withPlaceholder,
						A3($author$project$Eos$formatSymbolAmount, translators, community.as, 100),
						$author$project$Form$Text$init(
							{
								w: 'renovation-amount-input',
								n$: t('settings.community_currency.renovation_amount')
							})))),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$textField,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$succeed,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$int,
								$author$project$Form$Validate$validate(translators))),
						qd: F2(
							function (period, input) {
								return _Utils_update(
									input,
									{dX: period});
							}),
						lW: function ($) {
							return $.dX;
						}
					},
					A2(
						$author$project$Form$Text$withPlaceholder,
						'15',
						withSeconds(
							$author$project$Form$Text$init(
								{
									w: 'juridical-expiration-period-input',
									n$: t('settings.community_currency.juridical_expiration_period')
								})))),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$int,
									$author$project$Form$Validate$validate(translators))),
							qd: F2(
								function (period, input) {
									return _Utils_update(
										input,
										{d1: period});
								}),
							lW: function ($) {
								return $.d1;
							}
						},
						A2(
							$author$project$Form$Text$withPlaceholder,
							'10',
							withSeconds(
								$author$project$Form$Text$init(
									{
										w: 'natural-expiration-period-input',
										n$: t('settings.community_currency.natural_expiration_period')
									})))),
					A2(
						$author$project$Form$with,
						$author$project$Form$succeed(community.as),
						$author$project$Form$succeed($author$project$Token$ExpiryOptsData)))));
	});
var $author$project$Token$tokenTypeFromString = function (tokenType) {
	switch (tokenType) {
		case 'mcc':
			return $elm$core$Maybe$Just(0);
		case 'expiry':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$Currency$createForm = F2(
	function (translators, community) {
		var t = translators.fL;
		return A2(
			$author$project$Form$with,
			$author$project$Form$introspect(
				function (values) {
					var _v0 = values.p6;
					if (!_v0) {
						return $author$project$Form$succeed($author$project$Page$Community$Settings$Currency$NoExpiryOpts);
					} else {
						return A2(
							$author$project$Form$mapOutput,
							$author$project$Page$Community$Settings$Currency$WithExpiryOpts,
							A2($author$project$Page$Community$Settings$Currency$expiryOptsForm, translators, community));
					}
				}),
			A2(
				$author$project$Form$withNoOutput,
				A3(
					$author$project$Form$radio,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Token$tokenTypeFromString,
						$elm$core$Maybe$withDefault(0)),
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: $elm$core$Result$Ok,
						qd: F2(
							function (tokenType, input) {
								return _Utils_update(
									input,
									{p6: tokenType});
							}),
						lW: function ($) {
							return $.p6;
						}
					},
					A2(
						$author$project$Form$Radio$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-8')
							]),
						A2(
							$author$project$Form$Radio$withDisabled,
							true,
							A3(
								$author$project$Form$Radio$withOption,
								1,
								$elm$html$Html$text(
									t('settings.community_currency.expiry')),
								A3(
									$author$project$Form$Radio$withOption,
									0,
									$elm$html$Html$text('MCC'),
									$author$project$Form$Radio$init(
										{
											w: 'token-type-input',
											n$: t('settings.community_currency.token_type'),
											d5: $author$project$Token$tokenTypeToString
										})))))),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$maskedFloat(translators),
									$author$project$Form$Validate$validate(translators))),
							qd: F2(
								function (maximumSupply, input) {
									return _Utils_update(
										input,
										{cU: maximumSupply});
								}),
							lW: function ($) {
								return $.cU;
							}
						},
						A2(
							$author$project$Form$Text$withCurrency,
							community.as,
							$author$project$Form$Text$init(
								{
									w: 'maximum-supply-input',
									n$: t('community.create.labels.max_supply')
								}))),
					A2(
						$author$project$Form$with,
						A2(
							$author$project$Form$textField,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$succeed,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$maskedFloat(translators),
										$author$project$Form$Validate$validate(translators))),
								qd: F2(
									function (minimumBalance, input) {
										return _Utils_update(
											input,
											{d0: minimumBalance});
									}),
								lW: function ($) {
									return $.d0;
								}
							},
							A2(
								$author$project$Form$Text$withCurrency,
								community.as,
								$author$project$Form$Text$init(
									{
										w: 'minimum-balance-input',
										n$: t('community.create.labels.min_balance')
									}))),
						A2(
							$author$project$Form$withNoOutput,
							A2($author$project$Page$Community$Settings$Currency$communityInfoForm, translators, community),
							$author$project$Form$succeed($author$project$Page$Community$Settings$Currency$FormOutput))))));
	});
var $author$project$Page$Community$Settings$Currency$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var _v0 = shared.aw;
		var t = _v0.fL;
		var title = t('settings.community_currency.title');
		var content = function () {
			var _v1 = loggedIn.pC;
			switch (_v1.$) {
				case 2:
					var e = _v1.a;
					return A2($author$project$Page$fullPageGraphQLError, title, e);
				case 1:
					return $author$project$Page$fullPageLoading(shared);
				case 0:
					return $author$project$Page$fullPageLoading(shared);
				default:
					var community = _v1.a;
					var _v2 = model.hY;
					if (!_v2.$) {
						return $author$project$Page$fullPageLoading(shared);
					} else {
						var form = _v2.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white')
								]),
							_List_fromArray(
								[
									A2($author$project$Page$viewHeader, loggedIn, title),
									A6(
									$author$project$Form$view,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container mx-auto px-4 pt-4 pb-10')
										]),
									shared.aw,
									function (submitButton) {
										return _List_fromArray(
											[
												A2(
												submitButton,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('button button-primary w-full mt-12'),
														$elm$html$Html$Attributes$disabled(!loggedIn.gz)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('menu.save'))
													]))
											]);
									},
									A2($author$project$Page$Community$Settings$Currency$createForm, shared.aw, community),
									A2($author$project$Form$withDisabled, model.ap, form),
									{oU: $author$project$Page$Community$Settings$Currency$ClickedSubmit, lF: $author$project$Page$Community$Settings$Currency$GotFormMsg})
								]));
					}
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$Settings$Features$ToggleKyc = {$: 5};
var $author$project$Page$Community$Settings$Features$ToggleNews = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Community$Settings$Features$ToggleObjectives = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$Settings$Features$ToggleShop = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Settings$Features$ToggleSponsorship = {$: 6};
var $author$project$Page$Community$Settings$Features$view = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var title = t('settings.features.title');
		var content = function () {
			var _v1 = _Utils_Tuple2(loggedIn.pC, model.pN);
			switch (_v1.a.$) {
				case 2:
					var e = _v1.a.a;
					return A2($author$project$Page$fullPageGraphQLError, title, e);
				case 1:
					var _v2 = _v1.a;
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 0:
					var _v3 = _v1.a;
					return $author$project$Page$fullPageLoading(loggedIn.A);
				default:
					switch (_v1.b) {
						case 0:
							var _v4 = _v1.b;
							return $author$project$Page$fullPageLoading(loggedIn.A);
						case 1:
							var community = _v1.a.a;
							var _v5 = _v1.b;
							var addTooltip = function (maybeTooltip) {
								if (maybeTooltip.$ === 1) {
									return $elm$core$Basics$identity;
								} else {
									var tooltip = maybeTooltip.a;
									return $author$project$Form$Toggle$withTooltip(tooltip);
								}
							};
							var viewToggle = function (_v8) {
								var label = _v8.n$;
								var id = _v8.w;
								var action = _v8.dh;
								var disabled = _v8.b_;
								var value = _v8.lW;
								var tooltip = _v8.i3;
								return function (options) {
									return A2(
										$author$project$Form$Toggle$view,
										options,
										{
											na: $elm$html$Html$text(''),
											no: false,
											nV: false,
											oF: $author$project$Page$Community$Settings$Features$NoOp,
											oW: action,
											aw: loggedIn.A.aw,
											lW: value
										});
								}(
									A2(
										addTooltip,
										tooltip,
										A2(
											$author$project$Form$Toggle$withContainerAttrs,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('py-6')
												]),
											A2(
												$author$project$Form$Toggle$withDisabled,
												disabled || (!loggedIn.gz),
												$author$project$Form$Toggle$init(
													{
														w: id,
														n$: $elm$html$Html$text(
															t(label))
													})))));
							};
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bg-white flex flex-col items-center')
									]),
								_List_fromArray(
									[
										A2($author$project$Page$viewHeader, loggedIn, title),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('container divide-y px-4')
											]),
										A2(
											$elm$core$List$map,
											viewToggle,
											_List_fromArray(
												[
													{dh: $author$project$Page$Community$Settings$Features$ToggleObjectives, b_: false, w: 'actions-toggle', n$: 'community.objectives.title_plural', i3: $elm$core$Maybe$Nothing, lW: model.bz},
													{dh: $author$project$Page$Community$Settings$Features$ToggleShop, b_: false, w: 'shop-toggle', n$: 'menu.shop', i3: $elm$core$Maybe$Nothing, lW: model.bB},
													{
													dh: function (_v6) {
														return $author$project$Page$Community$Settings$Features$ToggleKyc;
													},
													b_: true,
													w: 'kyc-toggle',
													n$: 'community.kyc.title',
													i3: $elm$core$Maybe$Just(
														{
															mG: '',
															nx: 'text-orange-300',
															of: t('community.kyc.info')
														}),
													lW: model.by
												},
													{
													dh: function (_v7) {
														return $author$project$Page$Community$Settings$Features$ToggleSponsorship;
													},
													b_: true,
													w: 'sponsorship-toggle',
													n$: 'sponsorship.title',
													i3: $elm$core$Maybe$Nothing,
													lW: $elm_community$maybe_extra$Maybe$Extra$isJust(community.mM)
												},
													{dh: $author$project$Page$Community$Settings$Features$ToggleNews, b_: false, w: 'news-toggle', n$: 'news.title', i3: $elm$core$Maybe$Nothing, lW: model.dH}
												])))
									]));
						default:
							var _v10 = _v1.b;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Page$viewHeader, loggedIn, title),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('community.edit.unauthorized'))
											]))
									]));
					}
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$Settings$Info$ClickedSave = function (a) {
	return {$: 3, a: a};
};
var $author$project$Form$Text$CountLetters = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$Validate$floatGreaterThanOrEqualTo = $author$project$Form$Validate$numberGreaterThanOrEqualTo($elm$core$String$fromFloat);
var $author$project$Form$Text$withCounter = F2(
	function (counter, _v0) {
		var options = _v0;
		var _v1 = function () {
			if (!counter.$) {
				var maxLetters = counter.a;
				return _Utils_Tuple2(
					$author$project$Form$Text$withExtraAttrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$maxlength(maxLetters)
							])),
					$elm$core$String$left(maxLetters));
			} else {
				var maxWords = counter.a;
				return _Utils_Tuple2(
					$elm$core$Basics$identity,
					function (value) {
						return (_Utils_cmp(
							$elm$core$List$length(
								$elm$core$String$words(value)),
							maxWords) > -1) ? A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$take,
								maxWords,
								$elm$core$String$words(value))) : value;
					});
			}
		}();
		var addMaxlength = _v1.a;
		var beforeChangeEvent = _v1.b;
		return addMaxlength(
			_Utils_update(
				options,
				{
					bX: A2($elm$core$Basics$composeR, beforeChangeEvent, options.bX),
					gj: $elm$core$Maybe$Just(counter)
				}));
	});
var $author$project$Page$Community$Settings$Info$createForm = F3(
	function (shared, community, _v0) {
		var isLoading = _v0.ap;
		var translators = shared.aw;
		var t = translators.fL;
		return A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$textField,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$succeed,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$maskedFloat(translators),
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$floatGreaterThanOrEqualTo(0),
								$author$project$Form$Validate$validate(translators)))),
					qd: F2(
						function (invitedReward, input) {
							return _Utils_update(
								input,
								{b5: invitedReward});
						}),
					lW: function ($) {
						return $.b5;
					}
				},
				A2(
					$author$project$Form$Text$withPlaceholder,
					A3($author$project$Eos$formatSymbolAmount, translators, community.as, 5),
					A2(
						$author$project$Form$Text$withCurrency,
						community.as,
						$author$project$Form$Text$init(
							{
								w: 'invited-reward-input',
								n$: t('community.create.labels.invited_reward')
							})))),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$textField,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$succeed,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$maskedFloat(translators),
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$floatGreaterThanOrEqualTo(0),
									$author$project$Form$Validate$validate(translators)))),
						qd: F2(
							function (inviterReward, input) {
								return _Utils_update(
									input,
									{b6: inviterReward});
							}),
						lW: function ($) {
							return $.b6;
						}
					},
					A2(
						$author$project$Form$Text$withPlaceholder,
						A3($author$project$Eos$formatSymbolAmount, translators, community.as, 10),
						A2(
							$author$project$Form$Text$withCurrency,
							community.as,
							$author$project$Form$Text$init(
								{
									w: 'inviter-reward-input',
									n$: t('community.create.labels.inviter_reward')
								})))),
				A2(
					$author$project$Form$withDecoration,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-10')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('font-bold mt-7')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('settings.community_info.invitation.guidance'))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-600')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('settings.community_info.invitation.description'))
									]))
							])),
					A2(
						$author$project$Form$with,
						A2(
							$author$project$Form$toggle,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: $elm$core$Result$Ok,
								qd: F2(
									function (hasAutoInvite, input) {
										return _Utils_update(
											input,
											{bx: !hasAutoInvite});
									}),
								lW: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.bx;
									},
									$elm$core$Basics$not)
							},
							A2(
								$author$project$Form$Toggle$withTopLabel,
								t('settings.community_info.invitation.title'),
								$author$project$Form$Toggle$init(
									{
										w: 'require-invitation-toggle',
										n$: $elm$html$Html$text(
											t('settings.community_info.fields.invitation'))
									}))),
						A2(
							$author$project$Form$withDecoration,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('border-b border-gray-500 pb-4 mb-10')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('settings.community_info.url.guidance'))
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-600')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('settings.community_info.constraints.length'))
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('settings.community_info.constraints.characters'))
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('settings.community_info.constraints.donts'))
													]))
											]))
									])),
							A2(
								$author$project$Form$with,
								$author$project$Form$introspect(
									function (values) {
										return A2(
											$author$project$Form$textField,
											{
												ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
												o3: A2(
													$elm$core$Basics$composeR,
													$author$project$Form$Validate$succeed,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Form$Validate$custom(
															function (stringInput) {
																return A2(
																	$elm$core$String$all,
																	function (_char) {
																		return $elm$core$Char$isAlpha(_char) || (_char === '-');
																	},
																	stringInput) ? $elm$core$Result$Ok(stringInput) : $elm$core$Result$Err(
																	function (translators_) {
																		return translators_.fL('settings.community_info.errors.url.invalid_char');
																	});
															}),
														A2(
															$elm$core$Basics$composeR,
															$author$project$Form$Validate$custom(
																function (stringInput) {
																	return A2(
																		$elm$core$String$all,
																		$elm$core$Char$isLower,
																		A2($elm$core$String$filter, $elm$core$Char$isAlpha, stringInput)) ? $elm$core$Result$Ok(stringInput) : $elm$core$Result$Err(
																		function (translators_) {
																			return translators_.fL('settings.community_info.errors.url.invalid_case');
																		});
																}),
															A2(
																$elm$core$Basics$composeR,
																$author$project$Form$Validate$stringLongerThan(1),
																A2(
																	$elm$core$Basics$composeR,
																	$author$project$Form$Validate$url,
																	A2(
																		$elm$core$Basics$composeR,
																		$author$project$Form$Validate$map(
																			$author$project$Route$addEnvironmentToUrl(shared.m8)),
																		$author$project$Form$Validate$validate(translators))))))),
												qd: F2(
													function (subdomain, input) {
														return _Utils_update(
															input,
															{pP: subdomain});
													}),
												lW: function ($) {
													return $.pP;
												}
											},
											A2(
												$author$project$Form$Text$withElements,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('absolute inset-y-0 right-4 flex items-center bg-white pl-1 my-2'),
																$elm$html$Html$Attributes$classList(
																_List_fromArray(
																	[
																		_Utils_Tuple2('bg-gray-500', isLoading)
																	]))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('.cambiatus.io')
															]))
													]),
												A2(
													$author$project$Form$Text$withExtraAttrs,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$maxlength(30),
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'pr-29',
																	!$elm$core$String$isEmpty(values.pP))
																]))
														]),
													A2(
														$author$project$Form$Text$withCounter,
														$author$project$Form$Text$CountLetters(30),
														A2(
															$author$project$Form$Text$withPlaceholder,
															t('settings.community_info.placeholders.url'),
															$author$project$Form$Text$init(
																{
																	w: 'subdomain-input',
																	n$: t('settings.community_info.url.title')
																}))))));
									}),
								A2(
									$author$project$Form$withDecoration,
									A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-2 text-center text-gray-900 uppercase text-sm tracking-wide mb-10')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('settings.community_info.cover_photo.description'))
											])),
									A2(
										$author$project$Form$with,
										$author$project$Form$optional(
											A2(
												$author$project$Form$file,
												{
													ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
													o3: $elm$core$Result$Ok,
													aw: translators,
													qd: F2(
														function (coverPhoto, input) {
															return _Utils_update(
																input,
																{a7: coverPhoto});
														}),
													lW: function ($) {
														return $.a7;
													}
												},
												A2(
													$author$project$Form$File$withAddImagesView,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('h-56 w-full bg-purple-500 rounded-sm text-white flex flex-col items-center justify-center')
																]),
															_List_fromArray(
																[
																	$author$project$Icons$camera('w-10 mb-2'),
																	A2(
																	$elm$html$Html$p,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('px-4 font-bold')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			translators.fL('community.actions.proof.upload_hint'))
																		]))
																]))
														]),
													A2(
														$author$project$Form$File$withAddImagesContainerAttributes,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('!w-full')
															]),
														A2(
															$author$project$Form$File$withImageSiblingElement,
															A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('bg-orange-300 rounded-full absolute right-4 bottom-4 h-8 w-8 grid place-items-center')
																	]),
																_List_fromArray(
																	[
																		$author$project$Icons$edit('text-white w-4 h-4')
																	])),
															A2(
																$author$project$Form$File$withImageClass,
																'h-56',
																A2(
																	$author$project$Form$File$withEntryContainerAttributes,
																	function (_v2) {
																		return _List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('w-full h-56 bg-purple-500 rounded-sm grid place-items-center overflow-hidden relative')
																			]);
																	},
																	A2(
																		$author$project$Form$File$withLabel,
																		t('settings.community_info.cover_photo.title'),
																		$author$project$Form$File$init(
																			{w: 'cover-photo-input'}))))))))),
										A2(
											$author$project$Form$with,
											$author$project$Form$optional(
												A2(
													$author$project$Form$textField,
													{
														ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
														o3: A2(
															$elm$core$Basics$composeR,
															$author$project$Form$Validate$succeed,
															A2(
																$elm$core$Basics$composeR,
																$author$project$Form$Validate$url,
																$author$project$Form$Validate$validate(translators))),
														qd: F2(
															function (website, input) {
																return _Utils_update(
																	input,
																	{bT: website});
															}),
														lW: function ($) {
															return $.bT;
														}
													},
													A2(
														$author$project$Form$Text$withPlaceholder,
														'cambiatus.com',
														$author$project$Form$Text$init(
															{
																w: 'website-input',
																n$: t('settings.community_info.fields.website')
															})))),
											A2(
												$author$project$Form$with,
												A2(
													$author$project$Form$richText,
													{
														ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
														o3: $elm$core$Result$Ok,
														qd: F2(
															function (description, input) {
																return _Utils_update(
																	input,
																	{aR: description});
															}),
														lW: function ($) {
															return $.aR;
														}
													},
													A2(
														$author$project$Form$RichText$withPlaceholder,
														t('settings.community_info.placeholders.description'),
														A2(
															$author$project$Form$RichText$withEditorContainerAttrs,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('mb-10')
																]),
															$author$project$Form$RichText$init(
																{
																	n$: t('settings.community_info.placeholders.description')
																})))),
												A2(
													$author$project$Form$with,
													A2(
														$author$project$Form$textField,
														{
															ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
															o3: $elm$core$Result$Ok,
															qd: F2(
																function (name, input) {
																	return _Utils_update(
																		input,
																		{fj: name});
																}),
															lW: function ($) {
																return $.fj;
															}
														},
														A2(
															$author$project$Form$Text$withPlaceholder,
															t('settings.community_info.placeholders.name'),
															$author$project$Form$Text$init(
																{
																	w: 'name-input',
																	n$: t('settings.community_info.fields.name')
																}))),
													A2(
														$author$project$Form$withDecoration,
														A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('md:text-center mb-10')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$p,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('font-bold')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			t('settings.community_info.logo.guidance'))
																		])),
																	A2(
																	$elm$html$Html$p,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('text-gray-600')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			t('settings.community_info.logo.description'))
																		]))
																])),
														A2(
															$author$project$Form$with,
															A2(
																$author$project$Form$file,
																{
																	ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
																	o3: $elm$core$Result$Ok,
																	aw: translators,
																	qd: F2(
																		function (logo, input) {
																			return _Utils_update(
																				input,
																				{fe: logo});
																		}),
																	lW: function ($) {
																		return $.fe;
																	}
																},
																A2(
																	$author$project$Form$File$withImageCropperAttributes,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('rounded-full')
																		]),
																	A2(
																		$author$project$Form$File$withAddImagesView,
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$span,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('bg-orange-300 rounded-full p-4 w-20 h-20 mx-auto')
																					]),
																				_List_fromArray(
																					[
																						$author$project$Icons$camera('text-white')
																					]))
																			]),
																		A2(
																			$author$project$Form$File$withAddImagesContainerAttributes,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('mx-auto rounded-full')
																				]),
																			$author$project$Form$File$withEditIconOverlay(
																				A2(
																					$author$project$Form$File$withEntryContainerAttributes,
																					function (_v1) {
																						return _List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('mx-auto rounded-full w-20 h-20 self-center')
																							]);
																					},
																					A2(
																						$author$project$Form$File$withImageClass,
																						'object-cover rounded-full mx-auto w-20 h-20',
																						A2(
																							$author$project$Form$File$withContainerAttributes,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('mb-4')
																								]),
																							A2(
																								$author$project$Form$File$withLabel,
																								t('settings.community_info.logo.title'),
																								$author$project$Form$File$init(
																									{w: 'logo-input'})))))))))),
															$author$project$Form$succeed($author$project$Page$Community$Settings$Info$FormOutput))))))))))))));
	});
var $author$project$Page$Community$Settings$Info$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var _v0 = shared.aw;
		var t = _v0.fL;
		var title = t('settings.community_info.title');
		var content = function () {
			var _v1 = loggedIn.pC;
			switch (_v1.$) {
				case 2:
					var e = _v1.a;
					return A2($author$project$Page$fullPageGraphQLError, title, e);
				case 1:
					return $author$project$Page$fullPageLoading(shared);
				case 0:
					return $author$project$Page$fullPageLoading(shared);
				default:
					var community = _v1.a;
					var _v2 = model.hY;
					if (!_v2.$) {
						return $author$project$Page$fullPageLoading(shared);
					} else {
						var form = _v2.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white')
								]),
							_List_fromArray(
								[
									A2($author$project$Page$viewHeader, loggedIn, title),
									A6(
									$author$project$Form$view,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container mx-auto px-4 pb-10 pt-4')
										]),
									shared.aw,
									function (submitButton) {
										return _List_fromArray(
											[
												A2(
												submitButton,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('button button-primary w-full mt-14')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('menu.save'))
													]))
											]);
									},
									A3(
										$author$project$Page$Community$Settings$Info$createForm,
										shared,
										community,
										{ap: model.ap}),
									A2($author$project$Form$withDisabled, model.ap || (!loggedIn.gz), form),
									{oU: $author$project$Page$Community$Settings$Info$ClickedSave, lF: $author$project$Page$Community$Settings$Info$GotFormMsg})
								]));
					}
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$Settings$News$ClosedHighlightNewsConfirmationModal = {$: 4};
var $author$project$Page$Community$Settings$News$ConfirmedHighlightNews = function (a) {
	return {$: 5, a: a};
};
var $author$project$View$Components$disablableLink = function (_v0) {
	var isDisabled = _v0.nP;
	return isDisabled ? $elm$html$Html$span : $elm$html$Html$a;
};
var $author$project$Page$Community$Settings$News$NoOp = {$: 0};
var $author$project$Page$Community$Settings$News$ToggledHighlightNews = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Form$Toggle$YesNo = 1;
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$Form$Toggle$withStatusText = F2(
	function (statusText_, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{iS: statusText_});
	});
var $author$project$Page$Community$Settings$News$viewNewsCard = F3(
	function (loggedIn, isHighlighted, news) {
		var shared = loggedIn.A;
		var translators = shared.aw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white rounded p-4 pb-6 flex flex-col')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(news.fN)
						])),
					A2(
					$elm$html$Html$small,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('uppercase text-gray-900 text-sm font-bold block mt-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							translators.fL('news.created_at')),
							A4($author$project$View$Components$dateViewer, _List_Nil, $elm$core$Basics$identity, shared, news.nL)
						])),
					function () {
					var _v0 = news.iL;
					if (_v0.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var scheduling = _v0.a;
						var padTime = function (time) {
							return _Utils_ap(
								A2(
									$elm$core$String$repeat,
									2 - $elm$core$String$length(time),
									'0'),
								time);
						};
						return A2(
							$elm$html$Html$small,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('uppercase text-gray-900 text-sm font-bold block mt-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									translators.fL('news.scheduled_at')),
									A4($author$project$View$Components$dateViewer, _List_Nil, $elm$core$Basics$identity, shared, scheduling),
									$elm$html$Html$text(
									A2(
										translators.i4,
										'news.scheduled_at_time',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'hour',
												padTime(
													$elm$core$String$fromInt(
														A2($elm$time$Time$toHour, shared.i2, scheduling)))),
												_Utils_Tuple2(
												'minute',
												padTime(
													$elm$core$String$fromInt(
														A2($elm$time$Time$toMinute, shared.i2, scheduling))))
											])))
								]));
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-10 relative mt-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-900 max-h-11 overflow-hidden')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Markdown$toUnformattedString(news.aR))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute right-0 bottom-0 bg-white pl-2 text-orange-300 hover:underline focus:underline outline-none'),
									$author$project$Route$href(
									$author$project$Route$News(
										{
											pD: $elm$core$Maybe$Just(news.w),
											pJ: false
										})),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
									translators.fL('news.view_more'))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									translators.fL('news.view_more_with_ellipsis'))
								]))
						])),
					function (options) {
					return A2(
						$author$project$Form$Toggle$view,
						options,
						{
							na: $elm$html$Html$text(''),
							no: false,
							nV: false,
							oF: $author$project$Page$Community$Settings$News$NoOp,
							oW: $author$project$Page$Community$Settings$News$ToggledHighlightNews(news.w),
							aw: translators,
							lW: isHighlighted
						});
				}(
					A2(
						$author$project$Form$Toggle$withDisabled,
						!loggedIn.gz,
						A2(
							$author$project$Form$Toggle$withStatusText,
							1,
							A2(
								$author$project$Form$Toggle$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-auto')
									]),
								$author$project$Form$Toggle$init(
									{
										w: 'highlight-news-toggle-' + $elm$core$String$fromInt(news.w),
										n$: $elm$html$Html$text(
											translators.fL('news.highlight'))
									}))))),
					A3(
					$author$project$View$Components$disablableLink,
					{nP: !loggedIn.gz},
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button button-primary w-full mt-10 mb-4'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('button-disabled', !loggedIn.gz)
								])),
							$author$project$Route$href(
							$author$project$Route$CommunitySettingsNewsEditor(
								$author$project$Route$EditNews(news.w)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							translators.fL('news.edit'))
						])),
					A3(
					$author$project$View$Components$disablableLink,
					{nP: !loggedIn.gz},
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button button-secondary w-full'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('button-disabled', !loggedIn.gz)
								])),
							$author$project$Route$href(
							$author$project$Route$CommunitySettingsNewsEditor(
								$author$project$Route$CopyNews(news.w)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							translators.fL('news.copy'))
						]))
				]));
	});
var $author$project$Page$Community$Settings$News$view_ = F2(
	function (loggedIn, community) {
		var shared = loggedIn.A;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white py-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto px-4')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$View$Components$disablableLink,
									{nP: !loggedIn.gz},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-primary w-full'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('button-disabled', !loggedIn.gz)
												])),
											$author$project$Route$href(
											$author$project$Route$CommunitySettingsNewsEditor($author$project$Route$CreateNews))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											shared.aw.fL('news.create'))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4 my-4')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = community.fl;
							switch (_v0.$) {
								case 3:
									var news = _v0.a;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('grid gap-4 md:grid-cols-2')
											]),
										A2(
											$elm$core$List$map,
											function (newsForCard) {
												return A3(
													$author$project$Page$Community$Settings$News$viewNewsCard,
													loggedIn,
													_Utils_eq(
														$elm$core$Maybe$Just(newsForCard.w),
														A2(
															$elm$core$Maybe$map,
															function ($) {
																return $.w;
															},
															community.nu)),
													newsForCard);
											},
											news));
								case 2:
									var err = _v0.a;
									return A2(
										$author$project$Page$fullPageGraphQLError,
										shared.aw.fL('news.error_fetching'),
										err);
								case 0:
									return $author$project$Page$fullPageLoading(shared);
								default:
									return $author$project$Page$fullPageLoading(shared);
							}
						}()
						]))
				]));
	});
var $author$project$Page$Community$Settings$News$view = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var title = t('news.title');
		var content = function () {
			var _v1 = loggedIn.pC;
			switch (_v1.$) {
				case 3:
					var community = _v1.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Page$viewHeader, loggedIn, title),
								A2($author$project$Page$Community$Settings$News$view_, loggedIn, community),
								function () {
								var _v2 = model.cL;
								if (!_v2.$) {
									return $elm$html$Html$text('');
								} else {
									var newsId = _v2.a.bG;
									return $author$project$View$Modal$toHtml(
										A2(
											$author$project$View$Modal$withFooter,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-full flex flex-col md:flex-row md:space-x-4')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('button button-secondary w-full mb-4 md:mb-0'),
																	$elm$html$Html$Events$onClick($author$project$Page$Community$Settings$News$ClosedHighlightNewsConfirmationModal)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('community.actions.form.no'))
																])),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('button button-primary w-full'),
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Community$Settings$News$ConfirmedHighlightNews(newsId))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('community.actions.form.yes'))
																]))
														]))
												]),
											A2(
												$author$project$View$Modal$withBody,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																t('news.already_highlighted'))
															])),
														A2(
														$elm$html$Html$p,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('my-2')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																t('news.replace_notice'))
															])),
														A2(
														$elm$html$Html$p,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('mb-6')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																t('news.replace_confirmation'))
															]))
													]),
												A2(
													$author$project$View$Modal$withHeader,
													t('news.highlight'),
													$author$project$View$Modal$initWith(
														{mw: $author$project$Page$Community$Settings$News$ClosedHighlightNewsConfirmationModal, nX: true})))));
								}
							}()
							]));
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				default:
					var err = _v1.a;
					return A2($author$project$Page$fullPageGraphQLError, title, err);
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$Settings$News$Editor$SubmittedForm = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Settings$News$Editor$FormOutput = F3(
	function (title, description, publicationDate) {
		return {aR: description, ch: publicationDate, fN: title};
	});
var $author$project$Form$Text$Time = 4;
var $author$project$Page$Community$Settings$News$Editor$publicationModeFromString = function (publicationMode) {
	switch (publicationMode) {
		case 'publish-immediately':
			return $elm$core$Maybe$Just(0);
		case 'schedule-publication':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Settings$News$Editor$publicationModeToString = function (publicationMode) {
	if (!publicationMode) {
		return 'publish-immediately';
	} else {
		return 'schedule-publication';
	}
};
var $author$project$Form$Validate$time = $author$project$Form$Validate$custom(
	function (timeString) {
		var _v0 = A2($elm$core$String$split, ':', timeString);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var hourString = _v0.a;
			var _v1 = _v0.b;
			var minuteString = _v1.a;
			return A2(
				$elm$core$Result$fromMaybe,
				function (_v2) {
					var t = _v2.fL;
					return t('news.editor.error.invalid_time');
				},
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (hour, minute) {
							return {nv: hour, oi: minute};
						}),
					$elm$core$String$toInt(hourString),
					$elm$core$String$toInt(minuteString)));
		} else {
			return $elm$core$Result$Err(
				function (_v3) {
					var t = _v3.fL;
					return t('news.editor.error.invalid_time');
				});
		}
	});
var $author$project$Form$DatePicker$withAbsolutePositioning = F2(
	function (absolutePositioning, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{ex: absolutePositioning});
	});
var $author$project$Page$Community$Settings$News$Editor$publicationDateForm = function (shared) {
	var translators = shared.aw;
	var t = translators.fL;
	return A4(
		$author$project$Form$withGroup,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('grid md:grid-cols-2 md:gap-8')
			]),
		$author$project$Form$introspect(
			function (values) {
				var _v2 = values.c2;
				if (!_v2) {
					return $author$project$Form$succeed(
						A2($justinmimbs$date$Date$fromPosix, shared.i2, shared.ce));
				} else {
					return A2(
						$author$project$Form$datePicker,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$required,
									A2(
										$elm$core$Basics$composeR,
										A2($author$project$Form$Validate$futureDate, shared.i2, shared.ce),
										$author$project$Form$Validate$validate(translators)))),
							qd: F2(
								function (publicationDate, input) {
									return _Utils_update(
										input,
										{ch: publicationDate});
								}),
							lW: function ($) {
								return $.ch;
							}
						},
						A2(
							$author$project$Form$DatePicker$withContainerAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-10')
								]),
							A2(
								$author$project$Form$DatePicker$withAbsolutePositioning,
								false,
								$author$project$Form$DatePicker$init(
									{
										w: 'publication-date-input',
										n$: t('news.editor.field.initial_date')
									}))));
				}
			}),
		$author$project$Form$introspect(
			function (values) {
				var _v3 = values.c2;
				if (!_v3) {
					return $author$project$Form$succeed(
						{nv: 0, oi: 0});
				} else {
					return A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$time,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$custom(
											function (time) {
												var _v4 = $author$project$Form$DatePicker$getDate(values.ch);
												if (_v4.$ === 1) {
													return $elm$core$Result$Ok(time);
												} else {
													var date = _v4.a;
													var selectedTime = $elm$time$Time$posixToMillis(
														A2(
															$justinmimbs$time_extra$Time$Extra$partsToPosix,
															shared.i2,
															{
																mX: $justinmimbs$date$Date$day(date),
																nv: time.nv,
																og: 0,
																oi: time.oi,
																ol: $justinmimbs$date$Date$month(date),
																pB: 0,
																qn: $justinmimbs$date$Date$year(date)
															}));
													return (_Utils_cmp(
														selectedTime,
														$elm$time$Time$posixToMillis(shared.ce)) < 0) ? $elm$core$Result$Err(
														function (translators_) {
															return translators_.fL('news.editor.error.future_time');
														}) : $elm$core$Result$Ok(time);
												}
											}),
										$author$project$Form$Validate$validate(translators)))),
							qd: F2(
								function (publicationTime, input) {
									return _Utils_update(
										input,
										{fu: publicationTime});
								}),
							lW: function ($) {
								return $.fu;
							}
						},
						A2(
							$author$project$Form$Text$withType,
							4,
							$author$project$Form$Text$init(
								{
									w: 'publication-time-input',
									n$: t('news.editor.field.time')
								})));
				}
			}),
		A2(
			$author$project$Form$with,
			A3(
				$author$project$Form$radio,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Page$Community$Settings$News$Editor$publicationModeFromString,
					$elm$core$Maybe$withDefault(0)),
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: $elm$core$Result$Ok,
					qd: F2(
						function (publicationMode, input) {
							return _Utils_update(
								input,
								{c2: publicationMode});
						}),
					lW: function ($) {
						return $.c2;
					}
				},
				A2(
					$author$project$Form$Radio$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-6')
						]),
					A2(
						$author$project$Form$Radio$withDirection,
						1,
						A3(
							$author$project$Form$Radio$withOption,
							1,
							$elm$html$Html$text(
								t('news.editor.field.schedule')),
							A3(
								$author$project$Form$Radio$withOption,
								0,
								$elm$html$Html$text(
									t('news.editor.field.publish_immediately')),
								$author$project$Form$Radio$init(
									{
										w: 'publication-mode-radio',
										n$: t('news.editor.field.publication_mode'),
										d5: $author$project$Page$Community$Settings$News$Editor$publicationModeToString
									})))))),
			$author$project$Form$succeed(
				F3(
					function (publicationMode, publicationDate, _v0) {
						var hour = _v0.nv;
						var minute = _v0.oi;
						if (!publicationMode) {
							return $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Just(
								A2(
									$justinmimbs$time_extra$Time$Extra$partsToPosix,
									shared.i2,
									{
										mX: $justinmimbs$date$Date$day(publicationDate),
										nv: hour,
										og: 0,
										oi: minute,
										ol: $justinmimbs$date$Date$month(publicationDate),
										pB: 0,
										qn: $justinmimbs$date$Date$year(publicationDate)
									}));
						}
					}))));
};
var $author$project$Profile$Summary$withImageSize = F2(
	function (imageSize, model) {
		return _Utils_update(
			model,
			{e4: imageSize});
	});
var $author$project$Profile$Summary$withoutName = function (model) {
	return _Utils_update(
		model,
		{hc: false});
};
var $author$project$Page$Community$Settings$News$Editor$createForm = function (loggedIn) {
	var _v0 = loggedIn.A.aw;
	var t = _v0.fL;
	return A2(
		$author$project$Form$with,
		$author$project$Page$Community$Settings$News$Editor$publicationDateForm(loggedIn.A),
		A2(
			$author$project$Form$withDecoration,
			A2(
				$elm$html$Html$hr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-5 mb-10 text-gray-500')
					]),
				_List_Nil),
			A2(
				$author$project$Form$withNoOutput,
				$author$project$Form$introspect(
					function (_v1) {
						var latestEditions = _v1.d_;
						if (latestEditions.$ === 1) {
							return $author$project$Form$succeed(0);
						} else {
							var profileSummary = latestEditions.a.g2;
							var creator = latestEditions.a.jz;
							var updatedAt = latestEditions.a.qe;
							return $author$project$Form$arbitrary(
								A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('label mb-6')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Latest editions')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex items-center')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													function (summarySubMsg) {
														return function (values) {
															return _Utils_update(
																values,
																{
																	d_: A2(
																		$elm$core$Maybe$map,
																		function (latestEdit) {
																			return _Utils_update(
																				latestEdit,
																				{
																					g2: A2($author$project$Profile$Summary$update, summarySubMsg, latestEdit.g2)
																				});
																		},
																		values.d_)
																});
														};
													},
													A4(
														$author$project$Profile$Summary$view,
														loggedIn.A.aw,
														loggedIn._,
														creator,
														A2(
															$author$project$Profile$Summary$withImageSize,
															'h-8 w-8',
															$author$project$Profile$Summary$withoutName(profileSummary)))),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-gray-900 ml-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															t('news.edited_by')),
															A2(
															$elm$html$Html$a,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('font-bold hover:underline'),
																	$author$project$Route$href(
																	$author$project$Route$Profile(creator.l8))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$elm$core$Maybe$withDefault,
																		$author$project$Eos$Account$nameToString(creator.l8),
																		creator.fj))
																])),
															A4(
															$author$project$View$Components$dateViewer,
															_List_Nil,
															function (translations) {
																return _Utils_update(
																	translations,
																	{
																		o$: t('news.edited_date'),
																		p4: $elm$core$Maybe$Nothing,
																		qo: $elm$core$Maybe$Nothing
																	});
															},
															loggedIn.A,
															updatedAt)
														]))
												]))
										])));
						}
					}),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$richText,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: function (description) {
								return _Utils_eq(description, $author$project$Markdown$empty) ? $elm$core$Result$Err(
									t('news.editor.error.description')) : $elm$core$Result$Ok(description);
							},
							qd: F2(
								function (description, input) {
									return _Utils_update(
										input,
										{aR: description});
								}),
							lW: function ($) {
								return $.aR;
							}
						},
						A2(
							$author$project$Form$RichText$withEditorContainerAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-10')
								]),
							$author$project$Form$RichText$init(
								{
									n$: t('news.editor.field.description')
								}))),
					A2(
						$author$project$Form$with,
						A2(
							$author$project$Form$textField,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: function (title) {
									return $elm$core$String$isEmpty(title) ? $elm$core$Result$Err(
										t('news.editor.error.title')) : $elm$core$Result$Ok(title);
								},
								qd: F2(
									function (title, input) {
										return _Utils_update(
											input,
											{fN: title});
									}),
								lW: function ($) {
									return $.fN;
								}
							},
							$author$project$Form$Text$init(
								{
									w: 'title-input',
									n$: t('news.editor.field.title')
								})),
						$author$project$Form$succeed($author$project$Page$Community$Settings$News$Editor$FormOutput))))));
};
var $author$project$Page$Community$Settings$News$Editor$view = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var title = t('news.editor.title');
		return {
			mJ: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-white')
					]),
				_List_fromArray(
					[
						A2($author$project$Page$viewHeader, loggedIn, title),
						function () {
						switch (model.$) {
							case 2:
								var form = model.b;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container mx-auto pt-4 pb-10')
										]),
									_List_fromArray(
										[
											A6(
											$author$project$Form$view,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('px-4')
												]),
											loggedIn.A.aw,
											function (submitButton) {
												return _List_fromArray(
													[
														A2(
														submitButton,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('button button-primary w-full')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																t('menu.save'))
															]))
													]);
											},
											$author$project$Page$Community$Settings$News$Editor$createForm(loggedIn),
											form,
											{oU: $author$project$Page$Community$Settings$News$Editor$SubmittedForm, lF: $author$project$Page$Community$Settings$News$Editor$GotFormMsg})
										]));
							case 3:
								return A2(
									$author$project$Page$fullPageNotFound,
									t('news.not_found_title'),
									t('news.not_found_description'));
							case 4:
								var err = model.a;
								return A2(
									$author$project$Page$fullPageGraphQLError,
									t('news.error_fetching'),
									err);
							case 0:
								return $author$project$Page$fullPageLoading(loggedIn.A);
							default:
								return $author$project$Page$fullPageLoading(loggedIn.A);
						}
					}()
					])),
			fN: title
		};
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$viewModal = function (body) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fixed inset-0 z-50')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$View$Components$bgNoScroll,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fixed inset-0 bg-black opacity-50')
					]),
				1),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fixed top-modal inset-x-4 mx-auto max-w-sm px-8 pt-2 text-center bg-white rounded-lg')
					]),
				body)
			]));
};
var $author$project$Page$Community$Settings$ObjectiveEditor$viewCompletion = F2(
	function (shared, completionStatus) {
		var totalNumber = $elm$core$List$length(completionStatus.a4) + $elm$core$List$length(completionStatus.bE);
		var progressWidth = $elm$core$String$fromFloat(
			$elm$core$List$length(completionStatus.a4) / totalNumber);
		return $author$project$Page$Community$Settings$ObjectiveEditor$viewModal(
			_List_fromArray(
				[
					A3($author$project$View$Components$loadingLogoWithCustomText, shared.aw, 'community.objectives.editor.completion_text', ''),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-10 mt-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black uppercase font-light text-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										shared.aw.i4,
										'community.objectives.editor.completed_progress',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'progress',
												$elm$core$String$fromInt(
													$elm$core$List$length(completionStatus.a4))),
												_Utils_Tuple2(
												'total',
												$elm$core$String$fromInt(totalNumber))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-2 relative flex mt-2 bg-gray-900 rounded-full overflow-hidden')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-green w-full transition-transform origin-left'),
											(!_Utils_eq(
											$elm$core$List$length(completionStatus.a4),
											totalNumber)) ? A2($elm$html$Html$Attributes$style, 'transform', 'scaleX(' + (progressWidth + ')')) : $elm$html$Html$Attributes$class('')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$ClosedCelebrateObjectiveModal = {$: 11};
var $author$project$Page$Community$Settings$ObjectiveEditor$hasCompletedObjective = function (model) {
	var _v0 = model.pN;
	if (_v0.$ === 1) {
		var formStatus = _v0.b;
		if (!formStatus.$) {
			return false;
		} else {
			var status = formStatus.b;
			if (status.$ === 4) {
				return true;
			} else {
				return false;
			}
		}
	} else {
		return false;
	}
};
var $author$project$View$Modal$withAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				eB: _Utils_ap(attrs, options.eB)
			});
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$viewCompletionCelebrationModal = F2(
	function (_v0, model) {
		var t = _v0.fL;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withSize,
				1,
				A2(
					$author$project$View$Modal$withAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-purple-500')
						]),
					A2(
						$author$project$View$Modal$withBody,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('min-h-full flex flex-col text-white text-center mx-auto')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src('/images/animated-sparkling-doggo.svg'),
												$elm$html$Html$Attributes$alt(''),
												$elm$html$Html$Attributes$class('px-4 max-w-sm mx-auto')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$h2,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold text-xl mt-7')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('community.objectives.editor.celebration.title'))
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-3 flex-grow')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('community.objectives.editor.celebration.completed')),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$elm$html$Html$text(
												t('community.objectives.editor.celebration.special_moment')),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$elm$html$Html$text(
												t('community.objectives.editor.celebration.cheers'))
											])),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button button-primary w-full mt-8 flex-shrink-0'),
												$author$project$Route$href($author$project$Route$CommunitySettingsObjectives)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('community.objectives.editor.celebration.return'))
											]))
									]))
							]),
						$author$project$View$Modal$initWith(
							{
								mw: $author$project$Page$Community$Settings$ObjectiveEditor$ClosedCelebrateObjectiveModal,
								nX: $author$project$Page$Community$Settings$ObjectiveEditor$hasCompletedObjective(model)
							})))));
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$ClickedCompleteObjective = {$: 5};
var $author$project$Page$Community$Settings$ObjectiveEditor$createForm = function (_v0) {
	var t = _v0.fL;
	return A2(
		$author$project$Form$richText,
		{
			ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
			o3: $elm$core$Result$Ok,
			qd: F2(
				function (newModel, _v1) {
					return newModel;
				}),
			lW: $elm$core$Basics$identity
		},
		A2(
			$author$project$Form$RichText$withPlaceholder,
			t('community.objectives.editor.description_placeholder'),
			$author$project$Form$RichText$init(
				{
					n$: t('community.objectives.editor.description_label')
				})));
};
var $author$project$Page$Community$Settings$ObjectiveEditor$viewForm = F3(
	function (loggedIn, formModel, formStatus) {
		var shared = loggedIn.A;
		var _v0 = function () {
			if (!formStatus.$) {
				var creatingStatus = formStatus.a;
				return _Utils_Tuple3(creatingStatus === 1, false, false);
			} else {
				var objective = formStatus.a;
				var editingStatus = formStatus.b;
				return _Utils_Tuple3(
					!_Utils_eq(editingStatus, $author$project$Page$Community$Settings$ObjectiveEditor$Editing),
					true,
					objective.b7);
			}
		}();
		var isDisabled = _v0.a;
		var isEdit = _v0.b;
		var isCompleted = _v0.c;
		return A6(
			$author$project$Form$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto px-4')
				]),
			shared.aw,
			function (submitButton) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-10 flex flex-col w-full gap-4 md:flex-row md:justify-between')
							]),
						_List_fromArray(
							[
								A2(
								submitButton,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button button-primary w-full md:w-48'),
										$elm$html$Html$Attributes$disabled(isDisabled || (!loggedIn.gz))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										shared.aw.fL('community.objectives.editor.submit'))
									])),
								(isEdit && (!isCompleted)) ? A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button button-secondary w-full md:w-auto md:px-6 md:ml-auto'),
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Events$onClick($author$project$Page$Community$Settings$ObjectiveEditor$ClickedCompleteObjective),
										$elm$html$Html$Attributes$disabled(isDisabled || (!loggedIn.gz))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										shared.aw.fL('community.objectives.editor.mark_as_complete'))
									])) : $elm$html$Html$text('')
							]))
					]);
			},
			$author$project$Page$Community$Settings$ObjectiveEditor$createForm(shared.aw),
			formModel,
			{oU: $author$project$Page$Community$Settings$ObjectiveEditor$ClickedSaveObjective, lF: $author$project$Page$Community$Settings$ObjectiveEditor$GotFormMsg});
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$DeniedCompleteObjective = {$: 6};
var $author$project$Page$Community$Settings$ObjectiveEditor$viewMarkAsCompletedConfirmationModal = F2(
	function (_v0, model) {
		var t = _v0.fL;
		var isVisible = function () {
			var _v1 = model.pN;
			if (((_v1.$ === 1) && (_v1.b.$ === 1)) && (_v1.b.b.$ === 2)) {
				var _v2 = _v1.b;
				var _v3 = _v2.b;
				return true;
			} else {
				return false;
			}
		}();
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withFooter,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-cancel'),
								$elm$html$Html$Events$onClick($author$project$Page$Community$Settings$ObjectiveEditor$DeniedCompleteObjective)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('community.objectives.editor.modal.cancel'))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-accept'),
								$elm$html$Html$Events$onClick($author$project$Page$Community$Settings$ObjectiveEditor$AcceptedCompleteObjective)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('community.objectives.editor.modal.confirm'))
							]))
					]),
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('community.objectives.editor.modal.body'))
						]),
					A2(
						$author$project$View$Modal$withHeader,
						t('community.objectives.editor.modal.title'),
						$author$project$View$Modal$initWith(
							{mw: $author$project$Page$Community$Settings$ObjectiveEditor$DeniedCompleteObjective, nX: isVisible})))));
	});
var $author$project$Page$Community$Settings$ObjectiveEditor$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var _v0 = shared.aw;
		var t = _v0.fL;
		var content = function () {
			var _v4 = _Utils_Tuple2(loggedIn.pC, model.pN);
			_v4$0:
			while (true) {
				_v4$1:
				while (true) {
					switch (_v4.a.$) {
						case 1:
							switch (_v4.b.$) {
								case 0:
									break _v4$0;
								case 3:
									break _v4$1;
								default:
									var _v7 = _v4.a;
									return $author$project$Page$fullPageLoading(shared);
							}
						case 0:
							switch (_v4.b.$) {
								case 0:
									break _v4$0;
								case 3:
									break _v4$1;
								default:
									var _v8 = _v4.a;
									return $author$project$Page$fullPageLoading(shared);
							}
						case 2:
							switch (_v4.b.$) {
								case 0:
									break _v4$0;
								case 3:
									break _v4$1;
								default:
									var e = _v4.a.a;
									return A2(
										$author$project$Page$fullPageGraphQLError,
										t('community.objectives.editor.error'),
										e);
							}
						default:
							switch (_v4.b.$) {
								case 0:
									break _v4$0;
								case 3:
									break _v4$1;
								case 2:
									var _v9 = _v4.b;
									return A2(
										$author$project$Page$fullPageNotFound,
										t('community.edit.unauthorized'),
										'');
								default:
									var _v10 = _v4.b;
									var formModel = _v10.a;
									var formStatus = _v10.b;
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Page$viewHeader,
												loggedIn,
												t('community.objectives.title')),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-full bg-white py-10')
													]),
												_List_fromArray(
													[
														A3($author$project$Page$Community$Settings$ObjectiveEditor$viewForm, loggedIn, formModel, formStatus)
													])),
												A2($author$project$Page$Community$Settings$ObjectiveEditor$viewMarkAsCompletedConfirmationModal, shared.aw, model),
												function () {
												if ((formStatus.$ === 1) && (formStatus.b.$ === 3)) {
													var completionStatus = formStatus.b.a;
													return A2($author$project$Page$Community$Settings$ObjectiveEditor$viewCompletion, shared, completionStatus);
												} else {
													return $elm$html$Html$text('');
												}
											}(),
												A2($author$project$Page$Community$Settings$ObjectiveEditor$viewCompletionCelebrationModal, shared.aw, model)
											]));
							}
					}
				}
				var _v6 = _v4.b;
				return A2(
					$author$project$Page$fullPageNotFound,
					t('community.objectives.editor.not_found'),
					'');
			}
			var _v5 = _v4.b;
			return $author$project$Page$fullPageLoading(shared);
		}();
		var title = function () {
			var _v2 = model.pN;
			if (_v2.$ === 1) {
				var editStatus = _v2.b;
				var action = function () {
					if (!editStatus.$) {
						return t('menu.create');
					} else {
						return t('menu.edit');
					}
				}();
				return action + (' ' + t('community.objectives.title'));
			} else {
				return '';
			}
		}();
		return {
			mJ: function () {
				var _v1 = A2(
					$krisajenkins$remotedata$RemoteData$map,
					function ($) {
						return $.bz;
					},
					loggedIn.pC);
				switch (_v1.$) {
					case 3:
						if (_v1.a) {
							return content;
						} else {
							return A2(
								$author$project$Page$fullPageNotFound,
								t('error.pageNotFound'),
								t('community.objectives.disabled.description'));
						}
					case 1:
						return $author$project$Page$fullPageLoading(shared);
					case 0:
						return $author$project$Page$fullPageLoading(shared);
					default:
						var e = _v1.a;
						return A2(
							$author$project$Page$fullPageGraphQLError,
							t('community.error_loading'),
							e);
				}
			}(),
			fN: title
		};
	});
var $author$project$Session$LoggedIn$isAccount = F2(
	function (accountName, model) {
		return _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.l8;
				},
				$author$project$Session$LoggedIn$profile(model)),
			$elm$core$Maybe$Just(accountName));
	});
var $author$project$Page$Community$Settings$Objectives$viewNewObjectiveButton = F2(
	function (loggedIn, community) {
		var shared = loggedIn.A;
		return A2($author$project$Session$LoggedIn$isAccount, community.jz, loggedIn) ? A3(
			$author$project$View$Components$disablableLink,
			{nP: !loggedIn.gz},
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button button-primary button-sm w-full md:w-64'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('button-disabled', !loggedIn.gz)
						])),
					$author$project$Route$href($author$project$Route$CommunitySettingsNewObjective)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					shared.aw.fL('community.objectives.new'))
				])) : $elm$html$Html$text('');
	});
var $author$project$Page$Community$Settings$Objectives$OpenObjective = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Settings$Objectives$GotProfileSummaryMsg = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Page$Community$Settings$Objectives$viewAction = F4(
	function (loggedIn, model, objectiveId, action) {
		var shared = loggedIn.A;
		var validationType = $author$project$Cambiatus$Enum$VerificationType$toString(action.jc);
		var tr = F2(
			function (rId, replaces) {
				return A2(loggedIn.A.aw.i4, rId, replaces);
			});
		var text_ = function (s) {
			return $elm$html$Html$text(
				shared.aw.fL(s));
		};
		var symbol = action.ad.V.as;
		var posixDeadline = $author$project$Utils$fromMaybeDateTime(action.go);
		var isClosed = A2($author$project$Action$isPastDeadline, action, shared.ce);
		var _v0 = _Utils_Tuple2(
			$elm$core$String$fromInt(action.ja),
			$elm$core$String$fromInt(action.jb));
		var usages = _v0.a;
		var usagesLeft = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-wrap sm:flex-nowrap mt-8 mb-4 relative bg-purple-500 rounded-lg px-4 py-5')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute top-0 left-0 right-0 -mt-6')
						]),
					_List_fromArray(
						[
							$author$project$Icons$flag('w-full fill-current text-green')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Markdown$view,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-white')
								]),
							action.aR),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap gap-y-4 gap-x-6 my-6 items-center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-white')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('label text-green')
												]),
											_List_fromArray(
												[
													text_('community.actions.reward')
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('uppercase')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$author$project$Eos$assetToString,
														shared.aw,
														{ji: action.fA, as: symbol}))
												]))
										])),
									(validationType === 'CLAIMABLE') ? A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('label text-green')
												]),
											_List_fromArray(
												[
													text_('community.actions.validation_reward')
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('uppercase text-white')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$author$project$Eos$assetToString,
														shared.aw,
														{ji: action.lY, as: symbol}))
												]))
										])) : $elm$html$Html$text(''),
									(_Utils_eq(action.go, $elm$core$Maybe$Nothing) && (!action.ja)) ? $elm$html$Html$text('') : A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('label text-green')
												]),
											_List_fromArray(
												[
													text_('community.actions.available_until')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													(action.ja > 0) ? A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-white')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																tr,
																'community.actions.usages',
																_List_fromArray(
																	[
																		_Utils_Tuple2('usages', usages),
																		_Utils_Tuple2('usagesLeft', usagesLeft)
																	])))
														])) : $elm$html$Html$text(''),
													function () {
													var _v1 = action.go;
													if (!_v1.$) {
														return A4(
															$author$project$View$Components$dateViewer,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('capitalize text-white')
																]),
															$elm$core$Basics$identity,
															shared,
															posixDeadline);
													} else {
														return $elm$html$Html$text('');
													}
												}()
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-auto')
										]),
									_List_fromArray(
										[
											action.b7 ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('tag bg-green')
												]),
											_List_fromArray(
												[
													text_('community.actions.completed')
												])) : (isClosed ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('tag bg-gray-500 text-red')
												]),
											_List_fromArray(
												[
													text_('community.actions.closed')
												])) : $elm$html$Html$text(''))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap justify-between items-end')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full sm:w-4/5')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('label text-green')
												]),
											_List_fromArray(
												[
													text_('community.actions.verifiers')
												])),
											(validationType === 'AUTOMATIC') ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex items-center')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-white')
														]),
													_List_fromArray(
														[
															text_('community.actions.automatic_analyzers')
														])),
													$author$project$Icons$exclamation('ml-2 text-white fill-current')
												])) : A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex gap-4 flex-wrap')
												]),
											A2(
												$elm$core$List$indexedMap,
												F2(
													function (validatorIndex, u) {
														var _v2 = A2(
															$elm$core$Maybe$andThen,
															$elm_community$list_extra$List$Extra$getAt(validatorIndex),
															A2($pzp1997$assoc_list$AssocList$get, action.w, model.c1));
														if (_v2.$ === 1) {
															return $elm$html$Html$text('');
														} else {
															var validatorSummary = _v2.a;
															var validatorId = A2(
																$elm$core$String$join,
																'-',
																A2(
																	$elm$core$List$cons,
																	'validator',
																	A2(
																		$elm$core$List$map,
																		$elm$core$String$fromInt,
																		_List_fromArray(
																			[
																				$author$project$Action$objectiveIdToInt(objectiveId),
																				$author$project$Action$idToInt(action.w),
																				validatorIndex
																			]))));
															return A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('action-verifier relative'),
																		$elm$html$Html$Attributes$id(validatorId)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$map,
																		A2($author$project$Page$Community$Settings$Objectives$GotProfileSummaryMsg, action.w, validatorIndex),
																		A4(
																			$author$project$Profile$Summary$view,
																			shared.aw,
																			loggedIn._,
																			u,
																			A2($author$project$Profile$Summary$withRelativeSelector, '#' + validatorId, validatorSummary)))
																	]));
														}
													}),
												action.lV))
										])),
									A3(
									$author$project$View$Components$disablableLink,
									{nP: action.ad.b7 || (!loggedIn.gz)},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-primary button-sm w-full sm:w-40 mt-8 focus:ring-offset-indigo-500'),
											$author$project$Route$href(
											A2(
												$author$project$Route$CommunitySettingsEditAction,
												$author$project$Action$objectiveIdToInt(objectiveId),
												$author$project$Action$idToInt(action.w))),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('button-disabled', action.ad.b7 || (!loggedIn.gz))
												]))
										]),
									_List_fromArray(
										[
											text_('community.actions.edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Community$Settings$Objectives$viewObjective = F3(
	function (loggedIn, model, objective) {
		var shared = loggedIn.A;
		var text_ = function (s) {
			return $elm$html$Html$text(
				shared.aw.fL(s));
		};
		var isOpen = function () {
			var _v0 = model.d4;
			if (!_v0.$) {
				var obj = _v0.a;
				return _Utils_eq(obj, objective.w);
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white rounded mt-4 hover:shadow')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('p-4 sm:px-6 cursor-pointer rounded flex justify-between'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('pb-0', isOpen)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Page$Community$Settings$Objectives$OpenObjective(objective.w))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('overflow-hidden')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Markdown$view,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-sm'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('truncate-children', !isOpen)
														]))
												]),
											objective.aR),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-gray-900 text-sm uppercase mt-2')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														shared.aw.i4,
														'community.objectives.action_count',
														_List_fromArray(
															[
																_Utils_Tuple2(
																'actions',
																$elm$core$String$fromInt(
																	$elm$core$List$length(objective.mb)))
															])))
												])),
											objective.b7 ? A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bg-green rounded-sm text-center inline-block px-7 py-1 text-sm text-black uppercase mt-4 tracking-wide')
												]),
											_List_fromArray(
												[
													text_('community.objectives.complete')
												])) : $elm$html$Html$text('')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('h-8')
										]),
									_List_fromArray(
										[
											isOpen ? $author$project$Icons$arrowDown('rotate-180') : $author$project$Icons$arrowDown('')
										]))
								]))
						])),
					isOpen ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('p-4 sm:px-6 pt-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap mt-2')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$View$Components$disablableLink,
									{nP: objective.b7 || (!loggedIn.gz)},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-secondary button-sm w-full sm:w-48 mt-2 px-1 sm:mr-4'),
											$author$project$Route$href(
											$author$project$Route$CommunitySettingsEditObjective(
												$author$project$Action$objectiveIdToInt(objective.w))),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('button-disabled', objective.b7 || (!loggedIn.gz))
												]))
										]),
									_List_fromArray(
										[
											text_('community.objectives.edit')
										])),
									A3(
									$author$project$View$Components$disablableLink,
									{nP: objective.b7 || (!loggedIn.gz)},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-secondary button-sm w-full sm:w-48 mt-4 sm:mt-2 px-1 mb-4'),
											$author$project$Route$href(
											$author$project$Route$CommunitySettingsNewAction(
												$author$project$Action$objectiveIdToInt(objective.w))),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('button-disabled', objective.b7 || (!loggedIn.gz))
												]))
										]),
									_List_fromArray(
										[
											text_('community.actions.new')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A3($author$project$Page$Community$Settings$Objectives$viewAction, loggedIn, model, objective.w),
								objective.mb))
						])) : $elm$html$Html$text('')
				]));
	});
var $author$project$Page$Community$Settings$Objectives$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var t = shared.aw.fL;
		var title = t('community.objectives.title_plural');
		var content = function () {
			var _v0 = _Utils_Tuple2(
				A2(
					$author$project$Community$getField,
					loggedIn.pC,
					function ($) {
						return $.cV;
					}),
				model.pN);
			switch (_v0.a.$) {
				case 3:
					switch (_v0.b) {
						case 1:
							var _v1 = _v0.a.a;
							var community = _v1.a;
							var objectives = _v1.b;
							var _v2 = _v0.b;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Page$viewHeader,
										loggedIn,
										t('community.objectives.title_plural')),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('container mx-auto px-4 my-10')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex justify-end mb-10')
													]),
												_List_fromArray(
													[
														A2($author$project$Page$Community$Settings$Objectives$viewNewObjectiveButton, loggedIn, community)
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												A2(
													$elm$core$List$map,
													A2($author$project$Page$Community$Settings$Objectives$viewObjective, loggedIn, model),
													$elm$core$List$reverse(
														A2(
															$elm$core$List$sortBy,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.w;
																},
																$author$project$Action$objectiveIdToInt),
															objectives))))
											]))
									]));
						case 2:
							var _v3 = _v0.b;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Page$viewHeader, loggedIn, title),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												shared.aw.fL('community.edit.unauthorized'))
											]))
									]));
						default:
							var _v6 = _v0.b;
							return $author$project$Page$fullPageLoading(shared);
					}
				case 2:
					if (!_v0.a.a.$) {
						var e = _v0.a.a.a;
						return A2(
							$author$project$Page$fullPageGraphQLError,
							t('community.objectives.title_plural'),
							e);
					} else {
						var e = _v0.a.a.a;
						return A2(
							$author$project$Page$fullPageGraphQLError,
							t('community.objectives.title_plural'),
							e);
					}
				case 1:
					var _v4 = _v0.a;
					return $author$project$Page$fullPageLoading(shared);
				default:
					var _v5 = _v0.a;
					return $author$project$Page$fullPageLoading(shared);
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$Settings$Settings$settingCard = F4(
	function (title, action, description, route) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col justify-around bg-white w-full h-32 rounded px-4 pt-3 pb-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-semibold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-sm text-gray-900 uppercase')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(description)
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(route),
							$elm$html$Html$Attributes$class('button button-primary w-full h-8')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(action)
						]))
				]));
	});
var $author$project$Page$Community$Settings$Settings$viewSettingsList = F2(
	function (shared, community) {
		var _v0 = shared.aw;
		var t = _v0.fL;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col container my-4 mx-auto gap-4 px-4')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Page$Community$Settings$Settings$settingCard,
					t('settings.community_info.title'),
					t('menu.edit'),
					t('settings.community_info.description'),
					$author$project$Route$CommunitySettingsInfo),
					A4(
					$author$project$Page$Community$Settings$Settings$settingCard,
					t('settings.community_currency.title'),
					t('menu.edit'),
					$author$project$Eos$symbolToSymbolCodeString(community.as),
					$author$project$Route$CommunitySettingsCurrency),
					community.bz ? A4(
					$author$project$Page$Community$Settings$Settings$settingCard,
					t('settings.actions.title'),
					t('menu.edit'),
					'',
					$author$project$Route$CommunitySettingsObjectives) : $elm$html$Html$text(''),
					A4(
					$author$project$Page$Community$Settings$Settings$settingCard,
					t('settings.shop.categories.title'),
					t('menu.edit'),
					t('settings.shop.categories.description'),
					$author$project$Route$CommunitySettingsShopCategories),
					A4(
					$author$project$Page$Community$Settings$Settings$settingCard,
					t('settings.contacts.title'),
					t('menu.edit'),
					t('settings.contacts.description'),
					$author$project$Route$CommunitySettingsContacts),
					A4(
					$author$project$Page$Community$Settings$Settings$settingCard,
					t('settings.features.title'),
					t('menu.edit'),
					t('settings.features.description'),
					$author$project$Route$CommunitySettingsFeatures),
					$elm_community$maybe_extra$Maybe$Extra$isJust(community.mM) ? A4(
					$author$project$Page$Community$Settings$Settings$settingCard,
					t('sponsorship.title'),
					t('menu.edit'),
					t('sponsorship.description'),
					$author$project$Route$CommunitySettingsSponsorship) : $elm$html$Html$text(''),
					community.dH ? A4(
					$author$project$Page$Community$Settings$Settings$settingCard,
					t('news.title'),
					t('menu.edit'),
					t('news.description'),
					$author$project$Route$CommunitySettingsNews) : $elm$html$Html$text('')
				]));
	});
var $author$project$Page$Community$Settings$Settings$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var title = shared.aw.fL('community.edit.title');
		var content = function () {
			var headerText = title;
			var header = A2($author$project$Page$viewHeader, loggedIn, headerText);
			var _v0 = _Utils_Tuple2(loggedIn.pC, model);
			_v0$0:
			while (true) {
				switch (_v0.a.$) {
					case 1:
						if (!_v0.b) {
							break _v0$0;
						} else {
							var _v2 = _v0.a;
							return $author$project$Page$fullPageLoading(shared);
						}
					case 0:
						if (!_v0.b) {
							break _v0$0;
						} else {
							var _v3 = _v0.a;
							return $author$project$Page$fullPageLoading(shared);
						}
					case 2:
						if (!_v0.b) {
							break _v0$0;
						} else {
							var e = _v0.a.a;
							return A2($author$project$Page$fullPageGraphQLError, headerText, e);
						}
					default:
						switch (_v0.b) {
							case 0:
								break _v0$0;
							case 1:
								var community = _v0.a.a;
								var _v4 = _v0.b;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											header,
											A2($author$project$Page$Community$Settings$Settings$viewSettingsList, shared, community)
										]));
							default:
								var _v5 = _v0.b;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Page$viewHeader, loggedIn, title),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('card')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													shared.aw.fL('community.edit.unauthorized'))
												]))
										]));
						}
				}
			}
			var _v1 = _v0.b;
			return $author$project$Page$fullPageLoading(shared);
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$Settings$Shop$Categories$viewPageContainer = F3(
	function (translators, _v0, model) {
		var children = _v0.hD;
		var modals = _v0.$9;
		var isActionsDropdownOpen = function () {
			var _v1 = model.x;
			switch (_v1.$) {
				case 0:
					return false;
				case 2:
					return true;
				default:
					return true;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto sm:px-4 sm:mt-6 pb-40 overflow-x-hidden')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white container mx-auto pt-6 pb-7 w-full px-4 sm:px-6 sm:rounded sm:shadow-lg lg:w-2/3'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('overflow-x-scroll', !isActionsDropdownOpen),
									_Utils_Tuple2('overflow-y-visible', isActionsDropdownOpen)
								]))
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-900 mb-10')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									translators.fL('shop.categories.admin_page_description'))
								])),
						children)),
				modals));
	});
var $author$project$Page$Community$Settings$Shop$Categories$viewLoading = F2(
	function (translators, model) {
		var viewBar = function (attributes) {
			return A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('animate-skeleton-loading max-w-full h-8 rounded-sm mt-2'),
					attributes),
				_List_Nil);
		};
		return A3(
			$author$project$Page$Community$Settings$Shop$Categories$viewPageContainer,
			translators,
			{
				hD: _List_fromArray(
					[
						viewBar(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-0')
							])),
						viewBar(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-4')
							])),
						viewBar(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-4')
							])),
						viewBar(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('!mt-6')
							])),
						viewBar(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('!mt-6')
							])),
						viewBar(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-4')
							])),
						viewBar(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-8')
							])),
						viewBar(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('!mt-6')
							]))
					]),
				$9: _List_Nil
			},
			model);
	});
var $author$project$Page$Community$Settings$Shop$Categories$ClickedAddCategory = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$OnRoot = {$: 1};
var $author$project$Dnd$DragLeft = function (a) {
	return {$: 3, a: a};
};
var $author$project$Dnd$onDragLeave = function (dropZoneId) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'dragleave',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(
				$author$project$Dnd$DragLeft(dropZoneId),
				true)));
};
var $author$project$Dnd$DraggedOverInternal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Dnd$onDragOver = function (dropZoneId) {
	return A2(
		$elm$html$Html$Events$custom,
		'dragover',
		$elm$json$Json$Decode$succeed(
			{
				of: $author$project$Dnd$DraggedOverInternal(dropZoneId),
				k3: true,
				lw: true
			}));
};
var $author$project$Dnd$DroppedOn = function (a) {
	return {$: 2, a: a};
};
var $author$project$Dnd$onDrop = function (dropZoneId) {
	return A2(
		$elm$html$Html$Events$custom,
		'drop',
		$elm$json$Json$Decode$succeed(
			{
				of: $author$project$Dnd$DroppedOn(dropZoneId),
				k3: true,
				lw: true
			}));
};
var $author$project$Dnd$dropZone = F2(
	function (dropZoneId, toMsg) {
		return A2(
			$elm$core$List$map,
			$elm$html$Html$Attributes$map(toMsg),
			_List_fromArray(
				[
					$author$project$Dnd$onDrop(dropZoneId),
					$author$project$Dnd$onDragOver(dropZoneId),
					$author$project$Dnd$onDragLeave(dropZoneId)
				]));
	});
var $author$project$Dnd$getDraggingElement = function (_v0) {
	var model = _v0;
	return model.dy;
};
var $author$project$Page$Community$Settings$Shop$Categories$ClosedMetadataModal = {$: 24};
var $author$project$Page$Community$Settings$Shop$Categories$SubmittedMetadataForm = function (a) {
	return {$: 23, a: a};
};
var $author$project$Form$isDisabled = function (_v0) {
	var model = _v0;
	return model.b_;
};
var $author$project$Page$Community$Settings$Shop$Categories$ClickedRemoveMetaKeyword = function (a) {
	return {$: 32, a: a};
};
var $author$project$Dnd$draggableAttr = $elm$html$Html$Attributes$draggable('true');
var $author$project$Dnd$StoppedDragging = {$: 1};
var $author$project$Dnd$onDragEnd = A2(
	$elm$html$Html$Events$on,
	'dragend',
	$elm$json$Json$Decode$succeed($author$project$Dnd$StoppedDragging));
var $author$project$Dnd$StartedDragging = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dnd$onDragStart = function (draggableId) {
	return A2(
		$elm$html$Html$Events$on,
		'dragstart',
		$elm$json$Json$Decode$succeed(
			$author$project$Dnd$StartedDragging(draggableId)));
};
var $author$project$Dnd$draggable = F2(
	function (draggableId, toMsg) {
		return A2(
			$elm$core$List$map,
			$elm$html$Html$Attributes$map(toMsg),
			_List_fromArray(
				[
					$author$project$Dnd$onDragStart(draggableId),
					$author$project$Dnd$onDragEnd,
					$author$project$Dnd$draggableAttr
				]));
	});
var $author$project$Form$unsafeArbitrary = function (html) {
	return function (_v0) {
		return {
			e: _List_fromArray(
				[
					{
					na: $elm$core$Maybe$Nothing,
					nV: false,
					Z: $author$project$Form$UnsafeArbitrary(html),
					ax: 0
				}
				]),
			g: $author$project$OptionalResult$OptNothing
		};
	};
};
var $author$project$Page$Community$Settings$Shop$Categories$keywordsForm = function (translators) {
	var viewKeyword = F3(
		function (dnd, index, keyword) {
			return A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('bg-green/50 border border-green px-3 py-2 rounded-full text-sm flex items-center text-black cursor-move transition-colors'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'border-dashed border-black !bg-green/80',
									_Utils_eq(
										$author$project$Dnd$getDraggingOverElement(dnd),
										$elm$core$Maybe$Just(index))),
									_Utils_Tuple2(
									'!bg-green/80',
									_Utils_eq(
										$author$project$Dnd$getDraggingElement(dnd),
										$elm$core$Maybe$Just(index)))
								])),
						_Utils_ap(
							A2($author$project$Dnd$draggable, index, $author$project$Page$Community$Settings$Shop$Categories$GotKeywordDndMsg),
							_Utils_eq(
								$author$project$Dnd$getDraggingElement(dnd),
								$elm$core$Maybe$Just(index)) ? _List_Nil : A2($author$project$Dnd$dropZone, index, $author$project$Page$Community$Settings$Shop$Categories$GotKeywordDndMsg)))),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('uppercase mr-3')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(keyword)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Events$onClick(
								$author$project$Page$Community$Settings$Shop$Categories$ClickedRemoveMetaKeyword(index)),
								$elm$html$Html$Attributes$class('hover:text-red')
							]),
						_List_fromArray(
							[
								$author$project$Icons$close('w-3 h-3 fill-current')
							]))
					]));
		});
	return A2(
		$author$project$Form$withNoOutput,
		$author$project$Form$introspect(
			function (values) {
				return $author$project$Form$unsafeArbitrary(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-wrap mb-10 gap-2')
							]),
						A2(
							$elm$core$List$indexedMap,
							viewKeyword(values.fb),
							values.ij)));
			}),
		A2(
			$author$project$Form$withNoOutput,
			A4(
				$author$project$Form$withGroup,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex mb-2')
					]),
				A2(
					$author$project$Form$textField,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: $elm$core$Result$Ok,
						qd: F2(
							function (metaKeyword, value) {
								return _Utils_update(
									value,
									{cc: metaKeyword});
							}),
						lW: function ($) {
							return $.cc;
						}
					},
					A2(
						$author$project$Form$Text$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-0 w-full')
							]),
						$author$project$Form$Text$init(
							{
								w: 'meta-keyword-input',
								n$: translators.fL('shop.categories.fields.meta.keywords')
							}))),
				$author$project$Form$arbitrary(
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('button button-secondary flex-shrink-0 h-12 ml-4 mt-auto w-auto px-6'),
								$elm$html$Html$Events$onClick(
								function (values) {
									return ($elm$core$String$isEmpty(values.cc) || A2($elm$core$List$member, values.cc, values.ij)) ? values : _Utils_update(
										values,
										{
											cc: '',
											ij: A2($elm$core$List$cons, values.cc, values.ij)
										});
								})
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								translators.fL('menu.add'))
							]))),
				$author$project$Form$succeed($elm$core$Basics$always)),
			$author$project$Form$introspect(
				function (values) {
					return $author$project$Form$succeed(values.ij);
				})));
};
var $author$project$Icons$image = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('32'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M27.3897 8.32158L21.9872 2.90308C21.648 2.35116 21.0536 2.01092 20.4094 2H5.89339C4.8477 2 4 2.85421 4 3.90792V28.0749C4 29.1286 4.8477 29.9828 5.89339 29.9828H26.0896C26.6111 30.0584 27.1375 29.8818 27.5101 29.5064C27.8827 29.1309 28.0579 28.6005 27.983 28.0749V10.2677C28.0316 9.56727 27.8202 8.87366 27.3897 8.32158ZM22.3028 5.89216L24.7516 8.35974H22.3028V5.89216ZM20.3463 3.90792V3.94608L20.3842 3.98424V10.2677H26.0643V17.0726L22.7446 15.1647C22.3575 14.9418 21.8686 15.0213 21.5707 15.3554L16.3134 21.2064L11.8954 19.5529C11.5484 19.4245 11.159 19.5115 10.8983 19.7755L5.88708 24.8251V3.90792H20.3463ZM5.89339 28.0749V27.5025H5.93126L11.8134 21.5753L16.2881 23.2415C16.6504 23.3761 17.0575 23.2754 17.3169 22.9871L22.4921 17.2252L26.0896 19.2985V28.0749H5.89339Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M11.5798 15.3555C13.3227 15.3555 14.7355 13.9318 14.7355 12.1756C14.7355 10.4194 13.3227 8.99571 11.5798 8.99571C9.83703 8.99571 8.42419 10.4194 8.42419 12.1756C8.42419 13.9318 9.83703 15.3555 11.5798 15.3555ZM11.5798 10.9036C12.277 10.9036 12.8421 11.4731 12.8421 12.1756C12.8421 12.8781 12.277 13.4475 11.5798 13.4475C10.8827 13.4475 10.3176 12.8781 10.3176 12.1756C10.3176 11.4731 10.8827 10.9036 11.5798 10.9036Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Community$Settings$Shop$Categories$viewShareCategoryPreview = F4(
	function (translators, community, category, values) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							translators.fL('shop.categories.metadata.preview'))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							translators.fL('shop.categories.metadata.preview_text'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('isolate mr-3 z-10 ml-auto w-full sm:w-3/4 md:w-2/3 border border-gray-300 rounded-large relative before:absolute before:bg-white before:border-t before:border-r before:border-gray-300 before:-top-px before:rounded-br-super before:rounded-tr-sm before:-right-2 before:w-8 before:h-4 before:-z-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white p-1 rounded-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex w-full bg-gray-100 rounded-large')
										]),
									_List_fromArray(
										[
											function () {
											var _v0 = A2($elm_community$maybe_extra$Maybe$Extra$or, category.p, category.h2);
											if (_v0.$ === 1) {
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('bg-gray-200 p-6 rounded-l-large w-1/4 flex-shrink-0 grid place-items-center')
														]),
													_List_fromArray(
														[
															$author$project$Icons$image('')
														]));
											} else {
												var previewImage = _v0.a;
												return A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src(previewImage),
															$elm$html$Html$Attributes$alt(''),
															$elm$html$Html$Attributes$class('bg-gray-100 rounded-l-large w-1/4 flex-shrink-0 object-contain')
														]),
													_List_Nil);
											}
										}(),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('py-2 mx-4 w-full')
												]),
											_List_fromArray(
												[
													$elm$core$String$isEmpty(values.ik) ? A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-3/4 bg-gray-300 rounded font-bold')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('opacity-0 pointer-events-none'),
																	$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('height')
																]))
														])) : A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('font-bold line-clamp-1')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(values.ik)
														])),
													$elm$core$String$isEmpty(values.ii) ? A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-full bg-gray-200 rounded mt-1 text-sm')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('opacity-0 pointer-events-none'),
																	$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('height')
																]))
														])) : A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-sm mt-1 line-clamp-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(values.ii),
															$elm$html$Html$text('. '),
															$elm$html$Html$text(
															A2($elm$core$String$join, ', ', values.ij))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-sm opacity-70 mt-2 mb-4')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(community.pP)
														]))
												]))
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-2 mb-1 ml-2 text-blue-600')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('https://' + community.pP)
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Community$Settings$Shop$Categories$metadataForm = F3(
	function (translators, community, category) {
		return A2(
			$author$project$Form$withNoOutput,
			$author$project$Form$introspect(
				function (values) {
					return $author$project$Form$arbitrary(
						A4($author$project$Page$Community$Settings$Shop$Categories$viewShareCategoryPreview, translators, community, category, values));
				}),
			A2(
				$author$project$Form$with,
				$author$project$Page$Community$Settings$Shop$Categories$keywordsForm(translators),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$stringLongerThan(3),
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$stringShorterThan(100),
										$author$project$Form$Validate$validate(translators)))),
							qd: F2(
								function (newMetaDescription, values) {
									return _Utils_update(
										values,
										{ii: newMetaDescription});
								}),
							lW: function ($) {
								return $.ii;
							}
						},
						$author$project$Form$Text$init(
							{
								w: 'meta-description-input',
								n$: translators.fL('shop.categories.fields.meta.description')
							})),
					A2(
						$author$project$Form$with,
						A2(
							$author$project$Form$textField,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$succeed,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$stringLongerThan(3),
										A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$stringShorterThan(40),
											$author$project$Form$Validate$validate(translators)))),
								qd: F2(
									function (newMetaTitle, values) {
										return _Utils_update(
											values,
											{ik: newMetaTitle});
									}),
								lW: function ($) {
									return $.ik;
								}
							},
							$author$project$Form$Text$init(
								{
									w: 'meta-title-input',
									n$: translators.fL('shop.categories.fields.meta.title')
								})),
						$author$project$Form$succeed(
							F3(
								function (metaTitle, metaDescription, metaKeywords) {
									return {w: category.w, ii: metaDescription, ij: metaKeywords, ik: metaTitle};
								}))))));
	});
var $author$project$Form$viewWithoutSubmit = F6(
	function (formAttrs, translators, footer, form, _v0, _v1) {
		var model = _v0;
		var toMsg = _v1.lF;
		return A2(
			$elm$html$Html$form,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$novalidate(true),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onSubmit(
						toMsg($author$project$Form$NoOp)),
					formAttrs)),
			_Utils_ap(
				A5(
					$author$project$Form$viewFields,
					translators,
					form,
					model,
					toMsg,
					function (_v2) {
						return toMsg($author$project$Form$NoOp);
					}),
				footer(model.o)));
	});
var $author$project$View$Modal$withHeaderElement = F2(
	function (header, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				e2: $elm$core$Maybe$Just(header)
			});
	});
var $author$project$Page$Community$Settings$Shop$Categories$viewCategoryMetadataModal = F4(
	function (translators, community, category, formModel) {
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withSize,
				1,
				A2(
					$author$project$View$Modal$withFooter,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col w-full sm:flex-row gap-4 items-center justify-center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-secondary w-full sm:w-40'),
											$elm$html$Html$Events$onClick($author$project$Page$Community$Settings$Shop$Categories$ClosedMetadataModal),
											$elm$html$Html$Attributes$disabled(
											$author$project$Form$isDisabled(formModel))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											translators.fL('menu.cancel'))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-primary w-full sm:w-40'),
											$elm$html$Html$Events$onClick(
											A3(
												$author$project$Form$parse,
												A3($author$project$Page$Community$Settings$Shop$Categories$metadataForm, translators, community, category),
												formModel,
												{oM: $author$project$Page$Community$Settings$Shop$Categories$GotMetadataFormMsg, oV: $author$project$Page$Community$Settings$Shop$Categories$SubmittedMetadataForm})),
											$elm$html$Html$Attributes$disabled(
											$author$project$Form$isDisabled(formModel))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											translators.fL('menu.save'))
										]))
								]))
						]),
					A2(
						$author$project$View$Modal$withBody,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-6 md:px-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										translators.fL('shop.categories.metadata.guidance'))
									])),
								A6(
								$author$project$Form$viewWithoutSubmit,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-2 md:px-2')
									]),
								translators,
								function (_v0) {
									return _List_Nil;
								},
								A3($author$project$Page$Community$Settings$Shop$Categories$metadataForm, translators, community, category),
								formModel,
								{lF: $author$project$Page$Community$Settings$Shop$Categories$GotMetadataFormMsg})
							]),
						A2(
							$author$project$View$Modal$withHeaderElement,
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('md:px-2 md:mt-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										translators.fL('shop.categories.metadata.title'))
									])),
							$author$project$View$Modal$initWith(
								{mw: $author$project$Page$Community$Settings$Shop$Categories$ClosedMetadataModal, nX: true}))))));
	});
var $author$project$Page$Community$Settings$Shop$Categories$ClosedCategoryModal = {$: 6};
var $author$project$Page$Community$Settings$Shop$Categories$SubmittedUpdateCategoryForm = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$iconForm = F2(
	function (translators, fieldId) {
		return $author$project$Form$optional(
			A2(
				$author$project$Form$file,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: $elm$core$Result$Ok,
					aw: translators,
					qd: F2(
						function (newIcon, values) {
							return _Utils_update(
								values,
								{p: newIcon});
						}),
					lW: function ($) {
						return $.p;
					}
				},
				$author$project$Form$File$withEditIconOverlay(
					A2(
						$author$project$Form$File$withContainerAttributes,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-10')
							]),
						A2(
							$author$project$Form$File$withImageCropperAttributes,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('rounded-full')
								]),
							A2(
								$author$project$Form$File$withAddImagesContainerAttributes,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mx-auto w-20 h-20')
									]),
								A2(
									$author$project$Form$File$withAddImagesView,
									$author$project$Form$File$defaultAddImagesView(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('!rounded-full w-20 h-20')
											])),
									A2(
										$author$project$Form$File$withEntryContainerAttributes,
										function (_v0) {
											return _List_fromArray(
												[
													$elm$html$Html$Attributes$class('mx-auto rounded-full w-20 h-20')
												]);
										},
										A2(
											$author$project$Form$File$withImageClass,
											'object-cover rounded-full w-20 h-20',
											$author$project$Form$File$init(
												{w: fieldId}))))))))));
	});
var $author$project$Page$Community$Settings$Shop$Categories$imageForm = F2(
	function (translators, fieldId) {
		return A2(
			$author$project$Form$withNoOutput,
			$author$project$Form$arbitrary(
				A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-2 text-gray-900')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							translators.fL('shop.categories.form.image_guidance'))
						]))),
			$author$project$Form$optional(
				A2(
					$author$project$Form$file,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: $elm$core$Result$Ok,
						aw: translators,
						qd: F2(
							function (newImage, values) {
								return _Utils_update(
									values,
									{h2: newImage});
							}),
						lW: function ($) {
							return $.h2;
						}
					},
					$author$project$Form$File$withEditIconOverlay(
						A2(
							$author$project$Form$File$withImageClass,
							'rounded-md',
							A2(
								$author$project$Form$File$withAddImagesView,
								$author$project$Form$File$defaultAddImagesView(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('!w-full min-h-48')
										])),
								A2(
									$author$project$Form$File$withAddImagesContainerAttributes,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('!w-full')
										]),
									A2(
										$author$project$Form$File$withContainerAttributes,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full')
											]),
										A2(
											$author$project$Form$File$withLabel,
											translators.fL('shop.categories.fields.image'),
											$author$project$Form$File$init(
												{w: fieldId}))))))))));
	});
var $author$project$Utils$slugify = function (input) {
	return $hecrj$elm_slug$Slug$generate(
		A3(
			$elm$core$String$replace,
			'õ',
			'o',
			A3(
				$elm$core$String$replace,
				'ó',
				'o',
				A3(
					$elm$core$String$replace,
					'ñ',
					'n',
					A3(
						$elm$core$String$replace,
						'í',
						'i',
						A3(
							$elm$core$String$replace,
							'é',
							'e',
							A3(
								$elm$core$String$replace,
								'ç',
								'c',
								A3(
									$elm$core$String$replace,
									'à',
									'a',
									A3(
										$elm$core$String$replace,
										'ã',
										'a',
										A3($elm$core$String$replace, 'á', 'a', input))))))))));
};
var $author$project$Page$Community$Settings$Shop$Categories$nameAndSlugForm = F2(
	function (translators, _v0) {
		var nameFieldId = _v0.iq;
		return A2(
			$author$project$Form$with,
			$author$project$Form$introspect(
				function (_v3) {
					var name = _v3.fj;
					var _v4 = $author$project$Utils$slugify(name);
					if (_v4.$ === 1) {
						return $author$project$Form$arbitrary(
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-10')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$View$Components$label,
										_List_Nil,
										{
											n0: translators.fL('shop.categories.fields.slug'),
											pZ: nameFieldId
										}),
										$elm$core$String$isEmpty(name) ? A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-400 italic')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												translators.fL('shop.categories.form.insert_name'))
											])) : A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('form-error')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														translators.fL('shop.categories.form.invalid_slug'))
													])),
												$author$project$View$Components$tooltip(
												{
													mG: 'self-end',
													nx: 'text-red',
													of: translators.fL('shop.categories.form.invalid_slug_tooltip')
												})
											]))
									])));
					} else {
						var slug = _v4.a;
						return A2(
							$author$project$Form$arbitraryWith,
							slug,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-10')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$View$Components$label,
										_List_Nil,
										{
											n0: translators.fL('shop.categories.fields.slug'),
											pZ: nameFieldId
										}),
										$elm$html$Html$text(
										$hecrj$elm_slug$Slug$toString(slug))
									])));
					}
				}),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$textField,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$succeed,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$stringLongerThan(2),
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$custom(
										function (name) {
											var _v1 = $author$project$Utils$slugify(name);
											if (!_v1.$) {
												return $elm$core$Result$Ok(name);
											} else {
												return $elm$core$Result$Err(
													function (_v2) {
														return '';
													});
											}
										}),
									$author$project$Form$Validate$validate(translators)))),
						qd: F2(
							function (newName, values) {
								return _Utils_update(
									values,
									{fj: newName});
							}),
						lW: function ($) {
							return $.fj;
						}
					},
					A2(
						$author$project$Form$Text$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-4')
							]),
						$author$project$Form$Text$init(
							{
								w: nameFieldId,
								n$: translators.fL('shop.categories.fields.name')
							}))),
				$author$project$Form$succeed(
					F2(
						function (name, slug) {
							return {fj: name, iP: slug};
						}))));
	});
var $author$project$Form$RichText$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mF: _Utils_ap(options.mF, attrs)
			});
	});
var $author$project$Page$Community$Settings$Shop$Categories$updateCategoryForm = F2(
	function (translators, id) {
		return A2(
			$author$project$Form$with,
			A2($author$project$Page$Community$Settings$Shop$Categories$imageForm, translators, 'update-category-image'),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$richText,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$succeed,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$markdownLongerThan(3),
								$author$project$Form$Validate$validate(translators))),
						qd: F2(
							function (newDescription, values) {
								return _Utils_update(
									values,
									{aR: newDescription});
							}),
						lW: function ($) {
							return $.aR;
						}
					},
					A2(
						$author$project$Form$RichText$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-10')
							]),
						$author$project$Form$RichText$init(
							{
								n$: translators.fL('shop.categories.fields.description')
							}))),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Page$Community$Settings$Shop$Categories$nameAndSlugForm,
						translators,
						{iq: 'update-category-name'}),
					A2(
						$author$project$Form$with,
						A2($author$project$Page$Community$Settings$Shop$Categories$iconForm, translators, 'update-category-icon'),
						$author$project$Form$succeed(
							F4(
								function (icon, _v0, description, image) {
									var name = _v0.fj;
									var slug = _v0.iP;
									return {aR: description, p: icon, w: id, h2: image, fj: name, iP: slug};
								}))))));
	});
var $author$project$Page$Community$Settings$Shop$Categories$viewCategoryModal = F3(
	function (translators, category, formModel) {
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withSize,
				1,
				A2(
					$author$project$View$Modal$withFooter,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col w-full sm:flex-row gap-4 items-center justify-center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-secondary w-full sm:w-40'),
											$elm$html$Html$Events$onClick($author$project$Page$Community$Settings$Shop$Categories$ClosedCategoryModal),
											$elm$html$Html$Attributes$disabled(
											$author$project$Form$isDisabled(formModel))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											translators.fL('menu.cancel'))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-primary w-full sm:w-40'),
											$elm$html$Html$Events$onClick(
											A3(
												$author$project$Form$parse,
												A2($author$project$Page$Community$Settings$Shop$Categories$updateCategoryForm, translators, category.w),
												formModel,
												{oM: $author$project$Page$Community$Settings$Shop$Categories$GotUpdateCategoryFormMsg, oV: $author$project$Page$Community$Settings$Shop$Categories$SubmittedUpdateCategoryForm})),
											$elm$html$Html$Attributes$disabled(
											$author$project$Form$isDisabled(formModel))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											translators.fL('menu.save'))
										]))
								]))
						]),
					A2(
						$author$project$View$Modal$withBody,
						_List_fromArray(
							[
								A6(
								$author$project$Form$viewWithoutSubmit,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-2')
									]),
								translators,
								function (_v0) {
									return _List_Nil;
								},
								A2($author$project$Page$Community$Settings$Shop$Categories$updateCategoryForm, translators, category.w),
								formModel,
								{lF: $author$project$Page$Community$Settings$Shop$Categories$GotUpdateCategoryFormMsg})
							]),
						$author$project$View$Modal$initWith(
							{mw: $author$project$Page$Community$Settings$Shop$Categories$ClosedCategoryModal, nX: true})))));
	});
var $zwilias$elm_rosetree$Tree$Zipper$fromTree = function (t) {
	return {hu: _List_Nil, hy: _List_Nil, W: _List_Nil, v: t};
};
var $zwilias$elm_rosetree$Tree$restructureHelp = F4(
	function (fLabel, fTree, acc, stack) {
		restructureHelp:
		while (true) {
			var _v0 = acc.J;
			if (!_v0.b) {
				var node = A2(
					fTree,
					acc.n$,
					$elm$core$List$reverse(acc.h));
				if (!stack.b) {
					return node;
				} else {
					var top = stack.a;
					var rest = stack.b;
					var $temp$fLabel = fLabel,
						$temp$fTree = fTree,
						$temp$acc = _Utils_update(
						top,
						{
							h: A2($elm$core$List$cons, node, top.h)
						}),
						$temp$stack = rest;
					fLabel = $temp$fLabel;
					fTree = $temp$fTree;
					acc = $temp$acc;
					stack = $temp$stack;
					continue restructureHelp;
				}
			} else {
				if (!_v0.a.b.b) {
					var _v2 = _v0.a;
					var l = _v2.a;
					var rest = _v0.b;
					var $temp$fLabel = fLabel,
						$temp$fTree = fTree,
						$temp$acc = _Utils_update(
						acc,
						{
							h: A2(
								$elm$core$List$cons,
								A2(
									fTree,
									fLabel(l),
									_List_Nil),
								acc.h),
							J: rest
						}),
						$temp$stack = stack;
					fLabel = $temp$fLabel;
					fTree = $temp$fTree;
					acc = $temp$acc;
					stack = $temp$stack;
					continue restructureHelp;
				} else {
					var _v3 = _v0.a;
					var l = _v3.a;
					var cs = _v3.b;
					var rest = _v0.b;
					var $temp$fLabel = fLabel,
						$temp$fTree = fTree,
						$temp$acc = {
						h: _List_Nil,
						n$: fLabel(l),
						J: cs
					},
						$temp$stack = A2(
						$elm$core$List$cons,
						_Utils_update(
							acc,
							{J: rest}),
						stack);
					fLabel = $temp$fLabel;
					fTree = $temp$fTree;
					acc = $temp$acc;
					stack = $temp$stack;
					continue restructureHelp;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$restructure = F3(
	function (convertLabel, convertTree, _v0) {
		var l = _v0.a;
		var c = _v0.b;
		return A4(
			$zwilias$elm_rosetree$Tree$restructureHelp,
			convertLabel,
			convertTree,
			{
				h: _List_Nil,
				n$: convertLabel(l),
				J: c
			},
			_List_Nil);
	});
var $author$project$Page$Community$Settings$Shop$Categories$ClickedToggleExpandCategory = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$OnTopOf = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$OpenedContextMenuForAction = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $zwilias$elm_rosetree$Tree$Zipper$children = function (zipper) {
	return $zwilias$elm_rosetree$Tree$children(
		$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
};
var $author$project$Page$Community$Settings$Shop$Categories$ClickedDeleteCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$ClickedEditCategory = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$ClickedMoveDown = function (a) {
	return {$: 30, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$ClickedMoveUp = function (a) {
	return {$: 29, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$ClickedOpenMetadataModal = function (a) {
	return {$: 21, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$ClickedShowActionsDropdown = function (a) {
	return {$: 17, a: a};
};
var $author$project$Icons$ellipsis = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7.33334 8.00001C7.33334 8.3682 7.63182 8.66668 8.00001 8.66668C8.36819 8.66668 8.66667 8.3682 8.66667 8.00001C8.66667 7.63182 8.36819 7.33334 8.00001 7.33334C7.63182 7.33334 7.33334 7.63182 7.33334 8.00001Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.75'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M2.66667 8.00001C2.66667 8.3682 2.96514 8.66668 3.33333 8.66668C3.70152 8.66668 4 8.3682 4 8.00001C4 7.63182 3.70152 7.33334 3.33333 7.33334C2.96514 7.33334 2.66667 7.63182 2.66667 8.00001Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.75'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 8.00001C12 8.3682 12.2985 8.66668 12.6667 8.66668C13.0349 8.66668 13.3333 8.3682 13.3333 8.00001C13.3333 7.63182 13.0349 7.33334 12.6667 7.33334C12.2985 7.33334 12 7.63182 12 8.00001Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.75'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$menu = _VirtualDom_node('menu');
var $author$project$Page$Community$Settings$Shop$Categories$viewAction = F2(
	function (containerAttrs, _v0) {
		var icon = _v0.p;
		var label = _v0.n$;
		var onClickMsg = _v0.d3;
		return A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('flex items-center w-full pl-2 pr-8 py-1 rounded-md transition-colors whitespace-nowrap font-bold class hover:bg-gray-200 focus:bg-gray-200 focus-ring'),
				A2(
					$elm$core$List$cons,
					$author$project$Utils$onClickNoBubble(onClickMsg),
					containerAttrs)),
			_List_fromArray(
				[
					icon,
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Page$Community$Settings$Shop$Categories$viewActions = F4(
	function (translators, _v0, model, zipper) {
		var isParentOfNewCategoryForm = _v0.kq;
		var isDraggingSomething = _v0.km;
		var hasActionsMenuOpen = function () {
			var _v4 = model.x;
			switch (_v4.$) {
				case 0:
					return false;
				case 2:
					var actionsDropdown = _v4.a;
					return A2(
						$author$project$Page$Community$Settings$Shop$Categories$isAncestorOf,
						actionsDropdown,
						$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
				default:
					var actionsDropdown = _v4.b;
					return A2(
						$author$project$Page$Community$Settings$Shop$Categories$isAncestorOf,
						actionsDropdown,
						$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
			}
		}();
		var category = $zwilias$elm_rosetree$Tree$Zipper$label(zipper);
		var isDropdownOpen = function () {
			var _v3 = model.x;
			switch (_v3.$) {
				case 0:
					return false;
				case 2:
					var actionsDropdown = _v3.a;
					return _Utils_eq(actionsDropdown, category.w);
				default:
					var actionsDropdown = _v3.b;
					return _Utils_eq(actionsDropdown, category.w);
			}
		}();
		var isDropdownOpenOnButton = function () {
			var _v2 = model.x;
			switch (_v2.$) {
				case 0:
					return false;
				case 2:
					var actionsDropdown = _v2.a;
					return _Utils_eq(actionsDropdown, category.w);
				default:
					return false;
			}
		}();
		var canGoUp = !($elm_community$maybe_extra$Maybe$Extra$isNothing(
			$author$project$Utils$Tree$goUpWithoutChildren(zipper)) && $elm_community$maybe_extra$Maybe$Extra$isNothing(
			$zwilias$elm_rosetree$Tree$Zipper$parent(zipper)));
		var canGoDown = !($elm_community$maybe_extra$Maybe$Extra$isNothing(
			$author$project$Utils$Tree$goDownWithoutChildren(zipper)) && $elm_community$maybe_extra$Maybe$Extra$isNothing(
			$zwilias$elm_rosetree$Tree$Zipper$parent(zipper)));
		var buttonClassListsFromParent = $elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('hover:!bg-orange-300/30 active:!bg-orange-300/60 focus:bg-orange-300/30', !isParentOfNewCategoryForm),
					_Utils_Tuple2('hover:!bg-green/30 active:!bg-green/60 focus:!bg-green/30', isParentOfNewCategoryForm)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative flex rounded-sm transition-colors'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('bg-green/20', isParentOfNewCategoryForm),
							_Utils_Tuple2('grand-parent-1-focus:bg-orange-100/20 grand-parent-2-hover:bg-orange-100/20', (!isParentOfNewCategoryForm) && (!isDraggingSomething)),
							_Utils_Tuple2('bg-orange-100/20', hasActionsMenuOpen)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hidden sm:block h-8 px-2 mr-2 rounded-sm transition-colors hover:!bg-orange-300/30 active:!bg-orange-300/60 focus-ring focus:bg-orange-300/30'),
							$author$project$Utils$onClickNoBubble(
							$author$project$Page$Community$Settings$Shop$Categories$ClickedEditCategory(category.w)),
							buttonClassListsFromParent,
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							A2(
								translators.i4,
								'shop.categories.click_category_to_edit',
								_List_fromArray(
									[
										_Utils_Tuple2('category_name', category.fj)
									])))
						]),
					_List_fromArray(
						[
							$author$project$Icons$edit('max-h-4 w-4')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-8 px-2 rounded-sm transition-colors action-opener focus-ring'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('bg-orange-300/60', isDropdownOpenOnButton && (!isParentOfNewCategoryForm)),
									_Utils_Tuple2('bg-green/30', isDropdownOpenOnButton && isParentOfNewCategoryForm)
								])),
							buttonClassListsFromParent,
							$author$project$Utils$onClickNoBubble(
							$author$project$Page$Community$Settings$Shop$Categories$ClickedShowActionsDropdown(category.w)),
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaHasPopup('true'),
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							A2(
								translators.i4,
								'shop.categories.action_for',
								_List_fromArray(
									[
										_Utils_Tuple2('category_name', category.fj)
									])))
						]),
					_List_fromArray(
						[
							$author$project$Icons$ellipsis('h-4 w-4 pointer-events-none text-gray-800')
						])),
					function () {
					if (!isDropdownOpen) {
						return $elm$html$Html$text('');
					} else {
						var openOnMouseAttrs = function () {
							var _v1 = model.x;
							if (_v1.$ === 1) {
								var x = _v1.a.l2;
								var y = _v1.a.l3;
								var viewport = _v1.c.qj;
								return _List_fromArray(
									[
										$elm$html$Html$Attributes$class('fixed'),
										A2(
										$elm$html$Html$Attributes$style,
										'top',
										$elm$core$String$fromFloat(y) + 'px'),
										(_Utils_cmp(x, viewport.l1 / 2) < 0) ? A2(
										$elm$html$Html$Attributes$style,
										'left',
										$elm$core$String$fromFloat(x) + 'px') : A2(
										$elm$html$Html$Attributes$style,
										'right',
										$elm$core$String$fromFloat(viewport.l1 - x) + 'px')
									]);
							} else {
								return _List_Nil;
							}
						}();
						return A2(
							$elm$html$Html$menu,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('bg-white border border-gray-300 rounded-md p-2 my-0 text-sm shadow-lg animate-fade-in-from-above-sm marker-hidden'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'absolute right-0 top-full',
												_Utils_eq(
													model.x,
													$author$project$Page$Community$Settings$Shop$Categories$DropdownOpenOnButton(category.w)))
											])),
									openOnMouseAttrs)),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Page$Community$Settings$Shop$Categories$viewAction,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('sm:hidden')
												]),
											{
												p: $author$project$Icons$edit('w-4 ml-1 mr-3'),
												n$: translators.fL('shop.categories.actions.edit_main_information'),
												d3: $author$project$Page$Community$Settings$Shop$Categories$ClickedEditCategory(category.w)
											})
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Page$Community$Settings$Shop$Categories$viewAction,
											_List_Nil,
											{
												p: $author$project$Icons$edit('w-4 ml-1 mr-3'),
												n$: translators.fL('shop.categories.actions.edit_sharing_data'),
												d3: $author$project$Page$Community$Settings$Shop$Categories$ClickedOpenMetadataModal(category.w)
											})
										])),
									canGoUp ? A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Page$Community$Settings$Shop$Categories$viewAction,
											_List_Nil,
											{
												p: $author$project$Icons$arrowDown('rotate-180 w-6 mr-2'),
												n$: translators.fL('shop.categories.actions.move_up'),
												d3: $author$project$Page$Community$Settings$Shop$Categories$ClickedMoveUp(category.w)
											})
										])) : $elm$html$Html$text(''),
									canGoDown ? A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Page$Community$Settings$Shop$Categories$viewAction,
											_List_Nil,
											{
												p: $author$project$Icons$arrowDown('w-6 mr-2'),
												n$: translators.fL('shop.categories.actions.move_down'),
												d3: $author$project$Page$Community$Settings$Shop$Categories$ClickedMoveDown(category.w)
											})
										])) : $elm$html$Html$text(''),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Page$Community$Settings$Shop$Categories$viewAction,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-red hover:bg-red/10 focus:bg-red/10')
												]),
											{
												p: $author$project$Icons$trash('w-4 ml-1 mr-3'),
												n$: translators.fL('shop.categories.actions.delete'),
												d3: $author$project$Page$Community$Settings$Shop$Categories$ClickedDeleteCategory(category.w)
											})
										]))
								]));
					}
				}()
				]));
	});
var $author$project$Page$Community$Settings$Shop$Categories$ClickedCancelAddCategory = {$: 4};
var $author$project$Page$Community$Settings$Shop$Categories$SubmittedAddCategoryForm = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$newCategoryForm = function (translators) {
	return A2(
		$author$project$Form$with,
		A2($author$project$Page$Community$Settings$Shop$Categories$imageForm, translators, 'new-category-image'),
		A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$richText,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$succeed,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$markdownLongerThan(3),
							$author$project$Form$Validate$validate(translators))),
					qd: F2(
						function (newDescription, values) {
							return _Utils_update(
								values,
								{aR: newDescription});
						}),
					lW: function ($) {
						return $.aR;
					}
				},
				A2(
					$author$project$Form$RichText$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-10')
						]),
					$author$project$Form$RichText$init(
						{
							n$: translators.fL('shop.categories.fields.description')
						}))),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Page$Community$Settings$Shop$Categories$nameAndSlugForm,
					translators,
					{iq: 'new-category-name'}),
				A2(
					$author$project$Form$with,
					A2($author$project$Page$Community$Settings$Shop$Categories$iconForm, translators, 'new-category-icon'),
					$author$project$Form$succeed(
						F4(
							function (icon, _v0, description, image) {
								var name = _v0.fj;
								var slug = _v0.iP;
								return {aR: description, p: icon, h2: image, fj: name, iP: slug};
							}))))));
};
var $author$project$Page$Community$Settings$Shop$Categories$viewNewCategoryForm = F3(
	function (attrs, translators, formModel) {
		return A6(
			$author$project$Form$view,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('border !border-gray-300 rounded-md p-4'),
				attrs),
			translators,
			function (submitButton) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col sm:flex-row justify-end gap-4 mt-10')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button button-secondary w-full sm:w-40'),
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Events$onClick($author$project$Page$Community$Settings$Shop$Categories$ClickedCancelAddCategory)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										translators.fL('menu.cancel'))
									])),
								A2(
								submitButton,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button button-primary w-full sm:w-40')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										translators.fL('menu.create'))
									]))
							]))
					]);
			},
			$author$project$Page$Community$Settings$Shop$Categories$newCategoryForm(translators),
			formModel,
			{oU: $author$project$Page$Community$Settings$Shop$Categories$SubmittedAddCategoryForm, lF: $author$project$Page$Community$Settings$Shop$Categories$GotAddCategoryFormMsg});
	});
var $author$project$Page$Community$Settings$Shop$Categories$viewAddCategory = F4(
	function (translators, attrs, model, parentCategory) {
		var viewAddCategoryButton = function (customAttrs) {
			return A2(
				$elm$html$Html$button,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('flex items-center px-2 h-8 transition-colors hover:bg-orange-100/20 rounded-sm whitespace-nowrap focus:bg-orange-100/20 focus-ring'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$type_('button'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Events$onClick(
								$author$project$Page$Community$Settings$Shop$Categories$ClickedAddCategory(
									$elm$core$Maybe$Just(parentCategory.w))),
							customAttrs))),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sticky left-2 flex items-center transition-colors text-orange-500/70 grand-parent-2-hover:text-orange-500/90')
							]),
						_List_fromArray(
							[
								$author$project$Icons$plus('w-4 h-4 mr-2 fill-current'),
								$elm$html$Html$text(
								A2(
									translators.i4,
									'shop.categories.add_child',
									_List_fromArray(
										[
											_Utils_Tuple2('parent_name', parentCategory.fj)
										])))
							]))
					]));
		};
		var _v0 = model.q;
		if (!_v0.$) {
			return viewAddCategoryButton(attrs);
		} else {
			var newCategoryData = _v0.a;
			return _Utils_eq(
				newCategoryData.ea,
				$elm$core$Maybe$Just(parentCategory.w)) ? A3($author$project$Page$Community$Settings$Shop$Categories$viewNewCategoryForm, attrs, translators, newCategoryData.hY) : viewAddCategoryButton(attrs);
		}
	});
var $author$project$Page$Community$Settings$Shop$Categories$viewCategoryWithChildren = F4(
	function (translators, model, zipper, children) {
		var isParentOfNewCategoryForm = function () {
			var _v8 = model.q;
			if (!_v8.$) {
				return false;
			} else {
				var parent = _v8.a.ea;
				if (parent.$ === 1) {
					return false;
				} else {
					var parentId = parent.a;
					return A2(
						$author$project$Page$Community$Settings$Shop$Categories$isAncestorOf,
						parentId,
						$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
				}
			}
		}();
		var isDraggingSomething = $elm_community$maybe_extra$Maybe$Extra$isJust(
			$author$project$Dnd$getDraggingElement(model.aS));
		var hasActionsMenuOpen = function () {
			var _v7 = model.x;
			switch (_v7.$) {
				case 0:
					return false;
				case 2:
					var actionsDropdown = _v7.a;
					return A2(
						$author$project$Page$Community$Settings$Shop$Categories$isAncestorOf,
						actionsDropdown,
						$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
				default:
					var actionsDropdown = _v7.b;
					return A2(
						$author$project$Page$Community$Settings$Shop$Categories$isAncestorOf,
						actionsDropdown,
						$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
			}
		}();
		var category = $zwilias$elm_rosetree$Tree$Zipper$label(zipper);
		var isDraggingOver = function () {
			var _v5 = $author$project$Dnd$getDraggingOverElement(model.aS);
			if (_v5.$ === 1) {
				return false;
			} else {
				if (!_v5.a.$) {
					var draggingOverId = _v5.a.a;
					return _Utils_eq(draggingOverId, category.w);
				} else {
					var _v6 = _v5.a;
					return false;
				}
			}
		}();
		var isOpen = A2($Gizra$elm_all_set$EverySet$member, category.w, model.aD);
		var openArrowClass = isOpen ? '' : '-rotate-90';
		var isValidDropzone = function () {
			var _v3 = $author$project$Dnd$getDraggingElement(model.aS);
			if (_v3.$ === 1) {
				return true;
			} else {
				var draggingId = _v3.a;
				var isDraggingItself = _Utils_eq(draggingId, category.w);
				var isDraggingChild = A2(
					$elm$core$List$any,
					function (child) {
						return _Utils_eq(
							draggingId,
							$zwilias$elm_rosetree$Tree$label(child).w);
					},
					$zwilias$elm_rosetree$Tree$Zipper$children(zipper));
				var isDraggingAncestor = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$zwilias$elm_rosetree$Tree$Zipper$tree,
							$author$project$Page$Community$Settings$Shop$Categories$isAncestorOf(category.w)),
						A2(
							$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
							function (_v4) {
								var id = _v4.w;
								return _Utils_eq(id, draggingId);
							},
							zipper)));
				return (!isDraggingItself) && ((!isDraggingChild) && (!isDraggingAncestor));
			}
		}();
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('transition-colors rounded-sm'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'bg-gray-300 rounded-sm cursor-wait',
								A2($Gizra$elm_all_set$EverySet$member, category.w, model.aB)),
								_Utils_Tuple2('!bg-green/30', isValidDropzone && isDraggingSomething),
								_Utils_Tuple2('outline-black outline-offset-0', isValidDropzone && (isDraggingSomething && isDraggingOver))
							])),
					isValidDropzone ? A2(
						$author$project$Dnd$dropZone,
						$author$project$Page$Community$Settings$Shop$Categories$OnTopOf(category.w),
						$author$project$Page$Community$Settings$Shop$Categories$GotDndMsg) : _List_Nil)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$details,
					_List_fromArray(
						[
							isOpen ? A2($elm$html$Html$Attributes$attribute, 'open', 'true') : $elm$html$Html$Attributes$class(''),
							$elm$html$Html$Attributes$class('parent grand-parent'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'pointer-events-none',
									A2($Gizra$elm_all_set$EverySet$member, category.w, model.aB))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$summary,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('marker-hidden flex items-center rounded-sm transition-colors cursor-pointer grand-parent focus-ring'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('!bg-green/20', isParentOfNewCategoryForm),
												_Utils_Tuple2('focus:bg-orange-100/20 parent-hover:bg-orange-100/20', (!isParentOfNewCategoryForm) && (!isDraggingSomething)),
												_Utils_Tuple2('bg-orange-100/20', hasActionsMenuOpen)
											])),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Events$onClick(
											$author$project$Page$Community$Settings$Shop$Categories$ClickedToggleExpandCategory(category.w)),
										A2(
											$elm$core$List$cons,
											A2(
												$elm$html$Html$Events$preventDefaultOn,
												'contextmenu',
												A4(
													$elm$json$Json$Decode$map3,
													F3(
														function (x, y, button) {
															return (!button) ? _Utils_Tuple2($author$project$Page$Community$Settings$Shop$Categories$NoOp, false) : _Utils_Tuple2(
																A2(
																	$author$project$Page$Community$Settings$Shop$Categories$OpenedContextMenuForAction,
																	{l2: x, l3: y},
																	category.w),
																function () {
																	var _v0 = model.x;
																	if (_v0.$ === 1) {
																		return false;
																	} else {
																		return true;
																	}
																}());
														}),
													A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
													A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float),
													A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int))),
											A2($author$project$Dnd$draggable, category.w, $author$project$Page$Community$Settings$Shop$Categories$GotDndMsg))))),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex items-center sticky left-0 w-full')
										]),
									_List_fromArray(
										[
											$author$project$Icons$arrowDown(
											A2(
												$elm$core$String$join,
												' ',
												_List_fromArray(
													['transition-transform', openArrowClass]))),
											function () {
											var _v1 = category.p;
											if (_v1.$ === 1) {
												return $elm$html$Html$text('');
											} else {
												var icon = _v1.a;
												return A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src(icon),
															$elm$html$Html$Attributes$alt(''),
															$elm$html$Html$Attributes$class('h-6 w-6 rounded-full mr-2')
														]),
													_List_Nil);
											}
										}(),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('whitespace-nowrap text-black'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'font-bold',
															$elm_community$maybe_extra$Maybe$Extra$isNothing(category.iE))
														]))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(category.fj)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sticky right-0 bg-white rounded-md transition-color'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('bg-transparent', isDraggingSomething),
													_Utils_Tuple2(
													'z-10',
													function () {
														var _v2 = model.x;
														switch (_v2.$) {
															case 0:
																return false;
															case 2:
																var actionsDropdown = _v2.a;
																return _Utils_eq(actionsDropdown, category.w);
															default:
																var actionsDropdown = _v2.b;
																return _Utils_eq(actionsDropdown, category.w);
														}
													}())
												]))
										]),
									_List_fromArray(
										[
											A4(
											$author$project$Page$Community$Settings$Shop$Categories$viewActions,
											translators,
											{km: isDraggingSomething, kq: isParentOfNewCategoryForm},
											model,
											zipper)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-4 mt-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('grid gap-y-2'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'mb-2',
													!$elm$core$List$isEmpty(children))
												]))
										]),
									A2(
										$elm$core$List$map,
										function (child) {
											return A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[child]));
										},
										children))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-4 mb-4')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Page$Community$Settings$Shop$Categories$viewAddCategory,
									translators,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full')
										]),
									model,
									category)
								]))
						]))
				]));
	});
var $author$project$Page$Community$Settings$Shop$Categories$viewCategoryTree = F4(
	function (translators, model, rootZipper, currentTree) {
		return A3(
			$zwilias$elm_rosetree$Tree$restructure,
			function (category) {
				return A2(
					$elm$core$Maybe$withDefault,
					$zwilias$elm_rosetree$Tree$Zipper$fromTree(
						$zwilias$elm_rosetree$Tree$singleton(category)),
					A2(
						$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
						function (_v0) {
							var id = _v0.w;
							return _Utils_eq(id, category.w);
						},
						rootZipper));
			},
			A2($author$project$Page$Community$Settings$Shop$Categories$viewCategoryWithChildren, translators, model),
			currentTree);
	});
var $author$project$Page$Community$Settings$Shop$Categories$ClosedConfirmDeleteModal = {$: 14};
var $author$project$Page$Community$Settings$Shop$Categories$ConfirmedDeleteCategory = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$Community$Settings$Shop$Categories$viewConfirmDeleteCategoryModal = F2(
	function (translators, category) {
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withFooter,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col sm:flex-row gap-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button button-secondary w-full sm:w-40'),
										$elm$html$Html$Events$onClick($author$project$Page$Community$Settings$Shop$Categories$ClosedConfirmDeleteModal)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										translators.fL('menu.cancel'))
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button button-danger w-full sm:w-40'),
										$elm$html$Html$Events$onClick(
										$author$project$Page$Community$Settings$Shop$Categories$ConfirmedDeleteCategory(category.w))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										translators.fL('shop.delete'))
									]))
							]))
					]),
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									translators.fL('shop.categories.delete.warning'))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									translators.fL('shop.categories.delete.confirmation'))
								]))
						]),
					A2(
						$author$project$View$Modal$withHeader,
						A2(
							translators.i4,
							'shop.categories.delete.title',
							_List_fromArray(
								[
									_Utils_Tuple2('category_name', category.fj)
								])),
						$author$project$View$Modal$initWith(
							{mw: $author$project$Page$Community$Settings$Shop$Categories$ClosedConfirmDeleteModal, nX: true})))));
	});
var $author$project$Page$Community$Settings$Shop$Categories$view_ = F4(
	function (translators, community, model, categories) {
		var maybeNewRootCategoryForm = function () {
			var _v11 = model.q;
			if (!_v11.$) {
				return $elm$core$Maybe$Nothing;
			} else {
				var parent = _v11.a.ea;
				var form = _v11.a.hY;
				return $elm_community$maybe_extra$Maybe$Extra$isNothing(parent) ? $elm$core$Maybe$Just(form) : $elm$core$Maybe$Nothing;
			}
		}();
		var isDraggingSomething = $elm_community$maybe_extra$Maybe$Extra$isJust(
			$author$project$Dnd$getDraggingElement(model.aS));
		var isDraggingRootCategory = function () {
			var _v10 = $author$project$Dnd$getDraggingElement(model.aS);
			if (_v10.$ === 1) {
				return false;
			} else {
				var draggingId = _v10.a;
				return A2(
					$elm$core$List$any,
					function (tree) {
						return _Utils_eq(tree.w, draggingId);
					},
					A2($elm$core$List$map, $zwilias$elm_rosetree$Tree$label, categories));
			}
		}();
		var isDraggingOverAddCategory = function () {
			var _v8 = $author$project$Dnd$getDraggingOverElement(model.aS);
			if (_v8.$ === 1) {
				return false;
			} else {
				if (!_v8.a.$) {
					return false;
				} else {
					var _v9 = _v8.a;
					return true;
				}
			}
		}();
		return A3(
			$author$project$Page$Community$Settings$Shop$Categories$viewPageContainer,
			translators,
			{
				hD: _List_fromArray(
					[
						function () {
						if (!categories.b) {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src('/images/not_found.svg'),
												$elm$html$Html$Attributes$alt(''),
												$elm$html$Html$Attributes$class('w-2/3 md:w-1/3 mx-auto')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$h2,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full md:w-2/3 mx-auto font-bold text-lg text-center mt-4')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												translators.fL('shop.categories.empty.description'))
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full md:w-2/3 mx-auto text-center mt-2 mb-6')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												translators.fL('shop.categories.empty.description'))
											]))
									]));
						} else {
							var first = categories.a;
							var others = categories.b;
							var rootZipper = A2($zwilias$elm_rosetree$Tree$Zipper$fromForest, first, others);
							return A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-2 grid gap-y-2')
									]),
								A2(
									$elm$core$List$map,
									function (category) {
										return A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													A4($author$project$Page$Community$Settings$Shop$Categories$viewCategoryTree, translators, model, rootZipper, category)
												]));
									},
									categories));
						}
					}(),
						A2(
						$elm$html$Html$div,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('w-full rounded-sm transition-all ease-out'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('h-0', !isDraggingSomething),
											_Utils_Tuple2('bg-green/30 h-8', isDraggingSomething && (!isDraggingRootCategory)),
											_Utils_Tuple2('outline-black outline-offset-0', isDraggingSomething && (isDraggingOverAddCategory && (!isDraggingRootCategory)))
										])),
								isDraggingRootCategory ? _List_Nil : A2($author$project$Dnd$dropZone, $author$project$Page$Community$Settings$Shop$Categories$OnRoot, $author$project$Page$Community$Settings$Shop$Categories$GotDndMsg))),
						_List_Nil),
						function () {
						if (maybeNewRootCategoryForm.$ === 1) {
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button button-primary w-full sm:w-auto whitespace-nowrap sm:px-4 sticky left-0 mt-8'),
										$elm$html$Html$Events$onClick(
										$author$project$Page$Community$Settings$Shop$Categories$ClickedAddCategory($elm$core$Maybe$Nothing))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										translators.fL('shop.categories.add_root'))
									]));
						} else {
							var formModel = maybeNewRootCategoryForm.a;
							return A3($author$project$Page$Community$Settings$Shop$Categories$viewNewCategoryForm, _List_Nil, translators, formModel);
						}
					}()
					]),
				$9: _List_fromArray(
					[
						function () {
						var _v2 = model.ao;
						if (!_v2.$) {
							return $elm$html$Html$text('');
						} else {
							var categoryId = _v2.a;
							var formModel = _v2.b;
							var _v3 = A2(
								$author$project$Utils$Tree$findInForest,
								function (category) {
									return _Utils_eq(category.w, categoryId);
								},
								categories);
							if (_v3.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var openCategory = _v3.a;
								return A3($author$project$Page$Community$Settings$Shop$Categories$viewCategoryModal, translators, openCategory, formModel);
							}
						}
					}(),
						function () {
						var _v4 = model.cy;
						if (_v4.$ === 1) {
							return $elm$html$Html$text('');
						} else {
							var categoryId = _v4.a;
							var _v5 = A2(
								$author$project$Utils$Tree$findInForest,
								function (category) {
									return _Utils_eq(category.w, categoryId);
								},
								categories);
							if (_v5.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var openCategory = _v5.a;
								return A2($author$project$Page$Community$Settings$Shop$Categories$viewConfirmDeleteCategoryModal, translators, openCategory);
							}
						}
					}(),
						function () {
						var _v6 = model.U;
						if (!_v6.$) {
							return $elm$html$Html$text('');
						} else {
							var categoryId = _v6.a;
							var formModel = _v6.b;
							var _v7 = A2(
								$author$project$Utils$Tree$findInForest,
								function (category) {
									return _Utils_eq(category.w, categoryId);
								},
								categories);
							if (_v7.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var openCategory = _v7.a;
								return A4($author$project$Page$Community$Settings$Shop$Categories$viewCategoryMetadataModal, translators, community, openCategory, formModel);
							}
						}
					}()
					])
			},
			model);
	});
var $author$project$Page$Community$Settings$Shop$Categories$view = F2(
	function (loggedIn, model) {
		var title = loggedIn.A.aw.fL('settings.shop.categories.title');
		return {
			mJ: A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Page$viewHeader, loggedIn, title),
						function () {
						var _v0 = A2(
							$author$project$Community$getField,
							loggedIn.pC,
							function ($) {
								return $.fC;
							});
						switch (_v0.$) {
							case 0:
								return A2($author$project$Page$Community$Settings$Shop$Categories$viewLoading, loggedIn.A.aw, model);
							case 1:
								return A2($author$project$Page$Community$Settings$Shop$Categories$viewLoading, loggedIn.A.aw, model);
							case 2:
								var fieldErr = _v0.a;
								if (!fieldErr.$) {
									var err = fieldErr.a;
									return A2($author$project$Page$fullPageGraphQLError, title, err);
								} else {
									var err = fieldErr.a;
									return A2($author$project$Page$fullPageGraphQLError, title, err);
								}
							default:
								var _v2 = _v0.a;
								var community = _v2.a;
								var categories = _v2.b;
								return _Utils_eq(community.jz, loggedIn._) ? A4($author$project$Page$Community$Settings$Shop$Categories$view_, loggedIn.A.aw, community, model, categories) : A2(
									$author$project$Page$fullPageNotFound,
									loggedIn.A.aw.fL('community.edit.unauthorized'),
									'');
						}
					}()
					])),
			fN: title
		};
	});
var $author$project$Page$Community$Settings$Sponsorship$NoOp = {$: 0};
var $author$project$Page$Community$Settings$Sponsorship$view_ = F2(
	function (_v0, community) {
		var translators = _v0.aw;
		var text_ = A2($elm$core$Basics$composeR, translators.fL, $elm$html$Html$text);
		var card = F3(
			function (title, description, bottomChild) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded p-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold')
								]),
							_List_fromArray(
								[
									text_(title)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-900 mt-2 mb-4')
								]),
							_List_fromArray(
								[
									text_(description)
								])),
							bottomChild
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-4')
				]),
			_List_fromArray(
				[
					function () {
					var _v1 = community.mM;
					if (_v1.$ === 1) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container mx-auto px-8 py-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-bold')
												]),
											_List_fromArray(
												[
													text_('sponsorship.guidance')
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-gray-900')
												]),
											_List_fromArray(
												[
													text_('sponsorship.guidance_description')
												]))
										]))
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4 mt-4 space-y-4')
						]),
					_List_fromArray(
						[
							A3(
							card,
							'sponsorship.cards.fiat.title',
							'sponsorship.cards.fiat.description',
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										function (options) {
										return A2(
											$author$project$Form$Toggle$view,
											options,
											{
												na: $elm$html$Html$text(''),
												no: false,
												nV: false,
												oF: $author$project$Page$Community$Settings$Sponsorship$NoOp,
												oW: function (_v2) {
													return $author$project$Page$Community$Settings$Sponsorship$NoOp;
												},
												aw: translators,
												lW: $elm_community$maybe_extra$Maybe$Extra$isJust(
													A2(
														$elm$core$Maybe$andThen,
														function ($) {
															return $.o5;
														},
														community.mM))
											});
									}(
										A2(
											$author$project$Form$Toggle$withDisabled,
											true,
											$author$project$Form$Toggle$init(
												{
													w: 'fiat-money-toggle',
													n$: text_('sponsorship.cards.fiat.toggle_label')
												}))),
										function () {
										var _v3 = community.mM;
										if (_v3.$ === 1) {
											return $elm$html$Html$text('');
										} else {
											return A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('button button-primary w-full cursor-pointer mt-6'),
														$author$project$Route$href($author$project$Route$CommunitySettingsSponsorshipFiat)
													]),
												_List_fromArray(
													[
														text_('sponsorship.cards.fiat.settings')
													]));
										}
									}()
									]))),
							A3(
							card,
							'sponsorship.cards.crypto.title',
							'sponsorship.cards.crypto.description',
							function (options) {
								return A2(
									$author$project$Form$Toggle$view,
									options,
									{
										na: $elm$html$Html$text(''),
										no: false,
										nV: false,
										oF: $author$project$Page$Community$Settings$Sponsorship$NoOp,
										oW: function (_v4) {
											return $author$project$Page$Community$Settings$Sponsorship$NoOp;
										},
										aw: translators,
										lW: false
									});
							}(
								A2(
									$author$project$Form$Toggle$withDisabled,
									true,
									$author$project$Form$Toggle$init(
										{
											w: 'cryptocurrency-toggle',
											n$: text_('sponsorship.cards.crypto.toggle_label')
										})))),
							A3(
							card,
							'sponsorship.cards.message.title',
							'sponsorship.cards.message.description',
							function () {
								var _v5 = community.mM;
								if (_v5.$ === 1) {
									return A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button button-primary w-full'),
												$elm$html$Html$Attributes$disabled(true)
											]),
										_List_fromArray(
											[
												text_('sponsorship.cards.message.button_label')
											]));
								} else {
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button button-primary w-full cursor-pointer'),
												$author$project$Route$href($author$project$Route$CommunitySettingsSponsorshipThankYouMessage)
											]),
										_List_fromArray(
											[
												text_('sponsorship.cards.message.button_label')
											]));
								}
							}())
						]))
				]));
	});
var $author$project$Page$Community$Settings$Sponsorship$view = F2(
	function (loggedIn, _v0) {
		var title = loggedIn.A.aw.fL('sponsorship.title');
		var content = function () {
			var _v1 = loggedIn.pC;
			switch (_v1.$) {
				case 3:
					var community = _v1.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Page$viewHeader, loggedIn, title),
								A2($author$project$Page$Community$Settings$Sponsorship$view_, loggedIn.A, community)
							]));
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				default:
					var err = _v1.a;
					return A2($author$project$Page$fullPageGraphQLError, title, err);
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$Settings$Sponsorship$Fiat$NoOp = {$: 0};
var $author$project$Page$Community$Settings$Sponsorship$Fiat$isPaypalCurrency = function (currencyType) {
	switch (currencyType) {
		case 0:
			return true;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			return false;
		default:
			return true;
	}
};
var $author$project$Cambiatus$Enum$CurrencyType$list = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $elm$svg$Svg$Attributes$colorInterpolationFilters = _VirtualDom_attribute('color-interpolation-filters');
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$dx = _VirtualDom_attribute('dx');
var $elm$svg$Svg$Attributes$dy = _VirtualDom_attribute('dy');
var $elm$svg$Svg$feBlend = $elm$svg$Svg$trustedNode('feBlend');
var $elm$svg$Svg$feColorMatrix = $elm$svg$Svg$trustedNode('feColorMatrix');
var $elm$svg$Svg$feComposite = $elm$svg$Svg$trustedNode('feComposite');
var $elm$svg$Svg$feFlood = $elm$svg$Svg$trustedNode('feFlood');
var $elm$svg$Svg$feGaussianBlur = $elm$svg$Svg$trustedNode('feGaussianBlur');
var $elm$svg$Svg$feOffset = $elm$svg$Svg$trustedNode('feOffset');
var $elm$svg$Svg$filter = $elm$svg$Svg$trustedNode('filter');
var $elm$svg$Svg$Attributes$filter = _VirtualDom_attribute('filter');
var $elm$svg$Svg$Attributes$filterUnits = _VirtualDom_attribute('filterUnits');
var $elm$svg$Svg$Attributes$floodOpacity = _VirtualDom_attribute('flood-opacity');
var $elm$svg$Svg$Attributes$gradientUnits = _VirtualDom_attribute('gradientUnits');
var $elm$svg$Svg$Attributes$in2 = _VirtualDom_attribute('in2');
var $elm$svg$Svg$Attributes$in_ = _VirtualDom_attribute('in');
var $elm$svg$Svg$Attributes$k2 = _VirtualDom_attribute('k2');
var $elm$svg$Svg$Attributes$k3 = _VirtualDom_attribute('k3');
var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$Attributes$operator = _VirtualDom_attribute('operator');
var $elm$svg$Svg$Attributes$result = _VirtualDom_attribute('result');
var $elm$svg$Svg$Attributes$stdDeviation = _VirtualDom_attribute('stdDeviation');
var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
var $elm$svg$Svg$Attributes$values = function (value) {
	return A2(
		_VirtualDom_attribute,
		'values',
		_VirtualDom_noJavaScriptUri(value));
};
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$Icons$paypal = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('21'),
				$elm$svg$Svg$Attributes$height('23'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M14.822 1c2.623 0 4.324 1.79 4.324 4.551v9.999c0 2.76-1.7 4.551-4.324 4.551H5.324C2.7 20.101 1 18.311 1 15.55V5.55C1 2.791 2.701 1 5.324 1h9.498Z'),
						$elm$svg$Svg$Attributes$fill('url(#a)')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$filter('url(#b)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$fillRule('evenodd'),
								$elm$svg$Svg$Attributes$clipRule('evenodd'),
								$elm$svg$Svg$Attributes$d('M6.787 3.706a.461.461 0 0 0-.448.402L4.648 15.25c-.045.29.168.553.447.553h2.446l.577-3.956a.462.462 0 0 1 .448-.405h.969s1.14.075 2.005-.28c1.221-.501 2.787-1.682 2.966-3.832.306-3.673-2.094-3.624-3.583-3.624H6.787Z'),
								$elm$svg$Svg$Attributes$fill('#fff')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$filter('url(#c)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$fillRule('evenodd'),
								$elm$svg$Svg$Attributes$clipRule('evenodd'),
								$elm$svg$Svg$Attributes$d('M9.282 6.73a.46.46 0 0 0-.447.403l-1.466 9.653c-.044.29.17.553.448.553H9.72c.223 0 .413-.17.448-.402l.46-3.02a.461.461 0 0 1 .447-.403h.57s.77.05 1.53-.261c1.07-.44 2.255-1.48 2.412-3.366.268-3.22-2.954-3.156-4.26-3.156H9.282Z'),
								$elm$svg$Svg$Attributes$fill('#ADD1E6')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$filter('url(#d)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$fillRule('evenodd'),
								$elm$svg$Svg$Attributes$clipRule('evenodd'),
								$elm$svg$Svg$Attributes$d('M8.126 11.816c.083-.199.262-.374.47-.374h.918s1.15.007 2.016-.348c1.22-.5 2.773-1.611 2.955-3.757-.993-.629-2.415-.606-3.18-.606H9.329c-.25 0-.486.211-.526.473l-.696 4.583.019.03Z'),
								$elm$svg$Svg$Attributes$fill('url(#e)')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$defs,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$filter,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('b'),
								$elm$svg$Svg$Attributes$x('.142'),
								$elm$svg$Svg$Attributes$y('.706'),
								$elm$svg$Svg$Attributes$width('17.891'),
								$elm$svg$Svg$Attributes$height('20.097'),
								$elm$svg$Svg$Attributes$filterUnits('userSpaceOnUse'),
								$elm$svg$Svg$Attributes$colorInterpolationFilters('sRGB')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$feFlood,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$floodOpacity('0'),
										$elm$svg$Svg$Attributes$result('BackgroundImageFix')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feColorMatrix,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in_('SourceAlpha'),
										$elm$svg$Svg$Attributes$values('0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'),
										$elm$svg$Svg$Attributes$result('hardAlpha')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feOffset,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$dx('-.5'),
										$elm$svg$Svg$Attributes$dy('1')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feGaussianBlur,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stdDeviation('2')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feColorMatrix,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$values('0 0 0 0 0 0 0 0 0 0.345098 0 0 0 0 0.631373 0 0 0 1 0')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feBlend,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in2('BackgroundImageFix'),
										$elm$svg$Svg$Attributes$result('effect1_dropShadow')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feBlend,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in_('SourceGraphic'),
										$elm$svg$Svg$Attributes$in2('effect1_dropShadow'),
										$elm$svg$Svg$Attributes$result('shape')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feColorMatrix,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in_('SourceAlpha'),
										$elm$svg$Svg$Attributes$values('0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'),
										$elm$svg$Svg$Attributes$result('hardAlpha')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feOffset,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$dy('-1')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feGaussianBlur,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stdDeviation('2')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feComposite,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in2('hardAlpha'),
										$elm$svg$Svg$Attributes$operator('arithmetic'),
										$elm$svg$Svg$Attributes$k2('-1'),
										$elm$svg$Svg$Attributes$k3('1')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feColorMatrix,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$values('0 0 0 0 0.760784 0 0 0 0 0.858824 0 0 0 0 0.921569 0 0 0 1 0')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feBlend,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in2('shape'),
										$elm$svg$Svg$Attributes$result('effect2_innerShadow')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$filter,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('c'),
								$elm$svg$Svg$Attributes$x('4.363'),
								$elm$svg$Svg$Attributes$y('3.73'),
								$elm$svg$Svg$Attributes$width('16.238'),
								$elm$svg$Svg$Attributes$height('18.608'),
								$elm$svg$Svg$Attributes$filterUnits('userSpaceOnUse'),
								$elm$svg$Svg$Attributes$colorInterpolationFilters('sRGB')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$feFlood,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$floodOpacity('0'),
										$elm$svg$Svg$Attributes$result('BackgroundImageFix')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feColorMatrix,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in_('SourceAlpha'),
										$elm$svg$Svg$Attributes$values('0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'),
										$elm$svg$Svg$Attributes$result('hardAlpha')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feOffset,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$dx('1'),
										$elm$svg$Svg$Attributes$dy('1')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feGaussianBlur,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stdDeviation('2')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feColorMatrix,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$values('0 0 0 0 0 0 0 0 0 0.419608 0 0 0 0 0.701961 0 0 0 1 0')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feBlend,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in2('BackgroundImageFix'),
										$elm$svg$Svg$Attributes$result('effect1_dropShadow')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feBlend,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in_('SourceGraphic'),
										$elm$svg$Svg$Attributes$in2('effect1_dropShadow'),
										$elm$svg$Svg$Attributes$result('shape')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feColorMatrix,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in_('SourceAlpha'),
										$elm$svg$Svg$Attributes$values('0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'),
										$elm$svg$Svg$Attributes$result('hardAlpha')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feOffset,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$dy('-1')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feGaussianBlur,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stdDeviation('2')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feComposite,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in2('hardAlpha'),
										$elm$svg$Svg$Attributes$operator('arithmetic'),
										$elm$svg$Svg$Attributes$k2('-1'),
										$elm$svg$Svg$Attributes$k3('1')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feColorMatrix,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$values('0 0 0 0 0.751403 0 0 0 0 0.876099 0 0 0 0 0.941911 0 0 0 1 0')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feBlend,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in2('shape'),
										$elm$svg$Svg$Attributes$result('effect2_innerShadow')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$filter,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('d'),
								$elm$svg$Svg$Attributes$x('8.107'),
								$elm$svg$Svg$Attributes$y('5.73'),
								$elm$svg$Svg$Attributes$width('6.378'),
								$elm$svg$Svg$Attributes$height('6.086'),
								$elm$svg$Svg$Attributes$filterUnits('userSpaceOnUse'),
								$elm$svg$Svg$Attributes$colorInterpolationFilters('sRGB')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$feFlood,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$floodOpacity('0'),
										$elm$svg$Svg$Attributes$result('BackgroundImageFix')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feBlend,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in_('SourceGraphic'),
										$elm$svg$Svg$Attributes$in2('BackgroundImageFix'),
										$elm$svg$Svg$Attributes$result('shape')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feColorMatrix,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in_('SourceAlpha'),
										$elm$svg$Svg$Attributes$values('0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'),
										$elm$svg$Svg$Attributes$result('hardAlpha')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feOffset,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$dy('-1')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feGaussianBlur,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stdDeviation('2')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feComposite,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in2('hardAlpha'),
										$elm$svg$Svg$Attributes$operator('arithmetic'),
										$elm$svg$Svg$Attributes$k2('-1'),
										$elm$svg$Svg$Attributes$k3('1')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feColorMatrix,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$values('0 0 0 0 0.839216 0 0 0 0 0.905882 0 0 0 0 0.945098 0 0 0 1 0')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feBlend,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in2('shape'),
										$elm$svg$Svg$Attributes$result('effect1_innerShadow')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$linearGradient,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('a'),
								$elm$svg$Svg$Attributes$x1('-5.858'),
								$elm$svg$Svg$Attributes$y1('10.954'),
								$elm$svg$Svg$Attributes$x2('10.889'),
								$elm$svg$Svg$Attributes$y2('26.375'),
								$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$stop,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stopColor('#002B6F')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$stop,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$offset('1'),
										$elm$svg$Svg$Attributes$stopColor('#0097D9')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$linearGradient,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('e'),
								$elm$svg$Svg$Attributes$x1('6.5'),
								$elm$svg$Svg$Attributes$y1('7.908'),
								$elm$svg$Svg$Attributes$x2('8.573'),
								$elm$svg$Svg$Attributes$y2('12.316'),
								$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$stop,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stopColor('#E6EEF5')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$stop,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$offset('1'),
										$elm$svg$Svg$Attributes$stopColor('#E6F0F7')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Page$Community$Settings$Sponsorship$Fiat$createForm = function (_v0) {
	var t = _v0.fL;
	var checkboxes = A2(
		$elm$core$List$map,
		function (currency) {
			var currencyString = $author$project$Cambiatus$Enum$CurrencyType$toString(currency);
			return A2(
				$author$project$Form$checkbox,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: $elm$core$Result$Ok,
					qd: F2(
						function (_v5, input) {
							return input;
						}),
					lW: function (input) {
						return A2($elm$core$List$member, currency, input.l6);
					}
				},
				$author$project$Form$Checkbox$init(
					{
						w: 'currencies-' + (currencyString + '-checkbox'),
						n$: $elm$html$Html$text(currencyString)
					}));
		},
		A2($elm$core$List$filter, $author$project$Page$Community$Settings$Sponsorship$Fiat$isPaypalCurrency, $author$project$Cambiatus$Enum$CurrencyType$list));
	var addCheckboxes = function (form) {
		return A3($elm$core$List$foldl, $author$project$Form$withNoOutput, form, checkboxes);
	};
	return A2(
		$author$project$Form$withNoOutput,
		A4(
			$author$project$Form$withGroup,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid xs-max:grid-cols-1 grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-y-6')
				]),
			addCheckboxes(
				$author$project$Form$succeed(0)),
			$author$project$Form$succeed(0),
			$author$project$Form$succeed(
				F2(
					function (_v3, _v4) {
						return 0;
					}))),
		A2(
			$author$project$Form$withDecoration,
			A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						t('sponsorship.cards.fiat.title'))
					])),
			A2(
				$author$project$Form$withDecoration,
				A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-10 text-gray-900')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('sponsorship.fiat.how_to_change'))
						])),
				A2(
					$author$project$Form$withNoOutput,
					A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: $elm$core$Result$Ok,
							qd: F2(
								function (_v2, input) {
									return input;
								}),
							lW: function ($) {
								return $.o5;
							}
						},
						A2(
							$author$project$Form$Text$withContainerAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-5 mb-2')
								]),
							A2(
								$author$project$Form$Text$withPlaceholder,
								t('sponsorship.fiat.paypal_example'),
								$author$project$Form$Text$init(
									{
										w: 'paypal-account-input',
										n$: t('sponsorship.fiat.paypal_account')
									})))),
					A2(
						$author$project$Form$withNoOutput,
						A2(
							$author$project$Form$toggle,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: $elm$core$Result$Ok,
								qd: F2(
									function (_v1, input) {
										return input;
									}),
								lW: function ($) {
									return $.ia;
								}
							},
							$author$project$Form$Toggle$init(
								{
									w: 'accept-paypal',
									n$: A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex')
											]),
										_List_fromArray(
											[
												$author$project$Icons$paypal('mr-2'),
												$elm$html$Html$text('Paypal')
											]))
								})),
						$author$project$Form$succeed(0))))));
};
var $author$project$Page$Community$Settings$Sponsorship$Fiat$view_ = F2(
	function (_v0, community) {
		var translators = _v0.aw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto px-4 my-4')
				]),
			_List_fromArray(
				[
					A6(
					$author$project$Form$viewWithoutSubmit,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('p-4 bg-white rounded')
						]),
					translators,
					function (_v1) {
						return _List_Nil;
					},
					$author$project$Page$Community$Settings$Sponsorship$Fiat$createForm(translators),
					A2(
						$author$project$Form$withDisabled,
						true,
						$author$project$Form$init(
							{
								l6: A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.l6;
										},
										community.mM)),
								ia: $elm_community$maybe_extra$Maybe$Extra$isJust(
									A2(
										$elm$core$Maybe$andThen,
										function ($) {
											return $.o5;
										},
										community.mM)),
								o5: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$andThen,
										function ($) {
											return $.o5;
										},
										community.mM))
							})),
					{
						lF: function (_v2) {
							return $author$project$Page$Community$Settings$Sponsorship$Fiat$NoOp;
						}
					})
				]));
	});
var $author$project$Page$Community$Settings$Sponsorship$Fiat$view = F2(
	function (loggedIn, _v0) {
		var title = loggedIn.A.aw.fL('sponsorship.fiat.title');
		var content = function () {
			var _v1 = loggedIn.pC;
			switch (_v1.$) {
				case 3:
					var community = _v1.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Page$viewHeader, loggedIn, title),
								A2($author$project$Page$Community$Settings$Sponsorship$Fiat$view_, loggedIn.A, community)
							]));
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				default:
					var err = _v1.a;
					return A2($author$project$Page$fullPageGraphQLError, title, err);
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$NoOp = {$: 0};
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$FormOutput = F2(
	function (title, message) {
		return {of: message, fN: title};
	});
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$createForm = F2(
	function (_v0, community) {
		var t = _v0.fL;
		var tr = _v0.i4;
		return A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$richText,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: $elm$core$Result$Ok,
					qd: F2(
						function (message, input) {
							return _Utils_update(
								input,
								{of: message});
						}),
					lW: function ($) {
						return $.of;
					}
				},
				A2(
					$author$project$Form$RichText$withPlaceholder,
					t('sponsorship.thank_you_message.default_message'),
					$author$project$Form$RichText$init(
						{
							n$: t('sponsorship.thank_you_message.message')
						}))),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$textField,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: $elm$core$Result$Ok,
						qd: F2(
							function (title, input) {
								return _Utils_update(
									input,
									{fN: title});
							}),
						lW: function ($) {
							return $.fN;
						}
					},
					A2(
						$author$project$Form$Text$withPlaceholder,
						A2(
							tr,
							'sponsorship.thank_you_message.default_title',
							_List_fromArray(
								[
									_Utils_Tuple2('community', community.fj)
								])),
						$author$project$Form$Text$init(
							{
								w: 'title-input',
								n$: t('sponsorship.thank_you_message.title')
							}))),
				$author$project$Form$succeed($author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$FormOutput)));
	});
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$view_ = F3(
	function (_v0, community, form) {
		var translators = _v0.aw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white flex-grow')
				]),
			_List_fromArray(
				[
					A6(
					$author$project$Form$view,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto p-4')
						]),
					translators,
					function (_v1) {
						return _List_Nil;
					},
					A2($author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$createForm, translators, community),
					A2($author$project$Form$withDisabled, true, form),
					{
						oU: function (_v2) {
							return $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$NoOp;
						},
						lF: $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$GotFormMsg
					})
				]));
	});
var $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$view = F2(
	function (loggedIn, model) {
		var title = loggedIn.A.aw.fL('sponsorship.cards.message.title');
		var content = function () {
			var _v0 = loggedIn.pC;
			switch (_v0.$) {
				case 3:
					var community = _v0.a;
					var _v1 = model.hY;
					if (!_v1.$) {
						return $author$project$Page$fullPageLoading(loggedIn.A);
					} else {
						var form = _v1.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-grow flex flex-col')
								]),
							_List_fromArray(
								[
									A2($author$project$Page$viewHeader, loggedIn, title),
									A3($author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$view_, loggedIn.A, community, form)
								]));
					}
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				default:
					var err = _v0.a;
					return A2($author$project$Page$fullPageGraphQLError, title, err);
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$Sponsor$PaypalApproved = {$: 5};
var $author$project$Page$Community$Sponsor$PaypalCanceled = {$: 6};
var $author$project$Page$Community$Sponsor$PaypalErrored = function (a) {
	return {$: 7, a: a};
};
var $author$project$View$PaypalButtons$AmountTooBig = {$: 1};
var $author$project$View$PaypalButtons$AmountTooSmall = {$: 0};
var $author$project$View$PaypalButtons$InvalidAmount = {$: 2};
var $author$project$View$PaypalButtons$LoadError = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$PaypalButtons$UnknownError = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$PaypalButtons$view = F2(
	function (attrs, options) {
		return A3(
			$elm$html$Html$node,
			'paypal-buttons',
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$Events$on,
					'paypal-approve',
					$elm$json$Json$Decode$succeed(options.oD)),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Events$on,
						'paypal-cancel',
						$elm$json$Json$Decode$succeed(options.oG)),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Events$on,
							'paypal-error',
							function () {
								var _v0 = options.lW;
								if (_v0.$ === 1) {
									return $elm$json$Json$Decode$succeed(
										options.oM($author$project$View$PaypalButtons$InvalidAmount));
								} else {
									var value = _v0.a;
									return (_Utils_cmp(value, $author$project$View$PaypalButtons$minimumAmount) < 0) ? $elm$json$Json$Decode$succeed(
										options.oM($author$project$View$PaypalButtons$AmountTooSmall)) : ((_Utils_cmp(value, $author$project$View$PaypalButtons$maximumAmount) > 0) ? $elm$json$Json$Decode$succeed(
										options.oM($author$project$View$PaypalButtons$AmountTooBig)) : A2(
										$elm$json$Json$Decode$map,
										A2($elm$core$Basics$composeR, $author$project$View$PaypalButtons$UnknownError, options.oM),
										$elm$json$Json$Decode$value));
								}
							}()),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$Events$on,
								'paypal-load-error',
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeR, $author$project$View$PaypalButtons$LoadError, options.oM),
									$elm$json$Json$Decode$value)),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$id(options.w),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('z-0'),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$Attributes$attribute,
											'elm-value',
											function () {
												var _v1 = options.lW;
												if (_v1.$ === 1) {
													return '';
												} else {
													var value = _v1.a;
													return $elm$core$String$fromFloat(value);
												}
											}()),
										A2(
											$elm$core$List$cons,
											A2(
												$elm$html$Html$Attributes$attribute,
												'elm-currency',
												$author$project$View$PaypalButtons$currencyToString(options.jA)),
											attrs)))))))),
			_List_Nil);
	});
var $author$project$Page$Community$Sponsor$view_ = F4(
	function (shared, community, contributionConfiguration, model) {
		var translators = shared.aw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('m-4 bg-white rounded md:m-0 md:bg-white md:flex-grow')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col items-center w-full px-4 py-7 bg-white md:w-1/2 md:mx-auto')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('h-10'),
											$elm$html$Html$Attributes$src(community.fe)
										]),
									_List_Nil),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold text-black text-3xl mb-8')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(community.fj)
										])),
									A6(
									$author$project$Form$viewWithoutSubmit,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full lg:w-3/4')
										]),
									translators,
									function (_v0) {
										var amount = _v0.ji;
										var selectedCurrency = _v0.c6;
										return _List_fromArray(
											[
												A2(
												$author$project$View$PaypalButtons$view,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-full lg:w-3/4')
													]),
												{
													jA: selectedCurrency,
													w: 'paypal-buttons-sponsorship',
													oD: $author$project$Page$Community$Sponsor$PaypalApproved,
													oG: $author$project$Page$Community$Sponsor$PaypalCanceled,
													oM: $author$project$Page$Community$Sponsor$PaypalErrored,
													lW: A2(
														$elm$core$Maybe$andThen,
														function (floatAmount) {
															return (_Utils_cmp(floatAmount, $author$project$View$PaypalButtons$minimumAmount) < 0) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(floatAmount, $author$project$View$PaypalButtons$maximumAmount) > 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(floatAmount));
														},
														$elm$core$String$toFloat(
															A2($author$project$Translation$floatStringFromSeparatedString, translators, amount)))
												})
											]);
									},
									A3($author$project$Page$Community$Sponsor$createForm, shared, contributionConfiguration, model),
									model.hY,
									{lF: $author$project$Page$Community$Sponsor$GotFormMsg})
								]))
						]))
				]));
	});
var $author$project$Page$Community$Sponsor$view = F2(
	function (loggedIn, model) {
		var title = loggedIn.A.aw.fL('sponsorship.sponsor');
		var content = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col md:flex-grow')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$viewHeader, loggedIn, title),
					function () {
					var _v0 = loggedIn.pC;
					switch (_v0.$) {
						case 3:
							var community = _v0.a;
							var _v1 = community.mM;
							if (_v1.$ === 1) {
								return A2(
									$author$project$Page$fullPageNotFound,
									loggedIn.A.aw.fL('sponsorship.no_support'),
									loggedIn.A.aw.fL('sponsorship.no_support_subtitle'));
							} else {
								var contributionConfiguration = _v1.a;
								return A4($author$project$Page$Community$Sponsor$view_, loggedIn.A, community, contributionConfiguration, model);
							}
						case 1:
							return $author$project$Page$fullPageLoading(loggedIn.A);
						case 0:
							return $author$project$Page$fullPageLoading(loggedIn.A);
						default:
							var err = _v0.a;
							return A2($author$project$Page$fullPageGraphQLError, title, err);
					}
				}()
				]));
		return {mJ: content, fN: title};
	});
var $elm$core$List$map3 = _List_map3;
var $author$project$Page$Community$Supporters$GotProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Profile$Summary$expand = 1;
var $author$project$Profile$Summary$withAttrs = F2(
	function (attrs, model) {
		return _Utils_update(
			model,
			{
				gu: _Utils_ap(model.gu, attrs)
			});
	});
var $author$project$Page$Community$Supporters$viewSupporter = F4(
	function (loggedIn, index, profileSummary, profile) {
		var content = _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Page$Community$Supporters$GotProfileSummaryMsg(index),
				A4(
					$author$project$Profile$Summary$view,
					loggedIn.A.aw,
					loggedIn._,
					profile,
					A2(
						$author$project$Profile$Summary$withAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$tabindex(-1)
							]),
						A2(
							$author$project$Profile$Summary$withImageSize,
							'w-14 h-14',
							$author$project$Profile$Summary$withoutName(profileSummary))))),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ml-4 font-bold text-black')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Eos$Account$nameToString(profile.l8),
							profile.fj))
					]))
			]);
		var containerClasses = 'flex items-center p-4 w-full hover:bg-gray-100 focus:outline-none focus:ring';
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(containerClasses + ' md:hidden'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Page$Community$Supporters$GotProfileSummaryMsg, index, $author$project$Profile$Summary$expand))
						]),
					content),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(containerClasses + ' hidden md:flex'),
							$author$project$Route$href(
							$author$project$Route$Profile(profile.l8))
						]),
					content)
				]));
	});
var $author$project$Page$Community$Supporters$view_ = F3(
	function (loggedIn, contributions, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-heading py-4')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-900')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('community.index.our_supporters'))
										])),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-indigo-500 font-bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('community.index.supporters'))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full bg-white flex-grow pt-5')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto px-4 space-y-4')
								]),
							$elm$core$List$reverse(
								A3(
									$elm$core$List$foldl,
									F2(
										function (_v1, _v2) {
											var firstContribution = _v1.a;
											var otherContributions = _v1.b;
											var currentIndex = _v2.a;
											var currentList = _v2.b;
											var contributionsLength = $elm$core$List$length(
												A2($elm$core$List$cons, firstContribution, otherContributions));
											return _Utils_Tuple2(
												currentIndex + contributionsLength,
												A2(
													$elm$core$List$cons,
													A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																A4(
																$author$project$View$Components$dateViewer,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('text-caption text-black uppercase')
																	]),
																$elm$core$Basics$identity,
																loggedIn.A,
																firstContribution.nL),
																A2(
																$elm$html$Html$ul,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('divide-y')
																	]),
																A4(
																	$elm$core$List$map3,
																	$author$project$Page$Community$Supporters$viewSupporter(loggedIn),
																	A2($elm$core$List$range, currentIndex, currentIndex + contributionsLength),
																	A2($elm$core$List$drop, currentIndex, model.c1),
																	A2(
																		$elm$core$List$map,
																		function ($) {
																			return $.qg;
																		},
																		A2($elm$core$List$cons, firstContribution, otherContributions))))
															])),
													currentList));
										}),
									_Utils_Tuple2(0, _List_Nil),
									A2(
										$elm_community$list_extra$List$Extra$groupWhile,
										F2(
											function (c1, c2) {
												return A3($author$project$Utils$areSameDay, loggedIn.A.i2, c1.nL, c2.nL);
											}),
										contributions)).b))
						]))
				]));
	});
var $author$project$Page$Community$Supporters$view = F2(
	function (loggedIn, model) {
		var title = A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				loggedIn.A.aw.fL,
				_List_fromArray(
					['community.index.our_supporters', 'community.index.supporters'])));
		var content = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col flex-grow')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$viewHeader, loggedIn, title),
					function () {
					var _v0 = A2(
						$author$project$Community$getField,
						loggedIn.pC,
						function ($) {
							return $.eN;
						});
					switch (_v0.$) {
						case 3:
							var _v1 = _v0.a;
							var contributions = _v1.b;
							return A3($author$project$Page$Community$Supporters$view_, loggedIn, contributions, model);
						case 1:
							return $author$project$Page$fullPageLoading(loggedIn.A);
						case 0:
							return $author$project$Page$fullPageLoading(loggedIn.A);
						default:
							if (!_v0.a.$) {
								var error = _v0.a.a;
								return A2($author$project$Page$fullPageGraphQLError, title, error);
							} else {
								var error = _v0.a.a;
								return A2($author$project$Page$fullPageGraphQLError, title, error);
							}
					}
				}()
				]));
		return {mJ: content, fN: title};
	});
var $author$project$Page$Community$ThankYou$view = function (loggedIn) {
	var title = loggedIn.A.aw.fL('community.thank_you.title');
	var text_ = A2($elm$core$Basics$composeR, loggedIn.A.aw.fL, $elm$html$Html$text);
	var content = function () {
		var _v0 = loggedIn.pC;
		switch (_v0.$) {
			case 3:
				var community = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-green flex-grow text-white text-center md:flex')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto my-10 px-4 flex flex-col items-center space-y-4 md:justify-center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/images/sponsor-celebration.svg')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold text-3xl leading-tight')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												A2(
													loggedIn.A.aw.i4,
													'sponsorship.thank_you_message.default_title',
													_List_fromArray(
														[
															_Utils_Tuple2('community', community.fj)
														])),
												A2(
													$elm$core$Maybe$andThen,
													function ($) {
														return $.p0;
													},
													community.mM)))
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Markdown$view,
											_List_Nil,
											A2(
												$elm$core$Maybe$withDefault,
												A2($author$project$Markdown$fromTranslation, loggedIn.A.aw, 'sponsorship.thank_you_message.default_message'),
												A2(
													$elm$core$Maybe$andThen,
													function ($) {
														return $.p$;
													},
													community.mM)))
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('underline cursor-pointer'),
											$author$project$Route$href($author$project$Route$CommunitySupporters)
										]),
									_List_fromArray(
										[
											text_('community.thank_you.all_supporters')
										]))
								]))
						]));
			case 0:
				return $author$project$Page$fullPageLoading(loggedIn.A);
			case 1:
				return $author$project$Page$fullPageLoading(loggedIn.A);
			default:
				var err = _v0.a;
				return A2($author$project$Page$fullPageGraphQLError, title, err);
		}
	}();
	return {mJ: content, fN: title};
};
var $author$project$Page$fullPageError = F2(
	function (title_, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$viewTitle(title_),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Something wrong happened.')
						]))
				]));
	});
var $author$project$Page$Community$Transfer$BalanceError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Transfer$TokenError = function (a) {
	return {$: 0, a: a};
};
var $krisajenkins$remotedata$RemoteData$andMap = F2(
	function (wrappedValue, wrappedFunction) {
		var _v0 = _Utils_Tuple2(wrappedFunction, wrappedValue);
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				_v0$4:
				while (true) {
					_v0$5:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										var f = _v0.a.a;
										var value = _v0.b.a;
										return $krisajenkins$remotedata$RemoteData$Success(
											f(value));
									case 2:
										break _v0$2;
									case 1:
										break _v0$4;
									default:
										var _v4 = _v0.b;
										return $krisajenkins$remotedata$RemoteData$NotAsked;
								}
							case 2:
								var error = _v0.a.a;
								return $krisajenkins$remotedata$RemoteData$Failure(error);
							case 1:
								switch (_v0.b.$) {
									case 2:
										break _v0$2;
									case 1:
										break _v0$3;
									case 0:
										break _v0$3;
									default:
										break _v0$3;
								}
							default:
								switch (_v0.b.$) {
									case 2:
										break _v0$2;
									case 1:
										break _v0$4;
									case 0:
										break _v0$5;
									default:
										break _v0$5;
								}
						}
					}
					var _v3 = _v0.a;
					return $krisajenkins$remotedata$RemoteData$NotAsked;
				}
				var _v2 = _v0.b;
				return $krisajenkins$remotedata$RemoteData$Loading;
			}
			var _v1 = _v0.a;
			return $krisajenkins$remotedata$RemoteData$Loading;
		}
		var error = _v0.b.a;
		return $krisajenkins$remotedata$RemoteData$Failure(error);
	});
var $krisajenkins$remotedata$RemoteData$map2 = F3(
	function (f, a, b) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andMap,
			b,
			A2($krisajenkins$remotedata$RemoteData$map, f, a));
	});
var $author$project$Page$Community$Transfer$getMaxTransferAmount = function (model) {
	return A3(
		$krisajenkins$remotedata$RemoteData$map2,
		F2(
			function (balance, token) {
				return balance.mk.ji - token.oh.ji;
			}),
		A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Page$Community$Transfer$BalanceError, model.cA),
		A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Page$Community$Transfer$TokenError, model.p5));
};
var $author$project$Page$Community$Transfer$FormOutput = F3(
	function (selectedProfile, amount, memo) {
		return {ji: amount, kE: memo, H: selectedProfile};
	});
var $author$project$Form$Validate$numberLowerThanOrEqualTo = F2(
	function (numberToString, upperBound) {
		return $author$project$Form$Validate$custom(
			function (x) {
				return (_Utils_cmp(x, upperBound) < 1) ? $elm$core$Result$Ok(x) : $elm$core$Result$Err(
					function (_v0) {
						var tr = _v0.i4;
						return A2(
							tr,
							'error.validator.number.lower_than_or_equal',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'base',
									numberToString(upperBound))
								]));
					});
			});
	});
var $author$project$Form$Validate$floatLowerThanOrEqualTo = $author$project$Form$Validate$numberLowerThanOrEqualTo($elm$core$String$fromFloat);
var $author$project$Form$userPicker = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Form$mapBaseField, $author$project$Form$UserPicker$fromSinglePicker, $author$project$Form$UserPicker$toSinglePicker),
				$author$project$Form$UserPicker(options)),
			{
				ne: config.ne,
				o3: A2($elm$core$Basics$composeR, $author$project$Form$UserPicker$getSingleProfile, config.o3),
				qd: config.qd,
				lW: config.lW
			});
	});
var $author$project$Form$Validate$withCustomError = F2(
	function (newError, _v0) {
		var validator = _v0;
		if (!validator.$) {
			var ok = validator.a;
			return $elm$core$Result$Ok(ok);
		} else {
			return $elm$core$Result$Err(newError);
		}
	});
var $author$project$Page$Community$Transfer$createForm = F4(
	function (loggedIn, community, balance, maxTransferAmount) {
		var _v0 = loggedIn.A;
		var translators = _v0.aw;
		return A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$richText,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: $elm$core$Result$Ok,
					qd: F2(
						function (memo, input) {
							return _Utils_update(
								input,
								{kE: memo});
						}),
					lW: function ($) {
						return $.kE;
					}
				},
				$author$project$Form$RichText$init(
					{
						n$: translators.fL('account.my_wallet.transfer.memo')
					})),
			A2(
				$author$project$Form$withNoOutput,
				$author$project$Form$arbitrary(
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-gray-100 uppercase text-sm px-2 inline-block mb-10')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									translators.i4,
									'account.my_wallet.your_current_balance',
									_List_fromArray(
										[
											_Utils_Tuple2(
											'balance',
											A2($author$project$Eos$assetToString, translators, balance))
										])))
							]))),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$maskedFloat(translators),
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$floatLowerThanOrEqualTo(maxTransferAmount),
										A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$withCustomError(
												function (translators_) {
													return A2(
														translators_.i4,
														'transfer.too_much',
														_List_fromArray(
															[
																_Utils_Tuple2(
																'token',
																$author$project$Eos$symbolToSymbolCodeString(balance.as)),
																_Utils_Tuple2(
																'max_asset',
																A2(
																	$author$project$Eos$assetToString,
																	translators_,
																	{ji: maxTransferAmount, as: balance.as}))
															]));
												}),
											A2(
												$elm$core$Basics$composeR,
												$author$project$Form$Validate$map(
													function (amount) {
														return {ji: amount, as: community.as};
													}),
												$author$project$Form$Validate$validate(translators)))))),
							qd: F2(
								function (amount, input) {
									return _Utils_update(
										input,
										{ji: amount});
								}),
							lW: function ($) {
								return $.ji;
							}
						},
						A2(
							$author$project$Form$Text$withCurrency,
							balance.as,
							A2(
								$author$project$Form$Text$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-4')
									]),
								$author$project$Form$Text$init(
									{
										w: 'transfer-amount-field',
										n$: A2(
											translators.i4,
											'account.my_wallet.transfer.amount',
											_List_fromArray(
												[
													_Utils_Tuple2(
													'symbol',
													$author$project$Eos$symbolToSymbolCodeString(community.as))
												]))
									})))),
					A2(
						$author$project$Form$with,
						A2(
							$author$project$Form$userPicker,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: function (maybeUser) {
									if (maybeUser.$ === 1) {
										return $elm$core$Result$Err(
											translators.fL('transfer.no_profile'));
									} else {
										var user = maybeUser.a;
										return _Utils_eq(user.l8, loggedIn._) ? $elm$core$Result$Err(
											translators.fL('transfer.to_self')) : $elm$core$Result$Ok(user);
									}
								},
								qd: F2(
									function (selectedProfile, input) {
										return _Utils_update(
											input,
											{H: selectedProfile});
									}),
								lW: function ($) {
									return $.H;
								}
							},
							$author$project$Form$UserPicker$init(
								{
									eR: loggedIn._,
									n$: translators.fL('account.my_wallet.transfer.send_to'),
									fs: community.ih
								})),
						$author$project$Form$succeed($author$project$Page$Community$Transfer$FormOutput)))));
	});
var $author$project$Page$Community$Transfer$viewForm = F4(
	function (loggedIn, model, community, maxTransferAmount) {
		var shared = loggedIn.A;
		var text_ = function (s) {
			return $elm$html$Html$text(
				loggedIn.A.aw.fL(s));
		};
		var isDisabled = function () {
			var _v0 = model.a0;
			switch (_v0.$) {
				case 0:
					return false;
				case 1:
					return true;
				default:
					return true;
			}
		}();
		var currBalance = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			{ji: 0, as: community.as},
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.mk;
				},
				model.cA));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Page$viewHeader,
					loggedIn,
					shared.aw.fL('transfer.title')),
					A6(
					$author$project$Form$view,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto p-4')
						]),
					shared.aw,
					function (submitButton) {
						return _List_fromArray(
							[
								A2(
								submitButton,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full mt-6 button button-primary'),
										$elm$html$Html$Attributes$disabled(!loggedIn.gz)
									]),
								_List_fromArray(
									[
										text_('account.my_wallet.transfer.submit')
									]))
							]);
					},
					A4($author$project$Page$Community$Transfer$createForm, loggedIn, community, currBalance, maxTransferAmount),
					A2($author$project$Form$withDisabled, isDisabled, model.hY),
					{oU: $author$project$Page$Community$Transfer$SubmittedForm, lF: $author$project$Page$Community$Transfer$GotFormMsg})
				]));
	});
var $author$project$Page$Community$Transfer$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var content = function () {
			var _v0 = _Utils_Tuple2(
				loggedIn.pC,
				$author$project$Page$Community$Transfer$getMaxTransferAmount(model));
			_v0$2:
			while (true) {
				_v0$3:
				while (true) {
					_v0$4:
					while (true) {
						switch (_v0.a.$) {
							case 0:
								var _v1 = _v0.a;
								return $author$project$Page$fullPageLoading(shared);
							case 1:
								var _v2 = _v0.a;
								return $author$project$Page$fullPageLoading(shared);
							case 2:
								switch (_v0.b.$) {
									case 0:
										break _v0$2;
									case 1:
										break _v0$3;
									case 2:
										break _v0$4;
									default:
										break _v0$4;
								}
							default:
								switch (_v0.b.$) {
									case 0:
										break _v0$2;
									case 1:
										break _v0$3;
									case 2:
										var e = _v0.b.a;
										var httpError = function () {
											if (!e.$) {
												var error = e.a;
												return error;
											} else {
												if (e.a.$ === 1) {
													var error = e.a.a;
													return error;
												} else {
													var _v6 = e.a;
													return $elm$http$Http$Timeout;
												}
											}
										}();
										return A2(
											$author$project$Page$fullPageError,
											shared.aw.fL('community.objectives.title_plural'),
											httpError);
									default:
										var community = _v0.a.a;
										var maxTransferAmount = _v0.b.a;
										return A4($author$project$Page$Community$Transfer$viewForm, loggedIn, model, community, maxTransferAmount);
								}
						}
					}
					var e = _v0.a.a;
					return A2(
						$author$project$Page$fullPageGraphQLError,
						shared.aw.fL('community.objectives.title_plural'),
						e);
				}
				var _v4 = _v0.b;
				return $author$project$Page$fullPageLoading(shared);
			}
			var _v3 = _v0.b;
			return $author$project$Page$fullPageLoading(shared);
		}();
		return {
			mJ: content,
			fN: shared.aw.fL('transfer.title')
		};
	});
var $author$project$Page$Dashboard$ClickedAcceptCodeOfConduct = {$: 21};
var $author$project$Page$Dashboard$ClosedAddContactModal = {$: 15};
var $author$project$Profile$Contact$ClickedSubmit = {$: 8};
var $author$project$Profile$Contact$ClosedDeleteModal = {$: 5};
var $author$project$Profile$Contact$ConfirmedDeleteContact = function (a) {
	return {$: 6, a: a};
};
var $krisajenkins$remotedata$RemoteData$isFailure = function (data) {
	if (data.$ === 2) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Profile$Contact$isMultiple = function (kind) {
	if (kind.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
	if (data.$ === 3) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$View$Components$loadingLogoAnimatedFluid = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('w-full text-center h-full py-2')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto h-full'),
					$elm$html$Html$Attributes$src('/images/loading.svg')
				]),
			_List_Nil)
		]));
var $author$project$Profile$Contact$EnteredContactOption = function (a) {
	return {$: 7, a: a};
};
var $author$project$Profile$Contact$contactTypeToString = F2(
	function (translators, contactType) {
		return translators.fL(
			function (asString) {
				return 'contact_form.types.' + asString;
			}(
				$elm$core$String$toLower(
					$author$project$Cambiatus$Enum$ContactType$toString(contactType))));
	});
var $author$project$Profile$Contact$viewContactTypeSelect = F2(
	function (translators, contactType) {
		var t = translators.fL;
		var makeOption = function (contactType_) {
			return {
				n$: A2($author$project$Profile$Contact$contactTypeToString, translators, contactType_),
				gY: contactType_
			};
		};
		return function (options) {
			return A2(
				$author$project$Form$Select$view,
				options,
				{
					na: $elm$html$Html$text(''),
					no: false,
					nV: false,
					oF: $author$project$Profile$Contact$NoOp,
					kV: $author$project$Profile$Contact$EnteredContactOption,
					lW: contactType
				});
		}(
			A2(
				$author$project$Form$Select$withContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-10')
					]),
				A2(
					$author$project$Form$Select$withOptions,
					A2($elm$core$List$map, makeOption, $author$project$Cambiatus$Enum$ContactType$list),
					$author$project$Form$Select$init(
						{
							w: 'contact-type',
							n$: t('contact_form.contact_type'),
							d5: $author$project$Cambiatus$Enum$ContactType$toString
						}))));
	});
var $author$project$Profile$Contact$ClickedToggleContactFlags = function (a) {
	return {$: 2, a: a};
};
var $author$project$Profile$Contact$PressedDownArrowOnFlagSelect = function (a) {
	return {$: 12, a: a};
};
var $author$project$Profile$Contact$PressedUpArrowOnFlagSelect = function (a) {
	return {$: 11, a: a};
};
var $author$project$Profile$Contact$SelectedCountry = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Profile$Contact$viewFlagsSelect = F2(
	function (_v0, basic) {
		var t = _v0.fL;
		var withPreventAll = function (message) {
			return {of: message, k3: true, lw: true};
		};
		var escListener = A2(
			$elm$html$Html$Events$custom,
			'keydown',
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return ((key === 'Esc') || (key === 'Escape')) ? $elm$json$Json$Decode$succeed(
						{
							of: $author$project$Profile$Contact$ClickedToggleContactFlags(basic.mE),
							k3: true,
							lw: true
						}) : $elm$json$Json$Decode$fail('Expecting Esc');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
		var flag = F3(
			function (addId, classes, supportedCountry) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full flex items-center space-x-2 text-menu rounded-sm focus:outline-none focus:ring focus:ring-offset-2 ' + classes),
							$elm$html$Html$Events$onClick(
							A2($author$project$Profile$Contact$SelectedCountry, basic.mE, supportedCountry)),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$tabindex(-1),
							escListener,
							addId ? $elm$html$Html$Attributes$id(
							A2($author$project$Profile$Contact$flagId, supportedCountry, basic.mE)) : $elm$html$Html$Attributes$class('')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-7'),
									$elm$html$Html$Attributes$src(supportedCountry.aU)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('justify-self-center text-left'),
									A2($elm$html$Html$Attributes$style, 'min-width', '4ch')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('+' + supportedCountry.mP.eO)
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-10 flex-shrink-0')
				]),
			_List_fromArray(
				[
					basic.co ? A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fixed top-0 left-0 w-full h-full cursor-default z-40'),
							$elm$html$Html$Events$onClick(
							$author$project$Profile$Contact$ClickedToggleContactFlags(basic.mE)),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$tabindex(-1)
						]),
					_List_Nil) : $elm$html$Html$text(''),
					A2(
					$author$project$View$Components$label,
					_List_Nil,
					{
						n0: t('contact_form.country'),
						pZ: $author$project$Profile$Contact$flagSelectorId(basic.mE)
					}),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-select relative'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('border-none mx-px', basic.co)
								])),
							$elm$html$Html$Events$onClick(
							$author$project$Profile$Contact$ClickedToggleContactFlags(basic.mE)),
							$elm$html$Html$Attributes$id(
							$author$project$Profile$Contact$flagSelectorId(basic.mE)),
							$elm$html$Html$Attributes$type_('button'),
							A2(
							$elm$html$Html$Events$custom,
							'keydown',
							A2(
								$elm$json$Json$Decode$andThen,
								function (key) {
									switch (key) {
										case 'ArrowUp':
											return $elm$json$Json$Decode$succeed(
												withPreventAll(
													$author$project$Profile$Contact$PressedUpArrowOnFlagSelect(basic.mE)));
										case 'ArrowDown':
											return $elm$json$Json$Decode$succeed(
												withPreventAll(
													$author$project$Profile$Contact$PressedDownArrowOnFlagSelect(basic.mE)));
										case 'Esc':
											return $elm$json$Json$Decode$succeed(
												withPreventAll(
													$author$project$Profile$Contact$ClickedToggleContactFlags(basic.mE)));
										case 'Escape':
											return $elm$json$Json$Decode$succeed(
												withPreventAll(
													$author$project$Profile$Contact$ClickedToggleContactFlags(basic.mE)));
										case 'Tab':
											return basic.co ? $elm$json$Json$Decode$succeed(
												{
													of: $author$project$Profile$Contact$ClickedToggleContactFlags(basic.mE),
													k3: false,
													lw: false
												}) : $elm$json$Json$Decode$fail('Only listen to tab when dropdown is open');
										default:
											return $elm$json$Json$Decode$fail('Expected arrow up or arrow down');
									}
								},
								A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)))
						]),
					_List_fromArray(
						[
							A3(flag, false, '', basic.aM),
							basic.co ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute input -mx-px inset-x-0 top-0 space-y-4 z-50 h-44 overflow-auto'),
									$elm$html$Html$Attributes$tabindex(-1)
								]),
							A2(
								$elm$core$List$map,
								A2(flag, true, 'mt-1'),
								$author$project$Profile$Contact$countryOptions(basic.aM))) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Profile$Contact$EnteredContactText = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Profile$Contact$phoneMask = function (basic) {
	return {
		gR: A2(
			$elm$core$String$map,
			function (phoneChar) {
				return $elm$core$Char$isDigit(phoneChar) ? '#' : phoneChar;
			},
			basic.aM.aJ),
		pu: '#'
	};
};
var $author$project$Form$Text$withAllowedChars = F2(
	function (isAllowed, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				bX: A2(
					$elm$core$Basics$composeR,
					$elm$core$String$filter(isAllowed),
					options.bX)
			});
	});
var $author$project$Profile$Contact$viewPhoneInput = F2(
	function (translators, basic) {
		var t = translators.fL;
		var tr = translators.i4;
		return function (options) {
			return A2(
				$author$project$Form$Text$view,
				options,
				{
					na: function () {
						var _v0 = basic.jO;
						if (!_v0.$) {
							if (_v0.a.b) {
								var _v1 = _v0.a;
								var firstError = _v1.a;
								return A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('form-error')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(firstError)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						} else {
							return $elm$html$Html$text('');
						}
					}(),
					no: $elm_community$maybe_extra$Maybe$Extra$isJust(basic.jO),
					nV: false,
					oF: $author$project$Profile$Contact$NoOp,
					oH: $author$project$Profile$Contact$EnteredContactText(basic.mE),
					aw: translators,
					lW: basic.mD
				});
		}(
			A2(
				$author$project$Form$Text$withContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				A2(
					$author$project$Form$Text$withAllowedChars,
					$elm$core$Char$isDigit,
					A2(
						$author$project$Form$Text$withType,
						1,
						A2(
							$author$project$Form$Text$withMask,
							$author$project$Profile$Contact$phoneMask(basic),
							A2(
								$author$project$Form$Text$withPlaceholder,
								A2(
									tr,
									'contact_form.phone.placeholder',
									_List_fromArray(
										[
											_Utils_Tuple2('example_number', basic.aM.aJ)
										])),
								$author$project$Form$Text$init(
									{
										w: $author$project$Cambiatus$Enum$ContactType$toString(basic.mE) + '-input',
										n$: t('contact_form.phone.label')
									})))))));
	});
var $author$project$Profile$Contact$viewTextInput = F2(
	function (translators, basic) {
		var t = translators.fL;
		var contactKey = function () {
			var _v2 = basic.mE;
			switch (_v2) {
				case 1:
					return 'username';
				case 4:
					return 'username';
				case 2:
					return 'link';
				case 0:
					return 'email';
				case 5:
					return 'phone';
				default:
					return 'phone';
			}
		}();
		return function (options) {
			return A2(
				$author$project$Form$Text$view,
				options,
				{
					na: function () {
						var _v0 = basic.jO;
						if (!_v0.$) {
							if (_v0.a.b) {
								var _v1 = _v0.a;
								var firstError = _v1.a;
								return A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('form-error')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(firstError)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						} else {
							return $elm$html$Html$text('');
						}
					}(),
					no: $elm_community$maybe_extra$Maybe$Extra$isJust(basic.jO),
					nV: false,
					oF: $author$project$Profile$Contact$NoOp,
					oH: $author$project$Profile$Contact$EnteredContactText(basic.mE),
					aw: translators,
					lW: basic.mD
				});
		}(
			A2(
				$author$project$Form$Text$withContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				A2(
					$author$project$Form$Text$withPlaceholder,
					t('contact_form.' + (contactKey + '.placeholder')),
					$author$project$Form$Text$init(
						{
							w: $author$project$Cambiatus$Enum$ContactType$toString(basic.mE) + '-input',
							n$: t('contact_form.' + (contactKey + '.label'))
						}))));
	});
var $author$project$Profile$Contact$viewInput = F2(
	function (translators, basic) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex space-x-4')
				]),
			$author$project$Profile$Contact$usesPhone(basic.mE) ? _List_fromArray(
				[
					A2($author$project$Profile$Contact$viewFlagsSelect, translators, basic),
					A2($author$project$Profile$Contact$viewPhoneInput, translators, basic)
				]) : _List_fromArray(
				[
					A2($author$project$Profile$Contact$viewTextInput, translators, basic)
				]));
	});
var $author$project$Profile$Contact$ClickedDeleteContact = function (a) {
	return {$: 4, a: a};
};
var $author$project$Profile$Contact$viewInputWithBackground = F2(
	function (translators, basic) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-gray-100 p-4 pb-0 rounded mb-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-menu font-semibold flex items-center mb-4 justify-between')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center')
								]),
							_List_fromArray(
								[
									A3($author$project$Profile$Contact$contactTypeToIcon, 'mr-2', false, basic.mE),
									$elm$html$Html$text(
									A2($author$project$Profile$Contact$contactTypeToString, translators, basic.mE))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Profile$Contact$ClickedDeleteContact(basic.mE)),
									$elm$html$Html$Attributes$type_('button')
								]),
							_List_fromArray(
								[
									$author$project$Icons$trash('text-red')
								]))
						])),
					A2($author$project$Profile$Contact$viewInput, translators, basic)
				]));
	});
var $author$project$Profile$Contact$view = F2(
	function (translators, model) {
		var submitText = $elm$html$Html$text(
			translators.fL(
				function () {
					var _v3 = model.z;
					if (!_v3.$) {
						var contact = _v3.a;
						var _v4 = contact.mE;
						switch (_v4) {
							case 1:
								return 'contact_form.username.submit';
							case 4:
								return 'contact_form.username.submit';
							case 2:
								return 'contact_form.link.submit';
							case 0:
								return 'contact_form.email.submit';
							case 5:
								return 'contact_form.phone.submit';
							default:
								return 'contact_form.phone.submit';
						}
					} else {
						return 'contact_form.submit_multiple';
					}
				}()));
		var isDisabled = $krisajenkins$remotedata$RemoteData$isLoading(model.Z) || $krisajenkins$remotedata$RemoteData$isSuccess(model.Z);
		var submitButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button w-full'),
					$elm$html$Html$Attributes$type_('submit'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'button-success',
							$krisajenkins$remotedata$RemoteData$isSuccess(model.Z)),
							_Utils_Tuple2(
							'button-primary',
							!$krisajenkins$remotedata$RemoteData$isSuccess(model.Z)),
							_Utils_Tuple2(
							'mt-7',
							$author$project$Profile$Contact$isMultiple(model.z))
						])),
					$elm$html$Html$Attributes$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					function () {
					var _v2 = model.Z;
					if (_v2.$ === 1) {
						return $author$project$View$Components$loadingLogoAnimatedFluid;
					} else {
						return submitText;
					}
				}()
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'container mx-auto',
							$author$project$Profile$Contact$isMultiple(model.z))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-12'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'px-4',
									$author$project$Profile$Contact$isMultiple(model.z)),
									_Utils_Tuple2(
									'w-full md:w-5/6 mx-auto lg:w-2/3',
									!$author$project$Profile$Contact$isMultiple(model.z))
								])),
							$elm$html$Html$Events$onSubmit($author$project$Profile$Contact$ClickedSubmit)
						]),
					_Utils_ap(
						function () {
							var _v0 = model.z;
							if (!_v0.$) {
								var contact = _v0.a;
								return _List_fromArray(
									[
										A2($author$project$Profile$Contact$viewContactTypeSelect, translators, contact.mE),
										A2($author$project$Profile$Contact$viewInput, translators, contact)
									]);
							} else {
								var contacts = _v0.a;
								return A2(
									$elm$core$List$map,
									$author$project$Profile$Contact$viewInputWithBackground(translators),
									contacts);
							}
						}(),
						_List_fromArray(
							[
								submitButton,
								$krisajenkins$remotedata$RemoteData$isFailure(model.Z) ? $elm$html$Html$text(
								translators.fL('contact_form.error')) : $elm$html$Html$text('')
							]))),
					function () {
					var _v1 = model.cC;
					if (!_v1.$) {
						var contactType = _v1.a;
						return $author$project$View$Modal$toHtml(
							A2(
								$author$project$View$Modal$withFooter,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('modal-cancel'),
												$elm$html$Html$Events$onClick($author$project$Profile$Contact$ClosedDeleteModal)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												translators.fL('contact_form.delete.cancel'))
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('modal-accept'),
												$elm$html$Html$Events$onClick(
												$author$project$Profile$Contact$ConfirmedDeleteContact(contactType))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												translators.fL('contact_form.delete.accept'))
											]))
									]),
								A2(
									$author$project$View$Modal$withBody,
									_List_fromArray(
										[
											$elm$html$Html$text(
											translators.fL('contact_form.delete.body'))
										]),
									A2(
										$author$project$View$Modal$withHeader,
										translators.fL('contact_form.delete.title'),
										$author$project$View$Modal$initWith(
											{mw: $author$project$Profile$Contact$ClosedDeleteModal, nX: true})))));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Page$Dashboard$addContactModal = F2(
	function (shared, model) {
		var contactModel = model.eM;
		var text_ = function (s) {
			return $elm$html$Html$text(
				shared.aw.fL(s));
		};
		var header = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline bg-purple-100 text-white rounded-full py-0.5 px-2 text-sm uppercase')
						]),
					_List_fromArray(
						[
							text_('contact_modal.new')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-lg font-bold mt-2')
						]),
					_List_fromArray(
						[
							text_('contact_modal.title')
						]))
				]));
		var form = A2(
			$elm$html$Html$map,
			$author$project$Page$Dashboard$GotContactMsg,
			A2($author$project$Profile$Contact$view, shared.aw, contactModel));
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withSize,
				1,
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mx-auto mt-10'),
									$elm$html$Html$Attributes$src('/images/girl-with-phone.svg')
								]),
							_List_Nil),
							form,
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-sm text-center uppercase my-4')
								]),
							_List_fromArray(
								[
									text_('contact_modal.footer')
								]))
						]),
					A2(
						$author$project$View$Modal$withHeaderElement,
						header,
						$author$project$View$Modal$initWith(
							{mw: $author$project$Page$Dashboard$ClosedAddContactModal, nX: model.bN})))));
	});
var $author$project$Markdown$fromTranslationWithReplacements = F3(
	function (_v0, key, replacements) {
		var tr = _v0.i4;
		return A2(tr, key, replacements);
	});
var $author$project$Page$Dashboard$viewActionsForAnalysisCard = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, t);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('md:animate-fade-in-from-above-lg md:animation-delay-150 md:motion-reduce:animate-none', !loggedIn.gC)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-333 mt-6 mb-4 md:mb-7 lg:mt-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									text_('dashboard.analysis.title.1')
								])),
							$elm$html$Html$text(' '),
							text_('dashboard.analysis.title.2')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded py-6')
						]),
					_List_fromArray(
						[
							function () {
							var _v1 = model.dj;
							switch (_v1.$) {
								case 0:
									return A2($author$project$View$Components$loadingLogoAnimated, loggedIn.A.aw, '-mt-8');
								case 2:
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('px-6')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-2/3 mx-auto'),
														$elm$html$Html$Attributes$src('/images/error.svg')
													]),
												_List_Nil),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-center mt-4')
													]),
												_List_fromArray(
													[
														text_('dashboard.analysis.error_fetching')
													]))
											]));
								default:
									var analysis = _v1.a;
									var claims = analysis.jt;
									var compareAvatars = F2(
										function (first, second) {
											var _v2 = _Utils_Tuple2(
												$author$project$Avatar$toMaybeString(first),
												$author$project$Avatar$toMaybeString(second));
											if (!_v2.a.$) {
												if (!_v2.b.$) {
													var x = _v2.a.a;
													var y = _v2.b.a;
													return _Utils_eq(x, y) ? 0 : 1;
												} else {
													var _v3 = _v2.b;
													return 0;
												}
											} else {
												if (!_v2.b.$) {
													var _v4 = _v2.a;
													return 2;
												} else {
													var _v5 = _v2.a;
													var _v6 = _v2.b;
													return 1;
												}
											}
										});
									return (analysis.mO > 0) ? A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-2/3 mx-auto')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex justify-center space-x-2 mb-4')
													]),
												A2(
													$elm$core$List$map,
													function (avatar) {
														return A2($author$project$Avatar$view, avatar, 'w-7 h-7');
													},
													A2(
														$elm$core$List$take,
														5,
														A2(
															$elm$core$List$sortWith,
															compareAvatars,
															A2(
																$elm$core$List$map,
																A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.gb;
																	},
																	function ($) {
																		return $.dl;
																	}),
																claims))))),
												A2(
												$author$project$Markdown$view,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-4 text-center')
													]),
												A3(
													$author$project$Markdown$fromTranslationWithReplacements,
													loggedIn.A.aw,
													'dashboard.analysis.count',
													_List_fromArray(
														[
															_Utils_Tuple2(
															'amount',
															$elm$core$String$fromInt(analysis.mO))
														]))),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('button button-primary w-full'),
														$author$project$Route$href($author$project$Route$Analysis)
													]),
												_List_fromArray(
													[
														text_('dashboard.analysis.analyze_now')
													]))
											])) : A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('py-4')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mx-auto'),
														$elm$html$Html$Attributes$src('/images/empty-analysis.svg')
													]),
												_List_Nil),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-5 text-center text-gray-333')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																text_('dashboard.analysis.empty.1')
															])),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														text_('dashboard.analysis.empty.2')
													]))
											]));
							}
						}()
						]))
				]));
	});
var $author$project$Session$LoggedIn$viewFrozenAccountCard = F3(
	function (_v0, options, attrs) {
		var t = _v0.fL;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('bg-white rounded py-10 px-4'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('md:flex md:space-x-6 lg:max-w-2xl md:py-6 md:px-10', options.nS)
							])),
					attrs)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/images/girl-with-ice-cube.svg'),
							$elm$html$Html$Attributes$alt(''),
							$elm$html$Html$Attributes$class('mx-auto mb-8'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('md:mb-0', options.nS)
								]))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold text-black text-lg mb-6')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('account_frozen.title'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black mb-3')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('account_frozen.why'))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('account_frozen.solve')),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-orange-300 hover:underline focus-ring focus-visible:ring-orange-300 focus-visible:ring-opacity-30 rounded-sm'),
											$elm$html$Html$Attributes$href('#'),
											$elm$html$Html$Events$onClick(options.oJ)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('account_frozen.solve_link'))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Dashboard$CloseInviteModal = {$: 16};
var $author$project$Page$Dashboard$CopyToClipboard = function (a) {
	return {$: 18, a: a};
};
var $author$project$Page$Dashboard$viewInvitationModal = F2(
	function (_v0, model) {
		var shared = _v0.A;
		var t = shared.aw.fL;
		var text_ = function (s) {
			return $elm$html$Html$text(
				t(s));
		};
		var protocol = function () {
			var _v6 = shared.hn.pn;
			if (!_v6) {
				return 'http://';
			} else {
				return 'https://';
			}
		}();
		var url = function (invitationId) {
			var portStr = function () {
				var _v5 = shared.hn.pb;
				if (!_v5.$) {
					var p = _v5.a;
					return ':' + $elm$core$String$fromInt(p);
				} else {
					return '';
				}
			}();
			return protocol + (shared.hn.e3 + (portStr + ('/invite/' + invitationId)));
		};
		var isInviteModalVisible = function () {
			var _v4 = model.bg;
			if (!_v4.$) {
				return false;
			} else {
				return true;
			}
		}();
		var header = t('community.invite.title');
		var footer = function () {
			var _v3 = model.bg;
			switch (_v3.$) {
				case 3:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('button-primary', !model.cD),
											_Utils_Tuple2('button-success', model.cD)
										])),
									$elm$html$Html$Attributes$class('button w-full md:w-48 select-all'),
									$elm$html$Html$Attributes$id('copy-invite-button'),
									$elm$html$Html$Events$onClick(
									$author$project$Page$Dashboard$CopyToClipboard('invitation-id'))
								]),
							_List_fromArray(
								[
									model.cD ? text_('community.invite.copied') : text_('community.invite.copy')
								]))
						]);
				case 2:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary'),
									$elm$html$Html$Events$onClick($author$project$Page$Dashboard$CloseInviteModal)
								]),
							_List_fromArray(
								[
									text_('menu.close')
								]))
						]);
				default:
					return _List_Nil;
			}
		}();
		var body = function () {
			var _v1 = model.bg;
			switch (_v1.$) {
				case 0:
					return _List_Nil;
				case 1:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('spinner m-auto')
								]),
							_List_Nil)
						]);
				case 2:
					var err = _v1.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center text-red')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(err)
								]))
						]);
				default:
					var invitationId = _v1.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-3 label')
								]),
							_List_fromArray(
								[
									text_('community.invite.label')
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('py-2 md:text-lg text-black')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									url(invitationId))
								])),
							A2(
							$author$project$Form$Text$view,
							A2(
								$author$project$Form$Text$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-0 overflow-hidden')
									]),
								A2(
									$author$project$Form$Text$withExtraAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute opacity-0 left-[-9999em]'),
											$elm$html$Html$Attributes$tabindex(-1)
										]),
									$author$project$Form$Text$init(
										{w: 'invitation-id', n$: ''}))),
							{
								na: $elm$html$Html$text(''),
								no: false,
								nV: false,
								oF: $author$project$Page$Dashboard$NoOp,
								oH: function (_v2) {
									return $author$project$Page$Dashboard$NoOp;
								},
								aw: shared.aw,
								lW: url(invitationId)
							})
						]);
			}
		}();
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withFooter,
				footer,
				A2(
					$author$project$View$Modal$withBody,
					body,
					A2(
						$author$project$View$Modal$withHeader,
						header,
						$author$project$View$Modal$initWith(
							{mw: $author$project$Page$Dashboard$CloseInviteModal, nX: isInviteModalVisible})))));
	});
var $author$project$Page$Dashboard$ClosedModalRequestingSponsor = {$: 20};
var $author$project$View$Modal$Large = 0;
var $author$project$Page$Dashboard$viewNewTag = function (shared) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center bg-purple-100 text-white rounded-full py-0.5 px-2 text-caption uppercase')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				shared.aw.fL('contact_modal.new'))
			]));
};
var $author$project$Page$Dashboard$viewModalRequestingSponsor = F3(
	function (shared, community, model) {
		var text_ = A2($elm$core$Basics$composeR, shared.aw.fL, $elm$html$Html$text);
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withSize,
				0,
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col items-center h-full')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-center text-heading font-bold')
										]),
									_List_fromArray(
										[
											text_('sponsorship.dashboard_modal.title')
										])),
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-4'),
											$elm$html$Html$Attributes$src('/images/sponsor-community.svg')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full mt-7 mx-auto md:w-5/6 lg:w-2/3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-center mb-6')
												]),
											_List_fromArray(
												[
													text_('sponsorship.dashboard_modal.subtitle')
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-center mb-6')
												]),
											_List_fromArray(
												[
													text_('sponsorship.dashboard_modal.explanation')
												])),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button button-primary w-full md:mt-8 mb-6'),
													$author$project$Route$href($author$project$Route$CommunitySponsor)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														shared.aw.i4,
														'sponsorship.dashboard_modal.sponsor',
														_List_fromArray(
															[
																_Utils_Tuple2('community_name', community.fj)
															])))
												]))
										]))
								]))
						]),
					A2(
						$author$project$View$Modal$withHeaderElement,
						$author$project$Page$Dashboard$viewNewTag(shared),
						$author$project$View$Modal$initWith(
							{mw: $author$project$Page$Dashboard$ClosedModalRequestingSponsor, nX: model.cp})))));
	});
var $author$project$Page$Dashboard$ClickedOpenTransferFilters = {$: 7};
var $author$project$Page$Dashboard$RequestedMoreTransfers = {$: 6};
var $author$project$View$Components$TrackSelf = {$: 0};
var $author$project$View$Components$TrackWindow = {$: 1};
var $author$project$Page$Dashboard$hasModalsOpen = function (model) {
	var isShowingInviteModal = function () {
		var _v1 = model.bg;
		if (!_v1.$) {
			return false;
		} else {
			return true;
		}
	}();
	var isShowingClaimModal = function () {
		var _v0 = model.hF;
		if (_v0.$ === 3) {
			return false;
		} else {
			return true;
		}
	}();
	return model.c8 || (model.bN || (model.cp || (isShowingInviteModal || isShowingClaimModal)));
};
var $author$project$View$Components$infiniteList = F3(
	function (options, attrs, children) {
		var requestedItemsListener = function () {
			var _v1 = options.oP;
			if (_v1.$ === 1) {
				return $elm$html$Html$Attributes$class('');
			} else {
				var onRequestedItems = _v1.a;
				return A2(
					$elm$html$Html$Events$on,
					'requested-items',
					$elm$json$Json$Decode$succeed(onRequestedItems));
			}
		}();
		var elementToTrackToString = function (elementToTrack) {
			switch (elementToTrack.$) {
				case 1:
					return 'track-window';
				case 0:
					return 'track-self';
				default:
					var selector = elementToTrack.a;
					return selector;
			}
		};
		return A3(
			$elm$html$Html$node,
			'infinite-list',
			A2(
				$elm$core$List$cons,
				requestedItemsListener,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('overflow-y-auto inline-block'),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Attributes$attribute,
							'elm-distance-to-request',
							$elm$core$String$fromInt(options.m$)),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$Attributes$attribute,
								'elm-element-to-track',
								elementToTrackToString(options.m6)),
							attrs)))),
			children);
	});
var $author$project$Page$Dashboard$ClickedTransferCard = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Dashboard$GotTransferCardProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Dashboard$viewTransfer = F3(
	function (loggedIn, transfer, profileSummary) {
		var addRelativeSelector = loggedIn.gC ? $elm$core$Basics$identity : $author$project$Profile$Summary$withRelativeSelector('#transfer-list-container');
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var _v1 = _Utils_eq(transfer.e_.l8, loggedIn._) ? _Utils_Tuple2(transfer.fO, true) : _Utils_Tuple2(transfer.e_, false);
		var otherProfile = _v1.a;
		var isFromUser = _v1.b;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex w-full px-6 py-4 focus-ring ring-inset focus-visible:rounded-sm hover:bg-gray-200'),
					$elm$html$Html$Events$onClick(
					$author$project$Page$Dashboard$ClickedTransferCard(transfer.w))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Page$Dashboard$GotTransferCardProfileSummaryMsg(transfer.w),
					A4(
						$author$project$Profile$Summary$view,
						loggedIn.A.aw,
						loggedIn._,
						otherProfile,
						A2(
							$author$project$Profile$Summary$withScrollSelector,
							'#transfer-list-container',
							addRelativeSelector(
								A2(
									$author$project$Profile$Summary$withPreventScrolling,
									1,
									A2(
										$author$project$Profile$Summary$withImageSize,
										'w-8 h-8',
										$author$project$Profile$Summary$withoutName(profileSummary))))))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-4 text-left')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-1')
								]),
							_List_fromArray(
								[
									isFromUser ? $elm$html$Html$text(
									t('transfer.sent_to')) : $elm$html$Html$text(
									t('transfer.received_from')),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$Eos$Account$nameToString(otherProfile.l8),
												otherProfile.fj))
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-green')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Eos$assetToString,
												loggedIn.A.aw,
												{ji: transfer.lW, as: transfer.V.as}))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Dashboard$viewTransferList = F5(
	function (loggedIn, model, transfers, maybePageInfo, isLoading) {
		var infiniteList = function (isMobile_) {
			return $author$project$View$Components$infiniteList(
				{
					m$: 800,
					m6: isMobile_ ? $author$project$View$Components$TrackWindow : $author$project$View$Components$TrackSelf,
					oP: A2(
						$elm$core$Maybe$andThen,
						function (pageInfo) {
							return pageInfo.np ? $elm$core$Maybe$Just($author$project$Page$Dashboard$RequestedMoreTransfers) : $elm$core$Maybe$Nothing;
						},
						maybePageInfo)
				});
		};
		var container = F2(
			function (attrs, children) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							infiniteList,
							true,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('md:hidden'),
								attrs),
							children),
							A3(
							infiniteList,
							false,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('hidden md:block'),
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'height', 'max(60vh, 400px)'),
									attrs)),
							children)
						]));
			});
		var addLoading = function (transfers_) {
			return isLoading ? _Utils_ap(
				transfers_,
				_List_fromArray(
					[
						A2($author$project$View$Components$loadingLogoAnimated, loggedIn.A.aw, 'mb-8')
					])) : transfers_;
		};
		return A2(
			container,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$tabindex(-1),
					$elm$html$Html$Attributes$class('w-full'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'md:overflow-y-hidden',
							$author$project$Page$Dashboard$hasModalsOpen(model))
						]))
				]),
			addLoading(
				A2(
					$elm$core$List$map,
					function (_v2) {
						var first = _v2.a;
						var t1 = first.a;
						var rest = _v2.b;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pb-6 first:pt-4 last:pb-2')
								]),
							$elm$core$List$concat(
								A2(
									$elm$core$List$cons,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('uppercase text-sm font-bold px-6')
												]),
											_List_fromArray(
												[
													A4(
													$author$project$View$Components$dateViewer,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-black')
														]),
													$elm$core$Basics$identity,
													loggedIn.A,
													$author$project$Utils$fromDateTime(t1.f5)),
													$elm$html$Html$text(' '),
													A4(
													$author$project$View$Components$dateViewer,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-gray-333')
														]),
													function (translations) {
														return _Utils_update(
															translations,
															{
																o$: '',
																p4: $elm$core$Maybe$Just('{{date}}'),
																qo: $elm$core$Maybe$Just('{{date}}')
															});
													},
													loggedIn.A,
													$author$project$Utils$fromDateTime(t1.f5))
												]))
										]),
									A2(
										$elm$core$List$map,
										function (_v3) {
											var transfer = _v3.a;
											var profileSummary = _v3.b;
											return _List_fromArray(
												[
													A3($author$project$Page$Dashboard$viewTransfer, loggedIn, transfer, profileSummary),
													A2(
													$elm$html$Html$hr,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('mx-6 border-gray-100')
														]),
													_List_Nil)
												]);
										},
										A2($elm$core$List$cons, first, rest)))));
					},
					A2(
						$elm_community$list_extra$List$Extra$groupWhile,
						F2(
							function (_v0, _v1) {
								var t1 = _v0.a;
								var t2 = _v1.a;
								return A3(
									$author$project$Utils$areSameDay,
									loggedIn.A.i2,
									$author$project$Utils$fromDateTime(t1.f5),
									$author$project$Utils$fromDateTime(t2.f5));
							}),
						transfers))));
	});
var $author$project$Page$Dashboard$viewTimelineCard = F3(
	function (loggedIn, isValidator, model) {
		var translators = loggedIn.A.aw;
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, translators.fL);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('md:animate-fade-in-from-above-lg md:motion-reduce:animate-none', !loggedIn.gC),
							_Utils_Tuple2('md:animation-delay-300', (!loggedIn.gC) && isValidator),
							_Utils_Tuple2('md:animation-delay-150', (!loggedIn.gC) && (!isValidator))
						])),
					$elm$html$Html$Attributes$id('transfer-list-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between items-center mt-6 mb-4 lg:mt-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-333')
								]),
							_List_fromArray(
								[
									text_('transfer.transfers_latest'),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											text_('transfer.transfers')
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary w-auto h-auto pl-4 flex'),
									$elm$html$Html$Events$onClick($author$project$Page$Dashboard$ClickedOpenTransferFilters)
								]),
							_List_fromArray(
								[
									text_('all_analysis.filter.title'),
									$author$project$Icons$arrowDown('fill-current')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded md:overflow-hidden')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = model.av;
							switch (_v0.$) {
								case 2:
									return A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-900 text-sm py-20 px-6 text-center')
											]),
										_List_fromArray(
											[
												text_('transfer.loading_error')
											]));
								case 0:
									if (_v0.a.$ === 1) {
										var _v1 = _v0.a;
										return A2($author$project$View$Components$loadingLogoAnimated, translators, 'px-6 mb-8');
									} else {
										var transfers = _v0.a.a;
										return A5($author$project$Page$Dashboard$viewTransferList, loggedIn, model, transfers, $elm$core$Maybe$Nothing, true);
									}
								default:
									if (!_v0.a.b) {
										return A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-gray-900 text-sm py-20 px-6 text-center')
												]),
											_List_fromArray(
												[
													text_('transfer.no_transfers_yet')
												]));
									} else {
										var transfers = _v0.a;
										var maybePageInfo = _v0.b;
										return A5($author$project$Page$Dashboard$viewTransferList, loggedIn, model, transfers, maybePageInfo, false);
									}
							}
						}()
						]))
				]));
	});
var $author$project$Page$Dashboard$ClosedTransfersFilters = {$: 8};
var $author$project$Page$Dashboard$SubmittedTransfersFiltersForm = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Dashboard$TransfersFilters = F3(
	function (date, direction, otherAccount) {
		return {dw: date, F: direction, d9: otherAccount};
	});
var $author$project$Cambiatus$Enum$TransferDirectionValue$fromString = function (enumString) {
	switch (enumString) {
		case 'RECEIVING':
			return $elm$core$Maybe$Just(0);
		case 'SENDING':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Form$UserPicker$withMenuClass = F2(
	function (menuClass, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{d$: options.d$ + (' ' + menuClass)});
	});
var $author$project$Form$UserPicker$withModalSelectors = F2(
	function (useModalSelectors, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				eA: !useModalSelectors,
				fr: useModalSelectors ? {
					ee: $elm$core$Maybe$Just('.modal-content'),
					g9: $elm$core$Maybe$Just('.modal-body')
				} : {ee: $elm$core$Maybe$Nothing, g9: $elm$core$Maybe$Nothing}
			});
	});
var $author$project$Page$Dashboard$transferFiltersForm = F2(
	function (loggedIn, users) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		return A2(
			$author$project$Form$with,
			$author$project$Form$introspect(
				function (_v1) {
					var direction = _v1.F;
					var directionText = function () {
						if (direction.$ === 1) {
							return 'transfer.direction.other_user';
						} else {
							if (!direction.a) {
								var _v3 = direction.a;
								return 'transfer.direction.user_who_sent';
							} else {
								var _v4 = direction.a;
								return 'transfer.direction.user_who_received';
							}
						}
					}();
					return A2(
						$author$project$Form$userPicker,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: $elm$core$Result$Ok,
							qd: F2(
								function (user, input) {
									return _Utils_update(
										input,
										{qg: user});
								}),
							lW: function ($) {
								return $.qg;
							}
						},
						A2(
							$author$project$Form$UserPicker$withModalSelectors,
							true,
							A2(
								$author$project$Form$UserPicker$withMenuClass,
								'max-h-44 overflow-y-auto !relative',
								$author$project$Form$UserPicker$init(
									{
										eR: loggedIn._,
										n$: t(directionText),
										fs: users
									}))));
				}),
			A2(
				$author$project$Form$with,
				A3(
					$author$project$Form$select,
					$author$project$Cambiatus$Enum$TransferDirectionValue$fromString,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: $elm$core$Result$Ok,
						qd: F2(
							function (direction, input) {
								return _Utils_update(
									input,
									{F: direction});
							}),
						lW: function ($) {
							return $.F;
						}
					},
					A2(
						$author$project$Form$Select$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-10')
							]),
						A3(
							$author$project$Form$Select$withOption,
							$elm$core$Maybe$Just(0),
							t('transfer.direction.receiving'),
							A3(
								$author$project$Form$Select$withOption,
								$elm$core$Maybe$Just(1),
								t('transfer.direction.sending'),
								A3(
									$author$project$Form$Select$withOption,
									$elm$core$Maybe$Nothing,
									t('transfer.direction.both'),
									$author$project$Form$Select$init(
										{
											w: 'transfer-filters-direction-select',
											n$: t('transfer.direction.title'),
											d5: A2(
												$elm$core$Basics$composeR,
												$elm$core$Maybe$map($author$project$Cambiatus$Enum$TransferDirectionValue$toString),
												$elm$core$Maybe$withDefault('BOTH'))
										})))))),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$datePicker,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: $elm$core$Result$Ok,
							qd: F2(
								function (date, input) {
									return _Utils_update(
										input,
										{dw: date});
								}),
							lW: function ($) {
								return $.dw;
							}
						},
						A2(
							$author$project$Form$DatePicker$withAbsolutePositioning,
							false,
							A2(
								$author$project$Form$DatePicker$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-10')
									]),
								$author$project$Form$DatePicker$init(
									{
										w: 'transfer-filters-date-picker',
										n$: t('payment_history.pick_date')
									})))),
					$author$project$Form$succeed($author$project$Page$Dashboard$TransfersFilters))));
	});
var $author$project$Page$Dashboard$viewTransferFilters = F3(
	function (loggedIn, users, model) {
		var shared = loggedIn.A;
		var _v0 = shared.aw;
		var t = _v0.fL;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						A6(
						$author$project$Form$view,
						_List_Nil,
						shared.aw,
						function (submitButton) {
							return _List_fromArray(
								[
									A2(
									submitButton,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-primary w-full')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('all_analysis.filter.apply'))
										]))
								]);
						},
						A2($author$project$Page$Dashboard$transferFiltersForm, loggedIn, users),
						model.fU,
						{oU: $author$project$Page$Dashboard$SubmittedTransfersFiltersForm, lF: $author$project$Page$Dashboard$GotTransfersFiltersFormMsg})
					]),
				A2(
					$author$project$View$Modal$withHeader,
					t('all_analysis.filter.title'),
					$author$project$View$Modal$initWith(
						{mw: $author$project$Page$Dashboard$ClosedTransfersFilters, nX: model.c8}))));
	});
var $author$project$Page$Dashboard$ClickedSupportUsButton = {$: 12};
var $author$project$Page$Dashboard$CreateInvite = {$: 13};
var $author$project$Icons$flagWithoutBackground = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('19'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 19 20'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M15.9168 6.62927L18.2501 2.91707C18.5353 2.46401 18.5317 1.90851 18.2407 1.45845C17.9497 1.0084 17.4152 0.731624 16.8371 0.731707H1.62416C1.62416 0.327597 1.26058 0 0.81208 0C0.36358 0 0 0.327597 0 0.731707V19.2683C0 19.6724 0.36358 20 0.81208 20C1.26058 20 1.62416 19.6724 1.62416 19.2683V12.9268H16.783C17.3453 12.9261 17.8672 12.6634 18.1627 12.2323C18.4581 11.8012 18.4851 11.2631 18.2339 10.8098L15.9168 6.62927ZM1.6241 11.4634V2.19512H16.7829L14.0381 6.58536L16.745 11.4634H1.6241Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$globe = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14Z'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M17.25 16C16.4061 16.733 15.4181 17.2814 14.3497 17.61C13.2812 17.9385 12.1558 18.0399 11.0458 17.9076C9.93582 17.7754 8.86577 17.4124 7.9044 16.842C6.94303 16.2716 6.1116 15.5065 5.46353 14.5957C4.81545 13.6849 4.36507 12.6486 4.1413 11.5533C3.91753 10.4581 3.92534 9.32822 4.16421 8.2362C4.40308 7.14418 4.86774 6.1142 5.52833 5.21243C6.18892 4.31066 7.03084 3.55705 8 3'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 18V22'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M16 22H8'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$heartStroke = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('22'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 22 20'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M16.2447 0C13.9541 0 12.1226 1.77722 10.9844 2.95389C9.82238 1.78698 7.95737 0 5.67154 0C2.32409 0 0 2.40706 0 5.85896C0 13.3536 9.61675 19.5299 10.0424 19.7789C10.5064 20.0737 11.0942 20.0737 11.5583 19.7789C11.9647 19.5201 21.5385 13.3145 21.5385 5.86384C21.505 2.24594 19.4917 0 16.2447 0ZM10.7451 18.5534C10.7451 18.5534 1.40096 12.6456 1.40096 5.85894C1.40096 3.23706 3.0699 1.46472 5.63788 1.46472C8.20585 1.46472 10.4869 4.88245 10.9651 4.88245C11.4433 4.88245 13.6574 1.46472 16.2254 1.46472C18.7934 1.46472 20.051 3.23706 20.051 5.85894C20.0702 12.5821 10.7451 18.5534 10.7451 18.5534Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$profile = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('32'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3ZM4.77273 16C4.77237 11.0828 7.9718 6.7375 12.6674 5.27792C17.363 3.81834 22.462 5.58413 25.2493 9.63505C28.0366 13.686 27.8635 19.0793 24.8223 22.9432C23.4677 20.9257 21.5024 19.3953 19.2145 18.5764C20.2033 17.518 20.7452 16.1187 20.7273 14.6705C20.7273 11.7159 18.6059 9.35227 16 9.35227C13.3941 9.35227 11.2727 11.7159 11.2727 14.6705C11.258 16.1704 11.8455 17.6136 12.9036 18.6768C10.5995 19.5039 8.65606 21.1088 7.40818 23.215C5.70471 21.197 4.77102 18.6409 4.77273 16ZM16.2955 18.0682C15.9717 18.0695 15.6483 18.0873 15.3264 18.1214C13.8883 17.5999 12.9616 16.1979 13.0455 14.6705C13.0455 12.7145 14.3691 11.125 16 11.125C17.6309 11.125 18.9545 12.7145 18.9545 14.6705C19.0274 16.1549 18.1558 17.5238 16.78 18.0859C16.6205 18.08 16.4609 18.0682 16.2955 18.0682ZM8.72 24.5682C10.0043 22.0608 12.4298 20.3365 15.22 19.9473C15.7952 20.0596 16.388 20.0455 16.9573 19.9059C19.7148 20.2783 22.1494 21.8941 23.5636 24.2905C19.3964 28.1368 13.0103 28.2562 8.70227 24.5682H8.72Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$shop = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('26'),
				$elm$svg$Svg$Attributes$height('26'),
				$elm$svg$Svg$Attributes$viewBox('0 0 26 26'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M24.1537 1.85143C23.8514 1.54952 23.3617 1.54952 23.0594 1.85143L21.6813 3.22956C21.5519 3.19346 21.4183 3.17438 21.2839 3.17278H13.4538C13.0433 3.17314 12.6497 3.33652 12.3596 3.62699L2.07785 13.9036C1.47405 14.5082 1.47405 15.4875 2.07785 16.0921L9.90788 23.9221C10.5124 24.5259 11.4918 24.5259 12.0964 23.9221L22.373 13.6455C22.6615 13.3546 22.823 12.9611 22.822 12.5513V4.72124C22.8204 4.58686 22.8013 4.45326 22.7652 4.3238L24.1434 2.94567C24.4481 2.64625 24.4528 2.15654 24.1537 1.85143ZM21.2787 12.5513L11.0021 22.8279L3.1721 14.9979L13.4539 4.72124H20.1896L17.8257 7.08522C17.4617 6.89131 17.0561 6.78858 16.6437 6.78585C15.2184 6.78585 14.0629 7.9413 14.0629 9.36662C14.0629 10.7919 15.2184 11.9474 16.6437 11.9474C18.069 11.9474 19.2244 10.7919 19.2244 9.36662C19.2201 8.95378 19.1156 8.54816 18.9199 8.18463L21.2839 5.82064L21.2787 12.5513ZM17.6657 9.36662C17.6657 9.93675 17.2035 10.3989 16.6333 10.3989C16.0632 10.3989 15.601 9.93675 15.601 9.36662C15.601 8.79649 16.0632 8.33431 16.6333 8.33431C16.908 8.33294 17.1719 8.4411 17.3666 8.63484C17.5613 8.82858 17.6708 9.09194 17.6708 9.36662H17.6657Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Dashboard$viewWelcomeCard = F3(
	function (loggedIn, community, balance) {
		var shared = loggedIn.A;
		var listItem = F6(
			function (icon, isDisabled, iconSize, description, element, attrs) {
				return A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							element,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('py-2 flex items-center w-full'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('group hover:text-orange-300 focus-visible:text-orange-300 focus-ring focus:ring-orange-300 focus:ring-opacity-50 focus:ring-offset-4 rounded-sm', !isDisabled),
												_Utils_Tuple2('text-gray-900', isDisabled)
											])),
									attrs)),
							_List_fromArray(
								[
									icon(iconSize + ' mr-4 text-gray-500 fill-current group-hover:text-orange-300 group-focus-visible:text-orange-300'),
									$elm$html$Html$text(description),
									$author$project$Icons$arrowDown('-rotate-90 ml-auto text-gray-900 fill-current group-hover:text-orange-300 group-focus-visible:text-orange-300')
								]))
						]));
			});
		var _v0 = shared.aw;
		var t = _v0.fL;
		var tr = _v0.i4;
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, t);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('md:animate-fade-in-from-above-lg md:motion-reduce:animate-none', !loggedIn.gC)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-333 mb-4 md:mb-7')
						]),
					_List_fromArray(
						[
							text_('menu.my_communities'),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(community.fj)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded flex flex-col pt-4 pb-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col px-4 pb-6 border-b border-gray-100')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-green text-xl font-bold text-center')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3($author$project$Eos$formatSymbolAmount, shared.aw, balance.mk.as, balance.mk.ji))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-900 text-sm font-bold uppercase text-center')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												tr,
												'dashboard.your_balance',
												_List_fromArray(
													[
														_Utils_Tuple2(
														'symbol',
														$author$project$Eos$symbolToSymbolCodeString(community.as))
													])))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex space-x-4 mt-4')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$View$Components$disablableLink,
											{nP: !loggedIn.gz},
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button button-primary w-full'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('button-disabled', !loggedIn.gz)
														])),
													$author$project$Route$href(
													$author$project$Route$Transfer($elm$core$Maybe$Nothing))
												]),
											_List_fromArray(
												[
													text_('dashboard.transfer')
												])),
											function () {
											var _v1 = A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.o5;
												},
												community.mM);
											if (!_v1.$) {
												return A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('button button-secondary w-full'),
															$elm$html$Html$Attributes$disabled(!loggedIn.gz),
															$elm$html$Html$Events$onClick($author$project$Page$Dashboard$ClickedSupportUsButton)
														]),
													_List_fromArray(
														[
															text_('community.index.support_us')
														]));
											} else {
												return $elm$html$Html$text('');
											}
										}()
										]))
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('px-4 pt-2 divide-y divide-y-gray-100')
								]),
							_List_fromArray(
								[
									community.bz ? A6(
									listItem,
									$author$project$Icons$cambiatusCoin,
									!loggedIn.gz,
									'w-5',
									A2(
										tr,
										'dashboard.how_to_earn',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'symbol',
												$author$project$Eos$symbolToSymbolCodeString(community.as))
											])),
									function (attrs) {
										return A2(
											$author$project$View$Components$disablableLink,
											{nP: !loggedIn.gz},
											A2(
												$elm$core$List$cons,
												$author$project$Route$href(
													$author$project$Route$CommunityObjectives($author$project$Route$WithNoObjectiveSelected)),
												attrs));
									},
									_List_Nil) : $elm$html$Html$text(''),
									A6(
									listItem,
									$author$project$Icons$profile,
									!loggedIn.gz,
									'w-5 h-5',
									t('dashboard.invite'),
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$Page$Dashboard$CreateInvite),
											$elm$html$Html$Attributes$disabled(!loggedIn.gz),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('cursor-default', !loggedIn.gz)
												]))
										])),
									community.bz ? A6(
									listItem,
									$author$project$Icons$flagWithoutBackground,
									false,
									'h-5',
									t('dashboard.my_claims'),
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href(
											$author$project$Route$ProfileClaims(
												$author$project$Eos$Account$nameToString(loggedIn._)))
										])) : $elm$html$Html$text(''),
									community.bB ? A6(
									listItem,
									$author$project$Icons$shop,
									false,
									'w-5 h-5',
									t('dashboard.my_offers'),
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href(
											$author$project$Route$Shop(
												{
													dn: _List_Nil,
													o1: $elm$core$Maybe$Just(loggedIn._)
												}))
										])) : $elm$html$Html$text(''),
									function () {
									var _v2 = loggedIn.mN;
									if (_v2.$ === 3) {
										var contributionCount = _v2.a;
										return (contributionCount > 0) ? A6(
											listItem,
											$author$project$Icons$heartStroke,
											false,
											'w-5 h-5',
											t('dashboard.my_contributions'),
											$elm$html$Html$a,
											_List_fromArray(
												[
													$author$project$Route$href(
													$author$project$Route$ProfileContributions(loggedIn._))
												])) : $elm$html$Html$text('');
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									A6(
									listItem,
									$author$project$Icons$globe,
									false,
									'w-5 h-5',
									t('dashboard.about_community'),
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href($author$project$Route$CommunityAbout)
										]))
								]))
						])),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute -top-2 md:top-0 right-2 md:right-4'),
							$elm$html$Html$Attributes$alt(''),
							$elm$html$Html$Attributes$src('/images/success-doggo.svg')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$Dashboard$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var t = shared.aw.fL;
		var content = function () {
			var _v0 = _Utils_Tuple2(model.cA, loggedIn.pC);
			switch (_v0.a.$) {
				case 1:
					var _v1 = _v0.a;
					return $author$project$Page$fullPageLoading(shared);
				case 0:
					var _v2 = _v0.a;
					return $author$project$Page$fullPageLoading(shared);
				case 2:
					var e = _v0.a.a;
					return A2(
						$author$project$Page$fullPageError,
						t('dashboard.sorry'),
						e);
				default:
					if ((!_v0.a.a.$) && (_v0.b.$ === 3)) {
						var balance = _v0.a.a.a;
						var community = _v0.b.a;
						var isValidator = A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(loggedIn._),
							community.lV);
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container mx-auto my-8 px-4 lg:grid lg:grid-cols-3 lg:gap-7')
										]),
									_List_fromArray(
										[
											(!loggedIn.gz) ? A3(
											$author$project$Session$LoggedIn$viewFrozenAccountCard,
											shared.aw,
											{nS: false, oJ: $author$project$Page$Dashboard$ClickedAcceptCodeOfConduct},
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mb-6 lg:mb-0 self-start')
												])) : $elm$html$Html$text(''),
											A3($author$project$Page$Dashboard$viewWelcomeCard, loggedIn, community, balance),
											(community.bz && (isValidator && loggedIn.gz)) ? A2($author$project$Page$Dashboard$viewActionsForAnalysisCard, loggedIn, model) : $elm$html$Html$text(''),
											A3($author$project$Page$Dashboard$viewTimelineCard, loggedIn, community.bz && isValidator, model)
										])),
									A2($author$project$Page$Dashboard$viewInvitationModal, loggedIn, model),
									A2($author$project$Page$Dashboard$addContactModal, shared, model),
									A3($author$project$Page$Dashboard$viewModalRequestingSponsor, shared, community, model),
									A3($author$project$Page$Dashboard$viewTransferFilters, loggedIn, community.ih, model)
								]));
					} else {
						return A2(
							$author$project$Page$fullPageNotFound,
							t('dashboard.sorry'),
							'');
					}
			}
		}();
		return {
			mJ: content,
			fN: t('menu.dashboard')
		};
	});
var $author$project$Page$Dashboard$Analysis$ClaimMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Claim$CloseClaimModals = {$: 1};
var $author$project$View$Components$Sm = 0;
var $author$project$Page$Dashboard$Analysis$VoteClaim = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Claim$CardSummary = {$: 0};
var $author$project$Claim$GotExternalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Claim$GotProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Claim$OpenClaimModal = {$: 0};
var $author$project$Claim$OpenPhotoModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Claim$OpenVoteModal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$toMonths = function (rd) {
	var date = $justinmimbs$date$Date$toCalendarDate(rd);
	var wholeMonths = (12 * (date.qn - 1)) + ($justinmimbs$date$Date$monthToNumber(date.ol) - 1);
	return wholeMonths + (date.mX / 100);
};
var $elm$core$Basics$truncate = _Basics_truncate;
var $justinmimbs$date$Date$diff = F3(
	function (unit, _v0, _v1) {
		var rd1 = _v0;
		var rd2 = _v1;
		switch (unit) {
			case 0:
				return ((($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0) / 12) | 0;
			case 1:
				return ($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0;
			case 2:
				return ((rd2 - rd1) / 7) | 0;
			default:
				return rd2 - rd1;
		}
	});
var $author$project$Claim$isValidator = F2(
	function (accountName, claim) {
		return A2(
			$elm$core$List$any,
			function (v) {
				return _Utils_eq(v.l8, accountName);
			},
			claim.dh.lV);
	});
var $author$project$Claim$CloseClaimModal = {$: 1};
var $author$project$Claim$PendingSummaries = function (a) {
	return {$: 3, a: a};
};
var $author$project$Claim$TopModalSummary = {$: 1};
var $author$project$Claim$VotersSummaries = function (a) {
	return {$: 2, a: a};
};
var $author$project$Claim$isVotable = F3(
	function (claim, accountName, now) {
		return A2($author$project$Claim$isValidator, accountName, claim) && ((!A2($author$project$Claim$isValidated, claim, accountName)) && ((!A2($author$project$Action$isClosed, claim.dh, now)) && (!claim.dh.b7)));
	});
var $author$project$Profile$viewEmpty = function (translators) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('uppercase text-gray-900 text-sm')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						translators.fL('profile.no_one'))
					]))
			]));
};
var $author$project$Claim$viewVotingProgress = F2(
	function (shared, completionStatus) {
		var votingLeft = (completionStatus.lX - completionStatus.ay) - completionStatus.aC;
		var totalVotes = completionStatus.lX;
		var disapprovedWidth = (completionStatus.aC / totalVotes) * 100;
		var approvedWidth = (completionStatus.ay / totalVotes) * 100;
		var _v0 = shared.aw;
		var t = _v0.fL;
		var viewVotesBar = function () {
			var _v2 = completionStatus.eH;
			switch (_v2.$) {
				case 2:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full text-right text-gray-600')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('claim.pending'))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full h-2 bg-gray-500 flex rounded-full my-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex rounded-full overflow-hidden h-2'),
												A2(
												$elm$html$Html$Attributes$style,
												'width',
												$elm$core$String$fromFloat(approvedWidth + disapprovedWidth) + '%')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('bg-green'),
														A2(
														$elm$html$Html$Attributes$style,
														'width',
														$elm$core$String$fromFloat((completionStatus.ay / (completionStatus.ay + completionStatus.aC)) * 100) + '%')
													]),
												_List_Nil),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('bg-red'),
														A2(
														$elm$html$Html$Attributes$style,
														'width',
														$elm$core$String$fromFloat((completionStatus.aC / (completionStatus.ay + completionStatus.aC)) * 100) + '%')
													]),
												_List_Nil)
											]))
									]))
							]));
				case 3:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full text-right text-gray-600')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('claim.cancelled'))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full h-2 flex bg-gray-500 rounded-full my-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex rounded-full bg-gray-900 h-2'),
												A2(
												$elm$html$Html$Attributes$style,
												'width',
												$elm$core$String$fromFloat(approvedWidth + disapprovedWidth) + '%')
											]),
										_List_Nil)
									]))
							]));
				case 0:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full text-right text-green')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('claim.approved'))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full h-2 bg-green flex rounded-full my-2')
									]),
								_List_Nil)
							]));
				default:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full text-right text-red')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('claim.disapproved'))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full h-2 bg-red flex rounded-full my-2')
									]),
								_List_Nil)
							]));
			}
		}();
		var voteNumberTitleConditional = function (compStatus) {
			return (compStatus === 1) ? $elm$html$Html$text(
				t('claim.vote')) : $elm$html$Html$text(
				t('claim.votes'));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col mb-4')
				]),
			_List_fromArray(
				[
					viewVotesBar,
					function () {
					var _v1 = completionStatus.eH;
					switch (_v1.$) {
						case 0:
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-auto text-green text-right')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold mr-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(completionStatus.ay))
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												voteNumberTitleConditional(completionStatus.ay)
											]))
									]));
						case 1:
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-auto text-red text-right')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold mr-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(completionStatus.aC))
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												voteNumberTitleConditional(completionStatus.aC)
											]))
									]));
						case 2:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex')
									]),
								_List_fromArray(
									[
										(!completionStatus.ay) ? $elm$html$Html$text('') : A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$Attributes$style,
												'width',
												$elm$core$String$fromFloat(approvedWidth) + '%')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold text-green')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(completionStatus.ay))
													]))
											])),
										(!completionStatus.aC) ? $elm$html$Html$text('') : A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$Attributes$style,
												'width',
												$elm$core$String$fromFloat(disapprovedWidth) + '%')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold text-red')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(completionStatus.aC))
													]))
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ml-auto text-gray-600 text-right')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold mr-2')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(votingLeft))
													])),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														voteNumberTitleConditional(votingLeft)
													]))
											]))
									]));
						default:
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full text-gray-600 text-right space-x-1')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(votingLeft))
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('claim.cancelled_voting_bar'))
											]))
									]));
					}
				}()
				]));
	});
var $author$project$Claim$viewClaimModal = F3(
	function (loggedIn, profileSummaries, claim) {
		var shared = loggedIn.A;
		var accountName = loggedIn._;
		var viewProfileSummary = F2(
			function (profile_, profileSummary_) {
				return A4(
					$author$project$Profile$Summary$view,
					shared.aw,
					accountName,
					profile_,
					A2(
						$author$project$Profile$Summary$withScrollSelector,
						'.modal-body-lg',
						A2(
							$author$project$Profile$Summary$withRelativeSelector,
							'.modal-content',
							A2($author$project$Profile$Summary$withPreventScrolling, 1, profileSummary_))));
			});
		var viewClaimerProfileSummary = A2(
			$elm$html$Html$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Claim$GotProfileSummaryMsg($author$project$Claim$TopModalSummary),
				$author$project$Claim$GotExternalMsg),
			A2(viewProfileSummary, claim.gb, profileSummaries.fT));
		var completionStatus = {
			ay: $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.bC;
					},
					claim.aa)),
			eH: claim.pN,
			aC: $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.bC;
						}),
					claim.aa)),
			lX: claim.dh.lX
		};
		var claimVerifiersSectionClass = 'block my-6 h-auto space-y-4';
		var claimVerifiersProfileListContainerClass = 'grid grid-cols-3 md:flex md:flex-wrap md:space-x-6 py-2';
		var claimVerifiersFewerProfiles = 'flex flex-wrap space-x-6';
		var profileSummaryEmpty = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(claimVerifiersFewerProfiles)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-10')
						]),
					_List_fromArray(
						[
							$author$project$Profile$viewEmpty(shared.aw)
						]))
				]));
		var claimRoute = A3(
			$author$project$Route$Claim,
			$author$project$Action$objectiveIdToInt(claim.dh.ad.w),
			$author$project$Action$idToInt(claim.dh.w),
			claim.w);
		var _v0 = shared.aw;
		var t = _v0.fL;
		var claimDetailsButton = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button button-primary w-full mt-4'),
					$elm$html$Html$Attributes$target('_blank'),
					$author$project$Route$href(claimRoute)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					t('claim.modal.view_details')),
					$author$project$Icons$externalLink('inline-block ml-4 h-3 fill-current')
				]));
		var footer = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block w-full my-4 sm:w-1/2 sm:mx-auto')
				]),
			_List_fromArray(
				[
					A3($author$project$Claim$isVotable, claim, accountName, shared.ce) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex space-x-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full button button-danger'),
									$elm$html$Html$Events$onClick(
									A2($author$project$Claim$OpenVoteModal, claim.w, false)),
									$elm$html$Html$Attributes$disabled(!loggedIn.gz)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('dashboard.reject'))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full button button-primary'),
									$elm$html$Html$Events$onClick(
									A2($author$project$Claim$OpenVoteModal, claim.w, true)),
									$elm$html$Html$Attributes$disabled(!loggedIn.gz)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('dashboard.verify'))
								]))
						])) : $elm$html$Html$text(''),
					claimDetailsButton
				]));
		var viewActionDetails = function () {
			var proofCode = function () {
				var _v6 = claim.g3;
				if (!_v6.$) {
					var code = _v6.a;
					return code;
				} else {
					return '';
				}
			}();
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('block mt-6')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('claim.action'))
							])),
						A2(
						$author$project$Markdown$view,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-left mt-2 mb-6 text-lg w-full')
							]),
						claim.dh.aR),
						function () {
						var _v5 = claim.ft;
						if (!_v5.$) {
							var url = _v5.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('relative h-auto w-auto text-center text-white'),
										$author$project$Utils$onClickNoBubble(
										$author$project$Claim$OpenPhotoModal(claim))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('z-10 absolute bottom-4 left-4 bg-black bg-opacity-60 p-4')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-sm text-left w-full uppercase')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('community.actions.form.verification_code'))
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold font-normal text-left w-full')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(proofCode)
													]))
											])),
										A2(
										$author$project$View$Components$pdfViewer,
										_List_fromArray(
											[
												$author$project$Utils$onClickNoBubble(
												$author$project$Claim$OpenPhotoModal(claim)),
												$elm$html$Html$Attributes$class('w-full h-full min-h-48 rounded-sm bg-gray-300')
											]),
										{hC: 'max-w-full max-h-full', ig: $elm$core$Maybe$Nothing, ix: $elm$core$Maybe$Nothing, hn: url})
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					]));
		}();
		var viewApprovedByProfileSummaryList = function () {
			var cls = ($elm$core$List$length(claim.aa) > 3) ? claimVerifiersProfileListContainerClass : claimVerifiersFewerProfiles;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(claimVerifiersSectionClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('claim.approved_by'))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								(!A2(
								$elm$core$List$any,
								function ($) {
									return $.bC;
								},
								claim.aa)) ? profileSummaryEmpty : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(cls)
									]),
								A4(
									$elm$core$List$map3,
									F3(
										function (profileSummary, index, c) {
											return c.bC ? A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-4')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														A2(
															$elm$core$Basics$composeR,
															$author$project$Claim$GotProfileSummaryMsg(
																$author$project$Claim$VotersSummaries(index)),
															$author$project$Claim$GotExternalMsg),
														A2(viewProfileSummary, c.aN, profileSummary))
													])) : $elm$html$Html$text('');
										}),
									profileSummaries.cw,
									A2(
										$elm$core$List$range,
										0,
										$elm$core$List$length(profileSummaries.cw)),
									claim.aa))
							]))
					]));
		}();
		var viewCancelledNotice = function () {
			var _v3 = claim.pN;
			if (_v3.$ === 3) {
				var reason = _v3.a;
				var reasonText = function () {
					switch (reason) {
						case 0:
							return 'claim.cancelled_texts.deadline_reached';
						case 1:
							return 'claim.cancelled_texts.usages_reached';
						default:
							return 'claim.cancelled_texts.action_completed';
					}
				}();
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-900 my-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('claim.attention'))
								])),
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								'. ',
								A2(
									$elm$core$List$map,
									t,
									_List_fromArray(
										[reasonText, 'claim.cancelled_texts.not_available']))))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var viewClaimDateAndState = function () {
			var _v1 = function () {
				var _v2 = claim.pN;
				switch (_v2.$) {
					case 0:
						return _Utils_Tuple3(
							t('claim.title_approved.1'),
							t('claim.title_approved.2'),
							'text-lg font-bold lowercase text-green');
					case 1:
						return _Utils_Tuple3(
							t('claim.title_rejected.1'),
							t('claim.title_rejected.2'),
							'text-lg font-bold lowercase text-red');
					case 2:
						return _Utils_Tuple3(
							t('claim.title_under_review.1'),
							t('claim.pending'),
							'text-lg font-bold lowercase text-gray-600');
					default:
						return _Utils_Tuple3(
							t('claim.title_cancelled.1'),
							t('claim.title_cancelled.2'),
							'text-lg font-bold lowercase text-gray-900');
				}
			}();
			var claimStatusPhrase = _v1.a;
			var claimStatus = _v1.b;
			var textColor = _v1.c;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('block')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$View$Components$dateViewer,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-xs uppercase block text-gray-900')
							]),
						function (translations) {
							return _Utils_update(
								translations,
								{
									o$: t('claim.claimed_on'),
									p4: $elm$core$Maybe$Just(
										t('claim.claimed_today')),
									qo: $elm$core$Maybe$Just(
										t('claim.claimed_yesterday'))
								});
						},
						shared,
						$author$project$Utils$fromDateTime(claim.gl)),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-lg font-bold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(claimStatusPhrase)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(textColor)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(claimStatus)
							]))
					]));
		}();
		var header = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex space-x-6 md:justify-center md:space-x-8 md:mt-4')
				]),
			_List_fromArray(
				[viewClaimerProfileSummary, viewClaimDateAndState]));
		var viewDisapprovedByProfileSummaryList = function () {
			var cls = ($elm$core$List$length(claim.aa) > 3) ? claimVerifiersProfileListContainerClass : claimVerifiersFewerProfiles;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(claimVerifiersSectionClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('claim.disapproved_by'))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$core$List$isEmpty(
								A2(
									$elm$core$List$filter,
									function (check) {
										return !check.bC;
									},
									claim.aa)) ? profileSummaryEmpty : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(cls)
									]),
								A4(
									$elm$core$List$map3,
									F3(
										function (profileSummary, index, c) {
											return (!c.bC) ? A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-4')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														A2(
															$elm$core$Basics$composeR,
															$author$project$Claim$GotProfileSummaryMsg(
																$author$project$Claim$VotersSummaries(index)),
															$author$project$Claim$GotExternalMsg),
														A2(viewProfileSummary, c.aN, profileSummary))
													])) : $elm$html$Html$text('');
										}),
									profileSummaries.cw,
									A2(
										$elm$core$List$range,
										0,
										$elm$core$List$length(profileSummaries.cw)),
									claim.aa))
							]))
					]));
		}();
		var viewPendingVotersProfileSummaryList = function () {
			var cls = ($elm$core$List$length(profileSummaries.cY) > 3) ? claimVerifiersProfileListContainerClass : claimVerifiersFewerProfiles;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(claimVerifiersSectionClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('claim.pending_vote'))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								_Utils_eq(
								$elm$core$List$length(claim.aa),
								claim.dh.lX) ? profileSummaryEmpty : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(cls)
									]),
								A4(
									$elm$core$List$map3,
									F3(
										function (profileSummary, index, v) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-4')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														A2(
															$elm$core$Basics$composeR,
															$author$project$Claim$GotProfileSummaryMsg(
																$author$project$Claim$PendingSummaries(index)),
															$author$project$Claim$GotExternalMsg),
														A2(viewProfileSummary, v, profileSummary))
													]));
										}),
									profileSummaries.cY,
									A2(
										$elm$core$List$range,
										0,
										$elm$core$List$length(profileSummaries.cY)),
									$author$project$Claim$pendingValidators(claim)))
							]))
					]));
		}();
		var viewRewardInfo = function () {
			var rewardTxtClass = 'my-2 font-bold text-lg';
			var makeAsset = function (_float) {
				return {ji: _float, as: claim.dh.ad.V.as};
			};
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center flex justify-center bg-gray-100 rounded-md my-10 p-4 space-x-16')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(rewardTxtClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Eos$assetToString,
											shared.aw,
											makeAsset(claim.dh.fA)))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm text-green uppercase')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('community.actions.reward'))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(rewardTxtClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Eos$assetToString,
											shared.aw,
											makeAsset(claim.dh.lY)))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm text-green uppercase')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('claim.analyst_reward'))
									]))
							]))
					]));
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$Modal$toHtml(
					A2(
						$author$project$View$Modal$withSize,
						0,
						A2(
							$author$project$View$Modal$withFooter,
							_List_fromArray(
								[footer]),
							A2(
								$author$project$View$Modal$withBody,
								_List_fromArray(
									[
										header,
										viewCancelledNotice,
										A2($author$project$Claim$viewVotingProgress, shared, completionStatus),
										viewRewardInfo,
										viewApprovedByProfileSummaryList,
										viewDisapprovedByProfileSummaryList,
										viewPendingVotersProfileSummaryList,
										viewActionDetails
									]),
								$author$project$View$Modal$initWith(
									{
										mw: $author$project$Claim$GotExternalMsg($author$project$Claim$CloseClaimModal),
										nX: profileSummaries.fE
									})))))
				]));
	});
var $author$project$Claim$viewClaimCard = F4(
	function (attributes, loggedIn, profileSummaries, claim) {
		var isCancelled = function () {
			var _v5 = claim.pN;
			if (_v5.$ === 3) {
				return true;
			} else {
				return false;
			}
		}();
		var completionStatus = {
			ay: $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.bC;
					},
					claim.aa)),
			eH: claim.pN,
			aC: $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.bC;
						}),
					claim.aa)),
			lX: claim.dh.lX
		};
		var claimAging = function () {
			var createdAtDate = A2(
				$justinmimbs$date$Date$fromPosix,
				loggedIn.A.i2,
				$author$project$Utils$fromDateTime(claim.gl));
			return A3(
				$justinmimbs$date$Date$diff,
				3,
				createdAtDate,
				A2($justinmimbs$date$Date$fromPosix, loggedIn.A.i2, loggedIn.A.ce));
		}();
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var tr = _v0.i4;
		var claimAgingText = (claimAging < 1) ? t('claim.opened_today') : ((claimAging === 1) ? A2(
			tr,
			'claim.day_ago',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'day_count',
					$elm$core$String$fromInt(claimAging))
				])) : A2(
			tr,
			'claim.days_ago',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'day_count',
					$elm$core$String$fromInt(claimAging))
				])));
		return A2(
			$elm$html$Html$div,
			attributes,
			_List_fromArray(
				[
					A3($author$project$Claim$viewClaimModal, loggedIn, profileSummaries, claim),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col p-4 my-2 rounded-lg bg-white hover:shadow cursor-pointer'),
							$elm$html$Html$Attributes$id(
							'claim' + $elm$core$String$fromInt(claim.w)),
							$author$project$Utils$onClickNoBubble(
							$author$project$Claim$GotExternalMsg($author$project$Claim$OpenClaimModal))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex mb-4'),
									function () {
									var _v1 = claim.ft;
									if (!_v1.$) {
										return $elm$html$Html$Attributes$class('justify-between');
									} else {
										return $elm$html$Html$Attributes$class('justify-center');
									}
								}()
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Claim$GotProfileSummaryMsg($author$project$Claim$CardSummary),
										$author$project$Claim$GotExternalMsg),
									A4($author$project$Profile$Summary$view, loggedIn.A.aw, loggedIn._, claim.gb, profileSummaries.eF)),
									function () {
									var _v2 = claim.ft;
									if (!_v2.$) {
										var url = _v2.a;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('claim-photo-thumb')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$View$Components$pdfViewer,
													_List_fromArray(
														[
															$author$project$Utils$onClickNoBubble(
															$author$project$Claim$OpenPhotoModal(claim)),
															$elm$html$Html$Attributes$class('w-full h-full rounded-sm')
														]),
													{hC: 'max-w-full max-h-full', ig: $elm$core$Maybe$Nothing, ix: $elm$core$Maybe$Nothing, hn: url})
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}()
								])),
							isCancelled ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-gray-900 text-white font-bold uppercase text-sm py-1 px-5 rounded-label self-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('claim.cancelled_texts.cancelled_claim'))
								])) : A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-purple-500 font-bold uppercase text-sm self-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(claimAgingText)
								])),
							A2(
							$author$project$Markdown$view,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('truncate-children mb-2 mt-6'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('text-gray-900', isCancelled)
										]))
								]),
							claim.dh.aR),
							A4(
							$author$project$View$Components$dateViewer,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-900 font-bold text-sm uppercase flex mb-6')
								]),
							$elm$core$Basics$identity,
							loggedIn.A,
							$author$project$Utils$fromDateTime(claim.gl)),
							function () {
							var _v3 = claim.pN;
							if (_v3.$ === 3) {
								var reason = _v3.a;
								var reasonText = function () {
									switch (reason) {
										case 0:
											return 'claim.cancelled_texts.deadline_reached';
										case 1:
											return 'claim.cancelled_texts.usages_reached';
										default:
											return 'claim.cancelled_texts.action_completed';
									}
								}();
								return A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-gray-900 rounded p-4 text-white mb-6')
										]),
									$elm$core$List$singleton(
										$elm$html$Html$text(
											A2(
												$elm$core$String$join,
												'. ',
												A2(
													$elm$core$List$map,
													t,
													_List_fromArray(
														['claim.cancelled_texts.was_cancelled', reasonText, 'claim.cancelled_texts.not_available']))))));
							} else {
								return A2($author$project$Claim$viewVotingProgress, loggedIn.A, completionStatus);
							}
						}(),
							(A2($author$project$Claim$isValidated, claim, loggedIn._) || ((!A2($author$project$Claim$isValidator, loggedIn._, claim)) || (claim.dh.b7 || A2($author$project$Action$isClosed, claim.dh, loggedIn.A.ce)))) ? A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary w-full font-semibold mb-2'),
									$author$project$Utils$onClickNoBubble(
									$author$project$Claim$GotExternalMsg($author$project$Claim$OpenClaimModal))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('all_analysis.more_details'))
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex justify-between space-x-4')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-danger'),
											$author$project$Utils$onClickNoBubble(
											A2($author$project$Claim$OpenVoteModal, claim.w, false)),
											$elm$html$Html$Attributes$disabled(!loggedIn.gz)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('dashboard.reject'))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-primary'),
											$author$project$Utils$onClickNoBubble(
											A2($author$project$Claim$OpenVoteModal, claim.w, true)),
											$elm$html$Html$Attributes$disabled(!loggedIn.gz)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('dashboard.verify'))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Dashboard$Analysis$ClearFilters = {$: 12};
var $author$project$Page$Dashboard$Analysis$viewEmptyResults = function (_v0) {
	var shared = _v0.A;
	var text_ = function (s) {
		return $elm$html$Html$text(
			shared.aw.fL(s));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full text-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full flex justify-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src('/images/empty-analysis.svg'),
								$elm$html$Html$Attributes$class('object-contain h-32 mb-3')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-block text-gray')
					]),
				_List_fromArray(
					[
						text_('all_analysis.empty'),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('underline text-orange-500'),
								$elm$html$Html$Events$onClick($author$project$Page$Dashboard$Analysis$ClearFilters)
							]),
						_List_fromArray(
							[
								text_('all_analysis.clear_filters')
							]))
					]))
			]));
};
var $author$project$Page$Dashboard$Analysis$ShowMore = {$: 10};
var $author$project$Page$Dashboard$Analysis$viewPagination = F2(
	function (_v0, maybePageInfo) {
		var shared = _v0.A;
		var text_ = function (s) {
			return $elm$html$Html$text(
				shared.aw.fL(s));
		};
		if (!maybePageInfo.$) {
			var pageInfo = maybePageInfo.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-center')
					]),
				_List_fromArray(
					[
						pageInfo.np ? A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-primary uppercase w-full'),
								$elm$html$Html$Events$onClick($author$project$Page$Dashboard$Analysis$ShowMore)
							]),
						_List_fromArray(
							[
								text_('all_analysis.show_more')
							])) : $elm$html$Html$text('')
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Claim$viewPhotoModal = F2(
	function (loggedIn, claim) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var body = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('md:flex md:justify-start md:space-x-4')
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = claim.ft;
						if (!_v1.$) {
							var url = _v1.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sm:w-1/2')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$View$Components$pdfViewer,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('min-h-[100px] max-h-[42vh] rounded-sm')
											]),
										{
											hC: 'max-w-full max-h-full',
											ig: $elm$core$Maybe$Just(loggedIn.A.aw),
											ix: $elm$core$Maybe$Nothing,
											hn: url
										}),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('underline inline-block py-1 text-gray'),
												$elm$html$Html$Attributes$href(url),
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('community.actions.proof.upload_full')),
												$author$project$Icons$externalLink('inline-block ml-1 h-3 fill-current')
											]))
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}(),
						function () {
						var _v2 = claim.g3;
						if (!_v2.$) {
							var proofCode = _v2.a;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-4 md:mt-0 label md:text-xl block')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('community.actions.form.verification_code'))
											])),
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xl md:text-3xl')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(proofCode)
											]))
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					]))
			]);
		var withPhotoModalFooter = A3($author$project$Claim$isVotable, claim, loggedIn._, loggedIn.A.ce) ? $author$project$View$Modal$withFooter(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-cancel'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Claim$OpenVoteModal, claim.w, false))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('dashboard.reject'))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-accept'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Claim$OpenVoteModal, claim.w, true))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('dashboard.verify'))
						]))
				])) : $elm$core$Basics$identity;
		return $author$project$View$Modal$toHtml(
			withPhotoModalFooter(
				A2(
					$author$project$View$Modal$withBody,
					body,
					A2(
						$author$project$View$Modal$withHeader,
						t('dashboard.claim'),
						$author$project$View$Modal$initWith(
							{mw: $author$project$Claim$CloseClaimModals, nX: true})))));
	});
var $author$project$Claim$viewVoteClaimModal = F2(
	function (_v0, _v1) {
		var t = _v0.fL;
		var voteMsg = _v1.l_;
		var closeMsg = _v1.mw;
		var claimId = _v1.js;
		var isApproving = _v1.kl;
		var isInProgress = _v1.ko;
		var text_ = function (s) {
			return $elm$html$Html$text(
				t(s));
		};
		var footer = _List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-cancel'),
						$elm$html$Html$Events$onClick(closeMsg),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('button-disabled', isInProgress)
							])),
						$elm$html$Html$Attributes$disabled(isInProgress)
					]),
				_List_fromArray(
					[
						text_('claim.modal.secondary')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-accept'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('button-disabled', isInProgress)
							])),
						$elm$html$Html$Attributes$disabled(isInProgress),
						$elm$html$Html$Events$onClick(
						A2(voteMsg, claimId, isApproving))
					]),
				_List_fromArray(
					[
						isApproving ? text_('claim.modal.primary_approve') : text_('claim.modal.primary_disapprove')
					]))
			]);
		var body = _List_fromArray(
			[
				isApproving ? text_('claim.modal.message_approve') : text_('claim.modal.message_disapprove')
			]);
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withFooter,
				footer,
				A2(
					$author$project$View$Modal$withBody,
					body,
					A2(
						$author$project$View$Modal$withHeader,
						t('claim.modal.title'),
						$author$project$View$Modal$initWith(
							{mw: closeMsg, nX: true})))));
	});
var $author$project$Page$Dashboard$Analysis$viewContent = F3(
	function (loggedIn, _v0, model) {
		var claims = _v0.jt;
		var profileSummaries = _v0.c1;
		var pageInfo = _v0.o2;
		var viewClaim = F3(
			function (profileSummary, claimIndex, claim) {
				return A2(
					$elm$html$Html$map,
					$author$project$Page$Dashboard$Analysis$ClaimMsg(claimIndex),
					A4(
						$author$project$Claim$viewClaimCard,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full self-start')
							]),
						loggedIn,
						profileSummary,
						claim));
			});
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container mx-auto px-4 mb-10')
					]),
				($elm$core$List$length(claims) > 0) ? _List_fromArray(
					[
						A4(
						$author$project$View$Components$masonryLayout,
						_List_fromArray(
							[0]),
						{p9: false},
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 mb-4 sm:auto-rows-[5px]')
							]),
						A4(
							$elm$core$List$map3,
							viewClaim,
							profileSummaries,
							A2(
								$elm$core$List$range,
								0,
								$elm$core$List$length(claims)),
							claims)),
						A2($author$project$Page$Dashboard$Analysis$viewPagination, loggedIn, pageInfo)
					]) : _List_fromArray(
					[
						$author$project$Page$Dashboard$Analysis$viewEmptyResults(loggedIn)
					])),
				function () {
				var viewVoteModal = F3(
					function (claimId, isApproving, isLoading) {
						return A2(
							$author$project$Claim$viewVoteClaimModal,
							loggedIn.A.aw,
							{
								js: claimId,
								mw: A2($author$project$Page$Dashboard$Analysis$ClaimMsg, 0, $author$project$Claim$CloseClaimModals),
								kl: isApproving,
								ko: isLoading,
								l_: $author$project$Page$Dashboard$Analysis$VoteClaim
							});
					});
				var _v1 = model.hF;
				switch (_v1.$) {
					case 1:
						var claimId = _v1.a;
						var vote = _v1.b;
						return A3(viewVoteModal, claimId, vote, false);
					case 0:
						var claimId = _v1.a;
						var vote = _v1.b;
						return A3(viewVoteModal, claimId, vote, true);
					case 2:
						var claim = _v1.a;
						return A2(
							$elm$html$Html$map,
							$author$project$Page$Dashboard$Analysis$ClaimMsg(0),
							A2($author$project$Claim$viewPhotoModal, loggedIn, claim));
					default:
						return $elm$html$Html$text('');
				}
			}()
			]);
	});
var $author$project$Page$Dashboard$Analysis$ClosedFilterModal = {$: 6};
var $author$project$Page$Dashboard$Analysis$SubmittedFilterForm = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Dashboard$Analysis$Approved = 1;
var $author$project$Page$Dashboard$Analysis$Filter = F2(
	function (profile, statusFilter) {
		return {pl: profile, iR: statusFilter};
	});
var $author$project$Page$Dashboard$Analysis$Rejected = 2;
var $author$project$Page$Dashboard$Analysis$statusFilterFromString = function (filter) {
	switch (filter) {
		case 'all':
			return $elm$core$Maybe$Just(0);
		case 'approved':
			return $elm$core$Maybe$Just(1);
		case 'rejected':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Dashboard$Analysis$statusFilterToString = function (filter) {
	switch (filter) {
		case 0:
			return 'all';
		case 1:
			return 'approved';
		default:
			return 'rejected';
	}
};
var $author$project$Page$Dashboard$Analysis$filtersForm = F3(
	function (loggedIn, users, _v0) {
		var showStatusSelect = _v0.lt;
		var _v1 = loggedIn.A.aw;
		var t = _v1.fL;
		return A2(
			$author$project$Form$with,
			(!showStatusSelect) ? $author$project$Form$succeed(0) : A3(
				$author$project$Form$select,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Page$Dashboard$Analysis$statusFilterFromString,
					$elm$core$Maybe$withDefault(0)),
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: $elm$core$Result$Ok,
					qd: F2(
						function (status, input) {
							return _Utils_update(
								input,
								{pN: status});
						}),
					lW: function ($) {
						return $.pN;
					}
				},
				A2(
					$author$project$Form$Select$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-10')
						]),
					A3(
						$author$project$Form$Select$withOption,
						2,
						t('all_analysis.disapproved'),
						A3(
							$author$project$Form$Select$withOption,
							1,
							t('all_analysis.approved'),
							A3(
								$author$project$Form$Select$withOption,
								0,
								t('all_analysis.all'),
								$author$project$Form$Select$init(
									{
										w: 'status-select',
										n$: t('all_analysis.filter.status.label'),
										d5: $author$project$Page$Dashboard$Analysis$statusFilterToString
									})))))),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$userPicker,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: $elm$core$Result$Ok,
						qd: F2(
							function (user, input) {
								return _Utils_update(
									input,
									{qg: user});
							}),
						lW: function ($) {
							return $.qg;
						}
					},
					A2(
						$author$project$Form$UserPicker$withMenuClass,
						'max-h-44 overflow-y-auto !relative',
						A2(
							$author$project$Form$UserPicker$withModalSelectors,
							true,
							$author$project$Form$UserPicker$init(
								{
									eR: loggedIn._,
									n$: t('all_analysis.filter.user'),
									fs: users
								})))),
				$author$project$Form$succeed($author$project$Page$Dashboard$Analysis$Filter)));
	});
var $author$project$Page$Dashboard$Analysis$viewFiltersModal = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var showFilterSelect = function () {
			var _v1 = model.aZ;
			if (!_v1) {
				return false;
			} else {
				return true;
			}
		}();
		var profiles = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			_List_Nil,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.ih;
				},
				loggedIn.pC));
		var _v0 = shared.aw;
		var t = _v0.fL;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						A6(
						$author$project$Form$view,
						_List_Nil,
						shared.aw,
						function (submitButton) {
							return _List_fromArray(
								[
									A2(
									submitButton,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-primary w-full')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('all_analysis.filter.apply'))
										]))
								]);
						},
						A3(
							$author$project$Page$Dashboard$Analysis$filtersForm,
							loggedIn,
							profiles,
							{lt: showFilterSelect}),
						model.eZ,
						{oU: $author$project$Page$Dashboard$Analysis$SubmittedFilterForm, lF: $author$project$Page$Dashboard$Analysis$GotFilterFormMsg})
					]),
				A2(
					$author$project$View$Modal$withHeader,
					t('all_analysis.filter.title'),
					$author$project$View$Modal$initWith(
						{mw: $author$project$Page$Dashboard$Analysis$ClosedFilterModal, nX: model.c7}))));
	});
var $author$project$Page$Dashboard$Analysis$OpenedFilterModal = {$: 5};
var $author$project$Page$Dashboard$Analysis$ToggleSorting = {$: 11};
var $author$project$Icons$sortAscending = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('20'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M11.1567 6.8125C11.2813 6.6875 11.406 6.5 11.406 6.25C11.406 6.0625 11.3436 5.875 11.1567 5.6875L6.66978 1.1875L2.18287 5.6875C1.99591 5.875 1.93359 6.0625 1.93359 6.25C1.93359 6.4375 1.99591 6.625 2.18287 6.8125C2.3075 6.9375 2.49446 7.0625 2.74373 7.0625C2.93069 7.0625 3.11764 7 3.30459 6.8125L5.92196 4.1875V10.75C5.92196 11.1875 6.29587 11.5 6.66978 11.5C7.04369 11.5 7.4176 11.125 7.4176 10.75V4.125L10.035 6.75C10.4089 7.0625 10.9074 7.0625 11.1567 6.8125Z'),
						$elm$svg$Svg$Attributes$fill('#F99D33')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M17.7626 12.75C17.451 12.4375 16.9525 12.4375 16.7032 12.75L14.0858 15.375V8.8125C14.0858 8.375 13.7119 8.0625 13.338 8.0625C12.9641 8.0625 12.4655 8.375 12.4655 8.8125V15.375L9.84817 12.75C9.53658 12.4375 9.03804 12.4375 8.78876 12.75C8.66413 12.875 8.53949 13.0625 8.53949 13.3125C8.53949 13.5625 8.60181 13.6875 8.78876 13.875L13.2757 18.375L17.7626 13.875C17.8872 13.75 18.0119 13.5625 18.0119 13.3125C18.0119 13.0625 17.9495 12.875 17.7626 12.75Z'),
						$elm$svg$Svg$Attributes$fill('#F99D33')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$sortDescending = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('18'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 18'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M0.249315 4.6875C0.124678 4.8125 4.24261e-05 5 4.24042e-05 5.25C4.23879e-05 5.4375 0.0623602 5.625 0.249315 5.8125L4.73623 10.3125L9.22314 5.8125C9.41009 5.625 9.47241 5.4375 9.47241 5.25C9.47241 5.0625 9.41009 4.875 9.22314 4.6875C9.0985 4.5625 8.91155 4.4375 8.66228 4.4375C8.47532 4.4375 8.28837 4.5 8.10141 4.6875L5.48405 7.3125L5.48405 0.749998C5.48405 0.312498 5.11014 -1.33504e-06 4.73623 -1.36772e-06C4.36232 -1.40041e-06 3.98841 0.374998 3.98841 0.749998L3.98841 7.375L1.37104 4.75C0.997134 4.4375 0.498588 4.4375 0.249315 4.6875Z'),
						$elm$svg$Svg$Attributes$fill('#F99D33')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M6.24931 12.625C6.56091 12.9375 7.05945 12.9375 7.30872 12.625L9.92609 10L9.92609 16.5625C9.92609 17 10.3 17.3125 10.6739 17.3125C11.0478 17.3125 11.5464 17 11.5464 16.5625L11.5464 10L14.1637 12.625C14.4753 12.9375 14.9739 12.9375 15.2231 12.625C15.3478 12.5 15.4724 12.3125 15.4724 12.0625C15.4724 11.8125 15.4101 11.6875 15.2231 11.5L10.7362 7L6.24931 11.5C6.12468 11.625 6.00004 11.8125 6.00004 12.0625C6.00004 12.3125 6.06236 12.5 6.24931 12.625Z'),
						$elm$svg$Svg$Attributes$fill('#F99D33')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Dashboard$Analysis$viewFilterAndOrder = F2(
	function (_v0, model) {
		var shared = _v0.A;
		var viewButton = F3(
			function (label, icon, onClickMsg) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button button-secondary flex-grow-1 justify-between pl-4'),
							$elm$html$Html$Events$onClick(onClickMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							shared.aw.fL(label)),
							icon
						]));
			});
		var _v1 = function () {
			var _v2 = model.F;
			if (!_v2) {
				return _Utils_Tuple2($author$project$Icons$sortAscending, 'all_analysis.filter.sort.asc');
			} else {
				return _Utils_Tuple2($author$project$Icons$sortDescending, 'all_analysis.filter.sort.desc');
			}
		}();
		var filterDirectionIcon = _v1.a;
		var filterDirectionLabel = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full md:w-2/3 xl:w-1/3 mx-auto mt-4 mb-6 flex space-x-4')
				]),
			_List_fromArray(
				[
					A3(
					viewButton,
					'all_analysis.filter.title',
					$author$project$Icons$arrowDown('fill-current'),
					$author$project$Page$Dashboard$Analysis$OpenedFilterModal),
					A3(
					viewButton,
					filterDirectionLabel,
					filterDirectionIcon('mr-2'),
					$author$project$Page$Dashboard$Analysis$ToggleSorting)
				]));
	});
var $author$project$Page$Dashboard$Analysis$SelectedTab = function (a) {
	return {$: 9, a: a};
};
var $author$project$View$TabSelector$init = function (initialOptions) {
	return {mF: _List_Nil, oR: initialOptions.oR, aZ: initialOptions.aZ, pW: initialOptions.pW};
};
var $author$project$View$TabSelector$Center = 1;
var $author$project$View$TabSelector$Left = 0;
var $author$project$View$TabSelector$Right = 2;
var $author$project$View$TabSelector$isLeft = function (position) {
	if (!position) {
		return true;
	} else {
		return false;
	}
};
var $author$project$View$TabSelector$isRight = function (position) {
	if (position === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$View$TabSelector$viewTab = F3(
	function (position, tabSelector, tab) {
		var maybeCount = A2(
			$elm$core$Maybe$map,
			function (c) {
				return '(' + ($elm$core$String$fromInt(c) + ')');
			},
			tab.mO);
		var isActive = _Utils_eq(tab.lA, tabSelector.aZ);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-center py-3 px-8 w-1/2 focus:outline-none flex flex-col items-center justify-center sm:flex-row'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('bg-orange-300 text-white cursor-default', isActive),
							_Utils_Tuple2('bg-gray-100 text-black hover:bg-gray-200', !isActive),
							_Utils_Tuple2(
							'rounded-l-full',
							$author$project$View$TabSelector$isLeft(position)),
							_Utils_Tuple2(
							'rounded-r-full',
							$author$project$View$TabSelector$isRight(position))
						])),
					$elm$html$Html$Events$onClick(
					tabSelector.oR(tab.lA))
				]),
			function () {
				if (maybeCount.$ === 1) {
					return _List_fromArray(
						[
							$elm$html$Html$text(tab.n$)
						]);
				} else {
					var count = maybeCount.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(tab.n$),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sm:ml-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(count)
								]))
						]);
				}
			}());
	});
var $author$project$View$TabSelector$toHtml = function (tabSelector) {
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('flex'),
			tabSelector.mF),
		A2(
			$elm$core$List$indexedMap,
			function (idx) {
				var position = (!idx) ? 0 : (_Utils_eq(
					idx,
					$elm$core$List$length(tabSelector.pW) - 1) ? 2 : 1);
				return A2($author$project$View$TabSelector$viewTab, position, tabSelector);
			},
			tabSelector.pW));
};
var $author$project$View$TabSelector$withContainerAttrs = F2(
	function (attrs, tabSelector) {
		return _Utils_update(
			tabSelector,
			{
				mF: _Utils_ap(tabSelector.mF, attrs)
			});
	});
var $author$project$Page$Dashboard$Analysis$viewTabSelector = F2(
	function (_v0, model) {
		var translators = _v0.aw;
		var count = function (tab) {
			if (!tab) {
				return model.a$.ew;
			} else {
				return model.a$.dk;
			}
		};
		return $author$project$View$TabSelector$toHtml(
			A2(
				$author$project$View$TabSelector$withContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full md:w-2/3 xl:w-2/5')
					]),
				$author$project$View$TabSelector$init(
					{
						oR: $author$project$Page$Dashboard$Analysis$SelectedTab,
						aZ: model.aZ,
						pW: _List_fromArray(
							[
								{
								mO: count(0),
								n$: translators.fL('all_analysis.tabs.waiting_vote'),
								lA: 0
							},
								{
								mO: count(1),
								n$: translators.fL('all_analysis.tabs.analyzed'),
								lA: 1
							}
							])
					})));
	});
var $author$project$Page$Dashboard$Analysis$viewHeaderAndOptions = F2(
	function (loggedIn, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-white py-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container mx-auto px-4 flex justify-center')
							]),
						_List_fromArray(
							[
								A2($author$project$Page$Dashboard$Analysis$viewTabSelector, loggedIn.A, model)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container mx-auto px-4')
					]),
				_List_fromArray(
					[
						A2($author$project$Page$Dashboard$Analysis$viewFilterAndOrder, loggedIn, model)
					]))
			]);
	});
var $author$project$Page$Dashboard$Analysis$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var viewLoading = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-10')
				]),
			_List_fromArray(
				[
					$author$project$Page$fullPageLoading(shared)
				]));
		var t = shared.aw.fL;
		var pageTitle = t('all_analysis.title');
		var content = function () {
			var _v0 = model.pN;
			switch (_v0.$) {
				case 0:
					return _List_fromArray(
						[viewLoading]);
				case 1:
					return _List_fromArray(
						[viewLoading]);
				case 3:
					var loadedModel = _v0.a;
					return A3($author$project$Page$Dashboard$Analysis$viewContent, loggedIn, loadedModel, model);
				default:
					var err = _v0.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center container mx-auto')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Page$fullPageGraphQLError,
									t('all_analysis.error'),
									err)
								]))
						]);
			}
		}();
		return {
			mJ: A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2($author$project$Page$viewHeader, loggedIn, pageTitle),
					A2(
						$elm$core$List$cons,
						A2($author$project$Page$Dashboard$Analysis$viewFiltersModal, loggedIn, model),
						_Utils_ap(
							A2($author$project$Page$Dashboard$Analysis$viewHeaderAndOptions, loggedIn, model),
							content)))),
			fN: pageTitle
		};
	});
var $author$project$Page$Dashboard$Claim$ClaimMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Dashboard$Claim$ClaimerSummary = {$: 0};
var $author$project$Page$Dashboard$Claim$GotProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm_community$string_extra$String$Extra$softBreakRegexp = function (width) {
	return $elm_community$string_extra$String$Extra$regexFromString(
		'.{1,' + ($elm$core$String$fromInt(width) + '}(\\s+|$)|\\S+?(\\s+|$)'));
};
var $elm_community$string_extra$String$Extra$softEllipsis = F2(
	function (howLong, string) {
		return (_Utils_cmp(
			$elm$core$String$length(string),
			howLong) < 1) ? string : function (a) {
			return A2($elm$core$String$append, a, '...');
		}(
			A3(
				$elm$regex$Regex$replace,
				$elm_community$string_extra$String$Extra$regexFromString('([\\.,;:\\s])+$'),
				$elm$core$Basics$always(''),
				A2(
					$elm$core$String$join,
					'',
					A2(
						$elm$core$List$map,
						function ($) {
							return $.fg;
						},
						A3(
							$elm$regex$Regex$findAtMost,
							1,
							$elm_community$string_extra$String$Extra$softBreakRegexp(howLong),
							string)))));
	});
var $thaterikperson$elm_strftime$Strftime$abbreviatedMonth = F2(
	function (zone, time) {
		var _v0 = A2($elm$time$Time$toMonth, zone, time);
		switch (_v0) {
			case 0:
				return 'Jan';
			case 1:
				return 'Feb';
			case 2:
				return 'Mar';
			case 3:
				return 'Apr';
			case 4:
				return 'May';
			case 5:
				return 'Jun';
			case 6:
				return 'Jul';
			case 7:
				return 'Aug';
			case 8:
				return 'Sep';
			case 9:
				return 'Oct';
			case 10:
				return 'Nov';
			default:
				return 'Dec';
		}
	});
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $thaterikperson$elm_strftime$Strftime$abbreviatedWeekday = F2(
	function (zone, time) {
		var _v0 = A2($elm$time$Time$toWeekday, zone, time);
		switch (_v0) {
			case 0:
				return 'Mon';
			case 1:
				return 'Tue';
			case 2:
				return 'Wed';
			case 3:
				return 'Thu';
			case 4:
				return 'Fri';
			case 5:
				return 'Sat';
			default:
				return 'Sun';
		}
	});
var $thaterikperson$elm_strftime$Strftime$amPmString = F2(
	function (zone, time) {
		return (A2($elm$time$Time$toHour, zone, time) > 11) ? 'PM' : 'AM';
	});
var $thaterikperson$elm_strftime$Strftime$fullMonth = F2(
	function (zone, time) {
		var _v0 = A2($elm$time$Time$toMonth, zone, time);
		switch (_v0) {
			case 0:
				return 'January';
			case 1:
				return 'February';
			case 2:
				return 'March';
			case 3:
				return 'April';
			case 4:
				return 'May';
			case 5:
				return 'June';
			case 6:
				return 'July';
			case 7:
				return 'August';
			case 8:
				return 'September';
			case 9:
				return 'October';
			case 10:
				return 'November';
			default:
				return 'December';
		}
	});
var $thaterikperson$elm_strftime$Strftime$fullWeekday = F2(
	function (zone, time) {
		var _v0 = A2($elm$time$Time$toWeekday, zone, time);
		switch (_v0) {
			case 0:
				return 'Monday';
			case 1:
				return 'Tuesday';
			case 2:
				return 'Wednesday';
			case 3:
				return 'Thursday';
			case 4:
				return 'Friday';
			case 5:
				return 'Saturday';
			default:
				return 'Sunday';
		}
	});
var $thaterikperson$elm_strftime$Strftime$numberWeekday = F2(
	function (zone, time) {
		var _v0 = A2($elm$time$Time$toWeekday, zone, time);
		switch (_v0) {
			case 6:
				return '0';
			case 0:
				return '1';
			case 1:
				return '2';
			case 2:
				return '3';
			case 3:
				return '4';
			case 4:
				return '5';
			default:
				return '6';
		}
	});
var $thaterikperson$elm_strftime$Strftime$numericMonth = F2(
	function (zone, time) {
		var _v0 = A2($elm$time$Time$toMonth, zone, time);
		switch (_v0) {
			case 0:
				return 1;
			case 1:
				return 2;
			case 2:
				return 3;
			case 3:
				return 4;
			case 4:
				return 5;
			case 5:
				return 6;
			case 6:
				return 7;
			case 7:
				return 8;
			case 8:
				return 9;
			case 9:
				return 10;
			case 10:
				return 11;
			default:
				return 12;
		}
	});
var $thaterikperson$elm_strftime$Strftime$regex = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $thaterikperson$elm_strftime$Strftime$twentyFourHourToTwelveHour = function (hour) {
	return (!hour) ? 12 : ((hour > 12) ? (hour - 12) : hour);
};
var $thaterikperson$elm_strftime$Strftime$zeroPad = function (number) {
	return (number < 10) ? ('0' + $elm$core$String$fromInt(number)) : $elm$core$String$fromInt(number);
};
var $thaterikperson$elm_strftime$Strftime$format = F3(
	function (fmt, zone, time) {
		return A3(
			$elm$regex$Regex$replace,
			$thaterikperson$elm_strftime$Strftime$regex('%S'),
			function (_v19) {
				return $thaterikperson$elm_strftime$Strftime$zeroPad(
					A2($elm$time$Time$toSecond, zone, time));
			},
			A3(
				$elm$regex$Regex$replace,
				$thaterikperson$elm_strftime$Strftime$regex('%-S'),
				function (_v18) {
					return $elm$core$String$fromInt(
						A2($elm$time$Time$toSecond, zone, time));
				},
				A3(
					$elm$regex$Regex$replace,
					$thaterikperson$elm_strftime$Strftime$regex('%M'),
					function (_v17) {
						return $thaterikperson$elm_strftime$Strftime$zeroPad(
							A2($elm$time$Time$toMinute, zone, time));
					},
					A3(
						$elm$regex$Regex$replace,
						$thaterikperson$elm_strftime$Strftime$regex('%-M'),
						function (_v16) {
							return $elm$core$String$fromInt(
								A2($elm$time$Time$toMinute, zone, time));
						},
						A3(
							$elm$regex$Regex$replace,
							$thaterikperson$elm_strftime$Strftime$regex('%p'),
							function (_v15) {
								return A2($thaterikperson$elm_strftime$Strftime$amPmString, zone, time);
							},
							A3(
								$elm$regex$Regex$replace,
								$thaterikperson$elm_strftime$Strftime$regex('%I'),
								function (_v14) {
									return $thaterikperson$elm_strftime$Strftime$zeroPad(
										$thaterikperson$elm_strftime$Strftime$twentyFourHourToTwelveHour(
											A2($elm$time$Time$toHour, zone, time)));
								},
								A3(
									$elm$regex$Regex$replace,
									$thaterikperson$elm_strftime$Strftime$regex('%-I'),
									function (_v13) {
										return $elm$core$String$fromInt(
											$thaterikperson$elm_strftime$Strftime$twentyFourHourToTwelveHour(
												A2($elm$time$Time$toHour, zone, time)));
									},
									A3(
										$elm$regex$Regex$replace,
										$thaterikperson$elm_strftime$Strftime$regex('%H'),
										function (_v12) {
											return $thaterikperson$elm_strftime$Strftime$zeroPad(
												A2($elm$time$Time$toHour, zone, time));
										},
										A3(
											$elm$regex$Regex$replace,
											$thaterikperson$elm_strftime$Strftime$regex('%-H'),
											function (_v11) {
												return $elm$core$String$fromInt(
													A2($elm$time$Time$toHour, zone, time));
											},
											A3(
												$elm$regex$Regex$replace,
												$thaterikperson$elm_strftime$Strftime$regex('%Y'),
												function (_v10) {
													return $elm$core$String$fromInt(
														A2($elm$time$Time$toYear, zone, time));
												},
												A3(
													$elm$regex$Regex$replace,
													$thaterikperson$elm_strftime$Strftime$regex('%y'),
													function (_v9) {
														return A2(
															$elm$core$String$right,
															2,
															$elm$core$String$fromInt(
																A2($elm$time$Time$toYear, zone, time)));
													},
													A3(
														$elm$regex$Regex$replace,
														$thaterikperson$elm_strftime$Strftime$regex('%d'),
														function (_v8) {
															return $thaterikperson$elm_strftime$Strftime$zeroPad(
																A2($elm$time$Time$toDay, zone, time));
														},
														A3(
															$elm$regex$Regex$replace,
															$thaterikperson$elm_strftime$Strftime$regex('%-d'),
															function (_v7) {
																return $elm$core$String$fromInt(
																	A2($elm$time$Time$toDay, zone, time));
															},
															A3(
																$elm$regex$Regex$replace,
																$thaterikperson$elm_strftime$Strftime$regex('%w'),
																function (_v6) {
																	return A2($thaterikperson$elm_strftime$Strftime$numberWeekday, zone, time);
																},
																A3(
																	$elm$regex$Regex$replace,
																	$thaterikperson$elm_strftime$Strftime$regex('%A'),
																	function (_v5) {
																		return A2($thaterikperson$elm_strftime$Strftime$fullWeekday, zone, time);
																	},
																	A3(
																		$elm$regex$Regex$replace,
																		$thaterikperson$elm_strftime$Strftime$regex('%a'),
																		function (_v4) {
																			return A2($thaterikperson$elm_strftime$Strftime$abbreviatedWeekday, zone, time);
																		},
																		A3(
																			$elm$regex$Regex$replace,
																			$thaterikperson$elm_strftime$Strftime$regex('%m'),
																			function (_v3) {
																				return $thaterikperson$elm_strftime$Strftime$zeroPad(
																					A2($thaterikperson$elm_strftime$Strftime$numericMonth, zone, time));
																			},
																			A3(
																				$elm$regex$Regex$replace,
																				$thaterikperson$elm_strftime$Strftime$regex('%-m'),
																				function (_v2) {
																					return $elm$core$String$fromInt(
																						A2($thaterikperson$elm_strftime$Strftime$numericMonth, zone, time));
																				},
																				A3(
																					$elm$regex$Regex$replace,
																					$thaterikperson$elm_strftime$Strftime$regex('%B'),
																					function (_v1) {
																						return A2($thaterikperson$elm_strftime$Strftime$fullMonth, zone, time);
																					},
																					A3(
																						$elm$regex$Regex$replace,
																						$thaterikperson$elm_strftime$Strftime$regex('%b'),
																						function (_v0) {
																							return A2($thaterikperson$elm_strftime$Strftime$abbreviatedMonth, zone, time);
																						},
																						fmt))))))))))))))))))));
	});
var $author$project$Page$Dashboard$Claim$viewDetails = F3(
	function (_v0, _v1, claim) {
		var shared = _v0.A;
		var text_ = function (s) {
			return $elm$html$Html$text(
				shared.aw.fL(s));
		};
		var isRejected = _Utils_eq(claim.pN, $author$project$Claim$Rejected);
		var completionStatus = {
			ay: $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.bC;
					},
					claim.aa)),
			eH: claim.pN,
			aC: $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.bC;
						}),
					claim.aa)),
			lX: claim.dh.lX
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Claim$viewVotingProgress, shared, completionStatus),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									text_('claim.action')
								])),
							A2(
							$author$project$Markdown$view,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-2')
								]),
							claim.dh.aR),
							claim.dh.b7 ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex mb-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tag bg-green')
										]),
									_List_fromArray(
										[
											text_('community.actions.completed')
										]))
								])) : (A2($author$project$Action$isClosed, claim.dh, shared.ce) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex mb-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tag bg-gray-500 text-red')
										]),
									_List_fromArray(
										[
											text_('community.actions.closed')
										]))
								])) : $elm$html$Html$text(''))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex justify-between lg:justify-start')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mr-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('label')
												]),
											_List_fromArray(
												[
													text_('claim.date')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A3(
														$thaterikperson$elm_strftime$Strftime$format,
														'%d %b %Y %H:%M',
														shared.i2,
														$author$project$Utils$fromDateTime(claim.gl)))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('label')
												]),
											_List_fromArray(
												[
													text_('claim.claimer_reward')
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('text-red line-through', isRejected)
														]))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromFloat(claim.dh.fA) + (' ' + $author$project$Eos$symbolToSymbolCodeString(claim.dh.ad.V.as)))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									text_('claim.objective')
								])),
							A2($author$project$Markdown$view, _List_Nil, claim.dh.ad.aR)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									text_('claim.your_reward')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromFloat(claim.dh.lY) + (' ' + $author$project$Eos$symbolToSymbolCodeString(claim.dh.ad.V.as)))
								]))
						]))
				]));
	});
var $author$project$Page$Dashboard$Claim$viewProofs = F2(
	function (_v0, claim) {
		var t = _v0.fL;
		var viewProofCode = function () {
			var _v2 = claim.g3;
			if (!_v2.$) {
				var proofCode = _v2.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.actions.form.verification_code'))
								])),
							A2(
							$elm$html$Html$strong,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-lg block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(proofCode)
								]))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var _v1 = claim.ft;
		if (!_v1.$) {
			var url = _v1.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-8 flex')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('claim-photo-thumb')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$View$Components$pdfViewer,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Page$Dashboard$Claim$ClaimMsg(
											$author$project$Claim$OpenPhotoModal(claim))),
										$elm$html$Html$Attributes$class('h-full w-full')
									]),
								{hC: 'max-w-full max-h-full', ig: $elm$core$Maybe$Nothing, ix: $elm$core$Maybe$Nothing, hn: url})
							])),
						viewProofCode
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Page$Dashboard$Claim$viewTitle = F3(
	function (shared, _v0, claim) {
		var text_ = function (s) {
			return $elm$html$Html$text(
				shared.aw.fL(s));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-lg font-bold text-center mb-4')
				]),
			_List_fromArray(
				[
					function () {
					var _v1 = claim.pN;
					switch (_v1.$) {
						case 0:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block')
									]),
								_List_fromArray(
									[
										text_('claim.title_approved.1'),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-green ml-1')
											]),
										_List_fromArray(
											[
												text_('claim.title_approved.2')
											]))
									]));
						case 3:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block')
									]),
								_List_fromArray(
									[
										text_('claim.title_action_completed')
									]));
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block')
									]),
								_List_fromArray(
									[
										text_('claim.title_rejected.1'),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-red ml-1')
											]),
										_List_fromArray(
											[
												text_('claim.title_rejected.2')
											]))
									]));
						default:
							return A2($author$project$Action$isClosed, claim.dh, shared.ce) ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block')
									]),
								_List_fromArray(
									[
										text_('claim.title_action_closed')
									])) : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block')
									]),
								_List_fromArray(
									[
										text_('claim.title_under_review.1'),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray ml-1')
											]),
										_List_fromArray(
											[
												text_('claim.title_under_review.2')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mr-1')
											]),
										_List_fromArray(
											[
												text_('claim.title_under_review.3')
											]))
									]));
					}
				}()
				]));
	});
var $author$project$Page$Dashboard$Claim$VoteClaim = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Dashboard$Claim$viewVoteButtons = F3(
	function (loggedIn, claimId, modalStatus) {
		var viewVoteModal = F2(
			function (isApproving, isInProgress) {
				return A2(
					$author$project$Claim$viewVoteClaimModal,
					loggedIn.A.aw,
					{
						js: claimId,
						mw: $author$project$Page$Dashboard$Claim$ClaimMsg($author$project$Claim$CloseClaimModals),
						kl: isApproving,
						ko: isInProgress,
						l_: $author$project$Page$Dashboard$Claim$VoteClaim
					});
			});
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-8 border-t pt-8')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold mb-6 text-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('claim.voteTitle'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-around sm:justify-center sm:space-x-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary text-red'),
									$elm$html$Html$Events$onClick(
									$author$project$Page$Dashboard$Claim$ClaimMsg(
										A2($author$project$Claim$OpenVoteModal, claimId, false))),
									$elm$html$Html$Attributes$disabled(!loggedIn.gz)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('dashboard.reject'))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary'),
									$elm$html$Html$Events$onClick(
									$author$project$Page$Dashboard$Claim$ClaimMsg(
										A2($author$project$Claim$OpenVoteModal, claimId, true))),
									$elm$html$Html$Attributes$disabled(!loggedIn.gz)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('dashboard.verify'))
								]))
						])),
					function () {
					switch (modalStatus.$) {
						case 0:
							var isApproving = modalStatus.b;
							return A2(viewVoteModal, isApproving, true);
						case 1:
							var isApproving = modalStatus.b;
							return A2(viewVoteModal, isApproving, false);
						default:
							return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Page$Dashboard$Claim$PendingSummary = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Dashboard$Claim$VoterSummary = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Dashboard$Claim$viewVoters = F3(
	function (loggedIn, profileSummaries, claim) {
		var shared = loggedIn.A;
		var text_ = function (s) {
			return $elm$html$Html$text(
				shared.aw.fL(s));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									text_('claim.approved_by')
								])),
							$elm$core$List$isEmpty(claim.aa) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex mb-10')
								]),
							_List_fromArray(
								[
									$author$project$Profile$viewEmpty(shared.aw)
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap -mx-2')
								]),
							A4(
								$elm$core$List$map3,
								F3(
									function (profileSummary, index, c) {
										return c.bC ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('px-2')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Page$Dashboard$Claim$GotProfileSummaryMsg(
														$author$project$Page$Dashboard$Claim$VoterSummary(index)),
													A4($author$project$Profile$Summary$view, shared.aw, loggedIn._, c.aN, profileSummary))
												])) : $elm$html$Html$text('');
									}),
								profileSummaries.cv,
								A2(
									$elm$core$List$range,
									0,
									$elm$core$List$length(profileSummaries.cv)),
								claim.aa))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									text_('claim.disapproved_by')
								])),
							$elm$core$List$isEmpty(
							A2(
								$elm$core$List$filter,
								function (check) {
									return !check.bC;
								},
								claim.aa)) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex mb-10')
								]),
							_List_fromArray(
								[
									$author$project$Profile$viewEmpty(shared.aw)
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap mb-10 -mx-2 pt-2')
								]),
							A4(
								$elm$core$List$map3,
								F3(
									function (profileSummary, index, c) {
										return (!c.bC) ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('px-2')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Page$Dashboard$Claim$GotProfileSummaryMsg(
														$author$project$Page$Dashboard$Claim$VoterSummary(index)),
													A4($author$project$Profile$Summary$view, shared.aw, loggedIn._, c.aN, profileSummary))
												])) : $elm$html$Html$text('');
									}),
								profileSummaries.cv,
								A2(
									$elm$core$List$range,
									0,
									$elm$core$List$length(profileSummaries.cv)),
								claim.aa))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									text_('claim.pending')
								])),
							_Utils_eq(
							$elm$core$List$length(claim.aa),
							claim.dh.lX) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex')
								]),
							_List_fromArray(
								[
									$author$project$Profile$viewEmpty(shared.aw)
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row flex-wrap space-x-6')
								]),
							A4(
								$elm$core$List$map3,
								F3(
									function (profileSummary, index, v) {
										return A2(
											$elm$html$Html$map,
											$author$project$Page$Dashboard$Claim$GotProfileSummaryMsg(
												$author$project$Page$Dashboard$Claim$PendingSummary(index)),
											A4($author$project$Profile$Summary$view, shared.aw, loggedIn._, v, profileSummary));
									}),
								profileSummaries.eb,
								A2(
									$elm$core$List$range,
									0,
									$elm$core$List$length(profileSummaries.eb)),
								$author$project$Page$Dashboard$Claim$pendingValidators(claim)))
						]))
				]));
	});
var $author$project$Page$Dashboard$Claim$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var title = function () {
			var _v4 = model.an;
			if (_v4.$ === 1) {
				var claim = _v4.a;
				return A2(
					$elm_community$string_extra$String$Extra$softEllipsis,
					20,
					$author$project$Markdown$toUnformattedString(claim.dh.aR));
			} else {
				return '';
			}
		}();
		var _v0 = shared.aw;
		var t = _v0.fL;
		var content = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v2 = model.an;
					switch (_v2.$) {
						case 0:
							return $author$project$Page$fullPageLoading(shared);
						case 1:
							var claim = _v2.a;
							var profileSummaries = _v2.b;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bg-gray-100')
									]),
								_List_fromArray(
									[
										A2($author$project$Page$viewHeader, loggedIn, title),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-10 mb-8 flex items-center justify-center')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Page$Dashboard$Claim$GotProfileSummaryMsg($author$project$Page$Dashboard$Claim$ClaimerSummary),
												A4($author$project$Profile$Summary$view, shared.aw, loggedIn._, claim.gb, profileSummaries.gb))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mx-auto container px-4')
											]),
										_List_fromArray(
											[
												A3($author$project$Page$Dashboard$Claim$viewTitle, shared, model, claim),
												A2($author$project$Page$Dashboard$Claim$viewProofs, shared.aw, claim),
												A3($author$project$Page$Dashboard$Claim$viewDetails, loggedIn, model, claim),
												A3($author$project$Page$Dashboard$Claim$viewVoters, loggedIn, profileSummaries, claim)
											])),
										function () {
										var _v3 = model.hF;
										if (_v3.$ === 2) {
											var c = _v3.a;
											return A2(
												$elm$html$Html$map,
												$author$project$Page$Dashboard$Claim$ClaimMsg,
												A2($author$project$Claim$viewPhotoModal, loggedIn, c));
										} else {
											return (A3($author$project$Claim$isVotable, claim, loggedIn._, shared.ce) && (!model.fa)) ? A3($author$project$Page$Dashboard$Claim$viewVoteButtons, loggedIn, claim.w, model.hF) : $elm$html$Html$text('');
										}
									}()
									]));
						default:
							var err = _v2.a;
							return A2(
								$author$project$Page$fullPageGraphQLError,
								t('error.unknown'),
								err);
					}
				}()
				]));
		return {
			mJ: function () {
				var _v1 = A2(
					$krisajenkins$remotedata$RemoteData$map,
					function ($) {
						return $.bz;
					},
					loggedIn.pC);
				switch (_v1.$) {
					case 3:
						if (_v1.a) {
							return content;
						} else {
							return A2(
								$author$project$Page$fullPageNotFound,
								t('error.pageNotFound'),
								t('community.objectives.disabled.description'));
						}
					case 1:
						return $author$project$Page$fullPageLoading(shared);
					case 0:
						return $author$project$Page$fullPageLoading(shared);
					default:
						var e = _v1.a;
						return A2(
							$author$project$Page$fullPageGraphQLError,
							t('community.error_loading'),
							e);
				}
			}(),
			fN: title
		};
	});
var $author$project$Page$Join$viewLoading = function (shared) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col flex-grow items-center md:justify-center')
			]),
		_List_fromArray(
			[
				A2($author$project$View$Components$loadingLogoAnimated, shared.aw, '')
			]));
};
var $author$project$Page$Join$ClickedJoinCommunity = {$: 0};
var $author$project$Community$communityPreviewImage = F3(
	function (isLeftSide, _v0, community) {
		var translators = _v0.aw;
		var defaultImage = isLeftSide ? '/images/community-bg-desktop.svg' : '/images/community-bg-mobile.svg';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('md:hidden w-full', !isLeftSide),
							_Utils_Tuple2('w-1/2 flex-grow hidden md:block', isLeftSide)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-black')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full opacity-60'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('h-screen object-cover', isLeftSide),
											_Utils_Tuple2('min-h-25 max-h-108', !isLeftSide)
										])),
									$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										defaultImage,
										$elm$core$List$head(community.bQ)))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute inset-0 flex flex-col items-center justify-center text-white uppercase px-5')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold text-lg')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(community.fj)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold text-sm mt-4')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										translators.i4,
										'community.join.member_count',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'member_count',
												$elm$core$String$fromInt(community.gT))
											])))
								]))
						]))
				]));
	});
var $author$project$Page$Join$view_ = F4(
	function (isGuest, shared, community, model) {
		var translators = shared.aw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-purple-500 flex-grow flex flex-col md:justify-center items-center p-4 lg:p-0'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('w-1/2', !isGuest)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded-b md:rounded w-full lg:w-4/5 xl:w-7/12')
						]),
					_List_fromArray(
						[
							A3($author$project$Community$communityPreviewImage, false, shared, community),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('p-4')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Markdown$view,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-333 block mb-7')
										]),
									community.aR),
								_Utils_ap(
									community.bx ? _List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button button-primary w-full cursor-pointer'),
													$elm$html$Html$Events$onClick($author$project$Page$Join$ClickedJoinCommunity)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														translators.i4,
														'community.join.title_with_community',
														_List_fromArray(
															[
																_Utils_Tuple2('community_name', community.fj)
															])))
												]))
										]) : _List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('block text-center text-black font-bold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													translators.fL('community.join.only_invited'))
												])),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button button-primary w-full mt-4'),
													$author$project$Route$href(
													A2($author$project$Route$Login, $elm$core$Maybe$Nothing, model.kD))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													translators.fL('community.join.already_member'))
												]))
										]),
									function () {
										var _v0 = community.bT;
										if (_v0.$ === 1) {
											return _List_fromArray(
												[
													$elm$html$Html$text('')
												]);
										} else {
											var website = _v0.a;
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('button button-secondary w-full mt-4 cursor-pointer'),
															$elm$html$Html$Attributes$href(website)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															translators.fL('community.join.visit_website'))
														]))
												]);
										}
									}())))
						]))
				]));
	});
var $author$project$Page$Join$viewAsGuest = F3(
	function (title, guest, model) {
		var _v0 = guest.V;
		switch (_v0.$) {
			case 3:
				var communityPreview = _v0.a;
				return A4($author$project$Page$Join$view_, true, guest.A, communityPreview, model);
			case 2:
				var err = _v0.a;
				return A2($author$project$Page$fullPageGraphQLError, title, err);
			default:
				return $author$project$Page$Join$viewLoading(guest.A);
		}
	});
var $author$project$Page$Join$viewAsLoggedIn = F3(
	function (title, loggedIn, model) {
		var _v0 = A2(
			$author$project$Community$getField,
			loggedIn.pC,
			function ($) {
				return $.bQ;
			});
		switch (_v0.$) {
			case 3:
				var _v1 = _v0.a;
				var community = _v1.a;
				var uploads = _v1.b;
				var normalizedCommunity = {aR: community.aR, bx: community.bx, gT: community.gT, fj: community.fj, bQ: uploads, bT: community.bT};
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-grow flex')
						]),
					_List_fromArray(
						[
							A3($author$project$Community$communityPreviewImage, true, loggedIn.A, normalizedCommunity),
							A4($author$project$Page$Join$view_, false, loggedIn.A, normalizedCommunity, model)
						]));
			case 2:
				if (!_v0.a.$) {
					var err = _v0.a.a;
					return A2($author$project$Page$fullPageGraphQLError, title, err);
				} else {
					var err = _v0.a.a;
					return A2($author$project$Page$fullPageGraphQLError, title, err);
				}
			case 1:
				return $author$project$Page$Join$viewLoading(loggedIn.A);
			default:
				return $author$project$Page$Join$viewLoading(loggedIn.A);
		}
	});
var $author$project$Page$Join$view = F2(
	function (session, model) {
		var maybeCommunityName = function () {
			if (!session.$) {
				var guest = session.a;
				return $krisajenkins$remotedata$RemoteData$toMaybe(
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function ($) {
							return $.fj;
						},
						guest.V));
			} else {
				var loggedIn = session.a;
				return $krisajenkins$remotedata$RemoteData$toMaybe(
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function ($) {
							return $.fj;
						},
						loggedIn.pC));
			}
		}();
		var _v0 = $author$project$Page$toShared(session);
		var translators = _v0.aw;
		var title = function () {
			if (maybeCommunityName.$ === 1) {
				return translators.fL('community.join.title_generic');
			} else {
				var name = maybeCommunityName.a;
				return A2(
					translators.i4,
					'community.join.title_with_community',
					_List_fromArray(
						[
							_Utils_Tuple2('community_name', name)
						]));
			}
		}();
		var content = function () {
			if (!session.$) {
				var guest = session.a;
				return A3($author$project$Page$Join$viewAsGuest, title, guest, model);
			} else {
				var loggedIn = session.a;
				return A3($author$project$Page$Join$viewAsLoggedIn, title, loggedIn, model);
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Login$ClickedNextStep = function (a) {
	return {$: 5, a: a};
};
var $author$project$Form$isShowingAllErrors = function (_v0) {
	var model = _v0;
	var _v1 = model.aT;
	var errorTracking = _v1;
	return errorTracking.fD;
};
var $author$project$Form$Text$CountWords = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Login$ScrolledTextArea = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $author$project$Page$Login$Passphrase = $elm$core$Basics$identity;
var $author$project$Page$Login$passphraseValidator = function (maybeBip39Wordlist) {
	var wordsHave3Letters = function (passphrase) {
		return A2(
			$elm$core$List$all,
			function (word) {
				return $elm$core$String$length(word) > 2;
			},
			$elm$core$String$words(passphrase)) ? $elm$core$Result$Ok(passphrase) : $elm$core$Result$Err(
			function (translators_) {
				return translators_.fL('auth.login.wordsMode.input.atLeastThreeLettersError');
			});
	};
	var isBip39 = function (passphrase) {
		if (maybeBip39Wordlist.$ === 1) {
			return $elm$core$Result$Ok(passphrase);
		} else {
			var bip39Wordlist = maybeBip39Wordlist.a;
			var _v1 = A2(
				$elm$core$List$filter,
				function (word) {
					return (!A2($elm$core$Set$member, word, bip39Wordlist.gr)) && ((!A2($elm$core$Set$member, word, bip39Wordlist.g$)) && (!A2($elm$core$Set$member, word, bip39Wordlist.hf)));
				},
				$elm$core$String$words(passphrase));
			if (_v1.b) {
				if (!_v1.b.b) {
					var firstWord = _v1.a;
					return $elm$core$Result$Err(
						function (translators_) {
							return A2(
								translators_.i4,
								'auth.login.wordsMode.input.invalid_word',
								_List_fromArray(
									[
										_Utils_Tuple2('word', firstWord)
									]));
						});
				} else {
					var firstWord = _v1.a;
					var otherWords = _v1.b;
					return $elm$core$Result$Err(
						function (translators_) {
							return A2(
								translators_.i4,
								'auth.login.wordsMode.input.invalid_words',
								_List_fromArray(
									[
										_Utils_Tuple2(
										'words',
										A2(
											$elm$core$String$join,
											', ',
											A2($elm$core$List$cons, firstWord, otherWords)))
									]));
						});
				}
			} else {
				return $elm$core$Result$Ok(passphrase);
			}
		}
	};
	var has12Words = function (passphrase) {
		return ($elm$core$List$length(
			$elm$core$String$words(passphrase)) >= 12) ? $elm$core$Result$Ok(
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$take,
					12,
					$elm$core$String$words(passphrase)))) : $elm$core$Result$Err(
			function (translators_) {
				return translators_.fL('auth.login.wordsMode.input.notPassphraseError');
			});
	};
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Form$Validate$map($elm$core$String$toLower),
		A2(
			$elm$core$Basics$composeR,
			$author$project$Form$Validate$custom(has12Words),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Form$Validate$custom(wordsHave3Letters),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Validate$custom(isBip39),
					$author$project$Form$Validate$map($elm$core$Basics$identity)))));
};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty('spellcheck');
var $author$project$Page$Login$viewIllustration = function (fileName) {
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('h-40 mx-auto mb-6'),
				$elm$html$Html$Attributes$src('/images/' + fileName)
			]),
		_List_Nil);
};
var $author$project$Form$Text$withCounterAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gk: _Utils_ap(options.gk, attrs)
			});
	});
var $author$project$Form$Text$withErrorAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gs: _Utils_ap(options.gs, attrs)
			});
	});
var $author$project$Form$Text$withInputContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gF: _Utils_ap(options.gF, attrs)
			});
	});
var $author$project$Page$Login$passphraseForm = F2(
	function (shared, _v0) {
		var translators = shared.aw;
		var hasPasted = _v0.bA;
		var hasTriedSubmitting = _v0.j3;
		var viewHighlights = function (currentText) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute inset-px pointer-events-none'),
						$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('highlights'),
								$elm$html$Html$Attributes$class('p-4 overflow-auto h-full scrollbar-hidden')
							]),
						A2(
							$elm$core$List$map,
							function (line) {
								return $elm$core$String$isEmpty(line) ? A2($elm$html$Html$br, _List_Nil, _List_Nil) : A2(
									$elm$html$Html$p,
									_List_Nil,
									A2(
										$elm$core$List$intersperse,
										A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' ')
												])),
										A2(
											$elm$core$List$map,
											function (word) {
												return $elm$core$String$isEmpty(word) ? A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('inline-block')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(' ')
														])) : A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															function () {
															var _v2 = shared.f4;
															if (_v2.$ === 1) {
																return $elm$html$Html$Attributes$class('transition-colors');
															} else {
																var bip39Wordlist = _v2.a;
																return (hasTriedSubmitting && ((!A2($elm$core$Set$member, word, bip39Wordlist.gr)) && ((!A2($elm$core$Set$member, word, bip39Wordlist.g$)) && (!A2($elm$core$Set$member, word, bip39Wordlist.hf))))) ? $elm$html$Html$Attributes$class('bg-red/60 text-white') : $elm$html$Html$Attributes$class('transition-colors');
															}
														}(),
															$elm$html$Html$Attributes$class('pointer-events-none rounded-sm px-0.5 -mx-0.5')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(word)
														]));
											},
											A2($elm$core$String$split, ' ', line))));
							},
							A2($elm$core$String$split, '\n', currentText)))
					]));
		};
		var _v1 = translators;
		var t = _v1.fL;
		var viewPasteButton = shared.jp ? A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute bottom-4 left-1/2 -translate-x-1/2 button z-10'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('button-secondary', !hasPasted),
							_Utils_Tuple2('button-primary', hasPasted)
						])),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Events$onClick($author$project$Page$Login$ClickedPaste)
				]),
			_List_fromArray(
				[
					hasPasted ? $elm$html$Html$text(
					t('auth.login.wordsMode.input.pasted')) : $elm$html$Html$text(
					t('auth.login.wordsMode.input.paste'))
				])) : $elm$html$Html$text('');
		return A2(
			$author$project$Form$with,
			$author$project$Form$introspect(
				function (values) {
					return A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Page$Login$passphraseValidator(shared.f4),
									$author$project$Form$Validate$validate(translators))),
							qd: F2(
								function (passphrase, input) {
									return _Utils_update(
										input,
										{bp: passphrase});
								}),
							lW: function ($) {
								return $.bp;
							}
						},
						A2(
							$author$project$Form$Text$withElements,
							_List_fromArray(
								[
									viewPasteButton,
									viewHighlights(values.bp)
								]),
							A2(
								$author$project$Form$Text$withErrorAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-error-on-dark-bg')
									]),
								A2(
									$author$project$Form$Text$withLabelAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-white')
										]),
									A2(
										$author$project$Form$Text$withCounterAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('!text-white')
											]),
										A2(
											$author$project$Form$Text$withCounter,
											$author$project$Form$Text$CountWords(12),
											A2(
												$author$project$Form$Text$withInputContainerAttrs,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('bg-white rounded')
													]),
												A2(
													$author$project$Form$Text$withExtraAttrs,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('min-w-full block p-4 relative bg-transparent z-10 caret-black text-transparent'),
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('pb-18', shared.jp)
																])),
															$elm$html$Html$Attributes$rows(2),
															$elm$html$Html$Attributes$autofocus(true),
															$elm$html$Html$Attributes$autocomplete(false),
															$elm$html$Html$Attributes$spellcheck(false),
															A2(
															$elm$html$Html$Events$on,
															'scroll',
															A2(
																$elm$json$Json$Decode$map,
																function (scrollTop) {
																	return $author$project$Page$Login$ScrolledTextArea(
																		{lp: scrollTop});
																},
																A2(
																	$elm$json$Json$Decode$at,
																	_List_fromArray(
																		['target', 'scrollTop']),
																	$elm$json$Json$Decode$int)))
														]),
													A2(
														$author$project$Form$Text$withPlaceholder,
														t('auth.login.wordsMode.input.placeholder'),
														A2(
															$author$project$Form$Text$withInputElement,
															$author$project$Form$Text$TextareaInput(
																{pR: true}),
															$author$project$Form$Text$init(
																{
																	w: 'passphrase-input',
																	n$: t('auth.login.wordsMode.input.label')
																})))))))))));
				}),
			A2(
				$author$project$Form$withDecoration,
				A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-white mb-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('menu.welcome_to'))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('auth.login.wordsMode.input.description'))
								]))
						])),
				A2(
					$author$project$Form$withDecoration,
					$author$project$Page$Login$viewIllustration('login_key.svg'),
					$author$project$Form$succeed($elm$core$Basics$identity))));
	});
var $author$project$Page$Login$viewPassphrase = F2(
	function (guest, model) {
		var shared = guest.A;
		var showRegisterLink = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			false,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.bx;
				},
				guest.V));
		var _v0 = shared.aw;
		var t = _v0.fL;
		return _List_fromArray(
			[
				A6(
				$author$project$Form$view,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col justify-center')
					]),
				shared.aw,
				function (submitButton) {
					return _List_fromArray(
						[
							showRegisterLink ? A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-white text-center mb-6 block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('auth.login.register')),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href(
											A2($author$project$Route$Register, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
											$elm$html$Html$Attributes$class('text-orange-300 underline')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('auth.login.registerLink'))
										]))
								])) : $elm$html$Html$text(''),
							A2(
							submitButton,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary min-w-full')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('dashboard.continue'))
								]))
						]);
				},
				A2(
					$author$project$Page$Login$passphraseForm,
					shared,
					{
						bA: model.bA,
						j3: $author$project$Form$isShowingAllErrors(model.hY)
					}),
				model.hY,
				{oU: $author$project$Page$Login$ClickedNextStep, lF: $author$project$Page$Login$GotPassphraseFormMsg})
			]);
	});
var $author$project$View$Pin$Dark = 1;
var $author$project$View$Pin$SubmittedForm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Form$Text$Password = 5;
var $author$project$View$Pin$isVisible = F2(
	function (field, model) {
		if (!field) {
			return model.cS;
		} else {
			return model.e7;
		}
	});
var $author$project$View$Pin$pinLength = 6;
var $author$project$View$Pin$ToggledPinVisibility = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$Pin$viewToggleVisibility = F3(
	function (field, model, _v0) {
		var t = _v0.fL;
		var text_ = A2($elm$core$Basics$composeR, t, $elm$html$Html$text);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute inset-y-0 uppercase text-sm font-bold right-0 mr-3 text-orange-300'),
					$elm$html$Html$Events$onClick(
					$author$project$View$Pin$ToggledPinVisibility(field)),
					A2($elm$html$Html$Attributes$attribute, 'tabindex', '-1'),
					$elm$html$Html$Attributes$type_('button')
				]),
			_List_fromArray(
				[
					A2($author$project$View$Pin$isVisible, field, model) ? text_('auth.pin.toggle.hide') : text_('auth.pin.toggle.show')
				]));
	});
var $author$project$View$Pin$createForm = F2(
	function (translators, model) {
		var t = translators.fL;
		var validatePin = A2(
			$elm$core$Basics$composeR,
			$author$project$Form$Validate$succeed,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Form$Validate$stringLengthExactly($author$project$View$Pin$pinLength),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Validate$custom(
						function (pin) {
							return A2($elm$core$String$all, $elm$core$Char$isDigit, pin) ? $elm$core$Result$Ok(pin) : $elm$core$Result$Err(
								function (translators_) {
									return translators_.fL('auth.pin.shouldHaveSixDigitsError');
								});
						}),
					$author$project$Form$Validate$validate(translators))));
		var backgroundAttrs = function () {
			var _v5 = model.f3;
			if (_v5 === 1) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Text$withLabelAttrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-white')
							])),
					$author$project$Form$Text$withCounterAttrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('!text-white')
							])));
			} else {
				return $elm$core$Basics$identity;
			}
		}();
		var commonOptions = function (field) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Form$Text$withPlaceholder(
					A2($elm$core$String$repeat, $author$project$View$Pin$pinLength, '*')),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Text$withDisabled(model.b_ || model.cT),
					A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Text$withCounter(
							$author$project$Form$Text$CountLetters($author$project$View$Pin$pinLength)),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Text$withElements(
								_List_fromArray(
									[
										A3($author$project$View$Pin$viewToggleVisibility, field, model, translators)
									])),
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Text$withExtraAttrs(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$maxlength($author$project$View$Pin$pinLength),
											$elm$html$Html$Attributes$autocomplete(false),
											$elm$html$Html$Attributes$class('text-body-black tracking-widest')
										])),
								A2(
									$elm$core$Basics$composeR,
									backgroundAttrs,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Text$withType(
											A2($author$project$View$Pin$isVisible, field, model) ? 0 : 5),
										$author$project$Form$Text$asNumeric)))))));
		};
		return A2(
			$author$project$Form$with,
			model.ir ? A2(
				$author$project$Form$textField,
				{
					ne: function (_v3) {
						var pin = _v3.o8;
						var confirmation = _v3.dt;
						var externalProblem = A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$core$Tuple$second, t),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (_v4) {
									var problemField = _v4.a;
									return !problemField;
								},
								model.bL));
						var confirmationProblem = _Utils_eq(pin, confirmation) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							t('auth.pinConfirmation.differsFromPinError'));
						return A2($elm_community$maybe_extra$Maybe$Extra$or, confirmationProblem, externalProblem);
					},
					o3: validatePin,
					qd: F2(
						function (confirmation, input) {
							return _Utils_update(
								input,
								{dt: confirmation});
						}),
					lW: function ($) {
						return $.dt;
					}
				},
				A2(
					commonOptions,
					1,
					$author$project$Form$Text$init(
						{
							w: 'pin-confirmation-input',
							n$: t(model.n$)
						}))) : $author$project$Form$succeed(''),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$textField,
					{
						ne: function (_v1) {
							return A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $elm$core$Tuple$second, t),
								A2(
									$elm_community$list_extra$List$Extra$find,
									function (_v2) {
										var problemField = _v2.a;
										return !problemField;
									},
									model.bL));
						},
						o3: validatePin,
						qd: F2(
							function (pin, input) {
								return _Utils_update(
									input,
									{o8: pin});
							}),
						lW: function ($) {
							return $.o8;
						}
					},
					A2(
						$author$project$Form$Text$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-6')
							]),
						A2(
							$author$project$Form$Text$withExtraAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$autofocus(true)
								]),
							A2(
								commonOptions,
								0,
								$author$project$Form$Text$init(
									{
										w: 'pin-input',
										n$: t(model.n$)
									}))))),
				$author$project$Form$succeed(
					F2(
						function (pin, _v0) {
							return {o8: pin};
						}))));
	});
var $author$project$View$Pin$view = F2(
	function (translators, model) {
		var t = translators.fL;
		var text_ = A2($elm$core$Basics$composeR, t, $elm$html$Html$text);
		return A6(
			$author$project$Form$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col flex-grow')
				]),
			translators,
			function (submitButton) {
				return _List_fromArray(
					[
						A2(
						submitButton,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-primary min-w-full mt-auto'),
								$elm$html$Html$Attributes$disabled(model.b_ || model.cT)
							]),
						_List_fromArray(
							[
								model.cT ? text_(model.pS) : text_(model.pQ)
							]))
					]);
			},
			A2($author$project$View$Pin$createForm, translators, model),
			model.hY,
			{oU: $author$project$View$Pin$SubmittedForm, lF: $author$project$View$Pin$GotFormMsg});
	});
var $author$project$View$Pin$withBackgroundColor = F2(
	function (background, model) {
		return _Utils_update(
			model,
			{f3: background});
	});
var $author$project$Page$Login$viewPin = F2(
	function (_v0, model) {
		var shared = _v0.A;
		var trPrefix = function (s) {
			return 'auth.pin.instruction.' + s;
		};
		var isInputtingPin = function () {
			var _v2 = model.pN;
			if (!_v2.$) {
				return true;
			} else {
				return false;
			}
		}();
		var _v1 = shared.aw;
		var t = _v1.fL;
		return _List_fromArray(
			[
				$author$project$Page$Login$viewIllustration('login_pin.svg'),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-white')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						t(
							trPrefix('nowCreate'))),
						$elm$html$Html$text(' '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								t(
									trPrefix('sixDigitPin')))
							])),
						$elm$html$Html$text('. '),
						$elm$html$Html$text(
						t(
							trPrefix('thePin'))),
						$elm$html$Html$text(' '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								t(
									trPrefix('notPassword')))
							])),
						$elm$html$Html$text(' '),
						$elm$html$Html$text(
						t(
							trPrefix('eachLogin')))
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Page$Login$GotPinComponentMsg,
				A2(
					$author$project$View$Pin$view,
					shared.aw,
					A2(
						$author$project$View$Pin$withDisabled,
						!isInputtingPin,
						A2($author$project$View$Pin$withBackgroundColor, 1, model.ak))))
			]);
	});
var $author$project$Page$Login$view = F2(
	function (guest, model) {
		return {
			mJ: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-purple-500 flex-grow flex flex-col justify-center md:block')
					]),
				_List_fromArray(
					[
						A3(
						$elm$html$Html$Keyed$node,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col flex-grow justify-between w-full p-4 md:max-w-sm md:mx-auto md:pt-20 md:px-0')
							]),
						function () {
							if (!model.$) {
								var passphraseModel = model.a;
								return A2(
									$elm$core$List$indexedMap,
									F2(
										function (index, node) {
											return _Utils_Tuple2(
												'passphrase-' + $elm$core$String$fromInt(index),
												node);
										}),
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($author$project$Page$Login$GotPassphraseMsg),
										A2($author$project$Page$Login$viewPassphrase, guest, passphraseModel)));
							} else {
								var pinModel = model.a;
								return A2(
									$elm$core$List$indexedMap,
									F2(
										function (index, node) {
											return _Utils_Tuple2(
												'pin-' + $elm$core$String$fromInt(index),
												node);
										}),
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($author$project$Page$Login$GotPinMsg),
										A2($author$project$Page$Login$viewPin, guest, pinModel)));
							}
						}())
					])),
			fN: guest.A.aw.fL('auth.login.loginTab')
		};
	});
var $author$project$Page$News$GotLastEditorSummaryMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$News$ClickedToggleReactions = {$: 3};
var $author$project$Page$News$ToggledReaction = function (a) {
	return {$: 4, a: a};
};
var $author$project$Cambiatus$Enum$ReactionEnum$list = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);
var $author$project$Community$News$listReactions = $author$project$Cambiatus$Enum$ReactionEnum$list;
var $author$project$Community$News$reactionToString = function (reaction) {
	switch (reaction) {
		case 0:
			return '👏';
		case 1:
			return '🤨';
		case 2:
			return '😃';
		case 3:
			return '🎉';
		case 4:
			return '❤️';
		case 5:
			return '🚀';
		case 6:
			return '🙁';
		case 7:
			return '😍';
		case 8:
			return '👎';
		default:
			return '👍';
	}
};
var $author$project$Icons$smilingFace = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_),
				$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true),
				$elm$html$Html$Attributes$alt('')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7.99998 14.6667C4.31798 14.6667 1.33331 11.682 1.33331 8.00001C1.33331 4.31801 4.31798 1.33334 7.99998 1.33334C11.682 1.33334 14.6666 4.31801 14.6666 8.00001C14.6666 11.682 11.682 14.6667 7.99998 14.6667ZM7.99998 13.3333C9.41447 13.3333 10.771 12.7714 11.7712 11.7712C12.7714 10.7711 13.3333 9.4145 13.3333 8.00001C13.3333 6.58552 12.7714 5.22897 11.7712 4.22877C10.771 3.22858 9.41447 2.66668 7.99998 2.66668C6.58549 2.66668 5.22894 3.22858 4.22874 4.22877C3.22855 5.22897 2.66665 6.58552 2.66665 8.00001C2.66665 9.4145 3.22855 10.7711 4.22874 11.7712C5.22894 12.7714 6.58549 13.3333 7.99998 13.3333ZM4.66665 8.66668H5.99998C5.99998 9.19711 6.21069 9.70582 6.58577 10.0809C6.96084 10.456 7.46955 10.6667 7.99998 10.6667C8.53041 10.6667 9.03912 10.456 9.41419 10.0809C9.78927 9.70582 9.99998 9.19711 9.99998 8.66668H11.3333C11.3333 9.55073 10.9821 10.3986 10.357 11.0237C9.73188 11.6488 8.88403 12 7.99998 12C7.11592 12 6.26808 11.6488 5.64296 11.0237C5.01784 10.3986 4.66665 9.55073 4.66665 8.66668ZM5.33331 7.33334C5.0681 7.33334 4.81374 7.22799 4.62621 7.04045C4.43867 6.85291 4.33331 6.59856 4.33331 6.33334C4.33331 6.06813 4.43867 5.81377 4.62621 5.62624C4.81374 5.4387 5.0681 5.33334 5.33331 5.33334C5.59853 5.33334 5.85288 5.4387 6.04042 5.62624C6.22796 5.81377 6.33331 6.06813 6.33331 6.33334C6.33331 6.59856 6.22796 6.85291 6.04042 7.04045C5.85288 7.22799 5.59853 7.33334 5.33331 7.33334ZM10.6666 7.33334C10.4014 7.33334 10.1471 7.22799 9.95954 7.04045C9.772 6.85291 9.66665 6.59856 9.66665 6.33334C9.66665 6.06813 9.772 5.81377 9.95954 5.62624C10.1471 5.4387 10.4014 5.33334 10.6666 5.33334C10.9319 5.33334 11.1862 5.4387 11.3738 5.62624C11.5613 5.81377 11.6666 6.06813 11.6666 6.33334C11.6666 6.59856 11.5613 6.85291 11.3738 7.04045C11.1862 7.22799 10.9319 7.33334 10.6666 7.33334Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$News$viewReactionPicker = F3(
	function (_v0, model, news) {
		var t = _v0.fL;
		var hasReaction = function (reaction) {
			var _v2 = news.iK;
			if (_v2.$ === 1) {
				return false;
			} else {
				var receipt = _v2.a;
				return A2($elm$core$List$member, reaction, receipt.la);
			}
		};
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$details,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-block relative z-10'),
						$elm$html$Html$Attributes$id('reaction-picker'),
						$author$project$Utils$onClickPreventAll($author$project$Page$News$ClickedToggleReactions),
						model.cq ? A2($elm$html$Html$Attributes$attribute, 'open', '') : $elm$html$Html$Attributes$class('')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$summary,
						_List_fromArray(
							[
								$fapian$elm_html_aria$Html$Attributes$Aria$role('button'),
								$fapian$elm_html_aria$Html$Attributes$Aria$ariaHasPopup('true'),
								$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
								t('news.reaction.choose')),
								$elm$html$Html$Attributes$class('marker-hidden bg-gray-200 rounded-full p-0.5 focus-ring transition-colors hover:bg-gray-500 active:bg-gray-300')
							]),
						_List_fromArray(
							[
								$author$project$Icons$smilingFace('fill-current text-gray-900 w-6 h-6')
							])),
						A3(
						$author$project$View$Components$focusTrap,
						{nF: $elm$core$Maybe$Nothing},
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('absolute shadow grid gap-1 p-2 rounded-sm bg-white'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('animate-bounce-in', model.cq)
											])),
										A2($elm$html$Html$Attributes$style, 'grid-template-columns', 'repeat(5, 1fr)')
									]),
								A2(
									$elm$core$List$indexedMap,
									F2(
										function (index, reaction) {
											return A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('w-8 h-8 flex items-center justify-center rounded-sm focus-ring transition-colors'),
																$elm$html$Html$Attributes$classList(
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'bg-green bg-opacity-80 hover:bg-opacity-60',
																		hasReaction(reaction)),
																		_Utils_Tuple2(
																		'bg-white hover:bg-gray-200 focus-visible:bg-gray-200',
																		!hasReaction(reaction))
																	])),
																$elm$html$Html$Events$onClick(
																$author$project$Page$News$ToggledReaction(reaction)),
																$elm$html$Html$Attributes$id(
																'reaction-' + $elm$core$String$fromInt(index))
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('sr-only')
																	]),
																_List_fromArray(
																	[
																		hasReaction(reaction) ? $elm$html$Html$text(
																		t('news.reaction.remove')) : $elm$html$Html$text(
																		t('news.reaction.add'))
																	])),
																$elm$html$Html$text(
																$author$project$Community$News$reactionToString(reaction))
															]))
													]));
										}),
									$author$project$Community$News$listReactions))
							]))
					])),
			model.cq ? _List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fixed top-0 right-0 w-screen h-screen cursor-auto'),
							$elm$html$Html$Events$onClick($author$project$Page$News$ClickedToggleReactions),
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							t('news.reaction.close')),
							$elm$html$Html$Attributes$tabindex(-1)
						]),
					_List_Nil),
					$author$project$View$Components$keyListener(
					{
						l7: _List_fromArray(
							[0]),
						k3: false,
						lw: true,
						lF: function (_v1) {
							return $author$project$Page$News$ClickedToggleReactions;
						}
					})
				]) : _List_Nil);
	});
var $author$project$Community$News$reactionName = A2(
	$elm$core$Basics$composeR,
	$author$project$Cambiatus$Enum$ReactionEnum$toString,
	A2($elm$core$String$replace, '_', ' '));
var $author$project$Page$News$viewReactions = F2(
	function (_v0, news) {
		var tr = _v0.i4;
		var hasReaction = function (reaction) {
			var _v3 = news.iK;
			if (_v3.$ === 1) {
				return false;
			} else {
				var receipt = _v3.a;
				return A2($elm$core$List$member, reaction, receipt.la);
			}
		};
		return A2(
			$elm$html$Html$Keyed$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center')
				]),
			A2(
				$elm$core$List$map,
				function (_v2) {
					var reaction = _v2.fw;
					var count = _v2.mO;
					return _Utils_Tuple2(
						$author$project$Community$News$reactionName(reaction),
						A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-4 rounded-full py-0.5 px-2 flex gap-1 focus-ring transition-colors'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'bg-green bg-opacity-50 border border-green hover:bg-opacity-40 active:bg-opacity-60',
													hasReaction(reaction)),
													_Utils_Tuple2(
													'bg-gray-200 hover:bg-gray-500 active:bg-gray-300',
													!hasReaction(reaction))
												])),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Events$onClick(
											$author$project$Page$News$ToggledReaction(reaction))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('sr-only')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														tr,
														'news.reaction.reactions',
														_List_fromArray(
															[
																_Utils_Tuple2(
																'count',
																$elm$core$String$fromInt(count))
															])))
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Community$News$reactionToString(reaction))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(count))
												]))
										]))
								])));
				},
				A2(
					$elm$core$List$filter,
					function (_v1) {
						var count = _v1.mO;
						return count > 0;
					},
					news.la)));
	});
var $author$project$Page$News$viewMainNews = F3(
	function (loggedIn, model, news) {
		var shared = loggedIn.A;
		var _v0 = shared;
		var translators = _v0.aw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4 pt-10 pb-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-lg text-black font-bold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(news.fN)
								])),
							A2(
							$author$project$Markdown$view,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-6 text-black colored-links')
								]),
							news.aR),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center mt-8')
								]),
							_Utils_ap(
								A3($author$project$Page$News$viewReactionPicker, translators, model, news),
								_List_fromArray(
									[
										A2($author$project$Page$News$viewReactions, translators, news)
									]))),
							(!_Utils_eq(news.nL, news.qe)) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center mt-6')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Page$News$GotLastEditorSummaryMsg,
									A4(
										$author$project$Profile$Summary$view,
										shared.aw,
										loggedIn._,
										news.jz,
										A2(
											$author$project$Profile$Summary$withImageSize,
											'h-8 w-8',
											$author$project$Profile$Summary$withoutName(model.fd)))),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-900 ml-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											translators.fL('news.edited_by')),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-bold hover:underline'),
													$author$project$Route$href(
													$author$project$Route$Profile(news.jz.l8))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														$author$project$Eos$Account$nameToString(news.jz.l8),
														news.jz.fj))
												])),
											A4(
											$author$project$View$Components$dateViewer,
											_List_Nil,
											function (translations) {
												return _Utils_update(
													translations,
													{
														o$: translators.fL('news.edited_date'),
														p4: $elm$core$Maybe$Nothing,
														qo: $elm$core$Maybe$Nothing
													});
											},
											shared,
											news.qe)
										]))
								])) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Page$News$view_ = F4(
	function (loggedIn, model, maybeSelectedNews, news) {
		var shared = loggedIn.A;
		var _v0 = shared.aw;
		var t = _v0.fL;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						if (!maybeSelectedNews.$) {
							var selectedNews = maybeSelectedNews.a;
							return _List_fromArray(
								[
									A3($author$project$Page$News$viewMainNews, loggedIn, model, selectedNews),
									($elm$core$List$isEmpty(news) || (!model.pI)) ? $elm$html$Html$text('') : A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container mx-auto px-4 mt-16 mb-4 text-lg font-bold text-gray-900')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('news.read'))
												])),
											$elm$html$Html$text(' '),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-purple-500')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('news.other_news'))
												]))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						_List_fromArray(
						[
							model.pI ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white pb-4')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Community$News$viewList,
									shared,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container mx-auto px-4 pt-6')
										]),
									news)
								])) : $elm$html$Html$text('')
						])
					])));
	});
var $author$project$Page$News$view = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var title = t('news.title');
		var content = function () {
			var _v1 = A2(
				$author$project$Community$getField,
				loggedIn.pC,
				function ($) {
					return $.fl;
				});
			switch (_v1.$) {
				case 3:
					var _v2 = _v1.a;
					var community = _v2.a;
					var news = _v2.b;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Page$viewHeader, loggedIn, title),
								((!community.dH) || $elm$core$List$isEmpty(news)) ? A2(
								$author$project$Page$fullPageNotFound,
								t('news.no_news.title'),
								t('news.no_news.description')) : A4(
								$author$project$Page$News$view_,
								loggedIn,
								model,
								A2(
									$elm$core$Maybe$andThen,
									function (newsId) {
										return A2(
											$elm_community$list_extra$List$Extra$find,
											function (_v3) {
												var id = _v3.w;
												return _Utils_eq(id, newsId);
											},
											news);
									},
									model.bG),
								A2(
									$elm$core$List$filter,
									function (n) {
										return A2($author$project$Community$News$isPublished, loggedIn.A.ce, n) && (!_Utils_eq(
											$elm$core$Maybe$Just(n.w),
											model.bG));
									},
									news))
							]));
				case 2:
					var failure = _v1.a;
					if (failure.$ === 1) {
						var err = failure.a;
						return A2($author$project$Page$fullPageGraphQLError, title, err);
					} else {
						var err = failure.a;
						return A2($author$project$Page$fullPageGraphQLError, title, err);
					}
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				default:
					return $author$project$Page$fullPageLoading(loggedIn.A);
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$NotFound$view = function (session) {
	var shared = $author$project$Page$toShared(session);
	return {
		mJ: A2(
			$author$project$Page$fullPageNotFound,
			shared.aw.fL('error.pageNotFound'),
			''),
		fN: shared.aw.fL('error.pageNotFound')
	};
};
var $author$project$Page$Notification$viewEmptyNotifications = function (shared) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('rounded-lg bg-white mt-5 p-8 text-center shadow')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						shared.aw.fL('notifications.empty'))
					]))
			]));
};
var $author$project$Page$Notification$M = {$: 2};
var $author$project$Page$Notification$MarkAsRead = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {cF: decimals, kh: integers, s: original, g0: prefix, hg: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.kh,
				$elm$core$List$singleton(formatted.cF))));
	return onlyZeros ? 1 : ((formatted.s < 0) ? 2 : 0);
};
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.cF;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.cF;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = $cuducos$elm_format_number$FormatNumber$Parser$splitThousands(
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{g0: locale.gX, hg: locale.is});
			case 0:
				return _Utils_update(
					partial,
					{g0: locale.k1, hg: locale.k2});
			default:
				return _Utils_update(
					partial,
					{g0: locale.l4, hg: locale.l5});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.jD, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.c9, formatted.kh);
		var decimals = stringfyDecimals(formatted.cF);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.g0, integers, decimals, formatted.hg]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	jD: '.',
	cF: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	gX: '−',
	is: '',
	k1: '',
	k2: '',
	c9: '',
	l4: '',
	l5: ''
};
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		cF: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2),
		c9: ','
	});
var $author$project$Page$Notification$viewAmount = F2(
	function (amount, symbol) {
		var color = (amount > 0) ? 'text-green' : 'text-red';
		var amountText = A2($cuducos$elm_format_number$FormatNumber$format, $cuducos$elm_format_number$FormatNumber$Locales$usLocale, amount);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-2xl'),
						$elm$html$Html$Attributes$class(color)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(amountText)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('uppercase text-sm font-extralight mt-3 ml-2 font-sans'),
						$elm$html$Html$Attributes$class(color)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Eos$symbolToSymbolCodeString(symbol))
					]))
			]);
	});
var $author$project$Page$Notification$viewNotificationMint = F3(
	function (shared, history, notification) {
		var maybeLogo = $elm$core$String$isEmpty(notification.V.fe) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(notification.V.fe);
		var description = A2(
			shared.aw.i4,
			'notifications.issue.receive',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$core$String$fromFloat(notification.po)),
					_Utils_Tuple2(
					'symbol',
					$author$project$Eos$symbolToSymbolCodeString(notification.V.as))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-start lg:items-center p-4'),
					$elm$html$Html$Events$onClick(
					A2($author$project$Page$Notification$MarkAsRead, history.w, $author$project$Page$Notification$M))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-none')
						]),
					_List_fromArray(
						[
							function () {
							if (!maybeLogo.$) {
								var logoUrl = maybeLogo.a;
								return A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10 h-10 object-scale-down'),
											$elm$html$Html$Attributes$src(logoUrl)
										]),
									_List_Nil);
							} else {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10 h-10 object-scale-down')
										]),
									_List_Nil);
							}
						}()
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-col flex-grow-1 pl-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								])),
							A4(
							$author$project$View$Components$dateViewer,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-900 text-sm uppercase')
								]),
							$elm$core$Basics$identity,
							shared,
							$author$project$Utils$fromDateTime(history.nL))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-none pl-4')
						]),
					A2($author$project$Page$Notification$viewAmount, notification.po, notification.V.as))
				]));
	});
var $author$project$Page$Notification$S = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Notification$viewNotificationSaleHistoryDetail = F3(
	function (loggedIn, sale, date) {
		var shared = loggedIn.A;
		var isBuy = _Utils_eq(loggedIn._, sale.jX);
		var description = isBuy ? A2(
			shared.aw.i4,
			'notifications.saleHistory.buy',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$author$project$Eos$Account$nameToString(sale.lE)),
					_Utils_Tuple2('sale', sale.pi.fN)
				])) : A2(
			shared.aw.i4,
			'notifications.saleHistory.sell',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$author$project$Eos$Account$nameToString(sale.jX)),
					_Utils_Tuple2('sale', sale.pi.fN)
				]));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-col flex-grow-1 pl-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-black')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(description)
							])),
						A4(
						$author$project$View$Components$dateViewer,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-gray-900 text-sm uppercase')
							]),
						$elm$core$Basics$identity,
						shared,
						$author$project$Utils$fromDateTime(date))
					])),
				function () {
				var _v0 = sale.pi.h5;
				if (!_v0.b) {
					return $elm$html$Html$text('');
				} else {
					var firstImage = _v0.a;
					return A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(firstImage),
								$elm$html$Html$Attributes$class('object-scale-down rounded-full h-10 ml-4')
							]),
						_List_Nil);
				}
			}()
			]);
	});
var $author$project$Page$Notification$viewNotificationSaleHistory = F3(
	function (loggedIn, notification, sale) {
		var logoString = sale.pi.V.fe;
		var maybeLogo = $elm$core$String$isEmpty(logoString) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(logoString);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-start lg:items-center p-4'),
					$elm$html$Html$Events$onClick(
					A2(
						$author$project$Page$Notification$MarkAsRead,
						notification.w,
						$author$project$Page$Notification$S(sale)))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-none')
						]),
					_List_fromArray(
						[
							function () {
							if (!maybeLogo.$) {
								var logoUrl = maybeLogo.a;
								return A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10 h-10 object-scale-down'),
											$elm$html$Html$Attributes$src(logoUrl)
										]),
									_List_Nil);
							} else {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10 h-10 object-scale-down')
										]),
									_List_Nil);
							}
						}()
						])),
				A3($author$project$Page$Notification$viewNotificationSaleHistoryDetail, loggedIn, sale, notification.nL)));
	});
var $author$project$Page$Notification$T = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Notification$viewNotificationTransfer = F3(
	function (shared, history, notification) {
		var maybeLogo = $elm$core$String$isEmpty(notification.V.fe) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(notification.V.fe);
		var isReceive = !_Utils_eq(
			$author$project$Eos$Account$nameToString(history.pr),
			notification.jX);
		var description = isReceive ? A2(
			shared.aw.i4,
			'notifications.transfer.receive',
			_List_fromArray(
				[
					_Utils_Tuple2('user', notification.jX),
					_Utils_Tuple2(
					'amount',
					$elm$core$String$fromFloat(notification.ji))
				])) : A2(
			shared.aw.i4,
			'notifications.transfer.sent',
			_List_fromArray(
				[
					_Utils_Tuple2('user', notification.lE),
					_Utils_Tuple2(
					'amount',
					$elm$core$String$fromFloat(notification.ji))
				]));
		var amount = isReceive ? notification.ji : (notification.ji * (-1));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-start lg:items-center p-4'),
					$elm$html$Html$Events$onClick(
					A2(
						$author$project$Page$Notification$MarkAsRead,
						history.w,
						$author$project$Page$Notification$T(notification)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-none')
						]),
					_List_fromArray(
						[
							function () {
							if (!maybeLogo.$) {
								var logoUrl = maybeLogo.a;
								return A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10 h-10 object-scale-down'),
											$elm$html$Html$Attributes$src(logoUrl)
										]),
									_List_Nil);
							} else {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10 h-10 object-scale-down')
										]),
									_List_Nil);
							}
						}()
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-col flex-grow-1 pl-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								])),
							A4(
							$author$project$View$Components$dateViewer,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-900 text-sm uppercase')
								]),
							$elm$core$Basics$identity,
							shared,
							$author$project$Utils$fromDateTime(history.nL))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-none pl-4')
						]),
					A2($author$project$Page$Notification$viewAmount, amount, notification.as))
				]));
	});
var $author$project$Page$Notification$viewNotification = F2(
	function (loggedIn, notification) {
		var isReadIndicator = notification.nT ? '' : ' bg-orange-100 first:rounded-t-lg last:rounded-b-lg';
		var _v0 = notification.o4;
		switch (_v0.$) {
			case 0:
				var data = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('border-b last:border-b-0 border-gray-500 hover:bg-gray-100' + isReadIndicator)
						]),
					_List_fromArray(
						[
							A3($author$project$Page$Notification$viewNotificationTransfer, loggedIn.A, notification, data)
						]));
			case 2:
				var data = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('border-b last:border-b-0 border-gray-500 hover:bg-gray-100' + isReadIndicator)
						]),
					_List_fromArray(
						[
							A3($author$project$Page$Notification$viewNotificationMint, loggedIn.A, notification, data)
						]));
			default:
				var data = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('border-b last:border-b-0 border-gray-500 hover:bg-gray-100' + isReadIndicator)
						]),
					_List_fromArray(
						[
							A3($author$project$Page$Notification$viewNotificationSaleHistory, loggedIn, notification, data)
						]));
		}
	});
var $author$project$Page$Notification$viewNotifications = F2(
	function (loggedIn, notifications) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('shadow-md rounded-lg bg-white mt-5')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Page$Notification$viewNotification(loggedIn),
				notifications));
	});
var $author$project$Page$Notification$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var content = function () {
			if (!model.$) {
				return $author$project$Page$fullPageLoading(shared);
			} else {
				var notifications = model.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Page$viewHeader,
							loggedIn,
							shared.aw.fL('notifications.title')),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto px-4 mb-6')
								]),
							_List_fromArray(
								[
									_Utils_eq(notifications, _List_Nil) ? $author$project$Page$Notification$viewEmptyNotifications(loggedIn.A) : A2($author$project$Page$Notification$viewNotifications, loggedIn, notifications)
								]))
						]));
			}
		}();
		return {
			mJ: content,
			fN: shared.aw.fL('notifications.title')
		};
	});
var $author$project$Page$PaymentHistory$viewDatePicker = F2(
	function (shared, model) {
		return A3(
			$author$project$Form$DatePicker$view,
			$author$project$Page$PaymentHistory$datePickerOptions(shared),
			A2($author$project$Page$PaymentHistory$datePickerViewConfig, shared, model),
			$author$project$Page$PaymentHistory$GotDatePickerMsg);
	});
var $author$project$Page$PaymentHistory$viewSplash = function (p) {
	var name = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Eos$Account$nameToString(p.l8),
		p.fj);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-purple-500 bg-contain bg-center bg-no-repeat h-56 mb-6'),
				A2($elm$html$Html$Attributes$style, 'background-image', 'url(/images/cover_pic_payment_history.svg)')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-white text-center text-2xl pt-6')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					]))
			]));
};
var $author$project$Page$PaymentHistory$ShowMore = {$: 6};
var $author$project$Page$PaymentHistory$viewPagination = F2(
	function (shared, _v0) {
		var incomingTransfersPageInfo = _v0.cP;
		if (!incomingTransfersPageInfo.$) {
			var pi = incomingTransfersPageInfo.a;
			return pi.np ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pb-8')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button m-auto button-primary w-full sm:w-40'),
								$elm$html$Html$Events$onClick($author$project$Page$PaymentHistory$ShowMore)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								shared.aw.fL('payment_history.more'))
							]))
					])) : $elm$html$Html$text('');
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Emoji$alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
var $author$project$Emoji$alphabetEmojiMapper = function () {
	var emojis = '😄 😘 😺 🚀 🚗 🚙 🚚 🌀 🌟 🌴 🌵 🌷 🌸 🌹 🌺 🌻 🌼 🌽 🌿 🍁 🍄 🍅 🍆 🍇 🍈 🍉 🍊 🍌 🍍 🍎 🍏 🍑 🍒 🍓 🍭 🍯 🎀 🎃 🎈 🎨 🎲 🎸 🏡 🐌 🐒 🐚 🐞 🐬 🐱 🐲 🐳 🐴 🐵 🐶 🐸 🐹 💜 😎 🚘 🌳 🍋 🍐';
	return $elm$core$Dict$fromList(
		A3(
			$elm$core$List$map2,
			$elm$core$Tuple$pair,
			A2($elm$core$String$split, '', $author$project$Emoji$alphabet),
			A2($elm$core$String$split, ' ', emojis)));
}();
var $author$project$Transfer$createdTxToString = function (_v0) {
	var tx = _v0;
	return tx;
};
var $pdamoc$elm_hashids$Hashids$ordOfIdx = F2(
	function (i, str) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Char$toCode,
				$elm$core$List$head(
					$elm$core$String$toList(
						A2($elm$core$String$dropLeft, i, str)))));
	});
var $pdamoc$elm_hashids$Hashids$forceGet = F2(
	function (i, axs) {
		return A2(
			$elm$core$Maybe$withDefault,
			' ',
			A2($elm$core$Array$get, i, axs));
	});
var $pdamoc$elm_hashids$Hashids$swap = F3(
	function (i, j, str) {
		var strArray = $elm$core$Array$fromList(
			$elm$core$String$toList(str));
		var jElem = A2($pdamoc$elm_hashids$Hashids$forceGet, j, strArray);
		var iElem = A2($pdamoc$elm_hashids$Hashids$forceGet, i, strArray);
		return $elm$core$String$fromList(
			$elm$core$Array$toList(
				A3(
					$elm$core$Array$set,
					j,
					iElem,
					A3($elm$core$Array$set, i, jElem, strArray))));
	});
var $pdamoc$elm_hashids$Hashids$reorder = F2(
	function (string, salt) {
		var saltLen = $elm$core$String$length(salt);
		var saltArray = $elm$core$Array$fromList(
			$elm$core$String$toList(salt));
		var shuffle = F4(
			function (i, index, integerSum, str) {
				shuffle:
				while (true) {
					if (i > 0) {
						var newIndex = A2($elm$core$Basics$modBy, saltLen, index);
						var integer = $elm$core$Char$toCode(
							A2($pdamoc$elm_hashids$Hashids$forceGet, newIndex, saltArray));
						var newIntegerSum = integerSum + integer;
						var j = A2($elm$core$Basics$modBy, i, (integer + newIndex) + newIntegerSum);
						var newStr = A3($pdamoc$elm_hashids$Hashids$swap, i, j, str);
						var $temp$i = i - 1,
							$temp$index = newIndex + 1,
							$temp$integerSum = newIntegerSum,
							$temp$str = newStr;
						i = $temp$i;
						index = $temp$index;
						integerSum = $temp$integerSum;
						str = $temp$str;
						continue shuffle;
					} else {
						return str;
					}
				}
			});
		var alphaLen = $elm$core$String$length(string);
		return (!saltLen) ? string : A4(shuffle, alphaLen - 1, 0, 0, string);
	});
var $pdamoc$elm_hashids$Hashids$strGet = F2(
	function (i, str) {
		return A2(
			$elm$core$String$left,
			1,
			A2($elm$core$String$dropLeft, i, str));
	});
var $pdamoc$elm_hashids$Hashids$ensureLength = F5(
	function (encoded, minHashLength, alphabet, guards, valuesHash) {
		var splitAt = ($elm$core$String$length(alphabet) / 2) | 0;
		var guardsLen = $elm$core$String$length(guards);
		var guardIndex = A2(
			$elm$core$Basics$modBy,
			guardsLen,
			valuesHash + A2($pdamoc$elm_hashids$Hashids$ordOfIdx, 0, encoded));
		var extend = F2(
			function (encoded_, alpha) {
				extend:
				while (true) {
					var alpha1 = A2($pdamoc$elm_hashids$Hashids$reorder, alpha, alpha);
					var encodedPre = _Utils_ap(
						A2($elm$core$String$dropLeft, splitAt, alpha1),
						_Utils_ap(
							encoded_,
							A2($elm$core$String$left, splitAt, alpha1)));
					var excess = $elm$core$String$length(encodedPre) - minHashLength;
					var fromIndex = (excess / 2) | 0;
					var encoded1 = (excess > 0) ? A2(
						$elm$core$String$left,
						minHashLength,
						A2($elm$core$String$dropLeft, fromIndex, encodedPre)) : encodedPre;
					if (_Utils_cmp(
						$elm$core$String$length(encoded1),
						minHashLength) < 0) {
						var $temp$encoded_ = encoded1,
							$temp$alpha = alpha1;
						encoded_ = $temp$encoded_;
						alpha = $temp$alpha;
						continue extend;
					} else {
						return encoded1;
					}
				}
			});
		var acc = _Utils_ap(
			A2($pdamoc$elm_hashids$Hashids$strGet, guardIndex, guards),
			encoded);
		var guardIndex1 = A2(
			$elm$core$Basics$modBy,
			guardsLen,
			valuesHash + A2($pdamoc$elm_hashids$Hashids$ordOfIdx, 2, acc));
		var acc1 = (_Utils_cmp(
			$elm$core$String$length(acc),
			minHashLength) < 0) ? _Utils_ap(
			acc,
			A2($pdamoc$elm_hashids$Hashids$strGet, guardIndex1, guards)) : acc;
		return A2(extend, acc1, alphabet);
	});
var $pdamoc$elm_hashids$Hashids$encodeList = F2(
	function (context, numbers) {
		var valuesHash = $elm$core$List$sum(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, n) {
						return A2($elm$core$Basics$modBy, i + 100, n);
					}),
				numbers));
		var _v0 = context;
		var guards = _v0.gy;
		var seps = _v0.hb;
		var salt = _v0.g8;
		var minHashLength = _v0.gU;
		var alphabet = _v0.f1;
		var alphaLen = $elm$core$String$length(alphabet);
		var hash = F3(
			function (value, alpha, acc) {
				hash:
				while (true) {
					var value1 = (value / alphaLen) | 0;
					var alphaLen_ = $elm$core$String$length(alpha);
					var acc1 = _Utils_ap(
						A2(
							$pdamoc$elm_hashids$Hashids$strGet,
							A2($elm$core$Basics$modBy, alphaLen_, value),
							alpha),
						acc);
					if (!value1) {
						return acc1;
					} else {
						var $temp$value = value1,
							$temp$alpha = alpha,
							$temp$acc = acc1;
						value = $temp$value;
						alpha = $temp$alpha;
						acc = $temp$acc;
						continue hash;
					}
				}
			});
		var lottery = A2(
			$pdamoc$elm_hashids$Hashids$strGet,
			A2($elm$core$Basics$modBy, alphaLen, valuesHash),
			alphabet);
		var sepsLen = $elm$core$String$length(seps);
		var go = F2(
			function (_v2, _v3) {
				var i = _v2.a;
				var value = _v2.b;
				var acc = _v3.a;
				var alpha = _v3.b;
				var alphaSalt = A2(
					$elm$core$String$left,
					alphaLen,
					_Utils_ap(
						lottery,
						_Utils_ap(salt, alpha)));
				var alpha1_ = A2($pdamoc$elm_hashids$Hashids$reorder, alpha, alphaSalt);
				var last = A3(hash, value, alpha1_, '');
				var firstCode = A2($pdamoc$elm_hashids$Hashids$ordOfIdx, 0, last);
				var value1 = A2($elm$core$Basics$modBy, firstCode + i, value);
				var sepEnc = A2(
					$pdamoc$elm_hashids$Hashids$strGet,
					A2($elm$core$Basics$modBy, sepsLen, value1),
					seps);
				return _Utils_Tuple2(
					_Utils_ap(
						acc,
						_List_fromArray(
							[
								_Utils_ap(last, sepEnc)
							])),
					alpha1_);
			});
		var _v1 = A3(
			$elm$core$List$foldl,
			go,
			_Utils_Tuple2(
				_List_fromArray(
					[lottery]),
				alphabet),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (a, b) {
						return _Utils_Tuple2(a, b);
					}),
				numbers));
		var encodedList = _v1.a;
		var alpha1 = _v1.b;
		var encodedPre = $elm$core$String$concat(encodedList);
		var encoded = A2($elm$core$String$dropRight, 1, encodedPre);
		return (_Utils_cmp(
			$elm$core$String$length(encoded),
			minHashLength) > -1) ? encoded : A5($pdamoc$elm_hashids$Hashids$ensureLength, encoded, minHashLength, alpha1, guards, valuesHash);
	});
var $pdamoc$elm_hashids$Hashids$encode = F2(
	function (context, n) {
		return A2(
			$pdamoc$elm_hashids$Hashids$encodeList,
			context,
			_List_fromArray(
				[n]));
	});
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {dp: charsProcessed, dJ: hash, c5: seed, ek: shift};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.dJ)) ? (data.c5 ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.dJ)))) : data.c5;
	var h0 = acc ^ data.dp;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.dJ | ((255 & $elm$core$Char$toCode(c)) << data.ek);
		var _v0 = data.ek;
		if (_v0 === 24) {
			return {
				dp: data.dp + 1,
				dJ: 0,
				c5: A2($robinheghan$murmur3$Murmur3$mix, data.c5, res),
				ek: 0
			};
		} else {
			return {dp: data.dp + 1, dJ: res, c5: data.c5, ek: data.ek + 8};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $pdamoc$elm_hashids$Hashids$defaultAlphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
var $pdamoc$elm_hashids$Hashids$containsChar = A2($elm$core$Basics$composeL, $elm$core$String$contains, $elm$core$String$fromChar);
var $pdamoc$elm_hashids$Hashids$exclude = F2(
	function (toBeExcluded, from) {
		var member = function (c) {
			return !A2($pdamoc$elm_hashids$Hashids$containsChar, c, toBeExcluded);
		};
		return A2($elm$core$String$filter, member, from);
	});
var $pdamoc$elm_hashids$Hashids$intersect = F2(
	function (first, second) {
		var member = function (c) {
			return A2($pdamoc$elm_hashids$Hashids$containsChar, c, second);
		};
		return A2($elm$core$String$filter, member, first);
	});
var $pdamoc$elm_hashids$Hashids$unique = function (str) {
	var addIfNotMember = F2(
		function (c, xs) {
			return A2($pdamoc$elm_hashids$Hashids$containsChar, c, xs) ? xs : A2($elm$core$String$cons, c, xs);
		});
	return A3($elm$core$String$foldr, addIfNotMember, '', str);
};
var $pdamoc$elm_hashids$Hashids$createHashidsContext = F3(
	function (salt, minHashLen, alphabet) {
		var sepDiv = 3.5;
		var validSeps = function (_v3) {
			var seps = _v3.a;
			var alpha = _v3.b;
			var seps1 = A2($pdamoc$elm_hashids$Hashids$reorder, seps, salt);
			var lenSeps = $elm$core$String$length(seps1);
			var lenAlpha = $elm$core$String$length(alpha);
			var minSeps = $elm$core$Basics$ceiling(lenAlpha / sepDiv);
			if (_Utils_cmp(lenSeps, minSeps) < 0) {
				var minSeps1 = (minSeps === 1) ? 2 : minSeps;
				if (_Utils_cmp(minSeps1, lenSeps) > 0) {
					var splitAt = minSeps1 - lenSeps;
					var seps2 = _Utils_ap(
						seps1,
						A2($elm$core$String$left, splitAt, alpha));
					var alpha1 = A2($elm$core$String$dropLeft, splitAt, alpha);
					return _Utils_Tuple2(seps2, alpha1);
				} else {
					return _Utils_Tuple2(seps1, alpha);
				}
			} else {
				return _Utils_Tuple2(seps1, alpha);
			}
		};
		var minAlphabetLength = 16;
		var guardDiv = 12;
		var withGuard = function (_v2) {
			var seps = _v2.a;
			var alpha = _v2.b;
			var lenAlpha = $elm$core$String$length(alpha);
			var numGuards = $elm$core$Basics$ceiling(lenAlpha / guardDiv);
			var alpha1 = A2($pdamoc$elm_hashids$Hashids$reorder, alpha, salt);
			return (lenAlpha < 3) ? _Utils_Tuple3(
				A2($elm$core$String$dropLeft, numGuards, seps),
				alpha1,
				A2($elm$core$String$left, numGuards, seps)) : _Utils_Tuple3(
				seps,
				A2($elm$core$String$dropLeft, numGuards, alpha1),
				A2($elm$core$String$left, numGuards, alpha1));
		};
		var clean = function (alpha) {
			var seps = 'cfhistuCFHISTU';
			var seps1 = A2($pdamoc$elm_hashids$Hashids$intersect, seps, alpha);
			var hasSpaces = A2($elm$core$String$contains, ' ', alpha);
			var alpha1 = A2(
				$pdamoc$elm_hashids$Hashids$exclude,
				seps1,
				$pdamoc$elm_hashids$Hashids$unique(alpha));
			var alphabetIsSmall = _Utils_cmp(
				$elm$core$String$length(
					_Utils_ap(alpha1, seps1)),
				minAlphabetLength) < 0;
			var _v1 = _Utils_Tuple2(hasSpaces, alphabetIsSmall);
			if (_v1.a) {
				return _Utils_Tuple2(
					seps,
					A2($pdamoc$elm_hashids$Hashids$exclude, seps, $pdamoc$elm_hashids$Hashids$defaultAlphabet));
			} else {
				if (_v1.b) {
					return _Utils_Tuple2(
						seps,
						A2($pdamoc$elm_hashids$Hashids$exclude, seps, $pdamoc$elm_hashids$Hashids$defaultAlphabet));
				} else {
					return _Utils_Tuple2(seps1, alpha1);
				}
			}
		};
		var _v0 = withGuard(
			validSeps(
				clean(alphabet)));
		var seps1b = _v0.a;
		var alphabet1 = _v0.b;
		var guards = _v0.c;
		return {f1: alphabet1, gy: guards, gU: minHashLen, g8: salt, hb: seps1b};
	});
var $author$project$Emoji$salt = 123456;
var $author$project$Emoji$hashidsCtx = A3(
	$pdamoc$elm_hashids$Hashids$createHashidsContext,
	$elm$core$String$fromInt($author$project$Emoji$salt),
	8,
	$author$project$Emoji$alphabet);
var $author$project$Emoji$encode = function (transferId) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			function (n) {
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Dict$get, n, $author$project$Emoji$alphabetEmojiMapper));
			},
			A2(
				$elm$core$String$split,
				'',
				A2(
					$pdamoc$elm_hashids$Hashids$encode,
					$author$project$Emoji$hashidsCtx,
					A2(
						$robinheghan$murmur3$Murmur3$hashString,
						$author$project$Emoji$salt,
						$author$project$Transfer$createdTxToString(transferId))))));
};
var $author$project$Page$PaymentHistory$viewTransfer = F2(
	function (shared, payment) {
		var time = A3(
			$thaterikperson$elm_strftime$Strftime$format,
			'%d %b %Y, %H:%M',
			shared.i2,
			$author$project$Utils$fromMaybeDateTime(
				$elm$core$Maybe$Just(payment.f5)));
		var payer = payment.e_;
		var userName = $author$project$Eos$Account$nameToString(payer.l8);
		var avatarImg = A2($author$project$Avatar$view, payer.dl, 'max-w-full max-h-full');
		var amount = $elm$core$String$concat(
			_List_fromArray(
				[
					$elm$core$String$fromFloat(payment.lW),
					' ',
					$author$project$Eos$symbolToSymbolCodeString(payment.V.as)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-gray-100 text-center py-6 my-6 rounded-lg')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rounded-full m-auto overflow-hidden border-white border-2 bg-grey w-14 h-14')
						]),
					_List_fromArray(
						[avatarImg])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black mt-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(userName)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('uppercase text-gray-900 text-sm my-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(time)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-green text-4xl my-3')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(amount)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tracking-widest text-2xl')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Emoji$encode(payment.mQ))
						]))
				]));
	});
var $author$project$Page$PaymentHistory$viewTransfers = F2(
	function (shared, model) {
		var _v0 = model.cO;
		if (!_v0.$) {
			var transfers = _v0.a;
			return $elm$core$List$isEmpty(transfers) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center my-6')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						shared.aw.fL('payment_history.no_transfers_found'))
					])) : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pb-6')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Page$PaymentHistory$viewTransfer(shared),
							transfers)),
						A2($author$project$Page$PaymentHistory$viewPagination, shared, model)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center h-48')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('m-auto spinner')
							]),
						_List_Nil),
						$elm$html$Html$text(
						shared.aw.fL('menu.loading'))
					]));
		}
	});
var $author$project$Page$PaymentHistory$viewUserAutocomplete = F2(
	function (loggedIn, model) {
		return A3(
			$author$project$Form$UserPicker$view,
			A2($author$project$Page$PaymentHistory$userPickerOptions, loggedIn, model.eD),
			A2($author$project$Page$PaymentHistory$userPickerViewConfig, loggedIn.A, model),
			$author$project$Page$PaymentHistory$GotUserPickerMsg);
	});
var $author$project$Page$PaymentHistory$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var pageTitle = shared.aw.fL('payment_history.title');
		var content = function () {
			var _v0 = model.fv;
			switch (_v0.$) {
				case 1:
					var profile = _v0.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-white')
							]),
						_List_fromArray(
							[
								$author$project$Page$PaymentHistory$viewSplash(profile),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mx-4 max-w-md md:m-auto')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h2,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-center text-black text-2xl')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												shared.aw.fL('payment_history.title'))
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Page$PaymentHistory$viewUserAutocomplete, loggedIn, model),
												A2($author$project$Page$PaymentHistory$viewDatePicker, shared, model)
											])),
										A2($author$project$Page$PaymentHistory$viewTransfers, shared, model)
									]))
							]));
				case 2:
					var err = _v0.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Page$fullPageGraphQLError,
								shared.aw.fL('error.accountNotFound'),
								err)
							]));
				default:
					return $author$project$Page$fullPageLoading(shared);
			}
		}();
		return {mJ: content, fN: pageTitle};
	});
var $author$project$Page$Profile$BalanceError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$GraphqlError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Profile$ProfileError = function (a) {
	return {$: 0, a: a};
};
var $krisajenkins$remotedata$RemoteData$map3 = F4(
	function (f, a, b, c) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andMap,
			c,
			A2(
				$krisajenkins$remotedata$RemoteData$andMap,
				b,
				A2($krisajenkins$remotedata$RemoteData$map, f, a)));
	});
var $author$project$Page$Profile$Center = 1;
var $author$project$Page$Profile$Top = 0;
var $author$project$Page$Profile$viewDetailsItem = F3(
	function (label, content, verticalAlign) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('items-start', !verticalAlign),
									_Utils_Tuple2('items-center', verticalAlign === 1)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-sm mr-4')
								]),
							_List_fromArray(
								[label])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-indigo-500 font-semibold text-sm text-right')
								]),
							_List_fromArray(
								[content]))
						]))
				]));
	});
var $author$project$Page$Profile$viewAddress = F2(
	function (_v0, address) {
		var t = _v0.fL;
		var fullAddress = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
							_List_fromArray(
								[address.mP, address.Z, address.mt, address.op, address.fK, address.d2])))),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					$elm$html$Html$text(address.fY)
				]));
		return A3(
			$author$project$Page$Profile$viewDetailsItem,
			$elm$html$Html$text(
				t('Address')),
			fullAddress,
			0);
	});
var $elm$svg$Svg$Attributes$strokeMiterlimit = _VirtualDom_attribute('stroke-miterlimit');
var $author$project$Icons$coin = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('30'),
				$elm$svg$Svg$Attributes$height('43'),
				$elm$svg$Svg$Attributes$viewBox('0 0 30 43'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M30 21.1577C30 32.8414 23.284 42.3154 15 42.3154C6.71602 42.3154 0 32.8414 0 21.1577C0 9.47402 6.71602 -2.09352e-08 15 -2.09352e-08C23.284 -2.09352e-08 30 9.47402 30 21.1577Z'),
						$elm$svg$Svg$Attributes$fill('#FFD200')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M24.4496 21.1577C24.4496 28.5224 20.2169 34.4911 14.9977 34.4911C9.77845 34.4911 5.54567 28.5224 5.54567 21.1577C5.54567 13.7929 9.77845 7.82425 14.9977 7.82425C20.2169 7.82425 24.4496 13.7929 24.4496 21.1577Z'),
						$elm$svg$Svg$Attributes$stroke('#228C98'),
						$elm$svg$Svg$Attributes$strokeWidth('0.33'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.31065 6.43094C5.08605 7.5261 6.46263 9.46776 8.15574 11.859'),
						$elm$svg$Svg$Attributes$stroke('#228C98'),
						$elm$svg$Svg$Attributes$strokeWidth('0.33'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M21.5914 30.8027C23.417 33.3774 24.8402 35.3868 25.4929 36.3062'),
						$elm$svg$Svg$Attributes$stroke('#228C98'),
						$elm$svg$Svg$Attributes$strokeWidth('0.33'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.22958 36.0008C4.99517 34.9207 6.42818 32.9012 8.20717 30.3894'),
						$elm$svg$Svg$Attributes$stroke('#228C98'),
						$elm$svg$Svg$Attributes$strokeWidth('0.33'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M21.6439 11.4425C23.3713 9.00598 24.7332 7.08441 25.4129 6.12488'),
						$elm$svg$Svg$Attributes$stroke('#228C98'),
						$elm$svg$Svg$Attributes$strokeWidth('0.33'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Community$currencyTranslationKey = function (_v0) {
	var amount = _v0.ji;
	var currency = _v0.jA;
	var baseTranslation = function () {
		switch (currency) {
			case 0:
				return 'currency.brl';
			case 1:
				return 'currency.btc';
			case 2:
				return 'currency.crc';
			case 3:
				return 'currency.eos';
			case 4:
				return 'currency.eth';
			default:
				return 'currency.usd';
		}
	}();
	return (amount === 1) ? (baseTranslation + '_singular') : (baseTranslation + '_plural');
};
var $author$project$Page$Profile$viewHistory = F4(
	function (shared, balance, graphqlInfo, maybeContributionInfo) {
		var viewHistoryItem = F3(
			function (title, number, translation) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center py-4 text-sm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center')
								]),
							title),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-auto')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mr-1 text-indigo-500 font-bold')
										]),
									_List_fromArray(
										[number])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-sm text-gray-900 uppercase')
										]),
									_List_fromArray(
										[translation]))
								]))
						]));
			});
		var _v0 = shared.aw;
		var t = _v0.fL;
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, t);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white px-4 mb-6 md:bg-gray-100')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto w-full self-center divide-y divide-gray-500')
						]),
					_List_fromArray(
						[
							A3(
							viewHistoryItem,
							_List_fromArray(
								[
									$author$project$Icons$coin('mr-2'),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											text_('profile.history.balance')
										]))
								]),
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-3xl mr-1')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A3($author$project$Eos$formatSymbolAmount, shared.aw, balance.mk.as, balance.mk.ji))
									])),
							$elm$html$Html$text(
								$author$project$Eos$symbolToSymbolCodeString(balance.mk.as))),
							function () {
							if (maybeContributionInfo.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var contributionInfo = maybeContributionInfo.a;
								return A3(
									viewHistoryItem,
									_List_fromArray(
										[
											text_('dashboard.my_contributions')
										]),
									$elm$html$Html$text(
										A3(
											$author$project$Utils$formatFloat,
											$elm$core$Maybe$Just(shared.aw),
											2,
											contributionInfo.ji)),
									text_(
										$author$project$Community$currencyTranslationKey(contributionInfo)));
							}
						}(),
							A3(
							viewHistoryItem,
							_List_fromArray(
								[
									text_('profile.history.transfers_number')
								]),
							$elm$html$Html$text(
								$elm$core$String$fromInt(graphqlInfo.lJ)),
							text_('profile.history.transfers')),
							A3(
							viewHistoryItem,
							_List_fromArray(
								[
									text_('profile.history.claims_number')
								]),
							$elm$html$Html$text(
								$elm$core$String$fromInt(graphqlInfo.lH)),
							text_('profile.history.claims')),
							A3(
							viewHistoryItem,
							_List_fromArray(
								[
									text_('profile.history.products')
								]),
							$elm$html$Html$text(
								$elm$core$String$fromInt(graphqlInfo.lI)),
							text_('profile.history.items')),
							function () {
							var _v2 = graphqlInfo.hM;
							if (!_v2.$) {
								var createdDate = _v2.a;
								return A3(
									viewHistoryItem,
									_List_fromArray(
										[
											text_('profile.history.registration_date')
										]),
									A4(
										$author$project$View$Components$dateViewer,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('capitalize -mr-1')
											]),
										$elm$core$Basics$identity,
										shared,
										createdDate),
									$elm$html$Html$text(''));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A3(
							viewHistoryItem,
							_List_fromArray(
								[
									text_('profile.history.last_transaction')
								]),
							A4(
								$author$project$View$Components$dateViewer,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('capitalize -mr-1')
									]),
								$elm$core$Basics$identity,
								shared,
								balance.n1),
							$elm$html$Html$text(''))
						]))
				]));
	});
var $author$project$Page$Profile$viewKycInfo = function (kyc) {
	var documentLabel = function () {
		var _v0 = kyc.eU;
		switch (_v0) {
			case 'cedula_de_identidad':
				return 'Cédula de identidad';
			case 'dimex':
				return 'DIMEX';
			case 'nite':
				return 'NITE';
			case 'gran_empresa':
				return 'Gran Empresa';
			case 'mipyme':
				return 'MIPYME';
			default:
				return 'Unknown Document';
		}
	}();
	return A3(
		$author$project$Page$Profile$viewDetailsItem,
		$elm$html$Html$text(documentLabel),
		$elm$html$Html$text(kyc.eT),
		1);
};
var $author$project$Page$Profile$RequestedMoreTransfers = {$: 8};
var $author$project$View$Components$TrackSelector = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$viewCardEmpty = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('rounded-lg bg-white mt-5 p-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-white-smoke flex items-center justify-center p-8')
					]),
				content)
			]));
};
var $author$project$Page$Profile$ClickedTransferCard = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Profile$GotTransferCardProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Transfer$view = F6(
	function (loggedIn, transfer, profileSummary, profileSummaryToMsg, onClickMsg, attrs) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var _v1 = _Utils_eq(transfer.e_.l8, loggedIn._) ? _Utils_Tuple2(transfer.fO, true) : _Utils_Tuple2(transfer.e_, false);
		var otherProfile = _v1.a;
		var isFromUser = _v1.b;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('flex hover:bg-gray-100 p-4 cursor-pointer'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(onClickMsg),
					attrs)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					profileSummaryToMsg,
					A4(
						$author$project$Profile$Summary$view,
						loggedIn.A.aw,
						loggedIn._,
						otherProfile,
						A2(
							$author$project$Profile$Summary$withImageSize,
							'w-14 h-14',
							$author$project$Profile$Summary$withoutName(profileSummary)))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-4 w-full overflow-ellipsis overflow-hidden')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-sm flex flex-wrap'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('text-gray-333', isFromUser),
											_Utils_Tuple2('text-indigo-500', !isFromUser)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mr-1')
										]),
									_List_fromArray(
										[
											isFromUser ? $elm$html$Html$text(
											t('transfer.sent_to')) : $elm$html$Html$text(
											t('transfer.received_from'))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$Eos$Account$nameToString(otherProfile.l8),
												otherProfile.fj))
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('text-gray-333', isFromUser),
											_Utils_Tuple2('text-indigo-500', !isFromUser)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold text-lg')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3($author$project$Eos$formatSymbolAmount, loggedIn.A.aw, transfer.V.as, transfer.lW))
										])),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-sm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Eos$symbolToSymbolCodeString(transfer.V.as))
										]))
								])),
							function () {
							var _v2 = transfer.kE;
							if (_v2.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var memo = _v2.a;
								return A2(
									$author$project$Markdown$view,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-sm text-gray-900 break-all')
										]),
									memo);
							}
						}()
						]))
				]));
	});
var $author$project$Page$Profile$viewTransactionList = F2(
	function (loggedIn, transfers) {
		return A2(
			$elm$core$List$map,
			function (_v2) {
				var first = _v2.a;
				var t1 = first.a;
				var rest = _v2.b;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-4')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$View$Components$dateViewer,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('uppercase text-sm text-black tracking-wide')
										]),
									$elm$core$Basics$identity,
									loggedIn.A,
									$author$project$Utils$fromDateTime(t1.f5))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('divide-y divide-gray-500')
								]),
							A2(
								$elm$core$List$map,
								function (_v3) {
									var transfer = _v3.a;
									var profileSummary = _v3.b;
									return A6(
										$author$project$Transfer$view,
										loggedIn,
										transfer,
										A2(
											$author$project$Profile$Summary$withScrollSelector,
											'#transfer-scroll-container',
											A2($author$project$Profile$Summary$withRelativeSelector, '#transfer-relative-container', profileSummary)),
										$author$project$Page$Profile$GotTransferCardProfileSummaryMsg(transfer.w),
										$author$project$Page$Profile$ClickedTransferCard(transfer.w),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('md:hover:bg-gray-200')
											]));
								},
								A2($elm$core$List$cons, first, rest)))
						]));
			},
			A2(
				$elm_community$list_extra$List$Extra$groupWhile,
				F2(
					function (_v0, _v1) {
						var t1 = _v0.a;
						var t2 = _v1.a;
						return A3(
							$author$project$Utils$areSameDay,
							loggedIn.A.i2,
							$author$project$Utils$fromDateTime(t1.f5),
							$author$project$Utils$fromDateTime(t2.f5));
					}),
				transfers));
	});
var $author$project$Page$Profile$viewLatestTransactions = F2(
	function (loggedIn, model) {
		var viewInfiniteList = F2(
			function (maybePageInfo, children) {
				var viewList = function (isMobile) {
					return A3(
						$author$project$View$Components$infiniteList,
						{
							m$: 1000,
							m6: isMobile ? $author$project$View$Components$TrackWindow : $author$project$View$Components$TrackSelector('#transfer-scroll-container'),
							oP: A2(
								$elm$core$Maybe$andThen,
								function (pageInfo) {
									return pageInfo.np ? $elm$core$Maybe$Just($author$project$Page$Profile$RequestedMoreTransfers) : $elm$core$Maybe$Nothing;
								},
								maybePageInfo)
						},
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full mt-2 divide-y divide-gray-500'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('hidden md:block', !isMobile),
										_Utils_Tuple2('md:hidden', isMobile)
									]))
							]),
						children);
				};
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							viewList(true),
							viewList(false)
						]));
			});
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, loggedIn.A.aw.fL);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('p-4 bg-white max-w-screen md:px-3 md:bg-transparent')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto w-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-lg')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-900 font-light')
										]),
									_List_fromArray(
										[
											text_('transfer.transfers_latest')
										])),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-indigo-500 font-semibold')
										]),
									_List_fromArray(
										[
											text_('transfer.transfers')
										]))
								])),
							function () {
							var _v0 = model.a1;
							switch (_v0.$) {
								case 2:
									return $author$project$Page$viewCardEmpty(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-gray-900 text-sm')
													]),
												_List_fromArray(
													[
														text_('transfer.loading_error')
													]))
											]));
								case 1:
									var transfers = _v0.a;
									return A2(
										viewInfiniteList,
										$elm$core$Maybe$Nothing,
										_Utils_ap(
											A2($author$project$Page$Profile$viewTransactionList, loggedIn, transfers),
											_List_fromArray(
												[
													A2($author$project$View$Components$loadingLogoAnimated, loggedIn.A.aw, '')
												])));
								default:
									var transfers = _v0.a;
									var maybePageInfo = _v0.b;
									return A2(
										viewInfiniteList,
										maybePageInfo,
										A2($author$project$Page$Profile$viewTransactionList, loggedIn, transfers));
							}
						}()
						]))
				]));
	});
var $author$project$Page$Profile$viewDetails = F5(
	function (loggedIn, profile, balance, graphqlInfo, model) {
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, loggedIn.A.aw.fL);
		var isProfileOwner = _Utils_eq(loggedIn._, profile.l8);
		var isCommunityAdmin = function () {
			var _v2 = loggedIn.pC;
			if (_v2.$ === 3) {
				var community = _v2.a;
				return _Utils_eq(community.jz, loggedIn._);
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-gray-100 w-full md:flex md:flex-col')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('md:flex-basis-0 md:flex-grow-1 md:overflow-y-auto'),
							$elm$html$Html$Attributes$id('transfer-scroll-container'),
							$elm$html$Html$Attributes$tabindex(-1)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full bg-white md:bg-gray-100')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('px-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$ul,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('container mx-auto divide-y divide-gray-500 w-full mb-4 bg-white md:bg-gray-100')
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Page$Profile$viewDetailsItem,
													text_('profile.locations'),
													$elm$html$Html$text(
														A2($elm$core$Maybe$withDefault, '', profile.n9)),
													1),
													function () {
													var _v0 = profile.ht;
													if (!_v0.$) {
														var address = _v0.a;
														return A2($author$project$Page$Profile$viewAddress, loggedIn.A.aw, address);
													} else {
														return $elm$html$Html$text('');
													}
												}(),
													A3(
													$author$project$Page$Profile$viewDetailsItem,
													text_('profile.interests'),
													$elm$html$Html$text(
														A2($elm$core$String$join, ', ', profile.dN)),
													0),
													isProfileOwner ? A3(
													$author$project$Page$Profile$viewDetailsItem,
													text_('contact_form.options'),
													A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('button-secondary button-sm uppercase cursor-pointer'),
																$author$project$Route$href($author$project$Route$ProfileAddContact)
															]),
														_List_fromArray(
															[
																$elm$core$List$isEmpty(profile.az) ? text_('menu.add') : text_('menu.edit')
															])),
													1) : $elm$html$Html$text(''),
													function () {
													if (isProfileOwner) {
														var _v1 = profile.ib;
														if (!_v1.$) {
															var kyc = _v1.a;
															return $author$project$Page$Profile$viewKycInfo(kyc);
														} else {
															return $elm$html$Html$text('');
														}
													} else {
														return $elm$html$Html$text('');
													}
												}()
												]))
										]))
								])),
							(isProfileOwner || isCommunityAdmin) ? A4($author$project$Page$Profile$viewHistory, loggedIn.A, balance, graphqlInfo, model.gf) : $elm$html$Html$text(''),
							(isProfileOwner || isCommunityAdmin) ? A2($author$project$Page$Profile$viewLatestTransactions, loggedIn, model) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Eos$Explorer$Profile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Profile$Contact$contactTypeTextColor = function (contactType) {
	switch (contactType) {
		case 3:
			return 'text-phone';
		case 1:
			return 'text-instagram';
		case 4:
			return 'text-telegram';
		case 5:
			return 'text-whatsapp';
		case 0:
			return 'text-orange-300';
		default:
			return 'text-orange-300';
	}
};
var $author$project$Eos$Explorer$baseUrl = 'https://local.bloks.io';
var $author$project$Eos$Explorer$coreSymbol = function (environment) {
	switch (environment) {
		case 0:
			return 'SYS';
		case 1:
			return 'SYS';
		case 2:
			return 'SYS';
		default:
			return 'EOS';
	}
};
var $author$project$Eos$Explorer$nodeUrl = function (environment) {
	switch (environment) {
		case 0:
			return 'https://staging.cambiatus.io';
		case 1:
			return 'https://staging.cambiatus.io';
		case 2:
			return 'https://demo.cambiatus.io';
		default:
			return 'https://app.cambiatus.io';
	}
};
var $author$project$Eos$Explorer$path = function (subject) {
	if (!subject.$) {
		var accountName = subject.a;
		return _List_fromArray(
			[
				'account',
				$author$project$Eos$Account$nameToString(accountName)
			]);
	} else {
		var createdTx = subject.a;
		return _List_fromArray(
			[
				'transaction',
				$author$project$Transfer$createdTxToString(createdTx)
			]);
	}
};
var $author$project$Eos$Explorer$link = F2(
	function (environment, subject) {
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			$author$project$Eos$Explorer$baseUrl,
			$author$project$Eos$Explorer$path(subject),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'nodeUrl',
					$author$project$Eos$Explorer$nodeUrl(environment)),
					A2($elm$url$Url$Builder$string, 'systemDomain', 'eosio'),
					A2(
					$elm$url$Url$Builder$string,
					'coreSymbol',
					$author$project$Eos$Explorer$coreSymbol(environment))
				]));
	});
var $author$project$Page$Profile$viewProfile = F2(
	function (loggedIn, profile) {
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, loggedIn.A.aw.fL);
		var isProfileOwner = _Utils_eq(loggedIn._, profile.l8);
		var email = A2($elm$core$Maybe$withDefault, '', profile.jK);
		var blockExplorerButton = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button w-full mt-4'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('button-primary', isProfileOwner),
							_Utils_Tuple2('button-secondary', !isProfileOwner)
						])),
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$href(
					A2(
						$author$project$Eos$Explorer$link,
						loggedIn.A.m8,
						$author$project$Eos$Explorer$Profile(profile.l8)))
				]),
			_List_fromArray(
				[
					text_('block_explorer.see')
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white border-white border-r w-full flex md:border-gray-500')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full p-4 max-w-screen container mx-auto self-center md:max-w-lg')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pb-4 w-full')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-wrap items-center justify-center mb-4')
										]),
									_List_fromArray(
										[
											A2($author$project$Avatar$view, profile.dl, 'w-20 h-20 mr-6 xs-max:w-16 xs-max:h-16 xs-max:mr-3'),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-grow items-center justify-between')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-sm text-gray-900')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('font-semibold text-body-black text-2xl xs-max:text-xl')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($elm$core$Maybe$withDefault, '', profile.fj))
																])),
															A2(
															$elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$a,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$href('mailto:' + email)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(email)
																		]))
																])),
															A2(
															$elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Eos$Account$nameToString(profile.l8))
																]))
														]))
												])),
											isProfileOwner ? A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('ml-2 fill-current text-orange-300 hover:text-orange-100'),
													$author$project$Route$href($author$project$Route$ProfileEditor)
												]),
											_List_fromArray(
												[
													$author$project$Icons$edit('')
												])) : $elm$html$Html$text('')
										])),
									function () {
									var _v0 = profile.dm;
									if (_v0.$ === 1) {
										return $elm$html$Html$text('');
									} else {
										var bio = _v0.a;
										return A2(
											$author$project$Markdown$view,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-sm text-gray-900')
												]),
											bio);
									}
								}()
								])),
						isProfileOwner ? _List_fromArray(
							[blockExplorerButton]) : _List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button button-primary w-full mt-4'),
										$author$project$Route$href(
										$author$project$Route$Transfer(
											$elm$core$Maybe$Just(profile.l8)))
									]),
								_List_fromArray(
									[
										text_('transfer.title')
									])),
								blockExplorerButton,
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col space-y-4 mt-4 mb-2')
									]),
								A2(
									$elm$core$List$map,
									function (contact) {
										var _v1 = $author$project$Profile$Contact$unwrap(contact);
										var contactType = _v1.mE;
										var contactClass = function () {
											if (contactType === 5) {
												return 'fill-current text-green';
											} else {
												return '';
											}
										}();
										return A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(
													'button-secondary uppercase bg-gray-100 py-2 flex items-center justify-center border-none hover:bg-gray-200 ' + $author$project$Profile$Contact$contactTypeTextColor(contactType)),
													$author$project$Profile$Contact$toHref(contact),
													$elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													A3($author$project$Profile$Contact$contactTypeToIcon, 'mr-2 w-6 h-6 ' + contactClass, true, contactType),
													$elm$html$Html$text(
													A2($author$project$Profile$Contact$contactTypeToString, loggedIn.A.aw, contactType))
												]));
									},
									profile.az))
							])))
				]));
	});
var $author$project$Page$Profile$view_ = F5(
	function (loggedIn, model, profile, balance, graphqlInfo) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-grow bg-gray-100 relative'),
					$elm$html$Html$Attributes$id('transfer-relative-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('z-10 w-full bg-grey-100 grid md:grid-cols-2 md:container md:mx-auto')
						]),
					_List_fromArray(
						[
							A2($author$project$Page$Profile$viewProfile, loggedIn, profile),
							A5($author$project$Page$Profile$viewDetails, loggedIn, profile, balance, graphqlInfo, model)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('z-0 absolute w-full h-full md:w-1/2 md:bg-white')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$Profile$view = F2(
	function (loggedIn, model) {
		var title = function () {
			var _v3 = model.pl;
			if (_v3.$ === 3) {
				var profile = _v3.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Eos$Account$nameToString(model.k5),
					profile.fj);
			} else {
				return $author$project$Eos$Account$nameToString(model.k5);
			}
		}();
		var combinedRemoteData = A4(
			$krisajenkins$remotedata$RemoteData$map3,
			F3(
				function (profile, balance, graphqlInfo) {
					return {cA: balance, b1: graphqlInfo, pl: profile};
				}),
			A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Page$Profile$ProfileError, model.pl),
			A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Page$Profile$BalanceError, model.cA),
			A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Page$Profile$GraphqlError, model.b1));
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var content = function () {
			switch (combinedRemoteData.$) {
				case 3:
					var profile = combinedRemoteData.a.pl;
					var balance = combinedRemoteData.a.cA;
					var graphqlInfo = combinedRemoteData.a.b1;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-grow flex-col')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Page$viewHeader,
								loggedIn,
								t('menu.profile')),
								A5($author$project$Page$Profile$view_, loggedIn, model, profile, balance, graphqlInfo)
							]));
				case 2:
					var error = combinedRemoteData.a;
					_v2$3:
					while (true) {
						switch (error.$) {
							case 0:
								if (error.a.$ === 1) {
									var graphqlError = error.a.a;
									return A2(
										$author$project$Page$fullPageGraphQLError,
										t('error.unknown'),
										graphqlError);
								} else {
									break _v2$3;
								}
							case 1:
								if (error.a.$ === 1) {
									var httpError = error.a.a;
									return A2(
										$author$project$Page$fullPageError,
										t('error.unknown'),
										httpError);
								} else {
									break _v2$3;
								}
							default:
								if (error.a.$ === 1) {
									var graphqlError = error.a.a;
									return A2(
										$author$project$Page$fullPageGraphQLError,
										t('error.unknown'),
										graphqlError);
								} else {
									break _v2$3;
								}
						}
					}
					return A2(
						$author$project$Page$fullPageNotFound,
						t('error.unknown'),
						t('error.pageNotFound'));
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				default:
					return $author$project$Page$fullPageLoading(loggedIn.A);
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Profile$AddContact$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		return {
			mJ: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-white pb-8')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Page$viewHeader,
						loggedIn,
						shared.aw.fL('contact_form.options')),
						function () {
						switch (model.$) {
							case 3:
								var contacts = model.a;
								return A2(
									$elm$html$Html$map,
									$author$project$Page$Profile$AddContact$GotContactMsg,
									A2($author$project$Profile$Contact$view, shared.aw, contacts));
							case 1:
								return $author$project$Page$fullPageLoading(shared);
							case 2:
								var err = model.a;
								return A2($author$project$Page$fullPageError, err, $elm$http$Http$NetworkError);
							default:
								return $elm$html$Html$text('');
						}
					}()
					])),
			fN: shared.aw.fL('contact_form.options')
		};
	});
var $author$project$Page$Profile$AddKyc$view = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var pageTitle = t('community.kyc.add.title');
		var content = function () {
			var _v1 = loggedIn.pl;
			switch (_v1.$) {
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 2:
					var e = _v1.a;
					return A2($author$project$Page$fullPageGraphQLError, pageTitle, e);
				default:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-white')
							]),
						_List_fromArray(
							[
								A2($author$project$Page$viewHeader, loggedIn, pageTitle),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('px-4')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$identity,
										A2($author$project$Profile$EditKycForm$view, loggedIn.A.aw, model))
									]))
							]));
			}
		}();
		return {mJ: content, fN: pageTitle};
	});
var $author$project$Page$Profile$Claims$ClaimMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Page$Profile$Claims$VoteClaim = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Profile$Claims$viewClaimVoteModal = F2(
	function (loggedIn, model) {
		var viewVoteModal = F3(
			function (claimId, isApproving, isLoading) {
				return A2(
					$author$project$Claim$viewVoteClaimModal,
					loggedIn.A.aw,
					{
						js: claimId,
						mw: A2($author$project$Page$Profile$Claims$ClaimMsg, 0, $author$project$Claim$CloseClaimModals),
						kl: isApproving,
						ko: isLoading,
						l_: $author$project$Page$Profile$Claims$VoteClaim
					});
			});
		var _v0 = model.hF;
		switch (_v0.$) {
			case 1:
				var claimId = _v0.a;
				var vote = _v0.b;
				return A3(viewVoteModal, claimId, vote, false);
			case 0:
				var claimId = _v0.a;
				var vote = _v0.b;
				return A3(viewVoteModal, claimId, vote, true);
			case 2:
				var claimId = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Page$Profile$Claims$ClaimMsg(0),
					A2($author$project$Claim$viewPhotoModal, loggedIn, claimId));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Page$Profile$Claims$Approved = 1;
var $author$project$Page$Profile$Claims$ClickedApplyFilters = {$: 12};
var $author$project$Page$Profile$Claims$ClosedFilterModal = {$: 9};
var $author$project$Page$Profile$Claims$Completed = 3;
var $author$project$Page$Profile$Claims$Disapproved = 2;
var $author$project$Page$Profile$Claims$NoOp = {$: 0};
var $author$project$Page$Profile$Claims$SelectedStatusFilter = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Profile$Claims$viewFiltersModal = F2(
	function (shared, model) {
		var statusFilterToString = function (statusFilter) {
			switch (statusFilter) {
				case 0:
					return 'all';
				case 1:
					return 'approved';
				case 2:
					return 'disapproved';
				default:
					return 'completed';
			}
		};
		var _v0 = shared.aw;
		var t = _v0.fL;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						function (options) {
						return A2(
							$author$project$Form$Select$view,
							options,
							{
								na: $elm$html$Html$text(''),
								no: false,
								nV: false,
								oF: $author$project$Page$Profile$Claims$NoOp,
								kV: $author$project$Page$Profile$Claims$SelectedStatusFilter,
								lW: model.eV
							});
					}(
						A2(
							$author$project$Form$Select$withContainerAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-10')
								]),
							A3(
								$author$project$Form$Select$withOption,
								3,
								t('community.actions.completed'),
								A3(
									$author$project$Form$Select$withOption,
									2,
									t('all_analysis.disapproved'),
									A3(
										$author$project$Form$Select$withOption,
										1,
										t('all_analysis.approved'),
										A3(
											$author$project$Form$Select$withOption,
											0,
											t('all_analysis.all'),
											$author$project$Form$Select$init(
												{
													w: 'status-filter-select',
													n$: t('all_analysis.filter.status.label'),
													d5: statusFilterToString
												}))))))),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-primary w-full'),
								$elm$html$Html$Events$onClick($author$project$Page$Profile$Claims$ClickedApplyFilters)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('all_analysis.filter.apply'))
							]))
					]),
				A2(
					$author$project$View$Modal$withHeader,
					t('all_analysis.filter.title'),
					$author$project$View$Modal$initWith(
						{mw: $author$project$Page$Profile$Claims$ClosedFilterModal, nX: model.em}))));
	});
var $author$project$Page$Profile$Claims$ClickedAcceptCodeOfConduct = {$: 13};
var $author$project$Page$Profile$Claims$OpenedFilterModal = {$: 8};
var $author$project$Page$Profile$Claims$ToggledSorting = {$: 10};
var $author$project$Page$Profile$Claims$viewFilterAndOrder = F2(
	function (shared, model) {
		var viewButton = F3(
			function (label, icon, onClickMsg) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button button-secondary flex-grow-1 justify-between pl-4'),
							$elm$html$Html$Events$onClick(onClickMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							shared.aw.fL(label)),
							icon
						]));
			});
		var showFilters = function () {
			var _v2 = model.aZ;
			if (!_v2) {
				return false;
			} else {
				return true;
			}
		}();
		var _v0 = function () {
			var _v1 = model.d7;
			if (!_v1) {
				return _Utils_Tuple2($author$project$Icons$sortAscending, 'all_analysis.filter.sort.asc');
			} else {
				return _Utils_Tuple2($author$project$Icons$sortDescending, 'all_analysis.filter.sort.desc');
			}
		}();
		var filterDirectionIcon = _v0.a;
		var filterDirectionLabel = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full md:w-2/3 xl:w-1/3 mx-auto mt-4 mb-6 flex space-x-4'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('sm:w-1/2 md:w-2/6 xl:w-1/6', !showFilters)
						]))
				]),
			_List_fromArray(
				[
					showFilters ? A3(
					viewButton,
					'all_analysis.filter.title',
					$author$project$Icons$arrowDown('fill-current'),
					$author$project$Page$Profile$Claims$OpenedFilterModal) : $elm$html$Html$text(''),
					A3(
					viewButton,
					filterDirectionLabel,
					filterDirectionIcon('mr-2'),
					$author$project$Page$Profile$Claims$ToggledSorting)
				]));
	});
var $author$project$Session$LoggedIn$codeOfConductUrl = function (language) {
	var defaultEndpoint = '/code-of-conduct';
	var endpoint = function () {
		switch (language) {
			case 0:
				return defaultEndpoint;
			case 1:
				return '/pt-br/codigo-de-conduta';
			case 2:
				return '/es/codigo-de-conducta';
			case 3:
				return defaultEndpoint;
			default:
				return defaultEndpoint;
		}
	}();
	var baseUrl = 'https://www.cambiatus.com';
	return _Utils_ap(baseUrl, endpoint);
};
var $author$project$Icons$lamp = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('28'),
				$elm$svg$Svg$Attributes$height('28'),
				$elm$svg$Svg$Attributes$viewBox('0 0 28 28'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M13.7472 5.125C14.166 5.125 14.5056 4.78921 14.5056 4.375V3.375C14.5056 2.96079 14.166 2.625 13.7472 2.625C13.3284 2.625 12.9889 2.96079 12.9889 3.375V4.375C12.9889 4.78921 13.3284 5.125 13.7472 5.125Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M24.6166 11.875H23.6055C23.1867 11.875 22.8472 12.2108 22.8472 12.625C22.8472 13.0392 23.1867 13.375 23.6055 13.375H24.6166C25.0354 13.375 25.3749 13.0392 25.3749 12.625C25.3749 12.2108 25.0354 11.875 24.6166 11.875Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M5.15278 12.625C5.15278 12.2108 4.81326 11.875 4.39444 11.875H3.38333C2.96452 11.875 2.625 12.2108 2.625 12.625C2.625 13.0392 2.96452 13.375 3.38333 13.375H4.39444C4.81326 13.375 5.15278 13.0392 5.15278 12.625Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M20.7897 7.65504C20.9907 7.65487 21.1835 7.57574 21.3256 7.43504L22.0434 6.73004C22.3219 6.43453 22.3137 5.97403 22.0249 5.68842C21.7361 5.40281 21.2705 5.39468 20.9717 5.67004L20.2538 6.37504C20.0372 6.58953 19.9724 6.91188 20.0897 7.19197C20.207 7.47205 20.4832 7.65478 20.7897 7.65504Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M7.24075 6.37504L6.52287 5.67004C6.22407 5.39468 5.75846 5.40281 5.46967 5.68842C5.18088 5.97403 5.17267 6.43453 5.45109 6.73004L6.16898 7.43504C6.46777 7.7104 6.93339 7.70228 7.22217 7.41666C7.51096 7.13105 7.51917 6.67055 7.24075 6.37504Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M22.3417 18.3751C22.0429 18.0998 21.5773 18.1079 21.2885 18.3935C20.9997 18.6791 20.9915 19.1396 21.2699 19.4351L21.9878 20.1401C22.2866 20.4155 22.7522 20.4074 23.041 20.1217C23.3298 19.8361 23.338 19.3756 23.0596 19.0801L22.3417 18.3751Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M5.15274 18.3751L4.43485 19.0801C4.15643 19.3756 4.16465 19.8361 4.45343 20.1217C4.74222 20.4074 5.20784 20.4155 5.50663 20.1401L6.22452 19.4351C6.50294 19.1396 6.49472 18.6791 6.20594 18.3935C5.91715 18.1079 5.45153 18.0998 5.15274 18.3751Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M21.0778 13.8747C21.0827 10.4405 18.5678 7.50991 15.1408 6.95641C11.7138 6.40292 8.38688 8.38995 7.28682 11.6473C6.18677 14.9047 7.63847 18.4702 10.7139 20.0647C10.5562 20.3061 10.472 20.5873 10.4713 20.8747V22.3747C10.4713 24.0315 11.8293 25.3747 13.5046 25.3747H14.5157C16.191 25.3747 17.549 24.0315 17.549 22.3747V20.8747C17.5483 20.5873 17.4641 20.3061 17.3064 20.0647C19.6265 18.8523 21.0781 16.4699 21.0778 13.8747ZM16.0223 20.8747V21.3747H13.4945C13.0757 21.3747 12.7361 21.7105 12.7361 22.1247C12.7361 22.5389 13.0757 22.8747 13.4945 22.8747H15.9313C15.7175 23.4726 15.1468 23.8729 14.5056 23.8747H13.4945C12.6568 23.8747 11.9778 23.2031 11.9778 22.3747V20.8747H16.0223ZM14 19.3747C10.9287 19.3747 8.43892 16.9123 8.43892 13.8747C8.43892 10.8371 10.9287 8.37469 14 8.37469C17.0714 8.37469 19.5611 10.8371 19.5611 13.8747C19.5611 15.3343 18.9745 16.734 17.9305 17.7655C16.8865 18.7971 15.4708 19.376 13.995 19.3747H14Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M14 9.625C13.5812 9.625 13.2417 9.96079 13.2417 10.375C13.2417 10.7892 13.5812 11.125 14 11.125C15.5345 11.1278 16.7778 12.3574 16.7806 13.875C16.7806 14.2892 17.1201 14.625 17.5389 14.625C17.9577 14.625 18.2973 14.2892 18.2973 13.875C18.2945 11.5289 16.3722 9.62776 14 9.625Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Profile$Claims$viewGoodPracticesCard = function (_v0) {
	var translators = _v0.aw;
	var language = _v0.ic;
	var text_ = A2($elm$core$Basics$composeR, translators.fL, $elm$html$Html$text);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('rounded shadow-lg w-full md:w-3/4 lg:w-2/3 bg-white')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center bg-yellow text-black font-semibold p-2 rounded-t')
					]),
				_List_fromArray(
					[
						$author$project$Icons$lamp('mr-2'),
						text_('profile.claims.good_practices.title')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list-disc p-4 pl-8 pb-4 md:pb-11 space-y-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pl-1')
							]),
						_List_fromArray(
							[
								text_('profile.claims.good_practices.once_a_day')
							])),
						A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pl-1')
							]),
						_List_fromArray(
							[
								text_('profile.claims.good_practices.completed_action')
							])),
						A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pl-1')
							]),
						_List_fromArray(
							[
								text_('profile.claims.good_practices.know_the'),
								$elm$html$Html$text(' '),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-orange-300 hover:underline focus-ring rounded-sm'),
										$elm$html$Html$Attributes$href(
										$author$project$Session$LoggedIn$codeOfConductUrl(language))
									]),
								_List_fromArray(
									[
										text_('profile.claims.good_practices.good_practices')
									]))
							]))
					]))
			]));
};
var $author$project$Page$Profile$Claims$Analyzed = 1;
var $author$project$Page$Profile$Claims$SelectedTab = function (a) {
	return {$: 7, a: a};
};
var $author$project$Claim$isOpenForVotes = F2(
	function (now, claim) {
		var isOpen = function () {
			var _v0 = claim.pN;
			if (_v0.$ === 2) {
				return true;
			} else {
				return false;
			}
		}();
		return (!A2($author$project$Action$isClosed, claim.dh, now)) && ((!claim.dh.b7) && isOpen);
	});
var $author$project$Page$Profile$Claims$claimsToShow = F4(
	function (shared, claims, statusFilter, tab) {
		if (!tab) {
			return A2(
				$elm$core$List$filter,
				$author$project$Claim$isOpenForVotes(shared.ce),
				claims);
		} else {
			var satisfiesFilter = function (claim) {
				switch (statusFilter) {
					case 0:
						return true;
					case 1:
						return _Utils_eq(claim.pN, $author$project$Claim$Approved);
					case 2:
						return _Utils_eq(claim.pN, $author$project$Claim$Rejected);
					default:
						return _Utils_eq(claim.pN, $author$project$Claim$Pending);
				}
			};
			return A2(
				$elm$core$List$filter,
				function (claim) {
					return (!A2($author$project$Claim$isOpenForVotes, shared.ce, claim)) && satisfiesFilter(claim);
				},
				claims);
		}
	});
var $author$project$Page$Profile$Claims$viewTabSelector = F3(
	function (shared, maybeClaims, model) {
		var translators = shared.aw;
		var tabCount = function (tab) {
			return A2(
				$elm$core$Maybe$map,
				function (claims) {
					return $elm$core$List$length(
						A4($author$project$Page$Profile$Claims$claimsToShow, shared, claims, 0, tab));
				},
				maybeClaims);
		};
		return $author$project$View$TabSelector$toHtml(
			A2(
				$author$project$View$TabSelector$withContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full md:w-2/3 xl:w-2/5 mt-6 lg:mt-8')
					]),
				$author$project$View$TabSelector$init(
					{
						oR: $author$project$Page$Profile$Claims$SelectedTab,
						aZ: model.aZ,
						pW: _List_fromArray(
							[
								{
								mO: tabCount(0),
								n$: translators.fL('all_analysis.tabs.waiting_vote'),
								lA: 0
							},
								{
								mO: tabCount(1),
								n$: translators.fL('all_analysis.tabs.analyzed'),
								lA: 1
							}
							])
					})));
	});
var $author$project$Page$Profile$Claims$viewHeaderAndOptions = F3(
	function (loggedIn, maybeClaims, model) {
		var shared = loggedIn.A;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-white pt-5 md:pt-6 pb-6')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container mx-auto px-4 flex flex-col items-center')
							]),
						_List_fromArray(
							[
								(!loggedIn.gz) ? A3(
								$author$project$Session$LoggedIn$viewFrozenAccountCard,
								shared.aw,
								{nS: true, oJ: $author$project$Page$Profile$Claims$ClickedAcceptCodeOfConduct},
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('shadow-lg')
									])) : $author$project$Page$Profile$Claims$viewGoodPracticesCard(shared),
								A3($author$project$Page$Profile$Claims$viewTabSelector, shared, maybeClaims, model)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container mx-auto px-4')
					]),
				_List_fromArray(
					[
						A2($author$project$Page$Profile$Claims$viewFilterAndOrder, shared, model)
					]))
			]);
	});
var $author$project$View$Components$keyedMasonryLayout = F4(
	function (breakpoints, transitionWithParent, attrs, children) {
		return A3(
			$elm$html$Html$Keyed$node,
			'masonry-layout',
			A3($author$project$View$Components$masonryLayoutAttributes, breakpoints, transitionWithParent, attrs),
			children);
	});
var $author$project$Page$Profile$Claims$viewEmptyResults = function (_v0) {
	var shared = _v0.A;
	var text_ = function (s) {
		return $elm$html$Html$text(
			shared.aw.fL(s));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full text-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full flex justify-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src('/images/empty-analysis.svg'),
								$elm$html$Html$Attributes$class('object-contain h-32 mb-3')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-block text-gray')
					]),
				_List_fromArray(
					[
						text_('profile.claims.empty_results')
					]))
			]));
};
var $author$project$Page$Profile$Claims$viewResults = F4(
	function (loggedIn, profileSummaries, claims, model) {
		var viewClaim = F3(
			function (profileSummary, claimIndex, claim) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(claim.w),
					A2(
						$elm$html$Html$map,
						$author$project$Page$Profile$Claims$ClaimMsg(claimIndex),
						A4(
							$author$project$Claim$viewClaimCard,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full self-start')
								]),
							loggedIn,
							profileSummary,
							claim)));
			});
		var orderFunction = function () {
			var _v0 = model.d7;
			if (_v0 === 1) {
				return $elm$core$List$reverse;
			} else {
				return $elm$core$Basics$identity;
			}
		}();
		var claimsList = A4($author$project$Page$Profile$Claims$claimsToShow, loggedIn.A, claims, model.gn, model.aZ);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto px-4 mb-10')
				]),
			_List_fromArray(
				[
					($elm$core$List$length(claimsList) > 0) ? A4(
					$author$project$View$Components$keyedMasonryLayout,
					_List_fromArray(
						[0]),
					{p9: false},
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 mb-4 sm:auto-rows-[5px]')
						]),
					A4(
						$elm$core$List$map3,
						viewClaim,
						profileSummaries,
						A2(
							$elm$core$List$range,
							0,
							$elm$core$List$length(profileSummaries)),
						orderFunction(claimsList))) : $author$project$Page$Profile$Claims$viewEmptyResults(loggedIn)
				]));
	});
var $author$project$Page$Profile$Claims$view = F2(
	function (loggedIn, model) {
		var maybeClaims = function () {
			var _v2 = model.pN;
			if (_v2.$ === 1) {
				var profileClaims = _v2.b;
				return $elm$core$Maybe$Just(profileClaims);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var pageTitle = t('profile.claims.title');
		var content = function () {
			var _v1 = model.pN;
			switch (_v1.$) {
				case 0:
					return _List_fromArray(
						[
							$author$project$Page$fullPageLoading(loggedIn.A)
						]);
				case 1:
					var profileSummaries = _v1.a;
					var profileClaims = _v1.b;
					return _List_fromArray(
						[
							A4($author$project$Page$Profile$Claims$viewResults, loggedIn, profileSummaries, profileClaims, model),
							A2($author$project$Page$Profile$Claims$viewClaimVoteModal, loggedIn, model)
						]);
				case 2:
					return _List_fromArray(
						[
							A2(
							$author$project$Page$fullPageNotFound,
							t('profile.claims.not_found.title'),
							t('profile.claims.not_found.subtitle'))
						]);
				default:
					var e = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Page$fullPageGraphQLError, pageTitle, e)
						]);
			}
		}();
		return {
			mJ: A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2($author$project$Page$viewHeader, loggedIn, pageTitle),
					A2(
						$elm$core$List$cons,
						A2($author$project$Page$Profile$Claims$viewFiltersModal, loggedIn.A, model),
						_Utils_ap(
							A3($author$project$Page$Profile$Claims$viewHeaderAndOptions, loggedIn, maybeClaims, model),
							content)))),
			fN: pageTitle
		};
	});
var $author$project$Icons$coinHeart = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('29'),
				$elm$svg$Svg$Attributes$height('31'),
				$elm$svg$Svg$Attributes$viewBox('0 0 29 31'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M21 22.1094C25.4183 22.1094 29 17.1601 29 11.0547C29 4.94936 25.4183 0 21 0C16.5817 0 13 4.94936 13 11.0547C13 17.1601 16.5817 22.1094 21 22.1094Z'),
						$elm$svg$Svg$Attributes$fill('#00BCCC')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M21.0003 17.9927C23.7468 17.9927 25.9733 14.8872 25.9733 11.0564C25.9733 7.2256 23.7468 4.12012 21.0003 4.12012C18.2538 4.12012 16.0273 7.2256 16.0273 11.0564C16.0273 14.8872 18.2538 17.9927 21.0003 17.9927Z'),
						$elm$svg$Svg$Attributes$stroke('#008793'),
						$elm$svg$Svg$Attributes$strokeWidth('0.1991'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.3776 3.25293C15.81 3.90321 16.4587 4.77024 17.3236 6.0708'),
						$elm$svg$Svg$Attributes$stroke('#008793'),
						$elm$svg$Svg$Attributes$strokeWidth('0.1991'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M24.6758 16.042C25.5406 17.3425 26.4055 18.4263 26.8379 18.8599'),
						$elm$svg$Svg$Attributes$stroke('#008793'),
						$elm$svg$Svg$Attributes$strokeWidth('0.1991'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.3776 18.6421C15.81 17.9918 16.4587 17.1248 17.5397 15.8242'),
						$elm$svg$Svg$Attributes$stroke('#008793'),
						$elm$svg$Svg$Attributes$strokeWidth('0.1991'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M24.6758 5.85302C25.5406 4.55247 26.4055 3.68543 26.6217 3.03516'),
						$elm$svg$Svg$Attributes$stroke('#008793'),
						$elm$svg$Svg$Attributes$strokeWidth('0.1991'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.8258 6.35866L8.17377 2C7.99986 2 7.99985 2 7.82594 2L0.17392 6.35866C1.0612e-05 6.35866 0 6.533 0 6.70735V15.4247C0 15.599 1.0612e-05 15.599 0.17392 15.7734L7.82594 20.132H7.99986H8.17377L15.8258 15.7734C15.9997 15.7734 15.9997 15.599 15.9997 15.4247V6.70735C15.9997 6.533 15.9997 6.533 15.8258 6.35866Z'),
						$elm$svg$Svg$Attributes$fill('#F1653A')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M13.2171 7.92724L8.17371 5.1377H7.9998L2.95641 8.10158L2.7825 8.27593V14.0294C2.7825 14.0294 2.7825 14.2037 2.95641 14.2037L7.9998 17.1676C7.9998 17.1676 7.9998 17.1676 8.17371 17.1676C8.17371 17.1676 8.17371 17.1676 8.34762 17.1676L13.391 14.2037L13.5649 14.0294V8.27593C13.391 8.10158 13.391 7.92724 13.2171 7.92724Z'),
						$elm$svg$Svg$Attributes$stroke('#BC4F2C'),
						$elm$svg$Svg$Attributes$strokeWidth('0.2066'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.17368 20.1319C8.17368 20.1319 8.17368 18.9114 8.17368 17.168'),
						$elm$svg$Svg$Attributes$stroke('#BC4F2C'),
						$elm$svg$Svg$Attributes$strokeWidth('0.2066'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.17368 4.96389C8.17368 3.22042 8.17368 2 8.17368 2'),
						$elm$svg$Svg$Attributes$stroke('#BC4F2C'),
						$elm$svg$Svg$Attributes$strokeWidth('0.2066'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M16.0003 15.5974C16.0003 15.5974 14.9569 15.0744 13.3917 14.0283'),
						$elm$svg$Svg$Attributes$stroke('#BC4F2C'),
						$elm$svg$Svg$Attributes$strokeWidth('0.2066'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M2.78247 8.1033C1.21729 7.23157 0.173828 6.53418 0.173828 6.53418'),
						$elm$svg$Svg$Attributes$stroke('#BC4F2C'),
						$elm$svg$Svg$Attributes$strokeWidth('0.2066'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M16.0003 6.70703C16.0003 6.70703 14.9569 7.23007 13.3917 8.1018'),
						$elm$svg$Svg$Attributes$stroke('#BC4F2C'),
						$elm$svg$Svg$Attributes$strokeWidth('0.2066'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M2.78247 14.0283C1.21729 14.9001 0.173828 15.4231 0.173828 15.4231'),
						$elm$svg$Svg$Attributes$stroke('#BC4F2C'),
						$elm$svg$Svg$Attributes$strokeWidth('0.2066'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M23.8222 19.9805L16.4741 10.2376C16.4741 10 16.237 10 16 10C15.763 10 15.763 10 15.5259 10.2376L8.17778 19.9805C7.94074 20.2182 7.94074 20.4558 8.17778 20.4558L15.5259 30.1987C15.5259 30.4364 15.763 30.4364 16 30.4364C16.237 30.4364 16.237 30.4364 16.4741 30.1987L23.8222 20.4558C24.0593 20.4558 24.0593 20.2182 23.8222 19.9805Z'),
						$elm$svg$Svg$Attributes$fill('#F89C33')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M20.0293 19.9795L16.2367 14.9893H15.9996H15.7626L12.207 19.9795V20.2172L15.7626 25.2074H15.9996H16.2367L20.0293 20.2172C20.0293 20.2172 20.0293 20.2172 20.0293 19.9795Z'),
						$elm$svg$Svg$Attributes$stroke('#C47D27'),
						$elm$svg$Svg$Attributes$strokeWidth('0.21'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M16.237 14.9903V10'),
						$elm$svg$Svg$Attributes$stroke('#C47D27'),
						$elm$svg$Svg$Attributes$strokeWidth('0.21'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M16.237 30.1983V25.208'),
						$elm$svg$Svg$Attributes$stroke('#C47D27'),
						$elm$svg$Svg$Attributes$strokeWidth('0.21'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.65103 20.2188C8.65103 20.2188 10.3103 20.2188 12.4436 20.2188'),
						$elm$svg$Svg$Attributes$stroke('#C47D27'),
						$elm$svg$Svg$Attributes$strokeWidth('0.21'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M20.2669 20.2188C22.4003 20.2188 23.8225 20.2188 23.8225 20.2188'),
						$elm$svg$Svg$Attributes$stroke('#C47D27'),
						$elm$svg$Svg$Attributes$strokeWidth('0.21'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Profile$Contributions$viewContribution = F2(
	function (translators, contribution) {
		var t = translators.fL;
		var isFailedOrRejected = function () {
			var _v1 = contribution.pN;
			switch (_v1) {
				case 3:
					return true;
				case 4:
					return true;
				default:
					return false;
			}
		}();
		var isApprovedOrCaptured = function () {
			var _v0 = contribution.pN;
			switch (_v0) {
				case 0:
					return true;
				case 1:
					return true;
				default:
					return false;
			}
		}();
		var statusString = isApprovedOrCaptured ? t('profile.contributions.approved') : (isFailedOrRejected ? t('profile.contributions.failed') : t('profile.contributions.pending'));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center px-1 py-4 flex-wrap')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-14 h-14 bg-gray-100 flex items-center justify-center rounded')
						]),
					_List_fromArray(
						[
							$author$project$Icons$coinHeart('')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex space-x-1 text-black ml-3 mr-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-lg')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3(
										$author$project$Utils$formatFloat,
										$elm$core$Maybe$Just(translators),
										0,
										contribution.ji))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-sm uppercase self-end mb-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t(
										$author$project$Community$currencyTranslationKey(contribution)))
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-auto py-0.5 px-5 bg-gray-100 uppercase text-sm'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('font-bold text-green', isApprovedOrCaptured),
									_Utils_Tuple2('font-bold text-red', isFailedOrRejected)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(statusString)
						]))
				]));
	});
var $author$project$Page$Profile$Contributions$view_ = F3(
	function (loggedIn, profileContributions, title) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-grow flex-col')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$viewHeader, loggedIn, title),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-grow container mx-auto p-4')
						]),
					_List_fromArray(
						[
							$elm$core$List$isEmpty(profileContributions) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-grow flex flex-col items-center justify-center bg-white rounded px-4')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/images/empty-analysis.svg'),
											$elm$html$Html$Attributes$class('h-32 mb-3')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											loggedIn.A.aw.fL('profile.contributions.no_contributions'))
										]))
								])) : A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-grow bg-white rounded divide-y px-4')
								]),
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, _v0) {
										var firstContribution = _v0.a;
										var otherContributions = _v0.b;
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('pt-6', !(!index)),
															_Utils_Tuple2('pt-4', !index)
														]))
												]),
											_List_fromArray(
												[
													A4(
													$author$project$View$Components$dateViewer,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-sm text-black uppercase font-bold px-1')
														]),
													$elm$core$Basics$identity,
													loggedIn.A,
													firstContribution.nL),
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('divide-y')
														]),
													A2(
														$elm$core$List$map,
														$author$project$Page$Profile$Contributions$viewContribution(loggedIn.A.aw),
														A2($elm$core$List$cons, firstContribution, otherContributions)))
												]));
									}),
								A2(
									$elm_community$list_extra$List$Extra$groupWhile,
									F2(
										function (c1, c2) {
											return A3($author$project$Utils$areSameDay, loggedIn.A.i2, c1.nL, c2.nL);
										}),
									profileContributions)))
						]))
				]));
	});
var $author$project$Page$Profile$Contributions$view = F2(
	function (loggedIn, model) {
		var title = _Utils_eq(loggedIn._, model.k5) ? loggedIn.A.aw.fL('dashboard.my_contributions') : A2(
			loggedIn.A.aw.i4,
			'profile.contributions.profile_contributions',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'profile_name',
					$author$project$Eos$Account$nameToString(model.k5))
				]));
		var content = function () {
			var _v0 = loggedIn.pC;
			switch (_v0.$) {
				case 3:
					var community = _v0.a;
					if (_Utils_eq(loggedIn._, model.k5) || _Utils_eq(loggedIn._, community.jz)) {
						var _v1 = model.eN;
						switch (_v1.$) {
							case 3:
								var contributions = _v1.a;
								return A3($author$project$Page$Profile$Contributions$view_, loggedIn, contributions, title);
							case 1:
								return $author$project$Page$fullPageLoading(loggedIn.A);
							case 0:
								return $author$project$Page$fullPageLoading(loggedIn.A);
							default:
								var err = _v1.a;
								return A2($author$project$Page$fullPageGraphQLError, title, err);
						}
					} else {
						return A2(
							$author$project$Page$fullPageNotFound,
							loggedIn.A.aw.fL('profile.contributions.not_allowed_title'),
							loggedIn.A.aw.fL('profile.contributions.not_allowed'));
					}
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				default:
					var err = _v0.a;
					return A2($author$project$Page$fullPageGraphQLError, title, err);
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$Profile$Editor$ClickedSave = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$Editor$FormOutput = F6(
	function (avatar, fullName, email, bio, location, interests) {
		return {dl: avatar, dm: bio, jK: email, dG: fullName, dN: interests, oa: location};
	});
var $author$project$Page$Profile$Editor$interestsForm = function (_v0) {
	var t = _v0.fL;
	var viewInterest = function (interest) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-green px-3 h-8 rounded-sm text-sm flex text-white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-auto mr-3 uppercase')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(interest)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Events$onClick(
							function (values) {
								return _Utils_update(
									values,
									{
										dN: A2(
											$elm$core$List$filter,
											function (x) {
												return !_Utils_eq(x, interest);
											},
											values.dN)
									});
							})
						]),
					_List_fromArray(
						[
							$author$project$Icons$close('w-4 h-4 fill-current')
						]))
				]));
	};
	return A2(
		$author$project$Form$withNoOutput,
		$author$project$Form$introspect(
			function (values) {
				return $author$project$Form$arbitrary(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-wrap mb-10 gap-x-4 gap-y-2')
							]),
						A2($elm$core$List$map, viewInterest, values.dN)));
			}),
		A2(
			$author$project$Form$withNoOutput,
			A4(
				$author$project$Form$withGroup,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex')
					]),
				A2(
					$author$project$Form$textField,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: $elm$core$Result$Ok,
						qd: F2(
							function (interest, input) {
								return _Utils_update(
									input,
									{b4: interest});
							}),
						lW: function ($) {
							return $.b4;
						}
					},
					A2(
						$author$project$Form$Text$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full !mb-4')
							]),
						$author$project$Form$Text$init(
							{
								w: 'interest-input',
								n$: t('profile.edit.labels.interests')
							}))),
				$author$project$Form$arbitrary(
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('button button-secondary px-4 h-12 ml-4 mb-4 mt-auto max-w-min'),
								$elm$html$Html$Events$onClick(
								function (values) {
									return ($elm$core$String$isEmpty(values.b4) || A2($elm$core$List$member, values.b4, values.dN)) ? values : _Utils_update(
										values,
										{
											b4: '',
											dN: A2($elm$core$List$cons, values.b4, values.dN)
										});
								})
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('menu.add'))
							]))),
				$author$project$Form$succeed($elm$core$Basics$always)),
			$author$project$Form$introspect(
				function (values) {
					return $author$project$Form$succeed(values.dN);
				})));
};
var $author$project$Page$Profile$Editor$createForm = F2(
	function (translators, _v0) {
		var t = translators.fL;
		var hasKyc = _v0.by;
		return A2(
			$author$project$Form$with,
			$author$project$Page$Profile$Editor$interestsForm(translators),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$textField,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: $elm$core$Result$Ok,
						qd: F2(
							function (location, input) {
								return _Utils_update(
									input,
									{oa: location});
							}),
						lW: function ($) {
							return $.oa;
						}
					},
					$author$project$Form$Text$init(
						{
							w: 'location-input',
							n$: t('profile.edit.labels.localization')
						})),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$richText,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: $elm$core$Result$Ok,
							qd: F2(
								function (bio, input) {
									return _Utils_update(
										input,
										{dm: bio});
								}),
							lW: function ($) {
								return $.dm;
							}
						},
						A2(
							$author$project$Form$RichText$withEditorContainerAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-10')
								]),
							$author$project$Form$RichText$init(
								{
									n$: t('profile.edit.labels.bio')
								}))),
					A2(
						$author$project$Form$with,
						A2(
							$author$project$Form$textField,
							{
								ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								o3: $elm$core$Result$Ok,
								qd: F2(
									function (email, input) {
										return _Utils_update(
											input,
											{jK: email});
									}),
								lW: function ($) {
									return $.jK;
								}
							},
							$author$project$Form$Text$init(
								{
									w: 'email-input',
									n$: t('profile.edit.labels.email')
								})),
						A2(
							$author$project$Form$with,
							A2(
								$author$project$Form$textField,
								{
									ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
									o3: $elm$core$Result$Ok,
									qd: F2(
										function (name, input) {
											return _Utils_update(
												input,
												{dG: name});
										}),
									lW: function ($) {
										return $.dG;
									}
								},
								A2(
									$author$project$Form$Text$withDisabled,
									hasKyc,
									$author$project$Form$Text$init(
										{
											w: 'name-input',
											n$: t('profile.edit.labels.name')
										}))),
							A2(
								$author$project$Form$with,
								$author$project$Form$optional(
									A2(
										$author$project$Form$file,
										{
											ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
											o3: $elm$core$Result$Ok,
											aw: translators,
											qd: F2(
												function (avatar, input) {
													return _Utils_update(
														input,
														{dl: avatar});
												}),
											lW: function ($) {
												return $.dl;
											}
										},
										A2(
											$author$project$Form$File$withImageCropperAttributes,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('rounded-full')
												]),
											A2(
												$author$project$Form$File$withAddImagesView,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('bg-orange-300 rounded-full p-4 w-20 h-20')
															]),
														_List_fromArray(
															[
																$author$project$Icons$camera('text-white')
															]))
													]),
												$author$project$Form$File$withEditIconOverlay(
													A2(
														$author$project$Form$File$withEntryContainerAttributes,
														function (_v1) {
															return _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('mx-auto rounded-full w-20 h-20')
																]);
														},
														A2(
															$author$project$Form$File$withImageClass,
															'object-cover rounded-full mx-auto w-20 h-20',
															A2(
																$author$project$Form$File$withContainerAttributes,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('grid place-items-center')
																	]),
																$author$project$Form$File$init(
																	{w: 'avatar-input'}))))))))),
								$author$project$Form$succeed($author$project$Page$Profile$Editor$FormOutput)))))));
	});
var $author$project$Page$Profile$Editor$view_ = F3(
	function (loggedIn, form, profile) {
		var translators = loggedIn.A.aw;
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var title = t('menu.edit') + (' ' + $elm$core$String$toLower(
			t('menu.profile')));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$viewHeader, loggedIn, title),
					A6(
					$author$project$Form$view,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto p-4')
						]),
					translators,
					function (submitButton) {
						return _List_fromArray(
							[
								A2(
								submitButton,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button button-primary w-full')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('profile.edit.submit'))
									]))
							]);
					},
					A2(
						$author$project$Page$Profile$Editor$createForm,
						translators,
						{
							by: A2(
								$elm$core$List$any,
								function ($) {
									return $.by;
								},
								profile.eK)
						}),
					form,
					{oU: $author$project$Page$Profile$Editor$ClickedSave, lF: $author$project$Page$Profile$Editor$GotFormMsg})
				]));
	});
var $author$project$Page$Profile$Editor$view = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var content = function () {
			var _v1 = loggedIn.pl;
			switch (_v1.$) {
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 2:
					var e = _v1.a;
					return A2(
						$author$project$Page$fullPageGraphQLError,
						t('profile.title'),
						e);
				default:
					var profile = _v1.a;
					var _v2 = model.hY;
					if (!_v2.$) {
						return $author$project$Page$fullPageLoading(loggedIn.A);
					} else {
						var form = _v2.a;
						return A3($author$project$Page$Profile$Editor$view_, loggedIn, form, profile);
					}
			}
		}();
		var title = t('profile.edit.title');
		return {mJ: content, fN: title};
	});
var $author$project$Page$Register$AgreedToSave12Words = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Register$CopyToClipboard = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Register$DownloadPdf = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Register$viewAccountCreated = F3(
	function (translators, model, keys) {
		var t = translators.fL;
		var tr = translators.i4;
		var passphraseTextId = 'passphraseText';
		var passphraseInputId = 'passphraseWords';
		var name = $author$project$Eos$Account$nameToString(keys._);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex-grow bg-purple-500 flex md:block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col justify-between px-4 md:max-w-sm md:mx-auto md:pt-20 md:px-0 text-white')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold mb-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												tr,
												'register.account_created.greet',
												_List_fromArray(
													[
														_Utils_Tuple2('name', name)
													])))
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-6')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('register.account_created.instructions'))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-1/4 m-auto relative left-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('/images/reg-passphrase-boy.svg')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('absolute w-1/4 -mt-2 -ml-10'),
													$elm$html$Html$Attributes$src('/images/reg-passphrase-boy-hand.svg')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-white text-black text-2xl p-4 rounded-lg')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-sm font-bold mb-4 text-black')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('register.account_created.twelve_words')),
													model.gI ? A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('ml-1')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															t('register.account_created.words_copied')),
															$elm$html$Html$text(' ✔')
														])) : $elm$html$Html$text('')
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pb-4')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('select-all text-lg block font-bold'),
															$elm$html$Html$Attributes$id(passphraseTextId)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(keys.hq)
														])),
													function (options) {
													return A2(
														$author$project$Form$Text$view,
														options,
														{
															na: $elm$html$Html$text(''),
															no: false,
															nV: false,
															oF: $author$project$Page$Register$NoOp,
															oH: function (_v0) {
																return $author$project$Page$Register$NoOp;
															},
															aw: translators,
															lW: keys.hq
														});
												}(
													A2(
														$author$project$Form$Text$withContainerAttrs,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('mb-0 absolute opacity-0 left-[-9999em]')
															]),
														$author$project$Form$Text$init(
															{w: passphraseInputId, n$: ''})))
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button m-auto button-primary button-sm'),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Register$CopyToClipboard(passphraseInputId))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('register.account_created.copy'))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									function (options) {
									return A2(
										$author$project$Form$Checkbox$view,
										options,
										{
											na: $elm$html$Html$text(''),
											no: false,
											nV: true,
											oF: $author$project$Page$Register$NoOp,
											oI: $author$project$Page$Register$AgreedToSave12Words,
											lW: model.e0
										});
								}(
									A2(
										$author$project$Form$Checkbox$withContainerAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('my-6 font-bold')
											]),
										$author$project$Form$Checkbox$init(
											{
												w: 'agreed-save-passphrase',
												n$: $elm$html$Html$text(
													t('register.account_created.i_saved_words') + ' 💜')
											}))),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$Page$Register$DownloadPdf(
												{
													_: $author$project$Eos$Account$nameToString(keys._),
													bp: keys.hq
												})),
											$elm$html$Html$Attributes$class('button button-primary w-full mb-4'),
											$elm$html$Html$Attributes$disabled(!model.e0)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('register.account_created.download'))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Register$JuridicalAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Register$NaturalAccount = {$: 0};
var $author$project$Page$Register$AccountTypeSelected = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Register$viewAccountTypeButton = F3(
	function (title, accountType, status) {
		var isSelected = function () {
			var _v0 = _Utils_Tuple2(accountType, status);
			_v0$2:
			while (true) {
				if (!_v0.a.$) {
					if ((_v0.b.$ === 2) && (!_v0.b.b.$)) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return true;
					} else {
						break _v0$2;
					}
				} else {
					if ((_v0.b.$ === 2) && (_v0.b.b.$ === 1)) {
						var _v3 = _v0.b;
						return true;
					} else {
						break _v0$2;
					}
				}
			}
			return false;
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-1/2 text-center cursor-pointer rounded-sm cursor-pointer mb-4 py-2'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('bg-orange-300 text-white font-bold', isSelected),
							_Utils_Tuple2('bg-gray-100 text-black', !isSelected)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Page$Register$AccountTypeSelected(accountType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(title)
				]));
	});
var $author$project$Page$Register$viewAccountTypeSelector = F2(
	function (translators, model) {
		var _v0 = model.mP;
		if (!_v0.$) {
			var country = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$View$Components$label,
						_List_Nil,
						{
							n0: translators.fL('register.form.register_tooltip'),
							pZ: 'radio'
						}),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex space-x-2 mb-4')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Page$Register$viewAccountTypeButton,
								translators.fL('register.form.types.natural'),
								$author$project$Page$Register$NaturalAccount,
								model.pN),
								A3(
								$author$project$Page$Register$viewAccountTypeButton,
								translators.fL('register.form.types.juridical'),
								$author$project$Page$Register$JuridicalAccount(country),
								model.pN)
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Page$Register$viewFooter = F2(
	function (guest, submitButton) {
		var _v0 = guest.A.aw;
		var t = _v0.fL;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-auto flex flex-col items-center text-gray-333 md:mt-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-6')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('register.login')),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('underline text-orange-300'),
									$author$project$Route$href(
									A2($author$project$Route$Login, guest.kC, guest.me))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('register.authLink'))
								]))
						])),
					A2(
					submitButton,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button button-primary w-full mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('auth.login.continue'))
						]))
				]));
	});
var $author$project$Eos$Account$maxNameLength = 12;
var $author$project$Eos$Account$minNameLength = 12;
var $author$project$Eos$Account$errorToString = F2(
	function (_v0, error) {
		var tr = _v0.i4;
		switch (error.$) {
			case 0:
				var firstInvalidCharacter = error.a;
				return A2(
					tr,
					'error.notAllowedChar',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'char',
							$elm$core$String$fromChar(firstInvalidCharacter))
						]));
			case 1:
				return A2(
					tr,
					'error.validator.text.exactly',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'base',
							$elm$core$String$fromInt($author$project$Eos$Account$minNameLength))
						]));
			default:
				return A2(
					tr,
					'error.validator.text.exactly',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'base',
							$elm$core$String$fromInt($author$project$Eos$Account$maxNameLength))
						]));
		}
	});
var $author$project$Eos$Account$InvalidCharacters = function (a) {
	return {$: 0, a: a};
};
var $author$project$Eos$Account$TooLong = {$: 2};
var $author$project$Eos$Account$TooShort = {$: 1};
var $author$project$Eos$Account$fromString = function (string) {
	var sanitizedString = $elm$core$String$toLower(
		$elm$core$String$trim(string));
	var isCharacterAllowed = function (_char) {
		return $elm$core$Char$isAlpha(_char) || A2(
			$elm$core$List$member,
			_char,
			_List_fromArray(
				['1', '2', '3', '4', '5']));
	};
	var _v0 = $elm$core$List$head(
		$elm$core$String$toList(
			A2(
				$elm$core$String$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, isCharacterAllowed),
				sanitizedString)));
	if (!_v0.$) {
		var firstInvalidCharacter = _v0.a;
		return $elm$core$Result$Err(
			$author$project$Eos$Account$InvalidCharacters(firstInvalidCharacter));
	} else {
		return (_Utils_cmp(
			$elm$core$String$length(sanitizedString),
			$author$project$Eos$Account$minNameLength) < 0) ? $elm$core$Result$Err($author$project$Eos$Account$TooShort) : ((_Utils_cmp(
			$elm$core$String$length(sanitizedString),
			$author$project$Eos$Account$maxNameLength) > 0) ? $elm$core$Result$Err($author$project$Eos$Account$TooLong) : $elm$core$Result$Ok(sanitizedString));
	}
};
var $author$project$Form$Validate$eosName = $author$project$Form$Validate$custom(
	function (stringInput) {
		var _v0 = $author$project$Eos$Account$fromString(stringInput);
		if (!_v0.$) {
			var account = _v0.a;
			return $elm$core$Result$Ok(account);
		} else {
			var error = _v0.a;
			return $elm$core$Result$Err(
				function (translators) {
					return A2($author$project$Eos$Account$errorToString, translators, error);
				});
		}
	});
var $author$project$Page$Register$Common$accountNameField = F2(
	function (translators, _v0) {
		var t = translators.fL;
		var unavailableAccounts = _v0.hk;
		return A2(
			$author$project$Form$textField,
			{
				ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				o3: A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Validate$succeed,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$eosName,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$custom(
								function (accountName) {
									return A2(
										$elm$core$Set$member,
										$author$project$Eos$Account$nameToString(accountName),
										unavailableAccounts) ? $elm$core$Result$Err(
										function (translators_) {
											return translators_.fL('error.alreadyTaken');
										}) : $elm$core$Result$Ok(accountName);
								}),
							$author$project$Form$Validate$validate(translators)))),
				qd: F2(
					function (account, input) {
						return _Utils_update(
							input,
							{l8: account});
					}),
				lW: function ($) {
					return $.l8;
				}
			},
			A2(
				$author$project$Form$Text$withCounter,
				$author$project$Form$Text$CountLetters(12),
				A2(
					$author$project$Form$Text$withPlaceholder,
					t('register.form.account.placeholder'),
					$author$project$Form$Text$init(
						{
							w: 'account-input',
							n$: t('register.form.account.label')
						}))));
	});
var $author$project$Page$Register$Common$emailField = function (translators) {
	var t = translators.fL;
	return A2(
		$author$project$Form$textField,
		{
			ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
			o3: A2(
				$elm$core$Basics$composeR,
				$author$project$Form$Validate$succeed,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Validate$email,
					$author$project$Form$Validate$validate(translators))),
			qd: F2(
				function (email, input) {
					return _Utils_update(
						input,
						{jK: email});
				}),
			lW: function ($) {
				return $.jK;
			}
		},
		A2(
			$author$project$Form$Text$withPlaceholder,
			t('register.form.email.placeholder'),
			$author$project$Form$Text$init(
				{
					w: 'email-input',
					n$: t('register.form.email.label')
				})));
};
var $author$project$Page$Register$Common$personNameField = function (_v0) {
	var t = _v0.fL;
	return A2(
		$author$project$Form$textField,
		{
			ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
			o3: $elm$core$Result$Ok,
			qd: F2(
				function (name, input) {
					return _Utils_update(
						input,
						{fj: name});
				}),
			lW: function ($) {
				return $.fj;
			}
		},
		A2(
			$author$project$Form$Text$withPlaceholder,
			t('register.form.name.placeholder'),
			$author$project$Form$Text$init(
				{
					w: 'name-input',
					n$: t('register.form.name.label')
				})));
};
var $author$project$Page$Register$DefaultForm$form = F2(
	function (translators, unavailableAccounts) {
		return A2(
			$author$project$Form$with,
			$author$project$Page$Register$Common$emailField(translators),
			A2(
				$author$project$Form$with,
				A2($author$project$Page$Register$Common$accountNameField, translators, unavailableAccounts),
				A2(
					$author$project$Form$with,
					$author$project$Page$Register$Common$personNameField(translators),
					$author$project$Form$succeed($author$project$Page$Register$DefaultForm$FormOutput))));
	});
var $elm_community$maybe_extra$Maybe$Extra$andThen2 = F3(
	function (func, ma, mb) {
		if (!ma.$) {
			var a = ma.a;
			if (!mb.$) {
				var b = mb.a;
				return A2(func, a, b);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Register$JuridicalForm$costaRicaZipcodes = _List_fromArray(
	['10101', '10102', '10103', '10104', '10105', '10106', '10107', '10108', '10109', '10110', '10111', '10201', '10202', '10203', '10301', '10302', '10303', '10304', '10305', '10306', '10307', '10308', '10309', '10310', '10311', '10312', '10313', '10401', '10402', '10403', '10404', '10405', '10406', '10407', '10408', '10409', '10501', '10502', '10503', '10601', '10602', '10603', '10604', '10605', '10606', '10607', '10701', '10702', '10703', '10704', '10705', '10706', '10707', '10801', '10802', '10803', '10804', '10805', '10806', '10807', '10901', '10902', '10903', '10904', '10905', '10906', '11001', '11002', '11003', '11004', '11005', '11101', '11102', '11103', '11104', '11105', '11201', '11202', '11203', '11204', '11205', '11301', '11302', '11303', '11304', '11305', '11401', '11402', '11403', '11501', '11502', '11503', '11504', '11601', '11602', '11603', '11604', '11605', '11701', '11702', '11703', '11801', '11802', '11803', '11804', '11901', '11902', '11903', '11904', '11905', '11906', '11907', '11908', '11909', '11910', '11911', '11912', '12001', '12002', '12003', '12004', '12005', '12006', '20101', '20102', '20103', '20104', '20105', '20106', '20107', '20108', '20109', '20110', '20111', '20112', '20113', '20114', '20201', '20202', '20203', '20204', '20205', '20206', '20207', '20208', '20209', '20210', '20211', '20212', '20213', '20214', '20301', '20302', '20303', '20304', '20305', '20307', '20308', '20401', '20402', '20403', '20404', '20501', '20502', '20503', '20504', '20505', '20506', '20507', '20508', '20601', '20602', '20603', '20604', '20605', '20606', '20607', '20608', '20701', '20702', '20703', '20704', '20705', '20706', '20707', '20801', '20802', '20803', '20804', '20805', '20901', '20902', '20903', '20904', '20905', '21001', '21002', '21003', '21004', '21005', '21006', '21007', '21008', '21009', '21010', '21011', '21012', '21013', '21101', '21102', '21103', '21104', '21105', '21106', '21107', '21201', '21202', '21203', '21204', '21205', '21301', '21302', '21303', '21304', '21305', '21306', '21307', '21308', '21401', '21402', '21403', '21404', '21501', '21502', '21503', '21504', '21601', '21602', '21603', '30101', '30102', '30103', '30104', '30105', '30106', '30107', '30108', '30109', '30110', '30111', '30201', '30202', '30203', '30204', '30205', '30301', '30302', '30303', '30304', '30305', '30306', '30307', '30308', '30401', '30402', '30403', '30501', '30502', '30503', '30504', '30505', '30506', '30507', '30508', '30509', '30510', '30511', '30512', '30601', '30602', '30603', '30701', '30702', '30703', '30704', '30705', '30801', '30802', '30803', '30804', '40101', '40102', '40103', '40104', '40105', '40201', '40202', '40203', '40204', '40205', '40206', '40301', '40302', '40303', '40304', '40305', '40306', '40307', '40308', '40401', '40402', '40403', '40404', '40405', '40406', '40501', '40502', '40503', '40504', '40505', '40601', '40602', '40603', '40604', '40701', '40702', '40703', '40801', '40802', '40803', '40901', '40902', '41001', '41002', '41003', '41004', '41005', '50101', '50102', '50103', '50104', '50105', '50201', '50202', '50203', '50204', '50205', '50206', '50207', '50301', '50302', '50303', '50304', '50305', '50306', '50307', '50308', '50309', '50401', '50402', '50403', '50404', '50501', '50502', '50503', '50504', '50601', '50602', '50603', '50604', '50605', '50701', '50702', '50703', '50704', '50801', '50802', '50803', '50804', '50805', '50806', '50807', '50808', '50901', '50902', '50903', '50904', '50905', '50906', '51001', '51002', '51003', '51004', '51101', '51102', '51103', '51104', '51105', '60101', '60102', '60103', '60104', '60105', '60106', '60107', '60108', '60109', '60110', '60111', '60112', '60113', '60114', '60115', '60116', '60201', '60202', '60203', '60204', '60205', '60206', '60301', '60302', '60303', '60304', '60305', '60306', '60307', '60308', '60309', '60401', '60402', '60403', '60501', '60502', '60503', '60504', '60505', '60506', '60601', '60602', '60603', '60701', '60702', '60703', '60704', '60801', '60802', '60803', '60804', '60805', '60806', '60901', '61001', '61002', '61003', '61004', '61101', '61102', '70101', '70102', '70103', '70104', '70201', '70202', '70203', '70204', '70205', '70206', '70207', '70301', '70302', '70303', '70304', '70305', '70306', '70307', '70401', '70402', '70403', '70404', '70501', '70502', '70503', '70601', '70602', '70603', '70604', '70605']);
var $author$project$Form$fail = function (_v0) {
	return {e: _List_Nil, g: $author$project$OptionalResult$OptNothing};
};
var $author$project$Page$Register$JuridicalForm$nameAndIdFromString = function (nameAndId) {
	var _v0 = A2($elm$core$String$split, ';', nameAndId);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var id = _v0.a;
		var _v1 = _v0.b;
		var name = _v1.a;
		return $elm$core$Maybe$Just(
			{w: id, fj: name});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Register$JuridicalForm$nameAndIdToString = function (_v0) {
	var id = _v0.w;
	var name = _v0.fj;
	return id + (';' + name);
};
var $author$project$Page$Register$Common$phoneNumberField = function (_v0) {
	var t = _v0.fL;
	return A2(
		$author$project$Form$textField,
		{
			ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
			o3: function (phoneNumber) {
				return $author$project$Kyc$CostaRica$Phone$isValid(phoneNumber) ? $elm$core$Result$Ok(phoneNumber) : $elm$core$Result$Err(
					t('error.phone'));
			},
			qd: F2(
				function (phoneNumber, input) {
					return _Utils_update(
						input,
						{o7: phoneNumber});
				}),
			lW: function ($) {
				return $.o7;
			}
		},
		A2(
			$author$project$Form$Text$withType,
			1,
			A2(
				$author$project$Form$Text$withCounter,
				$author$project$Form$Text$CountLetters(8),
				A2(
					$author$project$Form$Text$withPlaceholder,
					t('register.form.phone.placeholder'),
					$author$project$Form$Text$init(
						{
							w: 'phone-input',
							n$: t('register.form.phone.label')
						})))));
};
var $author$project$Page$Register$JuridicalForm$form = F2(
	function (translators, unavailableAccounts) {
		var t = translators.fL;
		var unwrapId = function (_v11) {
			var id = _v11;
			return id;
		};
		return A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$textField,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: function (zip) {
						return A2($elm$core$List$member, zip, $author$project$Page$Register$JuridicalForm$costaRicaZipcodes) ? $elm$core$Result$Ok(zip) : $elm$core$Result$Err(
							t('error.zipcode'));
					},
					qd: F2(
						function (zip, input) {
							return _Utils_update(
								input,
								{fY: zip});
						}),
					lW: function ($) {
						return $.fY;
					}
				},
				A2(
					$author$project$Form$Text$withCounter,
					$author$project$Form$Text$CountLetters(5),
					$author$project$Form$Text$init(
						{
							w: 'zip-input',
							n$: t('register.form.zip.label')
						}))),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$textField,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: $elm$core$Result$Ok,
						qd: F2(
							function (number, input) {
								return _Utils_update(
									input,
									{d2: number});
							}),
						lW: function ($) {
							return $.d2;
						}
					},
					$author$project$Form$Text$init(
						{
							w: 'address-number-input',
							n$: t('register.form.number.label')
						})),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: $elm$core$Result$Ok,
							qd: F2(
								function (street, input) {
									return _Utils_update(
										input,
										{fK: street});
								}),
							lW: function ($) {
								return $.fK;
							}
						},
						$author$project$Form$Text$init(
							{
								w: 'street-input',
								n$: t('register.form.street.label')
							})),
					A2(
						$author$project$Form$with,
						$author$project$Form$introspect(
							function (_v6) {
								var city = _v6.mt;
								var state = _v6.Z;
								var country = _v6.mP;
								var availableDistricts = A3(
									$elm_community$maybe_extra$Maybe$Extra$andThen2,
									F2(
										function (validState, validCity) {
											return A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.oq;
												},
												A2(
													$elm$core$Maybe$andThen,
													function (_v9) {
														var cities = _v9.ms;
														return A2(
															$elm_community$list_extra$List$Extra$find,
															function (_v10) {
																var id = _v10.w;
																return _Utils_eq(
																	unwrapId(id),
																	validCity.w);
															},
															cities);
													},
													A2(
														$elm_community$list_extra$List$Extra$find,
														function (_v8) {
															var id = _v8.w;
															return _Utils_eq(
																unwrapId(id),
																validState.w);
														},
														country.pM)));
										}),
									state,
									city);
								if (availableDistricts.$ === 1) {
									return $author$project$Form$fail;
								} else {
									var districts = availableDistricts.a;
									return A3(
										$author$project$Form$select,
										$author$project$Page$Register$JuridicalForm$nameAndIdFromString,
										{
											ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
											o3: A2(
												$elm$core$Basics$composeR,
												$author$project$Form$Validate$succeed,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Form$Validate$required,
													$author$project$Form$Validate$validate(translators))),
											qd: F2(
												function (district, input) {
													return _Utils_update(
														input,
														{m0: district});
												}),
											lW: function ($) {
												return $.m0;
											}
										},
										A2(
											$author$project$Form$Select$withContainerAttrs,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mb-10')
												]),
											A2(
												$author$project$Form$Select$withOptions,
												A2(
													$elm$core$List$map,
													function (district) {
														return {
															n$: district.fj,
															gY: $elm$core$Maybe$Just(
																{
																	w: unwrapId(district.w),
																	fj: district.fj
																})
														};
													},
													districts),
												A3(
													$author$project$Form$Select$withOption,
													$elm$core$Maybe$Nothing,
													t('register.form.select.district'),
													$author$project$Form$Select$init(
														{
															w: 'district-select',
															n$: t('register.form.district'),
															d5: A2(
																$elm$core$Basics$composeR,
																$elm$core$Maybe$map($author$project$Page$Register$JuridicalForm$nameAndIdToString),
																$elm$core$Maybe$withDefault(''))
														})))));
								}
							}),
						A2(
							$author$project$Form$with,
							$author$project$Form$introspect(
								function (_v2) {
									var state = _v2.Z;
									var country = _v2.mP;
									if (state.$ === 1) {
										return $author$project$Form$fail;
									} else {
										var validState = state.a;
										var _v4 = A2(
											$elm_community$list_extra$List$Extra$find,
											function (_v5) {
												var id = _v5.w;
												return _Utils_eq(
													unwrapId(id),
													validState.w);
											},
											country.pM);
										if (_v4.$ === 1) {
											return $author$project$Form$fail;
										} else {
											var stateFromCountry = _v4.a;
											return A3(
												$author$project$Form$select,
												$author$project$Page$Register$JuridicalForm$nameAndIdFromString,
												{
													ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
													o3: A2(
														$elm$core$Basics$composeR,
														$author$project$Form$Validate$succeed,
														A2(
															$elm$core$Basics$composeR,
															$author$project$Form$Validate$required,
															$author$project$Form$Validate$validate(translators))),
													qd: F2(
														function (city, input) {
															return _Utils_update(
																input,
																{mt: city});
														}),
													lW: function ($) {
														return $.mt;
													}
												},
												A2(
													$author$project$Form$Select$withContainerAttrs,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('mb-10')
														]),
													A2(
														$author$project$Form$Select$withOptions,
														A2(
															$elm$core$List$map,
															function (city) {
																return {
																	n$: city.fj,
																	gY: $elm$core$Maybe$Just(
																		{
																			w: unwrapId(city.w),
																			fj: city.fj
																		})
																};
															},
															stateFromCountry.ms),
														A3(
															$author$project$Form$Select$withOption,
															$elm$core$Maybe$Nothing,
															t('register.form.select.city'),
															$author$project$Form$Select$init(
																{
																	w: 'city-select',
																	n$: t('register.form.city'),
																	d5: A2(
																		$elm$core$Basics$composeR,
																		$elm$core$Maybe$map($author$project$Page$Register$JuridicalForm$nameAndIdToString),
																		$elm$core$Maybe$withDefault(''))
																})))));
										}
									}
								}),
							A2(
								$author$project$Form$with,
								$author$project$Form$introspect(
									function (_v1) {
										var country = _v1.mP;
										return A3(
											$author$project$Form$select,
											$author$project$Page$Register$JuridicalForm$nameAndIdFromString,
											{
												ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
												o3: A2(
													$elm$core$Basics$composeR,
													$author$project$Form$Validate$succeed,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Form$Validate$required,
														$author$project$Form$Validate$validate(translators))),
												qd: F2(
													function (state, input) {
														return _Utils_update(
															input,
															{Z: state});
													}),
												lW: function ($) {
													return $.Z;
												}
											},
											A2(
												$author$project$Form$Select$withContainerAttrs,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-10')
													]),
												A2(
													$author$project$Form$Select$withOptions,
													A2(
														$elm$core$List$map,
														function (state) {
															return {
																n$: state.fj,
																gY: $elm$core$Maybe$Just(
																	{
																		w: unwrapId(state.w),
																		fj: state.fj
																	})
															};
														},
														country.pM),
													A3(
														$author$project$Form$Select$withOption,
														$elm$core$Maybe$Nothing,
														t('register.form.select.state'),
														$author$project$Form$Select$init(
															{
																w: 'state-select',
																n$: t('register.form.state'),
																d5: A2(
																	$elm$core$Basics$composeR,
																	$elm$core$Maybe$map($author$project$Page$Register$JuridicalForm$nameAndIdToString),
																	$elm$core$Maybe$withDefault(''))
															})))));
									}),
								A2(
									$author$project$Form$with,
									A2($author$project$Page$Register$Common$accountNameField, translators, unavailableAccounts),
									A2(
										$author$project$Form$with,
										$author$project$Page$Register$Common$phoneNumberField(translators),
										A2(
											$author$project$Form$with,
											$author$project$Page$Register$Common$emailField(translators),
											A2(
												$author$project$Form$with,
												A2(
													$author$project$Form$textField,
													{
														ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
														o3: $elm$core$Result$Ok,
														qd: F2(
															function (name, input) {
																return _Utils_update(
																	input,
																	{fj: name});
															}),
														lW: function ($) {
															return $.fj;
														}
													},
													A2(
														$author$project$Form$Text$withPlaceholder,
														t('register.form.name_example'),
														$author$project$Form$Text$init(
															{
																w: 'company-name-input',
																n$: t('register.form.company_name')
															}))),
												A2(
													$author$project$Form$with,
													$author$project$Form$introspect(
														function (_v0) {
															var companyType = _v0.mC;
															return A2(
																$author$project$Form$textField,
																{
																	ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
																	o3: $elm$core$Result$Ok,
																	qd: F2(
																		function (document, input) {
																			return _Utils_update(
																				input,
																				{eT: document});
																		}),
																	lW: function ($) {
																		return $.eT;
																	}
																},
																A2(
																	$author$project$Form$Text$withCounter,
																	$author$project$Form$Text$CountLetters(10),
																	A2(
																		$author$project$Form$Text$withPlaceholder,
																		t(
																			'register.form.company.' + ($author$project$Page$Register$JuridicalForm$companyTypeToString(companyType) + '.placeholder')),
																		$author$project$Form$Text$init(
																			{
																				w: 'document-input',
																				n$: t(
																					'register.form.company.' + ($author$project$Page$Register$JuridicalForm$companyTypeToString(companyType) + '.label'))
																			}))));
														}),
													A2(
														$author$project$Form$with,
														A3(
															$author$project$Form$select,
															A2(
																$elm$core$Basics$composeR,
																$author$project$Page$Register$JuridicalForm$companyTypeFromString,
																$elm$core$Maybe$withDefault(0)),
															{
																ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
																o3: $elm$core$Result$Ok,
																qd: F2(
																	function (companyType, input) {
																		return _Utils_update(
																			input,
																			{mC: companyType});
																	}),
																lW: function ($) {
																	return $.mC;
																}
															},
															A2(
																$author$project$Form$Select$withContainerAttrs,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-10')
																	]),
																A3(
																	$author$project$Form$Select$withOption,
																	1,
																	t('register.form.company.gran_empresa.label'),
																	A3(
																		$author$project$Form$Select$withOption,
																		0,
																		t('register.form.company.mipyme.label'),
																		$author$project$Form$Select$init(
																			{
																				w: 'company-type-select',
																				n$: t('register.form.company_type'),
																				d5: $author$project$Page$Register$JuridicalForm$companyTypeToString
																			}))))),
														$author$project$Form$succeed($author$project$Page$Register$JuridicalForm$FormOutput)))))))))))));
	});
var $author$project$Page$Register$NaturalForm$form = F2(
	function (translators, unavailableAccounts) {
		var t = translators.fL;
		return A2(
			$author$project$Form$with,
			A2($author$project$Page$Register$Common$accountNameField, translators, unavailableAccounts),
			A2(
				$author$project$Form$with,
				$author$project$Page$Register$Common$phoneNumberField(translators),
				A2(
					$author$project$Form$with,
					$author$project$Page$Register$Common$emailField(translators),
					A2(
						$author$project$Form$with,
						$author$project$Page$Register$Common$personNameField(translators),
						A2(
							$author$project$Form$with,
							$author$project$Form$introspect(
								function (_v0) {
									var documentType = _v0.eU;
									var documentLength = function () {
										switch (documentType) {
											case 0:
												return 9;
											case 2:
												return 10;
											default:
												return 12;
										}
									}();
									return A2(
										$author$project$Form$textField,
										{
											ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
											o3: $elm$core$Result$Ok,
											qd: F2(
												function (document, input) {
													return _Utils_update(
														input,
														{eT: document});
												}),
											lW: function ($) {
												return $.eT;
											}
										},
										A2(
											$author$project$Form$Text$withPlaceholder,
											t(
												'register.form.document.' + ($author$project$Page$Register$NaturalForm$documentTypeToString(documentType) + '.placeholder')),
											A2(
												$author$project$Form$Text$withCounter,
												$author$project$Form$Text$CountLetters(documentLength),
												$author$project$Form$Text$init(
													{
														w: 'document-input',
														n$: t(
															'register.form.document.' + ($author$project$Page$Register$NaturalForm$documentTypeToString(documentType) + '.label'))
													}))));
								}),
							A2(
								$author$project$Form$with,
								A3(
									$author$project$Form$select,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Page$Register$NaturalForm$documentTypeFromString,
										$elm$core$Maybe$withDefault(0)),
									{
										ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
										o3: $elm$core$Result$Ok,
										qd: F2(
											function (documentType, input) {
												return _Utils_update(
													input,
													{eU: documentType});
											}),
										lW: function ($) {
											return $.eU;
										}
									},
									A2(
										$author$project$Form$Select$withContainerAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-10')
											]),
										A3(
											$author$project$Form$Select$withOption,
											1,
											t('register.form.document.dimex.label'),
											A3(
												$author$project$Form$Select$withOption,
												2,
												t('register.form.document.nite.label'),
												A3(
													$author$project$Form$Select$withOption,
													0,
													t('register.form.document.cedula_de_identidad.label'),
													$author$project$Form$Select$init(
														{
															w: 'document-type-select',
															n$: t('register.form.document.type'),
															d5: $author$project$Page$Register$NaturalForm$documentTypeToString
														})))))),
								$author$project$Form$succeed($author$project$Page$Register$NaturalForm$FormOutput)))))));
	});
var $author$project$Page$Register$viewForm = F3(
	function (guest, unavailableAccounts, currentForm) {
		var _v0 = guest.A;
		var translators = _v0.aw;
		var helper = F4(
			function (formModel, form, toFormMsg, toFormOutput) {
				return A6(
					$author$project$Form$view,
					_List_Nil,
					translators,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Page$Register$viewFooter(guest),
						$elm$core$List$singleton),
					form,
					formModel,
					{
						oU: A2($elm$core$Basics$composeR, toFormOutput, $author$project$Page$Register$SubmittedForm),
						lF: A2($elm$core$Basics$composeR, toFormMsg, $author$project$Page$Register$GotFormMsg)
					});
			});
		switch (currentForm.$) {
			case 0:
				var form = currentForm.a;
				return A4(
					helper,
					form,
					A2($author$project$Page$Register$NaturalForm$form, translators, unavailableAccounts),
					$author$project$Page$Register$NaturalFormMsg,
					$author$project$Page$Register$NaturalFormOutput);
			case 1:
				var form = currentForm.a;
				return A4(
					helper,
					form,
					A2($author$project$Page$Register$JuridicalForm$form, translators, unavailableAccounts),
					$author$project$Page$Register$JuridicalFormMsg,
					$author$project$Page$Register$JuridicalFormOutput);
			default:
				var form = currentForm.a;
				return A4(
					helper,
					form,
					A2($author$project$Page$Register$DefaultForm$form, translators, unavailableAccounts),
					$author$project$Page$Register$DefaultFormMsg,
					$author$project$Page$Register$DefaultFormOutput);
		}
	});
var $author$project$Page$Register$viewTitleForStep = F2(
	function (_v0, s) {
		var t = _v0.fL;
		var tr = _v0.i4;
		var stepNum = function () {
			if (!s) {
				return '1';
			} else {
				return '2';
			}
		}();
		var isSavingPassphrase = function () {
			if (!s) {
				return false;
			} else {
				return true;
			}
		}();
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-4 py-4 font-bold md:mx-6'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('text-gray-333 border-t border-gray-500', !isSavingPassphrase),
							_Utils_Tuple2('text-white', isSavingPassphrase)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						tr,
						'register.form.step',
						_List_fromArray(
							[
								_Utils_Tuple2('stepNum', stepNum)
							]))),
					$elm$html$Html$text(' / '),
					$elm$html$Html$text(
					t('register.form.step' + (stepNum + '_title')))
				]));
	});
var $author$project$Page$Register$viewCreateAccount = F2(
	function (guest, model) {
		var formClasses = 'flex flex-grow flex-col bg-white px-4 md:px-0 md:pt-20 md:max-w-sm self-center w-full';
		var backgroundColor = function () {
			var _v2 = model.fJ;
			if (!_v2) {
				return 'bg-white';
			} else {
				return 'bg-purple-500';
			}
		}();
		var _v0 = guest.A;
		var translators = _v0.aw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('registrationPage'),
					$elm$html$Html$Attributes$class('flex flex-grow flex-col ' + backgroundColor)
				]),
			_List_fromArray(
				[
					A2($author$project$Page$Register$viewTitleForStep, translators, model.fJ),
					function () {
					var _v1 = model.pN;
					switch (_v1.$) {
						case 0:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h-full full-spinner-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('spinner spinner-light')
											]),
										_List_Nil)
									]));
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(formClasses)
									]),
								_List_fromArray(
									[
										A2($author$project$Page$Register$viewAccountTypeSelector, translators, model),
										A2(
										$author$project$Page$Register$viewFooter,
										guest,
										function (attrs) {
											return $elm$html$Html$button(
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Attributes$disabled(true),
													attrs));
										})
									]));
						case 2:
							var unavailableAccounts = _v1.a;
							var formModel = _v1.b;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(formClasses)
									]),
								_List_fromArray(
									[
										A2($author$project$Page$Register$viewAccountTypeSelector, translators, model),
										A3($author$project$Page$Register$viewForm, guest, unavailableAccounts, formModel)
									]));
						case 3:
							var accountKeys = _v1.a;
							return A3($author$project$Page$Register$viewAccountCreated, translators, model, accountKeys);
						case 4:
							return A2(
								$author$project$Page$fullPageNotFound,
								translators.fL('error.unknown'),
								'');
						default:
							return A2(
								$author$project$Page$fullPageNotFound,
								translators.fL('error.pageNotFound'),
								'');
					}
				}()
				]));
	});
var $author$project$Page$Register$view = F2(
	function (guest, model) {
		var shared = guest.A;
		var _v0 = shared.aw;
		var t = _v0.fL;
		var content = function () {
			var _v1 = guest.V;
			switch (_v1.$) {
				case 3:
					var community = _v1.a;
					var hasInvite = function () {
						var _v2 = model.dO;
						if (!_v2.$) {
							return true;
						} else {
							return false;
						}
					}();
					return (community.bx || hasInvite) ? A2($author$project$Page$Register$viewCreateAccount, guest, model) : $author$project$Page$fullPageLoading(shared);
				case 0:
					return $author$project$Page$fullPageLoading(shared);
				case 1:
					return $author$project$Page$fullPageLoading(shared);
				default:
					var e = _v1.a;
					return A2(
						$author$project$Page$fullPageGraphQLError,
						t('register.registerTab'),
						e);
			}
		}();
		return {
			mJ: content,
			fN: t('register.registerTab')
		};
	});
var $author$project$Page$Settings$ClickedChangePin = {$: 6};
var $author$project$Page$Settings$ClickedDeleteKyc = {$: 11};
var $author$project$Page$Settings$ClickedDownloadPdf = {$: 1};
var $author$project$Page$Settings$ClickedExportToSimpleos = {$: 2};
var $author$project$Page$Settings$viewCardItem = function (body) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-between py-4 first:pt-0 last:pb-0')
			]),
		body);
};
var $author$project$Page$Settings$viewAccountSettings = function (loggedIn) {
	var _v0 = loggedIn.A.aw;
	var t = _v0.fL;
	var tr = _v0.i4;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-4')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Markdown$view,
					_List_Nil,
					A2($author$project$Markdown$fromTranslation, loggedIn.A.aw, 'settings.account.account_settings'))
				])),
			A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white rounded-md p-4 divide-y')
				]),
			_List_fromArray(
				[
					$author$project$Page$Settings$viewCardItem(
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('profile.12words.title')),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary flex-shrink-0 ml-4'),
									$elm$html$Html$Events$onClick($author$project$Page$Settings$ClickedDownloadPdf)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('profile.12words.button'))
								]))
						])),
					$author$project$Page$Settings$viewCardItem(
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('settings.account.my_private_key')),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary flex-shrink-0 ml-4'),
									$elm$html$Html$Events$onClick($author$project$Page$Settings$ClickedExportToSimpleos)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('menu.export'))
								]))
						])),
					$author$project$Page$Settings$viewCardItem(
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('profile.pin.title')),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary flex-shrink-0 ml-4'),
									$elm$html$Html$Events$onClick($author$project$Page$Settings$ClickedChangePin)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('profile.pin.button'))
								]))
						])),
					function () {
					var _v1 = loggedIn.pl;
					switch (_v1.$) {
						case 3:
							var profile = _v1.a;
							return $author$project$Page$Settings$viewCardItem(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex items-center')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('community.kyc.dataTitle')),
														$author$project$View$Components$tooltip(
														{
															mG: '',
															nx: 'text-orange-300',
															of: t('community.kyc.info')
														})
													])),
												function () {
												var _v2 = profile.ib;
												if (!_v2.$) {
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('uppercase text-red mt-2 text-sm')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																t('community.kyc.delete.warning'))
															]));
												} else {
													return $elm$html$Html$text('');
												}
											}()
											])),
										function () {
										var _v3 = profile.ib;
										if (!_v3.$) {
											return A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('button button-danger flex-shrink-0 ml-4'),
														$elm$html$Html$Events$onClick($author$project$Page$Settings$ClickedDeleteKyc)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('community.kyc.delete.label'))
													]));
										} else {
											return A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('button button-secondary ml-4'),
														$author$project$Route$href($author$project$Route$ProfileAddKyc)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('menu.add'))
													]));
										}
									}()
									]));
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full max-w-xs h-6 rounded-md mt-4 mb-4 animate-skeleton-loading')
									]),
								_List_Nil);
						case 0:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full max-w-xs h-6 rounded-md mt-4 mb-4 animate-skeleton-loading')
									]),
								_List_Nil);
						default:
							return $elm$html$Html$text('');
					}
				}()
				]))
		]);
};
var $author$project$Page$Settings$AcceptedDeleteKyc = {$: 13};
var $author$project$Page$Settings$ClosedDeleteKycModal = {$: 12};
var $author$project$Page$Settings$viewDeleteKycModal = F2(
	function (_v0, model) {
		var t = _v0.fL;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withFooter,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-cancel'),
								$elm$html$Html$Events$onClick($author$project$Page$Settings$ClosedDeleteKycModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('community.kyc.delete.cancel'))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-accept'),
								$elm$html$Html$Events$onClick($author$project$Page$Settings$AcceptedDeleteKyc)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('community.kyc.delete.confirm'))
							]))
					]),
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('community.kyc.delete.confirmationBody'))
						]),
					A2(
						$author$project$View$Modal$withHeader,
						t('community.kyc.delete.confirmationHeader'),
						$author$project$View$Modal$initWith(
							{mw: $author$project$Page$Settings$ClosedDeleteKycModal, nX: model.dQ})))));
	});
var $author$project$Page$Settings$ClickedCopyPrivateKey = {$: 3};
var $author$project$Page$Settings$ClosedExportToSimpleosModal = {$: 5};
var $author$project$Eos$Account$privateKeyToString = function (_v0) {
	var pk = _v0;
	return pk;
};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$Page$Settings$viewExportToSimpleosModal = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.ml.pN;
		if (_v0.$ === 1) {
			var privateKey = _v0.a;
			var _v1 = loggedIn.A.aw;
			var t = _v1.fL;
			return $author$project$View$Modal$toHtml(
				A2(
					$author$project$View$Modal$withFooter,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-cancel'),
									$elm$html$Html$Events$onClick($author$project$Page$Settings$ClosedExportToSimpleosModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('menu.close'))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-accept'),
									$elm$html$Html$Events$onClick($author$project$Page$Settings$ClickedCopyPrivateKey)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('menu.copy'))
								]))
						]),
					A2(
						$author$project$View$Modal$withBody,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('settings.account.export_private_key_details')),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('hover:underline text-orange-300'),
												$elm$html$Html$Attributes$href('https://eosrio.io/simpleos/'),
												$elm$html$Html$Attributes$target('_blank'),
												$elm$html$Html$Attributes$rel('noopener')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Simpleos')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex w-full items-center justify-center p-4 bg-gray-200 rounded mt-4 select-all')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Eos$Account$privateKeyToString(privateKey))
									])),
								A2(
								$author$project$Form$Text$view,
								A2(
									$author$project$Form$Text$withInputElement,
									$author$project$Form$Text$TextareaInput(
										{pR: false}),
									A2(
										$author$project$Form$Text$withContainerAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('h-0 absolute opacity-0 left-[-9999em] !mb-0 overflow-hidden'),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										A2(
											$author$project$Form$Text$withExtraAttrs,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$tabindex(-1),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
												]),
											$author$project$Form$Text$init(
												{w: 'private-key-copy-input', n$: ''})))),
								{
									na: $elm$html$Html$text(''),
									no: false,
									nV: false,
									oF: $author$project$Page$Settings$NoOp,
									oH: function (_v2) {
										return $author$project$Page$Settings$NoOp;
									},
									aw: loggedIn.A.aw,
									lW: $author$project$Eos$Account$privateKeyToString(privateKey)
								})
							]),
						A2(
							$author$project$View$Modal$withHeader,
							t('settings.account.export_private_key'),
							$author$project$View$Modal$initWith(
								{mw: $author$project$Page$Settings$ClosedExportToSimpleosModal, nX: model.dT})))));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Page$Settings$ClosedNewPinModal = {$: 7};
var $author$project$Page$Settings$viewNewPinModal = F2(
	function (translators, model) {
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-sm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								translators.fL('profile.changePinPrompt'))
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Page$Settings$GotPinMsg,
						A2($author$project$View$Pin$view, translators, model.c_))
					]),
				A2(
					$author$project$View$Modal$withHeader,
					translators.fL('profile.changePin'),
					$author$project$View$Modal$initWith(
						{mw: $author$project$Page$Settings$ClosedNewPinModal, nX: model.dV}))));
	});
var $author$project$Page$Settings$ToggledClaimNotification = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$Settings$ToggledDigestNotification = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$Settings$ToggledTransferNotification = function (a) {
	return {$: 16, a: a};
};
var $author$project$Form$Toggle$withToggleContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				hi: _Utils_ap(options.hi, attrs)
			});
	});
var $author$project$Page$Settings$viewNotificationToggle = F2(
	function (translators, _v0) {
		var label = _v0.n$;
		var id = _v0.w;
		var onToggle = _v0.oW;
		var value = _v0.lW;
		return function (options) {
			return A2(
				$author$project$Form$Toggle$view,
				options,
				{
					na: $elm$html$Html$text(''),
					no: false,
					nV: false,
					oF: $author$project$Page$Settings$NoOp,
					oW: onToggle,
					aw: translators,
					lW: value
				});
		}(
			A2(
				$author$project$Form$Toggle$withToggleContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-40 flex items-center flex-shrink-0')
					]),
				A2(
					$author$project$Form$Toggle$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full')
						]),
					$author$project$Form$Toggle$init(
						{
							w: id,
							n$: $elm$html$Html$text(label)
						}))));
	});
var $author$project$Page$Settings$viewNotificationPreferences = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4 mt-10')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Markdown$view,
						_List_Nil,
						A2($author$project$Markdown$fromTranslation, loggedIn.A.aw, 'settings.account.notification_settings'))
					])),
				function () {
				var _v1 = loggedIn.pl;
				switch (_v1.$) {
					case 3:
						var profile = _v1.a;
						var updatingOrProfile = F2(
							function (modelGetter, profileGetter) {
								var _v2 = modelGetter(model);
								if (_v2.$ === 1) {
									var newValue = _v2.a;
									return newValue;
								} else {
									return profileGetter(profile);
								}
							});
						return A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white rounded-md p-4 divide-y')
								]),
							_List_fromArray(
								[
									$author$project$Page$Settings$viewCardItem(
									_List_fromArray(
										[
											A2(
											$author$project$Page$Settings$viewNotificationToggle,
											loggedIn.A.aw,
											{
												w: 'claim_notification',
												n$: t('profile.preferences.claim_notification'),
												oW: $author$project$Page$Settings$ToggledClaimNotification,
												lW: A2(
													updatingOrProfile,
													function ($) {
														return $.cB;
													},
													function ($) {
														return $.dq;
													})
											})
										])),
									$author$project$Page$Settings$viewCardItem(
									_List_fromArray(
										[
											A2(
											$author$project$Page$Settings$viewNotificationToggle,
											loggedIn.A.aw,
											{
												w: 'transfer_notification',
												n$: t('profile.preferences.transfer_notification'),
												oW: $author$project$Page$Settings$ToggledTransferNotification,
												lW: A2(
													updatingOrProfile,
													function ($) {
														return $.da;
													},
													function ($) {
														return $.ep;
													})
											})
										])),
									$author$project$Page$Settings$viewCardItem(
									_List_fromArray(
										[
											A2(
											$author$project$Page$Settings$viewNotificationToggle,
											loggedIn.A.aw,
											{
												w: 'digest_notification',
												n$: t('profile.preferences.digest'),
												oW: $author$project$Page$Settings$ToggledDigestNotification,
												lW: A2(
													updatingOrProfile,
													function ($) {
														return $.cG;
													},
													function ($) {
														return $.dx;
													})
											})
										]))
								]));
					case 1:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white rounded-md p-4 divide-y')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full max-w-xs h-4 mb-4 animate-skeleton-loading')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full max-w-sm h-4 my-4 animate-skeleton-loading')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full max-w-27 h-4 mt-4 animate-skeleton-loading')
										]),
									_List_Nil)
								]));
					case 0:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white rounded-md p-4 divide-y')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full max-w-xs h-4 mb-4 animate-skeleton-loading')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full max-w-sm h-4 my-4 animate-skeleton-loading')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full max-w-27 h-4 mt-4 animate-skeleton-loading')
										]),
									_List_Nil)
								]));
					default:
						var err = _v1.a;
						return $elm$html$Html$text('');
				}
			}()
			]);
	});
var $author$project$Page$Settings$view = F2(
	function (loggedIn, model) {
		var title = loggedIn.A.aw.fL('settings.account.title');
		return {
			mJ: A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Page$viewHeader, loggedIn, title),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container mx-auto px-4 mt-6 mb-20')
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									$author$project$Page$Settings$viewAccountSettings(loggedIn),
									A2($author$project$Page$Settings$viewNotificationPreferences, loggedIn, model),
									_List_fromArray(
									[
										A2($author$project$Page$Settings$viewExportToSimpleosModal, loggedIn, model),
										A2($author$project$Page$Settings$viewNewPinModal, loggedIn.A.aw, model),
										A2($author$project$Page$Settings$viewDeleteKycModal, loggedIn.A.aw, model)
									])
								])))
					])),
			fN: title
		};
	});
var $author$project$Page$Shop$ClickedAcceptCodeOfConduct = {$: 4};
var $author$project$Page$Shop$viewEmptyState = F3(
	function (loggedIn, communitySymbol, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var tr = _v0.i4;
		var title = function () {
			var _v2 = model.N.o1;
			if (!_v2.$) {
				var userName = _v2.a;
				return _Utils_eq(userName, loggedIn._) ? $elm$html$Html$text(
					t('shop.empty.user_title')) : $elm$html$Html$text(
					t('shop.empty.all_title'));
			} else {
				return $elm$html$Html$text(
					t('shop.empty.all_title'));
			}
		}();
		var description = function () {
			var _v1 = model.N.o1;
			if (!_v1.$) {
				var userName = _v1.a;
				return _Utils_eq(userName, loggedIn._) ? _List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							tr,
							'shop.empty.you_can_offer',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'symbol',
									$author$project$Eos$symbolToSymbolCodeString(communitySymbol))
								])))
					]) : _List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							tr,
							'shop.empty.user_is_not_selling',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'user',
									$author$project$Eos$Account$nameToString(userName))
								]))),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text(
						t('shop.empty.offer_something'))
					]);
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text(
						t('shop.empty.no_one_is_selling')),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text(
						t('shop.empty.offer_something'))
					]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center justify-center my-10')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/images/seller_confused.svg'),
							$elm$html$Html$Attributes$alt('')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold text-black mt-4 text-center')
						]),
					_List_fromArray(
						[title])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black text-center mt-4')
						]),
					description),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button button-primary mt-6 md:px-6 w-full md:w-max'),
							$author$project$Route$href(
							$author$project$Route$NewSale(0))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('shop.empty.create_new'))
						]))
				]));
	});
var $author$project$Page$Shop$viewEmptyStateWithFilters = function (_v0) {
	var t = _v0.fL;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col items-center mt-16 mb-10')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$alt(''),
						$elm$html$Html$Attributes$src('/images/not_found.svg'),
						$elm$html$Html$Attributes$class('w-1/2 md:w-40')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-6 text-gray-900')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						t('shop.empty.no_results_found'))
					])),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button button-secondary mt-2'),
						$author$project$Route$href(
						$author$project$Route$Shop(
							{dn: _List_Nil, o1: $elm$core$Maybe$Nothing}))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						t('shop.empty.clear_filters'))
					]))
			]));
};
var $author$project$Page$Shop$viewFilterTags = F2(
	function (community, model) {
		var getCategory = function (categoryId) {
			return A2(
				$elm$core$Maybe$andThen,
				$author$project$Utils$Tree$findInForest(
					function (category) {
						return _Utils_eq(category.w, categoryId);
					}),
				$krisajenkins$remotedata$RemoteData$toMaybe(community.fC));
		};
		var viewAppliedFilter = function (categoryId) {
			var _v0 = getCategory(categoryId);
			if (_v0.$ === 1) {
				return $elm$html$Html$text('');
			} else {
				var category = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white text-orange-300 rounded-sm flex items-center justify-center font-bold p-2 gap-4 flex-shrink-0 mr-4 sm:last:mr-0')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(category.fj),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('focus-ring focus:ring-offset-4 rounded-sm'),
									$author$project$Route$href(
									$author$project$Route$Shop(
										{
											dn: A2(
												$elm$core$List$filter,
												function (id) {
													return !_Utils_eq(id, categoryId);
												},
												model.N.dn),
											o1: model.N.o1
										}))
								]),
							_List_fromArray(
								[
									$author$project$Icons$close('fill-current w-3.5')
								]))
						]));
			}
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto pl-4 mt-4 sm:pr-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex overflow-auto focus-ring rounded-sm')
						]),
					A2($elm$core$List$map, viewAppliedFilter, model.N.dn))
				]));
	});
var $author$project$Page$Shop$ClosedFiltersModal = {$: 9};
var $author$project$Page$Shop$SubmittedFiltersForm = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Shop$FiltersFormOutput = F2(
	function (owner, categories) {
		return {dn: categories, o1: owner};
	});
var $author$project$Page$Shop$categoriesForm = F2(
	function (_v0, allCategories) {
		var t = _v0.fL;
		var checkbox = function (category) {
			return A2(
				$author$project$Form$checkbox,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: function (value) {
						return value ? $elm$core$Result$Ok(
							$elm$core$Maybe$Just(category.w)) : $elm$core$Result$Ok($elm$core$Maybe$Nothing);
					},
					qd: $pzp1997$assoc_list$AssocList$insert(category),
					lW: function (input) {
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2($pzp1997$assoc_list$AssocList$get, category, input));
					}
				},
				A2(
					$author$project$Form$Checkbox$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex')
						]),
					$author$project$Form$Checkbox$init(
						{
							w: 'category-' + $author$project$Shop$Category$idToString(category.w),
							n$: A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center gap-x-2')
									]),
								_List_fromArray(
									[
										function () {
										var _v2 = category.p;
										if (_v2.$ === 1) {
											return $elm$html$Html$text('');
										} else {
											var icon = _v2.a;
											return A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-5 h-5 rounded-full'),
														$elm$html$Html$Attributes$alt(''),
														$elm$html$Html$Attributes$src(icon)
													]),
												_List_Nil);
										}
									}(),
										$elm$html$Html$text(category.fj)
									]))
						})));
		};
		var treeToForm = function (tree) {
			return A4(
				$author$project$Form$withGroup,
				_List_Nil,
				checkbox(
					$zwilias$elm_rosetree$Tree$label(tree)),
				$elm$core$List$isEmpty(
					$zwilias$elm_rosetree$Tree$children(tree)) ? $author$project$Form$succeed(_List_Nil) : A2(
					$author$project$Form$mapOutput,
					$elm$core$List$concat,
					A2(
						$author$project$Form$list,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-4 mt-4 flex flex-col gap-y-4')
							]),
						A2(
							$elm$core$List$map,
							treeToForm,
							$zwilias$elm_rosetree$Tree$children(tree)))),
				$author$project$Form$succeed(
					F2(
						function (label, children) {
							if (label.$ === 1) {
								return children;
							} else {
								var head = label.a;
								return A2($elm$core$List$cons, head, children);
							}
						})));
		};
		return A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$mapValues,
				{
					qd: F2(
						function (newChild, parent) {
							return _Utils_update(
								parent,
								{dn: newChild});
						}),
					lW: function ($) {
						return $.dn;
					}
				},
				A2(
					$author$project$Form$mapOutput,
					$elm$core$List$concat,
					A2(
						$author$project$Form$list,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col gap-y-4')
							]),
						A2($elm$core$List$map, treeToForm, allCategories)))),
			$author$project$Form$succeed($elm$core$Basics$identity));
	});
var $author$project$Page$Shop$ownerForm = F2(
	function (_v0, currentUser) {
		var t = _v0.fL;
		return A3(
			$author$project$Form$radio,
			function (account) {
				return $elm$core$String$isEmpty(account) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Eos$Account$stringToName(account));
			},
			{
				ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				o3: $elm$core$Result$Ok,
				qd: F2(
					function (owner, values) {
						return _Utils_update(
							values,
							{o1: owner});
					}),
				lW: function ($) {
					return $.o1;
				}
			},
			A2(
				$author$project$Form$Radio$withContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-6')
					]),
				A2(
					$author$project$Form$Radio$withDirection,
					1,
					A3(
						$author$project$Form$Radio$withOption,
						$elm$core$Maybe$Just(currentUser),
						$elm$html$Html$text(
							t('shop.filters.offers.mine')),
						A3(
							$author$project$Form$Radio$withOption,
							$elm$core$Maybe$Nothing,
							$elm$html$Html$text(
								t('shop.filters.offers.all')),
							$author$project$Form$Radio$init(
								{
									w: 'offers-radio',
									n$: t('shop.filters.offers.label'),
									d5: function (maybeAccount) {
										if (maybeAccount.$ === 1) {
											return '';
										} else {
											var account = maybeAccount.a;
											return $author$project$Eos$Account$nameToString(account);
										}
									}
								}))))));
	});
var $author$project$Page$Shop$filtersForm = F2(
	function (loggedIn, allCategories) {
		var loadingItem = function (width) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center gap-x-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('animate-skeleton-loading h-5 rounded w-5')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('animate-skeleton-loading h-5 rounded-full w-5')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('animate-skeleton-loading h-5 rounded-sm'),
								$elm$html$Html$Attributes$class(width)
							]),
						_List_Nil)
					]));
		};
		var loadingForm = A2(
			$author$project$Form$arbitraryWith,
			_List_Nil,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-y-4')
					]),
				_List_fromArray(
					[
						loadingItem('w-1/2'),
						loadingItem('w-2/3'),
						loadingItem('w-1/3'),
						loadingItem('w-1/2')
					])));
		return A2(
			$author$project$Form$with,
			function () {
				switch (allCategories.$) {
					case 3:
						var categories = allCategories.a;
						return $elm$core$List$isEmpty(categories) ? $author$project$Form$succeed(_List_Nil) : A2($author$project$Page$Shop$categoriesForm, loggedIn.A.aw, categories);
					case 1:
						return loadingForm;
					case 0:
						return loadingForm;
					default:
						return A2(
							$author$project$Form$arbitraryWith,
							_List_Nil,
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-error')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										loggedIn.A.aw.fL('shop.filters.categories.error_fetching'))
									])));
				}
			}(),
			A2(
				$author$project$Form$withNoOutput,
				function () {
					if (allCategories.$ === 3) {
						var categories = allCategories.a;
						return $elm$core$List$isEmpty(categories) ? $author$project$Form$succeed(_List_Nil) : $author$project$Form$arbitrary(
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										loggedIn.A.aw.fL('settings.shop.categories.title'))
									])));
					} else {
						return $author$project$Form$arbitrary(
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										loggedIn.A.aw.fL('settings.shop.categories.title'))
									])));
					}
				}(),
				A2(
					$author$project$Form$with,
					A2($author$project$Page$Shop$ownerForm, loggedIn.A.aw, loggedIn._),
					$author$project$Form$succeed($author$project$Page$Shop$FiltersFormOutput))));
	});
var $author$project$Page$Shop$viewFiltersModal = F2(
	function (loggedIn, model) {
		var categories = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$elm$core$Tuple$second,
			A2(
				$author$project$Community$getField,
				loggedIn.pC,
				function ($) {
					return $.fC;
				}));
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withSize,
				0,
				A2(
					$author$project$View$Modal$withFooter,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary w-full'),
									$elm$html$Html$Events$onClick(
									A3(
										$author$project$Form$parse,
										A2($author$project$Page$Shop$filtersForm, loggedIn, categories),
										model.eZ,
										{oM: $author$project$Page$Shop$GotFiltersFormMsg, oV: $author$project$Page$Shop$SubmittedFiltersForm}))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									loggedIn.A.aw.fL('shop.filters.apply'))
								]))
						]),
					A2(
						$author$project$View$Modal$withBody,
						_List_fromArray(
							[
								A6(
								$author$project$Form$viewWithoutSubmit,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-4')
									]),
								loggedIn.A.aw,
								function (_v0) {
									return _List_Nil;
								},
								A2($author$project$Page$Shop$filtersForm, loggedIn, categories),
								model.eZ,
								{lF: $author$project$Page$Shop$GotFiltersFormMsg})
							]),
						A2(
							$author$project$View$Modal$withHeader,
							loggedIn.A.aw.fL('shop.filters.title'),
							$author$project$View$Modal$initWith(
								{mw: $author$project$Page$Shop$ClosedFiltersModal, nX: model.dU}))))));
	});
var $author$project$Page$Shop$viewFoundOffersAmount = F3(
	function (translators, community, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white w-full py-4 mt-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto flex w-full justify-between px-4')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = model.a2;
							if (_v0.$ === 1) {
								var cards = _v0.a;
								return ($elm$core$List$length(cards) === 1) ? A2(
									$author$project$Markdown$view,
									_List_Nil,
									A2($author$project$Markdown$fromTranslation, translators, 'shop.filters.found_single_offer')) : A2(
									$author$project$Markdown$view,
									_List_Nil,
									A3(
										$author$project$Markdown$fromTranslationWithReplacements,
										translators,
										'shop.filters.found_offers',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'count',
												$elm$core$String$fromInt(
													$elm$core$List$length(cards)))
											])));
							} else {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-44 rounded-md animate-skeleton-loading')
										]),
									_List_Nil);
							}
						}(),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-orange-300 hover:underline flex-shrink-0 focus-ring rounded-sm focus:ring-offset-2'),
									$author$project$Route$href(
									$author$project$Route$Shop(
										{dn: _List_Nil, o1: model.N.o1}))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									translators.fL('shop.empty.clear_filters'))
								]))
						]))
				]));
	});
var $author$project$Page$Shop$ClickedScrollToImage = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Shop$ImageStartedIntersecting = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Page$Shop$ImageStoppedIntersecting = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Shop$ImageId = $elm$core$Basics$identity;
var $author$project$Shop$viewImageCarrousel = F4(
	function (_v0, _v1, options, _v2) {
		var t = _v0.fL;
		var tr = _v0.i4;
		var containerAttrs = _v1.mF;
		var listAttrs = _v1.n7;
		var imageContainerAttrs = _v1.nz;
		var imageOverlayAttrs = _v1.nB;
		var imageAttrs = _v1.ny;
		var firstImage = _v2.a;
		var otherImages = _v2.b;
		var maybeProductId = A2(
			$elm$core$Maybe$map,
			function (_v12) {
				var opaqueId = _v12;
				return opaqueId;
			},
			options.pk);
		var indexFromImageId = function (_v11) {
			var imgId = _v11;
			if (maybeProductId.$ === 1) {
				return $elm$core$String$toInt(
					A2($elm$core$String$dropLeft, 14, imgId));
			} else {
				var productId = maybeProductId.a;
				return $elm$core$String$toInt(
					A2(
						$elm$core$String$dropLeft,
						$elm$core$String$length(
							'product-image-' + ($elm$core$String$fromInt(productId) + '-')),
						imgId));
			}
		};
		var maybeCurrentIntersectingIndex = A2($elm$core$Maybe$andThen, indexFromImageId, options.mT);
		var imageUrls = A2($elm$core$List$cons, firstImage, otherImages);
		var imageId = function (index) {
			if (maybeProductId.$ === 1) {
				return 'product-image-' + $elm$core$String$fromInt(index);
			} else {
				var productId = maybeProductId.a;
				return 'product-image-' + ($elm$core$String$fromInt(productId) + ('-' + $elm$core$String$fromInt(index)));
			}
		};
		var isCurrentIntersecting = function (imageIndex) {
			var _v8 = options.mT;
			if (_v8.$ === 1) {
				return false;
			} else {
				var currentIntersecting = _v8.a;
				return _Utils_eq(
					currentIntersecting,
					imageId(imageIndex));
			}
		};
		var containerId = function () {
			if (maybeProductId.$ === 1) {
				return 'image-carrousel';
			} else {
				var productId = maybeProductId.a;
				return 'image-carrousel-' + $elm$core$String$fromInt(productId);
			}
		}();
		var clickedScrollToImage = function (imageIndex) {
			return options.oQ(
				{
					mI: containerId,
					nA: imageId(imageIndex)
				});
		};
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('relative'),
				containerAttrs),
			_List_fromArray(
				[
					function () {
					if (maybeCurrentIntersectingIndex.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var currentIntersectingIndex = maybeCurrentIntersectingIndex.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute left-4 bottom-1/2 translate-y-1/2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-white/80 rounded-full transition-all origin-left'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('hidden', !options.pF),
													_Utils_Tuple2('opacity-0 scale-50 pointer-events-none', !currentIntersectingIndex)
												])),
											$elm$html$Html$Events$onClick(
											clickedScrollToImage(currentIntersectingIndex - 1)),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											t('shop.carrousel.previous')),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(!currentIntersectingIndex)
										]),
									_List_fromArray(
										[
											$author$project$Icons$arrowDown('rotate-90')
										]))
								]));
					}
				}(),
					A2(
					$elm$html$Html$ul,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('flex h-full min-w-full overflow-x-scroll overflow-y-hidden snap-x scrollbar-hidden'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$id(containerId),
							listAttrs)),
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, image) {
								return A2(
									$elm$html$Html$div,
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('w-full h-full flex-shrink-0 snap-center snap-always grid place-items-center'),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$id(
												imageId(index)),
											imageContainerAttrs)),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$src(image),
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Attributes$alt(''),
													A2(
														$elm$core$List$cons,
														$elm$html$Html$Attributes$class('object-cover object-center max-w-full max-h-full'),
														imageAttrs))),
											_List_Nil)
										]));
							}),
						imageUrls)),
					function () {
					if (maybeCurrentIntersectingIndex.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var currentIntersectingIndex = maybeCurrentIntersectingIndex.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute right-4 bottom-1/2 translate-y-1/2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-white/80 rounded-full transition-all origin-right'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('hidden', !options.pF),
													_Utils_Tuple2(
													'opacity-0 scale-50 pointer-events-none',
													_Utils_eq(
														currentIntersectingIndex,
														$elm$core$List$length(imageUrls) - 1))
												])),
											$elm$html$Html$Events$onClick(
											clickedScrollToImage(currentIntersectingIndex + 1)),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											t('shop.carrousel.next')),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(
											_Utils_eq(
												currentIntersectingIndex,
												$elm$core$List$length(imageUrls) - 1))
										]),
									_List_fromArray(
										[
											$author$project$Icons$arrowDown('-rotate-90')
										]))
								]));
					}
				}(),
					($elm$core$List$length(imageUrls) === 1) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10')
						]),
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, _v5) {
								return A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('border-2 w-2 h-2 rounded-full transition-colors'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'bg-white border-orange-500',
													isCurrentIntersecting(index)),
													_Utils_Tuple2(
													'bg-white border-white',
													!isCurrentIntersecting(index))
												])),
											$author$project$Utils$onClickPreventAll(
											clickedScrollToImage(index)),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											A2(
												tr,
												'shop.carrousel.index',
												_List_fromArray(
													[
														_Utils_Tuple2(
														'index',
														$elm$core$String$fromInt(index + 1))
													])))
										]),
									_List_Nil);
							}),
						imageUrls)),
					($elm$core$List$length(imageUrls) === 1) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('bg-gradient-to-t from-black/40 to-transparent absolute bottom-0 left-0 right-0 h-10'),
						imageOverlayAttrs),
					_List_Nil),
					$author$project$View$Components$intersectionObserver(
					{
						mm: $elm$core$Maybe$Nothing,
						oS: $elm$core$Maybe$Just(
							A2($elm$core$Basics$composeR, $elm$core$Basics$identity, options.oS)),
						oT: $elm$core$Maybe$Just(
							A2($elm$core$Basics$composeR, $elm$core$Basics$identity, options.oT)),
						p_: A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, _v6) {
									return '#' + imageId(index);
								}),
							imageUrls),
						p2: 0.01
					})
				]));
	});
var $author$project$Page$Shop$viewCard = F3(
	function (loggedIn, index, card) {
		var isFree = !card.pi.iJ;
		var translators = loggedIn.A.aw;
		var t = translators.fL;
		var tr = translators.i4;
		var images = function () {
			var _v0 = card.pi.h5;
			if (!_v0.b) {
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-32 rounded-t object-cover'),
							$elm$html$Html$Attributes$alt(''),
							$elm$html$Html$Attributes$src(
							'/icons/shop-placeholder' + ($elm$core$String$fromInt(
								A2($elm$core$Basics$modBy, 3, index)) + '.svg'))
						]),
					_List_Nil);
			} else {
				var firstImage = _v0.a;
				var otherImages = _v0.b;
				return A4(
					$author$project$Shop$viewImageCarrousel,
					translators,
					{
						mF: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('h-32')
							]),
						ny: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full h-full')
							]),
						nz: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-white rounded-t')
							]),
						nB: _List_Nil,
						n7: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('gap-x-4 rounded-t bg-gray-100')
							])
					},
					{
						mT: card.cE,
						oQ: $author$project$Page$Shop$ClickedScrollToImage,
						oS: $author$project$Page$Shop$ImageStartedIntersecting(card.pi.w),
						oT: $author$project$Page$Shop$ImageStoppedIntersecting(card.pi.w),
						pk: $elm$core$Maybe$Just(card.pi.w),
						pF: false
					},
					_Utils_Tuple2(firstImage, otherImages));
			}
		}();
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('rounded bg-white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-full flex flex-col hover:shadow-md transition-shadow duration-300'),
							$elm$html$Html$Attributes$title(card.pi.fN),
							$author$project$Route$href(
							$author$project$Route$ViewSale(card.pi.w))
						]),
					_List_fromArray(
						[
							images,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('p-4 flex flex-col flex-grow')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('line-clamp-3 text-black')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(card.pi.fN)
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold text-gray-900 text-sm uppercase mb-auto line-clamp-2 mt-1')
										]),
									_List_fromArray(
										[
											_Utils_eq(loggedIn._, card.pi.mR) ? $elm$html$Html$text(
											t('shop.by_you')) : $elm$html$Html$text(
											A2(
												tr,
												'shop.by_user',
												_List_fromArray(
													[
														_Utils_Tuple2(
														'user',
														A2(
															$elm$core$Maybe$withDefault,
															$author$project$Eos$Account$nameToString(card.pi.jz.l8),
															card.pi.jz.fj))
													])))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold flex flex-col mt-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-lg'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('text-green', card.bD),
															_Utils_Tuple2('text-gray-900', !card.bD),
															_Utils_Tuple2('lowercase', isFree)
														]))
												]),
											_List_fromArray(
												[
													isFree ? $elm$html$Html$text(
													t('shop.free')) : $elm$html$Html$text(
													A3($author$project$Eos$formatSymbolAmount, translators, card.pi.as, card.pi.iJ))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('text-sm text-gray-333 uppercase', card.bD),
															_Utils_Tuple2('text-red font-normal lowercase', !card.bD)
														]))
												]),
											_List_fromArray(
												[
													(!card.bD) ? $elm$html$Html$text(
													t('shop.sold_out')) : (isFree ? $elm$html$Html$text(
													t('shop.enjoy')) : $elm$html$Html$text(
													$author$project$Eos$symbolToSymbolCodeString(card.pi.as)))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Shop$viewGrid = F2(
	function (loggedIn, cards) {
		var outOfStockCards = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.bD;
				},
				$elm$core$Basics$not),
			cards);
		var availableCards = A2(
			$elm$core$List$filter,
			function ($) {
				return $.bD;
			},
			cards);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-6 mb-10')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grid gap-4 xs-max:grid-cols-1 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5')
						]),
					A2(
						$elm$core$List$indexedMap,
						$author$project$Page$Shop$viewCard(loggedIn),
						_Utils_ap(availableCards, outOfStockCards)))
				]));
	});
var $author$project$Page$Shop$viewHeader = function (_v0) {
	var t = _v0.fL;
	return A2(
		$elm$html$Html$h1,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('font-bold text-lg'),
				$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
				t('shop.headline_no_emoji'))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				t('shop.headline'))
			]));
};
var $author$project$Page$Shop$ClickedOpenFiltersModal = {$: 8};
var $author$project$Page$Shop$viewShopFilter = F2(
	function (loggedIn, model) {
		var numberOfFiltersApplied = $elm$core$List$length(model.N.dn);
		var canSell = function () {
			var _v1 = loggedIn.pl;
			if (_v1.$ === 3) {
				var profile = _v1.a;
				return A2(
					$author$project$Session$LoggedIn$hasPermissions,
					profile,
					_List_fromArray(
						[4]));
			} else {
				return false;
			}
		}();
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid xs-max:grid-cols-1 grid-cols-2 md:flex mt-4 gap-4')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$View$Components$disablableLink,
					{nP: (!loggedIn.gz) || (!canSell)},
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full md:w-40 button button-primary'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('button-disabled', !loggedIn.gz)
								])),
							$author$project$Route$href(
							$author$project$Route$NewSale(0))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('shop.create_new_offer'))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full md:w-40 button button-secondary'),
							$elm$html$Html$Events$onClick($author$project$Page$Shop$ClickedOpenFiltersModal)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('shop.filters.title')),
							(numberOfFiltersApplied > 0) ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-2 bg-orange-300 rounded-full px-2 h-6 min-w-6 text-white flex items-center justify-center text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(numberOfFiltersApplied))
								])) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Page$Shop$view = F2(
	function (loggedIn, model) {
		var viewFrozenAccountCard = (!loggedIn.gz) ? A3(
			$author$project$Session$LoggedIn$viewFrozenAccountCard,
			loggedIn.A.aw,
			{nS: true, oJ: $author$project$Page$Shop$ClickedAcceptCodeOfConduct},
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto shadow-lg mb-6')
				])) : $elm$html$Html$text('');
		var selectedCommunityName = function () {
			var _v3 = loggedIn.pC;
			if (_v3.$ === 3) {
				var community = _v3.a;
				return community.fj;
			} else {
				return '';
			}
		}();
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var content = function (community) {
			var _v2 = model.a2;
			switch (_v2.$) {
				case 0:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-6 mb-10')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto px-4')
									]),
								_List_fromArray(
									[
										viewFrozenAccountCard,
										$author$project$Page$Shop$viewHeader(loggedIn.A.aw),
										A2($author$project$Page$Shop$viewShopFilter, loggedIn, model)
									])),
								$elm$core$List$isEmpty(model.N.dn) ? $elm$html$Html$text('') : A2($author$project$Page$Shop$viewFilterTags, community, model),
								$elm$core$List$isEmpty(model.N.dn) ? $elm$html$Html$text('') : A3($author$project$Page$Shop$viewFoundOffersAmount, loggedIn.A.aw, community, model),
								A2($author$project$Page$Shop$viewFiltersModal, loggedIn, model),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto px-4')
									]),
								_List_fromArray(
									[
										$author$project$Page$fullPageLoading(loggedIn.A)
									]))
							]));
				case 2:
					var e = _v2.a;
					return A2(
						$author$project$Page$fullPageGraphQLError,
						t('shop.title'),
						e);
				default:
					var cards = _v2.a;
					return $elm$core$List$isEmpty(cards) ? ((_Utils_eq(model.N.o1, $elm$core$Maybe$Nothing) && $elm$core$List$isEmpty(model.N.dn)) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container mx-auto px-4 mt-6')
							]),
						_List_fromArray(
							[
								viewFrozenAccountCard,
								A3($author$project$Page$Shop$viewEmptyState, loggedIn, community.as, model)
							])) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-6')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto px-4')
									]),
								_List_fromArray(
									[
										viewFrozenAccountCard,
										$author$project$Page$Shop$viewHeader(loggedIn.A.aw),
										A2($author$project$Page$Shop$viewShopFilter, loggedIn, model)
									])),
								$elm$core$List$isEmpty(model.N.dn) ? $elm$html$Html$text('') : A2($author$project$Page$Shop$viewFilterTags, community, model),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto px-4')
									]),
								_List_fromArray(
									[
										$author$project$Page$Shop$viewEmptyStateWithFilters(loggedIn.A.aw)
									])),
								A2($author$project$Page$Shop$viewFiltersModal, loggedIn, model)
							]))) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-6')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto px-4')
									]),
								_List_fromArray(
									[
										viewFrozenAccountCard,
										$author$project$Page$Shop$viewHeader(loggedIn.A.aw),
										A2($author$project$Page$Shop$viewShopFilter, loggedIn, model)
									])),
								$elm$core$List$isEmpty(model.N.dn) ? $elm$html$Html$text('') : A2($author$project$Page$Shop$viewFilterTags, community, model),
								$elm$core$List$isEmpty(model.N.dn) ? $elm$html$Html$text('') : A3($author$project$Page$Shop$viewFoundOffersAmount, loggedIn.A.aw, community, model),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto px-4')
									]),
								_List_fromArray(
									[
										A2($author$project$Page$Shop$viewGrid, loggedIn, cards)
									])),
								A2($author$project$Page$Shop$viewFiltersModal, loggedIn, model)
							]));
			}
		};
		var title = selectedCommunityName + (' ' + t('shop.title'));
		return {
			mJ: function () {
				var _v1 = loggedIn.pC;
				switch (_v1.$) {
					case 3:
						var community = _v1.a;
						return community.bB ? content(community) : A2(
							$author$project$Page$fullPageNotFound,
							t('error.pageNotFound'),
							t('shop.disabled.description'));
					case 1:
						return $author$project$Page$fullPageLoading(loggedIn.A);
					case 0:
						return $author$project$Page$fullPageLoading(loggedIn.A);
					default:
						var e = _v1.a;
						return A2(
							$author$project$Page$fullPageGraphQLError,
							t('community.error_loading'),
							e);
				}
			}(),
			fN: title
		};
	});
var $author$project$Page$Shop$Editor$allRouteSteps = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Page$Shop$Editor$removeCategoriesStep = F2(
	function (allCategories, steps) {
		return $elm$core$List$isEmpty(allCategories) ? A2(
			$elm$core$List$filter,
			function (step) {
				return step !== 2;
			},
			steps) : steps;
	});
var $author$project$Page$Shop$Editor$SubmittedPriceAndInventory = function (a) {
	return {$: 7, a: a};
};
var $author$project$Icons$checkmark = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('14'),
				$elm$svg$Svg$Attributes$height('10'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M5.662 9.5c-.266 0-.521-.102-.71-.284L.27 4.704a.942.942 0 0 1 .025-1.342 1.031 1.031 0 0 1 1.394-.024l3.974 3.829 6.65-6.408a1.031 1.031 0 0 1 1.394.024.942.942 0 0 1 .025 1.343l-7.36 7.09a1.023 1.023 0 0 1-.71.284Z'),
						$elm$svg$Svg$Attributes$fill('#fff')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Shop$Editor$PriceAndInventoryFormOutput = F2(
	function (price, unitTracking) {
		return {iJ: price, i7: unitTracking};
	});
var $author$project$Form$Validate$floatGreaterThan = $author$project$Form$Validate$numberGreaterThan($elm$core$String$fromFloat);
var $author$project$Page$Shop$Editor$ClickedDecrementStockUnits = {$: 9};
var $author$project$Page$Shop$Editor$ClickedIncrementStockUnits = {$: 10};
var $author$project$Icons$minus = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('26'),
				$elm$svg$Svg$Attributes$height('2'),
				$elm$svg$Svg$Attributes$viewBox('0 0 26 2'),
				$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M1.71711 0.032959H24.2829C24.817 0.032959 25.25 0.465947 25.25 1.00006C25.25 1.53418 24.817 1.96717 24.2829 1.96717H1.71711C1.18299 1.96717 0.75 1.53418 0.75 1.00006C0.75 0.465947 1.18299 0.032959 1.71711 0.032959Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Shop$Editor$stockTrackingForm = F2(
	function (translators, _v0) {
		var isDisabled = _v0.nP;
		return A4(
			$author$project$Form$withGroup,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-gray-100 rounded-sm p-4')
				]),
			A2(
				$author$project$Form$toggle,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: $elm$core$Result$Ok,
					qd: F2(
						function (newTrackUnits, values) {
							return _Utils_update(
								values,
								{eo: newTrackUnits});
						}),
					lW: function ($) {
						return $.eo;
					}
				},
				A2(
					$author$project$Form$Toggle$withToggleSide,
					$author$project$Form$Toggle$Right(
						{kj: true}),
					A2(
						$author$project$Form$Toggle$withToggleContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-0 pl-0')
							]),
						A2(
							$author$project$Form$Toggle$withContainerAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col')
								]),
							$author$project$Form$Toggle$init(
								{
									w: 'product-track-units-toggle',
									n$: A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-333 text-base mb-4')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														translators.fL('shop.steps.price_and_inventory.inventory_management'))
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-2')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														translators.fL('shop.steps.price_and_inventory.inventory_management_description'))
													]))
											]))
								}))))),
			$author$project$Form$introspect(
				function (_v1) {
					var trackUnits = _v1.eo;
					return trackUnits ? A2(
						$author$project$Form$textField,
						{
							ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							o3: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$int,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$intGreaterThanOrEqualTo(0),
										$author$project$Form$Validate$validate(translators)))),
							qd: F2(
								function (newUnitsInStock, values) {
									return _Utils_update(
										values,
										{db: newUnitsInStock});
								}),
							lW: function ($) {
								return $.db;
							}
						},
						A2(
							$author$project$Form$Text$withElements,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute top-1 bottom-1 left-1 px-4 rounded focus-ring text-orange-300 hover:text-orange-300/70'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('bg-white', !isDisabled),
													_Utils_Tuple2('bg-gray-500', isDisabled)
												])),
											$elm$html$Html$Attributes$type_('button'),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											translators.fL('shop.subtract_unit')),
											$elm$html$Html$Events$onClick($author$project$Page$Shop$Editor$ClickedDecrementStockUnits)
										]),
									_List_fromArray(
										[
											$author$project$Icons$minus('fill-current')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute top-1 bottom-1 right-1 px-4 rounded focus-ring text-orange-300 hover:text-orange-300/70'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('bg-white', !isDisabled),
													_Utils_Tuple2('bg-gray-500', isDisabled)
												])),
											$elm$html$Html$Attributes$type_('button'),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											translators.fL('shop.add_unit')),
											$elm$html$Html$Events$onClick($author$project$Page$Shop$Editor$ClickedIncrementStockUnits)
										]),
									_List_fromArray(
										[
											$author$project$Icons$plus('fill-current')
										]))
								]),
							A2(
								$author$project$Form$Text$withExtraAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$min('0'),
										$elm$html$Html$Attributes$class('text-center')
									]),
								A2(
									$author$project$Form$Text$withContainerAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-0 mt-10')
										]),
									A2(
										$author$project$Form$Text$withType,
										2,
										$author$project$Form$Text$asNumeric(
											A2(
												$author$project$Form$Text$withPlaceholder,
												'0',
												$author$project$Form$Text$init(
													{
														w: 'product-quantity-input',
														n$: translators.fL('shop.steps.price_and_inventory.quantity_label')
													})))))))) : $author$project$Form$succeed(0);
				}),
			$author$project$Form$succeed(
				F2(
					function (trackStock, availableUnits) {
						return trackStock ? $author$project$Shop$UnitTracking(
							{jl: availableUnits}) : $author$project$Shop$NoTracking;
					})));
	});
var $author$project$Page$Shop$Editor$priceAndInventoryForm = F3(
	function (translators, isDisabled, symbol) {
		return A4(
			$author$project$Form$withGroup,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid lg:grid-cols-2 gap-8')
				]),
			A2(
				$author$project$Form$textField,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$succeed,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$maskedFloat(translators),
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$floatGreaterThan(0),
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$map(
										function (price) {
											return {ji: price, as: symbol};
										}),
									$author$project$Form$Validate$validate(translators))))),
					qd: F2(
						function (newPrice, values) {
							return _Utils_update(
								values,
								{iJ: newPrice});
						}),
					lW: function ($) {
						return $.iJ;
					}
				},
				A2(
					$author$project$Form$Text$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-gray-100 rounded-sm p-4 mb-0 self-start')
						]),
					A2(
						$author$project$Form$Text$withExtraAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$min('0')
							]),
						A2(
							$author$project$Form$Text$withCurrency,
							symbol,
							$author$project$Form$Text$init(
								{
									w: 'product-price-input',
									n$: translators.fL('shop.steps.price_and_inventory.price_label')
								}))))),
			A2($author$project$Page$Shop$Editor$stockTrackingForm, translators, isDisabled),
			$author$project$Form$succeed($author$project$Page$Shop$Editor$PriceAndInventoryFormOutput));
	});
var $author$project$Page$Shop$Editor$viewForm = F6(
	function (loggedIn, community, allCategories, _v0, model, formData) {
		var shared = loggedIn.A;
		var isEdit = _v0.cR;
		var isDisabled = _v0.nP;
		var availableSteps = _v0.cz;
		var totalSteps = $elm$core$List$length(availableSteps);
		var isStepCompleted = function (step) {
			var _v10 = _Utils_Tuple2(step, formData.C);
			_v10$6:
			while (true) {
				switch (_v10.a) {
					case 0:
						switch (_v10.b.$) {
							case 1:
								var _v11 = _v10.a;
								return true;
							case 2:
								var _v12 = _v10.a;
								var _v13 = _v10.b;
								return true;
							case 3:
								var _v14 = _v10.a;
								var _v15 = _v10.b;
								return true;
							default:
								break _v10$6;
						}
					case 1:
						switch (_v10.b.$) {
							case 2:
								var _v16 = _v10.a;
								var _v17 = _v10.b;
								return true;
							case 3:
								var _v18 = _v10.a;
								var _v19 = _v10.b;
								return true;
							default:
								break _v10$6;
						}
					case 2:
						if (_v10.b.$ === 3) {
							var _v20 = _v10.a;
							var _v21 = _v10.b;
							return true;
						} else {
							break _v10$6;
						}
					default:
						break _v10$6;
				}
			}
			return false;
		};
		var stepLine = function (step) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full h-px bg-gray-900 relative')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-orange-300 w-full absolute left-0 top-0 bottom-0 transition-transform ease-out origin-left duration-300'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'scale-x-0 delay-300',
										!isStepCompleted(step)),
										_Utils_Tuple2(
										'scale-x-100',
										isStepCompleted(step))
									]))
							]),
						_List_Nil)
					]));
		};
		var findRouteStepIndex = F2(
			function (routeStep, _default) {
				return A2(
					$elm$core$Maybe$withDefault,
					_default,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$add(1),
						A2(
							$elm_community$list_extra$List$Extra$findIndex,
							$elm$core$Basics$eq(routeStep),
							availableSteps)));
			});
		var _v1 = shared.aw;
		var t = _v1.fL;
		var tr = _v1.i4;
		var stepBall = function (step) {
			var maybeNewRoute = A2($author$project$Page$Shop$Editor$setCurrentStepInRoute, model, step);
			var isCurrent = function () {
				var _v9 = formData.C;
				switch (_v9.$) {
					case 0:
						return !step;
					case 1:
						return step === 1;
					case 2:
						return step === 2;
					default:
						return step === 3;
				}
			}();
			var _v6 = function () {
				switch (step) {
					case 0:
						return _Utils_Tuple2(
							1,
							t('shop.steps.main_information.title'));
					case 1:
						return _Utils_Tuple2(
							2,
							t('shop.steps.images.title'));
					case 2:
						return _Utils_Tuple2(
							3,
							t('shop.steps.categories.title'));
					default:
						return _Utils_Tuple2(
							totalSteps,
							t('shop.steps.price_and_inventory.title'));
				}
			}();
			var defaultStepIndex = _v6.a;
			var linkStepName = _v6.b;
			var linkStepIndex = A2(findRouteStepIndex, step, defaultStepIndex);
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-6 h-6 rounded-full flex-shrink-0 flex items-center justify-center transition-colors duration-300'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'bg-orange-300 delay-300',
								isStepCompleted(step) || isCurrent),
								_Utils_Tuple2(
								'bg-gray-900',
								!(isStepCompleted(step) || isCurrent))
							])),
						function () {
						if (!maybeNewRoute.$) {
							var newRoute = maybeNewRoute.a;
							return $author$project$Route$href(newRoute);
						} else {
							return $elm$html$Html$Attributes$class('');
						}
					}(),
						$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
						A2(
							tr,
							'shop.steps.step_link',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'index',
									$elm$core$String$fromInt(linkStepIndex)),
									_Utils_Tuple2('step_title', linkStepName)
								])))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('transition-opacity duration-300'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'opacity-0',
										!isStepCompleted(step))
									]))
							]),
						_List_fromArray(
							[
								$author$project$Icons$checkmark('')
							]))
					]));
		};
		var _v2 = function () {
			var _v3 = formData.C;
			switch (_v3.$) {
				case 0:
					return _Utils_Tuple2(
						A2(findRouteStepIndex, 0, 1),
						t('shop.steps.main_information.title'));
				case 1:
					return _Utils_Tuple2(
						A2(findRouteStepIndex, 1, 2),
						t('shop.steps.images.title'));
				case 2:
					return _Utils_Tuple2(
						A2(findRouteStepIndex, 2, 3),
						t('shop.steps.categories.title'));
				default:
					return _Utils_Tuple2(
						A2(findRouteStepIndex, 3, 4),
						t('shop.steps.price_and_inventory.title'));
			}
		}();
		var stepNumber = _v2.a;
		var stepName = _v2.b;
		var viewHeader = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto px-4 lg:max-w-none lg:mx-0 lg:px-6')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-4 flex items-center')
						]),
					A2(
						$elm$core$List$concatMap,
						function (step) {
							return _Utils_eq(
								$elm_community$list_extra$List$Extra$last(availableSteps),
								$elm$core$Maybe$Just(step)) ? _List_fromArray(
								[
									stepBall(step)
								]) : _List_fromArray(
								[
									stepBall(step),
									stepLine(step)
								]);
						},
						availableSteps)),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold text-black mb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								tr,
								'shop.steps.index',
								_List_fromArray(
									[
										_Utils_Tuple2(
										'current',
										$elm$core$String$fromInt(stepNumber)),
										_Utils_Tuple2(
										'total',
										$elm$core$String$fromInt(totalSteps))
									])))
						])),
					$elm$html$Html$text(stepName)
				]));
		var _v4 = isEdit ? _Utils_Tuple2(
			t('menu.save'),
			t('shop.edit_offer')) : _Utils_Tuple2(
			t('menu.create'),
			t('shop.create_offer'));
		var actionText = _v4.a;
		var pageTitle = _v4.b;
		var viewForm_ = F5(
			function (formFn, formModel, routeStep, toFormMsg, onSubmitMsg) {
				var submitText = _Utils_eq(
					$elm_community$list_extra$List$Extra$last(availableSteps),
					$elm$core$Maybe$Just(routeStep)) ? actionText : t('shop.steps.continue');
				return A6(
					$author$project$Form$view,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4 flex-grow flex flex-col lg:max-w-none lg:mx-0 lg:px-6')
						]),
					shared.aw,
					function (submitButton) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-auto')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-10 flex gap-x-4')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('grid grid-cols-2 w-full gap-6 lg:w-1/2 lg:mx-auto'),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2('grid-cols-3', isEdit)
															]))
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('button button-secondary w-full'),
																$author$project$Route$href(
																$author$project$Route$Shop(
																	{dn: _List_Nil, o1: $elm$core$Maybe$Nothing}))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																t('menu.cancel'))
															])),
														A2(
														submitButton,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('button button-primary w-full'),
																$elm$html$Html$Attributes$disabled(
																isDisabled || $author$project$Form$hasFieldsLoading(formModel))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(submitText)
															]))
													]))
											]))
									]))
							]);
					},
					formFn,
					A2($author$project$Form$withDisabled, isDisabled, formModel),
					{
						oU: onSubmitMsg,
						lF: A2($elm$core$Basics$composeR, toFormMsg, $author$project$Page$Shop$Editor$GotFormMsg)
					});
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col flex-grow')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$viewHeader, loggedIn, pageTitle),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lg:container lg:mx-auto lg:px-4 lg:mt-6 lg:mb-20')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white pt-4 pb-8 flex-grow flex flex-col lg:w-2/3 lg:mx-auto lg:rounded lg:shadow-lg lg:animate-fade-in-from-above-lg lg:fill-mode-none lg:motion-reduce:animate-none'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'min-h-150',
											$elm$core$List$length(availableSteps) > 1)
										]))
								]),
							_List_fromArray(
								[
									($elm$core$List$length(availableSteps) > 1) ? viewHeader : A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold px-4')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(stepName)
										])),
									A2(
									$elm$html$Html$hr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-4 mb-6 border-gray-500 lg:mx-4 lg:mb-10'),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
										]),
									_List_Nil),
									function () {
									var _v5 = formData.C;
									switch (_v5.$) {
										case 0:
											return A5(
												viewForm_,
												$author$project$Page$Shop$Editor$mainInformationForm(shared.aw),
												formData.bF,
												0,
												$author$project$Page$Shop$Editor$MainInformationMsg,
												$author$project$Page$Shop$Editor$SubmittedMainInformation(0));
										case 1:
											return A5(
												viewForm_,
												$author$project$Page$Shop$Editor$imagesForm(shared.aw),
												formData.h5,
												1,
												$author$project$Page$Shop$Editor$ImagesMsg,
												$author$project$Page$Shop$Editor$SubmittedImages(
													A2($elm$core$List$member, 2, availableSteps) ? 0 : 1));
										case 2:
											return A5(
												viewForm_,
												A2($author$project$Page$Shop$Editor$categoriesForm, shared.aw, allCategories),
												formData.dn,
												2,
												$author$project$Page$Shop$Editor$CategoriesMsg,
												$author$project$Page$Shop$Editor$SubmittedCategories);
										default:
											return A5(
												viewForm_,
												A3(
													$author$project$Page$Shop$Editor$priceAndInventoryForm,
													shared.aw,
													{nP: isDisabled},
													community.as),
												formData.cg,
												3,
												$author$project$Page$Shop$Editor$PriceAndInventoryMsg,
												$author$project$Page$Shop$Editor$SubmittedPriceAndInventory);
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Page$Shop$Editor$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.A;
		var t = shared.aw.fL;
		var isEdit = function () {
			var _v4 = model.pN;
			switch (_v4.$) {
				case 3:
					return true;
				case 4:
					return true;
				case 5:
					return true;
				case 6:
					return true;
				default:
					return false;
			}
		}();
		var title = isEdit ? t('shop.edit_offer') : t('shop.create_offer');
		var content = F2(
			function (community, shopCategories) {
				var _v3 = model.pN;
				switch (_v3.$) {
					case 2:
						return $author$project$Page$fullPageLoading(shared);
					case 7:
						var error = _v3.a;
						return A2(
							$author$project$Page$fullPageGraphQLError,
							t('shop.title'),
							error);
					case 8:
						return A2(
							$author$project$Page$fullPageNotFound,
							t('shop.unauthorized'),
							'');
					case 0:
						var formData = _v3.a;
						return A6(
							$author$project$Page$Shop$Editor$viewForm,
							loggedIn,
							community,
							shopCategories,
							{
								cz: A2($author$project$Page$Shop$Editor$removeCategoriesStep, shopCategories, $author$project$Page$Shop$Editor$allRouteSteps),
								nP: false,
								cR: false
							},
							model,
							formData);
					case 1:
						var formData = _v3.a;
						return A6(
							$author$project$Page$Shop$Editor$viewForm,
							loggedIn,
							community,
							shopCategories,
							{
								cz: A2($author$project$Page$Shop$Editor$removeCategoriesStep, shopCategories, $author$project$Page$Shop$Editor$allRouteSteps),
								nP: true,
								cR: false
							},
							model,
							formData);
					case 3:
						var formData = _v3.b;
						return A6(
							$author$project$Page$Shop$Editor$viewForm,
							loggedIn,
							community,
							shopCategories,
							{
								cz: A2($author$project$Page$Shop$Editor$removeCategoriesStep, shopCategories, $author$project$Page$Shop$Editor$allRouteSteps),
								nP: false,
								cR: true
							},
							model,
							formData);
					case 4:
						var formData = _v3.b;
						return A6(
							$author$project$Page$Shop$Editor$viewForm,
							loggedIn,
							community,
							shopCategories,
							{
								cz: A2($author$project$Page$Shop$Editor$removeCategoriesStep, shopCategories, $author$project$Page$Shop$Editor$allRouteSteps),
								nP: true,
								cR: true
							},
							model,
							formData);
					case 5:
						var formData = _v3.b;
						return A6(
							$author$project$Page$Shop$Editor$viewForm,
							loggedIn,
							community,
							shopCategories,
							{
								cz: _List_fromArray(
									[2]),
								nP: false,
								cR: true
							},
							model,
							formData);
					default:
						var formData = _v3.b;
						return A6(
							$author$project$Page$Shop$Editor$viewForm,
							loggedIn,
							community,
							shopCategories,
							{
								cz: _List_fromArray(
									[2]),
								nP: true,
								cR: true
							},
							model,
							formData);
				}
			});
		return {
			mJ: function () {
				var _v0 = A2(
					$author$project$Community$getField,
					loggedIn.pC,
					function ($) {
						return $.fC;
					});
				switch (_v0.$) {
					case 3:
						var _v1 = _v0.a;
						var community = _v1.a;
						var shopCategories = _v1.b;
						return community.bB ? A2(content, community, shopCategories) : A2(
							$author$project$Page$fullPageNotFound,
							t('error.pageNotFound'),
							t('shop.disabled.description'));
					case 1:
						return $author$project$Page$fullPageLoading(shared);
					case 0:
						return $author$project$Page$fullPageLoading(shared);
					default:
						var fieldError = _v0.a;
						if (!fieldError.$) {
							var err = fieldError.a;
							return A2(
								$author$project$Page$fullPageGraphQLError,
								t('community.error_loading'),
								err);
						} else {
							var err = fieldError.a;
							return A2(
								$author$project$Page$fullPageGraphQLError,
								t('community.error_loading'),
								err);
						}
				}
			}(),
			fN: title
		};
	});
var $author$project$Page$Shop$Viewer$ClickedEditSale = {$: 7};
var $author$project$Page$Shop$Viewer$ClickedOpenDetails = {$: 4};
var $author$project$Page$Shop$Viewer$ClickedScrollToImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Viewer$ClickedShareOffer = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Shop$Viewer$GotFormInteractionMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Shop$Viewer$GotFormInteractionMsgAsGuest = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Viewer$ImageStartedIntersecting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Shop$Viewer$ImageStoppedIntersecting = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Shop$Viewer$communityHasCategories = function (session) {
	if (!session.$) {
		return false;
	} else {
		var loggedIn = session.a;
		var _v1 = A2(
			$author$project$Community$getField,
			loggedIn.pC,
			function ($) {
				return $.fC;
			});
		if (_v1.$ === 3) {
			var _v2 = _v1.a;
			var categories = _v2.b;
			return !$elm$core$List$isEmpty(categories);
		} else {
			return false;
		}
	}
};
var $author$project$Page$Shop$Viewer$ClickedDecrementUnits = 0;
var $author$project$Page$Shop$Viewer$ClickedIncrementUnits = 1;
var $author$project$Page$Shop$Viewer$FormOutput = F2(
	function (units, memo) {
		return {kE: memo, i8: units};
	});
var $author$project$Form$Validate$intLowerThanOrEqualTo = $author$project$Form$Validate$numberLowerThanOrEqualTo($elm$core$String$fromInt);
var $author$project$Page$Shop$Viewer$createForm = F5(
	function (translators, product, maybeBalance, _v0, toFormInteractionMsg) {
		var t = translators.fL;
		var tr = translators.i4;
		var isDisabled = _v0.nP;
		var communityMinBalance = _v0.hJ;
		return A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$richText,
				{
					ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					o3: $elm$core$Result$Ok,
					qd: F2(
						function (memo, input) {
							return _Utils_update(
								input,
								{kE: memo});
						}),
					lW: function ($) {
						return $.kE;
					}
				},
				A2(
					$author$project$Form$RichText$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-6')
						]),
					$author$project$Form$RichText$init(
						{
							n$: t('shop.transfer.memo_label')
						}))),
			A2(
				$author$project$Form$withNoOutput,
				$author$project$Form$introspect(
					function (values) {
						return $author$project$Form$arbitrary(
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bg-green pt-4 mb-6 rounded-sm flex flex-col text-white font-bold text-center')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xl px-4'),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										_List_fromArray(
											[
												function () {
												var _v2 = $elm$core$String$toInt(values.i8);
												if (_v2.$ === 1) {
													return $elm$html$Html$text('0');
												} else {
													var unitsValue = _v2.a;
													return $elm$html$Html$text(
														$elm$core$String$fromFloat(unitsValue * product.iJ));
												}
											}()
											])),
										function () {
										var _v3 = $elm$core$String$toInt(values.i8);
										if (_v3.$ === 1) {
											return $elm$html$Html$text('');
										} else {
											var unitsValue = _v3.a;
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('sr-only')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															tr,
															'shop.total_price',
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'amount',
																	$elm$core$String$fromFloat(unitsValue * product.iJ)),
																	_Utils_Tuple2(
																	'symbol',
																	$author$project$Eos$symbolToSymbolCodeString(product.as))
																])))
													]));
										}
									}(),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('px-4 mb-4'),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													tr,
													'shop.transfer.price',
													_List_fromArray(
														[
															_Utils_Tuple2(
															'symbol',
															$author$project$Eos$symbolToSymbolCodeString(product.as))
														])))
											])),
										function () {
										if (maybeBalance.$ === 1) {
											return $elm$html$Html$text('');
										} else {
											var balance = maybeBalance.a;
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-sm py-3 px-4 bg-black bg-opacity-20 rounded-b-sm uppercase')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															tr,
															'shop.transfer.balance',
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'asset',
																	A2($author$project$Eos$assetToString, translators, balance.mk))
																])))
													]));
										}
									}()
									])));
					}),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$textField,
						{
							ne: function (values) {
								var minBalance = A2($elm$core$Maybe$withDefault, 0, communityMinBalance);
								var maybeTotalBeingSpent = A2(
									$elm$core$Maybe$map,
									function (units) {
										return units * product.iJ;
									},
									$elm$core$String$toInt(values.i8));
								var isSpendingTooMuch = A2(
									$elm$core$Maybe$withDefault,
									false,
									A3(
										$elm$core$Maybe$map2,
										F2(
											function (balance, totalBeingSpent) {
												return _Utils_cmp(balance.mk.ji - totalBeingSpent, minBalance) < 0;
											}),
										maybeBalance,
										maybeTotalBeingSpent));
								return isSpendingTooMuch ? $elm$core$Maybe$Just(
									A2(
										tr,
										'shop.transfer.errors.balanceTooLow',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'symbol',
												$author$project$Eos$symbolToSymbolCodeString(product.as))
											]))) : $elm$core$Maybe$Nothing;
							},
							o3: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$int,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$intGreaterThanOrEqualTo(1),
										A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$withCustomError(
												function (translators_) {
													return translators_.fL('shop.transfer.errors.unitTooLow');
												}),
											A2(
												$elm$core$Basics$composeR,
												function () {
													var _v1 = product.iT;
													if (!_v1.$) {
														return $elm$core$Basics$identity;
													} else {
														var availableUnits = _v1.a.jl;
														return A2(
															$elm$core$Basics$composeR,
															$author$project$Form$Validate$intLowerThanOrEqualTo(availableUnits),
															$author$project$Form$Validate$withCustomError(
																function (translators_) {
																	return translators_.fL('shop.transfer.errors.unitTooHigh');
																}));
													}
												}(),
												$author$project$Form$Validate$validate(translators)))))),
							qd: F2(
								function (units, input) {
									return _Utils_update(
										input,
										{i8: units});
								}),
							lW: function ($) {
								return $.i8;
							}
						},
						A2(
							$author$project$Form$Text$withElements,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute top-1 bottom-1 left-1 px-4 rounded focus-ring text-orange-300'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('bg-white hover:text-orange-300/70', !isDisabled),
													_Utils_Tuple2('bg-gray-500 cursor-default', isDisabled)
												])),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$disabled(isDisabled),
											$elm$html$Html$Events$onClick(
											toFormInteractionMsg(0)),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											t('shop.subtract_unit'))
										]),
									_List_fromArray(
										[
											$author$project$Icons$minus('fill-current')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute top-1 bottom-1 right-1 px-4 rounded focus-ring text-orange-300'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('bg-white hover:text-orange-300/70', !isDisabled),
													_Utils_Tuple2('bg-gray-500 cursor-default', isDisabled)
												])),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$disabled(isDisabled),
											$elm$html$Html$Events$onClick(
											toFormInteractionMsg(1)),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											t('shop.add_unit'))
										]),
									_List_fromArray(
										[
											$author$project$Icons$plus('fill-current')
										]))
								]),
							A2(
								$author$project$Form$Text$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-6')
									]),
								A2(
									$author$project$Form$Text$withExtraAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$autocomplete(false),
											$elm$html$Html$Attributes$min('0'),
											$elm$html$Html$Attributes$class('text-center')
										]),
									A2(
										$author$project$Form$Text$withType,
										2,
										$author$project$Form$Text$asNumeric(
											$author$project$Form$Text$init(
												{
													w: 'units-input',
													n$: t('shop.transfer.units_label')
												}))))))),
					$author$project$Form$succeed($author$project$Page$Shop$Viewer$FormOutput))));
	});
var $author$project$Page$Shop$Viewer$isAdmin = function (session) {
	if (!session.$) {
		return false;
	} else {
		var loggedIn = session.a;
		var _v1 = loggedIn.pC;
		if (_v1.$ === 3) {
			var community = _v1.a;
			return _Utils_eq(community.jz, loggedIn._);
		} else {
			return false;
		}
	}
};
var $author$project$Page$Shop$Viewer$ClickedConfirmDelete = {$: 11};
var $author$project$Page$Shop$Viewer$ClosedConfirmDeleteModal = {$: 10};
var $author$project$Page$Shop$Viewer$viewConfirmDeleteModal = F2(
	function (_v0, model) {
		var t = _v0.fL;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withFooter,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-secondary'),
								$elm$html$Html$Events$onClick($author$project$Page$Shop$Viewer$ClosedConfirmDeleteModal),
								$elm$html$Html$Attributes$disabled(model.a5 === 2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('shop.delete_modal.cancel'))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-primary ml-4'),
								$elm$html$Html$Events$onClick($author$project$Page$Shop$Viewer$ClickedConfirmDelete),
								$elm$html$Html$Attributes$disabled(model.a5 === 2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('shop.delete_modal.confirm'))
							]))
					]),
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('shop.delete_modal.body'))
						]),
					A2(
						$author$project$View$Modal$withHeader,
						t('shop.delete_modal.title'),
						$author$project$View$Modal$initWith(
							{
								mw: $author$project$Page$Shop$Viewer$ClosedConfirmDeleteModal,
								nX: function () {
									var _v1 = model.a5;
									switch (_v1) {
										case 0:
											return false;
										case 1:
											return true;
										default:
											return true;
									}
								}()
							})))));
	});
var $author$project$Profile$Contact$ariaLabelForContactType = F2(
	function (_v0, contactType) {
		var t = _v0.fL;
		switch (contactType) {
			case 3:
				return t('contact_form.reach_out.phone');
			case 1:
				return t('contact_form.reach_out.instagram');
			case 4:
				return t('contact_form.reach_out.telegram');
			case 5:
				return t('contact_form.reach_out.whatsapp');
			case 0:
				return t('contact_form.reach_out.email');
			default:
				return t('contact_form.reach_out.link');
		}
	});
var $author$project$Profile$Contact$circularLinkWithGrayBg = F3(
	function (translators, class_, _v0) {
		var normalized = _v0;
		var defaultClass = function () {
			var _v1 = normalized.mE;
			switch (_v1) {
				case 5:
					return 'fill-current text-green ';
				case 3:
					return 'fill-current text-orange-500';
				default:
					return '';
			}
		}();
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Profile$Contact$toHref(normalized),
					$elm$html$Html$Attributes$class('w-10 h-10 flex-shrink-0 bg-gray-100 rounded-full flex items-center justify-center hover:opacity-70 focus-ring'),
					$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
					A2($author$project$Profile$Contact$ariaLabelForContactType, translators, normalized.mE))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Profile$Contact$contactTypeToIcon,
					_Utils_ap(defaultClass, class_),
					true,
					normalized.mE)
				]));
	});
var $author$project$Page$Shop$Viewer$viewContactTheSeller = F3(
	function (translators, _v0, profile) {
		var t = translators.fL;
		var tr = translators.i4;
		var isGuest = _v0.kn;
		var name = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Eos$Account$nameToString(profile.l8),
			profile.fj);
		var makeHref = function (originalRoute) {
			return isGuest ? $author$project$Route$href(
				$author$project$Route$Join(
					$elm$core$Maybe$Just(originalRoute))) : $author$project$Route$href(originalRoute);
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									makeHref(
									$author$project$Route$Profile(profile.l8)),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									A2($author$project$Avatar$view, profile.dl, 'w-14 h-14')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-4 flex flex-col text-gray-333')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold lowercase')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('shop.transfer.contact_seller'))
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											makeHref(
											$author$project$Route$Profile(profile.l8)),
											$elm$html$Html$Attributes$class('hover:underline'),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											A2(
												tr,
												'shop.transfer.visit_seller',
												_List_fromArray(
													[
														_Utils_Tuple2('seller', name)
													])))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-18 mt-2 flex flex-wrap gap-4')
						]),
					function (contacts) {
						var _v1 = profile.jK;
						if (_v1.$ === 1) {
							return contacts;
						} else {
							var email = _v1.a;
							return _Utils_ap(
								contacts,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('mailto:' + email),
												$elm$html$Html$Attributes$class('w-10 h-10 flex-shrink-0 bg-gray-100 rounded-full flex items-center justify-center hover:opacity-70'),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
												t('contact_form.reach_out.email'))
											]),
										_List_fromArray(
											[
												$author$project$Icons$mail('')
											]))
									]));
						}
					}(
						A2(
							$elm$core$List$map,
							A2($author$project$Profile$Contact$circularLinkWithGrayBg, translators, ''),
							profile.az)))
				]));
	});
var $author$project$Page$Shop$Viewer$ClosedDetailsModal = {$: 5};
var $author$project$Page$Shop$Viewer$viewDetailsModal = F3(
	function (session, sale, model) {
		var viewItem = F4(
			function (icon, element, action, itemText) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-[calc(100%+2rem)] -mx-4 px-2 py-1')
						]),
					_List_fromArray(
						[
							A2(
							element,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center w-full px-2 py-4 hover:bg-gray-100 focus-ring rounded-sm group transition-colors'),
									action
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center group-hover:bg-white transition-colors')
										]),
									_List_fromArray(
										[
											icon('text-orange-300 w-4 h-4')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-3 text-gray-333')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(itemText)
										]))
								]))
						]));
			});
		var shared = $author$project$Page$toShared(session);
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('divide-y divide-gray-100')
							]),
						_List_fromArray(
							[
								$author$project$Page$Shop$Viewer$isAdmin(session) ? A4(
								viewItem,
								$author$project$Icons$edit,
								$elm$html$Html$a,
								$author$project$Route$href(
									A2($author$project$Route$EditSale, sale.w, 2)),
								shared.aw.fL('shop.edit_categories')) : $elm$html$Html$text(''),
								A4(
								viewItem,
								$author$project$Icons$share,
								$elm$html$Html$button,
								$elm$html$Html$Events$onClick(
									$author$project$Page$Shop$Viewer$ClickedShareOffer(sale)),
								shared.aw.fL('share'))
							]))
					]),
				A2(
					$author$project$View$Modal$withHeader,
					shared.aw.fL('shop.action_options'),
					$author$project$View$Modal$initWith(
						{mw: $author$project$Page$Shop$Viewer$ClosedDetailsModal, nX: model.cQ}))));
	});
var $author$project$Page$Shop$Viewer$ClickedDelete = {$: 9};
var $author$project$Page$Shop$Viewer$ClosedEditSaleModal = {$: 8};
var $author$project$Page$Shop$Viewer$viewEditSaleModal = F4(
	function (_v0, model, shopCategories, product) {
		var t = _v0.fL;
		var item = F2(
			function (step, name) {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-4 flex items-center hover:opacity-70 focus-ring rounded-sm'),
							$author$project$Route$href(
							A2($author$project$Route$EditSale, product.w, step))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name),
							$author$project$Icons$arrowDown('-rotate-90 ml-auto')
						]));
			});
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col divide-y divide-gray-500 mt-1')
							]),
						_List_fromArray(
							[
								A2(
								item,
								0,
								t('shop.steps.main_information.title')),
								A2(
								item,
								1,
								t('shop.steps.images.title')),
								$elm$core$List$isEmpty(shopCategories) ? $elm$html$Html$text('') : A2(
								item,
								2,
								t('shop.steps.categories.title')),
								A2(
								item,
								3,
								t('shop.steps.price_and_inventory.title')),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-red py-4 flex items-center hover:opacity-60 focus-ring rounded-sm'),
										$elm$html$Html$Events$onClick($author$project$Page$Shop$Viewer$ClickedDelete)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('shop.delete')),
										$author$project$Icons$arrowDown('-rotate-90 ml-auto')
									]))
							]))
					]),
				A2(
					$author$project$View$Modal$withHeader,
					t('shop.edit_offer'),
					$author$project$View$Modal$initWith(
						{mw: $author$project$Page$Shop$Viewer$ClosedEditSaleModal, nX: model.dR}))));
	});
var $author$project$Page$Shop$Viewer$view = F2(
	function (session, model) {
		var shared = $author$project$Page$toShared(session);
		var translators = shared.aw;
		var t = translators.fL;
		var shopTitle = t('shop.title');
		var title = function () {
			var _v11 = model.pN;
			if (_v11.$ === 1) {
				var status = _v11.a.pN;
				if (status.$ === 3) {
					var sale = status.a;
					return sale.fN + (' - ' + shopTitle);
				} else {
					return shopTitle;
				}
			} else {
				var productPreview = _v11.a.ec;
				if (productPreview.$ === 3) {
					var sale = productPreview.a;
					return sale.fN + (' - ' + shopTitle);
				} else {
					return shopTitle;
				}
			}
		}();
		var viewContent = F3(
			function (sale, categories, formView) {
				var isGuest = function () {
					if (!session.$) {
						return true;
					} else {
						return false;
					}
				}();
				var isCreator = function () {
					if (!session.$) {
						return false;
					} else {
						var loggedIn = session.a;
						return _Utils_eq(loggedIn._, sale.jz.l8);
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-grow items-center relative bg-white md:bg-gray-100')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute bg-white top-0 bottom-0 left-0 right-1/2 hidden md:block')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto px-4 my-4 md:my-10 md:isolate grid grid-cols-1 md:grid-cols-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-6 md:mb-0 md:w-2/3 md:mx-auto')
										]),
									_List_fromArray(
										[
											function () {
											var _v7 = sale.h5;
											if (!_v7.b) {
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('h-68 w-full bg-gray-100 flex flex-col items-center justify-center rounded')
														]),
													_List_fromArray(
														[
															$author$project$Icons$image(''),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('font-bold uppercase text-black text-sm mt-2')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('shop.no_image'))
																]))
														]));
											} else {
												var firstImage = _v7.a;
												var otherImages = _v7.b;
												return A4(
													$author$project$Shop$viewImageCarrousel,
													translators,
													{
														mF: _List_fromArray(
															[
																$elm$html$Html$Attributes$class('h-68')
															]),
														ny: _List_Nil,
														nz: _List_fromArray(
															[
																$elm$html$Html$Attributes$class('bg-gray-100 rounded')
															]),
														nB: _List_fromArray(
															[
																$elm$html$Html$Attributes$class('rounded-b')
															]),
														n7: _List_fromArray(
															[
																$elm$html$Html$Attributes$class('gap-x-4 rounded')
															])
													},
													{mT: model.cE, oQ: $author$project$Page$Shop$Viewer$ClickedScrollToImage, oS: $author$project$Page$Shop$Viewer$ImageStartedIntersecting, oT: $author$project$Page$Shop$Viewer$ImageStoppedIntersecting, pk: $elm$core$Maybe$Nothing, pF: true},
													_Utils_Tuple2(firstImage, otherImages));
											}
										}(),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex justify-between mt-4')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('font-bold text-lg text-black'),
															$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(sale.fN)
														])),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('ml-4 self-start w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200'),
															($author$project$Page$Shop$Viewer$isAdmin(session) && $author$project$Page$Shop$Viewer$communityHasCategories(session)) ? $elm$html$Html$Events$onClick($author$project$Page$Shop$Viewer$ClickedOpenDetails) : $elm$html$Html$Events$onClick(
															$author$project$Page$Shop$Viewer$ClickedShareOffer(
																{aR: sale.aR, w: sale.w, fN: sale.fN}))
														]),
													_List_fromArray(
														[
															($author$project$Page$Shop$Viewer$isAdmin(session) && $author$project$Page$Shop$Viewer$communityHasCategories(session)) ? $author$project$Icons$ellipsis('text-orange-300') : $author$project$Icons$share('text-orange-300')
														]))
												])),
											A2(
											$author$project$Markdown$view,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-2 mb-4 text-gray-333')
												]),
											sale.aR),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-wrap gap-2'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'mb-6',
															!$elm$core$List$isEmpty(categories)),
															_Utils_Tuple2(
															'mb-2',
															$elm$core$List$isEmpty(categories))
														]))
												]),
											A2(
												$elm$core$List$map,
												function (category) {
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('bg-gray-100 px-2 py-1 text-black font-bold text-sm uppercase')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(category.fj)
															]));
												},
												categories)),
											isCreator ? $elm$html$Html$text('') : A3(
											$author$project$Page$Shop$Viewer$viewContactTheSeller,
											translators,
											{kn: isGuest},
											sale.jz)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-gray-100 px-4 pt-6 pb-4 w-full rounded-lg md:p-0 md:w-2/3 md:mx-auto md:place-self-start')
										]),
									_List_fromArray(
										[formView]))
								])),
							A3(
							$author$project$Page$Shop$Viewer$viewDetailsModal,
							session,
							{aR: sale.aR, w: sale.w, fN: sale.fN},
							model),
							(!shared.jq) ? A2(
							$author$project$Form$Text$view,
							A2(
								$author$project$Form$Text$withInputElement,
								$author$project$Form$Text$TextareaInput(
									{pR: false}),
								A2(
									$author$project$Form$Text$withContainerAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-0 overflow-hidden')
										]),
									A2(
										$author$project$Form$Text$withExtraAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('sr-only'),
												$elm$html$Html$Attributes$tabindex(-1),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										$author$project$Form$Text$init(
											{w: 'share-fallback-input', n$: ''})))),
							{
								na: $elm$html$Html$text(''),
								no: false,
								nV: false,
								oF: $author$project$Page$Shop$Viewer$NoOp,
								oH: function (_v8) {
									return $author$project$Page$Shop$Viewer$NoOp;
								},
								aw: shared.aw,
								lW: $elm$url$Url$toString(
									A2(
										$author$project$Route$addRouteToUrl,
										shared,
										$author$project$Route$ViewSale(sale.w)))
							}) : $elm$html$Html$text('')
						]));
			});
		var content = function () {
			var _v0 = _Utils_Tuple2(model.pN, session);
			_v0$2:
			while (true) {
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var model_ = _v0.a.a;
						var guest = _v0.b.a;
						var _v1 = model_.ec;
						switch (_v1.$) {
							case 3:
								var sale = _v1.a;
								return A3(
									viewContent,
									sale,
									_List_Nil,
									A2(
										$elm$html$Html$map,
										$author$project$Page$Shop$Viewer$AsGuestMsg,
										A6(
											$author$project$Form$viewWithoutSubmit,
											_List_Nil,
											guest.A.aw,
											function (_v2) {
												return _List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$author$project$Route$href(
																$author$project$Route$Join(
																	$elm$core$Maybe$Just(
																		$author$project$Route$ViewSale(sale.w)))),
																$elm$html$Html$Attributes$class('button button-primary w-full')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																t('shop.buy'))
															]))
													]);
											},
											A5(
												$author$project$Page$Shop$Viewer$createForm,
												guest.A.aw,
												{iJ: sale.iJ, iT: $author$project$Shop$NoTracking, as: sale.as},
												$elm$core$Maybe$Nothing,
												{hJ: $elm$core$Maybe$Nothing, nP: false},
												$author$project$Page$Shop$Viewer$GotFormInteractionMsgAsGuest),
											model_.hY,
											{lF: $author$project$Page$Shop$Viewer$GotFormMsgAsGuest})));
							case 2:
								var err = _v1.a;
								return A2(
									$author$project$Page$fullPageGraphQLError,
									t('shop.title'),
									err);
							case 1:
								return $author$project$Page$fullPageLoading(guest.A);
							default:
								return $author$project$Page$fullPageLoading(guest.A);
						}
					} else {
						break _v0$2;
					}
				} else {
					if (_v0.b.$ === 1) {
						var model_ = _v0.a.a;
						var loggedIn = _v0.b.a;
						var _v3 = A2(
							$author$project$Community$getField,
							loggedIn.pC,
							function ($) {
								return $.fC;
							});
						switch (_v3.$) {
							case 1:
								return $author$project$Page$fullPageLoading(loggedIn.A);
							case 0:
								return $author$project$Page$fullPageLoading(loggedIn.A);
							case 2:
								var fieldError = _v3.a;
								if (!fieldError.$) {
									var err = fieldError.a;
									return A2(
										$author$project$Page$fullPageGraphQLError,
										t('community.error_loading'),
										err);
								} else {
									var err = fieldError.a;
									return A2(
										$author$project$Page$fullPageGraphQLError,
										t('community.error_loading'),
										err);
								}
							default:
								var _v5 = _v3.a;
								var community = _v5.a;
								var shopCategories = _v5.b;
								if (!community.bB) {
									return A2(
										$author$project$Page$fullPageNotFound,
										t('error.pageNotFound'),
										t('shop.disabled.description'));
								} else {
									var _v6 = model_.pN;
									switch (_v6.$) {
										case 1:
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2($author$project$Page$viewHeader, loggedIn, ''),
														$author$project$Page$fullPageLoading(loggedIn.A)
													]));
										case 0:
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2($author$project$Page$viewHeader, loggedIn, ''),
														$author$project$Page$fullPageLoading(loggedIn.A)
													]));
										case 2:
											var e = _v6.a;
											return A2(
												$author$project$Page$fullPageGraphQLError,
												t('shop.title'),
												e);
										default:
											var sale = _v6.a;
											var maybeBalance = A2(
												$elm_community$list_extra$List$Extra$find,
												function (bal) {
													return _Utils_eq(bal.mk.as, sale.as);
												},
												model_.hx);
											var isOwner = _Utils_eq(sale.jz.l8, loggedIn._);
											var isOutOfStock = $author$project$Shop$isOutOfStock(sale);
											var isDisabled = isOwner || isOutOfStock;
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex-grow flex flex-col')
													]),
												_List_fromArray(
													[
														A2($author$project$Page$viewHeader, loggedIn, sale.fN),
														A3(
														viewContent,
														sale,
														sale.dn,
														A2(
															$elm$html$Html$map,
															$author$project$Page$Shop$Viewer$AsLoggedInMsg,
															A6(
																$author$project$Form$view,
																_List_Nil,
																loggedIn.A.aw,
																function (submitButton) {
																	return _List_fromArray(
																		[
																			isOwner ? A2(
																			$elm$html$Html$button,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('button button-primary w-full'),
																					$elm$html$Html$Attributes$disabled(!loggedIn.gz),
																					$elm$html$Html$Events$onClick($author$project$Page$Shop$Viewer$ClickedEditSale),
																					$elm$html$Html$Attributes$type_('button')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					t('shop.edit'))
																				])) : A2(
																			submitButton,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('button button-primary w-full'),
																					$elm$html$Html$Attributes$disabled(isOutOfStock || (!loggedIn.gz))
																				]),
																			_List_fromArray(
																				[
																					isOutOfStock ? $elm$html$Html$text(
																					t('shop.sold_out')) : $elm$html$Html$text(
																					t('shop.buy'))
																				]))
																		]);
																},
																A5(
																	$author$project$Page$Shop$Viewer$createForm,
																	loggedIn.A.aw,
																	sale,
																	maybeBalance,
																	{hJ: community.oh, nP: isDisabled},
																	$author$project$Page$Shop$Viewer$GotFormInteractionMsg),
																A2($author$project$Form$withDisabled, isDisabled, model_.hY),
																{
																	oU: $author$project$Page$Shop$Viewer$ClickedTransfer(sale),
																	lF: $author$project$Page$Shop$Viewer$GotFormMsg
																}))),
														A2(
														$elm$html$Html$map,
														$author$project$Page$Shop$Viewer$AsLoggedInMsg,
														A4($author$project$Page$Shop$Viewer$viewEditSaleModal, translators, model_, shopCategories, sale)),
														A2(
														$elm$html$Html$map,
														$author$project$Page$Shop$Viewer$AsLoggedInMsg,
														A2($author$project$Page$Shop$Viewer$viewConfirmDeleteModal, translators, model_))
													]));
									}
								}
						}
					} else {
						break _v0$2;
					}
				}
			}
			return A2(
				$author$project$Page$fullPageError,
				t('shop.title'),
				$elm$http$Http$Timeout);
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Page$ViewTransfer$GotProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Eos$Explorer$Transfer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$ViewTransfer$viewDetail = F3(
	function (containerAttrs, title, content) {
		return A2(
			$elm$html$Html$div,
			containerAttrs,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[content]))
				]));
	});
var $author$project$Profile$Summary$withNameBg = F2(
	function (showNameTagBg, model) {
		return _Utils_update(
			model,
			{hd: showNameTagBg});
	});
var $author$project$Page$ViewTransfer$viewTransferCard = F6(
	function (loggedIn, transfer, transferDirection, profileSummaries, profileSummaryToMsg, attrs) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var _v1 = function () {
			if (!transferDirection) {
				return _Utils_Tuple3(transfer.fO, transfer.e_, 'rotate-90');
			} else {
				return _Utils_Tuple3(transfer.e_, transfer.fO, '-rotate-90');
			}
		}();
		var leftProfile = _v1.a;
		var rightProfile = _v1.b;
		var rotateClass = _v1.c;
		var viewSummary = F2(
			function (profile, summary) {
				return A2(
					$elm$html$Html$map,
					profileSummaryToMsg(
						_Utils_eq(profile, leftProfile)),
					A4(
						$author$project$Profile$Summary$view,
						loggedIn.A.aw,
						loggedIn._,
						profile,
						A2(
							$author$project$Profile$Summary$withRelativeSelector,
							'#content-container',
							A2($author$project$Profile$Summary$withNameBg, false, summary))));
			});
		var arrowClass = 'fill-current text-black ' + rotateClass;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('flex justify-between'),
				attrs),
			_List_fromArray(
				[
					A2(viewSummary, leftProfile, profileSummaries.bE),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex mt-2 space-x-2 justify-self-center')
						]),
					_List_fromArray(
						[
							$author$project$Icons$arrowDown(arrowClass),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col px-2 font-bold')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-black text-sm uppercase')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											function () {
												if (!transferDirection) {
													return t('transfer_result.received');
												} else {
													return t('transfer_result.transferred');
												}
											}())
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-green')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Eos$assetToString,
												loggedIn.A.aw,
												{ji: transfer.lW, as: transfer.V.as}))
										]))
								])),
							$author$project$Icons$arrowDown(arrowClass)
						])),
					A2(viewSummary, rightProfile, profileSummaries.li)
				]));
	});
var $author$project$Page$ViewTransfer$viewDetails = F4(
	function (loggedIn, transfer, profileSummaries, direction) {
		var shared = loggedIn.A;
		var t = function (str) {
			return $elm$core$String$toUpper(
				shared.aw.fL(str));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white pt-6 pb-10 lg:pt-0 lg:pb-0 lg:w-2/3 lg:mx-auto lg:self-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4 lg:mx-0 lg:px-0 lg:max-w-none')
						]),
					_List_fromArray(
						[
							A6(
							$author$project$Page$ViewTransfer$viewTransferCard,
							loggedIn,
							transfer,
							direction,
							profileSummaries,
							$author$project$Page$ViewTransfer$GotProfileSummaryMsg,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pb-6 border-b border-gray-500')
								])),
							A3(
							$author$project$Page$ViewTransfer$viewDetail,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-6')
								]),
							t('transfer_result.date'),
							A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$View$Components$dateViewer,
										_List_Nil,
										$elm$core$Basics$identity,
										shared,
										$author$project$Utils$fromDateTime(transfer.f5)),
										A4(
										$author$project$View$Components$dateViewer,
										_List_Nil,
										function (translations) {
											return _Utils_update(
												translations,
												{
													o$: '',
													p4: $elm$core$Maybe$Just(', {{date}}'),
													qo: $elm$core$Maybe$Just(', {{date}}')
												});
										},
										shared,
										$author$project$Utils$fromDateTime(transfer.f5))
									]))),
							function () {
							var _v0 = transfer.kE;
							if (_v0.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var memo = _v0.a;
								return _Utils_eq(memo, $author$project$Markdown$empty) ? $elm$html$Html$text('') : A3(
									$author$project$Page$ViewTransfer$viewDetail,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-6')
										]),
									t('transfer_result.message'),
									A2($author$project$Markdown$view, _List_Nil, memo));
							}
						}(),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary w-full mt-6'),
									$elm$html$Html$Attributes$href(
									A2(
										$author$project$Eos$Explorer$link,
										shared.m8,
										$author$project$Eos$Explorer$Transfer(transfer.mQ))),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('block_explorer.see'))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary w-full mt-4'),
									$author$project$Route$href($author$project$Route$Dashboard)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('transfer_result.my_balance'))
								]))
						]))
				]));
	});
var $author$project$Page$ViewTransfer$viewTransfer = F3(
	function (loggedIn, transfer, direction) {
		var t = loggedIn.A.aw.fL;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('isolate text-white text-center bg-purple-500 pt-4 pb-6 lg:pb-0 lg:pt-0 lg:w-2/3 lg:mx-auto')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4 lg:mx-0 lg:px-0 lg:max-w-none')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-64 w-full'),
									$elm$html$Html$Attributes$src('/images/transfer-doggo.svg'),
									$elm$html$Html$Attributes$alt('')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold text-xl mt-7 mb-4')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									function () {
										if (direction === 1) {
											return t('transfer_result.transfer_success');
										} else {
											return t('transfer_result.receive_success');
										}
									}())
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('transfer_result.transaction_id.body'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xl md:text-2xl mt-4')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Emoji$encode(transfer.mQ))
								]))
						]))
				]));
	});
var $author$project$Page$ViewTransfer$view = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.A.aw;
		var t = _v0.fL;
		var content = function () {
			var _v3 = model.pN;
			switch (_v3.$) {
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.A);
				case 1:
					var error = _v3.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Page$viewHeader,
								loggedIn,
								t('transfer_result.title')),
								A2(
								$author$project$Page$fullPageGraphQLError,
								t('transfer_result.title'),
								error)
							]));
				default:
					var maybeTransfer = _v3.a;
					var direction = _v3.b;
					var profileSummaries = _v3.c;
					if (!maybeTransfer.$) {
						var transfer = maybeTransfer.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-grow flex flex-col')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Page$viewHeader,
									loggedIn,
									t('transfer_result.title')),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('relative flex-grow flex items-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bg-purple-500 absolute top-0 bottom-0 left-0 right-1/2 hidden lg:block')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bg-white absolute top-0 bottom-0 left-1/2 right-0 hidden lg:block')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('relative flex-grow grid grid-cols-1 mb-10 lg:container lg:mx-auto lg:px-4 lg:grid-cols-2 lg:py-10 lg:mb-0'),
													$elm$html$Html$Attributes$id('content-container')
												]),
											_List_fromArray(
												[
													A3($author$project$Page$ViewTransfer$viewTransfer, loggedIn, transfer, direction),
													A4($author$project$Page$ViewTransfer$viewDetails, loggedIn, transfer, profileSummaries, direction)
												]))
										]))
								]));
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto px-4')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Could not load the transfer')
										]))
								]));
					}
			}
		}();
		var title = function () {
			var _v1 = model.pN;
			if (_v1.$ === 2) {
				var maybeTransfer = _v1.a;
				if (!maybeTransfer.$) {
					return t('transfer_result.title');
				} else {
					return '';
				}
			} else {
				return '';
			}
		}();
		return {mJ: content, fN: title};
	});
var $author$project$Session$Guest$ClickedTryAgainTranslation = {$: 1};
var $author$project$Session$Guest$GotFeedbackMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Session$Guest$loginLeftCol = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('hidden md:block md:visible md:w-2/5 h-screen sticky top-0 bg-bottom bg-no-repeat'),
			A2($elm$html$Html$Attributes$style, 'background-color', '#EFF9FB'),
			A2($elm$html$Html$Attributes$style, 'background-size', 'auto 80%'),
			A2($elm$html$Html$Attributes$style, 'background-image', 'url(/images/auth_bg_full.png)')
		]),
	_List_Nil);
var $author$project$Session$Shared$translationStatus = function (shared) {
	return shared.bP;
};
var $author$project$View$Feedback$ClickedClose = 0;
var $author$project$View$Feedback$view = function (model) {
	if (!model.$) {
		return $elm$html$Html$text('');
	} else {
		var status = model.a;
		var content = model.b;
		var bgColor = function () {
			if (!status) {
				return 'bg-green';
			} else {
				return 'bg-red';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full sticky top-0 text-white py-2 grid grid-cols-10 z-40 ' + bgColor),
					$fapian$elm_html_aria$Html$Attributes$Aria$role('alert')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-center text-white font-bold col-start-2 col-end-10')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(content)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-auto mr-6 cursor-pointer'),
							$elm$html$Html$Events$onClick(0)
						]),
					_List_fromArray(
						[
							$author$project$Icons$close('fill-current text-white w-4 h-4')
						]))
				]));
	}
};
var $author$project$Session$Shared$viewFullError = F4(
	function (shared, _v0, msg, msgText) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('full-page-loading full-spinner-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(msgText)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(msg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$I18Next$t, shared.fV, 'menu.try_again'))
						]))
				]));
	});
var $author$project$Session$Shared$viewFullLoading = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('full-page-loading full-spinner-container')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('spinner')
				]),
			_List_Nil)
		]));
var $author$project$Session$Guest$ClickedLanguage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Session$Guest$ShowLanguageNav = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$Session$Shared$langFlag = F2(
	function (attrs, language) {
		var iconLink = function () {
			switch (language) {
				case 0:
					return '/icons/flag-usa.svg';
				case 1:
					return '/icons/flag-brazil.svg';
				case 2:
					return '/icons/flag-spain.svg';
				case 3:
					return '/icons/flag-catalan.svg';
				default:
					return '/icons/flag-ethiopia.svg';
			}
		}();
		return A2(
			$elm$html$Html$img,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('object-cover rounded-full'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$src(iconLink),
					attrs)),
			_List_Nil);
	});
var $author$project$Translation$languageToLanguageCode = function (language) {
	switch (language) {
		case 0:
			return 'en-US';
		case 1:
			return 'pt-br';
		case 2:
			return 'es';
		case 3:
			return 'cat';
		default:
			return 'amh';
	}
};
var $author$project$Translation$allLanguages = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$Session$Shared$viewLanguageItems = F3(
	function (_v0, shared, toMsg) {
		var containerAttrs = _v0.mF;
		var flagIconAttrs = _v0.nk;
		return A2(
			$elm$core$List$map,
			function (lang) {
				return A2(
					$elm$html$Html$button,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onClick(
							toMsg(lang)),
						containerAttrs),
					_List_fromArray(
						[
							A2($author$project$Session$Shared$langFlag, flagIconAttrs, lang),
							$elm$html$Html$text(
							$author$project$Translation$languageToLanguageCode(lang))
						]));
			},
			A2(
				$elm$core$List$sortBy,
				$author$project$Translation$languageToLocale,
				A2(
					$elm$core$List$filter,
					function (l) {
						return !_Utils_eq(l, shared.ic);
					},
					$author$project$Translation$allLanguages)));
	});
var $author$project$Session$Guest$viewPageHeader = F2(
	function (model, shared) {
		var logo = function () {
			var _v0 = model.V;
			switch (_v0.$) {
				case 1:
					return '';
				case 0:
					return '';
				case 3:
					var comm = _v0.a;
					return comm.fe;
				default:
					return shared.fe;
			}
		}();
		return A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center justify-between pl-4 py-4 md:pl-6 bg-white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(
							A2($author$project$Route$Login, model.kC, model.me))
						]),
					_List_fromArray(
						[
							$elm$core$String$isEmpty(logo) ? $elm$html$Html$text('') : A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-10'),
									$elm$html$Html$Attributes$src(logo)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative z-50')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$tabindex(-1),
									$elm$html$Html$Attributes$class('flex block relative z-20 items-center px-4 py-2 bg-white text-sm focus:outline-none'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('rounded-tr-lg rounded-tl-lg justify-between lang-menu-open', model.bt)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Session$Guest$ShowLanguageNav(!model.bt)),
									$elm$html$Html$Events$onMouseEnter(
									$author$project$Session$Guest$ShowLanguageNav(true))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Session$Shared$langFlag,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-6 h-6 mr-2')
										]),
									shared.ic),
									model.bt ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex-grow whitespace-nowrap uppercase')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translation$languageToLanguageCode(model.A.ic))
										])) : $elm$html$Html$text(''),
									$author$project$Icons$arrowDown('flex-none')
								])),
							model.bt ? A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fixed h-full w-full inset-0 bg-black opacity-50 cursor-default'),
									$elm$html$Html$Events$onClick(
									$author$project$Session$Guest$ShowLanguageNav(false)),
									$elm$html$Html$Events$onMouseEnter(
									$author$project$Session$Guest$ShowLanguageNav(false))
								]),
							_List_Nil) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute right-0 w-full py-2 bg-white border-t rounded-br-lg rounded-bl-lg shadow-lg'),
									$elm$html$Html$Attributes$class('lang-menu-open'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('hidden', !model.bt)
										]))
								]),
							A3(
								$author$project$Session$Shared$viewLanguageItems,
								{
									mF: _List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex w-full px-4 py-2 text-gray items-center text-sm uppercase focus-ring rounded-sm hover:text-indigo-500 focus-visible:text-indigo-500')
										]),
									nk: _List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-6 h-6 mr-2')
										])
								},
								shared,
								$author$project$Session$Guest$ClickedLanguage))
						]))
				]));
	});
var $author$project$Session$Guest$view = F4(
	function (thisMsg, page, model, content) {
		var shared = model.A;
		var _v0 = function () {
			switch (page) {
				case 4:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just($author$project$Session$Guest$loginLeftCol),
						'md:w-3/5');
				case 3:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just($author$project$Session$Guest$loginLeftCol),
						'md:w-3/5');
				case 5:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full');
				case 6:
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full'),
						A2(
							$elm$core$Maybe$map,
							function (community) {
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(
										A3($author$project$Community$communityPreviewImage, true, model.A, community)),
									'md:w-1/2');
							},
							$krisajenkins$remotedata$RemoteData$toMaybe(model.V)));
				case 7:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full');
				case 0:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full');
				case 1:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full');
				default:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full');
			}
		}();
		var maybeLeftArt = _v0.a;
		var rightColWidth = _v0.b;
		var _v2 = $author$project$Session$Shared$translationStatus(shared);
		switch (_v2.$) {
			case 0:
				return $author$project$Session$Shared$viewFullLoading;
			case 1:
				var err = _v2.a;
				return A2(
					$elm$html$Html$map,
					thisMsg,
					A4($author$project$Session$Shared$viewFullError, shared, err, $author$project$Session$Guest$ClickedTryAgainTranslation, 'An error occurred while loading translation.'));
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('md:flex')
						]),
					_List_fromArray(
						[
							function () {
							if (!maybeLeftArt.$) {
								var leftArt = maybeLeftArt.a;
								return leftArt;
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('min-h-screen flex flex-col'),
									$elm$html$Html$Attributes$class(rightColWidth)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									thisMsg,
									A2($author$project$Session$Guest$viewPageHeader, model, shared)),
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$Session$Guest$GotFeedbackMsg, thisMsg),
									$author$project$View$Feedback$view(model.hU)),
									content
								]))
						]));
		}
	});
var $author$project$Page$viewGuest = F4(
	function (thisMsg, page, model, content) {
		return A4(
			$author$project$Session$Guest$view,
			A2($elm$core$Basics$composeL, thisMsg, $author$project$Page$GotGuestMsg),
			page,
			model,
			content);
	});
var $author$project$Auth$view = F2(
	function (shared, model) {
		var _v0 = shared.aw;
		var t = _v0.fL;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-sm')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						t('auth.login.enterPinToContinue'))
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Auth$GotPinMsg,
				A2($author$project$View$Pin$view, shared.aw, model.ak))
			]);
	});
var $author$project$Session$LoggedIn$viewAuthModal = F2(
	function (pageMsg, model) {
		var shared = model.A;
		return A2(
			$elm$html$Html$map,
			pageMsg,
			$author$project$View$Modal$toHtml(
				A2(
					$author$project$View$Modal$withBody,
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($author$project$Session$LoggedIn$GotAuthMsg),
						A2($author$project$Auth$view, shared, model.ml)),
					A2(
						$author$project$View$Modal$withHeader,
						shared.aw.fL('auth.login.modalFormTitle'),
						$author$project$View$Modal$initWith(
							{mw: $author$project$Session$LoggedIn$ClosedAuthModal, nX: model.el})))));
	});
var $author$project$Session$Shared$viewFullGraphqlError = F4(
	function (shared, _v0, msg, msgText) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('full-page-loading full-spinner-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(msgText)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(msg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$I18Next$t, shared.fV, 'menu.try_again'))
						]))
				]));
	});
var $author$project$Session$LoggedIn$codeOfConductVersion = '1.0';
var $author$project$Session$LoggedIn$codeOfConductModal = function (model) {
	var needsToWaitBeforeDenyingAgain = function () {
		var _v3 = model.ab;
		if (_v3.$ === 2) {
			var hasCompletedAnimation = _v3.a.gA;
			return !hasCompletedAnimation;
		} else {
			return false;
		}
	}();
	var _v0 = model.A.aw;
	var t = _v0.fL;
	var tr = _v0.i4;
	return $author$project$View$Modal$toHtml(
		A2(
			$author$project$View$Modal$withFooter,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full grid gap-4 md:grid-cols-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClickedAcceptCodeOfConduct),
									$elm$html$Html$Attributes$class('button button-primary w-full')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('terms_of_conduct.accept'))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClickedDenyCodeOfConduct),
									$elm$html$Html$Attributes$class('button button-secondary !bg-white w-full relative overflow-hidden'),
									$elm$html$Html$Attributes$disabled(needsToWaitBeforeDenyingAgain)
								]),
							_List_fromArray(
								[
									function () {
									var _v2 = model.ab;
									if (_v2.$ === 2) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('absolute top-0 left-0 bottom-0 bg-gray-500 w-full origin-left animate-scale-down'),
													A2(
													$elm$html$Html$Events$on,
													'animationend',
													$elm$json$Json$Decode$succeed($author$project$Session$LoggedIn$EndedCodeOfConductWarningAnimation))
												]),
											_List_Nil);
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('z-10')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('terms_of_conduct.deny'))
										]))
								]))
						]))
				]),
			A2(
				$author$project$View$Modal$withBody,
				function () {
					var _v1 = model.ab;
					switch (_v1.$) {
						case 0:
							return _List_Nil;
						case 1:
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-4')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('terms_of_conduct.description'))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('terms_of_conduct.to_have_good_experience'))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(
													$author$project$Session$LoggedIn$codeOfConductUrl(model.A.ic)),
													$elm$html$Html$Attributes$target('_blank'),
													$elm$html$Html$Attributes$class('text-orange-300 hover:underline focus-visible:underline focus-visible:outline-none rounded-sm')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														tr,
														'terms_of_conduct.link',
														_List_fromArray(
															[
																_Utils_Tuple2('version', $author$project$Session$LoggedIn$codeOfConductVersion)
															])))
												]))
										]))
								]);
						default:
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-red mt-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('uppercase')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('terms_of_conduct.attention'))
												])),
											$elm$html$Html$text(
											t('terms_of_conduct.not_accepting'))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												tr,
												'terms_of_conduct.to_participate',
												_List_fromArray(
													[
														_Utils_Tuple2('version', $author$project$Session$LoggedIn$codeOfConductVersion)
													])))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('terms_of_conduct.are_you_sure'))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(
													$author$project$Session$LoggedIn$codeOfConductUrl(model.A.ic)),
													$elm$html$Html$Attributes$target('_blank'),
													$elm$html$Html$Attributes$class('text-orange-300 hover:underline')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														tr,
														'terms_of_conduct.link',
														_List_fromArray(
															[
																_Utils_Tuple2('version', $author$project$Session$LoggedIn$codeOfConductVersion)
															])))
												]))
										]))
								]);
					}
				}(),
				A2(
					$author$project$View$Modal$withHeader,
					A2(
						tr,
						'terms_of_conduct.title',
						_List_fromArray(
							[
								_Utils_Tuple2('version', $author$project$Session$LoggedIn$codeOfConductVersion)
							])),
					$author$project$View$Modal$initWith(
						{
							mw: $author$project$Session$LoggedIn$ClickedDenyCodeOfConduct,
							nX: !_Utils_eq(model.ab, $author$project$Session$LoggedIn$CodeOfConductNotShown)
						})))));
};
var $author$project$Session$LoggedIn$communitySelectorModal = function (model) {
	var viewCommunityItem = function (c) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full flex items-center p-3 m-1 text-body rounded-sm hover:text-black hover:bg-gray-100 focus:outline-none focus:ring'),
							$elm$html$Html$Events$onClick(
							$author$project$Session$LoggedIn$SelectedCommunity(c))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(c.fe),
									$elm$html$Html$Attributes$class('h-16 w-16 mr-5 object-scale-down')
								]),
							_List_Nil),
							$elm$html$Html$text(c.fj)
						]))
				]));
	};
	var t = function (s) {
		return model.A.aw.fL(s);
	};
	var text_ = function (s) {
		return $elm$html$Html$text(
			t(s));
	};
	if (model.cm) {
		var _v0 = model.pl;
		if (_v0.$ === 3) {
			var pro = _v0.a;
			return $elm$core$List$isEmpty(pro.eK) ? $elm$html$Html$text('') : $author$project$View$Modal$toHtml(
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									text_('menu.community_selector.body')
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full flex flex-col overflow-y-auto divide-y divide-gray-300')
								]),
							A2($elm$core$List$map, viewCommunityItem, pro.eK))
						]),
					A2(
						$author$project$View$Modal$withHeader,
						t('menu.community_selector.title'),
						$author$project$View$Modal$initWith(
							{mw: $author$project$Session$LoggedIn$CloseCommunitySelector, nX: true}))));
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Session$LoggedIn$isCommunityMember = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Session$LoggedIn$profile(model),
		model.pC);
	_v0$2:
	while (true) {
		if (!_v0.a.$) {
			if (_v0.b.$ === 3) {
				var profile_ = _v0.a.a;
				var community = _v0.b.a;
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.as;
						},
						$elm$core$Basics$eq(community.as)),
					profile_.eK) || A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.l8;
						},
						$elm$core$Basics$eq(profile_.l8)),
					community.ih);
			} else {
				break _v0$2;
			}
		} else {
			if (_v0.b.$ === 3) {
				var _v1 = _v0.a;
				var community = _v0.b.a;
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.l8;
						},
						$elm$core$Basics$eq(model._)),
					community.ih);
			} else {
				break _v0$2;
			}
		}
	}
	return false;
};
var $author$project$Session$LoggedIn$hideCommunityAndSearch = F2(
	function (currentPage, model) {
		var hiddenPages = _List_fromArray(
			[$author$project$Session$LoggedIn$CommunitySelector]);
		return A2($elm$core$List$member, currentPage, hiddenPages) || (!$author$project$Session$LoggedIn$isCommunityMember(model));
	});
var $author$project$Session$LoggedIn$insufficientPermissionsModal = function (model) {
	var _v0 = model.A.aw;
	var t = _v0.fL;
	return $author$project$View$Modal$toHtml(
		A2(
			$author$project$View$Modal$withSize,
			0,
			A2(
				$author$project$View$Modal$withFooter,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-primary w-full mt-2'),
								$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClosedInsufficientPermissionsModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('permissions.insufficient.ok'))
							]))
					]),
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/images/girl-with-ice-cube.svg'),
									$elm$html$Html$Attributes$alt(''),
									$elm$html$Html$Attributes$class('mx-auto mt-4 mb-6')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('md:max-w-md md:mx-auto md:text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('permissions.insufficient.explanation'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('my-4 md:max-w-md md:mx-auto md:text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('permissions.insufficient.try_again'))
								]))
						]),
					A2(
						$author$project$View$Modal$withHeader,
						t('permissions.insufficient.title'),
						$author$project$View$Modal$initWith(
							{mw: $author$project$Session$LoggedIn$ClosedInsufficientPermissionsModal, nX: model.bs}))))));
};
var $author$project$Search$isActive = function (model) {
	var _v0 = model.Z;
	if (!_v0.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Session$LoggedIn$isAdminPage = function (page) {
	return A2(
		$elm$core$List$member,
		page,
		_List_fromArray(
			[$author$project$Session$LoggedIn$CommunitySettings, $author$project$Session$LoggedIn$CommunitySettingsInfo, $author$project$Session$LoggedIn$CommunitySettingsNews, $author$project$Session$LoggedIn$CommunitySettingsNewsEditor, $author$project$Session$LoggedIn$CommunitySettingsCurrency, $author$project$Session$LoggedIn$CommunitySettingsFeatures, $author$project$Session$LoggedIn$CommunitySettingsSponsorship, $author$project$Session$LoggedIn$CommunitySettingsSponsorshipFiat, $author$project$Session$LoggedIn$CommunitySettingsSponsorshipThankYouMessage, $author$project$Session$LoggedIn$CommunitySettingsObjectiveEditor, $author$project$Session$LoggedIn$CommunitySettingsActionEditor]));
};
var $author$project$Action$ClickedCloseClaimModal = {$: 0};
var $author$project$Action$ConfirmedClaimAction = {$: 1};
var $author$project$Action$ConfirmedClaimActionWithPhotoProof = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$time_extra$Time$Extra$Second = 14;
var $author$project$Form$File$withFileTypes = F2(
	function (fileTypes, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{dE: fileTypes});
	});
var $author$project$Action$claimWithPhotoForm = function (translators) {
	return A2(
		$author$project$Form$with,
		A2(
			$author$project$Form$file,
			{
				ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				o3: $elm$core$Result$Ok,
				aw: translators,
				qd: F2(
					function (newModel, _v1) {
						return newModel;
					}),
				lW: $elm$core$Basics$identity
			},
			A2(
				$author$project$Form$File$withAddImagesContainerAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-56 rounded-sm')
					]),
				A2(
					$author$project$Form$File$withImageClass,
					'h-56',
					A2(
						$author$project$Form$File$withEntryContainerAttributes,
						function (_v0) {
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-56 w-full')
								]);
						},
						A2(
							$author$project$Form$File$withContainerAttributes,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full mt-2')
								]),
							A2(
								$author$project$Form$File$withGrayBoxVariant,
								translators,
								A2(
									$author$project$Form$File$withFileTypes,
									_List_fromArray(
										[1, 0]),
									$author$project$Form$File$init(
										{w: 'photo-proof-input'})))))))),
		$author$project$Form$succeed($elm$core$Basics$identity));
};
var $justinmimbs$time_extra$Time$Extra$Week = 3;
var $justinmimbs$date$Date$Month = 2;
var $justinmimbs$date$Date$Quarter = 1;
var $justinmimbs$date$Date$Week = 3;
var $justinmimbs$date$Date$Year = 0;
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval) {
			case 15:
				return posix;
			case 14:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 13:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 12:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 11:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 11, zone, posix);
			case 2:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 2, zone, posix);
			case 0:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 0, zone, posix);
			case 1:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 1, zone, posix);
			case 3:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 3, zone, posix);
			case 4:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 4, zone, posix);
			case 5:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 5, zone, posix);
			case 6:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 6, zone, posix);
			case 7:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 7, zone, posix);
			case 8:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 8, zone, posix);
			case 9:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 9, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 10, zone, posix);
		}
	});
var $justinmimbs$time_extra$Time$Extra$toFractionalDay = F2(
	function (zone, posix) {
		return A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix) / 86400000;
	});
var $justinmimbs$time_extra$Time$Extra$toMonths = F2(
	function (zone, posix) {
		var wholeMonths = (12 * (A2($elm$time$Time$toYear, zone, posix) - 1)) + ($justinmimbs$date$Date$monthToNumber(
			A2($elm$time$Time$toMonth, zone, posix)) - 1);
		var fractionalMonth = (A2($elm$time$Time$toDay, zone, posix) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix)) / 100;
		return wholeMonths + fractionalMonth;
	});
var $justinmimbs$time_extra$Time$Extra$toRataDieMoment = F2(
	function (zone, posix) {
		return $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix);
	});
var $justinmimbs$time_extra$Time$Extra$diff = F4(
	function (interval, zone, posix1, posix2) {
		diff:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$posixToMillis(posix2) - $elm$time$Time$posixToMillis(posix1);
				case 14:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 1000) | 0;
				case 13:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 60000) | 0;
				case 12:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 3600000) | 0;
				case 11:
					return (A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix1)) | 0;
				case 2:
					return (A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix1)) | 0;
				case 0:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 12) | 0;
				case 1:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 3) | 0;
				case 3:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 11, zone, posix1, posix2) / 7) | 0;
				default:
					var weekday = interval;
					var $temp$interval = 3,
						$temp$zone = zone,
						$temp$posix1 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix1),
						$temp$posix2 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix2);
					interval = $temp$interval;
					zone = $temp$zone;
					posix1 = $temp$posix1;
					posix2 = $temp$posix2;
					continue diff;
			}
		}
	});
var $author$project$Utils$padInt = F2(
	function (totalLength, number) {
		var currentLength = $elm$core$String$length(
			$elm$core$String$fromInt(number));
		var missingLength = totalLength - currentLength;
		return _Utils_ap(
			A2($elm$core$String$repeat, missingLength, '0'),
			$elm$core$String$fromInt(number));
	});
var $author$project$Action$viewClaimCount = F3(
	function (_v0, attrs, action) {
		var t = _v0.fL;
		var tr = _v0.i4;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mt-4 p-2 bg-gray-100 flex items-center justify-center text-gray-900 font-semibold text-sm rounded-sm'),
				attrs),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/images/doggo_holding_coins.svg'),
							$elm$html$Html$Attributes$alt(''),
							$elm$html$Html$Attributes$class('w-8 mr-2')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('community.objectives.claim_count')),
							$elm$html$Html$text(' '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-base ml-1 font-bold')
								]),
							_List_fromArray(
								[
									(action.hE === 1) ? $elm$html$Html$text(
									t('community.objectives.claim_count_times_singular')) : $elm$html$Html$text(
									A2(
										tr,
										'community.objectives.claim_count_times',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'count',
												$elm$core$String$fromInt(action.hE))
											])))
								]))
						]))
				]));
	});
var $author$project$Action$viewClaimModal = F2(
	function (shared, status) {
		if (!status.$) {
			return $elm$html$Html$text('');
		} else {
			var action = status.a.dh;
			var proof = status.a.aY;
			var position = status.a.bq;
			var _v1 = shared.aw;
			var t = _v1.fL;
			var _v2 = function () {
				if (proof.$ === 1) {
					var formModel = proof.a;
					return _Utils_Tuple2(
						A3(
							$author$project$Form$parse,
							$author$project$Action$claimWithPhotoForm(shared.aw),
							formModel,
							{
								oM: $author$project$Action$GotPhotoProofFormMsg,
								oV: function (photoProofUrl) {
									return $author$project$Action$ConfirmedClaimActionWithPhotoProof(
										{
											k_: photoProofUrl,
											g3: function () {
												if ((proof.$ === 1) && (proof.b.$ === 2)) {
													var proofCode = proof.b.a;
													return $elm$core$Maybe$Just(proofCode);
												} else {
													return $elm$core$Maybe$Nothing;
												}
											}()
										});
								}
							}),
						$author$project$Form$hasFieldsLoading(formModel));
				} else {
					return _Utils_Tuple2($author$project$Action$ConfirmedClaimAction, false);
				}
			}();
			var onClaimClick = _v2.a;
			var isClaimDisabled = _v2.b;
			return A2(
				$elm$html$Html$map,
				$author$project$Action$GotClaimingActionMsg,
				$author$project$View$Modal$toHtml(
					A2(
						$author$project$View$Modal$withSize,
						1,
						A2(
							$author$project$View$Modal$withFooter,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full grid md:grid-cols-2 gap-4')
										]),
									_List_fromArray(
										[
											$author$project$Action$isClaimable(action) ? A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button button-secondary w-full'),
													$elm$html$Html$Events$onClick($author$project$Action$ClickedCloseClaimModal)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('menu.cancel'))
												])) : $elm$html$Html$text(''),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(onClaimClick),
													$elm$html$Html$Attributes$class('button button-primary w-full'),
													$elm$html$Html$Attributes$disabled(isClaimDisabled)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('dashboard.claim'))
												]))
										]))
								]),
							A2(
								$author$project$View$Modal$withBody,
								_List_fromArray(
									[
										function () {
										var _v5 = action.h2;
										if (_v5.$ === 1) {
											return $elm$html$Html$text('');
										} else {
											if (_v5.a === '') {
												return $elm$html$Html$text('');
											} else {
												var image = _v5.a;
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('mb-4 relative')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$src(image),
																	$elm$html$Html$Attributes$alt(''),
																	$elm$html$Html$Attributes$class('max-w-full mx-auto object-scale-down rounded')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('bg-gradient-to-t from-[#01003a14] to-[#01003a00] absolute top-0 left-0 w-full h-full rounded')
																]),
															_List_Nil)
														]));
											}
										}
									}(),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'md:mb-6',
														_Utils_eq(proof, $author$project$Action$NoProofNecessary))
													]))
											]),
										_List_fromArray(
											[
												function () {
												if (position.$ === 1) {
													return $author$project$Icons$flag('w-8 text-green fill-current');
												} else {
													var validPosition = position.a;
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-lg text-gray-500 font-bold'),
																$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$elm$core$String$fromInt(validPosition) + '.')
															]));
												}
											}(),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('ml-5 mt-1 min-w-0 w-full')
													]),
												_List_fromArray(
													[
														A2($author$project$Markdown$view, _List_Nil, action.aR),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('md:flex md:justify-between md:w-full')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('font-bold text-sm text-gray-900 uppercase block mt-6')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				t('community.objectives.reward'))
																			])),
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('text-green font-bold')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$span,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('text-2xl mr-1')
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						A3($author$project$Eos$formatSymbolAmount, shared.aw, action.ad.V.as, action.fA))
																					])),
																				$elm$html$Html$text(
																				$author$project$Eos$symbolToSymbolCodeString(action.ad.V.as))
																			]))
																	])),
																A3(
																$author$project$Action$viewClaimCount,
																shared.aw,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('hidden md:flex md:self-end md:mr-8')
																	]),
																action)
															]))
													]))
											])),
										A3(
										$author$project$Action$viewClaimCount,
										shared.aw,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('md:hidden'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'mb-6',
														_Utils_eq(proof, $author$project$Action$NoProofNecessary))
													]))
											]),
										action),
										function () {
										if (proof.$ === 1) {
											var formModel = proof.a;
											var proofCode = proof.b;
											var timeLeft = function () {
												switch (proofCode.$) {
													case 0:
														return $elm$core$Maybe$Nothing;
													case 1:
														return $elm$core$Maybe$Nothing;
													default:
														var expiration = proofCode.a.hT;
														var seconds = A2(
															$elm$core$Basics$modBy,
															60,
															A4($justinmimbs$time_extra$Time$Extra$diff, 14, shared.i2, shared.ce, expiration));
														var minutes = A4($justinmimbs$time_extra$Time$Extra$diff, 13, shared.i2, shared.ce, expiration);
														return $elm$core$Maybe$Just(
															{im: minutes, lq: seconds});
												}
											}();
											var isTimeOver = function () {
												if (timeLeft.$ === 1) {
													return false;
												} else {
													var minutes = timeLeft.a.im;
													return minutes < 0;
												}
											}();
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$p,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-lg font-bold text-gray-333 mt-6 mb-4 md:text-center')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																t('community.actions.proof.title'))
															])),
														function () {
														var _v8 = action.iG;
														if (!_v8.$) {
															var instructions = _v8.a;
															return A2($author$project$Markdown$view, _List_Nil, instructions);
														} else {
															return A2(
																$elm$html$Html$p,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		t('community.actions.proof.upload_hint'))
																	]));
														}
													}(),
														function () {
														switch (proofCode.$) {
															case 0:
																return $elm$html$Html$text('');
															case 1:
																return A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('p-4 mt-4 bg-gray-100 rounded-sm flex flex-col items-center justify-center md:w-1/2 md:mx-auto')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$span,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('uppercase text-gray-333 font-bold text-sm')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					t('community.actions.form.verification_code'))
																				])),
																			A2(
																			$elm$html$Html$span,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('bg-gray-333 animate-skeleton-loading h-10 w-44 mt-2')
																				]),
																			_List_Nil)
																		]));
															default:
																var code = proofCode.a.ds;
																return A2(
																	$elm$html$Html$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('p-4 mt-4 bg-gray-100 rounded-sm flex flex-col items-center justify-center md:w-1/2 md:mx-auto')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$span,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('uppercase text-gray-333 font-bold text-sm')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(
																							t('community.actions.form.verification_code'))
																						])),
																					A2(
																					$elm$html$Html$span,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('font-bold text-xl text-gray-333')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(code)
																						]))
																				])),
																			A2(
																			$elm$html$Html$p,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('text-purple-500 text-center mt-4'),
																					$elm$html$Html$Attributes$classList(
																					_List_fromArray(
																						[
																							_Utils_Tuple2('text-red', isTimeOver)
																						]))
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					t('community.actions.proof.code_period_label')),
																					$elm$html$Html$text(' '),
																					A2(
																					$elm$html$Html$span,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('font-bold')
																						]),
																					_List_fromArray(
																						[
																							function () {
																							if (timeLeft.$ === 1) {
																								return $elm$html$Html$text('30:00');
																							} else {
																								var minutes = timeLeft.a.im;
																								var seconds = timeLeft.a.lq;
																								return $elm$html$Html$text(
																									A2($author$project$Utils$padInt, 2, minutes) + (':' + A2($author$project$Utils$padInt, 2, seconds)));
																							}
																						}()
																						]))
																				]))
																		]));
														}
													}(),
														A6(
														$author$project$Form$viewWithoutSubmit,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('mb-6')
															]),
														shared.aw,
														function (_v11) {
															return _List_Nil;
														},
														$author$project$Action$claimWithPhotoForm(shared.aw),
														formModel,
														{lF: $author$project$Action$GotPhotoProofFormMsg})
													]));
										} else {
											return $elm$html$Html$text('');
										}
									}()
									]),
								$author$project$View$Modal$initWith(
									{mw: $author$project$Action$ClickedCloseClaimModal, nX: true}))))));
		}
	});
var $author$project$Session$LoggedIn$viewCommunityContactsModal = function (model) {
	var _v0 = model.pC;
	if (_v0.$ === 3) {
		var community = _v0.a;
		var _v1 = model.A.aw;
		var t = _v1.fL;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('footer.choose_contact'))
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-wrap gap-6 items-start justify-center mt-6 mb-10')
							]),
						A2(
							$elm$core$List$map,
							function (contact) {
								return A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col items-center hover:opacity-60'),
													$elm$html$Html$Attributes$href(
													$author$project$Contact$toHref(contact)),
													$elm$html$Html$Attributes$target('blank'),
													$elm$html$Html$Attributes$title(
													A2($author$project$Contact$toLabel, model.A.aw, contact)),
													$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClosedCommunityContactsModal)
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Contact$circularIconWithGrayBg,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-10 h-10')
														]),
													model.A.aw,
													contact),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-gray-900 text-sm text-center mt-2 font-semibold line-clamp-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($author$project$Contact$toLabel, model.A.aw, contact))
														]))
												]))
										]));
							},
							community.az))
					]),
				A2(
					$author$project$View$Modal$withHeader,
					t('footer.need_help'),
					$author$project$View$Modal$initWith(
						{mw: $author$project$Session$LoggedIn$ClosedCommunityContactsModal, nX: model.cl}))));
	} else {
		return $elm$html$Html$text('');
	}
};
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $author$project$Icons$heartSolid = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('49'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 49 32'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M24.4692 27.1195C24.4692 27.1195 12.3218 19.4394 12.3218 10.6168C12.3218 7.20833 14.4914 4.9043 17.8298 4.9043C21.1681 4.9043 24.1335 9.34734 24.7552 9.34734C25.3768 9.34734 28.2552 4.9043 31.5935 4.9043C34.9319 4.9043 36.5669 7.20833 36.5669 10.6168C36.5918 19.3569 24.4692 27.1195 24.4692 27.1195Z'),
						$elm$svg$Svg$Attributes$fill('#DB1B1B')
					]),
				_List_Nil)
			]));
};
var $author$project$Session$LoggedIn$viewFooter = function (model) {
	var shared = model.A;
	var _v0 = shared.aw;
	var t = _v0.fL;
	var tr = _v0.i4;
	var viewContactSupport = function () {
		var _v1 = model.pC;
		if (_v1.$ === 3) {
			var community = _v1.a;
			if ($elm$core$List$isEmpty(community.az)) {
				return $elm$html$Html$text('');
			} else {
				var linkContainer = function (attrs) {
					var _v2 = community.az;
					if (_v2.b && (!_v2.b.b)) {
						var contact = _v2.a;
						return $elm$html$Html$a(
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$href(
									$author$project$Contact$toHref(contact)),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$target('blank'),
									attrs)));
					} else {
						return $elm$html$Html$button(
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClickedOpenCommunityContactsModal),
								attrs));
					}
				};
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('footer.need_help'))
								])),
							A2(
							linkContainer,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-orange-300 hover:underline text-left')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('footer.contact_support'))
								]))
						]));
			}
		} else {
			return $elm$html$Html$text('');
		}
	}();
	return A2(
		$elm$html$Html$footer,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-white w-full border-t border-grey-500 relative overflow-hidden'),
				$fapian$elm_html_aria$Html$Attributes$Aria$role('contentinfo')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container mx-auto px-4 pb-6 pt-12 flex flex-col lg:flex-row lg:py-4 lg:relative lg:overflow-hidden')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col lg:flex-row lg:items-center lg:flex-grow after:h-px after:w-1/4 after:mx-auto after:mt-12 after:bg-gray-500 lg:after:w-px lg:after:h-full lg:after:mr-8 lg:after:mt-0 lg:after:ml-auto')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sr-only')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('footer.created_with_love'))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center lg:flex-shrink-0')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-center flex justify-center items-center'),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('footer.created_with'))
													])),
												$author$project$Icons$heartSolid('w-7'),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('footer.created_by'))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex items-center ml-8')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('h-8'),
														$elm$html$Html$Attributes$src('/images/logo-cambiatus-mobile.svg'),
														$elm$html$Html$Attributes$alt('')
													]),
												_List_Nil),
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('h-12 ml-8'),
														$elm$html$Html$Attributes$src('/images/satisfied-vagabonds.svg'),
														$elm$html$Html$Attributes$alt('')
													]),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										$author$project$Session$LoggedIn$codeOfConductUrl(shared.ic)),
										$elm$html$Html$Attributes$target('_blank'),
										$elm$html$Html$Attributes$class('text-orange-300 mt-6 hover:underline lg:mt-0 lg:ml-10 lg:mr-4')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											tr,
											'terms_of_conduct.title',
											_List_fromArray(
												[
													_Utils_Tuple2('version', $author$project$Session$LoggedIn$codeOfConductVersion)
												])))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-4 lg:mt-0 lg:flex-shrink-0')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mr-32 md:mr-20 lg:mr-52 md:pt-6')
									]),
								_List_fromArray(
									[
										viewContactSupport,
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xs mt-6 text-gray-900')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													tr,
													'footer.version',
													_List_fromArray(
														[
															_Utils_Tuple2(
															'version',
															$author$project$Version$toString(shared.lZ))
														])))
											]))
									])),
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src('/images/man-with-envelope.svg'),
										$elm$html$Html$Attributes$alt(''),
										$elm$html$Html$Attributes$class('pointer-events-none absolute w-40 -bottom-12 -right-8 lg:right-4 md:-bottom-13 md:w-44')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Icons$languages = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('32'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M24.2727 4.09979C26.3815 4.09979 28.0909 5.98001 28.0909 8.29937V19.4983C28.0909 21.8176 26.3815 23.6978 24.2727 23.6978H12.6591L8.36364 27.8974V23.6978H7.72728C5.61855 23.6978 3.90909 21.8176 3.90909 19.4983V8.29937C3.90909 5.98001 5.61855 4.09979 7.72728 4.09979H24.2727ZM24.2727 2H7.72727C4.56419 2 2 4.82032 2 8.29937V19.4983C1.9985 22.4393 3.84747 24.9901 6.45455 25.6436V27.8974C6.45356 28.726 6.89564 29.4777 7.58311 29.8165C8.27058 30.1552 9.07488 30.0176 9.63636 29.4653L13.3909 25.7976H24.2727C27.4358 25.7976 30 22.9773 30 19.4983V8.29937C30 4.82032 27.4358 2 24.2727 2V2Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M16 14.9487C16.5271 14.9487 16.9545 14.4786 16.9545 13.8988C16.9545 13.3189 16.5271 12.8489 16 12.8489C15.4728 12.8489 15.0454 13.3189 15.0454 13.8988C15.0454 14.4786 15.4728 14.9487 16 14.9487Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M22.3636 14.9487C22.8908 14.9487 23.3181 14.4786 23.3181 13.8988C23.3181 13.3189 22.8908 12.8489 22.3636 12.8489C21.8364 12.8489 21.4091 13.3189 21.4091 13.8988C21.4091 14.4786 21.8364 14.9487 22.3636 14.9487Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M9.71272 14.9487C10.2399 14.9487 10.6673 14.4786 10.6673 13.8988C10.6673 13.3189 10.2399 12.8489 9.71272 12.8489C9.18554 12.8489 8.75818 13.3189 8.75818 13.8988C8.75818 14.4786 9.18554 14.9487 9.71272 14.9487Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$notification = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M27.4525 23.6028C27.1921 23.3615 25.0769 21.1955 25.0769 14.3608C25.0272 12.0243 24.1647 9.77815 22.6378 8.0089C21.8183 7.02925 20.8037 6.23102 19.6587 5.66505C19.6639 5.608 19.6639 5.5506 19.6587 5.49355C19.6587 3.56411 18.0946 2 16.1652 2C14.2358 2 12.6716 3.56411 12.6716 5.49355C12.6665 5.5506 12.6665 5.608 12.6716 5.66505C11.5267 6.23102 10.5121 7.02925 9.69261 8.0089C8.16566 9.77815 7.30314 12.0243 7.25347 14.3608C7.25347 21.1828 5.14464 23.3424 4.88421 23.5838C4.16959 24.0113 3.83712 24.8699 4.07752 25.6672C4.33116 26.5024 5.11046 27.0661 5.98309 27.0456H12.1953C11.8452 27.4115 11.8452 27.9881 12.1953 28.3541C13.22 29.4064 14.6265 30 16.0953 30C17.5642 30 18.9707 29.4064 19.9954 28.3541C20.3218 27.9935 20.3218 27.4442 19.9954 27.0837H26.2901C27.1628 27.1042 27.9421 26.5405 28.1957 25.7053C28.4555 24.917 28.15 24.0528 27.4525 23.6028ZM16.0576 3.88017C16.7226 3.93687 17.2982 4.36491 17.544 4.9854C16.5636 4.78128 15.5517 4.78128 14.5713 4.9854C14.817 4.36491 15.3927 3.93687 16.0576 3.88017ZM16.1315 6.73852C20.1586 6.73852 23.1186 10.8037 23.1186 14.3608C23.0829 16.5017 23.3328 18.6379 23.8618 20.7127H8.40127C8.93022 18.6379 9.18015 16.5017 9.14444 14.3608C9.14444 10.8037 12.1044 6.73852 16.1315 6.73852ZM16.0262 28.1063C15.0721 28.1166 14.1548 27.7382 13.4854 27.0583H18.5034C17.8498 27.7231 16.9584 28.1002 16.0262 28.1063ZM5.99728 25.159C6.7918 24.4755 7.39945 23.6012 7.76311 22.6183H24.5639C24.9276 23.6012 25.5352 24.4755 26.3297 25.159H5.99728Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$settings = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$height('28'),
				$elm$svg$Svg$Attributes$viewBox('0 0 28 28'),
				$elm$svg$Svg$Attributes$width('28'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M14 8.90906C11.1884 8.90906 8.90909 11.1883 8.90909 14C8.90909 16.8116 11.1884 19.0909 14 19.0909C16.8116 19.0909 19.0909 16.8116 19.0909 14C19.0909 11.1883 16.8116 8.90906 14 8.90906ZM14 17.1818C12.2427 17.1818 10.8182 15.7572 10.8182 14C10.8182 12.2427 12.2427 10.8181 14 10.8181C15.7573 10.8181 17.1818 12.2427 17.1818 14C17.1818 15.7572 15.7573 17.1818 14 17.1818Z'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M26.0909 10.1818H25.4545C25.2812 9.63475 25.0685 9.10093 24.8182 8.58455L25.2573 8.14545C26.0017 7.4001 26.0017 6.19263 25.2573 5.44727L22.5591 2.74909C21.8137 2.00466 20.6063 2.00466 19.8609 2.74909L19.4091 3.18182C18.8927 2.93148 18.3589 2.71881 17.8118 2.54545V1.90909C17.8118 0.854729 16.9571 0 15.9027 0H12.0845C11.0302 0 10.1755 0.854729 10.1755 1.90909V2.54545C9.62839 2.71881 9.09457 2.93148 8.57818 3.18182L8.13909 2.74273C7.39373 1.9983 6.18626 1.9983 5.44091 2.74273L2.74273 5.44091C1.9983 6.18626 1.9983 7.39374 2.74273 8.13909L3.18182 8.57818C2.93146 9.09456 2.71878 9.62838 2.54545 10.1755H1.90909C0.854729 10.1755 0 11.0302 0 12.0845V15.9027C0 16.9571 0.854729 17.8118 1.90909 17.8118H2.54545C2.71878 18.3589 2.93146 18.8927 3.18182 19.4091L2.74273 19.8482C1.9983 20.5935 1.9983 21.801 2.74273 22.5464L5.44091 25.2445C6.18626 25.989 7.39373 25.989 8.13909 25.2445L8.59091 24.8182C9.1073 25.0685 9.64111 25.2812 10.1882 25.4545V26.0909C10.1882 27.1453 11.0429 28 12.0973 28H15.9154C16.9698 28 17.8245 27.1453 17.8245 26.0909V25.4545C18.3716 25.2812 18.9054 25.0685 19.4218 24.8182L19.8609 25.2573C20.6063 26.0017 21.8137 26.0017 22.5591 25.2573L25.2573 22.5591C26.0017 21.8137 26.0017 20.6063 25.2573 19.8609L24.8182 19.4218C25.0685 18.9054 25.2812 18.3716 25.4545 17.8245H26.0909C27.1453 17.8245 28 16.9698 28 15.9155V12.0973C28.0017 11.5898 27.8013 11.1026 27.4431 10.7432C27.0849 10.3838 26.5983 10.1818 26.0909 10.1818ZM26.0909 15.9091H23.9973C23.7392 17.2768 23.202 18.5765 22.4191 19.7273L23.8954 21.2036L21.1973 23.9018L19.7209 22.4255C18.5703 23.2085 17.2704 23.7458 15.9027 24.0036V26.0909H12.0845V23.9973C10.7168 23.7394 9.417 23.2022 8.26636 22.4191L6.79 23.8955L4.09181 21.1973L5.56818 19.7209C4.78527 18.5702 4.24803 17.2704 3.99 15.9027H1.90909V12.0845H4.00272C4.26075 10.7169 4.798 9.41709 5.58091 8.26636L4.10454 6.79L6.80272 4.09182L8.27909 5.56818C9.42981 4.78527 10.7296 4.24803 12.0973 3.99V1.90909H15.9154V4.00273C17.2831 4.26076 18.5829 4.798 19.7336 5.58091L21.21 4.10455L23.9082 6.80273L22.4191 8.27273C23.202 9.42345 23.7392 10.7232 23.9973 12.0909H26.0909V15.9091Z'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_Nil)
			]));
};
var $author$project$Session$LoggedIn$viewCommunitySelector = function (model) {
	var hasMultipleCommunities = function () {
		var _v1 = model.pl;
		if (_v1.$ === 3) {
			var p = _v1.a;
			return ($elm$core$List$length(p.eK) > 1) || (!$author$project$Session$LoggedIn$isCommunityMember(model));
		} else {
			return false;
		}
	}();
	var _v0 = model.pC;
	if (_v0.$ === 3) {
		var community = _v0.a;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center rounded-sm focus-ring focus:ring-offset-4'),
					$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$OpenCommunitySelector)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-8 w-8 object-scale-down'),
							$elm$html$Html$Attributes$src(community.fe)
						]),
					_List_Nil),
					hasMultipleCommunities ? $author$project$Icons$arrowDown('fill-current text-gray-900') : $elm$html$Html$text('')
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Search$ClearSearchIconClicked = {$: 11};
var $author$project$Search$FormOutput = function (query) {
	return {ed: query};
};
var $author$project$Search$InputFocused = {$: 3};
var $author$project$Icons$clearInput = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$width('20'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m10 18.3334c4.6024 0 8.3333-3.7309 8.3333-8.3333 0-4.60239-3.7309-8.33335-8.3333-8.33335-4.60237 0-8.33333 3.73096-8.33333 8.33335 0 4.6024 3.73096 8.3333 8.33333 8.3333z'),
								$elm$svg$Svg$Attributes$strokeWidth('2')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$stroke('#fff')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('m12.5 7.5-5 5')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('m7.5 7.5 5 5')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $elm$html$Html$Attributes$minlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'minLength',
		$elm$core$String$fromInt(n));
};
var $author$project$Icons$search = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('28'),
				$elm$svg$Svg$Attributes$height('28'),
				$elm$svg$Svg$Attributes$viewBox('0 0 28 28'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M25.9969 24.7134L20.1885 19.2244C24.2584 15.3336 24.3824 9.08776 20.4699 5.05379C16.5574 1.01982 9.99564 0.628044 5.58244 4.16492C1.16924 7.70179 0.469389 13.9132 3.9946 18.2576C7.51981 22.6019 14.0201 23.5388 18.7427 20.3832L24.6643 26.0095C25.0358 26.3385 25.6147 26.3288 25.9738 25.9876C26.3329 25.6464 26.3431 25.0963 25.9969 24.7433V24.7134ZM3.80046 12.0571C3.80046 7.43892 7.74064 3.69516 12.6011 3.69516C17.4616 3.69516 21.4018 7.43892 21.4018 12.0571C21.4018 16.6752 17.4616 20.419 12.6011 20.419C7.74064 20.419 3.80046 16.6752 3.80046 12.0571Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Search$createForm = F2(
	function (_v0, model) {
		var t = _v0.fL;
		var isSearchOpen = function () {
			var _v4 = model.Z;
			if (!_v4.$) {
				return false;
			} else {
				return true;
			}
		}();
		var viewClearSearchIcon = (isSearchOpen && (!$elm$core$String$isEmpty(
			A2(
				$author$project$Form$getValue,
				function ($) {
					return $.ed;
				},
				model.hY)))) ? A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute right-3 flex items-center top-1/2 -translate-y-1/2 focus-ring focus-visible:ring-red focus-visible:ring-opacity-50 rounded-full group'),
					$elm$html$Html$Events$onClick($author$project$Search$ClearSearchIconClicked),
					$elm$html$Html$Attributes$type_('button')
				]),
			_List_fromArray(
				[
					$author$project$Icons$clearInput('fill-current text-gray-400 hover:text-red group-focus:text-red')
				])) : $elm$html$Html$text('');
		var isLoading = function () {
			var _v2 = model.Z;
			if ((_v2.$ === 2) && (_v2.a.$ === 1)) {
				var _v3 = _v2.a;
				return true;
			} else {
				return false;
			}
		}();
		var iconColor = function () {
			var _v1 = model.Z;
			if (!_v1.$) {
				return 'text-gray-400';
			} else {
				return 'text-indigo-500';
			}
		}();
		return A2(
			$author$project$Form$withNoOutput,
			$author$project$Form$unsafeArbitrary(
				A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-orange-300 ml-3 lowercase hover:underline focus:outline-none focus:underline'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', !isSearchOpen)
								])),
							$elm$html$Html$Events$onClick($author$project$Search$CancelClicked),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('menu.cancel'))
						]))),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$textField,
					{
						ne: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						o3: $elm$core$Result$Ok,
						qd: F2(
							function (query, input) {
								return _Utils_update(
									input,
									{ed: query});
							}),
						lW: function ($) {
							return $.ed;
						}
					},
					A2(
						$author$project$Form$Text$withElements,
						_List_fromArray(
							[
								viewClearSearchIcon,
								$author$project$Icons$search('absolute top-0 mt-[10px] left-4 fill-current ' + iconColor)
							]),
						A2(
							$author$project$Form$Text$withExtraAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('rounded-full bg-gray-100 border-0 pl-12 h-12'),
									$elm$html$Html$Events$onFocus($author$project$Search$InputFocused),
									$elm$html$Html$Attributes$minlength(3),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							A2(
								$author$project$Form$Text$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('!m-0 w-full')
									]),
								A2(
									$author$project$Form$Text$withDisabled,
									isLoading,
									A2(
										$author$project$Form$Text$withPlaceholder,
										t('menu.search.placeholder'),
										$author$project$Form$Text$init(
											{w: 'search-input', n$: ''}))))))),
				$author$project$Form$succeed($author$project$Search$FormOutput)));
	});
var $author$project$Search$viewForm = F3(
	function (attrs, translators, model) {
		return A6(
			$author$project$Form$viewWithoutSubmit,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('flex items-center'),
				attrs),
			translators,
			function (_v0) {
				return _List_Nil;
			},
			A2($author$project$Search$createForm, translators, model),
			model.hY,
			{lF: $author$project$Search$GotFormMsg});
	});
var $author$project$Session$LoggedIn$viewHeader = F3(
	function (page, model, profile_) {
		var shared = model.A;
		var tr = F2(
			function (str, values) {
				return A2(shared.aw.i4, str, values);
			});
		var text_ = function (str) {
			return $elm$html$Html$text(
				shared.aw.fL(str));
		};
		var isSearchOpen = function () {
			var _v1 = model.al.Z;
			if (!_v1.$) {
				return false;
			} else {
				return true;
			}
		}();
		var isCommunityCreator = function () {
			var _v0 = model.pC;
			if (_v0.$ === 3) {
				var community = _v0.a;
				return _Utils_eq(community.jz, model._);
			} else {
				return false;
			}
		}();
		var hideCommunitySelectorPages = _List_fromArray(
			[$author$project$Session$LoggedIn$CommunitySelector]);
		var hideCommunitySelector = A2($elm$core$List$member, page, hideCommunitySelectorPages);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-wrap items-center justify-between p-4 md:flex-nowrap')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-shrink-0'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('md:flex-shrink md:w-full lg:w-2/3 xl:w-full', !isSearchOpen),
									_Utils_Tuple2('lg:w-full', (!isCommunityCreator) && (!isSearchOpen))
								]))
						]),
					hideCommunitySelector ? _List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hidden sm:block h-5'),
									$elm$html$Html$Attributes$src(shared.fe)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sm:hidden h-5'),
									$elm$html$Html$Attributes$src(shared.ky)
								]),
							_List_Nil)
						]) : _List_fromArray(
						[
							$author$project$Session$LoggedIn$viewCommunitySelector(model)
						])),
					A2($author$project$Session$LoggedIn$hideCommunityAndSearch, page, model) ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : A2(
					$elm$html$Html$map,
					$author$project$Session$LoggedIn$GotSearchMsg,
					A3(
						$author$project$Search$viewForm,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('order-last w-full md:order-none mt-4 md:mt-0 md:mx-4'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('md:w-96 md:flex-shrink-0', !isSearchOpen),
										_Utils_Tuple2('w-full', isSearchOpen)
									]))
							]),
						shared.aw,
						model.al)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-end space-x-8 my-auto flex-shrink-0'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('md:flex-shrink md:w-full', !isSearchOpen)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative rounded-sm group focus-ring focus-visible:ring-orange-300 focus-visible:ring-opacity-50'),
									$author$project$Route$href($author$project$Route$Notification),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('mr-4', model.er > 0)
										])),
									$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClosedSearch)
								]),
							_List_fromArray(
								[
									$author$project$Icons$notification('fill-current text-gray-900 h-6 md:h-7 group-hover:text-orange-300'),
									(model.er > 0) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute top-0 right-0 -mr-2 px-1 py-0.5 bg-orange-500 text-white font-semibold text-xs rounded-full md:-mr-4 md:px-2 md:py-1 md:text-sm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(model.er))
										])) : $elm$html$Html$text('')
								])),
							isCommunityCreator ? A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('rounded-sm group focus-ring focus:ring-orange-300 focus:ring-opacity-50 focus:ring-offset-4'),
									$author$project$Route$href($author$project$Route$CommunitySettings),
									$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClosedSearch)
								]),
							_List_fromArray(
								[
									$author$project$Icons$settings('fill-current h-6 text-gray-900 md:h-7 group-hover:text-orange-300')
								])) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative z-50 lg:min-w-50')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('z-10 pt-3 -mt-3 px-3 relative rounded-t hidden lg:w-full lg:visible lg:flex lg:items-center lg:bg-white lg:focus-ring lg:focus-visible:ring-orange-300 lg:focus-visible:ring-opacity-50'),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Events$onClick(
											$author$project$Session$LoggedIn$ShowUserNav(!model.aL)),
											$elm$html$Html$Events$onMouseEnter(
											$author$project$Session$LoggedIn$ShowUserNav(true))
										]),
									_List_fromArray(
										[
											A2($author$project$Avatar$view, profile_.dl, 'h-8 w-8'),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col items-center text-left pl-2')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-full text-gray-333 overflow-x-hidden')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																tr,
																'menu.welcome_message',
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'user_name',
																		$author$project$Eos$Account$nameToString(profile_.l8))
																	])))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-full text-orange-300')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															shared.aw.fL('menu.my_account'))
														]))
												]))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('z-10 flex relative rounded focus-ring focus-visible:ring-orange-300 focus-visible:ring-opacity-50 focus-visible:ring-offset-4 lg:hidden'),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Events$onClick(
											$author$project$Session$LoggedIn$ShowUserNav(!model.aL)),
											$elm$html$Html$Events$onMouseEnter(
											$author$project$Session$LoggedIn$ShowUserNav(true))
										]),
									_List_fromArray(
										[
											A2($author$project$Avatar$view, profile_.dl, 'h-6 w-6 md:h-7 md:w-7')
										])),
									model.aL ? A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fixed h-full w-full inset-0 bg-black opacity-50 cursor-default'),
											$elm$html$Html$Events$onClick(
											$author$project$Session$LoggedIn$ShowUserNav(false)),
											$elm$html$Html$Events$onMouseEnter(
											$author$project$Session$LoggedIn$ShowUserNav(false))
										]),
									_List_Nil) : $elm$html$Html$text(''),
									function () {
									if (model.aL) {
										var menuItemClass = 'flex w-full py-4 lg:py-2 pl-2.5 pr-8 lg:pr-2 justify-start items-center text-base lg:text-sm focus-ring rounded first:rounded-t lg:first:rounded-t last:rounded-b hover:bg-gray-200 focus-visible:bg-gray-200 transition-colors';
										var menuIcon = function (icon) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-6 md:w-7 lg:w-8 flex items-center justify-center mr-2')
													]),
												_List_fromArray(
													[
														icon('h-5 lg:h-4 fill-current')
													]));
										};
										return A3(
											$author$project$View$Components$focusTrap,
											{nF: $elm$core$Maybe$Nothing},
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$nav,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('absolute right-0 lg:w-full py-1 px-1 shadow-lg bg-white rounded lg:rounded-t-none z-50')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(menuItemClass),
																	$author$project$Route$href(
																	$author$project$Route$Profile(model._)),
																	$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClickedNavLink)
																]),
															_List_fromArray(
																[
																	menuIcon($author$project$Icons$profile),
																	text_('menu.profile')
																])),
															A2(
															$elm$html$Html$a,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(menuItemClass),
																	$author$project$Route$href($author$project$Route$Settings),
																	$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClickedNavLink)
																]),
															_List_fromArray(
																[
																	menuIcon($author$project$Icons$settings),
																	text_('settings.account.title')
																])),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(menuItemClass),
																	$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ToggleLanguageItems)
																]),
															_List_fromArray(
																[
																	menuIcon($author$project$Icons$languages),
																	text_('menu.languages')
																])),
															model.fF ? A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 mb-2')
																]),
															A2(
																$elm$core$List$cons,
																A2(
																	$elm$html$Html$button,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class(menuItemClass),
																			$elm$html$Html$Attributes$class('uppercase !rounded !text-sm lg:!text-xs')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Session$Shared$langFlag,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('w-4 h-4 mr-2')
																				]),
																			shared.ic),
																			$elm$html$Html$text(
																			$author$project$Translation$languageToLanguageCode(shared.ic))
																		])),
																A3(
																	$author$project$Session$Shared$viewLanguageItems,
																	{
																		mF: _List_fromArray(
																			[
																				$elm$html$Html$Attributes$class(menuItemClass),
																				$elm$html$Html$Attributes$class('uppercase !rounded !text-sm lg:!text-xs')
																			]),
																		nk: _List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('w-4 h-4 mr-2')
																			])
																	},
																	shared,
																	$author$project$Session$LoggedIn$ClickedLanguage))) : $elm$html$Html$text(''),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(menuItemClass),
																	$elm$html$Html$Attributes$class('text-red hover:bg-red/10 focus:bg-red/10'),
																	$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClickedLogout)
																]),
															_List_fromArray(
																[
																	menuIcon($author$project$Icons$close),
																	text_('menu.logout')
																]))
														]))
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}()
								]))
						]))
				]));
	});
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaLive = $elm$html$Html$Attributes$attribute('aria-live');
var $author$project$Session$LoggedIn$viewHighlightedNews = F3(
	function (_v0, toPageMsg, news) {
		var t = _v0.fL;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-purple-500 py-4 sticky top-0 z-10')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4 text-white flex items-center')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Icons$speechBubble,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$alt('')
								]),
							'stroke-current flex-shrink-0'),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('truncate ml-4 mr-8')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold truncate'),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLive('polite')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('sr-only')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('news.got_community_news'))
												])),
											$elm$html$Html$text(news.fN)
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('truncate')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Markdown$toUnformattedString(news.aR))
										]))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary w-auto px-4 ml-auto mr-6'),
									$author$project$Route$href(
									$author$project$Route$News(
										{
											pD: $elm$core$Maybe$Just(news.w),
											pJ: true
										})),
									$elm$html$Html$Events$onClick(
									toPageMsg($author$project$Session$LoggedIn$ClickedReadHighlightedNews))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('news.read'))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hover:text-red focus:text-red focus:outline-none'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
									t('menu.close')),
									$elm$html$Html$Events$onClick(
									toPageMsg($author$project$Session$LoggedIn$ClosedHighlightedNews))
								]),
							_List_fromArray(
								[
									$author$project$Icons$close('fill-current')
								]))
						]))
				]));
	});
var $author$project$Session$LoggedIn$isActive = F2(
	function (page, route) {
		var _v0 = _Utils_Tuple2(page, route);
		_v0$2:
		while (true) {
			switch (_v0.a.$) {
				case 4:
					if (_v0.b.$ === 13) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return true;
					} else {
						break _v0$2;
					}
				case 30:
					if (_v0.b.$ === 40) {
						var _v3 = _v0.a;
						return true;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return false;
	});
var $author$project$Session$LoggedIn$viewMainMenu = F2(
	function (page, model) {
		var menuItem = F2(
			function (title, route) {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-center uppercase py-2 hover:text-orange-300 focus-ring focus-visible:ring-orange-300 focus-visible:ring-opacity-50 rounded-sm'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'text-orange-300 font-bold',
									A2($author$project$Session$LoggedIn$isActive, page, route)),
									_Utils_Tuple2(
									'text-gray-900',
									!A2($author$project$Session$LoggedIn$isActive, page, route))
								])),
							$author$project$Route$href(route)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							model.A.aw.fL(title))
						]));
			});
		var isInShop = A2(
			$author$project$Session$LoggedIn$isActive,
			page,
			$author$project$Route$Shop(
				{dn: _List_Nil, o1: $elm$core$Maybe$Nothing}));
		var isInDashboard = A2($author$project$Session$LoggedIn$isActive, page, $author$project$Route$Dashboard);
		var hasShop = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			false,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.bB;
				},
				model.pC));
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid relative md:mx-4'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('grid-cols-2 md:w-96', hasShop),
							_Utils_Tuple2('md:w-48', !hasShop)
						]))
				]),
			_List_fromArray(
				[
					A2(menuItem, 'menu.dashboard', $author$project$Route$Dashboard),
					hasShop ? A2(
					menuItem,
					'menu.shop',
					$author$project$Route$Shop(
						{dn: _List_Nil, o1: $elm$core$Maybe$Nothing})) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute bottom-0 h-3px'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('w-1/2 transform transition-transform motion-reduce:transition-none', hasShop),
									_Utils_Tuple2('w-full', !hasShop),
									_Utils_Tuple2('translate-x-0', isInDashboard),
									_Utils_Tuple2('translate-x-full', isInShop),
									_Utils_Tuple2('bg-orange-300', isInDashboard || isInShop)
								]))
						]),
					_List_Nil)
				]));
	});
var $author$project$Session$LoggedIn$ProfilePublic = {$: 34};
var $author$project$Session$LoggedIn$viewPageBody = F4(
	function (model, profile_, page, content) {
		var shared = model.A;
		var hasUserKycFilled = function () {
			var _v2 = profile_.ib;
			if (!_v2.$) {
				return true;
			} else {
				return false;
			}
		}();
		var availableWithoutKyc = _List_fromArray(
			[$author$project$Session$LoggedIn$Redirect, $author$project$Session$LoggedIn$NotFound, $author$project$Session$LoggedIn$ComingSoon, $author$project$Session$LoggedIn$Invite, $author$project$Session$LoggedIn$CommunitySelector, $author$project$Session$LoggedIn$Profile, $author$project$Session$LoggedIn$Notification, $author$project$Session$LoggedIn$ProfilePublic, $author$project$Session$LoggedIn$ProfileEditor, $author$project$Session$LoggedIn$ProfileAddKyc, $author$project$Session$LoggedIn$PaymentHistory, $author$project$Session$LoggedIn$ViewTransfer, $author$project$Session$LoggedIn$Join]);
		var _v0 = shared.aw;
		var t = _v0.fL;
		var viewKycRestriction = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto container max-w-sm')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('my-6 mx-4 text-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-2xl font-bold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.kyc.restriction.title'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-2 mb-6')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.kyc.restriction.description'))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary m-auto w-full'),
									$author$project$Route$href($author$project$Route$ProfileAddKyc)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.kyc.restriction.link'))
								]))
						])),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full mx-auto md:w-64 mt-6 mb-8'),
							$elm$html$Html$Attributes$src('/images/not_found.svg')
						]),
					_List_Nil)
				]));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-grow flex flex-col')
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = model.pC;
						switch (_v1.$) {
							case 1:
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('full-spinner-container h-full')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('spinner spinner--delay mt-8')
												]),
											_List_Nil)
										]));
							case 0:
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('full-spinner-container h-full')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('spinner spinner--delay mt-8')
												]),
											_List_Nil)
										]));
							case 3:
								var hasKyc = _v1.a.by;
								var isContentAllowed = A2($elm$core$List$member, page, availableWithoutKyc) || ((!hasKyc) || (hasKyc && hasUserKycFilled));
								return isContentAllowed ? content : viewKycRestriction;
							default:
								var isContentAllowed = A2($elm$core$List$member, page, availableWithoutKyc);
								return isContentAllowed ? content : $elm$html$Html$text('');
						}
					}()
					]))
			]);
	});
var $author$project$Search$ActionsTab = 1;
var $author$project$Search$MembersTab = 2;
var $author$project$Search$OffersTab = 0;
var $author$project$Search$viewEmptyResults = F2(
	function (_v0, queryText) {
		var t = _v0.fL;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex-grow bg-white text-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-20 text-xl font-bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('menu.search.notFoundLabel') + (' \"' + (queryText + '\"')))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-2/3 mx-auto md:w-64 mt-6 mb-8'),
									$elm$html$Html$Attributes$src('/images/not_found.svg')
								]),
							_List_Nil),
							$elm$html$Html$text(
							t('menu.search.notFoundResults'))
						]))
				]));
	});
var $author$project$Search$FoundItemClicked = {$: 12};
var $author$project$Search$viewMembers = F2(
	function (_v0, members) {
		var t = _v0.fL;
		var viewMember = function (member) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-white rounded flex flex-col p-4 space-y-4 justify-between')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('grid grid-cols-3 px-4')
							]),
						_List_fromArray(
							[
								A2($author$project$Avatar$view, member.dl, 'h-20 w-20 my-auto'),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col col-span-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-lg font-bold capitalize')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($elm$core$Maybe$withDefault, '', member.fj))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-sm text-gray-900')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($elm$core$Maybe$withDefault, '', member.jK))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-sm text-gray-900')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Eos$Account$nameToString(member.l8))
											]))
									]))
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full button button-secondary cursor-pointer'),
								$elm$html$Html$Events$onClick($author$project$Search$FoundItemClicked),
								$author$project$Route$href(
								$author$project$Route$Profile(member.l8))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('all_analysis.more_details'))
							]))
					]));
		};
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6 mb-8 mx-2')
				]),
			A2($elm$core$List$map, viewMember, members));
	});
var $author$project$Search$ClickedScrollToImage = function (a) {
	return {$: 13, a: a};
};
var $author$project$Search$ImageStartedIntersecting = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Search$ImageStoppedIntersecting = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Search$viewOffers = F3(
	function (translators, symbol, offers) {
		var viewOffer = function (productInfo) {
			var images = function () {
				var _v0 = productInfo.pi.h5;
				if (!_v0.b) {
					return A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src('/icons/shop-placeholder1.svg'),
								$elm$html$Html$Attributes$alt(''),
								$elm$html$Html$Attributes$class('h-32')
							]),
						_List_Nil);
				} else {
					var firstImage = _v0.a;
					var otherImages = _v0.b;
					return A4(
						$author$project$Shop$viewImageCarrousel,
						translators,
						{
							mF: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-32')
								]),
							ny: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full h-full')
								]),
							nz: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white rounded-t')
								]),
							nB: _List_Nil,
							n7: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('gap-x-4 rounded-t bg-gray-100')
								])
						},
						{
							mT: productInfo.cE,
							oQ: $author$project$Search$ClickedScrollToImage,
							oS: $author$project$Search$ImageStartedIntersecting(productInfo.pi.w),
							oT: $author$project$Search$ImageStoppedIntersecting(productInfo.pi.w),
							pk: $elm$core$Maybe$Just(productInfo.pi.w),
							pF: false
						},
						_Utils_Tuple2(firstImage, otherImages));
				}
			}();
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex px-2 w-1/2 sm:w-1/3 md:w-1/4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rounded-md overflow-hidden bg-white flex-grow mb-4 pb-4 cursor-pointer hover:shadow focus:shadow focus:outline-none focus:ring focus:ring-gray-400'),
								$elm$html$Html$Events$onClick($author$project$Search$FoundItemClicked),
								$author$project$Route$href(
								$author$project$Route$ViewSale(productInfo.pi.w))
							]),
						_List_fromArray(
							[
								images,
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('p-3')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(productInfo.pi.fN)
									])),
								$author$project$Shop$isOutOfStock(productInfo.pi) ? A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('px-3 text-xl text-red')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										translators.fL('shop.out_of_stock'))
									])) : A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('px-3')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xl text-green font-semibold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromFloat(productInfo.pi.iJ))
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-900 text-sm')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Eos$symbolToSymbolCodeString(symbol))
											]))
									]))
							]))
					]));
		};
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-wrap mt-6 mb-8 mx-2 justify-left')
				]),
			A2($elm$core$List$map, viewOffer, offers));
	});
var $author$project$Search$RecentQueryClicked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Icons$clock = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$width('20'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m19.4141 9.41404c-.3236 0-.5859.26235-.5859.58594 0 4.86782-3.9603 8.82812-8.8281 8.82812-4.86779 0-8.82804-3.9603-8.82804-8.82812 0-4.86783 3.96025-8.82808 8.82804-8.82808 1.4844 0 2.9282.36856 4.2172 1.07082l-.7326.73253c-.1676.16758-.2177.41957-.127.63855.0907.21895.3043.36172.5413.36172h2.8036c.3236 0 .586-.26234.586-.58593v-2.803619c0-.236991-.1428-.450623-.3617-.5413252-.2191-.0907417-.4711-.04058572-.6386.1270302l-1.2116 1.211594c-1.5347-.906127-3.2796-1.38319428-5.0766-1.38319428-2.67108 0-5.18232 1.04018428-7.07106 2.92888428-1.88874 1.88878-2.92888741 4.39998-2.92888741 7.07104 0 2.6711 1.04014741 5.1823 2.92888741 7.071 1.88878 1.8888 4.39998 2.929 7.07106 2.929 2.6711 0 5.1823-1.0402 7.071-2.929 1.8888-1.8887 2.9289-4.3999 2.9289-7.071.0001-.32361-.2623-.58596-.5859-.58596z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m13.7656 9.41403h-3.1796v-3.17966c0-.32359-.2623-.58593-.5859-.58593-.32363 0-.58598.26234-.58598.58593v3.76559c0 .32364.26235.58594.58598.58594h3.7655c.3236 0 .586-.2623.586-.58594 0-.32359-.2624-.58593-.586-.58593z')
					]),
				_List_Nil)
			]));
};
var $author$project$Search$viewRecentQueries = F2(
	function (_v0, recentQueries) {
		var t = _v0.fL;
		var viewItem = function (q) {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex items-center w-full hover:text-orange-500 focus:text-orange-500 focus:outline-none'),
								$elm$html$Html$Events$onClick(
								$author$project$Search$RecentQueryClicked(q))
							]),
						_List_fromArray(
							[
								$author$project$Icons$clock('mr-3 fill-current'),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(q)
									]))
							]))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full p-4 bg-white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('menu.search.recentlyHeader'))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-900 mt-4 space-y-2')
						]),
					A2($elm$core$List$map, viewItem, recentQueries))
				]));
	});
var $author$project$Search$TabActivated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Icons$accountCircle = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM1.63635 12C1.63601 7.46102 4.58934 3.44999 8.92373 2.10268C13.2581 0.755376 17.9649 2.38534 20.5378 6.12465C23.1107 9.86395 22.9509 14.8424 20.1436 18.4091C18.8933 16.5468 17.0792 15.1341 14.9673 14.3782C15.8799 13.4012 16.3802 12.1096 16.3636 10.7727C16.3636 8.04544 14.4054 5.86362 12 5.86362C9.59453 5.86362 7.63635 8.04544 7.63635 10.7727C7.62279 12.1573 8.16508 13.4894 9.1418 14.4709C7.01491 15.2344 5.22096 16.7158 4.06907 18.66C2.49663 16.7972 1.63477 14.4377 1.63635 12ZM12.2727 13.9091C11.9739 13.9103 11.6753 13.9267 11.3781 13.9582C10.0507 13.4768 9.19531 12.1826 9.27269 10.7727C9.27269 8.96727 10.4945 7.5 12 7.5C13.5054 7.5 14.7272 8.96727 14.7272 10.7727C14.7944 12.143 13.9899 13.4066 12.72 13.9255C12.5727 13.92 12.4254 13.9091 12.2727 13.9091ZM5.28 19.9091C6.46553 17.5946 8.70447 16.0029 11.28 15.6436C11.811 15.7473 12.3582 15.7343 12.8836 15.6054C15.429 15.9491 17.6764 17.4407 18.9818 19.6527C15.1352 23.2032 9.24024 23.3134 5.26363 19.9091H5.28Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil)
			]));
};
var $author$project$Search$viewResultsOverview = F2(
	function (_v0, _v1) {
		var t = _v0.fL;
		var tr = _v0.i4;
		var offers = _v1.bm;
		var actions = _v1.mb;
		var members = _v1.ih;
		var viewItem = F5(
			function (icon, count, singular, plural, showMsg) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-4 flex items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-grow flex items-center')
								]),
							_List_fromArray(
								[
									icon('w-6 h-6 text-black fill-current mr-3'),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('menu.search.overviewFound')),
											$elm$html$Html$text(' '),
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													(count === 1) ? $elm$html$Html$text(
													t(singular)) : $elm$html$Html$text(
													A2(
														tr,
														plural,
														_List_fromArray(
															[
																_Utils_Tuple2(
																'count',
																$elm$core$String$fromInt(count))
															])))
												]))
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button w-auto button-sm px-6'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('button-disabled', !count),
											_Utils_Tuple2('button-primary', !(!count))
										])),
									$elm$html$Html$Attributes$disabled(!count),
									$elm$html$Html$Events$onClick(showMsg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('menu.search.overviewShow'))
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block pb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('menu.search.overviewHeader'))
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					_List_fromArray(
						[
							A5(
							viewItem,
							$author$project$Icons$shop,
							$elm$core$List$length(offers),
							'menu.search.offer',
							'menu.search.offers',
							$author$project$Search$TabActivated(0)),
							A5(
							viewItem,
							$author$project$Icons$flag,
							$elm$core$List$length(actions),
							'menu.search.action',
							'menu.search.actions',
							$author$project$Search$TabActivated(1)),
							A5(
							viewItem,
							$author$project$Icons$accountCircle,
							$elm$core$List$length(members),
							'menu.search.member',
							'menu.search.members',
							$author$project$Search$TabActivated(2))
						]))
				]));
	});
var $author$project$Search$viewTabs = F3(
	function (_v0, results, activeTab) {
		var tr = _v0.i4;
		var viewTab = F4(
			function (tabKind, label, foundItems, clickMsg) {
				var count = $elm$core$List$length(foundItems);
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('rounded-sm text-center capitalize w-full py-3 focus-ring focus-visible:ring-gray-300'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'bg-orange-300 text-white font-bold',
											_Utils_eq(activeTab, tabKind)),
											_Utils_Tuple2(
											'bg-gray-100 hover:bg-gray-200 focus:bg-gray-200',
											!_Utils_eq(activeTab, tabKind)),
											_Utils_Tuple2('cursor-not-allowed text-gray-300', count <= 0)
										])),
									(count > 0) ? $elm$html$Html$Events$onClick(clickMsg) : $elm$html$Html$Attributes$tabindex(-1),
									_Utils_eq(activeTab, tabKind) ? $elm$html$Html$Attributes$tabindex(-1) : $elm$html$Html$Attributes$class('')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										tr,
										label,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'count',
												$elm$core$String$fromInt(count))
											])))
								]))
						]));
			});
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-x-2 flex items-stretch p-4 pb-2 bg-white')
				]),
			_List_fromArray(
				[
					A4(
					viewTab,
					0,
					'menu.search.offers_title',
					results.bm,
					$author$project$Search$TabActivated(0)),
					A4(
					viewTab,
					1,
					'menu.search.actions_title',
					results.mb,
					$author$project$Search$TabActivated(1)),
					A4(
					viewTab,
					2,
					'menu.search.members_title',
					results.ih,
					$author$project$Search$TabActivated(2))
				]));
	});
var $author$project$Search$viewSearchBody = F6(
	function (loggedIn, selectedCommunity, today, searchToMsg, actionToMsg, searchModel) {
		var translators = loggedIn.A.aw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto flex flex-grow')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = searchModel.Z;
					_v0$2:
					while (true) {
						if (_v0.$ === 2) {
							switch (_v0.a.$) {
								case 3:
									var results = _v0.a.a;
									var activeTab = _v0.b;
									if ($elm$core$List$isEmpty(results.mb) && ($elm$core$List$isEmpty(results.bm) && $elm$core$List$isEmpty(results.ih))) {
										return A2(
											$elm$html$Html$map,
											searchToMsg,
											A2(
												$author$project$Search$viewEmptyResults,
												translators,
												A2(
													$author$project$Form$getValue,
													function ($) {
														return $.ed;
													},
													searchModel.hY)));
									} else {
										if (!activeTab.$) {
											switch (activeTab.a) {
												case 0:
													var _v2 = activeTab.a;
													return A2(
														$elm$html$Html$map,
														searchToMsg,
														A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('w-full')
																]),
															_List_fromArray(
																[
																	A3($author$project$Search$viewTabs, translators, results, 0),
																	A3($author$project$Search$viewOffers, translators, selectedCommunity, results.bm)
																])));
												case 1:
													var _v3 = activeTab.a;
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('w-full')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$map,
																searchToMsg,
																A3($author$project$Search$viewTabs, translators, results, 1)),
																A4(
																$author$project$View$Components$masonryLayout,
																_List_fromArray(
																	[0]),
																{p9: false},
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('grid mt-4 lg:mt-6 marker-hidden gap-4 lg:gap-x-6 sm:grid-cols-2 lg:grid-cols-3'),
																		$fapian$elm_html_aria$Html$Attributes$Aria$role('list')
																	]),
																A2(
																	$elm$core$List$map,
																	A2(
																		$author$project$Action$viewCard,
																		loggedIn,
																		{
																			mF: _List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('mb-4 lg:mb-6')
																				]),
																			bq: $elm$core$Maybe$Nothing,
																			lF: actionToMsg
																		}),
																	results.mb))
															]));
												default:
													var _v4 = activeTab.a;
													return A2(
														$elm$html$Html$map,
														searchToMsg,
														A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('w-full')
																]),
															_List_fromArray(
																[
																	A3($author$project$Search$viewTabs, translators, results, 2),
																	A2($author$project$Search$viewMembers, translators, results.ih)
																])));
											}
										} else {
											return A2(
												$elm$html$Html$map,
												searchToMsg,
												A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('bg-white w-full p-4')
														]),
													_List_fromArray(
														[
															A2($author$project$Search$viewResultsOverview, translators, results)
														])));
										}
									}
								case 1:
									var _v5 = _v0.a;
									return A2($author$project$View$Components$loadingLogoAnimated, translators, '');
								default:
									break _v0$2;
							}
						} else {
							break _v0$2;
						}
					}
					return A2(
						$elm$html$Html$map,
						searchToMsg,
						A2($author$project$Search$viewRecentQueries, translators, searchModel.cj));
				}()
				]));
	});
var $author$project$Session$LoggedIn$viewHelper = F5(
	function (pageMsg, page, profile_, model, content) {
		var shared = model.A;
		var mainView = function () {
			if ($author$project$Search$isActive(model.al)) {
				var _v2 = model.pC;
				if (_v2.$ === 3) {
					var community = _v2.a;
					return _List_fromArray(
						[
							A6(
							$author$project$Search$viewSearchBody,
							model,
							community.as,
							shared.ce,
							A2($elm$core$Basics$composeR, $author$project$Session$LoggedIn$GotSearchMsg, pageMsg),
							A2($elm$core$Basics$composeR, $author$project$Session$LoggedIn$GotActionMsg, pageMsg),
							model.al)
						]);
				} else {
					return _List_Nil;
				}
			} else {
				return A4($author$project$Session$LoggedIn$viewPageBody, model, profile_, page, content);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('min-h-screen flex flex-col')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									pageMsg,
									A3($author$project$Session$LoggedIn$viewHeader, page, model, profile_)),
									(A2($author$project$Session$LoggedIn$hideCommunityAndSearch, page, model) || $author$project$Search$isActive(model.al)) ? $elm$html$Html$text('') : A2(
									$elm$html$Html$map,
									pageMsg,
									A2($author$project$Session$LoggedIn$viewMainMenu, page, model))
								]))
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeR, $author$project$Session$LoggedIn$GotFeedbackMsg, pageMsg),
						$author$project$View$Feedback$view(model.hU)),
					A2(
						$elm$core$List$cons,
						function () {
							var _v0 = model.kB;
							if (!_v0.$) {
								var news = _v0.a;
								var isInNewsPage = function () {
									if (page.$ === 5) {
										var maybeNewsId = page.a;
										return _Utils_eq(
											maybeNewsId,
											$elm$core$Maybe$Just(news.w));
									} else {
										return false;
									}
								}();
								var showHighlightedNews = (!$elm_community$maybe_extra$Maybe$Extra$isJust(news.iK)) && ((!$author$project$Session$LoggedIn$isAdminPage(page)) && ((!isInNewsPage) && (!A2(
									$elm$core$List$member,
									page,
									_List_fromArray(
										[$author$project$Session$LoggedIn$Join, $author$project$Session$LoggedIn$Invite])))));
								return showHighlightedNews ? A3($author$project$Session$LoggedIn$viewHighlightedNews, shared.aw, pageMsg, news) : $elm$html$Html$text('');
							} else {
								return $elm$html$Html$text('');
							}
						}(),
						_Utils_ap(
							mainView,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									pageMsg,
									$author$project$Session$LoggedIn$viewFooter(model)),
									A2(
									$elm$html$Html$map,
									pageMsg,
									$author$project$Session$LoggedIn$viewCommunityContactsModal(model)),
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$Session$LoggedIn$GotActionMsg, pageMsg),
									A2($author$project$Action$viewClaimModal, model.A, model.eI)),
									A2($author$project$Session$LoggedIn$viewAuthModal, pageMsg, model),
									A2(
									$elm$html$Html$map,
									pageMsg,
									$author$project$Session$LoggedIn$communitySelectorModal(model)),
									A2(
									$elm$html$Html$map,
									pageMsg,
									$author$project$Session$LoggedIn$insufficientPermissionsModal(model)),
									A2(
									$elm$html$Html$map,
									pageMsg,
									$author$project$Session$LoggedIn$codeOfConductModal(model))
								]))))));
	});
var $author$project$Session$LoggedIn$view = F4(
	function (thisMsg, page, model, content) {
		var shared = model.A;
		var _v0 = _Utils_Tuple2(
			$author$project$Session$Shared$translationStatus(shared),
			model.pl);
		_v0$0:
		while (true) {
			_v0$1:
			while (true) {
				switch (_v0.b.$) {
					case 1:
						switch (_v0.a.$) {
							case 0:
								break _v0$0;
							case 1:
								break _v0$1;
							default:
								var _v2 = _v0.b;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$View$Components$loadingLogoAnimated, shared.aw, ''),
											A2($author$project$Session$LoggedIn$viewAuthModal, thisMsg, model)
										]));
						}
					case 0:
						switch (_v0.a.$) {
							case 0:
								break _v0$0;
							case 1:
								break _v0$1;
							default:
								var _v3 = _v0.b;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$View$Components$loadingLogoAnimated, shared.aw, ''),
											A2($author$project$Session$LoggedIn$viewAuthModal, thisMsg, model)
										]));
						}
					case 2:
						switch (_v0.a.$) {
							case 0:
								break _v0$0;
							case 1:
								break _v0$1;
							default:
								var err = _v0.b.a;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											thisMsg,
											A4(
												$author$project$Session$Shared$viewFullGraphqlError,
												shared,
												err,
												$author$project$Session$LoggedIn$ClickedTryAgainProfile(model._),
												'An error occurred while loading profile.')),
											A2($author$project$Session$LoggedIn$viewAuthModal, thisMsg, model)
										]));
						}
					default:
						switch (_v0.a.$) {
							case 0:
								break _v0$0;
							case 1:
								break _v0$1;
							default:
								var profile_ = _v0.b.a;
								return A5($author$project$Session$LoggedIn$viewHelper, thisMsg, page, profile_, model, content);
						}
				}
			}
			var err = _v0.a.a;
			return A2(
				$elm$html$Html$map,
				thisMsg,
				A4($author$project$Session$Shared$viewFullError, shared, err, $author$project$Session$LoggedIn$ClickedTryAgainTranslation, 'An error occurred while loading translation.'));
		}
		var _v1 = _v0.a;
		return $author$project$Session$Shared$viewFullLoading;
	});
var $author$project$Page$viewLoggedIn = F4(
	function (thisMsg, page, model, content) {
		return A4(
			$author$project$Session$LoggedIn$view,
			A2($elm$core$Basics$composeL, thisMsg, $author$project$Page$GotLoggedInMsg),
			page,
			model,
			content);
	});
var $author$project$Main$view = function (model) {
	var baseTitle = 'Cambiatus';
	var fullPageTitle = function (subTitle) {
		return (subTitle === '') ? baseTitle : (subTitle + (' | ' + baseTitle));
	};
	var viewGuest = F4(
		function (subModel, page, toMsg, subView) {
			var _v11 = model.c;
			if (!_v11.$) {
				var guest = _v11.a;
				var _v12 = A2(subView, guest, subModel);
				var title = _v12.fN;
				var content = _v12.mJ;
				return A2(
					$elm$browser$Browser$Document,
					fullPageTitle(title),
					_List_fromArray(
						[
							A4(
							$author$project$Page$viewGuest,
							$author$project$Main$GotPageMsg,
							page,
							guest,
							A2($elm$html$Html$map, toMsg, content))
						]));
			} else {
				return A2(
					$elm$browser$Browser$Document,
					fullPageTitle(''),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
			}
		});
	var viewLoggedIn = F4(
		function (subModel, page, toMsg, subView) {
			var _v9 = model.c;
			if (!_v9.$) {
				return A2(
					$elm$browser$Browser$Document,
					fullPageTitle(''),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
			} else {
				var loggedIn = _v9.a;
				var _v10 = A2(subView, loggedIn, subModel);
				var title = _v10.fN;
				var content = _v10.mJ;
				return A2(
					$elm$browser$Browser$Document,
					fullPageTitle(title),
					_List_fromArray(
						[
							A4(
							$author$project$Page$viewLoggedIn,
							$author$project$Main$GotPageMsg,
							page,
							loggedIn,
							A2($elm$html$Html$map, toMsg, content))
						]));
			}
		});
	var viewPage = F4(
		function (guestPage, loggedInPage, toMsg, _v8) {
			var title = _v8.fN;
			var content = _v8.mJ;
			var _v7 = model.c;
			if (!_v7.$) {
				var guest = _v7.a;
				return A2(
					$elm$browser$Browser$Document,
					fullPageTitle(title),
					_List_fromArray(
						[
							A4(
							$author$project$Page$viewGuest,
							$author$project$Main$GotPageMsg,
							guestPage,
							guest,
							A2($elm$html$Html$map, toMsg, content))
						]));
			} else {
				var loggedIn = _v7.a;
				return A2(
					$elm$browser$Browser$Document,
					fullPageTitle(title),
					_List_fromArray(
						[
							A4(
							$author$project$Page$viewLoggedIn,
							$author$project$Main$GotPageMsg,
							loggedInPage,
							loggedIn,
							A2($elm$html$Html$map, toMsg, content))
						]));
			}
		});
	var _v0 = model.pN;
	switch (_v0.$) {
		case 0:
			return A4(
				viewPage,
				0,
				$author$project$Session$LoggedIn$Redirect,
				function (_v1) {
					return $author$project$Main$Ignored;
				},
				{
					mJ: $elm$html$Html$text(''),
					fN: ''
				});
		case 1:
			return A4(
				viewPage,
				1,
				$author$project$Session$LoggedIn$NotFound,
				function (_v2) {
					return $author$project$Main$Ignored;
				},
				$author$project$Page$NotFound$view(model.c));
		case 2:
			return A4(
				viewPage,
				2,
				$author$project$Session$LoggedIn$ComingSoon,
				function (_v3) {
					return $author$project$Main$Ignored;
				},
				$author$project$Page$ComingSoon$view(model.c));
		case 42:
			var subModel = _v0.a;
			return A4(
				viewPage,
				5,
				$author$project$Session$LoggedIn$Invite,
				$author$project$Main$GotInviteMsg,
				A2($author$project$Page$Community$Invite$view, model.c, subModel));
		case 43:
			var subModel = _v0.a;
			return A4(
				viewPage,
				6,
				$author$project$Session$LoggedIn$Join,
				$author$project$Main$GotJoinMsg,
				A2($author$project$Page$Join$view, model.c, subModel));
		case 3:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$PaymentHistory, $author$project$Main$GotPaymentHistoryMsg, $author$project$Page$PaymentHistory$view);
		case 36:
			var subModel = _v0.c;
			return A4(viewGuest, subModel, 3, $author$project$Main$GotRegisterMsg, $author$project$Page$Register$view);
		case 37:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Settings, $author$project$Main$GotSettingsMsg, $author$project$Page$Settings$view);
		case 28:
			var subModel = _v0.b;
			return A4(viewGuest, subModel, 4, $author$project$Main$GotLoginMsg, $author$project$Page$Login$view);
		case 29:
			var subModel = _v0.a;
			return A4(
				viewLoggedIn,
				subModel,
				$author$project$Session$LoggedIn$News(subModel.bG),
				$author$project$Main$GotNewsMsg,
				$author$project$Page$News$view);
		case 26:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Notification, $author$project$Main$GotNotificationMsg, $author$project$Page$Notification$view);
		case 4:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunityAbout, $author$project$Main$GotCommunityAboutMsg, $author$project$Page$Community$About$view);
		case 5:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunityObjectives, $author$project$Main$GotCommunityObjectivesMsg, $author$project$Page$Community$Objectives$view);
		case 7:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettings, $author$project$Main$GotCommunitySettingsMsg, $author$project$Page$Community$Settings$Settings$view);
		case 8:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsShopCategories, $author$project$Main$GotCommunitySettingsShopCategoriesMsg, $author$project$Page$Community$Settings$Shop$Categories$view);
		case 9:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsFeatures, $author$project$Main$GotCommunitySettingsFeaturesMsg, $author$project$Page$Community$Settings$Features$view);
		case 10:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsInfo, $author$project$Main$GotCommunitySettingsInfoMsg, $author$project$Page$Community$Settings$Info$view);
		case 11:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsNews, $author$project$Main$GotCommunitySettingsNewsMsg, $author$project$Page$Community$Settings$News$view);
		case 12:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsNewsEditor, $author$project$Main$GotCommunitySettingsNewsEditorMsg, $author$project$Page$Community$Settings$News$Editor$view);
		case 13:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsCurrency, $author$project$Main$GotCommunitySettingsCurrencyMsg, $author$project$Page$Community$Settings$Currency$view);
		case 14:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsSponsorship, $author$project$Main$GotCommunitySettingsSponsorshipMsg, $author$project$Page$Community$Settings$Sponsorship$view);
		case 15:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsSponsorshipFiat, $author$project$Main$GotCommunitySettingsSponsorshipFiatMsg, $author$project$Page$Community$Settings$Sponsorship$Fiat$view);
		case 16:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsSponsorshipThankYouMessage, $author$project$Main$GotCommunitySettingsSponsorshipThankYouMessageMsg, $author$project$Page$Community$Settings$Sponsorship$ThankYouMessage$view);
		case 17:
			var subModel = _v0.a;
			return A4(
				viewLoggedIn,
				subModel,
				$author$project$Session$LoggedIn$CommunitySelector,
				function (_v4) {
					return $author$project$Main$Ignored;
				},
				$author$project$Page$Community$Selector$view);
		case 18:
			return A4(
				viewLoggedIn,
				0,
				$author$project$Session$LoggedIn$CommunityThankYou,
				function (_v5) {
					return $author$project$Main$Ignored;
				},
				F2(
					function (l, _v6) {
						return $author$project$Page$Community$ThankYou$view(l);
					}));
		case 19:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySponsor, $author$project$Main$GotCommunitySponsorMsg, $author$project$Page$Community$Sponsor$view);
		case 20:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySupporters, $author$project$Main$GotCommunitySupportersMsg, $author$project$Page$Community$Supporters$view);
		case 6:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunityEditor, $author$project$Main$GotCommunityEditorMsg, $author$project$Page$Community$New$view);
		case 21:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsObjectives, $author$project$Main$GotCommunitySettingsObjectivesMsg, $author$project$Page$Community$Settings$Objectives$view);
		case 22:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsObjectiveEditor, $author$project$Main$GotCommunitySettingsObjectiveEditorMsg, $author$project$Page$Community$Settings$ObjectiveEditor$view);
		case 23:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsActionEditor, $author$project$Main$GotCommunitySettingsActionEditorMsg, $author$project$Page$Community$Settings$ActionEditor$view);
		case 24:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunitySettingsContacts, $author$project$Main$GotCommunitySettingsContactsMsg, $author$project$Page$Community$Settings$Contacts$view);
		case 25:
			var subModel = _v0.c;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Claim, $author$project$Main$GotVerifyClaimMsg, $author$project$Page$Dashboard$Claim$view);
		case 27:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Dashboard, $author$project$Main$GotDashboardMsg, $author$project$Page$Dashboard$view);
		case 30:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Profile, $author$project$Main$GotProfileMsg, $author$project$Page$Profile$view);
		case 31:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ProfileContributions, $author$project$Main$GotProfileContributionsMsg, $author$project$Page$Profile$Contributions$view);
		case 32:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ProfileEditor, $author$project$Main$GotProfileEditorMsg, $author$project$Page$Profile$Editor$view);
		case 33:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ProfileAddKyc, $author$project$Main$GotProfileAddKycMsg, $author$project$Page$Profile$AddKyc$view);
		case 34:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ProfileClaims, $author$project$Main$GotProfileClaimsMsg, $author$project$Page$Profile$Claims$view);
		case 35:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ProfileAddContact, $author$project$Main$GotProfileAddContactMsg, $author$project$Page$Profile$AddContact$view);
		case 38:
			var subModel = _v0.b;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Shop, $author$project$Main$GotShopMsg, $author$project$Page$Shop$view);
		case 39:
			var subModel = _v0.b;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ShopEditor, $author$project$Main$GotShopEditorMsg, $author$project$Page$Shop$Editor$view);
		case 40:
			var subModel = _v0.b;
			return A4(
				viewPage,
				7,
				$author$project$Session$LoggedIn$ShopViewer,
				$author$project$Main$GotShopViewerMsg,
				A2($author$project$Page$Shop$Viewer$view, model.c, subModel));
		case 41:
			var subModel = _v0.b;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ViewTransfer, $author$project$Main$GotViewTransferScreenMsg, $author$project$Page$ViewTransfer$view);
		case 44:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Transfer, $author$project$Main$GotTransferMsg, $author$project$Page$Community$Transfer$view);
		default:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Analysis, $author$project$Main$GotAnalysisMsg, $author$project$Page$Dashboard$Analysis$view);
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{nE: $author$project$Main$init, oX: $author$project$Main$ChangedUrl, oY: $author$project$Main$ClickedLink, pT: $author$project$Main$subscriptions, qd: $author$project$Main$update, qi: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}});}(this));